import * as $protobuf from 'protobufjs/minimal';

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
const models = $root.models = (() => {
  const models2 = {};
  models2.EncapMessage = function() {
    function EncapMessage(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EncapMessage.prototype.type = 0;
    EncapMessage.prototype.payload = $util.newBuffer([]);
    EncapMessage.prototype.context = null;
    EncapMessage.create = function create(properties) {
      return new EncapMessage(properties);
    };
    EncapMessage.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
        writer.uint32(18).bytes(message.payload);
      if (message.context != null && Object.hasOwnProperty.call(message, "context"))
        $root.models.EventContext.encode(message.context, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    EncapMessage.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EncapMessage.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.EncapMessage();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.payload = reader.bytes();
            break;
          case 3:
            message.context = $root.models.EventContext.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EncapMessage.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EncapMessage.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
          case 22:
          case 23:
          case 24:
          case 25:
          case 26:
          case 27:
          case 28:
          case 29:
          case 30:
          case 31:
          case 32:
          case 33:
          case 34:
          case 35:
          case 36:
          case 37:
          case 38:
          case 39:
          case 40:
          case 41:
          case 42:
          case 43:
          case 44:
          case 45:
          case 46:
          case 47:
          case 48:
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
          case 58:
          case 59:
          case 60:
          case 61:
          case 62:
          case 63:
          case 64:
          case 65:
          case 66:
          case 67:
          case 68:
          case 69:
          case 70:
          case 71:
          case 72:
          case 73:
          case 74:
          case 75:
          case 76:
          case 77:
          case 78:
          case 79:
          case 80:
          case 81:
          case 82:
          case 83:
          case 84:
          case 85:
          case 86:
          case 87:
          case 88:
          case 89:
          case 90:
          case 91:
          case 92:
          case 93:
          case 94:
          case 95:
          case 96:
          case 97:
          case 98:
          case 100:
          case 101:
          case 200:
          case 201:
          case 202:
          case 203:
          case 204:
          case 205:
          case 206:
          case 207:
          case 208:
          case 209:
          case 210:
          case 211:
          case 212:
          case 213:
          case 214:
          case 215:
          case 216:
          case 217:
          case 218:
          case 219:
          case 220:
          case 221:
          case 225:
          case 222:
          case 223:
          case 224:
          case 230:
          case 231:
          case 232:
          case 233:
          case 240:
          case 241:
          case 242:
          case 243:
          case 244:
          case 245:
          case 250:
          case 251:
          case 252:
          case 253:
          case 254:
          case 255:
          case 256:
          case 257:
          case 258:
          case 260:
          case 261:
          case 262:
          case 263:
          case 264:
          case 265:
          case 266:
          case 267:
          case 268:
          case 269:
          case 270:
          case 271:
          case 272:
          case 273:
          case 274:
          case 280:
          case 281:
          case 282:
          case 283:
          case 284:
          case 285:
          case 286:
          case 287:
          case 290:
          case 291:
          case 292:
          case 300:
          case 301:
          case 302:
          case 303:
          case 304:
          case 305:
          case 310:
          case 311:
          case 312:
          case 313:
          case 320:
          case 321:
          case 322:
          case 323:
          case 400:
          case 401:
          case 402:
          case 403:
          case 404:
          case 405:
          case 406:
          case 520:
          case 521:
          case 522:
          case 530:
          case 531:
          case 550:
          case 600:
          case 601:
          case 602:
          case 700:
          case 701:
          case 702:
          case 730:
          case 731:
          case 800:
          case 4e3:
          case 4001:
          case 4002:
          case 4101:
          case 1e3:
          case 1001:
          case 1002:
          case 1003:
          case 1004:
          case 1005:
          case 1101:
          case 1102:
          case 1103:
          case 1200:
          case 1201:
          case 1202:
          case 1203:
          case 1204:
          case 1205:
          case 1206:
          case 1207:
          case 1208:
          case 1209:
          case 1300:
          case 1301:
          case 1302:
          case 1303:
          case 1304:
          case 1305:
          case 1306:
          case 1400:
          case 1401:
          case 1402:
          case 1403:
          case 1404:
          case 1405:
          case 1406:
          case 1407:
          case 1500:
          case 1501:
          case 1502:
          case 1503:
          case 1504:
          case 1505:
          case 1506:
          case 1507:
          case 1600:
          case 1601:
          case 1602:
          case 1603:
          case 2e3:
          case 2001:
          case 2002:
          case 2003:
          case 2004:
          case 2005:
          case 2006:
          case 2007:
          case 2008:
          case 2009:
          case 2010:
          case 2011:
          case 2012:
          case 2013:
          case 2014:
          case 2015:
          case 2016:
          case 2017:
          case 2018:
          case 2019:
          case 2020:
          case 2021:
          case 2022:
          case 2030:
          case 2031:
          case 2032:
          case 2033:
          case 2034:
          case 2035:
          case 2036:
          case 2037:
          case 2038:
          case 2039:
          case 2040:
          case 2100:
          case 2200:
          case 2201:
          case 2202:
          case 2203:
          case 2204:
          case 2205:
          case 2206:
          case 2207:
          case 2210:
          case 2211:
          case 2212:
          case 2213:
          case 2214:
          case 2215:
          case 2216:
          case 2217:
          case 2218:
          case 2219:
          case 2220:
          case 2221:
          case 2222:
          case 2223:
          case 2224:
          case 2225:
          case 2226:
          case 2250:
          case 3e3:
          case 3001:
          case 2300:
          case 2400:
          case 2401:
          case 2402:
          case 2500:
          case 2600:
          case 2601:
          case 2800:
          case 5e3:
          case 5001:
          case 5002:
          case 6e3:
          case 6001:
          case 6002:
          case 7e3:
          case 7001:
          case 7002:
          case 8e3:
          case 8001:
          case 8002:
          case 8003:
          case 8004:
          case 8005:
          case 8006:
          case 8007:
          case 8008:
          case 8009:
          case 8010:
          case 8011:
          case 9e3:
            break;
        }
      if (message.payload != null && message.hasOwnProperty("payload")) {
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
          return "payload: buffer expected";
      }
      if (message.context != null && message.hasOwnProperty("context")) {
        let error = $root.models.EventContext.verify(message.context);
        if (error)
          return "context." + error;
      }
      return null;
    };
    EncapMessage.fromObject = function fromObject(object) {
      if (object instanceof $root.models.EncapMessage)
        return object;
      let message = new $root.models.EncapMessage();
      switch (object.type) {
        case "DERIVATIVE_PRICE":
        case 0:
          message.type = 0;
          break;
        case "ORDER":
        case 1:
          message.type = 1;
          break;
        case "MARKET_INDEX":
        case 2:
          message.type = 2;
          break;
        case "DEAL":
        case 3:
          message.type = 3;
          break;
        case "RISK_CONFIG":
        case 4:
          message.type = 4;
          break;
        case "INVESTOR":
        case 5:
          message.type = 5;
          break;
        case "EMAIL_VERIFICATION":
        case 6:
          message.type = 6;
          break;
        case "OHLC":
        case 7:
          message.type = 7;
          break;
        case "STOCK_PRICE":
        case 8:
          message.type = 8;
          break;
        case "BID_ASK":
        case 9:
          message.type = 9;
          break;
        case "ACCOUNT_BALANCE":
        case 10:
          message.type = 10;
          break;
        case "TA_INDICATOR":
        case 11:
          message.type = 11;
          break;
        case "CUT_LOSS_PRICE":
        case 12:
          message.type = 12;
          break;
        case "CONTRACT":
        case 13:
          message.type = 13;
          break;
        case "BOT_RESULT":
        case 14:
          message.type = 14;
          break;
        case "DEAL_RISK":
        case 15:
          message.type = 15;
          break;
        case "BOT_HEARTBEAT":
        case 16:
          message.type = 16;
          break;
        case "BOT_ORDER":
        case 17:
          message.type = 17;
          break;
        case "TRANSACTION":
        case 18:
          message.type = 18;
          break;
        case "NOTIFICATION":
        case 19:
          message.type = 19;
          break;
        case "HOLD_OVERNIGHT_ALERT":
        case 20:
          message.type = 20;
          break;
        case "INVESTOR_ACCOUNT":
        case 21:
          message.type = 21;
          break;
        case "STOCK_QUOTE":
        case 22:
          message.type = 22;
          break;
        case "SMART_ORDER":
        case 23:
          message.type = 23;
          break;
        case "CAMPAIGN_EMAIL_VERIFICATION":
        case 24:
          message.type = 24;
          break;
        case "DNSE_ORDER":
        case 25:
          message.type = 25;
          break;
        case "DNSE_ACCOUNT_BALANCE":
        case 26:
          message.type = 26;
          break;
        case "DNSE_PORTFOLIO":
        case 27:
          message.type = 27;
          break;
        case "DNSE_EMAIL_VERIFICATION":
        case 28:
          message.type = 28;
          break;
        case "DNSE_EVENT_CI":
        case 29:
          message.type = 29;
          break;
        case "DNSE_EVENT_SE":
        case 30:
          message.type = 30;
          break;
        case "DNSE_EVENT_OD":
        case 31:
          message.type = 31;
          break;
        case "DNSE_INVESTOR_ACCOUNT":
        case 32:
          message.type = 32;
          break;
        case "DNSE_NEW_INVESTOR":
        case 33:
          message.type = 33;
          break;
        case "DNSE_UPDATE_INVESTOR":
        case 34:
          message.type = 34;
          break;
        case "DNSE_BANK_WITHDRAW":
        case 35:
          message.type = 35;
          break;
        case "DNSE_BANK_DEPOSIT":
        case 36:
          message.type = 36;
          break;
        case "DNSE_WITHDRAW_NOTIFICATION":
        case 37:
          message.type = 37;
          break;
        case "TOP_PRICE":
        case 38:
          message.type = 38;
          break;
        case "TRADING_SESSION":
        case 39:
          message.type = 39;
          break;
        case "HSX_SECURITY":
        case 40:
          message.type = 40;
          break;
        case "TICK":
        case 41:
          message.type = 41;
          break;
        case "SYMBOL":
        case 42:
          message.type = 42;
          break;
        case "STOCK_INFO":
        case 43:
          message.type = 43;
          break;
        case "DNSE_KYC_UPDATED":
        case 44:
          message.type = 44;
          break;
        case "DNSE_ACCOUNT_DEADLINE_REMINDER":
        case 45:
          message.type = 45;
          break;
        case "DNSE_SI":
        case 46:
          message.type = 46;
          break;
        case "DNSE_FO_SECURITIES":
        case 47:
          message.type = 47;
          break;
        case "DNSE_CTRL":
        case 48:
          message.type = 48;
          break;
        case "DNSE_FO_CONTROL":
        case 49:
          message.type = 49;
          break;
        case "DNSE_SY":
        case 50:
          message.type = 50;
          break;
        case "DNSE_INIT_DAY_SE":
        case 51:
          message.type = 51;
          break;
        case "DNSE_INIT_DAY_BA":
        case 52:
          message.type = 52;
          break;
        case "DNSE_INIT_DAY_PR":
        case 53:
          message.type = 53;
          break;
        case "DNSE_INIT_DAY_CF":
        case 54:
          message.type = 54;
          break;
        case "DNSE_INIT_DAY_AF":
        case 55:
          message.type = 55;
          break;
        case "DNSE_INIT_DAY_CI":
        case 56:
          message.type = 56;
          break;
        case "DNSE_FO_SYSTEM_CONFIG":
        case 57:
          message.type = 57;
          break;
        case "DNSE_FO_TRADING_CONFIG":
        case 58:
          message.type = 58;
          break;
        case "DNSE_FO_POSITION":
        case 59:
          message.type = 59;
          break;
        case "DNSE_FO_ACCOUNT":
        case 60:
          message.type = 60;
          break;
        case "DNSE_FO_CASH_ACCOUNT":
        case 61:
          message.type = 61;
          break;
        case "DNSE_FO_MARGIN_BASKET":
        case 62:
          message.type = 62;
          break;
        case "DNSE_FO_ORDER":
        case 63:
          message.type = 63;
          break;
        case "DNSE_FO_POOL_RULE":
        case 64:
          message.type = 64;
          break;
        case "DNSE_FO_POOL_RULE_WRAP":
        case 65:
          message.type = 65;
          break;
        case "DNSE_FO_INTRADAY_CASH_EVENT":
        case 66:
          message.type = 66;
          break;
        case "DNSE_FO_INTRADAY_POSITION_EVENT":
        case 67:
          message.type = 67;
          break;
        case "SS":
        case 68:
          message.type = 68;
          break;
        case "SU":
        case 69:
          message.type = 69;
          break;
        case "PING":
        case 70:
          message.type = 70;
          break;
        case "ENID_USER_CREATED":
        case 71:
          message.type = 71;
          break;
        case "ENID_USER_UPDATED":
        case 72:
          message.type = 72;
          break;
        case "DNSE_INVESTOR_REFERRAL":
        case 73:
          message.type = 73;
          break;
        case "DNSE_INVESTOR_REFERRAL_DONE":
        case 74:
          message.type = 74;
          break;
        case "DNSE_MARGIN_ACCOUNT_OFFER":
        case 75:
          message.type = 75;
          break;
        case "DNSE_INVESTOR_STATUS_CHANGED":
        case 76:
          message.type = 76;
          break;
        case "DNSE_CORPORATE_ACTION_DIVIDEND_AND_RIGHT":
        case 77:
          message.type = 77;
          break;
        case "ENBOX_BADGE":
        case 78:
          message.type = 78;
          break;
        case "DNSE_FO_DEAL":
        case 79:
          message.type = 79;
          break;
        case "DNSE_FO_EXCHANGE_FEE":
        case 80:
          message.type = 80;
          break;
        case "DNSE_FO_TRADING_FEE":
        case 81:
          message.type = 81;
          break;
        case "DNSE_FO_ADVANCE_FEE":
        case 82:
          message.type = 82;
          break;
        case "DNSE_INVESTOR_REFERRAL_FOR_NEW_USER_DONE":
        case 83:
          message.type = 83;
          break;
        case "DNSE_WITHDRAW_PPSE_NOTIFICATION":
        case 84:
          message.type = 84;
          break;
        case "DNSE_DEAL_PPSE_WITHDRAW":
        case 85:
          message.type = 85;
          break;
        case "DNSE_DEAL_PREPAYMENT":
        case 86:
          message.type = 86;
          break;
        case "DNSE_USER_CHANGE_REQUEST_UPDATED":
        case 87:
          message.type = 87;
          break;
        case "DNSE_BPM_USER_CHANGE_REQUEST_UPDATED":
        case 88:
          message.type = 88;
          break;
        case "DNSE_USER_CHANGE_REQUEST_RESULT":
        case 89:
          message.type = 89;
          break;
        case "DNSE_TRACKING_DEVICE_LOGIN":
        case 90:
          message.type = 90;
          break;
        case "DNSE_CROSS_ORDER":
        case 91:
          message.type = 91;
          break;
        case "DNSE_WARNING_UPDATE_INFORMATION":
        case 92:
          message.type = 92;
          break;
        case "DNSE_FO_ROOM_RULE":
        case 93:
          message.type = 93;
          break;
        case "DNSE_FO_ROOM_RULE_WRAP":
        case 94:
          message.type = 94;
          break;
        case "DNSE_ACCOUNT_CUSTOM_DETAIL":
        case 95:
          message.type = 95;
          break;
        case "DNSE_ACCOUNT_UPDATED":
        case 96:
          message.type = 96;
          break;
        case "DNSE_MARKET_SESSION":
        case 97:
          message.type = 97;
          break;
        case "DNSE_INVESTOR_CHANGE_EMAIL":
        case 98:
          message.type = 98;
          break;
        case "ENTRADE_DNSE_LINK":
        case 100:
          message.type = 100;
          break;
        case "ENTRADE_DERIVATIVE_MARGIN_PORTFOLIO_OFFER":
        case 101:
          message.type = 101;
          break;
        case "DNSE_FO_LOAN_PACKAGE":
        case 200:
          message.type = 200;
          break;
        case "DNSE_FO_LOAN_BASKET":
        case 201:
          message.type = 201;
          break;
        case "DNSE_FO_LOAN_PACKAGE_ACCOUNT":
        case 202:
          message.type = 202;
          break;
        case "DNSE_FO_LOAN_PACKAGE_ACCOUNT_WRAP":
        case 203:
          message.type = 203;
          break;
        case "DNSE_FO_TRADING_CONFIG_V2":
        case 204:
          message.type = 204;
          break;
        case "DNSE_BANK_REWARD_COMMISSION":
        case 205:
          message.type = 205;
          break;
        case "DNSE_FO_LOAN":
        case 206:
          message.type = 206;
          break;
        case "DNSE_LOAN":
        case 207:
          message.type = 207;
          break;
        case "DNSE_LOAN_INIT_CONTROL":
        case 208:
          message.type = 208;
          break;
        case "SAVINGS_PRODUCT":
        case 209:
          message.type = 209;
          break;
        case "SAVINGS_ACCOUNT":
        case 210:
          message.type = 210;
          break;
        case "SAVINGS_ACCOUNT_DEPOSIT":
        case 211:
          message.type = 211;
          break;
        case "SAVINGS_ACCOUNT_SETTLEMENT":
        case 212:
          message.type = 212;
          break;
        case "SAVINGS_BPM_SETTLEMENT":
        case 213:
          message.type = 213;
          break;
        case "SAVINGS_ACCOUNT_WITHDRAWAL":
        case 214:
          message.type = 214;
          break;
        case "SAVINGS_ACCOUNT_MATURITY_ALERT":
        case 215:
          message.type = 215;
          break;
        case "SAVINGS_ACCOUNT_ROLLOVER":
        case 216:
          message.type = 216;
          break;
        case "SAVINGS_CASH_EVENT":
        case 217:
          message.type = 217;
          break;
        case "SAVINGS_ACCOUNT_CREATED":
        case 218:
          message.type = 218;
          break;
        case "STOCK_STATISTICS":
        case 219:
          message.type = 219;
          break;
        case "TOP_INFLUENCE_STOCKS":
        case 220:
          message.type = 220;
          break;
        case "LIST_STOCK_STATISTICS":
        case 221:
          message.type = 221;
          break;
        case "FSP_ESTIMATE":
        case 225:
          message.type = 225;
          break;
        case "DNSE_INVESTOR_ACTIVATED":
        case 222:
          message.type = 222;
          break;
        case "DNSE_FLEX_CUSTOMER_ACTIVE":
        case 223:
          message.type = 223;
          break;
        case "DNSE_FLEX_HO_STATUS":
        case 224:
          message.type = 224;
          break;
        case "DNSE_DEAL_RISK_CALL":
        case 230:
          message.type = 230;
          break;
        case "EMAIL":
        case 231:
          message.type = 231;
          break;
        case "DNSE_PRODUCT_SUGGESTION":
        case 232:
          message.type = 232;
          break;
        case "DNSE_CASH_IN_ADVANCE_EVENT":
        case 233:
          message.type = 233;
          break;
        case "DNSE_DEAL_RISK_LIQUID":
        case 240:
          message.type = 240;
          break;
        case "DNSE_DEAL_ACCOUNT_EVENT":
        case 241:
          message.type = 241;
          break;
        case "DNSE_FIRST_ORDER_REWARD":
        case 242:
          message.type = 242;
          break;
        case "DNSE_FIRST_ORDER_REWARD_PAID":
        case 243:
          message.type = 243;
          break;
        case "DNSE_REWARD_PROGRESS":
        case 244:
          message.type = 244;
          break;
        case "DNSE_FIRST_ORDER_WICHART_REWARD":
        case 245:
          message.type = 245;
          break;
        case "DNSE_DEAL_RISK_DELAY_LIQUID":
        case 250:
          message.type = 250;
          break;
        case "DNSE_SMART_EXECUTION":
        case 251:
          message.type = 251;
          break;
        case "DNSE_HANDOFF_SMART_OTP":
        case 252:
          message.type = 252;
          break;
        case "DNSE_HANDOFF_SMART_OTP_APPROVED":
        case 253:
          message.type = 253;
          break;
        case "DNSE_DEAL_DEPOSIT_REQ":
        case 254:
          message.type = 254;
          break;
        case "DNSE_DEAL_WITHDRAWAL_REQ":
        case 255:
          message.type = 255;
          break;
        case "DNSE_LOAN_WARNING_DUE_DATE":
        case 256:
          message.type = 256;
          break;
        case "DNSE_LOAN_OVER_DUE_DATE":
        case 257:
          message.type = 257;
          break;
        case "DNSE_DEAL_MIGRATE":
        case 258:
          message.type = 258;
          break;
        case "DNSE_TRIGGER_INVESTOR_CHANGE":
        case 260:
          message.type = 260;
          break;
        case "DNSE_DEAL_CORPORATE_ACTION":
        case 261:
          message.type = 261;
          break;
        case "DNSE_AVAILABLE_CASH_CHANGE":
        case 262:
          message.type = 262;
          break;
        case "DNSE_TYPE_BASE_WITHDRAW":
        case 263:
          message.type = 263;
          break;
        case "DNSE_ADVANCE_WITHDRAW_TRANSACTION":
        case 264:
          message.type = 264;
          break;
        case "DNSE_STOCKS_TRANSFER":
        case 265:
          message.type = 265;
          break;
        case "DNSE_ORDER_PNL":
        case 266:
          message.type = 266;
          break;
        case "SAVINGS_GOLDEN_EGG_NEW_DAY":
        case 267:
          message.type = 267;
          break;
        case "DNSE_SYSTEM_MAINTAIN":
        case 268:
          message.type = 268;
          break;
        case "DNSE_INVESTOR_SACO_REFERRAL_FOR_NEW_USER":
        case 269:
          message.type = 269;
          break;
        case "DNSE_ACCOUNT_CORPORATE_ACTION":
        case 270:
          message.type = 270;
          break;
        case "ENTRADE_DEBT_SNAPSHOT":
        case 271:
          message.type = 271;
          break;
        case "DNSE_NOTIFY_ORDER":
        case 272:
          message.type = 272;
          break;
        case "DNSE_LOAN_CALL_FORCE_SELL":
        case 273:
          message.type = 273;
          break;
        case "DNSE_ASSET_CASH_TRANSFER_EXTERNAL":
        case 274:
          message.type = 274;
          break;
        case "DNSE_PROMO_TASK":
        case 280:
          message.type = 280;
          break;
        case "DNSE_PROMO_REGISTER_EVENT":
        case 281:
          message.type = 281;
          break;
        case "DNSE_PROMO_STOCK_REWARD":
        case 282:
          message.type = 282;
          break;
        case "RECOMMENDER_TRADE_SIGNAL":
        case 283:
          message.type = 283;
          break;
        case "LEADERBOARD_USER_RANKS":
        case 284:
          message.type = 284;
          break;
        case "LEADERBOARD_USER_RANK":
        case 285:
          message.type = 285;
          break;
        case "LEADERBOARD_TOP_USERS":
        case 286:
          message.type = 286;
          break;
        case "OAUTH2_USER_CONSENT":
        case 287:
          message.type = 287;
          break;
        case "DNSE_MGM_EVENT":
        case 290:
          message.type = 290;
          break;
        case "DNSE_MGM_FIRST_TRANSACTION_REWARD":
        case 291:
          message.type = 291;
          break;
        case "DNSE_MGM_GET_REWARD":
        case 292:
          message.type = 292;
          break;
        case "DNSE_COVERED_WARRANT_SETTLEMENT_EVENT":
        case 300:
          message.type = 300;
          break;
        case "BID_ASK_INFO":
        case 301:
          message.type = 301;
          break;
        case "MARKET_BREADTH":
        case 302:
          message.type = 302;
          break;
        case "ESTIMATED_MARKET_INDEX":
        case 303:
          message.type = 303;
          break;
        case "GLOBAL_MARKET_INDEX":
        case 304:
          message.type = 304;
          break;
        case "GLOBAL_MARKET_OHLC":
        case 305:
          message.type = 305;
          break;
        case "DNSE_AUTO_CALL_PAYMENT_EVENT":
        case 310:
          message.type = 310;
          break;
        case "DNSE_FLEX_CUSTOMER_EVENT":
        case 311:
          message.type = 311;
          break;
        case "DNSE_DTA_ACCOUNT":
        case 312:
          message.type = 312;
          break;
        case "DNSE_DTA_CASH":
        case 313:
          message.type = 313;
          break;
        case "DNSE_RESET_PASSWORD_EVENT":
        case 320:
          message.type = 320;
          break;
        case "DNSE_REGISTER_DERIVATIVE_EVENT":
        case 321:
          message.type = 321;
          break;
        case "DNSE_DERIVATIVE_ACCOUNT_ACTIVE":
        case 322:
          message.type = 322;
          break;
        case "DNSE_DERIVATIVE_CASH_ACCOUNT_COMMAND":
        case 323:
          message.type = 323;
          break;
        case "GIFT_REDEEMED_NOTIFICATION":
        case 400:
          message.type = 400;
          break;
        case "GIFT_CREATED_NOTIFICATION":
        case 401:
          message.type = 401;
          break;
        case "GIFT_REJECTED_NOTIFICATION":
        case 402:
          message.type = 402;
          break;
        case "GIFT_EXPIRED_NOTIFICATION":
        case 403:
          message.type = 403;
          break;
        case "BPM_GIFT_REJECTED":
        case 404:
          message.type = 404;
          break;
        case "BPM_GIFT_REDEEMED":
        case 405:
          message.type = 405;
          break;
        case "BPM_GIFT_CONTRACT_SIGNED":
        case 406:
          message.type = 406;
          break;
        case "DNSE_NEWS_NOTICE":
        case 520:
          message.type = 520;
          break;
        case "DNSE_BREAKING_NEWS":
        case 521:
          message.type = 521;
          break;
        case "DNSE_NEWS":
        case 522:
          message.type = 522;
          break;
        case "DNSE_MARKET_MENTALITY":
        case 530:
          message.type = 530;
          break;
        case "DNSE_MARKET_PE":
        case 531:
          message.type = 531;
          break;
        case "DNSE_ECONTRACT_EVENT":
        case 550:
          message.type = 550;
          break;
        case "DNSE_BROKER_SACO_TYPE":
        case 600:
          message.type = 600;
          break;
        case "DNSE_BROKER_WRAPPER":
        case 601:
          message.type = 601;
          break;
        case "DNSE_NEW_BROKER_CREATED":
        case 602:
          message.type = 602;
          break;
        case "DNSE_BIDV_LA_WALLET_TRANSACTION":
        case 700:
          message.type = 700;
          break;
        case "DNSE_LA_WALLET_TRANSACTION":
        case 701:
          message.type = 701;
          break;
        case "DNSE_LA_LINK_TRANSACTION":
        case 702:
          message.type = 702;
          break;
        case "SECTOR_VOLATILITY":
        case 730:
          message.type = 730;
          break;
        case "STOCK_VOLATILITY":
        case 731:
          message.type = 731;
          break;
        case "DNSE_IPO_REGISTRATION_ANALYTIC":
        case 800:
          message.type = 800;
          break;
        case "DNSE_IPO_NOTIFY_PAYMENT_STATUS":
        case 4e3:
          message.type = 4e3;
          break;
        case "DNSE_IPO_NOTIFY_ENBOX":
        case 4001:
          message.type = 4001;
          break;
        case "DNSE_IPO_NOTIFY_REGISTRATION_FORM_STATUS":
        case 4002:
          message.type = 4002;
          break;
        case "DNSE_GAMIFICATION_NOTIFY_LEADERBOARD_RESULT":
        case 4101:
          message.type = 4101;
          break;
        case "DNSE_CONDITIONAL_ORDER":
        case 1e3:
          message.type = 1e3;
          break;
        case "DNSE_CONDITIONAL_ORDER_WORKER_STATUS_REPORT":
        case 1001:
          message.type = 1001;
          break;
        case "STOCK_LISTED_STATUS":
        case 1002:
          message.type = 1002;
          break;
        case "PARTNER_DEPOSIT_HOOK":
        case 1003:
          message.type = 1003;
          break;
        case "PARTNER_DEPOSIT_REQUEST":
        case 1004:
          message.type = 1004;
          break;
        case "PARTNER_DEPOSIT_BALANCE_HOOK":
        case 1005:
          message.type = 1005;
          break;
        case "SAVINGS_BPM_APPROVE_OPEN_MANUAL":
        case 1101:
          message.type = 1101;
          break;
        case "SAVINGS_BPM_APPROVE_SETTLE_MANUAL":
        case 1102:
          message.type = 1102;
          break;
        case "SAVINGS_BPM_GOLDEN_EGG_CONTRACT":
        case 1103:
          message.type = 1103;
          break;
        case "FINANCING_OFFER_CREATED":
        case 1200:
          message.type = 1200;
          break;
        case "FINANCING_OFFER_REQUEST_DECLINED":
        case 1201:
          message.type = 1201;
          break;
        case "FINANCING_OFFER_OFFLINE_CONFIRMATION":
        case 1202:
          message.type = 1202;
          break;
        case "FINANCING_OFFER_ONLINE_CONFIRMATION":
        case 1203:
          message.type = 1203;
          break;
        case "FINANCING_OFFER_LOAN_PACKAGE_READY":
        case 1204:
          message.type = 1204;
          break;
        case "FINANCING_OFFER_DERIVATIVE_REQUEST_DECLINED":
        case 1205:
          message.type = 1205;
          break;
        case "FINANCING_OFFER_DERIVATIVE_OFFLINE_CONFIRMATION":
        case 1206:
          message.type = 1206;
          break;
        case "FINANCING_OFFER_DERIVATIVE_LOAN_PACKAGE_READY":
        case 1207:
          message.type = 1207;
          break;
        case "FINANCING_OFFER_SUGGESTED_OFFER_CREATED":
        case 1208:
          message.type = 1208;
          break;
        case "FINANCING_OFFER_LOAN_PACKAGE_REQUEST":
        case 1209:
          message.type = 1209;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_CREATED":
        case 1300:
          message.type = 1300;
          break;
        case "MOBILIZED_CAPITAL_BPM_LOAN_PACKAGE_SETTLEMENT":
        case 1301:
          message.type = 1301;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_WITHDRAWAL":
        case 1302:
          message.type = 1302;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_CONTRACT":
        case 1303:
          message.type = 1303;
          break;
        case "MOBILIZED_CAPITAL_MATURITY_ALERT":
        case 1304:
          message.type = 1304;
          break;
        case "MOBILIZED_CAPITAL_LOAN_INVESTOR_ACTIVATED":
        case 1305:
          message.type = 1305;
          break;
        case "MOBILIZED_CAPITAL_GOLDEN_EGG_CREATED":
        case 1306:
          message.type = 1306;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_CREATED":
        case 1400:
          message.type = 1400;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_SETTLEMENT":
        case 1401:
          message.type = 1401;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_WITHDRAWAL":
        case 1402:
          message.type = 1402;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_CONTRACT":
        case 1403:
          message.type = 1403;
          break;
        case "ENTRADE_LOANX_MATURITY_ALERT":
        case 1404:
          message.type = 1404;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACTIVATED":
        case 1405:
          message.type = 1405;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_DEPOSIT":
        case 1406:
          message.type = 1406;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_WITHDRAWAL":
        case 1407:
          message.type = 1407;
          break;
        case "GOLDEN_EGG_CREATED":
        case 1500:
          message.type = 1500;
          break;
        case "GOLDEN_EGG_CREATED_FAIL":
        case 1501:
          message.type = 1501;
          break;
        case "GOLDEN_EGG_RECEIVED_INTEREST":
        case 1502:
          message.type = 1502;
          break;
        case "GOLDEN_EGG_DUE_DATE":
        case 1503:
          message.type = 1503;
          break;
        case "GOLDEN_EGG_OVER_DUE_DATE":
        case 1504:
          message.type = 1504;
          break;
        case "GOLDEN_EGG_SELLING_CONFIRMATION":
        case 1505:
          message.type = 1505;
          break;
        case "GOLDEN_EGG_CREATED_PRE_MARKET":
        case 1506:
          message.type = 1506;
          break;
        case "GOLDEN_EGG_SUCCEED_SELL_CONFIRMATION":
        case 1507:
          message.type = 1507;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_CREATED":
        case 1600:
          message.type = 1600;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_FAILED":
        case 1601:
          message.type = 1601;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_WITHDRAWAL":
        case 1602:
          message.type = 1602;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_CHANGED":
        case 1603:
          message.type = 1603;
          break;
        case "DNSE_FO_DERIVATIVE_BASKET":
        case 2e3:
          message.type = 2e3;
          break;
        case "DNSE_FO_DERIVATIVE_LOAN_PACKAGE":
        case 2001:
          message.type = 2001;
          break;
        case "DNSE_FO_DERIVATIVE_EXCHANGE_FEE":
        case 2002:
          message.type = 2002;
          break;
        case "DNSE_FO_DERIVATIVE_LOAN_PACKAGE_ACCOUNT":
        case 2003:
          message.type = 2003;
          break;
        case "DNSE_FO_DERIVATIVE_TRADING_FEE":
        case 2004:
          message.type = 2004;
          break;
        case "DNSE_FO_DERIVATIVE_ACCOUNT":
        case 2005:
          message.type = 2005;
          break;
        case "DNSE_FO_DERIVATIVE_TRADING_CONFIG":
        case 2006:
          message.type = 2006;
          break;
        case "DNSE_FO_DERIVATIVE_INSTRUMENT":
        case 2007:
          message.type = 2007;
          break;
        case "DNSE_FO_DERIVATIVE_CONTROL":
        case 2008:
          message.type = 2008;
          break;
        case "DNSE_FO_DERIVATIVE_LOAN_PACKAGE_ACCOUNT_WRAP":
        case 2009:
          message.type = 2009;
          break;
        case "DNSE_FO_DERIVATIVE_SYSTEM_CONFIG":
        case 2010:
          message.type = 2010;
          break;
        case "DNSE_FO_DERIVATIVE_INTRADAY_CASH_EVENT":
        case 2011:
          message.type = 2011;
          break;
        case "DNSE_FO_DERIVATIVE_SETTLEMENT_PRICE_EVENT":
        case 2012:
          message.type = 2012;
          break;
        case "DNSE_FO_DERIVATIVE_PAYMENT_OBLIGATION":
        case 2013:
          message.type = 2013;
          break;
        case "DNSE_FO_DERIVATIVE_PAID_CONTROL_MESSAGE":
        case 2014:
          message.type = 2014;
          break;
        case "DNSE_FO_DERIVATIVE_DEAL":
        case 2015:
          message.type = 2015;
          break;
        case "DNSE_FO_DERIVATIVE_DEAL_WRAP":
        case 2016:
          message.type = 2016;
          break;
        case "DNSE_FO_DERIVATIVE_SETTLEMENT_CONTROL_MESSAGE":
        case 2017:
          message.type = 2017;
          break;
        case "DNSE_FO_DERIVATIVE_INITIAL_MARGIN":
        case 2018:
          message.type = 2018;
          break;
        case "DNSE_FO_DERIVATIVE_CASH_ACCOUNT":
        case 2019:
          message.type = 2019;
          break;
        case "DNSE_FO_DERIVATIVE_ORDER":
        case 2020:
          message.type = 2020;
          break;
        case "DNSE_FO_DERIVATIVE_POSITION_LIMIT":
        case 2021:
          message.type = 2021;
          break;
        case "DNSE_NOTIFY_DERIVATIVE_ORDER":
        case 2022:
          message.type = 2022;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_UPDATE":
        case 2030:
          message.type = 2030;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_CALL":
        case 2031:
          message.type = 2031;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_LIQUIDATE":
        case 2032:
          message.type = 2032;
          break;
        case "DNSE_FO_DERIVATIVE_VSD_SECURE":
        case 2033:
          message.type = 2033;
          break;
        case "DNSE_DERIVATIVE_RECEIVE_PROFIT":
        case 2034:
          message.type = 2034;
          break;
        case "DNSE_DERIVATIVE_PAYMENT_OBLIGATION_EOD":
        case 2035:
          message.type = 2035;
          break;
        case "DNSE_DERIVATIVE_MATURITY":
        case 2036:
          message.type = 2036;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_STOP_LOSS":
        case 2037:
          message.type = 2037;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_TAKE_PROFIT":
        case 2038:
          message.type = 2038;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_STOP_LOSS_FAILED":
        case 2039:
          message.type = 2039;
          break;
        case "DNSE_FO_DERIVATIVE_RISK_TAKE_PROFIT_FAILED":
        case 2040:
          message.type = 2040;
          break;
        case "DNSE_DERIVATIVE_DEAL_SECURE":
        case 2100:
          message.type = 2100;
          break;
        case "DNSE_DERIVATIVE_PROFIT_LOSS_CLOSE_DEAL":
        case 2200:
          message.type = 2200;
          break;
        case "DNSE_DERIVATIVE_ESTIMATE_SETTLEMENT_PRICE":
        case 2201:
          message.type = 2201;
          break;
        case "DNSE_DERIVATIVE_PENDING_DEPOSIT_EVENT":
        case 2202:
          message.type = 2202;
          break;
        case "DNSE_DERIVATIVE_LOAN":
        case 2203:
          message.type = 2203;
          break;
        case "DNSE_DERIVATIVE_LOAN_WRAP":
        case 2204:
          message.type = 2204;
          break;
        case "DNSE_DERIVATIVE_PENDING_DEPOSIT_AND_WITHDRAW_EVENT":
        case 2205:
          message.type = 2205;
          break;
        case "DNSE_DERIVATIVE_DEAL_SECURE_WITHDRAW":
        case 2206:
          message.type = 2206;
          break;
        case "DNSE_DERIVATIVE_DEPOSIT_SECURE_FROM_BANK_FAILED":
        case 2207:
          message.type = 2207;
          break;
        case "DNSE_DERIVATIVE_PREPAY_DEAL_OBLIGATION_PAYMENT_EVENT":
        case 2210:
          message.type = 2210;
          break;
        case "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_DEAL_DEBT_EVENT":
        case 2211:
          message.type = 2211;
          break;
        case "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_PROFIT_ADVANCE_EVENT":
        case 2212:
          message.type = 2212;
          break;
        case "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_OBLIGATION_PAYMENT_EVENT":
        case 2213:
          message.type = 2213;
          break;
        case "DNSE_DERIVATIVE_AUTO_PREPAY":
        case 2214:
          message.type = 2214;
          break;
        case "DNSE_DERIVATIVE_END_OF_MONTH_INTEREST_PAYMENT":
        case 2215:
          message.type = 2215;
          break;
        case "DNSE_INITDAY_INTERNAL_PERSON":
        case 2216:
          message.type = 2216;
          break;
        case "DNSE_INTRADAY_INTERNAL_PERSON":
        case 2217:
          message.type = 2217;
          break;
        case "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_VSD_SECURE_ADVANCE_EVENT":
        case 2218:
          message.type = 2218;
          break;
        case "DNSE_DERIVATIVE_TRANSACTION":
        case 2219:
          message.type = 2219;
          break;
        case "DNSE_DERIVATIVE_HOLD_COLLATERAL_FEES":
        case 2220:
          message.type = 2220;
          break;
        case "DNSE_CROSS_ORDER_APPROVAL_REQUIREMENT":
        case 2221:
          message.type = 2221;
          break;
        case "DNSE_INTERNAL_COMPANY_PERSON":
        case 2222:
          message.type = 2222;
          break;
        case "DNSE_END_OF_MONTH_INTEREST_EVENT":
        case 2223:
          message.type = 2223;
          break;
        case "DNSE_DERIVATIVE_LOAN_TRANSACTION":
        case 2224:
          message.type = 2224;
          break;
        case "DNSE_DERIVATIVE_INTERNAL_END_OF_MONTH_INTEREST":
        case 2225:
          message.type = 2225;
          break;
        case "DNSE_DERIVATIVE_INIT_DAY_PAYMENT_REPORT":
        case 2226:
          message.type = 2226;
          break;
        case "DNSE_GROUP_ORDER":
        case 2250:
          message.type = 2250;
          break;
        case "DNSE_ACCOUNT_CHANGE_EVENT_WRAPPER":
        case 3e3:
          message.type = 3e3;
          break;
        case "DNSE_CORPORATE_ACTION_NOTIFICATION":
        case 3001:
          message.type = 3001;
          break;
        case "DNSE_VOLATILITY_INDEX_EVENT":
        case 2300:
          message.type = 2300;
          break;
        case "DNSE_CO_INVESTMENT_NOTIFY_EVENT":
        case 2400:
          message.type = 2400;
          break;
        case "DNSE_CO_INVESTMENT_NOTIFY_BALANCE":
        case 2401:
          message.type = 2401;
          break;
        case "DNSE_CO_INVESTMENT_GROUP":
        case 2402:
          message.type = 2402;
          break;
        case "DNSE_SOE_DEAL":
        case 2500:
          message.type = 2500;
          break;
        case "DNSE_WI_ADD_REWARD":
        case 2600:
          message.type = 2600;
          break;
        case "DNSE_PROMO_STOCK_REWARD_24H":
        case 2601:
          message.type = 2601;
          break;
        case "DNSE_SUBSCRIPTION":
        case 2800:
          message.type = 2800;
          break;
        case "DNSE_BOND_PORTFOLIO":
        case 5e3:
          message.type = 5e3;
          break;
        case "DNSE_BOND_INTEREST_PAYMENT_SCHEDULE":
        case 5001:
          message.type = 5001;
          break;
        case "DNSE_BOND_LISTED_BOND_ORDER":
        case 5002:
          message.type = 5002;
          break;
        case "LOYALTY_POINT_CHANGED":
        case 6e3:
          message.type = 6e3;
          break;
        case "LOYALTY_STATE_CHANGED":
        case 6001:
          message.type = 6001;
          break;
        case "LOYALTY_STATE_UPDATED":
        case 6002:
          message.type = 6002;
          break;
        case "DNSE_BROKER_BROKER_MARGIN":
        case 7e3:
          message.type = 7e3;
          break;
        case "OTP_SENT":
        case 7001:
          message.type = 7001;
          break;
        case "PARTNER_P2P_GIFT_HOOK":
        case 7002:
          message.type = 7002;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_CREATED":
        case 8e3:
          message.type = 8e3;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_CANCELLED":
        case 8001:
          message.type = 8001;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_REFUSED":
        case 8002:
          message.type = 8002;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_ACTIVATED":
        case 8003:
          message.type = 8003;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_CREATED":
        case 8004:
          message.type = 8004;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_CANCELLED":
        case 8005:
          message.type = 8005;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_REFUSED":
        case 8006:
          message.type = 8006;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_EVF":
        case 8007:
          message.type = 8007;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE":
        case 8008:
          message.type = 8008;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE_FAILED":
        case 8009:
          message.type = 8009;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_STATUS_CHANGED":
        case 8010:
          message.type = 8010;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_STATUS_CHANGED":
        case 8011:
          message.type = 8011;
          break;
        case "TRANSACTION_CONFIRMATIONS_OWNER_COSPONSOR_BANK_SHOULD_CONFIRM_TRANSACTION":
        case 9e3:
          message.type = 9e3;
          break;
      }
      if (object.payload != null) {
        if (typeof object.payload === "string")
          $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
        else if (object.payload.length)
          message.payload = object.payload;
      }
      if (object.context != null) {
        if (typeof object.context !== "object")
          throw TypeError(".models.EncapMessage.context: object expected");
        message.context = $root.models.EventContext.fromObject(object.context);
      }
      return message;
    };
    EncapMessage.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? "DERIVATIVE_PRICE" : 0;
        if (options.bytes === String)
          object.payload = "";
        else {
          object.payload = [];
          if (options.bytes !== Array)
            object.payload = $util.newBuffer(object.payload);
        }
        object.context = null;
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.models.EncapMessage.MessageType[message.type] : message.type;
      if (message.payload != null && message.hasOwnProperty("payload"))
        object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
      if (message.context != null && message.hasOwnProperty("context"))
        object.context = $root.models.EventContext.toObject(message.context, options);
      return object;
    };
    EncapMessage.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    EncapMessage.MessageType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "DERIVATIVE_PRICE"] = 0;
      values[valuesById[1] = "ORDER"] = 1;
      values[valuesById[2] = "MARKET_INDEX"] = 2;
      values[valuesById[3] = "DEAL"] = 3;
      values[valuesById[4] = "RISK_CONFIG"] = 4;
      values[valuesById[5] = "INVESTOR"] = 5;
      values[valuesById[6] = "EMAIL_VERIFICATION"] = 6;
      values[valuesById[7] = "OHLC"] = 7;
      values[valuesById[8] = "STOCK_PRICE"] = 8;
      values[valuesById[9] = "BID_ASK"] = 9;
      values[valuesById[10] = "ACCOUNT_BALANCE"] = 10;
      values[valuesById[11] = "TA_INDICATOR"] = 11;
      values[valuesById[12] = "CUT_LOSS_PRICE"] = 12;
      values[valuesById[13] = "CONTRACT"] = 13;
      values[valuesById[14] = "BOT_RESULT"] = 14;
      values[valuesById[15] = "DEAL_RISK"] = 15;
      values[valuesById[16] = "BOT_HEARTBEAT"] = 16;
      values[valuesById[17] = "BOT_ORDER"] = 17;
      values[valuesById[18] = "TRANSACTION"] = 18;
      values[valuesById[19] = "NOTIFICATION"] = 19;
      values[valuesById[20] = "HOLD_OVERNIGHT_ALERT"] = 20;
      values[valuesById[21] = "INVESTOR_ACCOUNT"] = 21;
      values[valuesById[22] = "STOCK_QUOTE"] = 22;
      values[valuesById[23] = "SMART_ORDER"] = 23;
      values[valuesById[24] = "CAMPAIGN_EMAIL_VERIFICATION"] = 24;
      values[valuesById[25] = "DNSE_ORDER"] = 25;
      values[valuesById[26] = "DNSE_ACCOUNT_BALANCE"] = 26;
      values[valuesById[27] = "DNSE_PORTFOLIO"] = 27;
      values[valuesById[28] = "DNSE_EMAIL_VERIFICATION"] = 28;
      values[valuesById[29] = "DNSE_EVENT_CI"] = 29;
      values[valuesById[30] = "DNSE_EVENT_SE"] = 30;
      values[valuesById[31] = "DNSE_EVENT_OD"] = 31;
      values[valuesById[32] = "DNSE_INVESTOR_ACCOUNT"] = 32;
      values[valuesById[33] = "DNSE_NEW_INVESTOR"] = 33;
      values[valuesById[34] = "DNSE_UPDATE_INVESTOR"] = 34;
      values[valuesById[35] = "DNSE_BANK_WITHDRAW"] = 35;
      values[valuesById[36] = "DNSE_BANK_DEPOSIT"] = 36;
      values[valuesById[37] = "DNSE_WITHDRAW_NOTIFICATION"] = 37;
      values[valuesById[38] = "TOP_PRICE"] = 38;
      values[valuesById[39] = "TRADING_SESSION"] = 39;
      values[valuesById[40] = "HSX_SECURITY"] = 40;
      values[valuesById[41] = "TICK"] = 41;
      values[valuesById[42] = "SYMBOL"] = 42;
      values[valuesById[43] = "STOCK_INFO"] = 43;
      values[valuesById[44] = "DNSE_KYC_UPDATED"] = 44;
      values[valuesById[45] = "DNSE_ACCOUNT_DEADLINE_REMINDER"] = 45;
      values[valuesById[46] = "DNSE_SI"] = 46;
      values[valuesById[47] = "DNSE_FO_SECURITIES"] = 47;
      values[valuesById[48] = "DNSE_CTRL"] = 48;
      values[valuesById[49] = "DNSE_FO_CONTROL"] = 49;
      values[valuesById[50] = "DNSE_SY"] = 50;
      values[valuesById[51] = "DNSE_INIT_DAY_SE"] = 51;
      values[valuesById[52] = "DNSE_INIT_DAY_BA"] = 52;
      values[valuesById[53] = "DNSE_INIT_DAY_PR"] = 53;
      values[valuesById[54] = "DNSE_INIT_DAY_CF"] = 54;
      values[valuesById[55] = "DNSE_INIT_DAY_AF"] = 55;
      values[valuesById[56] = "DNSE_INIT_DAY_CI"] = 56;
      values[valuesById[57] = "DNSE_FO_SYSTEM_CONFIG"] = 57;
      values[valuesById[58] = "DNSE_FO_TRADING_CONFIG"] = 58;
      values[valuesById[59] = "DNSE_FO_POSITION"] = 59;
      values[valuesById[60] = "DNSE_FO_ACCOUNT"] = 60;
      values[valuesById[61] = "DNSE_FO_CASH_ACCOUNT"] = 61;
      values[valuesById[62] = "DNSE_FO_MARGIN_BASKET"] = 62;
      values[valuesById[63] = "DNSE_FO_ORDER"] = 63;
      values[valuesById[64] = "DNSE_FO_POOL_RULE"] = 64;
      values[valuesById[65] = "DNSE_FO_POOL_RULE_WRAP"] = 65;
      values[valuesById[66] = "DNSE_FO_INTRADAY_CASH_EVENT"] = 66;
      values[valuesById[67] = "DNSE_FO_INTRADAY_POSITION_EVENT"] = 67;
      values[valuesById[68] = "SS"] = 68;
      values[valuesById[69] = "SU"] = 69;
      values[valuesById[70] = "PING"] = 70;
      values[valuesById[71] = "ENID_USER_CREATED"] = 71;
      values[valuesById[72] = "ENID_USER_UPDATED"] = 72;
      values[valuesById[73] = "DNSE_INVESTOR_REFERRAL"] = 73;
      values[valuesById[74] = "DNSE_INVESTOR_REFERRAL_DONE"] = 74;
      values[valuesById[75] = "DNSE_MARGIN_ACCOUNT_OFFER"] = 75;
      values[valuesById[76] = "DNSE_INVESTOR_STATUS_CHANGED"] = 76;
      values[valuesById[77] = "DNSE_CORPORATE_ACTION_DIVIDEND_AND_RIGHT"] = 77;
      values[valuesById[78] = "ENBOX_BADGE"] = 78;
      values[valuesById[79] = "DNSE_FO_DEAL"] = 79;
      values[valuesById[80] = "DNSE_FO_EXCHANGE_FEE"] = 80;
      values[valuesById[81] = "DNSE_FO_TRADING_FEE"] = 81;
      values[valuesById[82] = "DNSE_FO_ADVANCE_FEE"] = 82;
      values[valuesById[83] = "DNSE_INVESTOR_REFERRAL_FOR_NEW_USER_DONE"] = 83;
      values[valuesById[84] = "DNSE_WITHDRAW_PPSE_NOTIFICATION"] = 84;
      values[valuesById[85] = "DNSE_DEAL_PPSE_WITHDRAW"] = 85;
      values[valuesById[86] = "DNSE_DEAL_PREPAYMENT"] = 86;
      values[valuesById[87] = "DNSE_USER_CHANGE_REQUEST_UPDATED"] = 87;
      values[valuesById[88] = "DNSE_BPM_USER_CHANGE_REQUEST_UPDATED"] = 88;
      values[valuesById[89] = "DNSE_USER_CHANGE_REQUEST_RESULT"] = 89;
      values[valuesById[90] = "DNSE_TRACKING_DEVICE_LOGIN"] = 90;
      values[valuesById[91] = "DNSE_CROSS_ORDER"] = 91;
      values[valuesById[92] = "DNSE_WARNING_UPDATE_INFORMATION"] = 92;
      values[valuesById[93] = "DNSE_FO_ROOM_RULE"] = 93;
      values[valuesById[94] = "DNSE_FO_ROOM_RULE_WRAP"] = 94;
      values[valuesById[95] = "DNSE_ACCOUNT_CUSTOM_DETAIL"] = 95;
      values[valuesById[96] = "DNSE_ACCOUNT_UPDATED"] = 96;
      values[valuesById[97] = "DNSE_MARKET_SESSION"] = 97;
      values[valuesById[98] = "DNSE_INVESTOR_CHANGE_EMAIL"] = 98;
      values[valuesById[100] = "ENTRADE_DNSE_LINK"] = 100;
      values[valuesById[101] = "ENTRADE_DERIVATIVE_MARGIN_PORTFOLIO_OFFER"] = 101;
      values[valuesById[200] = "DNSE_FO_LOAN_PACKAGE"] = 200;
      values[valuesById[201] = "DNSE_FO_LOAN_BASKET"] = 201;
      values[valuesById[202] = "DNSE_FO_LOAN_PACKAGE_ACCOUNT"] = 202;
      values[valuesById[203] = "DNSE_FO_LOAN_PACKAGE_ACCOUNT_WRAP"] = 203;
      values[valuesById[204] = "DNSE_FO_TRADING_CONFIG_V2"] = 204;
      values[valuesById[205] = "DNSE_BANK_REWARD_COMMISSION"] = 205;
      values[valuesById[206] = "DNSE_FO_LOAN"] = 206;
      values[valuesById[207] = "DNSE_LOAN"] = 207;
      values[valuesById[208] = "DNSE_LOAN_INIT_CONTROL"] = 208;
      values[valuesById[209] = "SAVINGS_PRODUCT"] = 209;
      values[valuesById[210] = "SAVINGS_ACCOUNT"] = 210;
      values[valuesById[211] = "SAVINGS_ACCOUNT_DEPOSIT"] = 211;
      values[valuesById[212] = "SAVINGS_ACCOUNT_SETTLEMENT"] = 212;
      values[valuesById[213] = "SAVINGS_BPM_SETTLEMENT"] = 213;
      values[valuesById[214] = "SAVINGS_ACCOUNT_WITHDRAWAL"] = 214;
      values[valuesById[215] = "SAVINGS_ACCOUNT_MATURITY_ALERT"] = 215;
      values[valuesById[216] = "SAVINGS_ACCOUNT_ROLLOVER"] = 216;
      values[valuesById[217] = "SAVINGS_CASH_EVENT"] = 217;
      values[valuesById[218] = "SAVINGS_ACCOUNT_CREATED"] = 218;
      values[valuesById[219] = "STOCK_STATISTICS"] = 219;
      values[valuesById[220] = "TOP_INFLUENCE_STOCKS"] = 220;
      values[valuesById[221] = "LIST_STOCK_STATISTICS"] = 221;
      values[valuesById[225] = "FSP_ESTIMATE"] = 225;
      values[valuesById[222] = "DNSE_INVESTOR_ACTIVATED"] = 222;
      values[valuesById[223] = "DNSE_FLEX_CUSTOMER_ACTIVE"] = 223;
      values[valuesById[224] = "DNSE_FLEX_HO_STATUS"] = 224;
      values[valuesById[230] = "DNSE_DEAL_RISK_CALL"] = 230;
      values[valuesById[231] = "EMAIL"] = 231;
      values[valuesById[232] = "DNSE_PRODUCT_SUGGESTION"] = 232;
      values[valuesById[233] = "DNSE_CASH_IN_ADVANCE_EVENT"] = 233;
      values[valuesById[240] = "DNSE_DEAL_RISK_LIQUID"] = 240;
      values[valuesById[241] = "DNSE_DEAL_ACCOUNT_EVENT"] = 241;
      values[valuesById[242] = "DNSE_FIRST_ORDER_REWARD"] = 242;
      values[valuesById[243] = "DNSE_FIRST_ORDER_REWARD_PAID"] = 243;
      values[valuesById[244] = "DNSE_REWARD_PROGRESS"] = 244;
      values[valuesById[245] = "DNSE_FIRST_ORDER_WICHART_REWARD"] = 245;
      values[valuesById[250] = "DNSE_DEAL_RISK_DELAY_LIQUID"] = 250;
      values[valuesById[251] = "DNSE_SMART_EXECUTION"] = 251;
      values[valuesById[252] = "DNSE_HANDOFF_SMART_OTP"] = 252;
      values[valuesById[253] = "DNSE_HANDOFF_SMART_OTP_APPROVED"] = 253;
      values[valuesById[254] = "DNSE_DEAL_DEPOSIT_REQ"] = 254;
      values[valuesById[255] = "DNSE_DEAL_WITHDRAWAL_REQ"] = 255;
      values[valuesById[256] = "DNSE_LOAN_WARNING_DUE_DATE"] = 256;
      values[valuesById[257] = "DNSE_LOAN_OVER_DUE_DATE"] = 257;
      values[valuesById[258] = "DNSE_DEAL_MIGRATE"] = 258;
      values[valuesById[260] = "DNSE_TRIGGER_INVESTOR_CHANGE"] = 260;
      values[valuesById[261] = "DNSE_DEAL_CORPORATE_ACTION"] = 261;
      values[valuesById[262] = "DNSE_AVAILABLE_CASH_CHANGE"] = 262;
      values[valuesById[263] = "DNSE_TYPE_BASE_WITHDRAW"] = 263;
      values[valuesById[264] = "DNSE_ADVANCE_WITHDRAW_TRANSACTION"] = 264;
      values[valuesById[265] = "DNSE_STOCKS_TRANSFER"] = 265;
      values[valuesById[266] = "DNSE_ORDER_PNL"] = 266;
      values[valuesById[267] = "SAVINGS_GOLDEN_EGG_NEW_DAY"] = 267;
      values[valuesById[268] = "DNSE_SYSTEM_MAINTAIN"] = 268;
      values[valuesById[269] = "DNSE_INVESTOR_SACO_REFERRAL_FOR_NEW_USER"] = 269;
      values[valuesById[270] = "DNSE_ACCOUNT_CORPORATE_ACTION"] = 270;
      values[valuesById[271] = "ENTRADE_DEBT_SNAPSHOT"] = 271;
      values[valuesById[272] = "DNSE_NOTIFY_ORDER"] = 272;
      values[valuesById[273] = "DNSE_LOAN_CALL_FORCE_SELL"] = 273;
      values[valuesById[274] = "DNSE_ASSET_CASH_TRANSFER_EXTERNAL"] = 274;
      values[valuesById[280] = "DNSE_PROMO_TASK"] = 280;
      values[valuesById[281] = "DNSE_PROMO_REGISTER_EVENT"] = 281;
      values[valuesById[282] = "DNSE_PROMO_STOCK_REWARD"] = 282;
      values[valuesById[283] = "RECOMMENDER_TRADE_SIGNAL"] = 283;
      values[valuesById[284] = "LEADERBOARD_USER_RANKS"] = 284;
      values[valuesById[285] = "LEADERBOARD_USER_RANK"] = 285;
      values[valuesById[286] = "LEADERBOARD_TOP_USERS"] = 286;
      values[valuesById[287] = "OAUTH2_USER_CONSENT"] = 287;
      values[valuesById[290] = "DNSE_MGM_EVENT"] = 290;
      values[valuesById[291] = "DNSE_MGM_FIRST_TRANSACTION_REWARD"] = 291;
      values[valuesById[292] = "DNSE_MGM_GET_REWARD"] = 292;
      values[valuesById[300] = "DNSE_COVERED_WARRANT_SETTLEMENT_EVENT"] = 300;
      values[valuesById[301] = "BID_ASK_INFO"] = 301;
      values[valuesById[302] = "MARKET_BREADTH"] = 302;
      values[valuesById[303] = "ESTIMATED_MARKET_INDEX"] = 303;
      values[valuesById[304] = "GLOBAL_MARKET_INDEX"] = 304;
      values[valuesById[305] = "GLOBAL_MARKET_OHLC"] = 305;
      values[valuesById[310] = "DNSE_AUTO_CALL_PAYMENT_EVENT"] = 310;
      values[valuesById[311] = "DNSE_FLEX_CUSTOMER_EVENT"] = 311;
      values[valuesById[312] = "DNSE_DTA_ACCOUNT"] = 312;
      values[valuesById[313] = "DNSE_DTA_CASH"] = 313;
      values[valuesById[320] = "DNSE_RESET_PASSWORD_EVENT"] = 320;
      values[valuesById[321] = "DNSE_REGISTER_DERIVATIVE_EVENT"] = 321;
      values[valuesById[322] = "DNSE_DERIVATIVE_ACCOUNT_ACTIVE"] = 322;
      values[valuesById[323] = "DNSE_DERIVATIVE_CASH_ACCOUNT_COMMAND"] = 323;
      values[valuesById[400] = "GIFT_REDEEMED_NOTIFICATION"] = 400;
      values[valuesById[401] = "GIFT_CREATED_NOTIFICATION"] = 401;
      values[valuesById[402] = "GIFT_REJECTED_NOTIFICATION"] = 402;
      values[valuesById[403] = "GIFT_EXPIRED_NOTIFICATION"] = 403;
      values[valuesById[404] = "BPM_GIFT_REJECTED"] = 404;
      values[valuesById[405] = "BPM_GIFT_REDEEMED"] = 405;
      values[valuesById[406] = "BPM_GIFT_CONTRACT_SIGNED"] = 406;
      values[valuesById[520] = "DNSE_NEWS_NOTICE"] = 520;
      values[valuesById[521] = "DNSE_BREAKING_NEWS"] = 521;
      values[valuesById[522] = "DNSE_NEWS"] = 522;
      values[valuesById[530] = "DNSE_MARKET_MENTALITY"] = 530;
      values[valuesById[531] = "DNSE_MARKET_PE"] = 531;
      values[valuesById[550] = "DNSE_ECONTRACT_EVENT"] = 550;
      values[valuesById[600] = "DNSE_BROKER_SACO_TYPE"] = 600;
      values[valuesById[601] = "DNSE_BROKER_WRAPPER"] = 601;
      values[valuesById[602] = "DNSE_NEW_BROKER_CREATED"] = 602;
      values[valuesById[700] = "DNSE_BIDV_LA_WALLET_TRANSACTION"] = 700;
      values[valuesById[701] = "DNSE_LA_WALLET_TRANSACTION"] = 701;
      values[valuesById[702] = "DNSE_LA_LINK_TRANSACTION"] = 702;
      values[valuesById[730] = "SECTOR_VOLATILITY"] = 730;
      values[valuesById[731] = "STOCK_VOLATILITY"] = 731;
      values[valuesById[800] = "DNSE_IPO_REGISTRATION_ANALYTIC"] = 800;
      values[valuesById[4e3] = "DNSE_IPO_NOTIFY_PAYMENT_STATUS"] = 4e3;
      values[valuesById[4001] = "DNSE_IPO_NOTIFY_ENBOX"] = 4001;
      values[valuesById[4002] = "DNSE_IPO_NOTIFY_REGISTRATION_FORM_STATUS"] = 4002;
      values[valuesById[4101] = "DNSE_GAMIFICATION_NOTIFY_LEADERBOARD_RESULT"] = 4101;
      values[valuesById[1e3] = "DNSE_CONDITIONAL_ORDER"] = 1e3;
      values[valuesById[1001] = "DNSE_CONDITIONAL_ORDER_WORKER_STATUS_REPORT"] = 1001;
      values[valuesById[1002] = "STOCK_LISTED_STATUS"] = 1002;
      values[valuesById[1003] = "PARTNER_DEPOSIT_HOOK"] = 1003;
      values[valuesById[1004] = "PARTNER_DEPOSIT_REQUEST"] = 1004;
      values[valuesById[1005] = "PARTNER_DEPOSIT_BALANCE_HOOK"] = 1005;
      values[valuesById[1101] = "SAVINGS_BPM_APPROVE_OPEN_MANUAL"] = 1101;
      values[valuesById[1102] = "SAVINGS_BPM_APPROVE_SETTLE_MANUAL"] = 1102;
      values[valuesById[1103] = "SAVINGS_BPM_GOLDEN_EGG_CONTRACT"] = 1103;
      values[valuesById[1200] = "FINANCING_OFFER_CREATED"] = 1200;
      values[valuesById[1201] = "FINANCING_OFFER_REQUEST_DECLINED"] = 1201;
      values[valuesById[1202] = "FINANCING_OFFER_OFFLINE_CONFIRMATION"] = 1202;
      values[valuesById[1203] = "FINANCING_OFFER_ONLINE_CONFIRMATION"] = 1203;
      values[valuesById[1204] = "FINANCING_OFFER_LOAN_PACKAGE_READY"] = 1204;
      values[valuesById[1205] = "FINANCING_OFFER_DERIVATIVE_REQUEST_DECLINED"] = 1205;
      values[valuesById[1206] = "FINANCING_OFFER_DERIVATIVE_OFFLINE_CONFIRMATION"] = 1206;
      values[valuesById[1207] = "FINANCING_OFFER_DERIVATIVE_LOAN_PACKAGE_READY"] = 1207;
      values[valuesById[1208] = "FINANCING_OFFER_SUGGESTED_OFFER_CREATED"] = 1208;
      values[valuesById[1209] = "FINANCING_OFFER_LOAN_PACKAGE_REQUEST"] = 1209;
      values[valuesById[1300] = "MOBILIZED_CAPITAL_LOAN_PACKAGE_CREATED"] = 1300;
      values[valuesById[1301] = "MOBILIZED_CAPITAL_BPM_LOAN_PACKAGE_SETTLEMENT"] = 1301;
      values[valuesById[1302] = "MOBILIZED_CAPITAL_LOAN_PACKAGE_WITHDRAWAL"] = 1302;
      values[valuesById[1303] = "MOBILIZED_CAPITAL_LOAN_PACKAGE_CONTRACT"] = 1303;
      values[valuesById[1304] = "MOBILIZED_CAPITAL_MATURITY_ALERT"] = 1304;
      values[valuesById[1305] = "MOBILIZED_CAPITAL_LOAN_INVESTOR_ACTIVATED"] = 1305;
      values[valuesById[1306] = "MOBILIZED_CAPITAL_GOLDEN_EGG_CREATED"] = 1306;
      values[valuesById[1400] = "ENTRADE_LOANX_LOAN_PACKAGE_CREATED"] = 1400;
      values[valuesById[1401] = "ENTRADE_LOANX_LOAN_PACKAGE_SETTLEMENT"] = 1401;
      values[valuesById[1402] = "ENTRADE_LOANX_LOAN_PACKAGE_WITHDRAWAL"] = 1402;
      values[valuesById[1403] = "ENTRADE_LOANX_LOAN_PACKAGE_CONTRACT"] = 1403;
      values[valuesById[1404] = "ENTRADE_LOANX_MATURITY_ALERT"] = 1404;
      values[valuesById[1405] = "ENTRADE_LOANX_LOAN_INVESTOR_ACTIVATED"] = 1405;
      values[valuesById[1406] = "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_DEPOSIT"] = 1406;
      values[valuesById[1407] = "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_WITHDRAWAL"] = 1407;
      values[valuesById[1500] = "GOLDEN_EGG_CREATED"] = 1500;
      values[valuesById[1501] = "GOLDEN_EGG_CREATED_FAIL"] = 1501;
      values[valuesById[1502] = "GOLDEN_EGG_RECEIVED_INTEREST"] = 1502;
      values[valuesById[1503] = "GOLDEN_EGG_DUE_DATE"] = 1503;
      values[valuesById[1504] = "GOLDEN_EGG_OVER_DUE_DATE"] = 1504;
      values[valuesById[1505] = "GOLDEN_EGG_SELLING_CONFIRMATION"] = 1505;
      values[valuesById[1506] = "GOLDEN_EGG_CREATED_PRE_MARKET"] = 1506;
      values[valuesById[1507] = "GOLDEN_EGG_SUCCEED_SELL_CONFIRMATION"] = 1507;
      values[valuesById[1600] = "SAVINGS_ACCOUNT_FINANCING_CASH_CREATED"] = 1600;
      values[valuesById[1601] = "SAVINGS_ACCOUNT_FINANCING_CASH_FAILED"] = 1601;
      values[valuesById[1602] = "SAVINGS_ACCOUNT_FINANCING_CASH_WITHDRAWAL"] = 1602;
      values[valuesById[1603] = "SAVINGS_ACCOUNT_FINANCING_CASH_CHANGED"] = 1603;
      values[valuesById[2e3] = "DNSE_FO_DERIVATIVE_BASKET"] = 2e3;
      values[valuesById[2001] = "DNSE_FO_DERIVATIVE_LOAN_PACKAGE"] = 2001;
      values[valuesById[2002] = "DNSE_FO_DERIVATIVE_EXCHANGE_FEE"] = 2002;
      values[valuesById[2003] = "DNSE_FO_DERIVATIVE_LOAN_PACKAGE_ACCOUNT"] = 2003;
      values[valuesById[2004] = "DNSE_FO_DERIVATIVE_TRADING_FEE"] = 2004;
      values[valuesById[2005] = "DNSE_FO_DERIVATIVE_ACCOUNT"] = 2005;
      values[valuesById[2006] = "DNSE_FO_DERIVATIVE_TRADING_CONFIG"] = 2006;
      values[valuesById[2007] = "DNSE_FO_DERIVATIVE_INSTRUMENT"] = 2007;
      values[valuesById[2008] = "DNSE_FO_DERIVATIVE_CONTROL"] = 2008;
      values[valuesById[2009] = "DNSE_FO_DERIVATIVE_LOAN_PACKAGE_ACCOUNT_WRAP"] = 2009;
      values[valuesById[2010] = "DNSE_FO_DERIVATIVE_SYSTEM_CONFIG"] = 2010;
      values[valuesById[2011] = "DNSE_FO_DERIVATIVE_INTRADAY_CASH_EVENT"] = 2011;
      values[valuesById[2012] = "DNSE_FO_DERIVATIVE_SETTLEMENT_PRICE_EVENT"] = 2012;
      values[valuesById[2013] = "DNSE_FO_DERIVATIVE_PAYMENT_OBLIGATION"] = 2013;
      values[valuesById[2014] = "DNSE_FO_DERIVATIVE_PAID_CONTROL_MESSAGE"] = 2014;
      values[valuesById[2015] = "DNSE_FO_DERIVATIVE_DEAL"] = 2015;
      values[valuesById[2016] = "DNSE_FO_DERIVATIVE_DEAL_WRAP"] = 2016;
      values[valuesById[2017] = "DNSE_FO_DERIVATIVE_SETTLEMENT_CONTROL_MESSAGE"] = 2017;
      values[valuesById[2018] = "DNSE_FO_DERIVATIVE_INITIAL_MARGIN"] = 2018;
      values[valuesById[2019] = "DNSE_FO_DERIVATIVE_CASH_ACCOUNT"] = 2019;
      values[valuesById[2020] = "DNSE_FO_DERIVATIVE_ORDER"] = 2020;
      values[valuesById[2021] = "DNSE_FO_DERIVATIVE_POSITION_LIMIT"] = 2021;
      values[valuesById[2022] = "DNSE_NOTIFY_DERIVATIVE_ORDER"] = 2022;
      values[valuesById[2030] = "DNSE_FO_DERIVATIVE_RISK_UPDATE"] = 2030;
      values[valuesById[2031] = "DNSE_FO_DERIVATIVE_RISK_CALL"] = 2031;
      values[valuesById[2032] = "DNSE_FO_DERIVATIVE_RISK_LIQUIDATE"] = 2032;
      values[valuesById[2033] = "DNSE_FO_DERIVATIVE_VSD_SECURE"] = 2033;
      values[valuesById[2034] = "DNSE_DERIVATIVE_RECEIVE_PROFIT"] = 2034;
      values[valuesById[2035] = "DNSE_DERIVATIVE_PAYMENT_OBLIGATION_EOD"] = 2035;
      values[valuesById[2036] = "DNSE_DERIVATIVE_MATURITY"] = 2036;
      values[valuesById[2037] = "DNSE_FO_DERIVATIVE_RISK_STOP_LOSS"] = 2037;
      values[valuesById[2038] = "DNSE_FO_DERIVATIVE_RISK_TAKE_PROFIT"] = 2038;
      values[valuesById[2039] = "DNSE_FO_DERIVATIVE_RISK_STOP_LOSS_FAILED"] = 2039;
      values[valuesById[2040] = "DNSE_FO_DERIVATIVE_RISK_TAKE_PROFIT_FAILED"] = 2040;
      values[valuesById[2100] = "DNSE_DERIVATIVE_DEAL_SECURE"] = 2100;
      values[valuesById[2200] = "DNSE_DERIVATIVE_PROFIT_LOSS_CLOSE_DEAL"] = 2200;
      values[valuesById[2201] = "DNSE_DERIVATIVE_ESTIMATE_SETTLEMENT_PRICE"] = 2201;
      values[valuesById[2202] = "DNSE_DERIVATIVE_PENDING_DEPOSIT_EVENT"] = 2202;
      values[valuesById[2203] = "DNSE_DERIVATIVE_LOAN"] = 2203;
      values[valuesById[2204] = "DNSE_DERIVATIVE_LOAN_WRAP"] = 2204;
      values[valuesById[2205] = "DNSE_DERIVATIVE_PENDING_DEPOSIT_AND_WITHDRAW_EVENT"] = 2205;
      values[valuesById[2206] = "DNSE_DERIVATIVE_DEAL_SECURE_WITHDRAW"] = 2206;
      values[valuesById[2207] = "DNSE_DERIVATIVE_DEPOSIT_SECURE_FROM_BANK_FAILED"] = 2207;
      values[valuesById[2210] = "DNSE_DERIVATIVE_PREPAY_DEAL_OBLIGATION_PAYMENT_EVENT"] = 2210;
      values[valuesById[2211] = "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_DEAL_DEBT_EVENT"] = 2211;
      values[valuesById[2212] = "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_PROFIT_ADVANCE_EVENT"] = 2212;
      values[valuesById[2213] = "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_OBLIGATION_PAYMENT_EVENT"] = 2213;
      values[valuesById[2214] = "DNSE_DERIVATIVE_AUTO_PREPAY"] = 2214;
      values[valuesById[2215] = "DNSE_DERIVATIVE_END_OF_MONTH_INTEREST_PAYMENT"] = 2215;
      values[valuesById[2216] = "DNSE_INITDAY_INTERNAL_PERSON"] = 2216;
      values[valuesById[2217] = "DNSE_INTRADAY_INTERNAL_PERSON"] = 2217;
      values[valuesById[2218] = "DNSE_DERIVATIVE_PREPAY_CASH_ACCOUNT_VSD_SECURE_ADVANCE_EVENT"] = 2218;
      values[valuesById[2219] = "DNSE_DERIVATIVE_TRANSACTION"] = 2219;
      values[valuesById[2220] = "DNSE_DERIVATIVE_HOLD_COLLATERAL_FEES"] = 2220;
      values[valuesById[2221] = "DNSE_CROSS_ORDER_APPROVAL_REQUIREMENT"] = 2221;
      values[valuesById[2222] = "DNSE_INTERNAL_COMPANY_PERSON"] = 2222;
      values[valuesById[2223] = "DNSE_END_OF_MONTH_INTEREST_EVENT"] = 2223;
      values[valuesById[2224] = "DNSE_DERIVATIVE_LOAN_TRANSACTION"] = 2224;
      values[valuesById[2225] = "DNSE_DERIVATIVE_INTERNAL_END_OF_MONTH_INTEREST"] = 2225;
      values[valuesById[2226] = "DNSE_DERIVATIVE_INIT_DAY_PAYMENT_REPORT"] = 2226;
      values[valuesById[2250] = "DNSE_GROUP_ORDER"] = 2250;
      values[valuesById[3e3] = "DNSE_ACCOUNT_CHANGE_EVENT_WRAPPER"] = 3e3;
      values[valuesById[3001] = "DNSE_CORPORATE_ACTION_NOTIFICATION"] = 3001;
      values[valuesById[2300] = "DNSE_VOLATILITY_INDEX_EVENT"] = 2300;
      values[valuesById[2400] = "DNSE_CO_INVESTMENT_NOTIFY_EVENT"] = 2400;
      values[valuesById[2401] = "DNSE_CO_INVESTMENT_NOTIFY_BALANCE"] = 2401;
      values[valuesById[2402] = "DNSE_CO_INVESTMENT_GROUP"] = 2402;
      values[valuesById[2500] = "DNSE_SOE_DEAL"] = 2500;
      values[valuesById[2600] = "DNSE_WI_ADD_REWARD"] = 2600;
      values[valuesById[2601] = "DNSE_PROMO_STOCK_REWARD_24H"] = 2601;
      values[valuesById[2800] = "DNSE_SUBSCRIPTION"] = 2800;
      values[valuesById[5e3] = "DNSE_BOND_PORTFOLIO"] = 5e3;
      values[valuesById[5001] = "DNSE_BOND_INTEREST_PAYMENT_SCHEDULE"] = 5001;
      values[valuesById[5002] = "DNSE_BOND_LISTED_BOND_ORDER"] = 5002;
      values[valuesById[6e3] = "LOYALTY_POINT_CHANGED"] = 6e3;
      values[valuesById[6001] = "LOYALTY_STATE_CHANGED"] = 6001;
      values[valuesById[6002] = "LOYALTY_STATE_UPDATED"] = 6002;
      values[valuesById[7e3] = "DNSE_BROKER_BROKER_MARGIN"] = 7e3;
      values[valuesById[7001] = "OTP_SENT"] = 7001;
      values[valuesById[7002] = "PARTNER_P2P_GIFT_HOOK"] = 7002;
      values[valuesById[8e3] = "LOAN_NEXUS_EVF_CONTRACT_CREATED"] = 8e3;
      values[valuesById[8001] = "LOAN_NEXUS_EVF_CONTRACT_CANCELLED"] = 8001;
      values[valuesById[8002] = "LOAN_NEXUS_EVF_CONTRACT_REFUSED"] = 8002;
      values[valuesById[8003] = "LOAN_NEXUS_EVF_CONTRACT_ACTIVATED"] = 8003;
      values[valuesById[8004] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_CREATED"] = 8004;
      values[valuesById[8005] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_CANCELLED"] = 8005;
      values[valuesById[8006] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_REFUSED"] = 8006;
      values[valuesById[8007] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_EVF"] = 8007;
      values[valuesById[8008] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE"] = 8008;
      values[valuesById[8009] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE_FAILED"] = 8009;
      values[valuesById[8010] = "LOAN_NEXUS_EVF_CONTRACT_STATUS_CHANGED"] = 8010;
      values[valuesById[8011] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_STATUS_CHANGED"] = 8011;
      values[valuesById[9e3] = "TRANSACTION_CONFIRMATIONS_OWNER_COSPONSOR_BANK_SHOULD_CONFIRM_TRANSACTION"] = 9e3;
      return values;
    }();
    return EncapMessage;
  }();
  models2.EventContext = function() {
    function EventContext(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EventContext.prototype.action = 0;
    EventContext.prototype.source = "";
    EventContext.create = function create(properties) {
      return new EventContext(properties);
    };
    EventContext.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(8).int32(message.action);
      if (message.source != null && Object.hasOwnProperty.call(message, "source"))
        writer.uint32(18).string(message.source);
      return writer;
    };
    EventContext.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EventContext.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.EventContext();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.action = reader.int32();
            break;
          case 2:
            message.source = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EventContext.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EventContext.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.action != null && message.hasOwnProperty("action"))
        switch (message.action) {
          default:
            return "action: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.source != null && message.hasOwnProperty("source")) {
        if (!$util.isString(message.source))
          return "source: string expected";
      }
      return null;
    };
    EventContext.fromObject = function fromObject(object) {
      if (object instanceof $root.models.EventContext)
        return object;
      let message = new $root.models.EventContext();
      switch (object.action) {
        case "CREATE":
        case 0:
          message.action = 0;
          break;
        case "UPDATE":
        case 1:
          message.action = 1;
          break;
        case "DELETE":
        case 2:
          message.action = 2;
          break;
        case "UPSERT":
        case 3:
          message.action = 3;
          break;
      }
      if (object.source != null)
        message.source = String(object.source);
      return message;
    };
    EventContext.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.action = options.enums === String ? "CREATE" : 0;
        object.source = "";
      }
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = options.enums === String ? $root.models.EventContext.Action[message.action] : message.action;
      if (message.source != null && message.hasOwnProperty("source"))
        object.source = message.source;
      return object;
    };
    EventContext.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    EventContext.Action = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "CREATE"] = 0;
      values[valuesById[1] = "UPDATE"] = 1;
      values[valuesById[2] = "DELETE"] = 2;
      values[valuesById[3] = "UPSERT"] = 3;
      return values;
    }();
    return EventContext;
  }();
  models2.TimeResolution = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MIN1"] = 0;
    values[valuesById[1] = "MIN3"] = 1;
    values[valuesById[2] = "MIN5"] = 2;
    values[valuesById[3] = "MIN15"] = 3;
    values[valuesById[4] = "MIN30"] = 4;
    values[valuesById[5] = "MIN45"] = 5;
    values[valuesById[6] = "HOUR1"] = 6;
    values[valuesById[7] = "HOUR2"] = 7;
    values[valuesById[8] = "HOUR3"] = 8;
    values[valuesById[9] = "HOUR4"] = 9;
    values[valuesById[10] = "DAY"] = 10;
    values[valuesById[11] = "WEEK"] = 11;
    values[valuesById[12] = "MONTH"] = 12;
    return values;
  }();
  models2.OHLC = function() {
    function OHLC(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OHLC.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OHLC.prototype.open = 0;
    OHLC.prototype.high = 0;
    OHLC.prototype.low = 0;
    OHLC.prototype.close = 0;
    OHLC.prototype.volume = 0;
    OHLC.prototype.symbol = "";
    OHLC.prototype.resolution = 0;
    OHLC.prototype.lastUpdated = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OHLC.prototype.type = 0;
    OHLC.create = function create(properties) {
      return new OHLC(properties);
    };
    OHLC.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(8).int64(message.time);
      if (message.open != null && Object.hasOwnProperty.call(message, "open"))
        writer.uint32(21).float(message.open);
      if (message.high != null && Object.hasOwnProperty.call(message, "high"))
        writer.uint32(29).float(message.high);
      if (message.low != null && Object.hasOwnProperty.call(message, "low"))
        writer.uint32(37).float(message.low);
      if (message.close != null && Object.hasOwnProperty.call(message, "close"))
        writer.uint32(45).float(message.close);
      if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
        writer.uint32(48).int32(message.volume);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(58).string(message.symbol);
      if (message.resolution != null && Object.hasOwnProperty.call(message, "resolution"))
        writer.uint32(64).int32(message.resolution);
      if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
        writer.uint32(72).int64(message.lastUpdated);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(80).int32(message.type);
      return writer;
    };
    OHLC.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OHLC.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.OHLC();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = reader.int64();
            break;
          case 2:
            message.open = reader.float();
            break;
          case 3:
            message.high = reader.float();
            break;
          case 4:
            message.low = reader.float();
            break;
          case 5:
            message.close = reader.float();
            break;
          case 6:
            message.volume = reader.int32();
            break;
          case 7:
            message.symbol = reader.string();
            break;
          case 8:
            message.resolution = reader.int32();
            break;
          case 9:
            message.lastUpdated = reader.int64();
            break;
          case 10:
            message.type = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OHLC.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OHLC.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.open != null && message.hasOwnProperty("open")) {
        if (typeof message.open !== "number")
          return "open: number expected";
      }
      if (message.high != null && message.hasOwnProperty("high")) {
        if (typeof message.high !== "number")
          return "high: number expected";
      }
      if (message.low != null && message.hasOwnProperty("low")) {
        if (typeof message.low !== "number")
          return "low: number expected";
      }
      if (message.close != null && message.hasOwnProperty("close")) {
        if (typeof message.close !== "number")
          return "close: number expected";
      }
      if (message.volume != null && message.hasOwnProperty("volume")) {
        if (!$util.isInteger(message.volume))
          return "volume: integer expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.resolution != null && message.hasOwnProperty("resolution"))
        switch (message.resolution) {
          default:
            return "resolution: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
            break;
        }
      if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated")) {
        if (!$util.isInteger(message.lastUpdated) && !(message.lastUpdated && $util.isInteger(message.lastUpdated.low) && $util.isInteger(message.lastUpdated.high)))
          return "lastUpdated: integer|Long expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      return null;
    };
    OHLC.fromObject = function fromObject(object) {
      if (object instanceof $root.models.OHLC)
        return object;
      let message = new $root.models.OHLC();
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.open != null)
        message.open = Number(object.open);
      if (object.high != null)
        message.high = Number(object.high);
      if (object.low != null)
        message.low = Number(object.low);
      if (object.close != null)
        message.close = Number(object.close);
      if (object.volume != null)
        message.volume = object.volume | 0;
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      switch (object.resolution) {
        case "MIN1":
        case 0:
          message.resolution = 0;
          break;
        case "MIN3":
        case 1:
          message.resolution = 1;
          break;
        case "MIN5":
        case 2:
          message.resolution = 2;
          break;
        case "MIN15":
        case 3:
          message.resolution = 3;
          break;
        case "MIN30":
        case 4:
          message.resolution = 4;
          break;
        case "MIN45":
        case 5:
          message.resolution = 5;
          break;
        case "HOUR1":
        case 6:
          message.resolution = 6;
          break;
        case "HOUR2":
        case 7:
          message.resolution = 7;
          break;
        case "HOUR3":
        case 8:
          message.resolution = 8;
          break;
        case "HOUR4":
        case 9:
          message.resolution = 9;
          break;
        case "DAY":
        case 10:
          message.resolution = 10;
          break;
        case "WEEK":
        case 11:
          message.resolution = 11;
          break;
        case "MONTH":
        case 12:
          message.resolution = 12;
          break;
      }
      if (object.lastUpdated != null) {
        if ($util.Long)
          (message.lastUpdated = $util.Long.fromValue(object.lastUpdated)).unsigned = false;
        else if (typeof object.lastUpdated === "string")
          message.lastUpdated = parseInt(object.lastUpdated, 10);
        else if (typeof object.lastUpdated === "number")
          message.lastUpdated = object.lastUpdated;
        else if (typeof object.lastUpdated === "object")
          message.lastUpdated = new $util.LongBits(object.lastUpdated.low >>> 0, object.lastUpdated.high >>> 0).toNumber();
      }
      switch (object.type) {
        case "UNKNOWN":
        case 0:
          message.type = 0;
          break;
        case "DERIVATIVE":
        case 1:
          message.type = 1;
          break;
        case "STOCK":
        case 2:
          message.type = 2;
          break;
        case "INDEX":
        case 3:
          message.type = 3;
          break;
      }
      return message;
    };
    OHLC.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.open = 0;
        object.high = 0;
        object.low = 0;
        object.close = 0;
        object.volume = 0;
        object.symbol = "";
        object.resolution = options.enums === String ? "MIN1" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastUpdated = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.lastUpdated = options.longs === String ? "0" : 0;
        object.type = options.enums === String ? "UNKNOWN" : 0;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.open != null && message.hasOwnProperty("open"))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.high != null && message.hasOwnProperty("high"))
        object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
      if (message.low != null && message.hasOwnProperty("low"))
        object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
      if (message.close != null && message.hasOwnProperty("close"))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.volume != null && message.hasOwnProperty("volume"))
        object.volume = message.volume;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.resolution != null && message.hasOwnProperty("resolution"))
        object.resolution = options.enums === String ? $root.models.TimeResolution[message.resolution] : message.resolution;
      if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated"))
        if (typeof message.lastUpdated === "number")
          object.lastUpdated = options.longs === String ? String(message.lastUpdated) : message.lastUpdated;
        else
          object.lastUpdated = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdated) : options.longs === Number ? new $util.LongBits(message.lastUpdated.low >>> 0, message.lastUpdated.high >>> 0).toNumber() : message.lastUpdated;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.models.OHLC.SymbolType[message.type] : message.type;
      return object;
    };
    OHLC.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    OHLC.SymbolType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "DERIVATIVE"] = 1;
      values[valuesById[2] = "STOCK"] = 2;
      values[valuesById[3] = "INDEX"] = 3;
      return values;
    }();
    return OHLC;
  }();
  models2.GlobalOHLC = function() {
    function GlobalOHLC(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GlobalOHLC.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GlobalOHLC.prototype.open = 0;
    GlobalOHLC.prototype.high = 0;
    GlobalOHLC.prototype.low = 0;
    GlobalOHLC.prototype.close = 0;
    GlobalOHLC.prototype.volume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GlobalOHLC.prototype.symbol = "";
    GlobalOHLC.prototype.resolution = 0;
    GlobalOHLC.prototype.lastUpdated = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GlobalOHLC.prototype.type = 0;
    GlobalOHLC.create = function create(properties) {
      return new GlobalOHLC(properties);
    };
    GlobalOHLC.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(8).int64(message.time);
      if (message.open != null && Object.hasOwnProperty.call(message, "open"))
        writer.uint32(21).float(message.open);
      if (message.high != null && Object.hasOwnProperty.call(message, "high"))
        writer.uint32(29).float(message.high);
      if (message.low != null && Object.hasOwnProperty.call(message, "low"))
        writer.uint32(37).float(message.low);
      if (message.close != null && Object.hasOwnProperty.call(message, "close"))
        writer.uint32(45).float(message.close);
      if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
        writer.uint32(48).int64(message.volume);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(58).string(message.symbol);
      if (message.resolution != null && Object.hasOwnProperty.call(message, "resolution"))
        writer.uint32(64).int32(message.resolution);
      if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
        writer.uint32(72).int64(message.lastUpdated);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(80).int32(message.type);
      return writer;
    };
    GlobalOHLC.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GlobalOHLC.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.GlobalOHLC();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = reader.int64();
            break;
          case 2:
            message.open = reader.float();
            break;
          case 3:
            message.high = reader.float();
            break;
          case 4:
            message.low = reader.float();
            break;
          case 5:
            message.close = reader.float();
            break;
          case 6:
            message.volume = reader.int64();
            break;
          case 7:
            message.symbol = reader.string();
            break;
          case 8:
            message.resolution = reader.int32();
            break;
          case 9:
            message.lastUpdated = reader.int64();
            break;
          case 10:
            message.type = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GlobalOHLC.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GlobalOHLC.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.open != null && message.hasOwnProperty("open")) {
        if (typeof message.open !== "number")
          return "open: number expected";
      }
      if (message.high != null && message.hasOwnProperty("high")) {
        if (typeof message.high !== "number")
          return "high: number expected";
      }
      if (message.low != null && message.hasOwnProperty("low")) {
        if (typeof message.low !== "number")
          return "low: number expected";
      }
      if (message.close != null && message.hasOwnProperty("close")) {
        if (typeof message.close !== "number")
          return "close: number expected";
      }
      if (message.volume != null && message.hasOwnProperty("volume")) {
        if (!$util.isInteger(message.volume) && !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high)))
          return "volume: integer|Long expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.resolution != null && message.hasOwnProperty("resolution"))
        switch (message.resolution) {
          default:
            return "resolution: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
            break;
        }
      if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated")) {
        if (!$util.isInteger(message.lastUpdated) && !(message.lastUpdated && $util.isInteger(message.lastUpdated.low) && $util.isInteger(message.lastUpdated.high)))
          return "lastUpdated: integer|Long expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      return null;
    };
    GlobalOHLC.fromObject = function fromObject(object) {
      if (object instanceof $root.models.GlobalOHLC)
        return object;
      let message = new $root.models.GlobalOHLC();
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.open != null)
        message.open = Number(object.open);
      if (object.high != null)
        message.high = Number(object.high);
      if (object.low != null)
        message.low = Number(object.low);
      if (object.close != null)
        message.close = Number(object.close);
      if (object.volume != null) {
        if ($util.Long)
          (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
        else if (typeof object.volume === "string")
          message.volume = parseInt(object.volume, 10);
        else if (typeof object.volume === "number")
          message.volume = object.volume;
        else if (typeof object.volume === "object")
          message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      switch (object.resolution) {
        case "MIN1":
        case 0:
          message.resolution = 0;
          break;
        case "MIN3":
        case 1:
          message.resolution = 1;
          break;
        case "MIN5":
        case 2:
          message.resolution = 2;
          break;
        case "MIN15":
        case 3:
          message.resolution = 3;
          break;
        case "MIN30":
        case 4:
          message.resolution = 4;
          break;
        case "MIN45":
        case 5:
          message.resolution = 5;
          break;
        case "HOUR1":
        case 6:
          message.resolution = 6;
          break;
        case "HOUR2":
        case 7:
          message.resolution = 7;
          break;
        case "HOUR3":
        case 8:
          message.resolution = 8;
          break;
        case "HOUR4":
        case 9:
          message.resolution = 9;
          break;
        case "DAY":
        case 10:
          message.resolution = 10;
          break;
        case "WEEK":
        case 11:
          message.resolution = 11;
          break;
        case "MONTH":
        case 12:
          message.resolution = 12;
          break;
      }
      if (object.lastUpdated != null) {
        if ($util.Long)
          (message.lastUpdated = $util.Long.fromValue(object.lastUpdated)).unsigned = false;
        else if (typeof object.lastUpdated === "string")
          message.lastUpdated = parseInt(object.lastUpdated, 10);
        else if (typeof object.lastUpdated === "number")
          message.lastUpdated = object.lastUpdated;
        else if (typeof object.lastUpdated === "object")
          message.lastUpdated = new $util.LongBits(object.lastUpdated.low >>> 0, object.lastUpdated.high >>> 0).toNumber();
      }
      switch (object.type) {
        case "UNKNOWN":
        case 0:
          message.type = 0;
          break;
        case "DERIVATIVE":
        case 1:
          message.type = 1;
          break;
        case "STOCK":
        case 2:
          message.type = 2;
          break;
        case "INDEX":
        case 3:
          message.type = 3;
          break;
      }
      return message;
    };
    GlobalOHLC.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.open = 0;
        object.high = 0;
        object.low = 0;
        object.close = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.volume = options.longs === String ? "0" : 0;
        object.symbol = "";
        object.resolution = options.enums === String ? "MIN1" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastUpdated = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.lastUpdated = options.longs === String ? "0" : 0;
        object.type = options.enums === String ? "UNKNOWN" : 0;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.open != null && message.hasOwnProperty("open"))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.high != null && message.hasOwnProperty("high"))
        object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
      if (message.low != null && message.hasOwnProperty("low"))
        object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
      if (message.close != null && message.hasOwnProperty("close"))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.volume != null && message.hasOwnProperty("volume"))
        if (typeof message.volume === "number")
          object.volume = options.longs === String ? String(message.volume) : message.volume;
        else
          object.volume = options.longs === String ? $util.Long.prototype.toString.call(message.volume) : options.longs === Number ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber() : message.volume;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.resolution != null && message.hasOwnProperty("resolution"))
        object.resolution = options.enums === String ? $root.models.TimeResolution[message.resolution] : message.resolution;
      if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated"))
        if (typeof message.lastUpdated === "number")
          object.lastUpdated = options.longs === String ? String(message.lastUpdated) : message.lastUpdated;
        else
          object.lastUpdated = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdated) : options.longs === Number ? new $util.LongBits(message.lastUpdated.low >>> 0, message.lastUpdated.high >>> 0).toNumber() : message.lastUpdated;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.models.GlobalOHLC.SymbolType[message.type] : message.type;
      return object;
    };
    GlobalOHLC.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    GlobalOHLC.SymbolType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "DERIVATIVE"] = 1;
      values[valuesById[2] = "STOCK"] = 2;
      values[valuesById[3] = "INDEX"] = 3;
      return values;
    }();
    return GlobalOHLC;
  }();
  models2.StockQuickQuote = function() {
    function StockQuickQuote(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockQuickQuote.prototype.symbol = "";
    StockQuickQuote.prototype.basicPrice = 0;
    StockQuickQuote.prototype.ceilingPrice = 0;
    StockQuickQuote.prototype.floorPrice = 0;
    StockQuickQuote.prototype.accumulatedVolume = 0;
    StockQuickQuote.prototype.accumulatedValue = 0;
    StockQuickQuote.prototype.lastPrice = 0;
    StockQuickQuote.prototype.lastQtty = 0;
    StockQuickQuote.prototype.percentChange = 0;
    StockQuickQuote.prototype.valueChange = 0;
    StockQuickQuote.prototype.timestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    StockQuickQuote.prototype.floorCode = "";
    StockQuickQuote.create = function create(properties) {
      return new StockQuickQuote(properties);
    };
    StockQuickQuote.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
        writer.uint32(21).float(message.basicPrice);
      if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
        writer.uint32(29).float(message.ceilingPrice);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(37).float(message.floorPrice);
      if (message.accumulatedVolume != null && Object.hasOwnProperty.call(message, "accumulatedVolume"))
        writer.uint32(45).float(message.accumulatedVolume);
      if (message.accumulatedValue != null && Object.hasOwnProperty.call(message, "accumulatedValue"))
        writer.uint32(53).float(message.accumulatedValue);
      if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
        writer.uint32(61).float(message.lastPrice);
      if (message.lastQtty != null && Object.hasOwnProperty.call(message, "lastQtty"))
        writer.uint32(69).float(message.lastQtty);
      if (message.percentChange != null && Object.hasOwnProperty.call(message, "percentChange"))
        writer.uint32(77).float(message.percentChange);
      if (message.valueChange != null && Object.hasOwnProperty.call(message, "valueChange"))
        writer.uint32(85).float(message.valueChange);
      if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
        writer.uint32(88).int64(message.timestamp);
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(98).string(message.floorCode);
      return writer;
    };
    StockQuickQuote.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockQuickQuote.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.StockQuickQuote();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.basicPrice = reader.float();
            break;
          case 3:
            message.ceilingPrice = reader.float();
            break;
          case 4:
            message.floorPrice = reader.float();
            break;
          case 5:
            message.accumulatedVolume = reader.float();
            break;
          case 6:
            message.accumulatedValue = reader.float();
            break;
          case 7:
            message.lastPrice = reader.float();
            break;
          case 8:
            message.lastQtty = reader.float();
            break;
          case 9:
            message.percentChange = reader.float();
            break;
          case 10:
            message.valueChange = reader.float();
            break;
          case 11:
            message.timestamp = reader.int64();
            break;
          case 12:
            message.floorCode = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockQuickQuote.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockQuickQuote.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
        if (typeof message.basicPrice !== "number")
          return "basicPrice: number expected";
      }
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
        if (typeof message.ceilingPrice !== "number")
          return "ceilingPrice: number expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (typeof message.floorPrice !== "number")
          return "floorPrice: number expected";
      }
      if (message.accumulatedVolume != null && message.hasOwnProperty("accumulatedVolume")) {
        if (typeof message.accumulatedVolume !== "number")
          return "accumulatedVolume: number expected";
      }
      if (message.accumulatedValue != null && message.hasOwnProperty("accumulatedValue")) {
        if (typeof message.accumulatedValue !== "number")
          return "accumulatedValue: number expected";
      }
      if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
        if (typeof message.lastPrice !== "number")
          return "lastPrice: number expected";
      }
      if (message.lastQtty != null && message.hasOwnProperty("lastQtty")) {
        if (typeof message.lastQtty !== "number")
          return "lastQtty: number expected";
      }
      if (message.percentChange != null && message.hasOwnProperty("percentChange")) {
        if (typeof message.percentChange !== "number")
          return "percentChange: number expected";
      }
      if (message.valueChange != null && message.hasOwnProperty("valueChange")) {
        if (typeof message.valueChange !== "number")
          return "valueChange: number expected";
      }
      if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
          return "timestamp: integer|Long expected";
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode")) {
        if (!$util.isString(message.floorCode))
          return "floorCode: string expected";
      }
      return null;
    };
    StockQuickQuote.fromObject = function fromObject(object) {
      if (object instanceof $root.models.StockQuickQuote)
        return object;
      let message = new $root.models.StockQuickQuote();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.basicPrice != null)
        message.basicPrice = Number(object.basicPrice);
      if (object.ceilingPrice != null)
        message.ceilingPrice = Number(object.ceilingPrice);
      if (object.floorPrice != null)
        message.floorPrice = Number(object.floorPrice);
      if (object.accumulatedVolume != null)
        message.accumulatedVolume = Number(object.accumulatedVolume);
      if (object.accumulatedValue != null)
        message.accumulatedValue = Number(object.accumulatedValue);
      if (object.lastPrice != null)
        message.lastPrice = Number(object.lastPrice);
      if (object.lastQtty != null)
        message.lastQtty = Number(object.lastQtty);
      if (object.percentChange != null)
        message.percentChange = Number(object.percentChange);
      if (object.valueChange != null)
        message.valueChange = Number(object.valueChange);
      if (object.timestamp != null) {
        if ($util.Long)
          (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
        else if (typeof object.timestamp === "string")
          message.timestamp = parseInt(object.timestamp, 10);
        else if (typeof object.timestamp === "number")
          message.timestamp = object.timestamp;
        else if (typeof object.timestamp === "object")
          message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
      }
      if (object.floorCode != null)
        message.floorCode = String(object.floorCode);
      return message;
    };
    StockQuickQuote.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.basicPrice = 0;
        object.ceilingPrice = 0;
        object.floorPrice = 0;
        object.accumulatedVolume = 0;
        object.accumulatedValue = 0;
        object.lastPrice = 0;
        object.lastQtty = 0;
        object.percentChange = 0;
        object.valueChange = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.timestamp = options.longs === String ? "0" : 0;
        object.floorCode = "";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
        object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
        object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
      if (message.accumulatedVolume != null && message.hasOwnProperty("accumulatedVolume"))
        object.accumulatedVolume = options.json && !isFinite(message.accumulatedVolume) ? String(message.accumulatedVolume) : message.accumulatedVolume;
      if (message.accumulatedValue != null && message.hasOwnProperty("accumulatedValue"))
        object.accumulatedValue = options.json && !isFinite(message.accumulatedValue) ? String(message.accumulatedValue) : message.accumulatedValue;
      if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
        object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
      if (message.lastQtty != null && message.hasOwnProperty("lastQtty"))
        object.lastQtty = options.json && !isFinite(message.lastQtty) ? String(message.lastQtty) : message.lastQtty;
      if (message.percentChange != null && message.hasOwnProperty("percentChange"))
        object.percentChange = options.json && !isFinite(message.percentChange) ? String(message.percentChange) : message.percentChange;
      if (message.valueChange != null && message.hasOwnProperty("valueChange"))
        object.valueChange = options.json && !isFinite(message.valueChange) ? String(message.valueChange) : message.valueChange;
      if (message.timestamp != null && message.hasOwnProperty("timestamp"))
        if (typeof message.timestamp === "number")
          object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
        else
          object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = message.floorCode;
      return object;
    };
    StockQuickQuote.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockQuickQuote;
  }();
  models2.StockQuote = function() {
    function StockQuote(properties) {
      this.bid = [];
      this.ask = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockQuote.prototype.floorCode = "";
    StockQuote.prototype.tradingDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    StockQuote.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    StockQuote.prototype.symbol = "";
    StockQuote.prototype.stockType = "";
    StockQuote.prototype.totalRoom = 0;
    StockQuote.prototype.currentRoom = 0;
    StockQuote.prototype.basicPrice = 0;
    StockQuote.prototype.openPrice = 0;
    StockQuote.prototype.closePrice = 0;
    StockQuote.prototype.currentPrice = 0;
    StockQuote.prototype.currentQtty = 0;
    StockQuote.prototype.highestPrice = 0;
    StockQuote.prototype.lowestPrice = 0;
    StockQuote.prototype.ceilingPrice = 0;
    StockQuote.prototype.floorPrice = 0;
    StockQuote.prototype.totalOfferQtty = 0;
    StockQuote.prototype.totalBidQtty = 0;
    StockQuote.prototype.matchPrice = 0;
    StockQuote.prototype.matchQtty = 0;
    StockQuote.prototype.matchValue = 0;
    StockQuote.prototype.averagePrice = 0;
    StockQuote.prototype.bid = $util.emptyArray;
    StockQuote.prototype.ask = $util.emptyArray;
    StockQuote.prototype.accumulatedVal = 0;
    StockQuote.prototype.accumulatedVol = 0;
    StockQuote.prototype.buyForeignQtty = 0;
    StockQuote.prototype.sellForeignQtty = 0;
    StockQuote.prototype.projectOpen = 0;
    StockQuote.prototype.sequence = 0;
    StockQuote.prototype.totalBidPloQtty = 0;
    StockQuote.prototype.totalOfferPloQtty = 0;
    StockQuote.prototype.basket = "";
    StockQuote.prototype.basketContribution = 0;
    StockQuote.prototype.basketWeight = 0;
    StockQuote.create = function create(properties) {
      return new StockQuote(properties);
    };
    StockQuote.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(10).string(message.floorCode);
      if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
        writer.uint32(16).int64(message.tradingDate);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(24).int64(message.time);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.stockType != null && Object.hasOwnProperty.call(message, "stockType"))
        writer.uint32(42).string(message.stockType);
      if (message.totalRoom != null && Object.hasOwnProperty.call(message, "totalRoom"))
        writer.uint32(53).float(message.totalRoom);
      if (message.currentRoom != null && Object.hasOwnProperty.call(message, "currentRoom"))
        writer.uint32(61).float(message.currentRoom);
      if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
        writer.uint32(69).float(message.basicPrice);
      if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
        writer.uint32(77).float(message.openPrice);
      if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
        writer.uint32(85).float(message.closePrice);
      if (message.currentPrice != null && Object.hasOwnProperty.call(message, "currentPrice"))
        writer.uint32(93).float(message.currentPrice);
      if (message.currentQtty != null && Object.hasOwnProperty.call(message, "currentQtty"))
        writer.uint32(101).float(message.currentQtty);
      if (message.highestPrice != null && Object.hasOwnProperty.call(message, "highestPrice"))
        writer.uint32(109).float(message.highestPrice);
      if (message.lowestPrice != null && Object.hasOwnProperty.call(message, "lowestPrice"))
        writer.uint32(117).float(message.lowestPrice);
      if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
        writer.uint32(125).float(message.ceilingPrice);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(133).float(message.floorPrice);
      if (message.totalOfferQtty != null && Object.hasOwnProperty.call(message, "totalOfferQtty"))
        writer.uint32(141).float(message.totalOfferQtty);
      if (message.totalBidQtty != null && Object.hasOwnProperty.call(message, "totalBidQtty"))
        writer.uint32(149).float(message.totalBidQtty);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(157).float(message.matchPrice);
      if (message.matchQtty != null && Object.hasOwnProperty.call(message, "matchQtty"))
        writer.uint32(165).float(message.matchQtty);
      if (message.matchValue != null && Object.hasOwnProperty.call(message, "matchValue"))
        writer.uint32(173).float(message.matchValue);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(181).float(message.averagePrice);
      if (message.bid != null && message.bid.length)
        for (let i = 0; i < message.bid.length; ++i)
          $root.models.OrderMini.encode(message.bid[i], writer.uint32(186).fork()).ldelim();
      if (message.ask != null && message.ask.length)
        for (let i = 0; i < message.ask.length; ++i)
          $root.models.OrderMini.encode(message.ask[i], writer.uint32(194).fork()).ldelim();
      if (message.accumulatedVal != null && Object.hasOwnProperty.call(message, "accumulatedVal"))
        writer.uint32(205).float(message.accumulatedVal);
      if (message.accumulatedVol != null && Object.hasOwnProperty.call(message, "accumulatedVol"))
        writer.uint32(213).float(message.accumulatedVol);
      if (message.buyForeignQtty != null && Object.hasOwnProperty.call(message, "buyForeignQtty"))
        writer.uint32(221).float(message.buyForeignQtty);
      if (message.sellForeignQtty != null && Object.hasOwnProperty.call(message, "sellForeignQtty"))
        writer.uint32(229).float(message.sellForeignQtty);
      if (message.projectOpen != null && Object.hasOwnProperty.call(message, "projectOpen"))
        writer.uint32(237).float(message.projectOpen);
      if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
        writer.uint32(245).float(message.sequence);
      if (message.totalBidPloQtty != null && Object.hasOwnProperty.call(message, "totalBidPloQtty"))
        writer.uint32(253).float(message.totalBidPloQtty);
      if (message.totalOfferPloQtty != null && Object.hasOwnProperty.call(message, "totalOfferPloQtty"))
        writer.uint32(261).float(message.totalOfferPloQtty);
      if (message.basket != null && Object.hasOwnProperty.call(message, "basket"))
        writer.uint32(266).string(message.basket);
      if (message.basketContribution != null && Object.hasOwnProperty.call(message, "basketContribution"))
        writer.uint32(277).float(message.basketContribution);
      if (message.basketWeight != null && Object.hasOwnProperty.call(message, "basketWeight"))
        writer.uint32(285).float(message.basketWeight);
      return writer;
    };
    StockQuote.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockQuote.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.StockQuote();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.floorCode = reader.string();
            break;
          case 2:
            message.tradingDate = reader.int64();
            break;
          case 3:
            message.time = reader.int64();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.stockType = reader.string();
            break;
          case 6:
            message.totalRoom = reader.float();
            break;
          case 7:
            message.currentRoom = reader.float();
            break;
          case 8:
            message.basicPrice = reader.float();
            break;
          case 9:
            message.openPrice = reader.float();
            break;
          case 10:
            message.closePrice = reader.float();
            break;
          case 11:
            message.currentPrice = reader.float();
            break;
          case 12:
            message.currentQtty = reader.float();
            break;
          case 13:
            message.highestPrice = reader.float();
            break;
          case 14:
            message.lowestPrice = reader.float();
            break;
          case 15:
            message.ceilingPrice = reader.float();
            break;
          case 16:
            message.floorPrice = reader.float();
            break;
          case 17:
            message.totalOfferQtty = reader.float();
            break;
          case 18:
            message.totalBidQtty = reader.float();
            break;
          case 19:
            message.matchPrice = reader.float();
            break;
          case 20:
            message.matchQtty = reader.float();
            break;
          case 21:
            message.matchValue = reader.float();
            break;
          case 22:
            message.averagePrice = reader.float();
            break;
          case 23:
            if (!(message.bid && message.bid.length))
              message.bid = [];
            message.bid.push($root.models.OrderMini.decode(reader, reader.uint32()));
            break;
          case 24:
            if (!(message.ask && message.ask.length))
              message.ask = [];
            message.ask.push($root.models.OrderMini.decode(reader, reader.uint32()));
            break;
          case 25:
            message.accumulatedVal = reader.float();
            break;
          case 26:
            message.accumulatedVol = reader.float();
            break;
          case 27:
            message.buyForeignQtty = reader.float();
            break;
          case 28:
            message.sellForeignQtty = reader.float();
            break;
          case 29:
            message.projectOpen = reader.float();
            break;
          case 30:
            message.sequence = reader.float();
            break;
          case 31:
            message.totalBidPloQtty = reader.float();
            break;
          case 32:
            message.totalOfferPloQtty = reader.float();
            break;
          case 33:
            message.basket = reader.string();
            break;
          case 34:
            message.basketContribution = reader.float();
            break;
          case 35:
            message.basketWeight = reader.float();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockQuote.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockQuote.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.floorCode != null && message.hasOwnProperty("floorCode")) {
        if (!$util.isString(message.floorCode))
          return "floorCode: string expected";
      }
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
        if (!$util.isInteger(message.tradingDate) && !(message.tradingDate && $util.isInteger(message.tradingDate.low) && $util.isInteger(message.tradingDate.high)))
          return "tradingDate: integer|Long expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.stockType != null && message.hasOwnProperty("stockType")) {
        if (!$util.isString(message.stockType))
          return "stockType: string expected";
      }
      if (message.totalRoom != null && message.hasOwnProperty("totalRoom")) {
        if (typeof message.totalRoom !== "number")
          return "totalRoom: number expected";
      }
      if (message.currentRoom != null && message.hasOwnProperty("currentRoom")) {
        if (typeof message.currentRoom !== "number")
          return "currentRoom: number expected";
      }
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
        if (typeof message.basicPrice !== "number")
          return "basicPrice: number expected";
      }
      if (message.openPrice != null && message.hasOwnProperty("openPrice")) {
        if (typeof message.openPrice !== "number")
          return "openPrice: number expected";
      }
      if (message.closePrice != null && message.hasOwnProperty("closePrice")) {
        if (typeof message.closePrice !== "number")
          return "closePrice: number expected";
      }
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice")) {
        if (typeof message.currentPrice !== "number")
          return "currentPrice: number expected";
      }
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty")) {
        if (typeof message.currentQtty !== "number")
          return "currentQtty: number expected";
      }
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice")) {
        if (typeof message.highestPrice !== "number")
          return "highestPrice: number expected";
      }
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice")) {
        if (typeof message.lowestPrice !== "number")
          return "lowestPrice: number expected";
      }
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
        if (typeof message.ceilingPrice !== "number")
          return "ceilingPrice: number expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (typeof message.floorPrice !== "number")
          return "floorPrice: number expected";
      }
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty")) {
        if (typeof message.totalOfferQtty !== "number")
          return "totalOfferQtty: number expected";
      }
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty")) {
        if (typeof message.totalBidQtty !== "number")
          return "totalBidQtty: number expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty")) {
        if (typeof message.matchQtty !== "number")
          return "matchQtty: number expected";
      }
      if (message.matchValue != null && message.hasOwnProperty("matchValue")) {
        if (typeof message.matchValue !== "number")
          return "matchValue: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.bid != null && message.hasOwnProperty("bid")) {
        if (!Array.isArray(message.bid))
          return "bid: array expected";
        for (let i = 0; i < message.bid.length; ++i) {
          let error = $root.models.OrderMini.verify(message.bid[i]);
          if (error)
            return "bid." + error;
        }
      }
      if (message.ask != null && message.hasOwnProperty("ask")) {
        if (!Array.isArray(message.ask))
          return "ask: array expected";
        for (let i = 0; i < message.ask.length; ++i) {
          let error = $root.models.OrderMini.verify(message.ask[i]);
          if (error)
            return "ask." + error;
        }
      }
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal")) {
        if (typeof message.accumulatedVal !== "number")
          return "accumulatedVal: number expected";
      }
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol")) {
        if (typeof message.accumulatedVol !== "number")
          return "accumulatedVol: number expected";
      }
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty")) {
        if (typeof message.buyForeignQtty !== "number")
          return "buyForeignQtty: number expected";
      }
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty")) {
        if (typeof message.sellForeignQtty !== "number")
          return "sellForeignQtty: number expected";
      }
      if (message.projectOpen != null && message.hasOwnProperty("projectOpen")) {
        if (typeof message.projectOpen !== "number")
          return "projectOpen: number expected";
      }
      if (message.sequence != null && message.hasOwnProperty("sequence")) {
        if (typeof message.sequence !== "number")
          return "sequence: number expected";
      }
      if (message.totalBidPloQtty != null && message.hasOwnProperty("totalBidPloQtty")) {
        if (typeof message.totalBidPloQtty !== "number")
          return "totalBidPloQtty: number expected";
      }
      if (message.totalOfferPloQtty != null && message.hasOwnProperty("totalOfferPloQtty")) {
        if (typeof message.totalOfferPloQtty !== "number")
          return "totalOfferPloQtty: number expected";
      }
      if (message.basket != null && message.hasOwnProperty("basket")) {
        if (!$util.isString(message.basket))
          return "basket: string expected";
      }
      if (message.basketContribution != null && message.hasOwnProperty("basketContribution")) {
        if (typeof message.basketContribution !== "number")
          return "basketContribution: number expected";
      }
      if (message.basketWeight != null && message.hasOwnProperty("basketWeight")) {
        if (typeof message.basketWeight !== "number")
          return "basketWeight: number expected";
      }
      return null;
    };
    StockQuote.fromObject = function fromObject(object) {
      if (object instanceof $root.models.StockQuote)
        return object;
      let message = new $root.models.StockQuote();
      if (object.floorCode != null)
        message.floorCode = String(object.floorCode);
      if (object.tradingDate != null) {
        if ($util.Long)
          (message.tradingDate = $util.Long.fromValue(object.tradingDate)).unsigned = false;
        else if (typeof object.tradingDate === "string")
          message.tradingDate = parseInt(object.tradingDate, 10);
        else if (typeof object.tradingDate === "number")
          message.tradingDate = object.tradingDate;
        else if (typeof object.tradingDate === "object")
          message.tradingDate = new $util.LongBits(object.tradingDate.low >>> 0, object.tradingDate.high >>> 0).toNumber();
      }
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.stockType != null)
        message.stockType = String(object.stockType);
      if (object.totalRoom != null)
        message.totalRoom = Number(object.totalRoom);
      if (object.currentRoom != null)
        message.currentRoom = Number(object.currentRoom);
      if (object.basicPrice != null)
        message.basicPrice = Number(object.basicPrice);
      if (object.openPrice != null)
        message.openPrice = Number(object.openPrice);
      if (object.closePrice != null)
        message.closePrice = Number(object.closePrice);
      if (object.currentPrice != null)
        message.currentPrice = Number(object.currentPrice);
      if (object.currentQtty != null)
        message.currentQtty = Number(object.currentQtty);
      if (object.highestPrice != null)
        message.highestPrice = Number(object.highestPrice);
      if (object.lowestPrice != null)
        message.lowestPrice = Number(object.lowestPrice);
      if (object.ceilingPrice != null)
        message.ceilingPrice = Number(object.ceilingPrice);
      if (object.floorPrice != null)
        message.floorPrice = Number(object.floorPrice);
      if (object.totalOfferQtty != null)
        message.totalOfferQtty = Number(object.totalOfferQtty);
      if (object.totalBidQtty != null)
        message.totalBidQtty = Number(object.totalBidQtty);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.matchQtty != null)
        message.matchQtty = Number(object.matchQtty);
      if (object.matchValue != null)
        message.matchValue = Number(object.matchValue);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.bid) {
        if (!Array.isArray(object.bid))
          throw TypeError(".models.StockQuote.bid: array expected");
        message.bid = [];
        for (let i = 0; i < object.bid.length; ++i) {
          if (typeof object.bid[i] !== "object")
            throw TypeError(".models.StockQuote.bid: object expected");
          message.bid[i] = $root.models.OrderMini.fromObject(object.bid[i]);
        }
      }
      if (object.ask) {
        if (!Array.isArray(object.ask))
          throw TypeError(".models.StockQuote.ask: array expected");
        message.ask = [];
        for (let i = 0; i < object.ask.length; ++i) {
          if (typeof object.ask[i] !== "object")
            throw TypeError(".models.StockQuote.ask: object expected");
          message.ask[i] = $root.models.OrderMini.fromObject(object.ask[i]);
        }
      }
      if (object.accumulatedVal != null)
        message.accumulatedVal = Number(object.accumulatedVal);
      if (object.accumulatedVol != null)
        message.accumulatedVol = Number(object.accumulatedVol);
      if (object.buyForeignQtty != null)
        message.buyForeignQtty = Number(object.buyForeignQtty);
      if (object.sellForeignQtty != null)
        message.sellForeignQtty = Number(object.sellForeignQtty);
      if (object.projectOpen != null)
        message.projectOpen = Number(object.projectOpen);
      if (object.sequence != null)
        message.sequence = Number(object.sequence);
      if (object.totalBidPloQtty != null)
        message.totalBidPloQtty = Number(object.totalBidPloQtty);
      if (object.totalOfferPloQtty != null)
        message.totalOfferPloQtty = Number(object.totalOfferPloQtty);
      if (object.basket != null)
        message.basket = String(object.basket);
      if (object.basketContribution != null)
        message.basketContribution = Number(object.basketContribution);
      if (object.basketWeight != null)
        message.basketWeight = Number(object.basketWeight);
      return message;
    };
    StockQuote.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.bid = [];
        object.ask = [];
      }
      if (options.defaults) {
        object.floorCode = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradingDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tradingDate = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.symbol = "";
        object.stockType = "";
        object.totalRoom = 0;
        object.currentRoom = 0;
        object.basicPrice = 0;
        object.openPrice = 0;
        object.closePrice = 0;
        object.currentPrice = 0;
        object.currentQtty = 0;
        object.highestPrice = 0;
        object.lowestPrice = 0;
        object.ceilingPrice = 0;
        object.floorPrice = 0;
        object.totalOfferQtty = 0;
        object.totalBidQtty = 0;
        object.matchPrice = 0;
        object.matchQtty = 0;
        object.matchValue = 0;
        object.averagePrice = 0;
        object.accumulatedVal = 0;
        object.accumulatedVol = 0;
        object.buyForeignQtty = 0;
        object.sellForeignQtty = 0;
        object.projectOpen = 0;
        object.sequence = 0;
        object.totalBidPloQtty = 0;
        object.totalOfferPloQtty = 0;
        object.basket = "";
        object.basketContribution = 0;
        object.basketWeight = 0;
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = message.floorCode;
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
        if (typeof message.tradingDate === "number")
          object.tradingDate = options.longs === String ? String(message.tradingDate) : message.tradingDate;
        else
          object.tradingDate = options.longs === String ? $util.Long.prototype.toString.call(message.tradingDate) : options.longs === Number ? new $util.LongBits(message.tradingDate.low >>> 0, message.tradingDate.high >>> 0).toNumber() : message.tradingDate;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.stockType != null && message.hasOwnProperty("stockType"))
        object.stockType = message.stockType;
      if (message.totalRoom != null && message.hasOwnProperty("totalRoom"))
        object.totalRoom = options.json && !isFinite(message.totalRoom) ? String(message.totalRoom) : message.totalRoom;
      if (message.currentRoom != null && message.hasOwnProperty("currentRoom"))
        object.currentRoom = options.json && !isFinite(message.currentRoom) ? String(message.currentRoom) : message.currentRoom;
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
        object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
      if (message.openPrice != null && message.hasOwnProperty("openPrice"))
        object.openPrice = options.json && !isFinite(message.openPrice) ? String(message.openPrice) : message.openPrice;
      if (message.closePrice != null && message.hasOwnProperty("closePrice"))
        object.closePrice = options.json && !isFinite(message.closePrice) ? String(message.closePrice) : message.closePrice;
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
        object.currentPrice = options.json && !isFinite(message.currentPrice) ? String(message.currentPrice) : message.currentPrice;
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty"))
        object.currentQtty = options.json && !isFinite(message.currentQtty) ? String(message.currentQtty) : message.currentQtty;
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
        object.highestPrice = options.json && !isFinite(message.highestPrice) ? String(message.highestPrice) : message.highestPrice;
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
        object.lowestPrice = options.json && !isFinite(message.lowestPrice) ? String(message.lowestPrice) : message.lowestPrice;
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
        object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty"))
        object.totalOfferQtty = options.json && !isFinite(message.totalOfferQtty) ? String(message.totalOfferQtty) : message.totalOfferQtty;
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty"))
        object.totalBidQtty = options.json && !isFinite(message.totalBidQtty) ? String(message.totalBidQtty) : message.totalBidQtty;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty"))
        object.matchQtty = options.json && !isFinite(message.matchQtty) ? String(message.matchQtty) : message.matchQtty;
      if (message.matchValue != null && message.hasOwnProperty("matchValue"))
        object.matchValue = options.json && !isFinite(message.matchValue) ? String(message.matchValue) : message.matchValue;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.bid && message.bid.length) {
        object.bid = [];
        for (let j = 0; j < message.bid.length; ++j)
          object.bid[j] = $root.models.OrderMini.toObject(message.bid[j], options);
      }
      if (message.ask && message.ask.length) {
        object.ask = [];
        for (let j = 0; j < message.ask.length; ++j)
          object.ask[j] = $root.models.OrderMini.toObject(message.ask[j], options);
      }
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal"))
        object.accumulatedVal = options.json && !isFinite(message.accumulatedVal) ? String(message.accumulatedVal) : message.accumulatedVal;
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol"))
        object.accumulatedVol = options.json && !isFinite(message.accumulatedVol) ? String(message.accumulatedVol) : message.accumulatedVol;
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty"))
        object.buyForeignQtty = options.json && !isFinite(message.buyForeignQtty) ? String(message.buyForeignQtty) : message.buyForeignQtty;
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty"))
        object.sellForeignQtty = options.json && !isFinite(message.sellForeignQtty) ? String(message.sellForeignQtty) : message.sellForeignQtty;
      if (message.projectOpen != null && message.hasOwnProperty("projectOpen"))
        object.projectOpen = options.json && !isFinite(message.projectOpen) ? String(message.projectOpen) : message.projectOpen;
      if (message.sequence != null && message.hasOwnProperty("sequence"))
        object.sequence = options.json && !isFinite(message.sequence) ? String(message.sequence) : message.sequence;
      if (message.totalBidPloQtty != null && message.hasOwnProperty("totalBidPloQtty"))
        object.totalBidPloQtty = options.json && !isFinite(message.totalBidPloQtty) ? String(message.totalBidPloQtty) : message.totalBidPloQtty;
      if (message.totalOfferPloQtty != null && message.hasOwnProperty("totalOfferPloQtty"))
        object.totalOfferPloQtty = options.json && !isFinite(message.totalOfferPloQtty) ? String(message.totalOfferPloQtty) : message.totalOfferPloQtty;
      if (message.basket != null && message.hasOwnProperty("basket"))
        object.basket = message.basket;
      if (message.basketContribution != null && message.hasOwnProperty("basketContribution"))
        object.basketContribution = options.json && !isFinite(message.basketContribution) ? String(message.basketContribution) : message.basketContribution;
      if (message.basketWeight != null && message.hasOwnProperty("basketWeight"))
        object.basketWeight = options.json && !isFinite(message.basketWeight) ? String(message.basketWeight) : message.basketWeight;
      return object;
    };
    StockQuote.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockQuote;
  }();
  models2.OrderMini = function() {
    function OrderMini(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OrderMini.prototype.price = 0;
    OrderMini.prototype.qtty = 0;
    OrderMini.create = function create(properties) {
      return new OrderMini(properties);
    };
    OrderMini.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(13).float(message.price);
      if (message.qtty != null && Object.hasOwnProperty.call(message, "qtty"))
        writer.uint32(21).float(message.qtty);
      return writer;
    };
    OrderMini.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OrderMini.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.OrderMini();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.price = reader.float();
            break;
          case 2:
            message.qtty = reader.float();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OrderMini.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OrderMini.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.qtty != null && message.hasOwnProperty("qtty")) {
        if (typeof message.qtty !== "number")
          return "qtty: number expected";
      }
      return null;
    };
    OrderMini.fromObject = function fromObject(object) {
      if (object instanceof $root.models.OrderMini)
        return object;
      let message = new $root.models.OrderMini();
      if (object.price != null)
        message.price = Number(object.price);
      if (object.qtty != null)
        message.qtty = Number(object.qtty);
      return message;
    };
    OrderMini.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.price = 0;
        object.qtty = 0;
      }
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.qtty != null && message.hasOwnProperty("qtty"))
        object.qtty = options.json && !isFinite(message.qtty) ? String(message.qtty) : message.qtty;
      return object;
    };
    OrderMini.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return OrderMini;
  }();
  models2.TradingSessionId = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "OPEN"] = 0;
    values[valuesById[13] = "CLOSED"] = 13;
    values[valuesById[12] = "DONE"] = 12;
    values[valuesById[10] = "NOON_BREAK"] = 10;
    values[valuesById[3] = "START_MIDSESSION_BREAK"] = 3;
    values[valuesById[1] = "DONE_MIDSESSION_BREAK"] = 1;
    values[valuesById[2] = "ATO"] = 2;
    values[valuesById[9] = "ATC"] = 9;
    values[valuesById[35] = "PUT_THROUGH"] = 35;
    values[valuesById[5] = "CONTINUOUS"] = 5;
    values[valuesById[7] = "STOP_ALL_TRADE"] = 7;
    values[valuesById[8] = "RESUME_ALL_TRADE"] = 8;
    values[valuesById[6] = "RESUME_TRADE_SYMBOL"] = 6;
    values[valuesById[11] = "END_ALL"] = 11;
    return values;
  }();
  models2.MarketIndex = function() {
    function MarketIndex(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MarketIndex.prototype.marketID = "";
    MarketIndex.prototype.totalTrade = 0;
    MarketIndex.prototype.totalShareTraded = 0;
    MarketIndex.prototype.totalValueTraded = 0;
    MarketIndex.prototype.advance = 0;
    MarketIndex.prototype.decline = 0;
    MarketIndex.prototype.noChange = 0;
    MarketIndex.prototype.indexValue = 0;
    MarketIndex.prototype.changed = 0;
    MarketIndex.prototype.tradingTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.tradingDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.floorCode = "";
    MarketIndex.prototype.marketIndex = 0;
    MarketIndex.prototype.priorMarketIndex = 0;
    MarketIndex.prototype.highestIndex = 0;
    MarketIndex.prototype.lowestIndex = 0;
    MarketIndex.prototype.shareTraded = 0;
    MarketIndex.prototype.status = 0;
    MarketIndex.prototype.sequence = 0;
    MarketIndex.prototype.predictionMarketIndex = 0;
    MarketIndex.prototype.indexName = 0;
    MarketIndex.prototype.tradingSessionId = 0;
    MarketIndex.prototype.fluctuationUpperLimitIssueCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.fluctuationLowerLimitIssueCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.fluctuationUpIssueVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.fluctuationDownIssueVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.fluctuationSteadinessIssueVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketIndex.prototype.receivedTime = null;
    MarketIndex.create = function create(properties) {
      return new MarketIndex(properties);
    };
    MarketIndex.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.marketID != null && Object.hasOwnProperty.call(message, "marketID"))
        writer.uint32(10).string(message.marketID);
      if (message.totalTrade != null && Object.hasOwnProperty.call(message, "totalTrade"))
        writer.uint32(21).float(message.totalTrade);
      if (message.totalShareTraded != null && Object.hasOwnProperty.call(message, "totalShareTraded"))
        writer.uint32(25).double(message.totalShareTraded);
      if (message.totalValueTraded != null && Object.hasOwnProperty.call(message, "totalValueTraded"))
        writer.uint32(33).double(message.totalValueTraded);
      if (message.advance != null && Object.hasOwnProperty.call(message, "advance"))
        writer.uint32(45).float(message.advance);
      if (message.decline != null && Object.hasOwnProperty.call(message, "decline"))
        writer.uint32(53).float(message.decline);
      if (message.noChange != null && Object.hasOwnProperty.call(message, "noChange"))
        writer.uint32(61).float(message.noChange);
      if (message.indexValue != null && Object.hasOwnProperty.call(message, "indexValue"))
        writer.uint32(69).float(message.indexValue);
      if (message.changed != null && Object.hasOwnProperty.call(message, "changed"))
        writer.uint32(77).float(message.changed);
      if (message.tradingTime != null && Object.hasOwnProperty.call(message, "tradingTime"))
        writer.uint32(80).int64(message.tradingTime);
      if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
        writer.uint32(88).int64(message.tradingDate);
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(98).string(message.floorCode);
      if (message.marketIndex != null && Object.hasOwnProperty.call(message, "marketIndex"))
        writer.uint32(109).float(message.marketIndex);
      if (message.priorMarketIndex != null && Object.hasOwnProperty.call(message, "priorMarketIndex"))
        writer.uint32(117).float(message.priorMarketIndex);
      if (message.highestIndex != null && Object.hasOwnProperty.call(message, "highestIndex"))
        writer.uint32(125).float(message.highestIndex);
      if (message.lowestIndex != null && Object.hasOwnProperty.call(message, "lowestIndex"))
        writer.uint32(133).float(message.lowestIndex);
      if (message.shareTraded != null && Object.hasOwnProperty.call(message, "shareTraded"))
        writer.uint32(141).float(message.shareTraded);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(149).float(message.status);
      if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
        writer.uint32(157).float(message.sequence);
      if (message.predictionMarketIndex != null && Object.hasOwnProperty.call(message, "predictionMarketIndex"))
        writer.uint32(165).float(message.predictionMarketIndex);
      if (message.indexName != null && Object.hasOwnProperty.call(message, "indexName"))
        writer.uint32(168).int32(message.indexName);
      if (message.tradingSessionId != null && Object.hasOwnProperty.call(message, "tradingSessionId"))
        writer.uint32(176).int32(message.tradingSessionId);
      if (message.fluctuationUpperLimitIssueCount != null && Object.hasOwnProperty.call(message, "fluctuationUpperLimitIssueCount"))
        writer.uint32(184).int64(message.fluctuationUpperLimitIssueCount);
      if (message.fluctuationLowerLimitIssueCount != null && Object.hasOwnProperty.call(message, "fluctuationLowerLimitIssueCount"))
        writer.uint32(192).int64(message.fluctuationLowerLimitIssueCount);
      if (message.fluctuationUpIssueVolume != null && Object.hasOwnProperty.call(message, "fluctuationUpIssueVolume"))
        writer.uint32(200).int64(message.fluctuationUpIssueVolume);
      if (message.fluctuationDownIssueVolume != null && Object.hasOwnProperty.call(message, "fluctuationDownIssueVolume"))
        writer.uint32(208).int64(message.fluctuationDownIssueVolume);
      if (message.fluctuationSteadinessIssueVolume != null && Object.hasOwnProperty.call(message, "fluctuationSteadinessIssueVolume"))
        writer.uint32(216).int64(message.fluctuationSteadinessIssueVolume);
      if (message.receivedTime != null && Object.hasOwnProperty.call(message, "receivedTime"))
        $root.google.protobuf.Timestamp.encode(message.receivedTime, writer.uint32(226).fork()).ldelim();
      return writer;
    };
    MarketIndex.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MarketIndex.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.MarketIndex();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.marketID = reader.string();
            break;
          case 2:
            message.totalTrade = reader.float();
            break;
          case 3:
            message.totalShareTraded = reader.double();
            break;
          case 4:
            message.totalValueTraded = reader.double();
            break;
          case 5:
            message.advance = reader.float();
            break;
          case 6:
            message.decline = reader.float();
            break;
          case 7:
            message.noChange = reader.float();
            break;
          case 8:
            message.indexValue = reader.float();
            break;
          case 9:
            message.changed = reader.float();
            break;
          case 10:
            message.tradingTime = reader.int64();
            break;
          case 11:
            message.tradingDate = reader.int64();
            break;
          case 12:
            message.floorCode = reader.string();
            break;
          case 13:
            message.marketIndex = reader.float();
            break;
          case 14:
            message.priorMarketIndex = reader.float();
            break;
          case 15:
            message.highestIndex = reader.float();
            break;
          case 16:
            message.lowestIndex = reader.float();
            break;
          case 17:
            message.shareTraded = reader.float();
            break;
          case 18:
            message.status = reader.float();
            break;
          case 19:
            message.sequence = reader.float();
            break;
          case 20:
            message.predictionMarketIndex = reader.float();
            break;
          case 21:
            message.indexName = reader.int32();
            break;
          case 22:
            message.tradingSessionId = reader.int32();
            break;
          case 23:
            message.fluctuationUpperLimitIssueCount = reader.int64();
            break;
          case 24:
            message.fluctuationLowerLimitIssueCount = reader.int64();
            break;
          case 25:
            message.fluctuationUpIssueVolume = reader.int64();
            break;
          case 26:
            message.fluctuationDownIssueVolume = reader.int64();
            break;
          case 27:
            message.fluctuationSteadinessIssueVolume = reader.int64();
            break;
          case 28:
            message.receivedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MarketIndex.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MarketIndex.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.marketID != null && message.hasOwnProperty("marketID")) {
        if (!$util.isString(message.marketID))
          return "marketID: string expected";
      }
      if (message.totalTrade != null && message.hasOwnProperty("totalTrade")) {
        if (typeof message.totalTrade !== "number")
          return "totalTrade: number expected";
      }
      if (message.totalShareTraded != null && message.hasOwnProperty("totalShareTraded")) {
        if (typeof message.totalShareTraded !== "number")
          return "totalShareTraded: number expected";
      }
      if (message.totalValueTraded != null && message.hasOwnProperty("totalValueTraded")) {
        if (typeof message.totalValueTraded !== "number")
          return "totalValueTraded: number expected";
      }
      if (message.advance != null && message.hasOwnProperty("advance")) {
        if (typeof message.advance !== "number")
          return "advance: number expected";
      }
      if (message.decline != null && message.hasOwnProperty("decline")) {
        if (typeof message.decline !== "number")
          return "decline: number expected";
      }
      if (message.noChange != null && message.hasOwnProperty("noChange")) {
        if (typeof message.noChange !== "number")
          return "noChange: number expected";
      }
      if (message.indexValue != null && message.hasOwnProperty("indexValue")) {
        if (typeof message.indexValue !== "number")
          return "indexValue: number expected";
      }
      if (message.changed != null && message.hasOwnProperty("changed")) {
        if (typeof message.changed !== "number")
          return "changed: number expected";
      }
      if (message.tradingTime != null && message.hasOwnProperty("tradingTime")) {
        if (!$util.isInteger(message.tradingTime) && !(message.tradingTime && $util.isInteger(message.tradingTime.low) && $util.isInteger(message.tradingTime.high)))
          return "tradingTime: integer|Long expected";
      }
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
        if (!$util.isInteger(message.tradingDate) && !(message.tradingDate && $util.isInteger(message.tradingDate.low) && $util.isInteger(message.tradingDate.high)))
          return "tradingDate: integer|Long expected";
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode")) {
        if (!$util.isString(message.floorCode))
          return "floorCode: string expected";
      }
      if (message.marketIndex != null && message.hasOwnProperty("marketIndex")) {
        if (typeof message.marketIndex !== "number")
          return "marketIndex: number expected";
      }
      if (message.priorMarketIndex != null && message.hasOwnProperty("priorMarketIndex")) {
        if (typeof message.priorMarketIndex !== "number")
          return "priorMarketIndex: number expected";
      }
      if (message.highestIndex != null && message.hasOwnProperty("highestIndex")) {
        if (typeof message.highestIndex !== "number")
          return "highestIndex: number expected";
      }
      if (message.lowestIndex != null && message.hasOwnProperty("lowestIndex")) {
        if (typeof message.lowestIndex !== "number")
          return "lowestIndex: number expected";
      }
      if (message.shareTraded != null && message.hasOwnProperty("shareTraded")) {
        if (typeof message.shareTraded !== "number")
          return "shareTraded: number expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (typeof message.status !== "number")
          return "status: number expected";
      }
      if (message.sequence != null && message.hasOwnProperty("sequence")) {
        if (typeof message.sequence !== "number")
          return "sequence: number expected";
      }
      if (message.predictionMarketIndex != null && message.hasOwnProperty("predictionMarketIndex")) {
        if (typeof message.predictionMarketIndex !== "number")
          return "predictionMarketIndex: number expected";
      }
      if (message.indexName != null && message.hasOwnProperty("indexName"))
        switch (message.indexName) {
          default:
            return "indexName: enum value expected";
          case 0:
          case 2:
          case 3:
          case 10:
          case 11:
          case 12:
          case 13:
            break;
        }
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        switch (message.tradingSessionId) {
          default:
            return "tradingSessionId: enum value expected";
          case 0:
          case 13:
          case 12:
          case 10:
          case 3:
          case 1:
          case 2:
          case 9:
          case 35:
          case 5:
          case 7:
          case 8:
          case 6:
          case 11:
            break;
        }
      if (message.fluctuationUpperLimitIssueCount != null && message.hasOwnProperty("fluctuationUpperLimitIssueCount")) {
        if (!$util.isInteger(message.fluctuationUpperLimitIssueCount) && !(message.fluctuationUpperLimitIssueCount && $util.isInteger(message.fluctuationUpperLimitIssueCount.low) && $util.isInteger(message.fluctuationUpperLimitIssueCount.high)))
          return "fluctuationUpperLimitIssueCount: integer|Long expected";
      }
      if (message.fluctuationLowerLimitIssueCount != null && message.hasOwnProperty("fluctuationLowerLimitIssueCount")) {
        if (!$util.isInteger(message.fluctuationLowerLimitIssueCount) && !(message.fluctuationLowerLimitIssueCount && $util.isInteger(message.fluctuationLowerLimitIssueCount.low) && $util.isInteger(message.fluctuationLowerLimitIssueCount.high)))
          return "fluctuationLowerLimitIssueCount: integer|Long expected";
      }
      if (message.fluctuationUpIssueVolume != null && message.hasOwnProperty("fluctuationUpIssueVolume")) {
        if (!$util.isInteger(message.fluctuationUpIssueVolume) && !(message.fluctuationUpIssueVolume && $util.isInteger(message.fluctuationUpIssueVolume.low) && $util.isInteger(message.fluctuationUpIssueVolume.high)))
          return "fluctuationUpIssueVolume: integer|Long expected";
      }
      if (message.fluctuationDownIssueVolume != null && message.hasOwnProperty("fluctuationDownIssueVolume")) {
        if (!$util.isInteger(message.fluctuationDownIssueVolume) && !(message.fluctuationDownIssueVolume && $util.isInteger(message.fluctuationDownIssueVolume.low) && $util.isInteger(message.fluctuationDownIssueVolume.high)))
          return "fluctuationDownIssueVolume: integer|Long expected";
      }
      if (message.fluctuationSteadinessIssueVolume != null && message.hasOwnProperty("fluctuationSteadinessIssueVolume")) {
        if (!$util.isInteger(message.fluctuationSteadinessIssueVolume) && !(message.fluctuationSteadinessIssueVolume && $util.isInteger(message.fluctuationSteadinessIssueVolume.low) && $util.isInteger(message.fluctuationSteadinessIssueVolume.high)))
          return "fluctuationSteadinessIssueVolume: integer|Long expected";
      }
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.receivedTime);
        if (error)
          return "receivedTime." + error;
      }
      return null;
    };
    MarketIndex.fromObject = function fromObject(object) {
      if (object instanceof $root.models.MarketIndex)
        return object;
      let message = new $root.models.MarketIndex();
      if (object.marketID != null)
        message.marketID = String(object.marketID);
      if (object.totalTrade != null)
        message.totalTrade = Number(object.totalTrade);
      if (object.totalShareTraded != null)
        message.totalShareTraded = Number(object.totalShareTraded);
      if (object.totalValueTraded != null)
        message.totalValueTraded = Number(object.totalValueTraded);
      if (object.advance != null)
        message.advance = Number(object.advance);
      if (object.decline != null)
        message.decline = Number(object.decline);
      if (object.noChange != null)
        message.noChange = Number(object.noChange);
      if (object.indexValue != null)
        message.indexValue = Number(object.indexValue);
      if (object.changed != null)
        message.changed = Number(object.changed);
      if (object.tradingTime != null) {
        if ($util.Long)
          (message.tradingTime = $util.Long.fromValue(object.tradingTime)).unsigned = false;
        else if (typeof object.tradingTime === "string")
          message.tradingTime = parseInt(object.tradingTime, 10);
        else if (typeof object.tradingTime === "number")
          message.tradingTime = object.tradingTime;
        else if (typeof object.tradingTime === "object")
          message.tradingTime = new $util.LongBits(object.tradingTime.low >>> 0, object.tradingTime.high >>> 0).toNumber();
      }
      if (object.tradingDate != null) {
        if ($util.Long)
          (message.tradingDate = $util.Long.fromValue(object.tradingDate)).unsigned = false;
        else if (typeof object.tradingDate === "string")
          message.tradingDate = parseInt(object.tradingDate, 10);
        else if (typeof object.tradingDate === "number")
          message.tradingDate = object.tradingDate;
        else if (typeof object.tradingDate === "object")
          message.tradingDate = new $util.LongBits(object.tradingDate.low >>> 0, object.tradingDate.high >>> 0).toNumber();
      }
      if (object.floorCode != null)
        message.floorCode = String(object.floorCode);
      if (object.marketIndex != null)
        message.marketIndex = Number(object.marketIndex);
      if (object.priorMarketIndex != null)
        message.priorMarketIndex = Number(object.priorMarketIndex);
      if (object.highestIndex != null)
        message.highestIndex = Number(object.highestIndex);
      if (object.lowestIndex != null)
        message.lowestIndex = Number(object.lowestIndex);
      if (object.shareTraded != null)
        message.shareTraded = Number(object.shareTraded);
      if (object.status != null)
        message.status = Number(object.status);
      if (object.sequence != null)
        message.sequence = Number(object.sequence);
      if (object.predictionMarketIndex != null)
        message.predictionMarketIndex = Number(object.predictionMarketIndex);
      switch (object.indexName) {
        case "UNKNOWN":
        case 0:
          message.indexName = 0;
          break;
        case "HNX":
        case 2:
          message.indexName = 2;
          break;
        case "UPCOM":
        case 3:
          message.indexName = 3;
          break;
        case "VNINDEX":
        case 10:
          message.indexName = 10;
          break;
        case "VN30":
        case 11:
          message.indexName = 11;
          break;
        case "HNX30":
        case 12:
          message.indexName = 12;
          break;
        case "VNXALLSHARE":
        case 13:
          message.indexName = 13;
          break;
      }
      switch (object.tradingSessionId) {
        case "OPEN":
        case 0:
          message.tradingSessionId = 0;
          break;
        case "CLOSED":
        case 13:
          message.tradingSessionId = 13;
          break;
        case "DONE":
        case 12:
          message.tradingSessionId = 12;
          break;
        case "NOON_BREAK":
        case 10:
          message.tradingSessionId = 10;
          break;
        case "START_MIDSESSION_BREAK":
        case 3:
          message.tradingSessionId = 3;
          break;
        case "DONE_MIDSESSION_BREAK":
        case 1:
          message.tradingSessionId = 1;
          break;
        case "ATO":
        case 2:
          message.tradingSessionId = 2;
          break;
        case "ATC":
        case 9:
          message.tradingSessionId = 9;
          break;
        case "PUT_THROUGH":
        case 35:
          message.tradingSessionId = 35;
          break;
        case "CONTINUOUS":
        case 5:
          message.tradingSessionId = 5;
          break;
        case "STOP_ALL_TRADE":
        case 7:
          message.tradingSessionId = 7;
          break;
        case "RESUME_ALL_TRADE":
        case 8:
          message.tradingSessionId = 8;
          break;
        case "RESUME_TRADE_SYMBOL":
        case 6:
          message.tradingSessionId = 6;
          break;
        case "END_ALL":
        case 11:
          message.tradingSessionId = 11;
          break;
      }
      if (object.fluctuationUpperLimitIssueCount != null) {
        if ($util.Long)
          (message.fluctuationUpperLimitIssueCount = $util.Long.fromValue(object.fluctuationUpperLimitIssueCount)).unsigned = false;
        else if (typeof object.fluctuationUpperLimitIssueCount === "string")
          message.fluctuationUpperLimitIssueCount = parseInt(object.fluctuationUpperLimitIssueCount, 10);
        else if (typeof object.fluctuationUpperLimitIssueCount === "number")
          message.fluctuationUpperLimitIssueCount = object.fluctuationUpperLimitIssueCount;
        else if (typeof object.fluctuationUpperLimitIssueCount === "object")
          message.fluctuationUpperLimitIssueCount = new $util.LongBits(object.fluctuationUpperLimitIssueCount.low >>> 0, object.fluctuationUpperLimitIssueCount.high >>> 0).toNumber();
      }
      if (object.fluctuationLowerLimitIssueCount != null) {
        if ($util.Long)
          (message.fluctuationLowerLimitIssueCount = $util.Long.fromValue(object.fluctuationLowerLimitIssueCount)).unsigned = false;
        else if (typeof object.fluctuationLowerLimitIssueCount === "string")
          message.fluctuationLowerLimitIssueCount = parseInt(object.fluctuationLowerLimitIssueCount, 10);
        else if (typeof object.fluctuationLowerLimitIssueCount === "number")
          message.fluctuationLowerLimitIssueCount = object.fluctuationLowerLimitIssueCount;
        else if (typeof object.fluctuationLowerLimitIssueCount === "object")
          message.fluctuationLowerLimitIssueCount = new $util.LongBits(object.fluctuationLowerLimitIssueCount.low >>> 0, object.fluctuationLowerLimitIssueCount.high >>> 0).toNumber();
      }
      if (object.fluctuationUpIssueVolume != null) {
        if ($util.Long)
          (message.fluctuationUpIssueVolume = $util.Long.fromValue(object.fluctuationUpIssueVolume)).unsigned = false;
        else if (typeof object.fluctuationUpIssueVolume === "string")
          message.fluctuationUpIssueVolume = parseInt(object.fluctuationUpIssueVolume, 10);
        else if (typeof object.fluctuationUpIssueVolume === "number")
          message.fluctuationUpIssueVolume = object.fluctuationUpIssueVolume;
        else if (typeof object.fluctuationUpIssueVolume === "object")
          message.fluctuationUpIssueVolume = new $util.LongBits(object.fluctuationUpIssueVolume.low >>> 0, object.fluctuationUpIssueVolume.high >>> 0).toNumber();
      }
      if (object.fluctuationDownIssueVolume != null) {
        if ($util.Long)
          (message.fluctuationDownIssueVolume = $util.Long.fromValue(object.fluctuationDownIssueVolume)).unsigned = false;
        else if (typeof object.fluctuationDownIssueVolume === "string")
          message.fluctuationDownIssueVolume = parseInt(object.fluctuationDownIssueVolume, 10);
        else if (typeof object.fluctuationDownIssueVolume === "number")
          message.fluctuationDownIssueVolume = object.fluctuationDownIssueVolume;
        else if (typeof object.fluctuationDownIssueVolume === "object")
          message.fluctuationDownIssueVolume = new $util.LongBits(object.fluctuationDownIssueVolume.low >>> 0, object.fluctuationDownIssueVolume.high >>> 0).toNumber();
      }
      if (object.fluctuationSteadinessIssueVolume != null) {
        if ($util.Long)
          (message.fluctuationSteadinessIssueVolume = $util.Long.fromValue(object.fluctuationSteadinessIssueVolume)).unsigned = false;
        else if (typeof object.fluctuationSteadinessIssueVolume === "string")
          message.fluctuationSteadinessIssueVolume = parseInt(object.fluctuationSteadinessIssueVolume, 10);
        else if (typeof object.fluctuationSteadinessIssueVolume === "number")
          message.fluctuationSteadinessIssueVolume = object.fluctuationSteadinessIssueVolume;
        else if (typeof object.fluctuationSteadinessIssueVolume === "object")
          message.fluctuationSteadinessIssueVolume = new $util.LongBits(object.fluctuationSteadinessIssueVolume.low >>> 0, object.fluctuationSteadinessIssueVolume.high >>> 0).toNumber();
      }
      if (object.receivedTime != null) {
        if (typeof object.receivedTime !== "object")
          throw TypeError(".models.MarketIndex.receivedTime: object expected");
        message.receivedTime = $root.google.protobuf.Timestamp.fromObject(object.receivedTime);
      }
      return message;
    };
    MarketIndex.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.marketID = "";
        object.totalTrade = 0;
        object.totalShareTraded = 0;
        object.totalValueTraded = 0;
        object.advance = 0;
        object.decline = 0;
        object.noChange = 0;
        object.indexValue = 0;
        object.changed = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradingTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tradingTime = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradingDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tradingDate = options.longs === String ? "0" : 0;
        object.floorCode = "";
        object.marketIndex = 0;
        object.priorMarketIndex = 0;
        object.highestIndex = 0;
        object.lowestIndex = 0;
        object.shareTraded = 0;
        object.status = 0;
        object.sequence = 0;
        object.predictionMarketIndex = 0;
        object.indexName = options.enums === String ? "UNKNOWN" : 0;
        object.tradingSessionId = options.enums === String ? "OPEN" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fluctuationUpperLimitIssueCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fluctuationUpperLimitIssueCount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fluctuationLowerLimitIssueCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fluctuationLowerLimitIssueCount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fluctuationUpIssueVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fluctuationUpIssueVolume = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fluctuationDownIssueVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fluctuationDownIssueVolume = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fluctuationSteadinessIssueVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fluctuationSteadinessIssueVolume = options.longs === String ? "0" : 0;
        object.receivedTime = null;
      }
      if (message.marketID != null && message.hasOwnProperty("marketID"))
        object.marketID = message.marketID;
      if (message.totalTrade != null && message.hasOwnProperty("totalTrade"))
        object.totalTrade = options.json && !isFinite(message.totalTrade) ? String(message.totalTrade) : message.totalTrade;
      if (message.totalShareTraded != null && message.hasOwnProperty("totalShareTraded"))
        object.totalShareTraded = options.json && !isFinite(message.totalShareTraded) ? String(message.totalShareTraded) : message.totalShareTraded;
      if (message.totalValueTraded != null && message.hasOwnProperty("totalValueTraded"))
        object.totalValueTraded = options.json && !isFinite(message.totalValueTraded) ? String(message.totalValueTraded) : message.totalValueTraded;
      if (message.advance != null && message.hasOwnProperty("advance"))
        object.advance = options.json && !isFinite(message.advance) ? String(message.advance) : message.advance;
      if (message.decline != null && message.hasOwnProperty("decline"))
        object.decline = options.json && !isFinite(message.decline) ? String(message.decline) : message.decline;
      if (message.noChange != null && message.hasOwnProperty("noChange"))
        object.noChange = options.json && !isFinite(message.noChange) ? String(message.noChange) : message.noChange;
      if (message.indexValue != null && message.hasOwnProperty("indexValue"))
        object.indexValue = options.json && !isFinite(message.indexValue) ? String(message.indexValue) : message.indexValue;
      if (message.changed != null && message.hasOwnProperty("changed"))
        object.changed = options.json && !isFinite(message.changed) ? String(message.changed) : message.changed;
      if (message.tradingTime != null && message.hasOwnProperty("tradingTime"))
        if (typeof message.tradingTime === "number")
          object.tradingTime = options.longs === String ? String(message.tradingTime) : message.tradingTime;
        else
          object.tradingTime = options.longs === String ? $util.Long.prototype.toString.call(message.tradingTime) : options.longs === Number ? new $util.LongBits(message.tradingTime.low >>> 0, message.tradingTime.high >>> 0).toNumber() : message.tradingTime;
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
        if (typeof message.tradingDate === "number")
          object.tradingDate = options.longs === String ? String(message.tradingDate) : message.tradingDate;
        else
          object.tradingDate = options.longs === String ? $util.Long.prototype.toString.call(message.tradingDate) : options.longs === Number ? new $util.LongBits(message.tradingDate.low >>> 0, message.tradingDate.high >>> 0).toNumber() : message.tradingDate;
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = message.floorCode;
      if (message.marketIndex != null && message.hasOwnProperty("marketIndex"))
        object.marketIndex = options.json && !isFinite(message.marketIndex) ? String(message.marketIndex) : message.marketIndex;
      if (message.priorMarketIndex != null && message.hasOwnProperty("priorMarketIndex"))
        object.priorMarketIndex = options.json && !isFinite(message.priorMarketIndex) ? String(message.priorMarketIndex) : message.priorMarketIndex;
      if (message.highestIndex != null && message.hasOwnProperty("highestIndex"))
        object.highestIndex = options.json && !isFinite(message.highestIndex) ? String(message.highestIndex) : message.highestIndex;
      if (message.lowestIndex != null && message.hasOwnProperty("lowestIndex"))
        object.lowestIndex = options.json && !isFinite(message.lowestIndex) ? String(message.lowestIndex) : message.lowestIndex;
      if (message.shareTraded != null && message.hasOwnProperty("shareTraded"))
        object.shareTraded = options.json && !isFinite(message.shareTraded) ? String(message.shareTraded) : message.shareTraded;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.json && !isFinite(message.status) ? String(message.status) : message.status;
      if (message.sequence != null && message.hasOwnProperty("sequence"))
        object.sequence = options.json && !isFinite(message.sequence) ? String(message.sequence) : message.sequence;
      if (message.predictionMarketIndex != null && message.hasOwnProperty("predictionMarketIndex"))
        object.predictionMarketIndex = options.json && !isFinite(message.predictionMarketIndex) ? String(message.predictionMarketIndex) : message.predictionMarketIndex;
      if (message.indexName != null && message.hasOwnProperty("indexName"))
        object.indexName = options.enums === String ? $root.models.MarketIndex.Market[message.indexName] : message.indexName;
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        object.tradingSessionId = options.enums === String ? $root.models.TradingSessionId[message.tradingSessionId] : message.tradingSessionId;
      if (message.fluctuationUpperLimitIssueCount != null && message.hasOwnProperty("fluctuationUpperLimitIssueCount"))
        if (typeof message.fluctuationUpperLimitIssueCount === "number")
          object.fluctuationUpperLimitIssueCount = options.longs === String ? String(message.fluctuationUpperLimitIssueCount) : message.fluctuationUpperLimitIssueCount;
        else
          object.fluctuationUpperLimitIssueCount = options.longs === String ? $util.Long.prototype.toString.call(message.fluctuationUpperLimitIssueCount) : options.longs === Number ? new $util.LongBits(message.fluctuationUpperLimitIssueCount.low >>> 0, message.fluctuationUpperLimitIssueCount.high >>> 0).toNumber() : message.fluctuationUpperLimitIssueCount;
      if (message.fluctuationLowerLimitIssueCount != null && message.hasOwnProperty("fluctuationLowerLimitIssueCount"))
        if (typeof message.fluctuationLowerLimitIssueCount === "number")
          object.fluctuationLowerLimitIssueCount = options.longs === String ? String(message.fluctuationLowerLimitIssueCount) : message.fluctuationLowerLimitIssueCount;
        else
          object.fluctuationLowerLimitIssueCount = options.longs === String ? $util.Long.prototype.toString.call(message.fluctuationLowerLimitIssueCount) : options.longs === Number ? new $util.LongBits(message.fluctuationLowerLimitIssueCount.low >>> 0, message.fluctuationLowerLimitIssueCount.high >>> 0).toNumber() : message.fluctuationLowerLimitIssueCount;
      if (message.fluctuationUpIssueVolume != null && message.hasOwnProperty("fluctuationUpIssueVolume"))
        if (typeof message.fluctuationUpIssueVolume === "number")
          object.fluctuationUpIssueVolume = options.longs === String ? String(message.fluctuationUpIssueVolume) : message.fluctuationUpIssueVolume;
        else
          object.fluctuationUpIssueVolume = options.longs === String ? $util.Long.prototype.toString.call(message.fluctuationUpIssueVolume) : options.longs === Number ? new $util.LongBits(message.fluctuationUpIssueVolume.low >>> 0, message.fluctuationUpIssueVolume.high >>> 0).toNumber() : message.fluctuationUpIssueVolume;
      if (message.fluctuationDownIssueVolume != null && message.hasOwnProperty("fluctuationDownIssueVolume"))
        if (typeof message.fluctuationDownIssueVolume === "number")
          object.fluctuationDownIssueVolume = options.longs === String ? String(message.fluctuationDownIssueVolume) : message.fluctuationDownIssueVolume;
        else
          object.fluctuationDownIssueVolume = options.longs === String ? $util.Long.prototype.toString.call(message.fluctuationDownIssueVolume) : options.longs === Number ? new $util.LongBits(message.fluctuationDownIssueVolume.low >>> 0, message.fluctuationDownIssueVolume.high >>> 0).toNumber() : message.fluctuationDownIssueVolume;
      if (message.fluctuationSteadinessIssueVolume != null && message.hasOwnProperty("fluctuationSteadinessIssueVolume"))
        if (typeof message.fluctuationSteadinessIssueVolume === "number")
          object.fluctuationSteadinessIssueVolume = options.longs === String ? String(message.fluctuationSteadinessIssueVolume) : message.fluctuationSteadinessIssueVolume;
        else
          object.fluctuationSteadinessIssueVolume = options.longs === String ? $util.Long.prototype.toString.call(message.fluctuationSteadinessIssueVolume) : options.longs === Number ? new $util.LongBits(message.fluctuationSteadinessIssueVolume.low >>> 0, message.fluctuationSteadinessIssueVolume.high >>> 0).toNumber() : message.fluctuationSteadinessIssueVolume;
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime"))
        object.receivedTime = $root.google.protobuf.Timestamp.toObject(message.receivedTime, options);
      return object;
    };
    MarketIndex.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    MarketIndex.Market = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[2] = "HNX"] = 2;
      values[valuesById[3] = "UPCOM"] = 3;
      values[valuesById[10] = "VNINDEX"] = 10;
      values[valuesById[11] = "VN30"] = 11;
      values[valuesById[12] = "HNX30"] = 12;
      values[valuesById[13] = "VNXALLSHARE"] = 13;
      return values;
    }();
    return MarketIndex;
  }();
  models2.GlobalMarketIndex = function() {
    function GlobalMarketIndex(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GlobalMarketIndex.prototype.marketID = "";
    GlobalMarketIndex.prototype.indexValue = 0;
    GlobalMarketIndex.prototype.changed = 0;
    GlobalMarketIndex.prototype.changedRatio = 0;
    GlobalMarketIndex.prototype.previousClose = 0;
    GlobalMarketIndex.prototype.currency = "";
    GlobalMarketIndex.prototype.floor = "";
    GlobalMarketIndex.prototype.instrumentType = "";
    GlobalMarketIndex.prototype.timezone = "";
    GlobalMarketIndex.prototype.floorTimezoneName = "";
    GlobalMarketIndex.prototype.indexName = 0;
    GlobalMarketIndex.create = function create(properties) {
      return new GlobalMarketIndex(properties);
    };
    GlobalMarketIndex.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.marketID != null && Object.hasOwnProperty.call(message, "marketID"))
        writer.uint32(10).string(message.marketID);
      if (message.indexValue != null && Object.hasOwnProperty.call(message, "indexValue"))
        writer.uint32(21).float(message.indexValue);
      if (message.changed != null && Object.hasOwnProperty.call(message, "changed"))
        writer.uint32(29).float(message.changed);
      if (message.changedRatio != null && Object.hasOwnProperty.call(message, "changedRatio"))
        writer.uint32(37).float(message.changedRatio);
      if (message.previousClose != null && Object.hasOwnProperty.call(message, "previousClose"))
        writer.uint32(45).float(message.previousClose);
      if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
        writer.uint32(50).string(message.currency);
      if (message.floor != null && Object.hasOwnProperty.call(message, "floor"))
        writer.uint32(58).string(message.floor);
      if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
        writer.uint32(66).string(message.instrumentType);
      if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
        writer.uint32(74).string(message.timezone);
      if (message.floorTimezoneName != null && Object.hasOwnProperty.call(message, "floorTimezoneName"))
        writer.uint32(82).string(message.floorTimezoneName);
      if (message.indexName != null && Object.hasOwnProperty.call(message, "indexName"))
        writer.uint32(88).int32(message.indexName);
      return writer;
    };
    GlobalMarketIndex.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GlobalMarketIndex.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.GlobalMarketIndex();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.marketID = reader.string();
            break;
          case 2:
            message.indexValue = reader.float();
            break;
          case 3:
            message.changed = reader.float();
            break;
          case 4:
            message.changedRatio = reader.float();
            break;
          case 5:
            message.previousClose = reader.float();
            break;
          case 6:
            message.currency = reader.string();
            break;
          case 7:
            message.floor = reader.string();
            break;
          case 8:
            message.instrumentType = reader.string();
            break;
          case 9:
            message.timezone = reader.string();
            break;
          case 10:
            message.floorTimezoneName = reader.string();
            break;
          case 11:
            message.indexName = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GlobalMarketIndex.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GlobalMarketIndex.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.marketID != null && message.hasOwnProperty("marketID")) {
        if (!$util.isString(message.marketID))
          return "marketID: string expected";
      }
      if (message.indexValue != null && message.hasOwnProperty("indexValue")) {
        if (typeof message.indexValue !== "number")
          return "indexValue: number expected";
      }
      if (message.changed != null && message.hasOwnProperty("changed")) {
        if (typeof message.changed !== "number")
          return "changed: number expected";
      }
      if (message.changedRatio != null && message.hasOwnProperty("changedRatio")) {
        if (typeof message.changedRatio !== "number")
          return "changedRatio: number expected";
      }
      if (message.previousClose != null && message.hasOwnProperty("previousClose")) {
        if (typeof message.previousClose !== "number")
          return "previousClose: number expected";
      }
      if (message.currency != null && message.hasOwnProperty("currency")) {
        if (!$util.isString(message.currency))
          return "currency: string expected";
      }
      if (message.floor != null && message.hasOwnProperty("floor")) {
        if (!$util.isString(message.floor))
          return "floor: string expected";
      }
      if (message.instrumentType != null && message.hasOwnProperty("instrumentType")) {
        if (!$util.isString(message.instrumentType))
          return "instrumentType: string expected";
      }
      if (message.timezone != null && message.hasOwnProperty("timezone")) {
        if (!$util.isString(message.timezone))
          return "timezone: string expected";
      }
      if (message.floorTimezoneName != null && message.hasOwnProperty("floorTimezoneName")) {
        if (!$util.isString(message.floorTimezoneName))
          return "floorTimezoneName: string expected";
      }
      if (message.indexName != null && message.hasOwnProperty("indexName"))
        switch (message.indexName) {
          default:
            return "indexName: enum value expected";
          case 0:
          case 20:
          case 21:
          case 22:
          case 23:
          case 24:
          case 25:
          case 26:
          case 27:
          case 28:
            break;
        }
      return null;
    };
    GlobalMarketIndex.fromObject = function fromObject(object) {
      if (object instanceof $root.models.GlobalMarketIndex)
        return object;
      let message = new $root.models.GlobalMarketIndex();
      if (object.marketID != null)
        message.marketID = String(object.marketID);
      if (object.indexValue != null)
        message.indexValue = Number(object.indexValue);
      if (object.changed != null)
        message.changed = Number(object.changed);
      if (object.changedRatio != null)
        message.changedRatio = Number(object.changedRatio);
      if (object.previousClose != null)
        message.previousClose = Number(object.previousClose);
      if (object.currency != null)
        message.currency = String(object.currency);
      if (object.floor != null)
        message.floor = String(object.floor);
      if (object.instrumentType != null)
        message.instrumentType = String(object.instrumentType);
      if (object.timezone != null)
        message.timezone = String(object.timezone);
      if (object.floorTimezoneName != null)
        message.floorTimezoneName = String(object.floorTimezoneName);
      switch (object.indexName) {
        case "UNKNOWN":
        case 0:
          message.indexName = 0;
          break;
        case "DOWJONES":
        case 20:
          message.indexName = 20;
          break;
        case "DOWJONESFUTURE":
        case 21:
          message.indexName = 21;
          break;
        case "NASDAQ":
        case 22:
          message.indexName = 22;
          break;
        case "NASDAQFUTURE":
        case 23:
          message.indexName = 23;
          break;
        case "SNP500":
        case 24:
          message.indexName = 24;
          break;
        case "SNP500FUTURE":
        case 25:
          message.indexName = 25;
          break;
        case "NIKKEI225":
        case 26:
          message.indexName = 26;
          break;
        case "SHANGHAI":
        case 27:
          message.indexName = 27;
          break;
        case "HANGSENG":
        case 28:
          message.indexName = 28;
          break;
      }
      return message;
    };
    GlobalMarketIndex.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.marketID = "";
        object.indexValue = 0;
        object.changed = 0;
        object.changedRatio = 0;
        object.previousClose = 0;
        object.currency = "";
        object.floor = "";
        object.instrumentType = "";
        object.timezone = "";
        object.floorTimezoneName = "";
        object.indexName = options.enums === String ? "UNKNOWN" : 0;
      }
      if (message.marketID != null && message.hasOwnProperty("marketID"))
        object.marketID = message.marketID;
      if (message.indexValue != null && message.hasOwnProperty("indexValue"))
        object.indexValue = options.json && !isFinite(message.indexValue) ? String(message.indexValue) : message.indexValue;
      if (message.changed != null && message.hasOwnProperty("changed"))
        object.changed = options.json && !isFinite(message.changed) ? String(message.changed) : message.changed;
      if (message.changedRatio != null && message.hasOwnProperty("changedRatio"))
        object.changedRatio = options.json && !isFinite(message.changedRatio) ? String(message.changedRatio) : message.changedRatio;
      if (message.previousClose != null && message.hasOwnProperty("previousClose"))
        object.previousClose = options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
      if (message.currency != null && message.hasOwnProperty("currency"))
        object.currency = message.currency;
      if (message.floor != null && message.hasOwnProperty("floor"))
        object.floor = message.floor;
      if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
        object.instrumentType = message.instrumentType;
      if (message.timezone != null && message.hasOwnProperty("timezone"))
        object.timezone = message.timezone;
      if (message.floorTimezoneName != null && message.hasOwnProperty("floorTimezoneName"))
        object.floorTimezoneName = message.floorTimezoneName;
      if (message.indexName != null && message.hasOwnProperty("indexName"))
        object.indexName = options.enums === String ? $root.models.GlobalMarketIndex.Market[message.indexName] : message.indexName;
      return object;
    };
    GlobalMarketIndex.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    GlobalMarketIndex.Market = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[20] = "DOWJONES"] = 20;
      values[valuesById[21] = "DOWJONESFUTURE"] = 21;
      values[valuesById[22] = "NASDAQ"] = 22;
      values[valuesById[23] = "NASDAQFUTURE"] = 23;
      values[valuesById[24] = "SNP500"] = 24;
      values[valuesById[25] = "SNP500FUTURE"] = 25;
      values[valuesById[26] = "NIKKEI225"] = 26;
      values[valuesById[27] = "SHANGHAI"] = 27;
      values[valuesById[28] = "HANGSENG"] = 28;
      return values;
    }();
    return GlobalMarketIndex;
  }();
  models2.MarketBreadth = function() {
    function MarketBreadth(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MarketBreadth.prototype.marketID = "";
    MarketBreadth.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarketBreadth.prototype.advance = 0;
    MarketBreadth.prototype.decline = 0;
    MarketBreadth.prototype.noChange = 0;
    MarketBreadth.prototype.ceiling = 0;
    MarketBreadth.prototype.floor = 0;
    MarketBreadth.create = function create(properties) {
      return new MarketBreadth(properties);
    };
    MarketBreadth.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.marketID != null && Object.hasOwnProperty.call(message, "marketID"))
        writer.uint32(10).string(message.marketID);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(16).int64(message.time);
      if (message.advance != null && Object.hasOwnProperty.call(message, "advance"))
        writer.uint32(29).float(message.advance);
      if (message.decline != null && Object.hasOwnProperty.call(message, "decline"))
        writer.uint32(37).float(message.decline);
      if (message.noChange != null && Object.hasOwnProperty.call(message, "noChange"))
        writer.uint32(45).float(message.noChange);
      if (message.ceiling != null && Object.hasOwnProperty.call(message, "ceiling"))
        writer.uint32(53).float(message.ceiling);
      if (message.floor != null && Object.hasOwnProperty.call(message, "floor"))
        writer.uint32(61).float(message.floor);
      return writer;
    };
    MarketBreadth.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MarketBreadth.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.MarketBreadth();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.marketID = reader.string();
            break;
          case 2:
            message.time = reader.int64();
            break;
          case 3:
            message.advance = reader.float();
            break;
          case 4:
            message.decline = reader.float();
            break;
          case 5:
            message.noChange = reader.float();
            break;
          case 6:
            message.ceiling = reader.float();
            break;
          case 7:
            message.floor = reader.float();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MarketBreadth.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MarketBreadth.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.marketID != null && message.hasOwnProperty("marketID")) {
        if (!$util.isString(message.marketID))
          return "marketID: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.advance != null && message.hasOwnProperty("advance")) {
        if (typeof message.advance !== "number")
          return "advance: number expected";
      }
      if (message.decline != null && message.hasOwnProperty("decline")) {
        if (typeof message.decline !== "number")
          return "decline: number expected";
      }
      if (message.noChange != null && message.hasOwnProperty("noChange")) {
        if (typeof message.noChange !== "number")
          return "noChange: number expected";
      }
      if (message.ceiling != null && message.hasOwnProperty("ceiling")) {
        if (typeof message.ceiling !== "number")
          return "ceiling: number expected";
      }
      if (message.floor != null && message.hasOwnProperty("floor")) {
        if (typeof message.floor !== "number")
          return "floor: number expected";
      }
      return null;
    };
    MarketBreadth.fromObject = function fromObject(object) {
      if (object instanceof $root.models.MarketBreadth)
        return object;
      let message = new $root.models.MarketBreadth();
      if (object.marketID != null)
        message.marketID = String(object.marketID);
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.advance != null)
        message.advance = Number(object.advance);
      if (object.decline != null)
        message.decline = Number(object.decline);
      if (object.noChange != null)
        message.noChange = Number(object.noChange);
      if (object.ceiling != null)
        message.ceiling = Number(object.ceiling);
      if (object.floor != null)
        message.floor = Number(object.floor);
      return message;
    };
    MarketBreadth.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.marketID = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.advance = 0;
        object.decline = 0;
        object.noChange = 0;
        object.ceiling = 0;
        object.floor = 0;
      }
      if (message.marketID != null && message.hasOwnProperty("marketID"))
        object.marketID = message.marketID;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.advance != null && message.hasOwnProperty("advance"))
        object.advance = options.json && !isFinite(message.advance) ? String(message.advance) : message.advance;
      if (message.decline != null && message.hasOwnProperty("decline"))
        object.decline = options.json && !isFinite(message.decline) ? String(message.decline) : message.decline;
      if (message.noChange != null && message.hasOwnProperty("noChange"))
        object.noChange = options.json && !isFinite(message.noChange) ? String(message.noChange) : message.noChange;
      if (message.ceiling != null && message.hasOwnProperty("ceiling"))
        object.ceiling = options.json && !isFinite(message.ceiling) ? String(message.ceiling) : message.ceiling;
      if (message.floor != null && message.hasOwnProperty("floor"))
        object.floor = options.json && !isFinite(message.floor) ? String(message.floor) : message.floor;
      return object;
    };
    MarketBreadth.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MarketBreadth;
  }();
  models2.BidAsk = function() {
    function BidAsk(properties) {
      this.bid = [];
      this.ask = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BidAsk.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BidAsk.prototype.symbol = "";
    BidAsk.prototype.bid = $util.emptyArray;
    BidAsk.prototype.ask = $util.emptyArray;
    BidAsk.prototype.accumulatedVol = 0;
    BidAsk.prototype.matchPrice = 0;
    BidAsk.prototype.matchQtty = 0;
    BidAsk.prototype.matchValue = 0;
    BidAsk.prototype.totalOfferQtty = 0;
    BidAsk.prototype.totalBidQtty = 0;
    BidAsk.prototype.basket = "";
    BidAsk.prototype.basketContribution = 0;
    BidAsk.prototype.basketWeight = 0;
    BidAsk.create = function create(properties) {
      return new BidAsk(properties);
    };
    BidAsk.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(8).int64(message.time);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.bid != null && message.bid.length)
        for (let i = 0; i < message.bid.length; ++i)
          $root.models.OrderMini.encode(message.bid[i], writer.uint32(26).fork()).ldelim();
      if (message.ask != null && message.ask.length)
        for (let i = 0; i < message.ask.length; ++i)
          $root.models.OrderMini.encode(message.ask[i], writer.uint32(34).fork()).ldelim();
      if (message.accumulatedVol != null && Object.hasOwnProperty.call(message, "accumulatedVol"))
        writer.uint32(45).float(message.accumulatedVol);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(53).float(message.matchPrice);
      if (message.matchQtty != null && Object.hasOwnProperty.call(message, "matchQtty"))
        writer.uint32(61).float(message.matchQtty);
      if (message.matchValue != null && Object.hasOwnProperty.call(message, "matchValue"))
        writer.uint32(69).float(message.matchValue);
      if (message.totalOfferQtty != null && Object.hasOwnProperty.call(message, "totalOfferQtty"))
        writer.uint32(77).float(message.totalOfferQtty);
      if (message.totalBidQtty != null && Object.hasOwnProperty.call(message, "totalBidQtty"))
        writer.uint32(85).float(message.totalBidQtty);
      if (message.basket != null && Object.hasOwnProperty.call(message, "basket"))
        writer.uint32(90).string(message.basket);
      if (message.basketContribution != null && Object.hasOwnProperty.call(message, "basketContribution"))
        writer.uint32(101).float(message.basketContribution);
      if (message.basketWeight != null && Object.hasOwnProperty.call(message, "basketWeight"))
        writer.uint32(109).float(message.basketWeight);
      return writer;
    };
    BidAsk.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BidAsk.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.BidAsk();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = reader.int64();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            if (!(message.bid && message.bid.length))
              message.bid = [];
            message.bid.push($root.models.OrderMini.decode(reader, reader.uint32()));
            break;
          case 4:
            if (!(message.ask && message.ask.length))
              message.ask = [];
            message.ask.push($root.models.OrderMini.decode(reader, reader.uint32()));
            break;
          case 5:
            message.accumulatedVol = reader.float();
            break;
          case 6:
            message.matchPrice = reader.float();
            break;
          case 7:
            message.matchQtty = reader.float();
            break;
          case 8:
            message.matchValue = reader.float();
            break;
          case 9:
            message.totalOfferQtty = reader.float();
            break;
          case 10:
            message.totalBidQtty = reader.float();
            break;
          case 11:
            message.basket = reader.string();
            break;
          case 12:
            message.basketContribution = reader.float();
            break;
          case 13:
            message.basketWeight = reader.float();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BidAsk.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BidAsk.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.bid != null && message.hasOwnProperty("bid")) {
        if (!Array.isArray(message.bid))
          return "bid: array expected";
        for (let i = 0; i < message.bid.length; ++i) {
          let error = $root.models.OrderMini.verify(message.bid[i]);
          if (error)
            return "bid." + error;
        }
      }
      if (message.ask != null && message.hasOwnProperty("ask")) {
        if (!Array.isArray(message.ask))
          return "ask: array expected";
        for (let i = 0; i < message.ask.length; ++i) {
          let error = $root.models.OrderMini.verify(message.ask[i]);
          if (error)
            return "ask." + error;
        }
      }
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol")) {
        if (typeof message.accumulatedVol !== "number")
          return "accumulatedVol: number expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty")) {
        if (typeof message.matchQtty !== "number")
          return "matchQtty: number expected";
      }
      if (message.matchValue != null && message.hasOwnProperty("matchValue")) {
        if (typeof message.matchValue !== "number")
          return "matchValue: number expected";
      }
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty")) {
        if (typeof message.totalOfferQtty !== "number")
          return "totalOfferQtty: number expected";
      }
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty")) {
        if (typeof message.totalBidQtty !== "number")
          return "totalBidQtty: number expected";
      }
      if (message.basket != null && message.hasOwnProperty("basket")) {
        if (!$util.isString(message.basket))
          return "basket: string expected";
      }
      if (message.basketContribution != null && message.hasOwnProperty("basketContribution")) {
        if (typeof message.basketContribution !== "number")
          return "basketContribution: number expected";
      }
      if (message.basketWeight != null && message.hasOwnProperty("basketWeight")) {
        if (typeof message.basketWeight !== "number")
          return "basketWeight: number expected";
      }
      return null;
    };
    BidAsk.fromObject = function fromObject(object) {
      if (object instanceof $root.models.BidAsk)
        return object;
      let message = new $root.models.BidAsk();
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.bid) {
        if (!Array.isArray(object.bid))
          throw TypeError(".models.BidAsk.bid: array expected");
        message.bid = [];
        for (let i = 0; i < object.bid.length; ++i) {
          if (typeof object.bid[i] !== "object")
            throw TypeError(".models.BidAsk.bid: object expected");
          message.bid[i] = $root.models.OrderMini.fromObject(object.bid[i]);
        }
      }
      if (object.ask) {
        if (!Array.isArray(object.ask))
          throw TypeError(".models.BidAsk.ask: array expected");
        message.ask = [];
        for (let i = 0; i < object.ask.length; ++i) {
          if (typeof object.ask[i] !== "object")
            throw TypeError(".models.BidAsk.ask: object expected");
          message.ask[i] = $root.models.OrderMini.fromObject(object.ask[i]);
        }
      }
      if (object.accumulatedVol != null)
        message.accumulatedVol = Number(object.accumulatedVol);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.matchQtty != null)
        message.matchQtty = Number(object.matchQtty);
      if (object.matchValue != null)
        message.matchValue = Number(object.matchValue);
      if (object.totalOfferQtty != null)
        message.totalOfferQtty = Number(object.totalOfferQtty);
      if (object.totalBidQtty != null)
        message.totalBidQtty = Number(object.totalBidQtty);
      if (object.basket != null)
        message.basket = String(object.basket);
      if (object.basketContribution != null)
        message.basketContribution = Number(object.basketContribution);
      if (object.basketWeight != null)
        message.basketWeight = Number(object.basketWeight);
      return message;
    };
    BidAsk.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.bid = [];
        object.ask = [];
      }
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.symbol = "";
        object.accumulatedVol = 0;
        object.matchPrice = 0;
        object.matchQtty = 0;
        object.matchValue = 0;
        object.totalOfferQtty = 0;
        object.totalBidQtty = 0;
        object.basket = "";
        object.basketContribution = 0;
        object.basketWeight = 0;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.bid && message.bid.length) {
        object.bid = [];
        for (let j = 0; j < message.bid.length; ++j)
          object.bid[j] = $root.models.OrderMini.toObject(message.bid[j], options);
      }
      if (message.ask && message.ask.length) {
        object.ask = [];
        for (let j = 0; j < message.ask.length; ++j)
          object.ask[j] = $root.models.OrderMini.toObject(message.ask[j], options);
      }
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol"))
        object.accumulatedVol = options.json && !isFinite(message.accumulatedVol) ? String(message.accumulatedVol) : message.accumulatedVol;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty"))
        object.matchQtty = options.json && !isFinite(message.matchQtty) ? String(message.matchQtty) : message.matchQtty;
      if (message.matchValue != null && message.hasOwnProperty("matchValue"))
        object.matchValue = options.json && !isFinite(message.matchValue) ? String(message.matchValue) : message.matchValue;
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty"))
        object.totalOfferQtty = options.json && !isFinite(message.totalOfferQtty) ? String(message.totalOfferQtty) : message.totalOfferQtty;
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty"))
        object.totalBidQtty = options.json && !isFinite(message.totalBidQtty) ? String(message.totalBidQtty) : message.totalBidQtty;
      if (message.basket != null && message.hasOwnProperty("basket"))
        object.basket = message.basket;
      if (message.basketContribution != null && message.hasOwnProperty("basketContribution"))
        object.basketContribution = options.json && !isFinite(message.basketContribution) ? String(message.basketContribution) : message.basketContribution;
      if (message.basketWeight != null && message.hasOwnProperty("basketWeight"))
        object.basketWeight = options.json && !isFinite(message.basketWeight) ? String(message.basketWeight) : message.basketWeight;
      return object;
    };
    BidAsk.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BidAsk;
  }();
  models2.StockPrice = function() {
    function StockPrice(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockPrice.prototype.floorCode = "";
    StockPrice.prototype.tradingDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    StockPrice.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    StockPrice.prototype.symbol = "";
    StockPrice.prototype.CompanyName = "";
    StockPrice.prototype.stockType = "";
    StockPrice.prototype.totalRoom = 0;
    StockPrice.prototype.currentRoom = 0;
    StockPrice.prototype.basicPrice = 0;
    StockPrice.prototype.openPrice = 0;
    StockPrice.prototype.closePrice = 0;
    StockPrice.prototype.currentPrice = 0;
    StockPrice.prototype.currentQtty = 0;
    StockPrice.prototype.highestPrice = 0;
    StockPrice.prototype.lowestPrice = 0;
    StockPrice.prototype.ceilingPrice = 0;
    StockPrice.prototype.floorPrice = 0;
    StockPrice.prototype.averagePrice = 0;
    StockPrice.prototype.accumulatedVal = 0;
    StockPrice.prototype.buyForeignQtty = 0;
    StockPrice.prototype.sellForeignQtty = 0;
    StockPrice.prototype.projectOpen = 0;
    StockPrice.prototype.sequence = 0;
    StockPrice.prototype.tradingSessionId = 0;
    StockPrice.create = function create(properties) {
      return new StockPrice(properties);
    };
    StockPrice.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(10).string(message.floorCode);
      if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
        writer.uint32(16).int64(message.tradingDate);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(24).int64(message.time);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.CompanyName != null && Object.hasOwnProperty.call(message, "CompanyName"))
        writer.uint32(42).string(message.CompanyName);
      if (message.stockType != null && Object.hasOwnProperty.call(message, "stockType"))
        writer.uint32(50).string(message.stockType);
      if (message.totalRoom != null && Object.hasOwnProperty.call(message, "totalRoom"))
        writer.uint32(61).float(message.totalRoom);
      if (message.currentRoom != null && Object.hasOwnProperty.call(message, "currentRoom"))
        writer.uint32(69).float(message.currentRoom);
      if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
        writer.uint32(77).float(message.basicPrice);
      if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
        writer.uint32(85).float(message.openPrice);
      if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
        writer.uint32(93).float(message.closePrice);
      if (message.currentPrice != null && Object.hasOwnProperty.call(message, "currentPrice"))
        writer.uint32(101).float(message.currentPrice);
      if (message.currentQtty != null && Object.hasOwnProperty.call(message, "currentQtty"))
        writer.uint32(109).float(message.currentQtty);
      if (message.highestPrice != null && Object.hasOwnProperty.call(message, "highestPrice"))
        writer.uint32(117).float(message.highestPrice);
      if (message.lowestPrice != null && Object.hasOwnProperty.call(message, "lowestPrice"))
        writer.uint32(125).float(message.lowestPrice);
      if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
        writer.uint32(133).float(message.ceilingPrice);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(141).float(message.floorPrice);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(149).float(message.averagePrice);
      if (message.accumulatedVal != null && Object.hasOwnProperty.call(message, "accumulatedVal"))
        writer.uint32(157).float(message.accumulatedVal);
      if (message.buyForeignQtty != null && Object.hasOwnProperty.call(message, "buyForeignQtty"))
        writer.uint32(165).float(message.buyForeignQtty);
      if (message.sellForeignQtty != null && Object.hasOwnProperty.call(message, "sellForeignQtty"))
        writer.uint32(173).float(message.sellForeignQtty);
      if (message.projectOpen != null && Object.hasOwnProperty.call(message, "projectOpen"))
        writer.uint32(181).float(message.projectOpen);
      if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
        writer.uint32(189).float(message.sequence);
      if (message.tradingSessionId != null && Object.hasOwnProperty.call(message, "tradingSessionId"))
        writer.uint32(192).int32(message.tradingSessionId);
      return writer;
    };
    StockPrice.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockPrice.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.StockPrice();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.floorCode = reader.string();
            break;
          case 2:
            message.tradingDate = reader.int64();
            break;
          case 3:
            message.time = reader.int64();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.CompanyName = reader.string();
            break;
          case 6:
            message.stockType = reader.string();
            break;
          case 7:
            message.totalRoom = reader.float();
            break;
          case 8:
            message.currentRoom = reader.float();
            break;
          case 9:
            message.basicPrice = reader.float();
            break;
          case 10:
            message.openPrice = reader.float();
            break;
          case 11:
            message.closePrice = reader.float();
            break;
          case 12:
            message.currentPrice = reader.float();
            break;
          case 13:
            message.currentQtty = reader.float();
            break;
          case 14:
            message.highestPrice = reader.float();
            break;
          case 15:
            message.lowestPrice = reader.float();
            break;
          case 16:
            message.ceilingPrice = reader.float();
            break;
          case 17:
            message.floorPrice = reader.float();
            break;
          case 18:
            message.averagePrice = reader.float();
            break;
          case 19:
            message.accumulatedVal = reader.float();
            break;
          case 20:
            message.buyForeignQtty = reader.float();
            break;
          case 21:
            message.sellForeignQtty = reader.float();
            break;
          case 22:
            message.projectOpen = reader.float();
            break;
          case 23:
            message.sequence = reader.float();
            break;
          case 24:
            message.tradingSessionId = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockPrice.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockPrice.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.floorCode != null && message.hasOwnProperty("floorCode")) {
        if (!$util.isString(message.floorCode))
          return "floorCode: string expected";
      }
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
        if (!$util.isInteger(message.tradingDate) && !(message.tradingDate && $util.isInteger(message.tradingDate.low) && $util.isInteger(message.tradingDate.high)))
          return "tradingDate: integer|Long expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.CompanyName != null && message.hasOwnProperty("CompanyName")) {
        if (!$util.isString(message.CompanyName))
          return "CompanyName: string expected";
      }
      if (message.stockType != null && message.hasOwnProperty("stockType")) {
        if (!$util.isString(message.stockType))
          return "stockType: string expected";
      }
      if (message.totalRoom != null && message.hasOwnProperty("totalRoom")) {
        if (typeof message.totalRoom !== "number")
          return "totalRoom: number expected";
      }
      if (message.currentRoom != null && message.hasOwnProperty("currentRoom")) {
        if (typeof message.currentRoom !== "number")
          return "currentRoom: number expected";
      }
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
        if (typeof message.basicPrice !== "number")
          return "basicPrice: number expected";
      }
      if (message.openPrice != null && message.hasOwnProperty("openPrice")) {
        if (typeof message.openPrice !== "number")
          return "openPrice: number expected";
      }
      if (message.closePrice != null && message.hasOwnProperty("closePrice")) {
        if (typeof message.closePrice !== "number")
          return "closePrice: number expected";
      }
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice")) {
        if (typeof message.currentPrice !== "number")
          return "currentPrice: number expected";
      }
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty")) {
        if (typeof message.currentQtty !== "number")
          return "currentQtty: number expected";
      }
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice")) {
        if (typeof message.highestPrice !== "number")
          return "highestPrice: number expected";
      }
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice")) {
        if (typeof message.lowestPrice !== "number")
          return "lowestPrice: number expected";
      }
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
        if (typeof message.ceilingPrice !== "number")
          return "ceilingPrice: number expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (typeof message.floorPrice !== "number")
          return "floorPrice: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal")) {
        if (typeof message.accumulatedVal !== "number")
          return "accumulatedVal: number expected";
      }
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty")) {
        if (typeof message.buyForeignQtty !== "number")
          return "buyForeignQtty: number expected";
      }
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty")) {
        if (typeof message.sellForeignQtty !== "number")
          return "sellForeignQtty: number expected";
      }
      if (message.projectOpen != null && message.hasOwnProperty("projectOpen")) {
        if (typeof message.projectOpen !== "number")
          return "projectOpen: number expected";
      }
      if (message.sequence != null && message.hasOwnProperty("sequence")) {
        if (typeof message.sequence !== "number")
          return "sequence: number expected";
      }
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        switch (message.tradingSessionId) {
          default:
            return "tradingSessionId: enum value expected";
          case 0:
          case 13:
          case 12:
          case 10:
          case 3:
          case 1:
          case 2:
          case 9:
          case 35:
          case 5:
          case 7:
          case 8:
          case 6:
          case 11:
            break;
        }
      return null;
    };
    StockPrice.fromObject = function fromObject(object) {
      if (object instanceof $root.models.StockPrice)
        return object;
      let message = new $root.models.StockPrice();
      if (object.floorCode != null)
        message.floorCode = String(object.floorCode);
      if (object.tradingDate != null) {
        if ($util.Long)
          (message.tradingDate = $util.Long.fromValue(object.tradingDate)).unsigned = false;
        else if (typeof object.tradingDate === "string")
          message.tradingDate = parseInt(object.tradingDate, 10);
        else if (typeof object.tradingDate === "number")
          message.tradingDate = object.tradingDate;
        else if (typeof object.tradingDate === "object")
          message.tradingDate = new $util.LongBits(object.tradingDate.low >>> 0, object.tradingDate.high >>> 0).toNumber();
      }
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.CompanyName != null)
        message.CompanyName = String(object.CompanyName);
      if (object.stockType != null)
        message.stockType = String(object.stockType);
      if (object.totalRoom != null)
        message.totalRoom = Number(object.totalRoom);
      if (object.currentRoom != null)
        message.currentRoom = Number(object.currentRoom);
      if (object.basicPrice != null)
        message.basicPrice = Number(object.basicPrice);
      if (object.openPrice != null)
        message.openPrice = Number(object.openPrice);
      if (object.closePrice != null)
        message.closePrice = Number(object.closePrice);
      if (object.currentPrice != null)
        message.currentPrice = Number(object.currentPrice);
      if (object.currentQtty != null)
        message.currentQtty = Number(object.currentQtty);
      if (object.highestPrice != null)
        message.highestPrice = Number(object.highestPrice);
      if (object.lowestPrice != null)
        message.lowestPrice = Number(object.lowestPrice);
      if (object.ceilingPrice != null)
        message.ceilingPrice = Number(object.ceilingPrice);
      if (object.floorPrice != null)
        message.floorPrice = Number(object.floorPrice);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.accumulatedVal != null)
        message.accumulatedVal = Number(object.accumulatedVal);
      if (object.buyForeignQtty != null)
        message.buyForeignQtty = Number(object.buyForeignQtty);
      if (object.sellForeignQtty != null)
        message.sellForeignQtty = Number(object.sellForeignQtty);
      if (object.projectOpen != null)
        message.projectOpen = Number(object.projectOpen);
      if (object.sequence != null)
        message.sequence = Number(object.sequence);
      switch (object.tradingSessionId) {
        case "OPEN":
        case 0:
          message.tradingSessionId = 0;
          break;
        case "CLOSED":
        case 13:
          message.tradingSessionId = 13;
          break;
        case "DONE":
        case 12:
          message.tradingSessionId = 12;
          break;
        case "NOON_BREAK":
        case 10:
          message.tradingSessionId = 10;
          break;
        case "START_MIDSESSION_BREAK":
        case 3:
          message.tradingSessionId = 3;
          break;
        case "DONE_MIDSESSION_BREAK":
        case 1:
          message.tradingSessionId = 1;
          break;
        case "ATO":
        case 2:
          message.tradingSessionId = 2;
          break;
        case "ATC":
        case 9:
          message.tradingSessionId = 9;
          break;
        case "PUT_THROUGH":
        case 35:
          message.tradingSessionId = 35;
          break;
        case "CONTINUOUS":
        case 5:
          message.tradingSessionId = 5;
          break;
        case "STOP_ALL_TRADE":
        case 7:
          message.tradingSessionId = 7;
          break;
        case "RESUME_ALL_TRADE":
        case 8:
          message.tradingSessionId = 8;
          break;
        case "RESUME_TRADE_SYMBOL":
        case 6:
          message.tradingSessionId = 6;
          break;
        case "END_ALL":
        case 11:
          message.tradingSessionId = 11;
          break;
      }
      return message;
    };
    StockPrice.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.floorCode = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradingDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tradingDate = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.symbol = "";
        object.CompanyName = "";
        object.stockType = "";
        object.totalRoom = 0;
        object.currentRoom = 0;
        object.basicPrice = 0;
        object.openPrice = 0;
        object.closePrice = 0;
        object.currentPrice = 0;
        object.currentQtty = 0;
        object.highestPrice = 0;
        object.lowestPrice = 0;
        object.ceilingPrice = 0;
        object.floorPrice = 0;
        object.averagePrice = 0;
        object.accumulatedVal = 0;
        object.buyForeignQtty = 0;
        object.sellForeignQtty = 0;
        object.projectOpen = 0;
        object.sequence = 0;
        object.tradingSessionId = options.enums === String ? "OPEN" : 0;
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = message.floorCode;
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
        if (typeof message.tradingDate === "number")
          object.tradingDate = options.longs === String ? String(message.tradingDate) : message.tradingDate;
        else
          object.tradingDate = options.longs === String ? $util.Long.prototype.toString.call(message.tradingDate) : options.longs === Number ? new $util.LongBits(message.tradingDate.low >>> 0, message.tradingDate.high >>> 0).toNumber() : message.tradingDate;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.CompanyName != null && message.hasOwnProperty("CompanyName"))
        object.CompanyName = message.CompanyName;
      if (message.stockType != null && message.hasOwnProperty("stockType"))
        object.stockType = message.stockType;
      if (message.totalRoom != null && message.hasOwnProperty("totalRoom"))
        object.totalRoom = options.json && !isFinite(message.totalRoom) ? String(message.totalRoom) : message.totalRoom;
      if (message.currentRoom != null && message.hasOwnProperty("currentRoom"))
        object.currentRoom = options.json && !isFinite(message.currentRoom) ? String(message.currentRoom) : message.currentRoom;
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
        object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
      if (message.openPrice != null && message.hasOwnProperty("openPrice"))
        object.openPrice = options.json && !isFinite(message.openPrice) ? String(message.openPrice) : message.openPrice;
      if (message.closePrice != null && message.hasOwnProperty("closePrice"))
        object.closePrice = options.json && !isFinite(message.closePrice) ? String(message.closePrice) : message.closePrice;
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
        object.currentPrice = options.json && !isFinite(message.currentPrice) ? String(message.currentPrice) : message.currentPrice;
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty"))
        object.currentQtty = options.json && !isFinite(message.currentQtty) ? String(message.currentQtty) : message.currentQtty;
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
        object.highestPrice = options.json && !isFinite(message.highestPrice) ? String(message.highestPrice) : message.highestPrice;
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
        object.lowestPrice = options.json && !isFinite(message.lowestPrice) ? String(message.lowestPrice) : message.lowestPrice;
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
        object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal"))
        object.accumulatedVal = options.json && !isFinite(message.accumulatedVal) ? String(message.accumulatedVal) : message.accumulatedVal;
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty"))
        object.buyForeignQtty = options.json && !isFinite(message.buyForeignQtty) ? String(message.buyForeignQtty) : message.buyForeignQtty;
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty"))
        object.sellForeignQtty = options.json && !isFinite(message.sellForeignQtty) ? String(message.sellForeignQtty) : message.sellForeignQtty;
      if (message.projectOpen != null && message.hasOwnProperty("projectOpen"))
        object.projectOpen = options.json && !isFinite(message.projectOpen) ? String(message.projectOpen) : message.projectOpen;
      if (message.sequence != null && message.hasOwnProperty("sequence"))
        object.sequence = options.json && !isFinite(message.sequence) ? String(message.sequence) : message.sequence;
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        object.tradingSessionId = options.enums === String ? $root.models.TradingSessionId[message.tradingSessionId] : message.tradingSessionId;
      return object;
    };
    StockPrice.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockPrice;
  }();
  models2.DerPrice = function() {
    function DerPrice(properties) {
      this.bid = [];
      this.ask = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerPrice.prototype.accumulatedVal = 0;
    DerPrice.prototype.accumulatedVol = 0;
    DerPrice.prototype.basicPrice = 0;
    DerPrice.prototype.ceilingPrice = 0;
    DerPrice.prototype.floorPrice = 0;
    DerPrice.prototype.bid = $util.emptyArray;
    DerPrice.prototype.ask = $util.emptyArray;
    DerPrice.prototype.buyForeignQtty = 0;
    DerPrice.prototype.sellForeignQtty = 0;
    DerPrice.prototype.symbol = "";
    DerPrice.prototype.currentPrice = 0;
    DerPrice.prototype.currentQtty = 0;
    DerPrice.prototype.highestPrice = 0;
    DerPrice.prototype.lastTradingDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerPrice.prototype.lowestPrice = 0;
    DerPrice.prototype.matchPrice = 0;
    DerPrice.prototype.matchQtty = 0;
    DerPrice.prototype.openInterest = 0;
    DerPrice.prototype.openPrice = 0;
    DerPrice.prototype.tradingSessionId = 0;
    DerPrice.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerPrice.prototype.closePrice = 0;
    DerPrice.prototype.symbolType = "";
    DerPrice.prototype.totalBidQtty = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerPrice.prototype.totalOfferQtty = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerPrice.prototype.securityType = 0;
    DerPrice.prototype.avgPrice = 0;
    DerPrice.prototype.changed = 0;
    DerPrice.prototype.changedRatio = 0;
    DerPrice.prototype.floorCode = 0;
    DerPrice.prototype.bidQtty = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerPrice.prototype.offerQtty = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerPrice.create = function create(properties) {
      return new DerPrice(properties);
    };
    DerPrice.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accumulatedVal != null && Object.hasOwnProperty.call(message, "accumulatedVal"))
        writer.uint32(9).double(message.accumulatedVal);
      if (message.accumulatedVol != null && Object.hasOwnProperty.call(message, "accumulatedVol"))
        writer.uint32(21).float(message.accumulatedVol);
      if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
        writer.uint32(29).float(message.basicPrice);
      if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
        writer.uint32(37).float(message.ceilingPrice);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(45).float(message.floorPrice);
      if (message.bid != null && message.bid.length)
        for (let i = 0; i < message.bid.length; ++i)
          $root.models.OrderMini.encode(message.bid[i], writer.uint32(50).fork()).ldelim();
      if (message.ask != null && message.ask.length)
        for (let i = 0; i < message.ask.length; ++i)
          $root.models.OrderMini.encode(message.ask[i], writer.uint32(58).fork()).ldelim();
      if (message.buyForeignQtty != null && Object.hasOwnProperty.call(message, "buyForeignQtty"))
        writer.uint32(69).float(message.buyForeignQtty);
      if (message.sellForeignQtty != null && Object.hasOwnProperty.call(message, "sellForeignQtty"))
        writer.uint32(77).float(message.sellForeignQtty);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(82).string(message.symbol);
      if (message.currentPrice != null && Object.hasOwnProperty.call(message, "currentPrice"))
        writer.uint32(93).float(message.currentPrice);
      if (message.currentQtty != null && Object.hasOwnProperty.call(message, "currentQtty"))
        writer.uint32(101).float(message.currentQtty);
      if (message.highestPrice != null && Object.hasOwnProperty.call(message, "highestPrice"))
        writer.uint32(109).float(message.highestPrice);
      if (message.lastTradingDate != null && Object.hasOwnProperty.call(message, "lastTradingDate"))
        writer.uint32(112).int64(message.lastTradingDate);
      if (message.lowestPrice != null && Object.hasOwnProperty.call(message, "lowestPrice"))
        writer.uint32(125).float(message.lowestPrice);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(133).float(message.matchPrice);
      if (message.matchQtty != null && Object.hasOwnProperty.call(message, "matchQtty"))
        writer.uint32(141).float(message.matchQtty);
      if (message.openInterest != null && Object.hasOwnProperty.call(message, "openInterest"))
        writer.uint32(149).float(message.openInterest);
      if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
        writer.uint32(157).float(message.openPrice);
      if (message.tradingSessionId != null && Object.hasOwnProperty.call(message, "tradingSessionId"))
        writer.uint32(160).int32(message.tradingSessionId);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(168).int64(message.time);
      if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
        writer.uint32(181).float(message.closePrice);
      if (message.symbolType != null && Object.hasOwnProperty.call(message, "symbolType"))
        writer.uint32(186).string(message.symbolType);
      if (message.totalBidQtty != null && Object.hasOwnProperty.call(message, "totalBidQtty"))
        writer.uint32(192).int64(message.totalBidQtty);
      if (message.totalOfferQtty != null && Object.hasOwnProperty.call(message, "totalOfferQtty"))
        writer.uint32(200).int64(message.totalOfferQtty);
      if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
        writer.uint32(208).int32(message.securityType);
      if (message.avgPrice != null && Object.hasOwnProperty.call(message, "avgPrice"))
        writer.uint32(217).double(message.avgPrice);
      if (message.changed != null && Object.hasOwnProperty.call(message, "changed"))
        writer.uint32(225).double(message.changed);
      if (message.changedRatio != null && Object.hasOwnProperty.call(message, "changedRatio"))
        writer.uint32(233).double(message.changedRatio);
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(240).int32(message.floorCode);
      if (message.bidQtty != null && Object.hasOwnProperty.call(message, "bidQtty"))
        writer.uint32(248).int64(message.bidQtty);
      if (message.offerQtty != null && Object.hasOwnProperty.call(message, "offerQtty"))
        writer.uint32(256).int64(message.offerQtty);
      return writer;
    };
    DerPrice.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerPrice.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.DerPrice();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accumulatedVal = reader.double();
            break;
          case 2:
            message.accumulatedVol = reader.float();
            break;
          case 3:
            message.basicPrice = reader.float();
            break;
          case 4:
            message.ceilingPrice = reader.float();
            break;
          case 5:
            message.floorPrice = reader.float();
            break;
          case 6:
            if (!(message.bid && message.bid.length))
              message.bid = [];
            message.bid.push($root.models.OrderMini.decode(reader, reader.uint32()));
            break;
          case 7:
            if (!(message.ask && message.ask.length))
              message.ask = [];
            message.ask.push($root.models.OrderMini.decode(reader, reader.uint32()));
            break;
          case 8:
            message.buyForeignQtty = reader.float();
            break;
          case 9:
            message.sellForeignQtty = reader.float();
            break;
          case 10:
            message.symbol = reader.string();
            break;
          case 11:
            message.currentPrice = reader.float();
            break;
          case 12:
            message.currentQtty = reader.float();
            break;
          case 13:
            message.highestPrice = reader.float();
            break;
          case 14:
            message.lastTradingDate = reader.int64();
            break;
          case 15:
            message.lowestPrice = reader.float();
            break;
          case 16:
            message.matchPrice = reader.float();
            break;
          case 17:
            message.matchQtty = reader.float();
            break;
          case 18:
            message.openInterest = reader.float();
            break;
          case 19:
            message.openPrice = reader.float();
            break;
          case 20:
            message.tradingSessionId = reader.int32();
            break;
          case 21:
            message.time = reader.int64();
            break;
          case 22:
            message.closePrice = reader.float();
            break;
          case 23:
            message.symbolType = reader.string();
            break;
          case 24:
            message.totalBidQtty = reader.int64();
            break;
          case 25:
            message.totalOfferQtty = reader.int64();
            break;
          case 26:
            message.securityType = reader.int32();
            break;
          case 27:
            message.avgPrice = reader.double();
            break;
          case 28:
            message.changed = reader.double();
            break;
          case 29:
            message.changedRatio = reader.double();
            break;
          case 30:
            message.floorCode = reader.int32();
            break;
          case 31:
            message.bidQtty = reader.int64();
            break;
          case 32:
            message.offerQtty = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerPrice.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerPrice.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal")) {
        if (typeof message.accumulatedVal !== "number")
          return "accumulatedVal: number expected";
      }
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol")) {
        if (typeof message.accumulatedVol !== "number")
          return "accumulatedVol: number expected";
      }
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
        if (typeof message.basicPrice !== "number")
          return "basicPrice: number expected";
      }
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
        if (typeof message.ceilingPrice !== "number")
          return "ceilingPrice: number expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (typeof message.floorPrice !== "number")
          return "floorPrice: number expected";
      }
      if (message.bid != null && message.hasOwnProperty("bid")) {
        if (!Array.isArray(message.bid))
          return "bid: array expected";
        for (let i = 0; i < message.bid.length; ++i) {
          let error = $root.models.OrderMini.verify(message.bid[i]);
          if (error)
            return "bid." + error;
        }
      }
      if (message.ask != null && message.hasOwnProperty("ask")) {
        if (!Array.isArray(message.ask))
          return "ask: array expected";
        for (let i = 0; i < message.ask.length; ++i) {
          let error = $root.models.OrderMini.verify(message.ask[i]);
          if (error)
            return "ask." + error;
        }
      }
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty")) {
        if (typeof message.buyForeignQtty !== "number")
          return "buyForeignQtty: number expected";
      }
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty")) {
        if (typeof message.sellForeignQtty !== "number")
          return "sellForeignQtty: number expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice")) {
        if (typeof message.currentPrice !== "number")
          return "currentPrice: number expected";
      }
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty")) {
        if (typeof message.currentQtty !== "number")
          return "currentQtty: number expected";
      }
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice")) {
        if (typeof message.highestPrice !== "number")
          return "highestPrice: number expected";
      }
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate")) {
        if (!$util.isInteger(message.lastTradingDate) && !(message.lastTradingDate && $util.isInteger(message.lastTradingDate.low) && $util.isInteger(message.lastTradingDate.high)))
          return "lastTradingDate: integer|Long expected";
      }
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice")) {
        if (typeof message.lowestPrice !== "number")
          return "lowestPrice: number expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty")) {
        if (typeof message.matchQtty !== "number")
          return "matchQtty: number expected";
      }
      if (message.openInterest != null && message.hasOwnProperty("openInterest")) {
        if (typeof message.openInterest !== "number")
          return "openInterest: number expected";
      }
      if (message.openPrice != null && message.hasOwnProperty("openPrice")) {
        if (typeof message.openPrice !== "number")
          return "openPrice: number expected";
      }
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        switch (message.tradingSessionId) {
          default:
            return "tradingSessionId: enum value expected";
          case 0:
          case 21:
          case 100:
          case 17:
          case 18:
          case 2:
            break;
        }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.closePrice != null && message.hasOwnProperty("closePrice")) {
        if (typeof message.closePrice !== "number")
          return "closePrice: number expected";
      }
      if (message.symbolType != null && message.hasOwnProperty("symbolType")) {
        if (!$util.isString(message.symbolType))
          return "symbolType: string expected";
      }
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty")) {
        if (!$util.isInteger(message.totalBidQtty) && !(message.totalBidQtty && $util.isInteger(message.totalBidQtty.low) && $util.isInteger(message.totalBidQtty.high)))
          return "totalBidQtty: integer|Long expected";
      }
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty")) {
        if (!$util.isInteger(message.totalOfferQtty) && !(message.totalOfferQtty && $util.isInteger(message.totalOfferQtty.low) && $util.isInteger(message.totalOfferQtty.high)))
          return "totalOfferQtty: integer|Long expected";
      }
      if (message.securityType != null && message.hasOwnProperty("securityType"))
        switch (message.securityType) {
          default:
            return "securityType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 100:
            break;
        }
      if (message.avgPrice != null && message.hasOwnProperty("avgPrice")) {
        if (typeof message.avgPrice !== "number")
          return "avgPrice: number expected";
      }
      if (message.changed != null && message.hasOwnProperty("changed")) {
        if (typeof message.changed !== "number")
          return "changed: number expected";
      }
      if (message.changedRatio != null && message.hasOwnProperty("changedRatio")) {
        if (typeof message.changedRatio !== "number")
          return "changedRatio: number expected";
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        switch (message.floorCode) {
          default:
            return "floorCode: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.bidQtty != null && message.hasOwnProperty("bidQtty")) {
        if (!$util.isInteger(message.bidQtty) && !(message.bidQtty && $util.isInteger(message.bidQtty.low) && $util.isInteger(message.bidQtty.high)))
          return "bidQtty: integer|Long expected";
      }
      if (message.offerQtty != null && message.hasOwnProperty("offerQtty")) {
        if (!$util.isInteger(message.offerQtty) && !(message.offerQtty && $util.isInteger(message.offerQtty.low) && $util.isInteger(message.offerQtty.high)))
          return "offerQtty: integer|Long expected";
      }
      return null;
    };
    DerPrice.fromObject = function fromObject(object) {
      if (object instanceof $root.models.DerPrice)
        return object;
      let message = new $root.models.DerPrice();
      if (object.accumulatedVal != null)
        message.accumulatedVal = Number(object.accumulatedVal);
      if (object.accumulatedVol != null)
        message.accumulatedVol = Number(object.accumulatedVol);
      if (object.basicPrice != null)
        message.basicPrice = Number(object.basicPrice);
      if (object.ceilingPrice != null)
        message.ceilingPrice = Number(object.ceilingPrice);
      if (object.floorPrice != null)
        message.floorPrice = Number(object.floorPrice);
      if (object.bid) {
        if (!Array.isArray(object.bid))
          throw TypeError(".models.DerPrice.bid: array expected");
        message.bid = [];
        for (let i = 0; i < object.bid.length; ++i) {
          if (typeof object.bid[i] !== "object")
            throw TypeError(".models.DerPrice.bid: object expected");
          message.bid[i] = $root.models.OrderMini.fromObject(object.bid[i]);
        }
      }
      if (object.ask) {
        if (!Array.isArray(object.ask))
          throw TypeError(".models.DerPrice.ask: array expected");
        message.ask = [];
        for (let i = 0; i < object.ask.length; ++i) {
          if (typeof object.ask[i] !== "object")
            throw TypeError(".models.DerPrice.ask: object expected");
          message.ask[i] = $root.models.OrderMini.fromObject(object.ask[i]);
        }
      }
      if (object.buyForeignQtty != null)
        message.buyForeignQtty = Number(object.buyForeignQtty);
      if (object.sellForeignQtty != null)
        message.sellForeignQtty = Number(object.sellForeignQtty);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.currentPrice != null)
        message.currentPrice = Number(object.currentPrice);
      if (object.currentQtty != null)
        message.currentQtty = Number(object.currentQtty);
      if (object.highestPrice != null)
        message.highestPrice = Number(object.highestPrice);
      if (object.lastTradingDate != null) {
        if ($util.Long)
          (message.lastTradingDate = $util.Long.fromValue(object.lastTradingDate)).unsigned = false;
        else if (typeof object.lastTradingDate === "string")
          message.lastTradingDate = parseInt(object.lastTradingDate, 10);
        else if (typeof object.lastTradingDate === "number")
          message.lastTradingDate = object.lastTradingDate;
        else if (typeof object.lastTradingDate === "object")
          message.lastTradingDate = new $util.LongBits(object.lastTradingDate.low >>> 0, object.lastTradingDate.high >>> 0).toNumber();
      }
      if (object.lowestPrice != null)
        message.lowestPrice = Number(object.lowestPrice);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.matchQtty != null)
        message.matchQtty = Number(object.matchQtty);
      if (object.openInterest != null)
        message.openInterest = Number(object.openInterest);
      if (object.openPrice != null)
        message.openPrice = Number(object.openPrice);
      switch (object.tradingSessionId) {
        case "UNKNOWN":
        case 0:
          message.tradingSessionId = 0;
          break;
        case "ATO":
        case 21:
          message.tradingSessionId = 21;
          break;
        case "ATC":
        case 100:
          message.tradingSessionId = 100;
          break;
        case "CONTINUOUS":
        case 17:
          message.tradingSessionId = 17;
          break;
        case "CLOSED":
        case 18:
          message.tradingSessionId = 18;
          break;
        case "NOON_BREAK":
        case 2:
          message.tradingSessionId = 2;
          break;
      }
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.closePrice != null)
        message.closePrice = Number(object.closePrice);
      if (object.symbolType != null)
        message.symbolType = String(object.symbolType);
      if (object.totalBidQtty != null) {
        if ($util.Long)
          (message.totalBidQtty = $util.Long.fromValue(object.totalBidQtty)).unsigned = false;
        else if (typeof object.totalBidQtty === "string")
          message.totalBidQtty = parseInt(object.totalBidQtty, 10);
        else if (typeof object.totalBidQtty === "number")
          message.totalBidQtty = object.totalBidQtty;
        else if (typeof object.totalBidQtty === "object")
          message.totalBidQtty = new $util.LongBits(object.totalBidQtty.low >>> 0, object.totalBidQtty.high >>> 0).toNumber();
      }
      if (object.totalOfferQtty != null) {
        if ($util.Long)
          (message.totalOfferQtty = $util.Long.fromValue(object.totalOfferQtty)).unsigned = false;
        else if (typeof object.totalOfferQtty === "string")
          message.totalOfferQtty = parseInt(object.totalOfferQtty, 10);
        else if (typeof object.totalOfferQtty === "number")
          message.totalOfferQtty = object.totalOfferQtty;
        else if (typeof object.totalOfferQtty === "object")
          message.totalOfferQtty = new $util.LongBits(object.totalOfferQtty.low >>> 0, object.totalOfferQtty.high >>> 0).toNumber();
      }
      switch (object.securityType) {
        case "UNKNOWN_TYPE":
        case 0:
          message.securityType = 0;
          break;
        case "STOCK":
        case 1:
          message.securityType = 1;
          break;
        case "BOND":
        case 2:
          message.securityType = 2;
          break;
        case "MUTUAL_FUND":
        case 3:
          message.securityType = 3;
          break;
        case "ETF":
        case 4:
          message.securityType = 4;
          break;
        case "FUTURE":
        case 5:
          message.securityType = 5;
          break;
        case "OPTION":
        case 6:
          message.securityType = 6;
          break;
        case "COVERED_WARRANT":
        case 7:
          message.securityType = 7;
          break;
        case "FUTURE_INDEX":
        case 8:
          message.securityType = 8;
          break;
        case "FUTURE_BOND":
        case 9:
          message.securityType = 9;
          break;
        case "CORPORATE_BOND":
        case 10:
          message.securityType = 10;
          break;
        case "PRIVATE_BOND":
        case 11:
          message.securityType = 11;
          break;
        case "ALL":
        case 100:
          message.securityType = 100;
          break;
      }
      if (object.avgPrice != null)
        message.avgPrice = Number(object.avgPrice);
      if (object.changed != null)
        message.changed = Number(object.changed);
      if (object.changedRatio != null)
        message.changedRatio = Number(object.changedRatio);
      switch (object.floorCode) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floorCode = 0;
          break;
        case "HNX":
        case 2:
          message.floorCode = 2;
          break;
        case "UPCOM":
        case 3:
          message.floorCode = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floorCode = 4;
          break;
        case "HOSE":
        case 10:
          message.floorCode = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floorCode = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floorCode = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floorCode = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floorCode = 14;
          break;
      }
      if (object.bidQtty != null) {
        if ($util.Long)
          (message.bidQtty = $util.Long.fromValue(object.bidQtty)).unsigned = false;
        else if (typeof object.bidQtty === "string")
          message.bidQtty = parseInt(object.bidQtty, 10);
        else if (typeof object.bidQtty === "number")
          message.bidQtty = object.bidQtty;
        else if (typeof object.bidQtty === "object")
          message.bidQtty = new $util.LongBits(object.bidQtty.low >>> 0, object.bidQtty.high >>> 0).toNumber();
      }
      if (object.offerQtty != null) {
        if ($util.Long)
          (message.offerQtty = $util.Long.fromValue(object.offerQtty)).unsigned = false;
        else if (typeof object.offerQtty === "string")
          message.offerQtty = parseInt(object.offerQtty, 10);
        else if (typeof object.offerQtty === "number")
          message.offerQtty = object.offerQtty;
        else if (typeof object.offerQtty === "object")
          message.offerQtty = new $util.LongBits(object.offerQtty.low >>> 0, object.offerQtty.high >>> 0).toNumber();
      }
      return message;
    };
    DerPrice.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.bid = [];
        object.ask = [];
      }
      if (options.defaults) {
        object.accumulatedVal = 0;
        object.accumulatedVol = 0;
        object.basicPrice = 0;
        object.ceilingPrice = 0;
        object.floorPrice = 0;
        object.buyForeignQtty = 0;
        object.sellForeignQtty = 0;
        object.symbol = "";
        object.currentPrice = 0;
        object.currentQtty = 0;
        object.highestPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastTradingDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.lastTradingDate = options.longs === String ? "0" : 0;
        object.lowestPrice = 0;
        object.matchPrice = 0;
        object.matchQtty = 0;
        object.openInterest = 0;
        object.openPrice = 0;
        object.tradingSessionId = options.enums === String ? "UNKNOWN" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.closePrice = 0;
        object.symbolType = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalBidQtty = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalBidQtty = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalOfferQtty = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalOfferQtty = options.longs === String ? "0" : 0;
        object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.avgPrice = 0;
        object.changed = 0;
        object.changedRatio = 0;
        object.floorCode = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.bidQtty = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.bidQtty = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerQtty = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerQtty = options.longs === String ? "0" : 0;
      }
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal"))
        object.accumulatedVal = options.json && !isFinite(message.accumulatedVal) ? String(message.accumulatedVal) : message.accumulatedVal;
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol"))
        object.accumulatedVol = options.json && !isFinite(message.accumulatedVol) ? String(message.accumulatedVol) : message.accumulatedVol;
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
        object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
        object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
      if (message.bid && message.bid.length) {
        object.bid = [];
        for (let j = 0; j < message.bid.length; ++j)
          object.bid[j] = $root.models.OrderMini.toObject(message.bid[j], options);
      }
      if (message.ask && message.ask.length) {
        object.ask = [];
        for (let j = 0; j < message.ask.length; ++j)
          object.ask[j] = $root.models.OrderMini.toObject(message.ask[j], options);
      }
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty"))
        object.buyForeignQtty = options.json && !isFinite(message.buyForeignQtty) ? String(message.buyForeignQtty) : message.buyForeignQtty;
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty"))
        object.sellForeignQtty = options.json && !isFinite(message.sellForeignQtty) ? String(message.sellForeignQtty) : message.sellForeignQtty;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
        object.currentPrice = options.json && !isFinite(message.currentPrice) ? String(message.currentPrice) : message.currentPrice;
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty"))
        object.currentQtty = options.json && !isFinite(message.currentQtty) ? String(message.currentQtty) : message.currentQtty;
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
        object.highestPrice = options.json && !isFinite(message.highestPrice) ? String(message.highestPrice) : message.highestPrice;
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate"))
        if (typeof message.lastTradingDate === "number")
          object.lastTradingDate = options.longs === String ? String(message.lastTradingDate) : message.lastTradingDate;
        else
          object.lastTradingDate = options.longs === String ? $util.Long.prototype.toString.call(message.lastTradingDate) : options.longs === Number ? new $util.LongBits(message.lastTradingDate.low >>> 0, message.lastTradingDate.high >>> 0).toNumber() : message.lastTradingDate;
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
        object.lowestPrice = options.json && !isFinite(message.lowestPrice) ? String(message.lowestPrice) : message.lowestPrice;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty"))
        object.matchQtty = options.json && !isFinite(message.matchQtty) ? String(message.matchQtty) : message.matchQtty;
      if (message.openInterest != null && message.hasOwnProperty("openInterest"))
        object.openInterest = options.json && !isFinite(message.openInterest) ? String(message.openInterest) : message.openInterest;
      if (message.openPrice != null && message.hasOwnProperty("openPrice"))
        object.openPrice = options.json && !isFinite(message.openPrice) ? String(message.openPrice) : message.openPrice;
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        object.tradingSessionId = options.enums === String ? $root.models.DerPrice.TradingSessionId[message.tradingSessionId] : message.tradingSessionId;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.closePrice != null && message.hasOwnProperty("closePrice"))
        object.closePrice = options.json && !isFinite(message.closePrice) ? String(message.closePrice) : message.closePrice;
      if (message.symbolType != null && message.hasOwnProperty("symbolType"))
        object.symbolType = message.symbolType;
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty"))
        if (typeof message.totalBidQtty === "number")
          object.totalBidQtty = options.longs === String ? String(message.totalBidQtty) : message.totalBidQtty;
        else
          object.totalBidQtty = options.longs === String ? $util.Long.prototype.toString.call(message.totalBidQtty) : options.longs === Number ? new $util.LongBits(message.totalBidQtty.low >>> 0, message.totalBidQtty.high >>> 0).toNumber() : message.totalBidQtty;
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty"))
        if (typeof message.totalOfferQtty === "number")
          object.totalOfferQtty = options.longs === String ? String(message.totalOfferQtty) : message.totalOfferQtty;
        else
          object.totalOfferQtty = options.longs === String ? $util.Long.prototype.toString.call(message.totalOfferQtty) : options.longs === Number ? new $util.LongBits(message.totalOfferQtty.low >>> 0, message.totalOfferQtty.high >>> 0).toNumber() : message.totalOfferQtty;
      if (message.securityType != null && message.hasOwnProperty("securityType"))
        object.securityType = options.enums === String ? $root.price.SecurityType[message.securityType] : message.securityType;
      if (message.avgPrice != null && message.hasOwnProperty("avgPrice"))
        object.avgPrice = options.json && !isFinite(message.avgPrice) ? String(message.avgPrice) : message.avgPrice;
      if (message.changed != null && message.hasOwnProperty("changed"))
        object.changed = options.json && !isFinite(message.changed) ? String(message.changed) : message.changed;
      if (message.changedRatio != null && message.hasOwnProperty("changedRatio"))
        object.changedRatio = options.json && !isFinite(message.changedRatio) ? String(message.changedRatio) : message.changedRatio;
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = options.enums === String ? $root.price.FloorCode[message.floorCode] : message.floorCode;
      if (message.bidQtty != null && message.hasOwnProperty("bidQtty"))
        if (typeof message.bidQtty === "number")
          object.bidQtty = options.longs === String ? String(message.bidQtty) : message.bidQtty;
        else
          object.bidQtty = options.longs === String ? $util.Long.prototype.toString.call(message.bidQtty) : options.longs === Number ? new $util.LongBits(message.bidQtty.low >>> 0, message.bidQtty.high >>> 0).toNumber() : message.bidQtty;
      if (message.offerQtty != null && message.hasOwnProperty("offerQtty"))
        if (typeof message.offerQtty === "number")
          object.offerQtty = options.longs === String ? String(message.offerQtty) : message.offerQtty;
        else
          object.offerQtty = options.longs === String ? $util.Long.prototype.toString.call(message.offerQtty) : options.longs === Number ? new $util.LongBits(message.offerQtty.low >>> 0, message.offerQtty.high >>> 0).toNumber() : message.offerQtty;
      return object;
    };
    DerPrice.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    DerPrice.TradingSessionId = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[21] = "ATO"] = 21;
      values[valuesById[100] = "ATC"] = 100;
      values[valuesById[17] = "CONTINUOUS"] = 17;
      values[valuesById[18] = "CLOSED"] = 18;
      values[valuesById[2] = "NOON_BREAK"] = 2;
      return values;
    }();
    return DerPrice;
  }();
  models2.Order = function() {
    function Order(properties) {
      this.reports = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Order.prototype.id = 0;
    Order.prototype.side = "";
    Order.prototype.investorId = 0;
    Order.prototype.bankId = 0;
    Order.prototype.bankAccountId = 0;
    Order.prototype.symbol = "";
    Order.prototype.price = 0;
    Order.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Order.prototype.orderType = "";
    Order.prototype.orderStatus = "";
    Order.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Order.prototype.lastQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Order.prototype.lastPrice = 0;
    Order.prototype.averagePrice = 0;
    Order.prototype.createdDate = null;
    Order.prototype.modifiedDate = null;
    Order.prototype.bankMarginPortfolioId = 0;
    Order.prototype.leavesQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Order.prototype.externalId = "";
    Order.prototype.error = "";
    Order.prototype.triggeredBy = "";
    Order.prototype.investorAccountId = 0;
    Order.prototype.priceSecure = 0;
    Order.prototype.reports = $util.emptyArray;
    Order.create = function create(properties) {
      return new Order(properties);
    };
    Order.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(18).string(message.side);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(24).int32(message.investorId);
      if (message.bankId != null && Object.hasOwnProperty.call(message, "bankId"))
        writer.uint32(32).int32(message.bankId);
      if (message.bankAccountId != null && Object.hasOwnProperty.call(message, "bankAccountId"))
        writer.uint32(40).int32(message.bankAccountId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(50).string(message.symbol);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(57).double(message.price);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(64).int64(message.quantity);
      if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
        writer.uint32(74).string(message.orderType);
      if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
        writer.uint32(82).string(message.orderStatus);
      if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
        writer.uint32(88).int64(message.fillQuantity);
      if (message.lastQuantity != null && Object.hasOwnProperty.call(message, "lastQuantity"))
        writer.uint32(96).int64(message.lastQuantity);
      if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
        writer.uint32(105).double(message.lastPrice);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(113).double(message.averagePrice);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(122).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(130).fork()).ldelim();
      if (message.bankMarginPortfolioId != null && Object.hasOwnProperty.call(message, "bankMarginPortfolioId"))
        writer.uint32(136).int32(message.bankMarginPortfolioId);
      if (message.leavesQuantity != null && Object.hasOwnProperty.call(message, "leavesQuantity"))
        writer.uint32(144).int64(message.leavesQuantity);
      if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
        writer.uint32(154).string(message.externalId);
      if (message.error != null && Object.hasOwnProperty.call(message, "error"))
        writer.uint32(162).string(message.error);
      if (message.triggeredBy != null && Object.hasOwnProperty.call(message, "triggeredBy"))
        writer.uint32(170).string(message.triggeredBy);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(176).int32(message.investorAccountId);
      if (message.priceSecure != null && Object.hasOwnProperty.call(message, "priceSecure"))
        writer.uint32(185).double(message.priceSecure);
      if (message.reports != null && message.reports.length)
        for (let i = 0; i < message.reports.length; ++i)
          $root.models.Order.encode(message.reports[i], writer.uint32(194).fork()).ldelim();
      return writer;
    };
    Order.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Order.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Order();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.side = reader.string();
            break;
          case 3:
            message.investorId = reader.int32();
            break;
          case 4:
            message.bankId = reader.int32();
            break;
          case 5:
            message.bankAccountId = reader.int32();
            break;
          case 6:
            message.symbol = reader.string();
            break;
          case 7:
            message.price = reader.double();
            break;
          case 8:
            message.quantity = reader.int64();
            break;
          case 9:
            message.orderType = reader.string();
            break;
          case 10:
            message.orderStatus = reader.string();
            break;
          case 11:
            message.fillQuantity = reader.int64();
            break;
          case 12:
            message.lastQuantity = reader.int64();
            break;
          case 13:
            message.lastPrice = reader.double();
            break;
          case 14:
            message.averagePrice = reader.double();
            break;
          case 15:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 16:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 17:
            message.bankMarginPortfolioId = reader.int32();
            break;
          case 18:
            message.leavesQuantity = reader.int64();
            break;
          case 19:
            message.externalId = reader.string();
            break;
          case 20:
            message.error = reader.string();
            break;
          case 21:
            message.triggeredBy = reader.string();
            break;
          case 22:
            message.investorAccountId = reader.int32();
            break;
          case 23:
            message.priceSecure = reader.double();
            break;
          case 24:
            if (!(message.reports && message.reports.length))
              message.reports = [];
            message.reports.push($root.models.Order.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Order.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Order.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.bankId != null && message.hasOwnProperty("bankId")) {
        if (!$util.isInteger(message.bankId))
          return "bankId: integer expected";
      }
      if (message.bankAccountId != null && message.hasOwnProperty("bankAccountId")) {
        if (!$util.isInteger(message.bankAccountId))
          return "bankAccountId: integer expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.orderType != null && message.hasOwnProperty("orderType")) {
        if (!$util.isString(message.orderType))
          return "orderType: string expected";
      }
      if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
        if (!$util.isString(message.orderStatus))
          return "orderStatus: string expected";
      }
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
        if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
          return "fillQuantity: integer|Long expected";
      }
      if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity")) {
        if (!$util.isInteger(message.lastQuantity) && !(message.lastQuantity && $util.isInteger(message.lastQuantity.low) && $util.isInteger(message.lastQuantity.high)))
          return "lastQuantity: integer|Long expected";
      }
      if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
        if (typeof message.lastPrice !== "number")
          return "lastPrice: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.bankMarginPortfolioId != null && message.hasOwnProperty("bankMarginPortfolioId")) {
        if (!$util.isInteger(message.bankMarginPortfolioId))
          return "bankMarginPortfolioId: integer expected";
      }
      if (message.leavesQuantity != null && message.hasOwnProperty("leavesQuantity")) {
        if (!$util.isInteger(message.leavesQuantity) && !(message.leavesQuantity && $util.isInteger(message.leavesQuantity.low) && $util.isInteger(message.leavesQuantity.high)))
          return "leavesQuantity: integer|Long expected";
      }
      if (message.externalId != null && message.hasOwnProperty("externalId")) {
        if (!$util.isString(message.externalId))
          return "externalId: string expected";
      }
      if (message.error != null && message.hasOwnProperty("error")) {
        if (!$util.isString(message.error))
          return "error: string expected";
      }
      if (message.triggeredBy != null && message.hasOwnProperty("triggeredBy")) {
        if (!$util.isString(message.triggeredBy))
          return "triggeredBy: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.priceSecure != null && message.hasOwnProperty("priceSecure")) {
        if (typeof message.priceSecure !== "number")
          return "priceSecure: number expected";
      }
      if (message.reports != null && message.hasOwnProperty("reports")) {
        if (!Array.isArray(message.reports))
          return "reports: array expected";
        for (let i = 0; i < message.reports.length; ++i) {
          let error = $root.models.Order.verify(message.reports[i]);
          if (error)
            return "reports." + error;
        }
      }
      return null;
    };
    Order.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Order)
        return object;
      let message = new $root.models.Order();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.side != null)
        message.side = String(object.side);
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.bankId != null)
        message.bankId = object.bankId | 0;
      if (object.bankAccountId != null)
        message.bankAccountId = object.bankAccountId | 0;
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.price != null)
        message.price = Number(object.price);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.orderType != null)
        message.orderType = String(object.orderType);
      if (object.orderStatus != null)
        message.orderStatus = String(object.orderStatus);
      if (object.fillQuantity != null) {
        if ($util.Long)
          (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
        else if (typeof object.fillQuantity === "string")
          message.fillQuantity = parseInt(object.fillQuantity, 10);
        else if (typeof object.fillQuantity === "number")
          message.fillQuantity = object.fillQuantity;
        else if (typeof object.fillQuantity === "object")
          message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
      }
      if (object.lastQuantity != null) {
        if ($util.Long)
          (message.lastQuantity = $util.Long.fromValue(object.lastQuantity)).unsigned = false;
        else if (typeof object.lastQuantity === "string")
          message.lastQuantity = parseInt(object.lastQuantity, 10);
        else if (typeof object.lastQuantity === "number")
          message.lastQuantity = object.lastQuantity;
        else if (typeof object.lastQuantity === "object")
          message.lastQuantity = new $util.LongBits(object.lastQuantity.low >>> 0, object.lastQuantity.high >>> 0).toNumber();
      }
      if (object.lastPrice != null)
        message.lastPrice = Number(object.lastPrice);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.Order.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".models.Order.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.bankMarginPortfolioId != null)
        message.bankMarginPortfolioId = object.bankMarginPortfolioId | 0;
      if (object.leavesQuantity != null) {
        if ($util.Long)
          (message.leavesQuantity = $util.Long.fromValue(object.leavesQuantity)).unsigned = false;
        else if (typeof object.leavesQuantity === "string")
          message.leavesQuantity = parseInt(object.leavesQuantity, 10);
        else if (typeof object.leavesQuantity === "number")
          message.leavesQuantity = object.leavesQuantity;
        else if (typeof object.leavesQuantity === "object")
          message.leavesQuantity = new $util.LongBits(object.leavesQuantity.low >>> 0, object.leavesQuantity.high >>> 0).toNumber();
      }
      if (object.externalId != null)
        message.externalId = String(object.externalId);
      if (object.error != null)
        message.error = String(object.error);
      if (object.triggeredBy != null)
        message.triggeredBy = String(object.triggeredBy);
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.priceSecure != null)
        message.priceSecure = Number(object.priceSecure);
      if (object.reports) {
        if (!Array.isArray(object.reports))
          throw TypeError(".models.Order.reports: array expected");
        message.reports = [];
        for (let i = 0; i < object.reports.length; ++i) {
          if (typeof object.reports[i] !== "object")
            throw TypeError(".models.Order.reports: object expected");
          message.reports[i] = $root.models.Order.fromObject(object.reports[i]);
        }
      }
      return message;
    };
    Order.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.reports = [];
      if (options.defaults) {
        object.id = 0;
        object.side = "";
        object.investorId = 0;
        object.bankId = 0;
        object.bankAccountId = 0;
        object.symbol = "";
        object.price = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        object.orderType = "";
        object.orderStatus = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fillQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.lastQuantity = options.longs === String ? "0" : 0;
        object.lastPrice = 0;
        object.averagePrice = 0;
        object.createdDate = null;
        object.modifiedDate = null;
        object.bankMarginPortfolioId = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.leavesQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.leavesQuantity = options.longs === String ? "0" : 0;
        object.externalId = "";
        object.error = "";
        object.triggeredBy = "";
        object.investorAccountId = 0;
        object.priceSecure = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.bankId != null && message.hasOwnProperty("bankId"))
        object.bankId = message.bankId;
      if (message.bankAccountId != null && message.hasOwnProperty("bankAccountId"))
        object.bankAccountId = message.bankAccountId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.orderType != null && message.hasOwnProperty("orderType"))
        object.orderType = message.orderType;
      if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
        object.orderStatus = message.orderStatus;
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
        if (typeof message.fillQuantity === "number")
          object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
        else
          object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
      if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity"))
        if (typeof message.lastQuantity === "number")
          object.lastQuantity = options.longs === String ? String(message.lastQuantity) : message.lastQuantity;
        else
          object.lastQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.lastQuantity) : options.longs === Number ? new $util.LongBits(message.lastQuantity.low >>> 0, message.lastQuantity.high >>> 0).toNumber() : message.lastQuantity;
      if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
        object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.bankMarginPortfolioId != null && message.hasOwnProperty("bankMarginPortfolioId"))
        object.bankMarginPortfolioId = message.bankMarginPortfolioId;
      if (message.leavesQuantity != null && message.hasOwnProperty("leavesQuantity"))
        if (typeof message.leavesQuantity === "number")
          object.leavesQuantity = options.longs === String ? String(message.leavesQuantity) : message.leavesQuantity;
        else
          object.leavesQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leavesQuantity) : options.longs === Number ? new $util.LongBits(message.leavesQuantity.low >>> 0, message.leavesQuantity.high >>> 0).toNumber() : message.leavesQuantity;
      if (message.externalId != null && message.hasOwnProperty("externalId"))
        object.externalId = message.externalId;
      if (message.error != null && message.hasOwnProperty("error"))
        object.error = message.error;
      if (message.triggeredBy != null && message.hasOwnProperty("triggeredBy"))
        object.triggeredBy = message.triggeredBy;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.priceSecure != null && message.hasOwnProperty("priceSecure"))
        object.priceSecure = options.json && !isFinite(message.priceSecure) ? String(message.priceSecure) : message.priceSecure;
      if (message.reports && message.reports.length) {
        object.reports = [];
        for (let j = 0; j < message.reports.length; ++j)
          object.reports[j] = $root.models.Order.toObject(message.reports[j], options);
      }
      return object;
    };
    Order.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Order;
  }();
  models2.Deal = function() {
    function Deal(properties) {
      this.orderIds = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Deal.prototype.id = 0;
    Deal.prototype.investorId = 0;
    Deal.prototype.bankId = 0;
    Deal.prototype.bankAccountId = 0;
    Deal.prototype.bankMarginPortfolioId = 0;
    Deal.prototype.symbol = "";
    Deal.prototype.side = "";
    Deal.prototype.type = "";
    Deal.prototype.positionCostPrice = 0;
    Deal.prototype.stockClosePrice = 0;
    Deal.prototype.averageClosedPrice = 0;
    Deal.prototype.adjustedCostPrice = 0;
    Deal.prototype.openQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Deal.prototype.closedQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Deal.prototype.initialQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Deal.prototype.currentMarginRate = 0;
    Deal.prototype.loan = 0;
    Deal.prototype.secure = 0;
    Deal.prototype.interest = 0;
    Deal.prototype.positionRealizedProfit = 0;
    Deal.prototype.positionUnrealizedProfit = 0;
    Deal.prototype.positionType = 0;
    Deal.prototype.createdDate = null;
    Deal.prototype.modifiedDate = null;
    Deal.prototype.marginRate = 0;
    Deal.prototype.maintainanceRate = 0;
    Deal.prototype.liquidateMarginRate = 0;
    Deal.prototype.totalDebt = 0;
    Deal.prototype.netProfit = 0;
    Deal.prototype.breakEvenPrice = 0;
    Deal.prototype.status = 0;
    Deal.prototype.unrealizedTradingTaxFactor = 0;
    Deal.prototype.cutLossPrice = 0;
    Deal.prototype.bankSecureRate = 0;
    Deal.prototype.vsdSecureRate = 0;
    Deal.prototype.initialMarginRate = 0;
    Deal.prototype.totalInterestAndFeeWithoutClosingTax = 0;
    Deal.prototype.averageCostPrice = 0;
    Deal.prototype.totalInterestAndFee = 0;
    Deal.prototype.coInvestTaxRate = 0;
    Deal.prototype.investorAccountId = 0;
    Deal.prototype.collectedInterestAndFee = 0;
    Deal.prototype.unrealizedTotalTaxAndFee = 0;
    Deal.prototype.tradingFeeAmount = 0;
    Deal.prototype.lastRealizedProfit = 0;
    Deal.prototype.tradingTaxAmount = 0;
    Deal.prototype.closedPositionFeeAmount = 0;
    Deal.prototype.orderIds = $util.emptyArray;
    Deal.prototype.assetManagementOvernightFeeAmount = 0;
    Deal.prototype.netProfitRate = 0;
    Deal.prototype.coInvestTax = 0;
    Deal.prototype.accumulatedSecure = 0;
    Deal.create = function create(properties) {
      return new Deal(properties);
    };
    Deal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(16).int32(message.investorId);
      if (message.bankId != null && Object.hasOwnProperty.call(message, "bankId"))
        writer.uint32(24).int32(message.bankId);
      if (message.bankAccountId != null && Object.hasOwnProperty.call(message, "bankAccountId"))
        writer.uint32(32).int32(message.bankAccountId);
      if (message.bankMarginPortfolioId != null && Object.hasOwnProperty.call(message, "bankMarginPortfolioId"))
        writer.uint32(40).int32(message.bankMarginPortfolioId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(50).string(message.symbol);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(58).string(message.side);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(66).string(message.type);
      if (message.positionCostPrice != null && Object.hasOwnProperty.call(message, "positionCostPrice"))
        writer.uint32(73).double(message.positionCostPrice);
      if (message.stockClosePrice != null && Object.hasOwnProperty.call(message, "stockClosePrice"))
        writer.uint32(81).double(message.stockClosePrice);
      if (message.averageClosedPrice != null && Object.hasOwnProperty.call(message, "averageClosedPrice"))
        writer.uint32(89).double(message.averageClosedPrice);
      if (message.adjustedCostPrice != null && Object.hasOwnProperty.call(message, "adjustedCostPrice"))
        writer.uint32(97).double(message.adjustedCostPrice);
      if (message.openQuantity != null && Object.hasOwnProperty.call(message, "openQuantity"))
        writer.uint32(104).int64(message.openQuantity);
      if (message.closedQuantity != null && Object.hasOwnProperty.call(message, "closedQuantity"))
        writer.uint32(112).int64(message.closedQuantity);
      if (message.initialQuantity != null && Object.hasOwnProperty.call(message, "initialQuantity"))
        writer.uint32(120).int64(message.initialQuantity);
      if (message.currentMarginRate != null && Object.hasOwnProperty.call(message, "currentMarginRate"))
        writer.uint32(129).double(message.currentMarginRate);
      if (message.loan != null && Object.hasOwnProperty.call(message, "loan"))
        writer.uint32(137).double(message.loan);
      if (message.secure != null && Object.hasOwnProperty.call(message, "secure"))
        writer.uint32(145).double(message.secure);
      if (message.interest != null && Object.hasOwnProperty.call(message, "interest"))
        writer.uint32(153).double(message.interest);
      if (message.positionRealizedProfit != null && Object.hasOwnProperty.call(message, "positionRealizedProfit"))
        writer.uint32(161).double(message.positionRealizedProfit);
      if (message.positionUnrealizedProfit != null && Object.hasOwnProperty.call(message, "positionUnrealizedProfit"))
        writer.uint32(169).double(message.positionUnrealizedProfit);
      if (message.positionType != null && Object.hasOwnProperty.call(message, "positionType"))
        writer.uint32(176).int32(message.positionType);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(186).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(194).fork()).ldelim();
      if (message.marginRate != null && Object.hasOwnProperty.call(message, "marginRate"))
        writer.uint32(201).double(message.marginRate);
      if (message.maintainanceRate != null && Object.hasOwnProperty.call(message, "maintainanceRate"))
        writer.uint32(209).double(message.maintainanceRate);
      if (message.liquidateMarginRate != null && Object.hasOwnProperty.call(message, "liquidateMarginRate"))
        writer.uint32(217).double(message.liquidateMarginRate);
      if (message.totalDebt != null && Object.hasOwnProperty.call(message, "totalDebt"))
        writer.uint32(225).double(message.totalDebt);
      if (message.netProfit != null && Object.hasOwnProperty.call(message, "netProfit"))
        writer.uint32(233).double(message.netProfit);
      if (message.breakEvenPrice != null && Object.hasOwnProperty.call(message, "breakEvenPrice"))
        writer.uint32(241).double(message.breakEvenPrice);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(248).int32(message.status);
      if (message.unrealizedTradingTaxFactor != null && Object.hasOwnProperty.call(message, "unrealizedTradingTaxFactor"))
        writer.uint32(257).double(message.unrealizedTradingTaxFactor);
      if (message.cutLossPrice != null && Object.hasOwnProperty.call(message, "cutLossPrice"))
        writer.uint32(265).double(message.cutLossPrice);
      if (message.bankSecureRate != null && Object.hasOwnProperty.call(message, "bankSecureRate"))
        writer.uint32(273).double(message.bankSecureRate);
      if (message.vsdSecureRate != null && Object.hasOwnProperty.call(message, "vsdSecureRate"))
        writer.uint32(281).double(message.vsdSecureRate);
      if (message.initialMarginRate != null && Object.hasOwnProperty.call(message, "initialMarginRate"))
        writer.uint32(289).double(message.initialMarginRate);
      if (message.totalInterestAndFeeWithoutClosingTax != null && Object.hasOwnProperty.call(message, "totalInterestAndFeeWithoutClosingTax"))
        writer.uint32(297).double(message.totalInterestAndFeeWithoutClosingTax);
      if (message.averageCostPrice != null && Object.hasOwnProperty.call(message, "averageCostPrice"))
        writer.uint32(305).double(message.averageCostPrice);
      if (message.totalInterestAndFee != null && Object.hasOwnProperty.call(message, "totalInterestAndFee"))
        writer.uint32(313).double(message.totalInterestAndFee);
      if (message.coInvestTaxRate != null && Object.hasOwnProperty.call(message, "coInvestTaxRate"))
        writer.uint32(321).double(message.coInvestTaxRate);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(328).int32(message.investorAccountId);
      if (message.collectedInterestAndFee != null && Object.hasOwnProperty.call(message, "collectedInterestAndFee"))
        writer.uint32(337).double(message.collectedInterestAndFee);
      if (message.unrealizedTotalTaxAndFee != null && Object.hasOwnProperty.call(message, "unrealizedTotalTaxAndFee"))
        writer.uint32(345).double(message.unrealizedTotalTaxAndFee);
      if (message.tradingFeeAmount != null && Object.hasOwnProperty.call(message, "tradingFeeAmount"))
        writer.uint32(353).double(message.tradingFeeAmount);
      if (message.lastRealizedProfit != null && Object.hasOwnProperty.call(message, "lastRealizedProfit"))
        writer.uint32(361).double(message.lastRealizedProfit);
      if (message.tradingTaxAmount != null && Object.hasOwnProperty.call(message, "tradingTaxAmount"))
        writer.uint32(369).double(message.tradingTaxAmount);
      if (message.closedPositionFeeAmount != null && Object.hasOwnProperty.call(message, "closedPositionFeeAmount"))
        writer.uint32(377).double(message.closedPositionFeeAmount);
      if (message.orderIds != null && message.orderIds.length) {
        writer.uint32(386).fork();
        for (let i = 0; i < message.orderIds.length; ++i)
          writer.int32(message.orderIds[i]);
        writer.ldelim();
      }
      if (message.assetManagementOvernightFeeAmount != null && Object.hasOwnProperty.call(message, "assetManagementOvernightFeeAmount"))
        writer.uint32(393).double(message.assetManagementOvernightFeeAmount);
      if (message.netProfitRate != null && Object.hasOwnProperty.call(message, "netProfitRate"))
        writer.uint32(401).double(message.netProfitRate);
      if (message.coInvestTax != null && Object.hasOwnProperty.call(message, "coInvestTax"))
        writer.uint32(409).double(message.coInvestTax);
      if (message.accumulatedSecure != null && Object.hasOwnProperty.call(message, "accumulatedSecure"))
        writer.uint32(417).double(message.accumulatedSecure);
      return writer;
    };
    Deal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Deal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Deal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.investorId = reader.int32();
            break;
          case 3:
            message.bankId = reader.int32();
            break;
          case 4:
            message.bankAccountId = reader.int32();
            break;
          case 5:
            message.bankMarginPortfolioId = reader.int32();
            break;
          case 6:
            message.symbol = reader.string();
            break;
          case 7:
            message.side = reader.string();
            break;
          case 8:
            message.type = reader.string();
            break;
          case 9:
            message.positionCostPrice = reader.double();
            break;
          case 10:
            message.stockClosePrice = reader.double();
            break;
          case 11:
            message.averageClosedPrice = reader.double();
            break;
          case 12:
            message.adjustedCostPrice = reader.double();
            break;
          case 13:
            message.openQuantity = reader.int64();
            break;
          case 14:
            message.closedQuantity = reader.int64();
            break;
          case 15:
            message.initialQuantity = reader.int64();
            break;
          case 16:
            message.currentMarginRate = reader.double();
            break;
          case 17:
            message.loan = reader.double();
            break;
          case 18:
            message.secure = reader.double();
            break;
          case 19:
            message.interest = reader.double();
            break;
          case 20:
            message.positionRealizedProfit = reader.double();
            break;
          case 21:
            message.positionUnrealizedProfit = reader.double();
            break;
          case 22:
            message.positionType = reader.int32();
            break;
          case 23:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 24:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 25:
            message.marginRate = reader.double();
            break;
          case 26:
            message.maintainanceRate = reader.double();
            break;
          case 27:
            message.liquidateMarginRate = reader.double();
            break;
          case 28:
            message.totalDebt = reader.double();
            break;
          case 29:
            message.netProfit = reader.double();
            break;
          case 30:
            message.breakEvenPrice = reader.double();
            break;
          case 31:
            message.status = reader.int32();
            break;
          case 32:
            message.unrealizedTradingTaxFactor = reader.double();
            break;
          case 33:
            message.cutLossPrice = reader.double();
            break;
          case 34:
            message.bankSecureRate = reader.double();
            break;
          case 35:
            message.vsdSecureRate = reader.double();
            break;
          case 36:
            message.initialMarginRate = reader.double();
            break;
          case 37:
            message.totalInterestAndFeeWithoutClosingTax = reader.double();
            break;
          case 38:
            message.averageCostPrice = reader.double();
            break;
          case 39:
            message.totalInterestAndFee = reader.double();
            break;
          case 40:
            message.coInvestTaxRate = reader.double();
            break;
          case 41:
            message.investorAccountId = reader.int32();
            break;
          case 42:
            message.collectedInterestAndFee = reader.double();
            break;
          case 43:
            message.unrealizedTotalTaxAndFee = reader.double();
            break;
          case 44:
            message.tradingFeeAmount = reader.double();
            break;
          case 45:
            message.lastRealizedProfit = reader.double();
            break;
          case 46:
            message.tradingTaxAmount = reader.double();
            break;
          case 47:
            message.closedPositionFeeAmount = reader.double();
            break;
          case 48:
            if (!(message.orderIds && message.orderIds.length))
              message.orderIds = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2)
                message.orderIds.push(reader.int32());
            } else
              message.orderIds.push(reader.int32());
            break;
          case 49:
            message.assetManagementOvernightFeeAmount = reader.double();
            break;
          case 50:
            message.netProfitRate = reader.double();
            break;
          case 51:
            message.coInvestTax = reader.double();
            break;
          case 52:
            message.accumulatedSecure = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Deal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Deal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.bankId != null && message.hasOwnProperty("bankId")) {
        if (!$util.isInteger(message.bankId))
          return "bankId: integer expected";
      }
      if (message.bankAccountId != null && message.hasOwnProperty("bankAccountId")) {
        if (!$util.isInteger(message.bankAccountId))
          return "bankAccountId: integer expected";
      }
      if (message.bankMarginPortfolioId != null && message.hasOwnProperty("bankMarginPortfolioId")) {
        if (!$util.isInteger(message.bankMarginPortfolioId))
          return "bankMarginPortfolioId: integer expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.positionCostPrice != null && message.hasOwnProperty("positionCostPrice")) {
        if (typeof message.positionCostPrice !== "number")
          return "positionCostPrice: number expected";
      }
      if (message.stockClosePrice != null && message.hasOwnProperty("stockClosePrice")) {
        if (typeof message.stockClosePrice !== "number")
          return "stockClosePrice: number expected";
      }
      if (message.averageClosedPrice != null && message.hasOwnProperty("averageClosedPrice")) {
        if (typeof message.averageClosedPrice !== "number")
          return "averageClosedPrice: number expected";
      }
      if (message.adjustedCostPrice != null && message.hasOwnProperty("adjustedCostPrice")) {
        if (typeof message.adjustedCostPrice !== "number")
          return "adjustedCostPrice: number expected";
      }
      if (message.openQuantity != null && message.hasOwnProperty("openQuantity")) {
        if (!$util.isInteger(message.openQuantity) && !(message.openQuantity && $util.isInteger(message.openQuantity.low) && $util.isInteger(message.openQuantity.high)))
          return "openQuantity: integer|Long expected";
      }
      if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity")) {
        if (!$util.isInteger(message.closedQuantity) && !(message.closedQuantity && $util.isInteger(message.closedQuantity.low) && $util.isInteger(message.closedQuantity.high)))
          return "closedQuantity: integer|Long expected";
      }
      if (message.initialQuantity != null && message.hasOwnProperty("initialQuantity")) {
        if (!$util.isInteger(message.initialQuantity) && !(message.initialQuantity && $util.isInteger(message.initialQuantity.low) && $util.isInteger(message.initialQuantity.high)))
          return "initialQuantity: integer|Long expected";
      }
      if (message.currentMarginRate != null && message.hasOwnProperty("currentMarginRate")) {
        if (typeof message.currentMarginRate !== "number")
          return "currentMarginRate: number expected";
      }
      if (message.loan != null && message.hasOwnProperty("loan")) {
        if (typeof message.loan !== "number")
          return "loan: number expected";
      }
      if (message.secure != null && message.hasOwnProperty("secure")) {
        if (typeof message.secure !== "number")
          return "secure: number expected";
      }
      if (message.interest != null && message.hasOwnProperty("interest")) {
        if (typeof message.interest !== "number")
          return "interest: number expected";
      }
      if (message.positionRealizedProfit != null && message.hasOwnProperty("positionRealizedProfit")) {
        if (typeof message.positionRealizedProfit !== "number")
          return "positionRealizedProfit: number expected";
      }
      if (message.positionUnrealizedProfit != null && message.hasOwnProperty("positionUnrealizedProfit")) {
        if (typeof message.positionUnrealizedProfit !== "number")
          return "positionUnrealizedProfit: number expected";
      }
      if (message.positionType != null && message.hasOwnProperty("positionType")) {
        if (!$util.isInteger(message.positionType))
          return "positionType: integer expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.marginRate != null && message.hasOwnProperty("marginRate")) {
        if (typeof message.marginRate !== "number")
          return "marginRate: number expected";
      }
      if (message.maintainanceRate != null && message.hasOwnProperty("maintainanceRate")) {
        if (typeof message.maintainanceRate !== "number")
          return "maintainanceRate: number expected";
      }
      if (message.liquidateMarginRate != null && message.hasOwnProperty("liquidateMarginRate")) {
        if (typeof message.liquidateMarginRate !== "number")
          return "liquidateMarginRate: number expected";
      }
      if (message.totalDebt != null && message.hasOwnProperty("totalDebt")) {
        if (typeof message.totalDebt !== "number")
          return "totalDebt: number expected";
      }
      if (message.netProfit != null && message.hasOwnProperty("netProfit")) {
        if (typeof message.netProfit !== "number")
          return "netProfit: number expected";
      }
      if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice")) {
        if (typeof message.breakEvenPrice !== "number")
          return "breakEvenPrice: number expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.unrealizedTradingTaxFactor != null && message.hasOwnProperty("unrealizedTradingTaxFactor")) {
        if (typeof message.unrealizedTradingTaxFactor !== "number")
          return "unrealizedTradingTaxFactor: number expected";
      }
      if (message.cutLossPrice != null && message.hasOwnProperty("cutLossPrice")) {
        if (typeof message.cutLossPrice !== "number")
          return "cutLossPrice: number expected";
      }
      if (message.bankSecureRate != null && message.hasOwnProperty("bankSecureRate")) {
        if (typeof message.bankSecureRate !== "number")
          return "bankSecureRate: number expected";
      }
      if (message.vsdSecureRate != null && message.hasOwnProperty("vsdSecureRate")) {
        if (typeof message.vsdSecureRate !== "number")
          return "vsdSecureRate: number expected";
      }
      if (message.initialMarginRate != null && message.hasOwnProperty("initialMarginRate")) {
        if (typeof message.initialMarginRate !== "number")
          return "initialMarginRate: number expected";
      }
      if (message.totalInterestAndFeeWithoutClosingTax != null && message.hasOwnProperty("totalInterestAndFeeWithoutClosingTax")) {
        if (typeof message.totalInterestAndFeeWithoutClosingTax !== "number")
          return "totalInterestAndFeeWithoutClosingTax: number expected";
      }
      if (message.averageCostPrice != null && message.hasOwnProperty("averageCostPrice")) {
        if (typeof message.averageCostPrice !== "number")
          return "averageCostPrice: number expected";
      }
      if (message.totalInterestAndFee != null && message.hasOwnProperty("totalInterestAndFee")) {
        if (typeof message.totalInterestAndFee !== "number")
          return "totalInterestAndFee: number expected";
      }
      if (message.coInvestTaxRate != null && message.hasOwnProperty("coInvestTaxRate")) {
        if (typeof message.coInvestTaxRate !== "number")
          return "coInvestTaxRate: number expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.collectedInterestAndFee != null && message.hasOwnProperty("collectedInterestAndFee")) {
        if (typeof message.collectedInterestAndFee !== "number")
          return "collectedInterestAndFee: number expected";
      }
      if (message.unrealizedTotalTaxAndFee != null && message.hasOwnProperty("unrealizedTotalTaxAndFee")) {
        if (typeof message.unrealizedTotalTaxAndFee !== "number")
          return "unrealizedTotalTaxAndFee: number expected";
      }
      if (message.tradingFeeAmount != null && message.hasOwnProperty("tradingFeeAmount")) {
        if (typeof message.tradingFeeAmount !== "number")
          return "tradingFeeAmount: number expected";
      }
      if (message.lastRealizedProfit != null && message.hasOwnProperty("lastRealizedProfit")) {
        if (typeof message.lastRealizedProfit !== "number")
          return "lastRealizedProfit: number expected";
      }
      if (message.tradingTaxAmount != null && message.hasOwnProperty("tradingTaxAmount")) {
        if (typeof message.tradingTaxAmount !== "number")
          return "tradingTaxAmount: number expected";
      }
      if (message.closedPositionFeeAmount != null && message.hasOwnProperty("closedPositionFeeAmount")) {
        if (typeof message.closedPositionFeeAmount !== "number")
          return "closedPositionFeeAmount: number expected";
      }
      if (message.orderIds != null && message.hasOwnProperty("orderIds")) {
        if (!Array.isArray(message.orderIds))
          return "orderIds: array expected";
        for (let i = 0; i < message.orderIds.length; ++i)
          if (!$util.isInteger(message.orderIds[i]))
            return "orderIds: integer[] expected";
      }
      if (message.assetManagementOvernightFeeAmount != null && message.hasOwnProperty("assetManagementOvernightFeeAmount")) {
        if (typeof message.assetManagementOvernightFeeAmount !== "number")
          return "assetManagementOvernightFeeAmount: number expected";
      }
      if (message.netProfitRate != null && message.hasOwnProperty("netProfitRate")) {
        if (typeof message.netProfitRate !== "number")
          return "netProfitRate: number expected";
      }
      if (message.coInvestTax != null && message.hasOwnProperty("coInvestTax")) {
        if (typeof message.coInvestTax !== "number")
          return "coInvestTax: number expected";
      }
      if (message.accumulatedSecure != null && message.hasOwnProperty("accumulatedSecure")) {
        if (typeof message.accumulatedSecure !== "number")
          return "accumulatedSecure: number expected";
      }
      return null;
    };
    Deal.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Deal)
        return object;
      let message = new $root.models.Deal();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.bankId != null)
        message.bankId = object.bankId | 0;
      if (object.bankAccountId != null)
        message.bankAccountId = object.bankAccountId | 0;
      if (object.bankMarginPortfolioId != null)
        message.bankMarginPortfolioId = object.bankMarginPortfolioId | 0;
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.side != null)
        message.side = String(object.side);
      if (object.type != null)
        message.type = String(object.type);
      if (object.positionCostPrice != null)
        message.positionCostPrice = Number(object.positionCostPrice);
      if (object.stockClosePrice != null)
        message.stockClosePrice = Number(object.stockClosePrice);
      if (object.averageClosedPrice != null)
        message.averageClosedPrice = Number(object.averageClosedPrice);
      if (object.adjustedCostPrice != null)
        message.adjustedCostPrice = Number(object.adjustedCostPrice);
      if (object.openQuantity != null) {
        if ($util.Long)
          (message.openQuantity = $util.Long.fromValue(object.openQuantity)).unsigned = false;
        else if (typeof object.openQuantity === "string")
          message.openQuantity = parseInt(object.openQuantity, 10);
        else if (typeof object.openQuantity === "number")
          message.openQuantity = object.openQuantity;
        else if (typeof object.openQuantity === "object")
          message.openQuantity = new $util.LongBits(object.openQuantity.low >>> 0, object.openQuantity.high >>> 0).toNumber();
      }
      if (object.closedQuantity != null) {
        if ($util.Long)
          (message.closedQuantity = $util.Long.fromValue(object.closedQuantity)).unsigned = false;
        else if (typeof object.closedQuantity === "string")
          message.closedQuantity = parseInt(object.closedQuantity, 10);
        else if (typeof object.closedQuantity === "number")
          message.closedQuantity = object.closedQuantity;
        else if (typeof object.closedQuantity === "object")
          message.closedQuantity = new $util.LongBits(object.closedQuantity.low >>> 0, object.closedQuantity.high >>> 0).toNumber();
      }
      if (object.initialQuantity != null) {
        if ($util.Long)
          (message.initialQuantity = $util.Long.fromValue(object.initialQuantity)).unsigned = false;
        else if (typeof object.initialQuantity === "string")
          message.initialQuantity = parseInt(object.initialQuantity, 10);
        else if (typeof object.initialQuantity === "number")
          message.initialQuantity = object.initialQuantity;
        else if (typeof object.initialQuantity === "object")
          message.initialQuantity = new $util.LongBits(object.initialQuantity.low >>> 0, object.initialQuantity.high >>> 0).toNumber();
      }
      if (object.currentMarginRate != null)
        message.currentMarginRate = Number(object.currentMarginRate);
      if (object.loan != null)
        message.loan = Number(object.loan);
      if (object.secure != null)
        message.secure = Number(object.secure);
      if (object.interest != null)
        message.interest = Number(object.interest);
      if (object.positionRealizedProfit != null)
        message.positionRealizedProfit = Number(object.positionRealizedProfit);
      if (object.positionUnrealizedProfit != null)
        message.positionUnrealizedProfit = Number(object.positionUnrealizedProfit);
      if (object.positionType != null)
        message.positionType = object.positionType | 0;
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.Deal.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".models.Deal.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.marginRate != null)
        message.marginRate = Number(object.marginRate);
      if (object.maintainanceRate != null)
        message.maintainanceRate = Number(object.maintainanceRate);
      if (object.liquidateMarginRate != null)
        message.liquidateMarginRate = Number(object.liquidateMarginRate);
      if (object.totalDebt != null)
        message.totalDebt = Number(object.totalDebt);
      if (object.netProfit != null)
        message.netProfit = Number(object.netProfit);
      if (object.breakEvenPrice != null)
        message.breakEvenPrice = Number(object.breakEvenPrice);
      switch (object.status) {
        case "PENDING":
        case 0:
          message.status = 0;
          break;
        case "ACTIVE":
        case 1:
          message.status = 1;
          break;
        case "PENDING_TO_CLOSED":
        case 2:
          message.status = 2;
          break;
        case "CLOSED":
        case 3:
          message.status = 3;
          break;
      }
      if (object.unrealizedTradingTaxFactor != null)
        message.unrealizedTradingTaxFactor = Number(object.unrealizedTradingTaxFactor);
      if (object.cutLossPrice != null)
        message.cutLossPrice = Number(object.cutLossPrice);
      if (object.bankSecureRate != null)
        message.bankSecureRate = Number(object.bankSecureRate);
      if (object.vsdSecureRate != null)
        message.vsdSecureRate = Number(object.vsdSecureRate);
      if (object.initialMarginRate != null)
        message.initialMarginRate = Number(object.initialMarginRate);
      if (object.totalInterestAndFeeWithoutClosingTax != null)
        message.totalInterestAndFeeWithoutClosingTax = Number(object.totalInterestAndFeeWithoutClosingTax);
      if (object.averageCostPrice != null)
        message.averageCostPrice = Number(object.averageCostPrice);
      if (object.totalInterestAndFee != null)
        message.totalInterestAndFee = Number(object.totalInterestAndFee);
      if (object.coInvestTaxRate != null)
        message.coInvestTaxRate = Number(object.coInvestTaxRate);
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.collectedInterestAndFee != null)
        message.collectedInterestAndFee = Number(object.collectedInterestAndFee);
      if (object.unrealizedTotalTaxAndFee != null)
        message.unrealizedTotalTaxAndFee = Number(object.unrealizedTotalTaxAndFee);
      if (object.tradingFeeAmount != null)
        message.tradingFeeAmount = Number(object.tradingFeeAmount);
      if (object.lastRealizedProfit != null)
        message.lastRealizedProfit = Number(object.lastRealizedProfit);
      if (object.tradingTaxAmount != null)
        message.tradingTaxAmount = Number(object.tradingTaxAmount);
      if (object.closedPositionFeeAmount != null)
        message.closedPositionFeeAmount = Number(object.closedPositionFeeAmount);
      if (object.orderIds) {
        if (!Array.isArray(object.orderIds))
          throw TypeError(".models.Deal.orderIds: array expected");
        message.orderIds = [];
        for (let i = 0; i < object.orderIds.length; ++i)
          message.orderIds[i] = object.orderIds[i] | 0;
      }
      if (object.assetManagementOvernightFeeAmount != null)
        message.assetManagementOvernightFeeAmount = Number(object.assetManagementOvernightFeeAmount);
      if (object.netProfitRate != null)
        message.netProfitRate = Number(object.netProfitRate);
      if (object.coInvestTax != null)
        message.coInvestTax = Number(object.coInvestTax);
      if (object.accumulatedSecure != null)
        message.accumulatedSecure = Number(object.accumulatedSecure);
      return message;
    };
    Deal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.orderIds = [];
      if (options.defaults) {
        object.id = 0;
        object.investorId = 0;
        object.bankId = 0;
        object.bankAccountId = 0;
        object.bankMarginPortfolioId = 0;
        object.symbol = "";
        object.side = "";
        object.type = "";
        object.positionCostPrice = 0;
        object.stockClosePrice = 0;
        object.averageClosedPrice = 0;
        object.adjustedCostPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.openQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.openQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.closedQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.closedQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.initialQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.initialQuantity = options.longs === String ? "0" : 0;
        object.currentMarginRate = 0;
        object.loan = 0;
        object.secure = 0;
        object.interest = 0;
        object.positionRealizedProfit = 0;
        object.positionUnrealizedProfit = 0;
        object.positionType = 0;
        object.createdDate = null;
        object.modifiedDate = null;
        object.marginRate = 0;
        object.maintainanceRate = 0;
        object.liquidateMarginRate = 0;
        object.totalDebt = 0;
        object.netProfit = 0;
        object.breakEvenPrice = 0;
        object.status = options.enums === String ? "PENDING" : 0;
        object.unrealizedTradingTaxFactor = 0;
        object.cutLossPrice = 0;
        object.bankSecureRate = 0;
        object.vsdSecureRate = 0;
        object.initialMarginRate = 0;
        object.totalInterestAndFeeWithoutClosingTax = 0;
        object.averageCostPrice = 0;
        object.totalInterestAndFee = 0;
        object.coInvestTaxRate = 0;
        object.investorAccountId = 0;
        object.collectedInterestAndFee = 0;
        object.unrealizedTotalTaxAndFee = 0;
        object.tradingFeeAmount = 0;
        object.lastRealizedProfit = 0;
        object.tradingTaxAmount = 0;
        object.closedPositionFeeAmount = 0;
        object.assetManagementOvernightFeeAmount = 0;
        object.netProfitRate = 0;
        object.coInvestTax = 0;
        object.accumulatedSecure = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.bankId != null && message.hasOwnProperty("bankId"))
        object.bankId = message.bankId;
      if (message.bankAccountId != null && message.hasOwnProperty("bankAccountId"))
        object.bankAccountId = message.bankAccountId;
      if (message.bankMarginPortfolioId != null && message.hasOwnProperty("bankMarginPortfolioId"))
        object.bankMarginPortfolioId = message.bankMarginPortfolioId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.positionCostPrice != null && message.hasOwnProperty("positionCostPrice"))
        object.positionCostPrice = options.json && !isFinite(message.positionCostPrice) ? String(message.positionCostPrice) : message.positionCostPrice;
      if (message.stockClosePrice != null && message.hasOwnProperty("stockClosePrice"))
        object.stockClosePrice = options.json && !isFinite(message.stockClosePrice) ? String(message.stockClosePrice) : message.stockClosePrice;
      if (message.averageClosedPrice != null && message.hasOwnProperty("averageClosedPrice"))
        object.averageClosedPrice = options.json && !isFinite(message.averageClosedPrice) ? String(message.averageClosedPrice) : message.averageClosedPrice;
      if (message.adjustedCostPrice != null && message.hasOwnProperty("adjustedCostPrice"))
        object.adjustedCostPrice = options.json && !isFinite(message.adjustedCostPrice) ? String(message.adjustedCostPrice) : message.adjustedCostPrice;
      if (message.openQuantity != null && message.hasOwnProperty("openQuantity"))
        if (typeof message.openQuantity === "number")
          object.openQuantity = options.longs === String ? String(message.openQuantity) : message.openQuantity;
        else
          object.openQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.openQuantity) : options.longs === Number ? new $util.LongBits(message.openQuantity.low >>> 0, message.openQuantity.high >>> 0).toNumber() : message.openQuantity;
      if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity"))
        if (typeof message.closedQuantity === "number")
          object.closedQuantity = options.longs === String ? String(message.closedQuantity) : message.closedQuantity;
        else
          object.closedQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.closedQuantity) : options.longs === Number ? new $util.LongBits(message.closedQuantity.low >>> 0, message.closedQuantity.high >>> 0).toNumber() : message.closedQuantity;
      if (message.initialQuantity != null && message.hasOwnProperty("initialQuantity"))
        if (typeof message.initialQuantity === "number")
          object.initialQuantity = options.longs === String ? String(message.initialQuantity) : message.initialQuantity;
        else
          object.initialQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.initialQuantity) : options.longs === Number ? new $util.LongBits(message.initialQuantity.low >>> 0, message.initialQuantity.high >>> 0).toNumber() : message.initialQuantity;
      if (message.currentMarginRate != null && message.hasOwnProperty("currentMarginRate"))
        object.currentMarginRate = options.json && !isFinite(message.currentMarginRate) ? String(message.currentMarginRate) : message.currentMarginRate;
      if (message.loan != null && message.hasOwnProperty("loan"))
        object.loan = options.json && !isFinite(message.loan) ? String(message.loan) : message.loan;
      if (message.secure != null && message.hasOwnProperty("secure"))
        object.secure = options.json && !isFinite(message.secure) ? String(message.secure) : message.secure;
      if (message.interest != null && message.hasOwnProperty("interest"))
        object.interest = options.json && !isFinite(message.interest) ? String(message.interest) : message.interest;
      if (message.positionRealizedProfit != null && message.hasOwnProperty("positionRealizedProfit"))
        object.positionRealizedProfit = options.json && !isFinite(message.positionRealizedProfit) ? String(message.positionRealizedProfit) : message.positionRealizedProfit;
      if (message.positionUnrealizedProfit != null && message.hasOwnProperty("positionUnrealizedProfit"))
        object.positionUnrealizedProfit = options.json && !isFinite(message.positionUnrealizedProfit) ? String(message.positionUnrealizedProfit) : message.positionUnrealizedProfit;
      if (message.positionType != null && message.hasOwnProperty("positionType"))
        object.positionType = message.positionType;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.marginRate != null && message.hasOwnProperty("marginRate"))
        object.marginRate = options.json && !isFinite(message.marginRate) ? String(message.marginRate) : message.marginRate;
      if (message.maintainanceRate != null && message.hasOwnProperty("maintainanceRate"))
        object.maintainanceRate = options.json && !isFinite(message.maintainanceRate) ? String(message.maintainanceRate) : message.maintainanceRate;
      if (message.liquidateMarginRate != null && message.hasOwnProperty("liquidateMarginRate"))
        object.liquidateMarginRate = options.json && !isFinite(message.liquidateMarginRate) ? String(message.liquidateMarginRate) : message.liquidateMarginRate;
      if (message.totalDebt != null && message.hasOwnProperty("totalDebt"))
        object.totalDebt = options.json && !isFinite(message.totalDebt) ? String(message.totalDebt) : message.totalDebt;
      if (message.netProfit != null && message.hasOwnProperty("netProfit"))
        object.netProfit = options.json && !isFinite(message.netProfit) ? String(message.netProfit) : message.netProfit;
      if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice"))
        object.breakEvenPrice = options.json && !isFinite(message.breakEvenPrice) ? String(message.breakEvenPrice) : message.breakEvenPrice;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.models.Deal.Status[message.status] : message.status;
      if (message.unrealizedTradingTaxFactor != null && message.hasOwnProperty("unrealizedTradingTaxFactor"))
        object.unrealizedTradingTaxFactor = options.json && !isFinite(message.unrealizedTradingTaxFactor) ? String(message.unrealizedTradingTaxFactor) : message.unrealizedTradingTaxFactor;
      if (message.cutLossPrice != null && message.hasOwnProperty("cutLossPrice"))
        object.cutLossPrice = options.json && !isFinite(message.cutLossPrice) ? String(message.cutLossPrice) : message.cutLossPrice;
      if (message.bankSecureRate != null && message.hasOwnProperty("bankSecureRate"))
        object.bankSecureRate = options.json && !isFinite(message.bankSecureRate) ? String(message.bankSecureRate) : message.bankSecureRate;
      if (message.vsdSecureRate != null && message.hasOwnProperty("vsdSecureRate"))
        object.vsdSecureRate = options.json && !isFinite(message.vsdSecureRate) ? String(message.vsdSecureRate) : message.vsdSecureRate;
      if (message.initialMarginRate != null && message.hasOwnProperty("initialMarginRate"))
        object.initialMarginRate = options.json && !isFinite(message.initialMarginRate) ? String(message.initialMarginRate) : message.initialMarginRate;
      if (message.totalInterestAndFeeWithoutClosingTax != null && message.hasOwnProperty("totalInterestAndFeeWithoutClosingTax"))
        object.totalInterestAndFeeWithoutClosingTax = options.json && !isFinite(message.totalInterestAndFeeWithoutClosingTax) ? String(message.totalInterestAndFeeWithoutClosingTax) : message.totalInterestAndFeeWithoutClosingTax;
      if (message.averageCostPrice != null && message.hasOwnProperty("averageCostPrice"))
        object.averageCostPrice = options.json && !isFinite(message.averageCostPrice) ? String(message.averageCostPrice) : message.averageCostPrice;
      if (message.totalInterestAndFee != null && message.hasOwnProperty("totalInterestAndFee"))
        object.totalInterestAndFee = options.json && !isFinite(message.totalInterestAndFee) ? String(message.totalInterestAndFee) : message.totalInterestAndFee;
      if (message.coInvestTaxRate != null && message.hasOwnProperty("coInvestTaxRate"))
        object.coInvestTaxRate = options.json && !isFinite(message.coInvestTaxRate) ? String(message.coInvestTaxRate) : message.coInvestTaxRate;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.collectedInterestAndFee != null && message.hasOwnProperty("collectedInterestAndFee"))
        object.collectedInterestAndFee = options.json && !isFinite(message.collectedInterestAndFee) ? String(message.collectedInterestAndFee) : message.collectedInterestAndFee;
      if (message.unrealizedTotalTaxAndFee != null && message.hasOwnProperty("unrealizedTotalTaxAndFee"))
        object.unrealizedTotalTaxAndFee = options.json && !isFinite(message.unrealizedTotalTaxAndFee) ? String(message.unrealizedTotalTaxAndFee) : message.unrealizedTotalTaxAndFee;
      if (message.tradingFeeAmount != null && message.hasOwnProperty("tradingFeeAmount"))
        object.tradingFeeAmount = options.json && !isFinite(message.tradingFeeAmount) ? String(message.tradingFeeAmount) : message.tradingFeeAmount;
      if (message.lastRealizedProfit != null && message.hasOwnProperty("lastRealizedProfit"))
        object.lastRealizedProfit = options.json && !isFinite(message.lastRealizedProfit) ? String(message.lastRealizedProfit) : message.lastRealizedProfit;
      if (message.tradingTaxAmount != null && message.hasOwnProperty("tradingTaxAmount"))
        object.tradingTaxAmount = options.json && !isFinite(message.tradingTaxAmount) ? String(message.tradingTaxAmount) : message.tradingTaxAmount;
      if (message.closedPositionFeeAmount != null && message.hasOwnProperty("closedPositionFeeAmount"))
        object.closedPositionFeeAmount = options.json && !isFinite(message.closedPositionFeeAmount) ? String(message.closedPositionFeeAmount) : message.closedPositionFeeAmount;
      if (message.orderIds && message.orderIds.length) {
        object.orderIds = [];
        for (let j = 0; j < message.orderIds.length; ++j)
          object.orderIds[j] = message.orderIds[j];
      }
      if (message.assetManagementOvernightFeeAmount != null && message.hasOwnProperty("assetManagementOvernightFeeAmount"))
        object.assetManagementOvernightFeeAmount = options.json && !isFinite(message.assetManagementOvernightFeeAmount) ? String(message.assetManagementOvernightFeeAmount) : message.assetManagementOvernightFeeAmount;
      if (message.netProfitRate != null && message.hasOwnProperty("netProfitRate"))
        object.netProfitRate = options.json && !isFinite(message.netProfitRate) ? String(message.netProfitRate) : message.netProfitRate;
      if (message.coInvestTax != null && message.hasOwnProperty("coInvestTax"))
        object.coInvestTax = options.json && !isFinite(message.coInvestTax) ? String(message.coInvestTax) : message.coInvestTax;
      if (message.accumulatedSecure != null && message.hasOwnProperty("accumulatedSecure"))
        object.accumulatedSecure = options.json && !isFinite(message.accumulatedSecure) ? String(message.accumulatedSecure) : message.accumulatedSecure;
      return object;
    };
    Deal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    Deal.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "PENDING"] = 0;
      values[valuesById[1] = "ACTIVE"] = 1;
      values[valuesById[2] = "PENDING_TO_CLOSED"] = 2;
      values[valuesById[3] = "CLOSED"] = 3;
      return values;
    }();
    return Deal;
  }();
  models2.RiskConfig = function() {
    function RiskConfig(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    RiskConfig.prototype.id = 0;
    RiskConfig.prototype.investorId = 0;
    RiskConfig.prototype.cutLossRate = 0;
    RiskConfig.prototype.trailingEnabled = false;
    RiskConfig.prototype.investorAccountId = 0;
    RiskConfig.prototype.defaultTakeProfitEnabled = false;
    RiskConfig.prototype.defaultTakeProfitRate = 0;
    RiskConfig.prototype.defaultTakeProfitPriceDelta = 0;
    RiskConfig.prototype.defaultTakeProfitOrderDelta = 0;
    RiskConfig.prototype.defaultTakeProfitOrderStrategy = "";
    RiskConfig.prototype.defaultTakeProfitType = "";
    RiskConfig.create = function create(properties) {
      return new RiskConfig(properties);
    };
    RiskConfig.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(16).int32(message.investorId);
      if (message.cutLossRate != null && Object.hasOwnProperty.call(message, "cutLossRate"))
        writer.uint32(25).double(message.cutLossRate);
      if (message.trailingEnabled != null && Object.hasOwnProperty.call(message, "trailingEnabled"))
        writer.uint32(32).bool(message.trailingEnabled);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(40).int32(message.investorAccountId);
      if (message.defaultTakeProfitEnabled != null && Object.hasOwnProperty.call(message, "defaultTakeProfitEnabled"))
        writer.uint32(48).bool(message.defaultTakeProfitEnabled);
      if (message.defaultTakeProfitRate != null && Object.hasOwnProperty.call(message, "defaultTakeProfitRate"))
        writer.uint32(57).double(message.defaultTakeProfitRate);
      if (message.defaultTakeProfitPriceDelta != null && Object.hasOwnProperty.call(message, "defaultTakeProfitPriceDelta"))
        writer.uint32(65).double(message.defaultTakeProfitPriceDelta);
      if (message.defaultTakeProfitOrderDelta != null && Object.hasOwnProperty.call(message, "defaultTakeProfitOrderDelta"))
        writer.uint32(73).double(message.defaultTakeProfitOrderDelta);
      if (message.defaultTakeProfitOrderStrategy != null && Object.hasOwnProperty.call(message, "defaultTakeProfitOrderStrategy"))
        writer.uint32(82).string(message.defaultTakeProfitOrderStrategy);
      if (message.defaultTakeProfitType != null && Object.hasOwnProperty.call(message, "defaultTakeProfitType"))
        writer.uint32(90).string(message.defaultTakeProfitType);
      return writer;
    };
    RiskConfig.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    RiskConfig.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.RiskConfig();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.investorId = reader.int32();
            break;
          case 3:
            message.cutLossRate = reader.double();
            break;
          case 4:
            message.trailingEnabled = reader.bool();
            break;
          case 5:
            message.investorAccountId = reader.int32();
            break;
          case 6:
            message.defaultTakeProfitEnabled = reader.bool();
            break;
          case 7:
            message.defaultTakeProfitRate = reader.double();
            break;
          case 8:
            message.defaultTakeProfitPriceDelta = reader.double();
            break;
          case 9:
            message.defaultTakeProfitOrderDelta = reader.double();
            break;
          case 10:
            message.defaultTakeProfitOrderStrategy = reader.string();
            break;
          case 11:
            message.defaultTakeProfitType = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    RiskConfig.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    RiskConfig.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.cutLossRate != null && message.hasOwnProperty("cutLossRate")) {
        if (typeof message.cutLossRate !== "number")
          return "cutLossRate: number expected";
      }
      if (message.trailingEnabled != null && message.hasOwnProperty("trailingEnabled")) {
        if (typeof message.trailingEnabled !== "boolean")
          return "trailingEnabled: boolean expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.defaultTakeProfitEnabled != null && message.hasOwnProperty("defaultTakeProfitEnabled")) {
        if (typeof message.defaultTakeProfitEnabled !== "boolean")
          return "defaultTakeProfitEnabled: boolean expected";
      }
      if (message.defaultTakeProfitRate != null && message.hasOwnProperty("defaultTakeProfitRate")) {
        if (typeof message.defaultTakeProfitRate !== "number")
          return "defaultTakeProfitRate: number expected";
      }
      if (message.defaultTakeProfitPriceDelta != null && message.hasOwnProperty("defaultTakeProfitPriceDelta")) {
        if (typeof message.defaultTakeProfitPriceDelta !== "number")
          return "defaultTakeProfitPriceDelta: number expected";
      }
      if (message.defaultTakeProfitOrderDelta != null && message.hasOwnProperty("defaultTakeProfitOrderDelta")) {
        if (typeof message.defaultTakeProfitOrderDelta !== "number")
          return "defaultTakeProfitOrderDelta: number expected";
      }
      if (message.defaultTakeProfitOrderStrategy != null && message.hasOwnProperty("defaultTakeProfitOrderStrategy")) {
        if (!$util.isString(message.defaultTakeProfitOrderStrategy))
          return "defaultTakeProfitOrderStrategy: string expected";
      }
      if (message.defaultTakeProfitType != null && message.hasOwnProperty("defaultTakeProfitType")) {
        if (!$util.isString(message.defaultTakeProfitType))
          return "defaultTakeProfitType: string expected";
      }
      return null;
    };
    RiskConfig.fromObject = function fromObject(object) {
      if (object instanceof $root.models.RiskConfig)
        return object;
      let message = new $root.models.RiskConfig();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.cutLossRate != null)
        message.cutLossRate = Number(object.cutLossRate);
      if (object.trailingEnabled != null)
        message.trailingEnabled = Boolean(object.trailingEnabled);
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.defaultTakeProfitEnabled != null)
        message.defaultTakeProfitEnabled = Boolean(object.defaultTakeProfitEnabled);
      if (object.defaultTakeProfitRate != null)
        message.defaultTakeProfitRate = Number(object.defaultTakeProfitRate);
      if (object.defaultTakeProfitPriceDelta != null)
        message.defaultTakeProfitPriceDelta = Number(object.defaultTakeProfitPriceDelta);
      if (object.defaultTakeProfitOrderDelta != null)
        message.defaultTakeProfitOrderDelta = Number(object.defaultTakeProfitOrderDelta);
      if (object.defaultTakeProfitOrderStrategy != null)
        message.defaultTakeProfitOrderStrategy = String(object.defaultTakeProfitOrderStrategy);
      if (object.defaultTakeProfitType != null)
        message.defaultTakeProfitType = String(object.defaultTakeProfitType);
      return message;
    };
    RiskConfig.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.investorId = 0;
        object.cutLossRate = 0;
        object.trailingEnabled = false;
        object.investorAccountId = 0;
        object.defaultTakeProfitEnabled = false;
        object.defaultTakeProfitRate = 0;
        object.defaultTakeProfitPriceDelta = 0;
        object.defaultTakeProfitOrderDelta = 0;
        object.defaultTakeProfitOrderStrategy = "";
        object.defaultTakeProfitType = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.cutLossRate != null && message.hasOwnProperty("cutLossRate"))
        object.cutLossRate = options.json && !isFinite(message.cutLossRate) ? String(message.cutLossRate) : message.cutLossRate;
      if (message.trailingEnabled != null && message.hasOwnProperty("trailingEnabled"))
        object.trailingEnabled = message.trailingEnabled;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.defaultTakeProfitEnabled != null && message.hasOwnProperty("defaultTakeProfitEnabled"))
        object.defaultTakeProfitEnabled = message.defaultTakeProfitEnabled;
      if (message.defaultTakeProfitRate != null && message.hasOwnProperty("defaultTakeProfitRate"))
        object.defaultTakeProfitRate = options.json && !isFinite(message.defaultTakeProfitRate) ? String(message.defaultTakeProfitRate) : message.defaultTakeProfitRate;
      if (message.defaultTakeProfitPriceDelta != null && message.hasOwnProperty("defaultTakeProfitPriceDelta"))
        object.defaultTakeProfitPriceDelta = options.json && !isFinite(message.defaultTakeProfitPriceDelta) ? String(message.defaultTakeProfitPriceDelta) : message.defaultTakeProfitPriceDelta;
      if (message.defaultTakeProfitOrderDelta != null && message.hasOwnProperty("defaultTakeProfitOrderDelta"))
        object.defaultTakeProfitOrderDelta = options.json && !isFinite(message.defaultTakeProfitOrderDelta) ? String(message.defaultTakeProfitOrderDelta) : message.defaultTakeProfitOrderDelta;
      if (message.defaultTakeProfitOrderStrategy != null && message.hasOwnProperty("defaultTakeProfitOrderStrategy"))
        object.defaultTakeProfitOrderStrategy = message.defaultTakeProfitOrderStrategy;
      if (message.defaultTakeProfitType != null && message.hasOwnProperty("defaultTakeProfitType"))
        object.defaultTakeProfitType = message.defaultTakeProfitType;
      return object;
    };
    RiskConfig.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return RiskConfig;
  }();
  models2.TA = function() {
    function TA(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    TA.create = function create(properties) {
      return new TA(properties);
    };
    TA.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      return writer;
    };
    TA.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    TA.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.TA();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    TA.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    TA.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      return null;
    };
    TA.fromObject = function fromObject(object) {
      if (object instanceof $root.models.TA)
        return object;
      return new $root.models.TA();
    };
    TA.toObject = function toObject() {
      return {};
    };
    TA.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    TA.Details = function() {
      function Details(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Details.prototype.ma = null;
      Details.create = function create(properties) {
        return new Details(properties);
      };
      Details.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.ma != null && Object.hasOwnProperty.call(message, "ma"))
          $root.models.TA.Details.MA.encode(message.ma, writer.uint32(10).fork()).ldelim();
        return writer;
      };
      Details.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Details.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.TA.Details();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.ma = $root.models.TA.Details.MA.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Details.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Details.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.ma != null && message.hasOwnProperty("ma")) {
          let error = $root.models.TA.Details.MA.verify(message.ma);
          if (error)
            return "ma." + error;
        }
        return null;
      };
      Details.fromObject = function fromObject(object) {
        if (object instanceof $root.models.TA.Details)
          return object;
        let message = new $root.models.TA.Details();
        if (object.ma != null) {
          if (typeof object.ma !== "object")
            throw TypeError(".models.TA.Details.ma: object expected");
          message.ma = $root.models.TA.Details.MA.fromObject(object.ma);
        }
        return message;
      };
      Details.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults)
          object.ma = null;
        if (message.ma != null && message.hasOwnProperty("ma"))
          object.ma = $root.models.TA.Details.MA.toObject(message.ma, options);
        return object;
      };
      Details.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      Details.MA = function() {
        function MA(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        MA.prototype.EMA5 = "";
        MA.prototype.EMA10 = "";
        MA.prototype.EMA20 = "";
        MA.prototype.EMA50 = "";
        MA.prototype.EMA100 = "";
        MA.prototype.EMA200 = "";
        MA.prototype.MA5 = "";
        MA.prototype.MA10 = "";
        MA.prototype.MA20 = "";
        MA.prototype.MA50 = "";
        MA.prototype.MA100 = "";
        MA.prototype.MA200 = "";
        MA.create = function create(properties) {
          return new MA(properties);
        };
        MA.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.EMA5 != null && Object.hasOwnProperty.call(message, "EMA5"))
            writer.uint32(10).string(message.EMA5);
          if (message.EMA10 != null && Object.hasOwnProperty.call(message, "EMA10"))
            writer.uint32(18).string(message.EMA10);
          if (message.EMA20 != null && Object.hasOwnProperty.call(message, "EMA20"))
            writer.uint32(26).string(message.EMA20);
          if (message.EMA50 != null && Object.hasOwnProperty.call(message, "EMA50"))
            writer.uint32(34).string(message.EMA50);
          if (message.EMA100 != null && Object.hasOwnProperty.call(message, "EMA100"))
            writer.uint32(42).string(message.EMA100);
          if (message.EMA200 != null && Object.hasOwnProperty.call(message, "EMA200"))
            writer.uint32(50).string(message.EMA200);
          if (message.MA5 != null && Object.hasOwnProperty.call(message, "MA5"))
            writer.uint32(58).string(message.MA5);
          if (message.MA10 != null && Object.hasOwnProperty.call(message, "MA10"))
            writer.uint32(66).string(message.MA10);
          if (message.MA20 != null && Object.hasOwnProperty.call(message, "MA20"))
            writer.uint32(74).string(message.MA20);
          if (message.MA50 != null && Object.hasOwnProperty.call(message, "MA50"))
            writer.uint32(82).string(message.MA50);
          if (message.MA100 != null && Object.hasOwnProperty.call(message, "MA100"))
            writer.uint32(90).string(message.MA100);
          if (message.MA200 != null && Object.hasOwnProperty.call(message, "MA200"))
            writer.uint32(98).string(message.MA200);
          return writer;
        };
        MA.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        MA.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.TA.Details.MA();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.EMA5 = reader.string();
                break;
              case 2:
                message.EMA10 = reader.string();
                break;
              case 3:
                message.EMA20 = reader.string();
                break;
              case 4:
                message.EMA50 = reader.string();
                break;
              case 5:
                message.EMA100 = reader.string();
                break;
              case 6:
                message.EMA200 = reader.string();
                break;
              case 7:
                message.MA5 = reader.string();
                break;
              case 8:
                message.MA10 = reader.string();
                break;
              case 9:
                message.MA20 = reader.string();
                break;
              case 10:
                message.MA50 = reader.string();
                break;
              case 11:
                message.MA100 = reader.string();
                break;
              case 12:
                message.MA200 = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        MA.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        MA.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.EMA5 != null && message.hasOwnProperty("EMA5")) {
            if (!$util.isString(message.EMA5))
              return "EMA5: string expected";
          }
          if (message.EMA10 != null && message.hasOwnProperty("EMA10")) {
            if (!$util.isString(message.EMA10))
              return "EMA10: string expected";
          }
          if (message.EMA20 != null && message.hasOwnProperty("EMA20")) {
            if (!$util.isString(message.EMA20))
              return "EMA20: string expected";
          }
          if (message.EMA50 != null && message.hasOwnProperty("EMA50")) {
            if (!$util.isString(message.EMA50))
              return "EMA50: string expected";
          }
          if (message.EMA100 != null && message.hasOwnProperty("EMA100")) {
            if (!$util.isString(message.EMA100))
              return "EMA100: string expected";
          }
          if (message.EMA200 != null && message.hasOwnProperty("EMA200")) {
            if (!$util.isString(message.EMA200))
              return "EMA200: string expected";
          }
          if (message.MA5 != null && message.hasOwnProperty("MA5")) {
            if (!$util.isString(message.MA5))
              return "MA5: string expected";
          }
          if (message.MA10 != null && message.hasOwnProperty("MA10")) {
            if (!$util.isString(message.MA10))
              return "MA10: string expected";
          }
          if (message.MA20 != null && message.hasOwnProperty("MA20")) {
            if (!$util.isString(message.MA20))
              return "MA20: string expected";
          }
          if (message.MA50 != null && message.hasOwnProperty("MA50")) {
            if (!$util.isString(message.MA50))
              return "MA50: string expected";
          }
          if (message.MA100 != null && message.hasOwnProperty("MA100")) {
            if (!$util.isString(message.MA100))
              return "MA100: string expected";
          }
          if (message.MA200 != null && message.hasOwnProperty("MA200")) {
            if (!$util.isString(message.MA200))
              return "MA200: string expected";
          }
          return null;
        };
        MA.fromObject = function fromObject(object) {
          if (object instanceof $root.models.TA.Details.MA)
            return object;
          let message = new $root.models.TA.Details.MA();
          if (object.EMA5 != null)
            message.EMA5 = String(object.EMA5);
          if (object.EMA10 != null)
            message.EMA10 = String(object.EMA10);
          if (object.EMA20 != null)
            message.EMA20 = String(object.EMA20);
          if (object.EMA50 != null)
            message.EMA50 = String(object.EMA50);
          if (object.EMA100 != null)
            message.EMA100 = String(object.EMA100);
          if (object.EMA200 != null)
            message.EMA200 = String(object.EMA200);
          if (object.MA5 != null)
            message.MA5 = String(object.MA5);
          if (object.MA10 != null)
            message.MA10 = String(object.MA10);
          if (object.MA20 != null)
            message.MA20 = String(object.MA20);
          if (object.MA50 != null)
            message.MA50 = String(object.MA50);
          if (object.MA100 != null)
            message.MA100 = String(object.MA100);
          if (object.MA200 != null)
            message.MA200 = String(object.MA200);
          return message;
        };
        MA.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.EMA5 = "";
            object.EMA10 = "";
            object.EMA20 = "";
            object.EMA50 = "";
            object.EMA100 = "";
            object.EMA200 = "";
            object.MA5 = "";
            object.MA10 = "";
            object.MA20 = "";
            object.MA50 = "";
            object.MA100 = "";
            object.MA200 = "";
          }
          if (message.EMA5 != null && message.hasOwnProperty("EMA5"))
            object.EMA5 = message.EMA5;
          if (message.EMA10 != null && message.hasOwnProperty("EMA10"))
            object.EMA10 = message.EMA10;
          if (message.EMA20 != null && message.hasOwnProperty("EMA20"))
            object.EMA20 = message.EMA20;
          if (message.EMA50 != null && message.hasOwnProperty("EMA50"))
            object.EMA50 = message.EMA50;
          if (message.EMA100 != null && message.hasOwnProperty("EMA100"))
            object.EMA100 = message.EMA100;
          if (message.EMA200 != null && message.hasOwnProperty("EMA200"))
            object.EMA200 = message.EMA200;
          if (message.MA5 != null && message.hasOwnProperty("MA5"))
            object.MA5 = message.MA5;
          if (message.MA10 != null && message.hasOwnProperty("MA10"))
            object.MA10 = message.MA10;
          if (message.MA20 != null && message.hasOwnProperty("MA20"))
            object.MA20 = message.MA20;
          if (message.MA50 != null && message.hasOwnProperty("MA50"))
            object.MA50 = message.MA50;
          if (message.MA100 != null && message.hasOwnProperty("MA100"))
            object.MA100 = message.MA100;
          if (message.MA200 != null && message.hasOwnProperty("MA200"))
            object.MA200 = message.MA200;
          return object;
        };
        MA.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return MA;
      }();
      return Details;
    }();
    TA.Indicator = function() {
      function Indicator(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Indicator.prototype.EMA5 = 0;
      Indicator.prototype.EMA10 = 0;
      Indicator.prototype.EMA20 = 0;
      Indicator.prototype.EMA50 = 0;
      Indicator.prototype.EMA100 = 0;
      Indicator.prototype.EMA200 = 0;
      Indicator.prototype.MA5 = 0;
      Indicator.prototype.MA10 = 0;
      Indicator.prototype.MA20 = 0;
      Indicator.prototype.MA50 = 0;
      Indicator.prototype.MA100 = 0;
      Indicator.prototype.MA200 = 0;
      Indicator.prototype.ADX_14 = 0;
      Indicator.prototype.ATR_14 = 0;
      Indicator.prototype.CCI_14 = 0;
      Indicator.prototype.MACD_12_26 = 0;
      Indicator.prototype.MACD_Signal_Line = 0;
      Indicator.prototype.MINUS_DI = 0;
      Indicator.prototype.MINUS_DM = 0;
      Indicator.prototype.PLUS_DI = 0;
      Indicator.prototype.PLUS_DM = 0;
      Indicator.prototype.ROC = 0;
      Indicator.prototype.RSI_14 = 0;
      Indicator.prototype.STOCH_9_6_D = 0;
      Indicator.prototype.STOCH_9_6_K = 0;
      Indicator.prototype.Ultimate_Oscillator = 0;
      Indicator.prototype.William_R = 0;
      Indicator.prototype.currentPrice = 0;
      Indicator.create = function create(properties) {
        return new Indicator(properties);
      };
      Indicator.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.EMA5 != null && Object.hasOwnProperty.call(message, "EMA5"))
          writer.uint32(13).float(message.EMA5);
        if (message.EMA10 != null && Object.hasOwnProperty.call(message, "EMA10"))
          writer.uint32(21).float(message.EMA10);
        if (message.EMA20 != null && Object.hasOwnProperty.call(message, "EMA20"))
          writer.uint32(29).float(message.EMA20);
        if (message.EMA50 != null && Object.hasOwnProperty.call(message, "EMA50"))
          writer.uint32(37).float(message.EMA50);
        if (message.EMA100 != null && Object.hasOwnProperty.call(message, "EMA100"))
          writer.uint32(45).float(message.EMA100);
        if (message.EMA200 != null && Object.hasOwnProperty.call(message, "EMA200"))
          writer.uint32(53).float(message.EMA200);
        if (message.MA5 != null && Object.hasOwnProperty.call(message, "MA5"))
          writer.uint32(61).float(message.MA5);
        if (message.MA10 != null && Object.hasOwnProperty.call(message, "MA10"))
          writer.uint32(69).float(message.MA10);
        if (message.MA20 != null && Object.hasOwnProperty.call(message, "MA20"))
          writer.uint32(77).float(message.MA20);
        if (message.MA50 != null && Object.hasOwnProperty.call(message, "MA50"))
          writer.uint32(85).float(message.MA50);
        if (message.MA100 != null && Object.hasOwnProperty.call(message, "MA100"))
          writer.uint32(93).float(message.MA100);
        if (message.MA200 != null && Object.hasOwnProperty.call(message, "MA200"))
          writer.uint32(101).float(message.MA200);
        if (message.ADX_14 != null && Object.hasOwnProperty.call(message, "ADX_14"))
          writer.uint32(109).float(message.ADX_14);
        if (message.ATR_14 != null && Object.hasOwnProperty.call(message, "ATR_14"))
          writer.uint32(117).float(message.ATR_14);
        if (message.CCI_14 != null && Object.hasOwnProperty.call(message, "CCI_14"))
          writer.uint32(125).float(message.CCI_14);
        if (message.MACD_12_26 != null && Object.hasOwnProperty.call(message, "MACD_12_26"))
          writer.uint32(133).float(message.MACD_12_26);
        if (message.MACD_Signal_Line != null && Object.hasOwnProperty.call(message, "MACD_Signal_Line"))
          writer.uint32(141).float(message.MACD_Signal_Line);
        if (message.MINUS_DI != null && Object.hasOwnProperty.call(message, "MINUS_DI"))
          writer.uint32(149).float(message.MINUS_DI);
        if (message.MINUS_DM != null && Object.hasOwnProperty.call(message, "MINUS_DM"))
          writer.uint32(157).float(message.MINUS_DM);
        if (message.PLUS_DI != null && Object.hasOwnProperty.call(message, "PLUS_DI"))
          writer.uint32(165).float(message.PLUS_DI);
        if (message.PLUS_DM != null && Object.hasOwnProperty.call(message, "PLUS_DM"))
          writer.uint32(173).float(message.PLUS_DM);
        if (message.ROC != null && Object.hasOwnProperty.call(message, "ROC"))
          writer.uint32(181).float(message.ROC);
        if (message.RSI_14 != null && Object.hasOwnProperty.call(message, "RSI_14"))
          writer.uint32(189).float(message.RSI_14);
        if (message.STOCH_9_6_D != null && Object.hasOwnProperty.call(message, "STOCH_9_6_D"))
          writer.uint32(197).float(message.STOCH_9_6_D);
        if (message.STOCH_9_6_K != null && Object.hasOwnProperty.call(message, "STOCH_9_6_K"))
          writer.uint32(205).float(message.STOCH_9_6_K);
        if (message.Ultimate_Oscillator != null && Object.hasOwnProperty.call(message, "Ultimate_Oscillator"))
          writer.uint32(221).float(message.Ultimate_Oscillator);
        if (message.William_R != null && Object.hasOwnProperty.call(message, "William_R"))
          writer.uint32(229).float(message.William_R);
        if (message.currentPrice != null && Object.hasOwnProperty.call(message, "currentPrice"))
          writer.uint32(237).float(message.currentPrice);
        return writer;
      };
      Indicator.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Indicator.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.TA.Indicator();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.EMA5 = reader.float();
              break;
            case 2:
              message.EMA10 = reader.float();
              break;
            case 3:
              message.EMA20 = reader.float();
              break;
            case 4:
              message.EMA50 = reader.float();
              break;
            case 5:
              message.EMA100 = reader.float();
              break;
            case 6:
              message.EMA200 = reader.float();
              break;
            case 7:
              message.MA5 = reader.float();
              break;
            case 8:
              message.MA10 = reader.float();
              break;
            case 9:
              message.MA20 = reader.float();
              break;
            case 10:
              message.MA50 = reader.float();
              break;
            case 11:
              message.MA100 = reader.float();
              break;
            case 12:
              message.MA200 = reader.float();
              break;
            case 13:
              message.ADX_14 = reader.float();
              break;
            case 14:
              message.ATR_14 = reader.float();
              break;
            case 15:
              message.CCI_14 = reader.float();
              break;
            case 16:
              message.MACD_12_26 = reader.float();
              break;
            case 17:
              message.MACD_Signal_Line = reader.float();
              break;
            case 18:
              message.MINUS_DI = reader.float();
              break;
            case 19:
              message.MINUS_DM = reader.float();
              break;
            case 20:
              message.PLUS_DI = reader.float();
              break;
            case 21:
              message.PLUS_DM = reader.float();
              break;
            case 22:
              message.ROC = reader.float();
              break;
            case 23:
              message.RSI_14 = reader.float();
              break;
            case 24:
              message.STOCH_9_6_D = reader.float();
              break;
            case 25:
              message.STOCH_9_6_K = reader.float();
              break;
            case 27:
              message.Ultimate_Oscillator = reader.float();
              break;
            case 28:
              message.William_R = reader.float();
              break;
            case 29:
              message.currentPrice = reader.float();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Indicator.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Indicator.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.EMA5 != null && message.hasOwnProperty("EMA5")) {
          if (typeof message.EMA5 !== "number")
            return "EMA5: number expected";
        }
        if (message.EMA10 != null && message.hasOwnProperty("EMA10")) {
          if (typeof message.EMA10 !== "number")
            return "EMA10: number expected";
        }
        if (message.EMA20 != null && message.hasOwnProperty("EMA20")) {
          if (typeof message.EMA20 !== "number")
            return "EMA20: number expected";
        }
        if (message.EMA50 != null && message.hasOwnProperty("EMA50")) {
          if (typeof message.EMA50 !== "number")
            return "EMA50: number expected";
        }
        if (message.EMA100 != null && message.hasOwnProperty("EMA100")) {
          if (typeof message.EMA100 !== "number")
            return "EMA100: number expected";
        }
        if (message.EMA200 != null && message.hasOwnProperty("EMA200")) {
          if (typeof message.EMA200 !== "number")
            return "EMA200: number expected";
        }
        if (message.MA5 != null && message.hasOwnProperty("MA5")) {
          if (typeof message.MA5 !== "number")
            return "MA5: number expected";
        }
        if (message.MA10 != null && message.hasOwnProperty("MA10")) {
          if (typeof message.MA10 !== "number")
            return "MA10: number expected";
        }
        if (message.MA20 != null && message.hasOwnProperty("MA20")) {
          if (typeof message.MA20 !== "number")
            return "MA20: number expected";
        }
        if (message.MA50 != null && message.hasOwnProperty("MA50")) {
          if (typeof message.MA50 !== "number")
            return "MA50: number expected";
        }
        if (message.MA100 != null && message.hasOwnProperty("MA100")) {
          if (typeof message.MA100 !== "number")
            return "MA100: number expected";
        }
        if (message.MA200 != null && message.hasOwnProperty("MA200")) {
          if (typeof message.MA200 !== "number")
            return "MA200: number expected";
        }
        if (message.ADX_14 != null && message.hasOwnProperty("ADX_14")) {
          if (typeof message.ADX_14 !== "number")
            return "ADX_14: number expected";
        }
        if (message.ATR_14 != null && message.hasOwnProperty("ATR_14")) {
          if (typeof message.ATR_14 !== "number")
            return "ATR_14: number expected";
        }
        if (message.CCI_14 != null && message.hasOwnProperty("CCI_14")) {
          if (typeof message.CCI_14 !== "number")
            return "CCI_14: number expected";
        }
        if (message.MACD_12_26 != null && message.hasOwnProperty("MACD_12_26")) {
          if (typeof message.MACD_12_26 !== "number")
            return "MACD_12_26: number expected";
        }
        if (message.MACD_Signal_Line != null && message.hasOwnProperty("MACD_Signal_Line")) {
          if (typeof message.MACD_Signal_Line !== "number")
            return "MACD_Signal_Line: number expected";
        }
        if (message.MINUS_DI != null && message.hasOwnProperty("MINUS_DI")) {
          if (typeof message.MINUS_DI !== "number")
            return "MINUS_DI: number expected";
        }
        if (message.MINUS_DM != null && message.hasOwnProperty("MINUS_DM")) {
          if (typeof message.MINUS_DM !== "number")
            return "MINUS_DM: number expected";
        }
        if (message.PLUS_DI != null && message.hasOwnProperty("PLUS_DI")) {
          if (typeof message.PLUS_DI !== "number")
            return "PLUS_DI: number expected";
        }
        if (message.PLUS_DM != null && message.hasOwnProperty("PLUS_DM")) {
          if (typeof message.PLUS_DM !== "number")
            return "PLUS_DM: number expected";
        }
        if (message.ROC != null && message.hasOwnProperty("ROC")) {
          if (typeof message.ROC !== "number")
            return "ROC: number expected";
        }
        if (message.RSI_14 != null && message.hasOwnProperty("RSI_14")) {
          if (typeof message.RSI_14 !== "number")
            return "RSI_14: number expected";
        }
        if (message.STOCH_9_6_D != null && message.hasOwnProperty("STOCH_9_6_D")) {
          if (typeof message.STOCH_9_6_D !== "number")
            return "STOCH_9_6_D: number expected";
        }
        if (message.STOCH_9_6_K != null && message.hasOwnProperty("STOCH_9_6_K")) {
          if (typeof message.STOCH_9_6_K !== "number")
            return "STOCH_9_6_K: number expected";
        }
        if (message.Ultimate_Oscillator != null && message.hasOwnProperty("Ultimate_Oscillator")) {
          if (typeof message.Ultimate_Oscillator !== "number")
            return "Ultimate_Oscillator: number expected";
        }
        if (message.William_R != null && message.hasOwnProperty("William_R")) {
          if (typeof message.William_R !== "number")
            return "William_R: number expected";
        }
        if (message.currentPrice != null && message.hasOwnProperty("currentPrice")) {
          if (typeof message.currentPrice !== "number")
            return "currentPrice: number expected";
        }
        return null;
      };
      Indicator.fromObject = function fromObject(object) {
        if (object instanceof $root.models.TA.Indicator)
          return object;
        let message = new $root.models.TA.Indicator();
        if (object.EMA5 != null)
          message.EMA5 = Number(object.EMA5);
        if (object.EMA10 != null)
          message.EMA10 = Number(object.EMA10);
        if (object.EMA20 != null)
          message.EMA20 = Number(object.EMA20);
        if (object.EMA50 != null)
          message.EMA50 = Number(object.EMA50);
        if (object.EMA100 != null)
          message.EMA100 = Number(object.EMA100);
        if (object.EMA200 != null)
          message.EMA200 = Number(object.EMA200);
        if (object.MA5 != null)
          message.MA5 = Number(object.MA5);
        if (object.MA10 != null)
          message.MA10 = Number(object.MA10);
        if (object.MA20 != null)
          message.MA20 = Number(object.MA20);
        if (object.MA50 != null)
          message.MA50 = Number(object.MA50);
        if (object.MA100 != null)
          message.MA100 = Number(object.MA100);
        if (object.MA200 != null)
          message.MA200 = Number(object.MA200);
        if (object.ADX_14 != null)
          message.ADX_14 = Number(object.ADX_14);
        if (object.ATR_14 != null)
          message.ATR_14 = Number(object.ATR_14);
        if (object.CCI_14 != null)
          message.CCI_14 = Number(object.CCI_14);
        if (object.MACD_12_26 != null)
          message.MACD_12_26 = Number(object.MACD_12_26);
        if (object.MACD_Signal_Line != null)
          message.MACD_Signal_Line = Number(object.MACD_Signal_Line);
        if (object.MINUS_DI != null)
          message.MINUS_DI = Number(object.MINUS_DI);
        if (object.MINUS_DM != null)
          message.MINUS_DM = Number(object.MINUS_DM);
        if (object.PLUS_DI != null)
          message.PLUS_DI = Number(object.PLUS_DI);
        if (object.PLUS_DM != null)
          message.PLUS_DM = Number(object.PLUS_DM);
        if (object.ROC != null)
          message.ROC = Number(object.ROC);
        if (object.RSI_14 != null)
          message.RSI_14 = Number(object.RSI_14);
        if (object.STOCH_9_6_D != null)
          message.STOCH_9_6_D = Number(object.STOCH_9_6_D);
        if (object.STOCH_9_6_K != null)
          message.STOCH_9_6_K = Number(object.STOCH_9_6_K);
        if (object.Ultimate_Oscillator != null)
          message.Ultimate_Oscillator = Number(object.Ultimate_Oscillator);
        if (object.William_R != null)
          message.William_R = Number(object.William_R);
        if (object.currentPrice != null)
          message.currentPrice = Number(object.currentPrice);
        return message;
      };
      Indicator.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.EMA5 = 0;
          object.EMA10 = 0;
          object.EMA20 = 0;
          object.EMA50 = 0;
          object.EMA100 = 0;
          object.EMA200 = 0;
          object.MA5 = 0;
          object.MA10 = 0;
          object.MA20 = 0;
          object.MA50 = 0;
          object.MA100 = 0;
          object.MA200 = 0;
          object.ADX_14 = 0;
          object.ATR_14 = 0;
          object.CCI_14 = 0;
          object.MACD_12_26 = 0;
          object.MACD_Signal_Line = 0;
          object.MINUS_DI = 0;
          object.MINUS_DM = 0;
          object.PLUS_DI = 0;
          object.PLUS_DM = 0;
          object.ROC = 0;
          object.RSI_14 = 0;
          object.STOCH_9_6_D = 0;
          object.STOCH_9_6_K = 0;
          object.Ultimate_Oscillator = 0;
          object.William_R = 0;
          object.currentPrice = 0;
        }
        if (message.EMA5 != null && message.hasOwnProperty("EMA5"))
          object.EMA5 = options.json && !isFinite(message.EMA5) ? String(message.EMA5) : message.EMA5;
        if (message.EMA10 != null && message.hasOwnProperty("EMA10"))
          object.EMA10 = options.json && !isFinite(message.EMA10) ? String(message.EMA10) : message.EMA10;
        if (message.EMA20 != null && message.hasOwnProperty("EMA20"))
          object.EMA20 = options.json && !isFinite(message.EMA20) ? String(message.EMA20) : message.EMA20;
        if (message.EMA50 != null && message.hasOwnProperty("EMA50"))
          object.EMA50 = options.json && !isFinite(message.EMA50) ? String(message.EMA50) : message.EMA50;
        if (message.EMA100 != null && message.hasOwnProperty("EMA100"))
          object.EMA100 = options.json && !isFinite(message.EMA100) ? String(message.EMA100) : message.EMA100;
        if (message.EMA200 != null && message.hasOwnProperty("EMA200"))
          object.EMA200 = options.json && !isFinite(message.EMA200) ? String(message.EMA200) : message.EMA200;
        if (message.MA5 != null && message.hasOwnProperty("MA5"))
          object.MA5 = options.json && !isFinite(message.MA5) ? String(message.MA5) : message.MA5;
        if (message.MA10 != null && message.hasOwnProperty("MA10"))
          object.MA10 = options.json && !isFinite(message.MA10) ? String(message.MA10) : message.MA10;
        if (message.MA20 != null && message.hasOwnProperty("MA20"))
          object.MA20 = options.json && !isFinite(message.MA20) ? String(message.MA20) : message.MA20;
        if (message.MA50 != null && message.hasOwnProperty("MA50"))
          object.MA50 = options.json && !isFinite(message.MA50) ? String(message.MA50) : message.MA50;
        if (message.MA100 != null && message.hasOwnProperty("MA100"))
          object.MA100 = options.json && !isFinite(message.MA100) ? String(message.MA100) : message.MA100;
        if (message.MA200 != null && message.hasOwnProperty("MA200"))
          object.MA200 = options.json && !isFinite(message.MA200) ? String(message.MA200) : message.MA200;
        if (message.ADX_14 != null && message.hasOwnProperty("ADX_14"))
          object.ADX_14 = options.json && !isFinite(message.ADX_14) ? String(message.ADX_14) : message.ADX_14;
        if (message.ATR_14 != null && message.hasOwnProperty("ATR_14"))
          object.ATR_14 = options.json && !isFinite(message.ATR_14) ? String(message.ATR_14) : message.ATR_14;
        if (message.CCI_14 != null && message.hasOwnProperty("CCI_14"))
          object.CCI_14 = options.json && !isFinite(message.CCI_14) ? String(message.CCI_14) : message.CCI_14;
        if (message.MACD_12_26 != null && message.hasOwnProperty("MACD_12_26"))
          object.MACD_12_26 = options.json && !isFinite(message.MACD_12_26) ? String(message.MACD_12_26) : message.MACD_12_26;
        if (message.MACD_Signal_Line != null && message.hasOwnProperty("MACD_Signal_Line"))
          object.MACD_Signal_Line = options.json && !isFinite(message.MACD_Signal_Line) ? String(message.MACD_Signal_Line) : message.MACD_Signal_Line;
        if (message.MINUS_DI != null && message.hasOwnProperty("MINUS_DI"))
          object.MINUS_DI = options.json && !isFinite(message.MINUS_DI) ? String(message.MINUS_DI) : message.MINUS_DI;
        if (message.MINUS_DM != null && message.hasOwnProperty("MINUS_DM"))
          object.MINUS_DM = options.json && !isFinite(message.MINUS_DM) ? String(message.MINUS_DM) : message.MINUS_DM;
        if (message.PLUS_DI != null && message.hasOwnProperty("PLUS_DI"))
          object.PLUS_DI = options.json && !isFinite(message.PLUS_DI) ? String(message.PLUS_DI) : message.PLUS_DI;
        if (message.PLUS_DM != null && message.hasOwnProperty("PLUS_DM"))
          object.PLUS_DM = options.json && !isFinite(message.PLUS_DM) ? String(message.PLUS_DM) : message.PLUS_DM;
        if (message.ROC != null && message.hasOwnProperty("ROC"))
          object.ROC = options.json && !isFinite(message.ROC) ? String(message.ROC) : message.ROC;
        if (message.RSI_14 != null && message.hasOwnProperty("RSI_14"))
          object.RSI_14 = options.json && !isFinite(message.RSI_14) ? String(message.RSI_14) : message.RSI_14;
        if (message.STOCH_9_6_D != null && message.hasOwnProperty("STOCH_9_6_D"))
          object.STOCH_9_6_D = options.json && !isFinite(message.STOCH_9_6_D) ? String(message.STOCH_9_6_D) : message.STOCH_9_6_D;
        if (message.STOCH_9_6_K != null && message.hasOwnProperty("STOCH_9_6_K"))
          object.STOCH_9_6_K = options.json && !isFinite(message.STOCH_9_6_K) ? String(message.STOCH_9_6_K) : message.STOCH_9_6_K;
        if (message.Ultimate_Oscillator != null && message.hasOwnProperty("Ultimate_Oscillator"))
          object.Ultimate_Oscillator = options.json && !isFinite(message.Ultimate_Oscillator) ? String(message.Ultimate_Oscillator) : message.Ultimate_Oscillator;
        if (message.William_R != null && message.hasOwnProperty("William_R"))
          object.William_R = options.json && !isFinite(message.William_R) ? String(message.William_R) : message.William_R;
        if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
          object.currentPrice = options.json && !isFinite(message.currentPrice) ? String(message.currentPrice) : message.currentPrice;
        return object;
      };
      Indicator.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Indicator;
    }();
    TA.Signal = function() {
      function Signal(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Signal.prototype.ADX = "";
      Signal.prototype.MA = "";
      Signal.prototype.MACD = "";
      Signal.prototype.RSI = "";
      Signal.prototype.STOCH = "";
      Signal.prototype.WILLR = "";
      Signal.create = function create(properties) {
        return new Signal(properties);
      };
      Signal.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.ADX != null && Object.hasOwnProperty.call(message, "ADX"))
          writer.uint32(10).string(message.ADX);
        if (message.MA != null && Object.hasOwnProperty.call(message, "MA"))
          writer.uint32(18).string(message.MA);
        if (message.MACD != null && Object.hasOwnProperty.call(message, "MACD"))
          writer.uint32(26).string(message.MACD);
        if (message.RSI != null && Object.hasOwnProperty.call(message, "RSI"))
          writer.uint32(34).string(message.RSI);
        if (message.STOCH != null && Object.hasOwnProperty.call(message, "STOCH"))
          writer.uint32(42).string(message.STOCH);
        if (message.WILLR != null && Object.hasOwnProperty.call(message, "WILLR"))
          writer.uint32(50).string(message.WILLR);
        return writer;
      };
      Signal.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Signal.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.TA.Signal();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.ADX = reader.string();
              break;
            case 2:
              message.MA = reader.string();
              break;
            case 3:
              message.MACD = reader.string();
              break;
            case 4:
              message.RSI = reader.string();
              break;
            case 5:
              message.STOCH = reader.string();
              break;
            case 6:
              message.WILLR = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Signal.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Signal.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.ADX != null && message.hasOwnProperty("ADX")) {
          if (!$util.isString(message.ADX))
            return "ADX: string expected";
        }
        if (message.MA != null && message.hasOwnProperty("MA")) {
          if (!$util.isString(message.MA))
            return "MA: string expected";
        }
        if (message.MACD != null && message.hasOwnProperty("MACD")) {
          if (!$util.isString(message.MACD))
            return "MACD: string expected";
        }
        if (message.RSI != null && message.hasOwnProperty("RSI")) {
          if (!$util.isString(message.RSI))
            return "RSI: string expected";
        }
        if (message.STOCH != null && message.hasOwnProperty("STOCH")) {
          if (!$util.isString(message.STOCH))
            return "STOCH: string expected";
        }
        if (message.WILLR != null && message.hasOwnProperty("WILLR")) {
          if (!$util.isString(message.WILLR))
            return "WILLR: string expected";
        }
        return null;
      };
      Signal.fromObject = function fromObject(object) {
        if (object instanceof $root.models.TA.Signal)
          return object;
        let message = new $root.models.TA.Signal();
        if (object.ADX != null)
          message.ADX = String(object.ADX);
        if (object.MA != null)
          message.MA = String(object.MA);
        if (object.MACD != null)
          message.MACD = String(object.MACD);
        if (object.RSI != null)
          message.RSI = String(object.RSI);
        if (object.STOCH != null)
          message.STOCH = String(object.STOCH);
        if (object.WILLR != null)
          message.WILLR = String(object.WILLR);
        return message;
      };
      Signal.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.ADX = "";
          object.MA = "";
          object.MACD = "";
          object.RSI = "";
          object.STOCH = "";
          object.WILLR = "";
        }
        if (message.ADX != null && message.hasOwnProperty("ADX"))
          object.ADX = message.ADX;
        if (message.MA != null && message.hasOwnProperty("MA"))
          object.MA = message.MA;
        if (message.MACD != null && message.hasOwnProperty("MACD"))
          object.MACD = message.MACD;
        if (message.RSI != null && message.hasOwnProperty("RSI"))
          object.RSI = message.RSI;
        if (message.STOCH != null && message.hasOwnProperty("STOCH"))
          object.STOCH = message.STOCH;
        if (message.WILLR != null && message.hasOwnProperty("WILLR"))
          object.WILLR = message.WILLR;
        return object;
      };
      Signal.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Signal;
    }();
    return TA;
  }();
  models2.TAIndicator = function() {
    function TAIndicator(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    TAIndicator.prototype.indicator = null;
    TAIndicator.prototype.signal = null;
    TAIndicator.prototype.details = null;
    TAIndicator.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    TAIndicator.prototype.resolution = 0;
    TAIndicator.prototype.symbol = "";
    TAIndicator.prototype.to = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    TAIndicator.create = function create(properties) {
      return new TAIndicator(properties);
    };
    TAIndicator.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.indicator != null && Object.hasOwnProperty.call(message, "indicator"))
        $root.models.TA.Indicator.encode(message.indicator, writer.uint32(10).fork()).ldelim();
      if (message.signal != null && Object.hasOwnProperty.call(message, "signal"))
        $root.models.TA.Signal.encode(message.signal, writer.uint32(18).fork()).ldelim();
      if (message.details != null && Object.hasOwnProperty.call(message, "details"))
        $root.models.TA.Details.encode(message.details, writer.uint32(26).fork()).ldelim();
      if (message.count != null && Object.hasOwnProperty.call(message, "count"))
        writer.uint32(32).int64(message.count);
      if (message.resolution != null && Object.hasOwnProperty.call(message, "resolution"))
        writer.uint32(40).int32(message.resolution);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(50).string(message.symbol);
      if (message.to != null && Object.hasOwnProperty.call(message, "to"))
        writer.uint32(56).int64(message.to);
      return writer;
    };
    TAIndicator.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    TAIndicator.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.TAIndicator();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.indicator = $root.models.TA.Indicator.decode(reader, reader.uint32());
            break;
          case 2:
            message.signal = $root.models.TA.Signal.decode(reader, reader.uint32());
            break;
          case 3:
            message.details = $root.models.TA.Details.decode(reader, reader.uint32());
            break;
          case 4:
            message.count = reader.int64();
            break;
          case 5:
            message.resolution = reader.int32();
            break;
          case 6:
            message.symbol = reader.string();
            break;
          case 7:
            message.to = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    TAIndicator.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    TAIndicator.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.indicator != null && message.hasOwnProperty("indicator")) {
        let error = $root.models.TA.Indicator.verify(message.indicator);
        if (error)
          return "indicator." + error;
      }
      if (message.signal != null && message.hasOwnProperty("signal")) {
        let error = $root.models.TA.Signal.verify(message.signal);
        if (error)
          return "signal." + error;
      }
      if (message.details != null && message.hasOwnProperty("details")) {
        let error = $root.models.TA.Details.verify(message.details);
        if (error)
          return "details." + error;
      }
      if (message.count != null && message.hasOwnProperty("count")) {
        if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
          return "count: integer|Long expected";
      }
      if (message.resolution != null && message.hasOwnProperty("resolution"))
        switch (message.resolution) {
          default:
            return "resolution: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
            break;
        }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.to != null && message.hasOwnProperty("to")) {
        if (!$util.isInteger(message.to) && !(message.to && $util.isInteger(message.to.low) && $util.isInteger(message.to.high)))
          return "to: integer|Long expected";
      }
      return null;
    };
    TAIndicator.fromObject = function fromObject(object) {
      if (object instanceof $root.models.TAIndicator)
        return object;
      let message = new $root.models.TAIndicator();
      if (object.indicator != null) {
        if (typeof object.indicator !== "object")
          throw TypeError(".models.TAIndicator.indicator: object expected");
        message.indicator = $root.models.TA.Indicator.fromObject(object.indicator);
      }
      if (object.signal != null) {
        if (typeof object.signal !== "object")
          throw TypeError(".models.TAIndicator.signal: object expected");
        message.signal = $root.models.TA.Signal.fromObject(object.signal);
      }
      if (object.details != null) {
        if (typeof object.details !== "object")
          throw TypeError(".models.TAIndicator.details: object expected");
        message.details = $root.models.TA.Details.fromObject(object.details);
      }
      if (object.count != null) {
        if ($util.Long)
          (message.count = $util.Long.fromValue(object.count)).unsigned = false;
        else if (typeof object.count === "string")
          message.count = parseInt(object.count, 10);
        else if (typeof object.count === "number")
          message.count = object.count;
        else if (typeof object.count === "object")
          message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
      }
      switch (object.resolution) {
        case "MIN1":
        case 0:
          message.resolution = 0;
          break;
        case "MIN3":
        case 1:
          message.resolution = 1;
          break;
        case "MIN5":
        case 2:
          message.resolution = 2;
          break;
        case "MIN15":
        case 3:
          message.resolution = 3;
          break;
        case "MIN30":
        case 4:
          message.resolution = 4;
          break;
        case "MIN45":
        case 5:
          message.resolution = 5;
          break;
        case "HOUR1":
        case 6:
          message.resolution = 6;
          break;
        case "HOUR2":
        case 7:
          message.resolution = 7;
          break;
        case "HOUR3":
        case 8:
          message.resolution = 8;
          break;
        case "HOUR4":
        case 9:
          message.resolution = 9;
          break;
        case "DAY":
        case 10:
          message.resolution = 10;
          break;
        case "WEEK":
        case 11:
          message.resolution = 11;
          break;
        case "MONTH":
        case 12:
          message.resolution = 12;
          break;
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.to != null) {
        if ($util.Long)
          (message.to = $util.Long.fromValue(object.to)).unsigned = false;
        else if (typeof object.to === "string")
          message.to = parseInt(object.to, 10);
        else if (typeof object.to === "number")
          message.to = object.to;
        else if (typeof object.to === "object")
          message.to = new $util.LongBits(object.to.low >>> 0, object.to.high >>> 0).toNumber();
      }
      return message;
    };
    TAIndicator.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.indicator = null;
        object.signal = null;
        object.details = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.count = options.longs === String ? "0" : 0;
        object.resolution = options.enums === String ? "MIN1" : 0;
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.to = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.to = options.longs === String ? "0" : 0;
      }
      if (message.indicator != null && message.hasOwnProperty("indicator"))
        object.indicator = $root.models.TA.Indicator.toObject(message.indicator, options);
      if (message.signal != null && message.hasOwnProperty("signal"))
        object.signal = $root.models.TA.Signal.toObject(message.signal, options);
      if (message.details != null && message.hasOwnProperty("details"))
        object.details = $root.models.TA.Details.toObject(message.details, options);
      if (message.count != null && message.hasOwnProperty("count"))
        if (typeof message.count === "number")
          object.count = options.longs === String ? String(message.count) : message.count;
        else
          object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
      if (message.resolution != null && message.hasOwnProperty("resolution"))
        object.resolution = options.enums === String ? $root.models.TimeResolution[message.resolution] : message.resolution;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.to != null && message.hasOwnProperty("to"))
        if (typeof message.to === "number")
          object.to = options.longs === String ? String(message.to) : message.to;
        else
          object.to = options.longs === String ? $util.Long.prototype.toString.call(message.to) : options.longs === Number ? new $util.LongBits(message.to.low >>> 0, message.to.high >>> 0).toNumber() : message.to;
      return object;
    };
    TAIndicator.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return TAIndicator;
  }();
  models2.Investor = function() {
    function Investor(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Investor.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Investor.prototype.email = "";
    Investor.prototype.fullName = "";
    Investor.create = function create(properties) {
      return new Investor(properties);
    };
    Investor.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(18).string(message.email);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(26).string(message.fullName);
      return writer;
    };
    Investor.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Investor.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Investor();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.email = reader.string();
            break;
          case 3:
            message.fullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Investor.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Investor.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      return null;
    };
    Investor.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Investor)
        return object;
      let message = new $root.models.Investor();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.email != null)
        message.email = String(object.email);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      return message;
    };
    Investor.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.email = "";
        object.fullName = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      return object;
    };
    Investor.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Investor;
  }();
  models2.EmailVerification = function() {
    function EmailVerification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EmailVerification.prototype.investorId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EmailVerification.prototype.email = "";
    EmailVerification.prototype.code = "";
    EmailVerification.prototype.fullName = "";
    EmailVerification.create = function create(properties) {
      return new EmailVerification(properties);
    };
    EmailVerification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int64(message.investorId);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(18).string(message.email);
      if (message.code != null && Object.hasOwnProperty.call(message, "code"))
        writer.uint32(26).string(message.code);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(34).string(message.fullName);
      return writer;
    };
    EmailVerification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EmailVerification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.EmailVerification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int64();
            break;
          case 2:
            message.email = reader.string();
            break;
          case 3:
            message.code = reader.string();
            break;
          case 4:
            message.fullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EmailVerification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EmailVerification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId) && !(message.investorId && $util.isInteger(message.investorId.low) && $util.isInteger(message.investorId.high)))
          return "investorId: integer|Long expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.code != null && message.hasOwnProperty("code")) {
        if (!$util.isString(message.code))
          return "code: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      return null;
    };
    EmailVerification.fromObject = function fromObject(object) {
      if (object instanceof $root.models.EmailVerification)
        return object;
      let message = new $root.models.EmailVerification();
      if (object.investorId != null) {
        if ($util.Long)
          (message.investorId = $util.Long.fromValue(object.investorId)).unsigned = false;
        else if (typeof object.investorId === "string")
          message.investorId = parseInt(object.investorId, 10);
        else if (typeof object.investorId === "number")
          message.investorId = object.investorId;
        else if (typeof object.investorId === "object")
          message.investorId = new $util.LongBits(object.investorId.low >>> 0, object.investorId.high >>> 0).toNumber();
      }
      if (object.email != null)
        message.email = String(object.email);
      if (object.code != null)
        message.code = String(object.code);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      return message;
    };
    EmailVerification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.investorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.investorId = options.longs === String ? "0" : 0;
        object.email = "";
        object.code = "";
        object.fullName = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        if (typeof message.investorId === "number")
          object.investorId = options.longs === String ? String(message.investorId) : message.investorId;
        else
          object.investorId = options.longs === String ? $util.Long.prototype.toString.call(message.investorId) : options.longs === Number ? new $util.LongBits(message.investorId.low >>> 0, message.investorId.high >>> 0).toNumber() : message.investorId;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.code != null && message.hasOwnProperty("code"))
        object.code = message.code;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      return object;
    };
    EmailVerification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EmailVerification;
  }();
  models2.AccountBalance = function() {
    function AccountBalance(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AccountBalance.prototype.investorId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.accountNo = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.nav = 0;
    AccountBalance.prototype.availableCash = 0;
    AccountBalance.prototype.withdrawalCash = 0;
    AccountBalance.prototype.holdOvernightSecure = 0;
    AccountBalance.prototype.createdDate = null;
    AccountBalance.prototype.navExcludeEstimatedProfit = 0;
    AccountBalance.prototype.totalSecure = 0;
    AccountBalance.prototype.investorAccountId = 0;
    AccountBalance.prototype.estimateHoldOvernightSecure = 0;
    AccountBalance.prototype.pendingVsdSecure = 0;
    AccountBalance.prototype.depositionalCash = 0;
    AccountBalance.prototype.vsdSecureDepositFee = 0;
    AccountBalance.prototype.withdrawGuaranteeAmount = 0;
    AccountBalance.prototype.holdCollateralFee = 0;
    AccountBalance.create = function create(properties) {
      return new AccountBalance(properties);
    };
    AccountBalance.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int64(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(16).int64(message.accountNo);
      if (message.nav != null && Object.hasOwnProperty.call(message, "nav"))
        writer.uint32(25).double(message.nav);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(33).double(message.availableCash);
      if (message.withdrawalCash != null && Object.hasOwnProperty.call(message, "withdrawalCash"))
        writer.uint32(41).double(message.withdrawalCash);
      if (message.holdOvernightSecure != null && Object.hasOwnProperty.call(message, "holdOvernightSecure"))
        writer.uint32(49).double(message.holdOvernightSecure);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.navExcludeEstimatedProfit != null && Object.hasOwnProperty.call(message, "navExcludeEstimatedProfit"))
        writer.uint32(65).double(message.navExcludeEstimatedProfit);
      if (message.totalSecure != null && Object.hasOwnProperty.call(message, "totalSecure"))
        writer.uint32(73).double(message.totalSecure);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(80).int32(message.investorAccountId);
      if (message.estimateHoldOvernightSecure != null && Object.hasOwnProperty.call(message, "estimateHoldOvernightSecure"))
        writer.uint32(89).double(message.estimateHoldOvernightSecure);
      if (message.pendingVsdSecure != null && Object.hasOwnProperty.call(message, "pendingVsdSecure"))
        writer.uint32(97).double(message.pendingVsdSecure);
      if (message.depositionalCash != null && Object.hasOwnProperty.call(message, "depositionalCash"))
        writer.uint32(105).double(message.depositionalCash);
      if (message.vsdSecureDepositFee != null && Object.hasOwnProperty.call(message, "vsdSecureDepositFee"))
        writer.uint32(113).double(message.vsdSecureDepositFee);
      if (message.withdrawGuaranteeAmount != null && Object.hasOwnProperty.call(message, "withdrawGuaranteeAmount"))
        writer.uint32(121).double(message.withdrawGuaranteeAmount);
      if (message.holdCollateralFee != null && Object.hasOwnProperty.call(message, "holdCollateralFee"))
        writer.uint32(129).double(message.holdCollateralFee);
      return writer;
    };
    AccountBalance.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AccountBalance.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.AccountBalance();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int64();
            break;
          case 2:
            message.accountNo = reader.int64();
            break;
          case 3:
            message.nav = reader.double();
            break;
          case 4:
            message.availableCash = reader.double();
            break;
          case 5:
            message.withdrawalCash = reader.double();
            break;
          case 6:
            message.holdOvernightSecure = reader.double();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.navExcludeEstimatedProfit = reader.double();
            break;
          case 9:
            message.totalSecure = reader.double();
            break;
          case 10:
            message.investorAccountId = reader.int32();
            break;
          case 11:
            message.estimateHoldOvernightSecure = reader.double();
            break;
          case 12:
            message.pendingVsdSecure = reader.double();
            break;
          case 13:
            message.depositionalCash = reader.double();
            break;
          case 14:
            message.vsdSecureDepositFee = reader.double();
            break;
          case 15:
            message.withdrawGuaranteeAmount = reader.double();
            break;
          case 16:
            message.holdCollateralFee = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AccountBalance.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AccountBalance.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId) && !(message.investorId && $util.isInteger(message.investorId.low) && $util.isInteger(message.investorId.high)))
          return "investorId: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isInteger(message.accountNo) && !(message.accountNo && $util.isInteger(message.accountNo.low) && $util.isInteger(message.accountNo.high)))
          return "accountNo: integer|Long expected";
      }
      if (message.nav != null && message.hasOwnProperty("nav")) {
        if (typeof message.nav !== "number")
          return "nav: number expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (typeof message.availableCash !== "number")
          return "availableCash: number expected";
      }
      if (message.withdrawalCash != null && message.hasOwnProperty("withdrawalCash")) {
        if (typeof message.withdrawalCash !== "number")
          return "withdrawalCash: number expected";
      }
      if (message.holdOvernightSecure != null && message.hasOwnProperty("holdOvernightSecure")) {
        if (typeof message.holdOvernightSecure !== "number")
          return "holdOvernightSecure: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.navExcludeEstimatedProfit != null && message.hasOwnProperty("navExcludeEstimatedProfit")) {
        if (typeof message.navExcludeEstimatedProfit !== "number")
          return "navExcludeEstimatedProfit: number expected";
      }
      if (message.totalSecure != null && message.hasOwnProperty("totalSecure")) {
        if (typeof message.totalSecure !== "number")
          return "totalSecure: number expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.estimateHoldOvernightSecure != null && message.hasOwnProperty("estimateHoldOvernightSecure")) {
        if (typeof message.estimateHoldOvernightSecure !== "number")
          return "estimateHoldOvernightSecure: number expected";
      }
      if (message.pendingVsdSecure != null && message.hasOwnProperty("pendingVsdSecure")) {
        if (typeof message.pendingVsdSecure !== "number")
          return "pendingVsdSecure: number expected";
      }
      if (message.depositionalCash != null && message.hasOwnProperty("depositionalCash")) {
        if (typeof message.depositionalCash !== "number")
          return "depositionalCash: number expected";
      }
      if (message.vsdSecureDepositFee != null && message.hasOwnProperty("vsdSecureDepositFee")) {
        if (typeof message.vsdSecureDepositFee !== "number")
          return "vsdSecureDepositFee: number expected";
      }
      if (message.withdrawGuaranteeAmount != null && message.hasOwnProperty("withdrawGuaranteeAmount")) {
        if (typeof message.withdrawGuaranteeAmount !== "number")
          return "withdrawGuaranteeAmount: number expected";
      }
      if (message.holdCollateralFee != null && message.hasOwnProperty("holdCollateralFee")) {
        if (typeof message.holdCollateralFee !== "number")
          return "holdCollateralFee: number expected";
      }
      return null;
    };
    AccountBalance.fromObject = function fromObject(object) {
      if (object instanceof $root.models.AccountBalance)
        return object;
      let message = new $root.models.AccountBalance();
      if (object.investorId != null) {
        if ($util.Long)
          (message.investorId = $util.Long.fromValue(object.investorId)).unsigned = false;
        else if (typeof object.investorId === "string")
          message.investorId = parseInt(object.investorId, 10);
        else if (typeof object.investorId === "number")
          message.investorId = object.investorId;
        else if (typeof object.investorId === "object")
          message.investorId = new $util.LongBits(object.investorId.low >>> 0, object.investorId.high >>> 0).toNumber();
      }
      if (object.accountNo != null) {
        if ($util.Long)
          (message.accountNo = $util.Long.fromValue(object.accountNo)).unsigned = false;
        else if (typeof object.accountNo === "string")
          message.accountNo = parseInt(object.accountNo, 10);
        else if (typeof object.accountNo === "number")
          message.accountNo = object.accountNo;
        else if (typeof object.accountNo === "object")
          message.accountNo = new $util.LongBits(object.accountNo.low >>> 0, object.accountNo.high >>> 0).toNumber();
      }
      if (object.nav != null)
        message.nav = Number(object.nav);
      if (object.availableCash != null)
        message.availableCash = Number(object.availableCash);
      if (object.withdrawalCash != null)
        message.withdrawalCash = Number(object.withdrawalCash);
      if (object.holdOvernightSecure != null)
        message.holdOvernightSecure = Number(object.holdOvernightSecure);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.AccountBalance.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.navExcludeEstimatedProfit != null)
        message.navExcludeEstimatedProfit = Number(object.navExcludeEstimatedProfit);
      if (object.totalSecure != null)
        message.totalSecure = Number(object.totalSecure);
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.estimateHoldOvernightSecure != null)
        message.estimateHoldOvernightSecure = Number(object.estimateHoldOvernightSecure);
      if (object.pendingVsdSecure != null)
        message.pendingVsdSecure = Number(object.pendingVsdSecure);
      if (object.depositionalCash != null)
        message.depositionalCash = Number(object.depositionalCash);
      if (object.vsdSecureDepositFee != null)
        message.vsdSecureDepositFee = Number(object.vsdSecureDepositFee);
      if (object.withdrawGuaranteeAmount != null)
        message.withdrawGuaranteeAmount = Number(object.withdrawGuaranteeAmount);
      if (object.holdCollateralFee != null)
        message.holdCollateralFee = Number(object.holdCollateralFee);
      return message;
    };
    AccountBalance.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.investorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.investorId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.accountNo = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.accountNo = options.longs === String ? "0" : 0;
        object.nav = 0;
        object.availableCash = 0;
        object.withdrawalCash = 0;
        object.holdOvernightSecure = 0;
        object.createdDate = null;
        object.navExcludeEstimatedProfit = 0;
        object.totalSecure = 0;
        object.investorAccountId = 0;
        object.estimateHoldOvernightSecure = 0;
        object.pendingVsdSecure = 0;
        object.depositionalCash = 0;
        object.vsdSecureDepositFee = 0;
        object.withdrawGuaranteeAmount = 0;
        object.holdCollateralFee = 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        if (typeof message.investorId === "number")
          object.investorId = options.longs === String ? String(message.investorId) : message.investorId;
        else
          object.investorId = options.longs === String ? $util.Long.prototype.toString.call(message.investorId) : options.longs === Number ? new $util.LongBits(message.investorId.low >>> 0, message.investorId.high >>> 0).toNumber() : message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        if (typeof message.accountNo === "number")
          object.accountNo = options.longs === String ? String(message.accountNo) : message.accountNo;
        else
          object.accountNo = options.longs === String ? $util.Long.prototype.toString.call(message.accountNo) : options.longs === Number ? new $util.LongBits(message.accountNo.low >>> 0, message.accountNo.high >>> 0).toNumber() : message.accountNo;
      if (message.nav != null && message.hasOwnProperty("nav"))
        object.nav = options.json && !isFinite(message.nav) ? String(message.nav) : message.nav;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        object.availableCash = options.json && !isFinite(message.availableCash) ? String(message.availableCash) : message.availableCash;
      if (message.withdrawalCash != null && message.hasOwnProperty("withdrawalCash"))
        object.withdrawalCash = options.json && !isFinite(message.withdrawalCash) ? String(message.withdrawalCash) : message.withdrawalCash;
      if (message.holdOvernightSecure != null && message.hasOwnProperty("holdOvernightSecure"))
        object.holdOvernightSecure = options.json && !isFinite(message.holdOvernightSecure) ? String(message.holdOvernightSecure) : message.holdOvernightSecure;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.navExcludeEstimatedProfit != null && message.hasOwnProperty("navExcludeEstimatedProfit"))
        object.navExcludeEstimatedProfit = options.json && !isFinite(message.navExcludeEstimatedProfit) ? String(message.navExcludeEstimatedProfit) : message.navExcludeEstimatedProfit;
      if (message.totalSecure != null && message.hasOwnProperty("totalSecure"))
        object.totalSecure = options.json && !isFinite(message.totalSecure) ? String(message.totalSecure) : message.totalSecure;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.estimateHoldOvernightSecure != null && message.hasOwnProperty("estimateHoldOvernightSecure"))
        object.estimateHoldOvernightSecure = options.json && !isFinite(message.estimateHoldOvernightSecure) ? String(message.estimateHoldOvernightSecure) : message.estimateHoldOvernightSecure;
      if (message.pendingVsdSecure != null && message.hasOwnProperty("pendingVsdSecure"))
        object.pendingVsdSecure = options.json && !isFinite(message.pendingVsdSecure) ? String(message.pendingVsdSecure) : message.pendingVsdSecure;
      if (message.depositionalCash != null && message.hasOwnProperty("depositionalCash"))
        object.depositionalCash = options.json && !isFinite(message.depositionalCash) ? String(message.depositionalCash) : message.depositionalCash;
      if (message.vsdSecureDepositFee != null && message.hasOwnProperty("vsdSecureDepositFee"))
        object.vsdSecureDepositFee = options.json && !isFinite(message.vsdSecureDepositFee) ? String(message.vsdSecureDepositFee) : message.vsdSecureDepositFee;
      if (message.withdrawGuaranteeAmount != null && message.hasOwnProperty("withdrawGuaranteeAmount"))
        object.withdrawGuaranteeAmount = options.json && !isFinite(message.withdrawGuaranteeAmount) ? String(message.withdrawGuaranteeAmount) : message.withdrawGuaranteeAmount;
      if (message.holdCollateralFee != null && message.hasOwnProperty("holdCollateralFee"))
        object.holdCollateralFee = options.json && !isFinite(message.holdCollateralFee) ? String(message.holdCollateralFee) : message.holdCollateralFee;
      return object;
    };
    AccountBalance.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return AccountBalance;
  }();
  models2.CutLossPrice = function() {
    function CutLossPrice(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CutLossPrice.prototype.investorId = 0;
    CutLossPrice.prototype.dealId = 0;
    CutLossPrice.prototype.cutLossPrice = 0;
    CutLossPrice.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CutLossPrice.prototype.investorAccountId = 0;
    CutLossPrice.create = function create(properties) {
      return new CutLossPrice(properties);
    };
    CutLossPrice.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int32(message.investorId);
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(16).int32(message.dealId);
      if (message.cutLossPrice != null && Object.hasOwnProperty.call(message, "cutLossPrice"))
        writer.uint32(33).double(message.cutLossPrice);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(40).int64(message.time);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(48).int32(message.investorAccountId);
      return writer;
    };
    CutLossPrice.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CutLossPrice.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.CutLossPrice();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int32();
            break;
          case 2:
            message.dealId = reader.int32();
            break;
          case 4:
            message.cutLossPrice = reader.double();
            break;
          case 5:
            message.time = reader.int64();
            break;
          case 6:
            message.investorAccountId = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CutLossPrice.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CutLossPrice.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId))
          return "dealId: integer expected";
      }
      if (message.cutLossPrice != null && message.hasOwnProperty("cutLossPrice")) {
        if (typeof message.cutLossPrice !== "number")
          return "cutLossPrice: number expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      return null;
    };
    CutLossPrice.fromObject = function fromObject(object) {
      if (object instanceof $root.models.CutLossPrice)
        return object;
      let message = new $root.models.CutLossPrice();
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.dealId != null)
        message.dealId = object.dealId | 0;
      if (object.cutLossPrice != null)
        message.cutLossPrice = Number(object.cutLossPrice);
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      return message;
    };
    CutLossPrice.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = 0;
        object.dealId = 0;
        object.cutLossPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.investorAccountId = 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        object.dealId = message.dealId;
      if (message.cutLossPrice != null && message.hasOwnProperty("cutLossPrice"))
        object.cutLossPrice = options.json && !isFinite(message.cutLossPrice) ? String(message.cutLossPrice) : message.cutLossPrice;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      return object;
    };
    CutLossPrice.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CutLossPrice;
  }();
  models2.DealRisk = function() {
    function DealRisk(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealRisk.prototype.investorId = 0;
    DealRisk.prototype.dealId = 0;
    DealRisk.prototype.cutLossPrice = 0;
    DealRisk.prototype.takeProfitPrice = 0;
    DealRisk.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRisk.prototype.cutLossRate = 0;
    DealRisk.prototype.takeProfitRate = 0;
    DealRisk.prototype.investorAccountId = 0;
    DealRisk.prototype.bestPrice = 0;
    DealRisk.prototype.liquidPrice = 0;
    DealRisk.prototype.takeProfitOrderDelta = 0;
    DealRisk.prototype.takeProfitOrderStrategy = "";
    DealRisk.create = function create(properties) {
      return new DealRisk(properties);
    };
    DealRisk.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int32(message.investorId);
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(16).int32(message.dealId);
      if (message.cutLossPrice != null && Object.hasOwnProperty.call(message, "cutLossPrice"))
        writer.uint32(33).double(message.cutLossPrice);
      if (message.takeProfitPrice != null && Object.hasOwnProperty.call(message, "takeProfitPrice"))
        writer.uint32(41).double(message.takeProfitPrice);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(48).int64(message.time);
      if (message.cutLossRate != null && Object.hasOwnProperty.call(message, "cutLossRate"))
        writer.uint32(57).double(message.cutLossRate);
      if (message.takeProfitRate != null && Object.hasOwnProperty.call(message, "takeProfitRate"))
        writer.uint32(65).double(message.takeProfitRate);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(72).int32(message.investorAccountId);
      if (message.bestPrice != null && Object.hasOwnProperty.call(message, "bestPrice"))
        writer.uint32(81).double(message.bestPrice);
      if (message.liquidPrice != null && Object.hasOwnProperty.call(message, "liquidPrice"))
        writer.uint32(89).double(message.liquidPrice);
      if (message.takeProfitOrderDelta != null && Object.hasOwnProperty.call(message, "takeProfitOrderDelta"))
        writer.uint32(97).double(message.takeProfitOrderDelta);
      if (message.takeProfitOrderStrategy != null && Object.hasOwnProperty.call(message, "takeProfitOrderStrategy"))
        writer.uint32(106).string(message.takeProfitOrderStrategy);
      return writer;
    };
    DealRisk.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealRisk.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.DealRisk();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int32();
            break;
          case 2:
            message.dealId = reader.int32();
            break;
          case 4:
            message.cutLossPrice = reader.double();
            break;
          case 5:
            message.takeProfitPrice = reader.double();
            break;
          case 6:
            message.time = reader.int64();
            break;
          case 7:
            message.cutLossRate = reader.double();
            break;
          case 8:
            message.takeProfitRate = reader.double();
            break;
          case 9:
            message.investorAccountId = reader.int32();
            break;
          case 10:
            message.bestPrice = reader.double();
            break;
          case 11:
            message.liquidPrice = reader.double();
            break;
          case 12:
            message.takeProfitOrderDelta = reader.double();
            break;
          case 13:
            message.takeProfitOrderStrategy = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealRisk.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealRisk.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId))
          return "dealId: integer expected";
      }
      if (message.cutLossPrice != null && message.hasOwnProperty("cutLossPrice")) {
        if (typeof message.cutLossPrice !== "number")
          return "cutLossPrice: number expected";
      }
      if (message.takeProfitPrice != null && message.hasOwnProperty("takeProfitPrice")) {
        if (typeof message.takeProfitPrice !== "number")
          return "takeProfitPrice: number expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.cutLossRate != null && message.hasOwnProperty("cutLossRate")) {
        if (typeof message.cutLossRate !== "number")
          return "cutLossRate: number expected";
      }
      if (message.takeProfitRate != null && message.hasOwnProperty("takeProfitRate")) {
        if (typeof message.takeProfitRate !== "number")
          return "takeProfitRate: number expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.bestPrice != null && message.hasOwnProperty("bestPrice")) {
        if (typeof message.bestPrice !== "number")
          return "bestPrice: number expected";
      }
      if (message.liquidPrice != null && message.hasOwnProperty("liquidPrice")) {
        if (typeof message.liquidPrice !== "number")
          return "liquidPrice: number expected";
      }
      if (message.takeProfitOrderDelta != null && message.hasOwnProperty("takeProfitOrderDelta")) {
        if (typeof message.takeProfitOrderDelta !== "number")
          return "takeProfitOrderDelta: number expected";
      }
      if (message.takeProfitOrderStrategy != null && message.hasOwnProperty("takeProfitOrderStrategy")) {
        if (!$util.isString(message.takeProfitOrderStrategy))
          return "takeProfitOrderStrategy: string expected";
      }
      return null;
    };
    DealRisk.fromObject = function fromObject(object) {
      if (object instanceof $root.models.DealRisk)
        return object;
      let message = new $root.models.DealRisk();
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.dealId != null)
        message.dealId = object.dealId | 0;
      if (object.cutLossPrice != null)
        message.cutLossPrice = Number(object.cutLossPrice);
      if (object.takeProfitPrice != null)
        message.takeProfitPrice = Number(object.takeProfitPrice);
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.cutLossRate != null)
        message.cutLossRate = Number(object.cutLossRate);
      if (object.takeProfitRate != null)
        message.takeProfitRate = Number(object.takeProfitRate);
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.bestPrice != null)
        message.bestPrice = Number(object.bestPrice);
      if (object.liquidPrice != null)
        message.liquidPrice = Number(object.liquidPrice);
      if (object.takeProfitOrderDelta != null)
        message.takeProfitOrderDelta = Number(object.takeProfitOrderDelta);
      if (object.takeProfitOrderStrategy != null)
        message.takeProfitOrderStrategy = String(object.takeProfitOrderStrategy);
      return message;
    };
    DealRisk.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = 0;
        object.dealId = 0;
        object.cutLossPrice = 0;
        object.takeProfitPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.cutLossRate = 0;
        object.takeProfitRate = 0;
        object.investorAccountId = 0;
        object.bestPrice = 0;
        object.liquidPrice = 0;
        object.takeProfitOrderDelta = 0;
        object.takeProfitOrderStrategy = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        object.dealId = message.dealId;
      if (message.cutLossPrice != null && message.hasOwnProperty("cutLossPrice"))
        object.cutLossPrice = options.json && !isFinite(message.cutLossPrice) ? String(message.cutLossPrice) : message.cutLossPrice;
      if (message.takeProfitPrice != null && message.hasOwnProperty("takeProfitPrice"))
        object.takeProfitPrice = options.json && !isFinite(message.takeProfitPrice) ? String(message.takeProfitPrice) : message.takeProfitPrice;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.cutLossRate != null && message.hasOwnProperty("cutLossRate"))
        object.cutLossRate = options.json && !isFinite(message.cutLossRate) ? String(message.cutLossRate) : message.cutLossRate;
      if (message.takeProfitRate != null && message.hasOwnProperty("takeProfitRate"))
        object.takeProfitRate = options.json && !isFinite(message.takeProfitRate) ? String(message.takeProfitRate) : message.takeProfitRate;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.bestPrice != null && message.hasOwnProperty("bestPrice"))
        object.bestPrice = options.json && !isFinite(message.bestPrice) ? String(message.bestPrice) : message.bestPrice;
      if (message.liquidPrice != null && message.hasOwnProperty("liquidPrice"))
        object.liquidPrice = options.json && !isFinite(message.liquidPrice) ? String(message.liquidPrice) : message.liquidPrice;
      if (message.takeProfitOrderDelta != null && message.hasOwnProperty("takeProfitOrderDelta"))
        object.takeProfitOrderDelta = options.json && !isFinite(message.takeProfitOrderDelta) ? String(message.takeProfitOrderDelta) : message.takeProfitOrderDelta;
      if (message.takeProfitOrderStrategy != null && message.hasOwnProperty("takeProfitOrderStrategy"))
        object.takeProfitOrderStrategy = message.takeProfitOrderStrategy;
      return object;
    };
    DealRisk.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealRisk;
  }();
  models2.Contract = function() {
    function Contract(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Contract.prototype.investorId = 0;
    Contract.prototype.email = "";
    Contract.prototype.fullName = "";
    Contract.prototype.notes = "";
    Contract.prototype.pdfLink = "";
    Contract.prototype.status = "";
    Contract.create = function create(properties) {
      return new Contract(properties);
    };
    Contract.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int32(message.investorId);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(18).string(message.email);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(26).string(message.fullName);
      if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
        writer.uint32(34).string(message.notes);
      if (message.pdfLink != null && Object.hasOwnProperty.call(message, "pdfLink"))
        writer.uint32(42).string(message.pdfLink);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(50).string(message.status);
      return writer;
    };
    Contract.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Contract.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Contract();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int32();
            break;
          case 2:
            message.email = reader.string();
            break;
          case 3:
            message.fullName = reader.string();
            break;
          case 4:
            message.notes = reader.string();
            break;
          case 5:
            message.pdfLink = reader.string();
            break;
          case 6:
            message.status = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Contract.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Contract.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.notes != null && message.hasOwnProperty("notes")) {
        if (!$util.isString(message.notes))
          return "notes: string expected";
      }
      if (message.pdfLink != null && message.hasOwnProperty("pdfLink")) {
        if (!$util.isString(message.pdfLink))
          return "pdfLink: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      return null;
    };
    Contract.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Contract)
        return object;
      let message = new $root.models.Contract();
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.email != null)
        message.email = String(object.email);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.notes != null)
        message.notes = String(object.notes);
      if (object.pdfLink != null)
        message.pdfLink = String(object.pdfLink);
      if (object.status != null)
        message.status = String(object.status);
      return message;
    };
    Contract.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = 0;
        object.email = "";
        object.fullName = "";
        object.notes = "";
        object.pdfLink = "";
        object.status = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.notes != null && message.hasOwnProperty("notes"))
        object.notes = message.notes;
      if (message.pdfLink != null && message.hasOwnProperty("pdfLink"))
        object.pdfLink = message.pdfLink;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      return object;
    };
    Contract.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Contract;
  }();
  models2.Notification = function() {
    function Notification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Notification.prototype.SenderId = "";
    Notification.prototype.UserId = "";
    Notification.prototype.NotificationType = "";
    Notification.prototype.Heading = "";
    Notification.prototype.Content = "";
    Notification.prototype.URL = "";
    Notification.prototype.Data = $util.newBuffer([]);
    Notification.prototype.NotificationState = "";
    Notification.prototype.CreatedDate = "";
    Notification.create = function create(properties) {
      return new Notification(properties);
    };
    Notification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.SenderId != null && Object.hasOwnProperty.call(message, "SenderId"))
        writer.uint32(10).string(message.SenderId);
      if (message.UserId != null && Object.hasOwnProperty.call(message, "UserId"))
        writer.uint32(18).string(message.UserId);
      if (message.NotificationType != null && Object.hasOwnProperty.call(message, "NotificationType"))
        writer.uint32(26).string(message.NotificationType);
      if (message.Heading != null && Object.hasOwnProperty.call(message, "Heading"))
        writer.uint32(34).string(message.Heading);
      if (message.Content != null && Object.hasOwnProperty.call(message, "Content"))
        writer.uint32(42).string(message.Content);
      if (message.URL != null && Object.hasOwnProperty.call(message, "URL"))
        writer.uint32(50).string(message.URL);
      if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
        writer.uint32(58).bytes(message.Data);
      if (message.NotificationState != null && Object.hasOwnProperty.call(message, "NotificationState"))
        writer.uint32(66).string(message.NotificationState);
      if (message.CreatedDate != null && Object.hasOwnProperty.call(message, "CreatedDate"))
        writer.uint32(74).string(message.CreatedDate);
      return writer;
    };
    Notification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Notification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Notification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.SenderId = reader.string();
            break;
          case 2:
            message.UserId = reader.string();
            break;
          case 3:
            message.NotificationType = reader.string();
            break;
          case 4:
            message.Heading = reader.string();
            break;
          case 5:
            message.Content = reader.string();
            break;
          case 6:
            message.URL = reader.string();
            break;
          case 7:
            message.Data = reader.bytes();
            break;
          case 8:
            message.NotificationState = reader.string();
            break;
          case 9:
            message.CreatedDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Notification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Notification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.SenderId != null && message.hasOwnProperty("SenderId")) {
        if (!$util.isString(message.SenderId))
          return "SenderId: string expected";
      }
      if (message.UserId != null && message.hasOwnProperty("UserId")) {
        if (!$util.isString(message.UserId))
          return "UserId: string expected";
      }
      if (message.NotificationType != null && message.hasOwnProperty("NotificationType")) {
        if (!$util.isString(message.NotificationType))
          return "NotificationType: string expected";
      }
      if (message.Heading != null && message.hasOwnProperty("Heading")) {
        if (!$util.isString(message.Heading))
          return "Heading: string expected";
      }
      if (message.Content != null && message.hasOwnProperty("Content")) {
        if (!$util.isString(message.Content))
          return "Content: string expected";
      }
      if (message.URL != null && message.hasOwnProperty("URL")) {
        if (!$util.isString(message.URL))
          return "URL: string expected";
      }
      if (message.Data != null && message.hasOwnProperty("Data")) {
        if (!(message.Data && typeof message.Data.length === "number" || $util.isString(message.Data)))
          return "Data: buffer expected";
      }
      if (message.NotificationState != null && message.hasOwnProperty("NotificationState")) {
        if (!$util.isString(message.NotificationState))
          return "NotificationState: string expected";
      }
      if (message.CreatedDate != null && message.hasOwnProperty("CreatedDate")) {
        if (!$util.isString(message.CreatedDate))
          return "CreatedDate: string expected";
      }
      return null;
    };
    Notification.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Notification)
        return object;
      let message = new $root.models.Notification();
      if (object.SenderId != null)
        message.SenderId = String(object.SenderId);
      if (object.UserId != null)
        message.UserId = String(object.UserId);
      if (object.NotificationType != null)
        message.NotificationType = String(object.NotificationType);
      if (object.Heading != null)
        message.Heading = String(object.Heading);
      if (object.Content != null)
        message.Content = String(object.Content);
      if (object.URL != null)
        message.URL = String(object.URL);
      if (object.Data != null) {
        if (typeof object.Data === "string")
          $util.base64.decode(object.Data, message.Data = $util.newBuffer($util.base64.length(object.Data)), 0);
        else if (object.Data.length)
          message.Data = object.Data;
      }
      if (object.NotificationState != null)
        message.NotificationState = String(object.NotificationState);
      if (object.CreatedDate != null)
        message.CreatedDate = String(object.CreatedDate);
      return message;
    };
    Notification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.SenderId = "";
        object.UserId = "";
        object.NotificationType = "";
        object.Heading = "";
        object.Content = "";
        object.URL = "";
        if (options.bytes === String)
          object.Data = "";
        else {
          object.Data = [];
          if (options.bytes !== Array)
            object.Data = $util.newBuffer(object.Data);
        }
        object.NotificationState = "";
        object.CreatedDate = "";
      }
      if (message.SenderId != null && message.hasOwnProperty("SenderId"))
        object.SenderId = message.SenderId;
      if (message.UserId != null && message.hasOwnProperty("UserId"))
        object.UserId = message.UserId;
      if (message.NotificationType != null && message.hasOwnProperty("NotificationType"))
        object.NotificationType = message.NotificationType;
      if (message.Heading != null && message.hasOwnProperty("Heading"))
        object.Heading = message.Heading;
      if (message.Content != null && message.hasOwnProperty("Content"))
        object.Content = message.Content;
      if (message.URL != null && message.hasOwnProperty("URL"))
        object.URL = message.URL;
      if (message.Data != null && message.hasOwnProperty("Data"))
        object.Data = options.bytes === String ? $util.base64.encode(message.Data, 0, message.Data.length) : options.bytes === Array ? Array.prototype.slice.call(message.Data) : message.Data;
      if (message.NotificationState != null && message.hasOwnProperty("NotificationState"))
        object.NotificationState = message.NotificationState;
      if (message.CreatedDate != null && message.hasOwnProperty("CreatedDate"))
        object.CreatedDate = message.CreatedDate;
      return object;
    };
    Notification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Notification;
  }();
  models2.BotResult = function() {
    function BotResult(properties) {
      this.deals = [];
      this.assets = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BotResult.prototype.id = "";
    BotResult.prototype.profit = 0;
    BotResult.prototype["return"] = 0;
    BotResult.prototype.numberOfSignals = 0;
    BotResult.prototype.numberOfWins = 0;
    BotResult.prototype.numberOfLosses = 0;
    BotResult.prototype.maxGain = 0;
    BotResult.prototype.maxLoss = 0;
    BotResult.prototype.averageGain = 0;
    BotResult.prototype.averageLoss = 0;
    BotResult.prototype.totalGain = 0;
    BotResult.prototype.totalLoss = 0;
    BotResult.prototype.initNav = 0;
    BotResult.prototype.endNav = 0;
    BotResult.prototype.highestNav = 0;
    BotResult.prototype.lowestNav = 0;
    BotResult.prototype.deals = $util.emptyArray;
    BotResult.prototype.assets = $util.emptyArray;
    BotResult.create = function create(properties) {
      return new BotResult(properties);
    };
    BotResult.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.profit != null && Object.hasOwnProperty.call(message, "profit"))
        writer.uint32(17).double(message.profit);
      if (message["return"] != null && Object.hasOwnProperty.call(message, "return"))
        writer.uint32(25).double(message["return"]);
      if (message.numberOfSignals != null && Object.hasOwnProperty.call(message, "numberOfSignals"))
        writer.uint32(32).int32(message.numberOfSignals);
      if (message.numberOfWins != null && Object.hasOwnProperty.call(message, "numberOfWins"))
        writer.uint32(40).int32(message.numberOfWins);
      if (message.numberOfLosses != null && Object.hasOwnProperty.call(message, "numberOfLosses"))
        writer.uint32(48).int32(message.numberOfLosses);
      if (message.maxGain != null && Object.hasOwnProperty.call(message, "maxGain"))
        writer.uint32(57).double(message.maxGain);
      if (message.maxLoss != null && Object.hasOwnProperty.call(message, "maxLoss"))
        writer.uint32(65).double(message.maxLoss);
      if (message.averageGain != null && Object.hasOwnProperty.call(message, "averageGain"))
        writer.uint32(73).double(message.averageGain);
      if (message.averageLoss != null && Object.hasOwnProperty.call(message, "averageLoss"))
        writer.uint32(81).double(message.averageLoss);
      if (message.totalGain != null && Object.hasOwnProperty.call(message, "totalGain"))
        writer.uint32(89).double(message.totalGain);
      if (message.totalLoss != null && Object.hasOwnProperty.call(message, "totalLoss"))
        writer.uint32(97).double(message.totalLoss);
      if (message.initNav != null && Object.hasOwnProperty.call(message, "initNav"))
        writer.uint32(105).double(message.initNav);
      if (message.endNav != null && Object.hasOwnProperty.call(message, "endNav"))
        writer.uint32(113).double(message.endNav);
      if (message.highestNav != null && Object.hasOwnProperty.call(message, "highestNav"))
        writer.uint32(121).double(message.highestNav);
      if (message.lowestNav != null && Object.hasOwnProperty.call(message, "lowestNav"))
        writer.uint32(129).double(message.lowestNav);
      if (message.deals != null && message.deals.length)
        for (let i = 0; i < message.deals.length; ++i)
          $root.models.BotDeal.encode(message.deals[i], writer.uint32(138).fork()).ldelim();
      if (message.assets != null && message.assets.length)
        for (let i = 0; i < message.assets.length; ++i)
          $root.models.BotAsset.encode(message.assets[i], writer.uint32(146).fork()).ldelim();
      return writer;
    };
    BotResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BotResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.BotResult();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.profit = reader.double();
            break;
          case 3:
            message["return"] = reader.double();
            break;
          case 4:
            message.numberOfSignals = reader.int32();
            break;
          case 5:
            message.numberOfWins = reader.int32();
            break;
          case 6:
            message.numberOfLosses = reader.int32();
            break;
          case 7:
            message.maxGain = reader.double();
            break;
          case 8:
            message.maxLoss = reader.double();
            break;
          case 9:
            message.averageGain = reader.double();
            break;
          case 10:
            message.averageLoss = reader.double();
            break;
          case 11:
            message.totalGain = reader.double();
            break;
          case 12:
            message.totalLoss = reader.double();
            break;
          case 13:
            message.initNav = reader.double();
            break;
          case 14:
            message.endNav = reader.double();
            break;
          case 15:
            message.highestNav = reader.double();
            break;
          case 16:
            message.lowestNav = reader.double();
            break;
          case 17:
            if (!(message.deals && message.deals.length))
              message.deals = [];
            message.deals.push($root.models.BotDeal.decode(reader, reader.uint32()));
            break;
          case 18:
            if (!(message.assets && message.assets.length))
              message.assets = [];
            message.assets.push($root.models.BotAsset.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BotResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BotResult.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.profit != null && message.hasOwnProperty("profit")) {
        if (typeof message.profit !== "number")
          return "profit: number expected";
      }
      if (message["return"] != null && message.hasOwnProperty("return")) {
        if (typeof message["return"] !== "number")
          return "return: number expected";
      }
      if (message.numberOfSignals != null && message.hasOwnProperty("numberOfSignals")) {
        if (!$util.isInteger(message.numberOfSignals))
          return "numberOfSignals: integer expected";
      }
      if (message.numberOfWins != null && message.hasOwnProperty("numberOfWins")) {
        if (!$util.isInteger(message.numberOfWins))
          return "numberOfWins: integer expected";
      }
      if (message.numberOfLosses != null && message.hasOwnProperty("numberOfLosses")) {
        if (!$util.isInteger(message.numberOfLosses))
          return "numberOfLosses: integer expected";
      }
      if (message.maxGain != null && message.hasOwnProperty("maxGain")) {
        if (typeof message.maxGain !== "number")
          return "maxGain: number expected";
      }
      if (message.maxLoss != null && message.hasOwnProperty("maxLoss")) {
        if (typeof message.maxLoss !== "number")
          return "maxLoss: number expected";
      }
      if (message.averageGain != null && message.hasOwnProperty("averageGain")) {
        if (typeof message.averageGain !== "number")
          return "averageGain: number expected";
      }
      if (message.averageLoss != null && message.hasOwnProperty("averageLoss")) {
        if (typeof message.averageLoss !== "number")
          return "averageLoss: number expected";
      }
      if (message.totalGain != null && message.hasOwnProperty("totalGain")) {
        if (typeof message.totalGain !== "number")
          return "totalGain: number expected";
      }
      if (message.totalLoss != null && message.hasOwnProperty("totalLoss")) {
        if (typeof message.totalLoss !== "number")
          return "totalLoss: number expected";
      }
      if (message.initNav != null && message.hasOwnProperty("initNav")) {
        if (typeof message.initNav !== "number")
          return "initNav: number expected";
      }
      if (message.endNav != null && message.hasOwnProperty("endNav")) {
        if (typeof message.endNav !== "number")
          return "endNav: number expected";
      }
      if (message.highestNav != null && message.hasOwnProperty("highestNav")) {
        if (typeof message.highestNav !== "number")
          return "highestNav: number expected";
      }
      if (message.lowestNav != null && message.hasOwnProperty("lowestNav")) {
        if (typeof message.lowestNav !== "number")
          return "lowestNav: number expected";
      }
      if (message.deals != null && message.hasOwnProperty("deals")) {
        if (!Array.isArray(message.deals))
          return "deals: array expected";
        for (let i = 0; i < message.deals.length; ++i) {
          let error = $root.models.BotDeal.verify(message.deals[i]);
          if (error)
            return "deals." + error;
        }
      }
      if (message.assets != null && message.hasOwnProperty("assets")) {
        if (!Array.isArray(message.assets))
          return "assets: array expected";
        for (let i = 0; i < message.assets.length; ++i) {
          let error = $root.models.BotAsset.verify(message.assets[i]);
          if (error)
            return "assets." + error;
        }
      }
      return null;
    };
    BotResult.fromObject = function fromObject(object) {
      if (object instanceof $root.models.BotResult)
        return object;
      let message = new $root.models.BotResult();
      if (object.id != null)
        message.id = String(object.id);
      if (object.profit != null)
        message.profit = Number(object.profit);
      if (object["return"] != null)
        message["return"] = Number(object["return"]);
      if (object.numberOfSignals != null)
        message.numberOfSignals = object.numberOfSignals | 0;
      if (object.numberOfWins != null)
        message.numberOfWins = object.numberOfWins | 0;
      if (object.numberOfLosses != null)
        message.numberOfLosses = object.numberOfLosses | 0;
      if (object.maxGain != null)
        message.maxGain = Number(object.maxGain);
      if (object.maxLoss != null)
        message.maxLoss = Number(object.maxLoss);
      if (object.averageGain != null)
        message.averageGain = Number(object.averageGain);
      if (object.averageLoss != null)
        message.averageLoss = Number(object.averageLoss);
      if (object.totalGain != null)
        message.totalGain = Number(object.totalGain);
      if (object.totalLoss != null)
        message.totalLoss = Number(object.totalLoss);
      if (object.initNav != null)
        message.initNav = Number(object.initNav);
      if (object.endNav != null)
        message.endNav = Number(object.endNav);
      if (object.highestNav != null)
        message.highestNav = Number(object.highestNav);
      if (object.lowestNav != null)
        message.lowestNav = Number(object.lowestNav);
      if (object.deals) {
        if (!Array.isArray(object.deals))
          throw TypeError(".models.BotResult.deals: array expected");
        message.deals = [];
        for (let i = 0; i < object.deals.length; ++i) {
          if (typeof object.deals[i] !== "object")
            throw TypeError(".models.BotResult.deals: object expected");
          message.deals[i] = $root.models.BotDeal.fromObject(object.deals[i]);
        }
      }
      if (object.assets) {
        if (!Array.isArray(object.assets))
          throw TypeError(".models.BotResult.assets: array expected");
        message.assets = [];
        for (let i = 0; i < object.assets.length; ++i) {
          if (typeof object.assets[i] !== "object")
            throw TypeError(".models.BotResult.assets: object expected");
          message.assets[i] = $root.models.BotAsset.fromObject(object.assets[i]);
        }
      }
      return message;
    };
    BotResult.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.deals = [];
        object.assets = [];
      }
      if (options.defaults) {
        object.id = "";
        object.profit = 0;
        object["return"] = 0;
        object.numberOfSignals = 0;
        object.numberOfWins = 0;
        object.numberOfLosses = 0;
        object.maxGain = 0;
        object.maxLoss = 0;
        object.averageGain = 0;
        object.averageLoss = 0;
        object.totalGain = 0;
        object.totalLoss = 0;
        object.initNav = 0;
        object.endNav = 0;
        object.highestNav = 0;
        object.lowestNav = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.profit != null && message.hasOwnProperty("profit"))
        object.profit = options.json && !isFinite(message.profit) ? String(message.profit) : message.profit;
      if (message["return"] != null && message.hasOwnProperty("return"))
        object["return"] = options.json && !isFinite(message["return"]) ? String(message["return"]) : message["return"];
      if (message.numberOfSignals != null && message.hasOwnProperty("numberOfSignals"))
        object.numberOfSignals = message.numberOfSignals;
      if (message.numberOfWins != null && message.hasOwnProperty("numberOfWins"))
        object.numberOfWins = message.numberOfWins;
      if (message.numberOfLosses != null && message.hasOwnProperty("numberOfLosses"))
        object.numberOfLosses = message.numberOfLosses;
      if (message.maxGain != null && message.hasOwnProperty("maxGain"))
        object.maxGain = options.json && !isFinite(message.maxGain) ? String(message.maxGain) : message.maxGain;
      if (message.maxLoss != null && message.hasOwnProperty("maxLoss"))
        object.maxLoss = options.json && !isFinite(message.maxLoss) ? String(message.maxLoss) : message.maxLoss;
      if (message.averageGain != null && message.hasOwnProperty("averageGain"))
        object.averageGain = options.json && !isFinite(message.averageGain) ? String(message.averageGain) : message.averageGain;
      if (message.averageLoss != null && message.hasOwnProperty("averageLoss"))
        object.averageLoss = options.json && !isFinite(message.averageLoss) ? String(message.averageLoss) : message.averageLoss;
      if (message.totalGain != null && message.hasOwnProperty("totalGain"))
        object.totalGain = options.json && !isFinite(message.totalGain) ? String(message.totalGain) : message.totalGain;
      if (message.totalLoss != null && message.hasOwnProperty("totalLoss"))
        object.totalLoss = options.json && !isFinite(message.totalLoss) ? String(message.totalLoss) : message.totalLoss;
      if (message.initNav != null && message.hasOwnProperty("initNav"))
        object.initNav = options.json && !isFinite(message.initNav) ? String(message.initNav) : message.initNav;
      if (message.endNav != null && message.hasOwnProperty("endNav"))
        object.endNav = options.json && !isFinite(message.endNav) ? String(message.endNav) : message.endNav;
      if (message.highestNav != null && message.hasOwnProperty("highestNav"))
        object.highestNav = options.json && !isFinite(message.highestNav) ? String(message.highestNav) : message.highestNav;
      if (message.lowestNav != null && message.hasOwnProperty("lowestNav"))
        object.lowestNav = options.json && !isFinite(message.lowestNav) ? String(message.lowestNav) : message.lowestNav;
      if (message.deals && message.deals.length) {
        object.deals = [];
        for (let j = 0; j < message.deals.length; ++j)
          object.deals[j] = $root.models.BotDeal.toObject(message.deals[j], options);
      }
      if (message.assets && message.assets.length) {
        object.assets = [];
        for (let j = 0; j < message.assets.length; ++j)
          object.assets[j] = $root.models.BotAsset.toObject(message.assets[j], options);
      }
      return object;
    };
    BotResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BotResult;
  }();
  models2.BotDeal = function() {
    function BotDeal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BotDeal.prototype.id = 0;
    BotDeal.prototype.symbol = "";
    BotDeal.prototype.positionType = 0;
    BotDeal.prototype.initialQuantity = 0;
    BotDeal.prototype.closedQuantity = 0;
    BotDeal.prototype.netProfit = 0;
    BotDeal.prototype.positionCostPrice = 0;
    BotDeal.prototype.positionClosedPrice = 0;
    BotDeal.prototype.openTime = null;
    BotDeal.prototype.closeTime = null;
    BotDeal.prototype.openTrigger = 0;
    BotDeal.prototype.closeTrigger = 0;
    BotDeal.prototype.netPoints = 0;
    BotDeal.create = function create(properties) {
      return new BotDeal(properties);
    };
    BotDeal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.positionType != null && Object.hasOwnProperty.call(message, "positionType"))
        writer.uint32(24).int32(message.positionType);
      if (message.initialQuantity != null && Object.hasOwnProperty.call(message, "initialQuantity"))
        writer.uint32(32).int32(message.initialQuantity);
      if (message.closedQuantity != null && Object.hasOwnProperty.call(message, "closedQuantity"))
        writer.uint32(40).int32(message.closedQuantity);
      if (message.netProfit != null && Object.hasOwnProperty.call(message, "netProfit"))
        writer.uint32(49).double(message.netProfit);
      if (message.positionCostPrice != null && Object.hasOwnProperty.call(message, "positionCostPrice"))
        writer.uint32(57).double(message.positionCostPrice);
      if (message.positionClosedPrice != null && Object.hasOwnProperty.call(message, "positionClosedPrice"))
        writer.uint32(65).double(message.positionClosedPrice);
      if (message.openTime != null && Object.hasOwnProperty.call(message, "openTime"))
        $root.google.protobuf.Timestamp.encode(message.openTime, writer.uint32(74).fork()).ldelim();
      if (message.closeTime != null && Object.hasOwnProperty.call(message, "closeTime"))
        $root.google.protobuf.Timestamp.encode(message.closeTime, writer.uint32(82).fork()).ldelim();
      if (message.openTrigger != null && Object.hasOwnProperty.call(message, "openTrigger"))
        writer.uint32(88).int32(message.openTrigger);
      if (message.closeTrigger != null && Object.hasOwnProperty.call(message, "closeTrigger"))
        writer.uint32(96).int32(message.closeTrigger);
      if (message.netPoints != null && Object.hasOwnProperty.call(message, "netPoints"))
        writer.uint32(105).double(message.netPoints);
      return writer;
    };
    BotDeal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BotDeal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.BotDeal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.positionType = reader.int32();
            break;
          case 4:
            message.initialQuantity = reader.int32();
            break;
          case 5:
            message.closedQuantity = reader.int32();
            break;
          case 6:
            message.netProfit = reader.double();
            break;
          case 7:
            message.positionCostPrice = reader.double();
            break;
          case 8:
            message.positionClosedPrice = reader.double();
            break;
          case 9:
            message.openTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.closeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.openTrigger = reader.int32();
            break;
          case 12:
            message.closeTrigger = reader.int32();
            break;
          case 13:
            message.netPoints = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BotDeal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BotDeal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.positionType != null && message.hasOwnProperty("positionType")) {
        if (!$util.isInteger(message.positionType))
          return "positionType: integer expected";
      }
      if (message.initialQuantity != null && message.hasOwnProperty("initialQuantity")) {
        if (!$util.isInteger(message.initialQuantity))
          return "initialQuantity: integer expected";
      }
      if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity")) {
        if (!$util.isInteger(message.closedQuantity))
          return "closedQuantity: integer expected";
      }
      if (message.netProfit != null && message.hasOwnProperty("netProfit")) {
        if (typeof message.netProfit !== "number")
          return "netProfit: number expected";
      }
      if (message.positionCostPrice != null && message.hasOwnProperty("positionCostPrice")) {
        if (typeof message.positionCostPrice !== "number")
          return "positionCostPrice: number expected";
      }
      if (message.positionClosedPrice != null && message.hasOwnProperty("positionClosedPrice")) {
        if (typeof message.positionClosedPrice !== "number")
          return "positionClosedPrice: number expected";
      }
      if (message.openTime != null && message.hasOwnProperty("openTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.openTime);
        if (error)
          return "openTime." + error;
      }
      if (message.closeTime != null && message.hasOwnProperty("closeTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.closeTime);
        if (error)
          return "closeTime." + error;
      }
      if (message.openTrigger != null && message.hasOwnProperty("openTrigger"))
        switch (message.openTrigger) {
          default:
            return "openTrigger: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.closeTrigger != null && message.hasOwnProperty("closeTrigger"))
        switch (message.closeTrigger) {
          default:
            return "closeTrigger: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.netPoints != null && message.hasOwnProperty("netPoints")) {
        if (typeof message.netPoints !== "number")
          return "netPoints: number expected";
      }
      return null;
    };
    BotDeal.fromObject = function fromObject(object) {
      if (object instanceof $root.models.BotDeal)
        return object;
      let message = new $root.models.BotDeal();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.positionType != null)
        message.positionType = object.positionType | 0;
      if (object.initialQuantity != null)
        message.initialQuantity = object.initialQuantity | 0;
      if (object.closedQuantity != null)
        message.closedQuantity = object.closedQuantity | 0;
      if (object.netProfit != null)
        message.netProfit = Number(object.netProfit);
      if (object.positionCostPrice != null)
        message.positionCostPrice = Number(object.positionCostPrice);
      if (object.positionClosedPrice != null)
        message.positionClosedPrice = Number(object.positionClosedPrice);
      if (object.openTime != null) {
        if (typeof object.openTime !== "object")
          throw TypeError(".models.BotDeal.openTime: object expected");
        message.openTime = $root.google.protobuf.Timestamp.fromObject(object.openTime);
      }
      if (object.closeTime != null) {
        if (typeof object.closeTime !== "object")
          throw TypeError(".models.BotDeal.closeTime: object expected");
        message.closeTime = $root.google.protobuf.Timestamp.fromObject(object.closeTime);
      }
      switch (object.openTrigger) {
        case "EN":
        case 0:
          message.openTrigger = 0;
          break;
        case "EX":
        case 1:
          message.openTrigger = 1;
          break;
        case "TP":
        case 2:
          message.openTrigger = 2;
          break;
        case "SL":
        case 3:
          message.openTrigger = 3;
          break;
      }
      switch (object.closeTrigger) {
        case "EN":
        case 0:
          message.closeTrigger = 0;
          break;
        case "EX":
        case 1:
          message.closeTrigger = 1;
          break;
        case "TP":
        case 2:
          message.closeTrigger = 2;
          break;
        case "SL":
        case 3:
          message.closeTrigger = 3;
          break;
      }
      if (object.netPoints != null)
        message.netPoints = Number(object.netPoints);
      return message;
    };
    BotDeal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.symbol = "";
        object.positionType = 0;
        object.initialQuantity = 0;
        object.closedQuantity = 0;
        object.netProfit = 0;
        object.positionCostPrice = 0;
        object.positionClosedPrice = 0;
        object.openTime = null;
        object.closeTime = null;
        object.openTrigger = options.enums === String ? "EN" : 0;
        object.closeTrigger = options.enums === String ? "EN" : 0;
        object.netPoints = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.positionType != null && message.hasOwnProperty("positionType"))
        object.positionType = message.positionType;
      if (message.initialQuantity != null && message.hasOwnProperty("initialQuantity"))
        object.initialQuantity = message.initialQuantity;
      if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity"))
        object.closedQuantity = message.closedQuantity;
      if (message.netProfit != null && message.hasOwnProperty("netProfit"))
        object.netProfit = options.json && !isFinite(message.netProfit) ? String(message.netProfit) : message.netProfit;
      if (message.positionCostPrice != null && message.hasOwnProperty("positionCostPrice"))
        object.positionCostPrice = options.json && !isFinite(message.positionCostPrice) ? String(message.positionCostPrice) : message.positionCostPrice;
      if (message.positionClosedPrice != null && message.hasOwnProperty("positionClosedPrice"))
        object.positionClosedPrice = options.json && !isFinite(message.positionClosedPrice) ? String(message.positionClosedPrice) : message.positionClosedPrice;
      if (message.openTime != null && message.hasOwnProperty("openTime"))
        object.openTime = $root.google.protobuf.Timestamp.toObject(message.openTime, options);
      if (message.closeTime != null && message.hasOwnProperty("closeTime"))
        object.closeTime = $root.google.protobuf.Timestamp.toObject(message.closeTime, options);
      if (message.openTrigger != null && message.hasOwnProperty("openTrigger"))
        object.openTrigger = options.enums === String ? $root.models.BotDeal.Trigger[message.openTrigger] : message.openTrigger;
      if (message.closeTrigger != null && message.hasOwnProperty("closeTrigger"))
        object.closeTrigger = options.enums === String ? $root.models.BotDeal.Trigger[message.closeTrigger] : message.closeTrigger;
      if (message.netPoints != null && message.hasOwnProperty("netPoints"))
        object.netPoints = options.json && !isFinite(message.netPoints) ? String(message.netPoints) : message.netPoints;
      return object;
    };
    BotDeal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    BotDeal.Trigger = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "EN"] = 0;
      values[valuesById[1] = "EX"] = 1;
      values[valuesById[2] = "TP"] = 2;
      values[valuesById[3] = "SL"] = 3;
      return values;
    }();
    return BotDeal;
  }();
  models2.BotAsset = function() {
    function BotAsset(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BotAsset.prototype.time = null;
    BotAsset.prototype.nav = 0;
    BotAsset.prototype.equityReturn = 0;
    BotAsset.prototype.drawdown = 0;
    BotAsset.create = function create(properties) {
      return new BotAsset(properties);
    };
    BotAsset.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
      if (message.nav != null && Object.hasOwnProperty.call(message, "nav"))
        writer.uint32(17).double(message.nav);
      if (message.equityReturn != null && Object.hasOwnProperty.call(message, "equityReturn"))
        writer.uint32(25).double(message.equityReturn);
      if (message.drawdown != null && Object.hasOwnProperty.call(message, "drawdown"))
        writer.uint32(33).double(message.drawdown);
      return writer;
    };
    BotAsset.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BotAsset.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.BotAsset();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 2:
            message.nav = reader.double();
            break;
          case 3:
            message.equityReturn = reader.double();
            break;
          case 4:
            message.drawdown = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BotAsset.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BotAsset.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.nav != null && message.hasOwnProperty("nav")) {
        if (typeof message.nav !== "number")
          return "nav: number expected";
      }
      if (message.equityReturn != null && message.hasOwnProperty("equityReturn")) {
        if (typeof message.equityReturn !== "number")
          return "equityReturn: number expected";
      }
      if (message.drawdown != null && message.hasOwnProperty("drawdown")) {
        if (typeof message.drawdown !== "number")
          return "drawdown: number expected";
      }
      return null;
    };
    BotAsset.fromObject = function fromObject(object) {
      if (object instanceof $root.models.BotAsset)
        return object;
      let message = new $root.models.BotAsset();
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".models.BotAsset.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.nav != null)
        message.nav = Number(object.nav);
      if (object.equityReturn != null)
        message.equityReturn = Number(object.equityReturn);
      if (object.drawdown != null)
        message.drawdown = Number(object.drawdown);
      return message;
    };
    BotAsset.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.time = null;
        object.nav = 0;
        object.equityReturn = 0;
        object.drawdown = 0;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.nav != null && message.hasOwnProperty("nav"))
        object.nav = options.json && !isFinite(message.nav) ? String(message.nav) : message.nav;
      if (message.equityReturn != null && message.hasOwnProperty("equityReturn"))
        object.equityReturn = options.json && !isFinite(message.equityReturn) ? String(message.equityReturn) : message.equityReturn;
      if (message.drawdown != null && message.hasOwnProperty("drawdown"))
        object.drawdown = options.json && !isFinite(message.drawdown) ? String(message.drawdown) : message.drawdown;
      return object;
    };
    BotAsset.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BotAsset;
  }();
  models2.BotHeartbeat = function() {
    function BotHeartbeat(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BotHeartbeat.prototype.status = 0;
    BotHeartbeat.create = function create(properties) {
      return new BotHeartbeat(properties);
    };
    BotHeartbeat.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(8).int32(message.status);
      return writer;
    };
    BotHeartbeat.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BotHeartbeat.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.BotHeartbeat();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.status = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BotHeartbeat.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BotHeartbeat.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return null;
    };
    BotHeartbeat.fromObject = function fromObject(object) {
      if (object instanceof $root.models.BotHeartbeat)
        return object;
      let message = new $root.models.BotHeartbeat();
      switch (object.status) {
        case "STOPPED":
        case 0:
          message.status = 0;
          break;
        case "PENDNG_STOP":
        case 1:
          message.status = 1;
          break;
        case "RUNNING":
        case 2:
          message.status = 2;
          break;
      }
      return message;
    };
    BotHeartbeat.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.status = options.enums === String ? "STOPPED" : 0;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.models.BotHeartbeat.BotStatus[message.status] : message.status;
      return object;
    };
    BotHeartbeat.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    BotHeartbeat.BotStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "STOPPED"] = 0;
      values[valuesById[1] = "PENDNG_STOP"] = 1;
      values[valuesById[2] = "RUNNING"] = 2;
      return values;
    }();
    return BotHeartbeat;
  }();
  models2.BotOrder = function() {
    function BotOrder(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BotOrder.prototype.investorId = 0;
    BotOrder.prototype.destination = "";
    BotOrder.prototype.direction = 0;
    BotOrder.prototype.quantity = 0;
    BotOrder.prototype.price = 0;
    BotOrder.prototype.triggeredBy = "";
    BotOrder.prototype.symbol = "";
    BotOrder.prototype.orderType = "";
    BotOrder.prototype.investorAccountId = 0;
    BotOrder.prototype.dealId = 0;
    BotOrder.create = function create(properties) {
      return new BotOrder(properties);
    };
    BotOrder.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int32(message.investorId);
      if (message.destination != null && Object.hasOwnProperty.call(message, "destination"))
        writer.uint32(18).string(message.destination);
      if (message.direction != null && Object.hasOwnProperty.call(message, "direction"))
        writer.uint32(24).int32(message.direction);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(32).int32(message.quantity);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(41).double(message.price);
      if (message.triggeredBy != null && Object.hasOwnProperty.call(message, "triggeredBy"))
        writer.uint32(50).string(message.triggeredBy);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(58).string(message.symbol);
      if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
        writer.uint32(66).string(message.orderType);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(72).int32(message.investorAccountId);
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(80).int32(message.dealId);
      return writer;
    };
    BotOrder.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BotOrder.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.BotOrder();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int32();
            break;
          case 2:
            message.destination = reader.string();
            break;
          case 3:
            message.direction = reader.int32();
            break;
          case 4:
            message.quantity = reader.int32();
            break;
          case 5:
            message.price = reader.double();
            break;
          case 6:
            message.triggeredBy = reader.string();
            break;
          case 7:
            message.symbol = reader.string();
            break;
          case 8:
            message.orderType = reader.string();
            break;
          case 9:
            message.investorAccountId = reader.int32();
            break;
          case 10:
            message.dealId = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BotOrder.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BotOrder.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.destination != null && message.hasOwnProperty("destination")) {
        if (!$util.isString(message.destination))
          return "destination: string expected";
      }
      if (message.direction != null && message.hasOwnProperty("direction"))
        switch (message.direction) {
          default:
            return "direction: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity))
          return "quantity: integer expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.triggeredBy != null && message.hasOwnProperty("triggeredBy")) {
        if (!$util.isString(message.triggeredBy))
          return "triggeredBy: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.orderType != null && message.hasOwnProperty("orderType")) {
        if (!$util.isString(message.orderType))
          return "orderType: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId))
          return "dealId: integer expected";
      }
      return null;
    };
    BotOrder.fromObject = function fromObject(object) {
      if (object instanceof $root.models.BotOrder)
        return object;
      let message = new $root.models.BotOrder();
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.destination != null)
        message.destination = String(object.destination);
      switch (object.direction) {
        case "BUY":
        case 0:
          message.direction = 0;
          break;
        case "SELL":
        case 1:
          message.direction = 1;
          break;
      }
      if (object.quantity != null)
        message.quantity = object.quantity | 0;
      if (object.price != null)
        message.price = Number(object.price);
      if (object.triggeredBy != null)
        message.triggeredBy = String(object.triggeredBy);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.orderType != null)
        message.orderType = String(object.orderType);
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.dealId != null)
        message.dealId = object.dealId | 0;
      return message;
    };
    BotOrder.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = 0;
        object.destination = "";
        object.direction = options.enums === String ? "BUY" : 0;
        object.quantity = 0;
        object.price = 0;
        object.triggeredBy = "";
        object.symbol = "";
        object.orderType = "";
        object.investorAccountId = 0;
        object.dealId = 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.destination != null && message.hasOwnProperty("destination"))
        object.destination = message.destination;
      if (message.direction != null && message.hasOwnProperty("direction"))
        object.direction = options.enums === String ? $root.models.BotOrder.BotOrderDirection[message.direction] : message.direction;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        object.quantity = message.quantity;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.triggeredBy != null && message.hasOwnProperty("triggeredBy"))
        object.triggeredBy = message.triggeredBy;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.orderType != null && message.hasOwnProperty("orderType"))
        object.orderType = message.orderType;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        object.dealId = message.dealId;
      return object;
    };
    BotOrder.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    BotOrder.BotOrderDirection = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "BUY"] = 0;
      values[valuesById[1] = "SELL"] = 1;
      return values;
    }();
    return BotOrder;
  }();
  models2.Transaction = function() {
    function Transaction(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Transaction.prototype.id = 0;
    Transaction.prototype.actor = "";
    Transaction.prototype.investorId = 0;
    Transaction.prototype.bankAccountId = 0;
    Transaction.prototype.transactionType = "";
    Transaction.prototype.amount = 0;
    Transaction.create = function create(properties) {
      return new Transaction(properties);
    };
    Transaction.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
        writer.uint32(18).string(message.actor);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(24).int32(message.investorId);
      if (message.bankAccountId != null && Object.hasOwnProperty.call(message, "bankAccountId"))
        writer.uint32(32).int32(message.bankAccountId);
      if (message.transactionType != null && Object.hasOwnProperty.call(message, "transactionType"))
        writer.uint32(42).string(message.transactionType);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(49).double(message.amount);
      return writer;
    };
    Transaction.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Transaction.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Transaction();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.actor = reader.string();
            break;
          case 3:
            message.investorId = reader.int32();
            break;
          case 4:
            message.bankAccountId = reader.int32();
            break;
          case 5:
            message.transactionType = reader.string();
            break;
          case 6:
            message.amount = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Transaction.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Transaction.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.actor != null && message.hasOwnProperty("actor")) {
        if (!$util.isString(message.actor))
          return "actor: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.bankAccountId != null && message.hasOwnProperty("bankAccountId")) {
        if (!$util.isInteger(message.bankAccountId))
          return "bankAccountId: integer expected";
      }
      if (message.transactionType != null && message.hasOwnProperty("transactionType")) {
        if (!$util.isString(message.transactionType))
          return "transactionType: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      return null;
    };
    Transaction.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Transaction)
        return object;
      let message = new $root.models.Transaction();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.actor != null)
        message.actor = String(object.actor);
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.bankAccountId != null)
        message.bankAccountId = object.bankAccountId | 0;
      if (object.transactionType != null)
        message.transactionType = String(object.transactionType);
      if (object.amount != null)
        message.amount = Number(object.amount);
      return message;
    };
    Transaction.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.actor = "";
        object.investorId = 0;
        object.bankAccountId = 0;
        object.transactionType = "";
        object.amount = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.actor != null && message.hasOwnProperty("actor"))
        object.actor = message.actor;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.bankAccountId != null && message.hasOwnProperty("bankAccountId"))
        object.bankAccountId = message.bankAccountId;
      if (message.transactionType != null && message.hasOwnProperty("transactionType"))
        object.transactionType = message.transactionType;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      return object;
    };
    Transaction.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Transaction;
  }();
  models2.HoldOvernightAlert = function() {
    function HoldOvernightAlert(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    HoldOvernightAlert.prototype.investorId = 0;
    HoldOvernightAlert.prototype.investorAccountId = 0;
    HoldOvernightAlert.prototype.overnightRate = 0;
    HoldOvernightAlert.prototype.estimatedOvernightSecure = 0;
    HoldOvernightAlert.prototype.cutoffTime = null;
    HoldOvernightAlert.create = function create(properties) {
      return new HoldOvernightAlert(properties);
    };
    HoldOvernightAlert.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int32(message.investorId);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(16).int32(message.investorAccountId);
      if (message.overnightRate != null && Object.hasOwnProperty.call(message, "overnightRate"))
        writer.uint32(25).double(message.overnightRate);
      if (message.estimatedOvernightSecure != null && Object.hasOwnProperty.call(message, "estimatedOvernightSecure"))
        writer.uint32(33).double(message.estimatedOvernightSecure);
      if (message.cutoffTime != null && Object.hasOwnProperty.call(message, "cutoffTime"))
        $root.google.protobuf.Timestamp.encode(message.cutoffTime, writer.uint32(42).fork()).ldelim();
      return writer;
    };
    HoldOvernightAlert.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    HoldOvernightAlert.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.HoldOvernightAlert();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int32();
            break;
          case 2:
            message.investorAccountId = reader.int32();
            break;
          case 3:
            message.overnightRate = reader.double();
            break;
          case 4:
            message.estimatedOvernightSecure = reader.double();
            break;
          case 5:
            message.cutoffTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    HoldOvernightAlert.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    HoldOvernightAlert.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.overnightRate != null && message.hasOwnProperty("overnightRate")) {
        if (typeof message.overnightRate !== "number")
          return "overnightRate: number expected";
      }
      if (message.estimatedOvernightSecure != null && message.hasOwnProperty("estimatedOvernightSecure")) {
        if (typeof message.estimatedOvernightSecure !== "number")
          return "estimatedOvernightSecure: number expected";
      }
      if (message.cutoffTime != null && message.hasOwnProperty("cutoffTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.cutoffTime);
        if (error)
          return "cutoffTime." + error;
      }
      return null;
    };
    HoldOvernightAlert.fromObject = function fromObject(object) {
      if (object instanceof $root.models.HoldOvernightAlert)
        return object;
      let message = new $root.models.HoldOvernightAlert();
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.overnightRate != null)
        message.overnightRate = Number(object.overnightRate);
      if (object.estimatedOvernightSecure != null)
        message.estimatedOvernightSecure = Number(object.estimatedOvernightSecure);
      if (object.cutoffTime != null) {
        if (typeof object.cutoffTime !== "object")
          throw TypeError(".models.HoldOvernightAlert.cutoffTime: object expected");
        message.cutoffTime = $root.google.protobuf.Timestamp.fromObject(object.cutoffTime);
      }
      return message;
    };
    HoldOvernightAlert.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = 0;
        object.investorAccountId = 0;
        object.overnightRate = 0;
        object.estimatedOvernightSecure = 0;
        object.cutoffTime = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.overnightRate != null && message.hasOwnProperty("overnightRate"))
        object.overnightRate = options.json && !isFinite(message.overnightRate) ? String(message.overnightRate) : message.overnightRate;
      if (message.estimatedOvernightSecure != null && message.hasOwnProperty("estimatedOvernightSecure"))
        object.estimatedOvernightSecure = options.json && !isFinite(message.estimatedOvernightSecure) ? String(message.estimatedOvernightSecure) : message.estimatedOvernightSecure;
      if (message.cutoffTime != null && message.hasOwnProperty("cutoffTime"))
        object.cutoffTime = $root.google.protobuf.Timestamp.toObject(message.cutoffTime, options);
      return object;
    };
    HoldOvernightAlert.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return HoldOvernightAlert;
  }();
  models2.InvestorAccount = function() {
    function InvestorAccount(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InvestorAccount.prototype.id = 0;
    InvestorAccount.prototype.investorId = 0;
    InvestorAccount.prototype.totalCash = 0;
    InvestorAccount.prototype.orderSecure = 0;
    InvestorAccount.prototype.dealSecure = 0;
    InvestorAccount.prototype.tradingFeeSecure = 0;
    InvestorAccount.prototype.createdDate = null;
    InvestorAccount.prototype.modifiedDate = null;
    InvestorAccount.prototype.sellingTaxSecure = 0;
    InvestorAccount.prototype.orderMoneyAdvanceFeeSecure = 0;
    InvestorAccount.prototype.receivable = 0;
    InvestorAccount.prototype.derivativeDealSecure = 0;
    InvestorAccount.prototype.derivativeOrderSecure = 0;
    InvestorAccount.prototype.netDerivativeOrderSecure = 0;
    InvestorAccount.prototype.taxCredit = 0;
    InvestorAccount.prototype.initCash = 0;
    InvestorAccount.prototype.holdOvernightSecure = 0;
    InvestorAccount.prototype.referenceBonus = 0;
    InvestorAccount.prototype.originalReferenceBonus = 0;
    InvestorAccount.prototype.type = "";
    InvestorAccount.prototype.status = "";
    InvestorAccount.prototype.cashOnHand = 0;
    InvestorAccount.prototype.remainDebt = 0;
    InvestorAccount.prototype.lastOrderAge = 0;
    InvestorAccount.prototype.lastActionAge = 0;
    InvestorAccount.create = function create(properties) {
      return new InvestorAccount(properties);
    };
    InvestorAccount.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(16).int32(message.investorId);
      if (message.totalCash != null && Object.hasOwnProperty.call(message, "totalCash"))
        writer.uint32(25).double(message.totalCash);
      if (message.orderSecure != null && Object.hasOwnProperty.call(message, "orderSecure"))
        writer.uint32(33).double(message.orderSecure);
      if (message.dealSecure != null && Object.hasOwnProperty.call(message, "dealSecure"))
        writer.uint32(41).double(message.dealSecure);
      if (message.tradingFeeSecure != null && Object.hasOwnProperty.call(message, "tradingFeeSecure"))
        writer.uint32(49).double(message.tradingFeeSecure);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(66).fork()).ldelim();
      if (message.sellingTaxSecure != null && Object.hasOwnProperty.call(message, "sellingTaxSecure"))
        writer.uint32(73).double(message.sellingTaxSecure);
      if (message.orderMoneyAdvanceFeeSecure != null && Object.hasOwnProperty.call(message, "orderMoneyAdvanceFeeSecure"))
        writer.uint32(81).double(message.orderMoneyAdvanceFeeSecure);
      if (message.receivable != null && Object.hasOwnProperty.call(message, "receivable"))
        writer.uint32(89).double(message.receivable);
      if (message.derivativeDealSecure != null && Object.hasOwnProperty.call(message, "derivativeDealSecure"))
        writer.uint32(97).double(message.derivativeDealSecure);
      if (message.derivativeOrderSecure != null && Object.hasOwnProperty.call(message, "derivativeOrderSecure"))
        writer.uint32(105).double(message.derivativeOrderSecure);
      if (message.netDerivativeOrderSecure != null && Object.hasOwnProperty.call(message, "netDerivativeOrderSecure"))
        writer.uint32(113).double(message.netDerivativeOrderSecure);
      if (message.taxCredit != null && Object.hasOwnProperty.call(message, "taxCredit"))
        writer.uint32(121).double(message.taxCredit);
      if (message.initCash != null && Object.hasOwnProperty.call(message, "initCash"))
        writer.uint32(129).double(message.initCash);
      if (message.holdOvernightSecure != null && Object.hasOwnProperty.call(message, "holdOvernightSecure"))
        writer.uint32(137).double(message.holdOvernightSecure);
      if (message.referenceBonus != null && Object.hasOwnProperty.call(message, "referenceBonus"))
        writer.uint32(145).double(message.referenceBonus);
      if (message.originalReferenceBonus != null && Object.hasOwnProperty.call(message, "originalReferenceBonus"))
        writer.uint32(153).double(message.originalReferenceBonus);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(162).string(message.type);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(170).string(message.status);
      if (message.cashOnHand != null && Object.hasOwnProperty.call(message, "cashOnHand"))
        writer.uint32(177).double(message.cashOnHand);
      if (message.remainDebt != null && Object.hasOwnProperty.call(message, "remainDebt"))
        writer.uint32(185).double(message.remainDebt);
      if (message.lastOrderAge != null && Object.hasOwnProperty.call(message, "lastOrderAge"))
        writer.uint32(192).int32(message.lastOrderAge);
      if (message.lastActionAge != null && Object.hasOwnProperty.call(message, "lastActionAge"))
        writer.uint32(200).int32(message.lastActionAge);
      return writer;
    };
    InvestorAccount.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InvestorAccount.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.InvestorAccount();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.investorId = reader.int32();
            break;
          case 3:
            message.totalCash = reader.double();
            break;
          case 4:
            message.orderSecure = reader.double();
            break;
          case 5:
            message.dealSecure = reader.double();
            break;
          case 6:
            message.tradingFeeSecure = reader.double();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.sellingTaxSecure = reader.double();
            break;
          case 10:
            message.orderMoneyAdvanceFeeSecure = reader.double();
            break;
          case 11:
            message.receivable = reader.double();
            break;
          case 12:
            message.derivativeDealSecure = reader.double();
            break;
          case 13:
            message.derivativeOrderSecure = reader.double();
            break;
          case 14:
            message.netDerivativeOrderSecure = reader.double();
            break;
          case 15:
            message.taxCredit = reader.double();
            break;
          case 16:
            message.initCash = reader.double();
            break;
          case 17:
            message.holdOvernightSecure = reader.double();
            break;
          case 18:
            message.referenceBonus = reader.double();
            break;
          case 19:
            message.originalReferenceBonus = reader.double();
            break;
          case 20:
            message.type = reader.string();
            break;
          case 21:
            message.status = reader.string();
            break;
          case 22:
            message.cashOnHand = reader.double();
            break;
          case 23:
            message.remainDebt = reader.double();
            break;
          case 24:
            message.lastOrderAge = reader.int32();
            break;
          case 25:
            message.lastActionAge = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InvestorAccount.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InvestorAccount.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.totalCash != null && message.hasOwnProperty("totalCash")) {
        if (typeof message.totalCash !== "number")
          return "totalCash: number expected";
      }
      if (message.orderSecure != null && message.hasOwnProperty("orderSecure")) {
        if (typeof message.orderSecure !== "number")
          return "orderSecure: number expected";
      }
      if (message.dealSecure != null && message.hasOwnProperty("dealSecure")) {
        if (typeof message.dealSecure !== "number")
          return "dealSecure: number expected";
      }
      if (message.tradingFeeSecure != null && message.hasOwnProperty("tradingFeeSecure")) {
        if (typeof message.tradingFeeSecure !== "number")
          return "tradingFeeSecure: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.sellingTaxSecure != null && message.hasOwnProperty("sellingTaxSecure")) {
        if (typeof message.sellingTaxSecure !== "number")
          return "sellingTaxSecure: number expected";
      }
      if (message.orderMoneyAdvanceFeeSecure != null && message.hasOwnProperty("orderMoneyAdvanceFeeSecure")) {
        if (typeof message.orderMoneyAdvanceFeeSecure !== "number")
          return "orderMoneyAdvanceFeeSecure: number expected";
      }
      if (message.receivable != null && message.hasOwnProperty("receivable")) {
        if (typeof message.receivable !== "number")
          return "receivable: number expected";
      }
      if (message.derivativeDealSecure != null && message.hasOwnProperty("derivativeDealSecure")) {
        if (typeof message.derivativeDealSecure !== "number")
          return "derivativeDealSecure: number expected";
      }
      if (message.derivativeOrderSecure != null && message.hasOwnProperty("derivativeOrderSecure")) {
        if (typeof message.derivativeOrderSecure !== "number")
          return "derivativeOrderSecure: number expected";
      }
      if (message.netDerivativeOrderSecure != null && message.hasOwnProperty("netDerivativeOrderSecure")) {
        if (typeof message.netDerivativeOrderSecure !== "number")
          return "netDerivativeOrderSecure: number expected";
      }
      if (message.taxCredit != null && message.hasOwnProperty("taxCredit")) {
        if (typeof message.taxCredit !== "number")
          return "taxCredit: number expected";
      }
      if (message.initCash != null && message.hasOwnProperty("initCash")) {
        if (typeof message.initCash !== "number")
          return "initCash: number expected";
      }
      if (message.holdOvernightSecure != null && message.hasOwnProperty("holdOvernightSecure")) {
        if (typeof message.holdOvernightSecure !== "number")
          return "holdOvernightSecure: number expected";
      }
      if (message.referenceBonus != null && message.hasOwnProperty("referenceBonus")) {
        if (typeof message.referenceBonus !== "number")
          return "referenceBonus: number expected";
      }
      if (message.originalReferenceBonus != null && message.hasOwnProperty("originalReferenceBonus")) {
        if (typeof message.originalReferenceBonus !== "number")
          return "originalReferenceBonus: number expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.cashOnHand != null && message.hasOwnProperty("cashOnHand")) {
        if (typeof message.cashOnHand !== "number")
          return "cashOnHand: number expected";
      }
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt")) {
        if (typeof message.remainDebt !== "number")
          return "remainDebt: number expected";
      }
      if (message.lastOrderAge != null && message.hasOwnProperty("lastOrderAge")) {
        if (!$util.isInteger(message.lastOrderAge))
          return "lastOrderAge: integer expected";
      }
      if (message.lastActionAge != null && message.hasOwnProperty("lastActionAge")) {
        if (!$util.isInteger(message.lastActionAge))
          return "lastActionAge: integer expected";
      }
      return null;
    };
    InvestorAccount.fromObject = function fromObject(object) {
      if (object instanceof $root.models.InvestorAccount)
        return object;
      let message = new $root.models.InvestorAccount();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.totalCash != null)
        message.totalCash = Number(object.totalCash);
      if (object.orderSecure != null)
        message.orderSecure = Number(object.orderSecure);
      if (object.dealSecure != null)
        message.dealSecure = Number(object.dealSecure);
      if (object.tradingFeeSecure != null)
        message.tradingFeeSecure = Number(object.tradingFeeSecure);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.InvestorAccount.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".models.InvestorAccount.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.sellingTaxSecure != null)
        message.sellingTaxSecure = Number(object.sellingTaxSecure);
      if (object.orderMoneyAdvanceFeeSecure != null)
        message.orderMoneyAdvanceFeeSecure = Number(object.orderMoneyAdvanceFeeSecure);
      if (object.receivable != null)
        message.receivable = Number(object.receivable);
      if (object.derivativeDealSecure != null)
        message.derivativeDealSecure = Number(object.derivativeDealSecure);
      if (object.derivativeOrderSecure != null)
        message.derivativeOrderSecure = Number(object.derivativeOrderSecure);
      if (object.netDerivativeOrderSecure != null)
        message.netDerivativeOrderSecure = Number(object.netDerivativeOrderSecure);
      if (object.taxCredit != null)
        message.taxCredit = Number(object.taxCredit);
      if (object.initCash != null)
        message.initCash = Number(object.initCash);
      if (object.holdOvernightSecure != null)
        message.holdOvernightSecure = Number(object.holdOvernightSecure);
      if (object.referenceBonus != null)
        message.referenceBonus = Number(object.referenceBonus);
      if (object.originalReferenceBonus != null)
        message.originalReferenceBonus = Number(object.originalReferenceBonus);
      if (object.type != null)
        message.type = String(object.type);
      if (object.status != null)
        message.status = String(object.status);
      if (object.cashOnHand != null)
        message.cashOnHand = Number(object.cashOnHand);
      if (object.remainDebt != null)
        message.remainDebt = Number(object.remainDebt);
      if (object.lastOrderAge != null)
        message.lastOrderAge = object.lastOrderAge | 0;
      if (object.lastActionAge != null)
        message.lastActionAge = object.lastActionAge | 0;
      return message;
    };
    InvestorAccount.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.investorId = 0;
        object.totalCash = 0;
        object.orderSecure = 0;
        object.dealSecure = 0;
        object.tradingFeeSecure = 0;
        object.createdDate = null;
        object.modifiedDate = null;
        object.sellingTaxSecure = 0;
        object.orderMoneyAdvanceFeeSecure = 0;
        object.receivable = 0;
        object.derivativeDealSecure = 0;
        object.derivativeOrderSecure = 0;
        object.netDerivativeOrderSecure = 0;
        object.taxCredit = 0;
        object.initCash = 0;
        object.holdOvernightSecure = 0;
        object.referenceBonus = 0;
        object.originalReferenceBonus = 0;
        object.type = "";
        object.status = "";
        object.cashOnHand = 0;
        object.remainDebt = 0;
        object.lastOrderAge = 0;
        object.lastActionAge = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.totalCash != null && message.hasOwnProperty("totalCash"))
        object.totalCash = options.json && !isFinite(message.totalCash) ? String(message.totalCash) : message.totalCash;
      if (message.orderSecure != null && message.hasOwnProperty("orderSecure"))
        object.orderSecure = options.json && !isFinite(message.orderSecure) ? String(message.orderSecure) : message.orderSecure;
      if (message.dealSecure != null && message.hasOwnProperty("dealSecure"))
        object.dealSecure = options.json && !isFinite(message.dealSecure) ? String(message.dealSecure) : message.dealSecure;
      if (message.tradingFeeSecure != null && message.hasOwnProperty("tradingFeeSecure"))
        object.tradingFeeSecure = options.json && !isFinite(message.tradingFeeSecure) ? String(message.tradingFeeSecure) : message.tradingFeeSecure;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.sellingTaxSecure != null && message.hasOwnProperty("sellingTaxSecure"))
        object.sellingTaxSecure = options.json && !isFinite(message.sellingTaxSecure) ? String(message.sellingTaxSecure) : message.sellingTaxSecure;
      if (message.orderMoneyAdvanceFeeSecure != null && message.hasOwnProperty("orderMoneyAdvanceFeeSecure"))
        object.orderMoneyAdvanceFeeSecure = options.json && !isFinite(message.orderMoneyAdvanceFeeSecure) ? String(message.orderMoneyAdvanceFeeSecure) : message.orderMoneyAdvanceFeeSecure;
      if (message.receivable != null && message.hasOwnProperty("receivable"))
        object.receivable = options.json && !isFinite(message.receivable) ? String(message.receivable) : message.receivable;
      if (message.derivativeDealSecure != null && message.hasOwnProperty("derivativeDealSecure"))
        object.derivativeDealSecure = options.json && !isFinite(message.derivativeDealSecure) ? String(message.derivativeDealSecure) : message.derivativeDealSecure;
      if (message.derivativeOrderSecure != null && message.hasOwnProperty("derivativeOrderSecure"))
        object.derivativeOrderSecure = options.json && !isFinite(message.derivativeOrderSecure) ? String(message.derivativeOrderSecure) : message.derivativeOrderSecure;
      if (message.netDerivativeOrderSecure != null && message.hasOwnProperty("netDerivativeOrderSecure"))
        object.netDerivativeOrderSecure = options.json && !isFinite(message.netDerivativeOrderSecure) ? String(message.netDerivativeOrderSecure) : message.netDerivativeOrderSecure;
      if (message.taxCredit != null && message.hasOwnProperty("taxCredit"))
        object.taxCredit = options.json && !isFinite(message.taxCredit) ? String(message.taxCredit) : message.taxCredit;
      if (message.initCash != null && message.hasOwnProperty("initCash"))
        object.initCash = options.json && !isFinite(message.initCash) ? String(message.initCash) : message.initCash;
      if (message.holdOvernightSecure != null && message.hasOwnProperty("holdOvernightSecure"))
        object.holdOvernightSecure = options.json && !isFinite(message.holdOvernightSecure) ? String(message.holdOvernightSecure) : message.holdOvernightSecure;
      if (message.referenceBonus != null && message.hasOwnProperty("referenceBonus"))
        object.referenceBonus = options.json && !isFinite(message.referenceBonus) ? String(message.referenceBonus) : message.referenceBonus;
      if (message.originalReferenceBonus != null && message.hasOwnProperty("originalReferenceBonus"))
        object.originalReferenceBonus = options.json && !isFinite(message.originalReferenceBonus) ? String(message.originalReferenceBonus) : message.originalReferenceBonus;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.cashOnHand != null && message.hasOwnProperty("cashOnHand"))
        object.cashOnHand = options.json && !isFinite(message.cashOnHand) ? String(message.cashOnHand) : message.cashOnHand;
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt"))
        object.remainDebt = options.json && !isFinite(message.remainDebt) ? String(message.remainDebt) : message.remainDebt;
      if (message.lastOrderAge != null && message.hasOwnProperty("lastOrderAge"))
        object.lastOrderAge = message.lastOrderAge;
      if (message.lastActionAge != null && message.hasOwnProperty("lastActionAge"))
        object.lastActionAge = message.lastActionAge;
      return object;
    };
    InvestorAccount.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return InvestorAccount;
  }();
  models2.CampaignEmailVerification = function() {
    function CampaignEmailVerification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CampaignEmailVerification.prototype.email = "";
    CampaignEmailVerification.prototype.token = "";
    CampaignEmailVerification.prototype.fullName = "";
    CampaignEmailVerification.create = function create(properties) {
      return new CampaignEmailVerification(properties);
    };
    CampaignEmailVerification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(10).string(message.email);
      if (message.token != null && Object.hasOwnProperty.call(message, "token"))
        writer.uint32(18).string(message.token);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(26).string(message.fullName);
      return writer;
    };
    CampaignEmailVerification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CampaignEmailVerification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.CampaignEmailVerification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.email = reader.string();
            break;
          case 2:
            message.token = reader.string();
            break;
          case 3:
            message.fullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CampaignEmailVerification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CampaignEmailVerification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.token != null && message.hasOwnProperty("token")) {
        if (!$util.isString(message.token))
          return "token: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      return null;
    };
    CampaignEmailVerification.fromObject = function fromObject(object) {
      if (object instanceof $root.models.CampaignEmailVerification)
        return object;
      let message = new $root.models.CampaignEmailVerification();
      if (object.email != null)
        message.email = String(object.email);
      if (object.token != null)
        message.token = String(object.token);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      return message;
    };
    CampaignEmailVerification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.email = "";
        object.token = "";
        object.fullName = "";
      }
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.token != null && message.hasOwnProperty("token"))
        object.token = message.token;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      return object;
    };
    CampaignEmailVerification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CampaignEmailVerification;
  }();
  models2.EnIdUser = function() {
    function EnIdUser(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EnIdUser.prototype.id = "";
    EnIdUser.prototype.username = "";
    EnIdUser.prototype.name = "";
    EnIdUser.prototype.email = "";
    EnIdUser.prototype.mobile = "";
    EnIdUser.prototype.status = "";
    EnIdUser.prototype.temporaryPassword = false;
    EnIdUser.prototype.emailVerified = false;
    EnIdUser.prototype.mobileVerified = false;
    EnIdUser.prototype.createdDate = null;
    EnIdUser.prototype.modifiedDate = null;
    EnIdUser.prototype.extraData = "";
    EnIdUser.create = function create(properties) {
      return new EnIdUser(properties);
    };
    EnIdUser.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.username != null && Object.hasOwnProperty.call(message, "username"))
        writer.uint32(18).string(message.username);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(26).string(message.name);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(34).string(message.email);
      if (message.mobile != null && Object.hasOwnProperty.call(message, "mobile"))
        writer.uint32(42).string(message.mobile);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(50).string(message.status);
      if (message.temporaryPassword != null && Object.hasOwnProperty.call(message, "temporaryPassword"))
        writer.uint32(56).bool(message.temporaryPassword);
      if (message.emailVerified != null && Object.hasOwnProperty.call(message, "emailVerified"))
        writer.uint32(64).bool(message.emailVerified);
      if (message.mobileVerified != null && Object.hasOwnProperty.call(message, "mobileVerified"))
        writer.uint32(72).bool(message.mobileVerified);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(90).fork()).ldelim();
      if (message.extraData != null && Object.hasOwnProperty.call(message, "extraData"))
        writer.uint32(98).string(message.extraData);
      return writer;
    };
    EnIdUser.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EnIdUser.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.EnIdUser();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.username = reader.string();
            break;
          case 3:
            message.name = reader.string();
            break;
          case 4:
            message.email = reader.string();
            break;
          case 5:
            message.mobile = reader.string();
            break;
          case 6:
            message.status = reader.string();
            break;
          case 7:
            message.temporaryPassword = reader.bool();
            break;
          case 8:
            message.emailVerified = reader.bool();
            break;
          case 9:
            message.mobileVerified = reader.bool();
            break;
          case 10:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.extraData = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EnIdUser.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EnIdUser.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.username != null && message.hasOwnProperty("username")) {
        if (!$util.isString(message.username))
          return "username: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.mobile != null && message.hasOwnProperty("mobile")) {
        if (!$util.isString(message.mobile))
          return "mobile: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.temporaryPassword != null && message.hasOwnProperty("temporaryPassword")) {
        if (typeof message.temporaryPassword !== "boolean")
          return "temporaryPassword: boolean expected";
      }
      if (message.emailVerified != null && message.hasOwnProperty("emailVerified")) {
        if (typeof message.emailVerified !== "boolean")
          return "emailVerified: boolean expected";
      }
      if (message.mobileVerified != null && message.hasOwnProperty("mobileVerified")) {
        if (typeof message.mobileVerified !== "boolean")
          return "mobileVerified: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.extraData != null && message.hasOwnProperty("extraData")) {
        if (!$util.isString(message.extraData))
          return "extraData: string expected";
      }
      return null;
    };
    EnIdUser.fromObject = function fromObject(object) {
      if (object instanceof $root.models.EnIdUser)
        return object;
      let message = new $root.models.EnIdUser();
      if (object.id != null)
        message.id = String(object.id);
      if (object.username != null)
        message.username = String(object.username);
      if (object.name != null)
        message.name = String(object.name);
      if (object.email != null)
        message.email = String(object.email);
      if (object.mobile != null)
        message.mobile = String(object.mobile);
      if (object.status != null)
        message.status = String(object.status);
      if (object.temporaryPassword != null)
        message.temporaryPassword = Boolean(object.temporaryPassword);
      if (object.emailVerified != null)
        message.emailVerified = Boolean(object.emailVerified);
      if (object.mobileVerified != null)
        message.mobileVerified = Boolean(object.mobileVerified);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.EnIdUser.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".models.EnIdUser.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.extraData != null)
        message.extraData = String(object.extraData);
      return message;
    };
    EnIdUser.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.username = "";
        object.name = "";
        object.email = "";
        object.mobile = "";
        object.status = "";
        object.temporaryPassword = false;
        object.emailVerified = false;
        object.mobileVerified = false;
        object.createdDate = null;
        object.modifiedDate = null;
        object.extraData = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.username != null && message.hasOwnProperty("username"))
        object.username = message.username;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.mobile != null && message.hasOwnProperty("mobile"))
        object.mobile = message.mobile;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.temporaryPassword != null && message.hasOwnProperty("temporaryPassword"))
        object.temporaryPassword = message.temporaryPassword;
      if (message.emailVerified != null && message.hasOwnProperty("emailVerified"))
        object.emailVerified = message.emailVerified;
      if (message.mobileVerified != null && message.hasOwnProperty("mobileVerified"))
        object.mobileVerified = message.mobileVerified;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.extraData != null && message.hasOwnProperty("extraData"))
        object.extraData = message.extraData;
      return object;
    };
    EnIdUser.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EnIdUser;
  }();
  models2.EntradeDebtSnapshot = function() {
    function EntradeDebtSnapshot(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeDebtSnapshot.prototype.investorAccountId = 0;
    EntradeDebtSnapshot.prototype.remainDebt = 0;
    EntradeDebtSnapshot.prototype.remainInterest = 0;
    EntradeDebtSnapshot.prototype.createdDate = null;
    EntradeDebtSnapshot.create = function create(properties) {
      return new EntradeDebtSnapshot(properties);
    };
    EntradeDebtSnapshot.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(8).int32(message.investorAccountId);
      if (message.remainDebt != null && Object.hasOwnProperty.call(message, "remainDebt"))
        writer.uint32(17).double(message.remainDebt);
      if (message.remainInterest != null && Object.hasOwnProperty.call(message, "remainInterest"))
        writer.uint32(25).double(message.remainInterest);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    EntradeDebtSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeDebtSnapshot.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.EntradeDebtSnapshot();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorAccountId = reader.int32();
            break;
          case 2:
            message.remainDebt = reader.double();
            break;
          case 3:
            message.remainInterest = reader.double();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeDebtSnapshot.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeDebtSnapshot.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isInteger(message.investorAccountId))
          return "investorAccountId: integer expected";
      }
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt")) {
        if (typeof message.remainDebt !== "number")
          return "remainDebt: number expected";
      }
      if (message.remainInterest != null && message.hasOwnProperty("remainInterest")) {
        if (typeof message.remainInterest !== "number")
          return "remainInterest: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    EntradeDebtSnapshot.fromObject = function fromObject(object) {
      if (object instanceof $root.models.EntradeDebtSnapshot)
        return object;
      let message = new $root.models.EntradeDebtSnapshot();
      if (object.investorAccountId != null)
        message.investorAccountId = object.investorAccountId | 0;
      if (object.remainDebt != null)
        message.remainDebt = Number(object.remainDebt);
      if (object.remainInterest != null)
        message.remainInterest = Number(object.remainInterest);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.EntradeDebtSnapshot.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    EntradeDebtSnapshot.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorAccountId = 0;
        object.remainDebt = 0;
        object.remainInterest = 0;
        object.createdDate = null;
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt"))
        object.remainDebt = options.json && !isFinite(message.remainDebt) ? String(message.remainDebt) : message.remainDebt;
      if (message.remainInterest != null && message.hasOwnProperty("remainInterest"))
        object.remainInterest = options.json && !isFinite(message.remainInterest) ? String(message.remainInterest) : message.remainInterest;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    EntradeDebtSnapshot.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeDebtSnapshot;
  }();
  models2.Ping = function() {
    function Ping(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Ping.prototype.value = "";
    Ping.create = function create(properties) {
      return new Ping(properties);
    };
    Ping.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, "value"))
        writer.uint32(10).string(message.value);
      return writer;
    };
    Ping.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Ping.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.Ping();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.value = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Ping.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Ping.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.value != null && message.hasOwnProperty("value")) {
        if (!$util.isString(message.value))
          return "value: string expected";
      }
      return null;
    };
    Ping.fromObject = function fromObject(object) {
      if (object instanceof $root.models.Ping)
        return object;
      let message = new $root.models.Ping();
      if (object.value != null)
        message.value = String(object.value);
      return message;
    };
    Ping.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.value = "";
      if (message.value != null && message.hasOwnProperty("value"))
        object.value = message.value;
      return object;
    };
    Ping.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Ping;
  }();
  models2.EntradeDnseLink = function() {
    function EntradeDnseLink(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeDnseLink.prototype.id = 0;
    EntradeDnseLink.prototype.investorId = 0;
    EntradeDnseLink.prototype.dnseInvestorId = "";
    EntradeDnseLink.prototype.dnseCustodyCode = "";
    EntradeDnseLink.prototype.dnseDerivativeAccountNo = "";
    EntradeDnseLink.prototype.cosponsorBankId = 0;
    EntradeDnseLink.prototype.createdDate = null;
    EntradeDnseLink.prototype.modifiedDate = null;
    EntradeDnseLink.create = function create(properties) {
      return new EntradeDnseLink(properties);
    };
    EntradeDnseLink.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(16).int32(message.investorId);
      if (message.dnseInvestorId != null && Object.hasOwnProperty.call(message, "dnseInvestorId"))
        writer.uint32(26).string(message.dnseInvestorId);
      if (message.dnseCustodyCode != null && Object.hasOwnProperty.call(message, "dnseCustodyCode"))
        writer.uint32(34).string(message.dnseCustodyCode);
      if (message.dnseDerivativeAccountNo != null && Object.hasOwnProperty.call(message, "dnseDerivativeAccountNo"))
        writer.uint32(42).string(message.dnseDerivativeAccountNo);
      if (message.cosponsorBankId != null && Object.hasOwnProperty.call(message, "cosponsorBankId"))
        writer.uint32(48).int32(message.cosponsorBankId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    EntradeDnseLink.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeDnseLink.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.EntradeDnseLink();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.investorId = reader.int32();
            break;
          case 3:
            message.dnseInvestorId = reader.string();
            break;
          case 4:
            message.dnseCustodyCode = reader.string();
            break;
          case 5:
            message.dnseDerivativeAccountNo = reader.string();
            break;
          case 6:
            message.cosponsorBankId = reader.int32();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeDnseLink.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeDnseLink.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.dnseInvestorId != null && message.hasOwnProperty("dnseInvestorId")) {
        if (!$util.isString(message.dnseInvestorId))
          return "dnseInvestorId: string expected";
      }
      if (message.dnseCustodyCode != null && message.hasOwnProperty("dnseCustodyCode")) {
        if (!$util.isString(message.dnseCustodyCode))
          return "dnseCustodyCode: string expected";
      }
      if (message.dnseDerivativeAccountNo != null && message.hasOwnProperty("dnseDerivativeAccountNo")) {
        if (!$util.isString(message.dnseDerivativeAccountNo))
          return "dnseDerivativeAccountNo: string expected";
      }
      if (message.cosponsorBankId != null && message.hasOwnProperty("cosponsorBankId")) {
        if (!$util.isInteger(message.cosponsorBankId))
          return "cosponsorBankId: integer expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    EntradeDnseLink.fromObject = function fromObject(object) {
      if (object instanceof $root.models.EntradeDnseLink)
        return object;
      let message = new $root.models.EntradeDnseLink();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.dnseInvestorId != null)
        message.dnseInvestorId = String(object.dnseInvestorId);
      if (object.dnseCustodyCode != null)
        message.dnseCustodyCode = String(object.dnseCustodyCode);
      if (object.dnseDerivativeAccountNo != null)
        message.dnseDerivativeAccountNo = String(object.dnseDerivativeAccountNo);
      if (object.cosponsorBankId != null)
        message.cosponsorBankId = object.cosponsorBankId | 0;
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.EntradeDnseLink.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".models.EntradeDnseLink.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    EntradeDnseLink.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.investorId = 0;
        object.dnseInvestorId = "";
        object.dnseCustodyCode = "";
        object.dnseDerivativeAccountNo = "";
        object.cosponsorBankId = 0;
        object.createdDate = null;
        object.modifiedDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.dnseInvestorId != null && message.hasOwnProperty("dnseInvestorId"))
        object.dnseInvestorId = message.dnseInvestorId;
      if (message.dnseCustodyCode != null && message.hasOwnProperty("dnseCustodyCode"))
        object.dnseCustodyCode = message.dnseCustodyCode;
      if (message.dnseDerivativeAccountNo != null && message.hasOwnProperty("dnseDerivativeAccountNo"))
        object.dnseDerivativeAccountNo = message.dnseDerivativeAccountNo;
      if (message.cosponsorBankId != null && message.hasOwnProperty("cosponsorBankId"))
        object.cosponsorBankId = message.cosponsorBankId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    EntradeDnseLink.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeDnseLink;
  }();
  models2.DerivativeMarginPortfolioOffer = function() {
    function DerivativeMarginPortfolioOffer(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeMarginPortfolioOffer.prototype.id = "";
    DerivativeMarginPortfolioOffer.prototype.investorId = 0;
    DerivativeMarginPortfolioOffer.prototype.derivativeMarginPortfolioId = 0;
    DerivativeMarginPortfolioOffer.prototype.dnseLoanPackageId = 0;
    DerivativeMarginPortfolioOffer.prototype.status = "";
    DerivativeMarginPortfolioOffer.prototype.createdDate = null;
    DerivativeMarginPortfolioOffer.prototype.modifiedDate = null;
    DerivativeMarginPortfolioOffer.create = function create(properties) {
      return new DerivativeMarginPortfolioOffer(properties);
    };
    DerivativeMarginPortfolioOffer.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(16).int32(message.investorId);
      if (message.derivativeMarginPortfolioId != null && Object.hasOwnProperty.call(message, "derivativeMarginPortfolioId"))
        writer.uint32(24).int32(message.derivativeMarginPortfolioId);
      if (message.dnseLoanPackageId != null && Object.hasOwnProperty.call(message, "dnseLoanPackageId"))
        writer.uint32(32).int32(message.dnseLoanPackageId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(42).string(message.status);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    DerivativeMarginPortfolioOffer.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeMarginPortfolioOffer.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.models.DerivativeMarginPortfolioOffer();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.investorId = reader.int32();
            break;
          case 3:
            message.derivativeMarginPortfolioId = reader.int32();
            break;
          case 4:
            message.dnseLoanPackageId = reader.int32();
            break;
          case 5:
            message.status = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeMarginPortfolioOffer.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeMarginPortfolioOffer.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId))
          return "investorId: integer expected";
      }
      if (message.derivativeMarginPortfolioId != null && message.hasOwnProperty("derivativeMarginPortfolioId")) {
        if (!$util.isInteger(message.derivativeMarginPortfolioId))
          return "derivativeMarginPortfolioId: integer expected";
      }
      if (message.dnseLoanPackageId != null && message.hasOwnProperty("dnseLoanPackageId")) {
        if (!$util.isInteger(message.dnseLoanPackageId))
          return "dnseLoanPackageId: integer expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    DerivativeMarginPortfolioOffer.fromObject = function fromObject(object) {
      if (object instanceof $root.models.DerivativeMarginPortfolioOffer)
        return object;
      let message = new $root.models.DerivativeMarginPortfolioOffer();
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = object.investorId | 0;
      if (object.derivativeMarginPortfolioId != null)
        message.derivativeMarginPortfolioId = object.derivativeMarginPortfolioId | 0;
      if (object.dnseLoanPackageId != null)
        message.dnseLoanPackageId = object.dnseLoanPackageId | 0;
      if (object.status != null)
        message.status = String(object.status);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".models.DerivativeMarginPortfolioOffer.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".models.DerivativeMarginPortfolioOffer.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    DerivativeMarginPortfolioOffer.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.investorId = 0;
        object.derivativeMarginPortfolioId = 0;
        object.dnseLoanPackageId = 0;
        object.status = "";
        object.createdDate = null;
        object.modifiedDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.derivativeMarginPortfolioId != null && message.hasOwnProperty("derivativeMarginPortfolioId"))
        object.derivativeMarginPortfolioId = message.derivativeMarginPortfolioId;
      if (message.dnseLoanPackageId != null && message.hasOwnProperty("dnseLoanPackageId"))
        object.dnseLoanPackageId = message.dnseLoanPackageId;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    DerivativeMarginPortfolioOffer.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeMarginPortfolioOffer;
  }();
  return models2;
})();
const price = $root.price = (() => {
  const price2 = {};
  price2.FloorCode = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_FLOOR_CODE"] = 0;
    values[valuesById[2] = "HNX"] = 2;
    values[valuesById[3] = "UPCOM"] = 3;
    values[valuesById[4] = "HNX_BOND"] = 4;
    values[valuesById[10] = "HOSE"] = 10;
    values[valuesById[11] = "HOSE_ODD_LOT"] = 11;
    values[valuesById[12] = "HNX_DERIVATIVES"] = 12;
    values[valuesById[13] = "HNX_DERIVATIVE_BOND"] = 13;
    values[valuesById[14] = "HNX_PRIVATE_BOND"] = 14;
    return values;
  }();
  price2.TradingSession = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "OPEN"] = 0;
    values[valuesById[13] = "CLOSED"] = 13;
    values[valuesById[12] = "DONE"] = 12;
    values[valuesById[10] = "NOON_BREAK"] = 10;
    values[valuesById[3] = "START_MIDSESSION_BREAK"] = 3;
    values[valuesById[1] = "DONE_MIDSESSION_BREAK"] = 1;
    values[valuesById[2] = "ATO"] = 2;
    values[valuesById[9] = "ATC"] = 9;
    values[valuesById[35] = "PUT_THROUGH"] = 35;
    values[valuesById[5] = "CONTINUOUS"] = 5;
    values[valuesById[7] = "STOP_ALL_TRADE"] = 7;
    values[valuesById[8] = "RESUME_ALL_TRADE"] = 8;
    values[valuesById[6] = "RESUME_TRADE_SYMBOL"] = 6;
    values[valuesById[11] = "END_ALL"] = 11;
    values[valuesById[36] = "UNKNOWN_SESSION"] = 36;
    return values;
  }();
  price2.TradingStatus = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BINH_THUONG"] = 0;
    values[valuesById[1] = "KHONG_GIAO_DICH_TRONG_NGAY"] = 1;
    values[valuesById[2] = "NGUNG_GIAO_DICH"] = 2;
    values[valuesById[6] = "HUY_NIEM_YET"] = 6;
    values[valuesById[7] = "NIEM_YET_MOI"] = 7;
    values[valuesById[8] = "SAP_HUY_NIEM_YET"] = 8;
    values[valuesById[10] = "TAM_NGUNG_GIAO_DICH_GIUA_PHIEN"] = 10;
    values[valuesById[25] = "GIAO_DICH_DAC_BIET"] = 25;
    return values;
  }();
  price2.SecurityType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_TYPE"] = 0;
    values[valuesById[1] = "STOCK"] = 1;
    values[valuesById[2] = "BOND"] = 2;
    values[valuesById[3] = "MUTUAL_FUND"] = 3;
    values[valuesById[4] = "ETF"] = 4;
    values[valuesById[5] = "FUTURE"] = 5;
    values[valuesById[6] = "OPTION"] = 6;
    values[valuesById[7] = "COVERED_WARRANT"] = 7;
    values[valuesById[8] = "FUTURE_INDEX"] = 8;
    values[valuesById[9] = "FUTURE_BOND"] = 9;
    values[valuesById[10] = "CORPORATE_BOND"] = 10;
    values[valuesById[11] = "PRIVATE_BOND"] = 11;
    values[valuesById[100] = "ALL"] = 100;
    return values;
  }();
  price2.SecurityStatus = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_STATUS"] = 0;
    values[valuesById[1] = "NORMAL"] = 1;
    values[valuesById[2] = "HALT"] = 2;
    values[valuesById[3] = "SUSPENDED"] = 3;
    values[valuesById[4] = "SPECIAL"] = 4;
    values[valuesById[5] = "UNLISTED"] = 5;
    values[valuesById[6] = "NEW"] = 6;
    values[valuesById[7] = "AOM_HALT"] = 7;
    values[valuesById[8] = "PUT_THROUGH_HALT"] = 8;
    return values;
  }();
  price2.Session = function() {
    function Session(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Session.prototype.floorCode = 0;
    Session.prototype.session = 0;
    Session.prototype.time = null;
    Session.create = function create(properties) {
      return new Session(properties);
    };
    Session.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(8).int32(message.floorCode);
      if (message.session != null && Object.hasOwnProperty.call(message, "session"))
        writer.uint32(16).int32(message.session);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    Session.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Session.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.Session();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.floorCode = reader.int32();
            break;
          case 2:
            message.session = reader.int32();
            break;
          case 4:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Session.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Session.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        switch (message.floorCode) {
          default:
            return "floorCode: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.session != null && message.hasOwnProperty("session"))
        switch (message.session) {
          default:
            return "session: enum value expected";
          case 0:
          case 13:
          case 12:
          case 10:
          case 3:
          case 1:
          case 2:
          case 9:
          case 35:
          case 5:
          case 7:
          case 8:
          case 6:
          case 11:
          case 36:
            break;
        }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    Session.fromObject = function fromObject(object) {
      if (object instanceof $root.price.Session)
        return object;
      let message = new $root.price.Session();
      switch (object.floorCode) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floorCode = 0;
          break;
        case "HNX":
        case 2:
          message.floorCode = 2;
          break;
        case "UPCOM":
        case 3:
          message.floorCode = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floorCode = 4;
          break;
        case "HOSE":
        case 10:
          message.floorCode = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floorCode = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floorCode = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floorCode = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floorCode = 14;
          break;
      }
      switch (object.session) {
        case "OPEN":
        case 0:
          message.session = 0;
          break;
        case "CLOSED":
        case 13:
          message.session = 13;
          break;
        case "DONE":
        case 12:
          message.session = 12;
          break;
        case "NOON_BREAK":
        case 10:
          message.session = 10;
          break;
        case "START_MIDSESSION_BREAK":
        case 3:
          message.session = 3;
          break;
        case "DONE_MIDSESSION_BREAK":
        case 1:
          message.session = 1;
          break;
        case "ATO":
        case 2:
          message.session = 2;
          break;
        case "ATC":
        case 9:
          message.session = 9;
          break;
        case "PUT_THROUGH":
        case 35:
          message.session = 35;
          break;
        case "CONTINUOUS":
        case 5:
          message.session = 5;
          break;
        case "STOP_ALL_TRADE":
        case 7:
          message.session = 7;
          break;
        case "RESUME_ALL_TRADE":
        case 8:
          message.session = 8;
          break;
        case "RESUME_TRADE_SYMBOL":
        case 6:
          message.session = 6;
          break;
        case "END_ALL":
        case 11:
          message.session = 11;
          break;
        case "UNKNOWN_SESSION":
        case 36:
          message.session = 36;
          break;
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.Session.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    Session.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.floorCode = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        object.session = options.enums === String ? "OPEN" : 0;
        object.time = null;
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = options.enums === String ? $root.price.FloorCode[message.floorCode] : message.floorCode;
      if (message.session != null && message.hasOwnProperty("session"))
        object.session = options.enums === String ? $root.price.TradingSession[message.session] : message.session;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    Session.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Session;
  }();
  price2.StockInfo = function() {
    function StockInfo(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockInfo.prototype.floorCode = 0;
    StockInfo.prototype.symbol = "";
    StockInfo.prototype.tradingTime = null;
    StockInfo.prototype.securityType = 0;
    StockInfo.prototype.basicPrice = 0;
    StockInfo.prototype.ceilingPrice = 0;
    StockInfo.prototype.floorPrice = 0;
    StockInfo.prototype.highestPrice = 0;
    StockInfo.prototype.lowestPrice = 0;
    StockInfo.prototype.openPrice = 0;
    StockInfo.prototype.closePrice = 0;
    StockInfo.prototype.avgPrice = 0;
    StockInfo.prototype.buyForeignQtty = 0;
    StockInfo.prototype.sellForeignQtty = 0;
    StockInfo.prototype.tradingStatus = 0;
    StockInfo.prototype.currentRoom = 0;
    StockInfo.prototype.accumulatedVal = 0;
    StockInfo.prototype.accumulatedVol = 0;
    StockInfo.prototype.matchPrice = 0;
    StockInfo.prototype.matchQtty = 0;
    StockInfo.prototype.matchValue = 0;
    StockInfo.prototype.changed = 0;
    StockInfo.prototype.changedRatio = 0;
    StockInfo.prototype.estimatedPrice = 0;
    StockInfo.prototype.estimatedQuantity = 0;
    StockInfo.prototype.tradingSession = 0;
    StockInfo.prototype.offerQtty = 0;
    StockInfo.prototype.bidQtty = 0;
    StockInfo.prototype.securityStatus = 0;
    StockInfo.prototype.ceilingPricePT = 0;
    StockInfo.prototype.floorPricePT = 0;
    StockInfo.prototype.oddLotSecurityStatus = 0;
    StockInfo.prototype.currentPrice = 0;
    StockInfo.prototype.currentQtty = 0;
    StockInfo.prototype.lastTradingDate = null;
    StockInfo.prototype.openInterest = 0;
    StockInfo.prototype.symbolType = "";
    StockInfo.prototype.parValue = 0;
    StockInfo.prototype.receivedTime = null;
    StockInfo.create = function create(properties) {
      return new StockInfo(properties);
    };
    StockInfo.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(8).int32(message.floorCode);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.tradingTime != null && Object.hasOwnProperty.call(message, "tradingTime"))
        $root.google.protobuf.Timestamp.encode(message.tradingTime, writer.uint32(34).fork()).ldelim();
      if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
        writer.uint32(40).int32(message.securityType);
      if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
        writer.uint32(49).double(message.basicPrice);
      if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
        writer.uint32(57).double(message.ceilingPrice);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(65).double(message.floorPrice);
      if (message.highestPrice != null && Object.hasOwnProperty.call(message, "highestPrice"))
        writer.uint32(73).double(message.highestPrice);
      if (message.lowestPrice != null && Object.hasOwnProperty.call(message, "lowestPrice"))
        writer.uint32(81).double(message.lowestPrice);
      if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
        writer.uint32(89).double(message.openPrice);
      if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
        writer.uint32(97).double(message.closePrice);
      if (message.avgPrice != null && Object.hasOwnProperty.call(message, "avgPrice"))
        writer.uint32(105).double(message.avgPrice);
      if (message.buyForeignQtty != null && Object.hasOwnProperty.call(message, "buyForeignQtty"))
        writer.uint32(113).double(message.buyForeignQtty);
      if (message.sellForeignQtty != null && Object.hasOwnProperty.call(message, "sellForeignQtty"))
        writer.uint32(121).double(message.sellForeignQtty);
      if (message.tradingStatus != null && Object.hasOwnProperty.call(message, "tradingStatus"))
        writer.uint32(128).int32(message.tradingStatus);
      if (message.currentRoom != null && Object.hasOwnProperty.call(message, "currentRoom"))
        writer.uint32(137).double(message.currentRoom);
      if (message.accumulatedVal != null && Object.hasOwnProperty.call(message, "accumulatedVal"))
        writer.uint32(145).double(message.accumulatedVal);
      if (message.accumulatedVol != null && Object.hasOwnProperty.call(message, "accumulatedVol"))
        writer.uint32(153).double(message.accumulatedVol);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(161).double(message.matchPrice);
      if (message.matchQtty != null && Object.hasOwnProperty.call(message, "matchQtty"))
        writer.uint32(169).double(message.matchQtty);
      if (message.matchValue != null && Object.hasOwnProperty.call(message, "matchValue"))
        writer.uint32(177).double(message.matchValue);
      if (message.changed != null && Object.hasOwnProperty.call(message, "changed"))
        writer.uint32(185).double(message.changed);
      if (message.changedRatio != null && Object.hasOwnProperty.call(message, "changedRatio"))
        writer.uint32(193).double(message.changedRatio);
      if (message.estimatedPrice != null && Object.hasOwnProperty.call(message, "estimatedPrice"))
        writer.uint32(201).double(message.estimatedPrice);
      if (message.estimatedQuantity != null && Object.hasOwnProperty.call(message, "estimatedQuantity"))
        writer.uint32(209).double(message.estimatedQuantity);
      if (message.tradingSession != null && Object.hasOwnProperty.call(message, "tradingSession"))
        writer.uint32(216).int32(message.tradingSession);
      if (message.offerQtty != null && Object.hasOwnProperty.call(message, "offerQtty"))
        writer.uint32(225).double(message.offerQtty);
      if (message.bidQtty != null && Object.hasOwnProperty.call(message, "bidQtty"))
        writer.uint32(233).double(message.bidQtty);
      if (message.securityStatus != null && Object.hasOwnProperty.call(message, "securityStatus"))
        writer.uint32(240).int32(message.securityStatus);
      if (message.ceilingPricePT != null && Object.hasOwnProperty.call(message, "ceilingPricePT"))
        writer.uint32(249).double(message.ceilingPricePT);
      if (message.floorPricePT != null && Object.hasOwnProperty.call(message, "floorPricePT"))
        writer.uint32(257).double(message.floorPricePT);
      if (message.oddLotSecurityStatus != null && Object.hasOwnProperty.call(message, "oddLotSecurityStatus"))
        writer.uint32(264).int32(message.oddLotSecurityStatus);
      if (message.currentPrice != null && Object.hasOwnProperty.call(message, "currentPrice"))
        writer.uint32(273).double(message.currentPrice);
      if (message.currentQtty != null && Object.hasOwnProperty.call(message, "currentQtty"))
        writer.uint32(281).double(message.currentQtty);
      if (message.lastTradingDate != null && Object.hasOwnProperty.call(message, "lastTradingDate"))
        $root.google.protobuf.Timestamp.encode(message.lastTradingDate, writer.uint32(290).fork()).ldelim();
      if (message.openInterest != null && Object.hasOwnProperty.call(message, "openInterest"))
        writer.uint32(297).double(message.openInterest);
      if (message.symbolType != null && Object.hasOwnProperty.call(message, "symbolType"))
        writer.uint32(306).string(message.symbolType);
      if (message.parValue != null && Object.hasOwnProperty.call(message, "parValue"))
        writer.uint32(313).double(message.parValue);
      if (message.receivedTime != null && Object.hasOwnProperty.call(message, "receivedTime"))
        $root.google.protobuf.Timestamp.encode(message.receivedTime, writer.uint32(322).fork()).ldelim();
      return writer;
    };
    StockInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.StockInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.floorCode = reader.int32();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 4:
            message.tradingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.securityType = reader.int32();
            break;
          case 6:
            message.basicPrice = reader.double();
            break;
          case 7:
            message.ceilingPrice = reader.double();
            break;
          case 8:
            message.floorPrice = reader.double();
            break;
          case 9:
            message.highestPrice = reader.double();
            break;
          case 10:
            message.lowestPrice = reader.double();
            break;
          case 11:
            message.openPrice = reader.double();
            break;
          case 12:
            message.closePrice = reader.double();
            break;
          case 13:
            message.avgPrice = reader.double();
            break;
          case 14:
            message.buyForeignQtty = reader.double();
            break;
          case 15:
            message.sellForeignQtty = reader.double();
            break;
          case 16:
            message.tradingStatus = reader.int32();
            break;
          case 17:
            message.currentRoom = reader.double();
            break;
          case 18:
            message.accumulatedVal = reader.double();
            break;
          case 19:
            message.accumulatedVol = reader.double();
            break;
          case 20:
            message.matchPrice = reader.double();
            break;
          case 21:
            message.matchQtty = reader.double();
            break;
          case 22:
            message.matchValue = reader.double();
            break;
          case 23:
            message.changed = reader.double();
            break;
          case 24:
            message.changedRatio = reader.double();
            break;
          case 25:
            message.estimatedPrice = reader.double();
            break;
          case 26:
            message.estimatedQuantity = reader.double();
            break;
          case 27:
            message.tradingSession = reader.int32();
            break;
          case 28:
            message.offerQtty = reader.double();
            break;
          case 29:
            message.bidQtty = reader.double();
            break;
          case 30:
            message.securityStatus = reader.int32();
            break;
          case 31:
            message.ceilingPricePT = reader.double();
            break;
          case 32:
            message.floorPricePT = reader.double();
            break;
          case 33:
            message.oddLotSecurityStatus = reader.int32();
            break;
          case 34:
            message.currentPrice = reader.double();
            break;
          case 35:
            message.currentQtty = reader.double();
            break;
          case 36:
            message.lastTradingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 37:
            message.openInterest = reader.double();
            break;
          case 38:
            message.symbolType = reader.string();
            break;
          case 39:
            message.parValue = reader.double();
            break;
          case 40:
            message.receivedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockInfo.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        switch (message.floorCode) {
          default:
            return "floorCode: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.tradingTime != null && message.hasOwnProperty("tradingTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.tradingTime);
        if (error)
          return "tradingTime." + error;
      }
      if (message.securityType != null && message.hasOwnProperty("securityType"))
        switch (message.securityType) {
          default:
            return "securityType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 100:
            break;
        }
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
        if (typeof message.basicPrice !== "number")
          return "basicPrice: number expected";
      }
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
        if (typeof message.ceilingPrice !== "number")
          return "ceilingPrice: number expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (typeof message.floorPrice !== "number")
          return "floorPrice: number expected";
      }
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice")) {
        if (typeof message.highestPrice !== "number")
          return "highestPrice: number expected";
      }
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice")) {
        if (typeof message.lowestPrice !== "number")
          return "lowestPrice: number expected";
      }
      if (message.openPrice != null && message.hasOwnProperty("openPrice")) {
        if (typeof message.openPrice !== "number")
          return "openPrice: number expected";
      }
      if (message.closePrice != null && message.hasOwnProperty("closePrice")) {
        if (typeof message.closePrice !== "number")
          return "closePrice: number expected";
      }
      if (message.avgPrice != null && message.hasOwnProperty("avgPrice")) {
        if (typeof message.avgPrice !== "number")
          return "avgPrice: number expected";
      }
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty")) {
        if (typeof message.buyForeignQtty !== "number")
          return "buyForeignQtty: number expected";
      }
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty")) {
        if (typeof message.sellForeignQtty !== "number")
          return "sellForeignQtty: number expected";
      }
      if (message.tradingStatus != null && message.hasOwnProperty("tradingStatus"))
        switch (message.tradingStatus) {
          default:
            return "tradingStatus: enum value expected";
          case 0:
          case 1:
          case 2:
          case 6:
          case 7:
          case 8:
          case 10:
          case 25:
            break;
        }
      if (message.currentRoom != null && message.hasOwnProperty("currentRoom")) {
        if (typeof message.currentRoom !== "number")
          return "currentRoom: number expected";
      }
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal")) {
        if (typeof message.accumulatedVal !== "number")
          return "accumulatedVal: number expected";
      }
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol")) {
        if (typeof message.accumulatedVol !== "number")
          return "accumulatedVol: number expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty")) {
        if (typeof message.matchQtty !== "number")
          return "matchQtty: number expected";
      }
      if (message.matchValue != null && message.hasOwnProperty("matchValue")) {
        if (typeof message.matchValue !== "number")
          return "matchValue: number expected";
      }
      if (message.changed != null && message.hasOwnProperty("changed")) {
        if (typeof message.changed !== "number")
          return "changed: number expected";
      }
      if (message.changedRatio != null && message.hasOwnProperty("changedRatio")) {
        if (typeof message.changedRatio !== "number")
          return "changedRatio: number expected";
      }
      if (message.estimatedPrice != null && message.hasOwnProperty("estimatedPrice")) {
        if (typeof message.estimatedPrice !== "number")
          return "estimatedPrice: number expected";
      }
      if (message.estimatedQuantity != null && message.hasOwnProperty("estimatedQuantity")) {
        if (typeof message.estimatedQuantity !== "number")
          return "estimatedQuantity: number expected";
      }
      if (message.tradingSession != null && message.hasOwnProperty("tradingSession"))
        switch (message.tradingSession) {
          default:
            return "tradingSession: enum value expected";
          case 0:
          case 13:
          case 12:
          case 10:
          case 3:
          case 1:
          case 2:
          case 9:
          case 35:
          case 5:
          case 7:
          case 8:
          case 6:
          case 11:
          case 36:
            break;
        }
      if (message.offerQtty != null && message.hasOwnProperty("offerQtty")) {
        if (typeof message.offerQtty !== "number")
          return "offerQtty: number expected";
      }
      if (message.bidQtty != null && message.hasOwnProperty("bidQtty")) {
        if (typeof message.bidQtty !== "number")
          return "bidQtty: number expected";
      }
      if (message.securityStatus != null && message.hasOwnProperty("securityStatus"))
        switch (message.securityStatus) {
          default:
            return "securityStatus: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
            break;
        }
      if (message.ceilingPricePT != null && message.hasOwnProperty("ceilingPricePT")) {
        if (typeof message.ceilingPricePT !== "number")
          return "ceilingPricePT: number expected";
      }
      if (message.floorPricePT != null && message.hasOwnProperty("floorPricePT")) {
        if (typeof message.floorPricePT !== "number")
          return "floorPricePT: number expected";
      }
      if (message.oddLotSecurityStatus != null && message.hasOwnProperty("oddLotSecurityStatus"))
        switch (message.oddLotSecurityStatus) {
          default:
            return "oddLotSecurityStatus: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
            break;
        }
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice")) {
        if (typeof message.currentPrice !== "number")
          return "currentPrice: number expected";
      }
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty")) {
        if (typeof message.currentQtty !== "number")
          return "currentQtty: number expected";
      }
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.lastTradingDate);
        if (error)
          return "lastTradingDate." + error;
      }
      if (message.openInterest != null && message.hasOwnProperty("openInterest")) {
        if (typeof message.openInterest !== "number")
          return "openInterest: number expected";
      }
      if (message.symbolType != null && message.hasOwnProperty("symbolType")) {
        if (!$util.isString(message.symbolType))
          return "symbolType: string expected";
      }
      if (message.parValue != null && message.hasOwnProperty("parValue")) {
        if (typeof message.parValue !== "number")
          return "parValue: number expected";
      }
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.receivedTime);
        if (error)
          return "receivedTime." + error;
      }
      return null;
    };
    StockInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.price.StockInfo)
        return object;
      let message = new $root.price.StockInfo();
      switch (object.floorCode) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floorCode = 0;
          break;
        case "HNX":
        case 2:
          message.floorCode = 2;
          break;
        case "UPCOM":
        case 3:
          message.floorCode = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floorCode = 4;
          break;
        case "HOSE":
        case 10:
          message.floorCode = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floorCode = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floorCode = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floorCode = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floorCode = 14;
          break;
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.tradingTime != null) {
        if (typeof object.tradingTime !== "object")
          throw TypeError(".price.StockInfo.tradingTime: object expected");
        message.tradingTime = $root.google.protobuf.Timestamp.fromObject(object.tradingTime);
      }
      switch (object.securityType) {
        case "UNKNOWN_TYPE":
        case 0:
          message.securityType = 0;
          break;
        case "STOCK":
        case 1:
          message.securityType = 1;
          break;
        case "BOND":
        case 2:
          message.securityType = 2;
          break;
        case "MUTUAL_FUND":
        case 3:
          message.securityType = 3;
          break;
        case "ETF":
        case 4:
          message.securityType = 4;
          break;
        case "FUTURE":
        case 5:
          message.securityType = 5;
          break;
        case "OPTION":
        case 6:
          message.securityType = 6;
          break;
        case "COVERED_WARRANT":
        case 7:
          message.securityType = 7;
          break;
        case "FUTURE_INDEX":
        case 8:
          message.securityType = 8;
          break;
        case "FUTURE_BOND":
        case 9:
          message.securityType = 9;
          break;
        case "CORPORATE_BOND":
        case 10:
          message.securityType = 10;
          break;
        case "PRIVATE_BOND":
        case 11:
          message.securityType = 11;
          break;
        case "ALL":
        case 100:
          message.securityType = 100;
          break;
      }
      if (object.basicPrice != null)
        message.basicPrice = Number(object.basicPrice);
      if (object.ceilingPrice != null)
        message.ceilingPrice = Number(object.ceilingPrice);
      if (object.floorPrice != null)
        message.floorPrice = Number(object.floorPrice);
      if (object.highestPrice != null)
        message.highestPrice = Number(object.highestPrice);
      if (object.lowestPrice != null)
        message.lowestPrice = Number(object.lowestPrice);
      if (object.openPrice != null)
        message.openPrice = Number(object.openPrice);
      if (object.closePrice != null)
        message.closePrice = Number(object.closePrice);
      if (object.avgPrice != null)
        message.avgPrice = Number(object.avgPrice);
      if (object.buyForeignQtty != null)
        message.buyForeignQtty = Number(object.buyForeignQtty);
      if (object.sellForeignQtty != null)
        message.sellForeignQtty = Number(object.sellForeignQtty);
      switch (object.tradingStatus) {
        case "BINH_THUONG":
        case 0:
          message.tradingStatus = 0;
          break;
        case "KHONG_GIAO_DICH_TRONG_NGAY":
        case 1:
          message.tradingStatus = 1;
          break;
        case "NGUNG_GIAO_DICH":
        case 2:
          message.tradingStatus = 2;
          break;
        case "HUY_NIEM_YET":
        case 6:
          message.tradingStatus = 6;
          break;
        case "NIEM_YET_MOI":
        case 7:
          message.tradingStatus = 7;
          break;
        case "SAP_HUY_NIEM_YET":
        case 8:
          message.tradingStatus = 8;
          break;
        case "TAM_NGUNG_GIAO_DICH_GIUA_PHIEN":
        case 10:
          message.tradingStatus = 10;
          break;
        case "GIAO_DICH_DAC_BIET":
        case 25:
          message.tradingStatus = 25;
          break;
      }
      if (object.currentRoom != null)
        message.currentRoom = Number(object.currentRoom);
      if (object.accumulatedVal != null)
        message.accumulatedVal = Number(object.accumulatedVal);
      if (object.accumulatedVol != null)
        message.accumulatedVol = Number(object.accumulatedVol);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.matchQtty != null)
        message.matchQtty = Number(object.matchQtty);
      if (object.matchValue != null)
        message.matchValue = Number(object.matchValue);
      if (object.changed != null)
        message.changed = Number(object.changed);
      if (object.changedRatio != null)
        message.changedRatio = Number(object.changedRatio);
      if (object.estimatedPrice != null)
        message.estimatedPrice = Number(object.estimatedPrice);
      if (object.estimatedQuantity != null)
        message.estimatedQuantity = Number(object.estimatedQuantity);
      switch (object.tradingSession) {
        case "OPEN":
        case 0:
          message.tradingSession = 0;
          break;
        case "CLOSED":
        case 13:
          message.tradingSession = 13;
          break;
        case "DONE":
        case 12:
          message.tradingSession = 12;
          break;
        case "NOON_BREAK":
        case 10:
          message.tradingSession = 10;
          break;
        case "START_MIDSESSION_BREAK":
        case 3:
          message.tradingSession = 3;
          break;
        case "DONE_MIDSESSION_BREAK":
        case 1:
          message.tradingSession = 1;
          break;
        case "ATO":
        case 2:
          message.tradingSession = 2;
          break;
        case "ATC":
        case 9:
          message.tradingSession = 9;
          break;
        case "PUT_THROUGH":
        case 35:
          message.tradingSession = 35;
          break;
        case "CONTINUOUS":
        case 5:
          message.tradingSession = 5;
          break;
        case "STOP_ALL_TRADE":
        case 7:
          message.tradingSession = 7;
          break;
        case "RESUME_ALL_TRADE":
        case 8:
          message.tradingSession = 8;
          break;
        case "RESUME_TRADE_SYMBOL":
        case 6:
          message.tradingSession = 6;
          break;
        case "END_ALL":
        case 11:
          message.tradingSession = 11;
          break;
        case "UNKNOWN_SESSION":
        case 36:
          message.tradingSession = 36;
          break;
      }
      if (object.offerQtty != null)
        message.offerQtty = Number(object.offerQtty);
      if (object.bidQtty != null)
        message.bidQtty = Number(object.bidQtty);
      switch (object.securityStatus) {
        case "UNKNOWN_STATUS":
        case 0:
          message.securityStatus = 0;
          break;
        case "NORMAL":
        case 1:
          message.securityStatus = 1;
          break;
        case "HALT":
        case 2:
          message.securityStatus = 2;
          break;
        case "SUSPENDED":
        case 3:
          message.securityStatus = 3;
          break;
        case "SPECIAL":
        case 4:
          message.securityStatus = 4;
          break;
        case "UNLISTED":
        case 5:
          message.securityStatus = 5;
          break;
        case "NEW":
        case 6:
          message.securityStatus = 6;
          break;
        case "AOM_HALT":
        case 7:
          message.securityStatus = 7;
          break;
        case "PUT_THROUGH_HALT":
        case 8:
          message.securityStatus = 8;
          break;
      }
      if (object.ceilingPricePT != null)
        message.ceilingPricePT = Number(object.ceilingPricePT);
      if (object.floorPricePT != null)
        message.floorPricePT = Number(object.floorPricePT);
      switch (object.oddLotSecurityStatus) {
        case "UNKNOWN_STATUS":
        case 0:
          message.oddLotSecurityStatus = 0;
          break;
        case "NORMAL":
        case 1:
          message.oddLotSecurityStatus = 1;
          break;
        case "HALT":
        case 2:
          message.oddLotSecurityStatus = 2;
          break;
        case "SUSPENDED":
        case 3:
          message.oddLotSecurityStatus = 3;
          break;
        case "SPECIAL":
        case 4:
          message.oddLotSecurityStatus = 4;
          break;
        case "UNLISTED":
        case 5:
          message.oddLotSecurityStatus = 5;
          break;
        case "NEW":
        case 6:
          message.oddLotSecurityStatus = 6;
          break;
        case "AOM_HALT":
        case 7:
          message.oddLotSecurityStatus = 7;
          break;
        case "PUT_THROUGH_HALT":
        case 8:
          message.oddLotSecurityStatus = 8;
          break;
      }
      if (object.currentPrice != null)
        message.currentPrice = Number(object.currentPrice);
      if (object.currentQtty != null)
        message.currentQtty = Number(object.currentQtty);
      if (object.lastTradingDate != null) {
        if (typeof object.lastTradingDate !== "object")
          throw TypeError(".price.StockInfo.lastTradingDate: object expected");
        message.lastTradingDate = $root.google.protobuf.Timestamp.fromObject(object.lastTradingDate);
      }
      if (object.openInterest != null)
        message.openInterest = Number(object.openInterest);
      if (object.symbolType != null)
        message.symbolType = String(object.symbolType);
      if (object.parValue != null)
        message.parValue = Number(object.parValue);
      if (object.receivedTime != null) {
        if (typeof object.receivedTime !== "object")
          throw TypeError(".price.StockInfo.receivedTime: object expected");
        message.receivedTime = $root.google.protobuf.Timestamp.fromObject(object.receivedTime);
      }
      return message;
    };
    StockInfo.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.floorCode = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        object.symbol = "";
        object.tradingTime = null;
        object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.basicPrice = 0;
        object.ceilingPrice = 0;
        object.floorPrice = 0;
        object.highestPrice = 0;
        object.lowestPrice = 0;
        object.openPrice = 0;
        object.closePrice = 0;
        object.avgPrice = 0;
        object.buyForeignQtty = 0;
        object.sellForeignQtty = 0;
        object.tradingStatus = options.enums === String ? "BINH_THUONG" : 0;
        object.currentRoom = 0;
        object.accumulatedVal = 0;
        object.accumulatedVol = 0;
        object.matchPrice = 0;
        object.matchQtty = 0;
        object.matchValue = 0;
        object.changed = 0;
        object.changedRatio = 0;
        object.estimatedPrice = 0;
        object.estimatedQuantity = 0;
        object.tradingSession = options.enums === String ? "OPEN" : 0;
        object.offerQtty = 0;
        object.bidQtty = 0;
        object.securityStatus = options.enums === String ? "UNKNOWN_STATUS" : 0;
        object.ceilingPricePT = 0;
        object.floorPricePT = 0;
        object.oddLotSecurityStatus = options.enums === String ? "UNKNOWN_STATUS" : 0;
        object.currentPrice = 0;
        object.currentQtty = 0;
        object.lastTradingDate = null;
        object.openInterest = 0;
        object.symbolType = "";
        object.parValue = 0;
        object.receivedTime = null;
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = options.enums === String ? $root.price.FloorCode[message.floorCode] : message.floorCode;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.tradingTime != null && message.hasOwnProperty("tradingTime"))
        object.tradingTime = $root.google.protobuf.Timestamp.toObject(message.tradingTime, options);
      if (message.securityType != null && message.hasOwnProperty("securityType"))
        object.securityType = options.enums === String ? $root.price.SecurityType[message.securityType] : message.securityType;
      if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
        object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
        object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
        object.highestPrice = options.json && !isFinite(message.highestPrice) ? String(message.highestPrice) : message.highestPrice;
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
        object.lowestPrice = options.json && !isFinite(message.lowestPrice) ? String(message.lowestPrice) : message.lowestPrice;
      if (message.openPrice != null && message.hasOwnProperty("openPrice"))
        object.openPrice = options.json && !isFinite(message.openPrice) ? String(message.openPrice) : message.openPrice;
      if (message.closePrice != null && message.hasOwnProperty("closePrice"))
        object.closePrice = options.json && !isFinite(message.closePrice) ? String(message.closePrice) : message.closePrice;
      if (message.avgPrice != null && message.hasOwnProperty("avgPrice"))
        object.avgPrice = options.json && !isFinite(message.avgPrice) ? String(message.avgPrice) : message.avgPrice;
      if (message.buyForeignQtty != null && message.hasOwnProperty("buyForeignQtty"))
        object.buyForeignQtty = options.json && !isFinite(message.buyForeignQtty) ? String(message.buyForeignQtty) : message.buyForeignQtty;
      if (message.sellForeignQtty != null && message.hasOwnProperty("sellForeignQtty"))
        object.sellForeignQtty = options.json && !isFinite(message.sellForeignQtty) ? String(message.sellForeignQtty) : message.sellForeignQtty;
      if (message.tradingStatus != null && message.hasOwnProperty("tradingStatus"))
        object.tradingStatus = options.enums === String ? $root.price.TradingStatus[message.tradingStatus] : message.tradingStatus;
      if (message.currentRoom != null && message.hasOwnProperty("currentRoom"))
        object.currentRoom = options.json && !isFinite(message.currentRoom) ? String(message.currentRoom) : message.currentRoom;
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal"))
        object.accumulatedVal = options.json && !isFinite(message.accumulatedVal) ? String(message.accumulatedVal) : message.accumulatedVal;
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol"))
        object.accumulatedVol = options.json && !isFinite(message.accumulatedVol) ? String(message.accumulatedVol) : message.accumulatedVol;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty"))
        object.matchQtty = options.json && !isFinite(message.matchQtty) ? String(message.matchQtty) : message.matchQtty;
      if (message.matchValue != null && message.hasOwnProperty("matchValue"))
        object.matchValue = options.json && !isFinite(message.matchValue) ? String(message.matchValue) : message.matchValue;
      if (message.changed != null && message.hasOwnProperty("changed"))
        object.changed = options.json && !isFinite(message.changed) ? String(message.changed) : message.changed;
      if (message.changedRatio != null && message.hasOwnProperty("changedRatio"))
        object.changedRatio = options.json && !isFinite(message.changedRatio) ? String(message.changedRatio) : message.changedRatio;
      if (message.estimatedPrice != null && message.hasOwnProperty("estimatedPrice"))
        object.estimatedPrice = options.json && !isFinite(message.estimatedPrice) ? String(message.estimatedPrice) : message.estimatedPrice;
      if (message.estimatedQuantity != null && message.hasOwnProperty("estimatedQuantity"))
        object.estimatedQuantity = options.json && !isFinite(message.estimatedQuantity) ? String(message.estimatedQuantity) : message.estimatedQuantity;
      if (message.tradingSession != null && message.hasOwnProperty("tradingSession"))
        object.tradingSession = options.enums === String ? $root.price.TradingSession[message.tradingSession] : message.tradingSession;
      if (message.offerQtty != null && message.hasOwnProperty("offerQtty"))
        object.offerQtty = options.json && !isFinite(message.offerQtty) ? String(message.offerQtty) : message.offerQtty;
      if (message.bidQtty != null && message.hasOwnProperty("bidQtty"))
        object.bidQtty = options.json && !isFinite(message.bidQtty) ? String(message.bidQtty) : message.bidQtty;
      if (message.securityStatus != null && message.hasOwnProperty("securityStatus"))
        object.securityStatus = options.enums === String ? $root.price.SecurityStatus[message.securityStatus] : message.securityStatus;
      if (message.ceilingPricePT != null && message.hasOwnProperty("ceilingPricePT"))
        object.ceilingPricePT = options.json && !isFinite(message.ceilingPricePT) ? String(message.ceilingPricePT) : message.ceilingPricePT;
      if (message.floorPricePT != null && message.hasOwnProperty("floorPricePT"))
        object.floorPricePT = options.json && !isFinite(message.floorPricePT) ? String(message.floorPricePT) : message.floorPricePT;
      if (message.oddLotSecurityStatus != null && message.hasOwnProperty("oddLotSecurityStatus"))
        object.oddLotSecurityStatus = options.enums === String ? $root.price.SecurityStatus[message.oddLotSecurityStatus] : message.oddLotSecurityStatus;
      if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
        object.currentPrice = options.json && !isFinite(message.currentPrice) ? String(message.currentPrice) : message.currentPrice;
      if (message.currentQtty != null && message.hasOwnProperty("currentQtty"))
        object.currentQtty = options.json && !isFinite(message.currentQtty) ? String(message.currentQtty) : message.currentQtty;
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate"))
        object.lastTradingDate = $root.google.protobuf.Timestamp.toObject(message.lastTradingDate, options);
      if (message.openInterest != null && message.hasOwnProperty("openInterest"))
        object.openInterest = options.json && !isFinite(message.openInterest) ? String(message.openInterest) : message.openInterest;
      if (message.symbolType != null && message.hasOwnProperty("symbolType"))
        object.symbolType = message.symbolType;
      if (message.parValue != null && message.hasOwnProperty("parValue"))
        object.parValue = options.json && !isFinite(message.parValue) ? String(message.parValue) : message.parValue;
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime"))
        object.receivedTime = $root.google.protobuf.Timestamp.toObject(message.receivedTime, options);
      return object;
    };
    StockInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockInfo;
  }();
  price2.Symbol = function() {
    function Symbol(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Symbol.prototype.symbol = "";
    Symbol.prototype.floor = 0;
    Symbol.prototype.securityCode = 0;
    Symbol.prototype.type = 0;
    Symbol.prototype.createdAt = null;
    Symbol.prototype.modifiedAt = null;
    Symbol.create = function create(properties) {
      return new Symbol(properties);
    };
    Symbol.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.floor != null && Object.hasOwnProperty.call(message, "floor"))
        writer.uint32(16).int32(message.floor);
      if (message.securityCode != null && Object.hasOwnProperty.call(message, "securityCode"))
        writer.uint32(24).int32(message.securityCode);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(32).int32(message.type);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(42).fork()).ldelim();
      if (message.modifiedAt != null && Object.hasOwnProperty.call(message, "modifiedAt"))
        $root.google.protobuf.Timestamp.encode(message.modifiedAt, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    Symbol.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Symbol.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.Symbol();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.floor = reader.int32();
            break;
          case 3:
            message.securityCode = reader.int32();
            break;
          case 4:
            message.type = reader.int32();
            break;
          case 5:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.modifiedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Symbol.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Symbol.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.floor != null && message.hasOwnProperty("floor"))
        switch (message.floor) {
          default:
            return "floor: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.securityCode != null && message.hasOwnProperty("securityCode")) {
        if (!$util.isInteger(message.securityCode))
          return "securityCode: integer expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 100:
            break;
        }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.modifiedAt != null && message.hasOwnProperty("modifiedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedAt);
        if (error)
          return "modifiedAt." + error;
      }
      return null;
    };
    Symbol.fromObject = function fromObject(object) {
      if (object instanceof $root.price.Symbol)
        return object;
      let message = new $root.price.Symbol();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      switch (object.floor) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floor = 0;
          break;
        case "HNX":
        case 2:
          message.floor = 2;
          break;
        case "UPCOM":
        case 3:
          message.floor = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floor = 4;
          break;
        case "HOSE":
        case 10:
          message.floor = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floor = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floor = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floor = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floor = 14;
          break;
      }
      if (object.securityCode != null)
        message.securityCode = object.securityCode | 0;
      switch (object.type) {
        case "UNKNOWN_TYPE":
        case 0:
          message.type = 0;
          break;
        case "STOCK":
        case 1:
          message.type = 1;
          break;
        case "BOND":
        case 2:
          message.type = 2;
          break;
        case "MUTUAL_FUND":
        case 3:
          message.type = 3;
          break;
        case "ETF":
        case 4:
          message.type = 4;
          break;
        case "FUTURE":
        case 5:
          message.type = 5;
          break;
        case "OPTION":
        case 6:
          message.type = 6;
          break;
        case "COVERED_WARRANT":
        case 7:
          message.type = 7;
          break;
        case "FUTURE_INDEX":
        case 8:
          message.type = 8;
          break;
        case "FUTURE_BOND":
        case 9:
          message.type = 9;
          break;
        case "CORPORATE_BOND":
        case 10:
          message.type = 10;
          break;
        case "PRIVATE_BOND":
        case 11:
          message.type = 11;
          break;
        case "ALL":
        case 100:
          message.type = 100;
          break;
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".price.Symbol.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.modifiedAt != null) {
        if (typeof object.modifiedAt !== "object")
          throw TypeError(".price.Symbol.modifiedAt: object expected");
        message.modifiedAt = $root.google.protobuf.Timestamp.fromObject(object.modifiedAt);
      }
      return message;
    };
    Symbol.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.floor = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        object.securityCode = 0;
        object.type = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.createdAt = null;
        object.modifiedAt = null;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.floor != null && message.hasOwnProperty("floor"))
        object.floor = options.enums === String ? $root.price.FloorCode[message.floor] : message.floor;
      if (message.securityCode != null && message.hasOwnProperty("securityCode"))
        object.securityCode = message.securityCode;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.price.SecurityType[message.type] : message.type;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.modifiedAt != null && message.hasOwnProperty("modifiedAt"))
        object.modifiedAt = $root.google.protobuf.Timestamp.toObject(message.modifiedAt, options);
      return object;
    };
    Symbol.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Symbol;
  }();
  price2.Tick = function() {
    function Tick(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Tick.prototype.symbol = "";
    Tick.prototype.matchPrice = 0;
    Tick.prototype.matchQtty = 0;
    Tick.prototype.time = null;
    Tick.prototype.side = 0;
    Tick.prototype.session = 0;
    Tick.prototype.floorCode = 0;
    Tick.prototype.receivedTime = null;
    Tick.create = function create(properties) {
      return new Tick(properties);
    };
    Tick.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(17).double(message.matchPrice);
      if (message.matchQtty != null && Object.hasOwnProperty.call(message, "matchQtty"))
        writer.uint32(25).double(message.matchQtty);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(40).int32(message.side);
      if (message.session != null && Object.hasOwnProperty.call(message, "session"))
        writer.uint32(48).int32(message.session);
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(56).int32(message.floorCode);
      if (message.receivedTime != null && Object.hasOwnProperty.call(message, "receivedTime"))
        $root.google.protobuf.Timestamp.encode(message.receivedTime, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    Tick.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Tick.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.Tick();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.matchPrice = reader.double();
            break;
          case 3:
            message.matchQtty = reader.double();
            break;
          case 4:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.side = reader.int32();
            break;
          case 6:
            message.session = reader.int32();
            break;
          case 7:
            message.floorCode = reader.int32();
            break;
          case 8:
            message.receivedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Tick.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Tick.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty")) {
        if (typeof message.matchQtty !== "number")
          return "matchQtty: number expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.side != null && message.hasOwnProperty("side"))
        switch (message.side) {
          default:
            return "side: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.session != null && message.hasOwnProperty("session"))
        switch (message.session) {
          default:
            return "session: enum value expected";
          case 0:
          case 13:
          case 12:
          case 10:
          case 3:
          case 1:
          case 2:
          case 9:
          case 35:
          case 5:
          case 7:
          case 8:
          case 6:
          case 11:
          case 36:
            break;
        }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        switch (message.floorCode) {
          default:
            return "floorCode: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.receivedTime);
        if (error)
          return "receivedTime." + error;
      }
      return null;
    };
    Tick.fromObject = function fromObject(object) {
      if (object instanceof $root.price.Tick)
        return object;
      let message = new $root.price.Tick();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.matchQtty != null)
        message.matchQtty = Number(object.matchQtty);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.Tick.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      switch (object.side) {
        case "UNKNOWN_SIDE":
        case 0:
          message.side = 0;
          break;
        case "SIDE_BUY":
        case 1:
          message.side = 1;
          break;
        case "SIDE_SELL":
        case 2:
          message.side = 2;
          break;
      }
      switch (object.session) {
        case "OPEN":
        case 0:
          message.session = 0;
          break;
        case "CLOSED":
        case 13:
          message.session = 13;
          break;
        case "DONE":
        case 12:
          message.session = 12;
          break;
        case "NOON_BREAK":
        case 10:
          message.session = 10;
          break;
        case "START_MIDSESSION_BREAK":
        case 3:
          message.session = 3;
          break;
        case "DONE_MIDSESSION_BREAK":
        case 1:
          message.session = 1;
          break;
        case "ATO":
        case 2:
          message.session = 2;
          break;
        case "ATC":
        case 9:
          message.session = 9;
          break;
        case "PUT_THROUGH":
        case 35:
          message.session = 35;
          break;
        case "CONTINUOUS":
        case 5:
          message.session = 5;
          break;
        case "STOP_ALL_TRADE":
        case 7:
          message.session = 7;
          break;
        case "RESUME_ALL_TRADE":
        case 8:
          message.session = 8;
          break;
        case "RESUME_TRADE_SYMBOL":
        case 6:
          message.session = 6;
          break;
        case "END_ALL":
        case 11:
          message.session = 11;
          break;
        case "UNKNOWN_SESSION":
        case 36:
          message.session = 36;
          break;
      }
      switch (object.floorCode) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floorCode = 0;
          break;
        case "HNX":
        case 2:
          message.floorCode = 2;
          break;
        case "UPCOM":
        case 3:
          message.floorCode = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floorCode = 4;
          break;
        case "HOSE":
        case 10:
          message.floorCode = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floorCode = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floorCode = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floorCode = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floorCode = 14;
          break;
      }
      if (object.receivedTime != null) {
        if (typeof object.receivedTime !== "object")
          throw TypeError(".price.Tick.receivedTime: object expected");
        message.receivedTime = $root.google.protobuf.Timestamp.fromObject(object.receivedTime);
      }
      return message;
    };
    Tick.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.matchPrice = 0;
        object.matchQtty = 0;
        object.time = null;
        object.side = options.enums === String ? "UNKNOWN_SIDE" : 0;
        object.session = options.enums === String ? "OPEN" : 0;
        object.floorCode = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        object.receivedTime = null;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.matchQtty != null && message.hasOwnProperty("matchQtty"))
        object.matchQtty = options.json && !isFinite(message.matchQtty) ? String(message.matchQtty) : message.matchQtty;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = options.enums === String ? $root.price.Tick.Side[message.side] : message.side;
      if (message.session != null && message.hasOwnProperty("session"))
        object.session = options.enums === String ? $root.price.TradingSession[message.session] : message.session;
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = options.enums === String ? $root.price.FloorCode[message.floorCode] : message.floorCode;
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime"))
        object.receivedTime = $root.google.protobuf.Timestamp.toObject(message.receivedTime, options);
      return object;
    };
    Tick.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    Tick.Side = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_SIDE"] = 0;
      values[valuesById[1] = "SIDE_BUY"] = 1;
      values[valuesById[2] = "SIDE_SELL"] = 2;
      return values;
    }();
    return Tick;
  }();
  price2.OrderMini = function() {
    function OrderMini(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OrderMini.prototype.price = 0;
    OrderMini.prototype.qtty = 0;
    OrderMini.create = function create(properties) {
      return new OrderMini(properties);
    };
    OrderMini.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(9).double(message.price);
      if (message.qtty != null && Object.hasOwnProperty.call(message, "qtty"))
        writer.uint32(17).double(message.qtty);
      return writer;
    };
    OrderMini.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OrderMini.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.OrderMini();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.price = reader.double();
            break;
          case 2:
            message.qtty = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OrderMini.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OrderMini.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.qtty != null && message.hasOwnProperty("qtty")) {
        if (typeof message.qtty !== "number")
          return "qtty: number expected";
      }
      return null;
    };
    OrderMini.fromObject = function fromObject(object) {
      if (object instanceof $root.price.OrderMini)
        return object;
      let message = new $root.price.OrderMini();
      if (object.price != null)
        message.price = Number(object.price);
      if (object.qtty != null)
        message.qtty = Number(object.qtty);
      return message;
    };
    OrderMini.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.price = 0;
        object.qtty = 0;
      }
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.qtty != null && message.hasOwnProperty("qtty"))
        object.qtty = options.json && !isFinite(message.qtty) ? String(message.qtty) : message.qtty;
      return object;
    };
    OrderMini.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return OrderMini;
  }();
  price2.TopPrice = function() {
    function TopPrice(properties) {
      this.bid = [];
      this.ask = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    TopPrice.prototype.time = null;
    TopPrice.prototype.symbol = "";
    TopPrice.prototype.bid = $util.emptyArray;
    TopPrice.prototype.ask = $util.emptyArray;
    TopPrice.prototype.totalOfferQtty = 0;
    TopPrice.prototype.totalBidQtty = 0;
    TopPrice.prototype.floorCode = 0;
    TopPrice.prototype.receivedTime = null;
    TopPrice.create = function create(properties) {
      return new TopPrice(properties);
    };
    TopPrice.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.bid != null && message.bid.length)
        for (let i = 0; i < message.bid.length; ++i)
          $root.price.OrderMini.encode(message.bid[i], writer.uint32(26).fork()).ldelim();
      if (message.ask != null && message.ask.length)
        for (let i = 0; i < message.ask.length; ++i)
          $root.price.OrderMini.encode(message.ask[i], writer.uint32(34).fork()).ldelim();
      if (message.totalOfferQtty != null && Object.hasOwnProperty.call(message, "totalOfferQtty"))
        writer.uint32(73).double(message.totalOfferQtty);
      if (message.totalBidQtty != null && Object.hasOwnProperty.call(message, "totalBidQtty"))
        writer.uint32(81).double(message.totalBidQtty);
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(88).int32(message.floorCode);
      if (message.receivedTime != null && Object.hasOwnProperty.call(message, "receivedTime"))
        $root.google.protobuf.Timestamp.encode(message.receivedTime, writer.uint32(98).fork()).ldelim();
      return writer;
    };
    TopPrice.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    TopPrice.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.TopPrice();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            if (!(message.bid && message.bid.length))
              message.bid = [];
            message.bid.push($root.price.OrderMini.decode(reader, reader.uint32()));
            break;
          case 4:
            if (!(message.ask && message.ask.length))
              message.ask = [];
            message.ask.push($root.price.OrderMini.decode(reader, reader.uint32()));
            break;
          case 9:
            message.totalOfferQtty = reader.double();
            break;
          case 10:
            message.totalBidQtty = reader.double();
            break;
          case 11:
            message.floorCode = reader.int32();
            break;
          case 12:
            message.receivedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    TopPrice.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    TopPrice.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.bid != null && message.hasOwnProperty("bid")) {
        if (!Array.isArray(message.bid))
          return "bid: array expected";
        for (let i = 0; i < message.bid.length; ++i) {
          let error = $root.price.OrderMini.verify(message.bid[i]);
          if (error)
            return "bid." + error;
        }
      }
      if (message.ask != null && message.hasOwnProperty("ask")) {
        if (!Array.isArray(message.ask))
          return "ask: array expected";
        for (let i = 0; i < message.ask.length; ++i) {
          let error = $root.price.OrderMini.verify(message.ask[i]);
          if (error)
            return "ask." + error;
        }
      }
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty")) {
        if (typeof message.totalOfferQtty !== "number")
          return "totalOfferQtty: number expected";
      }
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty")) {
        if (typeof message.totalBidQtty !== "number")
          return "totalBidQtty: number expected";
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        switch (message.floorCode) {
          default:
            return "floorCode: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.receivedTime);
        if (error)
          return "receivedTime." + error;
      }
      return null;
    };
    TopPrice.fromObject = function fromObject(object) {
      if (object instanceof $root.price.TopPrice)
        return object;
      let message = new $root.price.TopPrice();
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.TopPrice.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.bid) {
        if (!Array.isArray(object.bid))
          throw TypeError(".price.TopPrice.bid: array expected");
        message.bid = [];
        for (let i = 0; i < object.bid.length; ++i) {
          if (typeof object.bid[i] !== "object")
            throw TypeError(".price.TopPrice.bid: object expected");
          message.bid[i] = $root.price.OrderMini.fromObject(object.bid[i]);
        }
      }
      if (object.ask) {
        if (!Array.isArray(object.ask))
          throw TypeError(".price.TopPrice.ask: array expected");
        message.ask = [];
        for (let i = 0; i < object.ask.length; ++i) {
          if (typeof object.ask[i] !== "object")
            throw TypeError(".price.TopPrice.ask: object expected");
          message.ask[i] = $root.price.OrderMini.fromObject(object.ask[i]);
        }
      }
      if (object.totalOfferQtty != null)
        message.totalOfferQtty = Number(object.totalOfferQtty);
      if (object.totalBidQtty != null)
        message.totalBidQtty = Number(object.totalBidQtty);
      switch (object.floorCode) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floorCode = 0;
          break;
        case "HNX":
        case 2:
          message.floorCode = 2;
          break;
        case "UPCOM":
        case 3:
          message.floorCode = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floorCode = 4;
          break;
        case "HOSE":
        case 10:
          message.floorCode = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floorCode = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floorCode = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floorCode = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floorCode = 14;
          break;
      }
      if (object.receivedTime != null) {
        if (typeof object.receivedTime !== "object")
          throw TypeError(".price.TopPrice.receivedTime: object expected");
        message.receivedTime = $root.google.protobuf.Timestamp.fromObject(object.receivedTime);
      }
      return message;
    };
    TopPrice.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.bid = [];
        object.ask = [];
      }
      if (options.defaults) {
        object.time = null;
        object.symbol = "";
        object.totalOfferQtty = 0;
        object.totalBidQtty = 0;
        object.floorCode = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        object.receivedTime = null;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.bid && message.bid.length) {
        object.bid = [];
        for (let j = 0; j < message.bid.length; ++j)
          object.bid[j] = $root.price.OrderMini.toObject(message.bid[j], options);
      }
      if (message.ask && message.ask.length) {
        object.ask = [];
        for (let j = 0; j < message.ask.length; ++j)
          object.ask[j] = $root.price.OrderMini.toObject(message.ask[j], options);
      }
      if (message.totalOfferQtty != null && message.hasOwnProperty("totalOfferQtty"))
        object.totalOfferQtty = options.json && !isFinite(message.totalOfferQtty) ? String(message.totalOfferQtty) : message.totalOfferQtty;
      if (message.totalBidQtty != null && message.hasOwnProperty("totalBidQtty"))
        object.totalBidQtty = options.json && !isFinite(message.totalBidQtty) ? String(message.totalBidQtty) : message.totalBidQtty;
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = options.enums === String ? $root.price.FloorCode[message.floorCode] : message.floorCode;
      if (message.receivedTime != null && message.hasOwnProperty("receivedTime"))
        object.receivedTime = $root.google.protobuf.Timestamp.toObject(message.receivedTime, options);
      return object;
    };
    TopPrice.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return TopPrice;
  }();
  price2.StockStatistics = function() {
    function StockStatistics(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockStatistics.prototype.time = null;
    StockStatistics.prototype.symbol = "";
    StockStatistics.prototype.vn30Influence = 0;
    StockStatistics.prototype.vn30InfluenceRatio = 0;
    StockStatistics.prototype.vn30Proportion = 0;
    StockStatistics.prototype.basketInfluence = 0;
    StockStatistics.prototype.basketInfluenceRatio = 0;
    StockStatistics.prototype.basketProportion = 0;
    StockStatistics.prototype.percentagePriceChange = 0;
    StockStatistics.prototype.priceChange = 0;
    StockStatistics.prototype.matchPrice = 0;
    StockStatistics.prototype.accumulatedVal = 0;
    StockStatistics.prototype.accumulatedVol = 0;
    StockStatistics.create = function create(properties) {
      return new StockStatistics(properties);
    };
    StockStatistics.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.vn30Influence != null && Object.hasOwnProperty.call(message, "vn30Influence"))
        writer.uint32(29).float(message.vn30Influence);
      if (message.vn30InfluenceRatio != null && Object.hasOwnProperty.call(message, "vn30InfluenceRatio"))
        writer.uint32(37).float(message.vn30InfluenceRatio);
      if (message.vn30Proportion != null && Object.hasOwnProperty.call(message, "vn30Proportion"))
        writer.uint32(45).float(message.vn30Proportion);
      if (message.basketInfluence != null && Object.hasOwnProperty.call(message, "basketInfluence"))
        writer.uint32(53).float(message.basketInfluence);
      if (message.basketInfluenceRatio != null && Object.hasOwnProperty.call(message, "basketInfluenceRatio"))
        writer.uint32(61).float(message.basketInfluenceRatio);
      if (message.basketProportion != null && Object.hasOwnProperty.call(message, "basketProportion"))
        writer.uint32(69).float(message.basketProportion);
      if (message.percentagePriceChange != null && Object.hasOwnProperty.call(message, "percentagePriceChange"))
        writer.uint32(77).float(message.percentagePriceChange);
      if (message.priceChange != null && Object.hasOwnProperty.call(message, "priceChange"))
        writer.uint32(85).float(message.priceChange);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(93).float(message.matchPrice);
      if (message.accumulatedVal != null && Object.hasOwnProperty.call(message, "accumulatedVal"))
        writer.uint32(101).float(message.accumulatedVal);
      if (message.accumulatedVol != null && Object.hasOwnProperty.call(message, "accumulatedVol"))
        writer.uint32(109).float(message.accumulatedVol);
      return writer;
    };
    StockStatistics.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockStatistics.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.StockStatistics();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.vn30Influence = reader.float();
            break;
          case 4:
            message.vn30InfluenceRatio = reader.float();
            break;
          case 5:
            message.vn30Proportion = reader.float();
            break;
          case 6:
            message.basketInfluence = reader.float();
            break;
          case 7:
            message.basketInfluenceRatio = reader.float();
            break;
          case 8:
            message.basketProportion = reader.float();
            break;
          case 9:
            message.percentagePriceChange = reader.float();
            break;
          case 10:
            message.priceChange = reader.float();
            break;
          case 11:
            message.matchPrice = reader.float();
            break;
          case 12:
            message.accumulatedVal = reader.float();
            break;
          case 13:
            message.accumulatedVol = reader.float();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockStatistics.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockStatistics.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.vn30Influence != null && message.hasOwnProperty("vn30Influence")) {
        if (typeof message.vn30Influence !== "number")
          return "vn30Influence: number expected";
      }
      if (message.vn30InfluenceRatio != null && message.hasOwnProperty("vn30InfluenceRatio")) {
        if (typeof message.vn30InfluenceRatio !== "number")
          return "vn30InfluenceRatio: number expected";
      }
      if (message.vn30Proportion != null && message.hasOwnProperty("vn30Proportion")) {
        if (typeof message.vn30Proportion !== "number")
          return "vn30Proportion: number expected";
      }
      if (message.basketInfluence != null && message.hasOwnProperty("basketInfluence")) {
        if (typeof message.basketInfluence !== "number")
          return "basketInfluence: number expected";
      }
      if (message.basketInfluenceRatio != null && message.hasOwnProperty("basketInfluenceRatio")) {
        if (typeof message.basketInfluenceRatio !== "number")
          return "basketInfluenceRatio: number expected";
      }
      if (message.basketProportion != null && message.hasOwnProperty("basketProportion")) {
        if (typeof message.basketProportion !== "number")
          return "basketProportion: number expected";
      }
      if (message.percentagePriceChange != null && message.hasOwnProperty("percentagePriceChange")) {
        if (typeof message.percentagePriceChange !== "number")
          return "percentagePriceChange: number expected";
      }
      if (message.priceChange != null && message.hasOwnProperty("priceChange")) {
        if (typeof message.priceChange !== "number")
          return "priceChange: number expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal")) {
        if (typeof message.accumulatedVal !== "number")
          return "accumulatedVal: number expected";
      }
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol")) {
        if (typeof message.accumulatedVol !== "number")
          return "accumulatedVol: number expected";
      }
      return null;
    };
    StockStatistics.fromObject = function fromObject(object) {
      if (object instanceof $root.price.StockStatistics)
        return object;
      let message = new $root.price.StockStatistics();
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.StockStatistics.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.vn30Influence != null)
        message.vn30Influence = Number(object.vn30Influence);
      if (object.vn30InfluenceRatio != null)
        message.vn30InfluenceRatio = Number(object.vn30InfluenceRatio);
      if (object.vn30Proportion != null)
        message.vn30Proportion = Number(object.vn30Proportion);
      if (object.basketInfluence != null)
        message.basketInfluence = Number(object.basketInfluence);
      if (object.basketInfluenceRatio != null)
        message.basketInfluenceRatio = Number(object.basketInfluenceRatio);
      if (object.basketProportion != null)
        message.basketProportion = Number(object.basketProportion);
      if (object.percentagePriceChange != null)
        message.percentagePriceChange = Number(object.percentagePriceChange);
      if (object.priceChange != null)
        message.priceChange = Number(object.priceChange);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.accumulatedVal != null)
        message.accumulatedVal = Number(object.accumulatedVal);
      if (object.accumulatedVol != null)
        message.accumulatedVol = Number(object.accumulatedVol);
      return message;
    };
    StockStatistics.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.time = null;
        object.symbol = "";
        object.vn30Influence = 0;
        object.vn30InfluenceRatio = 0;
        object.vn30Proportion = 0;
        object.basketInfluence = 0;
        object.basketInfluenceRatio = 0;
        object.basketProportion = 0;
        object.percentagePriceChange = 0;
        object.priceChange = 0;
        object.matchPrice = 0;
        object.accumulatedVal = 0;
        object.accumulatedVol = 0;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.vn30Influence != null && message.hasOwnProperty("vn30Influence"))
        object.vn30Influence = options.json && !isFinite(message.vn30Influence) ? String(message.vn30Influence) : message.vn30Influence;
      if (message.vn30InfluenceRatio != null && message.hasOwnProperty("vn30InfluenceRatio"))
        object.vn30InfluenceRatio = options.json && !isFinite(message.vn30InfluenceRatio) ? String(message.vn30InfluenceRatio) : message.vn30InfluenceRatio;
      if (message.vn30Proportion != null && message.hasOwnProperty("vn30Proportion"))
        object.vn30Proportion = options.json && !isFinite(message.vn30Proportion) ? String(message.vn30Proportion) : message.vn30Proportion;
      if (message.basketInfluence != null && message.hasOwnProperty("basketInfluence"))
        object.basketInfluence = options.json && !isFinite(message.basketInfluence) ? String(message.basketInfluence) : message.basketInfluence;
      if (message.basketInfluenceRatio != null && message.hasOwnProperty("basketInfluenceRatio"))
        object.basketInfluenceRatio = options.json && !isFinite(message.basketInfluenceRatio) ? String(message.basketInfluenceRatio) : message.basketInfluenceRatio;
      if (message.basketProportion != null && message.hasOwnProperty("basketProportion"))
        object.basketProportion = options.json && !isFinite(message.basketProportion) ? String(message.basketProportion) : message.basketProportion;
      if (message.percentagePriceChange != null && message.hasOwnProperty("percentagePriceChange"))
        object.percentagePriceChange = options.json && !isFinite(message.percentagePriceChange) ? String(message.percentagePriceChange) : message.percentagePriceChange;
      if (message.priceChange != null && message.hasOwnProperty("priceChange"))
        object.priceChange = options.json && !isFinite(message.priceChange) ? String(message.priceChange) : message.priceChange;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.accumulatedVal != null && message.hasOwnProperty("accumulatedVal"))
        object.accumulatedVal = options.json && !isFinite(message.accumulatedVal) ? String(message.accumulatedVal) : message.accumulatedVal;
      if (message.accumulatedVol != null && message.hasOwnProperty("accumulatedVol"))
        object.accumulatedVol = options.json && !isFinite(message.accumulatedVol) ? String(message.accumulatedVol) : message.accumulatedVol;
      return object;
    };
    StockStatistics.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockStatistics;
  }();
  price2.EstimatedMarketIndex = function() {
    function EstimatedMarketIndex(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EstimatedMarketIndex.prototype.marketID = "";
    EstimatedMarketIndex.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EstimatedMarketIndex.prototype.estimatedPrice = 0;
    EstimatedMarketIndex.prototype.enabled = false;
    EstimatedMarketIndex.create = function create(properties) {
      return new EstimatedMarketIndex(properties);
    };
    EstimatedMarketIndex.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.marketID != null && Object.hasOwnProperty.call(message, "marketID"))
        writer.uint32(10).string(message.marketID);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        writer.uint32(16).int64(message.time);
      if (message.estimatedPrice != null && Object.hasOwnProperty.call(message, "estimatedPrice"))
        writer.uint32(29).float(message.estimatedPrice);
      if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
        writer.uint32(32).bool(message.enabled);
      return writer;
    };
    EstimatedMarketIndex.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EstimatedMarketIndex.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.EstimatedMarketIndex();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.marketID = reader.string();
            break;
          case 2:
            message.time = reader.int64();
            break;
          case 3:
            message.estimatedPrice = reader.float();
            break;
          case 4:
            message.enabled = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EstimatedMarketIndex.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EstimatedMarketIndex.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.marketID != null && message.hasOwnProperty("marketID")) {
        if (!$util.isString(message.marketID))
          return "marketID: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
          return "time: integer|Long expected";
      }
      if (message.estimatedPrice != null && message.hasOwnProperty("estimatedPrice")) {
        if (typeof message.estimatedPrice !== "number")
          return "estimatedPrice: number expected";
      }
      if (message.enabled != null && message.hasOwnProperty("enabled")) {
        if (typeof message.enabled !== "boolean")
          return "enabled: boolean expected";
      }
      return null;
    };
    EstimatedMarketIndex.fromObject = function fromObject(object) {
      if (object instanceof $root.price.EstimatedMarketIndex)
        return object;
      let message = new $root.price.EstimatedMarketIndex();
      if (object.marketID != null)
        message.marketID = String(object.marketID);
      if (object.time != null) {
        if ($util.Long)
          (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === "string")
          message.time = parseInt(object.time, 10);
        else if (typeof object.time === "number")
          message.time = object.time;
        else if (typeof object.time === "object")
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      }
      if (object.estimatedPrice != null)
        message.estimatedPrice = Number(object.estimatedPrice);
      if (object.enabled != null)
        message.enabled = Boolean(object.enabled);
      return message;
    };
    EstimatedMarketIndex.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.marketID = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.time = options.longs === String ? "0" : 0;
        object.estimatedPrice = 0;
        object.enabled = false;
      }
      if (message.marketID != null && message.hasOwnProperty("marketID"))
        object.marketID = message.marketID;
      if (message.time != null && message.hasOwnProperty("time"))
        if (typeof message.time === "number")
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
      if (message.estimatedPrice != null && message.hasOwnProperty("estimatedPrice"))
        object.estimatedPrice = options.json && !isFinite(message.estimatedPrice) ? String(message.estimatedPrice) : message.estimatedPrice;
      if (message.enabled != null && message.hasOwnProperty("enabled"))
        object.enabled = message.enabled;
      return object;
    };
    EstimatedMarketIndex.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EstimatedMarketIndex;
  }();
  price2.BidAskInfo = function() {
    function BidAskInfo(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BidAskInfo.prototype.time = null;
    BidAskInfo.prototype.symbol = "";
    BidAskInfo.prototype.type = 0;
    BidAskInfo.prototype.totalBidValue = 0;
    BidAskInfo.prototype.totalAskValue = 0;
    BidAskInfo.prototype.floorCode = 0;
    BidAskInfo.create = function create(properties) {
      return new BidAskInfo(properties);
    };
    BidAskInfo.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(24).int32(message.type);
      if (message.totalBidValue != null && Object.hasOwnProperty.call(message, "totalBidValue"))
        writer.uint32(37).float(message.totalBidValue);
      if (message.totalAskValue != null && Object.hasOwnProperty.call(message, "totalAskValue"))
        writer.uint32(45).float(message.totalAskValue);
      if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
        writer.uint32(48).int32(message.floorCode);
      return writer;
    };
    BidAskInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BidAskInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.BidAskInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.type = reader.int32();
            break;
          case 4:
            message.totalBidValue = reader.float();
            break;
          case 5:
            message.totalAskValue = reader.float();
            break;
          case 6:
            message.floorCode = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BidAskInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BidAskInfo.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isInteger(message.type))
          return "type: integer expected";
      }
      if (message.totalBidValue != null && message.hasOwnProperty("totalBidValue")) {
        if (typeof message.totalBidValue !== "number")
          return "totalBidValue: number expected";
      }
      if (message.totalAskValue != null && message.hasOwnProperty("totalAskValue")) {
        if (typeof message.totalAskValue !== "number")
          return "totalAskValue: number expected";
      }
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        switch (message.floorCode) {
          default:
            return "floorCode: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      return null;
    };
    BidAskInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.price.BidAskInfo)
        return object;
      let message = new $root.price.BidAskInfo();
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.BidAskInfo.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.type != null)
        message.type = object.type | 0;
      if (object.totalBidValue != null)
        message.totalBidValue = Number(object.totalBidValue);
      if (object.totalAskValue != null)
        message.totalAskValue = Number(object.totalAskValue);
      switch (object.floorCode) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floorCode = 0;
          break;
        case "HNX":
        case 2:
          message.floorCode = 2;
          break;
        case "UPCOM":
        case 3:
          message.floorCode = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floorCode = 4;
          break;
        case "HOSE":
        case 10:
          message.floorCode = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floorCode = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floorCode = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floorCode = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floorCode = 14;
          break;
      }
      return message;
    };
    BidAskInfo.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.time = null;
        object.symbol = "";
        object.type = 0;
        object.totalBidValue = 0;
        object.totalAskValue = 0;
        object.floorCode = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.totalBidValue != null && message.hasOwnProperty("totalBidValue"))
        object.totalBidValue = options.json && !isFinite(message.totalBidValue) ? String(message.totalBidValue) : message.totalBidValue;
      if (message.totalAskValue != null && message.hasOwnProperty("totalAskValue"))
        object.totalAskValue = options.json && !isFinite(message.totalAskValue) ? String(message.totalAskValue) : message.totalAskValue;
      if (message.floorCode != null && message.hasOwnProperty("floorCode"))
        object.floorCode = options.enums === String ? $root.price.FloorCode[message.floorCode] : message.floorCode;
      return object;
    };
    BidAskInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BidAskInfo;
  }();
  price2.ListStockStatistics = function() {
    function ListStockStatistics(properties) {
      this.Data = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ListStockStatistics.prototype.Data = $util.emptyArray;
    ListStockStatistics.prototype.Time = null;
    ListStockStatistics.create = function create(properties) {
      return new ListStockStatistics(properties);
    };
    ListStockStatistics.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.Data != null && message.Data.length)
        for (let i = 0; i < message.Data.length; ++i)
          $root.price.StockStatistics.encode(message.Data[i], writer.uint32(10).fork()).ldelim();
      if (message.Time != null && Object.hasOwnProperty.call(message, "Time"))
        $root.google.protobuf.Timestamp.encode(message.Time, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    ListStockStatistics.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ListStockStatistics.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.ListStockStatistics();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.Data && message.Data.length))
              message.Data = [];
            message.Data.push($root.price.StockStatistics.decode(reader, reader.uint32()));
            break;
          case 2:
            message.Time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ListStockStatistics.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ListStockStatistics.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.Data != null && message.hasOwnProperty("Data")) {
        if (!Array.isArray(message.Data))
          return "Data: array expected";
        for (let i = 0; i < message.Data.length; ++i) {
          let error = $root.price.StockStatistics.verify(message.Data[i]);
          if (error)
            return "Data." + error;
        }
      }
      if (message.Time != null && message.hasOwnProperty("Time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.Time);
        if (error)
          return "Time." + error;
      }
      return null;
    };
    ListStockStatistics.fromObject = function fromObject(object) {
      if (object instanceof $root.price.ListStockStatistics)
        return object;
      let message = new $root.price.ListStockStatistics();
      if (object.Data) {
        if (!Array.isArray(object.Data))
          throw TypeError(".price.ListStockStatistics.Data: array expected");
        message.Data = [];
        for (let i = 0; i < object.Data.length; ++i) {
          if (typeof object.Data[i] !== "object")
            throw TypeError(".price.ListStockStatistics.Data: object expected");
          message.Data[i] = $root.price.StockStatistics.fromObject(object.Data[i]);
        }
      }
      if (object.Time != null) {
        if (typeof object.Time !== "object")
          throw TypeError(".price.ListStockStatistics.Time: object expected");
        message.Time = $root.google.protobuf.Timestamp.fromObject(object.Time);
      }
      return message;
    };
    ListStockStatistics.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.Data = [];
      if (options.defaults)
        object.Time = null;
      if (message.Data && message.Data.length) {
        object.Data = [];
        for (let j = 0; j < message.Data.length; ++j)
          object.Data[j] = $root.price.StockStatistics.toObject(message.Data[j], options);
      }
      if (message.Time != null && message.hasOwnProperty("Time"))
        object.Time = $root.google.protobuf.Timestamp.toObject(message.Time, options);
      return object;
    };
    ListStockStatistics.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ListStockStatistics;
  }();
  price2.FSP = function() {
    function FSP(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FSP.prototype.time = null;
    FSP.prototype.index = 0;
    FSP.prototype.isFinal = false;
    FSP.prototype.isActive = false;
    FSP.create = function create(properties) {
      return new FSP(properties);
    };
    FSP.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
      if (message.index != null && Object.hasOwnProperty.call(message, "index"))
        writer.uint32(17).double(message.index);
      if (message.isFinal != null && Object.hasOwnProperty.call(message, "isFinal"))
        writer.uint32(24).bool(message.isFinal);
      if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
        writer.uint32(32).bool(message.isActive);
      return writer;
    };
    FSP.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FSP.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.FSP();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 2:
            message.index = reader.double();
            break;
          case 3:
            message.isFinal = reader.bool();
            break;
          case 4:
            message.isActive = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FSP.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FSP.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.index != null && message.hasOwnProperty("index")) {
        if (typeof message.index !== "number")
          return "index: number expected";
      }
      if (message.isFinal != null && message.hasOwnProperty("isFinal")) {
        if (typeof message.isFinal !== "boolean")
          return "isFinal: boolean expected";
      }
      if (message.isActive != null && message.hasOwnProperty("isActive")) {
        if (typeof message.isActive !== "boolean")
          return "isActive: boolean expected";
      }
      return null;
    };
    FSP.fromObject = function fromObject(object) {
      if (object instanceof $root.price.FSP)
        return object;
      let message = new $root.price.FSP();
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.FSP.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.index != null)
        message.index = Number(object.index);
      if (object.isFinal != null)
        message.isFinal = Boolean(object.isFinal);
      if (object.isActive != null)
        message.isActive = Boolean(object.isActive);
      return message;
    };
    FSP.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.time = null;
        object.index = 0;
        object.isFinal = false;
        object.isActive = false;
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.index != null && message.hasOwnProperty("index"))
        object.index = options.json && !isFinite(message.index) ? String(message.index) : message.index;
      if (message.isFinal != null && message.hasOwnProperty("isFinal"))
        object.isFinal = message.isFinal;
      if (message.isActive != null && message.hasOwnProperty("isActive"))
        object.isActive = message.isActive;
      return object;
    };
    FSP.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FSP;
  }();
  price2.StockListedStatus = function() {
    function StockListedStatus(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockListedStatus.prototype.symbol = "";
    StockListedStatus.prototype.time = null;
    StockListedStatus.prototype.state = 0;
    StockListedStatus.prototype.floor = 0;
    StockListedStatus.prototype.type = 0;
    StockListedStatus.prototype.name = "";
    StockListedStatus.prototype.groupType = 0;
    StockListedStatus.prototype.listingDate = "";
    StockListedStatus.create = function create(properties) {
      return new StockListedStatus(properties);
    };
    StockListedStatus.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
      if (message.state != null && Object.hasOwnProperty.call(message, "state"))
        writer.uint32(24).int32(message.state);
      if (message.floor != null && Object.hasOwnProperty.call(message, "floor"))
        writer.uint32(32).int32(message.floor);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(40).int32(message.type);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(50).string(message.name);
      if (message.groupType != null && Object.hasOwnProperty.call(message, "groupType"))
        writer.uint32(56).int32(message.groupType);
      if (message.listingDate != null && Object.hasOwnProperty.call(message, "listingDate"))
        writer.uint32(66).string(message.listingDate);
      return writer;
    };
    StockListedStatus.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockListedStatus.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.StockListedStatus();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 3:
            message.state = reader.int32();
            break;
          case 4:
            message.floor = reader.int32();
            break;
          case 5:
            message.type = reader.int32();
            break;
          case 6:
            message.name = reader.string();
            break;
          case 7:
            message.groupType = reader.int32();
            break;
          case 8:
            message.listingDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockListedStatus.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockListedStatus.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.state != null && message.hasOwnProperty("state"))
        switch (message.state) {
          default:
            return "state: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.floor != null && message.hasOwnProperty("floor"))
        switch (message.floor) {
          default:
            return "floor: enum value expected";
          case 0:
          case 2:
          case 3:
          case 4:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 100:
            break;
        }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.groupType != null && message.hasOwnProperty("groupType"))
        switch (message.groupType) {
          default:
            return "groupType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.listingDate != null && message.hasOwnProperty("listingDate")) {
        if (!$util.isString(message.listingDate))
          return "listingDate: string expected";
      }
      return null;
    };
    StockListedStatus.fromObject = function fromObject(object) {
      if (object instanceof $root.price.StockListedStatus)
        return object;
      let message = new $root.price.StockListedStatus();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.StockListedStatus.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      switch (object.state) {
        case "UNKNOWN":
        case 0:
          message.state = 0;
          break;
        case "LISTED":
        case 1:
          message.state = 1;
          break;
        case "DELISTED":
        case 2:
          message.state = 2;
          break;
        case "SUSPENDED":
        case 3:
          message.state = 3;
          break;
      }
      switch (object.floor) {
        case "UNKNOWN_FLOOR_CODE":
        case 0:
          message.floor = 0;
          break;
        case "HNX":
        case 2:
          message.floor = 2;
          break;
        case "UPCOM":
        case 3:
          message.floor = 3;
          break;
        case "HNX_BOND":
        case 4:
          message.floor = 4;
          break;
        case "HOSE":
        case 10:
          message.floor = 10;
          break;
        case "HOSE_ODD_LOT":
        case 11:
          message.floor = 11;
          break;
        case "HNX_DERIVATIVES":
        case 12:
          message.floor = 12;
          break;
        case "HNX_DERIVATIVE_BOND":
        case 13:
          message.floor = 13;
          break;
        case "HNX_PRIVATE_BOND":
        case 14:
          message.floor = 14;
          break;
      }
      switch (object.type) {
        case "UNKNOWN_TYPE":
        case 0:
          message.type = 0;
          break;
        case "STOCK":
        case 1:
          message.type = 1;
          break;
        case "BOND":
        case 2:
          message.type = 2;
          break;
        case "MUTUAL_FUND":
        case 3:
          message.type = 3;
          break;
        case "ETF":
        case 4:
          message.type = 4;
          break;
        case "FUTURE":
        case 5:
          message.type = 5;
          break;
        case "OPTION":
        case 6:
          message.type = 6;
          break;
        case "COVERED_WARRANT":
        case 7:
          message.type = 7;
          break;
        case "FUTURE_INDEX":
        case 8:
          message.type = 8;
          break;
        case "FUTURE_BOND":
        case 9:
          message.type = 9;
          break;
        case "CORPORATE_BOND":
        case 10:
          message.type = 10;
          break;
        case "PRIVATE_BOND":
        case 11:
          message.type = 11;
          break;
        case "ALL":
        case 100:
          message.type = 100;
          break;
      }
      if (object.name != null)
        message.name = String(object.name);
      switch (object.groupType) {
        case "UNSPECIFIED":
        case 0:
          message.groupType = 0;
          break;
        case "STOCK":
        case 1:
          message.groupType = 1;
          break;
        case "INDEX":
        case 2:
          message.groupType = 2;
          break;
        case "DERIVATIVE":
        case 3:
          message.groupType = 3;
          break;
        case "CORPORATE_BOND":
        case 4:
          message.groupType = 4;
          break;
      }
      if (object.listingDate != null)
        message.listingDate = String(object.listingDate);
      return message;
    };
    StockListedStatus.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.time = null;
        object.state = options.enums === String ? "UNKNOWN" : 0;
        object.floor = options.enums === String ? "UNKNOWN_FLOOR_CODE" : 0;
        object.type = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.name = "";
        object.groupType = options.enums === String ? "UNSPECIFIED" : 0;
        object.listingDate = "";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.state != null && message.hasOwnProperty("state"))
        object.state = options.enums === String ? $root.price.StockListedStatus.State[message.state] : message.state;
      if (message.floor != null && message.hasOwnProperty("floor"))
        object.floor = options.enums === String ? $root.price.FloorCode[message.floor] : message.floor;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.price.SecurityType[message.type] : message.type;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.groupType != null && message.hasOwnProperty("groupType"))
        object.groupType = options.enums === String ? $root.price.StockListedStatus.GroupType[message.groupType] : message.groupType;
      if (message.listingDate != null && message.hasOwnProperty("listingDate"))
        object.listingDate = message.listingDate;
      return object;
    };
    StockListedStatus.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    StockListedStatus.GroupType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNSPECIFIED"] = 0;
      values[valuesById[1] = "STOCK"] = 1;
      values[valuesById[2] = "INDEX"] = 2;
      values[valuesById[3] = "DERIVATIVE"] = 3;
      values[valuesById[4] = "CORPORATE_BOND"] = 4;
      return values;
    }();
    StockListedStatus.State = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "LISTED"] = 1;
      values[valuesById[2] = "DELISTED"] = 2;
      values[valuesById[3] = "SUSPENDED"] = 3;
      return values;
    }();
    return StockListedStatus;
  }();
  price2.ListSectorVolatility = function() {
    function ListSectorVolatility(properties) {
      this.data = [];
      this.priceVolatilityKey = [];
      this.priceVolatilityValue = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ListSectorVolatility.prototype.data = $util.emptyArray;
    ListSectorVolatility.prototype.time = null;
    ListSectorVolatility.prototype.priceVolatilityKey = $util.emptyArray;
    ListSectorVolatility.prototype.priceVolatilityValue = $util.emptyArray;
    ListSectorVolatility.prototype.matchPrice = 0;
    ListSectorVolatility.prototype.volume = 0;
    ListSectorVolatility.prototype.marketCap = 0;
    ListSectorVolatility.prototype.totalStocks = 0;
    ListSectorVolatility.create = function create(properties) {
      return new ListSectorVolatility(properties);
    };
    ListSectorVolatility.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.data != null && message.data.length)
        for (let i = 0; i < message.data.length; ++i)
          $root.price.SectorVolatility.encode(message.data[i], writer.uint32(10).fork()).ldelim();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
      if (message.priceVolatilityKey != null && message.priceVolatilityKey.length)
        for (let i = 0; i < message.priceVolatilityKey.length; ++i)
          writer.uint32(26).string(message.priceVolatilityKey[i]);
      if (message.priceVolatilityValue != null && message.priceVolatilityValue.length) {
        writer.uint32(34).fork();
        for (let i = 0; i < message.priceVolatilityValue.length; ++i)
          writer.double(message.priceVolatilityValue[i]);
        writer.ldelim();
      }
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(41).double(message.matchPrice);
      if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
        writer.uint32(49).double(message.volume);
      if (message.marketCap != null && Object.hasOwnProperty.call(message, "marketCap"))
        writer.uint32(57).double(message.marketCap);
      if (message.totalStocks != null && Object.hasOwnProperty.call(message, "totalStocks"))
        writer.uint32(64).int32(message.totalStocks);
      return writer;
    };
    ListSectorVolatility.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ListSectorVolatility.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.ListSectorVolatility();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.data && message.data.length))
              message.data = [];
            message.data.push($root.price.SectorVolatility.decode(reader, reader.uint32()));
            break;
          case 2:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 3:
            if (!(message.priceVolatilityKey && message.priceVolatilityKey.length))
              message.priceVolatilityKey = [];
            message.priceVolatilityKey.push(reader.string());
            break;
          case 4:
            if (!(message.priceVolatilityValue && message.priceVolatilityValue.length))
              message.priceVolatilityValue = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2)
                message.priceVolatilityValue.push(reader.double());
            } else
              message.priceVolatilityValue.push(reader.double());
            break;
          case 5:
            message.matchPrice = reader.double();
            break;
          case 6:
            message.volume = reader.double();
            break;
          case 7:
            message.marketCap = reader.double();
            break;
          case 8:
            message.totalStocks = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ListSectorVolatility.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ListSectorVolatility.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.data != null && message.hasOwnProperty("data")) {
        if (!Array.isArray(message.data))
          return "data: array expected";
        for (let i = 0; i < message.data.length; ++i) {
          let error = $root.price.SectorVolatility.verify(message.data[i]);
          if (error)
            return "data." + error;
        }
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.priceVolatilityKey != null && message.hasOwnProperty("priceVolatilityKey")) {
        if (!Array.isArray(message.priceVolatilityKey))
          return "priceVolatilityKey: array expected";
        for (let i = 0; i < message.priceVolatilityKey.length; ++i)
          if (!$util.isString(message.priceVolatilityKey[i]))
            return "priceVolatilityKey: string[] expected";
      }
      if (message.priceVolatilityValue != null && message.hasOwnProperty("priceVolatilityValue")) {
        if (!Array.isArray(message.priceVolatilityValue))
          return "priceVolatilityValue: array expected";
        for (let i = 0; i < message.priceVolatilityValue.length; ++i)
          if (typeof message.priceVolatilityValue[i] !== "number")
            return "priceVolatilityValue: number[] expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.volume != null && message.hasOwnProperty("volume")) {
        if (typeof message.volume !== "number")
          return "volume: number expected";
      }
      if (message.marketCap != null && message.hasOwnProperty("marketCap")) {
        if (typeof message.marketCap !== "number")
          return "marketCap: number expected";
      }
      if (message.totalStocks != null && message.hasOwnProperty("totalStocks")) {
        if (!$util.isInteger(message.totalStocks))
          return "totalStocks: integer expected";
      }
      return null;
    };
    ListSectorVolatility.fromObject = function fromObject(object) {
      if (object instanceof $root.price.ListSectorVolatility)
        return object;
      let message = new $root.price.ListSectorVolatility();
      if (object.data) {
        if (!Array.isArray(object.data))
          throw TypeError(".price.ListSectorVolatility.data: array expected");
        message.data = [];
        for (let i = 0; i < object.data.length; ++i) {
          if (typeof object.data[i] !== "object")
            throw TypeError(".price.ListSectorVolatility.data: object expected");
          message.data[i] = $root.price.SectorVolatility.fromObject(object.data[i]);
        }
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.ListSectorVolatility.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.priceVolatilityKey) {
        if (!Array.isArray(object.priceVolatilityKey))
          throw TypeError(".price.ListSectorVolatility.priceVolatilityKey: array expected");
        message.priceVolatilityKey = [];
        for (let i = 0; i < object.priceVolatilityKey.length; ++i)
          message.priceVolatilityKey[i] = String(object.priceVolatilityKey[i]);
      }
      if (object.priceVolatilityValue) {
        if (!Array.isArray(object.priceVolatilityValue))
          throw TypeError(".price.ListSectorVolatility.priceVolatilityValue: array expected");
        message.priceVolatilityValue = [];
        for (let i = 0; i < object.priceVolatilityValue.length; ++i)
          message.priceVolatilityValue[i] = Number(object.priceVolatilityValue[i]);
      }
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.volume != null)
        message.volume = Number(object.volume);
      if (object.marketCap != null)
        message.marketCap = Number(object.marketCap);
      if (object.totalStocks != null)
        message.totalStocks = object.totalStocks | 0;
      return message;
    };
    ListSectorVolatility.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.data = [];
        object.priceVolatilityKey = [];
        object.priceVolatilityValue = [];
      }
      if (options.defaults) {
        object.time = null;
        object.matchPrice = 0;
        object.volume = 0;
        object.marketCap = 0;
        object.totalStocks = 0;
      }
      if (message.data && message.data.length) {
        object.data = [];
        for (let j = 0; j < message.data.length; ++j)
          object.data[j] = $root.price.SectorVolatility.toObject(message.data[j], options);
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.priceVolatilityKey && message.priceVolatilityKey.length) {
        object.priceVolatilityKey = [];
        for (let j = 0; j < message.priceVolatilityKey.length; ++j)
          object.priceVolatilityKey[j] = message.priceVolatilityKey[j];
      }
      if (message.priceVolatilityValue && message.priceVolatilityValue.length) {
        object.priceVolatilityValue = [];
        for (let j = 0; j < message.priceVolatilityValue.length; ++j)
          object.priceVolatilityValue[j] = options.json && !isFinite(message.priceVolatilityValue[j]) ? String(message.priceVolatilityValue[j]) : message.priceVolatilityValue[j];
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.volume != null && message.hasOwnProperty("volume"))
        object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
      if (message.marketCap != null && message.hasOwnProperty("marketCap"))
        object.marketCap = options.json && !isFinite(message.marketCap) ? String(message.marketCap) : message.marketCap;
      if (message.totalStocks != null && message.hasOwnProperty("totalStocks"))
        object.totalStocks = message.totalStocks;
      return object;
    };
    ListSectorVolatility.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ListSectorVolatility;
  }();
  price2.SectorVolatility = function() {
    function SectorVolatility(properties) {
      this.priceVolatilityKey = [];
      this.priceVolatilityValue = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SectorVolatility.prototype.id = "";
    SectorVolatility.prototype.slug = "";
    SectorVolatility.prototype.name = "";
    SectorVolatility.prototype.priceVolatilityKey = $util.emptyArray;
    SectorVolatility.prototype.priceVolatilityValue = $util.emptyArray;
    SectorVolatility.prototype.matchPrice = 0;
    SectorVolatility.prototype.volume = 0;
    SectorVolatility.prototype.marketCap = 0;
    SectorVolatility.prototype.totalStocks = 0;
    SectorVolatility.create = function create(properties) {
      return new SectorVolatility(properties);
    };
    SectorVolatility.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.slug != null && Object.hasOwnProperty.call(message, "slug"))
        writer.uint32(18).string(message.slug);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(26).string(message.name);
      if (message.priceVolatilityKey != null && message.priceVolatilityKey.length)
        for (let i = 0; i < message.priceVolatilityKey.length; ++i)
          writer.uint32(34).string(message.priceVolatilityKey[i]);
      if (message.priceVolatilityValue != null && message.priceVolatilityValue.length) {
        writer.uint32(42).fork();
        for (let i = 0; i < message.priceVolatilityValue.length; ++i)
          writer.double(message.priceVolatilityValue[i]);
        writer.ldelim();
      }
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(49).double(message.matchPrice);
      if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
        writer.uint32(57).double(message.volume);
      if (message.marketCap != null && Object.hasOwnProperty.call(message, "marketCap"))
        writer.uint32(65).double(message.marketCap);
      if (message.totalStocks != null && Object.hasOwnProperty.call(message, "totalStocks"))
        writer.uint32(72).int32(message.totalStocks);
      return writer;
    };
    SectorVolatility.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SectorVolatility.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.SectorVolatility();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.slug = reader.string();
            break;
          case 3:
            message.name = reader.string();
            break;
          case 4:
            if (!(message.priceVolatilityKey && message.priceVolatilityKey.length))
              message.priceVolatilityKey = [];
            message.priceVolatilityKey.push(reader.string());
            break;
          case 5:
            if (!(message.priceVolatilityValue && message.priceVolatilityValue.length))
              message.priceVolatilityValue = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2)
                message.priceVolatilityValue.push(reader.double());
            } else
              message.priceVolatilityValue.push(reader.double());
            break;
          case 6:
            message.matchPrice = reader.double();
            break;
          case 7:
            message.volume = reader.double();
            break;
          case 8:
            message.marketCap = reader.double();
            break;
          case 9:
            message.totalStocks = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SectorVolatility.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SectorVolatility.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.slug != null && message.hasOwnProperty("slug")) {
        if (!$util.isString(message.slug))
          return "slug: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.priceVolatilityKey != null && message.hasOwnProperty("priceVolatilityKey")) {
        if (!Array.isArray(message.priceVolatilityKey))
          return "priceVolatilityKey: array expected";
        for (let i = 0; i < message.priceVolatilityKey.length; ++i)
          if (!$util.isString(message.priceVolatilityKey[i]))
            return "priceVolatilityKey: string[] expected";
      }
      if (message.priceVolatilityValue != null && message.hasOwnProperty("priceVolatilityValue")) {
        if (!Array.isArray(message.priceVolatilityValue))
          return "priceVolatilityValue: array expected";
        for (let i = 0; i < message.priceVolatilityValue.length; ++i)
          if (typeof message.priceVolatilityValue[i] !== "number")
            return "priceVolatilityValue: number[] expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.volume != null && message.hasOwnProperty("volume")) {
        if (typeof message.volume !== "number")
          return "volume: number expected";
      }
      if (message.marketCap != null && message.hasOwnProperty("marketCap")) {
        if (typeof message.marketCap !== "number")
          return "marketCap: number expected";
      }
      if (message.totalStocks != null && message.hasOwnProperty("totalStocks")) {
        if (!$util.isInteger(message.totalStocks))
          return "totalStocks: integer expected";
      }
      return null;
    };
    SectorVolatility.fromObject = function fromObject(object) {
      if (object instanceof $root.price.SectorVolatility)
        return object;
      let message = new $root.price.SectorVolatility();
      if (object.id != null)
        message.id = String(object.id);
      if (object.slug != null)
        message.slug = String(object.slug);
      if (object.name != null)
        message.name = String(object.name);
      if (object.priceVolatilityKey) {
        if (!Array.isArray(object.priceVolatilityKey))
          throw TypeError(".price.SectorVolatility.priceVolatilityKey: array expected");
        message.priceVolatilityKey = [];
        for (let i = 0; i < object.priceVolatilityKey.length; ++i)
          message.priceVolatilityKey[i] = String(object.priceVolatilityKey[i]);
      }
      if (object.priceVolatilityValue) {
        if (!Array.isArray(object.priceVolatilityValue))
          throw TypeError(".price.SectorVolatility.priceVolatilityValue: array expected");
        message.priceVolatilityValue = [];
        for (let i = 0; i < object.priceVolatilityValue.length; ++i)
          message.priceVolatilityValue[i] = Number(object.priceVolatilityValue[i]);
      }
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.volume != null)
        message.volume = Number(object.volume);
      if (object.marketCap != null)
        message.marketCap = Number(object.marketCap);
      if (object.totalStocks != null)
        message.totalStocks = object.totalStocks | 0;
      return message;
    };
    SectorVolatility.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.priceVolatilityKey = [];
        object.priceVolatilityValue = [];
      }
      if (options.defaults) {
        object.id = "";
        object.slug = "";
        object.name = "";
        object.matchPrice = 0;
        object.volume = 0;
        object.marketCap = 0;
        object.totalStocks = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.slug != null && message.hasOwnProperty("slug"))
        object.slug = message.slug;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.priceVolatilityKey && message.priceVolatilityKey.length) {
        object.priceVolatilityKey = [];
        for (let j = 0; j < message.priceVolatilityKey.length; ++j)
          object.priceVolatilityKey[j] = message.priceVolatilityKey[j];
      }
      if (message.priceVolatilityValue && message.priceVolatilityValue.length) {
        object.priceVolatilityValue = [];
        for (let j = 0; j < message.priceVolatilityValue.length; ++j)
          object.priceVolatilityValue[j] = options.json && !isFinite(message.priceVolatilityValue[j]) ? String(message.priceVolatilityValue[j]) : message.priceVolatilityValue[j];
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.volume != null && message.hasOwnProperty("volume"))
        object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
      if (message.marketCap != null && message.hasOwnProperty("marketCap"))
        object.marketCap = options.json && !isFinite(message.marketCap) ? String(message.marketCap) : message.marketCap;
      if (message.totalStocks != null && message.hasOwnProperty("totalStocks"))
        object.totalStocks = message.totalStocks;
      return object;
    };
    SectorVolatility.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SectorVolatility;
  }();
  price2.ListStockVolatility = function() {
    function ListStockVolatility(properties) {
      this.data = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ListStockVolatility.prototype.data = $util.emptyArray;
    ListStockVolatility.prototype.time = null;
    ListStockVolatility.create = function create(properties) {
      return new ListStockVolatility(properties);
    };
    ListStockVolatility.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.data != null && message.data.length)
        for (let i = 0; i < message.data.length; ++i)
          $root.price.StockVolatility.encode(message.data[i], writer.uint32(10).fork()).ldelim();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    ListStockVolatility.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ListStockVolatility.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.ListStockVolatility();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.data && message.data.length))
              message.data = [];
            message.data.push($root.price.StockVolatility.decode(reader, reader.uint32()));
            break;
          case 2:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ListStockVolatility.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ListStockVolatility.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.data != null && message.hasOwnProperty("data")) {
        if (!Array.isArray(message.data))
          return "data: array expected";
        for (let i = 0; i < message.data.length; ++i) {
          let error = $root.price.StockVolatility.verify(message.data[i]);
          if (error)
            return "data." + error;
        }
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    ListStockVolatility.fromObject = function fromObject(object) {
      if (object instanceof $root.price.ListStockVolatility)
        return object;
      let message = new $root.price.ListStockVolatility();
      if (object.data) {
        if (!Array.isArray(object.data))
          throw TypeError(".price.ListStockVolatility.data: array expected");
        message.data = [];
        for (let i = 0; i < object.data.length; ++i) {
          if (typeof object.data[i] !== "object")
            throw TypeError(".price.ListStockVolatility.data: object expected");
          message.data[i] = $root.price.StockVolatility.fromObject(object.data[i]);
        }
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".price.ListStockVolatility.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    ListStockVolatility.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.data = [];
      if (options.defaults)
        object.time = null;
      if (message.data && message.data.length) {
        object.data = [];
        for (let j = 0; j < message.data.length; ++j)
          object.data[j] = $root.price.StockVolatility.toObject(message.data[j], options);
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    ListStockVolatility.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ListStockVolatility;
  }();
  price2.StockVolatility = function() {
    function StockVolatility(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockVolatility.prototype.symbol = "";
    StockVolatility.prototype.priceChangePrevSession = 0;
    StockVolatility.prototype.matchPrice = 0;
    StockVolatility.prototype.volume = 0;
    StockVolatility.prototype.marketCap = 0;
    StockVolatility.prototype.highLimitPrice = 0;
    StockVolatility.prototype.referencePrice = 0;
    StockVolatility.prototype.lowLimitPrice = 0;
    StockVolatility.prototype.changed = 0;
    StockVolatility.prototype.closePrice = 0;
    StockVolatility.prototype.expectedTradePrice = 0;
    StockVolatility.prototype.symbolMatchPrice = 0;
    StockVolatility.prototype.tradingSessionId = 0;
    StockVolatility.create = function create(properties) {
      return new StockVolatility(properties);
    };
    StockVolatility.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.priceChangePrevSession != null && Object.hasOwnProperty.call(message, "priceChangePrevSession"))
        writer.uint32(17).double(message.priceChangePrevSession);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(25).double(message.matchPrice);
      if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
        writer.uint32(33).double(message.volume);
      if (message.marketCap != null && Object.hasOwnProperty.call(message, "marketCap"))
        writer.uint32(41).double(message.marketCap);
      if (message.highLimitPrice != null && Object.hasOwnProperty.call(message, "highLimitPrice"))
        writer.uint32(49).double(message.highLimitPrice);
      if (message.referencePrice != null && Object.hasOwnProperty.call(message, "referencePrice"))
        writer.uint32(57).double(message.referencePrice);
      if (message.lowLimitPrice != null && Object.hasOwnProperty.call(message, "lowLimitPrice"))
        writer.uint32(65).double(message.lowLimitPrice);
      if (message.changed != null && Object.hasOwnProperty.call(message, "changed"))
        writer.uint32(73).double(message.changed);
      if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
        writer.uint32(81).double(message.closePrice);
      if (message.expectedTradePrice != null && Object.hasOwnProperty.call(message, "expectedTradePrice"))
        writer.uint32(89).double(message.expectedTradePrice);
      if (message.symbolMatchPrice != null && Object.hasOwnProperty.call(message, "symbolMatchPrice"))
        writer.uint32(97).double(message.symbolMatchPrice);
      if (message.tradingSessionId != null && Object.hasOwnProperty.call(message, "tradingSessionId"))
        writer.uint32(105).double(message.tradingSessionId);
      return writer;
    };
    StockVolatility.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockVolatility.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.price.StockVolatility();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.priceChangePrevSession = reader.double();
            break;
          case 3:
            message.matchPrice = reader.double();
            break;
          case 4:
            message.volume = reader.double();
            break;
          case 5:
            message.marketCap = reader.double();
            break;
          case 6:
            message.highLimitPrice = reader.double();
            break;
          case 7:
            message.referencePrice = reader.double();
            break;
          case 8:
            message.lowLimitPrice = reader.double();
            break;
          case 9:
            message.changed = reader.double();
            break;
          case 10:
            message.closePrice = reader.double();
            break;
          case 11:
            message.expectedTradePrice = reader.double();
            break;
          case 12:
            message.symbolMatchPrice = reader.double();
            break;
          case 13:
            message.tradingSessionId = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockVolatility.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockVolatility.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.priceChangePrevSession != null && message.hasOwnProperty("priceChangePrevSession")) {
        if (typeof message.priceChangePrevSession !== "number")
          return "priceChangePrevSession: number expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.volume != null && message.hasOwnProperty("volume")) {
        if (typeof message.volume !== "number")
          return "volume: number expected";
      }
      if (message.marketCap != null && message.hasOwnProperty("marketCap")) {
        if (typeof message.marketCap !== "number")
          return "marketCap: number expected";
      }
      if (message.highLimitPrice != null && message.hasOwnProperty("highLimitPrice")) {
        if (typeof message.highLimitPrice !== "number")
          return "highLimitPrice: number expected";
      }
      if (message.referencePrice != null && message.hasOwnProperty("referencePrice")) {
        if (typeof message.referencePrice !== "number")
          return "referencePrice: number expected";
      }
      if (message.lowLimitPrice != null && message.hasOwnProperty("lowLimitPrice")) {
        if (typeof message.lowLimitPrice !== "number")
          return "lowLimitPrice: number expected";
      }
      if (message.changed != null && message.hasOwnProperty("changed")) {
        if (typeof message.changed !== "number")
          return "changed: number expected";
      }
      if (message.closePrice != null && message.hasOwnProperty("closePrice")) {
        if (typeof message.closePrice !== "number")
          return "closePrice: number expected";
      }
      if (message.expectedTradePrice != null && message.hasOwnProperty("expectedTradePrice")) {
        if (typeof message.expectedTradePrice !== "number")
          return "expectedTradePrice: number expected";
      }
      if (message.symbolMatchPrice != null && message.hasOwnProperty("symbolMatchPrice")) {
        if (typeof message.symbolMatchPrice !== "number")
          return "symbolMatchPrice: number expected";
      }
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId")) {
        if (typeof message.tradingSessionId !== "number")
          return "tradingSessionId: number expected";
      }
      return null;
    };
    StockVolatility.fromObject = function fromObject(object) {
      if (object instanceof $root.price.StockVolatility)
        return object;
      let message = new $root.price.StockVolatility();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.priceChangePrevSession != null)
        message.priceChangePrevSession = Number(object.priceChangePrevSession);
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.volume != null)
        message.volume = Number(object.volume);
      if (object.marketCap != null)
        message.marketCap = Number(object.marketCap);
      if (object.highLimitPrice != null)
        message.highLimitPrice = Number(object.highLimitPrice);
      if (object.referencePrice != null)
        message.referencePrice = Number(object.referencePrice);
      if (object.lowLimitPrice != null)
        message.lowLimitPrice = Number(object.lowLimitPrice);
      if (object.changed != null)
        message.changed = Number(object.changed);
      if (object.closePrice != null)
        message.closePrice = Number(object.closePrice);
      if (object.expectedTradePrice != null)
        message.expectedTradePrice = Number(object.expectedTradePrice);
      if (object.symbolMatchPrice != null)
        message.symbolMatchPrice = Number(object.symbolMatchPrice);
      if (object.tradingSessionId != null)
        message.tradingSessionId = Number(object.tradingSessionId);
      return message;
    };
    StockVolatility.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.priceChangePrevSession = 0;
        object.matchPrice = 0;
        object.volume = 0;
        object.marketCap = 0;
        object.highLimitPrice = 0;
        object.referencePrice = 0;
        object.lowLimitPrice = 0;
        object.changed = 0;
        object.closePrice = 0;
        object.expectedTradePrice = 0;
        object.symbolMatchPrice = 0;
        object.tradingSessionId = 0;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.priceChangePrevSession != null && message.hasOwnProperty("priceChangePrevSession"))
        object.priceChangePrevSession = options.json && !isFinite(message.priceChangePrevSession) ? String(message.priceChangePrevSession) : message.priceChangePrevSession;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.volume != null && message.hasOwnProperty("volume"))
        object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
      if (message.marketCap != null && message.hasOwnProperty("marketCap"))
        object.marketCap = options.json && !isFinite(message.marketCap) ? String(message.marketCap) : message.marketCap;
      if (message.highLimitPrice != null && message.hasOwnProperty("highLimitPrice"))
        object.highLimitPrice = options.json && !isFinite(message.highLimitPrice) ? String(message.highLimitPrice) : message.highLimitPrice;
      if (message.referencePrice != null && message.hasOwnProperty("referencePrice"))
        object.referencePrice = options.json && !isFinite(message.referencePrice) ? String(message.referencePrice) : message.referencePrice;
      if (message.lowLimitPrice != null && message.hasOwnProperty("lowLimitPrice"))
        object.lowLimitPrice = options.json && !isFinite(message.lowLimitPrice) ? String(message.lowLimitPrice) : message.lowLimitPrice;
      if (message.changed != null && message.hasOwnProperty("changed"))
        object.changed = options.json && !isFinite(message.changed) ? String(message.changed) : message.changed;
      if (message.closePrice != null && message.hasOwnProperty("closePrice"))
        object.closePrice = options.json && !isFinite(message.closePrice) ? String(message.closePrice) : message.closePrice;
      if (message.expectedTradePrice != null && message.hasOwnProperty("expectedTradePrice"))
        object.expectedTradePrice = options.json && !isFinite(message.expectedTradePrice) ? String(message.expectedTradePrice) : message.expectedTradePrice;
      if (message.symbolMatchPrice != null && message.hasOwnProperty("symbolMatchPrice"))
        object.symbolMatchPrice = options.json && !isFinite(message.symbolMatchPrice) ? String(message.symbolMatchPrice) : message.symbolMatchPrice;
      if (message.tradingSessionId != null && message.hasOwnProperty("tradingSessionId"))
        object.tradingSessionId = options.json && !isFinite(message.tradingSessionId) ? String(message.tradingSessionId) : message.tradingSessionId;
      return object;
    };
    StockVolatility.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockVolatility;
  }();
  return price2;
})();
const otp = $root.otp = (() => {
  const otp2 = {};
  otp2.v1 = function() {
    const v1 = {};
    v1.Otp = function() {
      function Otp(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Otp.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
      Otp.prototype.userId = "";
      Otp.prototype.channel = 0;
      Otp.prototype.sentAt = null;
      Otp.prototype.updatedAt = null;
      Otp.prototype.status = 0;
      Otp.prototype.externalId = "";
      Otp.prototype.errorCode = "";
      Otp.prototype.errorMessage = "";
      Otp.create = function create(properties) {
        return new Otp(properties);
      };
      Otp.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).uint64(message.id);
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
          writer.uint32(18).string(message.userId);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
          writer.uint32(24).int32(message.channel);
        if (message.sentAt != null && Object.hasOwnProperty.call(message, "sentAt"))
          $root.google.protobuf.Timestamp.encode(message.sentAt, writer.uint32(34).fork()).ldelim();
        if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
          $root.google.protobuf.Timestamp.encode(message.updatedAt, writer.uint32(42).fork()).ldelim();
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(48).int32(message.status);
        if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
          writer.uint32(58).string(message.externalId);
        if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
          writer.uint32(66).string(message.errorCode);
        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
          writer.uint32(74).string(message.errorMessage);
        return writer;
      };
      Otp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Otp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.otp.v1.Otp();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.uint64();
              break;
            case 2:
              message.userId = reader.string();
              break;
            case 3:
              message.channel = reader.int32();
              break;
            case 4:
              message.sentAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 5:
              message.updatedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 6:
              message.status = reader.int32();
              break;
            case 7:
              message.externalId = reader.string();
              break;
            case 8:
              message.errorCode = reader.string();
              break;
            case 9:
              message.errorMessage = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Otp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Otp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.userId != null && message.hasOwnProperty("userId")) {
          if (!$util.isString(message.userId))
            return "userId: string expected";
        }
        if (message.channel != null && message.hasOwnProperty("channel"))
          switch (message.channel) {
            default:
              return "channel: enum value expected";
            case 0:
            case 1:
              break;
          }
        if (message.sentAt != null && message.hasOwnProperty("sentAt")) {
          let error = $root.google.protobuf.Timestamp.verify(message.sentAt);
          if (error)
            return "sentAt." + error;
        }
        if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
          let error = $root.google.protobuf.Timestamp.verify(message.updatedAt);
          if (error)
            return "updatedAt." + error;
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.externalId != null && message.hasOwnProperty("externalId")) {
          if (!$util.isString(message.externalId))
            return "externalId: string expected";
        }
        if (message.errorCode != null && message.hasOwnProperty("errorCode")) {
          if (!$util.isString(message.errorCode))
            return "errorCode: string expected";
        }
        if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
          if (!$util.isString(message.errorMessage))
            return "errorMessage: string expected";
        }
        return null;
      };
      Otp.fromObject = function fromObject(object) {
        if (object instanceof $root.otp.v1.Otp)
          return object;
        let message = new $root.otp.v1.Otp();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = true;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
        }
        if (object.userId != null)
          message.userId = String(object.userId);
        switch (object.channel) {
          case "CHANNEL_UNSPECIFIED":
          case 0:
            message.channel = 0;
            break;
          case "CHANNEL_ZNS":
          case 1:
            message.channel = 1;
            break;
        }
        if (object.sentAt != null) {
          if (typeof object.sentAt !== "object")
            throw TypeError(".otp.v1.Otp.sentAt: object expected");
          message.sentAt = $root.google.protobuf.Timestamp.fromObject(object.sentAt);
        }
        if (object.updatedAt != null) {
          if (typeof object.updatedAt !== "object")
            throw TypeError(".otp.v1.Otp.updatedAt: object expected");
          message.updatedAt = $root.google.protobuf.Timestamp.fromObject(object.updatedAt);
        }
        switch (object.status) {
          case "STATUS_UNSPECIFIED":
          case 0:
            message.status = 0;
            break;
          case "STATUS_PROCESSING":
          case 1:
            message.status = 1;
            break;
          case "STATUS_SENT":
          case 2:
            message.status = 2;
            break;
          case "STATUS_FAILED":
          case 3:
            message.status = 3;
            break;
        }
        if (object.externalId != null)
          message.externalId = String(object.externalId);
        if (object.errorCode != null)
          message.errorCode = String(object.errorCode);
        if (object.errorMessage != null)
          message.errorMessage = String(object.errorMessage);
        return message;
      };
      Otp.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, true);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.userId = "";
          object.channel = options.enums === String ? "CHANNEL_UNSPECIFIED" : 0;
          object.sentAt = null;
          object.updatedAt = null;
          object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          object.externalId = "";
          object.errorCode = "";
          object.errorMessage = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
        if (message.userId != null && message.hasOwnProperty("userId"))
          object.userId = message.userId;
        if (message.channel != null && message.hasOwnProperty("channel"))
          object.channel = options.enums === String ? $root.otp.v1.Otp.Channel[message.channel] : message.channel;
        if (message.sentAt != null && message.hasOwnProperty("sentAt"))
          object.sentAt = $root.google.protobuf.Timestamp.toObject(message.sentAt, options);
        if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
          object.updatedAt = $root.google.protobuf.Timestamp.toObject(message.updatedAt, options);
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.otp.v1.Otp.Status[message.status] : message.status;
        if (message.externalId != null && message.hasOwnProperty("externalId"))
          object.externalId = message.externalId;
        if (message.errorCode != null && message.hasOwnProperty("errorCode"))
          object.errorCode = message.errorCode;
        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
          object.errorMessage = message.errorMessage;
        return object;
      };
      Otp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      Otp.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "STATUS_PROCESSING"] = 1;
        values[valuesById[2] = "STATUS_SENT"] = 2;
        values[valuesById[3] = "STATUS_FAILED"] = 3;
        return values;
      }();
      Otp.Channel = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CHANNEL_UNSPECIFIED"] = 0;
        values[valuesById[1] = "CHANNEL_ZNS"] = 1;
        return values;
      }();
      return Otp;
    }();
    return v1;
  }();
  return otp2;
})();
const notification = $root.notification = (() => {
  const notification2 = {};
  notification2.NotiType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN"] = 0;
    values[valuesById[1] = "AUTOMATIC_CUT_LOSS"] = 1;
    values[valuesById[2] = "BOT_ORDER_SUCCESSFUL_PLACED"] = 2;
    values[valuesById[3] = "DEAL_CLOSED"] = 3;
    values[valuesById[4] = "MAINTENANCE_RATE_REACHED"] = 4;
    values[valuesById[5] = "HOLD_OVERNIGHT_ALERT"] = 5;
    values[valuesById[6] = "SECURE_OVERNIGHT_CUT_LOSS"] = 6;
    values[valuesById[7] = "ORDER_SUCCESSFUL_PLACED"] = 7;
    values[valuesById[8] = "CONDITIONAL_ORDER_TRIGGERED"] = 8;
    values[valuesById[9] = "CONDITIONAL_ORDER_CANT_TRIGGERED_PP"] = 9;
    values[valuesById[10] = "CONDITIONAL_ORDER_EXPIRED"] = 10;
    values[valuesById[11] = "ORDER_REJECTED"] = 11;
    values[valuesById[12] = "AUTOMATIC_TAKE_PROFIT"] = 12;
    values[valuesById[13] = "DNSE_ORDER_PENDING_NEW"] = 13;
    values[valuesById[14] = "DNSE_ORDER_NEW"] = 14;
    values[valuesById[15] = "DNSE_ORDER_PENDING_CANCEL"] = 15;
    values[valuesById[16] = "DNSE_ORDER_CANCELED"] = 16;
    values[valuesById[17] = "DNSE_ORDER_PARTIALLY_FILLED"] = 17;
    values[valuesById[18] = "DNSE_ORDER_FILLED"] = 18;
    values[valuesById[19] = "DEPOSIT_FUND"] = 19;
    values[valuesById[20] = "WITHDRAWAL_FUND"] = 20;
    values[valuesById[21] = "INVESTOR_REFERAL"] = 21;
    values[valuesById[22] = "MARGIN_ACCOUNT_OFFER"] = 22;
    values[valuesById[23] = "APPROVE_REGISTER"] = 23;
    values[valuesById[24] = "REJECT_REGISTER"] = 24;
    values[valuesById[25] = "INVESTOR_REMINDER"] = 25;
    values[valuesById[26] = "ENBOX_ANNOUNCEMENT"] = 26;
    values[valuesById[27] = "INVESTOR_REFERRAL_NEW_USER"] = 27;
    values[valuesById[28] = "WITHDRAWAL_PPSE_FUND"] = 28;
    values[valuesById[29] = "AI_BROKER_ANNOUNCEMENT"] = 29;
    values[valuesById[30] = "SAVINGS_PROMOTION"] = 30;
    values[valuesById[31] = "SAVINGS_DEPOSIT"] = 31;
    values[valuesById[32] = "SAVINGS_DAILY_YIELD"] = 32;
    values[valuesById[33] = "SAVINGS_MONTHLY_YIELD"] = 33;
    values[valuesById[34] = "SAVINGS_TO_BE_MATURED"] = 34;
    values[valuesById[35] = "SAVINGS_MATURED"] = 35;
    values[valuesById[36] = "SAVINGS_WITHDRAWAL"] = 36;
    values[valuesById[37] = "SAVINGS_ROLLOVER"] = 37;
    values[valuesById[38] = "SAVINGS_CREATED"] = 38;
    values[valuesById[39] = "SAVINGS_SETTLED"] = 39;
    values[valuesById[40] = "DEAL_PPSE_WITHDRAW"] = 40;
    values[valuesById[41] = "DEAL_PREPAYMENT"] = 41;
    values[valuesById[42] = "DEAL_RISK_CALL_EVENT"] = 42;
    values[valuesById[43] = "PRODUCT_SUGGESTION"] = 43;
    values[valuesById[44] = "DNSE_INVESTOR_ACTIVATED"] = 44;
    values[valuesById[45] = "DEAL_RISK_LIQUID_EVENT"] = 45;
    values[valuesById[46] = "DEAL_RISK_LIQUID_DELAY_EVENT"] = 46;
    values[valuesById[48] = "FIRST_ORDER_REWARD"] = 48;
    values[valuesById[49] = "HANDOFF_SMART_OTP"] = 49;
    values[valuesById[50] = "LOAN_WARNING_DUE_DATE"] = 50;
    values[valuesById[51] = "LOAN_OVER_DUE_DATE"] = 51;
    values[valuesById[56] = "LOAN_CALL_FORCE_SELL"] = 56;
    values[valuesById[55] = "DEAL_CORPORATE_ACTION"] = 55;
    values[valuesById[52] = "DEAL_MIGRATE"] = 52;
    values[valuesById[53] = "AVAILABLE_CASH_CHANGE"] = 53;
    values[valuesById[54] = "ACCOUNT_CORPORATE_ACTION"] = 54;
    values[valuesById[60] = "COVERED_WARRANT_SETTLEMENT"] = 60;
    values[valuesById[70] = "AUTO_CALL_PAYMENT"] = 70;
    values[valuesById[71] = "INVESTMENT_OPPORTUNITIES_ANNOUNCEMENT"] = 71;
    values[valuesById[100] = "DNSE_CONDITIONAL_ORDER_ACTIVATED"] = 100;
    values[valuesById[101] = "DNSE_CONDITIONAL_ORDER_REJECTED"] = 101;
    values[valuesById[102] = "DNSE_CONDITIONAL_ORDER_EXPIRED"] = 102;
    values[valuesById[103] = "DNSE_CONDITIONAL_ORDER_CANCELLED_BY_RIGHTS_EVENT"] = 103;
    values[valuesById[128] = "DNSE_BREAKING_NEWS"] = 128;
    values[valuesById[130] = "DNSE_ORDER_PNL_TAKE_PROFIT"] = 130;
    values[valuesById[131] = "DNSE_ORDER_PNL_STOP_LOSS"] = 131;
    values[valuesById[132] = "DNSE_ORDER_PNL_BREAK_EVEN"] = 132;
    values[valuesById[150] = "GIFT_CREATED"] = 150;
    values[valuesById[151] = "GIFT_REDEEMED"] = 151;
    values[valuesById[152] = "GIFT_REJECTED"] = 152;
    values[valuesById[153] = "GIFT_EXPIRED"] = 153;
    values[valuesById[160] = "ENTRADE_DNSE_LINK"] = 160;
    values[valuesById[180] = "DNSE_PROMO_STOCK_REWARD"] = 180;
    values[valuesById[181] = "RECOMMENDER_TRADE_SIGNAL"] = 181;
    values[valuesById[200] = "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_SUCCESS"] = 200;
    values[valuesById[201] = "DNSE_DERIVATIVE_VSD_SECURE_WITHDRAW_SUCCESS"] = 201;
    values[valuesById[202] = "DNSE_DERIVATIVE_DEAL_RISK_CALL"] = 202;
    values[valuesById[203] = "DNSE_DERIVATIVE_DEAL_RISK_LIQUID"] = 203;
    values[valuesById[204] = "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_FAILED"] = 204;
    values[valuesById[205] = "DNSE_DERIVATIVE_VSD_SECURE_WITHDRAW_FAILED"] = 205;
    values[valuesById[206] = "DNSE_DERIVATIVE_DEAL_SECURE_DEPOSIT"] = 206;
    values[valuesById[207] = "DNSE_DERIVATIVE_PAYMENT_OBLIGATION_EOD"] = 207;
    values[valuesById[208] = "DNSE_DERIVATIVE_RECEIVE_PROFIT"] = 208;
    values[valuesById[209] = "DNSE_DERIVATIVE_MATURITY"] = 209;
    values[valuesById[210] = "DNSE_DERIVATIVE_CLOSE_DEAL_TAKE_PROFIT"] = 210;
    values[valuesById[211] = "DNSE_DERIVATIVE_CLOSE_DEAL_CUT_LOSS"] = 211;
    values[valuesById[212] = "DNSE_DERIVATIVE_DEAL_RISK_STOP_LOSS"] = 212;
    values[valuesById[213] = "DNSE_DERIVATIVE_DEAL_RISK_TAKE_PROFIT"] = 213;
    values[valuesById[214] = "DNSE_DERIVATIVE_DEAL_RISK_STOP_LOSS_FAILED"] = 214;
    values[valuesById[215] = "DNSE_DERIVATIVE_DEAL_RISK_TAKE_PROFIT_FAILED"] = 215;
    values[valuesById[216] = "DNSE_DERIVATIVE_DEAL_SECURE_WITHDRAW"] = 216;
    values[valuesById[217] = "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_PENDING_TO_VSD"] = 217;
    values[valuesById[220] = "DNSE_DERIVATIVE_PREPAY_LOAN_SUCCESS"] = 220;
    values[valuesById[221] = "DNSE_DERIVATIVE_PREPAY_LOAN_FAILED"] = 221;
    values[valuesById[222] = "DNSE_DERIVATIVE_END_OF_MONTH_INTEREST_PAYMENT"] = 222;
    values[valuesById[223] = "DNSE_DERIVATIVE_DEPOSIT_SECURE_FROM_BANK_FAILED"] = 223;
    values[valuesById[224] = "DNSE_LINKED_ACCOUNT_DEPOSIT_PENDING_WARNING"] = 224;
    values[valuesById[300] = "ADVANCE_WITHDRAWAL"] = 300;
    values[valuesById[400] = "DNSE_BROKER_SACO_CAREBY_REQUEST"] = 400;
    values[valuesById[405] = "DNSE_BROKER_OPERATION_REQUEST"] = 405;
    values[valuesById[407] = "DNSE_BROKER_FINANCING_OFFER_LOAN_PACKAGE_REQUEST"] = 407;
    values[valuesById[401] = "DNSE_PROMOTION"] = 401;
    values[valuesById[402] = "DNSE_DIVIDEND_STOCK_RECEIVED"] = 402;
    values[valuesById[403] = "DNSE_DIVIDEND_CASH_RECEIVED"] = 403;
    values[valuesById[404] = "DNSE_RIGHTS_OFFERING"] = 404;
    values[valuesById[406] = "DNSE_STOCK_BONUS_SHARES"] = 406;
    values[valuesById[408] = "DNSE_ATTEND_SHAREHOLDERS_MEETING"] = 408;
    values[valuesById[409] = "DNSE_GATHER_SHAREHOLDER_OPINIONS"] = 409;
    values[valuesById[450] = "CHATBOT_QUESTION"] = 450;
    values[valuesById[451] = "CHATBOT_QUESTION_TIMEOUT"] = 451;
    values[valuesById[452] = "CHATBOT_QUESTION_CANCEL"] = 452;
    values[valuesById[453] = "CHATBOT_ANSWER_SUCCESSFULLY"] = 453;
    values[valuesById[454] = "CHATBOT_ENSA_MESSAGE"] = 454;
    values[valuesById[455] = "CHATBOT_SUGGESTED_QUESTION"] = 455;
    values[valuesById[500] = "FINANCING_OFFER_CREATED"] = 500;
    values[valuesById[501] = "FINANCING_OFFER_REQUEST_DECLINED"] = 501;
    values[valuesById[502] = "FINANCING_OFFER_OFFLINE_CONFIRMATION"] = 502;
    values[valuesById[503] = "FINANCING_OFFER_ONLINE_CONFIRMATION"] = 503;
    values[valuesById[504] = "FINANCING_OFFER_LOAN_PACKAGE_READY"] = 504;
    values[valuesById[505] = "FINANCING_OFFER_DERIVATIVE_REQUEST_DECLINED"] = 505;
    values[valuesById[506] = "FINANCING_OFFER_DERIVATIVE_OFFLINE_CONFIRMATION"] = 506;
    values[valuesById[507] = "FINANCING_OFFER_DERIVATIVE_LOAN_PACKAGE_READY"] = 507;
    values[valuesById[508] = "FINANCING_OFFER_SUGGESTED_OFFER_CREATED"] = 508;
    values[valuesById[600] = "IPO_NOTIFY_SUBMITTED_REGISTRATION_FORM_PARTIALLY_DEPOSITED"] = 600;
    values[valuesById[601] = "IPO_NOTIFY_SUBMITTED_REGISTRATION_FORM_DEPOSITED"] = 601;
    values[valuesById[602] = "IPO_NOTIFY_NEW_REGISTRATION_FORM_PARTIALLY_DEPOSITED"] = 602;
    values[valuesById[603] = "IPO_NOTIFY_NEW_REGISTRATION_FORM_DEPOSITED"] = 603;
    values[valuesById[604] = "IPO_NOTIFY_REGISTRATION_FORM_SUBMISSION"] = 604;
    values[valuesById[605] = "IPO_NOTIFY_REGISTRATION_FORM_MODIFICATION"] = 605;
    values[valuesById[606] = "IPO_NOTIFY_PAYMENT_FAILED"] = 606;
    values[valuesById[607] = "IPO_NOTIFY_NOT_ENOUGH_MONEY"] = 607;
    values[valuesById[608] = "IPO_NOTIFY_REJECTED_REGISTRATION_FORM"] = 608;
    values[valuesById[609] = "IPO_NOTIFY_VALID_REGISTRATION_FORM"] = 609;
    values[valuesById[610] = "IPO_NOTIFY_SUCCESSFUL_PAID_AUCTION"] = 610;
    values[valuesById[611] = "IPO_NOTIFY_SUCCESSFUL_UNPAID_AUCTION"] = 611;
    values[valuesById[612] = "IPO_NOTIFY_AUCTION_FAILED"] = 612;
    values[valuesById[613] = "IPO_NOTIFY_REJECTED_AUCTION"] = 613;
    values[valuesById[614] = "IPO_NOTIFY_INCOMPLETE_FORM"] = 614;
    values[valuesById[615] = "IPO_NOTIFY_FINAL_DAY_INCOMPLETE_FORM"] = 615;
    values[valuesById[616] = "IPO_NOTIFY_DEPOSIT_PAYMENT"] = 616;
    values[valuesById[617] = "IPO_NOTIFY_FINAL_DAY_DEPOSIT_PAYMENT"] = 617;
    values[valuesById[618] = "IPO_NOTIFY_PAYMENT_REMINDER"] = 618;
    values[valuesById[619] = "IPO_NOTIFY_DECLINED_AUCTION"] = 619;
    values[valuesById[620] = "IPO_NOTIFY_BECAME_SHAREHOLDER"] = 620;
    values[valuesById[621] = "IPO_NOTIFY_REFUNDED_PAYMENT"] = 621;
    values[valuesById[700] = "MOBILIZED_CAPITAL_LOAN_PACKAGE_CREATED"] = 700;
    values[valuesById[701] = "MOBILIZED_CAPITAL_LOAN_PACKAGE_CLOSED"] = 701;
    values[valuesById[702] = "MOBILIZED_CAPITAL_MATURITY_ALERT"] = 702;
    values[valuesById[703] = "MOBILIZED_CAPITAL_LOAN_INVESTOR_ACTIVATED"] = 703;
    values[valuesById[704] = "MOBILIZED_CAPITAL_GOLDEN_EGG_CREATED"] = 704;
    values[valuesById[800] = "GAMIFICATION_PERSONAL_LEADERBOARD_RESULT"] = 800;
    values[valuesById[900] = "LOYALTY_LEVEL_MAINTAIN"] = 900;
    values[valuesById[901] = "LOYALTY_LEVEL_CHANGE"] = 901;
    values[valuesById[902] = "LOYALTY_LEVEL_UP"] = 902;
    values[valuesById[903] = "LOYALTY_ADD_POINT"] = 903;
    values[valuesById[904] = "LOYALTY_USED_POINT"] = 904;
    values[valuesById[905] = "LOYALTY_ABOUT_EXPIRE"] = 905;
    values[valuesById[1e3] = "CO_INVESTMENT_SEND_AGREEMENT"] = 1e3;
    values[valuesById[1001] = "CO_INVESTMENT_ACCEPT_AGREEMENT"] = 1001;
    values[valuesById[1002] = "CO_INVESTMENT_REMIND_DEPOSIT"] = 1002;
    values[valuesById[1003] = "CO_INVESTMENT_GROUP_DEPOSIT"] = 1003;
    values[valuesById[1004] = "CO_INVESTMENT_GROUP_REFUND"] = 1004;
    values[valuesById[1005] = "CO_INVESTMENT_MEMBER_TRANSFER"] = 1005;
    values[valuesById[1006] = "CO_INVESTMENT_MEMBER_RECEIVE_REFUND"] = 1006;
    values[valuesById[1007] = "CO_INVESTMENT_CLOSE_AGREEMENT"] = 1007;
    values[valuesById[1100] = "USER_CHANGE_REQUEST_ADDRESS_SUCCESSED"] = 1100;
    values[valuesById[1101] = "USER_CHANGE_REQUEST_ADDRESS_FAILED"] = 1101;
    values[valuesById[1102] = "USER_CHANGE_REQUEST_KYC_SUCCESSED"] = 1102;
    values[valuesById[1103] = "USER_CHANGE_REQUEST_KYC_FAILED"] = 1103;
    values[valuesById[1104] = "USER_CHANGE_REQUEST_CANCEL_FAILED"] = 1104;
    values[valuesById[1105] = "WARNING_UPDATE_INFORMATION_IDENTIFICATION_EXPIRED"] = 1105;
    values[valuesById[1106] = "WARNING_UPDATE_INFORMATION_IDENTIFICATION_UNSUPPORTED"] = 1106;
    values[valuesById[1107] = "WARNING_UPDATE_INFORMATION_MPS_NOT_MATCH"] = 1107;
    values[valuesById[1200] = "ENTRADE_LOANX_LOAN_PACKAGE_CREATED"] = 1200;
    values[valuesById[1201] = "ENTRADE_LOANX_LOAN_PACKAGE_CLOSED"] = 1201;
    values[valuesById[1202] = "ENTRADE_LOANX_MATURITY_ALERT"] = 1202;
    values[valuesById[1203] = "ENTRADE_LOANX_LOAN_INVESTOR_ACTIVATED"] = 1203;
    values[valuesById[1204] = "ENTRADE_LOANX_LOAN_PACKAGE_SETTLEMENT"] = 1204;
    values[valuesById[1205] = "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_DEPOSIT"] = 1205;
    values[valuesById[1206] = "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_WITHDRAWAL"] = 1206;
    values[valuesById[1290] = "ACCOUNT_BECOME_INSIDER"] = 1290;
    values[valuesById[1291] = "ACCOUNT_REMOVE_FROM_INSIDER"] = 1291;
    values[valuesById[1300] = "MGM_GET_REWARD"] = 1300;
    values[valuesById[1400] = "GOLDEN_EGG_CREATED"] = 1400;
    values[valuesById[1401] = "GOLDEN_EGG_CREATED_FAIL"] = 1401;
    values[valuesById[1402] = "GOLDEN_EGG_RECEIVED_INTEREST"] = 1402;
    values[valuesById[1403] = "GOLDEN_EGG_DUE_DATE"] = 1403;
    values[valuesById[1404] = "GOLDEN_EGG_OVER_DUE_DATE"] = 1404;
    values[valuesById[1405] = "GOLDEN_EGG_SELLING_CONFIRMATION"] = 1405;
    values[valuesById[1406] = "GOLDEN_EGG_CREATED_PRE_MARKET"] = 1406;
    values[valuesById[1407] = "GOLDEN_EGG_SUCCEED_SELL_CONFIRMATION"] = 1407;
    values[valuesById[1600] = "WI_ADD_REWARD"] = 1600;
    values[valuesById[1601] = "STOCK_REWARD_24H_WAIT_TO_TRANSFER"] = 1601;
    values[valuesById[1602] = "STOCK_REWARD_24H_EXPIRING_SOON"] = 1602;
    values[valuesById[1603] = "STOCK_REWARD_24H_SUCCESS"] = 1603;
    values[valuesById[1604] = "STOCK_REWARD_24H_EXPIRED"] = 1604;
    values[valuesById[1700] = "DNSE_SOE_DEAL_NEW"] = 1700;
    values[valuesById[1701] = "DNSE_SOE_DEAL_EXPRIED"] = 1701;
    values[valuesById[1702] = "DNSE_SOE_DEAL_CANCELED"] = 1702;
    values[valuesById[1703] = "DNSE_SOE_DEAL_PARTIALLY_FILLED"] = 1703;
    values[valuesById[1704] = "DNSE_SOE_DEAL_FILLED"] = 1704;
    values[valuesById[1705] = "DNSE_SOE_DEAL_WAITING_EXPIRE"] = 1705;
    values[valuesById[1706] = "DNSE_SOE_DEAL_WAITING_CANCEL"] = 1706;
    values[valuesById[1800] = "SAVINGS_ACCOUNT_FINANCING_CASH_CREATED"] = 1800;
    values[valuesById[1801] = "SAVINGS_ACCOUNT_FINANCING_CASH_FAILED"] = 1801;
    values[valuesById[1802] = "SAVINGS_ACCOUNT_FINANCING_CASH_WITHDRAWAL"] = 1802;
    values[valuesById[1900] = "DNSE_LINK_TRANSACTION"] = 1900;
    values[valuesById[2e3] = "LOAN_NEXUS_EVF_CONTRACT_CREATED"] = 2e3;
    values[valuesById[2001] = "LOAN_NEXUS_EVF_CONTRACT_CANCELLED"] = 2001;
    values[valuesById[2002] = "LOAN_NEXUS_EVF_CONTRACT_REFUSED"] = 2002;
    values[valuesById[2003] = "LOAN_NEXUS_EVF_CONTRACT_ACTIVATED"] = 2003;
    values[valuesById[2004] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_CREATED"] = 2004;
    values[valuesById[2005] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_CANCELLED"] = 2005;
    values[valuesById[2006] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_REFUSED"] = 2006;
    values[valuesById[2007] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_EVF"] = 2007;
    values[valuesById[2008] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE"] = 2008;
    values[valuesById[2009] = "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE_FAILED"] = 2009;
    values[valuesById[2100] = "LOOK_BACK_NOTIFICATION"] = 2100;
    values[valuesById[2200] = "SUBSCRIPTION_ACTION"] = 2200;
    values[valuesById[2201] = "SUBSCRIPTION_ACTION_PREV_RENEW"] = 2201;
    values[valuesById[2202] = "SUBSCRIPTION_ACTION_RENEW_SUCCESS"] = 2202;
    values[valuesById[2203] = "SUBSCRIPTION_ACTION_RENEW_FAILED"] = 2203;
    values[valuesById[2204] = "SUBSCRIPTION_ACTION_SUBSCRIBE_SUCCESS"] = 2204;
    values[valuesById[2205] = "SUBSCRIPTION_ACTION_SUBSCRIBE_FAILED"] = 2205;
    values[valuesById[2300] = "TRANSACTION_CONFIRMATIONS_OWNER_COSPONSOR_BANK_SHOULD_CONFIRM_TRANSACTION"] = 2300;
    return values;
  }();
  notification2.Notification = function() {
    function Notification(properties) {
      this.userIds = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Notification.prototype.senderId = 0;
    Notification.prototype.userId = "";
    Notification.prototype.type = 0;
    Notification.prototype.heading = "";
    Notification.prototype.content = "";
    Notification.prototype.url = "";
    Notification.prototype.data = null;
    Notification.prototype.read = false;
    Notification.prototype.createdDate = null;
    Notification.prototype.env = "";
    Notification.prototype.htmlContent = "";
    Notification.prototype.attachment = null;
    Notification.prototype.onlyPushNotification = false;
    Notification.prototype.userIds = $util.emptyArray;
    Notification.prototype.pushNotificationDisable = false;
    Notification.prototype.groupId = "";
    Notification.create = function create(properties) {
      return new Notification(properties);
    };
    Notification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
        writer.uint32(8).int32(message.senderId);
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(18).string(message.userId);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(24).int32(message.type);
      if (message.heading != null && Object.hasOwnProperty.call(message, "heading"))
        writer.uint32(34).string(message.heading);
      if (message.content != null && Object.hasOwnProperty.call(message, "content"))
        writer.uint32(42).string(message.content);
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(50).string(message.url);
      if (message.data != null && Object.hasOwnProperty.call(message, "data"))
        $root.google.protobuf.Struct.encode(message.data, writer.uint32(58).fork()).ldelim();
      if (message.read != null && Object.hasOwnProperty.call(message, "read"))
        writer.uint32(64).bool(message.read);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
      if (message.env != null && Object.hasOwnProperty.call(message, "env"))
        writer.uint32(82).string(message.env);
      if (message.htmlContent != null && Object.hasOwnProperty.call(message, "htmlContent"))
        writer.uint32(90).string(message.htmlContent);
      if (message.attachment != null && Object.hasOwnProperty.call(message, "attachment"))
        $root.notification.Attachment.encode(message.attachment, writer.uint32(98).fork()).ldelim();
      if (message.onlyPushNotification != null && Object.hasOwnProperty.call(message, "onlyPushNotification"))
        writer.uint32(104).bool(message.onlyPushNotification);
      if (message.userIds != null && message.userIds.length)
        for (let i = 0; i < message.userIds.length; ++i)
          writer.uint32(114).string(message.userIds[i]);
      if (message.pushNotificationDisable != null && Object.hasOwnProperty.call(message, "pushNotificationDisable"))
        writer.uint32(120).bool(message.pushNotificationDisable);
      if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
        writer.uint32(130).string(message.groupId);
      return writer;
    };
    Notification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Notification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.Notification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.senderId = reader.int32();
            break;
          case 2:
            message.userId = reader.string();
            break;
          case 3:
            message.type = reader.int32();
            break;
          case 4:
            message.heading = reader.string();
            break;
          case 5:
            message.content = reader.string();
            break;
          case 6:
            message.url = reader.string();
            break;
          case 7:
            message.data = $root.google.protobuf.Struct.decode(reader, reader.uint32());
            break;
          case 8:
            message.read = reader.bool();
            break;
          case 9:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.env = reader.string();
            break;
          case 11:
            message.htmlContent = reader.string();
            break;
          case 12:
            message.attachment = $root.notification.Attachment.decode(reader, reader.uint32());
            break;
          case 13:
            message.onlyPushNotification = reader.bool();
            break;
          case 14:
            if (!(message.userIds && message.userIds.length))
              message.userIds = [];
            message.userIds.push(reader.string());
            break;
          case 15:
            message.pushNotificationDisable = reader.bool();
            break;
          case 16:
            message.groupId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Notification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Notification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.senderId != null && message.hasOwnProperty("senderId")) {
        if (!$util.isInteger(message.senderId))
          return "senderId: integer expected";
      }
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isString(message.userId))
          return "userId: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
          case 22:
          case 23:
          case 24:
          case 25:
          case 26:
          case 27:
          case 28:
          case 29:
          case 30:
          case 31:
          case 32:
          case 33:
          case 34:
          case 35:
          case 36:
          case 37:
          case 38:
          case 39:
          case 40:
          case 41:
          case 42:
          case 43:
          case 44:
          case 45:
          case 46:
          case 48:
          case 49:
          case 50:
          case 51:
          case 56:
          case 55:
          case 52:
          case 53:
          case 54:
          case 60:
          case 70:
          case 71:
          case 100:
          case 101:
          case 102:
          case 103:
          case 128:
          case 130:
          case 131:
          case 132:
          case 150:
          case 151:
          case 152:
          case 153:
          case 160:
          case 180:
          case 181:
          case 200:
          case 201:
          case 202:
          case 203:
          case 204:
          case 205:
          case 206:
          case 207:
          case 208:
          case 209:
          case 210:
          case 211:
          case 212:
          case 213:
          case 214:
          case 215:
          case 216:
          case 217:
          case 220:
          case 221:
          case 222:
          case 223:
          case 224:
          case 300:
          case 400:
          case 405:
          case 407:
          case 401:
          case 402:
          case 403:
          case 404:
          case 406:
          case 408:
          case 409:
          case 450:
          case 451:
          case 452:
          case 453:
          case 454:
          case 455:
          case 500:
          case 501:
          case 502:
          case 503:
          case 504:
          case 505:
          case 506:
          case 507:
          case 508:
          case 600:
          case 601:
          case 602:
          case 603:
          case 604:
          case 605:
          case 606:
          case 607:
          case 608:
          case 609:
          case 610:
          case 611:
          case 612:
          case 613:
          case 614:
          case 615:
          case 616:
          case 617:
          case 618:
          case 619:
          case 620:
          case 621:
          case 700:
          case 701:
          case 702:
          case 703:
          case 704:
          case 800:
          case 900:
          case 901:
          case 902:
          case 903:
          case 904:
          case 905:
          case 1e3:
          case 1001:
          case 1002:
          case 1003:
          case 1004:
          case 1005:
          case 1006:
          case 1007:
          case 1100:
          case 1101:
          case 1102:
          case 1103:
          case 1104:
          case 1105:
          case 1106:
          case 1107:
          case 1200:
          case 1201:
          case 1202:
          case 1203:
          case 1204:
          case 1205:
          case 1206:
          case 1290:
          case 1291:
          case 1300:
          case 1400:
          case 1401:
          case 1402:
          case 1403:
          case 1404:
          case 1405:
          case 1406:
          case 1407:
          case 1600:
          case 1601:
          case 1602:
          case 1603:
          case 1604:
          case 1700:
          case 1701:
          case 1702:
          case 1703:
          case 1704:
          case 1705:
          case 1706:
          case 1800:
          case 1801:
          case 1802:
          case 1900:
          case 2e3:
          case 2001:
          case 2002:
          case 2003:
          case 2004:
          case 2005:
          case 2006:
          case 2007:
          case 2008:
          case 2009:
          case 2100:
          case 2200:
          case 2201:
          case 2202:
          case 2203:
          case 2204:
          case 2205:
          case 2300:
            break;
        }
      if (message.heading != null && message.hasOwnProperty("heading")) {
        if (!$util.isString(message.heading))
          return "heading: string expected";
      }
      if (message.content != null && message.hasOwnProperty("content")) {
        if (!$util.isString(message.content))
          return "content: string expected";
      }
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      if (message.data != null && message.hasOwnProperty("data")) {
        let error = $root.google.protobuf.Struct.verify(message.data);
        if (error)
          return "data." + error;
      }
      if (message.read != null && message.hasOwnProperty("read")) {
        if (typeof message.read !== "boolean")
          return "read: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.env != null && message.hasOwnProperty("env")) {
        if (!$util.isString(message.env))
          return "env: string expected";
      }
      if (message.htmlContent != null && message.hasOwnProperty("htmlContent")) {
        if (!$util.isString(message.htmlContent))
          return "htmlContent: string expected";
      }
      if (message.attachment != null && message.hasOwnProperty("attachment")) {
        let error = $root.notification.Attachment.verify(message.attachment);
        if (error)
          return "attachment." + error;
      }
      if (message.onlyPushNotification != null && message.hasOwnProperty("onlyPushNotification")) {
        if (typeof message.onlyPushNotification !== "boolean")
          return "onlyPushNotification: boolean expected";
      }
      if (message.userIds != null && message.hasOwnProperty("userIds")) {
        if (!Array.isArray(message.userIds))
          return "userIds: array expected";
        for (let i = 0; i < message.userIds.length; ++i)
          if (!$util.isString(message.userIds[i]))
            return "userIds: string[] expected";
      }
      if (message.pushNotificationDisable != null && message.hasOwnProperty("pushNotificationDisable")) {
        if (typeof message.pushNotificationDisable !== "boolean")
          return "pushNotificationDisable: boolean expected";
      }
      if (message.groupId != null && message.hasOwnProperty("groupId")) {
        if (!$util.isString(message.groupId))
          return "groupId: string expected";
      }
      return null;
    };
    Notification.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.Notification)
        return object;
      let message = new $root.notification.Notification();
      if (object.senderId != null)
        message.senderId = object.senderId | 0;
      if (object.userId != null)
        message.userId = String(object.userId);
      switch (object.type) {
        case "UNKNOWN":
        case 0:
          message.type = 0;
          break;
        case "AUTOMATIC_CUT_LOSS":
        case 1:
          message.type = 1;
          break;
        case "BOT_ORDER_SUCCESSFUL_PLACED":
        case 2:
          message.type = 2;
          break;
        case "DEAL_CLOSED":
        case 3:
          message.type = 3;
          break;
        case "MAINTENANCE_RATE_REACHED":
        case 4:
          message.type = 4;
          break;
        case "HOLD_OVERNIGHT_ALERT":
        case 5:
          message.type = 5;
          break;
        case "SECURE_OVERNIGHT_CUT_LOSS":
        case 6:
          message.type = 6;
          break;
        case "ORDER_SUCCESSFUL_PLACED":
        case 7:
          message.type = 7;
          break;
        case "CONDITIONAL_ORDER_TRIGGERED":
        case 8:
          message.type = 8;
          break;
        case "CONDITIONAL_ORDER_CANT_TRIGGERED_PP":
        case 9:
          message.type = 9;
          break;
        case "CONDITIONAL_ORDER_EXPIRED":
        case 10:
          message.type = 10;
          break;
        case "ORDER_REJECTED":
        case 11:
          message.type = 11;
          break;
        case "AUTOMATIC_TAKE_PROFIT":
        case 12:
          message.type = 12;
          break;
        case "DNSE_ORDER_PENDING_NEW":
        case 13:
          message.type = 13;
          break;
        case "DNSE_ORDER_NEW":
        case 14:
          message.type = 14;
          break;
        case "DNSE_ORDER_PENDING_CANCEL":
        case 15:
          message.type = 15;
          break;
        case "DNSE_ORDER_CANCELED":
        case 16:
          message.type = 16;
          break;
        case "DNSE_ORDER_PARTIALLY_FILLED":
        case 17:
          message.type = 17;
          break;
        case "DNSE_ORDER_FILLED":
        case 18:
          message.type = 18;
          break;
        case "DEPOSIT_FUND":
        case 19:
          message.type = 19;
          break;
        case "WITHDRAWAL_FUND":
        case 20:
          message.type = 20;
          break;
        case "INVESTOR_REFERAL":
        case 21:
          message.type = 21;
          break;
        case "MARGIN_ACCOUNT_OFFER":
        case 22:
          message.type = 22;
          break;
        case "APPROVE_REGISTER":
        case 23:
          message.type = 23;
          break;
        case "REJECT_REGISTER":
        case 24:
          message.type = 24;
          break;
        case "INVESTOR_REMINDER":
        case 25:
          message.type = 25;
          break;
        case "ENBOX_ANNOUNCEMENT":
        case 26:
          message.type = 26;
          break;
        case "INVESTOR_REFERRAL_NEW_USER":
        case 27:
          message.type = 27;
          break;
        case "WITHDRAWAL_PPSE_FUND":
        case 28:
          message.type = 28;
          break;
        case "AI_BROKER_ANNOUNCEMENT":
        case 29:
          message.type = 29;
          break;
        case "SAVINGS_PROMOTION":
        case 30:
          message.type = 30;
          break;
        case "SAVINGS_DEPOSIT":
        case 31:
          message.type = 31;
          break;
        case "SAVINGS_DAILY_YIELD":
        case 32:
          message.type = 32;
          break;
        case "SAVINGS_MONTHLY_YIELD":
        case 33:
          message.type = 33;
          break;
        case "SAVINGS_TO_BE_MATURED":
        case 34:
          message.type = 34;
          break;
        case "SAVINGS_MATURED":
        case 35:
          message.type = 35;
          break;
        case "SAVINGS_WITHDRAWAL":
        case 36:
          message.type = 36;
          break;
        case "SAVINGS_ROLLOVER":
        case 37:
          message.type = 37;
          break;
        case "SAVINGS_CREATED":
        case 38:
          message.type = 38;
          break;
        case "SAVINGS_SETTLED":
        case 39:
          message.type = 39;
          break;
        case "DEAL_PPSE_WITHDRAW":
        case 40:
          message.type = 40;
          break;
        case "DEAL_PREPAYMENT":
        case 41:
          message.type = 41;
          break;
        case "DEAL_RISK_CALL_EVENT":
        case 42:
          message.type = 42;
          break;
        case "PRODUCT_SUGGESTION":
        case 43:
          message.type = 43;
          break;
        case "DNSE_INVESTOR_ACTIVATED":
        case 44:
          message.type = 44;
          break;
        case "DEAL_RISK_LIQUID_EVENT":
        case 45:
          message.type = 45;
          break;
        case "DEAL_RISK_LIQUID_DELAY_EVENT":
        case 46:
          message.type = 46;
          break;
        case "FIRST_ORDER_REWARD":
        case 48:
          message.type = 48;
          break;
        case "HANDOFF_SMART_OTP":
        case 49:
          message.type = 49;
          break;
        case "LOAN_WARNING_DUE_DATE":
        case 50:
          message.type = 50;
          break;
        case "LOAN_OVER_DUE_DATE":
        case 51:
          message.type = 51;
          break;
        case "LOAN_CALL_FORCE_SELL":
        case 56:
          message.type = 56;
          break;
        case "DEAL_CORPORATE_ACTION":
        case 55:
          message.type = 55;
          break;
        case "DEAL_MIGRATE":
        case 52:
          message.type = 52;
          break;
        case "AVAILABLE_CASH_CHANGE":
        case 53:
          message.type = 53;
          break;
        case "ACCOUNT_CORPORATE_ACTION":
        case 54:
          message.type = 54;
          break;
        case "COVERED_WARRANT_SETTLEMENT":
        case 60:
          message.type = 60;
          break;
        case "AUTO_CALL_PAYMENT":
        case 70:
          message.type = 70;
          break;
        case "INVESTMENT_OPPORTUNITIES_ANNOUNCEMENT":
        case 71:
          message.type = 71;
          break;
        case "DNSE_CONDITIONAL_ORDER_ACTIVATED":
        case 100:
          message.type = 100;
          break;
        case "DNSE_CONDITIONAL_ORDER_REJECTED":
        case 101:
          message.type = 101;
          break;
        case "DNSE_CONDITIONAL_ORDER_EXPIRED":
        case 102:
          message.type = 102;
          break;
        case "DNSE_CONDITIONAL_ORDER_CANCELLED_BY_RIGHTS_EVENT":
        case 103:
          message.type = 103;
          break;
        case "DNSE_BREAKING_NEWS":
        case 128:
          message.type = 128;
          break;
        case "DNSE_ORDER_PNL_TAKE_PROFIT":
        case 130:
          message.type = 130;
          break;
        case "DNSE_ORDER_PNL_STOP_LOSS":
        case 131:
          message.type = 131;
          break;
        case "DNSE_ORDER_PNL_BREAK_EVEN":
        case 132:
          message.type = 132;
          break;
        case "GIFT_CREATED":
        case 150:
          message.type = 150;
          break;
        case "GIFT_REDEEMED":
        case 151:
          message.type = 151;
          break;
        case "GIFT_REJECTED":
        case 152:
          message.type = 152;
          break;
        case "GIFT_EXPIRED":
        case 153:
          message.type = 153;
          break;
        case "ENTRADE_DNSE_LINK":
        case 160:
          message.type = 160;
          break;
        case "DNSE_PROMO_STOCK_REWARD":
        case 180:
          message.type = 180;
          break;
        case "RECOMMENDER_TRADE_SIGNAL":
        case 181:
          message.type = 181;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_SUCCESS":
        case 200:
          message.type = 200;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_WITHDRAW_SUCCESS":
        case 201:
          message.type = 201;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_CALL":
        case 202:
          message.type = 202;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_LIQUID":
        case 203:
          message.type = 203;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_FAILED":
        case 204:
          message.type = 204;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_WITHDRAW_FAILED":
        case 205:
          message.type = 205;
          break;
        case "DNSE_DERIVATIVE_DEAL_SECURE_DEPOSIT":
        case 206:
          message.type = 206;
          break;
        case "DNSE_DERIVATIVE_PAYMENT_OBLIGATION_EOD":
        case 207:
          message.type = 207;
          break;
        case "DNSE_DERIVATIVE_RECEIVE_PROFIT":
        case 208:
          message.type = 208;
          break;
        case "DNSE_DERIVATIVE_MATURITY":
        case 209:
          message.type = 209;
          break;
        case "DNSE_DERIVATIVE_CLOSE_DEAL_TAKE_PROFIT":
        case 210:
          message.type = 210;
          break;
        case "DNSE_DERIVATIVE_CLOSE_DEAL_CUT_LOSS":
        case 211:
          message.type = 211;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_STOP_LOSS":
        case 212:
          message.type = 212;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_TAKE_PROFIT":
        case 213:
          message.type = 213;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_STOP_LOSS_FAILED":
        case 214:
          message.type = 214;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_TAKE_PROFIT_FAILED":
        case 215:
          message.type = 215;
          break;
        case "DNSE_DERIVATIVE_DEAL_SECURE_WITHDRAW":
        case 216:
          message.type = 216;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_PENDING_TO_VSD":
        case 217:
          message.type = 217;
          break;
        case "DNSE_DERIVATIVE_PREPAY_LOAN_SUCCESS":
        case 220:
          message.type = 220;
          break;
        case "DNSE_DERIVATIVE_PREPAY_LOAN_FAILED":
        case 221:
          message.type = 221;
          break;
        case "DNSE_DERIVATIVE_END_OF_MONTH_INTEREST_PAYMENT":
        case 222:
          message.type = 222;
          break;
        case "DNSE_DERIVATIVE_DEPOSIT_SECURE_FROM_BANK_FAILED":
        case 223:
          message.type = 223;
          break;
        case "DNSE_LINKED_ACCOUNT_DEPOSIT_PENDING_WARNING":
        case 224:
          message.type = 224;
          break;
        case "ADVANCE_WITHDRAWAL":
        case 300:
          message.type = 300;
          break;
        case "DNSE_BROKER_SACO_CAREBY_REQUEST":
        case 400:
          message.type = 400;
          break;
        case "DNSE_BROKER_OPERATION_REQUEST":
        case 405:
          message.type = 405;
          break;
        case "DNSE_BROKER_FINANCING_OFFER_LOAN_PACKAGE_REQUEST":
        case 407:
          message.type = 407;
          break;
        case "DNSE_PROMOTION":
        case 401:
          message.type = 401;
          break;
        case "DNSE_DIVIDEND_STOCK_RECEIVED":
        case 402:
          message.type = 402;
          break;
        case "DNSE_DIVIDEND_CASH_RECEIVED":
        case 403:
          message.type = 403;
          break;
        case "DNSE_RIGHTS_OFFERING":
        case 404:
          message.type = 404;
          break;
        case "DNSE_STOCK_BONUS_SHARES":
        case 406:
          message.type = 406;
          break;
        case "DNSE_ATTEND_SHAREHOLDERS_MEETING":
        case 408:
          message.type = 408;
          break;
        case "DNSE_GATHER_SHAREHOLDER_OPINIONS":
        case 409:
          message.type = 409;
          break;
        case "CHATBOT_QUESTION":
        case 450:
          message.type = 450;
          break;
        case "CHATBOT_QUESTION_TIMEOUT":
        case 451:
          message.type = 451;
          break;
        case "CHATBOT_QUESTION_CANCEL":
        case 452:
          message.type = 452;
          break;
        case "CHATBOT_ANSWER_SUCCESSFULLY":
        case 453:
          message.type = 453;
          break;
        case "CHATBOT_ENSA_MESSAGE":
        case 454:
          message.type = 454;
          break;
        case "CHATBOT_SUGGESTED_QUESTION":
        case 455:
          message.type = 455;
          break;
        case "FINANCING_OFFER_CREATED":
        case 500:
          message.type = 500;
          break;
        case "FINANCING_OFFER_REQUEST_DECLINED":
        case 501:
          message.type = 501;
          break;
        case "FINANCING_OFFER_OFFLINE_CONFIRMATION":
        case 502:
          message.type = 502;
          break;
        case "FINANCING_OFFER_ONLINE_CONFIRMATION":
        case 503:
          message.type = 503;
          break;
        case "FINANCING_OFFER_LOAN_PACKAGE_READY":
        case 504:
          message.type = 504;
          break;
        case "FINANCING_OFFER_DERIVATIVE_REQUEST_DECLINED":
        case 505:
          message.type = 505;
          break;
        case "FINANCING_OFFER_DERIVATIVE_OFFLINE_CONFIRMATION":
        case 506:
          message.type = 506;
          break;
        case "FINANCING_OFFER_DERIVATIVE_LOAN_PACKAGE_READY":
        case 507:
          message.type = 507;
          break;
        case "FINANCING_OFFER_SUGGESTED_OFFER_CREATED":
        case 508:
          message.type = 508;
          break;
        case "IPO_NOTIFY_SUBMITTED_REGISTRATION_FORM_PARTIALLY_DEPOSITED":
        case 600:
          message.type = 600;
          break;
        case "IPO_NOTIFY_SUBMITTED_REGISTRATION_FORM_DEPOSITED":
        case 601:
          message.type = 601;
          break;
        case "IPO_NOTIFY_NEW_REGISTRATION_FORM_PARTIALLY_DEPOSITED":
        case 602:
          message.type = 602;
          break;
        case "IPO_NOTIFY_NEW_REGISTRATION_FORM_DEPOSITED":
        case 603:
          message.type = 603;
          break;
        case "IPO_NOTIFY_REGISTRATION_FORM_SUBMISSION":
        case 604:
          message.type = 604;
          break;
        case "IPO_NOTIFY_REGISTRATION_FORM_MODIFICATION":
        case 605:
          message.type = 605;
          break;
        case "IPO_NOTIFY_PAYMENT_FAILED":
        case 606:
          message.type = 606;
          break;
        case "IPO_NOTIFY_NOT_ENOUGH_MONEY":
        case 607:
          message.type = 607;
          break;
        case "IPO_NOTIFY_REJECTED_REGISTRATION_FORM":
        case 608:
          message.type = 608;
          break;
        case "IPO_NOTIFY_VALID_REGISTRATION_FORM":
        case 609:
          message.type = 609;
          break;
        case "IPO_NOTIFY_SUCCESSFUL_PAID_AUCTION":
        case 610:
          message.type = 610;
          break;
        case "IPO_NOTIFY_SUCCESSFUL_UNPAID_AUCTION":
        case 611:
          message.type = 611;
          break;
        case "IPO_NOTIFY_AUCTION_FAILED":
        case 612:
          message.type = 612;
          break;
        case "IPO_NOTIFY_REJECTED_AUCTION":
        case 613:
          message.type = 613;
          break;
        case "IPO_NOTIFY_INCOMPLETE_FORM":
        case 614:
          message.type = 614;
          break;
        case "IPO_NOTIFY_FINAL_DAY_INCOMPLETE_FORM":
        case 615:
          message.type = 615;
          break;
        case "IPO_NOTIFY_DEPOSIT_PAYMENT":
        case 616:
          message.type = 616;
          break;
        case "IPO_NOTIFY_FINAL_DAY_DEPOSIT_PAYMENT":
        case 617:
          message.type = 617;
          break;
        case "IPO_NOTIFY_PAYMENT_REMINDER":
        case 618:
          message.type = 618;
          break;
        case "IPO_NOTIFY_DECLINED_AUCTION":
        case 619:
          message.type = 619;
          break;
        case "IPO_NOTIFY_BECAME_SHAREHOLDER":
        case 620:
          message.type = 620;
          break;
        case "IPO_NOTIFY_REFUNDED_PAYMENT":
        case 621:
          message.type = 621;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_CREATED":
        case 700:
          message.type = 700;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_CLOSED":
        case 701:
          message.type = 701;
          break;
        case "MOBILIZED_CAPITAL_MATURITY_ALERT":
        case 702:
          message.type = 702;
          break;
        case "MOBILIZED_CAPITAL_LOAN_INVESTOR_ACTIVATED":
        case 703:
          message.type = 703;
          break;
        case "MOBILIZED_CAPITAL_GOLDEN_EGG_CREATED":
        case 704:
          message.type = 704;
          break;
        case "GAMIFICATION_PERSONAL_LEADERBOARD_RESULT":
        case 800:
          message.type = 800;
          break;
        case "LOYALTY_LEVEL_MAINTAIN":
        case 900:
          message.type = 900;
          break;
        case "LOYALTY_LEVEL_CHANGE":
        case 901:
          message.type = 901;
          break;
        case "LOYALTY_LEVEL_UP":
        case 902:
          message.type = 902;
          break;
        case "LOYALTY_ADD_POINT":
        case 903:
          message.type = 903;
          break;
        case "LOYALTY_USED_POINT":
        case 904:
          message.type = 904;
          break;
        case "LOYALTY_ABOUT_EXPIRE":
        case 905:
          message.type = 905;
          break;
        case "CO_INVESTMENT_SEND_AGREEMENT":
        case 1e3:
          message.type = 1e3;
          break;
        case "CO_INVESTMENT_ACCEPT_AGREEMENT":
        case 1001:
          message.type = 1001;
          break;
        case "CO_INVESTMENT_REMIND_DEPOSIT":
        case 1002:
          message.type = 1002;
          break;
        case "CO_INVESTMENT_GROUP_DEPOSIT":
        case 1003:
          message.type = 1003;
          break;
        case "CO_INVESTMENT_GROUP_REFUND":
        case 1004:
          message.type = 1004;
          break;
        case "CO_INVESTMENT_MEMBER_TRANSFER":
        case 1005:
          message.type = 1005;
          break;
        case "CO_INVESTMENT_MEMBER_RECEIVE_REFUND":
        case 1006:
          message.type = 1006;
          break;
        case "CO_INVESTMENT_CLOSE_AGREEMENT":
        case 1007:
          message.type = 1007;
          break;
        case "USER_CHANGE_REQUEST_ADDRESS_SUCCESSED":
        case 1100:
          message.type = 1100;
          break;
        case "USER_CHANGE_REQUEST_ADDRESS_FAILED":
        case 1101:
          message.type = 1101;
          break;
        case "USER_CHANGE_REQUEST_KYC_SUCCESSED":
        case 1102:
          message.type = 1102;
          break;
        case "USER_CHANGE_REQUEST_KYC_FAILED":
        case 1103:
          message.type = 1103;
          break;
        case "USER_CHANGE_REQUEST_CANCEL_FAILED":
        case 1104:
          message.type = 1104;
          break;
        case "WARNING_UPDATE_INFORMATION_IDENTIFICATION_EXPIRED":
        case 1105:
          message.type = 1105;
          break;
        case "WARNING_UPDATE_INFORMATION_IDENTIFICATION_UNSUPPORTED":
        case 1106:
          message.type = 1106;
          break;
        case "WARNING_UPDATE_INFORMATION_MPS_NOT_MATCH":
        case 1107:
          message.type = 1107;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_CREATED":
        case 1200:
          message.type = 1200;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_CLOSED":
        case 1201:
          message.type = 1201;
          break;
        case "ENTRADE_LOANX_MATURITY_ALERT":
        case 1202:
          message.type = 1202;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACTIVATED":
        case 1203:
          message.type = 1203;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_SETTLEMENT":
        case 1204:
          message.type = 1204;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_DEPOSIT":
        case 1205:
          message.type = 1205;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_WITHDRAWAL":
        case 1206:
          message.type = 1206;
          break;
        case "ACCOUNT_BECOME_INSIDER":
        case 1290:
          message.type = 1290;
          break;
        case "ACCOUNT_REMOVE_FROM_INSIDER":
        case 1291:
          message.type = 1291;
          break;
        case "MGM_GET_REWARD":
        case 1300:
          message.type = 1300;
          break;
        case "GOLDEN_EGG_CREATED":
        case 1400:
          message.type = 1400;
          break;
        case "GOLDEN_EGG_CREATED_FAIL":
        case 1401:
          message.type = 1401;
          break;
        case "GOLDEN_EGG_RECEIVED_INTEREST":
        case 1402:
          message.type = 1402;
          break;
        case "GOLDEN_EGG_DUE_DATE":
        case 1403:
          message.type = 1403;
          break;
        case "GOLDEN_EGG_OVER_DUE_DATE":
        case 1404:
          message.type = 1404;
          break;
        case "GOLDEN_EGG_SELLING_CONFIRMATION":
        case 1405:
          message.type = 1405;
          break;
        case "GOLDEN_EGG_CREATED_PRE_MARKET":
        case 1406:
          message.type = 1406;
          break;
        case "GOLDEN_EGG_SUCCEED_SELL_CONFIRMATION":
        case 1407:
          message.type = 1407;
          break;
        case "WI_ADD_REWARD":
        case 1600:
          message.type = 1600;
          break;
        case "STOCK_REWARD_24H_WAIT_TO_TRANSFER":
        case 1601:
          message.type = 1601;
          break;
        case "STOCK_REWARD_24H_EXPIRING_SOON":
        case 1602:
          message.type = 1602;
          break;
        case "STOCK_REWARD_24H_SUCCESS":
        case 1603:
          message.type = 1603;
          break;
        case "STOCK_REWARD_24H_EXPIRED":
        case 1604:
          message.type = 1604;
          break;
        case "DNSE_SOE_DEAL_NEW":
        case 1700:
          message.type = 1700;
          break;
        case "DNSE_SOE_DEAL_EXPRIED":
        case 1701:
          message.type = 1701;
          break;
        case "DNSE_SOE_DEAL_CANCELED":
        case 1702:
          message.type = 1702;
          break;
        case "DNSE_SOE_DEAL_PARTIALLY_FILLED":
        case 1703:
          message.type = 1703;
          break;
        case "DNSE_SOE_DEAL_FILLED":
        case 1704:
          message.type = 1704;
          break;
        case "DNSE_SOE_DEAL_WAITING_EXPIRE":
        case 1705:
          message.type = 1705;
          break;
        case "DNSE_SOE_DEAL_WAITING_CANCEL":
        case 1706:
          message.type = 1706;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_CREATED":
        case 1800:
          message.type = 1800;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_FAILED":
        case 1801:
          message.type = 1801;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_WITHDRAWAL":
        case 1802:
          message.type = 1802;
          break;
        case "DNSE_LINK_TRANSACTION":
        case 1900:
          message.type = 1900;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_CREATED":
        case 2e3:
          message.type = 2e3;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_CANCELLED":
        case 2001:
          message.type = 2001;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_REFUSED":
        case 2002:
          message.type = 2002;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_ACTIVATED":
        case 2003:
          message.type = 2003;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_CREATED":
        case 2004:
          message.type = 2004;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_CANCELLED":
        case 2005:
          message.type = 2005;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_REFUSED":
        case 2006:
          message.type = 2006;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_EVF":
        case 2007:
          message.type = 2007;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE":
        case 2008:
          message.type = 2008;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE_FAILED":
        case 2009:
          message.type = 2009;
          break;
        case "LOOK_BACK_NOTIFICATION":
        case 2100:
          message.type = 2100;
          break;
        case "SUBSCRIPTION_ACTION":
        case 2200:
          message.type = 2200;
          break;
        case "SUBSCRIPTION_ACTION_PREV_RENEW":
        case 2201:
          message.type = 2201;
          break;
        case "SUBSCRIPTION_ACTION_RENEW_SUCCESS":
        case 2202:
          message.type = 2202;
          break;
        case "SUBSCRIPTION_ACTION_RENEW_FAILED":
        case 2203:
          message.type = 2203;
          break;
        case "SUBSCRIPTION_ACTION_SUBSCRIBE_SUCCESS":
        case 2204:
          message.type = 2204;
          break;
        case "SUBSCRIPTION_ACTION_SUBSCRIBE_FAILED":
        case 2205:
          message.type = 2205;
          break;
        case "TRANSACTION_CONFIRMATIONS_OWNER_COSPONSOR_BANK_SHOULD_CONFIRM_TRANSACTION":
        case 2300:
          message.type = 2300;
          break;
      }
      if (object.heading != null)
        message.heading = String(object.heading);
      if (object.content != null)
        message.content = String(object.content);
      if (object.url != null)
        message.url = String(object.url);
      if (object.data != null) {
        if (typeof object.data !== "object")
          throw TypeError(".notification.Notification.data: object expected");
        message.data = $root.google.protobuf.Struct.fromObject(object.data);
      }
      if (object.read != null)
        message.read = Boolean(object.read);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".notification.Notification.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.env != null)
        message.env = String(object.env);
      if (object.htmlContent != null)
        message.htmlContent = String(object.htmlContent);
      if (object.attachment != null) {
        if (typeof object.attachment !== "object")
          throw TypeError(".notification.Notification.attachment: object expected");
        message.attachment = $root.notification.Attachment.fromObject(object.attachment);
      }
      if (object.onlyPushNotification != null)
        message.onlyPushNotification = Boolean(object.onlyPushNotification);
      if (object.userIds) {
        if (!Array.isArray(object.userIds))
          throw TypeError(".notification.Notification.userIds: array expected");
        message.userIds = [];
        for (let i = 0; i < object.userIds.length; ++i)
          message.userIds[i] = String(object.userIds[i]);
      }
      if (object.pushNotificationDisable != null)
        message.pushNotificationDisable = Boolean(object.pushNotificationDisable);
      if (object.groupId != null)
        message.groupId = String(object.groupId);
      return message;
    };
    Notification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.userIds = [];
      if (options.defaults) {
        object.senderId = 0;
        object.userId = "";
        object.type = options.enums === String ? "UNKNOWN" : 0;
        object.heading = "";
        object.content = "";
        object.url = "";
        object.data = null;
        object.read = false;
        object.createdDate = null;
        object.env = "";
        object.htmlContent = "";
        object.attachment = null;
        object.onlyPushNotification = false;
        object.pushNotificationDisable = false;
        object.groupId = "";
      }
      if (message.senderId != null && message.hasOwnProperty("senderId"))
        object.senderId = message.senderId;
      if (message.userId != null && message.hasOwnProperty("userId"))
        object.userId = message.userId;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.notification.NotiType[message.type] : message.type;
      if (message.heading != null && message.hasOwnProperty("heading"))
        object.heading = message.heading;
      if (message.content != null && message.hasOwnProperty("content"))
        object.content = message.content;
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      if (message.data != null && message.hasOwnProperty("data"))
        object.data = $root.google.protobuf.Struct.toObject(message.data, options);
      if (message.read != null && message.hasOwnProperty("read"))
        object.read = message.read;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.env != null && message.hasOwnProperty("env"))
        object.env = message.env;
      if (message.htmlContent != null && message.hasOwnProperty("htmlContent"))
        object.htmlContent = message.htmlContent;
      if (message.attachment != null && message.hasOwnProperty("attachment"))
        object.attachment = $root.notification.Attachment.toObject(message.attachment, options);
      if (message.onlyPushNotification != null && message.hasOwnProperty("onlyPushNotification"))
        object.onlyPushNotification = message.onlyPushNotification;
      if (message.userIds && message.userIds.length) {
        object.userIds = [];
        for (let j = 0; j < message.userIds.length; ++j)
          object.userIds[j] = message.userIds[j];
      }
      if (message.pushNotificationDisable != null && message.hasOwnProperty("pushNotificationDisable"))
        object.pushNotificationDisable = message.pushNotificationDisable;
      if (message.groupId != null && message.hasOwnProperty("groupId"))
        object.groupId = message.groupId;
      return object;
    };
    Notification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Notification;
  }();
  notification2.EntradeNotification = function() {
    function EntradeNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeNotification.prototype.senderId = 0;
    EntradeNotification.prototype.userId = 0;
    EntradeNotification.prototype.type = 0;
    EntradeNotification.prototype.heading = "";
    EntradeNotification.prototype.content = "";
    EntradeNotification.prototype.url = "";
    EntradeNotification.prototype.data = $util.newBuffer([]);
    EntradeNotification.prototype.read = false;
    EntradeNotification.prototype.createdDate = null;
    EntradeNotification.prototype.env = "";
    EntradeNotification.prototype.htmlContent = "";
    EntradeNotification.create = function create(properties) {
      return new EntradeNotification(properties);
    };
    EntradeNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
        writer.uint32(8).int32(message.senderId);
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(16).int32(message.userId);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(24).int32(message.type);
      if (message.heading != null && Object.hasOwnProperty.call(message, "heading"))
        writer.uint32(34).string(message.heading);
      if (message.content != null && Object.hasOwnProperty.call(message, "content"))
        writer.uint32(42).string(message.content);
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(50).string(message.url);
      if (message.data != null && Object.hasOwnProperty.call(message, "data"))
        writer.uint32(58).bytes(message.data);
      if (message.read != null && Object.hasOwnProperty.call(message, "read"))
        writer.uint32(64).bool(message.read);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
      if (message.env != null && Object.hasOwnProperty.call(message, "env"))
        writer.uint32(82).string(message.env);
      if (message.htmlContent != null && Object.hasOwnProperty.call(message, "htmlContent"))
        writer.uint32(90).string(message.htmlContent);
      return writer;
    };
    EntradeNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.EntradeNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.senderId = reader.int32();
            break;
          case 2:
            message.userId = reader.int32();
            break;
          case 3:
            message.type = reader.int32();
            break;
          case 4:
            message.heading = reader.string();
            break;
          case 5:
            message.content = reader.string();
            break;
          case 6:
            message.url = reader.string();
            break;
          case 7:
            message.data = reader.bytes();
            break;
          case 8:
            message.read = reader.bool();
            break;
          case 9:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.env = reader.string();
            break;
          case 11:
            message.htmlContent = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.senderId != null && message.hasOwnProperty("senderId")) {
        if (!$util.isInteger(message.senderId))
          return "senderId: integer expected";
      }
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isInteger(message.userId))
          return "userId: integer expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
          case 22:
          case 23:
          case 24:
          case 25:
          case 26:
          case 27:
          case 28:
          case 29:
          case 30:
          case 31:
          case 32:
          case 33:
          case 34:
          case 35:
          case 36:
          case 37:
          case 38:
          case 39:
          case 40:
          case 41:
          case 42:
          case 43:
          case 44:
          case 45:
          case 46:
          case 48:
          case 49:
          case 50:
          case 51:
          case 56:
          case 55:
          case 52:
          case 53:
          case 54:
          case 60:
          case 70:
          case 71:
          case 100:
          case 101:
          case 102:
          case 103:
          case 128:
          case 130:
          case 131:
          case 132:
          case 150:
          case 151:
          case 152:
          case 153:
          case 160:
          case 180:
          case 181:
          case 200:
          case 201:
          case 202:
          case 203:
          case 204:
          case 205:
          case 206:
          case 207:
          case 208:
          case 209:
          case 210:
          case 211:
          case 212:
          case 213:
          case 214:
          case 215:
          case 216:
          case 217:
          case 220:
          case 221:
          case 222:
          case 223:
          case 224:
          case 300:
          case 400:
          case 405:
          case 407:
          case 401:
          case 402:
          case 403:
          case 404:
          case 406:
          case 408:
          case 409:
          case 450:
          case 451:
          case 452:
          case 453:
          case 454:
          case 455:
          case 500:
          case 501:
          case 502:
          case 503:
          case 504:
          case 505:
          case 506:
          case 507:
          case 508:
          case 600:
          case 601:
          case 602:
          case 603:
          case 604:
          case 605:
          case 606:
          case 607:
          case 608:
          case 609:
          case 610:
          case 611:
          case 612:
          case 613:
          case 614:
          case 615:
          case 616:
          case 617:
          case 618:
          case 619:
          case 620:
          case 621:
          case 700:
          case 701:
          case 702:
          case 703:
          case 704:
          case 800:
          case 900:
          case 901:
          case 902:
          case 903:
          case 904:
          case 905:
          case 1e3:
          case 1001:
          case 1002:
          case 1003:
          case 1004:
          case 1005:
          case 1006:
          case 1007:
          case 1100:
          case 1101:
          case 1102:
          case 1103:
          case 1104:
          case 1105:
          case 1106:
          case 1107:
          case 1200:
          case 1201:
          case 1202:
          case 1203:
          case 1204:
          case 1205:
          case 1206:
          case 1290:
          case 1291:
          case 1300:
          case 1400:
          case 1401:
          case 1402:
          case 1403:
          case 1404:
          case 1405:
          case 1406:
          case 1407:
          case 1600:
          case 1601:
          case 1602:
          case 1603:
          case 1604:
          case 1700:
          case 1701:
          case 1702:
          case 1703:
          case 1704:
          case 1705:
          case 1706:
          case 1800:
          case 1801:
          case 1802:
          case 1900:
          case 2e3:
          case 2001:
          case 2002:
          case 2003:
          case 2004:
          case 2005:
          case 2006:
          case 2007:
          case 2008:
          case 2009:
          case 2100:
          case 2200:
          case 2201:
          case 2202:
          case 2203:
          case 2204:
          case 2205:
          case 2300:
            break;
        }
      if (message.heading != null && message.hasOwnProperty("heading")) {
        if (!$util.isString(message.heading))
          return "heading: string expected";
      }
      if (message.content != null && message.hasOwnProperty("content")) {
        if (!$util.isString(message.content))
          return "content: string expected";
      }
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      if (message.data != null && message.hasOwnProperty("data")) {
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
          return "data: buffer expected";
      }
      if (message.read != null && message.hasOwnProperty("read")) {
        if (typeof message.read !== "boolean")
          return "read: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.env != null && message.hasOwnProperty("env")) {
        if (!$util.isString(message.env))
          return "env: string expected";
      }
      if (message.htmlContent != null && message.hasOwnProperty("htmlContent")) {
        if (!$util.isString(message.htmlContent))
          return "htmlContent: string expected";
      }
      return null;
    };
    EntradeNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.EntradeNotification)
        return object;
      let message = new $root.notification.EntradeNotification();
      if (object.senderId != null)
        message.senderId = object.senderId | 0;
      if (object.userId != null)
        message.userId = object.userId | 0;
      switch (object.type) {
        case "UNKNOWN":
        case 0:
          message.type = 0;
          break;
        case "AUTOMATIC_CUT_LOSS":
        case 1:
          message.type = 1;
          break;
        case "BOT_ORDER_SUCCESSFUL_PLACED":
        case 2:
          message.type = 2;
          break;
        case "DEAL_CLOSED":
        case 3:
          message.type = 3;
          break;
        case "MAINTENANCE_RATE_REACHED":
        case 4:
          message.type = 4;
          break;
        case "HOLD_OVERNIGHT_ALERT":
        case 5:
          message.type = 5;
          break;
        case "SECURE_OVERNIGHT_CUT_LOSS":
        case 6:
          message.type = 6;
          break;
        case "ORDER_SUCCESSFUL_PLACED":
        case 7:
          message.type = 7;
          break;
        case "CONDITIONAL_ORDER_TRIGGERED":
        case 8:
          message.type = 8;
          break;
        case "CONDITIONAL_ORDER_CANT_TRIGGERED_PP":
        case 9:
          message.type = 9;
          break;
        case "CONDITIONAL_ORDER_EXPIRED":
        case 10:
          message.type = 10;
          break;
        case "ORDER_REJECTED":
        case 11:
          message.type = 11;
          break;
        case "AUTOMATIC_TAKE_PROFIT":
        case 12:
          message.type = 12;
          break;
        case "DNSE_ORDER_PENDING_NEW":
        case 13:
          message.type = 13;
          break;
        case "DNSE_ORDER_NEW":
        case 14:
          message.type = 14;
          break;
        case "DNSE_ORDER_PENDING_CANCEL":
        case 15:
          message.type = 15;
          break;
        case "DNSE_ORDER_CANCELED":
        case 16:
          message.type = 16;
          break;
        case "DNSE_ORDER_PARTIALLY_FILLED":
        case 17:
          message.type = 17;
          break;
        case "DNSE_ORDER_FILLED":
        case 18:
          message.type = 18;
          break;
        case "DEPOSIT_FUND":
        case 19:
          message.type = 19;
          break;
        case "WITHDRAWAL_FUND":
        case 20:
          message.type = 20;
          break;
        case "INVESTOR_REFERAL":
        case 21:
          message.type = 21;
          break;
        case "MARGIN_ACCOUNT_OFFER":
        case 22:
          message.type = 22;
          break;
        case "APPROVE_REGISTER":
        case 23:
          message.type = 23;
          break;
        case "REJECT_REGISTER":
        case 24:
          message.type = 24;
          break;
        case "INVESTOR_REMINDER":
        case 25:
          message.type = 25;
          break;
        case "ENBOX_ANNOUNCEMENT":
        case 26:
          message.type = 26;
          break;
        case "INVESTOR_REFERRAL_NEW_USER":
        case 27:
          message.type = 27;
          break;
        case "WITHDRAWAL_PPSE_FUND":
        case 28:
          message.type = 28;
          break;
        case "AI_BROKER_ANNOUNCEMENT":
        case 29:
          message.type = 29;
          break;
        case "SAVINGS_PROMOTION":
        case 30:
          message.type = 30;
          break;
        case "SAVINGS_DEPOSIT":
        case 31:
          message.type = 31;
          break;
        case "SAVINGS_DAILY_YIELD":
        case 32:
          message.type = 32;
          break;
        case "SAVINGS_MONTHLY_YIELD":
        case 33:
          message.type = 33;
          break;
        case "SAVINGS_TO_BE_MATURED":
        case 34:
          message.type = 34;
          break;
        case "SAVINGS_MATURED":
        case 35:
          message.type = 35;
          break;
        case "SAVINGS_WITHDRAWAL":
        case 36:
          message.type = 36;
          break;
        case "SAVINGS_ROLLOVER":
        case 37:
          message.type = 37;
          break;
        case "SAVINGS_CREATED":
        case 38:
          message.type = 38;
          break;
        case "SAVINGS_SETTLED":
        case 39:
          message.type = 39;
          break;
        case "DEAL_PPSE_WITHDRAW":
        case 40:
          message.type = 40;
          break;
        case "DEAL_PREPAYMENT":
        case 41:
          message.type = 41;
          break;
        case "DEAL_RISK_CALL_EVENT":
        case 42:
          message.type = 42;
          break;
        case "PRODUCT_SUGGESTION":
        case 43:
          message.type = 43;
          break;
        case "DNSE_INVESTOR_ACTIVATED":
        case 44:
          message.type = 44;
          break;
        case "DEAL_RISK_LIQUID_EVENT":
        case 45:
          message.type = 45;
          break;
        case "DEAL_RISK_LIQUID_DELAY_EVENT":
        case 46:
          message.type = 46;
          break;
        case "FIRST_ORDER_REWARD":
        case 48:
          message.type = 48;
          break;
        case "HANDOFF_SMART_OTP":
        case 49:
          message.type = 49;
          break;
        case "LOAN_WARNING_DUE_DATE":
        case 50:
          message.type = 50;
          break;
        case "LOAN_OVER_DUE_DATE":
        case 51:
          message.type = 51;
          break;
        case "LOAN_CALL_FORCE_SELL":
        case 56:
          message.type = 56;
          break;
        case "DEAL_CORPORATE_ACTION":
        case 55:
          message.type = 55;
          break;
        case "DEAL_MIGRATE":
        case 52:
          message.type = 52;
          break;
        case "AVAILABLE_CASH_CHANGE":
        case 53:
          message.type = 53;
          break;
        case "ACCOUNT_CORPORATE_ACTION":
        case 54:
          message.type = 54;
          break;
        case "COVERED_WARRANT_SETTLEMENT":
        case 60:
          message.type = 60;
          break;
        case "AUTO_CALL_PAYMENT":
        case 70:
          message.type = 70;
          break;
        case "INVESTMENT_OPPORTUNITIES_ANNOUNCEMENT":
        case 71:
          message.type = 71;
          break;
        case "DNSE_CONDITIONAL_ORDER_ACTIVATED":
        case 100:
          message.type = 100;
          break;
        case "DNSE_CONDITIONAL_ORDER_REJECTED":
        case 101:
          message.type = 101;
          break;
        case "DNSE_CONDITIONAL_ORDER_EXPIRED":
        case 102:
          message.type = 102;
          break;
        case "DNSE_CONDITIONAL_ORDER_CANCELLED_BY_RIGHTS_EVENT":
        case 103:
          message.type = 103;
          break;
        case "DNSE_BREAKING_NEWS":
        case 128:
          message.type = 128;
          break;
        case "DNSE_ORDER_PNL_TAKE_PROFIT":
        case 130:
          message.type = 130;
          break;
        case "DNSE_ORDER_PNL_STOP_LOSS":
        case 131:
          message.type = 131;
          break;
        case "DNSE_ORDER_PNL_BREAK_EVEN":
        case 132:
          message.type = 132;
          break;
        case "GIFT_CREATED":
        case 150:
          message.type = 150;
          break;
        case "GIFT_REDEEMED":
        case 151:
          message.type = 151;
          break;
        case "GIFT_REJECTED":
        case 152:
          message.type = 152;
          break;
        case "GIFT_EXPIRED":
        case 153:
          message.type = 153;
          break;
        case "ENTRADE_DNSE_LINK":
        case 160:
          message.type = 160;
          break;
        case "DNSE_PROMO_STOCK_REWARD":
        case 180:
          message.type = 180;
          break;
        case "RECOMMENDER_TRADE_SIGNAL":
        case 181:
          message.type = 181;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_SUCCESS":
        case 200:
          message.type = 200;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_WITHDRAW_SUCCESS":
        case 201:
          message.type = 201;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_CALL":
        case 202:
          message.type = 202;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_LIQUID":
        case 203:
          message.type = 203;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_FAILED":
        case 204:
          message.type = 204;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_WITHDRAW_FAILED":
        case 205:
          message.type = 205;
          break;
        case "DNSE_DERIVATIVE_DEAL_SECURE_DEPOSIT":
        case 206:
          message.type = 206;
          break;
        case "DNSE_DERIVATIVE_PAYMENT_OBLIGATION_EOD":
        case 207:
          message.type = 207;
          break;
        case "DNSE_DERIVATIVE_RECEIVE_PROFIT":
        case 208:
          message.type = 208;
          break;
        case "DNSE_DERIVATIVE_MATURITY":
        case 209:
          message.type = 209;
          break;
        case "DNSE_DERIVATIVE_CLOSE_DEAL_TAKE_PROFIT":
        case 210:
          message.type = 210;
          break;
        case "DNSE_DERIVATIVE_CLOSE_DEAL_CUT_LOSS":
        case 211:
          message.type = 211;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_STOP_LOSS":
        case 212:
          message.type = 212;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_TAKE_PROFIT":
        case 213:
          message.type = 213;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_STOP_LOSS_FAILED":
        case 214:
          message.type = 214;
          break;
        case "DNSE_DERIVATIVE_DEAL_RISK_TAKE_PROFIT_FAILED":
        case 215:
          message.type = 215;
          break;
        case "DNSE_DERIVATIVE_DEAL_SECURE_WITHDRAW":
        case 216:
          message.type = 216;
          break;
        case "DNSE_DERIVATIVE_VSD_SECURE_DEPOSIT_PENDING_TO_VSD":
        case 217:
          message.type = 217;
          break;
        case "DNSE_DERIVATIVE_PREPAY_LOAN_SUCCESS":
        case 220:
          message.type = 220;
          break;
        case "DNSE_DERIVATIVE_PREPAY_LOAN_FAILED":
        case 221:
          message.type = 221;
          break;
        case "DNSE_DERIVATIVE_END_OF_MONTH_INTEREST_PAYMENT":
        case 222:
          message.type = 222;
          break;
        case "DNSE_DERIVATIVE_DEPOSIT_SECURE_FROM_BANK_FAILED":
        case 223:
          message.type = 223;
          break;
        case "DNSE_LINKED_ACCOUNT_DEPOSIT_PENDING_WARNING":
        case 224:
          message.type = 224;
          break;
        case "ADVANCE_WITHDRAWAL":
        case 300:
          message.type = 300;
          break;
        case "DNSE_BROKER_SACO_CAREBY_REQUEST":
        case 400:
          message.type = 400;
          break;
        case "DNSE_BROKER_OPERATION_REQUEST":
        case 405:
          message.type = 405;
          break;
        case "DNSE_BROKER_FINANCING_OFFER_LOAN_PACKAGE_REQUEST":
        case 407:
          message.type = 407;
          break;
        case "DNSE_PROMOTION":
        case 401:
          message.type = 401;
          break;
        case "DNSE_DIVIDEND_STOCK_RECEIVED":
        case 402:
          message.type = 402;
          break;
        case "DNSE_DIVIDEND_CASH_RECEIVED":
        case 403:
          message.type = 403;
          break;
        case "DNSE_RIGHTS_OFFERING":
        case 404:
          message.type = 404;
          break;
        case "DNSE_STOCK_BONUS_SHARES":
        case 406:
          message.type = 406;
          break;
        case "DNSE_ATTEND_SHAREHOLDERS_MEETING":
        case 408:
          message.type = 408;
          break;
        case "DNSE_GATHER_SHAREHOLDER_OPINIONS":
        case 409:
          message.type = 409;
          break;
        case "CHATBOT_QUESTION":
        case 450:
          message.type = 450;
          break;
        case "CHATBOT_QUESTION_TIMEOUT":
        case 451:
          message.type = 451;
          break;
        case "CHATBOT_QUESTION_CANCEL":
        case 452:
          message.type = 452;
          break;
        case "CHATBOT_ANSWER_SUCCESSFULLY":
        case 453:
          message.type = 453;
          break;
        case "CHATBOT_ENSA_MESSAGE":
        case 454:
          message.type = 454;
          break;
        case "CHATBOT_SUGGESTED_QUESTION":
        case 455:
          message.type = 455;
          break;
        case "FINANCING_OFFER_CREATED":
        case 500:
          message.type = 500;
          break;
        case "FINANCING_OFFER_REQUEST_DECLINED":
        case 501:
          message.type = 501;
          break;
        case "FINANCING_OFFER_OFFLINE_CONFIRMATION":
        case 502:
          message.type = 502;
          break;
        case "FINANCING_OFFER_ONLINE_CONFIRMATION":
        case 503:
          message.type = 503;
          break;
        case "FINANCING_OFFER_LOAN_PACKAGE_READY":
        case 504:
          message.type = 504;
          break;
        case "FINANCING_OFFER_DERIVATIVE_REQUEST_DECLINED":
        case 505:
          message.type = 505;
          break;
        case "FINANCING_OFFER_DERIVATIVE_OFFLINE_CONFIRMATION":
        case 506:
          message.type = 506;
          break;
        case "FINANCING_OFFER_DERIVATIVE_LOAN_PACKAGE_READY":
        case 507:
          message.type = 507;
          break;
        case "FINANCING_OFFER_SUGGESTED_OFFER_CREATED":
        case 508:
          message.type = 508;
          break;
        case "IPO_NOTIFY_SUBMITTED_REGISTRATION_FORM_PARTIALLY_DEPOSITED":
        case 600:
          message.type = 600;
          break;
        case "IPO_NOTIFY_SUBMITTED_REGISTRATION_FORM_DEPOSITED":
        case 601:
          message.type = 601;
          break;
        case "IPO_NOTIFY_NEW_REGISTRATION_FORM_PARTIALLY_DEPOSITED":
        case 602:
          message.type = 602;
          break;
        case "IPO_NOTIFY_NEW_REGISTRATION_FORM_DEPOSITED":
        case 603:
          message.type = 603;
          break;
        case "IPO_NOTIFY_REGISTRATION_FORM_SUBMISSION":
        case 604:
          message.type = 604;
          break;
        case "IPO_NOTIFY_REGISTRATION_FORM_MODIFICATION":
        case 605:
          message.type = 605;
          break;
        case "IPO_NOTIFY_PAYMENT_FAILED":
        case 606:
          message.type = 606;
          break;
        case "IPO_NOTIFY_NOT_ENOUGH_MONEY":
        case 607:
          message.type = 607;
          break;
        case "IPO_NOTIFY_REJECTED_REGISTRATION_FORM":
        case 608:
          message.type = 608;
          break;
        case "IPO_NOTIFY_VALID_REGISTRATION_FORM":
        case 609:
          message.type = 609;
          break;
        case "IPO_NOTIFY_SUCCESSFUL_PAID_AUCTION":
        case 610:
          message.type = 610;
          break;
        case "IPO_NOTIFY_SUCCESSFUL_UNPAID_AUCTION":
        case 611:
          message.type = 611;
          break;
        case "IPO_NOTIFY_AUCTION_FAILED":
        case 612:
          message.type = 612;
          break;
        case "IPO_NOTIFY_REJECTED_AUCTION":
        case 613:
          message.type = 613;
          break;
        case "IPO_NOTIFY_INCOMPLETE_FORM":
        case 614:
          message.type = 614;
          break;
        case "IPO_NOTIFY_FINAL_DAY_INCOMPLETE_FORM":
        case 615:
          message.type = 615;
          break;
        case "IPO_NOTIFY_DEPOSIT_PAYMENT":
        case 616:
          message.type = 616;
          break;
        case "IPO_NOTIFY_FINAL_DAY_DEPOSIT_PAYMENT":
        case 617:
          message.type = 617;
          break;
        case "IPO_NOTIFY_PAYMENT_REMINDER":
        case 618:
          message.type = 618;
          break;
        case "IPO_NOTIFY_DECLINED_AUCTION":
        case 619:
          message.type = 619;
          break;
        case "IPO_NOTIFY_BECAME_SHAREHOLDER":
        case 620:
          message.type = 620;
          break;
        case "IPO_NOTIFY_REFUNDED_PAYMENT":
        case 621:
          message.type = 621;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_CREATED":
        case 700:
          message.type = 700;
          break;
        case "MOBILIZED_CAPITAL_LOAN_PACKAGE_CLOSED":
        case 701:
          message.type = 701;
          break;
        case "MOBILIZED_CAPITAL_MATURITY_ALERT":
        case 702:
          message.type = 702;
          break;
        case "MOBILIZED_CAPITAL_LOAN_INVESTOR_ACTIVATED":
        case 703:
          message.type = 703;
          break;
        case "MOBILIZED_CAPITAL_GOLDEN_EGG_CREATED":
        case 704:
          message.type = 704;
          break;
        case "GAMIFICATION_PERSONAL_LEADERBOARD_RESULT":
        case 800:
          message.type = 800;
          break;
        case "LOYALTY_LEVEL_MAINTAIN":
        case 900:
          message.type = 900;
          break;
        case "LOYALTY_LEVEL_CHANGE":
        case 901:
          message.type = 901;
          break;
        case "LOYALTY_LEVEL_UP":
        case 902:
          message.type = 902;
          break;
        case "LOYALTY_ADD_POINT":
        case 903:
          message.type = 903;
          break;
        case "LOYALTY_USED_POINT":
        case 904:
          message.type = 904;
          break;
        case "LOYALTY_ABOUT_EXPIRE":
        case 905:
          message.type = 905;
          break;
        case "CO_INVESTMENT_SEND_AGREEMENT":
        case 1e3:
          message.type = 1e3;
          break;
        case "CO_INVESTMENT_ACCEPT_AGREEMENT":
        case 1001:
          message.type = 1001;
          break;
        case "CO_INVESTMENT_REMIND_DEPOSIT":
        case 1002:
          message.type = 1002;
          break;
        case "CO_INVESTMENT_GROUP_DEPOSIT":
        case 1003:
          message.type = 1003;
          break;
        case "CO_INVESTMENT_GROUP_REFUND":
        case 1004:
          message.type = 1004;
          break;
        case "CO_INVESTMENT_MEMBER_TRANSFER":
        case 1005:
          message.type = 1005;
          break;
        case "CO_INVESTMENT_MEMBER_RECEIVE_REFUND":
        case 1006:
          message.type = 1006;
          break;
        case "CO_INVESTMENT_CLOSE_AGREEMENT":
        case 1007:
          message.type = 1007;
          break;
        case "USER_CHANGE_REQUEST_ADDRESS_SUCCESSED":
        case 1100:
          message.type = 1100;
          break;
        case "USER_CHANGE_REQUEST_ADDRESS_FAILED":
        case 1101:
          message.type = 1101;
          break;
        case "USER_CHANGE_REQUEST_KYC_SUCCESSED":
        case 1102:
          message.type = 1102;
          break;
        case "USER_CHANGE_REQUEST_KYC_FAILED":
        case 1103:
          message.type = 1103;
          break;
        case "USER_CHANGE_REQUEST_CANCEL_FAILED":
        case 1104:
          message.type = 1104;
          break;
        case "WARNING_UPDATE_INFORMATION_IDENTIFICATION_EXPIRED":
        case 1105:
          message.type = 1105;
          break;
        case "WARNING_UPDATE_INFORMATION_IDENTIFICATION_UNSUPPORTED":
        case 1106:
          message.type = 1106;
          break;
        case "WARNING_UPDATE_INFORMATION_MPS_NOT_MATCH":
        case 1107:
          message.type = 1107;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_CREATED":
        case 1200:
          message.type = 1200;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_CLOSED":
        case 1201:
          message.type = 1201;
          break;
        case "ENTRADE_LOANX_MATURITY_ALERT":
        case 1202:
          message.type = 1202;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACTIVATED":
        case 1203:
          message.type = 1203;
          break;
        case "ENTRADE_LOANX_LOAN_PACKAGE_SETTLEMENT":
        case 1204:
          message.type = 1204;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_DEPOSIT":
        case 1205:
          message.type = 1205;
          break;
        case "ENTRADE_LOANX_LOAN_INVESTOR_ACCOUNT_WITHDRAWAL":
        case 1206:
          message.type = 1206;
          break;
        case "ACCOUNT_BECOME_INSIDER":
        case 1290:
          message.type = 1290;
          break;
        case "ACCOUNT_REMOVE_FROM_INSIDER":
        case 1291:
          message.type = 1291;
          break;
        case "MGM_GET_REWARD":
        case 1300:
          message.type = 1300;
          break;
        case "GOLDEN_EGG_CREATED":
        case 1400:
          message.type = 1400;
          break;
        case "GOLDEN_EGG_CREATED_FAIL":
        case 1401:
          message.type = 1401;
          break;
        case "GOLDEN_EGG_RECEIVED_INTEREST":
        case 1402:
          message.type = 1402;
          break;
        case "GOLDEN_EGG_DUE_DATE":
        case 1403:
          message.type = 1403;
          break;
        case "GOLDEN_EGG_OVER_DUE_DATE":
        case 1404:
          message.type = 1404;
          break;
        case "GOLDEN_EGG_SELLING_CONFIRMATION":
        case 1405:
          message.type = 1405;
          break;
        case "GOLDEN_EGG_CREATED_PRE_MARKET":
        case 1406:
          message.type = 1406;
          break;
        case "GOLDEN_EGG_SUCCEED_SELL_CONFIRMATION":
        case 1407:
          message.type = 1407;
          break;
        case "WI_ADD_REWARD":
        case 1600:
          message.type = 1600;
          break;
        case "STOCK_REWARD_24H_WAIT_TO_TRANSFER":
        case 1601:
          message.type = 1601;
          break;
        case "STOCK_REWARD_24H_EXPIRING_SOON":
        case 1602:
          message.type = 1602;
          break;
        case "STOCK_REWARD_24H_SUCCESS":
        case 1603:
          message.type = 1603;
          break;
        case "STOCK_REWARD_24H_EXPIRED":
        case 1604:
          message.type = 1604;
          break;
        case "DNSE_SOE_DEAL_NEW":
        case 1700:
          message.type = 1700;
          break;
        case "DNSE_SOE_DEAL_EXPRIED":
        case 1701:
          message.type = 1701;
          break;
        case "DNSE_SOE_DEAL_CANCELED":
        case 1702:
          message.type = 1702;
          break;
        case "DNSE_SOE_DEAL_PARTIALLY_FILLED":
        case 1703:
          message.type = 1703;
          break;
        case "DNSE_SOE_DEAL_FILLED":
        case 1704:
          message.type = 1704;
          break;
        case "DNSE_SOE_DEAL_WAITING_EXPIRE":
        case 1705:
          message.type = 1705;
          break;
        case "DNSE_SOE_DEAL_WAITING_CANCEL":
        case 1706:
          message.type = 1706;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_CREATED":
        case 1800:
          message.type = 1800;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_FAILED":
        case 1801:
          message.type = 1801;
          break;
        case "SAVINGS_ACCOUNT_FINANCING_CASH_WITHDRAWAL":
        case 1802:
          message.type = 1802;
          break;
        case "DNSE_LINK_TRANSACTION":
        case 1900:
          message.type = 1900;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_CREATED":
        case 2e3:
          message.type = 2e3;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_CANCELLED":
        case 2001:
          message.type = 2001;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_REFUSED":
        case 2002:
          message.type = 2002;
          break;
        case "LOAN_NEXUS_EVF_CONTRACT_ACTIVATED":
        case 2003:
          message.type = 2003;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_CREATED":
        case 2004:
          message.type = 2004;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_CANCELLED":
        case 2005:
          message.type = 2005;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_REFUSED":
        case 2006:
          message.type = 2006;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_EVF":
        case 2007:
          message.type = 2007;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE":
        case 2008:
          message.type = 2008;
          break;
        case "LOAN_NEXUS_EVF_ACK_OF_DEBT_ACTIVATED_IN_DNSE_FAILED":
        case 2009:
          message.type = 2009;
          break;
        case "LOOK_BACK_NOTIFICATION":
        case 2100:
          message.type = 2100;
          break;
        case "SUBSCRIPTION_ACTION":
        case 2200:
          message.type = 2200;
          break;
        case "SUBSCRIPTION_ACTION_PREV_RENEW":
        case 2201:
          message.type = 2201;
          break;
        case "SUBSCRIPTION_ACTION_RENEW_SUCCESS":
        case 2202:
          message.type = 2202;
          break;
        case "SUBSCRIPTION_ACTION_RENEW_FAILED":
        case 2203:
          message.type = 2203;
          break;
        case "SUBSCRIPTION_ACTION_SUBSCRIBE_SUCCESS":
        case 2204:
          message.type = 2204;
          break;
        case "SUBSCRIPTION_ACTION_SUBSCRIBE_FAILED":
        case 2205:
          message.type = 2205;
          break;
        case "TRANSACTION_CONFIRMATIONS_OWNER_COSPONSOR_BANK_SHOULD_CONFIRM_TRANSACTION":
        case 2300:
          message.type = 2300;
          break;
      }
      if (object.heading != null)
        message.heading = String(object.heading);
      if (object.content != null)
        message.content = String(object.content);
      if (object.url != null)
        message.url = String(object.url);
      if (object.data != null) {
        if (typeof object.data === "string")
          $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
        else if (object.data.length)
          message.data = object.data;
      }
      if (object.read != null)
        message.read = Boolean(object.read);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".notification.EntradeNotification.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.env != null)
        message.env = String(object.env);
      if (object.htmlContent != null)
        message.htmlContent = String(object.htmlContent);
      return message;
    };
    EntradeNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.senderId = 0;
        object.userId = 0;
        object.type = options.enums === String ? "UNKNOWN" : 0;
        object.heading = "";
        object.content = "";
        object.url = "";
        if (options.bytes === String)
          object.data = "";
        else {
          object.data = [];
          if (options.bytes !== Array)
            object.data = $util.newBuffer(object.data);
        }
        object.read = false;
        object.createdDate = null;
        object.env = "";
        object.htmlContent = "";
      }
      if (message.senderId != null && message.hasOwnProperty("senderId"))
        object.senderId = message.senderId;
      if (message.userId != null && message.hasOwnProperty("userId"))
        object.userId = message.userId;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.notification.NotiType[message.type] : message.type;
      if (message.heading != null && message.hasOwnProperty("heading"))
        object.heading = message.heading;
      if (message.content != null && message.hasOwnProperty("content"))
        object.content = message.content;
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      if (message.data != null && message.hasOwnProperty("data"))
        object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
      if (message.read != null && message.hasOwnProperty("read"))
        object.read = message.read;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.env != null && message.hasOwnProperty("env"))
        object.env = message.env;
      if (message.htmlContent != null && message.hasOwnProperty("htmlContent"))
        object.htmlContent = message.htmlContent;
      return object;
    };
    EntradeNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeNotification;
  }();
  notification2.Attachment = function() {
    function Attachment(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Attachment.prototype.type = "";
    Attachment.prototype.filePayload = null;
    Attachment.prototype.buttonTemplatePayload = null;
    Attachment.prototype.genericTemplatePayload = null;
    Attachment.prototype.mediaTemplatePayload = null;
    let $oneOfFields;
    Object.defineProperty(Attachment.prototype, "payload", {
      get: $util.oneOfGetter($oneOfFields = ["filePayload", "buttonTemplatePayload", "genericTemplatePayload", "mediaTemplatePayload"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Attachment.create = function create(properties) {
      return new Attachment(properties);
    };
    Attachment.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(10).string(message.type);
      if (message.filePayload != null && Object.hasOwnProperty.call(message, "filePayload"))
        $root.notification.FileAttachmentPayload.encode(message.filePayload, writer.uint32(18).fork()).ldelim();
      if (message.buttonTemplatePayload != null && Object.hasOwnProperty.call(message, "buttonTemplatePayload"))
        $root.notification.ButtonTemplatePayload.encode(message.buttonTemplatePayload, writer.uint32(26).fork()).ldelim();
      if (message.genericTemplatePayload != null && Object.hasOwnProperty.call(message, "genericTemplatePayload"))
        $root.notification.GenericTemplatePayload.encode(message.genericTemplatePayload, writer.uint32(34).fork()).ldelim();
      if (message.mediaTemplatePayload != null && Object.hasOwnProperty.call(message, "mediaTemplatePayload"))
        $root.notification.MediaTemplatePayload.encode(message.mediaTemplatePayload, writer.uint32(42).fork()).ldelim();
      return writer;
    };
    Attachment.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Attachment.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.Attachment();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.string();
            break;
          case 2:
            message.filePayload = $root.notification.FileAttachmentPayload.decode(reader, reader.uint32());
            break;
          case 3:
            message.buttonTemplatePayload = $root.notification.ButtonTemplatePayload.decode(reader, reader.uint32());
            break;
          case 4:
            message.genericTemplatePayload = $root.notification.GenericTemplatePayload.decode(reader, reader.uint32());
            break;
          case 5:
            message.mediaTemplatePayload = $root.notification.MediaTemplatePayload.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Attachment.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Attachment.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      let properties = {};
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.filePayload != null && message.hasOwnProperty("filePayload")) {
        properties.payload = 1;
        {
          let error = $root.notification.FileAttachmentPayload.verify(message.filePayload);
          if (error)
            return "filePayload." + error;
        }
      }
      if (message.buttonTemplatePayload != null && message.hasOwnProperty("buttonTemplatePayload")) {
        if (properties.payload === 1)
          return "payload: multiple values";
        properties.payload = 1;
        {
          let error = $root.notification.ButtonTemplatePayload.verify(message.buttonTemplatePayload);
          if (error)
            return "buttonTemplatePayload." + error;
        }
      }
      if (message.genericTemplatePayload != null && message.hasOwnProperty("genericTemplatePayload")) {
        if (properties.payload === 1)
          return "payload: multiple values";
        properties.payload = 1;
        {
          let error = $root.notification.GenericTemplatePayload.verify(message.genericTemplatePayload);
          if (error)
            return "genericTemplatePayload." + error;
        }
      }
      if (message.mediaTemplatePayload != null && message.hasOwnProperty("mediaTemplatePayload")) {
        if (properties.payload === 1)
          return "payload: multiple values";
        properties.payload = 1;
        {
          let error = $root.notification.MediaTemplatePayload.verify(message.mediaTemplatePayload);
          if (error)
            return "mediaTemplatePayload." + error;
        }
      }
      return null;
    };
    Attachment.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.Attachment)
        return object;
      let message = new $root.notification.Attachment();
      if (object.type != null)
        message.type = String(object.type);
      if (object.filePayload != null) {
        if (typeof object.filePayload !== "object")
          throw TypeError(".notification.Attachment.filePayload: object expected");
        message.filePayload = $root.notification.FileAttachmentPayload.fromObject(object.filePayload);
      }
      if (object.buttonTemplatePayload != null) {
        if (typeof object.buttonTemplatePayload !== "object")
          throw TypeError(".notification.Attachment.buttonTemplatePayload: object expected");
        message.buttonTemplatePayload = $root.notification.ButtonTemplatePayload.fromObject(object.buttonTemplatePayload);
      }
      if (object.genericTemplatePayload != null) {
        if (typeof object.genericTemplatePayload !== "object")
          throw TypeError(".notification.Attachment.genericTemplatePayload: object expected");
        message.genericTemplatePayload = $root.notification.GenericTemplatePayload.fromObject(object.genericTemplatePayload);
      }
      if (object.mediaTemplatePayload != null) {
        if (typeof object.mediaTemplatePayload !== "object")
          throw TypeError(".notification.Attachment.mediaTemplatePayload: object expected");
        message.mediaTemplatePayload = $root.notification.MediaTemplatePayload.fromObject(object.mediaTemplatePayload);
      }
      return message;
    };
    Attachment.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.type = "";
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.filePayload != null && message.hasOwnProperty("filePayload")) {
        object.filePayload = $root.notification.FileAttachmentPayload.toObject(message.filePayload, options);
        if (options.oneofs)
          object.payload = "filePayload";
      }
      if (message.buttonTemplatePayload != null && message.hasOwnProperty("buttonTemplatePayload")) {
        object.buttonTemplatePayload = $root.notification.ButtonTemplatePayload.toObject(message.buttonTemplatePayload, options);
        if (options.oneofs)
          object.payload = "buttonTemplatePayload";
      }
      if (message.genericTemplatePayload != null && message.hasOwnProperty("genericTemplatePayload")) {
        object.genericTemplatePayload = $root.notification.GenericTemplatePayload.toObject(message.genericTemplatePayload, options);
        if (options.oneofs)
          object.payload = "genericTemplatePayload";
      }
      if (message.mediaTemplatePayload != null && message.hasOwnProperty("mediaTemplatePayload")) {
        object.mediaTemplatePayload = $root.notification.MediaTemplatePayload.toObject(message.mediaTemplatePayload, options);
        if (options.oneofs)
          object.payload = "mediaTemplatePayload";
      }
      return object;
    };
    Attachment.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Attachment;
  }();
  notification2.FileAttachmentPayload = function() {
    function FileAttachmentPayload(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FileAttachmentPayload.prototype.url = "";
    FileAttachmentPayload.create = function create(properties) {
      return new FileAttachmentPayload(properties);
    };
    FileAttachmentPayload.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(10).string(message.url);
      return writer;
    };
    FileAttachmentPayload.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FileAttachmentPayload.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.FileAttachmentPayload();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.url = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FileAttachmentPayload.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FileAttachmentPayload.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      return null;
    };
    FileAttachmentPayload.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.FileAttachmentPayload)
        return object;
      let message = new $root.notification.FileAttachmentPayload();
      if (object.url != null)
        message.url = String(object.url);
      return message;
    };
    FileAttachmentPayload.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.url = "";
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      return object;
    };
    FileAttachmentPayload.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FileAttachmentPayload;
  }();
  notification2.ButtonTemplatePayload = function() {
    function ButtonTemplatePayload(properties) {
      this.buttons = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ButtonTemplatePayload.prototype.templateType = "";
    ButtonTemplatePayload.prototype.htmlContent = "";
    ButtonTemplatePayload.prototype.buttons = $util.emptyArray;
    ButtonTemplatePayload.create = function create(properties) {
      return new ButtonTemplatePayload(properties);
    };
    ButtonTemplatePayload.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.templateType != null && Object.hasOwnProperty.call(message, "templateType"))
        writer.uint32(10).string(message.templateType);
      if (message.htmlContent != null && Object.hasOwnProperty.call(message, "htmlContent"))
        writer.uint32(18).string(message.htmlContent);
      if (message.buttons != null && message.buttons.length)
        for (let i = 0; i < message.buttons.length; ++i)
          $root.notification.Button.encode(message.buttons[i], writer.uint32(26).fork()).ldelim();
      return writer;
    };
    ButtonTemplatePayload.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ButtonTemplatePayload.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.ButtonTemplatePayload();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.templateType = reader.string();
            break;
          case 2:
            message.htmlContent = reader.string();
            break;
          case 3:
            if (!(message.buttons && message.buttons.length))
              message.buttons = [];
            message.buttons.push($root.notification.Button.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ButtonTemplatePayload.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ButtonTemplatePayload.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.templateType != null && message.hasOwnProperty("templateType")) {
        if (!$util.isString(message.templateType))
          return "templateType: string expected";
      }
      if (message.htmlContent != null && message.hasOwnProperty("htmlContent")) {
        if (!$util.isString(message.htmlContent))
          return "htmlContent: string expected";
      }
      if (message.buttons != null && message.hasOwnProperty("buttons")) {
        if (!Array.isArray(message.buttons))
          return "buttons: array expected";
        for (let i = 0; i < message.buttons.length; ++i) {
          let error = $root.notification.Button.verify(message.buttons[i]);
          if (error)
            return "buttons." + error;
        }
      }
      return null;
    };
    ButtonTemplatePayload.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.ButtonTemplatePayload)
        return object;
      let message = new $root.notification.ButtonTemplatePayload();
      if (object.templateType != null)
        message.templateType = String(object.templateType);
      if (object.htmlContent != null)
        message.htmlContent = String(object.htmlContent);
      if (object.buttons) {
        if (!Array.isArray(object.buttons))
          throw TypeError(".notification.ButtonTemplatePayload.buttons: array expected");
        message.buttons = [];
        for (let i = 0; i < object.buttons.length; ++i) {
          if (typeof object.buttons[i] !== "object")
            throw TypeError(".notification.ButtonTemplatePayload.buttons: object expected");
          message.buttons[i] = $root.notification.Button.fromObject(object.buttons[i]);
        }
      }
      return message;
    };
    ButtonTemplatePayload.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.buttons = [];
      if (options.defaults) {
        object.templateType = "";
        object.htmlContent = "";
      }
      if (message.templateType != null && message.hasOwnProperty("templateType"))
        object.templateType = message.templateType;
      if (message.htmlContent != null && message.hasOwnProperty("htmlContent"))
        object.htmlContent = message.htmlContent;
      if (message.buttons && message.buttons.length) {
        object.buttons = [];
        for (let j = 0; j < message.buttons.length; ++j)
          object.buttons[j] = $root.notification.Button.toObject(message.buttons[j], options);
      }
      return object;
    };
    ButtonTemplatePayload.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ButtonTemplatePayload;
  }();
  notification2.Button = function() {
    function Button(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Button.prototype.urlButton = null;
    Button.prototype.actionButton = null;
    let $oneOfFields;
    Object.defineProperty(Button.prototype, "button", {
      get: $util.oneOfGetter($oneOfFields = ["urlButton", "actionButton"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Button.create = function create(properties) {
      return new Button(properties);
    };
    Button.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.urlButton != null && Object.hasOwnProperty.call(message, "urlButton"))
        $root.notification.UrlButton.encode(message.urlButton, writer.uint32(10).fork()).ldelim();
      if (message.actionButton != null && Object.hasOwnProperty.call(message, "actionButton"))
        $root.notification.ActionButton.encode(message.actionButton, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    Button.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Button.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.Button();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.urlButton = $root.notification.UrlButton.decode(reader, reader.uint32());
            break;
          case 2:
            message.actionButton = $root.notification.ActionButton.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Button.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Button.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      let properties = {};
      if (message.urlButton != null && message.hasOwnProperty("urlButton")) {
        properties.button = 1;
        {
          let error = $root.notification.UrlButton.verify(message.urlButton);
          if (error)
            return "urlButton." + error;
        }
      }
      if (message.actionButton != null && message.hasOwnProperty("actionButton")) {
        if (properties.button === 1)
          return "button: multiple values";
        properties.button = 1;
        {
          let error = $root.notification.ActionButton.verify(message.actionButton);
          if (error)
            return "actionButton." + error;
        }
      }
      return null;
    };
    Button.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.Button)
        return object;
      let message = new $root.notification.Button();
      if (object.urlButton != null) {
        if (typeof object.urlButton !== "object")
          throw TypeError(".notification.Button.urlButton: object expected");
        message.urlButton = $root.notification.UrlButton.fromObject(object.urlButton);
      }
      if (object.actionButton != null) {
        if (typeof object.actionButton !== "object")
          throw TypeError(".notification.Button.actionButton: object expected");
        message.actionButton = $root.notification.ActionButton.fromObject(object.actionButton);
      }
      return message;
    };
    Button.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (message.urlButton != null && message.hasOwnProperty("urlButton")) {
        object.urlButton = $root.notification.UrlButton.toObject(message.urlButton, options);
        if (options.oneofs)
          object.button = "urlButton";
      }
      if (message.actionButton != null && message.hasOwnProperty("actionButton")) {
        object.actionButton = $root.notification.ActionButton.toObject(message.actionButton, options);
        if (options.oneofs)
          object.button = "actionButton";
      }
      return object;
    };
    Button.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Button;
  }();
  notification2.UrlButton = function() {
    function UrlButton(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    UrlButton.prototype.type = "";
    UrlButton.prototype.url = "";
    UrlButton.prototype.title = "";
    UrlButton.create = function create(properties) {
      return new UrlButton(properties);
    };
    UrlButton.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(10).string(message.type);
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(18).string(message.url);
      if (message.title != null && Object.hasOwnProperty.call(message, "title"))
        writer.uint32(26).string(message.title);
      return writer;
    };
    UrlButton.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    UrlButton.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.UrlButton();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.string();
            break;
          case 2:
            message.url = reader.string();
            break;
          case 3:
            message.title = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    UrlButton.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    UrlButton.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      if (message.title != null && message.hasOwnProperty("title")) {
        if (!$util.isString(message.title))
          return "title: string expected";
      }
      return null;
    };
    UrlButton.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.UrlButton)
        return object;
      let message = new $root.notification.UrlButton();
      if (object.type != null)
        message.type = String(object.type);
      if (object.url != null)
        message.url = String(object.url);
      if (object.title != null)
        message.title = String(object.title);
      return message;
    };
    UrlButton.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = "";
        object.url = "";
        object.title = "";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      if (message.title != null && message.hasOwnProperty("title"))
        object.title = message.title;
      return object;
    };
    UrlButton.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return UrlButton;
  }();
  notification2.ActionButton = function() {
    function ActionButton(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ActionButton.prototype.type = "";
    ActionButton.prototype.title = "";
    ActionButton.prototype.actionType = "";
    ActionButton.prototype.params = "";
    ActionButton.create = function create(properties) {
      return new ActionButton(properties);
    };
    ActionButton.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(10).string(message.type);
      if (message.title != null && Object.hasOwnProperty.call(message, "title"))
        writer.uint32(18).string(message.title);
      if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
        writer.uint32(26).string(message.actionType);
      if (message.params != null && Object.hasOwnProperty.call(message, "params"))
        writer.uint32(34).string(message.params);
      return writer;
    };
    ActionButton.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ActionButton.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.ActionButton();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.string();
            break;
          case 2:
            message.title = reader.string();
            break;
          case 3:
            message.actionType = reader.string();
            break;
          case 4:
            message.params = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ActionButton.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ActionButton.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.title != null && message.hasOwnProperty("title")) {
        if (!$util.isString(message.title))
          return "title: string expected";
      }
      if (message.actionType != null && message.hasOwnProperty("actionType")) {
        if (!$util.isString(message.actionType))
          return "actionType: string expected";
      }
      if (message.params != null && message.hasOwnProperty("params")) {
        if (!$util.isString(message.params))
          return "params: string expected";
      }
      return null;
    };
    ActionButton.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.ActionButton)
        return object;
      let message = new $root.notification.ActionButton();
      if (object.type != null)
        message.type = String(object.type);
      if (object.title != null)
        message.title = String(object.title);
      if (object.actionType != null)
        message.actionType = String(object.actionType);
      if (object.params != null)
        message.params = String(object.params);
      return message;
    };
    ActionButton.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = "";
        object.title = "";
        object.actionType = "";
        object.params = "";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.title != null && message.hasOwnProperty("title"))
        object.title = message.title;
      if (message.actionType != null && message.hasOwnProperty("actionType"))
        object.actionType = message.actionType;
      if (message.params != null && message.hasOwnProperty("params"))
        object.params = message.params;
      return object;
    };
    ActionButton.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ActionButton;
  }();
  notification2.GenericTemplatePayload = function() {
    function GenericTemplatePayload(properties) {
      this.elements = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GenericTemplatePayload.prototype.templateType = "";
    GenericTemplatePayload.prototype.elements = $util.emptyArray;
    GenericTemplatePayload.create = function create(properties) {
      return new GenericTemplatePayload(properties);
    };
    GenericTemplatePayload.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.templateType != null && Object.hasOwnProperty.call(message, "templateType"))
        writer.uint32(10).string(message.templateType);
      if (message.elements != null && message.elements.length)
        for (let i = 0; i < message.elements.length; ++i)
          $root.notification.Element.encode(message.elements[i], writer.uint32(18).fork()).ldelim();
      return writer;
    };
    GenericTemplatePayload.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GenericTemplatePayload.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.GenericTemplatePayload();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.templateType = reader.string();
            break;
          case 2:
            if (!(message.elements && message.elements.length))
              message.elements = [];
            message.elements.push($root.notification.Element.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GenericTemplatePayload.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GenericTemplatePayload.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.templateType != null && message.hasOwnProperty("templateType")) {
        if (!$util.isString(message.templateType))
          return "templateType: string expected";
      }
      if (message.elements != null && message.hasOwnProperty("elements")) {
        if (!Array.isArray(message.elements))
          return "elements: array expected";
        for (let i = 0; i < message.elements.length; ++i) {
          let error = $root.notification.Element.verify(message.elements[i]);
          if (error)
            return "elements." + error;
        }
      }
      return null;
    };
    GenericTemplatePayload.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.GenericTemplatePayload)
        return object;
      let message = new $root.notification.GenericTemplatePayload();
      if (object.templateType != null)
        message.templateType = String(object.templateType);
      if (object.elements) {
        if (!Array.isArray(object.elements))
          throw TypeError(".notification.GenericTemplatePayload.elements: array expected");
        message.elements = [];
        for (let i = 0; i < object.elements.length; ++i) {
          if (typeof object.elements[i] !== "object")
            throw TypeError(".notification.GenericTemplatePayload.elements: object expected");
          message.elements[i] = $root.notification.Element.fromObject(object.elements[i]);
        }
      }
      return message;
    };
    GenericTemplatePayload.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.elements = [];
      if (options.defaults)
        object.templateType = "";
      if (message.templateType != null && message.hasOwnProperty("templateType"))
        object.templateType = message.templateType;
      if (message.elements && message.elements.length) {
        object.elements = [];
        for (let j = 0; j < message.elements.length; ++j)
          object.elements[j] = $root.notification.Element.toObject(message.elements[j], options);
      }
      return object;
    };
    GenericTemplatePayload.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GenericTemplatePayload;
  }();
  notification2.Element = function() {
    function Element(properties) {
      this.buttons = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Element.prototype.title = "";
    Element.prototype.subTitle = "";
    Element.prototype.imageUrl = "";
    Element.prototype.defaultAction = null;
    Element.prototype.buttons = $util.emptyArray;
    Element.create = function create(properties) {
      return new Element(properties);
    };
    Element.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.title != null && Object.hasOwnProperty.call(message, "title"))
        writer.uint32(10).string(message.title);
      if (message.subTitle != null && Object.hasOwnProperty.call(message, "subTitle"))
        writer.uint32(18).string(message.subTitle);
      if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
        writer.uint32(26).string(message.imageUrl);
      if (message.defaultAction != null && Object.hasOwnProperty.call(message, "defaultAction"))
        $root.notification.Button.encode(message.defaultAction, writer.uint32(34).fork()).ldelim();
      if (message.buttons != null && message.buttons.length)
        for (let i = 0; i < message.buttons.length; ++i)
          $root.notification.Button.encode(message.buttons[i], writer.uint32(42).fork()).ldelim();
      return writer;
    };
    Element.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Element.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.Element();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.title = reader.string();
            break;
          case 2:
            message.subTitle = reader.string();
            break;
          case 3:
            message.imageUrl = reader.string();
            break;
          case 4:
            message.defaultAction = $root.notification.Button.decode(reader, reader.uint32());
            break;
          case 5:
            if (!(message.buttons && message.buttons.length))
              message.buttons = [];
            message.buttons.push($root.notification.Button.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Element.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Element.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.title != null && message.hasOwnProperty("title")) {
        if (!$util.isString(message.title))
          return "title: string expected";
      }
      if (message.subTitle != null && message.hasOwnProperty("subTitle")) {
        if (!$util.isString(message.subTitle))
          return "subTitle: string expected";
      }
      if (message.imageUrl != null && message.hasOwnProperty("imageUrl")) {
        if (!$util.isString(message.imageUrl))
          return "imageUrl: string expected";
      }
      if (message.defaultAction != null && message.hasOwnProperty("defaultAction")) {
        let error = $root.notification.Button.verify(message.defaultAction);
        if (error)
          return "defaultAction." + error;
      }
      if (message.buttons != null && message.hasOwnProperty("buttons")) {
        if (!Array.isArray(message.buttons))
          return "buttons: array expected";
        for (let i = 0; i < message.buttons.length; ++i) {
          let error = $root.notification.Button.verify(message.buttons[i]);
          if (error)
            return "buttons." + error;
        }
      }
      return null;
    };
    Element.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.Element)
        return object;
      let message = new $root.notification.Element();
      if (object.title != null)
        message.title = String(object.title);
      if (object.subTitle != null)
        message.subTitle = String(object.subTitle);
      if (object.imageUrl != null)
        message.imageUrl = String(object.imageUrl);
      if (object.defaultAction != null) {
        if (typeof object.defaultAction !== "object")
          throw TypeError(".notification.Element.defaultAction: object expected");
        message.defaultAction = $root.notification.Button.fromObject(object.defaultAction);
      }
      if (object.buttons) {
        if (!Array.isArray(object.buttons))
          throw TypeError(".notification.Element.buttons: array expected");
        message.buttons = [];
        for (let i = 0; i < object.buttons.length; ++i) {
          if (typeof object.buttons[i] !== "object")
            throw TypeError(".notification.Element.buttons: object expected");
          message.buttons[i] = $root.notification.Button.fromObject(object.buttons[i]);
        }
      }
      return message;
    };
    Element.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.buttons = [];
      if (options.defaults) {
        object.title = "";
        object.subTitle = "";
        object.imageUrl = "";
        object.defaultAction = null;
      }
      if (message.title != null && message.hasOwnProperty("title"))
        object.title = message.title;
      if (message.subTitle != null && message.hasOwnProperty("subTitle"))
        object.subTitle = message.subTitle;
      if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
        object.imageUrl = message.imageUrl;
      if (message.defaultAction != null && message.hasOwnProperty("defaultAction"))
        object.defaultAction = $root.notification.Button.toObject(message.defaultAction, options);
      if (message.buttons && message.buttons.length) {
        object.buttons = [];
        for (let j = 0; j < message.buttons.length; ++j)
          object.buttons[j] = $root.notification.Button.toObject(message.buttons[j], options);
      }
      return object;
    };
    Element.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Element;
  }();
  notification2.MediaTemplatePayload = function() {
    function MediaTemplatePayload(properties) {
      this.elements = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MediaTemplatePayload.prototype.templateType = "";
    MediaTemplatePayload.prototype.elements = $util.emptyArray;
    MediaTemplatePayload.create = function create(properties) {
      return new MediaTemplatePayload(properties);
    };
    MediaTemplatePayload.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.templateType != null && Object.hasOwnProperty.call(message, "templateType"))
        writer.uint32(10).string(message.templateType);
      if (message.elements != null && message.elements.length)
        for (let i = 0; i < message.elements.length; ++i)
          $root.notification.MediaElement.encode(message.elements[i], writer.uint32(18).fork()).ldelim();
      return writer;
    };
    MediaTemplatePayload.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MediaTemplatePayload.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.MediaTemplatePayload();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.templateType = reader.string();
            break;
          case 2:
            if (!(message.elements && message.elements.length))
              message.elements = [];
            message.elements.push($root.notification.MediaElement.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MediaTemplatePayload.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MediaTemplatePayload.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.templateType != null && message.hasOwnProperty("templateType")) {
        if (!$util.isString(message.templateType))
          return "templateType: string expected";
      }
      if (message.elements != null && message.hasOwnProperty("elements")) {
        if (!Array.isArray(message.elements))
          return "elements: array expected";
        for (let i = 0; i < message.elements.length; ++i) {
          let error = $root.notification.MediaElement.verify(message.elements[i]);
          if (error)
            return "elements." + error;
        }
      }
      return null;
    };
    MediaTemplatePayload.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.MediaTemplatePayload)
        return object;
      let message = new $root.notification.MediaTemplatePayload();
      if (object.templateType != null)
        message.templateType = String(object.templateType);
      if (object.elements) {
        if (!Array.isArray(object.elements))
          throw TypeError(".notification.MediaTemplatePayload.elements: array expected");
        message.elements = [];
        for (let i = 0; i < object.elements.length; ++i) {
          if (typeof object.elements[i] !== "object")
            throw TypeError(".notification.MediaTemplatePayload.elements: object expected");
          message.elements[i] = $root.notification.MediaElement.fromObject(object.elements[i]);
        }
      }
      return message;
    };
    MediaTemplatePayload.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.elements = [];
      if (options.defaults)
        object.templateType = "";
      if (message.templateType != null && message.hasOwnProperty("templateType"))
        object.templateType = message.templateType;
      if (message.elements && message.elements.length) {
        object.elements = [];
        for (let j = 0; j < message.elements.length; ++j)
          object.elements[j] = $root.notification.MediaElement.toObject(message.elements[j], options);
      }
      return object;
    };
    MediaTemplatePayload.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MediaTemplatePayload;
  }();
  notification2.MediaElement = function() {
    function MediaElement(properties) {
      this.buttons = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MediaElement.prototype.mediaType = "";
    MediaElement.prototype.attachmentId = "";
    MediaElement.prototype.url = "";
    MediaElement.prototype.buttons = $util.emptyArray;
    MediaElement.create = function create(properties) {
      return new MediaElement(properties);
    };
    MediaElement.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.mediaType != null && Object.hasOwnProperty.call(message, "mediaType"))
        writer.uint32(10).string(message.mediaType);
      if (message.attachmentId != null && Object.hasOwnProperty.call(message, "attachmentId"))
        writer.uint32(18).string(message.attachmentId);
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(26).string(message.url);
      if (message.buttons != null && message.buttons.length)
        for (let i = 0; i < message.buttons.length; ++i)
          $root.notification.Button.encode(message.buttons[i], writer.uint32(34).fork()).ldelim();
      return writer;
    };
    MediaElement.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MediaElement.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.notification.MediaElement();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.mediaType = reader.string();
            break;
          case 2:
            message.attachmentId = reader.string();
            break;
          case 3:
            message.url = reader.string();
            break;
          case 4:
            if (!(message.buttons && message.buttons.length))
              message.buttons = [];
            message.buttons.push($root.notification.Button.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MediaElement.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MediaElement.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.mediaType != null && message.hasOwnProperty("mediaType")) {
        if (!$util.isString(message.mediaType))
          return "mediaType: string expected";
      }
      if (message.attachmentId != null && message.hasOwnProperty("attachmentId")) {
        if (!$util.isString(message.attachmentId))
          return "attachmentId: string expected";
      }
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      if (message.buttons != null && message.hasOwnProperty("buttons")) {
        if (!Array.isArray(message.buttons))
          return "buttons: array expected";
        for (let i = 0; i < message.buttons.length; ++i) {
          let error = $root.notification.Button.verify(message.buttons[i]);
          if (error)
            return "buttons." + error;
        }
      }
      return null;
    };
    MediaElement.fromObject = function fromObject(object) {
      if (object instanceof $root.notification.MediaElement)
        return object;
      let message = new $root.notification.MediaElement();
      if (object.mediaType != null)
        message.mediaType = String(object.mediaType);
      if (object.attachmentId != null)
        message.attachmentId = String(object.attachmentId);
      if (object.url != null)
        message.url = String(object.url);
      if (object.buttons) {
        if (!Array.isArray(object.buttons))
          throw TypeError(".notification.MediaElement.buttons: array expected");
        message.buttons = [];
        for (let i = 0; i < object.buttons.length; ++i) {
          if (typeof object.buttons[i] !== "object")
            throw TypeError(".notification.MediaElement.buttons: object expected");
          message.buttons[i] = $root.notification.Button.fromObject(object.buttons[i]);
        }
      }
      return message;
    };
    MediaElement.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.buttons = [];
      if (options.defaults) {
        object.mediaType = "";
        object.attachmentId = "";
        object.url = "";
      }
      if (message.mediaType != null && message.hasOwnProperty("mediaType"))
        object.mediaType = message.mediaType;
      if (message.attachmentId != null && message.hasOwnProperty("attachmentId"))
        object.attachmentId = message.attachmentId;
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      if (message.buttons && message.buttons.length) {
        object.buttons = [];
        for (let j = 0; j < message.buttons.length; ++j)
          object.buttons[j] = $root.notification.Button.toObject(message.buttons[j], options);
      }
      return object;
    };
    MediaElement.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MediaElement;
  }();
  return notification2;
})();
$root.google = (() => {
  const google2 = {};
  google2.protobuf = function() {
    const protobuf = {};
    protobuf.Timestamp = function() {
      function Timestamp(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Timestamp.prototype.nanos = 0;
      Timestamp.create = function create(properties) {
        return new Timestamp(properties);
      };
      Timestamp.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
          writer.uint32(8).int64(message.seconds);
        if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
          writer.uint32(16).int32(message.nanos);
        return writer;
      };
      Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Timestamp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seconds = reader.int64();
              break;
            case 2:
              message.nanos = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Timestamp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Timestamp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seconds != null && message.hasOwnProperty("seconds")) {
          if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
            return "seconds: integer|Long expected";
        }
        if (message.nanos != null && message.hasOwnProperty("nanos")) {
          if (!$util.isInteger(message.nanos))
            return "nanos: integer expected";
        }
        return null;
      };
      Timestamp.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Timestamp)
          return object;
        let message = new $root.google.protobuf.Timestamp();
        if (object.seconds != null) {
          if ($util.Long)
            (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
          else if (typeof object.seconds === "string")
            message.seconds = parseInt(object.seconds, 10);
          else if (typeof object.seconds === "number")
            message.seconds = object.seconds;
          else if (typeof object.seconds === "object")
            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
        }
        if (object.nanos != null)
          message.nanos = object.nanos | 0;
        return message;
      };
      Timestamp.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seconds = options.longs === String ? "0" : 0;
          object.nanos = 0;
        }
        if (message.seconds != null && message.hasOwnProperty("seconds"))
          if (typeof message.seconds === "number")
            object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
          else
            object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
        if (message.nanos != null && message.hasOwnProperty("nanos"))
          object.nanos = message.nanos;
        return object;
      };
      Timestamp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Timestamp;
    }();
    protobuf.Struct = function() {
      function Struct(properties) {
        this.fields = {};
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Struct.prototype.fields = $util.emptyObject;
      Struct.create = function create(properties) {
        return new Struct(properties);
      };
      Struct.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.fields != null && Object.hasOwnProperty.call(message, "fields"))
          for (let keys = Object.keys(message.fields), i = 0; i < keys.length; ++i) {
            writer.uint32(10).fork().uint32(10).string(keys[i]);
            $root.google.protobuf.Value.encode(message.fields[keys[i]], writer.uint32(18).fork()).ldelim().ldelim();
          }
        return writer;
      };
      Struct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Struct.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.protobuf.Struct(), key, value;
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (message.fields === $util.emptyObject)
                message.fields = {};
              let end2 = reader.uint32() + reader.pos;
              key = "";
              value = null;
              while (reader.pos < end2) {
                let tag2 = reader.uint32();
                switch (tag2 >>> 3) {
                  case 1:
                    key = reader.string();
                    break;
                  case 2:
                    value = $root.google.protobuf.Value.decode(reader, reader.uint32());
                    break;
                  default:
                    reader.skipType(tag2 & 7);
                    break;
                }
              }
              message.fields[key] = value;
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Struct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Struct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.fields != null && message.hasOwnProperty("fields")) {
          if (!$util.isObject(message.fields))
            return "fields: object expected";
          let key = Object.keys(message.fields);
          for (let i = 0; i < key.length; ++i) {
            let error = $root.google.protobuf.Value.verify(message.fields[key[i]]);
            if (error)
              return "fields." + error;
          }
        }
        return null;
      };
      Struct.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Struct)
          return object;
        let message = new $root.google.protobuf.Struct();
        if (object.fields) {
          if (typeof object.fields !== "object")
            throw TypeError(".google.protobuf.Struct.fields: object expected");
          message.fields = {};
          for (let keys = Object.keys(object.fields), i = 0; i < keys.length; ++i) {
            if (typeof object.fields[keys[i]] !== "object")
              throw TypeError(".google.protobuf.Struct.fields: object expected");
            message.fields[keys[i]] = $root.google.protobuf.Value.fromObject(object.fields[keys[i]]);
          }
        }
        return message;
      };
      Struct.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.objects || options.defaults)
          object.fields = {};
        let keys2;
        if (message.fields && (keys2 = Object.keys(message.fields)).length) {
          object.fields = {};
          for (let j = 0; j < keys2.length; ++j)
            object.fields[keys2[j]] = $root.google.protobuf.Value.toObject(message.fields[keys2[j]], options);
        }
        return object;
      };
      Struct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Struct;
    }();
    protobuf.Value = function() {
      function Value(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Value.prototype.nullValue = null;
      Value.prototype.numberValue = null;
      Value.prototype.stringValue = null;
      Value.prototype.boolValue = null;
      Value.prototype.structValue = null;
      Value.prototype.listValue = null;
      let $oneOfFields;
      Object.defineProperty(Value.prototype, "kind", {
        get: $util.oneOfGetter($oneOfFields = ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Value.create = function create(properties) {
        return new Value(properties);
      };
      Value.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.nullValue != null && Object.hasOwnProperty.call(message, "nullValue"))
          writer.uint32(8).int32(message.nullValue);
        if (message.numberValue != null && Object.hasOwnProperty.call(message, "numberValue"))
          writer.uint32(17).double(message.numberValue);
        if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
          writer.uint32(26).string(message.stringValue);
        if (message.boolValue != null && Object.hasOwnProperty.call(message, "boolValue"))
          writer.uint32(32).bool(message.boolValue);
        if (message.structValue != null && Object.hasOwnProperty.call(message, "structValue"))
          $root.google.protobuf.Struct.encode(message.structValue, writer.uint32(42).fork()).ldelim();
        if (message.listValue != null && Object.hasOwnProperty.call(message, "listValue"))
          $root.google.protobuf.ListValue.encode(message.listValue, writer.uint32(50).fork()).ldelim();
        return writer;
      };
      Value.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Value.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.protobuf.Value();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.nullValue = reader.int32();
              break;
            case 2:
              message.numberValue = reader.double();
              break;
            case 3:
              message.stringValue = reader.string();
              break;
            case 4:
              message.boolValue = reader.bool();
              break;
            case 5:
              message.structValue = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 6:
              message.listValue = $root.google.protobuf.ListValue.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Value.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Value.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        let properties = {};
        if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
          properties.kind = 1;
          switch (message.nullValue) {
            default:
              return "nullValue: enum value expected";
            case 0:
              break;
          }
        }
        if (message.numberValue != null && message.hasOwnProperty("numberValue")) {
          if (properties.kind === 1)
            return "kind: multiple values";
          properties.kind = 1;
          if (typeof message.numberValue !== "number")
            return "numberValue: number expected";
        }
        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
          if (properties.kind === 1)
            return "kind: multiple values";
          properties.kind = 1;
          if (!$util.isString(message.stringValue))
            return "stringValue: string expected";
        }
        if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
          if (properties.kind === 1)
            return "kind: multiple values";
          properties.kind = 1;
          if (typeof message.boolValue !== "boolean")
            return "boolValue: boolean expected";
        }
        if (message.structValue != null && message.hasOwnProperty("structValue")) {
          if (properties.kind === 1)
            return "kind: multiple values";
          properties.kind = 1;
          {
            let error = $root.google.protobuf.Struct.verify(message.structValue);
            if (error)
              return "structValue." + error;
          }
        }
        if (message.listValue != null && message.hasOwnProperty("listValue")) {
          if (properties.kind === 1)
            return "kind: multiple values";
          properties.kind = 1;
          {
            let error = $root.google.protobuf.ListValue.verify(message.listValue);
            if (error)
              return "listValue." + error;
          }
        }
        return null;
      };
      Value.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Value)
          return object;
        let message = new $root.google.protobuf.Value();
        switch (object.nullValue) {
          case "NULL_VALUE":
          case 0:
            message.nullValue = 0;
            break;
        }
        if (object.numberValue != null)
          message.numberValue = Number(object.numberValue);
        if (object.stringValue != null)
          message.stringValue = String(object.stringValue);
        if (object.boolValue != null)
          message.boolValue = Boolean(object.boolValue);
        if (object.structValue != null) {
          if (typeof object.structValue !== "object")
            throw TypeError(".google.protobuf.Value.structValue: object expected");
          message.structValue = $root.google.protobuf.Struct.fromObject(object.structValue);
        }
        if (object.listValue != null) {
          if (typeof object.listValue !== "object")
            throw TypeError(".google.protobuf.Value.listValue: object expected");
          message.listValue = $root.google.protobuf.ListValue.fromObject(object.listValue);
        }
        return message;
      };
      Value.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
          object.nullValue = options.enums === String ? $root.google.protobuf.NullValue[message.nullValue] : message.nullValue;
          if (options.oneofs)
            object.kind = "nullValue";
        }
        if (message.numberValue != null && message.hasOwnProperty("numberValue")) {
          object.numberValue = options.json && !isFinite(message.numberValue) ? String(message.numberValue) : message.numberValue;
          if (options.oneofs)
            object.kind = "numberValue";
        }
        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
          object.stringValue = message.stringValue;
          if (options.oneofs)
            object.kind = "stringValue";
        }
        if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
          object.boolValue = message.boolValue;
          if (options.oneofs)
            object.kind = "boolValue";
        }
        if (message.structValue != null && message.hasOwnProperty("structValue")) {
          object.structValue = $root.google.protobuf.Struct.toObject(message.structValue, options);
          if (options.oneofs)
            object.kind = "structValue";
        }
        if (message.listValue != null && message.hasOwnProperty("listValue")) {
          object.listValue = $root.google.protobuf.ListValue.toObject(message.listValue, options);
          if (options.oneofs)
            object.kind = "listValue";
        }
        return object;
      };
      Value.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Value;
    }();
    protobuf.NullValue = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "NULL_VALUE"] = 0;
      return values;
    }();
    protobuf.ListValue = function() {
      function ListValue(properties) {
        this.values = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      ListValue.prototype.values = $util.emptyArray;
      ListValue.create = function create(properties) {
        return new ListValue(properties);
      };
      ListValue.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.values != null && message.values.length)
          for (let i = 0; i < message.values.length; ++i)
            $root.google.protobuf.Value.encode(message.values[i], writer.uint32(10).fork()).ldelim();
        return writer;
      };
      ListValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      ListValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.protobuf.ListValue();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.values && message.values.length))
                message.values = [];
              message.values.push($root.google.protobuf.Value.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      ListValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      ListValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.values != null && message.hasOwnProperty("values")) {
          if (!Array.isArray(message.values))
            return "values: array expected";
          for (let i = 0; i < message.values.length; ++i) {
            let error = $root.google.protobuf.Value.verify(message.values[i]);
            if (error)
              return "values." + error;
          }
        }
        return null;
      };
      ListValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.ListValue)
          return object;
        let message = new $root.google.protobuf.ListValue();
        if (object.values) {
          if (!Array.isArray(object.values))
            throw TypeError(".google.protobuf.ListValue.values: array expected");
          message.values = [];
          for (let i = 0; i < object.values.length; ++i) {
            if (typeof object.values[i] !== "object")
              throw TypeError(".google.protobuf.ListValue.values: object expected");
            message.values[i] = $root.google.protobuf.Value.fromObject(object.values[i]);
          }
        }
        return message;
      };
      ListValue.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.values = [];
        if (message.values && message.values.length) {
          object.values = [];
          for (let j = 0; j < message.values.length; ++j)
            object.values[j] = $root.google.protobuf.Value.toObject(message.values[j], options);
        }
        return object;
      };
      ListValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return ListValue;
    }();
    protobuf.Duration = function() {
      function Duration(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Duration.prototype.nanos = 0;
      Duration.create = function create(properties) {
        return new Duration(properties);
      };
      Duration.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
          writer.uint32(8).int64(message.seconds);
        if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
          writer.uint32(16).int32(message.nanos);
        return writer;
      };
      Duration.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Duration.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seconds = reader.int64();
              break;
            case 2:
              message.nanos = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Duration.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Duration.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seconds != null && message.hasOwnProperty("seconds")) {
          if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
            return "seconds: integer|Long expected";
        }
        if (message.nanos != null && message.hasOwnProperty("nanos")) {
          if (!$util.isInteger(message.nanos))
            return "nanos: integer expected";
        }
        return null;
      };
      Duration.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Duration)
          return object;
        let message = new $root.google.protobuf.Duration();
        if (object.seconds != null) {
          if ($util.Long)
            (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
          else if (typeof object.seconds === "string")
            message.seconds = parseInt(object.seconds, 10);
          else if (typeof object.seconds === "number")
            message.seconds = object.seconds;
          else if (typeof object.seconds === "object")
            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
        }
        if (object.nanos != null)
          message.nanos = object.nanos | 0;
        return message;
      };
      Duration.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seconds = options.longs === String ? "0" : 0;
          object.nanos = 0;
        }
        if (message.seconds != null && message.hasOwnProperty("seconds"))
          if (typeof message.seconds === "number")
            object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
          else
            object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
        if (message.nanos != null && message.hasOwnProperty("nanos"))
          object.nanos = message.nanos;
        return object;
      };
      Duration.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Duration;
    }();
    return protobuf;
  }();
  google2.type = function() {
    const type = {};
    type.DateTime = function() {
      function DateTime(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DateTime.prototype.year = 0;
      DateTime.prototype.month = 0;
      DateTime.prototype.day = 0;
      DateTime.prototype.hours = 0;
      DateTime.prototype.minutes = 0;
      DateTime.prototype.seconds = 0;
      DateTime.prototype.nanos = 0;
      DateTime.prototype.utcOffset = null;
      DateTime.prototype.timeZone = null;
      let $oneOfFields;
      Object.defineProperty(DateTime.prototype, "timeOffset", {
        get: $util.oneOfGetter($oneOfFields = ["utcOffset", "timeZone"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      DateTime.create = function create(properties) {
        return new DateTime(properties);
      };
      DateTime.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.year != null && Object.hasOwnProperty.call(message, "year"))
          writer.uint32(8).int32(message.year);
        if (message.month != null && Object.hasOwnProperty.call(message, "month"))
          writer.uint32(16).int32(message.month);
        if (message.day != null && Object.hasOwnProperty.call(message, "day"))
          writer.uint32(24).int32(message.day);
        if (message.hours != null && Object.hasOwnProperty.call(message, "hours"))
          writer.uint32(32).int32(message.hours);
        if (message.minutes != null && Object.hasOwnProperty.call(message, "minutes"))
          writer.uint32(40).int32(message.minutes);
        if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
          writer.uint32(48).int32(message.seconds);
        if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
          writer.uint32(56).int32(message.nanos);
        if (message.utcOffset != null && Object.hasOwnProperty.call(message, "utcOffset"))
          $root.google.protobuf.Duration.encode(message.utcOffset, writer.uint32(66).fork()).ldelim();
        if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
          $root.google.type.TimeZone.encode(message.timeZone, writer.uint32(74).fork()).ldelim();
        return writer;
      };
      DateTime.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DateTime.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.type.DateTime();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.year = reader.int32();
              break;
            case 2:
              message.month = reader.int32();
              break;
            case 3:
              message.day = reader.int32();
              break;
            case 4:
              message.hours = reader.int32();
              break;
            case 5:
              message.minutes = reader.int32();
              break;
            case 6:
              message.seconds = reader.int32();
              break;
            case 7:
              message.nanos = reader.int32();
              break;
            case 8:
              message.utcOffset = $root.google.protobuf.Duration.decode(reader, reader.uint32());
              break;
            case 9:
              message.timeZone = $root.google.type.TimeZone.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DateTime.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DateTime.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        let properties = {};
        if (message.year != null && message.hasOwnProperty("year")) {
          if (!$util.isInteger(message.year))
            return "year: integer expected";
        }
        if (message.month != null && message.hasOwnProperty("month")) {
          if (!$util.isInteger(message.month))
            return "month: integer expected";
        }
        if (message.day != null && message.hasOwnProperty("day")) {
          if (!$util.isInteger(message.day))
            return "day: integer expected";
        }
        if (message.hours != null && message.hasOwnProperty("hours")) {
          if (!$util.isInteger(message.hours))
            return "hours: integer expected";
        }
        if (message.minutes != null && message.hasOwnProperty("minutes")) {
          if (!$util.isInteger(message.minutes))
            return "minutes: integer expected";
        }
        if (message.seconds != null && message.hasOwnProperty("seconds")) {
          if (!$util.isInteger(message.seconds))
            return "seconds: integer expected";
        }
        if (message.nanos != null && message.hasOwnProperty("nanos")) {
          if (!$util.isInteger(message.nanos))
            return "nanos: integer expected";
        }
        if (message.utcOffset != null && message.hasOwnProperty("utcOffset")) {
          properties.timeOffset = 1;
          {
            let error = $root.google.protobuf.Duration.verify(message.utcOffset);
            if (error)
              return "utcOffset." + error;
          }
        }
        if (message.timeZone != null && message.hasOwnProperty("timeZone")) {
          if (properties.timeOffset === 1)
            return "timeOffset: multiple values";
          properties.timeOffset = 1;
          {
            let error = $root.google.type.TimeZone.verify(message.timeZone);
            if (error)
              return "timeZone." + error;
          }
        }
        return null;
      };
      DateTime.fromObject = function fromObject(object) {
        if (object instanceof $root.google.type.DateTime)
          return object;
        let message = new $root.google.type.DateTime();
        if (object.year != null)
          message.year = object.year | 0;
        if (object.month != null)
          message.month = object.month | 0;
        if (object.day != null)
          message.day = object.day | 0;
        if (object.hours != null)
          message.hours = object.hours | 0;
        if (object.minutes != null)
          message.minutes = object.minutes | 0;
        if (object.seconds != null)
          message.seconds = object.seconds | 0;
        if (object.nanos != null)
          message.nanos = object.nanos | 0;
        if (object.utcOffset != null) {
          if (typeof object.utcOffset !== "object")
            throw TypeError(".google.type.DateTime.utcOffset: object expected");
          message.utcOffset = $root.google.protobuf.Duration.fromObject(object.utcOffset);
        }
        if (object.timeZone != null) {
          if (typeof object.timeZone !== "object")
            throw TypeError(".google.type.DateTime.timeZone: object expected");
          message.timeZone = $root.google.type.TimeZone.fromObject(object.timeZone);
        }
        return message;
      };
      DateTime.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.year = 0;
          object.month = 0;
          object.day = 0;
          object.hours = 0;
          object.minutes = 0;
          object.seconds = 0;
          object.nanos = 0;
        }
        if (message.year != null && message.hasOwnProperty("year"))
          object.year = message.year;
        if (message.month != null && message.hasOwnProperty("month"))
          object.month = message.month;
        if (message.day != null && message.hasOwnProperty("day"))
          object.day = message.day;
        if (message.hours != null && message.hasOwnProperty("hours"))
          object.hours = message.hours;
        if (message.minutes != null && message.hasOwnProperty("minutes"))
          object.minutes = message.minutes;
        if (message.seconds != null && message.hasOwnProperty("seconds"))
          object.seconds = message.seconds;
        if (message.nanos != null && message.hasOwnProperty("nanos"))
          object.nanos = message.nanos;
        if (message.utcOffset != null && message.hasOwnProperty("utcOffset")) {
          object.utcOffset = $root.google.protobuf.Duration.toObject(message.utcOffset, options);
          if (options.oneofs)
            object.timeOffset = "utcOffset";
        }
        if (message.timeZone != null && message.hasOwnProperty("timeZone")) {
          object.timeZone = $root.google.type.TimeZone.toObject(message.timeZone, options);
          if (options.oneofs)
            object.timeOffset = "timeZone";
        }
        return object;
      };
      DateTime.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DateTime;
    }();
    type.TimeZone = function() {
      function TimeZone(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      TimeZone.prototype.id = "";
      TimeZone.prototype.version = "";
      TimeZone.create = function create(properties) {
        return new TimeZone(properties);
      };
      TimeZone.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(10).string(message.id);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
          writer.uint32(18).string(message.version);
        return writer;
      };
      TimeZone.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      TimeZone.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.type.TimeZone();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.version = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      TimeZone.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      TimeZone.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isString(message.id))
            return "id: string expected";
        }
        if (message.version != null && message.hasOwnProperty("version")) {
          if (!$util.isString(message.version))
            return "version: string expected";
        }
        return null;
      };
      TimeZone.fromObject = function fromObject(object) {
        if (object instanceof $root.google.type.TimeZone)
          return object;
        let message = new $root.google.type.TimeZone();
        if (object.id != null)
          message.id = String(object.id);
        if (object.version != null)
          message.version = String(object.version);
        return message;
      };
      TimeZone.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.id = "";
          object.version = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.version != null && message.hasOwnProperty("version"))
          object.version = message.version;
        return object;
      };
      TimeZone.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return TimeZone;
    }();
    type.Date = function() {
      function Date(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Date.prototype.year = 0;
      Date.prototype.month = 0;
      Date.prototype.day = 0;
      Date.create = function create(properties) {
        return new Date(properties);
      };
      Date.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.year != null && Object.hasOwnProperty.call(message, "year"))
          writer.uint32(8).int32(message.year);
        if (message.month != null && Object.hasOwnProperty.call(message, "month"))
          writer.uint32(16).int32(message.month);
        if (message.day != null && Object.hasOwnProperty.call(message, "day"))
          writer.uint32(24).int32(message.day);
        return writer;
      };
      Date.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Date.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.google.type.Date();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.year = reader.int32();
              break;
            case 2:
              message.month = reader.int32();
              break;
            case 3:
              message.day = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Date.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Date.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.year != null && message.hasOwnProperty("year")) {
          if (!$util.isInteger(message.year))
            return "year: integer expected";
        }
        if (message.month != null && message.hasOwnProperty("month")) {
          if (!$util.isInteger(message.month))
            return "month: integer expected";
        }
        if (message.day != null && message.hasOwnProperty("day")) {
          if (!$util.isInteger(message.day))
            return "day: integer expected";
        }
        return null;
      };
      Date.fromObject = function fromObject(object) {
        if (object instanceof $root.google.type.Date)
          return object;
        let message = new $root.google.type.Date();
        if (object.year != null)
          message.year = object.year | 0;
        if (object.month != null)
          message.month = object.month | 0;
        if (object.day != null)
          message.day = object.day | 0;
        return message;
      };
      Date.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.year = 0;
          object.month = 0;
          object.day = 0;
        }
        if (message.year != null && message.hasOwnProperty("year"))
          object.year = message.year;
        if (message.month != null && message.hasOwnProperty("month"))
          object.month = message.month;
        if (message.day != null && message.hasOwnProperty("day"))
          object.day = message.day;
        return object;
      };
      Date.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Date;
    }();
    return type;
  }();
  return google2;
})();
$root.oauth2 = (() => {
  const oauth22 = {};
  oauth22.deposit = function() {
    const deposit = {};
    deposit.v1 = function() {
      const v1 = {};
      v1.DepositCode = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEPOSIT_CODE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "DEPOSIT_CODE_CREATED"] = 1;
        values[valuesById[2] = "DEPOSIT_CODE_SUCCESS"] = 2;
        values[valuesById[3] = "DEPOSIT_CODE_INVALID_ACCOUNT_NO"] = 3;
        values[valuesById[4] = "DEPOSIT_CODE_NOT_ENOUGH_ACCOUNT_BALANCE"] = 4;
        values[valuesById[5] = "DEPOSIT_CODE_POSTPONE"] = 5;
        values[valuesById[6] = "DEPOSIT_CODE_INVALID_BENEFICIARY"] = 6;
        return values;
      }();
      v1.DepositHook = function() {
        function DepositHook(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DepositHook.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DepositHook.prototype.code = 0;
        DepositHook.prototype.message = "";
        DepositHook.create = function create(properties) {
          return new DepositHook(properties);
        };
        DepositHook.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
          if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(16).int32(message.code);
          if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(26).string(message.message);
          return writer;
        };
        DepositHook.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DepositHook.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.oauth2.deposit.v1.DepositHook();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int64();
                break;
              case 2:
                message.code = reader.int32();
                break;
              case 3:
                message.message = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DepositHook.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DepositHook.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
              return "id: integer|Long expected";
          }
          if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
              default:
                return "code: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
                break;
            }
          if (message.message != null && message.hasOwnProperty("message")) {
            if (!$util.isString(message.message))
              return "message: string expected";
          }
          return null;
        };
        DepositHook.fromObject = function fromObject(object) {
          if (object instanceof $root.oauth2.deposit.v1.DepositHook)
            return object;
          let message = new $root.oauth2.deposit.v1.DepositHook();
          if (object.id != null) {
            if ($util.Long)
              (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
              message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
              message.id = object.id;
            else if (typeof object.id === "object")
              message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
          }
          switch (object.code) {
            case "DEPOSIT_CODE_UNSPECIFIED":
            case 0:
              message.code = 0;
              break;
            case "DEPOSIT_CODE_CREATED":
            case 1:
              message.code = 1;
              break;
            case "DEPOSIT_CODE_SUCCESS":
            case 2:
              message.code = 2;
              break;
            case "DEPOSIT_CODE_INVALID_ACCOUNT_NO":
            case 3:
              message.code = 3;
              break;
            case "DEPOSIT_CODE_NOT_ENOUGH_ACCOUNT_BALANCE":
            case 4:
              message.code = 4;
              break;
            case "DEPOSIT_CODE_POSTPONE":
            case 5:
              message.code = 5;
              break;
            case "DEPOSIT_CODE_INVALID_BENEFICIARY":
            case 6:
              message.code = 6;
              break;
          }
          if (object.message != null)
            message.message = String(object.message);
          return message;
        };
        DepositHook.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.id = options.longs === String ? "0" : 0;
            object.code = options.enums === String ? "DEPOSIT_CODE_UNSPECIFIED" : 0;
            object.message = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
              object.id = options.longs === String ? String(message.id) : message.id;
            else
              object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
          if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.oauth2.deposit.v1.DepositCode[message.code] : message.code;
          if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
          return object;
        };
        DepositHook.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return DepositHook;
      }();
      v1.DepositRequest = function() {
        function DepositRequest(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DepositRequest.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DepositRequest.prototype.partnerRefId = "";
        DepositRequest.prototype.transactionId = "";
        DepositRequest.prototype.investorId = "";
        DepositRequest.prototype.accountNo = "";
        DepositRequest.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DepositRequest.prototype.clientSource = "";
        DepositRequest.prototype.isRefund = false;
        DepositRequest.create = function create(properties) {
          return new DepositRequest(properties);
        };
        DepositRequest.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
          if (message.partnerRefId != null && Object.hasOwnProperty.call(message, "partnerRefId"))
            writer.uint32(18).string(message.partnerRefId);
          if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
            writer.uint32(26).string(message.transactionId);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(34).string(message.investorId);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(42).string(message.accountNo);
          if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(48).int64(message.amount);
          if (message.clientSource != null && Object.hasOwnProperty.call(message, "clientSource"))
            writer.uint32(58).string(message.clientSource);
          if (message.isRefund != null && Object.hasOwnProperty.call(message, "isRefund"))
            writer.uint32(64).bool(message.isRefund);
          return writer;
        };
        DepositRequest.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DepositRequest.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.oauth2.deposit.v1.DepositRequest();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int64();
                break;
              case 2:
                message.partnerRefId = reader.string();
                break;
              case 3:
                message.transactionId = reader.string();
                break;
              case 4:
                message.investorId = reader.string();
                break;
              case 5:
                message.accountNo = reader.string();
                break;
              case 6:
                message.amount = reader.int64();
                break;
              case 7:
                message.clientSource = reader.string();
                break;
              case 8:
                message.isRefund = reader.bool();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DepositRequest.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DepositRequest.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
              return "id: integer|Long expected";
          }
          if (message.partnerRefId != null && message.hasOwnProperty("partnerRefId")) {
            if (!$util.isString(message.partnerRefId))
              return "partnerRefId: string expected";
          }
          if (message.transactionId != null && message.hasOwnProperty("transactionId")) {
            if (!$util.isString(message.transactionId))
              return "transactionId: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.amount != null && message.hasOwnProperty("amount")) {
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
              return "amount: integer|Long expected";
          }
          if (message.clientSource != null && message.hasOwnProperty("clientSource")) {
            if (!$util.isString(message.clientSource))
              return "clientSource: string expected";
          }
          if (message.isRefund != null && message.hasOwnProperty("isRefund")) {
            if (typeof message.isRefund !== "boolean")
              return "isRefund: boolean expected";
          }
          return null;
        };
        DepositRequest.fromObject = function fromObject(object) {
          if (object instanceof $root.oauth2.deposit.v1.DepositRequest)
            return object;
          let message = new $root.oauth2.deposit.v1.DepositRequest();
          if (object.id != null) {
            if ($util.Long)
              (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
              message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
              message.id = object.id;
            else if (typeof object.id === "object")
              message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
          }
          if (object.partnerRefId != null)
            message.partnerRefId = String(object.partnerRefId);
          if (object.transactionId != null)
            message.transactionId = String(object.transactionId);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.amount != null) {
            if ($util.Long)
              (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
              message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
              message.amount = object.amount;
            else if (typeof object.amount === "object")
              message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
          }
          if (object.clientSource != null)
            message.clientSource = String(object.clientSource);
          if (object.isRefund != null)
            message.isRefund = Boolean(object.isRefund);
          return message;
        };
        DepositRequest.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.id = options.longs === String ? "0" : 0;
            object.partnerRefId = "";
            object.transactionId = "";
            object.investorId = "";
            object.accountNo = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.amount = options.longs === String ? "0" : 0;
            object.clientSource = "";
            object.isRefund = false;
          }
          if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
              object.id = options.longs === String ? String(message.id) : message.id;
            else
              object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
          if (message.partnerRefId != null && message.hasOwnProperty("partnerRefId"))
            object.partnerRefId = message.partnerRefId;
          if (message.transactionId != null && message.hasOwnProperty("transactionId"))
            object.transactionId = message.transactionId;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
              object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
              object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
          if (message.clientSource != null && message.hasOwnProperty("clientSource"))
            object.clientSource = message.clientSource;
          if (message.isRefund != null && message.hasOwnProperty("isRefund"))
            object.isRefund = message.isRefund;
          return object;
        };
        DepositRequest.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return DepositRequest;
      }();
      v1.DepositBalanceHook = function() {
        function DepositBalanceHook(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DepositBalanceHook.prototype.balance = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DepositBalanceHook.prototype.description = "";
        DepositBalanceHook.prototype.accountNo = "";
        DepositBalanceHook.prototype.executedAt = null;
        DepositBalanceHook.prototype.clientSource = "";
        DepositBalanceHook.create = function create(properties) {
          return new DepositBalanceHook(properties);
        };
        DepositBalanceHook.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
            writer.uint32(24).int64(message.balance);
          if (message.description != null && Object.hasOwnProperty.call(message, "description"))
            writer.uint32(34).string(message.description);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(50).string(message.accountNo);
          if (message.executedAt != null && Object.hasOwnProperty.call(message, "executedAt"))
            $root.google.protobuf.Timestamp.encode(message.executedAt, writer.uint32(58).fork()).ldelim();
          if (message.clientSource != null && Object.hasOwnProperty.call(message, "clientSource"))
            writer.uint32(66).string(message.clientSource);
          return writer;
        };
        DepositBalanceHook.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DepositBalanceHook.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.oauth2.deposit.v1.DepositBalanceHook();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 3:
                message.balance = reader.int64();
                break;
              case 4:
                message.description = reader.string();
                break;
              case 6:
                message.accountNo = reader.string();
                break;
              case 7:
                message.executedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 8:
                message.clientSource = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DepositBalanceHook.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DepositBalanceHook.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.balance != null && message.hasOwnProperty("balance")) {
            if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
              return "balance: integer|Long expected";
          }
          if (message.description != null && message.hasOwnProperty("description")) {
            if (!$util.isString(message.description))
              return "description: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.executedAt != null && message.hasOwnProperty("executedAt")) {
            let error = $root.google.protobuf.Timestamp.verify(message.executedAt);
            if (error)
              return "executedAt." + error;
          }
          if (message.clientSource != null && message.hasOwnProperty("clientSource")) {
            if (!$util.isString(message.clientSource))
              return "clientSource: string expected";
          }
          return null;
        };
        DepositBalanceHook.fromObject = function fromObject(object) {
          if (object instanceof $root.oauth2.deposit.v1.DepositBalanceHook)
            return object;
          let message = new $root.oauth2.deposit.v1.DepositBalanceHook();
          if (object.balance != null) {
            if ($util.Long)
              (message.balance = $util.Long.fromValue(object.balance)).unsigned = false;
            else if (typeof object.balance === "string")
              message.balance = parseInt(object.balance, 10);
            else if (typeof object.balance === "number")
              message.balance = object.balance;
            else if (typeof object.balance === "object")
              message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber();
          }
          if (object.description != null)
            message.description = String(object.description);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.executedAt != null) {
            if (typeof object.executedAt !== "object")
              throw TypeError(".oauth2.deposit.v1.DepositBalanceHook.executedAt: object expected");
            message.executedAt = $root.google.protobuf.Timestamp.fromObject(object.executedAt);
          }
          if (object.clientSource != null)
            message.clientSource = String(object.clientSource);
          return message;
        };
        DepositBalanceHook.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.balance = options.longs === String ? "0" : 0;
            object.description = "";
            object.accountNo = "";
            object.executedAt = null;
            object.clientSource = "";
          }
          if (message.balance != null && message.hasOwnProperty("balance"))
            if (typeof message.balance === "number")
              object.balance = options.longs === String ? String(message.balance) : message.balance;
            else
              object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber() : message.balance;
          if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.executedAt != null && message.hasOwnProperty("executedAt"))
            object.executedAt = $root.google.protobuf.Timestamp.toObject(message.executedAt, options);
          if (message.clientSource != null && message.hasOwnProperty("clientSource"))
            object.clientSource = message.clientSource;
          return object;
        };
        DepositBalanceHook.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return DepositBalanceHook;
      }();
      return v1;
    }();
    return deposit;
  }();
  oauth22.user = function() {
    const user = {};
    user.UserConsent = function() {
      function UserConsent(properties) {
        this.scopes = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      UserConsent.prototype.userId = "";
      UserConsent.prototype.clientId = "";
      UserConsent.prototype.scopes = $util.emptyArray;
      UserConsent.prototype.time = null;
      UserConsent.create = function create(properties) {
        return new UserConsent(properties);
      };
      UserConsent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
          writer.uint32(10).string(message.userId);
        if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
          writer.uint32(18).string(message.clientId);
        if (message.scopes != null && message.scopes.length)
          for (let i = 0; i < message.scopes.length; ++i)
            writer.uint32(26).string(message.scopes[i]);
        if (message.time != null && Object.hasOwnProperty.call(message, "time"))
          $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        return writer;
      };
      UserConsent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      UserConsent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.oauth2.user.UserConsent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.userId = reader.string();
              break;
            case 2:
              message.clientId = reader.string();
              break;
            case 3:
              if (!(message.scopes && message.scopes.length))
                message.scopes = [];
              message.scopes.push(reader.string());
              break;
            case 4:
              message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      UserConsent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      UserConsent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId")) {
          if (!$util.isString(message.userId))
            return "userId: string expected";
        }
        if (message.clientId != null && message.hasOwnProperty("clientId")) {
          if (!$util.isString(message.clientId))
            return "clientId: string expected";
        }
        if (message.scopes != null && message.hasOwnProperty("scopes")) {
          if (!Array.isArray(message.scopes))
            return "scopes: array expected";
          for (let i = 0; i < message.scopes.length; ++i)
            if (!$util.isString(message.scopes[i]))
              return "scopes: string[] expected";
        }
        if (message.time != null && message.hasOwnProperty("time")) {
          let error = $root.google.protobuf.Timestamp.verify(message.time);
          if (error)
            return "time." + error;
        }
        return null;
      };
      UserConsent.fromObject = function fromObject(object) {
        if (object instanceof $root.oauth2.user.UserConsent)
          return object;
        let message = new $root.oauth2.user.UserConsent();
        if (object.userId != null)
          message.userId = String(object.userId);
        if (object.clientId != null)
          message.clientId = String(object.clientId);
        if (object.scopes) {
          if (!Array.isArray(object.scopes))
            throw TypeError(".oauth2.user.UserConsent.scopes: array expected");
          message.scopes = [];
          for (let i = 0; i < object.scopes.length; ++i)
            message.scopes[i] = String(object.scopes[i]);
        }
        if (object.time != null) {
          if (typeof object.time !== "object")
            throw TypeError(".oauth2.user.UserConsent.time: object expected");
          message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
        }
        return message;
      };
      UserConsent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.scopes = [];
        if (options.defaults) {
          object.userId = "";
          object.clientId = "";
          object.time = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
          object.userId = message.userId;
        if (message.clientId != null && message.hasOwnProperty("clientId"))
          object.clientId = message.clientId;
        if (message.scopes && message.scopes.length) {
          object.scopes = [];
          for (let j = 0; j < message.scopes.length; ++j)
            object.scopes[j] = message.scopes[j];
        }
        if (message.time != null && message.hasOwnProperty("time"))
          object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
        return object;
      };
      UserConsent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return UserConsent;
    }();
    return user;
  }();
  return oauth22;
})();
$root.sense = (() => {
  const sense2 = {};
  sense2.SignalType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_TYPE"] = 0;
    values[valuesById[1] = "EMA5_CROSS_EMA10"] = 1;
    values[valuesById[2] = "EMA10_CROSS_EMA20"] = 2;
    return values;
  }();
  sense2.SignalAction = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_ACTION"] = 0;
    values[valuesById[1] = "BUY"] = 1;
    values[valuesById[2] = "SELL"] = 2;
    return values;
  }();
  sense2.TradeSignalNotification = function() {
    function TradeSignalNotification(properties) {
      this.investorIds = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    TradeSignalNotification.prototype.investorIds = $util.emptyArray;
    TradeSignalNotification.prototype.signalType = 0;
    TradeSignalNotification.prototype.action = 0;
    TradeSignalNotification.prototype.symbol = "";
    TradeSignalNotification.prototype.execPrice = 0;
    TradeSignalNotification.prototype.profit = 0;
    TradeSignalNotification.prototype.averageHoldingTime = 0;
    TradeSignalNotification.prototype.openDate = null;
    TradeSignalNotification.prototype.time = null;
    TradeSignalNotification.create = function create(properties) {
      return new TradeSignalNotification(properties);
    };
    TradeSignalNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorIds != null && message.investorIds.length)
        for (let i = 0; i < message.investorIds.length; ++i)
          writer.uint32(10).string(message.investorIds[i]);
      if (message.signalType != null && Object.hasOwnProperty.call(message, "signalType"))
        writer.uint32(16).int32(message.signalType);
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(24).int32(message.action);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.execPrice != null && Object.hasOwnProperty.call(message, "execPrice"))
        writer.uint32(45).float(message.execPrice);
      if (message.profit != null && Object.hasOwnProperty.call(message, "profit"))
        writer.uint32(53).float(message.profit);
      if (message.averageHoldingTime != null && Object.hasOwnProperty.call(message, "averageHoldingTime"))
        writer.uint32(61).float(message.averageHoldingTime);
      if (message.openDate != null && Object.hasOwnProperty.call(message, "openDate"))
        $root.google.protobuf.Timestamp.encode(message.openDate, writer.uint32(66).fork()).ldelim();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(74).fork()).ldelim();
      return writer;
    };
    TradeSignalNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    TradeSignalNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.sense.TradeSignalNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.investorIds && message.investorIds.length))
              message.investorIds = [];
            message.investorIds.push(reader.string());
            break;
          case 2:
            message.signalType = reader.int32();
            break;
          case 3:
            message.action = reader.int32();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.execPrice = reader.float();
            break;
          case 6:
            message.profit = reader.float();
            break;
          case 7:
            message.averageHoldingTime = reader.float();
            break;
          case 8:
            message.openDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    TradeSignalNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    TradeSignalNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorIds != null && message.hasOwnProperty("investorIds")) {
        if (!Array.isArray(message.investorIds))
          return "investorIds: array expected";
        for (let i = 0; i < message.investorIds.length; ++i)
          if (!$util.isString(message.investorIds[i]))
            return "investorIds: string[] expected";
      }
      if (message.signalType != null && message.hasOwnProperty("signalType"))
        switch (message.signalType) {
          default:
            return "signalType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.action != null && message.hasOwnProperty("action"))
        switch (message.action) {
          default:
            return "action: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.execPrice != null && message.hasOwnProperty("execPrice")) {
        if (typeof message.execPrice !== "number")
          return "execPrice: number expected";
      }
      if (message.profit != null && message.hasOwnProperty("profit")) {
        if (typeof message.profit !== "number")
          return "profit: number expected";
      }
      if (message.averageHoldingTime != null && message.hasOwnProperty("averageHoldingTime")) {
        if (typeof message.averageHoldingTime !== "number")
          return "averageHoldingTime: number expected";
      }
      if (message.openDate != null && message.hasOwnProperty("openDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.openDate);
        if (error)
          return "openDate." + error;
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    TradeSignalNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.sense.TradeSignalNotification)
        return object;
      let message = new $root.sense.TradeSignalNotification();
      if (object.investorIds) {
        if (!Array.isArray(object.investorIds))
          throw TypeError(".sense.TradeSignalNotification.investorIds: array expected");
        message.investorIds = [];
        for (let i = 0; i < object.investorIds.length; ++i)
          message.investorIds[i] = String(object.investorIds[i]);
      }
      switch (object.signalType) {
        case "UNKNOWN_TYPE":
        case 0:
          message.signalType = 0;
          break;
        case "EMA5_CROSS_EMA10":
        case 1:
          message.signalType = 1;
          break;
        case "EMA10_CROSS_EMA20":
        case 2:
          message.signalType = 2;
          break;
      }
      switch (object.action) {
        case "UNKNOWN_ACTION":
        case 0:
          message.action = 0;
          break;
        case "BUY":
        case 1:
          message.action = 1;
          break;
        case "SELL":
        case 2:
          message.action = 2;
          break;
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.execPrice != null)
        message.execPrice = Number(object.execPrice);
      if (object.profit != null)
        message.profit = Number(object.profit);
      if (object.averageHoldingTime != null)
        message.averageHoldingTime = Number(object.averageHoldingTime);
      if (object.openDate != null) {
        if (typeof object.openDate !== "object")
          throw TypeError(".sense.TradeSignalNotification.openDate: object expected");
        message.openDate = $root.google.protobuf.Timestamp.fromObject(object.openDate);
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".sense.TradeSignalNotification.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    TradeSignalNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.investorIds = [];
      if (options.defaults) {
        object.signalType = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.action = options.enums === String ? "UNKNOWN_ACTION" : 0;
        object.symbol = "";
        object.execPrice = 0;
        object.profit = 0;
        object.averageHoldingTime = 0;
        object.openDate = null;
        object.time = null;
      }
      if (message.investorIds && message.investorIds.length) {
        object.investorIds = [];
        for (let j = 0; j < message.investorIds.length; ++j)
          object.investorIds[j] = message.investorIds[j];
      }
      if (message.signalType != null && message.hasOwnProperty("signalType"))
        object.signalType = options.enums === String ? $root.sense.SignalType[message.signalType] : message.signalType;
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = options.enums === String ? $root.sense.SignalAction[message.action] : message.action;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.execPrice != null && message.hasOwnProperty("execPrice"))
        object.execPrice = options.json && !isFinite(message.execPrice) ? String(message.execPrice) : message.execPrice;
      if (message.profit != null && message.hasOwnProperty("profit"))
        object.profit = options.json && !isFinite(message.profit) ? String(message.profit) : message.profit;
      if (message.averageHoldingTime != null && message.hasOwnProperty("averageHoldingTime"))
        object.averageHoldingTime = options.json && !isFinite(message.averageHoldingTime) ? String(message.averageHoldingTime) : message.averageHoldingTime;
      if (message.openDate != null && message.hasOwnProperty("openDate"))
        object.openDate = $root.google.protobuf.Timestamp.toObject(message.openDate, options);
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    TradeSignalNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return TradeSignalNotification;
  }();
  sense2.PEBasket = function() {
    function PEBasket(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    PEBasket.prototype.basket = 0;
    PEBasket.prototype.pe = 0;
    PEBasket.prototype.tradingTime = null;
    PEBasket.prototype.ts = null;
    PEBasket.create = function create(properties) {
      return new PEBasket(properties);
    };
    PEBasket.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.basket != null && Object.hasOwnProperty.call(message, "basket"))
        writer.uint32(8).int32(message.basket);
      if (message.pe != null && Object.hasOwnProperty.call(message, "pe"))
        writer.uint32(21).float(message.pe);
      if (message.tradingTime != null && Object.hasOwnProperty.call(message, "tradingTime"))
        $root.google.protobuf.Timestamp.encode(message.tradingTime, writer.uint32(26).fork()).ldelim();
      if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
        $root.google.protobuf.Timestamp.encode(message.ts, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    PEBasket.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    PEBasket.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.sense.PEBasket();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.basket = reader.int32();
            break;
          case 2:
            message.pe = reader.float();
            break;
          case 3:
            message.tradingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.ts = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    PEBasket.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    PEBasket.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.basket != null && message.hasOwnProperty("basket"))
        switch (message.basket) {
          default:
            return "basket: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.pe != null && message.hasOwnProperty("pe")) {
        if (typeof message.pe !== "number")
          return "pe: number expected";
      }
      if (message.tradingTime != null && message.hasOwnProperty("tradingTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.tradingTime);
        if (error)
          return "tradingTime." + error;
      }
      if (message.ts != null && message.hasOwnProperty("ts")) {
        let error = $root.google.protobuf.Timestamp.verify(message.ts);
        if (error)
          return "ts." + error;
      }
      return null;
    };
    PEBasket.fromObject = function fromObject(object) {
      if (object instanceof $root.sense.PEBasket)
        return object;
      let message = new $root.sense.PEBasket();
      switch (object.basket) {
        case "UNKNOWN":
        case 0:
          message.basket = 0;
          break;
        case "HOSE":
        case 1:
          message.basket = 1;
          break;
      }
      if (object.pe != null)
        message.pe = Number(object.pe);
      if (object.tradingTime != null) {
        if (typeof object.tradingTime !== "object")
          throw TypeError(".sense.PEBasket.tradingTime: object expected");
        message.tradingTime = $root.google.protobuf.Timestamp.fromObject(object.tradingTime);
      }
      if (object.ts != null) {
        if (typeof object.ts !== "object")
          throw TypeError(".sense.PEBasket.ts: object expected");
        message.ts = $root.google.protobuf.Timestamp.fromObject(object.ts);
      }
      return message;
    };
    PEBasket.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.basket = options.enums === String ? "UNKNOWN" : 0;
        object.pe = 0;
        object.tradingTime = null;
        object.ts = null;
      }
      if (message.basket != null && message.hasOwnProperty("basket"))
        object.basket = options.enums === String ? $root.sense.PEBasket.Basket[message.basket] : message.basket;
      if (message.pe != null && message.hasOwnProperty("pe"))
        object.pe = options.json && !isFinite(message.pe) ? String(message.pe) : message.pe;
      if (message.tradingTime != null && message.hasOwnProperty("tradingTime"))
        object.tradingTime = $root.google.protobuf.Timestamp.toObject(message.tradingTime, options);
      if (message.ts != null && message.hasOwnProperty("ts"))
        object.ts = $root.google.protobuf.Timestamp.toObject(message.ts, options);
      return object;
    };
    PEBasket.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    PEBasket.Basket = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "HOSE"] = 1;
      return values;
    }();
    return PEBasket;
  }();
  sense2.MarketMentality = function() {
    function MarketMentality(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MarketMentality.prototype.score = 0;
    MarketMentality.prototype.tradingDate = null;
    MarketMentality.prototype.ts = null;
    MarketMentality.create = function create(properties) {
      return new MarketMentality(properties);
    };
    MarketMentality.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.score != null && Object.hasOwnProperty.call(message, "score"))
        writer.uint32(8).int32(message.score);
      if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
        $root.google.protobuf.Timestamp.encode(message.tradingDate, writer.uint32(18).fork()).ldelim();
      if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
        $root.google.protobuf.Timestamp.encode(message.ts, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    MarketMentality.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MarketMentality.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.sense.MarketMentality();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.score = reader.int32();
            break;
          case 2:
            message.tradingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 3:
            message.ts = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MarketMentality.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MarketMentality.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.score != null && message.hasOwnProperty("score")) {
        if (!$util.isInteger(message.score))
          return "score: integer expected";
      }
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.tradingDate);
        if (error)
          return "tradingDate." + error;
      }
      if (message.ts != null && message.hasOwnProperty("ts")) {
        let error = $root.google.protobuf.Timestamp.verify(message.ts);
        if (error)
          return "ts." + error;
      }
      return null;
    };
    MarketMentality.fromObject = function fromObject(object) {
      if (object instanceof $root.sense.MarketMentality)
        return object;
      let message = new $root.sense.MarketMentality();
      if (object.score != null)
        message.score = object.score | 0;
      if (object.tradingDate != null) {
        if (typeof object.tradingDate !== "object")
          throw TypeError(".sense.MarketMentality.tradingDate: object expected");
        message.tradingDate = $root.google.protobuf.Timestamp.fromObject(object.tradingDate);
      }
      if (object.ts != null) {
        if (typeof object.ts !== "object")
          throw TypeError(".sense.MarketMentality.ts: object expected");
        message.ts = $root.google.protobuf.Timestamp.fromObject(object.ts);
      }
      return message;
    };
    MarketMentality.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.score = 0;
        object.tradingDate = null;
        object.ts = null;
      }
      if (message.score != null && message.hasOwnProperty("score"))
        object.score = message.score;
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
        object.tradingDate = $root.google.protobuf.Timestamp.toObject(message.tradingDate, options);
      if (message.ts != null && message.hasOwnProperty("ts"))
        object.ts = $root.google.protobuf.Timestamp.toObject(message.ts, options);
      return object;
    };
    MarketMentality.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MarketMentality;
  }();
  return sense2;
})();
$root.SmartOrder = (() => {
  function SmartOrder2(properties) {
    if (properties) {
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null)
          this[keys[i]] = properties[keys[i]];
    }
  }
  SmartOrder2.prototype.id = 0;
  SmartOrder2.prototype.externalId = 0;
  SmartOrder2.prototype.investorId = 0;
  SmartOrder2.prototype.investorAccountId = 0;
  SmartOrder2.prototype.createdDate = null;
  SmartOrder2.prototype.modifiedDate = null;
  SmartOrder2.prototype.symbol = "";
  SmartOrder2.prototype.targetPrice = 0;
  SmartOrder2.prototype.targetQuantity = 0;
  SmartOrder2.prototype.targetSide = 0;
  SmartOrder2.prototype.expiredTime = null;
  SmartOrder2.prototype.errorCode = "";
  SmartOrder2.prototype.errorMessage = "";
  SmartOrder2.prototype.status = 0;
  SmartOrder2.prototype.type = "";
  SmartOrder2.prototype.condition = "";
  SmartOrder2.prototype.conditionDesc = "";
  SmartOrder2.create = function create(properties) {
    return new SmartOrder2(properties);
  };
  SmartOrder2.encode = function encode(message, writer) {
    if (!writer)
      writer = $Writer.create();
    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
      writer.uint32(8).int32(message.id);
    if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
      writer.uint32(16).int32(message.externalId);
    if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
      writer.uint32(24).int32(message.investorId);
    if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
      writer.uint32(32).int32(message.investorAccountId);
    if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
      $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(42).fork()).ldelim();
    if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
      $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(50).fork()).ldelim();
    if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
      writer.uint32(58).string(message.symbol);
    if (message.targetPrice != null && Object.hasOwnProperty.call(message, "targetPrice"))
      writer.uint32(65).double(message.targetPrice);
    if (message.targetQuantity != null && Object.hasOwnProperty.call(message, "targetQuantity"))
      writer.uint32(72).int32(message.targetQuantity);
    if (message.targetSide != null && Object.hasOwnProperty.call(message, "targetSide"))
      writer.uint32(80).int32(message.targetSide);
    if (message.expiredTime != null && Object.hasOwnProperty.call(message, "expiredTime"))
      $root.google.protobuf.Timestamp.encode(message.expiredTime, writer.uint32(90).fork()).ldelim();
    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
      writer.uint32(98).string(message.errorCode);
    if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
      writer.uint32(106).string(message.errorMessage);
    if (message.status != null && Object.hasOwnProperty.call(message, "status"))
      writer.uint32(112).int32(message.status);
    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
      writer.uint32(122).string(message.type);
    if (message.condition != null && Object.hasOwnProperty.call(message, "condition"))
      writer.uint32(130).string(message.condition);
    if (message.conditionDesc != null && Object.hasOwnProperty.call(message, "conditionDesc"))
      writer.uint32(138).string(message.conditionDesc);
    return writer;
  };
  SmartOrder2.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };
  SmartOrder2.decode = function decode(reader, length) {
    if (!(reader instanceof $Reader))
      reader = $Reader.create(reader);
    let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.SmartOrder();
    while (reader.pos < end) {
      let tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.int32();
          break;
        case 2:
          message.externalId = reader.int32();
          break;
        case 3:
          message.investorId = reader.int32();
          break;
        case 4:
          message.investorAccountId = reader.int32();
          break;
        case 5:
          message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
          break;
        case 6:
          message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
          break;
        case 7:
          message.symbol = reader.string();
          break;
        case 8:
          message.targetPrice = reader.double();
          break;
        case 9:
          message.targetQuantity = reader.int32();
          break;
        case 10:
          message.targetSide = reader.int32();
          break;
        case 11:
          message.expiredTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
          break;
        case 12:
          message.errorCode = reader.string();
          break;
        case 13:
          message.errorMessage = reader.string();
          break;
        case 14:
          message.status = reader.int32();
          break;
        case 15:
          message.type = reader.string();
          break;
        case 16:
          message.condition = reader.string();
          break;
        case 17:
          message.conditionDesc = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };
  SmartOrder2.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader))
      reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };
  SmartOrder2.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.id != null && message.hasOwnProperty("id")) {
      if (!$util.isInteger(message.id))
        return "id: integer expected";
    }
    if (message.externalId != null && message.hasOwnProperty("externalId")) {
      if (!$util.isInteger(message.externalId))
        return "externalId: integer expected";
    }
    if (message.investorId != null && message.hasOwnProperty("investorId")) {
      if (!$util.isInteger(message.investorId))
        return "investorId: integer expected";
    }
    if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
      if (!$util.isInteger(message.investorAccountId))
        return "investorAccountId: integer expected";
    }
    if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
      let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
      if (error)
        return "createdDate." + error;
    }
    if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
      let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
      if (error)
        return "modifiedDate." + error;
    }
    if (message.symbol != null && message.hasOwnProperty("symbol")) {
      if (!$util.isString(message.symbol))
        return "symbol: string expected";
    }
    if (message.targetPrice != null && message.hasOwnProperty("targetPrice")) {
      if (typeof message.targetPrice !== "number")
        return "targetPrice: number expected";
    }
    if (message.targetQuantity != null && message.hasOwnProperty("targetQuantity")) {
      if (!$util.isInteger(message.targetQuantity))
        return "targetQuantity: integer expected";
    }
    if (message.targetSide != null && message.hasOwnProperty("targetSide"))
      switch (message.targetSide) {
        default:
          return "targetSide: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (message.expiredTime != null && message.hasOwnProperty("expiredTime")) {
      let error = $root.google.protobuf.Timestamp.verify(message.expiredTime);
      if (error)
        return "expiredTime." + error;
    }
    if (message.errorCode != null && message.hasOwnProperty("errorCode")) {
      if (!$util.isString(message.errorCode))
        return "errorCode: string expected";
    }
    if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
      if (!$util.isString(message.errorMessage))
        return "errorMessage: string expected";
    }
    if (message.status != null && message.hasOwnProperty("status"))
      switch (message.status) {
        default:
          return "status: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
      }
    if (message.type != null && message.hasOwnProperty("type")) {
      if (!$util.isString(message.type))
        return "type: string expected";
    }
    if (message.condition != null && message.hasOwnProperty("condition")) {
      if (!$util.isString(message.condition))
        return "condition: string expected";
    }
    if (message.conditionDesc != null && message.hasOwnProperty("conditionDesc")) {
      if (!$util.isString(message.conditionDesc))
        return "conditionDesc: string expected";
    }
    return null;
  };
  SmartOrder2.fromObject = function fromObject(object) {
    if (object instanceof $root.SmartOrder)
      return object;
    let message = new $root.SmartOrder();
    if (object.id != null)
      message.id = object.id | 0;
    if (object.externalId != null)
      message.externalId = object.externalId | 0;
    if (object.investorId != null)
      message.investorId = object.investorId | 0;
    if (object.investorAccountId != null)
      message.investorAccountId = object.investorAccountId | 0;
    if (object.createdDate != null) {
      if (typeof object.createdDate !== "object")
        throw TypeError(".SmartOrder.createdDate: object expected");
      message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
    }
    if (object.modifiedDate != null) {
      if (typeof object.modifiedDate !== "object")
        throw TypeError(".SmartOrder.modifiedDate: object expected");
      message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
    }
    if (object.symbol != null)
      message.symbol = String(object.symbol);
    if (object.targetPrice != null)
      message.targetPrice = Number(object.targetPrice);
    if (object.targetQuantity != null)
      message.targetQuantity = object.targetQuantity | 0;
    switch (object.targetSide) {
      case "UNKNOWN_SIDE":
      case 0:
        message.targetSide = 0;
        break;
      case "NB":
      case 1:
        message.targetSide = 1;
        break;
      case "NS":
      case 2:
        message.targetSide = 2;
        break;
    }
    if (object.expiredTime != null) {
      if (typeof object.expiredTime !== "object")
        throw TypeError(".SmartOrder.expiredTime: object expected");
      message.expiredTime = $root.google.protobuf.Timestamp.fromObject(object.expiredTime);
    }
    if (object.errorCode != null)
      message.errorCode = String(object.errorCode);
    if (object.errorMessage != null)
      message.errorMessage = String(object.errorMessage);
    switch (object.status) {
      case "UNKNOWN_STATUS":
      case 0:
        message.status = 0;
        break;
      case "PENDING_TRIGGER":
      case 1:
        message.status = 1;
        break;
      case "TRIGGERED":
      case 2:
        message.status = 2;
        break;
      case "EXPIRED":
      case 3:
        message.status = 3;
        break;
      case "CANCELED":
      case 4:
        message.status = 4;
        break;
      case "FAILED":
      case 5:
        message.status = 5;
        break;
    }
    if (object.type != null)
      message.type = String(object.type);
    if (object.condition != null)
      message.condition = String(object.condition);
    if (object.conditionDesc != null)
      message.conditionDesc = String(object.conditionDesc);
    return message;
  };
  SmartOrder2.toObject = function toObject(message, options) {
    if (!options)
      options = {};
    let object = {};
    if (options.defaults) {
      object.id = 0;
      object.externalId = 0;
      object.investorId = 0;
      object.investorAccountId = 0;
      object.createdDate = null;
      object.modifiedDate = null;
      object.symbol = "";
      object.targetPrice = 0;
      object.targetQuantity = 0;
      object.targetSide = options.enums === String ? "UNKNOWN_SIDE" : 0;
      object.expiredTime = null;
      object.errorCode = "";
      object.errorMessage = "";
      object.status = options.enums === String ? "UNKNOWN_STATUS" : 0;
      object.type = "";
      object.condition = "";
      object.conditionDesc = "";
    }
    if (message.id != null && message.hasOwnProperty("id"))
      object.id = message.id;
    if (message.externalId != null && message.hasOwnProperty("externalId"))
      object.externalId = message.externalId;
    if (message.investorId != null && message.hasOwnProperty("investorId"))
      object.investorId = message.investorId;
    if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
      object.investorAccountId = message.investorAccountId;
    if (message.createdDate != null && message.hasOwnProperty("createdDate"))
      object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
    if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
      object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
    if (message.symbol != null && message.hasOwnProperty("symbol"))
      object.symbol = message.symbol;
    if (message.targetPrice != null && message.hasOwnProperty("targetPrice"))
      object.targetPrice = options.json && !isFinite(message.targetPrice) ? String(message.targetPrice) : message.targetPrice;
    if (message.targetQuantity != null && message.hasOwnProperty("targetQuantity"))
      object.targetQuantity = message.targetQuantity;
    if (message.targetSide != null && message.hasOwnProperty("targetSide"))
      object.targetSide = options.enums === String ? $root.SmartOrder.Side[message.targetSide] : message.targetSide;
    if (message.expiredTime != null && message.hasOwnProperty("expiredTime"))
      object.expiredTime = $root.google.protobuf.Timestamp.toObject(message.expiredTime, options);
    if (message.errorCode != null && message.hasOwnProperty("errorCode"))
      object.errorCode = message.errorCode;
    if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
      object.errorMessage = message.errorMessage;
    if (message.status != null && message.hasOwnProperty("status"))
      object.status = options.enums === String ? $root.SmartOrder.Status[message.status] : message.status;
    if (message.type != null && message.hasOwnProperty("type"))
      object.type = message.type;
    if (message.condition != null && message.hasOwnProperty("condition"))
      object.condition = message.condition;
    if (message.conditionDesc != null && message.hasOwnProperty("conditionDesc"))
      object.conditionDesc = message.conditionDesc;
    return object;
  };
  SmartOrder2.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };
  SmartOrder2.Status = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_STATUS"] = 0;
    values[valuesById[1] = "PENDING_TRIGGER"] = 1;
    values[valuesById[2] = "TRIGGERED"] = 2;
    values[valuesById[3] = "EXPIRED"] = 3;
    values[valuesById[4] = "CANCELED"] = 4;
    values[valuesById[5] = "FAILED"] = 5;
    return values;
  }();
  SmartOrder2.Side = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_SIDE"] = 0;
    values[valuesById[1] = "NB"] = 1;
    values[valuesById[2] = "NS"] = 2;
    return values;
  }();
  return SmartOrder2;
})();
$root.hsx = (() => {
  const hsx2 = {};
  hsx2.SS = function() {
    function SS(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SS.prototype.msgType = "";
    SS.prototype.securityNumber = 0;
    SS.prototype.filler1 = 0;
    SS.prototype.sectorNumber = 0;
    SS.prototype.filler2 = 0;
    SS.prototype.haltResumeFlag = "";
    SS.prototype.systemControlCode = "";
    SS.prototype.filler3 = 0;
    SS.prototype.suspension = "";
    SS.prototype.delist = "";
    SS.prototype.filler4 = 0;
    SS.prototype.ceiling = 0;
    SS.prototype.floorPrice = 0;
    SS.prototype.securityType = "";
    SS.prototype.priorClosePrice = 0;
    SS.prototype.filler5 = 0;
    SS.prototype.split = "";
    SS.prototype.benefit = "";
    SS.prototype.meeting = "";
    SS.prototype.notice = "";
    SS.prototype.boardLot = 0;
    SS.prototype.filler6 = 0;
    SS.prototype.underlyingSymbol = "";
    SS.prototype.issuerName = "";
    SS.prototype.coveredWarrantType = "";
    SS.prototype.maturityDate = "";
    SS.prototype.lastTradingDateRaw = "";
    SS.prototype.exercisePrice = 0;
    SS.prototype.exerciseRatio = "";
    SS.prototype.listedShare = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SS.prototype.oddLotHaltResumeFlag = "";
    SS.create = function create(properties) {
      return new SS(properties);
    };
    SS.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
        writer.uint32(10).string(message.msgType);
      if (message.securityNumber != null && Object.hasOwnProperty.call(message, "securityNumber"))
        writer.uint32(16).uint32(message.securityNumber);
      if (message.filler1 != null && Object.hasOwnProperty.call(message, "filler1"))
        writer.uint32(24).uint32(message.filler1);
      if (message.sectorNumber != null && Object.hasOwnProperty.call(message, "sectorNumber"))
        writer.uint32(32).uint32(message.sectorNumber);
      if (message.filler2 != null && Object.hasOwnProperty.call(message, "filler2"))
        writer.uint32(40).uint32(message.filler2);
      if (message.haltResumeFlag != null && Object.hasOwnProperty.call(message, "haltResumeFlag"))
        writer.uint32(50).string(message.haltResumeFlag);
      if (message.systemControlCode != null && Object.hasOwnProperty.call(message, "systemControlCode"))
        writer.uint32(58).string(message.systemControlCode);
      if (message.filler3 != null && Object.hasOwnProperty.call(message, "filler3"))
        writer.uint32(64).uint32(message.filler3);
      if (message.suspension != null && Object.hasOwnProperty.call(message, "suspension"))
        writer.uint32(74).string(message.suspension);
      if (message.delist != null && Object.hasOwnProperty.call(message, "delist"))
        writer.uint32(82).string(message.delist);
      if (message.filler4 != null && Object.hasOwnProperty.call(message, "filler4"))
        writer.uint32(88).uint32(message.filler4);
      if (message.ceiling != null && Object.hasOwnProperty.call(message, "ceiling"))
        writer.uint32(96).uint32(message.ceiling);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(104).uint32(message.floorPrice);
      if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
        writer.uint32(114).string(message.securityType);
      if (message.priorClosePrice != null && Object.hasOwnProperty.call(message, "priorClosePrice"))
        writer.uint32(120).uint32(message.priorClosePrice);
      if (message.filler5 != null && Object.hasOwnProperty.call(message, "filler5"))
        writer.uint32(128).uint32(message.filler5);
      if (message.split != null && Object.hasOwnProperty.call(message, "split"))
        writer.uint32(138).string(message.split);
      if (message.benefit != null && Object.hasOwnProperty.call(message, "benefit"))
        writer.uint32(146).string(message.benefit);
      if (message.meeting != null && Object.hasOwnProperty.call(message, "meeting"))
        writer.uint32(154).string(message.meeting);
      if (message.notice != null && Object.hasOwnProperty.call(message, "notice"))
        writer.uint32(162).string(message.notice);
      if (message.boardLot != null && Object.hasOwnProperty.call(message, "boardLot"))
        writer.uint32(168).uint32(message.boardLot);
      if (message.filler6 != null && Object.hasOwnProperty.call(message, "filler6"))
        writer.uint32(176).uint32(message.filler6);
      if (message.underlyingSymbol != null && Object.hasOwnProperty.call(message, "underlyingSymbol"))
        writer.uint32(186).string(message.underlyingSymbol);
      if (message.issuerName != null && Object.hasOwnProperty.call(message, "issuerName"))
        writer.uint32(194).string(message.issuerName);
      if (message.coveredWarrantType != null && Object.hasOwnProperty.call(message, "coveredWarrantType"))
        writer.uint32(202).string(message.coveredWarrantType);
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        writer.uint32(210).string(message.maturityDate);
      if (message.lastTradingDateRaw != null && Object.hasOwnProperty.call(message, "lastTradingDateRaw"))
        writer.uint32(218).string(message.lastTradingDateRaw);
      if (message.exercisePrice != null && Object.hasOwnProperty.call(message, "exercisePrice"))
        writer.uint32(224).uint32(message.exercisePrice);
      if (message.exerciseRatio != null && Object.hasOwnProperty.call(message, "exerciseRatio"))
        writer.uint32(234).string(message.exerciseRatio);
      if (message.listedShare != null && Object.hasOwnProperty.call(message, "listedShare"))
        writer.uint32(240).uint64(message.listedShare);
      if (message.oddLotHaltResumeFlag != null && Object.hasOwnProperty.call(message, "oddLotHaltResumeFlag"))
        writer.uint32(250).string(message.oddLotHaltResumeFlag);
      return writer;
    };
    SS.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SS.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.hsx.SS();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.msgType = reader.string();
            break;
          case 2:
            message.securityNumber = reader.uint32();
            break;
          case 3:
            message.filler1 = reader.uint32();
            break;
          case 4:
            message.sectorNumber = reader.uint32();
            break;
          case 5:
            message.filler2 = reader.uint32();
            break;
          case 6:
            message.haltResumeFlag = reader.string();
            break;
          case 7:
            message.systemControlCode = reader.string();
            break;
          case 8:
            message.filler3 = reader.uint32();
            break;
          case 9:
            message.suspension = reader.string();
            break;
          case 10:
            message.delist = reader.string();
            break;
          case 11:
            message.filler4 = reader.uint32();
            break;
          case 12:
            message.ceiling = reader.uint32();
            break;
          case 13:
            message.floorPrice = reader.uint32();
            break;
          case 14:
            message.securityType = reader.string();
            break;
          case 15:
            message.priorClosePrice = reader.uint32();
            break;
          case 16:
            message.filler5 = reader.uint32();
            break;
          case 17:
            message.split = reader.string();
            break;
          case 18:
            message.benefit = reader.string();
            break;
          case 19:
            message.meeting = reader.string();
            break;
          case 20:
            message.notice = reader.string();
            break;
          case 21:
            message.boardLot = reader.uint32();
            break;
          case 22:
            message.filler6 = reader.uint32();
            break;
          case 23:
            message.underlyingSymbol = reader.string();
            break;
          case 24:
            message.issuerName = reader.string();
            break;
          case 25:
            message.coveredWarrantType = reader.string();
            break;
          case 26:
            message.maturityDate = reader.string();
            break;
          case 27:
            message.lastTradingDateRaw = reader.string();
            break;
          case 28:
            message.exercisePrice = reader.uint32();
            break;
          case 29:
            message.exerciseRatio = reader.string();
            break;
          case 30:
            message.listedShare = reader.uint64();
            break;
          case 31:
            message.oddLotHaltResumeFlag = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SS.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SS.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.msgType != null && message.hasOwnProperty("msgType")) {
        if (!$util.isString(message.msgType))
          return "msgType: string expected";
      }
      if (message.securityNumber != null && message.hasOwnProperty("securityNumber")) {
        if (!$util.isInteger(message.securityNumber))
          return "securityNumber: integer expected";
      }
      if (message.filler1 != null && message.hasOwnProperty("filler1")) {
        if (!$util.isInteger(message.filler1))
          return "filler1: integer expected";
      }
      if (message.sectorNumber != null && message.hasOwnProperty("sectorNumber")) {
        if (!$util.isInteger(message.sectorNumber))
          return "sectorNumber: integer expected";
      }
      if (message.filler2 != null && message.hasOwnProperty("filler2")) {
        if (!$util.isInteger(message.filler2))
          return "filler2: integer expected";
      }
      if (message.haltResumeFlag != null && message.hasOwnProperty("haltResumeFlag")) {
        if (!$util.isString(message.haltResumeFlag))
          return "haltResumeFlag: string expected";
      }
      if (message.systemControlCode != null && message.hasOwnProperty("systemControlCode")) {
        if (!$util.isString(message.systemControlCode))
          return "systemControlCode: string expected";
      }
      if (message.filler3 != null && message.hasOwnProperty("filler3")) {
        if (!$util.isInteger(message.filler3))
          return "filler3: integer expected";
      }
      if (message.suspension != null && message.hasOwnProperty("suspension")) {
        if (!$util.isString(message.suspension))
          return "suspension: string expected";
      }
      if (message.delist != null && message.hasOwnProperty("delist")) {
        if (!$util.isString(message.delist))
          return "delist: string expected";
      }
      if (message.filler4 != null && message.hasOwnProperty("filler4")) {
        if (!$util.isInteger(message.filler4))
          return "filler4: integer expected";
      }
      if (message.ceiling != null && message.hasOwnProperty("ceiling")) {
        if (!$util.isInteger(message.ceiling))
          return "ceiling: integer expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (!$util.isInteger(message.floorPrice))
          return "floorPrice: integer expected";
      }
      if (message.securityType != null && message.hasOwnProperty("securityType")) {
        if (!$util.isString(message.securityType))
          return "securityType: string expected";
      }
      if (message.priorClosePrice != null && message.hasOwnProperty("priorClosePrice")) {
        if (!$util.isInteger(message.priorClosePrice))
          return "priorClosePrice: integer expected";
      }
      if (message.filler5 != null && message.hasOwnProperty("filler5")) {
        if (!$util.isInteger(message.filler5))
          return "filler5: integer expected";
      }
      if (message.split != null && message.hasOwnProperty("split")) {
        if (!$util.isString(message.split))
          return "split: string expected";
      }
      if (message.benefit != null && message.hasOwnProperty("benefit")) {
        if (!$util.isString(message.benefit))
          return "benefit: string expected";
      }
      if (message.meeting != null && message.hasOwnProperty("meeting")) {
        if (!$util.isString(message.meeting))
          return "meeting: string expected";
      }
      if (message.notice != null && message.hasOwnProperty("notice")) {
        if (!$util.isString(message.notice))
          return "notice: string expected";
      }
      if (message.boardLot != null && message.hasOwnProperty("boardLot")) {
        if (!$util.isInteger(message.boardLot))
          return "boardLot: integer expected";
      }
      if (message.filler6 != null && message.hasOwnProperty("filler6")) {
        if (!$util.isInteger(message.filler6))
          return "filler6: integer expected";
      }
      if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol")) {
        if (!$util.isString(message.underlyingSymbol))
          return "underlyingSymbol: string expected";
      }
      if (message.issuerName != null && message.hasOwnProperty("issuerName")) {
        if (!$util.isString(message.issuerName))
          return "issuerName: string expected";
      }
      if (message.coveredWarrantType != null && message.hasOwnProperty("coveredWarrantType")) {
        if (!$util.isString(message.coveredWarrantType))
          return "coveredWarrantType: string expected";
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        if (!$util.isString(message.maturityDate))
          return "maturityDate: string expected";
      }
      if (message.lastTradingDateRaw != null && message.hasOwnProperty("lastTradingDateRaw")) {
        if (!$util.isString(message.lastTradingDateRaw))
          return "lastTradingDateRaw: string expected";
      }
      if (message.exercisePrice != null && message.hasOwnProperty("exercisePrice")) {
        if (!$util.isInteger(message.exercisePrice))
          return "exercisePrice: integer expected";
      }
      if (message.exerciseRatio != null && message.hasOwnProperty("exerciseRatio")) {
        if (!$util.isString(message.exerciseRatio))
          return "exerciseRatio: string expected";
      }
      if (message.listedShare != null && message.hasOwnProperty("listedShare")) {
        if (!$util.isInteger(message.listedShare) && !(message.listedShare && $util.isInteger(message.listedShare.low) && $util.isInteger(message.listedShare.high)))
          return "listedShare: integer|Long expected";
      }
      if (message.oddLotHaltResumeFlag != null && message.hasOwnProperty("oddLotHaltResumeFlag")) {
        if (!$util.isString(message.oddLotHaltResumeFlag))
          return "oddLotHaltResumeFlag: string expected";
      }
      return null;
    };
    SS.fromObject = function fromObject(object) {
      if (object instanceof $root.hsx.SS)
        return object;
      let message = new $root.hsx.SS();
      if (object.msgType != null)
        message.msgType = String(object.msgType);
      if (object.securityNumber != null)
        message.securityNumber = object.securityNumber >>> 0;
      if (object.filler1 != null)
        message.filler1 = object.filler1 >>> 0;
      if (object.sectorNumber != null)
        message.sectorNumber = object.sectorNumber >>> 0;
      if (object.filler2 != null)
        message.filler2 = object.filler2 >>> 0;
      if (object.haltResumeFlag != null)
        message.haltResumeFlag = String(object.haltResumeFlag);
      if (object.systemControlCode != null)
        message.systemControlCode = String(object.systemControlCode);
      if (object.filler3 != null)
        message.filler3 = object.filler3 >>> 0;
      if (object.suspension != null)
        message.suspension = String(object.suspension);
      if (object.delist != null)
        message.delist = String(object.delist);
      if (object.filler4 != null)
        message.filler4 = object.filler4 >>> 0;
      if (object.ceiling != null)
        message.ceiling = object.ceiling >>> 0;
      if (object.floorPrice != null)
        message.floorPrice = object.floorPrice >>> 0;
      if (object.securityType != null)
        message.securityType = String(object.securityType);
      if (object.priorClosePrice != null)
        message.priorClosePrice = object.priorClosePrice >>> 0;
      if (object.filler5 != null)
        message.filler5 = object.filler5 >>> 0;
      if (object.split != null)
        message.split = String(object.split);
      if (object.benefit != null)
        message.benefit = String(object.benefit);
      if (object.meeting != null)
        message.meeting = String(object.meeting);
      if (object.notice != null)
        message.notice = String(object.notice);
      if (object.boardLot != null)
        message.boardLot = object.boardLot >>> 0;
      if (object.filler6 != null)
        message.filler6 = object.filler6 >>> 0;
      if (object.underlyingSymbol != null)
        message.underlyingSymbol = String(object.underlyingSymbol);
      if (object.issuerName != null)
        message.issuerName = String(object.issuerName);
      if (object.coveredWarrantType != null)
        message.coveredWarrantType = String(object.coveredWarrantType);
      if (object.maturityDate != null)
        message.maturityDate = String(object.maturityDate);
      if (object.lastTradingDateRaw != null)
        message.lastTradingDateRaw = String(object.lastTradingDateRaw);
      if (object.exercisePrice != null)
        message.exercisePrice = object.exercisePrice >>> 0;
      if (object.exerciseRatio != null)
        message.exerciseRatio = String(object.exerciseRatio);
      if (object.listedShare != null) {
        if ($util.Long)
          (message.listedShare = $util.Long.fromValue(object.listedShare)).unsigned = true;
        else if (typeof object.listedShare === "string")
          message.listedShare = parseInt(object.listedShare, 10);
        else if (typeof object.listedShare === "number")
          message.listedShare = object.listedShare;
        else if (typeof object.listedShare === "object")
          message.listedShare = new $util.LongBits(object.listedShare.low >>> 0, object.listedShare.high >>> 0).toNumber(true);
      }
      if (object.oddLotHaltResumeFlag != null)
        message.oddLotHaltResumeFlag = String(object.oddLotHaltResumeFlag);
      return message;
    };
    SS.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.msgType = "";
        object.securityNumber = 0;
        object.filler1 = 0;
        object.sectorNumber = 0;
        object.filler2 = 0;
        object.haltResumeFlag = "";
        object.systemControlCode = "";
        object.filler3 = 0;
        object.suspension = "";
        object.delist = "";
        object.filler4 = 0;
        object.ceiling = 0;
        object.floorPrice = 0;
        object.securityType = "";
        object.priorClosePrice = 0;
        object.filler5 = 0;
        object.split = "";
        object.benefit = "";
        object.meeting = "";
        object.notice = "";
        object.boardLot = 0;
        object.filler6 = 0;
        object.underlyingSymbol = "";
        object.issuerName = "";
        object.coveredWarrantType = "";
        object.maturityDate = "";
        object.lastTradingDateRaw = "";
        object.exercisePrice = 0;
        object.exerciseRatio = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.listedShare = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.listedShare = options.longs === String ? "0" : 0;
        object.oddLotHaltResumeFlag = "";
      }
      if (message.msgType != null && message.hasOwnProperty("msgType"))
        object.msgType = message.msgType;
      if (message.securityNumber != null && message.hasOwnProperty("securityNumber"))
        object.securityNumber = message.securityNumber;
      if (message.filler1 != null && message.hasOwnProperty("filler1"))
        object.filler1 = message.filler1;
      if (message.sectorNumber != null && message.hasOwnProperty("sectorNumber"))
        object.sectorNumber = message.sectorNumber;
      if (message.filler2 != null && message.hasOwnProperty("filler2"))
        object.filler2 = message.filler2;
      if (message.haltResumeFlag != null && message.hasOwnProperty("haltResumeFlag"))
        object.haltResumeFlag = message.haltResumeFlag;
      if (message.systemControlCode != null && message.hasOwnProperty("systemControlCode"))
        object.systemControlCode = message.systemControlCode;
      if (message.filler3 != null && message.hasOwnProperty("filler3"))
        object.filler3 = message.filler3;
      if (message.suspension != null && message.hasOwnProperty("suspension"))
        object.suspension = message.suspension;
      if (message.delist != null && message.hasOwnProperty("delist"))
        object.delist = message.delist;
      if (message.filler4 != null && message.hasOwnProperty("filler4"))
        object.filler4 = message.filler4;
      if (message.ceiling != null && message.hasOwnProperty("ceiling"))
        object.ceiling = message.ceiling;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = message.floorPrice;
      if (message.securityType != null && message.hasOwnProperty("securityType"))
        object.securityType = message.securityType;
      if (message.priorClosePrice != null && message.hasOwnProperty("priorClosePrice"))
        object.priorClosePrice = message.priorClosePrice;
      if (message.filler5 != null && message.hasOwnProperty("filler5"))
        object.filler5 = message.filler5;
      if (message.split != null && message.hasOwnProperty("split"))
        object.split = message.split;
      if (message.benefit != null && message.hasOwnProperty("benefit"))
        object.benefit = message.benefit;
      if (message.meeting != null && message.hasOwnProperty("meeting"))
        object.meeting = message.meeting;
      if (message.notice != null && message.hasOwnProperty("notice"))
        object.notice = message.notice;
      if (message.boardLot != null && message.hasOwnProperty("boardLot"))
        object.boardLot = message.boardLot;
      if (message.filler6 != null && message.hasOwnProperty("filler6"))
        object.filler6 = message.filler6;
      if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol"))
        object.underlyingSymbol = message.underlyingSymbol;
      if (message.issuerName != null && message.hasOwnProperty("issuerName"))
        object.issuerName = message.issuerName;
      if (message.coveredWarrantType != null && message.hasOwnProperty("coveredWarrantType"))
        object.coveredWarrantType = message.coveredWarrantType;
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = message.maturityDate;
      if (message.lastTradingDateRaw != null && message.hasOwnProperty("lastTradingDateRaw"))
        object.lastTradingDateRaw = message.lastTradingDateRaw;
      if (message.exercisePrice != null && message.hasOwnProperty("exercisePrice"))
        object.exercisePrice = message.exercisePrice;
      if (message.exerciseRatio != null && message.hasOwnProperty("exerciseRatio"))
        object.exerciseRatio = message.exerciseRatio;
      if (message.listedShare != null && message.hasOwnProperty("listedShare"))
        if (typeof message.listedShare === "number")
          object.listedShare = options.longs === String ? String(message.listedShare) : message.listedShare;
        else
          object.listedShare = options.longs === String ? $util.Long.prototype.toString.call(message.listedShare) : options.longs === Number ? new $util.LongBits(message.listedShare.low >>> 0, message.listedShare.high >>> 0).toNumber(true) : message.listedShare;
      if (message.oddLotHaltResumeFlag != null && message.hasOwnProperty("oddLotHaltResumeFlag"))
        object.oddLotHaltResumeFlag = message.oddLotHaltResumeFlag;
      return object;
    };
    SS.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SS;
  }();
  hsx2.SU = function() {
    function SU(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SU.prototype.messageType = "";
    SU.prototype.securityNumberNew = 0;
    SU.prototype.securityNumberOld = 0;
    SU.prototype.filler1 = 0;
    SU.prototype.sectorNumber = 0;
    SU.prototype.filler2 = 0;
    SU.prototype.securitySymbol = "";
    SU.prototype.securityType = "";
    SU.prototype.ceilingPrice = 0;
    SU.prototype.floorPrice = 0;
    SU.prototype.lastSalePrice = 0;
    SU.prototype.marketID = "";
    SU.prototype.filler3 = 0;
    SU.prototype.securityName = "";
    SU.prototype.filler4 = 0;
    SU.prototype.suspension = "";
    SU.prototype.delist = "";
    SU.prototype.haltResumeFlag = "";
    SU.prototype.split = "";
    SU.prototype.benefit = "";
    SU.prototype.meeting = "";
    SU.prototype.notice = "";
    SU.prototype.clientIDRequired = "";
    SU.prototype.parValue = 0;
    SU.prototype.sdcFlag = "";
    SU.prototype.priorClosePrice = 0;
    SU.prototype.priorCloseDate = "";
    SU.prototype.openPrice = 0;
    SU.prototype.highestPrice = 0;
    SU.prototype.lowestPrice = 0;
    SU.prototype.totalSharesTraded = 0;
    SU.prototype.totalValuesTraded = 0;
    SU.prototype.boardLot = 0;
    SU.prototype.filler5 = 0;
    SU.prototype.underlyingSymbol = "";
    SU.prototype.issuerName = "";
    SU.prototype.coveredWarrantType = "";
    SU.prototype.maturityDate = "";
    SU.prototype.lastTradingDate = "";
    SU.prototype.exercisePrice = 0;
    SU.prototype.exerciseRatio = "";
    SU.prototype.listedShare = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SU.prototype.oddLotHaltResumeFlag = "";
    SU.create = function create(properties) {
      return new SU(properties);
    };
    SU.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
        writer.uint32(10).string(message.messageType);
      if (message.securityNumberNew != null && Object.hasOwnProperty.call(message, "securityNumberNew"))
        writer.uint32(16).uint32(message.securityNumberNew);
      if (message.securityNumberOld != null && Object.hasOwnProperty.call(message, "securityNumberOld"))
        writer.uint32(24).uint32(message.securityNumberOld);
      if (message.filler1 != null && Object.hasOwnProperty.call(message, "filler1"))
        writer.uint32(32).uint32(message.filler1);
      if (message.sectorNumber != null && Object.hasOwnProperty.call(message, "sectorNumber"))
        writer.uint32(40).uint32(message.sectorNumber);
      if (message.filler2 != null && Object.hasOwnProperty.call(message, "filler2"))
        writer.uint32(48).uint32(message.filler2);
      if (message.securitySymbol != null && Object.hasOwnProperty.call(message, "securitySymbol"))
        writer.uint32(58).string(message.securitySymbol);
      if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
        writer.uint32(66).string(message.securityType);
      if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
        writer.uint32(72).uint32(message.ceilingPrice);
      if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
        writer.uint32(80).uint32(message.floorPrice);
      if (message.lastSalePrice != null && Object.hasOwnProperty.call(message, "lastSalePrice"))
        writer.uint32(88).uint32(message.lastSalePrice);
      if (message.marketID != null && Object.hasOwnProperty.call(message, "marketID"))
        writer.uint32(98).string(message.marketID);
      if (message.filler3 != null && Object.hasOwnProperty.call(message, "filler3"))
        writer.uint32(104).uint32(message.filler3);
      if (message.securityName != null && Object.hasOwnProperty.call(message, "securityName"))
        writer.uint32(114).string(message.securityName);
      if (message.filler4 != null && Object.hasOwnProperty.call(message, "filler4"))
        writer.uint32(120).uint32(message.filler4);
      if (message.suspension != null && Object.hasOwnProperty.call(message, "suspension"))
        writer.uint32(130).string(message.suspension);
      if (message.delist != null && Object.hasOwnProperty.call(message, "delist"))
        writer.uint32(138).string(message.delist);
      if (message.haltResumeFlag != null && Object.hasOwnProperty.call(message, "haltResumeFlag"))
        writer.uint32(146).string(message.haltResumeFlag);
      if (message.split != null && Object.hasOwnProperty.call(message, "split"))
        writer.uint32(154).string(message.split);
      if (message.benefit != null && Object.hasOwnProperty.call(message, "benefit"))
        writer.uint32(162).string(message.benefit);
      if (message.meeting != null && Object.hasOwnProperty.call(message, "meeting"))
        writer.uint32(170).string(message.meeting);
      if (message.notice != null && Object.hasOwnProperty.call(message, "notice"))
        writer.uint32(178).string(message.notice);
      if (message.clientIDRequired != null && Object.hasOwnProperty.call(message, "clientIDRequired"))
        writer.uint32(186).string(message.clientIDRequired);
      if (message.parValue != null && Object.hasOwnProperty.call(message, "parValue"))
        writer.uint32(192).uint32(message.parValue);
      if (message.sdcFlag != null && Object.hasOwnProperty.call(message, "sdcFlag"))
        writer.uint32(202).string(message.sdcFlag);
      if (message.priorClosePrice != null && Object.hasOwnProperty.call(message, "priorClosePrice"))
        writer.uint32(208).uint32(message.priorClosePrice);
      if (message.priorCloseDate != null && Object.hasOwnProperty.call(message, "priorCloseDate"))
        writer.uint32(218).string(message.priorCloseDate);
      if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
        writer.uint32(224).uint32(message.openPrice);
      if (message.highestPrice != null && Object.hasOwnProperty.call(message, "highestPrice"))
        writer.uint32(232).uint32(message.highestPrice);
      if (message.lowestPrice != null && Object.hasOwnProperty.call(message, "lowestPrice"))
        writer.uint32(240).uint32(message.lowestPrice);
      if (message.totalSharesTraded != null && Object.hasOwnProperty.call(message, "totalSharesTraded"))
        writer.uint32(248).uint32(message.totalSharesTraded);
      if (message.totalValuesTraded != null && Object.hasOwnProperty.call(message, "totalValuesTraded"))
        writer.uint32(256).uint32(message.totalValuesTraded);
      if (message.boardLot != null && Object.hasOwnProperty.call(message, "boardLot"))
        writer.uint32(264).uint32(message.boardLot);
      if (message.filler5 != null && Object.hasOwnProperty.call(message, "filler5"))
        writer.uint32(272).uint32(message.filler5);
      if (message.underlyingSymbol != null && Object.hasOwnProperty.call(message, "underlyingSymbol"))
        writer.uint32(282).string(message.underlyingSymbol);
      if (message.issuerName != null && Object.hasOwnProperty.call(message, "issuerName"))
        writer.uint32(290).string(message.issuerName);
      if (message.coveredWarrantType != null && Object.hasOwnProperty.call(message, "coveredWarrantType"))
        writer.uint32(298).string(message.coveredWarrantType);
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        writer.uint32(306).string(message.maturityDate);
      if (message.lastTradingDate != null && Object.hasOwnProperty.call(message, "lastTradingDate"))
        writer.uint32(314).string(message.lastTradingDate);
      if (message.exercisePrice != null && Object.hasOwnProperty.call(message, "exercisePrice"))
        writer.uint32(320).uint32(message.exercisePrice);
      if (message.exerciseRatio != null && Object.hasOwnProperty.call(message, "exerciseRatio"))
        writer.uint32(330).string(message.exerciseRatio);
      if (message.listedShare != null && Object.hasOwnProperty.call(message, "listedShare"))
        writer.uint32(336).uint64(message.listedShare);
      if (message.oddLotHaltResumeFlag != null && Object.hasOwnProperty.call(message, "oddLotHaltResumeFlag"))
        writer.uint32(346).string(message.oddLotHaltResumeFlag);
      return writer;
    };
    SU.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SU.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.hsx.SU();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.messageType = reader.string();
            break;
          case 2:
            message.securityNumberNew = reader.uint32();
            break;
          case 3:
            message.securityNumberOld = reader.uint32();
            break;
          case 4:
            message.filler1 = reader.uint32();
            break;
          case 5:
            message.sectorNumber = reader.uint32();
            break;
          case 6:
            message.filler2 = reader.uint32();
            break;
          case 7:
            message.securitySymbol = reader.string();
            break;
          case 8:
            message.securityType = reader.string();
            break;
          case 9:
            message.ceilingPrice = reader.uint32();
            break;
          case 10:
            message.floorPrice = reader.uint32();
            break;
          case 11:
            message.lastSalePrice = reader.uint32();
            break;
          case 12:
            message.marketID = reader.string();
            break;
          case 13:
            message.filler3 = reader.uint32();
            break;
          case 14:
            message.securityName = reader.string();
            break;
          case 15:
            message.filler4 = reader.uint32();
            break;
          case 16:
            message.suspension = reader.string();
            break;
          case 17:
            message.delist = reader.string();
            break;
          case 18:
            message.haltResumeFlag = reader.string();
            break;
          case 19:
            message.split = reader.string();
            break;
          case 20:
            message.benefit = reader.string();
            break;
          case 21:
            message.meeting = reader.string();
            break;
          case 22:
            message.notice = reader.string();
            break;
          case 23:
            message.clientIDRequired = reader.string();
            break;
          case 24:
            message.parValue = reader.uint32();
            break;
          case 25:
            message.sdcFlag = reader.string();
            break;
          case 26:
            message.priorClosePrice = reader.uint32();
            break;
          case 27:
            message.priorCloseDate = reader.string();
            break;
          case 28:
            message.openPrice = reader.uint32();
            break;
          case 29:
            message.highestPrice = reader.uint32();
            break;
          case 30:
            message.lowestPrice = reader.uint32();
            break;
          case 31:
            message.totalSharesTraded = reader.uint32();
            break;
          case 32:
            message.totalValuesTraded = reader.uint32();
            break;
          case 33:
            message.boardLot = reader.uint32();
            break;
          case 34:
            message.filler5 = reader.uint32();
            break;
          case 35:
            message.underlyingSymbol = reader.string();
            break;
          case 36:
            message.issuerName = reader.string();
            break;
          case 37:
            message.coveredWarrantType = reader.string();
            break;
          case 38:
            message.maturityDate = reader.string();
            break;
          case 39:
            message.lastTradingDate = reader.string();
            break;
          case 40:
            message.exercisePrice = reader.uint32();
            break;
          case 41:
            message.exerciseRatio = reader.string();
            break;
          case 42:
            message.listedShare = reader.uint64();
            break;
          case 43:
            message.oddLotHaltResumeFlag = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SU.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SU.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.messageType != null && message.hasOwnProperty("messageType")) {
        if (!$util.isString(message.messageType))
          return "messageType: string expected";
      }
      if (message.securityNumberNew != null && message.hasOwnProperty("securityNumberNew")) {
        if (!$util.isInteger(message.securityNumberNew))
          return "securityNumberNew: integer expected";
      }
      if (message.securityNumberOld != null && message.hasOwnProperty("securityNumberOld")) {
        if (!$util.isInteger(message.securityNumberOld))
          return "securityNumberOld: integer expected";
      }
      if (message.filler1 != null && message.hasOwnProperty("filler1")) {
        if (!$util.isInteger(message.filler1))
          return "filler1: integer expected";
      }
      if (message.sectorNumber != null && message.hasOwnProperty("sectorNumber")) {
        if (!$util.isInteger(message.sectorNumber))
          return "sectorNumber: integer expected";
      }
      if (message.filler2 != null && message.hasOwnProperty("filler2")) {
        if (!$util.isInteger(message.filler2))
          return "filler2: integer expected";
      }
      if (message.securitySymbol != null && message.hasOwnProperty("securitySymbol")) {
        if (!$util.isString(message.securitySymbol))
          return "securitySymbol: string expected";
      }
      if (message.securityType != null && message.hasOwnProperty("securityType")) {
        if (!$util.isString(message.securityType))
          return "securityType: string expected";
      }
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
        if (!$util.isInteger(message.ceilingPrice))
          return "ceilingPrice: integer expected";
      }
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
        if (!$util.isInteger(message.floorPrice))
          return "floorPrice: integer expected";
      }
      if (message.lastSalePrice != null && message.hasOwnProperty("lastSalePrice")) {
        if (!$util.isInteger(message.lastSalePrice))
          return "lastSalePrice: integer expected";
      }
      if (message.marketID != null && message.hasOwnProperty("marketID")) {
        if (!$util.isString(message.marketID))
          return "marketID: string expected";
      }
      if (message.filler3 != null && message.hasOwnProperty("filler3")) {
        if (!$util.isInteger(message.filler3))
          return "filler3: integer expected";
      }
      if (message.securityName != null && message.hasOwnProperty("securityName")) {
        if (!$util.isString(message.securityName))
          return "securityName: string expected";
      }
      if (message.filler4 != null && message.hasOwnProperty("filler4")) {
        if (!$util.isInteger(message.filler4))
          return "filler4: integer expected";
      }
      if (message.suspension != null && message.hasOwnProperty("suspension")) {
        if (!$util.isString(message.suspension))
          return "suspension: string expected";
      }
      if (message.delist != null && message.hasOwnProperty("delist")) {
        if (!$util.isString(message.delist))
          return "delist: string expected";
      }
      if (message.haltResumeFlag != null && message.hasOwnProperty("haltResumeFlag")) {
        if (!$util.isString(message.haltResumeFlag))
          return "haltResumeFlag: string expected";
      }
      if (message.split != null && message.hasOwnProperty("split")) {
        if (!$util.isString(message.split))
          return "split: string expected";
      }
      if (message.benefit != null && message.hasOwnProperty("benefit")) {
        if (!$util.isString(message.benefit))
          return "benefit: string expected";
      }
      if (message.meeting != null && message.hasOwnProperty("meeting")) {
        if (!$util.isString(message.meeting))
          return "meeting: string expected";
      }
      if (message.notice != null && message.hasOwnProperty("notice")) {
        if (!$util.isString(message.notice))
          return "notice: string expected";
      }
      if (message.clientIDRequired != null && message.hasOwnProperty("clientIDRequired")) {
        if (!$util.isString(message.clientIDRequired))
          return "clientIDRequired: string expected";
      }
      if (message.parValue != null && message.hasOwnProperty("parValue")) {
        if (!$util.isInteger(message.parValue))
          return "parValue: integer expected";
      }
      if (message.sdcFlag != null && message.hasOwnProperty("sdcFlag")) {
        if (!$util.isString(message.sdcFlag))
          return "sdcFlag: string expected";
      }
      if (message.priorClosePrice != null && message.hasOwnProperty("priorClosePrice")) {
        if (!$util.isInteger(message.priorClosePrice))
          return "priorClosePrice: integer expected";
      }
      if (message.priorCloseDate != null && message.hasOwnProperty("priorCloseDate")) {
        if (!$util.isString(message.priorCloseDate))
          return "priorCloseDate: string expected";
      }
      if (message.openPrice != null && message.hasOwnProperty("openPrice")) {
        if (!$util.isInteger(message.openPrice))
          return "openPrice: integer expected";
      }
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice")) {
        if (!$util.isInteger(message.highestPrice))
          return "highestPrice: integer expected";
      }
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice")) {
        if (!$util.isInteger(message.lowestPrice))
          return "lowestPrice: integer expected";
      }
      if (message.totalSharesTraded != null && message.hasOwnProperty("totalSharesTraded")) {
        if (!$util.isInteger(message.totalSharesTraded))
          return "totalSharesTraded: integer expected";
      }
      if (message.totalValuesTraded != null && message.hasOwnProperty("totalValuesTraded")) {
        if (!$util.isInteger(message.totalValuesTraded))
          return "totalValuesTraded: integer expected";
      }
      if (message.boardLot != null && message.hasOwnProperty("boardLot")) {
        if (!$util.isInteger(message.boardLot))
          return "boardLot: integer expected";
      }
      if (message.filler5 != null && message.hasOwnProperty("filler5")) {
        if (!$util.isInteger(message.filler5))
          return "filler5: integer expected";
      }
      if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol")) {
        if (!$util.isString(message.underlyingSymbol))
          return "underlyingSymbol: string expected";
      }
      if (message.issuerName != null && message.hasOwnProperty("issuerName")) {
        if (!$util.isString(message.issuerName))
          return "issuerName: string expected";
      }
      if (message.coveredWarrantType != null && message.hasOwnProperty("coveredWarrantType")) {
        if (!$util.isString(message.coveredWarrantType))
          return "coveredWarrantType: string expected";
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        if (!$util.isString(message.maturityDate))
          return "maturityDate: string expected";
      }
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate")) {
        if (!$util.isString(message.lastTradingDate))
          return "lastTradingDate: string expected";
      }
      if (message.exercisePrice != null && message.hasOwnProperty("exercisePrice")) {
        if (!$util.isInteger(message.exercisePrice))
          return "exercisePrice: integer expected";
      }
      if (message.exerciseRatio != null && message.hasOwnProperty("exerciseRatio")) {
        if (!$util.isString(message.exerciseRatio))
          return "exerciseRatio: string expected";
      }
      if (message.listedShare != null && message.hasOwnProperty("listedShare")) {
        if (!$util.isInteger(message.listedShare) && !(message.listedShare && $util.isInteger(message.listedShare.low) && $util.isInteger(message.listedShare.high)))
          return "listedShare: integer|Long expected";
      }
      if (message.oddLotHaltResumeFlag != null && message.hasOwnProperty("oddLotHaltResumeFlag")) {
        if (!$util.isString(message.oddLotHaltResumeFlag))
          return "oddLotHaltResumeFlag: string expected";
      }
      return null;
    };
    SU.fromObject = function fromObject(object) {
      if (object instanceof $root.hsx.SU)
        return object;
      let message = new $root.hsx.SU();
      if (object.messageType != null)
        message.messageType = String(object.messageType);
      if (object.securityNumberNew != null)
        message.securityNumberNew = object.securityNumberNew >>> 0;
      if (object.securityNumberOld != null)
        message.securityNumberOld = object.securityNumberOld >>> 0;
      if (object.filler1 != null)
        message.filler1 = object.filler1 >>> 0;
      if (object.sectorNumber != null)
        message.sectorNumber = object.sectorNumber >>> 0;
      if (object.filler2 != null)
        message.filler2 = object.filler2 >>> 0;
      if (object.securitySymbol != null)
        message.securitySymbol = String(object.securitySymbol);
      if (object.securityType != null)
        message.securityType = String(object.securityType);
      if (object.ceilingPrice != null)
        message.ceilingPrice = object.ceilingPrice >>> 0;
      if (object.floorPrice != null)
        message.floorPrice = object.floorPrice >>> 0;
      if (object.lastSalePrice != null)
        message.lastSalePrice = object.lastSalePrice >>> 0;
      if (object.marketID != null)
        message.marketID = String(object.marketID);
      if (object.filler3 != null)
        message.filler3 = object.filler3 >>> 0;
      if (object.securityName != null)
        message.securityName = String(object.securityName);
      if (object.filler4 != null)
        message.filler4 = object.filler4 >>> 0;
      if (object.suspension != null)
        message.suspension = String(object.suspension);
      if (object.delist != null)
        message.delist = String(object.delist);
      if (object.haltResumeFlag != null)
        message.haltResumeFlag = String(object.haltResumeFlag);
      if (object.split != null)
        message.split = String(object.split);
      if (object.benefit != null)
        message.benefit = String(object.benefit);
      if (object.meeting != null)
        message.meeting = String(object.meeting);
      if (object.notice != null)
        message.notice = String(object.notice);
      if (object.clientIDRequired != null)
        message.clientIDRequired = String(object.clientIDRequired);
      if (object.parValue != null)
        message.parValue = object.parValue >>> 0;
      if (object.sdcFlag != null)
        message.sdcFlag = String(object.sdcFlag);
      if (object.priorClosePrice != null)
        message.priorClosePrice = object.priorClosePrice >>> 0;
      if (object.priorCloseDate != null)
        message.priorCloseDate = String(object.priorCloseDate);
      if (object.openPrice != null)
        message.openPrice = object.openPrice >>> 0;
      if (object.highestPrice != null)
        message.highestPrice = object.highestPrice >>> 0;
      if (object.lowestPrice != null)
        message.lowestPrice = object.lowestPrice >>> 0;
      if (object.totalSharesTraded != null)
        message.totalSharesTraded = object.totalSharesTraded >>> 0;
      if (object.totalValuesTraded != null)
        message.totalValuesTraded = object.totalValuesTraded >>> 0;
      if (object.boardLot != null)
        message.boardLot = object.boardLot >>> 0;
      if (object.filler5 != null)
        message.filler5 = object.filler5 >>> 0;
      if (object.underlyingSymbol != null)
        message.underlyingSymbol = String(object.underlyingSymbol);
      if (object.issuerName != null)
        message.issuerName = String(object.issuerName);
      if (object.coveredWarrantType != null)
        message.coveredWarrantType = String(object.coveredWarrantType);
      if (object.maturityDate != null)
        message.maturityDate = String(object.maturityDate);
      if (object.lastTradingDate != null)
        message.lastTradingDate = String(object.lastTradingDate);
      if (object.exercisePrice != null)
        message.exercisePrice = object.exercisePrice >>> 0;
      if (object.exerciseRatio != null)
        message.exerciseRatio = String(object.exerciseRatio);
      if (object.listedShare != null) {
        if ($util.Long)
          (message.listedShare = $util.Long.fromValue(object.listedShare)).unsigned = true;
        else if (typeof object.listedShare === "string")
          message.listedShare = parseInt(object.listedShare, 10);
        else if (typeof object.listedShare === "number")
          message.listedShare = object.listedShare;
        else if (typeof object.listedShare === "object")
          message.listedShare = new $util.LongBits(object.listedShare.low >>> 0, object.listedShare.high >>> 0).toNumber(true);
      }
      if (object.oddLotHaltResumeFlag != null)
        message.oddLotHaltResumeFlag = String(object.oddLotHaltResumeFlag);
      return message;
    };
    SU.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.messageType = "";
        object.securityNumberNew = 0;
        object.securityNumberOld = 0;
        object.filler1 = 0;
        object.sectorNumber = 0;
        object.filler2 = 0;
        object.securitySymbol = "";
        object.securityType = "";
        object.ceilingPrice = 0;
        object.floorPrice = 0;
        object.lastSalePrice = 0;
        object.marketID = "";
        object.filler3 = 0;
        object.securityName = "";
        object.filler4 = 0;
        object.suspension = "";
        object.delist = "";
        object.haltResumeFlag = "";
        object.split = "";
        object.benefit = "";
        object.meeting = "";
        object.notice = "";
        object.clientIDRequired = "";
        object.parValue = 0;
        object.sdcFlag = "";
        object.priorClosePrice = 0;
        object.priorCloseDate = "";
        object.openPrice = 0;
        object.highestPrice = 0;
        object.lowestPrice = 0;
        object.totalSharesTraded = 0;
        object.totalValuesTraded = 0;
        object.boardLot = 0;
        object.filler5 = 0;
        object.underlyingSymbol = "";
        object.issuerName = "";
        object.coveredWarrantType = "";
        object.maturityDate = "";
        object.lastTradingDate = "";
        object.exercisePrice = 0;
        object.exerciseRatio = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.listedShare = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.listedShare = options.longs === String ? "0" : 0;
        object.oddLotHaltResumeFlag = "";
      }
      if (message.messageType != null && message.hasOwnProperty("messageType"))
        object.messageType = message.messageType;
      if (message.securityNumberNew != null && message.hasOwnProperty("securityNumberNew"))
        object.securityNumberNew = message.securityNumberNew;
      if (message.securityNumberOld != null && message.hasOwnProperty("securityNumberOld"))
        object.securityNumberOld = message.securityNumberOld;
      if (message.filler1 != null && message.hasOwnProperty("filler1"))
        object.filler1 = message.filler1;
      if (message.sectorNumber != null && message.hasOwnProperty("sectorNumber"))
        object.sectorNumber = message.sectorNumber;
      if (message.filler2 != null && message.hasOwnProperty("filler2"))
        object.filler2 = message.filler2;
      if (message.securitySymbol != null && message.hasOwnProperty("securitySymbol"))
        object.securitySymbol = message.securitySymbol;
      if (message.securityType != null && message.hasOwnProperty("securityType"))
        object.securityType = message.securityType;
      if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
        object.ceilingPrice = message.ceilingPrice;
      if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
        object.floorPrice = message.floorPrice;
      if (message.lastSalePrice != null && message.hasOwnProperty("lastSalePrice"))
        object.lastSalePrice = message.lastSalePrice;
      if (message.marketID != null && message.hasOwnProperty("marketID"))
        object.marketID = message.marketID;
      if (message.filler3 != null && message.hasOwnProperty("filler3"))
        object.filler3 = message.filler3;
      if (message.securityName != null && message.hasOwnProperty("securityName"))
        object.securityName = message.securityName;
      if (message.filler4 != null && message.hasOwnProperty("filler4"))
        object.filler4 = message.filler4;
      if (message.suspension != null && message.hasOwnProperty("suspension"))
        object.suspension = message.suspension;
      if (message.delist != null && message.hasOwnProperty("delist"))
        object.delist = message.delist;
      if (message.haltResumeFlag != null && message.hasOwnProperty("haltResumeFlag"))
        object.haltResumeFlag = message.haltResumeFlag;
      if (message.split != null && message.hasOwnProperty("split"))
        object.split = message.split;
      if (message.benefit != null && message.hasOwnProperty("benefit"))
        object.benefit = message.benefit;
      if (message.meeting != null && message.hasOwnProperty("meeting"))
        object.meeting = message.meeting;
      if (message.notice != null && message.hasOwnProperty("notice"))
        object.notice = message.notice;
      if (message.clientIDRequired != null && message.hasOwnProperty("clientIDRequired"))
        object.clientIDRequired = message.clientIDRequired;
      if (message.parValue != null && message.hasOwnProperty("parValue"))
        object.parValue = message.parValue;
      if (message.sdcFlag != null && message.hasOwnProperty("sdcFlag"))
        object.sdcFlag = message.sdcFlag;
      if (message.priorClosePrice != null && message.hasOwnProperty("priorClosePrice"))
        object.priorClosePrice = message.priorClosePrice;
      if (message.priorCloseDate != null && message.hasOwnProperty("priorCloseDate"))
        object.priorCloseDate = message.priorCloseDate;
      if (message.openPrice != null && message.hasOwnProperty("openPrice"))
        object.openPrice = message.openPrice;
      if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
        object.highestPrice = message.highestPrice;
      if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
        object.lowestPrice = message.lowestPrice;
      if (message.totalSharesTraded != null && message.hasOwnProperty("totalSharesTraded"))
        object.totalSharesTraded = message.totalSharesTraded;
      if (message.totalValuesTraded != null && message.hasOwnProperty("totalValuesTraded"))
        object.totalValuesTraded = message.totalValuesTraded;
      if (message.boardLot != null && message.hasOwnProperty("boardLot"))
        object.boardLot = message.boardLot;
      if (message.filler5 != null && message.hasOwnProperty("filler5"))
        object.filler5 = message.filler5;
      if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol"))
        object.underlyingSymbol = message.underlyingSymbol;
      if (message.issuerName != null && message.hasOwnProperty("issuerName"))
        object.issuerName = message.issuerName;
      if (message.coveredWarrantType != null && message.hasOwnProperty("coveredWarrantType"))
        object.coveredWarrantType = message.coveredWarrantType;
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = message.maturityDate;
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate"))
        object.lastTradingDate = message.lastTradingDate;
      if (message.exercisePrice != null && message.hasOwnProperty("exercisePrice"))
        object.exercisePrice = message.exercisePrice;
      if (message.exerciseRatio != null && message.hasOwnProperty("exerciseRatio"))
        object.exerciseRatio = message.exerciseRatio;
      if (message.listedShare != null && message.hasOwnProperty("listedShare"))
        if (typeof message.listedShare === "number")
          object.listedShare = options.longs === String ? String(message.listedShare) : message.listedShare;
        else
          object.listedShare = options.longs === String ? $util.Long.prototype.toString.call(message.listedShare) : options.longs === Number ? new $util.LongBits(message.listedShare.low >>> 0, message.listedShare.high >>> 0).toNumber(true) : message.listedShare;
      if (message.oddLotHaltResumeFlag != null && message.hasOwnProperty("oddLotHaltResumeFlag"))
        object.oddLotHaltResumeFlag = message.oddLotHaltResumeFlag;
      return object;
    };
    SU.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SU;
  }();
  hsx2.SECURITY = function() {
    function SECURITY(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SECURITY.prototype.stockNo = 0;
    SECURITY.prototype.stockSymbol = "";
    SECURITY.prototype.stockType = "";
    SECURITY.prototype.ceiling = 0;
    SECURITY.prototype.floor = 0;
    SECURITY.prototype.bigLotValue = 0;
    SECURITY.prototype.securityName = "";
    SECURITY.prototype.sectorNo = "";
    SECURITY.prototype.designated = "";
    SECURITY.prototype.suspension = "";
    SECURITY.prototype.delist = "";
    SECURITY.prototype.haltResumeFlag = "";
    SECURITY.prototype.split = "";
    SECURITY.prototype.benefit = "";
    SECURITY.prototype.meeting = "";
    SECURITY.prototype.notice = "";
    SECURITY.prototype.clientIDRequest = "";
    SECURITY.prototype.couponRate = 0;
    SECURITY.prototype.issueDate = "";
    SECURITY.prototype.matureDate = "";
    SECURITY.prototype.avrPrice = 0;
    SECURITY.prototype.parValue = 0;
    SECURITY.prototype.sdcFlag = "";
    SECURITY.prototype.priorClosePrice = 0;
    SECURITY.prototype.priorCloseDate = "";
    SECURITY.prototype.projectOpen = 0;
    SECURITY.prototype.openPrice = 0;
    SECURITY.prototype.last = 0;
    SECURITY.prototype.lastVol = 0;
    SECURITY.prototype.lastVal = 0;
    SECURITY.prototype.highest = 0;
    SECURITY.prototype.lowest = 0;
    SECURITY.prototype.totalshare = 0;
    SECURITY.prototype.totalValue = 0;
    SECURITY.prototype.accumulateDeal = 0;
    SECURITY.prototype.bigDeal = 0;
    SECURITY.prototype.bigVol = 0;
    SECURITY.prototype.bigVal = 0;
    SECURITY.prototype.oddDeal = 0;
    SECURITY.prototype.oddVol = 0;
    SECURITY.prototype.oddVal = 0;
    SECURITY.prototype.best1Bid = 0;
    SECURITY.prototype.best1BidVolume = 0;
    SECURITY.prototype.best2Bid = 0;
    SECURITY.prototype.best2BidVolume = 0;
    SECURITY.prototype.best3Bid = 0;
    SECURITY.prototype.best3BidVolume = 0;
    SECURITY.prototype.best1Offer = 0;
    SECURITY.prototype.best1OfferVolume = 0;
    SECURITY.prototype.best2Offer = 0;
    SECURITY.prototype.best2OfferVolume = 0;
    SECURITY.prototype.best3Offer = 0;
    SECURITY.prototype.best3OfferVolume = 0;
    SECURITY.prototype.boardLot = 0;
    SECURITY.prototype.underlyingSymbol = "";
    SECURITY.prototype.issuerName = "";
    SECURITY.prototype.coveredWarrantType = "";
    SECURITY.prototype.maturityDate = "";
    SECURITY.prototype.lastTradingDate = "";
    SECURITY.prototype.exercisePrice = 0;
    SECURITY.prototype.exerciseRatio = "";
    SECURITY.prototype.listedShare = 0;
    SECURITY.prototype.oddLotHaltResumeFlag = "";
    SECURITY.create = function create(properties) {
      return new SECURITY(properties);
    };
    SECURITY.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.stockNo != null && Object.hasOwnProperty.call(message, "stockNo"))
        writer.uint32(8).uint32(message.stockNo);
      if (message.stockSymbol != null && Object.hasOwnProperty.call(message, "stockSymbol"))
        writer.uint32(18).string(message.stockSymbol);
      if (message.stockType != null && Object.hasOwnProperty.call(message, "stockType"))
        writer.uint32(26).string(message.stockType);
      if (message.ceiling != null && Object.hasOwnProperty.call(message, "ceiling"))
        writer.uint32(32).uint32(message.ceiling);
      if (message.floor != null && Object.hasOwnProperty.call(message, "floor"))
        writer.uint32(40).uint32(message.floor);
      if (message.bigLotValue != null && Object.hasOwnProperty.call(message, "bigLotValue"))
        writer.uint32(49).double(message.bigLotValue);
      if (message.securityName != null && Object.hasOwnProperty.call(message, "securityName"))
        writer.uint32(58).string(message.securityName);
      if (message.sectorNo != null && Object.hasOwnProperty.call(message, "sectorNo"))
        writer.uint32(66).string(message.sectorNo);
      if (message.designated != null && Object.hasOwnProperty.call(message, "designated"))
        writer.uint32(74).string(message.designated);
      if (message.suspension != null && Object.hasOwnProperty.call(message, "suspension"))
        writer.uint32(82).string(message.suspension);
      if (message.delist != null && Object.hasOwnProperty.call(message, "delist"))
        writer.uint32(90).string(message.delist);
      if (message.haltResumeFlag != null && Object.hasOwnProperty.call(message, "haltResumeFlag"))
        writer.uint32(98).string(message.haltResumeFlag);
      if (message.split != null && Object.hasOwnProperty.call(message, "split"))
        writer.uint32(106).string(message.split);
      if (message.benefit != null && Object.hasOwnProperty.call(message, "benefit"))
        writer.uint32(114).string(message.benefit);
      if (message.meeting != null && Object.hasOwnProperty.call(message, "meeting"))
        writer.uint32(122).string(message.meeting);
      if (message.notice != null && Object.hasOwnProperty.call(message, "notice"))
        writer.uint32(130).string(message.notice);
      if (message.clientIDRequest != null && Object.hasOwnProperty.call(message, "clientIDRequest"))
        writer.uint32(138).string(message.clientIDRequest);
      if (message.couponRate != null && Object.hasOwnProperty.call(message, "couponRate"))
        writer.uint32(144).uint32(message.couponRate);
      if (message.issueDate != null && Object.hasOwnProperty.call(message, "issueDate"))
        writer.uint32(154).string(message.issueDate);
      if (message.matureDate != null && Object.hasOwnProperty.call(message, "matureDate"))
        writer.uint32(162).string(message.matureDate);
      if (message.avrPrice != null && Object.hasOwnProperty.call(message, "avrPrice"))
        writer.uint32(168).uint32(message.avrPrice);
      if (message.parValue != null && Object.hasOwnProperty.call(message, "parValue"))
        writer.uint32(176).uint32(message.parValue);
      if (message.sdcFlag != null && Object.hasOwnProperty.call(message, "sdcFlag"))
        writer.uint32(186).string(message.sdcFlag);
      if (message.priorClosePrice != null && Object.hasOwnProperty.call(message, "priorClosePrice"))
        writer.uint32(192).uint32(message.priorClosePrice);
      if (message.priorCloseDate != null && Object.hasOwnProperty.call(message, "priorCloseDate"))
        writer.uint32(202).string(message.priorCloseDate);
      if (message.projectOpen != null && Object.hasOwnProperty.call(message, "projectOpen"))
        writer.uint32(208).uint32(message.projectOpen);
      if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
        writer.uint32(216).uint32(message.openPrice);
      if (message.last != null && Object.hasOwnProperty.call(message, "last"))
        writer.uint32(224).uint32(message.last);
      if (message.lastVol != null && Object.hasOwnProperty.call(message, "lastVol"))
        writer.uint32(232).uint32(message.lastVol);
      if (message.lastVal != null && Object.hasOwnProperty.call(message, "lastVal"))
        writer.uint32(241).double(message.lastVal);
      if (message.highest != null && Object.hasOwnProperty.call(message, "highest"))
        writer.uint32(248).uint32(message.highest);
      if (message.lowest != null && Object.hasOwnProperty.call(message, "lowest"))
        writer.uint32(256).uint32(message.lowest);
      if (message.totalshare != null && Object.hasOwnProperty.call(message, "totalshare"))
        writer.uint32(265).double(message.totalshare);
      if (message.totalValue != null && Object.hasOwnProperty.call(message, "totalValue"))
        writer.uint32(273).double(message.totalValue);
      if (message.accumulateDeal != null && Object.hasOwnProperty.call(message, "accumulateDeal"))
        writer.uint32(280).uint32(message.accumulateDeal);
      if (message.bigDeal != null && Object.hasOwnProperty.call(message, "bigDeal"))
        writer.uint32(288).uint32(message.bigDeal);
      if (message.bigVol != null && Object.hasOwnProperty.call(message, "bigVol"))
        writer.uint32(296).uint32(message.bigVol);
      if (message.bigVal != null && Object.hasOwnProperty.call(message, "bigVal"))
        writer.uint32(305).double(message.bigVal);
      if (message.oddDeal != null && Object.hasOwnProperty.call(message, "oddDeal"))
        writer.uint32(312).uint32(message.oddDeal);
      if (message.oddVol != null && Object.hasOwnProperty.call(message, "oddVol"))
        writer.uint32(320).uint32(message.oddVol);
      if (message.oddVal != null && Object.hasOwnProperty.call(message, "oddVal"))
        writer.uint32(329).double(message.oddVal);
      if (message.best1Bid != null && Object.hasOwnProperty.call(message, "best1Bid"))
        writer.uint32(336).uint32(message.best1Bid);
      if (message.best1BidVolume != null && Object.hasOwnProperty.call(message, "best1BidVolume"))
        writer.uint32(344).uint32(message.best1BidVolume);
      if (message.best2Bid != null && Object.hasOwnProperty.call(message, "best2Bid"))
        writer.uint32(352).uint32(message.best2Bid);
      if (message.best2BidVolume != null && Object.hasOwnProperty.call(message, "best2BidVolume"))
        writer.uint32(360).uint32(message.best2BidVolume);
      if (message.best3Bid != null && Object.hasOwnProperty.call(message, "best3Bid"))
        writer.uint32(368).uint32(message.best3Bid);
      if (message.best3BidVolume != null && Object.hasOwnProperty.call(message, "best3BidVolume"))
        writer.uint32(376).uint32(message.best3BidVolume);
      if (message.best1Offer != null && Object.hasOwnProperty.call(message, "best1Offer"))
        writer.uint32(384).uint32(message.best1Offer);
      if (message.best1OfferVolume != null && Object.hasOwnProperty.call(message, "best1OfferVolume"))
        writer.uint32(392).uint32(message.best1OfferVolume);
      if (message.best2Offer != null && Object.hasOwnProperty.call(message, "best2Offer"))
        writer.uint32(400).uint32(message.best2Offer);
      if (message.best2OfferVolume != null && Object.hasOwnProperty.call(message, "best2OfferVolume"))
        writer.uint32(408).uint32(message.best2OfferVolume);
      if (message.best3Offer != null && Object.hasOwnProperty.call(message, "best3Offer"))
        writer.uint32(416).uint32(message.best3Offer);
      if (message.best3OfferVolume != null && Object.hasOwnProperty.call(message, "best3OfferVolume"))
        writer.uint32(424).uint32(message.best3OfferVolume);
      if (message.boardLot != null && Object.hasOwnProperty.call(message, "boardLot"))
        writer.uint32(432).uint32(message.boardLot);
      if (message.underlyingSymbol != null && Object.hasOwnProperty.call(message, "underlyingSymbol"))
        writer.uint32(442).string(message.underlyingSymbol);
      if (message.issuerName != null && Object.hasOwnProperty.call(message, "issuerName"))
        writer.uint32(450).string(message.issuerName);
      if (message.coveredWarrantType != null && Object.hasOwnProperty.call(message, "coveredWarrantType"))
        writer.uint32(458).string(message.coveredWarrantType);
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        writer.uint32(466).string(message.maturityDate);
      if (message.lastTradingDate != null && Object.hasOwnProperty.call(message, "lastTradingDate"))
        writer.uint32(474).string(message.lastTradingDate);
      if (message.exercisePrice != null && Object.hasOwnProperty.call(message, "exercisePrice"))
        writer.uint32(480).uint32(message.exercisePrice);
      if (message.exerciseRatio != null && Object.hasOwnProperty.call(message, "exerciseRatio"))
        writer.uint32(490).string(message.exerciseRatio);
      if (message.listedShare != null && Object.hasOwnProperty.call(message, "listedShare"))
        writer.uint32(497).double(message.listedShare);
      if (message.oddLotHaltResumeFlag != null && Object.hasOwnProperty.call(message, "oddLotHaltResumeFlag"))
        writer.uint32(506).string(message.oddLotHaltResumeFlag);
      return writer;
    };
    SECURITY.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SECURITY.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.hsx.SECURITY();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.stockNo = reader.uint32();
            break;
          case 2:
            message.stockSymbol = reader.string();
            break;
          case 3:
            message.stockType = reader.string();
            break;
          case 4:
            message.ceiling = reader.uint32();
            break;
          case 5:
            message.floor = reader.uint32();
            break;
          case 6:
            message.bigLotValue = reader.double();
            break;
          case 7:
            message.securityName = reader.string();
            break;
          case 8:
            message.sectorNo = reader.string();
            break;
          case 9:
            message.designated = reader.string();
            break;
          case 10:
            message.suspension = reader.string();
            break;
          case 11:
            message.delist = reader.string();
            break;
          case 12:
            message.haltResumeFlag = reader.string();
            break;
          case 13:
            message.split = reader.string();
            break;
          case 14:
            message.benefit = reader.string();
            break;
          case 15:
            message.meeting = reader.string();
            break;
          case 16:
            message.notice = reader.string();
            break;
          case 17:
            message.clientIDRequest = reader.string();
            break;
          case 18:
            message.couponRate = reader.uint32();
            break;
          case 19:
            message.issueDate = reader.string();
            break;
          case 20:
            message.matureDate = reader.string();
            break;
          case 21:
            message.avrPrice = reader.uint32();
            break;
          case 22:
            message.parValue = reader.uint32();
            break;
          case 23:
            message.sdcFlag = reader.string();
            break;
          case 24:
            message.priorClosePrice = reader.uint32();
            break;
          case 25:
            message.priorCloseDate = reader.string();
            break;
          case 26:
            message.projectOpen = reader.uint32();
            break;
          case 27:
            message.openPrice = reader.uint32();
            break;
          case 28:
            message.last = reader.uint32();
            break;
          case 29:
            message.lastVol = reader.uint32();
            break;
          case 30:
            message.lastVal = reader.double();
            break;
          case 31:
            message.highest = reader.uint32();
            break;
          case 32:
            message.lowest = reader.uint32();
            break;
          case 33:
            message.totalshare = reader.double();
            break;
          case 34:
            message.totalValue = reader.double();
            break;
          case 35:
            message.accumulateDeal = reader.uint32();
            break;
          case 36:
            message.bigDeal = reader.uint32();
            break;
          case 37:
            message.bigVol = reader.uint32();
            break;
          case 38:
            message.bigVal = reader.double();
            break;
          case 39:
            message.oddDeal = reader.uint32();
            break;
          case 40:
            message.oddVol = reader.uint32();
            break;
          case 41:
            message.oddVal = reader.double();
            break;
          case 42:
            message.best1Bid = reader.uint32();
            break;
          case 43:
            message.best1BidVolume = reader.uint32();
            break;
          case 44:
            message.best2Bid = reader.uint32();
            break;
          case 45:
            message.best2BidVolume = reader.uint32();
            break;
          case 46:
            message.best3Bid = reader.uint32();
            break;
          case 47:
            message.best3BidVolume = reader.uint32();
            break;
          case 48:
            message.best1Offer = reader.uint32();
            break;
          case 49:
            message.best1OfferVolume = reader.uint32();
            break;
          case 50:
            message.best2Offer = reader.uint32();
            break;
          case 51:
            message.best2OfferVolume = reader.uint32();
            break;
          case 52:
            message.best3Offer = reader.uint32();
            break;
          case 53:
            message.best3OfferVolume = reader.uint32();
            break;
          case 54:
            message.boardLot = reader.uint32();
            break;
          case 55:
            message.underlyingSymbol = reader.string();
            break;
          case 56:
            message.issuerName = reader.string();
            break;
          case 57:
            message.coveredWarrantType = reader.string();
            break;
          case 58:
            message.maturityDate = reader.string();
            break;
          case 59:
            message.lastTradingDate = reader.string();
            break;
          case 60:
            message.exercisePrice = reader.uint32();
            break;
          case 61:
            message.exerciseRatio = reader.string();
            break;
          case 62:
            message.listedShare = reader.double();
            break;
          case 63:
            message.oddLotHaltResumeFlag = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SECURITY.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SECURITY.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.stockNo != null && message.hasOwnProperty("stockNo")) {
        if (!$util.isInteger(message.stockNo))
          return "stockNo: integer expected";
      }
      if (message.stockSymbol != null && message.hasOwnProperty("stockSymbol")) {
        if (!$util.isString(message.stockSymbol))
          return "stockSymbol: string expected";
      }
      if (message.stockType != null && message.hasOwnProperty("stockType")) {
        if (!$util.isString(message.stockType))
          return "stockType: string expected";
      }
      if (message.ceiling != null && message.hasOwnProperty("ceiling")) {
        if (!$util.isInteger(message.ceiling))
          return "ceiling: integer expected";
      }
      if (message.floor != null && message.hasOwnProperty("floor")) {
        if (!$util.isInteger(message.floor))
          return "floor: integer expected";
      }
      if (message.bigLotValue != null && message.hasOwnProperty("bigLotValue")) {
        if (typeof message.bigLotValue !== "number")
          return "bigLotValue: number expected";
      }
      if (message.securityName != null && message.hasOwnProperty("securityName")) {
        if (!$util.isString(message.securityName))
          return "securityName: string expected";
      }
      if (message.sectorNo != null && message.hasOwnProperty("sectorNo")) {
        if (!$util.isString(message.sectorNo))
          return "sectorNo: string expected";
      }
      if (message.designated != null && message.hasOwnProperty("designated")) {
        if (!$util.isString(message.designated))
          return "designated: string expected";
      }
      if (message.suspension != null && message.hasOwnProperty("suspension")) {
        if (!$util.isString(message.suspension))
          return "suspension: string expected";
      }
      if (message.delist != null && message.hasOwnProperty("delist")) {
        if (!$util.isString(message.delist))
          return "delist: string expected";
      }
      if (message.haltResumeFlag != null && message.hasOwnProperty("haltResumeFlag")) {
        if (!$util.isString(message.haltResumeFlag))
          return "haltResumeFlag: string expected";
      }
      if (message.split != null && message.hasOwnProperty("split")) {
        if (!$util.isString(message.split))
          return "split: string expected";
      }
      if (message.benefit != null && message.hasOwnProperty("benefit")) {
        if (!$util.isString(message.benefit))
          return "benefit: string expected";
      }
      if (message.meeting != null && message.hasOwnProperty("meeting")) {
        if (!$util.isString(message.meeting))
          return "meeting: string expected";
      }
      if (message.notice != null && message.hasOwnProperty("notice")) {
        if (!$util.isString(message.notice))
          return "notice: string expected";
      }
      if (message.clientIDRequest != null && message.hasOwnProperty("clientIDRequest")) {
        if (!$util.isString(message.clientIDRequest))
          return "clientIDRequest: string expected";
      }
      if (message.couponRate != null && message.hasOwnProperty("couponRate")) {
        if (!$util.isInteger(message.couponRate))
          return "couponRate: integer expected";
      }
      if (message.issueDate != null && message.hasOwnProperty("issueDate")) {
        if (!$util.isString(message.issueDate))
          return "issueDate: string expected";
      }
      if (message.matureDate != null && message.hasOwnProperty("matureDate")) {
        if (!$util.isString(message.matureDate))
          return "matureDate: string expected";
      }
      if (message.avrPrice != null && message.hasOwnProperty("avrPrice")) {
        if (!$util.isInteger(message.avrPrice))
          return "avrPrice: integer expected";
      }
      if (message.parValue != null && message.hasOwnProperty("parValue")) {
        if (!$util.isInteger(message.parValue))
          return "parValue: integer expected";
      }
      if (message.sdcFlag != null && message.hasOwnProperty("sdcFlag")) {
        if (!$util.isString(message.sdcFlag))
          return "sdcFlag: string expected";
      }
      if (message.priorClosePrice != null && message.hasOwnProperty("priorClosePrice")) {
        if (!$util.isInteger(message.priorClosePrice))
          return "priorClosePrice: integer expected";
      }
      if (message.priorCloseDate != null && message.hasOwnProperty("priorCloseDate")) {
        if (!$util.isString(message.priorCloseDate))
          return "priorCloseDate: string expected";
      }
      if (message.projectOpen != null && message.hasOwnProperty("projectOpen")) {
        if (!$util.isInteger(message.projectOpen))
          return "projectOpen: integer expected";
      }
      if (message.openPrice != null && message.hasOwnProperty("openPrice")) {
        if (!$util.isInteger(message.openPrice))
          return "openPrice: integer expected";
      }
      if (message.last != null && message.hasOwnProperty("last")) {
        if (!$util.isInteger(message.last))
          return "last: integer expected";
      }
      if (message.lastVol != null && message.hasOwnProperty("lastVol")) {
        if (!$util.isInteger(message.lastVol))
          return "lastVol: integer expected";
      }
      if (message.lastVal != null && message.hasOwnProperty("lastVal")) {
        if (typeof message.lastVal !== "number")
          return "lastVal: number expected";
      }
      if (message.highest != null && message.hasOwnProperty("highest")) {
        if (!$util.isInteger(message.highest))
          return "highest: integer expected";
      }
      if (message.lowest != null && message.hasOwnProperty("lowest")) {
        if (!$util.isInteger(message.lowest))
          return "lowest: integer expected";
      }
      if (message.totalshare != null && message.hasOwnProperty("totalshare")) {
        if (typeof message.totalshare !== "number")
          return "totalshare: number expected";
      }
      if (message.totalValue != null && message.hasOwnProperty("totalValue")) {
        if (typeof message.totalValue !== "number")
          return "totalValue: number expected";
      }
      if (message.accumulateDeal != null && message.hasOwnProperty("accumulateDeal")) {
        if (!$util.isInteger(message.accumulateDeal))
          return "accumulateDeal: integer expected";
      }
      if (message.bigDeal != null && message.hasOwnProperty("bigDeal")) {
        if (!$util.isInteger(message.bigDeal))
          return "bigDeal: integer expected";
      }
      if (message.bigVol != null && message.hasOwnProperty("bigVol")) {
        if (!$util.isInteger(message.bigVol))
          return "bigVol: integer expected";
      }
      if (message.bigVal != null && message.hasOwnProperty("bigVal")) {
        if (typeof message.bigVal !== "number")
          return "bigVal: number expected";
      }
      if (message.oddDeal != null && message.hasOwnProperty("oddDeal")) {
        if (!$util.isInteger(message.oddDeal))
          return "oddDeal: integer expected";
      }
      if (message.oddVol != null && message.hasOwnProperty("oddVol")) {
        if (!$util.isInteger(message.oddVol))
          return "oddVol: integer expected";
      }
      if (message.oddVal != null && message.hasOwnProperty("oddVal")) {
        if (typeof message.oddVal !== "number")
          return "oddVal: number expected";
      }
      if (message.best1Bid != null && message.hasOwnProperty("best1Bid")) {
        if (!$util.isInteger(message.best1Bid))
          return "best1Bid: integer expected";
      }
      if (message.best1BidVolume != null && message.hasOwnProperty("best1BidVolume")) {
        if (!$util.isInteger(message.best1BidVolume))
          return "best1BidVolume: integer expected";
      }
      if (message.best2Bid != null && message.hasOwnProperty("best2Bid")) {
        if (!$util.isInteger(message.best2Bid))
          return "best2Bid: integer expected";
      }
      if (message.best2BidVolume != null && message.hasOwnProperty("best2BidVolume")) {
        if (!$util.isInteger(message.best2BidVolume))
          return "best2BidVolume: integer expected";
      }
      if (message.best3Bid != null && message.hasOwnProperty("best3Bid")) {
        if (!$util.isInteger(message.best3Bid))
          return "best3Bid: integer expected";
      }
      if (message.best3BidVolume != null && message.hasOwnProperty("best3BidVolume")) {
        if (!$util.isInteger(message.best3BidVolume))
          return "best3BidVolume: integer expected";
      }
      if (message.best1Offer != null && message.hasOwnProperty("best1Offer")) {
        if (!$util.isInteger(message.best1Offer))
          return "best1Offer: integer expected";
      }
      if (message.best1OfferVolume != null && message.hasOwnProperty("best1OfferVolume")) {
        if (!$util.isInteger(message.best1OfferVolume))
          return "best1OfferVolume: integer expected";
      }
      if (message.best2Offer != null && message.hasOwnProperty("best2Offer")) {
        if (!$util.isInteger(message.best2Offer))
          return "best2Offer: integer expected";
      }
      if (message.best2OfferVolume != null && message.hasOwnProperty("best2OfferVolume")) {
        if (!$util.isInteger(message.best2OfferVolume))
          return "best2OfferVolume: integer expected";
      }
      if (message.best3Offer != null && message.hasOwnProperty("best3Offer")) {
        if (!$util.isInteger(message.best3Offer))
          return "best3Offer: integer expected";
      }
      if (message.best3OfferVolume != null && message.hasOwnProperty("best3OfferVolume")) {
        if (!$util.isInteger(message.best3OfferVolume))
          return "best3OfferVolume: integer expected";
      }
      if (message.boardLot != null && message.hasOwnProperty("boardLot")) {
        if (!$util.isInteger(message.boardLot))
          return "boardLot: integer expected";
      }
      if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol")) {
        if (!$util.isString(message.underlyingSymbol))
          return "underlyingSymbol: string expected";
      }
      if (message.issuerName != null && message.hasOwnProperty("issuerName")) {
        if (!$util.isString(message.issuerName))
          return "issuerName: string expected";
      }
      if (message.coveredWarrantType != null && message.hasOwnProperty("coveredWarrantType")) {
        if (!$util.isString(message.coveredWarrantType))
          return "coveredWarrantType: string expected";
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        if (!$util.isString(message.maturityDate))
          return "maturityDate: string expected";
      }
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate")) {
        if (!$util.isString(message.lastTradingDate))
          return "lastTradingDate: string expected";
      }
      if (message.exercisePrice != null && message.hasOwnProperty("exercisePrice")) {
        if (!$util.isInteger(message.exercisePrice))
          return "exercisePrice: integer expected";
      }
      if (message.exerciseRatio != null && message.hasOwnProperty("exerciseRatio")) {
        if (!$util.isString(message.exerciseRatio))
          return "exerciseRatio: string expected";
      }
      if (message.listedShare != null && message.hasOwnProperty("listedShare")) {
        if (typeof message.listedShare !== "number")
          return "listedShare: number expected";
      }
      if (message.oddLotHaltResumeFlag != null && message.hasOwnProperty("oddLotHaltResumeFlag")) {
        if (!$util.isString(message.oddLotHaltResumeFlag))
          return "oddLotHaltResumeFlag: string expected";
      }
      return null;
    };
    SECURITY.fromObject = function fromObject(object) {
      if (object instanceof $root.hsx.SECURITY)
        return object;
      let message = new $root.hsx.SECURITY();
      if (object.stockNo != null)
        message.stockNo = object.stockNo >>> 0;
      if (object.stockSymbol != null)
        message.stockSymbol = String(object.stockSymbol);
      if (object.stockType != null)
        message.stockType = String(object.stockType);
      if (object.ceiling != null)
        message.ceiling = object.ceiling >>> 0;
      if (object.floor != null)
        message.floor = object.floor >>> 0;
      if (object.bigLotValue != null)
        message.bigLotValue = Number(object.bigLotValue);
      if (object.securityName != null)
        message.securityName = String(object.securityName);
      if (object.sectorNo != null)
        message.sectorNo = String(object.sectorNo);
      if (object.designated != null)
        message.designated = String(object.designated);
      if (object.suspension != null)
        message.suspension = String(object.suspension);
      if (object.delist != null)
        message.delist = String(object.delist);
      if (object.haltResumeFlag != null)
        message.haltResumeFlag = String(object.haltResumeFlag);
      if (object.split != null)
        message.split = String(object.split);
      if (object.benefit != null)
        message.benefit = String(object.benefit);
      if (object.meeting != null)
        message.meeting = String(object.meeting);
      if (object.notice != null)
        message.notice = String(object.notice);
      if (object.clientIDRequest != null)
        message.clientIDRequest = String(object.clientIDRequest);
      if (object.couponRate != null)
        message.couponRate = object.couponRate >>> 0;
      if (object.issueDate != null)
        message.issueDate = String(object.issueDate);
      if (object.matureDate != null)
        message.matureDate = String(object.matureDate);
      if (object.avrPrice != null)
        message.avrPrice = object.avrPrice >>> 0;
      if (object.parValue != null)
        message.parValue = object.parValue >>> 0;
      if (object.sdcFlag != null)
        message.sdcFlag = String(object.sdcFlag);
      if (object.priorClosePrice != null)
        message.priorClosePrice = object.priorClosePrice >>> 0;
      if (object.priorCloseDate != null)
        message.priorCloseDate = String(object.priorCloseDate);
      if (object.projectOpen != null)
        message.projectOpen = object.projectOpen >>> 0;
      if (object.openPrice != null)
        message.openPrice = object.openPrice >>> 0;
      if (object.last != null)
        message.last = object.last >>> 0;
      if (object.lastVol != null)
        message.lastVol = object.lastVol >>> 0;
      if (object.lastVal != null)
        message.lastVal = Number(object.lastVal);
      if (object.highest != null)
        message.highest = object.highest >>> 0;
      if (object.lowest != null)
        message.lowest = object.lowest >>> 0;
      if (object.totalshare != null)
        message.totalshare = Number(object.totalshare);
      if (object.totalValue != null)
        message.totalValue = Number(object.totalValue);
      if (object.accumulateDeal != null)
        message.accumulateDeal = object.accumulateDeal >>> 0;
      if (object.bigDeal != null)
        message.bigDeal = object.bigDeal >>> 0;
      if (object.bigVol != null)
        message.bigVol = object.bigVol >>> 0;
      if (object.bigVal != null)
        message.bigVal = Number(object.bigVal);
      if (object.oddDeal != null)
        message.oddDeal = object.oddDeal >>> 0;
      if (object.oddVol != null)
        message.oddVol = object.oddVol >>> 0;
      if (object.oddVal != null)
        message.oddVal = Number(object.oddVal);
      if (object.best1Bid != null)
        message.best1Bid = object.best1Bid >>> 0;
      if (object.best1BidVolume != null)
        message.best1BidVolume = object.best1BidVolume >>> 0;
      if (object.best2Bid != null)
        message.best2Bid = object.best2Bid >>> 0;
      if (object.best2BidVolume != null)
        message.best2BidVolume = object.best2BidVolume >>> 0;
      if (object.best3Bid != null)
        message.best3Bid = object.best3Bid >>> 0;
      if (object.best3BidVolume != null)
        message.best3BidVolume = object.best3BidVolume >>> 0;
      if (object.best1Offer != null)
        message.best1Offer = object.best1Offer >>> 0;
      if (object.best1OfferVolume != null)
        message.best1OfferVolume = object.best1OfferVolume >>> 0;
      if (object.best2Offer != null)
        message.best2Offer = object.best2Offer >>> 0;
      if (object.best2OfferVolume != null)
        message.best2OfferVolume = object.best2OfferVolume >>> 0;
      if (object.best3Offer != null)
        message.best3Offer = object.best3Offer >>> 0;
      if (object.best3OfferVolume != null)
        message.best3OfferVolume = object.best3OfferVolume >>> 0;
      if (object.boardLot != null)
        message.boardLot = object.boardLot >>> 0;
      if (object.underlyingSymbol != null)
        message.underlyingSymbol = String(object.underlyingSymbol);
      if (object.issuerName != null)
        message.issuerName = String(object.issuerName);
      if (object.coveredWarrantType != null)
        message.coveredWarrantType = String(object.coveredWarrantType);
      if (object.maturityDate != null)
        message.maturityDate = String(object.maturityDate);
      if (object.lastTradingDate != null)
        message.lastTradingDate = String(object.lastTradingDate);
      if (object.exercisePrice != null)
        message.exercisePrice = object.exercisePrice >>> 0;
      if (object.exerciseRatio != null)
        message.exerciseRatio = String(object.exerciseRatio);
      if (object.listedShare != null)
        message.listedShare = Number(object.listedShare);
      if (object.oddLotHaltResumeFlag != null)
        message.oddLotHaltResumeFlag = String(object.oddLotHaltResumeFlag);
      return message;
    };
    SECURITY.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.stockNo = 0;
        object.stockSymbol = "";
        object.stockType = "";
        object.ceiling = 0;
        object.floor = 0;
        object.bigLotValue = 0;
        object.securityName = "";
        object.sectorNo = "";
        object.designated = "";
        object.suspension = "";
        object.delist = "";
        object.haltResumeFlag = "";
        object.split = "";
        object.benefit = "";
        object.meeting = "";
        object.notice = "";
        object.clientIDRequest = "";
        object.couponRate = 0;
        object.issueDate = "";
        object.matureDate = "";
        object.avrPrice = 0;
        object.parValue = 0;
        object.sdcFlag = "";
        object.priorClosePrice = 0;
        object.priorCloseDate = "";
        object.projectOpen = 0;
        object.openPrice = 0;
        object.last = 0;
        object.lastVol = 0;
        object.lastVal = 0;
        object.highest = 0;
        object.lowest = 0;
        object.totalshare = 0;
        object.totalValue = 0;
        object.accumulateDeal = 0;
        object.bigDeal = 0;
        object.bigVol = 0;
        object.bigVal = 0;
        object.oddDeal = 0;
        object.oddVol = 0;
        object.oddVal = 0;
        object.best1Bid = 0;
        object.best1BidVolume = 0;
        object.best2Bid = 0;
        object.best2BidVolume = 0;
        object.best3Bid = 0;
        object.best3BidVolume = 0;
        object.best1Offer = 0;
        object.best1OfferVolume = 0;
        object.best2Offer = 0;
        object.best2OfferVolume = 0;
        object.best3Offer = 0;
        object.best3OfferVolume = 0;
        object.boardLot = 0;
        object.underlyingSymbol = "";
        object.issuerName = "";
        object.coveredWarrantType = "";
        object.maturityDate = "";
        object.lastTradingDate = "";
        object.exercisePrice = 0;
        object.exerciseRatio = "";
        object.listedShare = 0;
        object.oddLotHaltResumeFlag = "";
      }
      if (message.stockNo != null && message.hasOwnProperty("stockNo"))
        object.stockNo = message.stockNo;
      if (message.stockSymbol != null && message.hasOwnProperty("stockSymbol"))
        object.stockSymbol = message.stockSymbol;
      if (message.stockType != null && message.hasOwnProperty("stockType"))
        object.stockType = message.stockType;
      if (message.ceiling != null && message.hasOwnProperty("ceiling"))
        object.ceiling = message.ceiling;
      if (message.floor != null && message.hasOwnProperty("floor"))
        object.floor = message.floor;
      if (message.bigLotValue != null && message.hasOwnProperty("bigLotValue"))
        object.bigLotValue = options.json && !isFinite(message.bigLotValue) ? String(message.bigLotValue) : message.bigLotValue;
      if (message.securityName != null && message.hasOwnProperty("securityName"))
        object.securityName = message.securityName;
      if (message.sectorNo != null && message.hasOwnProperty("sectorNo"))
        object.sectorNo = message.sectorNo;
      if (message.designated != null && message.hasOwnProperty("designated"))
        object.designated = message.designated;
      if (message.suspension != null && message.hasOwnProperty("suspension"))
        object.suspension = message.suspension;
      if (message.delist != null && message.hasOwnProperty("delist"))
        object.delist = message.delist;
      if (message.haltResumeFlag != null && message.hasOwnProperty("haltResumeFlag"))
        object.haltResumeFlag = message.haltResumeFlag;
      if (message.split != null && message.hasOwnProperty("split"))
        object.split = message.split;
      if (message.benefit != null && message.hasOwnProperty("benefit"))
        object.benefit = message.benefit;
      if (message.meeting != null && message.hasOwnProperty("meeting"))
        object.meeting = message.meeting;
      if (message.notice != null && message.hasOwnProperty("notice"))
        object.notice = message.notice;
      if (message.clientIDRequest != null && message.hasOwnProperty("clientIDRequest"))
        object.clientIDRequest = message.clientIDRequest;
      if (message.couponRate != null && message.hasOwnProperty("couponRate"))
        object.couponRate = message.couponRate;
      if (message.issueDate != null && message.hasOwnProperty("issueDate"))
        object.issueDate = message.issueDate;
      if (message.matureDate != null && message.hasOwnProperty("matureDate"))
        object.matureDate = message.matureDate;
      if (message.avrPrice != null && message.hasOwnProperty("avrPrice"))
        object.avrPrice = message.avrPrice;
      if (message.parValue != null && message.hasOwnProperty("parValue"))
        object.parValue = message.parValue;
      if (message.sdcFlag != null && message.hasOwnProperty("sdcFlag"))
        object.sdcFlag = message.sdcFlag;
      if (message.priorClosePrice != null && message.hasOwnProperty("priorClosePrice"))
        object.priorClosePrice = message.priorClosePrice;
      if (message.priorCloseDate != null && message.hasOwnProperty("priorCloseDate"))
        object.priorCloseDate = message.priorCloseDate;
      if (message.projectOpen != null && message.hasOwnProperty("projectOpen"))
        object.projectOpen = message.projectOpen;
      if (message.openPrice != null && message.hasOwnProperty("openPrice"))
        object.openPrice = message.openPrice;
      if (message.last != null && message.hasOwnProperty("last"))
        object.last = message.last;
      if (message.lastVol != null && message.hasOwnProperty("lastVol"))
        object.lastVol = message.lastVol;
      if (message.lastVal != null && message.hasOwnProperty("lastVal"))
        object.lastVal = options.json && !isFinite(message.lastVal) ? String(message.lastVal) : message.lastVal;
      if (message.highest != null && message.hasOwnProperty("highest"))
        object.highest = message.highest;
      if (message.lowest != null && message.hasOwnProperty("lowest"))
        object.lowest = message.lowest;
      if (message.totalshare != null && message.hasOwnProperty("totalshare"))
        object.totalshare = options.json && !isFinite(message.totalshare) ? String(message.totalshare) : message.totalshare;
      if (message.totalValue != null && message.hasOwnProperty("totalValue"))
        object.totalValue = options.json && !isFinite(message.totalValue) ? String(message.totalValue) : message.totalValue;
      if (message.accumulateDeal != null && message.hasOwnProperty("accumulateDeal"))
        object.accumulateDeal = message.accumulateDeal;
      if (message.bigDeal != null && message.hasOwnProperty("bigDeal"))
        object.bigDeal = message.bigDeal;
      if (message.bigVol != null && message.hasOwnProperty("bigVol"))
        object.bigVol = message.bigVol;
      if (message.bigVal != null && message.hasOwnProperty("bigVal"))
        object.bigVal = options.json && !isFinite(message.bigVal) ? String(message.bigVal) : message.bigVal;
      if (message.oddDeal != null && message.hasOwnProperty("oddDeal"))
        object.oddDeal = message.oddDeal;
      if (message.oddVol != null && message.hasOwnProperty("oddVol"))
        object.oddVol = message.oddVol;
      if (message.oddVal != null && message.hasOwnProperty("oddVal"))
        object.oddVal = options.json && !isFinite(message.oddVal) ? String(message.oddVal) : message.oddVal;
      if (message.best1Bid != null && message.hasOwnProperty("best1Bid"))
        object.best1Bid = message.best1Bid;
      if (message.best1BidVolume != null && message.hasOwnProperty("best1BidVolume"))
        object.best1BidVolume = message.best1BidVolume;
      if (message.best2Bid != null && message.hasOwnProperty("best2Bid"))
        object.best2Bid = message.best2Bid;
      if (message.best2BidVolume != null && message.hasOwnProperty("best2BidVolume"))
        object.best2BidVolume = message.best2BidVolume;
      if (message.best3Bid != null && message.hasOwnProperty("best3Bid"))
        object.best3Bid = message.best3Bid;
      if (message.best3BidVolume != null && message.hasOwnProperty("best3BidVolume"))
        object.best3BidVolume = message.best3BidVolume;
      if (message.best1Offer != null && message.hasOwnProperty("best1Offer"))
        object.best1Offer = message.best1Offer;
      if (message.best1OfferVolume != null && message.hasOwnProperty("best1OfferVolume"))
        object.best1OfferVolume = message.best1OfferVolume;
      if (message.best2Offer != null && message.hasOwnProperty("best2Offer"))
        object.best2Offer = message.best2Offer;
      if (message.best2OfferVolume != null && message.hasOwnProperty("best2OfferVolume"))
        object.best2OfferVolume = message.best2OfferVolume;
      if (message.best3Offer != null && message.hasOwnProperty("best3Offer"))
        object.best3Offer = message.best3Offer;
      if (message.best3OfferVolume != null && message.hasOwnProperty("best3OfferVolume"))
        object.best3OfferVolume = message.best3OfferVolume;
      if (message.boardLot != null && message.hasOwnProperty("boardLot"))
        object.boardLot = message.boardLot;
      if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol"))
        object.underlyingSymbol = message.underlyingSymbol;
      if (message.issuerName != null && message.hasOwnProperty("issuerName"))
        object.issuerName = message.issuerName;
      if (message.coveredWarrantType != null && message.hasOwnProperty("coveredWarrantType"))
        object.coveredWarrantType = message.coveredWarrantType;
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = message.maturityDate;
      if (message.lastTradingDate != null && message.hasOwnProperty("lastTradingDate"))
        object.lastTradingDate = message.lastTradingDate;
      if (message.exercisePrice != null && message.hasOwnProperty("exercisePrice"))
        object.exercisePrice = message.exercisePrice;
      if (message.exerciseRatio != null && message.hasOwnProperty("exerciseRatio"))
        object.exerciseRatio = message.exerciseRatio;
      if (message.listedShare != null && message.hasOwnProperty("listedShare"))
        object.listedShare = options.json && !isFinite(message.listedShare) ? String(message.listedShare) : message.listedShare;
      if (message.oddLotHaltResumeFlag != null && message.hasOwnProperty("oddLotHaltResumeFlag"))
        object.oddLotHaltResumeFlag = message.oddLotHaltResumeFlag;
      return object;
    };
    SECURITY.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SECURITY;
  }();
  return hsx2;
})();
$root.events = (() => {
  const events2 = {};
  events2.EncapEvent = function() {
    function EncapEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EncapEvent.prototype.type = 0;
    EncapEvent.prototype.payload = $util.newBuffer([]);
    EncapEvent.create = function create(properties) {
      return new EncapEvent(properties);
    };
    EncapEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
        writer.uint32(18).bytes(message.payload);
      return writer;
    };
    EncapEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EncapEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.events.EncapEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.payload = reader.bytes();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EncapEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EncapEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (message.payload != null && message.hasOwnProperty("payload")) {
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
          return "payload: buffer expected";
      }
      return null;
    };
    EncapEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.events.EncapEvent)
        return object;
      let message = new $root.events.EncapEvent();
      switch (object.type) {
        case "UNDEFINED":
        case 0:
          message.type = 0;
          break;
        case "USER_CREATED":
        case 1:
          message.type = 1;
          break;
        case "USER_UPDATED":
        case 2:
          message.type = 2;
          break;
        case "USER_ACTIVATED":
        case 3:
          message.type = 3;
          break;
        case "CONTRACT_SIGNED":
        case 4:
          message.type = 4;
          break;
        case "CONTRACT_APPROVED":
        case 5:
          message.type = 5;
          break;
        case "CONTRACT_REJECTED":
        case 6:
          message.type = 6;
          break;
      }
      if (object.payload != null) {
        if (typeof object.payload === "string")
          $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
        else if (object.payload.length)
          message.payload = object.payload;
      }
      return message;
    };
    EncapEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? "UNDEFINED" : 0;
        if (options.bytes === String)
          object.payload = "";
        else {
          object.payload = [];
          if (options.bytes !== Array)
            object.payload = $util.newBuffer(object.payload);
        }
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.events.EncapEvent.EventType[message.type] : message.type;
      if (message.payload != null && message.hasOwnProperty("payload"))
        object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
      return object;
    };
    EncapEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    EncapEvent.EventType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNDEFINED"] = 0;
      values[valuesById[1] = "USER_CREATED"] = 1;
      values[valuesById[2] = "USER_UPDATED"] = 2;
      values[valuesById[3] = "USER_ACTIVATED"] = 3;
      values[valuesById[4] = "CONTRACT_SIGNED"] = 4;
      values[valuesById[5] = "CONTRACT_APPROVED"] = 5;
      values[valuesById[6] = "CONTRACT_REJECTED"] = 6;
      return values;
    }();
    return EncapEvent;
  }();
  events2.UserEvent = function() {
    function UserEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    UserEvent.prototype.investorId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserEvent.prototype.bankId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserEvent.prototype.username = "";
    UserEvent.prototype.fullname = "";
    UserEvent.prototype.type = "";
    UserEvent.prototype.status = "";
    UserEvent.create = function create(properties) {
      return new UserEvent(properties);
    };
    UserEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int64(message.investorId);
      if (message.bankId != null && Object.hasOwnProperty.call(message, "bankId"))
        writer.uint32(16).int64(message.bankId);
      if (message.username != null && Object.hasOwnProperty.call(message, "username"))
        writer.uint32(26).string(message.username);
      if (message.fullname != null && Object.hasOwnProperty.call(message, "fullname"))
        writer.uint32(34).string(message.fullname);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(42).string(message.type);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(50).string(message.status);
      return writer;
    };
    UserEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    UserEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.events.UserEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int64();
            break;
          case 2:
            message.bankId = reader.int64();
            break;
          case 3:
            message.username = reader.string();
            break;
          case 4:
            message.fullname = reader.string();
            break;
          case 5:
            message.type = reader.string();
            break;
          case 6:
            message.status = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    UserEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    UserEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId) && !(message.investorId && $util.isInteger(message.investorId.low) && $util.isInteger(message.investorId.high)))
          return "investorId: integer|Long expected";
      }
      if (message.bankId != null && message.hasOwnProperty("bankId")) {
        if (!$util.isInteger(message.bankId) && !(message.bankId && $util.isInteger(message.bankId.low) && $util.isInteger(message.bankId.high)))
          return "bankId: integer|Long expected";
      }
      if (message.username != null && message.hasOwnProperty("username")) {
        if (!$util.isString(message.username))
          return "username: string expected";
      }
      if (message.fullname != null && message.hasOwnProperty("fullname")) {
        if (!$util.isString(message.fullname))
          return "fullname: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      return null;
    };
    UserEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.events.UserEvent)
        return object;
      let message = new $root.events.UserEvent();
      if (object.investorId != null) {
        if ($util.Long)
          (message.investorId = $util.Long.fromValue(object.investorId)).unsigned = false;
        else if (typeof object.investorId === "string")
          message.investorId = parseInt(object.investorId, 10);
        else if (typeof object.investorId === "number")
          message.investorId = object.investorId;
        else if (typeof object.investorId === "object")
          message.investorId = new $util.LongBits(object.investorId.low >>> 0, object.investorId.high >>> 0).toNumber();
      }
      if (object.bankId != null) {
        if ($util.Long)
          (message.bankId = $util.Long.fromValue(object.bankId)).unsigned = false;
        else if (typeof object.bankId === "string")
          message.bankId = parseInt(object.bankId, 10);
        else if (typeof object.bankId === "number")
          message.bankId = object.bankId;
        else if (typeof object.bankId === "object")
          message.bankId = new $util.LongBits(object.bankId.low >>> 0, object.bankId.high >>> 0).toNumber();
      }
      if (object.username != null)
        message.username = String(object.username);
      if (object.fullname != null)
        message.fullname = String(object.fullname);
      if (object.type != null)
        message.type = String(object.type);
      if (object.status != null)
        message.status = String(object.status);
      return message;
    };
    UserEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.investorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.investorId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.bankId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.bankId = options.longs === String ? "0" : 0;
        object.username = "";
        object.fullname = "";
        object.type = "";
        object.status = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        if (typeof message.investorId === "number")
          object.investorId = options.longs === String ? String(message.investorId) : message.investorId;
        else
          object.investorId = options.longs === String ? $util.Long.prototype.toString.call(message.investorId) : options.longs === Number ? new $util.LongBits(message.investorId.low >>> 0, message.investorId.high >>> 0).toNumber() : message.investorId;
      if (message.bankId != null && message.hasOwnProperty("bankId"))
        if (typeof message.bankId === "number")
          object.bankId = options.longs === String ? String(message.bankId) : message.bankId;
        else
          object.bankId = options.longs === String ? $util.Long.prototype.toString.call(message.bankId) : options.longs === Number ? new $util.LongBits(message.bankId.low >>> 0, message.bankId.high >>> 0).toNumber() : message.bankId;
      if (message.username != null && message.hasOwnProperty("username"))
        object.username = message.username;
      if (message.fullname != null && message.hasOwnProperty("fullname"))
        object.fullname = message.fullname;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      return object;
    };
    UserEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return UserEvent;
  }();
  events2.ContractEvent = function() {
    function ContractEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ContractEvent.prototype.investorId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ContractEvent.prototype.fullname = "";
    ContractEvent.prototype.identificationFront = "";
    ContractEvent.prototype.identificationBack = "";
    ContractEvent.create = function create(properties) {
      return new ContractEvent(properties);
    };
    ContractEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(8).int64(message.investorId);
      if (message.fullname != null && Object.hasOwnProperty.call(message, "fullname"))
        writer.uint32(18).string(message.fullname);
      if (message.identificationFront != null && Object.hasOwnProperty.call(message, "identificationFront"))
        writer.uint32(26).string(message.identificationFront);
      if (message.identificationBack != null && Object.hasOwnProperty.call(message, "identificationBack"))
        writer.uint32(34).string(message.identificationBack);
      return writer;
    };
    ContractEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ContractEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.events.ContractEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.int64();
            break;
          case 2:
            message.fullname = reader.string();
            break;
          case 3:
            message.identificationFront = reader.string();
            break;
          case 4:
            message.identificationBack = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ContractEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ContractEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isInteger(message.investorId) && !(message.investorId && $util.isInteger(message.investorId.low) && $util.isInteger(message.investorId.high)))
          return "investorId: integer|Long expected";
      }
      if (message.fullname != null && message.hasOwnProperty("fullname")) {
        if (!$util.isString(message.fullname))
          return "fullname: string expected";
      }
      if (message.identificationFront != null && message.hasOwnProperty("identificationFront")) {
        if (!$util.isString(message.identificationFront))
          return "identificationFront: string expected";
      }
      if (message.identificationBack != null && message.hasOwnProperty("identificationBack")) {
        if (!$util.isString(message.identificationBack))
          return "identificationBack: string expected";
      }
      return null;
    };
    ContractEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.events.ContractEvent)
        return object;
      let message = new $root.events.ContractEvent();
      if (object.investorId != null) {
        if ($util.Long)
          (message.investorId = $util.Long.fromValue(object.investorId)).unsigned = false;
        else if (typeof object.investorId === "string")
          message.investorId = parseInt(object.investorId, 10);
        else if (typeof object.investorId === "number")
          message.investorId = object.investorId;
        else if (typeof object.investorId === "object")
          message.investorId = new $util.LongBits(object.investorId.low >>> 0, object.investorId.high >>> 0).toNumber();
      }
      if (object.fullname != null)
        message.fullname = String(object.fullname);
      if (object.identificationFront != null)
        message.identificationFront = String(object.identificationFront);
      if (object.identificationBack != null)
        message.identificationBack = String(object.identificationBack);
      return message;
    };
    ContractEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.investorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.investorId = options.longs === String ? "0" : 0;
        object.fullname = "";
        object.identificationFront = "";
        object.identificationBack = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        if (typeof message.investorId === "number")
          object.investorId = options.longs === String ? String(message.investorId) : message.investorId;
        else
          object.investorId = options.longs === String ? $util.Long.prototype.toString.call(message.investorId) : options.longs === Number ? new $util.LongBits(message.investorId.low >>> 0, message.investorId.high >>> 0).toNumber() : message.investorId;
      if (message.fullname != null && message.hasOwnProperty("fullname"))
        object.fullname = message.fullname;
      if (message.identificationFront != null && message.hasOwnProperty("identificationFront"))
        object.identificationFront = message.identificationFront;
      if (message.identificationBack != null && message.hasOwnProperty("identificationBack"))
        object.identificationBack = message.identificationBack;
      return object;
    };
    ContractEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ContractEvent;
  }();
  return events2;
})();
const enbox = $root.enbox = (() => {
  const enbox2 = {};
  enbox2.NotificationBadgeType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_BADGE_TYPE"] = 0;
    values[valuesById[1] = "GROUP"] = 1;
    values[valuesById[2] = "ALL"] = 2;
    return values;
  }();
  enbox2.EnboxNotificationBadge = function() {
    function EnboxNotificationBadge(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EnboxNotificationBadge.prototype.type = 0;
    EnboxNotificationBadge.prototype.env = "";
    EnboxNotificationBadge.prototype.userId = "";
    EnboxNotificationBadge.prototype.groupId = "";
    EnboxNotificationBadge.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EnboxNotificationBadge.prototype.modifiedDate = null;
    EnboxNotificationBadge.create = function create(properties) {
      return new EnboxNotificationBadge(properties);
    };
    EnboxNotificationBadge.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.env != null && Object.hasOwnProperty.call(message, "env"))
        writer.uint32(18).string(message.env);
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(26).string(message.userId);
      if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
        writer.uint32(34).string(message.groupId);
      if (message.count != null && Object.hasOwnProperty.call(message, "count"))
        writer.uint32(40).int64(message.count);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    EnboxNotificationBadge.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EnboxNotificationBadge.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.enbox.EnboxNotificationBadge();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.env = reader.string();
            break;
          case 3:
            message.userId = reader.string();
            break;
          case 4:
            message.groupId = reader.string();
            break;
          case 5:
            message.count = reader.int64();
            break;
          case 6:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EnboxNotificationBadge.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EnboxNotificationBadge.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.env != null && message.hasOwnProperty("env")) {
        if (!$util.isString(message.env))
          return "env: string expected";
      }
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isString(message.userId))
          return "userId: string expected";
      }
      if (message.groupId != null && message.hasOwnProperty("groupId")) {
        if (!$util.isString(message.groupId))
          return "groupId: string expected";
      }
      if (message.count != null && message.hasOwnProperty("count")) {
        if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
          return "count: integer|Long expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    EnboxNotificationBadge.fromObject = function fromObject(object) {
      if (object instanceof $root.enbox.EnboxNotificationBadge)
        return object;
      let message = new $root.enbox.EnboxNotificationBadge();
      switch (object.type) {
        case "UNKNOWN_BADGE_TYPE":
        case 0:
          message.type = 0;
          break;
        case "GROUP":
        case 1:
          message.type = 1;
          break;
        case "ALL":
        case 2:
          message.type = 2;
          break;
      }
      if (object.env != null)
        message.env = String(object.env);
      if (object.userId != null)
        message.userId = String(object.userId);
      if (object.groupId != null)
        message.groupId = String(object.groupId);
      if (object.count != null) {
        if ($util.Long)
          (message.count = $util.Long.fromValue(object.count)).unsigned = false;
        else if (typeof object.count === "string")
          message.count = parseInt(object.count, 10);
        else if (typeof object.count === "number")
          message.count = object.count;
        else if (typeof object.count === "object")
          message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".enbox.EnboxNotificationBadge.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    EnboxNotificationBadge.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? "UNKNOWN_BADGE_TYPE" : 0;
        object.env = "";
        object.userId = "";
        object.groupId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.count = options.longs === String ? "0" : 0;
        object.modifiedDate = null;
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.enbox.NotificationBadgeType[message.type] : message.type;
      if (message.env != null && message.hasOwnProperty("env"))
        object.env = message.env;
      if (message.userId != null && message.hasOwnProperty("userId"))
        object.userId = message.userId;
      if (message.groupId != null && message.hasOwnProperty("groupId"))
        object.groupId = message.groupId;
      if (message.count != null && message.hasOwnProperty("count"))
        if (typeof message.count === "number")
          object.count = options.longs === String ? String(message.count) : message.count;
        else
          object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    EnboxNotificationBadge.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EnboxNotificationBadge;
  }();
  return enbox2;
})();
const dnse = $root.dnse = (() => {
  const dnse2 = {};
  dnse2.TransferType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "TRANSFER_TYPE_UNSPECIFIED"] = 0;
    values[valuesById[1] = "TRANSFER_TYPE_FREE_GIFT"] = 1;
    values[valuesById[2] = "TRANSFER_TYPE_PEER_TRANSFER"] = 2;
    values[valuesById[3] = "TRANSFER_TYPE_PARTNER_PEER_TRANSFER"] = 3;
    return values;
  }();
  dnse2.Status = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
    values[valuesById[1] = "STATUS_SUCCESS"] = 1;
    values[valuesById[2] = "STATUS_FAILED"] = 2;
    return values;
  }();
  dnse2.Step = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STEP_UNSPECIFIED"] = 0;
    values[valuesById[1] = "STEP_PLACE_SELL_ORDER"] = 1;
    values[valuesById[2] = "STEP_INCREASE_BUY_ACCOUNT_BALANCE"] = 2;
    values[valuesById[3] = "STEP_CONFIRM_SELL_ORDER"] = 3;
    values[valuesById[4] = "STEP_DONE"] = 4;
    return values;
  }();
  dnse2.StocksTransfer = function() {
    function StocksTransfer(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StocksTransfer.prototype.symbol = "";
    StocksTransfer.prototype.quantity = 0;
    StocksTransfer.prototype.price = 0;
    StocksTransfer.prototype.buyAccountNo = "";
    StocksTransfer.prototype.buyLoanPackageId = 0;
    StocksTransfer.prototype.buyFeeRate = 0;
    StocksTransfer.prototype.sellAccountNo = "";
    StocksTransfer.prototype.transferType = 0;
    StocksTransfer.prototype.sellLoanPackageId = 0;
    StocksTransfer.prototype.id = "";
    StocksTransfer.prototype.sourceBankAccountNo = "";
    StocksTransfer.prototype.storeName = "";
    StocksTransfer.prototype.description = "";
    StocksTransfer.prototype.createdAt = null;
    StocksTransfer.prototype.status = 0;
    StocksTransfer.prototype.step = null;
    StocksTransfer.prototype.errorMessage = null;
    StocksTransfer.prototype.amount = 0;
    let $oneOfFields;
    Object.defineProperty(StocksTransfer.prototype, "_step", {
      get: $util.oneOfGetter($oneOfFields = ["step"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(StocksTransfer.prototype, "_errorMessage", {
      get: $util.oneOfGetter($oneOfFields = ["errorMessage"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    StocksTransfer.create = function create(properties) {
      return new StocksTransfer(properties);
    };
    StocksTransfer.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(16).uint32(message.quantity);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(24).uint32(message.price);
      if (message.buyAccountNo != null && Object.hasOwnProperty.call(message, "buyAccountNo"))
        writer.uint32(34).string(message.buyAccountNo);
      if (message.buyLoanPackageId != null && Object.hasOwnProperty.call(message, "buyLoanPackageId"))
        writer.uint32(40).uint32(message.buyLoanPackageId);
      if (message.buyFeeRate != null && Object.hasOwnProperty.call(message, "buyFeeRate"))
        writer.uint32(49).double(message.buyFeeRate);
      if (message.sellAccountNo != null && Object.hasOwnProperty.call(message, "sellAccountNo"))
        writer.uint32(58).string(message.sellAccountNo);
      if (message.transferType != null && Object.hasOwnProperty.call(message, "transferType"))
        writer.uint32(64).int32(message.transferType);
      if (message.sellLoanPackageId != null && Object.hasOwnProperty.call(message, "sellLoanPackageId"))
        writer.uint32(72).uint32(message.sellLoanPackageId);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(82).string(message.id);
      if (message.sourceBankAccountNo != null && Object.hasOwnProperty.call(message, "sourceBankAccountNo"))
        writer.uint32(90).string(message.sourceBankAccountNo);
      if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
        writer.uint32(98).string(message.storeName);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(106).string(message.description);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(114).fork()).ldelim();
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(120).int32(message.status);
      if (message.step != null && Object.hasOwnProperty.call(message, "step"))
        writer.uint32(128).int32(message.step);
      if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
        writer.uint32(138).string(message.errorMessage);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(145).double(message.amount);
      return writer;
    };
    StocksTransfer.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StocksTransfer.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.StocksTransfer();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.quantity = reader.uint32();
            break;
          case 3:
            message.price = reader.uint32();
            break;
          case 4:
            message.buyAccountNo = reader.string();
            break;
          case 5:
            message.buyLoanPackageId = reader.uint32();
            break;
          case 6:
            message.buyFeeRate = reader.double();
            break;
          case 7:
            message.sellAccountNo = reader.string();
            break;
          case 8:
            message.transferType = reader.int32();
            break;
          case 9:
            message.sellLoanPackageId = reader.uint32();
            break;
          case 10:
            message.id = reader.string();
            break;
          case 11:
            message.sourceBankAccountNo = reader.string();
            break;
          case 12:
            message.storeName = reader.string();
            break;
          case 13:
            message.description = reader.string();
            break;
          case 14:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 15:
            message.status = reader.int32();
            break;
          case 16:
            message.step = reader.int32();
            break;
          case 17:
            message.errorMessage = reader.string();
            break;
          case 18:
            message.amount = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StocksTransfer.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StocksTransfer.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity))
          return "quantity: integer expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (!$util.isInteger(message.price))
          return "price: integer expected";
      }
      if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo")) {
        if (!$util.isString(message.buyAccountNo))
          return "buyAccountNo: string expected";
      }
      if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId")) {
        if (!$util.isInteger(message.buyLoanPackageId))
          return "buyLoanPackageId: integer expected";
      }
      if (message.buyFeeRate != null && message.hasOwnProperty("buyFeeRate")) {
        if (typeof message.buyFeeRate !== "number")
          return "buyFeeRate: number expected";
      }
      if (message.sellAccountNo != null && message.hasOwnProperty("sellAccountNo")) {
        if (!$util.isString(message.sellAccountNo))
          return "sellAccountNo: string expected";
      }
      if (message.transferType != null && message.hasOwnProperty("transferType"))
        switch (message.transferType) {
          default:
            return "transferType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.sellLoanPackageId != null && message.hasOwnProperty("sellLoanPackageId")) {
        if (!$util.isInteger(message.sellLoanPackageId))
          return "sellLoanPackageId: integer expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.sourceBankAccountNo != null && message.hasOwnProperty("sourceBankAccountNo")) {
        if (!$util.isString(message.sourceBankAccountNo))
          return "sourceBankAccountNo: string expected";
      }
      if (message.storeName != null && message.hasOwnProperty("storeName")) {
        if (!$util.isString(message.storeName))
          return "storeName: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.step != null && message.hasOwnProperty("step")) {
        switch (message.step) {
          default:
            return "step: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      }
      if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
        if (!$util.isString(message.errorMessage))
          return "errorMessage: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      return null;
    };
    StocksTransfer.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.StocksTransfer)
        return object;
      let message = new $root.dnse.StocksTransfer();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.quantity != null)
        message.quantity = object.quantity >>> 0;
      if (object.price != null)
        message.price = object.price >>> 0;
      if (object.buyAccountNo != null)
        message.buyAccountNo = String(object.buyAccountNo);
      if (object.buyLoanPackageId != null)
        message.buyLoanPackageId = object.buyLoanPackageId >>> 0;
      if (object.buyFeeRate != null)
        message.buyFeeRate = Number(object.buyFeeRate);
      if (object.sellAccountNo != null)
        message.sellAccountNo = String(object.sellAccountNo);
      switch (object.transferType) {
        case "TRANSFER_TYPE_UNSPECIFIED":
        case 0:
          message.transferType = 0;
          break;
        case "TRANSFER_TYPE_FREE_GIFT":
        case 1:
          message.transferType = 1;
          break;
        case "TRANSFER_TYPE_PEER_TRANSFER":
        case 2:
          message.transferType = 2;
          break;
        case "TRANSFER_TYPE_PARTNER_PEER_TRANSFER":
        case 3:
          message.transferType = 3;
          break;
      }
      if (object.sellLoanPackageId != null)
        message.sellLoanPackageId = object.sellLoanPackageId >>> 0;
      if (object.id != null)
        message.id = String(object.id);
      if (object.sourceBankAccountNo != null)
        message.sourceBankAccountNo = String(object.sourceBankAccountNo);
      if (object.storeName != null)
        message.storeName = String(object.storeName);
      if (object.description != null)
        message.description = String(object.description);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.StocksTransfer.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      switch (object.status) {
        case "STATUS_UNSPECIFIED":
        case 0:
          message.status = 0;
          break;
        case "STATUS_SUCCESS":
        case 1:
          message.status = 1;
          break;
        case "STATUS_FAILED":
        case 2:
          message.status = 2;
          break;
      }
      switch (object.step) {
        case "STEP_UNSPECIFIED":
        case 0:
          message.step = 0;
          break;
        case "STEP_PLACE_SELL_ORDER":
        case 1:
          message.step = 1;
          break;
        case "STEP_INCREASE_BUY_ACCOUNT_BALANCE":
        case 2:
          message.step = 2;
          break;
        case "STEP_CONFIRM_SELL_ORDER":
        case 3:
          message.step = 3;
          break;
        case "STEP_DONE":
        case 4:
          message.step = 4;
          break;
      }
      if (object.errorMessage != null)
        message.errorMessage = String(object.errorMessage);
      if (object.amount != null)
        message.amount = Number(object.amount);
      return message;
    };
    StocksTransfer.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.quantity = 0;
        object.price = 0;
        object.buyAccountNo = "";
        object.buyLoanPackageId = 0;
        object.buyFeeRate = 0;
        object.sellAccountNo = "";
        object.transferType = options.enums === String ? "TRANSFER_TYPE_UNSPECIFIED" : 0;
        object.sellLoanPackageId = 0;
        object.id = "";
        object.sourceBankAccountNo = "";
        object.storeName = "";
        object.description = "";
        object.createdAt = null;
        object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
        object.amount = 0;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        object.quantity = message.quantity;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = message.price;
      if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo"))
        object.buyAccountNo = message.buyAccountNo;
      if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId"))
        object.buyLoanPackageId = message.buyLoanPackageId;
      if (message.buyFeeRate != null && message.hasOwnProperty("buyFeeRate"))
        object.buyFeeRate = options.json && !isFinite(message.buyFeeRate) ? String(message.buyFeeRate) : message.buyFeeRate;
      if (message.sellAccountNo != null && message.hasOwnProperty("sellAccountNo"))
        object.sellAccountNo = message.sellAccountNo;
      if (message.transferType != null && message.hasOwnProperty("transferType"))
        object.transferType = options.enums === String ? $root.dnse.TransferType[message.transferType] : message.transferType;
      if (message.sellLoanPackageId != null && message.hasOwnProperty("sellLoanPackageId"))
        object.sellLoanPackageId = message.sellLoanPackageId;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.sourceBankAccountNo != null && message.hasOwnProperty("sourceBankAccountNo"))
        object.sourceBankAccountNo = message.sourceBankAccountNo;
      if (message.storeName != null && message.hasOwnProperty("storeName"))
        object.storeName = message.storeName;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.Status[message.status] : message.status;
      if (message.step != null && message.hasOwnProperty("step")) {
        object.step = options.enums === String ? $root.dnse.Step[message.step] : message.step;
        if (options.oneofs)
          object._step = "step";
      }
      if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
        object.errorMessage = message.errorMessage;
        if (options.oneofs)
          object._errorMessage = "errorMessage";
      }
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      return object;
    };
    StocksTransfer.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StocksTransfer;
  }();
  dnse2.PartnerP2pGift = function() {
    function PartnerP2pGift(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    PartnerP2pGift.prototype.id = "";
    PartnerP2pGift.prototype.senderInvestorId = "";
    PartnerP2pGift.prototype.receiverInvestorId = "";
    PartnerP2pGift.prototype.receiverAccountNo = "";
    PartnerP2pGift.prototype.amount = 0;
    PartnerP2pGift.prototype.symbol = "";
    PartnerP2pGift.prototype.quantity = 0;
    PartnerP2pGift.prototype.expectedQuantity = 0;
    PartnerP2pGift.prototype.price = 0;
    PartnerP2pGift.prototype.expectedPrice = 0;
    PartnerP2pGift.prototype.averagePrice = 0;
    PartnerP2pGift.prototype.status = "";
    PartnerP2pGift.prototype.loanPackageId = 0;
    PartnerP2pGift.prototype.fillQuantity = 0;
    PartnerP2pGift.prototype.channel = "";
    PartnerP2pGift.prototype.createdAt = null;
    PartnerP2pGift.prototype.modifiedDate = null;
    PartnerP2pGift.create = function create(properties) {
      return new PartnerP2pGift(properties);
    };
    PartnerP2pGift.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.senderInvestorId != null && Object.hasOwnProperty.call(message, "senderInvestorId"))
        writer.uint32(18).string(message.senderInvestorId);
      if (message.receiverInvestorId != null && Object.hasOwnProperty.call(message, "receiverInvestorId"))
        writer.uint32(26).string(message.receiverInvestorId);
      if (message.receiverAccountNo != null && Object.hasOwnProperty.call(message, "receiverAccountNo"))
        writer.uint32(34).string(message.receiverAccountNo);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(41).double(message.amount);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(50).string(message.symbol);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(56).uint32(message.quantity);
      if (message.expectedQuantity != null && Object.hasOwnProperty.call(message, "expectedQuantity"))
        writer.uint32(64).uint32(message.expectedQuantity);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(73).double(message.price);
      if (message.expectedPrice != null && Object.hasOwnProperty.call(message, "expectedPrice"))
        writer.uint32(81).double(message.expectedPrice);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(89).double(message.averagePrice);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(98).string(message.status);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(104).uint32(message.loanPackageId);
      if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
        writer.uint32(112).uint32(message.fillQuantity);
      if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
        writer.uint32(122).string(message.channel);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(130).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(138).fork()).ldelim();
      return writer;
    };
    PartnerP2pGift.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    PartnerP2pGift.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.PartnerP2pGift();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.senderInvestorId = reader.string();
            break;
          case 3:
            message.receiverInvestorId = reader.string();
            break;
          case 4:
            message.receiverAccountNo = reader.string();
            break;
          case 5:
            message.amount = reader.double();
            break;
          case 6:
            message.symbol = reader.string();
            break;
          case 7:
            message.quantity = reader.uint32();
            break;
          case 8:
            message.expectedQuantity = reader.uint32();
            break;
          case 9:
            message.price = reader.double();
            break;
          case 10:
            message.expectedPrice = reader.double();
            break;
          case 11:
            message.averagePrice = reader.double();
            break;
          case 12:
            message.status = reader.string();
            break;
          case 13:
            message.loanPackageId = reader.uint32();
            break;
          case 14:
            message.fillQuantity = reader.uint32();
            break;
          case 15:
            message.channel = reader.string();
            break;
          case 16:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 17:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    PartnerP2pGift.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    PartnerP2pGift.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.senderInvestorId != null && message.hasOwnProperty("senderInvestorId")) {
        if (!$util.isString(message.senderInvestorId))
          return "senderInvestorId: string expected";
      }
      if (message.receiverInvestorId != null && message.hasOwnProperty("receiverInvestorId")) {
        if (!$util.isString(message.receiverInvestorId))
          return "receiverInvestorId: string expected";
      }
      if (message.receiverAccountNo != null && message.hasOwnProperty("receiverAccountNo")) {
        if (!$util.isString(message.receiverAccountNo))
          return "receiverAccountNo: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity))
          return "quantity: integer expected";
      }
      if (message.expectedQuantity != null && message.hasOwnProperty("expectedQuantity")) {
        if (!$util.isInteger(message.expectedQuantity))
          return "expectedQuantity: integer expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.expectedPrice != null && message.hasOwnProperty("expectedPrice")) {
        if (typeof message.expectedPrice !== "number")
          return "expectedPrice: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
        if (!$util.isInteger(message.fillQuantity))
          return "fillQuantity: integer expected";
      }
      if (message.channel != null && message.hasOwnProperty("channel")) {
        if (!$util.isString(message.channel))
          return "channel: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    PartnerP2pGift.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.PartnerP2pGift)
        return object;
      let message = new $root.dnse.PartnerP2pGift();
      if (object.id != null)
        message.id = String(object.id);
      if (object.senderInvestorId != null)
        message.senderInvestorId = String(object.senderInvestorId);
      if (object.receiverInvestorId != null)
        message.receiverInvestorId = String(object.receiverInvestorId);
      if (object.receiverAccountNo != null)
        message.receiverAccountNo = String(object.receiverAccountNo);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.quantity != null)
        message.quantity = object.quantity >>> 0;
      if (object.expectedQuantity != null)
        message.expectedQuantity = object.expectedQuantity >>> 0;
      if (object.price != null)
        message.price = Number(object.price);
      if (object.expectedPrice != null)
        message.expectedPrice = Number(object.expectedPrice);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.status != null)
        message.status = String(object.status);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId >>> 0;
      if (object.fillQuantity != null)
        message.fillQuantity = object.fillQuantity >>> 0;
      if (object.channel != null)
        message.channel = String(object.channel);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.PartnerP2pGift.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.PartnerP2pGift.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    PartnerP2pGift.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.senderInvestorId = "";
        object.receiverInvestorId = "";
        object.receiverAccountNo = "";
        object.amount = 0;
        object.symbol = "";
        object.quantity = 0;
        object.expectedQuantity = 0;
        object.price = 0;
        object.expectedPrice = 0;
        object.averagePrice = 0;
        object.status = "";
        object.loanPackageId = 0;
        object.fillQuantity = 0;
        object.channel = "";
        object.createdAt = null;
        object.modifiedDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.senderInvestorId != null && message.hasOwnProperty("senderInvestorId"))
        object.senderInvestorId = message.senderInvestorId;
      if (message.receiverInvestorId != null && message.hasOwnProperty("receiverInvestorId"))
        object.receiverInvestorId = message.receiverInvestorId;
      if (message.receiverAccountNo != null && message.hasOwnProperty("receiverAccountNo"))
        object.receiverAccountNo = message.receiverAccountNo;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        object.quantity = message.quantity;
      if (message.expectedQuantity != null && message.hasOwnProperty("expectedQuantity"))
        object.expectedQuantity = message.expectedQuantity;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.expectedPrice != null && message.hasOwnProperty("expectedPrice"))
        object.expectedPrice = options.json && !isFinite(message.expectedPrice) ? String(message.expectedPrice) : message.expectedPrice;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
        object.fillQuantity = message.fillQuantity;
      if (message.channel != null && message.hasOwnProperty("channel"))
        object.channel = message.channel;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    PartnerP2pGift.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return PartnerP2pGift;
  }();
  dnse2.EmailPayload = function() {
    function EmailPayload(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EmailPayload.prototype.dealRiskCallEvent = null;
    EmailPayload.prototype.dealRiskLiquidEvent = null;
    EmailPayload.prototype.dealRiskLiquidDelayEvent = null;
    EmailPayload.prototype.loanWarningEvent = null;
    EmailPayload.prototype.derivativeDealRiskWarningEvent = null;
    EmailPayload.prototype.derivativeMaturityEvent = null;
    EmailPayload.prototype.promoStockRewardEvent = null;
    EmailPayload.prototype.courseRegistrationSuccessEvent = null;
    EmailPayload.prototype.notifyUserChangeRequestResult = null;
    EmailPayload.prototype.welcomeNewDerivativeCustomerEvent = null;
    EmailPayload.prototype.brokerContractEvent = null;
    EmailPayload.prototype.careByContractEvent = null;
    EmailPayload.prototype.openMarginAccountSuccess = null;
    EmailPayload.prototype.internalCompanyPersonEvent = null;
    EmailPayload.prototype.corporateActionNotification = null;
    let $oneOfFields;
    Object.defineProperty(EmailPayload.prototype, "kind", {
      get: $util.oneOfGetter($oneOfFields = ["dealRiskCallEvent", "dealRiskLiquidEvent", "dealRiskLiquidDelayEvent", "loanWarningEvent", "derivativeDealRiskWarningEvent", "derivativeMaturityEvent", "promoStockRewardEvent", "courseRegistrationSuccessEvent", "notifyUserChangeRequestResult", "welcomeNewDerivativeCustomerEvent", "brokerContractEvent", "careByContractEvent", "openMarginAccountSuccess", "internalCompanyPersonEvent", "corporateActionNotification"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    EmailPayload.create = function create(properties) {
      return new EmailPayload(properties);
    };
    EmailPayload.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealRiskCallEvent != null && Object.hasOwnProperty.call(message, "dealRiskCallEvent"))
        $root.dnse.DealRiskCallEvent.encode(message.dealRiskCallEvent, writer.uint32(10).fork()).ldelim();
      if (message.dealRiskLiquidEvent != null && Object.hasOwnProperty.call(message, "dealRiskLiquidEvent"))
        $root.dnse.DealRiskLiquidEvent.encode(message.dealRiskLiquidEvent, writer.uint32(18).fork()).ldelim();
      if (message.dealRiskLiquidDelayEvent != null && Object.hasOwnProperty.call(message, "dealRiskLiquidDelayEvent"))
        $root.dnse.DealRiskLiquidDelayEvent.encode(message.dealRiskLiquidDelayEvent, writer.uint32(26).fork()).ldelim();
      if (message.loanWarningEvent != null && Object.hasOwnProperty.call(message, "loanWarningEvent"))
        $root.dnse.LoanWarningEvent.encode(message.loanWarningEvent, writer.uint32(34).fork()).ldelim();
      if (message.derivativeDealRiskWarningEvent != null && Object.hasOwnProperty.call(message, "derivativeDealRiskWarningEvent"))
        $root.dnse.fo.DerivativeDealRiskWarning.encode(message.derivativeDealRiskWarningEvent, writer.uint32(42).fork()).ldelim();
      if (message.derivativeMaturityEvent != null && Object.hasOwnProperty.call(message, "derivativeMaturityEvent"))
        $root.dnse.DerivativeMaturityEvent.encode(message.derivativeMaturityEvent, writer.uint32(50).fork()).ldelim();
      if (message.promoStockRewardEvent != null && Object.hasOwnProperty.call(message, "promoStockRewardEvent"))
        $root.dnse.StockRewardNotification.encode(message.promoStockRewardEvent, writer.uint32(58).fork()).ldelim();
      if (message.courseRegistrationSuccessEvent != null && Object.hasOwnProperty.call(message, "courseRegistrationSuccessEvent"))
        $root.dnse.CourseRegistrationSuccessEvent.encode(message.courseRegistrationSuccessEvent, writer.uint32(66).fork()).ldelim();
      if (message.notifyUserChangeRequestResult != null && Object.hasOwnProperty.call(message, "notifyUserChangeRequestResult"))
        $root.dnse.NotifyUserChangeRequestResult.encode(message.notifyUserChangeRequestResult, writer.uint32(74).fork()).ldelim();
      if (message.welcomeNewDerivativeCustomerEvent != null && Object.hasOwnProperty.call(message, "welcomeNewDerivativeCustomerEvent"))
        $root.dnse.WelcomeNewDerivativeCustomer.encode(message.welcomeNewDerivativeCustomerEvent, writer.uint32(82).fork()).ldelim();
      if (message.brokerContractEvent != null && Object.hasOwnProperty.call(message, "brokerContractEvent"))
        $root.dnse.broker.v1.BrokerContract.encode(message.brokerContractEvent, writer.uint32(90).fork()).ldelim();
      if (message.careByContractEvent != null && Object.hasOwnProperty.call(message, "careByContractEvent"))
        $root.dnse.broker.v1.CareByContract.encode(message.careByContractEvent, writer.uint32(98).fork()).ldelim();
      if (message.openMarginAccountSuccess != null && Object.hasOwnProperty.call(message, "openMarginAccountSuccess"))
        $root.dnse.OpenMarginAccountSuccess.encode(message.openMarginAccountSuccess, writer.uint32(106).fork()).ldelim();
      if (message.internalCompanyPersonEvent != null && Object.hasOwnProperty.call(message, "internalCompanyPersonEvent"))
        $root.dnse.InternalCompanyPersonEvent.encode(message.internalCompanyPersonEvent, writer.uint32(114).fork()).ldelim();
      if (message.corporateActionNotification != null && Object.hasOwnProperty.call(message, "corporateActionNotification"))
        $root.dnse.fo.CorporateActionNotification.encode(message.corporateActionNotification, writer.uint32(122).fork()).ldelim();
      return writer;
    };
    EmailPayload.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EmailPayload.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EmailPayload();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealRiskCallEvent = $root.dnse.DealRiskCallEvent.decode(reader, reader.uint32());
            break;
          case 2:
            message.dealRiskLiquidEvent = $root.dnse.DealRiskLiquidEvent.decode(reader, reader.uint32());
            break;
          case 3:
            message.dealRiskLiquidDelayEvent = $root.dnse.DealRiskLiquidDelayEvent.decode(reader, reader.uint32());
            break;
          case 4:
            message.loanWarningEvent = $root.dnse.LoanWarningEvent.decode(reader, reader.uint32());
            break;
          case 5:
            message.derivativeDealRiskWarningEvent = $root.dnse.fo.DerivativeDealRiskWarning.decode(reader, reader.uint32());
            break;
          case 6:
            message.derivativeMaturityEvent = $root.dnse.DerivativeMaturityEvent.decode(reader, reader.uint32());
            break;
          case 7:
            message.promoStockRewardEvent = $root.dnse.StockRewardNotification.decode(reader, reader.uint32());
            break;
          case 8:
            message.courseRegistrationSuccessEvent = $root.dnse.CourseRegistrationSuccessEvent.decode(reader, reader.uint32());
            break;
          case 9:
            message.notifyUserChangeRequestResult = $root.dnse.NotifyUserChangeRequestResult.decode(reader, reader.uint32());
            break;
          case 10:
            message.welcomeNewDerivativeCustomerEvent = $root.dnse.WelcomeNewDerivativeCustomer.decode(reader, reader.uint32());
            break;
          case 11:
            message.brokerContractEvent = $root.dnse.broker.v1.BrokerContract.decode(reader, reader.uint32());
            break;
          case 12:
            message.careByContractEvent = $root.dnse.broker.v1.CareByContract.decode(reader, reader.uint32());
            break;
          case 13:
            message.openMarginAccountSuccess = $root.dnse.OpenMarginAccountSuccess.decode(reader, reader.uint32());
            break;
          case 14:
            message.internalCompanyPersonEvent = $root.dnse.InternalCompanyPersonEvent.decode(reader, reader.uint32());
            break;
          case 15:
            message.corporateActionNotification = $root.dnse.fo.CorporateActionNotification.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EmailPayload.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EmailPayload.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      let properties = {};
      if (message.dealRiskCallEvent != null && message.hasOwnProperty("dealRiskCallEvent")) {
        properties.kind = 1;
        {
          let error = $root.dnse.DealRiskCallEvent.verify(message.dealRiskCallEvent);
          if (error)
            return "dealRiskCallEvent." + error;
        }
      }
      if (message.dealRiskLiquidEvent != null && message.hasOwnProperty("dealRiskLiquidEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.DealRiskLiquidEvent.verify(message.dealRiskLiquidEvent);
          if (error)
            return "dealRiskLiquidEvent." + error;
        }
      }
      if (message.dealRiskLiquidDelayEvent != null && message.hasOwnProperty("dealRiskLiquidDelayEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.DealRiskLiquidDelayEvent.verify(message.dealRiskLiquidDelayEvent);
          if (error)
            return "dealRiskLiquidDelayEvent." + error;
        }
      }
      if (message.loanWarningEvent != null && message.hasOwnProperty("loanWarningEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.LoanWarningEvent.verify(message.loanWarningEvent);
          if (error)
            return "loanWarningEvent." + error;
        }
      }
      if (message.derivativeDealRiskWarningEvent != null && message.hasOwnProperty("derivativeDealRiskWarningEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.fo.DerivativeDealRiskWarning.verify(message.derivativeDealRiskWarningEvent);
          if (error)
            return "derivativeDealRiskWarningEvent." + error;
        }
      }
      if (message.derivativeMaturityEvent != null && message.hasOwnProperty("derivativeMaturityEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.DerivativeMaturityEvent.verify(message.derivativeMaturityEvent);
          if (error)
            return "derivativeMaturityEvent." + error;
        }
      }
      if (message.promoStockRewardEvent != null && message.hasOwnProperty("promoStockRewardEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.StockRewardNotification.verify(message.promoStockRewardEvent);
          if (error)
            return "promoStockRewardEvent." + error;
        }
      }
      if (message.courseRegistrationSuccessEvent != null && message.hasOwnProperty("courseRegistrationSuccessEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.CourseRegistrationSuccessEvent.verify(message.courseRegistrationSuccessEvent);
          if (error)
            return "courseRegistrationSuccessEvent." + error;
        }
      }
      if (message.notifyUserChangeRequestResult != null && message.hasOwnProperty("notifyUserChangeRequestResult")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.NotifyUserChangeRequestResult.verify(message.notifyUserChangeRequestResult);
          if (error)
            return "notifyUserChangeRequestResult." + error;
        }
      }
      if (message.welcomeNewDerivativeCustomerEvent != null && message.hasOwnProperty("welcomeNewDerivativeCustomerEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.WelcomeNewDerivativeCustomer.verify(message.welcomeNewDerivativeCustomerEvent);
          if (error)
            return "welcomeNewDerivativeCustomerEvent." + error;
        }
      }
      if (message.brokerContractEvent != null && message.hasOwnProperty("brokerContractEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.broker.v1.BrokerContract.verify(message.brokerContractEvent);
          if (error)
            return "brokerContractEvent." + error;
        }
      }
      if (message.careByContractEvent != null && message.hasOwnProperty("careByContractEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.broker.v1.CareByContract.verify(message.careByContractEvent);
          if (error)
            return "careByContractEvent." + error;
        }
      }
      if (message.openMarginAccountSuccess != null && message.hasOwnProperty("openMarginAccountSuccess")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.OpenMarginAccountSuccess.verify(message.openMarginAccountSuccess);
          if (error)
            return "openMarginAccountSuccess." + error;
        }
      }
      if (message.internalCompanyPersonEvent != null && message.hasOwnProperty("internalCompanyPersonEvent")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.InternalCompanyPersonEvent.verify(message.internalCompanyPersonEvent);
          if (error)
            return "internalCompanyPersonEvent." + error;
        }
      }
      if (message.corporateActionNotification != null && message.hasOwnProperty("corporateActionNotification")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.fo.CorporateActionNotification.verify(message.corporateActionNotification);
          if (error)
            return "corporateActionNotification." + error;
        }
      }
      return null;
    };
    EmailPayload.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EmailPayload)
        return object;
      let message = new $root.dnse.EmailPayload();
      if (object.dealRiskCallEvent != null) {
        if (typeof object.dealRiskCallEvent !== "object")
          throw TypeError(".dnse.EmailPayload.dealRiskCallEvent: object expected");
        message.dealRiskCallEvent = $root.dnse.DealRiskCallEvent.fromObject(object.dealRiskCallEvent);
      }
      if (object.dealRiskLiquidEvent != null) {
        if (typeof object.dealRiskLiquidEvent !== "object")
          throw TypeError(".dnse.EmailPayload.dealRiskLiquidEvent: object expected");
        message.dealRiskLiquidEvent = $root.dnse.DealRiskLiquidEvent.fromObject(object.dealRiskLiquidEvent);
      }
      if (object.dealRiskLiquidDelayEvent != null) {
        if (typeof object.dealRiskLiquidDelayEvent !== "object")
          throw TypeError(".dnse.EmailPayload.dealRiskLiquidDelayEvent: object expected");
        message.dealRiskLiquidDelayEvent = $root.dnse.DealRiskLiquidDelayEvent.fromObject(object.dealRiskLiquidDelayEvent);
      }
      if (object.loanWarningEvent != null) {
        if (typeof object.loanWarningEvent !== "object")
          throw TypeError(".dnse.EmailPayload.loanWarningEvent: object expected");
        message.loanWarningEvent = $root.dnse.LoanWarningEvent.fromObject(object.loanWarningEvent);
      }
      if (object.derivativeDealRiskWarningEvent != null) {
        if (typeof object.derivativeDealRiskWarningEvent !== "object")
          throw TypeError(".dnse.EmailPayload.derivativeDealRiskWarningEvent: object expected");
        message.derivativeDealRiskWarningEvent = $root.dnse.fo.DerivativeDealRiskWarning.fromObject(object.derivativeDealRiskWarningEvent);
      }
      if (object.derivativeMaturityEvent != null) {
        if (typeof object.derivativeMaturityEvent !== "object")
          throw TypeError(".dnse.EmailPayload.derivativeMaturityEvent: object expected");
        message.derivativeMaturityEvent = $root.dnse.DerivativeMaturityEvent.fromObject(object.derivativeMaturityEvent);
      }
      if (object.promoStockRewardEvent != null) {
        if (typeof object.promoStockRewardEvent !== "object")
          throw TypeError(".dnse.EmailPayload.promoStockRewardEvent: object expected");
        message.promoStockRewardEvent = $root.dnse.StockRewardNotification.fromObject(object.promoStockRewardEvent);
      }
      if (object.courseRegistrationSuccessEvent != null) {
        if (typeof object.courseRegistrationSuccessEvent !== "object")
          throw TypeError(".dnse.EmailPayload.courseRegistrationSuccessEvent: object expected");
        message.courseRegistrationSuccessEvent = $root.dnse.CourseRegistrationSuccessEvent.fromObject(object.courseRegistrationSuccessEvent);
      }
      if (object.notifyUserChangeRequestResult != null) {
        if (typeof object.notifyUserChangeRequestResult !== "object")
          throw TypeError(".dnse.EmailPayload.notifyUserChangeRequestResult: object expected");
        message.notifyUserChangeRequestResult = $root.dnse.NotifyUserChangeRequestResult.fromObject(object.notifyUserChangeRequestResult);
      }
      if (object.welcomeNewDerivativeCustomerEvent != null) {
        if (typeof object.welcomeNewDerivativeCustomerEvent !== "object")
          throw TypeError(".dnse.EmailPayload.welcomeNewDerivativeCustomerEvent: object expected");
        message.welcomeNewDerivativeCustomerEvent = $root.dnse.WelcomeNewDerivativeCustomer.fromObject(object.welcomeNewDerivativeCustomerEvent);
      }
      if (object.brokerContractEvent != null) {
        if (typeof object.brokerContractEvent !== "object")
          throw TypeError(".dnse.EmailPayload.brokerContractEvent: object expected");
        message.brokerContractEvent = $root.dnse.broker.v1.BrokerContract.fromObject(object.brokerContractEvent);
      }
      if (object.careByContractEvent != null) {
        if (typeof object.careByContractEvent !== "object")
          throw TypeError(".dnse.EmailPayload.careByContractEvent: object expected");
        message.careByContractEvent = $root.dnse.broker.v1.CareByContract.fromObject(object.careByContractEvent);
      }
      if (object.openMarginAccountSuccess != null) {
        if (typeof object.openMarginAccountSuccess !== "object")
          throw TypeError(".dnse.EmailPayload.openMarginAccountSuccess: object expected");
        message.openMarginAccountSuccess = $root.dnse.OpenMarginAccountSuccess.fromObject(object.openMarginAccountSuccess);
      }
      if (object.internalCompanyPersonEvent != null) {
        if (typeof object.internalCompanyPersonEvent !== "object")
          throw TypeError(".dnse.EmailPayload.internalCompanyPersonEvent: object expected");
        message.internalCompanyPersonEvent = $root.dnse.InternalCompanyPersonEvent.fromObject(object.internalCompanyPersonEvent);
      }
      if (object.corporateActionNotification != null) {
        if (typeof object.corporateActionNotification !== "object")
          throw TypeError(".dnse.EmailPayload.corporateActionNotification: object expected");
        message.corporateActionNotification = $root.dnse.fo.CorporateActionNotification.fromObject(object.corporateActionNotification);
      }
      return message;
    };
    EmailPayload.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (message.dealRiskCallEvent != null && message.hasOwnProperty("dealRiskCallEvent")) {
        object.dealRiskCallEvent = $root.dnse.DealRiskCallEvent.toObject(message.dealRiskCallEvent, options);
        if (options.oneofs)
          object.kind = "dealRiskCallEvent";
      }
      if (message.dealRiskLiquidEvent != null && message.hasOwnProperty("dealRiskLiquidEvent")) {
        object.dealRiskLiquidEvent = $root.dnse.DealRiskLiquidEvent.toObject(message.dealRiskLiquidEvent, options);
        if (options.oneofs)
          object.kind = "dealRiskLiquidEvent";
      }
      if (message.dealRiskLiquidDelayEvent != null && message.hasOwnProperty("dealRiskLiquidDelayEvent")) {
        object.dealRiskLiquidDelayEvent = $root.dnse.DealRiskLiquidDelayEvent.toObject(message.dealRiskLiquidDelayEvent, options);
        if (options.oneofs)
          object.kind = "dealRiskLiquidDelayEvent";
      }
      if (message.loanWarningEvent != null && message.hasOwnProperty("loanWarningEvent")) {
        object.loanWarningEvent = $root.dnse.LoanWarningEvent.toObject(message.loanWarningEvent, options);
        if (options.oneofs)
          object.kind = "loanWarningEvent";
      }
      if (message.derivativeDealRiskWarningEvent != null && message.hasOwnProperty("derivativeDealRiskWarningEvent")) {
        object.derivativeDealRiskWarningEvent = $root.dnse.fo.DerivativeDealRiskWarning.toObject(message.derivativeDealRiskWarningEvent, options);
        if (options.oneofs)
          object.kind = "derivativeDealRiskWarningEvent";
      }
      if (message.derivativeMaturityEvent != null && message.hasOwnProperty("derivativeMaturityEvent")) {
        object.derivativeMaturityEvent = $root.dnse.DerivativeMaturityEvent.toObject(message.derivativeMaturityEvent, options);
        if (options.oneofs)
          object.kind = "derivativeMaturityEvent";
      }
      if (message.promoStockRewardEvent != null && message.hasOwnProperty("promoStockRewardEvent")) {
        object.promoStockRewardEvent = $root.dnse.StockRewardNotification.toObject(message.promoStockRewardEvent, options);
        if (options.oneofs)
          object.kind = "promoStockRewardEvent";
      }
      if (message.courseRegistrationSuccessEvent != null && message.hasOwnProperty("courseRegistrationSuccessEvent")) {
        object.courseRegistrationSuccessEvent = $root.dnse.CourseRegistrationSuccessEvent.toObject(message.courseRegistrationSuccessEvent, options);
        if (options.oneofs)
          object.kind = "courseRegistrationSuccessEvent";
      }
      if (message.notifyUserChangeRequestResult != null && message.hasOwnProperty("notifyUserChangeRequestResult")) {
        object.notifyUserChangeRequestResult = $root.dnse.NotifyUserChangeRequestResult.toObject(message.notifyUserChangeRequestResult, options);
        if (options.oneofs)
          object.kind = "notifyUserChangeRequestResult";
      }
      if (message.welcomeNewDerivativeCustomerEvent != null && message.hasOwnProperty("welcomeNewDerivativeCustomerEvent")) {
        object.welcomeNewDerivativeCustomerEvent = $root.dnse.WelcomeNewDerivativeCustomer.toObject(message.welcomeNewDerivativeCustomerEvent, options);
        if (options.oneofs)
          object.kind = "welcomeNewDerivativeCustomerEvent";
      }
      if (message.brokerContractEvent != null && message.hasOwnProperty("brokerContractEvent")) {
        object.brokerContractEvent = $root.dnse.broker.v1.BrokerContract.toObject(message.brokerContractEvent, options);
        if (options.oneofs)
          object.kind = "brokerContractEvent";
      }
      if (message.careByContractEvent != null && message.hasOwnProperty("careByContractEvent")) {
        object.careByContractEvent = $root.dnse.broker.v1.CareByContract.toObject(message.careByContractEvent, options);
        if (options.oneofs)
          object.kind = "careByContractEvent";
      }
      if (message.openMarginAccountSuccess != null && message.hasOwnProperty("openMarginAccountSuccess")) {
        object.openMarginAccountSuccess = $root.dnse.OpenMarginAccountSuccess.toObject(message.openMarginAccountSuccess, options);
        if (options.oneofs)
          object.kind = "openMarginAccountSuccess";
      }
      if (message.internalCompanyPersonEvent != null && message.hasOwnProperty("internalCompanyPersonEvent")) {
        object.internalCompanyPersonEvent = $root.dnse.InternalCompanyPersonEvent.toObject(message.internalCompanyPersonEvent, options);
        if (options.oneofs)
          object.kind = "internalCompanyPersonEvent";
      }
      if (message.corporateActionNotification != null && message.hasOwnProperty("corporateActionNotification")) {
        object.corporateActionNotification = $root.dnse.fo.CorporateActionNotification.toObject(message.corporateActionNotification, options);
        if (options.oneofs)
          object.kind = "corporateActionNotification";
      }
      return object;
    };
    EmailPayload.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EmailPayload;
  }();
  dnse2.EmailType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "EMAIL_TYPE_UNKNOWN"] = 0;
    values[valuesById[1] = "EMAIL_TYPE_DEAL_RISK_CALL"] = 1;
    values[valuesById[2] = "EMAIL_TYPE_DEAL_RISK_LIQUID"] = 2;
    values[valuesById[3] = "EMAIL_TYPE_DEAL_RISK_LIQUID_DELAY"] = 3;
    values[valuesById[4] = "EMAIL_TYPE_LOAN_WARNING_DUE_DATE"] = 4;
    values[valuesById[5] = "EMAIL_TYPE_LOAN_OVER_DUE_DATE"] = 5;
    values[valuesById[6] = "EMAIL_TYPE_DERIVATIVE_DEAL_RISK_CALL"] = 6;
    values[valuesById[7] = "EMAIL_TYPE_DERIVATIVE_DEAL_RISK_LIQUIDATE"] = 7;
    values[valuesById[8] = "EMAIL_TYPE_DERIVATIVE_MATURITY"] = 8;
    values[valuesById[9] = "EMAIL_TYPE_PROMO_SR_REWARD_ONHOLD"] = 9;
    values[valuesById[10] = "EMAIL_TYPE_PROMO_SR_REWARD_RECEIVED"] = 10;
    values[valuesById[11] = "EMAIL_TYPE_COURSE_REGISTRATION_SUCCESS"] = 11;
    values[valuesById[12] = "EMAIL_TYPE_NOTIFY_USER_CHANGE_REQUEST_RESULT"] = 12;
    values[valuesById[13] = "EMAIL_TYPE_WELCOME_NEW_DERIVATIVE_CUSTOMER"] = 13;
    values[valuesById[14] = "EMAIL_TYPE_BROKER_NEWLY_JOINED"] = 14;
    values[valuesById[15] = "EMAIL_TYPE_CARE_BY_EVENT"] = 15;
    values[valuesById[16] = "EMAIL_TYPE_OPEN_MARGIN_ACCOUNT_SUCCESS"] = 16;
    values[valuesById[17] = "EMAIL_TYPE_INTERNAL_COMPANY_PERSON_EVENT"] = 17;
    values[valuesById[18] = "EMAIL_TYPE_LOAN_CALL_FORCE_SELL"] = 18;
    values[valuesById[19] = "EMAIL_TYPE_WARNING_UPDATE_INFORMATION"] = 19;
    values[valuesById[20] = "EMAIL_TYPE_ATTEND_SHAREHOLDERS_MEETING"] = 20;
    values[valuesById[21] = "EMAIL_TYPE_GATHER_SHAREHOLDER_OPINIONS"] = 21;
    return values;
  }();
  dnse2.Recipient = function() {
    function Recipient(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Recipient.prototype.name = "";
    Recipient.prototype.email = "";
    Recipient.create = function create(properties) {
      return new Recipient(properties);
    };
    Recipient.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(10).string(message.name);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(18).string(message.email);
      return writer;
    };
    Recipient.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Recipient.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Recipient();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.name = reader.string();
            break;
          case 2:
            message.email = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Recipient.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Recipient.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      return null;
    };
    Recipient.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Recipient)
        return object;
      let message = new $root.dnse.Recipient();
      if (object.name != null)
        message.name = String(object.name);
      if (object.email != null)
        message.email = String(object.email);
      return message;
    };
    Recipient.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.name = "";
        object.email = "";
      }
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      return object;
    };
    Recipient.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Recipient;
  }();
  dnse2.Email = function() {
    function Email(properties) {
      this.tos = [];
      this.ccs = [];
      this.bccs = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Email.prototype.emailType = 0;
    Email.prototype.data = null;
    Email.prototype.tos = $util.emptyArray;
    Email.prototype.ccs = $util.emptyArray;
    Email.prototype.bccs = $util.emptyArray;
    Email.create = function create(properties) {
      return new Email(properties);
    };
    Email.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.emailType != null && Object.hasOwnProperty.call(message, "emailType"))
        writer.uint32(8).int32(message.emailType);
      if (message.data != null && Object.hasOwnProperty.call(message, "data"))
        $root.dnse.EmailPayload.encode(message.data, writer.uint32(18).fork()).ldelim();
      if (message.tos != null && message.tos.length)
        for (let i = 0; i < message.tos.length; ++i)
          $root.dnse.Recipient.encode(message.tos[i], writer.uint32(26).fork()).ldelim();
      if (message.ccs != null && message.ccs.length)
        for (let i = 0; i < message.ccs.length; ++i)
          $root.dnse.Recipient.encode(message.ccs[i], writer.uint32(34).fork()).ldelim();
      if (message.bccs != null && message.bccs.length)
        for (let i = 0; i < message.bccs.length; ++i)
          $root.dnse.Recipient.encode(message.bccs[i], writer.uint32(42).fork()).ldelim();
      return writer;
    };
    Email.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Email.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Email();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.emailType = reader.int32();
            break;
          case 2:
            message.data = $root.dnse.EmailPayload.decode(reader, reader.uint32());
            break;
          case 3:
            if (!(message.tos && message.tos.length))
              message.tos = [];
            message.tos.push($root.dnse.Recipient.decode(reader, reader.uint32()));
            break;
          case 4:
            if (!(message.ccs && message.ccs.length))
              message.ccs = [];
            message.ccs.push($root.dnse.Recipient.decode(reader, reader.uint32()));
            break;
          case 5:
            if (!(message.bccs && message.bccs.length))
              message.bccs = [];
            message.bccs.push($root.dnse.Recipient.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Email.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Email.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.emailType != null && message.hasOwnProperty("emailType"))
        switch (message.emailType) {
          default:
            return "emailType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
            break;
        }
      if (message.data != null && message.hasOwnProperty("data")) {
        let error = $root.dnse.EmailPayload.verify(message.data);
        if (error)
          return "data." + error;
      }
      if (message.tos != null && message.hasOwnProperty("tos")) {
        if (!Array.isArray(message.tos))
          return "tos: array expected";
        for (let i = 0; i < message.tos.length; ++i) {
          let error = $root.dnse.Recipient.verify(message.tos[i]);
          if (error)
            return "tos." + error;
        }
      }
      if (message.ccs != null && message.hasOwnProperty("ccs")) {
        if (!Array.isArray(message.ccs))
          return "ccs: array expected";
        for (let i = 0; i < message.ccs.length; ++i) {
          let error = $root.dnse.Recipient.verify(message.ccs[i]);
          if (error)
            return "ccs." + error;
        }
      }
      if (message.bccs != null && message.hasOwnProperty("bccs")) {
        if (!Array.isArray(message.bccs))
          return "bccs: array expected";
        for (let i = 0; i < message.bccs.length; ++i) {
          let error = $root.dnse.Recipient.verify(message.bccs[i]);
          if (error)
            return "bccs." + error;
        }
      }
      return null;
    };
    Email.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Email)
        return object;
      let message = new $root.dnse.Email();
      switch (object.emailType) {
        case "EMAIL_TYPE_UNKNOWN":
        case 0:
          message.emailType = 0;
          break;
        case "EMAIL_TYPE_DEAL_RISK_CALL":
        case 1:
          message.emailType = 1;
          break;
        case "EMAIL_TYPE_DEAL_RISK_LIQUID":
        case 2:
          message.emailType = 2;
          break;
        case "EMAIL_TYPE_DEAL_RISK_LIQUID_DELAY":
        case 3:
          message.emailType = 3;
          break;
        case "EMAIL_TYPE_LOAN_WARNING_DUE_DATE":
        case 4:
          message.emailType = 4;
          break;
        case "EMAIL_TYPE_LOAN_OVER_DUE_DATE":
        case 5:
          message.emailType = 5;
          break;
        case "EMAIL_TYPE_DERIVATIVE_DEAL_RISK_CALL":
        case 6:
          message.emailType = 6;
          break;
        case "EMAIL_TYPE_DERIVATIVE_DEAL_RISK_LIQUIDATE":
        case 7:
          message.emailType = 7;
          break;
        case "EMAIL_TYPE_DERIVATIVE_MATURITY":
        case 8:
          message.emailType = 8;
          break;
        case "EMAIL_TYPE_PROMO_SR_REWARD_ONHOLD":
        case 9:
          message.emailType = 9;
          break;
        case "EMAIL_TYPE_PROMO_SR_REWARD_RECEIVED":
        case 10:
          message.emailType = 10;
          break;
        case "EMAIL_TYPE_COURSE_REGISTRATION_SUCCESS":
        case 11:
          message.emailType = 11;
          break;
        case "EMAIL_TYPE_NOTIFY_USER_CHANGE_REQUEST_RESULT":
        case 12:
          message.emailType = 12;
          break;
        case "EMAIL_TYPE_WELCOME_NEW_DERIVATIVE_CUSTOMER":
        case 13:
          message.emailType = 13;
          break;
        case "EMAIL_TYPE_BROKER_NEWLY_JOINED":
        case 14:
          message.emailType = 14;
          break;
        case "EMAIL_TYPE_CARE_BY_EVENT":
        case 15:
          message.emailType = 15;
          break;
        case "EMAIL_TYPE_OPEN_MARGIN_ACCOUNT_SUCCESS":
        case 16:
          message.emailType = 16;
          break;
        case "EMAIL_TYPE_INTERNAL_COMPANY_PERSON_EVENT":
        case 17:
          message.emailType = 17;
          break;
        case "EMAIL_TYPE_LOAN_CALL_FORCE_SELL":
        case 18:
          message.emailType = 18;
          break;
        case "EMAIL_TYPE_WARNING_UPDATE_INFORMATION":
        case 19:
          message.emailType = 19;
          break;
        case "EMAIL_TYPE_ATTEND_SHAREHOLDERS_MEETING":
        case 20:
          message.emailType = 20;
          break;
        case "EMAIL_TYPE_GATHER_SHAREHOLDER_OPINIONS":
        case 21:
          message.emailType = 21;
          break;
      }
      if (object.data != null) {
        if (typeof object.data !== "object")
          throw TypeError(".dnse.Email.data: object expected");
        message.data = $root.dnse.EmailPayload.fromObject(object.data);
      }
      if (object.tos) {
        if (!Array.isArray(object.tos))
          throw TypeError(".dnse.Email.tos: array expected");
        message.tos = [];
        for (let i = 0; i < object.tos.length; ++i) {
          if (typeof object.tos[i] !== "object")
            throw TypeError(".dnse.Email.tos: object expected");
          message.tos[i] = $root.dnse.Recipient.fromObject(object.tos[i]);
        }
      }
      if (object.ccs) {
        if (!Array.isArray(object.ccs))
          throw TypeError(".dnse.Email.ccs: array expected");
        message.ccs = [];
        for (let i = 0; i < object.ccs.length; ++i) {
          if (typeof object.ccs[i] !== "object")
            throw TypeError(".dnse.Email.ccs: object expected");
          message.ccs[i] = $root.dnse.Recipient.fromObject(object.ccs[i]);
        }
      }
      if (object.bccs) {
        if (!Array.isArray(object.bccs))
          throw TypeError(".dnse.Email.bccs: array expected");
        message.bccs = [];
        for (let i = 0; i < object.bccs.length; ++i) {
          if (typeof object.bccs[i] !== "object")
            throw TypeError(".dnse.Email.bccs: object expected");
          message.bccs[i] = $root.dnse.Recipient.fromObject(object.bccs[i]);
        }
      }
      return message;
    };
    Email.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.tos = [];
        object.ccs = [];
        object.bccs = [];
      }
      if (options.defaults) {
        object.emailType = options.enums === String ? "EMAIL_TYPE_UNKNOWN" : 0;
        object.data = null;
      }
      if (message.emailType != null && message.hasOwnProperty("emailType"))
        object.emailType = options.enums === String ? $root.dnse.EmailType[message.emailType] : message.emailType;
      if (message.data != null && message.hasOwnProperty("data"))
        object.data = $root.dnse.EmailPayload.toObject(message.data, options);
      if (message.tos && message.tos.length) {
        object.tos = [];
        for (let j = 0; j < message.tos.length; ++j)
          object.tos[j] = $root.dnse.Recipient.toObject(message.tos[j], options);
      }
      if (message.ccs && message.ccs.length) {
        object.ccs = [];
        for (let j = 0; j < message.ccs.length; ++j)
          object.ccs[j] = $root.dnse.Recipient.toObject(message.ccs[j], options);
      }
      if (message.bccs && message.bccs.length) {
        object.bccs = [];
        for (let j = 0; j < message.bccs.length; ++j)
          object.bccs[j] = $root.dnse.Recipient.toObject(message.bccs[j], options);
      }
      return object;
    };
    Email.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Email;
  }();
  dnse2.fo = function() {
    const fo = {};
    fo.Exchange = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_EXCHANGE"] = 0;
      values[valuesById[2] = "HNX"] = 2;
      values[valuesById[3] = "UPCOM"] = 3;
      values[valuesById[4] = "HNX_BOND"] = 4;
      values[valuesById[10] = "HOSE"] = 10;
      values[valuesById[11] = "HOSE_ODD_LOT"] = 11;
      values[valuesById[12] = "HNX_DERIVATIVE"] = 12;
      values[valuesById[13] = "HNX_DERIVATIVE_BOND"] = 13;
      values[valuesById[14] = "HNX_PRIVATE_BOND"] = 14;
      values[valuesById[30] = "OTC"] = 30;
      return values;
    }();
    fo.SecurityStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_STATUS"] = 0;
      values[valuesById[1] = "NORMAL"] = 1;
      values[valuesById[2] = "HALT"] = 2;
      values[valuesById[3] = "SUSPENDED"] = 3;
      values[valuesById[4] = "SPECIAL"] = 4;
      values[valuesById[5] = "UNLISTED"] = 5;
      values[valuesById[6] = "NEW"] = 6;
      values[valuesById[7] = "AOM_HALT"] = 7;
      values[valuesById[8] = "PUT_THROUGH_HALT"] = 8;
      return values;
    }();
    fo.SecurityType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_TYPE"] = 0;
      values[valuesById[1] = "STOCK"] = 1;
      values[valuesById[2] = "BOND"] = 2;
      values[valuesById[3] = "MUTUAL_FUND"] = 3;
      values[valuesById[4] = "ETF"] = 4;
      values[valuesById[5] = "FUTURE"] = 5;
      values[valuesById[6] = "OPTION"] = 6;
      values[valuesById[7] = "COVERED_WARRANT"] = 7;
      values[valuesById[8] = "FUTURE_INDEX"] = 8;
      values[valuesById[9] = "FUTURE_BOND"] = 9;
      values[valuesById[10] = "CORPORATE_BOND"] = 10;
      values[valuesById[11] = "PRIVATE_BOND"] = 11;
      values[valuesById[100] = "ALL"] = 100;
      return values;
    }();
    fo.Securities = function() {
      function Securities(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Securities.prototype.symbol = "";
      Securities.prototype.securityType = 0;
      Securities.prototype.floorCode = 0;
      Securities.prototype.basicPrice = 0;
      Securities.prototype.floorPrice = 0;
      Securities.prototype.ceilingPrice = 0;
      Securities.prototype.parValue = 0;
      Securities.prototype.securityStatus = 0;
      Securities.prototype.currentRoom = 0;
      Securities.prototype.oddLotSecurityStatus = 0;
      Securities.prototype.issuer = "";
      Securities.create = function create(properties) {
        return new Securities(properties);
      };
      Securities.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(10).string(message.symbol);
        if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
          writer.uint32(16).int32(message.securityType);
        if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
          writer.uint32(24).int32(message.floorCode);
        if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
          writer.uint32(33).double(message.basicPrice);
        if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
          writer.uint32(41).double(message.floorPrice);
        if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
          writer.uint32(49).double(message.ceilingPrice);
        if (message.parValue != null && Object.hasOwnProperty.call(message, "parValue"))
          writer.uint32(57).double(message.parValue);
        if (message.securityStatus != null && Object.hasOwnProperty.call(message, "securityStatus"))
          writer.uint32(64).int32(message.securityStatus);
        if (message.currentRoom != null && Object.hasOwnProperty.call(message, "currentRoom"))
          writer.uint32(73).double(message.currentRoom);
        if (message.oddLotSecurityStatus != null && Object.hasOwnProperty.call(message, "oddLotSecurityStatus"))
          writer.uint32(80).int32(message.oddLotSecurityStatus);
        if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
          writer.uint32(90).string(message.issuer);
        return writer;
      };
      Securities.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Securities.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Securities();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.symbol = reader.string();
              break;
            case 2:
              message.securityType = reader.int32();
              break;
            case 3:
              message.floorCode = reader.int32();
              break;
            case 4:
              message.basicPrice = reader.double();
              break;
            case 5:
              message.floorPrice = reader.double();
              break;
            case 6:
              message.ceilingPrice = reader.double();
              break;
            case 7:
              message.parValue = reader.double();
              break;
            case 8:
              message.securityStatus = reader.int32();
              break;
            case 9:
              message.currentRoom = reader.double();
              break;
            case 10:
              message.oddLotSecurityStatus = reader.int32();
              break;
            case 11:
              message.issuer = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Securities.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Securities.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          switch (message.securityType) {
            default:
              return "securityType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 100:
              break;
          }
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          switch (message.floorCode) {
            default:
              return "floorCode: enum value expected";
            case 0:
            case 2:
            case 3:
            case 4:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 30:
              break;
          }
        if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
          if (typeof message.basicPrice !== "number")
            return "basicPrice: number expected";
        }
        if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
          if (typeof message.floorPrice !== "number")
            return "floorPrice: number expected";
        }
        if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
          if (typeof message.ceilingPrice !== "number")
            return "ceilingPrice: number expected";
        }
        if (message.parValue != null && message.hasOwnProperty("parValue")) {
          if (typeof message.parValue !== "number")
            return "parValue: number expected";
        }
        if (message.securityStatus != null && message.hasOwnProperty("securityStatus"))
          switch (message.securityStatus) {
            default:
              return "securityStatus: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
              break;
          }
        if (message.currentRoom != null && message.hasOwnProperty("currentRoom")) {
          if (typeof message.currentRoom !== "number")
            return "currentRoom: number expected";
        }
        if (message.oddLotSecurityStatus != null && message.hasOwnProperty("oddLotSecurityStatus"))
          switch (message.oddLotSecurityStatus) {
            default:
              return "oddLotSecurityStatus: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
              break;
          }
        if (message.issuer != null && message.hasOwnProperty("issuer")) {
          if (!$util.isString(message.issuer))
            return "issuer: string expected";
        }
        return null;
      };
      Securities.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Securities)
          return object;
        let message = new $root.dnse.fo.Securities();
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        switch (object.securityType) {
          case "UNKNOWN_TYPE":
          case 0:
            message.securityType = 0;
            break;
          case "STOCK":
          case 1:
            message.securityType = 1;
            break;
          case "BOND":
          case 2:
            message.securityType = 2;
            break;
          case "MUTUAL_FUND":
          case 3:
            message.securityType = 3;
            break;
          case "ETF":
          case 4:
            message.securityType = 4;
            break;
          case "FUTURE":
          case 5:
            message.securityType = 5;
            break;
          case "OPTION":
          case 6:
            message.securityType = 6;
            break;
          case "COVERED_WARRANT":
          case 7:
            message.securityType = 7;
            break;
          case "FUTURE_INDEX":
          case 8:
            message.securityType = 8;
            break;
          case "FUTURE_BOND":
          case 9:
            message.securityType = 9;
            break;
          case "CORPORATE_BOND":
          case 10:
            message.securityType = 10;
            break;
          case "PRIVATE_BOND":
          case 11:
            message.securityType = 11;
            break;
          case "ALL":
          case 100:
            message.securityType = 100;
            break;
        }
        switch (object.floorCode) {
          case "UNKNOWN_EXCHANGE":
          case 0:
            message.floorCode = 0;
            break;
          case "HNX":
          case 2:
            message.floorCode = 2;
            break;
          case "UPCOM":
          case 3:
            message.floorCode = 3;
            break;
          case "HNX_BOND":
          case 4:
            message.floorCode = 4;
            break;
          case "HOSE":
          case 10:
            message.floorCode = 10;
            break;
          case "HOSE_ODD_LOT":
          case 11:
            message.floorCode = 11;
            break;
          case "HNX_DERIVATIVE":
          case 12:
            message.floorCode = 12;
            break;
          case "HNX_DERIVATIVE_BOND":
          case 13:
            message.floorCode = 13;
            break;
          case "HNX_PRIVATE_BOND":
          case 14:
            message.floorCode = 14;
            break;
          case "OTC":
          case 30:
            message.floorCode = 30;
            break;
        }
        if (object.basicPrice != null)
          message.basicPrice = Number(object.basicPrice);
        if (object.floorPrice != null)
          message.floorPrice = Number(object.floorPrice);
        if (object.ceilingPrice != null)
          message.ceilingPrice = Number(object.ceilingPrice);
        if (object.parValue != null)
          message.parValue = Number(object.parValue);
        switch (object.securityStatus) {
          case "UNKNOWN_STATUS":
          case 0:
            message.securityStatus = 0;
            break;
          case "NORMAL":
          case 1:
            message.securityStatus = 1;
            break;
          case "HALT":
          case 2:
            message.securityStatus = 2;
            break;
          case "SUSPENDED":
          case 3:
            message.securityStatus = 3;
            break;
          case "SPECIAL":
          case 4:
            message.securityStatus = 4;
            break;
          case "UNLISTED":
          case 5:
            message.securityStatus = 5;
            break;
          case "NEW":
          case 6:
            message.securityStatus = 6;
            break;
          case "AOM_HALT":
          case 7:
            message.securityStatus = 7;
            break;
          case "PUT_THROUGH_HALT":
          case 8:
            message.securityStatus = 8;
            break;
        }
        if (object.currentRoom != null)
          message.currentRoom = Number(object.currentRoom);
        switch (object.oddLotSecurityStatus) {
          case "UNKNOWN_STATUS":
          case 0:
            message.oddLotSecurityStatus = 0;
            break;
          case "NORMAL":
          case 1:
            message.oddLotSecurityStatus = 1;
            break;
          case "HALT":
          case 2:
            message.oddLotSecurityStatus = 2;
            break;
          case "SUSPENDED":
          case 3:
            message.oddLotSecurityStatus = 3;
            break;
          case "SPECIAL":
          case 4:
            message.oddLotSecurityStatus = 4;
            break;
          case "UNLISTED":
          case 5:
            message.oddLotSecurityStatus = 5;
            break;
          case "NEW":
          case 6:
            message.oddLotSecurityStatus = 6;
            break;
          case "AOM_HALT":
          case 7:
            message.oddLotSecurityStatus = 7;
            break;
          case "PUT_THROUGH_HALT":
          case 8:
            message.oddLotSecurityStatus = 8;
            break;
        }
        if (object.issuer != null)
          message.issuer = String(object.issuer);
        return message;
      };
      Securities.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = "";
          object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
          object.floorCode = options.enums === String ? "UNKNOWN_EXCHANGE" : 0;
          object.basicPrice = 0;
          object.floorPrice = 0;
          object.ceilingPrice = 0;
          object.parValue = 0;
          object.securityStatus = options.enums === String ? "UNKNOWN_STATUS" : 0;
          object.currentRoom = 0;
          object.oddLotSecurityStatus = options.enums === String ? "UNKNOWN_STATUS" : 0;
          object.issuer = "";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          object.securityType = options.enums === String ? $root.dnse.fo.SecurityType[message.securityType] : message.securityType;
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          object.floorCode = options.enums === String ? $root.dnse.fo.Exchange[message.floorCode] : message.floorCode;
        if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
          object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
        if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
          object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
        if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
          object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
        if (message.parValue != null && message.hasOwnProperty("parValue"))
          object.parValue = options.json && !isFinite(message.parValue) ? String(message.parValue) : message.parValue;
        if (message.securityStatus != null && message.hasOwnProperty("securityStatus"))
          object.securityStatus = options.enums === String ? $root.dnse.fo.SecurityStatus[message.securityStatus] : message.securityStatus;
        if (message.currentRoom != null && message.hasOwnProperty("currentRoom"))
          object.currentRoom = options.json && !isFinite(message.currentRoom) ? String(message.currentRoom) : message.currentRoom;
        if (message.oddLotSecurityStatus != null && message.hasOwnProperty("oddLotSecurityStatus"))
          object.oddLotSecurityStatus = options.enums === String ? $root.dnse.fo.SecurityStatus[message.oddLotSecurityStatus] : message.oddLotSecurityStatus;
        if (message.issuer != null && message.hasOwnProperty("issuer"))
          object.issuer = message.issuer;
        return object;
      };
      Securities.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Securities;
    }();
    fo.MarketSession = function() {
      function MarketSession(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      MarketSession.prototype.floorCode = "";
      MarketSession.prototype.tradingSessionStatus = "";
      MarketSession.create = function create(properties) {
        return new MarketSession(properties);
      };
      MarketSession.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
          writer.uint32(10).string(message.floorCode);
        if (message.tradingSessionStatus != null && Object.hasOwnProperty.call(message, "tradingSessionStatus"))
          writer.uint32(18).string(message.tradingSessionStatus);
        return writer;
      };
      MarketSession.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      MarketSession.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.MarketSession();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.floorCode = reader.string();
              break;
            case 2:
              message.tradingSessionStatus = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      MarketSession.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      MarketSession.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.floorCode != null && message.hasOwnProperty("floorCode")) {
          if (!$util.isString(message.floorCode))
            return "floorCode: string expected";
        }
        if (message.tradingSessionStatus != null && message.hasOwnProperty("tradingSessionStatus")) {
          if (!$util.isString(message.tradingSessionStatus))
            return "tradingSessionStatus: string expected";
        }
        return null;
      };
      MarketSession.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.MarketSession)
          return object;
        let message = new $root.dnse.fo.MarketSession();
        if (object.floorCode != null)
          message.floorCode = String(object.floorCode);
        if (object.tradingSessionStatus != null)
          message.tradingSessionStatus = String(object.tradingSessionStatus);
        return message;
      };
      MarketSession.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.floorCode = "";
          object.tradingSessionStatus = "";
        }
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          object.floorCode = message.floorCode;
        if (message.tradingSessionStatus != null && message.hasOwnProperty("tradingSessionStatus"))
          object.tradingSessionStatus = message.tradingSessionStatus;
        return object;
      };
      MarketSession.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return MarketSession;
    }();
    fo.Control = function() {
      function Control(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Control.prototype.value = "";
      Control.prototype.bizDate = "";
      Control.prototype.applyForDerivative = false;
      Control.create = function create(properties) {
        return new Control(properties);
      };
      Control.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(10).string(message.value);
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          writer.uint32(18).string(message.bizDate);
        if (message.applyForDerivative != null && Object.hasOwnProperty.call(message, "applyForDerivative"))
          writer.uint32(24).bool(message.applyForDerivative);
        return writer;
      };
      Control.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Control.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Control();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.string();
              break;
            case 2:
              message.bizDate = reader.string();
              break;
            case 3:
              message.applyForDerivative = reader.bool();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Control.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Control.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.value != null && message.hasOwnProperty("value")) {
          if (!$util.isString(message.value))
            return "value: string expected";
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          if (!$util.isString(message.bizDate))
            return "bizDate: string expected";
        }
        if (message.applyForDerivative != null && message.hasOwnProperty("applyForDerivative")) {
          if (typeof message.applyForDerivative !== "boolean")
            return "applyForDerivative: boolean expected";
        }
        return null;
      };
      Control.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Control)
          return object;
        let message = new $root.dnse.fo.Control();
        if (object.value != null)
          message.value = String(object.value);
        if (object.bizDate != null)
          message.bizDate = String(object.bizDate);
        if (object.applyForDerivative != null)
          message.applyForDerivative = Boolean(object.applyForDerivative);
        return message;
      };
      Control.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.value = "";
          object.bizDate = "";
          object.applyForDerivative = false;
        }
        if (message.value != null && message.hasOwnProperty("value"))
          object.value = message.value;
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = message.bizDate;
        if (message.applyForDerivative != null && message.hasOwnProperty("applyForDerivative"))
          object.applyForDerivative = message.applyForDerivative;
        return object;
      };
      Control.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Control;
    }();
    fo.SystemConfig = function() {
      function SystemConfig(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      SystemConfig.prototype.currentTradingDate = "";
      SystemConfig.prototype.nextTradingDate = "";
      SystemConfig.prototype.advanceDays = 0;
      SystemConfig.prototype.daysInYear = 0;
      SystemConfig.prototype.dividendTaxRate = 0;
      SystemConfig.prototype.t2 = "";
      SystemConfig.create = function create(properties) {
        return new SystemConfig(properties);
      };
      SystemConfig.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.currentTradingDate != null && Object.hasOwnProperty.call(message, "currentTradingDate"))
          writer.uint32(10).string(message.currentTradingDate);
        if (message.nextTradingDate != null && Object.hasOwnProperty.call(message, "nextTradingDate"))
          writer.uint32(18).string(message.nextTradingDate);
        if (message.advanceDays != null && Object.hasOwnProperty.call(message, "advanceDays"))
          writer.uint32(24).int32(message.advanceDays);
        if (message.daysInYear != null && Object.hasOwnProperty.call(message, "daysInYear"))
          writer.uint32(32).int32(message.daysInYear);
        if (message.dividendTaxRate != null && Object.hasOwnProperty.call(message, "dividendTaxRate"))
          writer.uint32(41).double(message.dividendTaxRate);
        if (message.t2 != null && Object.hasOwnProperty.call(message, "t2"))
          writer.uint32(50).string(message.t2);
        return writer;
      };
      SystemConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      SystemConfig.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.SystemConfig();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.currentTradingDate = reader.string();
              break;
            case 2:
              message.nextTradingDate = reader.string();
              break;
            case 3:
              message.advanceDays = reader.int32();
              break;
            case 4:
              message.daysInYear = reader.int32();
              break;
            case 5:
              message.dividendTaxRate = reader.double();
              break;
            case 6:
              message.t2 = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      SystemConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      SystemConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.currentTradingDate != null && message.hasOwnProperty("currentTradingDate")) {
          if (!$util.isString(message.currentTradingDate))
            return "currentTradingDate: string expected";
        }
        if (message.nextTradingDate != null && message.hasOwnProperty("nextTradingDate")) {
          if (!$util.isString(message.nextTradingDate))
            return "nextTradingDate: string expected";
        }
        if (message.advanceDays != null && message.hasOwnProperty("advanceDays")) {
          if (!$util.isInteger(message.advanceDays))
            return "advanceDays: integer expected";
        }
        if (message.daysInYear != null && message.hasOwnProperty("daysInYear")) {
          if (!$util.isInteger(message.daysInYear))
            return "daysInYear: integer expected";
        }
        if (message.dividendTaxRate != null && message.hasOwnProperty("dividendTaxRate")) {
          if (typeof message.dividendTaxRate !== "number")
            return "dividendTaxRate: number expected";
        }
        if (message.t2 != null && message.hasOwnProperty("t2")) {
          if (!$util.isString(message.t2))
            return "t2: string expected";
        }
        return null;
      };
      SystemConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.SystemConfig)
          return object;
        let message = new $root.dnse.fo.SystemConfig();
        if (object.currentTradingDate != null)
          message.currentTradingDate = String(object.currentTradingDate);
        if (object.nextTradingDate != null)
          message.nextTradingDate = String(object.nextTradingDate);
        if (object.advanceDays != null)
          message.advanceDays = object.advanceDays | 0;
        if (object.daysInYear != null)
          message.daysInYear = object.daysInYear | 0;
        if (object.dividendTaxRate != null)
          message.dividendTaxRate = Number(object.dividendTaxRate);
        if (object.t2 != null)
          message.t2 = String(object.t2);
        return message;
      };
      SystemConfig.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.currentTradingDate = "";
          object.nextTradingDate = "";
          object.advanceDays = 0;
          object.daysInYear = 0;
          object.dividendTaxRate = 0;
          object.t2 = "";
        }
        if (message.currentTradingDate != null && message.hasOwnProperty("currentTradingDate"))
          object.currentTradingDate = message.currentTradingDate;
        if (message.nextTradingDate != null && message.hasOwnProperty("nextTradingDate"))
          object.nextTradingDate = message.nextTradingDate;
        if (message.advanceDays != null && message.hasOwnProperty("advanceDays"))
          object.advanceDays = message.advanceDays;
        if (message.daysInYear != null && message.hasOwnProperty("daysInYear"))
          object.daysInYear = message.daysInYear;
        if (message.dividendTaxRate != null && message.hasOwnProperty("dividendTaxRate"))
          object.dividendTaxRate = options.json && !isFinite(message.dividendTaxRate) ? String(message.dividendTaxRate) : message.dividendTaxRate;
        if (message.t2 != null && message.hasOwnProperty("t2"))
          object.t2 = message.t2;
        return object;
      };
      SystemConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return SystemConfig;
    }();
    fo.MarginBasketItem = function() {
      function MarginBasketItem(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      MarginBasketItem.prototype.symbol = "";
      MarginBasketItem.prototype.marginLoanRate = 0;
      MarginBasketItem.prototype.marginLoanPrice = 0;
      MarginBasketItem.prototype.marginCollateralRate = 0;
      MarginBasketItem.prototype.marginCollateralPrice = 0;
      MarginBasketItem.create = function create(properties) {
        return new MarginBasketItem(properties);
      };
      MarginBasketItem.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(10).string(message.symbol);
        if (message.marginLoanRate != null && Object.hasOwnProperty.call(message, "marginLoanRate"))
          writer.uint32(17).double(message.marginLoanRate);
        if (message.marginLoanPrice != null && Object.hasOwnProperty.call(message, "marginLoanPrice"))
          writer.uint32(25).double(message.marginLoanPrice);
        if (message.marginCollateralRate != null && Object.hasOwnProperty.call(message, "marginCollateralRate"))
          writer.uint32(33).double(message.marginCollateralRate);
        if (message.marginCollateralPrice != null && Object.hasOwnProperty.call(message, "marginCollateralPrice"))
          writer.uint32(41).double(message.marginCollateralPrice);
        return writer;
      };
      MarginBasketItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      MarginBasketItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.MarginBasketItem();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.symbol = reader.string();
              break;
            case 2:
              message.marginLoanRate = reader.double();
              break;
            case 3:
              message.marginLoanPrice = reader.double();
              break;
            case 4:
              message.marginCollateralRate = reader.double();
              break;
            case 5:
              message.marginCollateralPrice = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      MarginBasketItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      MarginBasketItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.marginLoanRate != null && message.hasOwnProperty("marginLoanRate")) {
          if (typeof message.marginLoanRate !== "number")
            return "marginLoanRate: number expected";
        }
        if (message.marginLoanPrice != null && message.hasOwnProperty("marginLoanPrice")) {
          if (typeof message.marginLoanPrice !== "number")
            return "marginLoanPrice: number expected";
        }
        if (message.marginCollateralRate != null && message.hasOwnProperty("marginCollateralRate")) {
          if (typeof message.marginCollateralRate !== "number")
            return "marginCollateralRate: number expected";
        }
        if (message.marginCollateralPrice != null && message.hasOwnProperty("marginCollateralPrice")) {
          if (typeof message.marginCollateralPrice !== "number")
            return "marginCollateralPrice: number expected";
        }
        return null;
      };
      MarginBasketItem.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.MarginBasketItem)
          return object;
        let message = new $root.dnse.fo.MarginBasketItem();
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.marginLoanRate != null)
          message.marginLoanRate = Number(object.marginLoanRate);
        if (object.marginLoanPrice != null)
          message.marginLoanPrice = Number(object.marginLoanPrice);
        if (object.marginCollateralRate != null)
          message.marginCollateralRate = Number(object.marginCollateralRate);
        if (object.marginCollateralPrice != null)
          message.marginCollateralPrice = Number(object.marginCollateralPrice);
        return message;
      };
      MarginBasketItem.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = "";
          object.marginLoanRate = 0;
          object.marginLoanPrice = 0;
          object.marginCollateralRate = 0;
          object.marginCollateralPrice = 0;
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.marginLoanRate != null && message.hasOwnProperty("marginLoanRate"))
          object.marginLoanRate = options.json && !isFinite(message.marginLoanRate) ? String(message.marginLoanRate) : message.marginLoanRate;
        if (message.marginLoanPrice != null && message.hasOwnProperty("marginLoanPrice"))
          object.marginLoanPrice = options.json && !isFinite(message.marginLoanPrice) ? String(message.marginLoanPrice) : message.marginLoanPrice;
        if (message.marginCollateralRate != null && message.hasOwnProperty("marginCollateralRate"))
          object.marginCollateralRate = options.json && !isFinite(message.marginCollateralRate) ? String(message.marginCollateralRate) : message.marginCollateralRate;
        if (message.marginCollateralPrice != null && message.hasOwnProperty("marginCollateralPrice"))
          object.marginCollateralPrice = options.json && !isFinite(message.marginCollateralPrice) ? String(message.marginCollateralPrice) : message.marginCollateralPrice;
        return object;
      };
      MarginBasketItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return MarginBasketItem;
    }();
    fo.MarginBasket = function() {
      function MarginBasket(properties) {
        this.items = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      MarginBasket.prototype.marginBasketId = "";
      MarginBasket.prototype.items = $util.emptyArray;
      MarginBasket.create = function create(properties) {
        return new MarginBasket(properties);
      };
      MarginBasket.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.marginBasketId != null && Object.hasOwnProperty.call(message, "marginBasketId"))
          writer.uint32(10).string(message.marginBasketId);
        if (message.items != null && message.items.length)
          for (let i = 0; i < message.items.length; ++i)
            $root.dnse.fo.MarginBasketItem.encode(message.items[i], writer.uint32(18).fork()).ldelim();
        return writer;
      };
      MarginBasket.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      MarginBasket.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.MarginBasket();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.marginBasketId = reader.string();
              break;
            case 2:
              if (!(message.items && message.items.length))
                message.items = [];
              message.items.push($root.dnse.fo.MarginBasketItem.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      MarginBasket.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      MarginBasket.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.marginBasketId != null && message.hasOwnProperty("marginBasketId")) {
          if (!$util.isString(message.marginBasketId))
            return "marginBasketId: string expected";
        }
        if (message.items != null && message.hasOwnProperty("items")) {
          if (!Array.isArray(message.items))
            return "items: array expected";
          for (let i = 0; i < message.items.length; ++i) {
            let error = $root.dnse.fo.MarginBasketItem.verify(message.items[i]);
            if (error)
              return "items." + error;
          }
        }
        return null;
      };
      MarginBasket.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.MarginBasket)
          return object;
        let message = new $root.dnse.fo.MarginBasket();
        if (object.marginBasketId != null)
          message.marginBasketId = String(object.marginBasketId);
        if (object.items) {
          if (!Array.isArray(object.items))
            throw TypeError(".dnse.fo.MarginBasket.items: array expected");
          message.items = [];
          for (let i = 0; i < object.items.length; ++i) {
            if (typeof object.items[i] !== "object")
              throw TypeError(".dnse.fo.MarginBasket.items: object expected");
            message.items[i] = $root.dnse.fo.MarginBasketItem.fromObject(object.items[i]);
          }
        }
        return message;
      };
      MarginBasket.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.items = [];
        if (options.defaults)
          object.marginBasketId = "";
        if (message.marginBasketId != null && message.hasOwnProperty("marginBasketId"))
          object.marginBasketId = message.marginBasketId;
        if (message.items && message.items.length) {
          object.items = [];
          for (let j = 0; j < message.items.length; ++j)
            object.items[j] = $root.dnse.fo.MarginBasketItem.toObject(message.items[j], options);
        }
        return object;
      };
      MarginBasket.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return MarginBasket;
    }();
    fo.TradingFee = function() {
      function TradingFee(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      TradingFee.prototype.securityType = 0;
      TradingFee.prototype.buyingFeeRate = 0;
      TradingFee.prototype.sellingFeeRate = 0;
      TradingFee.prototype.id = "";
      TradingFee.prototype.transferFee = 0;
      TradingFee.prototype.floorCode = 0;
      TradingFee.create = function create(properties) {
        return new TradingFee(properties);
      };
      TradingFee.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
          writer.uint32(8).int32(message.securityType);
        if (message.buyingFeeRate != null && Object.hasOwnProperty.call(message, "buyingFeeRate"))
          writer.uint32(17).double(message.buyingFeeRate);
        if (message.sellingFeeRate != null && Object.hasOwnProperty.call(message, "sellingFeeRate"))
          writer.uint32(25).double(message.sellingFeeRate);
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(34).string(message.id);
        if (message.transferFee != null && Object.hasOwnProperty.call(message, "transferFee"))
          writer.uint32(41).double(message.transferFee);
        if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
          writer.uint32(48).int32(message.floorCode);
        return writer;
      };
      TradingFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      TradingFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.TradingFee();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.securityType = reader.int32();
              break;
            case 2:
              message.buyingFeeRate = reader.double();
              break;
            case 3:
              message.sellingFeeRate = reader.double();
              break;
            case 4:
              message.id = reader.string();
              break;
            case 5:
              message.transferFee = reader.double();
              break;
            case 6:
              message.floorCode = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      TradingFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      TradingFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          switch (message.securityType) {
            default:
              return "securityType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 100:
              break;
          }
        if (message.buyingFeeRate != null && message.hasOwnProperty("buyingFeeRate")) {
          if (typeof message.buyingFeeRate !== "number")
            return "buyingFeeRate: number expected";
        }
        if (message.sellingFeeRate != null && message.hasOwnProperty("sellingFeeRate")) {
          if (typeof message.sellingFeeRate !== "number")
            return "sellingFeeRate: number expected";
        }
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isString(message.id))
            return "id: string expected";
        }
        if (message.transferFee != null && message.hasOwnProperty("transferFee")) {
          if (typeof message.transferFee !== "number")
            return "transferFee: number expected";
        }
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          switch (message.floorCode) {
            default:
              return "floorCode: enum value expected";
            case 0:
            case 2:
            case 3:
            case 4:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 30:
              break;
          }
        return null;
      };
      TradingFee.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.TradingFee)
          return object;
        let message = new $root.dnse.fo.TradingFee();
        switch (object.securityType) {
          case "UNKNOWN_TYPE":
          case 0:
            message.securityType = 0;
            break;
          case "STOCK":
          case 1:
            message.securityType = 1;
            break;
          case "BOND":
          case 2:
            message.securityType = 2;
            break;
          case "MUTUAL_FUND":
          case 3:
            message.securityType = 3;
            break;
          case "ETF":
          case 4:
            message.securityType = 4;
            break;
          case "FUTURE":
          case 5:
            message.securityType = 5;
            break;
          case "OPTION":
          case 6:
            message.securityType = 6;
            break;
          case "COVERED_WARRANT":
          case 7:
            message.securityType = 7;
            break;
          case "FUTURE_INDEX":
          case 8:
            message.securityType = 8;
            break;
          case "FUTURE_BOND":
          case 9:
            message.securityType = 9;
            break;
          case "CORPORATE_BOND":
          case 10:
            message.securityType = 10;
            break;
          case "PRIVATE_BOND":
          case 11:
            message.securityType = 11;
            break;
          case "ALL":
          case 100:
            message.securityType = 100;
            break;
        }
        if (object.buyingFeeRate != null)
          message.buyingFeeRate = Number(object.buyingFeeRate);
        if (object.sellingFeeRate != null)
          message.sellingFeeRate = Number(object.sellingFeeRate);
        if (object.id != null)
          message.id = String(object.id);
        if (object.transferFee != null)
          message.transferFee = Number(object.transferFee);
        switch (object.floorCode) {
          case "UNKNOWN_EXCHANGE":
          case 0:
            message.floorCode = 0;
            break;
          case "HNX":
          case 2:
            message.floorCode = 2;
            break;
          case "UPCOM":
          case 3:
            message.floorCode = 3;
            break;
          case "HNX_BOND":
          case 4:
            message.floorCode = 4;
            break;
          case "HOSE":
          case 10:
            message.floorCode = 10;
            break;
          case "HOSE_ODD_LOT":
          case 11:
            message.floorCode = 11;
            break;
          case "HNX_DERIVATIVE":
          case 12:
            message.floorCode = 12;
            break;
          case "HNX_DERIVATIVE_BOND":
          case 13:
            message.floorCode = 13;
            break;
          case "HNX_PRIVATE_BOND":
          case 14:
            message.floorCode = 14;
            break;
          case "OTC":
          case 30:
            message.floorCode = 30;
            break;
        }
        return message;
      };
      TradingFee.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
          object.buyingFeeRate = 0;
          object.sellingFeeRate = 0;
          object.id = "";
          object.transferFee = 0;
          object.floorCode = options.enums === String ? "UNKNOWN_EXCHANGE" : 0;
        }
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          object.securityType = options.enums === String ? $root.dnse.fo.SecurityType[message.securityType] : message.securityType;
        if (message.buyingFeeRate != null && message.hasOwnProperty("buyingFeeRate"))
          object.buyingFeeRate = options.json && !isFinite(message.buyingFeeRate) ? String(message.buyingFeeRate) : message.buyingFeeRate;
        if (message.sellingFeeRate != null && message.hasOwnProperty("sellingFeeRate"))
          object.sellingFeeRate = options.json && !isFinite(message.sellingFeeRate) ? String(message.sellingFeeRate) : message.sellingFeeRate;
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.transferFee != null && message.hasOwnProperty("transferFee"))
          object.transferFee = options.json && !isFinite(message.transferFee) ? String(message.transferFee) : message.transferFee;
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          object.floorCode = options.enums === String ? $root.dnse.fo.Exchange[message.floorCode] : message.floorCode;
        return object;
      };
      TradingFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return TradingFee;
    }();
    fo.AdvanceFee = function() {
      function AdvanceFee(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      AdvanceFee.prototype.advanceSource = "";
      AdvanceFee.prototype.advanceFee = 0;
      AdvanceFee.prototype.interestBasis = 0;
      AdvanceFee.prototype.id = "";
      AdvanceFee.create = function create(properties) {
        return new AdvanceFee(properties);
      };
      AdvanceFee.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.advanceSource != null && Object.hasOwnProperty.call(message, "advanceSource"))
          writer.uint32(10).string(message.advanceSource);
        if (message.advanceFee != null && Object.hasOwnProperty.call(message, "advanceFee"))
          writer.uint32(17).double(message.advanceFee);
        if (message.interestBasis != null && Object.hasOwnProperty.call(message, "interestBasis"))
          writer.uint32(24).int32(message.interestBasis);
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(34).string(message.id);
        return writer;
      };
      AdvanceFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      AdvanceFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.AdvanceFee();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.advanceSource = reader.string();
              break;
            case 2:
              message.advanceFee = reader.double();
              break;
            case 3:
              message.interestBasis = reader.int32();
              break;
            case 4:
              message.id = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      AdvanceFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      AdvanceFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.advanceSource != null && message.hasOwnProperty("advanceSource")) {
          if (!$util.isString(message.advanceSource))
            return "advanceSource: string expected";
        }
        if (message.advanceFee != null && message.hasOwnProperty("advanceFee")) {
          if (typeof message.advanceFee !== "number")
            return "advanceFee: number expected";
        }
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis")) {
          if (!$util.isInteger(message.interestBasis))
            return "interestBasis: integer expected";
        }
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isString(message.id))
            return "id: string expected";
        }
        return null;
      };
      AdvanceFee.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.AdvanceFee)
          return object;
        let message = new $root.dnse.fo.AdvanceFee();
        if (object.advanceSource != null)
          message.advanceSource = String(object.advanceSource);
        if (object.advanceFee != null)
          message.advanceFee = Number(object.advanceFee);
        if (object.interestBasis != null)
          message.interestBasis = object.interestBasis | 0;
        if (object.id != null)
          message.id = String(object.id);
        return message;
      };
      AdvanceFee.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.advanceSource = "";
          object.advanceFee = 0;
          object.interestBasis = 0;
          object.id = "";
        }
        if (message.advanceSource != null && message.hasOwnProperty("advanceSource"))
          object.advanceSource = message.advanceSource;
        if (message.advanceFee != null && message.hasOwnProperty("advanceFee"))
          object.advanceFee = options.json && !isFinite(message.advanceFee) ? String(message.advanceFee) : message.advanceFee;
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis"))
          object.interestBasis = message.interestBasis;
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        return object;
      };
      AdvanceFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return AdvanceFee;
    }();
    fo.Loan = function() {
      function Loan(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Loan.prototype.id = "";
      Loan.prototype.loanType = "";
      Loan.prototype.t1 = 0;
      Loan.prototype.i1 = 0;
      Loan.prototype.t2 = 0;
      Loan.prototype.i2 = 0;
      Loan.prototype.maturity = 0;
      Loan.prototype.overdueInterest = 0;
      Loan.prototype.interestBasis = 0;
      Loan.prototype.lendingSource = "";
      Loan.prototype.marginBasketId = "";
      Loan.create = function create(properties) {
        return new Loan(properties);
      };
      Loan.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(10).string(message.id);
        if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
          writer.uint32(18).string(message.loanType);
        if (message.t1 != null && Object.hasOwnProperty.call(message, "t1"))
          writer.uint32(24).int32(message.t1);
        if (message.i1 != null && Object.hasOwnProperty.call(message, "i1"))
          writer.uint32(33).double(message.i1);
        if (message.t2 != null && Object.hasOwnProperty.call(message, "t2"))
          writer.uint32(40).int32(message.t2);
        if (message.i2 != null && Object.hasOwnProperty.call(message, "i2"))
          writer.uint32(49).double(message.i2);
        if (message.maturity != null && Object.hasOwnProperty.call(message, "maturity"))
          writer.uint32(56).int32(message.maturity);
        if (message.overdueInterest != null && Object.hasOwnProperty.call(message, "overdueInterest"))
          writer.uint32(65).double(message.overdueInterest);
        if (message.interestBasis != null && Object.hasOwnProperty.call(message, "interestBasis"))
          writer.uint32(72).int32(message.interestBasis);
        if (message.lendingSource != null && Object.hasOwnProperty.call(message, "lendingSource"))
          writer.uint32(82).string(message.lendingSource);
        if (message.marginBasketId != null && Object.hasOwnProperty.call(message, "marginBasketId"))
          writer.uint32(90).string(message.marginBasketId);
        return writer;
      };
      Loan.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Loan.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Loan();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.loanType = reader.string();
              break;
            case 3:
              message.t1 = reader.int32();
              break;
            case 4:
              message.i1 = reader.double();
              break;
            case 5:
              message.t2 = reader.int32();
              break;
            case 6:
              message.i2 = reader.double();
              break;
            case 7:
              message.maturity = reader.int32();
              break;
            case 8:
              message.overdueInterest = reader.double();
              break;
            case 9:
              message.interestBasis = reader.int32();
              break;
            case 10:
              message.lendingSource = reader.string();
              break;
            case 11:
              message.marginBasketId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Loan.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Loan.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isString(message.id))
            return "id: string expected";
        }
        if (message.loanType != null && message.hasOwnProperty("loanType")) {
          if (!$util.isString(message.loanType))
            return "loanType: string expected";
        }
        if (message.t1 != null && message.hasOwnProperty("t1")) {
          if (!$util.isInteger(message.t1))
            return "t1: integer expected";
        }
        if (message.i1 != null && message.hasOwnProperty("i1")) {
          if (typeof message.i1 !== "number")
            return "i1: number expected";
        }
        if (message.t2 != null && message.hasOwnProperty("t2")) {
          if (!$util.isInteger(message.t2))
            return "t2: integer expected";
        }
        if (message.i2 != null && message.hasOwnProperty("i2")) {
          if (typeof message.i2 !== "number")
            return "i2: number expected";
        }
        if (message.maturity != null && message.hasOwnProperty("maturity")) {
          if (!$util.isInteger(message.maturity))
            return "maturity: integer expected";
        }
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest")) {
          if (typeof message.overdueInterest !== "number")
            return "overdueInterest: number expected";
        }
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis")) {
          if (!$util.isInteger(message.interestBasis))
            return "interestBasis: integer expected";
        }
        if (message.lendingSource != null && message.hasOwnProperty("lendingSource")) {
          if (!$util.isString(message.lendingSource))
            return "lendingSource: string expected";
        }
        if (message.marginBasketId != null && message.hasOwnProperty("marginBasketId")) {
          if (!$util.isString(message.marginBasketId))
            return "marginBasketId: string expected";
        }
        return null;
      };
      Loan.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Loan)
          return object;
        let message = new $root.dnse.fo.Loan();
        if (object.id != null)
          message.id = String(object.id);
        if (object.loanType != null)
          message.loanType = String(object.loanType);
        if (object.t1 != null)
          message.t1 = object.t1 | 0;
        if (object.i1 != null)
          message.i1 = Number(object.i1);
        if (object.t2 != null)
          message.t2 = object.t2 | 0;
        if (object.i2 != null)
          message.i2 = Number(object.i2);
        if (object.maturity != null)
          message.maturity = object.maturity | 0;
        if (object.overdueInterest != null)
          message.overdueInterest = Number(object.overdueInterest);
        if (object.interestBasis != null)
          message.interestBasis = object.interestBasis | 0;
        if (object.lendingSource != null)
          message.lendingSource = String(object.lendingSource);
        if (object.marginBasketId != null)
          message.marginBasketId = String(object.marginBasketId);
        return message;
      };
      Loan.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.id = "";
          object.loanType = "";
          object.t1 = 0;
          object.i1 = 0;
          object.t2 = 0;
          object.i2 = 0;
          object.maturity = 0;
          object.overdueInterest = 0;
          object.interestBasis = 0;
          object.lendingSource = "";
          object.marginBasketId = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.loanType != null && message.hasOwnProperty("loanType"))
          object.loanType = message.loanType;
        if (message.t1 != null && message.hasOwnProperty("t1"))
          object.t1 = message.t1;
        if (message.i1 != null && message.hasOwnProperty("i1"))
          object.i1 = options.json && !isFinite(message.i1) ? String(message.i1) : message.i1;
        if (message.t2 != null && message.hasOwnProperty("t2"))
          object.t2 = message.t2;
        if (message.i2 != null && message.hasOwnProperty("i2"))
          object.i2 = options.json && !isFinite(message.i2) ? String(message.i2) : message.i2;
        if (message.maturity != null && message.hasOwnProperty("maturity"))
          object.maturity = message.maturity;
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest"))
          object.overdueInterest = options.json && !isFinite(message.overdueInterest) ? String(message.overdueInterest) : message.overdueInterest;
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis"))
          object.interestBasis = message.interestBasis;
        if (message.lendingSource != null && message.hasOwnProperty("lendingSource"))
          object.lendingSource = message.lendingSource;
        if (message.marginBasketId != null && message.hasOwnProperty("marginBasketId"))
          object.marginBasketId = message.marginBasketId;
        return object;
      };
      Loan.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Loan;
    }();
    fo.TradingConfig = function() {
      function TradingConfig(properties) {
        this.tradingFees = [];
        this.advanceFees = [];
        this.loans = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      TradingConfig.prototype.accountNo = "";
      TradingConfig.prototype.accountType = "";
      TradingConfig.prototype.marginAccount = false;
      TradingConfig.prototype.tradeBasketRestrict = false;
      TradingConfig.prototype.autoAdvance = false;
      TradingConfig.prototype.maxLoanLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      TradingConfig.prototype.tradingFees = $util.emptyArray;
      TradingConfig.prototype.advanceFees = $util.emptyArray;
      TradingConfig.prototype.loans = $util.emptyArray;
      TradingConfig.prototype.buyingTaxRate = 0;
      TradingConfig.prototype.sellingTaxRate = 0;
      TradingConfig.prototype.dividendTaxRate = 0;
      TradingConfig.create = function create(properties) {
        return new TradingConfig(properties);
      };
      TradingConfig.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
          writer.uint32(18).string(message.accountType);
        if (message.marginAccount != null && Object.hasOwnProperty.call(message, "marginAccount"))
          writer.uint32(24).bool(message.marginAccount);
        if (message.tradeBasketRestrict != null && Object.hasOwnProperty.call(message, "tradeBasketRestrict"))
          writer.uint32(32).bool(message.tradeBasketRestrict);
        if (message.autoAdvance != null && Object.hasOwnProperty.call(message, "autoAdvance"))
          writer.uint32(40).bool(message.autoAdvance);
        if (message.maxLoanLimit != null && Object.hasOwnProperty.call(message, "maxLoanLimit"))
          writer.uint32(48).int64(message.maxLoanLimit);
        if (message.tradingFees != null && message.tradingFees.length)
          for (let i = 0; i < message.tradingFees.length; ++i)
            $root.dnse.fo.TradingFee.encode(message.tradingFees[i], writer.uint32(58).fork()).ldelim();
        if (message.advanceFees != null && message.advanceFees.length)
          for (let i = 0; i < message.advanceFees.length; ++i)
            $root.dnse.fo.AdvanceFee.encode(message.advanceFees[i], writer.uint32(66).fork()).ldelim();
        if (message.loans != null && message.loans.length)
          for (let i = 0; i < message.loans.length; ++i)
            $root.dnse.fo.Loan.encode(message.loans[i], writer.uint32(74).fork()).ldelim();
        if (message.buyingTaxRate != null && Object.hasOwnProperty.call(message, "buyingTaxRate"))
          writer.uint32(81).double(message.buyingTaxRate);
        if (message.sellingTaxRate != null && Object.hasOwnProperty.call(message, "sellingTaxRate"))
          writer.uint32(89).double(message.sellingTaxRate);
        if (message.dividendTaxRate != null && Object.hasOwnProperty.call(message, "dividendTaxRate"))
          writer.uint32(97).double(message.dividendTaxRate);
        return writer;
      };
      TradingConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      TradingConfig.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.TradingConfig();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.accountType = reader.string();
              break;
            case 3:
              message.marginAccount = reader.bool();
              break;
            case 4:
              message.tradeBasketRestrict = reader.bool();
              break;
            case 5:
              message.autoAdvance = reader.bool();
              break;
            case 6:
              message.maxLoanLimit = reader.int64();
              break;
            case 7:
              if (!(message.tradingFees && message.tradingFees.length))
                message.tradingFees = [];
              message.tradingFees.push($root.dnse.fo.TradingFee.decode(reader, reader.uint32()));
              break;
            case 8:
              if (!(message.advanceFees && message.advanceFees.length))
                message.advanceFees = [];
              message.advanceFees.push($root.dnse.fo.AdvanceFee.decode(reader, reader.uint32()));
              break;
            case 9:
              if (!(message.loans && message.loans.length))
                message.loans = [];
              message.loans.push($root.dnse.fo.Loan.decode(reader, reader.uint32()));
              break;
            case 10:
              message.buyingTaxRate = reader.double();
              break;
            case 11:
              message.sellingTaxRate = reader.double();
              break;
            case 12:
              message.dividendTaxRate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      TradingConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      TradingConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          if (!$util.isString(message.accountType))
            return "accountType: string expected";
        }
        if (message.marginAccount != null && message.hasOwnProperty("marginAccount")) {
          if (typeof message.marginAccount !== "boolean")
            return "marginAccount: boolean expected";
        }
        if (message.tradeBasketRestrict != null && message.hasOwnProperty("tradeBasketRestrict")) {
          if (typeof message.tradeBasketRestrict !== "boolean")
            return "tradeBasketRestrict: boolean expected";
        }
        if (message.autoAdvance != null && message.hasOwnProperty("autoAdvance")) {
          if (typeof message.autoAdvance !== "boolean")
            return "autoAdvance: boolean expected";
        }
        if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit")) {
          if (!$util.isInteger(message.maxLoanLimit) && !(message.maxLoanLimit && $util.isInteger(message.maxLoanLimit.low) && $util.isInteger(message.maxLoanLimit.high)))
            return "maxLoanLimit: integer|Long expected";
        }
        if (message.tradingFees != null && message.hasOwnProperty("tradingFees")) {
          if (!Array.isArray(message.tradingFees))
            return "tradingFees: array expected";
          for (let i = 0; i < message.tradingFees.length; ++i) {
            let error = $root.dnse.fo.TradingFee.verify(message.tradingFees[i]);
            if (error)
              return "tradingFees." + error;
          }
        }
        if (message.advanceFees != null && message.hasOwnProperty("advanceFees")) {
          if (!Array.isArray(message.advanceFees))
            return "advanceFees: array expected";
          for (let i = 0; i < message.advanceFees.length; ++i) {
            let error = $root.dnse.fo.AdvanceFee.verify(message.advanceFees[i]);
            if (error)
              return "advanceFees." + error;
          }
        }
        if (message.loans != null && message.hasOwnProperty("loans")) {
          if (!Array.isArray(message.loans))
            return "loans: array expected";
          for (let i = 0; i < message.loans.length; ++i) {
            let error = $root.dnse.fo.Loan.verify(message.loans[i]);
            if (error)
              return "loans." + error;
          }
        }
        if (message.buyingTaxRate != null && message.hasOwnProperty("buyingTaxRate")) {
          if (typeof message.buyingTaxRate !== "number")
            return "buyingTaxRate: number expected";
        }
        if (message.sellingTaxRate != null && message.hasOwnProperty("sellingTaxRate")) {
          if (typeof message.sellingTaxRate !== "number")
            return "sellingTaxRate: number expected";
        }
        if (message.dividendTaxRate != null && message.hasOwnProperty("dividendTaxRate")) {
          if (typeof message.dividendTaxRate !== "number")
            return "dividendTaxRate: number expected";
        }
        return null;
      };
      TradingConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.TradingConfig)
          return object;
        let message = new $root.dnse.fo.TradingConfig();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.accountType != null)
          message.accountType = String(object.accountType);
        if (object.marginAccount != null)
          message.marginAccount = Boolean(object.marginAccount);
        if (object.tradeBasketRestrict != null)
          message.tradeBasketRestrict = Boolean(object.tradeBasketRestrict);
        if (object.autoAdvance != null)
          message.autoAdvance = Boolean(object.autoAdvance);
        if (object.maxLoanLimit != null) {
          if ($util.Long)
            (message.maxLoanLimit = $util.Long.fromValue(object.maxLoanLimit)).unsigned = false;
          else if (typeof object.maxLoanLimit === "string")
            message.maxLoanLimit = parseInt(object.maxLoanLimit, 10);
          else if (typeof object.maxLoanLimit === "number")
            message.maxLoanLimit = object.maxLoanLimit;
          else if (typeof object.maxLoanLimit === "object")
            message.maxLoanLimit = new $util.LongBits(object.maxLoanLimit.low >>> 0, object.maxLoanLimit.high >>> 0).toNumber();
        }
        if (object.tradingFees) {
          if (!Array.isArray(object.tradingFees))
            throw TypeError(".dnse.fo.TradingConfig.tradingFees: array expected");
          message.tradingFees = [];
          for (let i = 0; i < object.tradingFees.length; ++i) {
            if (typeof object.tradingFees[i] !== "object")
              throw TypeError(".dnse.fo.TradingConfig.tradingFees: object expected");
            message.tradingFees[i] = $root.dnse.fo.TradingFee.fromObject(object.tradingFees[i]);
          }
        }
        if (object.advanceFees) {
          if (!Array.isArray(object.advanceFees))
            throw TypeError(".dnse.fo.TradingConfig.advanceFees: array expected");
          message.advanceFees = [];
          for (let i = 0; i < object.advanceFees.length; ++i) {
            if (typeof object.advanceFees[i] !== "object")
              throw TypeError(".dnse.fo.TradingConfig.advanceFees: object expected");
            message.advanceFees[i] = $root.dnse.fo.AdvanceFee.fromObject(object.advanceFees[i]);
          }
        }
        if (object.loans) {
          if (!Array.isArray(object.loans))
            throw TypeError(".dnse.fo.TradingConfig.loans: array expected");
          message.loans = [];
          for (let i = 0; i < object.loans.length; ++i) {
            if (typeof object.loans[i] !== "object")
              throw TypeError(".dnse.fo.TradingConfig.loans: object expected");
            message.loans[i] = $root.dnse.fo.Loan.fromObject(object.loans[i]);
          }
        }
        if (object.buyingTaxRate != null)
          message.buyingTaxRate = Number(object.buyingTaxRate);
        if (object.sellingTaxRate != null)
          message.sellingTaxRate = Number(object.sellingTaxRate);
        if (object.dividendTaxRate != null)
          message.dividendTaxRate = Number(object.dividendTaxRate);
        return message;
      };
      TradingConfig.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.tradingFees = [];
          object.advanceFees = [];
          object.loans = [];
        }
        if (options.defaults) {
          object.accountNo = "";
          object.accountType = "";
          object.marginAccount = false;
          object.tradeBasketRestrict = false;
          object.autoAdvance = false;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.maxLoanLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.maxLoanLimit = options.longs === String ? "0" : 0;
          object.buyingTaxRate = 0;
          object.sellingTaxRate = 0;
          object.dividendTaxRate = 0;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.accountType != null && message.hasOwnProperty("accountType"))
          object.accountType = message.accountType;
        if (message.marginAccount != null && message.hasOwnProperty("marginAccount"))
          object.marginAccount = message.marginAccount;
        if (message.tradeBasketRestrict != null && message.hasOwnProperty("tradeBasketRestrict"))
          object.tradeBasketRestrict = message.tradeBasketRestrict;
        if (message.autoAdvance != null && message.hasOwnProperty("autoAdvance"))
          object.autoAdvance = message.autoAdvance;
        if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit"))
          if (typeof message.maxLoanLimit === "number")
            object.maxLoanLimit = options.longs === String ? String(message.maxLoanLimit) : message.maxLoanLimit;
          else
            object.maxLoanLimit = options.longs === String ? $util.Long.prototype.toString.call(message.maxLoanLimit) : options.longs === Number ? new $util.LongBits(message.maxLoanLimit.low >>> 0, message.maxLoanLimit.high >>> 0).toNumber() : message.maxLoanLimit;
        if (message.tradingFees && message.tradingFees.length) {
          object.tradingFees = [];
          for (let j = 0; j < message.tradingFees.length; ++j)
            object.tradingFees[j] = $root.dnse.fo.TradingFee.toObject(message.tradingFees[j], options);
        }
        if (message.advanceFees && message.advanceFees.length) {
          object.advanceFees = [];
          for (let j = 0; j < message.advanceFees.length; ++j)
            object.advanceFees[j] = $root.dnse.fo.AdvanceFee.toObject(message.advanceFees[j], options);
        }
        if (message.loans && message.loans.length) {
          object.loans = [];
          for (let j = 0; j < message.loans.length; ++j)
            object.loans[j] = $root.dnse.fo.Loan.toObject(message.loans[j], options);
        }
        if (message.buyingTaxRate != null && message.hasOwnProperty("buyingTaxRate"))
          object.buyingTaxRate = options.json && !isFinite(message.buyingTaxRate) ? String(message.buyingTaxRate) : message.buyingTaxRate;
        if (message.sellingTaxRate != null && message.hasOwnProperty("sellingTaxRate"))
          object.sellingTaxRate = options.json && !isFinite(message.sellingTaxRate) ? String(message.sellingTaxRate) : message.sellingTaxRate;
        if (message.dividendTaxRate != null && message.hasOwnProperty("dividendTaxRate"))
          object.dividendTaxRate = options.json && !isFinite(message.dividendTaxRate) ? String(message.dividendTaxRate) : message.dividendTaxRate;
        return object;
      };
      TradingConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return TradingConfig;
    }();
    fo.Account = function() {
      function Account(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Account.prototype.investorId = "";
      Account.prototype.accountNo = "";
      Account.prototype.custody = "";
      Account.prototype.fullName = "";
      Account.prototype.foreigner = false;
      Account.prototype.status = 0;
      Account.prototype.accountType = "";
      Account.prototype.accountTypeName = "";
      Account.prototype.accountTypeBriefName = "";
      Account.prototype.marginAccount = false;
      Account.prototype.carebyId = "";
      Account.prototype.customerId = "";
      Account.prototype.accountCustomDetail = null;
      Account.create = function create(properties) {
        return new Account(properties);
      };
      Account.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(10).string(message.investorId);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.custody != null && Object.hasOwnProperty.call(message, "custody"))
          writer.uint32(26).string(message.custody);
        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
          writer.uint32(34).string(message.fullName);
        if (message.foreigner != null && Object.hasOwnProperty.call(message, "foreigner"))
          writer.uint32(40).bool(message.foreigner);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(48).int32(message.status);
        if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
          writer.uint32(58).string(message.accountType);
        if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
          writer.uint32(66).string(message.accountTypeName);
        if (message.accountTypeBriefName != null && Object.hasOwnProperty.call(message, "accountTypeBriefName"))
          writer.uint32(74).string(message.accountTypeBriefName);
        if (message.marginAccount != null && Object.hasOwnProperty.call(message, "marginAccount"))
          writer.uint32(80).bool(message.marginAccount);
        if (message.carebyId != null && Object.hasOwnProperty.call(message, "carebyId"))
          writer.uint32(90).string(message.carebyId);
        if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
          writer.uint32(98).string(message.customerId);
        if (message.accountCustomDetail != null && Object.hasOwnProperty.call(message, "accountCustomDetail"))
          $root.dnse.fo.AccountCustomDetail.encode(message.accountCustomDetail, writer.uint32(106).fork()).ldelim();
        return writer;
      };
      Account.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Account.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Account();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.investorId = reader.string();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.custody = reader.string();
              break;
            case 4:
              message.fullName = reader.string();
              break;
            case 5:
              message.foreigner = reader.bool();
              break;
            case 6:
              message.status = reader.int32();
              break;
            case 7:
              message.accountType = reader.string();
              break;
            case 8:
              message.accountTypeName = reader.string();
              break;
            case 9:
              message.accountTypeBriefName = reader.string();
              break;
            case 10:
              message.marginAccount = reader.bool();
              break;
            case 11:
              message.carebyId = reader.string();
              break;
            case 12:
              message.customerId = reader.string();
              break;
            case 13:
              message.accountCustomDetail = $root.dnse.fo.AccountCustomDetail.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Account.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Account.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.custody != null && message.hasOwnProperty("custody")) {
          if (!$util.isString(message.custody))
            return "custody: string expected";
        }
        if (message.fullName != null && message.hasOwnProperty("fullName")) {
          if (!$util.isString(message.fullName))
            return "fullName: string expected";
        }
        if (message.foreigner != null && message.hasOwnProperty("foreigner")) {
          if (typeof message.foreigner !== "boolean")
            return "foreigner: boolean expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          if (!$util.isString(message.accountType))
            return "accountType: string expected";
        }
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
          if (!$util.isString(message.accountTypeName))
            return "accountTypeName: string expected";
        }
        if (message.accountTypeBriefName != null && message.hasOwnProperty("accountTypeBriefName")) {
          if (!$util.isString(message.accountTypeBriefName))
            return "accountTypeBriefName: string expected";
        }
        if (message.marginAccount != null && message.hasOwnProperty("marginAccount")) {
          if (typeof message.marginAccount !== "boolean")
            return "marginAccount: boolean expected";
        }
        if (message.carebyId != null && message.hasOwnProperty("carebyId")) {
          if (!$util.isString(message.carebyId))
            return "carebyId: string expected";
        }
        if (message.customerId != null && message.hasOwnProperty("customerId")) {
          if (!$util.isString(message.customerId))
            return "customerId: string expected";
        }
        if (message.accountCustomDetail != null && message.hasOwnProperty("accountCustomDetail")) {
          let error = $root.dnse.fo.AccountCustomDetail.verify(message.accountCustomDetail);
          if (error)
            return "accountCustomDetail." + error;
        }
        return null;
      };
      Account.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Account)
          return object;
        let message = new $root.dnse.fo.Account();
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.custody != null)
          message.custody = String(object.custody);
        if (object.fullName != null)
          message.fullName = String(object.fullName);
        if (object.foreigner != null)
          message.foreigner = Boolean(object.foreigner);
        switch (object.status) {
          case "UNKNOWN":
          case 0:
            message.status = 0;
            break;
          case "ACTIVE":
          case 1:
            message.status = 1;
            break;
          case "CLOSE":
          case 2:
            message.status = 2;
            break;
          case "PENDING":
          case 3:
            message.status = 3;
            break;
        }
        if (object.accountType != null)
          message.accountType = String(object.accountType);
        if (object.accountTypeName != null)
          message.accountTypeName = String(object.accountTypeName);
        if (object.accountTypeBriefName != null)
          message.accountTypeBriefName = String(object.accountTypeBriefName);
        if (object.marginAccount != null)
          message.marginAccount = Boolean(object.marginAccount);
        if (object.carebyId != null)
          message.carebyId = String(object.carebyId);
        if (object.customerId != null)
          message.customerId = String(object.customerId);
        if (object.accountCustomDetail != null) {
          if (typeof object.accountCustomDetail !== "object")
            throw TypeError(".dnse.fo.Account.accountCustomDetail: object expected");
          message.accountCustomDetail = $root.dnse.fo.AccountCustomDetail.fromObject(object.accountCustomDetail);
        }
        return message;
      };
      Account.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.investorId = "";
          object.accountNo = "";
          object.custody = "";
          object.fullName = "";
          object.foreigner = false;
          object.status = options.enums === String ? "UNKNOWN" : 0;
          object.accountType = "";
          object.accountTypeName = "";
          object.accountTypeBriefName = "";
          object.marginAccount = false;
          object.carebyId = "";
          object.customerId = "";
          object.accountCustomDetail = null;
        }
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.custody != null && message.hasOwnProperty("custody"))
          object.custody = message.custody;
        if (message.fullName != null && message.hasOwnProperty("fullName"))
          object.fullName = message.fullName;
        if (message.foreigner != null && message.hasOwnProperty("foreigner"))
          object.foreigner = message.foreigner;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.Account.Status[message.status] : message.status;
        if (message.accountType != null && message.hasOwnProperty("accountType"))
          object.accountType = message.accountType;
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
          object.accountTypeName = message.accountTypeName;
        if (message.accountTypeBriefName != null && message.hasOwnProperty("accountTypeBriefName"))
          object.accountTypeBriefName = message.accountTypeBriefName;
        if (message.marginAccount != null && message.hasOwnProperty("marginAccount"))
          object.marginAccount = message.marginAccount;
        if (message.carebyId != null && message.hasOwnProperty("carebyId"))
          object.carebyId = message.carebyId;
        if (message.customerId != null && message.hasOwnProperty("customerId"))
          object.customerId = message.customerId;
        if (message.accountCustomDetail != null && message.hasOwnProperty("accountCustomDetail"))
          object.accountCustomDetail = $root.dnse.fo.AccountCustomDetail.toObject(message.accountCustomDetail, options);
        return object;
      };
      Account.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      Account.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ACTIVE"] = 1;
        values[valuesById[2] = "CLOSE"] = 2;
        values[valuesById[3] = "PENDING"] = 3;
        return values;
      }();
      return Account;
    }();
    fo.AccountCustomDetail = function() {
      function AccountCustomDetail(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      AccountCustomDetail.prototype.accountNo = "";
      AccountCustomDetail.prototype.dnseType = 0;
      AccountCustomDetail.prototype.customName = "";
      AccountCustomDetail.create = function create(properties) {
        return new AccountCustomDetail(properties);
      };
      AccountCustomDetail.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.dnseType != null && Object.hasOwnProperty.call(message, "dnseType"))
          writer.uint32(16).int32(message.dnseType);
        if (message.customName != null && Object.hasOwnProperty.call(message, "customName"))
          writer.uint32(26).string(message.customName);
        return writer;
      };
      AccountCustomDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      AccountCustomDetail.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.AccountCustomDetail();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.dnseType = reader.int32();
              break;
            case 3:
              message.customName = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      AccountCustomDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      AccountCustomDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.dnseType != null && message.hasOwnProperty("dnseType"))
          switch (message.dnseType) {
            default:
              return "dnseType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.customName != null && message.hasOwnProperty("customName")) {
          if (!$util.isString(message.customName))
            return "customName: string expected";
        }
        return null;
      };
      AccountCustomDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.AccountCustomDetail)
          return object;
        let message = new $root.dnse.fo.AccountCustomDetail();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        switch (object.dnseType) {
          case "DEFAULT":
          case 0:
            message.dnseType = 0;
            break;
          case "ENTRADE":
          case 1:
            message.dnseType = 1;
            break;
          case "COINVEST":
          case 2:
            message.dnseType = 2;
            break;
          case "SAVING":
          case 3:
            message.dnseType = 3;
            break;
        }
        if (object.customName != null)
          message.customName = String(object.customName);
        return message;
      };
      AccountCustomDetail.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.accountNo = "";
          object.dnseType = options.enums === String ? "DEFAULT" : 0;
          object.customName = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.dnseType != null && message.hasOwnProperty("dnseType"))
          object.dnseType = options.enums === String ? $root.dnse.fo.AccountCustomDetail.DNSEType[message.dnseType] : message.dnseType;
        if (message.customName != null && message.hasOwnProperty("customName"))
          object.customName = message.customName;
        return object;
      };
      AccountCustomDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      AccountCustomDetail.DNSEType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEFAULT"] = 0;
        values[valuesById[1] = "ENTRADE"] = 1;
        values[valuesById[2] = "COINVEST"] = 2;
        values[valuesById[3] = "SAVING"] = 3;
        return values;
      }();
      return AccountCustomDetail;
    }();
    fo.Position = function() {
      function Position(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Position.prototype.accountNo = "";
      Position.prototype.symbol = "";
      Position.prototype.availableQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.prototype.subscriptionQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.prototype.dividendQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.prototype.boughtQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.prototype.t1Quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.prototype.t2Quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.prototype.tradeDividendQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Position.create = function create(properties) {
        return new Position(properties);
      };
      Position.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(18).string(message.symbol);
        if (message.availableQuantity != null && Object.hasOwnProperty.call(message, "availableQuantity"))
          writer.uint32(24).int64(message.availableQuantity);
        if (message.subscriptionQuantity != null && Object.hasOwnProperty.call(message, "subscriptionQuantity"))
          writer.uint32(32).int64(message.subscriptionQuantity);
        if (message.dividendQuantity != null && Object.hasOwnProperty.call(message, "dividendQuantity"))
          writer.uint32(40).int64(message.dividendQuantity);
        if (message.boughtQuantity != null && Object.hasOwnProperty.call(message, "boughtQuantity"))
          writer.uint32(48).int64(message.boughtQuantity);
        if (message.t1Quantity != null && Object.hasOwnProperty.call(message, "t1Quantity"))
          writer.uint32(56).int64(message.t1Quantity);
        if (message.t2Quantity != null && Object.hasOwnProperty.call(message, "t2Quantity"))
          writer.uint32(64).int64(message.t2Quantity);
        if (message.tradeDividendQuantity != null && Object.hasOwnProperty.call(message, "tradeDividendQuantity"))
          writer.uint32(72).int64(message.tradeDividendQuantity);
        return writer;
      };
      Position.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Position.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Position();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.symbol = reader.string();
              break;
            case 3:
              message.availableQuantity = reader.int64();
              break;
            case 4:
              message.subscriptionQuantity = reader.int64();
              break;
            case 5:
              message.dividendQuantity = reader.int64();
              break;
            case 6:
              message.boughtQuantity = reader.int64();
              break;
            case 7:
              message.t1Quantity = reader.int64();
              break;
            case 8:
              message.t2Quantity = reader.int64();
              break;
            case 9:
              message.tradeDividendQuantity = reader.int64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Position.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Position.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.availableQuantity != null && message.hasOwnProperty("availableQuantity")) {
          if (!$util.isInteger(message.availableQuantity) && !(message.availableQuantity && $util.isInteger(message.availableQuantity.low) && $util.isInteger(message.availableQuantity.high)))
            return "availableQuantity: integer|Long expected";
        }
        if (message.subscriptionQuantity != null && message.hasOwnProperty("subscriptionQuantity")) {
          if (!$util.isInteger(message.subscriptionQuantity) && !(message.subscriptionQuantity && $util.isInteger(message.subscriptionQuantity.low) && $util.isInteger(message.subscriptionQuantity.high)))
            return "subscriptionQuantity: integer|Long expected";
        }
        if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity")) {
          if (!$util.isInteger(message.dividendQuantity) && !(message.dividendQuantity && $util.isInteger(message.dividendQuantity.low) && $util.isInteger(message.dividendQuantity.high)))
            return "dividendQuantity: integer|Long expected";
        }
        if (message.boughtQuantity != null && message.hasOwnProperty("boughtQuantity")) {
          if (!$util.isInteger(message.boughtQuantity) && !(message.boughtQuantity && $util.isInteger(message.boughtQuantity.low) && $util.isInteger(message.boughtQuantity.high)))
            return "boughtQuantity: integer|Long expected";
        }
        if (message.t1Quantity != null && message.hasOwnProperty("t1Quantity")) {
          if (!$util.isInteger(message.t1Quantity) && !(message.t1Quantity && $util.isInteger(message.t1Quantity.low) && $util.isInteger(message.t1Quantity.high)))
            return "t1Quantity: integer|Long expected";
        }
        if (message.t2Quantity != null && message.hasOwnProperty("t2Quantity")) {
          if (!$util.isInteger(message.t2Quantity) && !(message.t2Quantity && $util.isInteger(message.t2Quantity.low) && $util.isInteger(message.t2Quantity.high)))
            return "t2Quantity: integer|Long expected";
        }
        if (message.tradeDividendQuantity != null && message.hasOwnProperty("tradeDividendQuantity")) {
          if (!$util.isInteger(message.tradeDividendQuantity) && !(message.tradeDividendQuantity && $util.isInteger(message.tradeDividendQuantity.low) && $util.isInteger(message.tradeDividendQuantity.high)))
            return "tradeDividendQuantity: integer|Long expected";
        }
        return null;
      };
      Position.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Position)
          return object;
        let message = new $root.dnse.fo.Position();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.availableQuantity != null) {
          if ($util.Long)
            (message.availableQuantity = $util.Long.fromValue(object.availableQuantity)).unsigned = false;
          else if (typeof object.availableQuantity === "string")
            message.availableQuantity = parseInt(object.availableQuantity, 10);
          else if (typeof object.availableQuantity === "number")
            message.availableQuantity = object.availableQuantity;
          else if (typeof object.availableQuantity === "object")
            message.availableQuantity = new $util.LongBits(object.availableQuantity.low >>> 0, object.availableQuantity.high >>> 0).toNumber();
        }
        if (object.subscriptionQuantity != null) {
          if ($util.Long)
            (message.subscriptionQuantity = $util.Long.fromValue(object.subscriptionQuantity)).unsigned = false;
          else if (typeof object.subscriptionQuantity === "string")
            message.subscriptionQuantity = parseInt(object.subscriptionQuantity, 10);
          else if (typeof object.subscriptionQuantity === "number")
            message.subscriptionQuantity = object.subscriptionQuantity;
          else if (typeof object.subscriptionQuantity === "object")
            message.subscriptionQuantity = new $util.LongBits(object.subscriptionQuantity.low >>> 0, object.subscriptionQuantity.high >>> 0).toNumber();
        }
        if (object.dividendQuantity != null) {
          if ($util.Long)
            (message.dividendQuantity = $util.Long.fromValue(object.dividendQuantity)).unsigned = false;
          else if (typeof object.dividendQuantity === "string")
            message.dividendQuantity = parseInt(object.dividendQuantity, 10);
          else if (typeof object.dividendQuantity === "number")
            message.dividendQuantity = object.dividendQuantity;
          else if (typeof object.dividendQuantity === "object")
            message.dividendQuantity = new $util.LongBits(object.dividendQuantity.low >>> 0, object.dividendQuantity.high >>> 0).toNumber();
        }
        if (object.boughtQuantity != null) {
          if ($util.Long)
            (message.boughtQuantity = $util.Long.fromValue(object.boughtQuantity)).unsigned = false;
          else if (typeof object.boughtQuantity === "string")
            message.boughtQuantity = parseInt(object.boughtQuantity, 10);
          else if (typeof object.boughtQuantity === "number")
            message.boughtQuantity = object.boughtQuantity;
          else if (typeof object.boughtQuantity === "object")
            message.boughtQuantity = new $util.LongBits(object.boughtQuantity.low >>> 0, object.boughtQuantity.high >>> 0).toNumber();
        }
        if (object.t1Quantity != null) {
          if ($util.Long)
            (message.t1Quantity = $util.Long.fromValue(object.t1Quantity)).unsigned = false;
          else if (typeof object.t1Quantity === "string")
            message.t1Quantity = parseInt(object.t1Quantity, 10);
          else if (typeof object.t1Quantity === "number")
            message.t1Quantity = object.t1Quantity;
          else if (typeof object.t1Quantity === "object")
            message.t1Quantity = new $util.LongBits(object.t1Quantity.low >>> 0, object.t1Quantity.high >>> 0).toNumber();
        }
        if (object.t2Quantity != null) {
          if ($util.Long)
            (message.t2Quantity = $util.Long.fromValue(object.t2Quantity)).unsigned = false;
          else if (typeof object.t2Quantity === "string")
            message.t2Quantity = parseInt(object.t2Quantity, 10);
          else if (typeof object.t2Quantity === "number")
            message.t2Quantity = object.t2Quantity;
          else if (typeof object.t2Quantity === "object")
            message.t2Quantity = new $util.LongBits(object.t2Quantity.low >>> 0, object.t2Quantity.high >>> 0).toNumber();
        }
        if (object.tradeDividendQuantity != null) {
          if ($util.Long)
            (message.tradeDividendQuantity = $util.Long.fromValue(object.tradeDividendQuantity)).unsigned = false;
          else if (typeof object.tradeDividendQuantity === "string")
            message.tradeDividendQuantity = parseInt(object.tradeDividendQuantity, 10);
          else if (typeof object.tradeDividendQuantity === "number")
            message.tradeDividendQuantity = object.tradeDividendQuantity;
          else if (typeof object.tradeDividendQuantity === "object")
            message.tradeDividendQuantity = new $util.LongBits(object.tradeDividendQuantity.low >>> 0, object.tradeDividendQuantity.high >>> 0).toNumber();
        }
        return message;
      };
      Position.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.accountNo = "";
          object.symbol = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.availableQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.availableQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.subscriptionQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.subscriptionQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.dividendQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.dividendQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.boughtQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.boughtQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t1Quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t1Quantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t2Quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t2Quantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.tradeDividendQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.tradeDividendQuantity = options.longs === String ? "0" : 0;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.availableQuantity != null && message.hasOwnProperty("availableQuantity"))
          if (typeof message.availableQuantity === "number")
            object.availableQuantity = options.longs === String ? String(message.availableQuantity) : message.availableQuantity;
          else
            object.availableQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.availableQuantity) : options.longs === Number ? new $util.LongBits(message.availableQuantity.low >>> 0, message.availableQuantity.high >>> 0).toNumber() : message.availableQuantity;
        if (message.subscriptionQuantity != null && message.hasOwnProperty("subscriptionQuantity"))
          if (typeof message.subscriptionQuantity === "number")
            object.subscriptionQuantity = options.longs === String ? String(message.subscriptionQuantity) : message.subscriptionQuantity;
          else
            object.subscriptionQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.subscriptionQuantity) : options.longs === Number ? new $util.LongBits(message.subscriptionQuantity.low >>> 0, message.subscriptionQuantity.high >>> 0).toNumber() : message.subscriptionQuantity;
        if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity"))
          if (typeof message.dividendQuantity === "number")
            object.dividendQuantity = options.longs === String ? String(message.dividendQuantity) : message.dividendQuantity;
          else
            object.dividendQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.dividendQuantity) : options.longs === Number ? new $util.LongBits(message.dividendQuantity.low >>> 0, message.dividendQuantity.high >>> 0).toNumber() : message.dividendQuantity;
        if (message.boughtQuantity != null && message.hasOwnProperty("boughtQuantity"))
          if (typeof message.boughtQuantity === "number")
            object.boughtQuantity = options.longs === String ? String(message.boughtQuantity) : message.boughtQuantity;
          else
            object.boughtQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.boughtQuantity) : options.longs === Number ? new $util.LongBits(message.boughtQuantity.low >>> 0, message.boughtQuantity.high >>> 0).toNumber() : message.boughtQuantity;
        if (message.t1Quantity != null && message.hasOwnProperty("t1Quantity"))
          if (typeof message.t1Quantity === "number")
            object.t1Quantity = options.longs === String ? String(message.t1Quantity) : message.t1Quantity;
          else
            object.t1Quantity = options.longs === String ? $util.Long.prototype.toString.call(message.t1Quantity) : options.longs === Number ? new $util.LongBits(message.t1Quantity.low >>> 0, message.t1Quantity.high >>> 0).toNumber() : message.t1Quantity;
        if (message.t2Quantity != null && message.hasOwnProperty("t2Quantity"))
          if (typeof message.t2Quantity === "number")
            object.t2Quantity = options.longs === String ? String(message.t2Quantity) : message.t2Quantity;
          else
            object.t2Quantity = options.longs === String ? $util.Long.prototype.toString.call(message.t2Quantity) : options.longs === Number ? new $util.LongBits(message.t2Quantity.low >>> 0, message.t2Quantity.high >>> 0).toNumber() : message.t2Quantity;
        if (message.tradeDividendQuantity != null && message.hasOwnProperty("tradeDividendQuantity"))
          if (typeof message.tradeDividendQuantity === "number")
            object.tradeDividendQuantity = options.longs === String ? String(message.tradeDividendQuantity) : message.tradeDividendQuantity;
          else
            object.tradeDividendQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.tradeDividendQuantity) : options.longs === Number ? new $util.LongBits(message.tradeDividendQuantity.low >>> 0, message.tradeDividendQuantity.high >>> 0).toNumber() : message.tradeDividendQuantity;
        return object;
      };
      Position.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Position;
    }();
    fo.CashAccount = function() {
      function CashAccount(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      CashAccount.prototype.accountNo = "";
      CashAccount.prototype.initCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.t0ReceivingCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.t1ReceivingCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.t2ReceivingCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.termDeposit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.totalDebt = 0;
      CashAccount.prototype.totalFee = 0;
      CashAccount.prototype.dividend = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.t0Limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CashAccount.create = function create(properties) {
        return new CashAccount(properties);
      };
      CashAccount.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.initCash != null && Object.hasOwnProperty.call(message, "initCash"))
          writer.uint32(16).int64(message.initCash);
        if (message.t0ReceivingCash != null && Object.hasOwnProperty.call(message, "t0ReceivingCash"))
          writer.uint32(24).int64(message.t0ReceivingCash);
        if (message.t1ReceivingCash != null && Object.hasOwnProperty.call(message, "t1ReceivingCash"))
          writer.uint32(32).int64(message.t1ReceivingCash);
        if (message.t2ReceivingCash != null && Object.hasOwnProperty.call(message, "t2ReceivingCash"))
          writer.uint32(40).int64(message.t2ReceivingCash);
        if (message.termDeposit != null && Object.hasOwnProperty.call(message, "termDeposit"))
          writer.uint32(48).int64(message.termDeposit);
        if (message.totalDebt != null && Object.hasOwnProperty.call(message, "totalDebt"))
          writer.uint32(57).double(message.totalDebt);
        if (message.totalFee != null && Object.hasOwnProperty.call(message, "totalFee"))
          writer.uint32(65).double(message.totalFee);
        if (message.dividend != null && Object.hasOwnProperty.call(message, "dividend"))
          writer.uint32(72).int64(message.dividend);
        if (message.t0Limit != null && Object.hasOwnProperty.call(message, "t0Limit"))
          writer.uint32(80).int64(message.t0Limit);
        if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
          writer.uint32(88).int64(message.availableCash);
        return writer;
      };
      CashAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      CashAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.CashAccount();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.initCash = reader.int64();
              break;
            case 3:
              message.t0ReceivingCash = reader.int64();
              break;
            case 4:
              message.t1ReceivingCash = reader.int64();
              break;
            case 5:
              message.t2ReceivingCash = reader.int64();
              break;
            case 6:
              message.termDeposit = reader.int64();
              break;
            case 7:
              message.totalDebt = reader.double();
              break;
            case 8:
              message.totalFee = reader.double();
              break;
            case 9:
              message.dividend = reader.int64();
              break;
            case 10:
              message.t0Limit = reader.int64();
              break;
            case 11:
              message.availableCash = reader.int64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      CashAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      CashAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.initCash != null && message.hasOwnProperty("initCash")) {
          if (!$util.isInteger(message.initCash) && !(message.initCash && $util.isInteger(message.initCash.low) && $util.isInteger(message.initCash.high)))
            return "initCash: integer|Long expected";
        }
        if (message.t0ReceivingCash != null && message.hasOwnProperty("t0ReceivingCash")) {
          if (!$util.isInteger(message.t0ReceivingCash) && !(message.t0ReceivingCash && $util.isInteger(message.t0ReceivingCash.low) && $util.isInteger(message.t0ReceivingCash.high)))
            return "t0ReceivingCash: integer|Long expected";
        }
        if (message.t1ReceivingCash != null && message.hasOwnProperty("t1ReceivingCash")) {
          if (!$util.isInteger(message.t1ReceivingCash) && !(message.t1ReceivingCash && $util.isInteger(message.t1ReceivingCash.low) && $util.isInteger(message.t1ReceivingCash.high)))
            return "t1ReceivingCash: integer|Long expected";
        }
        if (message.t2ReceivingCash != null && message.hasOwnProperty("t2ReceivingCash")) {
          if (!$util.isInteger(message.t2ReceivingCash) && !(message.t2ReceivingCash && $util.isInteger(message.t2ReceivingCash.low) && $util.isInteger(message.t2ReceivingCash.high)))
            return "t2ReceivingCash: integer|Long expected";
        }
        if (message.termDeposit != null && message.hasOwnProperty("termDeposit")) {
          if (!$util.isInteger(message.termDeposit) && !(message.termDeposit && $util.isInteger(message.termDeposit.low) && $util.isInteger(message.termDeposit.high)))
            return "termDeposit: integer|Long expected";
        }
        if (message.totalDebt != null && message.hasOwnProperty("totalDebt")) {
          if (typeof message.totalDebt !== "number")
            return "totalDebt: number expected";
        }
        if (message.totalFee != null && message.hasOwnProperty("totalFee")) {
          if (typeof message.totalFee !== "number")
            return "totalFee: number expected";
        }
        if (message.dividend != null && message.hasOwnProperty("dividend")) {
          if (!$util.isInteger(message.dividend) && !(message.dividend && $util.isInteger(message.dividend.low) && $util.isInteger(message.dividend.high)))
            return "dividend: integer|Long expected";
        }
        if (message.t0Limit != null && message.hasOwnProperty("t0Limit")) {
          if (!$util.isInteger(message.t0Limit) && !(message.t0Limit && $util.isInteger(message.t0Limit.low) && $util.isInteger(message.t0Limit.high)))
            return "t0Limit: integer|Long expected";
        }
        if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
          if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
            return "availableCash: integer|Long expected";
        }
        return null;
      };
      CashAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.CashAccount)
          return object;
        let message = new $root.dnse.fo.CashAccount();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.initCash != null) {
          if ($util.Long)
            (message.initCash = $util.Long.fromValue(object.initCash)).unsigned = false;
          else if (typeof object.initCash === "string")
            message.initCash = parseInt(object.initCash, 10);
          else if (typeof object.initCash === "number")
            message.initCash = object.initCash;
          else if (typeof object.initCash === "object")
            message.initCash = new $util.LongBits(object.initCash.low >>> 0, object.initCash.high >>> 0).toNumber();
        }
        if (object.t0ReceivingCash != null) {
          if ($util.Long)
            (message.t0ReceivingCash = $util.Long.fromValue(object.t0ReceivingCash)).unsigned = false;
          else if (typeof object.t0ReceivingCash === "string")
            message.t0ReceivingCash = parseInt(object.t0ReceivingCash, 10);
          else if (typeof object.t0ReceivingCash === "number")
            message.t0ReceivingCash = object.t0ReceivingCash;
          else if (typeof object.t0ReceivingCash === "object")
            message.t0ReceivingCash = new $util.LongBits(object.t0ReceivingCash.low >>> 0, object.t0ReceivingCash.high >>> 0).toNumber();
        }
        if (object.t1ReceivingCash != null) {
          if ($util.Long)
            (message.t1ReceivingCash = $util.Long.fromValue(object.t1ReceivingCash)).unsigned = false;
          else if (typeof object.t1ReceivingCash === "string")
            message.t1ReceivingCash = parseInt(object.t1ReceivingCash, 10);
          else if (typeof object.t1ReceivingCash === "number")
            message.t1ReceivingCash = object.t1ReceivingCash;
          else if (typeof object.t1ReceivingCash === "object")
            message.t1ReceivingCash = new $util.LongBits(object.t1ReceivingCash.low >>> 0, object.t1ReceivingCash.high >>> 0).toNumber();
        }
        if (object.t2ReceivingCash != null) {
          if ($util.Long)
            (message.t2ReceivingCash = $util.Long.fromValue(object.t2ReceivingCash)).unsigned = false;
          else if (typeof object.t2ReceivingCash === "string")
            message.t2ReceivingCash = parseInt(object.t2ReceivingCash, 10);
          else if (typeof object.t2ReceivingCash === "number")
            message.t2ReceivingCash = object.t2ReceivingCash;
          else if (typeof object.t2ReceivingCash === "object")
            message.t2ReceivingCash = new $util.LongBits(object.t2ReceivingCash.low >>> 0, object.t2ReceivingCash.high >>> 0).toNumber();
        }
        if (object.termDeposit != null) {
          if ($util.Long)
            (message.termDeposit = $util.Long.fromValue(object.termDeposit)).unsigned = false;
          else if (typeof object.termDeposit === "string")
            message.termDeposit = parseInt(object.termDeposit, 10);
          else if (typeof object.termDeposit === "number")
            message.termDeposit = object.termDeposit;
          else if (typeof object.termDeposit === "object")
            message.termDeposit = new $util.LongBits(object.termDeposit.low >>> 0, object.termDeposit.high >>> 0).toNumber();
        }
        if (object.totalDebt != null)
          message.totalDebt = Number(object.totalDebt);
        if (object.totalFee != null)
          message.totalFee = Number(object.totalFee);
        if (object.dividend != null) {
          if ($util.Long)
            (message.dividend = $util.Long.fromValue(object.dividend)).unsigned = false;
          else if (typeof object.dividend === "string")
            message.dividend = parseInt(object.dividend, 10);
          else if (typeof object.dividend === "number")
            message.dividend = object.dividend;
          else if (typeof object.dividend === "object")
            message.dividend = new $util.LongBits(object.dividend.low >>> 0, object.dividend.high >>> 0).toNumber();
        }
        if (object.t0Limit != null) {
          if ($util.Long)
            (message.t0Limit = $util.Long.fromValue(object.t0Limit)).unsigned = false;
          else if (typeof object.t0Limit === "string")
            message.t0Limit = parseInt(object.t0Limit, 10);
          else if (typeof object.t0Limit === "number")
            message.t0Limit = object.t0Limit;
          else if (typeof object.t0Limit === "object")
            message.t0Limit = new $util.LongBits(object.t0Limit.low >>> 0, object.t0Limit.high >>> 0).toNumber();
        }
        if (object.availableCash != null) {
          if ($util.Long)
            (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
          else if (typeof object.availableCash === "string")
            message.availableCash = parseInt(object.availableCash, 10);
          else if (typeof object.availableCash === "number")
            message.availableCash = object.availableCash;
          else if (typeof object.availableCash === "object")
            message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
        }
        return message;
      };
      CashAccount.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.accountNo = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.initCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.initCash = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t0ReceivingCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t0ReceivingCash = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t1ReceivingCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t1ReceivingCash = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t2ReceivingCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t2ReceivingCash = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.termDeposit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.termDeposit = options.longs === String ? "0" : 0;
          object.totalDebt = 0;
          object.totalFee = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.dividend = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.dividend = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t0Limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t0Limit = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.availableCash = options.longs === String ? "0" : 0;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.initCash != null && message.hasOwnProperty("initCash"))
          if (typeof message.initCash === "number")
            object.initCash = options.longs === String ? String(message.initCash) : message.initCash;
          else
            object.initCash = options.longs === String ? $util.Long.prototype.toString.call(message.initCash) : options.longs === Number ? new $util.LongBits(message.initCash.low >>> 0, message.initCash.high >>> 0).toNumber() : message.initCash;
        if (message.t0ReceivingCash != null && message.hasOwnProperty("t0ReceivingCash"))
          if (typeof message.t0ReceivingCash === "number")
            object.t0ReceivingCash = options.longs === String ? String(message.t0ReceivingCash) : message.t0ReceivingCash;
          else
            object.t0ReceivingCash = options.longs === String ? $util.Long.prototype.toString.call(message.t0ReceivingCash) : options.longs === Number ? new $util.LongBits(message.t0ReceivingCash.low >>> 0, message.t0ReceivingCash.high >>> 0).toNumber() : message.t0ReceivingCash;
        if (message.t1ReceivingCash != null && message.hasOwnProperty("t1ReceivingCash"))
          if (typeof message.t1ReceivingCash === "number")
            object.t1ReceivingCash = options.longs === String ? String(message.t1ReceivingCash) : message.t1ReceivingCash;
          else
            object.t1ReceivingCash = options.longs === String ? $util.Long.prototype.toString.call(message.t1ReceivingCash) : options.longs === Number ? new $util.LongBits(message.t1ReceivingCash.low >>> 0, message.t1ReceivingCash.high >>> 0).toNumber() : message.t1ReceivingCash;
        if (message.t2ReceivingCash != null && message.hasOwnProperty("t2ReceivingCash"))
          if (typeof message.t2ReceivingCash === "number")
            object.t2ReceivingCash = options.longs === String ? String(message.t2ReceivingCash) : message.t2ReceivingCash;
          else
            object.t2ReceivingCash = options.longs === String ? $util.Long.prototype.toString.call(message.t2ReceivingCash) : options.longs === Number ? new $util.LongBits(message.t2ReceivingCash.low >>> 0, message.t2ReceivingCash.high >>> 0).toNumber() : message.t2ReceivingCash;
        if (message.termDeposit != null && message.hasOwnProperty("termDeposit"))
          if (typeof message.termDeposit === "number")
            object.termDeposit = options.longs === String ? String(message.termDeposit) : message.termDeposit;
          else
            object.termDeposit = options.longs === String ? $util.Long.prototype.toString.call(message.termDeposit) : options.longs === Number ? new $util.LongBits(message.termDeposit.low >>> 0, message.termDeposit.high >>> 0).toNumber() : message.termDeposit;
        if (message.totalDebt != null && message.hasOwnProperty("totalDebt"))
          object.totalDebt = options.json && !isFinite(message.totalDebt) ? String(message.totalDebt) : message.totalDebt;
        if (message.totalFee != null && message.hasOwnProperty("totalFee"))
          object.totalFee = options.json && !isFinite(message.totalFee) ? String(message.totalFee) : message.totalFee;
        if (message.dividend != null && message.hasOwnProperty("dividend"))
          if (typeof message.dividend === "number")
            object.dividend = options.longs === String ? String(message.dividend) : message.dividend;
          else
            object.dividend = options.longs === String ? $util.Long.prototype.toString.call(message.dividend) : options.longs === Number ? new $util.LongBits(message.dividend.low >>> 0, message.dividend.high >>> 0).toNumber() : message.dividend;
        if (message.t0Limit != null && message.hasOwnProperty("t0Limit"))
          if (typeof message.t0Limit === "number")
            object.t0Limit = options.longs === String ? String(message.t0Limit) : message.t0Limit;
          else
            object.t0Limit = options.longs === String ? $util.Long.prototype.toString.call(message.t0Limit) : options.longs === Number ? new $util.LongBits(message.t0Limit.low >>> 0, message.t0Limit.high >>> 0).toNumber() : message.t0Limit;
        if (message.availableCash != null && message.hasOwnProperty("availableCash"))
          if (typeof message.availableCash === "number")
            object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
          else
            object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
        return object;
      };
      CashAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return CashAccount;
    }();
    fo.Order = function() {
      function Order(properties) {
        this.reports = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Order.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Order.prototype.side = "";
      Order.prototype.accountNo = "";
      Order.prototype.symbol = "";
      Order.prototype.price = 0;
      Order.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Order.prototype.orderType = "";
      Order.prototype.orderStatus = "";
      Order.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Order.prototype.canceledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Order.prototype.lastQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Order.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Order.prototype.lastPrice = 0;
      Order.prototype.averagePrice = 0;
      Order.prototype.priceSecure = 0;
      Order.prototype.createdDate = null;
      Order.prototype.modifiedDate = null;
      Order.prototype.transDate = null;
      Order.prototype.execType = "";
      Order.prototype.custody = "";
      Order.prototype.taxRate = 0;
      Order.prototype.feeRate = 0;
      Order.prototype.clOrdId = "";
      Order.prototype.origClOrdId = "";
      Order.prototype.maker = "";
      Order.prototype.channel = "";
      Order.prototype.externalId = "";
      Order.prototype.exDestination = "";
      Order.prototype.error = "";
      Order.prototype.text = "";
      Order.prototype.reports = $util.emptyArray;
      Order.prototype.investorId = "";
      Order.prototype.loanPackageId = 0;
      Order.prototype.initialRate = 0;
      Order.prototype.metadata = "";
      Order.prototype.exchangeFeeRate = 0;
      Order.create = function create(properties) {
        return new Order(properties);
      };
      Order.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
          writer.uint32(18).string(message.side);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(26).string(message.accountNo);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(34).string(message.symbol);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
          writer.uint32(41).double(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
          writer.uint32(48).int64(message.quantity);
        if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
          writer.uint32(58).string(message.orderType);
        if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
          writer.uint32(66).string(message.orderStatus);
        if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
          writer.uint32(72).int64(message.fillQuantity);
        if (message.canceledQuantity != null && Object.hasOwnProperty.call(message, "canceledQuantity"))
          writer.uint32(80).int64(message.canceledQuantity);
        if (message.lastQuantity != null && Object.hasOwnProperty.call(message, "lastQuantity"))
          writer.uint32(88).int64(message.lastQuantity);
        if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
          writer.uint32(96).int64(message.leaveQuantity);
        if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
          writer.uint32(105).double(message.lastPrice);
        if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
          writer.uint32(113).double(message.averagePrice);
        if (message.priceSecure != null && Object.hasOwnProperty.call(message, "priceSecure"))
          writer.uint32(121).double(message.priceSecure);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(130).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(138).fork()).ldelim();
        if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
          $root.google.protobuf.Timestamp.encode(message.transDate, writer.uint32(146).fork()).ldelim();
        if (message.execType != null && Object.hasOwnProperty.call(message, "execType"))
          writer.uint32(154).string(message.execType);
        if (message.custody != null && Object.hasOwnProperty.call(message, "custody"))
          writer.uint32(162).string(message.custody);
        if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
          writer.uint32(169).double(message.taxRate);
        if (message.feeRate != null && Object.hasOwnProperty.call(message, "feeRate"))
          writer.uint32(177).double(message.feeRate);
        if (message.clOrdId != null && Object.hasOwnProperty.call(message, "clOrdId"))
          writer.uint32(186).string(message.clOrdId);
        if (message.origClOrdId != null && Object.hasOwnProperty.call(message, "origClOrdId"))
          writer.uint32(194).string(message.origClOrdId);
        if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
          writer.uint32(202).string(message.maker);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
          writer.uint32(210).string(message.channel);
        if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
          writer.uint32(218).string(message.externalId);
        if (message.exDestination != null && Object.hasOwnProperty.call(message, "exDestination"))
          writer.uint32(226).string(message.exDestination);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
          writer.uint32(234).string(message.error);
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
          writer.uint32(242).string(message.text);
        if (message.reports != null && message.reports.length)
          for (let i = 0; i < message.reports.length; ++i)
            $root.dnse.fo.Order.encode(message.reports[i], writer.uint32(250).fork()).ldelim();
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(258).string(message.investorId);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(264).int32(message.loanPackageId);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(273).double(message.initialRate);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          writer.uint32(282).string(message.metadata);
        if (message.exchangeFeeRate != null && Object.hasOwnProperty.call(message, "exchangeFeeRate"))
          writer.uint32(289).double(message.exchangeFeeRate);
        return writer;
      };
      Order.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Order.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Order();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.side = reader.string();
              break;
            case 3:
              message.accountNo = reader.string();
              break;
            case 4:
              message.symbol = reader.string();
              break;
            case 5:
              message.price = reader.double();
              break;
            case 6:
              message.quantity = reader.int64();
              break;
            case 7:
              message.orderType = reader.string();
              break;
            case 8:
              message.orderStatus = reader.string();
              break;
            case 9:
              message.fillQuantity = reader.int64();
              break;
            case 10:
              message.canceledQuantity = reader.int64();
              break;
            case 11:
              message.lastQuantity = reader.int64();
              break;
            case 12:
              message.leaveQuantity = reader.int64();
              break;
            case 13:
              message.lastPrice = reader.double();
              break;
            case 14:
              message.averagePrice = reader.double();
              break;
            case 15:
              message.priceSecure = reader.double();
              break;
            case 16:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 17:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 18:
              message.transDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 19:
              message.execType = reader.string();
              break;
            case 20:
              message.custody = reader.string();
              break;
            case 21:
              message.taxRate = reader.double();
              break;
            case 22:
              message.feeRate = reader.double();
              break;
            case 23:
              message.clOrdId = reader.string();
              break;
            case 24:
              message.origClOrdId = reader.string();
              break;
            case 25:
              message.maker = reader.string();
              break;
            case 26:
              message.channel = reader.string();
              break;
            case 27:
              message.externalId = reader.string();
              break;
            case 28:
              message.exDestination = reader.string();
              break;
            case 29:
              message.error = reader.string();
              break;
            case 30:
              message.text = reader.string();
              break;
            case 31:
              if (!(message.reports && message.reports.length))
                message.reports = [];
              message.reports.push($root.dnse.fo.Order.decode(reader, reader.uint32()));
              break;
            case 32:
              message.investorId = reader.string();
              break;
            case 33:
              message.loanPackageId = reader.int32();
              break;
            case 34:
              message.initialRate = reader.double();
              break;
            case 35:
              message.metadata = reader.string();
              break;
            case 36:
              message.exchangeFeeRate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Order.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Order.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.side != null && message.hasOwnProperty("side")) {
          if (!$util.isString(message.side))
            return "side: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.price != null && message.hasOwnProperty("price")) {
          if (typeof message.price !== "number")
            return "price: number expected";
        }
        if (message.quantity != null && message.hasOwnProperty("quantity")) {
          if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
            return "quantity: integer|Long expected";
        }
        if (message.orderType != null && message.hasOwnProperty("orderType")) {
          if (!$util.isString(message.orderType))
            return "orderType: string expected";
        }
        if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
          if (!$util.isString(message.orderStatus))
            return "orderStatus: string expected";
        }
        if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
          if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
            return "fillQuantity: integer|Long expected";
        }
        if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity")) {
          if (!$util.isInteger(message.canceledQuantity) && !(message.canceledQuantity && $util.isInteger(message.canceledQuantity.low) && $util.isInteger(message.canceledQuantity.high)))
            return "canceledQuantity: integer|Long expected";
        }
        if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity")) {
          if (!$util.isInteger(message.lastQuantity) && !(message.lastQuantity && $util.isInteger(message.lastQuantity.low) && $util.isInteger(message.lastQuantity.high)))
            return "lastQuantity: integer|Long expected";
        }
        if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
          if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
            return "leaveQuantity: integer|Long expected";
        }
        if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
          if (typeof message.lastPrice !== "number")
            return "lastPrice: number expected";
        }
        if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
          if (typeof message.averagePrice !== "number")
            return "averagePrice: number expected";
        }
        if (message.priceSecure != null && message.hasOwnProperty("priceSecure")) {
          if (typeof message.priceSecure !== "number")
            return "priceSecure: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.transDate != null && message.hasOwnProperty("transDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.transDate);
          if (error)
            return "transDate." + error;
        }
        if (message.execType != null && message.hasOwnProperty("execType")) {
          if (!$util.isString(message.execType))
            return "execType: string expected";
        }
        if (message.custody != null && message.hasOwnProperty("custody")) {
          if (!$util.isString(message.custody))
            return "custody: string expected";
        }
        if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
          if (typeof message.taxRate !== "number")
            return "taxRate: number expected";
        }
        if (message.feeRate != null && message.hasOwnProperty("feeRate")) {
          if (typeof message.feeRate !== "number")
            return "feeRate: number expected";
        }
        if (message.clOrdId != null && message.hasOwnProperty("clOrdId")) {
          if (!$util.isString(message.clOrdId))
            return "clOrdId: string expected";
        }
        if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId")) {
          if (!$util.isString(message.origClOrdId))
            return "origClOrdId: string expected";
        }
        if (message.maker != null && message.hasOwnProperty("maker")) {
          if (!$util.isString(message.maker))
            return "maker: string expected";
        }
        if (message.channel != null && message.hasOwnProperty("channel")) {
          if (!$util.isString(message.channel))
            return "channel: string expected";
        }
        if (message.externalId != null && message.hasOwnProperty("externalId")) {
          if (!$util.isString(message.externalId))
            return "externalId: string expected";
        }
        if (message.exDestination != null && message.hasOwnProperty("exDestination")) {
          if (!$util.isString(message.exDestination))
            return "exDestination: string expected";
        }
        if (message.error != null && message.hasOwnProperty("error")) {
          if (!$util.isString(message.error))
            return "error: string expected";
        }
        if (message.text != null && message.hasOwnProperty("text")) {
          if (!$util.isString(message.text))
            return "text: string expected";
        }
        if (message.reports != null && message.hasOwnProperty("reports")) {
          if (!Array.isArray(message.reports))
            return "reports: array expected";
          for (let i = 0; i < message.reports.length; ++i) {
            let error = $root.dnse.fo.Order.verify(message.reports[i]);
            if (error)
              return "reports." + error;
          }
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          if (!$util.isString(message.metadata))
            return "metadata: string expected";
        }
        if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate")) {
          if (typeof message.exchangeFeeRate !== "number")
            return "exchangeFeeRate: number expected";
        }
        return null;
      };
      Order.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Order)
          return object;
        let message = new $root.dnse.fo.Order();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.side != null)
          message.side = String(object.side);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.price != null)
          message.price = Number(object.price);
        if (object.quantity != null) {
          if ($util.Long)
            (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
          else if (typeof object.quantity === "string")
            message.quantity = parseInt(object.quantity, 10);
          else if (typeof object.quantity === "number")
            message.quantity = object.quantity;
          else if (typeof object.quantity === "object")
            message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        }
        if (object.orderType != null)
          message.orderType = String(object.orderType);
        if (object.orderStatus != null)
          message.orderStatus = String(object.orderStatus);
        if (object.fillQuantity != null) {
          if ($util.Long)
            (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
          else if (typeof object.fillQuantity === "string")
            message.fillQuantity = parseInt(object.fillQuantity, 10);
          else if (typeof object.fillQuantity === "number")
            message.fillQuantity = object.fillQuantity;
          else if (typeof object.fillQuantity === "object")
            message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
        }
        if (object.canceledQuantity != null) {
          if ($util.Long)
            (message.canceledQuantity = $util.Long.fromValue(object.canceledQuantity)).unsigned = false;
          else if (typeof object.canceledQuantity === "string")
            message.canceledQuantity = parseInt(object.canceledQuantity, 10);
          else if (typeof object.canceledQuantity === "number")
            message.canceledQuantity = object.canceledQuantity;
          else if (typeof object.canceledQuantity === "object")
            message.canceledQuantity = new $util.LongBits(object.canceledQuantity.low >>> 0, object.canceledQuantity.high >>> 0).toNumber();
        }
        if (object.lastQuantity != null) {
          if ($util.Long)
            (message.lastQuantity = $util.Long.fromValue(object.lastQuantity)).unsigned = false;
          else if (typeof object.lastQuantity === "string")
            message.lastQuantity = parseInt(object.lastQuantity, 10);
          else if (typeof object.lastQuantity === "number")
            message.lastQuantity = object.lastQuantity;
          else if (typeof object.lastQuantity === "object")
            message.lastQuantity = new $util.LongBits(object.lastQuantity.low >>> 0, object.lastQuantity.high >>> 0).toNumber();
        }
        if (object.leaveQuantity != null) {
          if ($util.Long)
            (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
          else if (typeof object.leaveQuantity === "string")
            message.leaveQuantity = parseInt(object.leaveQuantity, 10);
          else if (typeof object.leaveQuantity === "number")
            message.leaveQuantity = object.leaveQuantity;
          else if (typeof object.leaveQuantity === "object")
            message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
        }
        if (object.lastPrice != null)
          message.lastPrice = Number(object.lastPrice);
        if (object.averagePrice != null)
          message.averagePrice = Number(object.averagePrice);
        if (object.priceSecure != null)
          message.priceSecure = Number(object.priceSecure);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.Order.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.Order.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.transDate != null) {
          if (typeof object.transDate !== "object")
            throw TypeError(".dnse.fo.Order.transDate: object expected");
          message.transDate = $root.google.protobuf.Timestamp.fromObject(object.transDate);
        }
        if (object.execType != null)
          message.execType = String(object.execType);
        if (object.custody != null)
          message.custody = String(object.custody);
        if (object.taxRate != null)
          message.taxRate = Number(object.taxRate);
        if (object.feeRate != null)
          message.feeRate = Number(object.feeRate);
        if (object.clOrdId != null)
          message.clOrdId = String(object.clOrdId);
        if (object.origClOrdId != null)
          message.origClOrdId = String(object.origClOrdId);
        if (object.maker != null)
          message.maker = String(object.maker);
        if (object.channel != null)
          message.channel = String(object.channel);
        if (object.externalId != null)
          message.externalId = String(object.externalId);
        if (object.exDestination != null)
          message.exDestination = String(object.exDestination);
        if (object.error != null)
          message.error = String(object.error);
        if (object.text != null)
          message.text = String(object.text);
        if (object.reports) {
          if (!Array.isArray(object.reports))
            throw TypeError(".dnse.fo.Order.reports: array expected");
          message.reports = [];
          for (let i = 0; i < object.reports.length; ++i) {
            if (typeof object.reports[i] !== "object")
              throw TypeError(".dnse.fo.Order.reports: object expected");
            message.reports[i] = $root.dnse.fo.Order.fromObject(object.reports[i]);
          }
        }
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        if (object.metadata != null)
          message.metadata = String(object.metadata);
        if (object.exchangeFeeRate != null)
          message.exchangeFeeRate = Number(object.exchangeFeeRate);
        return message;
      };
      Order.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.reports = [];
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.side = "";
          object.accountNo = "";
          object.symbol = "";
          object.price = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.quantity = options.longs === String ? "0" : 0;
          object.orderType = "";
          object.orderStatus = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.fillQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.canceledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.canceledQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.lastQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.lastQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.leaveQuantity = options.longs === String ? "0" : 0;
          object.lastPrice = 0;
          object.averagePrice = 0;
          object.priceSecure = 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.transDate = null;
          object.execType = "";
          object.custody = "";
          object.taxRate = 0;
          object.feeRate = 0;
          object.clOrdId = "";
          object.origClOrdId = "";
          object.maker = "";
          object.channel = "";
          object.externalId = "";
          object.exDestination = "";
          object.error = "";
          object.text = "";
          object.investorId = "";
          object.loanPackageId = 0;
          object.initialRate = 0;
          object.metadata = "";
          object.exchangeFeeRate = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.side != null && message.hasOwnProperty("side"))
          object.side = message.side;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.price != null && message.hasOwnProperty("price"))
          object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
          if (typeof message.quantity === "number")
            object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
          else
            object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.orderType != null && message.hasOwnProperty("orderType"))
          object.orderType = message.orderType;
        if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
          object.orderStatus = message.orderStatus;
        if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
          if (typeof message.fillQuantity === "number")
            object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
          else
            object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
        if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity"))
          if (typeof message.canceledQuantity === "number")
            object.canceledQuantity = options.longs === String ? String(message.canceledQuantity) : message.canceledQuantity;
          else
            object.canceledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.canceledQuantity) : options.longs === Number ? new $util.LongBits(message.canceledQuantity.low >>> 0, message.canceledQuantity.high >>> 0).toNumber() : message.canceledQuantity;
        if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity"))
          if (typeof message.lastQuantity === "number")
            object.lastQuantity = options.longs === String ? String(message.lastQuantity) : message.lastQuantity;
          else
            object.lastQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.lastQuantity) : options.longs === Number ? new $util.LongBits(message.lastQuantity.low >>> 0, message.lastQuantity.high >>> 0).toNumber() : message.lastQuantity;
        if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
          if (typeof message.leaveQuantity === "number")
            object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
          else
            object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
        if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
          object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
        if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
          object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
        if (message.priceSecure != null && message.hasOwnProperty("priceSecure"))
          object.priceSecure = options.json && !isFinite(message.priceSecure) ? String(message.priceSecure) : message.priceSecure;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.transDate != null && message.hasOwnProperty("transDate"))
          object.transDate = $root.google.protobuf.Timestamp.toObject(message.transDate, options);
        if (message.execType != null && message.hasOwnProperty("execType"))
          object.execType = message.execType;
        if (message.custody != null && message.hasOwnProperty("custody"))
          object.custody = message.custody;
        if (message.taxRate != null && message.hasOwnProperty("taxRate"))
          object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
        if (message.feeRate != null && message.hasOwnProperty("feeRate"))
          object.feeRate = options.json && !isFinite(message.feeRate) ? String(message.feeRate) : message.feeRate;
        if (message.clOrdId != null && message.hasOwnProperty("clOrdId"))
          object.clOrdId = message.clOrdId;
        if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId"))
          object.origClOrdId = message.origClOrdId;
        if (message.maker != null && message.hasOwnProperty("maker"))
          object.maker = message.maker;
        if (message.channel != null && message.hasOwnProperty("channel"))
          object.channel = message.channel;
        if (message.externalId != null && message.hasOwnProperty("externalId"))
          object.externalId = message.externalId;
        if (message.exDestination != null && message.hasOwnProperty("exDestination"))
          object.exDestination = message.exDestination;
        if (message.error != null && message.hasOwnProperty("error"))
          object.error = message.error;
        if (message.text != null && message.hasOwnProperty("text"))
          object.text = message.text;
        if (message.reports && message.reports.length) {
          object.reports = [];
          for (let j = 0; j < message.reports.length; ++j)
            object.reports[j] = $root.dnse.fo.Order.toObject(message.reports[j], options);
        }
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = message.metadata;
        if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate"))
          object.exchangeFeeRate = options.json && !isFinite(message.exchangeFeeRate) ? String(message.exchangeFeeRate) : message.exchangeFeeRate;
        return object;
      };
      Order.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Order;
    }();
    fo.Metadata = function() {
      function Metadata(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Metadata.prototype.operation = 0;
      Metadata.prototype.ts = null;
      Metadata.prototype.source = "";
      Metadata.create = function create(properties) {
        return new Metadata(properties);
      };
      Metadata.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
          writer.uint32(8).int32(message.operation);
        if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
          $root.google.protobuf.Timestamp.encode(message.ts, writer.uint32(18).fork()).ldelim();
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(26).string(message.source);
        return writer;
      };
      Metadata.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Metadata.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Metadata();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.operation = reader.int32();
              break;
            case 2:
              message.ts = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 3:
              message.source = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Metadata.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Metadata.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.operation != null && message.hasOwnProperty("operation"))
          switch (message.operation) {
            default:
              return "operation: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.ts != null && message.hasOwnProperty("ts")) {
          let error = $root.google.protobuf.Timestamp.verify(message.ts);
          if (error)
            return "ts." + error;
        }
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        return null;
      };
      Metadata.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Metadata)
          return object;
        let message = new $root.dnse.fo.Metadata();
        switch (object.operation) {
          case "UPSERT":
          case 0:
            message.operation = 0;
            break;
          case "DELETE":
          case 1:
            message.operation = 1;
            break;
          case "CREATE":
          case 2:
            message.operation = 2;
            break;
          case "UPDATE":
          case 3:
            message.operation = 3;
            break;
        }
        if (object.ts != null) {
          if (typeof object.ts !== "object")
            throw TypeError(".dnse.fo.Metadata.ts: object expected");
          message.ts = $root.google.protobuf.Timestamp.fromObject(object.ts);
        }
        if (object.source != null)
          message.source = String(object.source);
        return message;
      };
      Metadata.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.operation = options.enums === String ? "UPSERT" : 0;
          object.ts = null;
          object.source = "";
        }
        if (message.operation != null && message.hasOwnProperty("operation"))
          object.operation = options.enums === String ? $root.dnse.fo.Metadata.Operation[message.operation] : message.operation;
        if (message.ts != null && message.hasOwnProperty("ts"))
          object.ts = $root.google.protobuf.Timestamp.toObject(message.ts, options);
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        return object;
      };
      Metadata.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      Metadata.Operation = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UPSERT"] = 0;
        values[valuesById[1] = "DELETE"] = 1;
        values[valuesById[2] = "CREATE"] = 2;
        values[valuesById[3] = "UPDATE"] = 3;
        return values;
      }();
      return Metadata;
    }();
    fo.PoolRuleItem = function() {
      function PoolRuleItem(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      PoolRuleItem.prototype.fromAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      PoolRuleItem.prototype.toAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      PoolRuleItem.prototype.action = 0;
      PoolRuleItem.create = function create(properties) {
        return new PoolRuleItem(properties);
      };
      PoolRuleItem.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.fromAmount != null && Object.hasOwnProperty.call(message, "fromAmount"))
          writer.uint32(8).int64(message.fromAmount);
        if (message.toAmount != null && Object.hasOwnProperty.call(message, "toAmount"))
          writer.uint32(16).int64(message.toAmount);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(24).int32(message.action);
        return writer;
      };
      PoolRuleItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      PoolRuleItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.PoolRuleItem();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.fromAmount = reader.int64();
              break;
            case 2:
              message.toAmount = reader.int64();
              break;
            case 3:
              message.action = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      PoolRuleItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      PoolRuleItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.fromAmount != null && message.hasOwnProperty("fromAmount")) {
          if (!$util.isInteger(message.fromAmount) && !(message.fromAmount && $util.isInteger(message.fromAmount.low) && $util.isInteger(message.fromAmount.high)))
            return "fromAmount: integer|Long expected";
        }
        if (message.toAmount != null && message.hasOwnProperty("toAmount")) {
          if (!$util.isInteger(message.toAmount) && !(message.toAmount && $util.isInteger(message.toAmount.low) && $util.isInteger(message.toAmount.high)))
            return "toAmount: integer|Long expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
              break;
          }
        return null;
      };
      PoolRuleItem.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.PoolRuleItem)
          return object;
        let message = new $root.dnse.fo.PoolRuleItem();
        if (object.fromAmount != null) {
          if ($util.Long)
            (message.fromAmount = $util.Long.fromValue(object.fromAmount)).unsigned = false;
          else if (typeof object.fromAmount === "string")
            message.fromAmount = parseInt(object.fromAmount, 10);
          else if (typeof object.fromAmount === "number")
            message.fromAmount = object.fromAmount;
          else if (typeof object.fromAmount === "object")
            message.fromAmount = new $util.LongBits(object.fromAmount.low >>> 0, object.fromAmount.high >>> 0).toNumber();
        }
        if (object.toAmount != null) {
          if ($util.Long)
            (message.toAmount = $util.Long.fromValue(object.toAmount)).unsigned = false;
          else if (typeof object.toAmount === "string")
            message.toAmount = parseInt(object.toAmount, 10);
          else if (typeof object.toAmount === "number")
            message.toAmount = object.toAmount;
          else if (typeof object.toAmount === "object")
            message.toAmount = new $util.LongBits(object.toAmount.low >>> 0, object.toAmount.high >>> 0).toNumber();
        }
        switch (object.action) {
          case "PASS":
          case 0:
            message.action = 0;
            break;
          case "REJECT":
          case 1:
            message.action = 1;
            break;
        }
        return message;
      };
      PoolRuleItem.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.fromAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.fromAmount = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.toAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.toAmount = options.longs === String ? "0" : 0;
          object.action = options.enums === String ? "PASS" : 0;
        }
        if (message.fromAmount != null && message.hasOwnProperty("fromAmount"))
          if (typeof message.fromAmount === "number")
            object.fromAmount = options.longs === String ? String(message.fromAmount) : message.fromAmount;
          else
            object.fromAmount = options.longs === String ? $util.Long.prototype.toString.call(message.fromAmount) : options.longs === Number ? new $util.LongBits(message.fromAmount.low >>> 0, message.fromAmount.high >>> 0).toNumber() : message.fromAmount;
        if (message.toAmount != null && message.hasOwnProperty("toAmount"))
          if (typeof message.toAmount === "number")
            object.toAmount = options.longs === String ? String(message.toAmount) : message.toAmount;
          else
            object.toAmount = options.longs === String ? $util.Long.prototype.toString.call(message.toAmount) : options.longs === Number ? new $util.LongBits(message.toAmount.low >>> 0, message.toAmount.high >>> 0).toNumber() : message.toAmount;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.PoolRuleItem.Action[message.action] : message.action;
        return object;
      };
      PoolRuleItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      PoolRuleItem.Action = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PASS"] = 0;
        values[valuesById[1] = "REJECT"] = 1;
        return values;
      }();
      return PoolRuleItem;
    }();
    fo.PoolRule = function() {
      function PoolRule(properties) {
        this.rules = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      PoolRule.prototype.source = "";
      PoolRule.prototype.loanType = "";
      PoolRule.prototype.accountNo = "";
      PoolRule.prototype.rules = $util.emptyArray;
      PoolRule.prototype.loanPackageId = 0;
      PoolRule.create = function create(properties) {
        return new PoolRule(properties);
      };
      PoolRule.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(10).string(message.source);
        if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
          writer.uint32(18).string(message.loanType);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(26).string(message.accountNo);
        if (message.rules != null && message.rules.length)
          for (let i = 0; i < message.rules.length; ++i)
            $root.dnse.fo.PoolRuleItem.encode(message.rules[i], writer.uint32(34).fork()).ldelim();
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(40).int32(message.loanPackageId);
        return writer;
      };
      PoolRule.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      PoolRule.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.PoolRule();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.source = reader.string();
              break;
            case 2:
              message.loanType = reader.string();
              break;
            case 3:
              message.accountNo = reader.string();
              break;
            case 4:
              if (!(message.rules && message.rules.length))
                message.rules = [];
              message.rules.push($root.dnse.fo.PoolRuleItem.decode(reader, reader.uint32()));
              break;
            case 5:
              message.loanPackageId = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      PoolRule.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      PoolRule.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        if (message.loanType != null && message.hasOwnProperty("loanType")) {
          if (!$util.isString(message.loanType))
            return "loanType: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.rules != null && message.hasOwnProperty("rules")) {
          if (!Array.isArray(message.rules))
            return "rules: array expected";
          for (let i = 0; i < message.rules.length; ++i) {
            let error = $root.dnse.fo.PoolRuleItem.verify(message.rules[i]);
            if (error)
              return "rules." + error;
          }
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        return null;
      };
      PoolRule.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.PoolRule)
          return object;
        let message = new $root.dnse.fo.PoolRule();
        if (object.source != null)
          message.source = String(object.source);
        if (object.loanType != null)
          message.loanType = String(object.loanType);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.rules) {
          if (!Array.isArray(object.rules))
            throw TypeError(".dnse.fo.PoolRule.rules: array expected");
          message.rules = [];
          for (let i = 0; i < object.rules.length; ++i) {
            if (typeof object.rules[i] !== "object")
              throw TypeError(".dnse.fo.PoolRule.rules: object expected");
            message.rules[i] = $root.dnse.fo.PoolRuleItem.fromObject(object.rules[i]);
          }
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        return message;
      };
      PoolRule.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.rules = [];
        if (options.defaults) {
          object.source = "";
          object.loanType = "";
          object.accountNo = "";
          object.loanPackageId = 0;
        }
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        if (message.loanType != null && message.hasOwnProperty("loanType"))
          object.loanType = message.loanType;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.rules && message.rules.length) {
          object.rules = [];
          for (let j = 0; j < message.rules.length; ++j)
            object.rules[j] = $root.dnse.fo.PoolRuleItem.toObject(message.rules[j], options);
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        return object;
      };
      PoolRule.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return PoolRule;
    }();
    fo.PoolRuleWrap = function() {
      function PoolRuleWrap(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      PoolRuleWrap.prototype.poolRule = null;
      PoolRuleWrap.prototype.metadata = null;
      PoolRuleWrap.create = function create(properties) {
        return new PoolRuleWrap(properties);
      };
      PoolRuleWrap.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.poolRule != null && Object.hasOwnProperty.call(message, "poolRule"))
          $root.dnse.fo.PoolRule.encode(message.poolRule, writer.uint32(10).fork()).ldelim();
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          $root.dnse.fo.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      PoolRuleWrap.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      PoolRuleWrap.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.PoolRuleWrap();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.poolRule = $root.dnse.fo.PoolRule.decode(reader, reader.uint32());
              break;
            case 2:
              message.metadata = $root.dnse.fo.Metadata.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      PoolRuleWrap.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      PoolRuleWrap.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.poolRule != null && message.hasOwnProperty("poolRule")) {
          let error = $root.dnse.fo.PoolRule.verify(message.poolRule);
          if (error)
            return "poolRule." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          let error = $root.dnse.fo.Metadata.verify(message.metadata);
          if (error)
            return "metadata." + error;
        }
        return null;
      };
      PoolRuleWrap.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.PoolRuleWrap)
          return object;
        let message = new $root.dnse.fo.PoolRuleWrap();
        if (object.poolRule != null) {
          if (typeof object.poolRule !== "object")
            throw TypeError(".dnse.fo.PoolRuleWrap.poolRule: object expected");
          message.poolRule = $root.dnse.fo.PoolRule.fromObject(object.poolRule);
        }
        if (object.metadata != null) {
          if (typeof object.metadata !== "object")
            throw TypeError(".dnse.fo.PoolRuleWrap.metadata: object expected");
          message.metadata = $root.dnse.fo.Metadata.fromObject(object.metadata);
        }
        return message;
      };
      PoolRuleWrap.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.poolRule = null;
          object.metadata = null;
        }
        if (message.poolRule != null && message.hasOwnProperty("poolRule"))
          object.poolRule = $root.dnse.fo.PoolRule.toObject(message.poolRule, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = $root.dnse.fo.Metadata.toObject(message.metadata, options);
        return object;
      };
      PoolRuleWrap.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return PoolRuleWrap;
    }();
    fo.IntraDayAction = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "C"] = 0;
      values[valuesById[1] = "D"] = 1;
      values[valuesById[2] = "U"] = 2;
      return values;
    }();
    fo.IntraDayCashEvent = function() {
      function IntraDayCashEvent(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      IntraDayCashEvent.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      IntraDayCashEvent.prototype.txNum = "";
      IntraDayCashEvent.prototype.txCode = "";
      IntraDayCashEvent.prototype.accountNo = "";
      IntraDayCashEvent.prototype.field = "";
      IntraDayCashEvent.prototype.value = 0;
      IntraDayCashEvent.prototype.action = 0;
      IntraDayCashEvent.prototype.txTime = null;
      IntraDayCashEvent.prototype.bizDate = "";
      IntraDayCashEvent.prototype.isRevert = false;
      IntraDayCashEvent.prototype.ref = "";
      IntraDayCashEvent.prototype.flag = "";
      IntraDayCashEvent.prototype.symbol = "";
      IntraDayCashEvent.prototype.keyId = "";
      IntraDayCashEvent.create = function create(properties) {
        return new IntraDayCashEvent(properties);
      };
      IntraDayCashEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.txNum != null && Object.hasOwnProperty.call(message, "txNum"))
          writer.uint32(18).string(message.txNum);
        if (message.txCode != null && Object.hasOwnProperty.call(message, "txCode"))
          writer.uint32(26).string(message.txCode);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(34).string(message.accountNo);
        if (message.field != null && Object.hasOwnProperty.call(message, "field"))
          writer.uint32(42).string(message.field);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(49).double(message.value);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(56).int32(message.action);
        if (message.txTime != null && Object.hasOwnProperty.call(message, "txTime"))
          $root.google.protobuf.Timestamp.encode(message.txTime, writer.uint32(66).fork()).ldelim();
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          writer.uint32(74).string(message.bizDate);
        if (message.isRevert != null && Object.hasOwnProperty.call(message, "isRevert"))
          writer.uint32(80).bool(message.isRevert);
        if (message.ref != null && Object.hasOwnProperty.call(message, "ref"))
          writer.uint32(90).string(message.ref);
        if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
          writer.uint32(98).string(message.flag);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(106).string(message.symbol);
        if (message.keyId != null && Object.hasOwnProperty.call(message, "keyId"))
          writer.uint32(114).string(message.keyId);
        return writer;
      };
      IntraDayCashEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      IntraDayCashEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.IntraDayCashEvent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.txNum = reader.string();
              break;
            case 3:
              message.txCode = reader.string();
              break;
            case 4:
              message.accountNo = reader.string();
              break;
            case 5:
              message.field = reader.string();
              break;
            case 6:
              message.value = reader.double();
              break;
            case 7:
              message.action = reader.int32();
              break;
            case 8:
              message.txTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 9:
              message.bizDate = reader.string();
              break;
            case 10:
              message.isRevert = reader.bool();
              break;
            case 11:
              message.ref = reader.string();
              break;
            case 12:
              message.flag = reader.string();
              break;
            case 13:
              message.symbol = reader.string();
              break;
            case 14:
              message.keyId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      IntraDayCashEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      IntraDayCashEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.txNum != null && message.hasOwnProperty("txNum")) {
          if (!$util.isString(message.txNum))
            return "txNum: string expected";
        }
        if (message.txCode != null && message.hasOwnProperty("txCode")) {
          if (!$util.isString(message.txCode))
            return "txCode: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.field != null && message.hasOwnProperty("field")) {
          if (!$util.isString(message.field))
            return "field: string expected";
        }
        if (message.value != null && message.hasOwnProperty("value")) {
          if (typeof message.value !== "number")
            return "value: number expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.txTime != null && message.hasOwnProperty("txTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.txTime);
          if (error)
            return "txTime." + error;
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          if (!$util.isString(message.bizDate))
            return "bizDate: string expected";
        }
        if (message.isRevert != null && message.hasOwnProperty("isRevert")) {
          if (typeof message.isRevert !== "boolean")
            return "isRevert: boolean expected";
        }
        if (message.ref != null && message.hasOwnProperty("ref")) {
          if (!$util.isString(message.ref))
            return "ref: string expected";
        }
        if (message.flag != null && message.hasOwnProperty("flag")) {
          if (!$util.isString(message.flag))
            return "flag: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.keyId != null && message.hasOwnProperty("keyId")) {
          if (!$util.isString(message.keyId))
            return "keyId: string expected";
        }
        return null;
      };
      IntraDayCashEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.IntraDayCashEvent)
          return object;
        let message = new $root.dnse.fo.IntraDayCashEvent();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.txNum != null)
          message.txNum = String(object.txNum);
        if (object.txCode != null)
          message.txCode = String(object.txCode);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.field != null)
          message.field = String(object.field);
        if (object.value != null)
          message.value = Number(object.value);
        switch (object.action) {
          case "C":
          case 0:
            message.action = 0;
            break;
          case "D":
          case 1:
            message.action = 1;
            break;
          case "U":
          case 2:
            message.action = 2;
            break;
        }
        if (object.txTime != null) {
          if (typeof object.txTime !== "object")
            throw TypeError(".dnse.fo.IntraDayCashEvent.txTime: object expected");
          message.txTime = $root.google.protobuf.Timestamp.fromObject(object.txTime);
        }
        if (object.bizDate != null)
          message.bizDate = String(object.bizDate);
        if (object.isRevert != null)
          message.isRevert = Boolean(object.isRevert);
        if (object.ref != null)
          message.ref = String(object.ref);
        if (object.flag != null)
          message.flag = String(object.flag);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.keyId != null)
          message.keyId = String(object.keyId);
        return message;
      };
      IntraDayCashEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.txNum = "";
          object.txCode = "";
          object.accountNo = "";
          object.field = "";
          object.value = 0;
          object.action = options.enums === String ? "C" : 0;
          object.txTime = null;
          object.bizDate = "";
          object.isRevert = false;
          object.ref = "";
          object.flag = "";
          object.symbol = "";
          object.keyId = "";
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.txNum != null && message.hasOwnProperty("txNum"))
          object.txNum = message.txNum;
        if (message.txCode != null && message.hasOwnProperty("txCode"))
          object.txCode = message.txCode;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.field != null && message.hasOwnProperty("field"))
          object.field = message.field;
        if (message.value != null && message.hasOwnProperty("value"))
          object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.IntraDayAction[message.action] : message.action;
        if (message.txTime != null && message.hasOwnProperty("txTime"))
          object.txTime = $root.google.protobuf.Timestamp.toObject(message.txTime, options);
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = message.bizDate;
        if (message.isRevert != null && message.hasOwnProperty("isRevert"))
          object.isRevert = message.isRevert;
        if (message.ref != null && message.hasOwnProperty("ref"))
          object.ref = message.ref;
        if (message.flag != null && message.hasOwnProperty("flag"))
          object.flag = message.flag;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.keyId != null && message.hasOwnProperty("keyId"))
          object.keyId = message.keyId;
        return object;
      };
      IntraDayCashEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return IntraDayCashEvent;
    }();
    fo.IntraDayPositionEvent = function() {
      function IntraDayPositionEvent(properties) {
        this.extra = {};
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      IntraDayPositionEvent.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      IntraDayPositionEvent.prototype.txNum = "";
      IntraDayPositionEvent.prototype.txCode = "";
      IntraDayPositionEvent.prototype.symbol = "";
      IntraDayPositionEvent.prototype.accountNo = "";
      IntraDayPositionEvent.prototype.field = "";
      IntraDayPositionEvent.prototype.value = 0;
      IntraDayPositionEvent.prototype.action = 0;
      IntraDayPositionEvent.prototype.txTime = null;
      IntraDayPositionEvent.prototype.bizDate = "";
      IntraDayPositionEvent.prototype.isRevert = false;
      IntraDayPositionEvent.prototype.ref = "";
      IntraDayPositionEvent.prototype.flag = "";
      IntraDayPositionEvent.prototype.extra = $util.emptyObject;
      IntraDayPositionEvent.prototype.keyId = "";
      IntraDayPositionEvent.create = function create(properties) {
        return new IntraDayPositionEvent(properties);
      };
      IntraDayPositionEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.txNum != null && Object.hasOwnProperty.call(message, "txNum"))
          writer.uint32(18).string(message.txNum);
        if (message.txCode != null && Object.hasOwnProperty.call(message, "txCode"))
          writer.uint32(26).string(message.txCode);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(34).string(message.symbol);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(42).string(message.accountNo);
        if (message.field != null && Object.hasOwnProperty.call(message, "field"))
          writer.uint32(50).string(message.field);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(57).double(message.value);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(64).int32(message.action);
        if (message.txTime != null && Object.hasOwnProperty.call(message, "txTime"))
          $root.google.protobuf.Timestamp.encode(message.txTime, writer.uint32(74).fork()).ldelim();
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          writer.uint32(82).string(message.bizDate);
        if (message.isRevert != null && Object.hasOwnProperty.call(message, "isRevert"))
          writer.uint32(88).bool(message.isRevert);
        if (message.ref != null && Object.hasOwnProperty.call(message, "ref"))
          writer.uint32(98).string(message.ref);
        if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
          writer.uint32(106).string(message.flag);
        if (message.extra != null && Object.hasOwnProperty.call(message, "extra"))
          for (let keys = Object.keys(message.extra), i = 0; i < keys.length; ++i)
            writer.uint32(114).fork().uint32(10).string(keys[i]).uint32(18).string(message.extra[keys[i]]).ldelim();
        if (message.keyId != null && Object.hasOwnProperty.call(message, "keyId"))
          writer.uint32(122).string(message.keyId);
        return writer;
      };
      IntraDayPositionEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      IntraDayPositionEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.IntraDayPositionEvent(), key, value;
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.txNum = reader.string();
              break;
            case 3:
              message.txCode = reader.string();
              break;
            case 4:
              message.symbol = reader.string();
              break;
            case 5:
              message.accountNo = reader.string();
              break;
            case 6:
              message.field = reader.string();
              break;
            case 7:
              message.value = reader.double();
              break;
            case 8:
              message.action = reader.int32();
              break;
            case 9:
              message.txTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 10:
              message.bizDate = reader.string();
              break;
            case 11:
              message.isRevert = reader.bool();
              break;
            case 12:
              message.ref = reader.string();
              break;
            case 13:
              message.flag = reader.string();
              break;
            case 14:
              if (message.extra === $util.emptyObject)
                message.extra = {};
              let end2 = reader.uint32() + reader.pos;
              key = "";
              value = "";
              while (reader.pos < end2) {
                let tag2 = reader.uint32();
                switch (tag2 >>> 3) {
                  case 1:
                    key = reader.string();
                    break;
                  case 2:
                    value = reader.string();
                    break;
                  default:
                    reader.skipType(tag2 & 7);
                    break;
                }
              }
              message.extra[key] = value;
              break;
            case 15:
              message.keyId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      IntraDayPositionEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      IntraDayPositionEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.txNum != null && message.hasOwnProperty("txNum")) {
          if (!$util.isString(message.txNum))
            return "txNum: string expected";
        }
        if (message.txCode != null && message.hasOwnProperty("txCode")) {
          if (!$util.isString(message.txCode))
            return "txCode: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.field != null && message.hasOwnProperty("field")) {
          if (!$util.isString(message.field))
            return "field: string expected";
        }
        if (message.value != null && message.hasOwnProperty("value")) {
          if (typeof message.value !== "number")
            return "value: number expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.txTime != null && message.hasOwnProperty("txTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.txTime);
          if (error)
            return "txTime." + error;
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          if (!$util.isString(message.bizDate))
            return "bizDate: string expected";
        }
        if (message.isRevert != null && message.hasOwnProperty("isRevert")) {
          if (typeof message.isRevert !== "boolean")
            return "isRevert: boolean expected";
        }
        if (message.ref != null && message.hasOwnProperty("ref")) {
          if (!$util.isString(message.ref))
            return "ref: string expected";
        }
        if (message.flag != null && message.hasOwnProperty("flag")) {
          if (!$util.isString(message.flag))
            return "flag: string expected";
        }
        if (message.extra != null && message.hasOwnProperty("extra")) {
          if (!$util.isObject(message.extra))
            return "extra: object expected";
          let key = Object.keys(message.extra);
          for (let i = 0; i < key.length; ++i)
            if (!$util.isString(message.extra[key[i]]))
              return "extra: string{k:string} expected";
        }
        if (message.keyId != null && message.hasOwnProperty("keyId")) {
          if (!$util.isString(message.keyId))
            return "keyId: string expected";
        }
        return null;
      };
      IntraDayPositionEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.IntraDayPositionEvent)
          return object;
        let message = new $root.dnse.fo.IntraDayPositionEvent();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.txNum != null)
          message.txNum = String(object.txNum);
        if (object.txCode != null)
          message.txCode = String(object.txCode);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.field != null)
          message.field = String(object.field);
        if (object.value != null)
          message.value = Number(object.value);
        switch (object.action) {
          case "C":
          case 0:
            message.action = 0;
            break;
          case "D":
          case 1:
            message.action = 1;
            break;
          case "U":
          case 2:
            message.action = 2;
            break;
        }
        if (object.txTime != null) {
          if (typeof object.txTime !== "object")
            throw TypeError(".dnse.fo.IntraDayPositionEvent.txTime: object expected");
          message.txTime = $root.google.protobuf.Timestamp.fromObject(object.txTime);
        }
        if (object.bizDate != null)
          message.bizDate = String(object.bizDate);
        if (object.isRevert != null)
          message.isRevert = Boolean(object.isRevert);
        if (object.ref != null)
          message.ref = String(object.ref);
        if (object.flag != null)
          message.flag = String(object.flag);
        if (object.extra) {
          if (typeof object.extra !== "object")
            throw TypeError(".dnse.fo.IntraDayPositionEvent.extra: object expected");
          message.extra = {};
          for (let keys = Object.keys(object.extra), i = 0; i < keys.length; ++i)
            message.extra[keys[i]] = String(object.extra[keys[i]]);
        }
        if (object.keyId != null)
          message.keyId = String(object.keyId);
        return message;
      };
      IntraDayPositionEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.objects || options.defaults)
          object.extra = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.txNum = "";
          object.txCode = "";
          object.symbol = "";
          object.accountNo = "";
          object.field = "";
          object.value = 0;
          object.action = options.enums === String ? "C" : 0;
          object.txTime = null;
          object.bizDate = "";
          object.isRevert = false;
          object.ref = "";
          object.flag = "";
          object.keyId = "";
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.txNum != null && message.hasOwnProperty("txNum"))
          object.txNum = message.txNum;
        if (message.txCode != null && message.hasOwnProperty("txCode"))
          object.txCode = message.txCode;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.field != null && message.hasOwnProperty("field"))
          object.field = message.field;
        if (message.value != null && message.hasOwnProperty("value"))
          object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.IntraDayAction[message.action] : message.action;
        if (message.txTime != null && message.hasOwnProperty("txTime"))
          object.txTime = $root.google.protobuf.Timestamp.toObject(message.txTime, options);
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = message.bizDate;
        if (message.isRevert != null && message.hasOwnProperty("isRevert"))
          object.isRevert = message.isRevert;
        if (message.ref != null && message.hasOwnProperty("ref"))
          object.ref = message.ref;
        if (message.flag != null && message.hasOwnProperty("flag"))
          object.flag = message.flag;
        let keys2;
        if (message.extra && (keys2 = Object.keys(message.extra)).length) {
          object.extra = {};
          for (let j = 0; j < keys2.length; ++j)
            object.extra[keys2[j]] = message.extra[keys2[j]];
        }
        if (message.keyId != null && message.hasOwnProperty("keyId"))
          object.keyId = message.keyId;
        return object;
      };
      IntraDayPositionEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return IntraDayPositionEvent;
    }();
    fo.Deal = function() {
      function Deal(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Deal.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.accountNo = "";
      Deal.prototype.symbol = "";
      Deal.prototype.status = 0;
      Deal.prototype.loanPackageId = 0;
      Deal.prototype.side = "";
      Deal.prototype.secure = 0;
      Deal.prototype.accumulateQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.tradeQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.closedQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.t0ReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.t1ReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.t2ReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.pendingCloseQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.costPrice = 0;
      Deal.prototype.averageCostPrice = 0;
      Deal.prototype.marketPrice = 0;
      Deal.prototype.realizedProfit = 0;
      Deal.prototype.collectedBuyingFee = 0;
      Deal.prototype.collectedBuyingTax = 0;
      Deal.prototype.collectedSellingFee = 0;
      Deal.prototype.collectedStockTransferFee = 0;
      Deal.prototype.collectedInterestFee = 0;
      Deal.prototype.collectedSellingTax = 0;
      Deal.prototype.realizedTotalTaxAndFee = 0;
      Deal.prototype.estimateRemainTaxAndFee = 0;
      Deal.prototype.unrealizedProfit = 0;
      Deal.prototype.dividendReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.dividendQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.cashReceiving = 0;
      Deal.prototype.rightReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.maxRightQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.t0ReceivingCash = 0;
      Deal.prototype.t1ReceivingCash = 0;
      Deal.prototype.t2ReceivingCash = 0;
      Deal.prototype.breakEvenPrice = 0;
      Deal.prototype.openQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.createdDate = null;
      Deal.prototype.modifiedDate = null;
      Deal.prototype.investorId = "";
      Deal.prototype.currentDebt = 0;
      Deal.prototype.currentInterest = 0;
      Deal.prototype.accumulateSecure = 0;
      Deal.prototype.accumulateDebt = 0;
      Deal.prototype.averageClosePrice = 0;
      Deal.prototype.realizedOpenFee = 0;
      Deal.prototype.realizedOpenTax = 0;
      Deal.prototype.collectedSellingDividendTax = 0;
      Deal.prototype.unrealizedOpenTaxAndFee = 0;
      Deal.prototype.accumulatePrepayDebt = 0;
      Deal.prototype.accumulatePrepayInterest = 0;
      Deal.prototype.unrealizedPrepayDebt = 0;
      Deal.prototype.unrealizedPrepayInterest = 0;
      Deal.prototype.stockBonusReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.accumulateMarginDebt = 0;
      Deal.prototype.marginDebt = 0;
      Deal.prototype.accumulateMarginPrepayDebt = 0;
      Deal.prototype.unrealizedMarginPrepayDebt = 0;
      Deal.prototype.dealManaDebt = 0;
      Deal.prototype.accumulateDealManaPrepayDebt = 0;
      Deal.prototype.unrealizedDealManaPrepayDebt = 0;
      Deal.prototype.accumulateDealManaDebt = 0;
      Deal.prototype.blockedTradeQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.restrictedTradeQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Deal.prototype.initialRate = 0;
      Deal.create = function create(properties) {
        return new Deal(properties);
      };
      Deal.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(26).string(message.symbol);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(32).int32(message.status);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(40).int32(message.loanPackageId);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
          writer.uint32(50).string(message.side);
        if (message.secure != null && Object.hasOwnProperty.call(message, "secure"))
          writer.uint32(57).double(message.secure);
        if (message.accumulateQuantity != null && Object.hasOwnProperty.call(message, "accumulateQuantity"))
          writer.uint32(64).int64(message.accumulateQuantity);
        if (message.tradeQuantity != null && Object.hasOwnProperty.call(message, "tradeQuantity"))
          writer.uint32(72).int64(message.tradeQuantity);
        if (message.closedQuantity != null && Object.hasOwnProperty.call(message, "closedQuantity"))
          writer.uint32(80).int64(message.closedQuantity);
        if (message.t0ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t0ReceivingQuantity"))
          writer.uint32(88).int64(message.t0ReceivingQuantity);
        if (message.t1ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t1ReceivingQuantity"))
          writer.uint32(96).int64(message.t1ReceivingQuantity);
        if (message.t2ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t2ReceivingQuantity"))
          writer.uint32(104).int64(message.t2ReceivingQuantity);
        if (message.pendingCloseQuantity != null && Object.hasOwnProperty.call(message, "pendingCloseQuantity"))
          writer.uint32(112).int64(message.pendingCloseQuantity);
        if (message.costPrice != null && Object.hasOwnProperty.call(message, "costPrice"))
          writer.uint32(121).double(message.costPrice);
        if (message.averageCostPrice != null && Object.hasOwnProperty.call(message, "averageCostPrice"))
          writer.uint32(129).double(message.averageCostPrice);
        if (message.marketPrice != null && Object.hasOwnProperty.call(message, "marketPrice"))
          writer.uint32(137).double(message.marketPrice);
        if (message.realizedProfit != null && Object.hasOwnProperty.call(message, "realizedProfit"))
          writer.uint32(145).double(message.realizedProfit);
        if (message.collectedBuyingFee != null && Object.hasOwnProperty.call(message, "collectedBuyingFee"))
          writer.uint32(153).double(message.collectedBuyingFee);
        if (message.collectedBuyingTax != null && Object.hasOwnProperty.call(message, "collectedBuyingTax"))
          writer.uint32(161).double(message.collectedBuyingTax);
        if (message.collectedSellingFee != null && Object.hasOwnProperty.call(message, "collectedSellingFee"))
          writer.uint32(169).double(message.collectedSellingFee);
        if (message.collectedStockTransferFee != null && Object.hasOwnProperty.call(message, "collectedStockTransferFee"))
          writer.uint32(177).double(message.collectedStockTransferFee);
        if (message.collectedInterestFee != null && Object.hasOwnProperty.call(message, "collectedInterestFee"))
          writer.uint32(185).double(message.collectedInterestFee);
        if (message.collectedSellingTax != null && Object.hasOwnProperty.call(message, "collectedSellingTax"))
          writer.uint32(193).double(message.collectedSellingTax);
        if (message.realizedTotalTaxAndFee != null && Object.hasOwnProperty.call(message, "realizedTotalTaxAndFee"))
          writer.uint32(201).double(message.realizedTotalTaxAndFee);
        if (message.estimateRemainTaxAndFee != null && Object.hasOwnProperty.call(message, "estimateRemainTaxAndFee"))
          writer.uint32(209).double(message.estimateRemainTaxAndFee);
        if (message.unrealizedProfit != null && Object.hasOwnProperty.call(message, "unrealizedProfit"))
          writer.uint32(217).double(message.unrealizedProfit);
        if (message.dividendReceivingQuantity != null && Object.hasOwnProperty.call(message, "dividendReceivingQuantity"))
          writer.uint32(224).int64(message.dividendReceivingQuantity);
        if (message.dividendQuantity != null && Object.hasOwnProperty.call(message, "dividendQuantity"))
          writer.uint32(232).int64(message.dividendQuantity);
        if (message.cashReceiving != null && Object.hasOwnProperty.call(message, "cashReceiving"))
          writer.uint32(241).double(message.cashReceiving);
        if (message.rightReceivingQuantity != null && Object.hasOwnProperty.call(message, "rightReceivingQuantity"))
          writer.uint32(248).int64(message.rightReceivingQuantity);
        if (message.maxRightQuantity != null && Object.hasOwnProperty.call(message, "maxRightQuantity"))
          writer.uint32(256).int64(message.maxRightQuantity);
        if (message.t0ReceivingCash != null && Object.hasOwnProperty.call(message, "t0ReceivingCash"))
          writer.uint32(265).double(message.t0ReceivingCash);
        if (message.t1ReceivingCash != null && Object.hasOwnProperty.call(message, "t1ReceivingCash"))
          writer.uint32(273).double(message.t1ReceivingCash);
        if (message.t2ReceivingCash != null && Object.hasOwnProperty.call(message, "t2ReceivingCash"))
          writer.uint32(281).double(message.t2ReceivingCash);
        if (message.breakEvenPrice != null && Object.hasOwnProperty.call(message, "breakEvenPrice"))
          writer.uint32(289).double(message.breakEvenPrice);
        if (message.openQuantity != null && Object.hasOwnProperty.call(message, "openQuantity"))
          writer.uint32(296).int64(message.openQuantity);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(306).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(314).fork()).ldelim();
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(322).string(message.investorId);
        if (message.currentDebt != null && Object.hasOwnProperty.call(message, "currentDebt"))
          writer.uint32(329).double(message.currentDebt);
        if (message.currentInterest != null && Object.hasOwnProperty.call(message, "currentInterest"))
          writer.uint32(337).double(message.currentInterest);
        if (message.accumulateSecure != null && Object.hasOwnProperty.call(message, "accumulateSecure"))
          writer.uint32(345).double(message.accumulateSecure);
        if (message.accumulateDebt != null && Object.hasOwnProperty.call(message, "accumulateDebt"))
          writer.uint32(353).double(message.accumulateDebt);
        if (message.averageClosePrice != null && Object.hasOwnProperty.call(message, "averageClosePrice"))
          writer.uint32(361).double(message.averageClosePrice);
        if (message.realizedOpenFee != null && Object.hasOwnProperty.call(message, "realizedOpenFee"))
          writer.uint32(369).double(message.realizedOpenFee);
        if (message.realizedOpenTax != null && Object.hasOwnProperty.call(message, "realizedOpenTax"))
          writer.uint32(377).double(message.realizedOpenTax);
        if (message.collectedSellingDividendTax != null && Object.hasOwnProperty.call(message, "collectedSellingDividendTax"))
          writer.uint32(385).double(message.collectedSellingDividendTax);
        if (message.unrealizedOpenTaxAndFee != null && Object.hasOwnProperty.call(message, "unrealizedOpenTaxAndFee"))
          writer.uint32(393).double(message.unrealizedOpenTaxAndFee);
        if (message.accumulatePrepayDebt != null && Object.hasOwnProperty.call(message, "accumulatePrepayDebt"))
          writer.uint32(401).double(message.accumulatePrepayDebt);
        if (message.accumulatePrepayInterest != null && Object.hasOwnProperty.call(message, "accumulatePrepayInterest"))
          writer.uint32(409).double(message.accumulatePrepayInterest);
        if (message.unrealizedPrepayDebt != null && Object.hasOwnProperty.call(message, "unrealizedPrepayDebt"))
          writer.uint32(417).double(message.unrealizedPrepayDebt);
        if (message.unrealizedPrepayInterest != null && Object.hasOwnProperty.call(message, "unrealizedPrepayInterest"))
          writer.uint32(425).double(message.unrealizedPrepayInterest);
        if (message.stockBonusReceivingQuantity != null && Object.hasOwnProperty.call(message, "stockBonusReceivingQuantity"))
          writer.uint32(432).int64(message.stockBonusReceivingQuantity);
        if (message.accumulateMarginDebt != null && Object.hasOwnProperty.call(message, "accumulateMarginDebt"))
          writer.uint32(441).double(message.accumulateMarginDebt);
        if (message.marginDebt != null && Object.hasOwnProperty.call(message, "marginDebt"))
          writer.uint32(449).double(message.marginDebt);
        if (message.accumulateMarginPrepayDebt != null && Object.hasOwnProperty.call(message, "accumulateMarginPrepayDebt"))
          writer.uint32(457).double(message.accumulateMarginPrepayDebt);
        if (message.unrealizedMarginPrepayDebt != null && Object.hasOwnProperty.call(message, "unrealizedMarginPrepayDebt"))
          writer.uint32(465).double(message.unrealizedMarginPrepayDebt);
        if (message.dealManaDebt != null && Object.hasOwnProperty.call(message, "dealManaDebt"))
          writer.uint32(473).double(message.dealManaDebt);
        if (message.accumulateDealManaPrepayDebt != null && Object.hasOwnProperty.call(message, "accumulateDealManaPrepayDebt"))
          writer.uint32(481).double(message.accumulateDealManaPrepayDebt);
        if (message.unrealizedDealManaPrepayDebt != null && Object.hasOwnProperty.call(message, "unrealizedDealManaPrepayDebt"))
          writer.uint32(489).double(message.unrealizedDealManaPrepayDebt);
        if (message.accumulateDealManaDebt != null && Object.hasOwnProperty.call(message, "accumulateDealManaDebt"))
          writer.uint32(497).double(message.accumulateDealManaDebt);
        if (message.blockedTradeQuantity != null && Object.hasOwnProperty.call(message, "blockedTradeQuantity"))
          writer.uint32(504).int64(message.blockedTradeQuantity);
        if (message.restrictedTradeQuantity != null && Object.hasOwnProperty.call(message, "restrictedTradeQuantity"))
          writer.uint32(512).int64(message.restrictedTradeQuantity);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(521).double(message.initialRate);
        return writer;
      };
      Deal.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Deal.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Deal();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.symbol = reader.string();
              break;
            case 4:
              message.status = reader.int32();
              break;
            case 5:
              message.loanPackageId = reader.int32();
              break;
            case 6:
              message.side = reader.string();
              break;
            case 7:
              message.secure = reader.double();
              break;
            case 8:
              message.accumulateQuantity = reader.int64();
              break;
            case 9:
              message.tradeQuantity = reader.int64();
              break;
            case 10:
              message.closedQuantity = reader.int64();
              break;
            case 11:
              message.t0ReceivingQuantity = reader.int64();
              break;
            case 12:
              message.t1ReceivingQuantity = reader.int64();
              break;
            case 13:
              message.t2ReceivingQuantity = reader.int64();
              break;
            case 14:
              message.pendingCloseQuantity = reader.int64();
              break;
            case 15:
              message.costPrice = reader.double();
              break;
            case 16:
              message.averageCostPrice = reader.double();
              break;
            case 17:
              message.marketPrice = reader.double();
              break;
            case 18:
              message.realizedProfit = reader.double();
              break;
            case 19:
              message.collectedBuyingFee = reader.double();
              break;
            case 20:
              message.collectedBuyingTax = reader.double();
              break;
            case 21:
              message.collectedSellingFee = reader.double();
              break;
            case 22:
              message.collectedStockTransferFee = reader.double();
              break;
            case 23:
              message.collectedInterestFee = reader.double();
              break;
            case 24:
              message.collectedSellingTax = reader.double();
              break;
            case 25:
              message.realizedTotalTaxAndFee = reader.double();
              break;
            case 26:
              message.estimateRemainTaxAndFee = reader.double();
              break;
            case 27:
              message.unrealizedProfit = reader.double();
              break;
            case 28:
              message.dividendReceivingQuantity = reader.int64();
              break;
            case 29:
              message.dividendQuantity = reader.int64();
              break;
            case 30:
              message.cashReceiving = reader.double();
              break;
            case 31:
              message.rightReceivingQuantity = reader.int64();
              break;
            case 32:
              message.maxRightQuantity = reader.int64();
              break;
            case 33:
              message.t0ReceivingCash = reader.double();
              break;
            case 34:
              message.t1ReceivingCash = reader.double();
              break;
            case 35:
              message.t2ReceivingCash = reader.double();
              break;
            case 36:
              message.breakEvenPrice = reader.double();
              break;
            case 37:
              message.openQuantity = reader.int64();
              break;
            case 38:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 39:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 40:
              message.investorId = reader.string();
              break;
            case 41:
              message.currentDebt = reader.double();
              break;
            case 42:
              message.currentInterest = reader.double();
              break;
            case 43:
              message.accumulateSecure = reader.double();
              break;
            case 44:
              message.accumulateDebt = reader.double();
              break;
            case 45:
              message.averageClosePrice = reader.double();
              break;
            case 46:
              message.realizedOpenFee = reader.double();
              break;
            case 47:
              message.realizedOpenTax = reader.double();
              break;
            case 48:
              message.collectedSellingDividendTax = reader.double();
              break;
            case 49:
              message.unrealizedOpenTaxAndFee = reader.double();
              break;
            case 50:
              message.accumulatePrepayDebt = reader.double();
              break;
            case 51:
              message.accumulatePrepayInterest = reader.double();
              break;
            case 52:
              message.unrealizedPrepayDebt = reader.double();
              break;
            case 53:
              message.unrealizedPrepayInterest = reader.double();
              break;
            case 54:
              message.stockBonusReceivingQuantity = reader.int64();
              break;
            case 55:
              message.accumulateMarginDebt = reader.double();
              break;
            case 56:
              message.marginDebt = reader.double();
              break;
            case 57:
              message.accumulateMarginPrepayDebt = reader.double();
              break;
            case 58:
              message.unrealizedMarginPrepayDebt = reader.double();
              break;
            case 59:
              message.dealManaDebt = reader.double();
              break;
            case 60:
              message.accumulateDealManaPrepayDebt = reader.double();
              break;
            case 61:
              message.unrealizedDealManaPrepayDebt = reader.double();
              break;
            case 62:
              message.accumulateDealManaDebt = reader.double();
              break;
            case 63:
              message.blockedTradeQuantity = reader.int64();
              break;
            case 64:
              message.restrictedTradeQuantity = reader.int64();
              break;
            case 65:
              message.initialRate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Deal.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Deal.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.side != null && message.hasOwnProperty("side")) {
          if (!$util.isString(message.side))
            return "side: string expected";
        }
        if (message.secure != null && message.hasOwnProperty("secure")) {
          if (typeof message.secure !== "number")
            return "secure: number expected";
        }
        if (message.accumulateQuantity != null && message.hasOwnProperty("accumulateQuantity")) {
          if (!$util.isInteger(message.accumulateQuantity) && !(message.accumulateQuantity && $util.isInteger(message.accumulateQuantity.low) && $util.isInteger(message.accumulateQuantity.high)))
            return "accumulateQuantity: integer|Long expected";
        }
        if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity")) {
          if (!$util.isInteger(message.tradeQuantity) && !(message.tradeQuantity && $util.isInteger(message.tradeQuantity.low) && $util.isInteger(message.tradeQuantity.high)))
            return "tradeQuantity: integer|Long expected";
        }
        if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity")) {
          if (!$util.isInteger(message.closedQuantity) && !(message.closedQuantity && $util.isInteger(message.closedQuantity.low) && $util.isInteger(message.closedQuantity.high)))
            return "closedQuantity: integer|Long expected";
        }
        if (message.t0ReceivingQuantity != null && message.hasOwnProperty("t0ReceivingQuantity")) {
          if (!$util.isInteger(message.t0ReceivingQuantity) && !(message.t0ReceivingQuantity && $util.isInteger(message.t0ReceivingQuantity.low) && $util.isInteger(message.t0ReceivingQuantity.high)))
            return "t0ReceivingQuantity: integer|Long expected";
        }
        if (message.t1ReceivingQuantity != null && message.hasOwnProperty("t1ReceivingQuantity")) {
          if (!$util.isInteger(message.t1ReceivingQuantity) && !(message.t1ReceivingQuantity && $util.isInteger(message.t1ReceivingQuantity.low) && $util.isInteger(message.t1ReceivingQuantity.high)))
            return "t1ReceivingQuantity: integer|Long expected";
        }
        if (message.t2ReceivingQuantity != null && message.hasOwnProperty("t2ReceivingQuantity")) {
          if (!$util.isInteger(message.t2ReceivingQuantity) && !(message.t2ReceivingQuantity && $util.isInteger(message.t2ReceivingQuantity.low) && $util.isInteger(message.t2ReceivingQuantity.high)))
            return "t2ReceivingQuantity: integer|Long expected";
        }
        if (message.pendingCloseQuantity != null && message.hasOwnProperty("pendingCloseQuantity")) {
          if (!$util.isInteger(message.pendingCloseQuantity) && !(message.pendingCloseQuantity && $util.isInteger(message.pendingCloseQuantity.low) && $util.isInteger(message.pendingCloseQuantity.high)))
            return "pendingCloseQuantity: integer|Long expected";
        }
        if (message.costPrice != null && message.hasOwnProperty("costPrice")) {
          if (typeof message.costPrice !== "number")
            return "costPrice: number expected";
        }
        if (message.averageCostPrice != null && message.hasOwnProperty("averageCostPrice")) {
          if (typeof message.averageCostPrice !== "number")
            return "averageCostPrice: number expected";
        }
        if (message.marketPrice != null && message.hasOwnProperty("marketPrice")) {
          if (typeof message.marketPrice !== "number")
            return "marketPrice: number expected";
        }
        if (message.realizedProfit != null && message.hasOwnProperty("realizedProfit")) {
          if (typeof message.realizedProfit !== "number")
            return "realizedProfit: number expected";
        }
        if (message.collectedBuyingFee != null && message.hasOwnProperty("collectedBuyingFee")) {
          if (typeof message.collectedBuyingFee !== "number")
            return "collectedBuyingFee: number expected";
        }
        if (message.collectedBuyingTax != null && message.hasOwnProperty("collectedBuyingTax")) {
          if (typeof message.collectedBuyingTax !== "number")
            return "collectedBuyingTax: number expected";
        }
        if (message.collectedSellingFee != null && message.hasOwnProperty("collectedSellingFee")) {
          if (typeof message.collectedSellingFee !== "number")
            return "collectedSellingFee: number expected";
        }
        if (message.collectedStockTransferFee != null && message.hasOwnProperty("collectedStockTransferFee")) {
          if (typeof message.collectedStockTransferFee !== "number")
            return "collectedStockTransferFee: number expected";
        }
        if (message.collectedInterestFee != null && message.hasOwnProperty("collectedInterestFee")) {
          if (typeof message.collectedInterestFee !== "number")
            return "collectedInterestFee: number expected";
        }
        if (message.collectedSellingTax != null && message.hasOwnProperty("collectedSellingTax")) {
          if (typeof message.collectedSellingTax !== "number")
            return "collectedSellingTax: number expected";
        }
        if (message.realizedTotalTaxAndFee != null && message.hasOwnProperty("realizedTotalTaxAndFee")) {
          if (typeof message.realizedTotalTaxAndFee !== "number")
            return "realizedTotalTaxAndFee: number expected";
        }
        if (message.estimateRemainTaxAndFee != null && message.hasOwnProperty("estimateRemainTaxAndFee")) {
          if (typeof message.estimateRemainTaxAndFee !== "number")
            return "estimateRemainTaxAndFee: number expected";
        }
        if (message.unrealizedProfit != null && message.hasOwnProperty("unrealizedProfit")) {
          if (typeof message.unrealizedProfit !== "number")
            return "unrealizedProfit: number expected";
        }
        if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity")) {
          if (!$util.isInteger(message.dividendReceivingQuantity) && !(message.dividendReceivingQuantity && $util.isInteger(message.dividendReceivingQuantity.low) && $util.isInteger(message.dividendReceivingQuantity.high)))
            return "dividendReceivingQuantity: integer|Long expected";
        }
        if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity")) {
          if (!$util.isInteger(message.dividendQuantity) && !(message.dividendQuantity && $util.isInteger(message.dividendQuantity.low) && $util.isInteger(message.dividendQuantity.high)))
            return "dividendQuantity: integer|Long expected";
        }
        if (message.cashReceiving != null && message.hasOwnProperty("cashReceiving")) {
          if (typeof message.cashReceiving !== "number")
            return "cashReceiving: number expected";
        }
        if (message.rightReceivingQuantity != null && message.hasOwnProperty("rightReceivingQuantity")) {
          if (!$util.isInteger(message.rightReceivingQuantity) && !(message.rightReceivingQuantity && $util.isInteger(message.rightReceivingQuantity.low) && $util.isInteger(message.rightReceivingQuantity.high)))
            return "rightReceivingQuantity: integer|Long expected";
        }
        if (message.maxRightQuantity != null && message.hasOwnProperty("maxRightQuantity")) {
          if (!$util.isInteger(message.maxRightQuantity) && !(message.maxRightQuantity && $util.isInteger(message.maxRightQuantity.low) && $util.isInteger(message.maxRightQuantity.high)))
            return "maxRightQuantity: integer|Long expected";
        }
        if (message.t0ReceivingCash != null && message.hasOwnProperty("t0ReceivingCash")) {
          if (typeof message.t0ReceivingCash !== "number")
            return "t0ReceivingCash: number expected";
        }
        if (message.t1ReceivingCash != null && message.hasOwnProperty("t1ReceivingCash")) {
          if (typeof message.t1ReceivingCash !== "number")
            return "t1ReceivingCash: number expected";
        }
        if (message.t2ReceivingCash != null && message.hasOwnProperty("t2ReceivingCash")) {
          if (typeof message.t2ReceivingCash !== "number")
            return "t2ReceivingCash: number expected";
        }
        if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice")) {
          if (typeof message.breakEvenPrice !== "number")
            return "breakEvenPrice: number expected";
        }
        if (message.openQuantity != null && message.hasOwnProperty("openQuantity")) {
          if (!$util.isInteger(message.openQuantity) && !(message.openQuantity && $util.isInteger(message.openQuantity.low) && $util.isInteger(message.openQuantity.high)))
            return "openQuantity: integer|Long expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.currentDebt != null && message.hasOwnProperty("currentDebt")) {
          if (typeof message.currentDebt !== "number")
            return "currentDebt: number expected";
        }
        if (message.currentInterest != null && message.hasOwnProperty("currentInterest")) {
          if (typeof message.currentInterest !== "number")
            return "currentInterest: number expected";
        }
        if (message.accumulateSecure != null && message.hasOwnProperty("accumulateSecure")) {
          if (typeof message.accumulateSecure !== "number")
            return "accumulateSecure: number expected";
        }
        if (message.accumulateDebt != null && message.hasOwnProperty("accumulateDebt")) {
          if (typeof message.accumulateDebt !== "number")
            return "accumulateDebt: number expected";
        }
        if (message.averageClosePrice != null && message.hasOwnProperty("averageClosePrice")) {
          if (typeof message.averageClosePrice !== "number")
            return "averageClosePrice: number expected";
        }
        if (message.realizedOpenFee != null && message.hasOwnProperty("realizedOpenFee")) {
          if (typeof message.realizedOpenFee !== "number")
            return "realizedOpenFee: number expected";
        }
        if (message.realizedOpenTax != null && message.hasOwnProperty("realizedOpenTax")) {
          if (typeof message.realizedOpenTax !== "number")
            return "realizedOpenTax: number expected";
        }
        if (message.collectedSellingDividendTax != null && message.hasOwnProperty("collectedSellingDividendTax")) {
          if (typeof message.collectedSellingDividendTax !== "number")
            return "collectedSellingDividendTax: number expected";
        }
        if (message.unrealizedOpenTaxAndFee != null && message.hasOwnProperty("unrealizedOpenTaxAndFee")) {
          if (typeof message.unrealizedOpenTaxAndFee !== "number")
            return "unrealizedOpenTaxAndFee: number expected";
        }
        if (message.accumulatePrepayDebt != null && message.hasOwnProperty("accumulatePrepayDebt")) {
          if (typeof message.accumulatePrepayDebt !== "number")
            return "accumulatePrepayDebt: number expected";
        }
        if (message.accumulatePrepayInterest != null && message.hasOwnProperty("accumulatePrepayInterest")) {
          if (typeof message.accumulatePrepayInterest !== "number")
            return "accumulatePrepayInterest: number expected";
        }
        if (message.unrealizedPrepayDebt != null && message.hasOwnProperty("unrealizedPrepayDebt")) {
          if (typeof message.unrealizedPrepayDebt !== "number")
            return "unrealizedPrepayDebt: number expected";
        }
        if (message.unrealizedPrepayInterest != null && message.hasOwnProperty("unrealizedPrepayInterest")) {
          if (typeof message.unrealizedPrepayInterest !== "number")
            return "unrealizedPrepayInterest: number expected";
        }
        if (message.stockBonusReceivingQuantity != null && message.hasOwnProperty("stockBonusReceivingQuantity")) {
          if (!$util.isInteger(message.stockBonusReceivingQuantity) && !(message.stockBonusReceivingQuantity && $util.isInteger(message.stockBonusReceivingQuantity.low) && $util.isInteger(message.stockBonusReceivingQuantity.high)))
            return "stockBonusReceivingQuantity: integer|Long expected";
        }
        if (message.accumulateMarginDebt != null && message.hasOwnProperty("accumulateMarginDebt")) {
          if (typeof message.accumulateMarginDebt !== "number")
            return "accumulateMarginDebt: number expected";
        }
        if (message.marginDebt != null && message.hasOwnProperty("marginDebt")) {
          if (typeof message.marginDebt !== "number")
            return "marginDebt: number expected";
        }
        if (message.accumulateMarginPrepayDebt != null && message.hasOwnProperty("accumulateMarginPrepayDebt")) {
          if (typeof message.accumulateMarginPrepayDebt !== "number")
            return "accumulateMarginPrepayDebt: number expected";
        }
        if (message.unrealizedMarginPrepayDebt != null && message.hasOwnProperty("unrealizedMarginPrepayDebt")) {
          if (typeof message.unrealizedMarginPrepayDebt !== "number")
            return "unrealizedMarginPrepayDebt: number expected";
        }
        if (message.dealManaDebt != null && message.hasOwnProperty("dealManaDebt")) {
          if (typeof message.dealManaDebt !== "number")
            return "dealManaDebt: number expected";
        }
        if (message.accumulateDealManaPrepayDebt != null && message.hasOwnProperty("accumulateDealManaPrepayDebt")) {
          if (typeof message.accumulateDealManaPrepayDebt !== "number")
            return "accumulateDealManaPrepayDebt: number expected";
        }
        if (message.unrealizedDealManaPrepayDebt != null && message.hasOwnProperty("unrealizedDealManaPrepayDebt")) {
          if (typeof message.unrealizedDealManaPrepayDebt !== "number")
            return "unrealizedDealManaPrepayDebt: number expected";
        }
        if (message.accumulateDealManaDebt != null && message.hasOwnProperty("accumulateDealManaDebt")) {
          if (typeof message.accumulateDealManaDebt !== "number")
            return "accumulateDealManaDebt: number expected";
        }
        if (message.blockedTradeQuantity != null && message.hasOwnProperty("blockedTradeQuantity")) {
          if (!$util.isInteger(message.blockedTradeQuantity) && !(message.blockedTradeQuantity && $util.isInteger(message.blockedTradeQuantity.low) && $util.isInteger(message.blockedTradeQuantity.high)))
            return "blockedTradeQuantity: integer|Long expected";
        }
        if (message.restrictedTradeQuantity != null && message.hasOwnProperty("restrictedTradeQuantity")) {
          if (!$util.isInteger(message.restrictedTradeQuantity) && !(message.restrictedTradeQuantity && $util.isInteger(message.restrictedTradeQuantity.low) && $util.isInteger(message.restrictedTradeQuantity.high)))
            return "restrictedTradeQuantity: integer|Long expected";
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        return null;
      };
      Deal.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Deal)
          return object;
        let message = new $root.dnse.fo.Deal();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        switch (object.status) {
          case "OPEN":
          case 0:
            message.status = 0;
            break;
          case "CLOSED":
          case 1:
            message.status = 1;
            break;
          case "PENDING_CLOSE":
          case 2:
            message.status = 2;
            break;
          case "ODD_LOT":
          case 3:
            message.status = 3;
            break;
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.side != null)
          message.side = String(object.side);
        if (object.secure != null)
          message.secure = Number(object.secure);
        if (object.accumulateQuantity != null) {
          if ($util.Long)
            (message.accumulateQuantity = $util.Long.fromValue(object.accumulateQuantity)).unsigned = false;
          else if (typeof object.accumulateQuantity === "string")
            message.accumulateQuantity = parseInt(object.accumulateQuantity, 10);
          else if (typeof object.accumulateQuantity === "number")
            message.accumulateQuantity = object.accumulateQuantity;
          else if (typeof object.accumulateQuantity === "object")
            message.accumulateQuantity = new $util.LongBits(object.accumulateQuantity.low >>> 0, object.accumulateQuantity.high >>> 0).toNumber();
        }
        if (object.tradeQuantity != null) {
          if ($util.Long)
            (message.tradeQuantity = $util.Long.fromValue(object.tradeQuantity)).unsigned = false;
          else if (typeof object.tradeQuantity === "string")
            message.tradeQuantity = parseInt(object.tradeQuantity, 10);
          else if (typeof object.tradeQuantity === "number")
            message.tradeQuantity = object.tradeQuantity;
          else if (typeof object.tradeQuantity === "object")
            message.tradeQuantity = new $util.LongBits(object.tradeQuantity.low >>> 0, object.tradeQuantity.high >>> 0).toNumber();
        }
        if (object.closedQuantity != null) {
          if ($util.Long)
            (message.closedQuantity = $util.Long.fromValue(object.closedQuantity)).unsigned = false;
          else if (typeof object.closedQuantity === "string")
            message.closedQuantity = parseInt(object.closedQuantity, 10);
          else if (typeof object.closedQuantity === "number")
            message.closedQuantity = object.closedQuantity;
          else if (typeof object.closedQuantity === "object")
            message.closedQuantity = new $util.LongBits(object.closedQuantity.low >>> 0, object.closedQuantity.high >>> 0).toNumber();
        }
        if (object.t0ReceivingQuantity != null) {
          if ($util.Long)
            (message.t0ReceivingQuantity = $util.Long.fromValue(object.t0ReceivingQuantity)).unsigned = false;
          else if (typeof object.t0ReceivingQuantity === "string")
            message.t0ReceivingQuantity = parseInt(object.t0ReceivingQuantity, 10);
          else if (typeof object.t0ReceivingQuantity === "number")
            message.t0ReceivingQuantity = object.t0ReceivingQuantity;
          else if (typeof object.t0ReceivingQuantity === "object")
            message.t0ReceivingQuantity = new $util.LongBits(object.t0ReceivingQuantity.low >>> 0, object.t0ReceivingQuantity.high >>> 0).toNumber();
        }
        if (object.t1ReceivingQuantity != null) {
          if ($util.Long)
            (message.t1ReceivingQuantity = $util.Long.fromValue(object.t1ReceivingQuantity)).unsigned = false;
          else if (typeof object.t1ReceivingQuantity === "string")
            message.t1ReceivingQuantity = parseInt(object.t1ReceivingQuantity, 10);
          else if (typeof object.t1ReceivingQuantity === "number")
            message.t1ReceivingQuantity = object.t1ReceivingQuantity;
          else if (typeof object.t1ReceivingQuantity === "object")
            message.t1ReceivingQuantity = new $util.LongBits(object.t1ReceivingQuantity.low >>> 0, object.t1ReceivingQuantity.high >>> 0).toNumber();
        }
        if (object.t2ReceivingQuantity != null) {
          if ($util.Long)
            (message.t2ReceivingQuantity = $util.Long.fromValue(object.t2ReceivingQuantity)).unsigned = false;
          else if (typeof object.t2ReceivingQuantity === "string")
            message.t2ReceivingQuantity = parseInt(object.t2ReceivingQuantity, 10);
          else if (typeof object.t2ReceivingQuantity === "number")
            message.t2ReceivingQuantity = object.t2ReceivingQuantity;
          else if (typeof object.t2ReceivingQuantity === "object")
            message.t2ReceivingQuantity = new $util.LongBits(object.t2ReceivingQuantity.low >>> 0, object.t2ReceivingQuantity.high >>> 0).toNumber();
        }
        if (object.pendingCloseQuantity != null) {
          if ($util.Long)
            (message.pendingCloseQuantity = $util.Long.fromValue(object.pendingCloseQuantity)).unsigned = false;
          else if (typeof object.pendingCloseQuantity === "string")
            message.pendingCloseQuantity = parseInt(object.pendingCloseQuantity, 10);
          else if (typeof object.pendingCloseQuantity === "number")
            message.pendingCloseQuantity = object.pendingCloseQuantity;
          else if (typeof object.pendingCloseQuantity === "object")
            message.pendingCloseQuantity = new $util.LongBits(object.pendingCloseQuantity.low >>> 0, object.pendingCloseQuantity.high >>> 0).toNumber();
        }
        if (object.costPrice != null)
          message.costPrice = Number(object.costPrice);
        if (object.averageCostPrice != null)
          message.averageCostPrice = Number(object.averageCostPrice);
        if (object.marketPrice != null)
          message.marketPrice = Number(object.marketPrice);
        if (object.realizedProfit != null)
          message.realizedProfit = Number(object.realizedProfit);
        if (object.collectedBuyingFee != null)
          message.collectedBuyingFee = Number(object.collectedBuyingFee);
        if (object.collectedBuyingTax != null)
          message.collectedBuyingTax = Number(object.collectedBuyingTax);
        if (object.collectedSellingFee != null)
          message.collectedSellingFee = Number(object.collectedSellingFee);
        if (object.collectedStockTransferFee != null)
          message.collectedStockTransferFee = Number(object.collectedStockTransferFee);
        if (object.collectedInterestFee != null)
          message.collectedInterestFee = Number(object.collectedInterestFee);
        if (object.collectedSellingTax != null)
          message.collectedSellingTax = Number(object.collectedSellingTax);
        if (object.realizedTotalTaxAndFee != null)
          message.realizedTotalTaxAndFee = Number(object.realizedTotalTaxAndFee);
        if (object.estimateRemainTaxAndFee != null)
          message.estimateRemainTaxAndFee = Number(object.estimateRemainTaxAndFee);
        if (object.unrealizedProfit != null)
          message.unrealizedProfit = Number(object.unrealizedProfit);
        if (object.dividendReceivingQuantity != null) {
          if ($util.Long)
            (message.dividendReceivingQuantity = $util.Long.fromValue(object.dividendReceivingQuantity)).unsigned = false;
          else if (typeof object.dividendReceivingQuantity === "string")
            message.dividendReceivingQuantity = parseInt(object.dividendReceivingQuantity, 10);
          else if (typeof object.dividendReceivingQuantity === "number")
            message.dividendReceivingQuantity = object.dividendReceivingQuantity;
          else if (typeof object.dividendReceivingQuantity === "object")
            message.dividendReceivingQuantity = new $util.LongBits(object.dividendReceivingQuantity.low >>> 0, object.dividendReceivingQuantity.high >>> 0).toNumber();
        }
        if (object.dividendQuantity != null) {
          if ($util.Long)
            (message.dividendQuantity = $util.Long.fromValue(object.dividendQuantity)).unsigned = false;
          else if (typeof object.dividendQuantity === "string")
            message.dividendQuantity = parseInt(object.dividendQuantity, 10);
          else if (typeof object.dividendQuantity === "number")
            message.dividendQuantity = object.dividendQuantity;
          else if (typeof object.dividendQuantity === "object")
            message.dividendQuantity = new $util.LongBits(object.dividendQuantity.low >>> 0, object.dividendQuantity.high >>> 0).toNumber();
        }
        if (object.cashReceiving != null)
          message.cashReceiving = Number(object.cashReceiving);
        if (object.rightReceivingQuantity != null) {
          if ($util.Long)
            (message.rightReceivingQuantity = $util.Long.fromValue(object.rightReceivingQuantity)).unsigned = false;
          else if (typeof object.rightReceivingQuantity === "string")
            message.rightReceivingQuantity = parseInt(object.rightReceivingQuantity, 10);
          else if (typeof object.rightReceivingQuantity === "number")
            message.rightReceivingQuantity = object.rightReceivingQuantity;
          else if (typeof object.rightReceivingQuantity === "object")
            message.rightReceivingQuantity = new $util.LongBits(object.rightReceivingQuantity.low >>> 0, object.rightReceivingQuantity.high >>> 0).toNumber();
        }
        if (object.maxRightQuantity != null) {
          if ($util.Long)
            (message.maxRightQuantity = $util.Long.fromValue(object.maxRightQuantity)).unsigned = false;
          else if (typeof object.maxRightQuantity === "string")
            message.maxRightQuantity = parseInt(object.maxRightQuantity, 10);
          else if (typeof object.maxRightQuantity === "number")
            message.maxRightQuantity = object.maxRightQuantity;
          else if (typeof object.maxRightQuantity === "object")
            message.maxRightQuantity = new $util.LongBits(object.maxRightQuantity.low >>> 0, object.maxRightQuantity.high >>> 0).toNumber();
        }
        if (object.t0ReceivingCash != null)
          message.t0ReceivingCash = Number(object.t0ReceivingCash);
        if (object.t1ReceivingCash != null)
          message.t1ReceivingCash = Number(object.t1ReceivingCash);
        if (object.t2ReceivingCash != null)
          message.t2ReceivingCash = Number(object.t2ReceivingCash);
        if (object.breakEvenPrice != null)
          message.breakEvenPrice = Number(object.breakEvenPrice);
        if (object.openQuantity != null) {
          if ($util.Long)
            (message.openQuantity = $util.Long.fromValue(object.openQuantity)).unsigned = false;
          else if (typeof object.openQuantity === "string")
            message.openQuantity = parseInt(object.openQuantity, 10);
          else if (typeof object.openQuantity === "number")
            message.openQuantity = object.openQuantity;
          else if (typeof object.openQuantity === "object")
            message.openQuantity = new $util.LongBits(object.openQuantity.low >>> 0, object.openQuantity.high >>> 0).toNumber();
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.Deal.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.Deal.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.currentDebt != null)
          message.currentDebt = Number(object.currentDebt);
        if (object.currentInterest != null)
          message.currentInterest = Number(object.currentInterest);
        if (object.accumulateSecure != null)
          message.accumulateSecure = Number(object.accumulateSecure);
        if (object.accumulateDebt != null)
          message.accumulateDebt = Number(object.accumulateDebt);
        if (object.averageClosePrice != null)
          message.averageClosePrice = Number(object.averageClosePrice);
        if (object.realizedOpenFee != null)
          message.realizedOpenFee = Number(object.realizedOpenFee);
        if (object.realizedOpenTax != null)
          message.realizedOpenTax = Number(object.realizedOpenTax);
        if (object.collectedSellingDividendTax != null)
          message.collectedSellingDividendTax = Number(object.collectedSellingDividendTax);
        if (object.unrealizedOpenTaxAndFee != null)
          message.unrealizedOpenTaxAndFee = Number(object.unrealizedOpenTaxAndFee);
        if (object.accumulatePrepayDebt != null)
          message.accumulatePrepayDebt = Number(object.accumulatePrepayDebt);
        if (object.accumulatePrepayInterest != null)
          message.accumulatePrepayInterest = Number(object.accumulatePrepayInterest);
        if (object.unrealizedPrepayDebt != null)
          message.unrealizedPrepayDebt = Number(object.unrealizedPrepayDebt);
        if (object.unrealizedPrepayInterest != null)
          message.unrealizedPrepayInterest = Number(object.unrealizedPrepayInterest);
        if (object.stockBonusReceivingQuantity != null) {
          if ($util.Long)
            (message.stockBonusReceivingQuantity = $util.Long.fromValue(object.stockBonusReceivingQuantity)).unsigned = false;
          else if (typeof object.stockBonusReceivingQuantity === "string")
            message.stockBonusReceivingQuantity = parseInt(object.stockBonusReceivingQuantity, 10);
          else if (typeof object.stockBonusReceivingQuantity === "number")
            message.stockBonusReceivingQuantity = object.stockBonusReceivingQuantity;
          else if (typeof object.stockBonusReceivingQuantity === "object")
            message.stockBonusReceivingQuantity = new $util.LongBits(object.stockBonusReceivingQuantity.low >>> 0, object.stockBonusReceivingQuantity.high >>> 0).toNumber();
        }
        if (object.accumulateMarginDebt != null)
          message.accumulateMarginDebt = Number(object.accumulateMarginDebt);
        if (object.marginDebt != null)
          message.marginDebt = Number(object.marginDebt);
        if (object.accumulateMarginPrepayDebt != null)
          message.accumulateMarginPrepayDebt = Number(object.accumulateMarginPrepayDebt);
        if (object.unrealizedMarginPrepayDebt != null)
          message.unrealizedMarginPrepayDebt = Number(object.unrealizedMarginPrepayDebt);
        if (object.dealManaDebt != null)
          message.dealManaDebt = Number(object.dealManaDebt);
        if (object.accumulateDealManaPrepayDebt != null)
          message.accumulateDealManaPrepayDebt = Number(object.accumulateDealManaPrepayDebt);
        if (object.unrealizedDealManaPrepayDebt != null)
          message.unrealizedDealManaPrepayDebt = Number(object.unrealizedDealManaPrepayDebt);
        if (object.accumulateDealManaDebt != null)
          message.accumulateDealManaDebt = Number(object.accumulateDealManaDebt);
        if (object.blockedTradeQuantity != null) {
          if ($util.Long)
            (message.blockedTradeQuantity = $util.Long.fromValue(object.blockedTradeQuantity)).unsigned = false;
          else if (typeof object.blockedTradeQuantity === "string")
            message.blockedTradeQuantity = parseInt(object.blockedTradeQuantity, 10);
          else if (typeof object.blockedTradeQuantity === "number")
            message.blockedTradeQuantity = object.blockedTradeQuantity;
          else if (typeof object.blockedTradeQuantity === "object")
            message.blockedTradeQuantity = new $util.LongBits(object.blockedTradeQuantity.low >>> 0, object.blockedTradeQuantity.high >>> 0).toNumber();
        }
        if (object.restrictedTradeQuantity != null) {
          if ($util.Long)
            (message.restrictedTradeQuantity = $util.Long.fromValue(object.restrictedTradeQuantity)).unsigned = false;
          else if (typeof object.restrictedTradeQuantity === "string")
            message.restrictedTradeQuantity = parseInt(object.restrictedTradeQuantity, 10);
          else if (typeof object.restrictedTradeQuantity === "number")
            message.restrictedTradeQuantity = object.restrictedTradeQuantity;
          else if (typeof object.restrictedTradeQuantity === "object")
            message.restrictedTradeQuantity = new $util.LongBits(object.restrictedTradeQuantity.low >>> 0, object.restrictedTradeQuantity.high >>> 0).toNumber();
        }
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        return message;
      };
      Deal.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.symbol = "";
          object.status = options.enums === String ? "OPEN" : 0;
          object.loanPackageId = 0;
          object.side = "";
          object.secure = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.accumulateQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.accumulateQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.tradeQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.tradeQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.closedQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.closedQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t0ReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t0ReceivingQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t1ReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t1ReceivingQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.t2ReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.t2ReceivingQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.pendingCloseQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.pendingCloseQuantity = options.longs === String ? "0" : 0;
          object.costPrice = 0;
          object.averageCostPrice = 0;
          object.marketPrice = 0;
          object.realizedProfit = 0;
          object.collectedBuyingFee = 0;
          object.collectedBuyingTax = 0;
          object.collectedSellingFee = 0;
          object.collectedStockTransferFee = 0;
          object.collectedInterestFee = 0;
          object.collectedSellingTax = 0;
          object.realizedTotalTaxAndFee = 0;
          object.estimateRemainTaxAndFee = 0;
          object.unrealizedProfit = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.dividendReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.dividendReceivingQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.dividendQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.dividendQuantity = options.longs === String ? "0" : 0;
          object.cashReceiving = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.rightReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.rightReceivingQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.maxRightQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.maxRightQuantity = options.longs === String ? "0" : 0;
          object.t0ReceivingCash = 0;
          object.t1ReceivingCash = 0;
          object.t2ReceivingCash = 0;
          object.breakEvenPrice = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.openQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.openQuantity = options.longs === String ? "0" : 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.investorId = "";
          object.currentDebt = 0;
          object.currentInterest = 0;
          object.accumulateSecure = 0;
          object.accumulateDebt = 0;
          object.averageClosePrice = 0;
          object.realizedOpenFee = 0;
          object.realizedOpenTax = 0;
          object.collectedSellingDividendTax = 0;
          object.unrealizedOpenTaxAndFee = 0;
          object.accumulatePrepayDebt = 0;
          object.accumulatePrepayInterest = 0;
          object.unrealizedPrepayDebt = 0;
          object.unrealizedPrepayInterest = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.stockBonusReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.stockBonusReceivingQuantity = options.longs === String ? "0" : 0;
          object.accumulateMarginDebt = 0;
          object.marginDebt = 0;
          object.accumulateMarginPrepayDebt = 0;
          object.unrealizedMarginPrepayDebt = 0;
          object.dealManaDebt = 0;
          object.accumulateDealManaPrepayDebt = 0;
          object.unrealizedDealManaPrepayDebt = 0;
          object.accumulateDealManaDebt = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.blockedTradeQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.blockedTradeQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.restrictedTradeQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.restrictedTradeQuantity = options.longs === String ? "0" : 0;
          object.initialRate = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.Deal.Status[message.status] : message.status;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.side != null && message.hasOwnProperty("side"))
          object.side = message.side;
        if (message.secure != null && message.hasOwnProperty("secure"))
          object.secure = options.json && !isFinite(message.secure) ? String(message.secure) : message.secure;
        if (message.accumulateQuantity != null && message.hasOwnProperty("accumulateQuantity"))
          if (typeof message.accumulateQuantity === "number")
            object.accumulateQuantity = options.longs === String ? String(message.accumulateQuantity) : message.accumulateQuantity;
          else
            object.accumulateQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.accumulateQuantity) : options.longs === Number ? new $util.LongBits(message.accumulateQuantity.low >>> 0, message.accumulateQuantity.high >>> 0).toNumber() : message.accumulateQuantity;
        if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity"))
          if (typeof message.tradeQuantity === "number")
            object.tradeQuantity = options.longs === String ? String(message.tradeQuantity) : message.tradeQuantity;
          else
            object.tradeQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.tradeQuantity) : options.longs === Number ? new $util.LongBits(message.tradeQuantity.low >>> 0, message.tradeQuantity.high >>> 0).toNumber() : message.tradeQuantity;
        if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity"))
          if (typeof message.closedQuantity === "number")
            object.closedQuantity = options.longs === String ? String(message.closedQuantity) : message.closedQuantity;
          else
            object.closedQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.closedQuantity) : options.longs === Number ? new $util.LongBits(message.closedQuantity.low >>> 0, message.closedQuantity.high >>> 0).toNumber() : message.closedQuantity;
        if (message.t0ReceivingQuantity != null && message.hasOwnProperty("t0ReceivingQuantity"))
          if (typeof message.t0ReceivingQuantity === "number")
            object.t0ReceivingQuantity = options.longs === String ? String(message.t0ReceivingQuantity) : message.t0ReceivingQuantity;
          else
            object.t0ReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.t0ReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.t0ReceivingQuantity.low >>> 0, message.t0ReceivingQuantity.high >>> 0).toNumber() : message.t0ReceivingQuantity;
        if (message.t1ReceivingQuantity != null && message.hasOwnProperty("t1ReceivingQuantity"))
          if (typeof message.t1ReceivingQuantity === "number")
            object.t1ReceivingQuantity = options.longs === String ? String(message.t1ReceivingQuantity) : message.t1ReceivingQuantity;
          else
            object.t1ReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.t1ReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.t1ReceivingQuantity.low >>> 0, message.t1ReceivingQuantity.high >>> 0).toNumber() : message.t1ReceivingQuantity;
        if (message.t2ReceivingQuantity != null && message.hasOwnProperty("t2ReceivingQuantity"))
          if (typeof message.t2ReceivingQuantity === "number")
            object.t2ReceivingQuantity = options.longs === String ? String(message.t2ReceivingQuantity) : message.t2ReceivingQuantity;
          else
            object.t2ReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.t2ReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.t2ReceivingQuantity.low >>> 0, message.t2ReceivingQuantity.high >>> 0).toNumber() : message.t2ReceivingQuantity;
        if (message.pendingCloseQuantity != null && message.hasOwnProperty("pendingCloseQuantity"))
          if (typeof message.pendingCloseQuantity === "number")
            object.pendingCloseQuantity = options.longs === String ? String(message.pendingCloseQuantity) : message.pendingCloseQuantity;
          else
            object.pendingCloseQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.pendingCloseQuantity) : options.longs === Number ? new $util.LongBits(message.pendingCloseQuantity.low >>> 0, message.pendingCloseQuantity.high >>> 0).toNumber() : message.pendingCloseQuantity;
        if (message.costPrice != null && message.hasOwnProperty("costPrice"))
          object.costPrice = options.json && !isFinite(message.costPrice) ? String(message.costPrice) : message.costPrice;
        if (message.averageCostPrice != null && message.hasOwnProperty("averageCostPrice"))
          object.averageCostPrice = options.json && !isFinite(message.averageCostPrice) ? String(message.averageCostPrice) : message.averageCostPrice;
        if (message.marketPrice != null && message.hasOwnProperty("marketPrice"))
          object.marketPrice = options.json && !isFinite(message.marketPrice) ? String(message.marketPrice) : message.marketPrice;
        if (message.realizedProfit != null && message.hasOwnProperty("realizedProfit"))
          object.realizedProfit = options.json && !isFinite(message.realizedProfit) ? String(message.realizedProfit) : message.realizedProfit;
        if (message.collectedBuyingFee != null && message.hasOwnProperty("collectedBuyingFee"))
          object.collectedBuyingFee = options.json && !isFinite(message.collectedBuyingFee) ? String(message.collectedBuyingFee) : message.collectedBuyingFee;
        if (message.collectedBuyingTax != null && message.hasOwnProperty("collectedBuyingTax"))
          object.collectedBuyingTax = options.json && !isFinite(message.collectedBuyingTax) ? String(message.collectedBuyingTax) : message.collectedBuyingTax;
        if (message.collectedSellingFee != null && message.hasOwnProperty("collectedSellingFee"))
          object.collectedSellingFee = options.json && !isFinite(message.collectedSellingFee) ? String(message.collectedSellingFee) : message.collectedSellingFee;
        if (message.collectedStockTransferFee != null && message.hasOwnProperty("collectedStockTransferFee"))
          object.collectedStockTransferFee = options.json && !isFinite(message.collectedStockTransferFee) ? String(message.collectedStockTransferFee) : message.collectedStockTransferFee;
        if (message.collectedInterestFee != null && message.hasOwnProperty("collectedInterestFee"))
          object.collectedInterestFee = options.json && !isFinite(message.collectedInterestFee) ? String(message.collectedInterestFee) : message.collectedInterestFee;
        if (message.collectedSellingTax != null && message.hasOwnProperty("collectedSellingTax"))
          object.collectedSellingTax = options.json && !isFinite(message.collectedSellingTax) ? String(message.collectedSellingTax) : message.collectedSellingTax;
        if (message.realizedTotalTaxAndFee != null && message.hasOwnProperty("realizedTotalTaxAndFee"))
          object.realizedTotalTaxAndFee = options.json && !isFinite(message.realizedTotalTaxAndFee) ? String(message.realizedTotalTaxAndFee) : message.realizedTotalTaxAndFee;
        if (message.estimateRemainTaxAndFee != null && message.hasOwnProperty("estimateRemainTaxAndFee"))
          object.estimateRemainTaxAndFee = options.json && !isFinite(message.estimateRemainTaxAndFee) ? String(message.estimateRemainTaxAndFee) : message.estimateRemainTaxAndFee;
        if (message.unrealizedProfit != null && message.hasOwnProperty("unrealizedProfit"))
          object.unrealizedProfit = options.json && !isFinite(message.unrealizedProfit) ? String(message.unrealizedProfit) : message.unrealizedProfit;
        if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity"))
          if (typeof message.dividendReceivingQuantity === "number")
            object.dividendReceivingQuantity = options.longs === String ? String(message.dividendReceivingQuantity) : message.dividendReceivingQuantity;
          else
            object.dividendReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.dividendReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.dividendReceivingQuantity.low >>> 0, message.dividendReceivingQuantity.high >>> 0).toNumber() : message.dividendReceivingQuantity;
        if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity"))
          if (typeof message.dividendQuantity === "number")
            object.dividendQuantity = options.longs === String ? String(message.dividendQuantity) : message.dividendQuantity;
          else
            object.dividendQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.dividendQuantity) : options.longs === Number ? new $util.LongBits(message.dividendQuantity.low >>> 0, message.dividendQuantity.high >>> 0).toNumber() : message.dividendQuantity;
        if (message.cashReceiving != null && message.hasOwnProperty("cashReceiving"))
          object.cashReceiving = options.json && !isFinite(message.cashReceiving) ? String(message.cashReceiving) : message.cashReceiving;
        if (message.rightReceivingQuantity != null && message.hasOwnProperty("rightReceivingQuantity"))
          if (typeof message.rightReceivingQuantity === "number")
            object.rightReceivingQuantity = options.longs === String ? String(message.rightReceivingQuantity) : message.rightReceivingQuantity;
          else
            object.rightReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.rightReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.rightReceivingQuantity.low >>> 0, message.rightReceivingQuantity.high >>> 0).toNumber() : message.rightReceivingQuantity;
        if (message.maxRightQuantity != null && message.hasOwnProperty("maxRightQuantity"))
          if (typeof message.maxRightQuantity === "number")
            object.maxRightQuantity = options.longs === String ? String(message.maxRightQuantity) : message.maxRightQuantity;
          else
            object.maxRightQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.maxRightQuantity) : options.longs === Number ? new $util.LongBits(message.maxRightQuantity.low >>> 0, message.maxRightQuantity.high >>> 0).toNumber() : message.maxRightQuantity;
        if (message.t0ReceivingCash != null && message.hasOwnProperty("t0ReceivingCash"))
          object.t0ReceivingCash = options.json && !isFinite(message.t0ReceivingCash) ? String(message.t0ReceivingCash) : message.t0ReceivingCash;
        if (message.t1ReceivingCash != null && message.hasOwnProperty("t1ReceivingCash"))
          object.t1ReceivingCash = options.json && !isFinite(message.t1ReceivingCash) ? String(message.t1ReceivingCash) : message.t1ReceivingCash;
        if (message.t2ReceivingCash != null && message.hasOwnProperty("t2ReceivingCash"))
          object.t2ReceivingCash = options.json && !isFinite(message.t2ReceivingCash) ? String(message.t2ReceivingCash) : message.t2ReceivingCash;
        if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice"))
          object.breakEvenPrice = options.json && !isFinite(message.breakEvenPrice) ? String(message.breakEvenPrice) : message.breakEvenPrice;
        if (message.openQuantity != null && message.hasOwnProperty("openQuantity"))
          if (typeof message.openQuantity === "number")
            object.openQuantity = options.longs === String ? String(message.openQuantity) : message.openQuantity;
          else
            object.openQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.openQuantity) : options.longs === Number ? new $util.LongBits(message.openQuantity.low >>> 0, message.openQuantity.high >>> 0).toNumber() : message.openQuantity;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.currentDebt != null && message.hasOwnProperty("currentDebt"))
          object.currentDebt = options.json && !isFinite(message.currentDebt) ? String(message.currentDebt) : message.currentDebt;
        if (message.currentInterest != null && message.hasOwnProperty("currentInterest"))
          object.currentInterest = options.json && !isFinite(message.currentInterest) ? String(message.currentInterest) : message.currentInterest;
        if (message.accumulateSecure != null && message.hasOwnProperty("accumulateSecure"))
          object.accumulateSecure = options.json && !isFinite(message.accumulateSecure) ? String(message.accumulateSecure) : message.accumulateSecure;
        if (message.accumulateDebt != null && message.hasOwnProperty("accumulateDebt"))
          object.accumulateDebt = options.json && !isFinite(message.accumulateDebt) ? String(message.accumulateDebt) : message.accumulateDebt;
        if (message.averageClosePrice != null && message.hasOwnProperty("averageClosePrice"))
          object.averageClosePrice = options.json && !isFinite(message.averageClosePrice) ? String(message.averageClosePrice) : message.averageClosePrice;
        if (message.realizedOpenFee != null && message.hasOwnProperty("realizedOpenFee"))
          object.realizedOpenFee = options.json && !isFinite(message.realizedOpenFee) ? String(message.realizedOpenFee) : message.realizedOpenFee;
        if (message.realizedOpenTax != null && message.hasOwnProperty("realizedOpenTax"))
          object.realizedOpenTax = options.json && !isFinite(message.realizedOpenTax) ? String(message.realizedOpenTax) : message.realizedOpenTax;
        if (message.collectedSellingDividendTax != null && message.hasOwnProperty("collectedSellingDividendTax"))
          object.collectedSellingDividendTax = options.json && !isFinite(message.collectedSellingDividendTax) ? String(message.collectedSellingDividendTax) : message.collectedSellingDividendTax;
        if (message.unrealizedOpenTaxAndFee != null && message.hasOwnProperty("unrealizedOpenTaxAndFee"))
          object.unrealizedOpenTaxAndFee = options.json && !isFinite(message.unrealizedOpenTaxAndFee) ? String(message.unrealizedOpenTaxAndFee) : message.unrealizedOpenTaxAndFee;
        if (message.accumulatePrepayDebt != null && message.hasOwnProperty("accumulatePrepayDebt"))
          object.accumulatePrepayDebt = options.json && !isFinite(message.accumulatePrepayDebt) ? String(message.accumulatePrepayDebt) : message.accumulatePrepayDebt;
        if (message.accumulatePrepayInterest != null && message.hasOwnProperty("accumulatePrepayInterest"))
          object.accumulatePrepayInterest = options.json && !isFinite(message.accumulatePrepayInterest) ? String(message.accumulatePrepayInterest) : message.accumulatePrepayInterest;
        if (message.unrealizedPrepayDebt != null && message.hasOwnProperty("unrealizedPrepayDebt"))
          object.unrealizedPrepayDebt = options.json && !isFinite(message.unrealizedPrepayDebt) ? String(message.unrealizedPrepayDebt) : message.unrealizedPrepayDebt;
        if (message.unrealizedPrepayInterest != null && message.hasOwnProperty("unrealizedPrepayInterest"))
          object.unrealizedPrepayInterest = options.json && !isFinite(message.unrealizedPrepayInterest) ? String(message.unrealizedPrepayInterest) : message.unrealizedPrepayInterest;
        if (message.stockBonusReceivingQuantity != null && message.hasOwnProperty("stockBonusReceivingQuantity"))
          if (typeof message.stockBonusReceivingQuantity === "number")
            object.stockBonusReceivingQuantity = options.longs === String ? String(message.stockBonusReceivingQuantity) : message.stockBonusReceivingQuantity;
          else
            object.stockBonusReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.stockBonusReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.stockBonusReceivingQuantity.low >>> 0, message.stockBonusReceivingQuantity.high >>> 0).toNumber() : message.stockBonusReceivingQuantity;
        if (message.accumulateMarginDebt != null && message.hasOwnProperty("accumulateMarginDebt"))
          object.accumulateMarginDebt = options.json && !isFinite(message.accumulateMarginDebt) ? String(message.accumulateMarginDebt) : message.accumulateMarginDebt;
        if (message.marginDebt != null && message.hasOwnProperty("marginDebt"))
          object.marginDebt = options.json && !isFinite(message.marginDebt) ? String(message.marginDebt) : message.marginDebt;
        if (message.accumulateMarginPrepayDebt != null && message.hasOwnProperty("accumulateMarginPrepayDebt"))
          object.accumulateMarginPrepayDebt = options.json && !isFinite(message.accumulateMarginPrepayDebt) ? String(message.accumulateMarginPrepayDebt) : message.accumulateMarginPrepayDebt;
        if (message.unrealizedMarginPrepayDebt != null && message.hasOwnProperty("unrealizedMarginPrepayDebt"))
          object.unrealizedMarginPrepayDebt = options.json && !isFinite(message.unrealizedMarginPrepayDebt) ? String(message.unrealizedMarginPrepayDebt) : message.unrealizedMarginPrepayDebt;
        if (message.dealManaDebt != null && message.hasOwnProperty("dealManaDebt"))
          object.dealManaDebt = options.json && !isFinite(message.dealManaDebt) ? String(message.dealManaDebt) : message.dealManaDebt;
        if (message.accumulateDealManaPrepayDebt != null && message.hasOwnProperty("accumulateDealManaPrepayDebt"))
          object.accumulateDealManaPrepayDebt = options.json && !isFinite(message.accumulateDealManaPrepayDebt) ? String(message.accumulateDealManaPrepayDebt) : message.accumulateDealManaPrepayDebt;
        if (message.unrealizedDealManaPrepayDebt != null && message.hasOwnProperty("unrealizedDealManaPrepayDebt"))
          object.unrealizedDealManaPrepayDebt = options.json && !isFinite(message.unrealizedDealManaPrepayDebt) ? String(message.unrealizedDealManaPrepayDebt) : message.unrealizedDealManaPrepayDebt;
        if (message.accumulateDealManaDebt != null && message.hasOwnProperty("accumulateDealManaDebt"))
          object.accumulateDealManaDebt = options.json && !isFinite(message.accumulateDealManaDebt) ? String(message.accumulateDealManaDebt) : message.accumulateDealManaDebt;
        if (message.blockedTradeQuantity != null && message.hasOwnProperty("blockedTradeQuantity"))
          if (typeof message.blockedTradeQuantity === "number")
            object.blockedTradeQuantity = options.longs === String ? String(message.blockedTradeQuantity) : message.blockedTradeQuantity;
          else
            object.blockedTradeQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.blockedTradeQuantity) : options.longs === Number ? new $util.LongBits(message.blockedTradeQuantity.low >>> 0, message.blockedTradeQuantity.high >>> 0).toNumber() : message.blockedTradeQuantity;
        if (message.restrictedTradeQuantity != null && message.hasOwnProperty("restrictedTradeQuantity"))
          if (typeof message.restrictedTradeQuantity === "number")
            object.restrictedTradeQuantity = options.longs === String ? String(message.restrictedTradeQuantity) : message.restrictedTradeQuantity;
          else
            object.restrictedTradeQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.restrictedTradeQuantity) : options.longs === Number ? new $util.LongBits(message.restrictedTradeQuantity.low >>> 0, message.restrictedTradeQuantity.high >>> 0).toNumber() : message.restrictedTradeQuantity;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        return object;
      };
      Deal.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      Deal.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OPEN"] = 0;
        values[valuesById[1] = "CLOSED"] = 1;
        values[valuesById[2] = "PENDING_CLOSE"] = 2;
        values[valuesById[3] = "ODD_LOT"] = 3;
        return values;
      }();
      return Deal;
    }();
    fo.ExchangeFee = function() {
      function ExchangeFee(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      ExchangeFee.prototype.securityType = 0;
      ExchangeFee.prototype.exchangeCode = 0;
      ExchangeFee.prototype.tradingFeeRate = 0;
      ExchangeFee.create = function create(properties) {
        return new ExchangeFee(properties);
      };
      ExchangeFee.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
          writer.uint32(8).int32(message.securityType);
        if (message.exchangeCode != null && Object.hasOwnProperty.call(message, "exchangeCode"))
          writer.uint32(16).int32(message.exchangeCode);
        if (message.tradingFeeRate != null && Object.hasOwnProperty.call(message, "tradingFeeRate"))
          writer.uint32(25).double(message.tradingFeeRate);
        return writer;
      };
      ExchangeFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      ExchangeFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.ExchangeFee();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.securityType = reader.int32();
              break;
            case 2:
              message.exchangeCode = reader.int32();
              break;
            case 3:
              message.tradingFeeRate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      ExchangeFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      ExchangeFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          switch (message.securityType) {
            default:
              return "securityType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 100:
              break;
          }
        if (message.exchangeCode != null && message.hasOwnProperty("exchangeCode"))
          switch (message.exchangeCode) {
            default:
              return "exchangeCode: enum value expected";
            case 0:
            case 2:
            case 3:
            case 4:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 30:
              break;
          }
        if (message.tradingFeeRate != null && message.hasOwnProperty("tradingFeeRate")) {
          if (typeof message.tradingFeeRate !== "number")
            return "tradingFeeRate: number expected";
        }
        return null;
      };
      ExchangeFee.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.ExchangeFee)
          return object;
        let message = new $root.dnse.fo.ExchangeFee();
        switch (object.securityType) {
          case "UNKNOWN_TYPE":
          case 0:
            message.securityType = 0;
            break;
          case "STOCK":
          case 1:
            message.securityType = 1;
            break;
          case "BOND":
          case 2:
            message.securityType = 2;
            break;
          case "MUTUAL_FUND":
          case 3:
            message.securityType = 3;
            break;
          case "ETF":
          case 4:
            message.securityType = 4;
            break;
          case "FUTURE":
          case 5:
            message.securityType = 5;
            break;
          case "OPTION":
          case 6:
            message.securityType = 6;
            break;
          case "COVERED_WARRANT":
          case 7:
            message.securityType = 7;
            break;
          case "FUTURE_INDEX":
          case 8:
            message.securityType = 8;
            break;
          case "FUTURE_BOND":
          case 9:
            message.securityType = 9;
            break;
          case "CORPORATE_BOND":
          case 10:
            message.securityType = 10;
            break;
          case "PRIVATE_BOND":
          case 11:
            message.securityType = 11;
            break;
          case "ALL":
          case 100:
            message.securityType = 100;
            break;
        }
        switch (object.exchangeCode) {
          case "UNKNOWN_EXCHANGE":
          case 0:
            message.exchangeCode = 0;
            break;
          case "HNX":
          case 2:
            message.exchangeCode = 2;
            break;
          case "UPCOM":
          case 3:
            message.exchangeCode = 3;
            break;
          case "HNX_BOND":
          case 4:
            message.exchangeCode = 4;
            break;
          case "HOSE":
          case 10:
            message.exchangeCode = 10;
            break;
          case "HOSE_ODD_LOT":
          case 11:
            message.exchangeCode = 11;
            break;
          case "HNX_DERIVATIVE":
          case 12:
            message.exchangeCode = 12;
            break;
          case "HNX_DERIVATIVE_BOND":
          case 13:
            message.exchangeCode = 13;
            break;
          case "HNX_PRIVATE_BOND":
          case 14:
            message.exchangeCode = 14;
            break;
          case "OTC":
          case 30:
            message.exchangeCode = 30;
            break;
        }
        if (object.tradingFeeRate != null)
          message.tradingFeeRate = Number(object.tradingFeeRate);
        return message;
      };
      ExchangeFee.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
          object.exchangeCode = options.enums === String ? "UNKNOWN_EXCHANGE" : 0;
          object.tradingFeeRate = 0;
        }
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          object.securityType = options.enums === String ? $root.dnse.fo.SecurityType[message.securityType] : message.securityType;
        if (message.exchangeCode != null && message.hasOwnProperty("exchangeCode"))
          object.exchangeCode = options.enums === String ? $root.dnse.fo.Exchange[message.exchangeCode] : message.exchangeCode;
        if (message.tradingFeeRate != null && message.hasOwnProperty("tradingFeeRate"))
          object.tradingFeeRate = options.json && !isFinite(message.tradingFeeRate) ? String(message.tradingFeeRate) : message.tradingFeeRate;
        return object;
      };
      ExchangeFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return ExchangeFee;
    }();
    fo.LoanPackageSource = function() {
      function LoanPackageSource(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPackageSource.prototype.name = "";
      LoanPackageSource.prototype.rate = 0;
      LoanPackageSource.create = function create(properties) {
        return new LoanPackageSource(properties);
      };
      LoanPackageSource.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(10).string(message.name);
        if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
          writer.uint32(17).double(message.rate);
        return writer;
      };
      LoanPackageSource.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPackageSource.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPackageSource();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.name = reader.string();
              break;
            case 2:
              message.rate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPackageSource.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPackageSource.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.rate != null && message.hasOwnProperty("rate")) {
          if (typeof message.rate !== "number")
            return "rate: number expected";
        }
        return null;
      };
      LoanPackageSource.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPackageSource)
          return object;
        let message = new $root.dnse.fo.LoanPackageSource();
        if (object.name != null)
          message.name = String(object.name);
        if (object.rate != null)
          message.rate = Number(object.rate);
        return message;
      };
      LoanPackageSource.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.name = "";
          object.rate = 0;
        }
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.rate != null && message.hasOwnProperty("rate"))
          object.rate = options.json && !isFinite(message.rate) ? String(message.rate) : message.rate;
        return object;
      };
      LoanPackageSource.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPackageSource;
    }();
    fo.LoanPackage = function() {
      function LoanPackage(properties) {
        this.tradingFees = [];
        this.sources = [];
        this.detailTradingFees = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPackage.prototype.id = 0;
      LoanPackage.prototype.loanType = "";
      LoanPackage.prototype.source = "";
      LoanPackage.prototype.initialRate = 0;
      LoanPackage.prototype.maintenanceRate = 0;
      LoanPackage.prototype.liquidRate = 0;
      LoanPackage.prototype.preferentialPeriod = 0;
      LoanPackage.prototype.preferentialInterestRate = 0;
      LoanPackage.prototype.interestRate = 0;
      LoanPackage.prototype.term = 0;
      LoanPackage.prototype.overdueInterest = 0;
      LoanPackage.prototype.allowExtendLoanTerm = false;
      LoanPackage.prototype.allowEarlyPayment = false;
      LoanPackage.prototype.brokerFirmBuyingFeeRate = 0;
      LoanPackage.prototype.brokerFirmSellingFeeRate = 0;
      LoanPackage.prototype.transferFee = 0;
      LoanPackage.prototype.loanBasketId = 0;
      LoanPackage.prototype.interestBasis = 0;
      LoanPackage.prototype.tradingFees = $util.emptyArray;
      LoanPackage.prototype.name = "";
      LoanPackage.prototype.sources = $util.emptyArray;
      LoanPackage.prototype.initialRateForWithdraw = 0;
      LoanPackage.prototype.description = "";
      LoanPackage.prototype.label = "";
      LoanPackage.prototype.allowOverdueLoanDays = 0;
      LoanPackage.prototype.productCategoryId = 0;
      LoanPackage.prototype.detailTradingFees = $util.emptyArray;
      LoanPackage.create = function create(properties) {
        return new LoanPackage(properties);
      };
      LoanPackage.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int32(message.id);
        if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
          writer.uint32(18).string(message.loanType);
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(26).string(message.source);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(33).double(message.initialRate);
        if (message.maintenanceRate != null && Object.hasOwnProperty.call(message, "maintenanceRate"))
          writer.uint32(41).double(message.maintenanceRate);
        if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
          writer.uint32(49).double(message.liquidRate);
        if (message.preferentialPeriod != null && Object.hasOwnProperty.call(message, "preferentialPeriod"))
          writer.uint32(56).int32(message.preferentialPeriod);
        if (message.preferentialInterestRate != null && Object.hasOwnProperty.call(message, "preferentialInterestRate"))
          writer.uint32(65).double(message.preferentialInterestRate);
        if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
          writer.uint32(73).double(message.interestRate);
        if (message.term != null && Object.hasOwnProperty.call(message, "term"))
          writer.uint32(80).int32(message.term);
        if (message.overdueInterest != null && Object.hasOwnProperty.call(message, "overdueInterest"))
          writer.uint32(89).double(message.overdueInterest);
        if (message.allowExtendLoanTerm != null && Object.hasOwnProperty.call(message, "allowExtendLoanTerm"))
          writer.uint32(96).bool(message.allowExtendLoanTerm);
        if (message.allowEarlyPayment != null && Object.hasOwnProperty.call(message, "allowEarlyPayment"))
          writer.uint32(104).bool(message.allowEarlyPayment);
        if (message.brokerFirmBuyingFeeRate != null && Object.hasOwnProperty.call(message, "brokerFirmBuyingFeeRate"))
          writer.uint32(113).double(message.brokerFirmBuyingFeeRate);
        if (message.brokerFirmSellingFeeRate != null && Object.hasOwnProperty.call(message, "brokerFirmSellingFeeRate"))
          writer.uint32(121).double(message.brokerFirmSellingFeeRate);
        if (message.transferFee != null && Object.hasOwnProperty.call(message, "transferFee"))
          writer.uint32(129).double(message.transferFee);
        if (message.loanBasketId != null && Object.hasOwnProperty.call(message, "loanBasketId"))
          writer.uint32(136).int32(message.loanBasketId);
        if (message.interestBasis != null && Object.hasOwnProperty.call(message, "interestBasis"))
          writer.uint32(144).int32(message.interestBasis);
        if (message.tradingFees != null && message.tradingFees.length)
          for (let i = 0; i < message.tradingFees.length; ++i)
            $root.dnse.fo.TradingFee.encode(message.tradingFees[i], writer.uint32(154).fork()).ldelim();
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(162).string(message.name);
        if (message.sources != null && message.sources.length)
          for (let i = 0; i < message.sources.length; ++i)
            $root.dnse.fo.LoanPackageSource.encode(message.sources[i], writer.uint32(170).fork()).ldelim();
        if (message.initialRateForWithdraw != null && Object.hasOwnProperty.call(message, "initialRateForWithdraw"))
          writer.uint32(177).double(message.initialRateForWithdraw);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(186).string(message.description);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
          writer.uint32(194).string(message.label);
        if (message.allowOverdueLoanDays != null && Object.hasOwnProperty.call(message, "allowOverdueLoanDays"))
          writer.uint32(200).int32(message.allowOverdueLoanDays);
        if (message.productCategoryId != null && Object.hasOwnProperty.call(message, "productCategoryId"))
          writer.uint32(208).int32(message.productCategoryId);
        if (message.detailTradingFees != null && message.detailTradingFees.length)
          for (let i = 0; i < message.detailTradingFees.length; ++i)
            $root.dnse.fo.DetailTradingFee.encode(message.detailTradingFees[i], writer.uint32(218).fork()).ldelim();
        return writer;
      };
      LoanPackage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPackage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPackage();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int32();
              break;
            case 2:
              message.loanType = reader.string();
              break;
            case 3:
              message.source = reader.string();
              break;
            case 4:
              message.initialRate = reader.double();
              break;
            case 5:
              message.maintenanceRate = reader.double();
              break;
            case 6:
              message.liquidRate = reader.double();
              break;
            case 7:
              message.preferentialPeriod = reader.int32();
              break;
            case 8:
              message.preferentialInterestRate = reader.double();
              break;
            case 9:
              message.interestRate = reader.double();
              break;
            case 10:
              message.term = reader.int32();
              break;
            case 11:
              message.overdueInterest = reader.double();
              break;
            case 12:
              message.allowExtendLoanTerm = reader.bool();
              break;
            case 13:
              message.allowEarlyPayment = reader.bool();
              break;
            case 14:
              message.brokerFirmBuyingFeeRate = reader.double();
              break;
            case 15:
              message.brokerFirmSellingFeeRate = reader.double();
              break;
            case 16:
              message.transferFee = reader.double();
              break;
            case 17:
              message.loanBasketId = reader.int32();
              break;
            case 18:
              message.interestBasis = reader.int32();
              break;
            case 19:
              if (!(message.tradingFees && message.tradingFees.length))
                message.tradingFees = [];
              message.tradingFees.push($root.dnse.fo.TradingFee.decode(reader, reader.uint32()));
              break;
            case 20:
              message.name = reader.string();
              break;
            case 21:
              if (!(message.sources && message.sources.length))
                message.sources = [];
              message.sources.push($root.dnse.fo.LoanPackageSource.decode(reader, reader.uint32()));
              break;
            case 22:
              message.initialRateForWithdraw = reader.double();
              break;
            case 23:
              message.description = reader.string();
              break;
            case 24:
              message.label = reader.string();
              break;
            case 25:
              message.allowOverdueLoanDays = reader.int32();
              break;
            case 26:
              message.productCategoryId = reader.int32();
              break;
            case 27:
              if (!(message.detailTradingFees && message.detailTradingFees.length))
                message.detailTradingFees = [];
              message.detailTradingFees.push($root.dnse.fo.DetailTradingFee.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPackage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPackage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id))
            return "id: integer expected";
        }
        if (message.loanType != null && message.hasOwnProperty("loanType")) {
          if (!$util.isString(message.loanType))
            return "loanType: string expected";
        }
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate")) {
          if (typeof message.maintenanceRate !== "number")
            return "maintenanceRate: number expected";
        }
        if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
          if (typeof message.liquidRate !== "number")
            return "liquidRate: number expected";
        }
        if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod")) {
          if (!$util.isInteger(message.preferentialPeriod))
            return "preferentialPeriod: integer expected";
        }
        if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate")) {
          if (typeof message.preferentialInterestRate !== "number")
            return "preferentialInterestRate: number expected";
        }
        if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
          if (typeof message.interestRate !== "number")
            return "interestRate: number expected";
        }
        if (message.term != null && message.hasOwnProperty("term")) {
          if (!$util.isInteger(message.term))
            return "term: integer expected";
        }
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest")) {
          if (typeof message.overdueInterest !== "number")
            return "overdueInterest: number expected";
        }
        if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm")) {
          if (typeof message.allowExtendLoanTerm !== "boolean")
            return "allowExtendLoanTerm: boolean expected";
        }
        if (message.allowEarlyPayment != null && message.hasOwnProperty("allowEarlyPayment")) {
          if (typeof message.allowEarlyPayment !== "boolean")
            return "allowEarlyPayment: boolean expected";
        }
        if (message.brokerFirmBuyingFeeRate != null && message.hasOwnProperty("brokerFirmBuyingFeeRate")) {
          if (typeof message.brokerFirmBuyingFeeRate !== "number")
            return "brokerFirmBuyingFeeRate: number expected";
        }
        if (message.brokerFirmSellingFeeRate != null && message.hasOwnProperty("brokerFirmSellingFeeRate")) {
          if (typeof message.brokerFirmSellingFeeRate !== "number")
            return "brokerFirmSellingFeeRate: number expected";
        }
        if (message.transferFee != null && message.hasOwnProperty("transferFee")) {
          if (typeof message.transferFee !== "number")
            return "transferFee: number expected";
        }
        if (message.loanBasketId != null && message.hasOwnProperty("loanBasketId")) {
          if (!$util.isInteger(message.loanBasketId))
            return "loanBasketId: integer expected";
        }
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis")) {
          if (!$util.isInteger(message.interestBasis))
            return "interestBasis: integer expected";
        }
        if (message.tradingFees != null && message.hasOwnProperty("tradingFees")) {
          if (!Array.isArray(message.tradingFees))
            return "tradingFees: array expected";
          for (let i = 0; i < message.tradingFees.length; ++i) {
            let error = $root.dnse.fo.TradingFee.verify(message.tradingFees[i]);
            if (error)
              return "tradingFees." + error;
          }
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.sources != null && message.hasOwnProperty("sources")) {
          if (!Array.isArray(message.sources))
            return "sources: array expected";
          for (let i = 0; i < message.sources.length; ++i) {
            let error = $root.dnse.fo.LoanPackageSource.verify(message.sources[i]);
            if (error)
              return "sources." + error;
          }
        }
        if (message.initialRateForWithdraw != null && message.hasOwnProperty("initialRateForWithdraw")) {
          if (typeof message.initialRateForWithdraw !== "number")
            return "initialRateForWithdraw: number expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.label != null && message.hasOwnProperty("label")) {
          if (!$util.isString(message.label))
            return "label: string expected";
        }
        if (message.allowOverdueLoanDays != null && message.hasOwnProperty("allowOverdueLoanDays")) {
          if (!$util.isInteger(message.allowOverdueLoanDays))
            return "allowOverdueLoanDays: integer expected";
        }
        if (message.productCategoryId != null && message.hasOwnProperty("productCategoryId")) {
          if (!$util.isInteger(message.productCategoryId))
            return "productCategoryId: integer expected";
        }
        if (message.detailTradingFees != null && message.hasOwnProperty("detailTradingFees")) {
          if (!Array.isArray(message.detailTradingFees))
            return "detailTradingFees: array expected";
          for (let i = 0; i < message.detailTradingFees.length; ++i) {
            let error = $root.dnse.fo.DetailTradingFee.verify(message.detailTradingFees[i]);
            if (error)
              return "detailTradingFees." + error;
          }
        }
        return null;
      };
      LoanPackage.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPackage)
          return object;
        let message = new $root.dnse.fo.LoanPackage();
        if (object.id != null)
          message.id = object.id | 0;
        if (object.loanType != null)
          message.loanType = String(object.loanType);
        if (object.source != null)
          message.source = String(object.source);
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        if (object.maintenanceRate != null)
          message.maintenanceRate = Number(object.maintenanceRate);
        if (object.liquidRate != null)
          message.liquidRate = Number(object.liquidRate);
        if (object.preferentialPeriod != null)
          message.preferentialPeriod = object.preferentialPeriod | 0;
        if (object.preferentialInterestRate != null)
          message.preferentialInterestRate = Number(object.preferentialInterestRate);
        if (object.interestRate != null)
          message.interestRate = Number(object.interestRate);
        if (object.term != null)
          message.term = object.term | 0;
        if (object.overdueInterest != null)
          message.overdueInterest = Number(object.overdueInterest);
        if (object.allowExtendLoanTerm != null)
          message.allowExtendLoanTerm = Boolean(object.allowExtendLoanTerm);
        if (object.allowEarlyPayment != null)
          message.allowEarlyPayment = Boolean(object.allowEarlyPayment);
        if (object.brokerFirmBuyingFeeRate != null)
          message.brokerFirmBuyingFeeRate = Number(object.brokerFirmBuyingFeeRate);
        if (object.brokerFirmSellingFeeRate != null)
          message.brokerFirmSellingFeeRate = Number(object.brokerFirmSellingFeeRate);
        if (object.transferFee != null)
          message.transferFee = Number(object.transferFee);
        if (object.loanBasketId != null)
          message.loanBasketId = object.loanBasketId | 0;
        if (object.interestBasis != null)
          message.interestBasis = object.interestBasis | 0;
        if (object.tradingFees) {
          if (!Array.isArray(object.tradingFees))
            throw TypeError(".dnse.fo.LoanPackage.tradingFees: array expected");
          message.tradingFees = [];
          for (let i = 0; i < object.tradingFees.length; ++i) {
            if (typeof object.tradingFees[i] !== "object")
              throw TypeError(".dnse.fo.LoanPackage.tradingFees: object expected");
            message.tradingFees[i] = $root.dnse.fo.TradingFee.fromObject(object.tradingFees[i]);
          }
        }
        if (object.name != null)
          message.name = String(object.name);
        if (object.sources) {
          if (!Array.isArray(object.sources))
            throw TypeError(".dnse.fo.LoanPackage.sources: array expected");
          message.sources = [];
          for (let i = 0; i < object.sources.length; ++i) {
            if (typeof object.sources[i] !== "object")
              throw TypeError(".dnse.fo.LoanPackage.sources: object expected");
            message.sources[i] = $root.dnse.fo.LoanPackageSource.fromObject(object.sources[i]);
          }
        }
        if (object.initialRateForWithdraw != null)
          message.initialRateForWithdraw = Number(object.initialRateForWithdraw);
        if (object.description != null)
          message.description = String(object.description);
        if (object.label != null)
          message.label = String(object.label);
        if (object.allowOverdueLoanDays != null)
          message.allowOverdueLoanDays = object.allowOverdueLoanDays | 0;
        if (object.productCategoryId != null)
          message.productCategoryId = object.productCategoryId | 0;
        if (object.detailTradingFees) {
          if (!Array.isArray(object.detailTradingFees))
            throw TypeError(".dnse.fo.LoanPackage.detailTradingFees: array expected");
          message.detailTradingFees = [];
          for (let i = 0; i < object.detailTradingFees.length; ++i) {
            if (typeof object.detailTradingFees[i] !== "object")
              throw TypeError(".dnse.fo.LoanPackage.detailTradingFees: object expected");
            message.detailTradingFees[i] = $root.dnse.fo.DetailTradingFee.fromObject(object.detailTradingFees[i]);
          }
        }
        return message;
      };
      LoanPackage.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.tradingFees = [];
          object.sources = [];
          object.detailTradingFees = [];
        }
        if (options.defaults) {
          object.id = 0;
          object.loanType = "";
          object.source = "";
          object.initialRate = 0;
          object.maintenanceRate = 0;
          object.liquidRate = 0;
          object.preferentialPeriod = 0;
          object.preferentialInterestRate = 0;
          object.interestRate = 0;
          object.term = 0;
          object.overdueInterest = 0;
          object.allowExtendLoanTerm = false;
          object.allowEarlyPayment = false;
          object.brokerFirmBuyingFeeRate = 0;
          object.brokerFirmSellingFeeRate = 0;
          object.transferFee = 0;
          object.loanBasketId = 0;
          object.interestBasis = 0;
          object.name = "";
          object.initialRateForWithdraw = 0;
          object.description = "";
          object.label = "";
          object.allowOverdueLoanDays = 0;
          object.productCategoryId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.loanType != null && message.hasOwnProperty("loanType"))
          object.loanType = message.loanType;
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate"))
          object.maintenanceRate = options.json && !isFinite(message.maintenanceRate) ? String(message.maintenanceRate) : message.maintenanceRate;
        if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
          object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
        if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod"))
          object.preferentialPeriod = message.preferentialPeriod;
        if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate"))
          object.preferentialInterestRate = options.json && !isFinite(message.preferentialInterestRate) ? String(message.preferentialInterestRate) : message.preferentialInterestRate;
        if (message.interestRate != null && message.hasOwnProperty("interestRate"))
          object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
        if (message.term != null && message.hasOwnProperty("term"))
          object.term = message.term;
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest"))
          object.overdueInterest = options.json && !isFinite(message.overdueInterest) ? String(message.overdueInterest) : message.overdueInterest;
        if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm"))
          object.allowExtendLoanTerm = message.allowExtendLoanTerm;
        if (message.allowEarlyPayment != null && message.hasOwnProperty("allowEarlyPayment"))
          object.allowEarlyPayment = message.allowEarlyPayment;
        if (message.brokerFirmBuyingFeeRate != null && message.hasOwnProperty("brokerFirmBuyingFeeRate"))
          object.brokerFirmBuyingFeeRate = options.json && !isFinite(message.brokerFirmBuyingFeeRate) ? String(message.brokerFirmBuyingFeeRate) : message.brokerFirmBuyingFeeRate;
        if (message.brokerFirmSellingFeeRate != null && message.hasOwnProperty("brokerFirmSellingFeeRate"))
          object.brokerFirmSellingFeeRate = options.json && !isFinite(message.brokerFirmSellingFeeRate) ? String(message.brokerFirmSellingFeeRate) : message.brokerFirmSellingFeeRate;
        if (message.transferFee != null && message.hasOwnProperty("transferFee"))
          object.transferFee = options.json && !isFinite(message.transferFee) ? String(message.transferFee) : message.transferFee;
        if (message.loanBasketId != null && message.hasOwnProperty("loanBasketId"))
          object.loanBasketId = message.loanBasketId;
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis"))
          object.interestBasis = message.interestBasis;
        if (message.tradingFees && message.tradingFees.length) {
          object.tradingFees = [];
          for (let j = 0; j < message.tradingFees.length; ++j)
            object.tradingFees[j] = $root.dnse.fo.TradingFee.toObject(message.tradingFees[j], options);
        }
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.sources && message.sources.length) {
          object.sources = [];
          for (let j = 0; j < message.sources.length; ++j)
            object.sources[j] = $root.dnse.fo.LoanPackageSource.toObject(message.sources[j], options);
        }
        if (message.initialRateForWithdraw != null && message.hasOwnProperty("initialRateForWithdraw"))
          object.initialRateForWithdraw = options.json && !isFinite(message.initialRateForWithdraw) ? String(message.initialRateForWithdraw) : message.initialRateForWithdraw;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.label != null && message.hasOwnProperty("label"))
          object.label = message.label;
        if (message.allowOverdueLoanDays != null && message.hasOwnProperty("allowOverdueLoanDays"))
          object.allowOverdueLoanDays = message.allowOverdueLoanDays;
        if (message.productCategoryId != null && message.hasOwnProperty("productCategoryId"))
          object.productCategoryId = message.productCategoryId;
        if (message.detailTradingFees && message.detailTradingFees.length) {
          object.detailTradingFees = [];
          for (let j = 0; j < message.detailTradingFees.length; ++j)
            object.detailTradingFees[j] = $root.dnse.fo.DetailTradingFee.toObject(message.detailTradingFees[j], options);
        }
        return object;
      };
      LoanPackage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPackage;
    }();
    fo.DetailTradingFee = function() {
      function DetailTradingFee(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DetailTradingFee.prototype.securityType = 0;
      DetailTradingFee.prototype.exchange = 0;
      DetailTradingFee.prototype.buyingFeeRate = 0;
      DetailTradingFee.prototype.sellingFeeRate = 0;
      DetailTradingFee.create = function create(properties) {
        return new DetailTradingFee(properties);
      };
      DetailTradingFee.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
          writer.uint32(8).int32(message.securityType);
        if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
          writer.uint32(16).int32(message.exchange);
        if (message.buyingFeeRate != null && Object.hasOwnProperty.call(message, "buyingFeeRate"))
          writer.uint32(25).double(message.buyingFeeRate);
        if (message.sellingFeeRate != null && Object.hasOwnProperty.call(message, "sellingFeeRate"))
          writer.uint32(33).double(message.sellingFeeRate);
        return writer;
      };
      DetailTradingFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DetailTradingFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DetailTradingFee();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.securityType = reader.int32();
              break;
            case 2:
              message.exchange = reader.int32();
              break;
            case 3:
              message.buyingFeeRate = reader.double();
              break;
            case 4:
              message.sellingFeeRate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DetailTradingFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DetailTradingFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          switch (message.securityType) {
            default:
              return "securityType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 100:
              break;
          }
        if (message.exchange != null && message.hasOwnProperty("exchange"))
          switch (message.exchange) {
            default:
              return "exchange: enum value expected";
            case 0:
            case 2:
            case 3:
            case 4:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 30:
              break;
          }
        if (message.buyingFeeRate != null && message.hasOwnProperty("buyingFeeRate")) {
          if (typeof message.buyingFeeRate !== "number")
            return "buyingFeeRate: number expected";
        }
        if (message.sellingFeeRate != null && message.hasOwnProperty("sellingFeeRate")) {
          if (typeof message.sellingFeeRate !== "number")
            return "sellingFeeRate: number expected";
        }
        return null;
      };
      DetailTradingFee.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DetailTradingFee)
          return object;
        let message = new $root.dnse.fo.DetailTradingFee();
        switch (object.securityType) {
          case "UNKNOWN_TYPE":
          case 0:
            message.securityType = 0;
            break;
          case "STOCK":
          case 1:
            message.securityType = 1;
            break;
          case "BOND":
          case 2:
            message.securityType = 2;
            break;
          case "MUTUAL_FUND":
          case 3:
            message.securityType = 3;
            break;
          case "ETF":
          case 4:
            message.securityType = 4;
            break;
          case "FUTURE":
          case 5:
            message.securityType = 5;
            break;
          case "OPTION":
          case 6:
            message.securityType = 6;
            break;
          case "COVERED_WARRANT":
          case 7:
            message.securityType = 7;
            break;
          case "FUTURE_INDEX":
          case 8:
            message.securityType = 8;
            break;
          case "FUTURE_BOND":
          case 9:
            message.securityType = 9;
            break;
          case "CORPORATE_BOND":
          case 10:
            message.securityType = 10;
            break;
          case "PRIVATE_BOND":
          case 11:
            message.securityType = 11;
            break;
          case "ALL":
          case 100:
            message.securityType = 100;
            break;
        }
        switch (object.exchange) {
          case "UNKNOWN_EXCHANGE":
          case 0:
            message.exchange = 0;
            break;
          case "HNX":
          case 2:
            message.exchange = 2;
            break;
          case "UPCOM":
          case 3:
            message.exchange = 3;
            break;
          case "HNX_BOND":
          case 4:
            message.exchange = 4;
            break;
          case "HOSE":
          case 10:
            message.exchange = 10;
            break;
          case "HOSE_ODD_LOT":
          case 11:
            message.exchange = 11;
            break;
          case "HNX_DERIVATIVE":
          case 12:
            message.exchange = 12;
            break;
          case "HNX_DERIVATIVE_BOND":
          case 13:
            message.exchange = 13;
            break;
          case "HNX_PRIVATE_BOND":
          case 14:
            message.exchange = 14;
            break;
          case "OTC":
          case 30:
            message.exchange = 30;
            break;
        }
        if (object.buyingFeeRate != null)
          message.buyingFeeRate = Number(object.buyingFeeRate);
        if (object.sellingFeeRate != null)
          message.sellingFeeRate = Number(object.sellingFeeRate);
        return message;
      };
      DetailTradingFee.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
          object.exchange = options.enums === String ? "UNKNOWN_EXCHANGE" : 0;
          object.buyingFeeRate = 0;
          object.sellingFeeRate = 0;
        }
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          object.securityType = options.enums === String ? $root.dnse.fo.SecurityType[message.securityType] : message.securityType;
        if (message.exchange != null && message.hasOwnProperty("exchange"))
          object.exchange = options.enums === String ? $root.dnse.fo.Exchange[message.exchange] : message.exchange;
        if (message.buyingFeeRate != null && message.hasOwnProperty("buyingFeeRate"))
          object.buyingFeeRate = options.json && !isFinite(message.buyingFeeRate) ? String(message.buyingFeeRate) : message.buyingFeeRate;
        if (message.sellingFeeRate != null && message.hasOwnProperty("sellingFeeRate"))
          object.sellingFeeRate = options.json && !isFinite(message.sellingFeeRate) ? String(message.sellingFeeRate) : message.sellingFeeRate;
        return object;
      };
      DetailTradingFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DetailTradingFee;
    }();
    fo.LoanBasket = function() {
      function LoanBasket(properties) {
        this.symbols = [];
        this.loanProducts = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanBasket.prototype.id = 0;
      LoanBasket.prototype.symbols = $util.emptyArray;
      LoanBasket.prototype.name = "";
      LoanBasket.prototype.loanProducts = $util.emptyArray;
      LoanBasket.create = function create(properties) {
        return new LoanBasket(properties);
      };
      LoanBasket.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int32(message.id);
        if (message.symbols != null && message.symbols.length)
          for (let i = 0; i < message.symbols.length; ++i)
            writer.uint32(18).string(message.symbols[i]);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(26).string(message.name);
        if (message.loanProducts != null && message.loanProducts.length)
          for (let i = 0; i < message.loanProducts.length; ++i)
            $root.dnse.fo.LoanProduct.encode(message.loanProducts[i], writer.uint32(34).fork()).ldelim();
        return writer;
      };
      LoanBasket.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanBasket.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanBasket();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int32();
              break;
            case 2:
              if (!(message.symbols && message.symbols.length))
                message.symbols = [];
              message.symbols.push(reader.string());
              break;
            case 3:
              message.name = reader.string();
              break;
            case 4:
              if (!(message.loanProducts && message.loanProducts.length))
                message.loanProducts = [];
              message.loanProducts.push($root.dnse.fo.LoanProduct.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanBasket.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanBasket.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id))
            return "id: integer expected";
        }
        if (message.symbols != null && message.hasOwnProperty("symbols")) {
          if (!Array.isArray(message.symbols))
            return "symbols: array expected";
          for (let i = 0; i < message.symbols.length; ++i)
            if (!$util.isString(message.symbols[i]))
              return "symbols: string[] expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.loanProducts != null && message.hasOwnProperty("loanProducts")) {
          if (!Array.isArray(message.loanProducts))
            return "loanProducts: array expected";
          for (let i = 0; i < message.loanProducts.length; ++i) {
            let error = $root.dnse.fo.LoanProduct.verify(message.loanProducts[i]);
            if (error)
              return "loanProducts." + error;
          }
        }
        return null;
      };
      LoanBasket.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanBasket)
          return object;
        let message = new $root.dnse.fo.LoanBasket();
        if (object.id != null)
          message.id = object.id | 0;
        if (object.symbols) {
          if (!Array.isArray(object.symbols))
            throw TypeError(".dnse.fo.LoanBasket.symbols: array expected");
          message.symbols = [];
          for (let i = 0; i < object.symbols.length; ++i)
            message.symbols[i] = String(object.symbols[i]);
        }
        if (object.name != null)
          message.name = String(object.name);
        if (object.loanProducts) {
          if (!Array.isArray(object.loanProducts))
            throw TypeError(".dnse.fo.LoanBasket.loanProducts: array expected");
          message.loanProducts = [];
          for (let i = 0; i < object.loanProducts.length; ++i) {
            if (typeof object.loanProducts[i] !== "object")
              throw TypeError(".dnse.fo.LoanBasket.loanProducts: object expected");
            message.loanProducts[i] = $root.dnse.fo.LoanProduct.fromObject(object.loanProducts[i]);
          }
        }
        return message;
      };
      LoanBasket.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.symbols = [];
          object.loanProducts = [];
        }
        if (options.defaults) {
          object.id = 0;
          object.name = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.symbols && message.symbols.length) {
          object.symbols = [];
          for (let j = 0; j < message.symbols.length; ++j)
            object.symbols[j] = message.symbols[j];
        }
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.loanProducts && message.loanProducts.length) {
          object.loanProducts = [];
          for (let j = 0; j < message.loanProducts.length; ++j)
            object.loanProducts[j] = $root.dnse.fo.LoanProduct.toObject(message.loanProducts[j], options);
        }
        return object;
      };
      LoanBasket.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanBasket;
    }();
    fo.LoanPkgCustom = function() {
      function LoanPkgCustom(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPkgCustom.prototype.brokerFirmBuyingFeeRate = null;
      LoanPkgCustom.prototype.brokerFirmSellingFeeRate = null;
      LoanPkgCustom.prototype.brokerFirmBuyingFeeRateEffectiveDate = null;
      LoanPkgCustom.prototype.brokerFirmBuyingFeeRateExpiredDate = null;
      LoanPkgCustom.prototype.brokerFirmSellingFeeRateEffectiveDate = null;
      LoanPkgCustom.prototype.brokerFirmSellingFeeRateExpiredDate = null;
      let $oneOfFields;
      Object.defineProperty(LoanPkgCustom.prototype, "_brokerFirmBuyingFeeRate", {
        get: $util.oneOfGetter($oneOfFields = ["brokerFirmBuyingFeeRate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(LoanPkgCustom.prototype, "_brokerFirmSellingFeeRate", {
        get: $util.oneOfGetter($oneOfFields = ["brokerFirmSellingFeeRate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(LoanPkgCustom.prototype, "_brokerFirmBuyingFeeRateEffectiveDate", {
        get: $util.oneOfGetter($oneOfFields = ["brokerFirmBuyingFeeRateEffectiveDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(LoanPkgCustom.prototype, "_brokerFirmBuyingFeeRateExpiredDate", {
        get: $util.oneOfGetter($oneOfFields = ["brokerFirmBuyingFeeRateExpiredDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(LoanPkgCustom.prototype, "_brokerFirmSellingFeeRateEffectiveDate", {
        get: $util.oneOfGetter($oneOfFields = ["brokerFirmSellingFeeRateEffectiveDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(LoanPkgCustom.prototype, "_brokerFirmSellingFeeRateExpiredDate", {
        get: $util.oneOfGetter($oneOfFields = ["brokerFirmSellingFeeRateExpiredDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      LoanPkgCustom.create = function create(properties) {
        return new LoanPkgCustom(properties);
      };
      LoanPkgCustom.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.brokerFirmBuyingFeeRate != null && Object.hasOwnProperty.call(message, "brokerFirmBuyingFeeRate"))
          writer.uint32(9).double(message.brokerFirmBuyingFeeRate);
        if (message.brokerFirmSellingFeeRate != null && Object.hasOwnProperty.call(message, "brokerFirmSellingFeeRate"))
          writer.uint32(17).double(message.brokerFirmSellingFeeRate);
        if (message.brokerFirmBuyingFeeRateEffectiveDate != null && Object.hasOwnProperty.call(message, "brokerFirmBuyingFeeRateEffectiveDate"))
          $root.google.protobuf.Timestamp.encode(message.brokerFirmBuyingFeeRateEffectiveDate, writer.uint32(26).fork()).ldelim();
        if (message.brokerFirmBuyingFeeRateExpiredDate != null && Object.hasOwnProperty.call(message, "brokerFirmBuyingFeeRateExpiredDate"))
          $root.google.protobuf.Timestamp.encode(message.brokerFirmBuyingFeeRateExpiredDate, writer.uint32(34).fork()).ldelim();
        if (message.brokerFirmSellingFeeRateEffectiveDate != null && Object.hasOwnProperty.call(message, "brokerFirmSellingFeeRateEffectiveDate"))
          $root.google.protobuf.Timestamp.encode(message.brokerFirmSellingFeeRateEffectiveDate, writer.uint32(42).fork()).ldelim();
        if (message.brokerFirmSellingFeeRateExpiredDate != null && Object.hasOwnProperty.call(message, "brokerFirmSellingFeeRateExpiredDate"))
          $root.google.protobuf.Timestamp.encode(message.brokerFirmSellingFeeRateExpiredDate, writer.uint32(50).fork()).ldelim();
        return writer;
      };
      LoanPkgCustom.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPkgCustom.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPkgCustom();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.brokerFirmBuyingFeeRate = reader.double();
              break;
            case 2:
              message.brokerFirmSellingFeeRate = reader.double();
              break;
            case 3:
              message.brokerFirmBuyingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 4:
              message.brokerFirmBuyingFeeRateExpiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 5:
              message.brokerFirmSellingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 6:
              message.brokerFirmSellingFeeRateExpiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPkgCustom.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPkgCustom.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.brokerFirmBuyingFeeRate != null && message.hasOwnProperty("brokerFirmBuyingFeeRate")) {
          if (typeof message.brokerFirmBuyingFeeRate !== "number")
            return "brokerFirmBuyingFeeRate: number expected";
        }
        if (message.brokerFirmSellingFeeRate != null && message.hasOwnProperty("brokerFirmSellingFeeRate")) {
          if (typeof message.brokerFirmSellingFeeRate !== "number")
            return "brokerFirmSellingFeeRate: number expected";
        }
        if (message.brokerFirmBuyingFeeRateEffectiveDate != null && message.hasOwnProperty("brokerFirmBuyingFeeRateEffectiveDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.brokerFirmBuyingFeeRateEffectiveDate);
            if (error)
              return "brokerFirmBuyingFeeRateEffectiveDate." + error;
          }
        }
        if (message.brokerFirmBuyingFeeRateExpiredDate != null && message.hasOwnProperty("brokerFirmBuyingFeeRateExpiredDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.brokerFirmBuyingFeeRateExpiredDate);
            if (error)
              return "brokerFirmBuyingFeeRateExpiredDate." + error;
          }
        }
        if (message.brokerFirmSellingFeeRateEffectiveDate != null && message.hasOwnProperty("brokerFirmSellingFeeRateEffectiveDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.brokerFirmSellingFeeRateEffectiveDate);
            if (error)
              return "brokerFirmSellingFeeRateEffectiveDate." + error;
          }
        }
        if (message.brokerFirmSellingFeeRateExpiredDate != null && message.hasOwnProperty("brokerFirmSellingFeeRateExpiredDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.brokerFirmSellingFeeRateExpiredDate);
            if (error)
              return "brokerFirmSellingFeeRateExpiredDate." + error;
          }
        }
        return null;
      };
      LoanPkgCustom.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPkgCustom)
          return object;
        let message = new $root.dnse.fo.LoanPkgCustom();
        if (object.brokerFirmBuyingFeeRate != null)
          message.brokerFirmBuyingFeeRate = Number(object.brokerFirmBuyingFeeRate);
        if (object.brokerFirmSellingFeeRate != null)
          message.brokerFirmSellingFeeRate = Number(object.brokerFirmSellingFeeRate);
        if (object.brokerFirmBuyingFeeRateEffectiveDate != null) {
          if (typeof object.brokerFirmBuyingFeeRateEffectiveDate !== "object")
            throw TypeError(".dnse.fo.LoanPkgCustom.brokerFirmBuyingFeeRateEffectiveDate: object expected");
          message.brokerFirmBuyingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.fromObject(object.brokerFirmBuyingFeeRateEffectiveDate);
        }
        if (object.brokerFirmBuyingFeeRateExpiredDate != null) {
          if (typeof object.brokerFirmBuyingFeeRateExpiredDate !== "object")
            throw TypeError(".dnse.fo.LoanPkgCustom.brokerFirmBuyingFeeRateExpiredDate: object expected");
          message.brokerFirmBuyingFeeRateExpiredDate = $root.google.protobuf.Timestamp.fromObject(object.brokerFirmBuyingFeeRateExpiredDate);
        }
        if (object.brokerFirmSellingFeeRateEffectiveDate != null) {
          if (typeof object.brokerFirmSellingFeeRateEffectiveDate !== "object")
            throw TypeError(".dnse.fo.LoanPkgCustom.brokerFirmSellingFeeRateEffectiveDate: object expected");
          message.brokerFirmSellingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.fromObject(object.brokerFirmSellingFeeRateEffectiveDate);
        }
        if (object.brokerFirmSellingFeeRateExpiredDate != null) {
          if (typeof object.brokerFirmSellingFeeRateExpiredDate !== "object")
            throw TypeError(".dnse.fo.LoanPkgCustom.brokerFirmSellingFeeRateExpiredDate: object expected");
          message.brokerFirmSellingFeeRateExpiredDate = $root.google.protobuf.Timestamp.fromObject(object.brokerFirmSellingFeeRateExpiredDate);
        }
        return message;
      };
      LoanPkgCustom.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (message.brokerFirmBuyingFeeRate != null && message.hasOwnProperty("brokerFirmBuyingFeeRate")) {
          object.brokerFirmBuyingFeeRate = options.json && !isFinite(message.brokerFirmBuyingFeeRate) ? String(message.brokerFirmBuyingFeeRate) : message.brokerFirmBuyingFeeRate;
          if (options.oneofs)
            object._brokerFirmBuyingFeeRate = "brokerFirmBuyingFeeRate";
        }
        if (message.brokerFirmSellingFeeRate != null && message.hasOwnProperty("brokerFirmSellingFeeRate")) {
          object.brokerFirmSellingFeeRate = options.json && !isFinite(message.brokerFirmSellingFeeRate) ? String(message.brokerFirmSellingFeeRate) : message.brokerFirmSellingFeeRate;
          if (options.oneofs)
            object._brokerFirmSellingFeeRate = "brokerFirmSellingFeeRate";
        }
        if (message.brokerFirmBuyingFeeRateEffectiveDate != null && message.hasOwnProperty("brokerFirmBuyingFeeRateEffectiveDate")) {
          object.brokerFirmBuyingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.toObject(message.brokerFirmBuyingFeeRateEffectiveDate, options);
          if (options.oneofs)
            object._brokerFirmBuyingFeeRateEffectiveDate = "brokerFirmBuyingFeeRateEffectiveDate";
        }
        if (message.brokerFirmBuyingFeeRateExpiredDate != null && message.hasOwnProperty("brokerFirmBuyingFeeRateExpiredDate")) {
          object.brokerFirmBuyingFeeRateExpiredDate = $root.google.protobuf.Timestamp.toObject(message.brokerFirmBuyingFeeRateExpiredDate, options);
          if (options.oneofs)
            object._brokerFirmBuyingFeeRateExpiredDate = "brokerFirmBuyingFeeRateExpiredDate";
        }
        if (message.brokerFirmSellingFeeRateEffectiveDate != null && message.hasOwnProperty("brokerFirmSellingFeeRateEffectiveDate")) {
          object.brokerFirmSellingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.toObject(message.brokerFirmSellingFeeRateEffectiveDate, options);
          if (options.oneofs)
            object._brokerFirmSellingFeeRateEffectiveDate = "brokerFirmSellingFeeRateEffectiveDate";
        }
        if (message.brokerFirmSellingFeeRateExpiredDate != null && message.hasOwnProperty("brokerFirmSellingFeeRateExpiredDate")) {
          object.brokerFirmSellingFeeRateExpiredDate = $root.google.protobuf.Timestamp.toObject(message.brokerFirmSellingFeeRateExpiredDate, options);
          if (options.oneofs)
            object._brokerFirmSellingFeeRateExpiredDate = "brokerFirmSellingFeeRateExpiredDate";
        }
        return object;
      };
      LoanPkgCustom.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPkgCustom;
    }();
    fo.TradingFeeCustom = function() {
      function TradingFeeCustom(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      TradingFeeCustom.prototype.securityType = 0;
      TradingFeeCustom.prototype.exchange = 0;
      TradingFeeCustom.prototype.buyingFeeRate = 0;
      TradingFeeCustom.prototype.sellingFeeRate = 0;
      TradingFeeCustom.prototype.buyingFeeRateEffectiveDate = null;
      TradingFeeCustom.prototype.buyingFeeRateExpiredDate = null;
      TradingFeeCustom.prototype.sellingFeeRateEffectiveDate = null;
      TradingFeeCustom.prototype.sellingFeeRateExpiredDate = null;
      TradingFeeCustom.create = function create(properties) {
        return new TradingFeeCustom(properties);
      };
      TradingFeeCustom.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
          writer.uint32(8).int32(message.securityType);
        if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
          writer.uint32(16).int32(message.exchange);
        if (message.buyingFeeRate != null && Object.hasOwnProperty.call(message, "buyingFeeRate"))
          writer.uint32(25).double(message.buyingFeeRate);
        if (message.sellingFeeRate != null && Object.hasOwnProperty.call(message, "sellingFeeRate"))
          writer.uint32(33).double(message.sellingFeeRate);
        if (message.buyingFeeRateEffectiveDate != null && Object.hasOwnProperty.call(message, "buyingFeeRateEffectiveDate"))
          $root.google.protobuf.Timestamp.encode(message.buyingFeeRateEffectiveDate, writer.uint32(42).fork()).ldelim();
        if (message.buyingFeeRateExpiredDate != null && Object.hasOwnProperty.call(message, "buyingFeeRateExpiredDate"))
          $root.google.protobuf.Timestamp.encode(message.buyingFeeRateExpiredDate, writer.uint32(50).fork()).ldelim();
        if (message.sellingFeeRateEffectiveDate != null && Object.hasOwnProperty.call(message, "sellingFeeRateEffectiveDate"))
          $root.google.protobuf.Timestamp.encode(message.sellingFeeRateEffectiveDate, writer.uint32(58).fork()).ldelim();
        if (message.sellingFeeRateExpiredDate != null && Object.hasOwnProperty.call(message, "sellingFeeRateExpiredDate"))
          $root.google.protobuf.Timestamp.encode(message.sellingFeeRateExpiredDate, writer.uint32(66).fork()).ldelim();
        return writer;
      };
      TradingFeeCustom.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      TradingFeeCustom.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.TradingFeeCustom();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.securityType = reader.int32();
              break;
            case 2:
              message.exchange = reader.int32();
              break;
            case 3:
              message.buyingFeeRate = reader.double();
              break;
            case 4:
              message.sellingFeeRate = reader.double();
              break;
            case 5:
              message.buyingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 6:
              message.buyingFeeRateExpiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 7:
              message.sellingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 8:
              message.sellingFeeRateExpiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      TradingFeeCustom.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      TradingFeeCustom.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          switch (message.securityType) {
            default:
              return "securityType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 100:
              break;
          }
        if (message.exchange != null && message.hasOwnProperty("exchange"))
          switch (message.exchange) {
            default:
              return "exchange: enum value expected";
            case 0:
            case 2:
            case 3:
            case 4:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 30:
              break;
          }
        if (message.buyingFeeRate != null && message.hasOwnProperty("buyingFeeRate")) {
          if (typeof message.buyingFeeRate !== "number")
            return "buyingFeeRate: number expected";
        }
        if (message.sellingFeeRate != null && message.hasOwnProperty("sellingFeeRate")) {
          if (typeof message.sellingFeeRate !== "number")
            return "sellingFeeRate: number expected";
        }
        if (message.buyingFeeRateEffectiveDate != null && message.hasOwnProperty("buyingFeeRateEffectiveDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.buyingFeeRateEffectiveDate);
          if (error)
            return "buyingFeeRateEffectiveDate." + error;
        }
        if (message.buyingFeeRateExpiredDate != null && message.hasOwnProperty("buyingFeeRateExpiredDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.buyingFeeRateExpiredDate);
          if (error)
            return "buyingFeeRateExpiredDate." + error;
        }
        if (message.sellingFeeRateEffectiveDate != null && message.hasOwnProperty("sellingFeeRateEffectiveDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.sellingFeeRateEffectiveDate);
          if (error)
            return "sellingFeeRateEffectiveDate." + error;
        }
        if (message.sellingFeeRateExpiredDate != null && message.hasOwnProperty("sellingFeeRateExpiredDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.sellingFeeRateExpiredDate);
          if (error)
            return "sellingFeeRateExpiredDate." + error;
        }
        return null;
      };
      TradingFeeCustom.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.TradingFeeCustom)
          return object;
        let message = new $root.dnse.fo.TradingFeeCustom();
        switch (object.securityType) {
          case "UNKNOWN_TYPE":
          case 0:
            message.securityType = 0;
            break;
          case "STOCK":
          case 1:
            message.securityType = 1;
            break;
          case "BOND":
          case 2:
            message.securityType = 2;
            break;
          case "MUTUAL_FUND":
          case 3:
            message.securityType = 3;
            break;
          case "ETF":
          case 4:
            message.securityType = 4;
            break;
          case "FUTURE":
          case 5:
            message.securityType = 5;
            break;
          case "OPTION":
          case 6:
            message.securityType = 6;
            break;
          case "COVERED_WARRANT":
          case 7:
            message.securityType = 7;
            break;
          case "FUTURE_INDEX":
          case 8:
            message.securityType = 8;
            break;
          case "FUTURE_BOND":
          case 9:
            message.securityType = 9;
            break;
          case "CORPORATE_BOND":
          case 10:
            message.securityType = 10;
            break;
          case "PRIVATE_BOND":
          case 11:
            message.securityType = 11;
            break;
          case "ALL":
          case 100:
            message.securityType = 100;
            break;
        }
        switch (object.exchange) {
          case "UNKNOWN_EXCHANGE":
          case 0:
            message.exchange = 0;
            break;
          case "HNX":
          case 2:
            message.exchange = 2;
            break;
          case "UPCOM":
          case 3:
            message.exchange = 3;
            break;
          case "HNX_BOND":
          case 4:
            message.exchange = 4;
            break;
          case "HOSE":
          case 10:
            message.exchange = 10;
            break;
          case "HOSE_ODD_LOT":
          case 11:
            message.exchange = 11;
            break;
          case "HNX_DERIVATIVE":
          case 12:
            message.exchange = 12;
            break;
          case "HNX_DERIVATIVE_BOND":
          case 13:
            message.exchange = 13;
            break;
          case "HNX_PRIVATE_BOND":
          case 14:
            message.exchange = 14;
            break;
          case "OTC":
          case 30:
            message.exchange = 30;
            break;
        }
        if (object.buyingFeeRate != null)
          message.buyingFeeRate = Number(object.buyingFeeRate);
        if (object.sellingFeeRate != null)
          message.sellingFeeRate = Number(object.sellingFeeRate);
        if (object.buyingFeeRateEffectiveDate != null) {
          if (typeof object.buyingFeeRateEffectiveDate !== "object")
            throw TypeError(".dnse.fo.TradingFeeCustom.buyingFeeRateEffectiveDate: object expected");
          message.buyingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.fromObject(object.buyingFeeRateEffectiveDate);
        }
        if (object.buyingFeeRateExpiredDate != null) {
          if (typeof object.buyingFeeRateExpiredDate !== "object")
            throw TypeError(".dnse.fo.TradingFeeCustom.buyingFeeRateExpiredDate: object expected");
          message.buyingFeeRateExpiredDate = $root.google.protobuf.Timestamp.fromObject(object.buyingFeeRateExpiredDate);
        }
        if (object.sellingFeeRateEffectiveDate != null) {
          if (typeof object.sellingFeeRateEffectiveDate !== "object")
            throw TypeError(".dnse.fo.TradingFeeCustom.sellingFeeRateEffectiveDate: object expected");
          message.sellingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.fromObject(object.sellingFeeRateEffectiveDate);
        }
        if (object.sellingFeeRateExpiredDate != null) {
          if (typeof object.sellingFeeRateExpiredDate !== "object")
            throw TypeError(".dnse.fo.TradingFeeCustom.sellingFeeRateExpiredDate: object expected");
          message.sellingFeeRateExpiredDate = $root.google.protobuf.Timestamp.fromObject(object.sellingFeeRateExpiredDate);
        }
        return message;
      };
      TradingFeeCustom.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
          object.exchange = options.enums === String ? "UNKNOWN_EXCHANGE" : 0;
          object.buyingFeeRate = 0;
          object.sellingFeeRate = 0;
          object.buyingFeeRateEffectiveDate = null;
          object.buyingFeeRateExpiredDate = null;
          object.sellingFeeRateEffectiveDate = null;
          object.sellingFeeRateExpiredDate = null;
        }
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          object.securityType = options.enums === String ? $root.dnse.fo.SecurityType[message.securityType] : message.securityType;
        if (message.exchange != null && message.hasOwnProperty("exchange"))
          object.exchange = options.enums === String ? $root.dnse.fo.Exchange[message.exchange] : message.exchange;
        if (message.buyingFeeRate != null && message.hasOwnProperty("buyingFeeRate"))
          object.buyingFeeRate = options.json && !isFinite(message.buyingFeeRate) ? String(message.buyingFeeRate) : message.buyingFeeRate;
        if (message.sellingFeeRate != null && message.hasOwnProperty("sellingFeeRate"))
          object.sellingFeeRate = options.json && !isFinite(message.sellingFeeRate) ? String(message.sellingFeeRate) : message.sellingFeeRate;
        if (message.buyingFeeRateEffectiveDate != null && message.hasOwnProperty("buyingFeeRateEffectiveDate"))
          object.buyingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.toObject(message.buyingFeeRateEffectiveDate, options);
        if (message.buyingFeeRateExpiredDate != null && message.hasOwnProperty("buyingFeeRateExpiredDate"))
          object.buyingFeeRateExpiredDate = $root.google.protobuf.Timestamp.toObject(message.buyingFeeRateExpiredDate, options);
        if (message.sellingFeeRateEffectiveDate != null && message.hasOwnProperty("sellingFeeRateEffectiveDate"))
          object.sellingFeeRateEffectiveDate = $root.google.protobuf.Timestamp.toObject(message.sellingFeeRateEffectiveDate, options);
        if (message.sellingFeeRateExpiredDate != null && message.hasOwnProperty("sellingFeeRateExpiredDate"))
          object.sellingFeeRateExpiredDate = $root.google.protobuf.Timestamp.toObject(message.sellingFeeRateExpiredDate, options);
        return object;
      };
      TradingFeeCustom.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return TradingFeeCustom;
    }();
    fo.LoanPackageAccount = function() {
      function LoanPackageAccount(properties) {
        this.TradingFeeCustoms = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPackageAccount.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      LoanPackageAccount.prototype.accountNo = "";
      LoanPackageAccount.prototype.loanPackageId = 0;
      LoanPackageAccount.prototype.customInfo = null;
      LoanPackageAccount.prototype.TradingFeeCustoms = $util.emptyArray;
      LoanPackageAccount.create = function create(properties) {
        return new LoanPackageAccount(properties);
      };
      LoanPackageAccount.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(24).int32(message.loanPackageId);
        if (message.customInfo != null && Object.hasOwnProperty.call(message, "customInfo"))
          $root.dnse.fo.LoanPkgCustom.encode(message.customInfo, writer.uint32(34).fork()).ldelim();
        if (message.TradingFeeCustoms != null && message.TradingFeeCustoms.length)
          for (let i = 0; i < message.TradingFeeCustoms.length; ++i)
            $root.dnse.fo.TradingFeeCustom.encode(message.TradingFeeCustoms[i], writer.uint32(42).fork()).ldelim();
        return writer;
      };
      LoanPackageAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPackageAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPackageAccount();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.loanPackageId = reader.int32();
              break;
            case 4:
              message.customInfo = $root.dnse.fo.LoanPkgCustom.decode(reader, reader.uint32());
              break;
            case 5:
              if (!(message.TradingFeeCustoms && message.TradingFeeCustoms.length))
                message.TradingFeeCustoms = [];
              message.TradingFeeCustoms.push($root.dnse.fo.TradingFeeCustom.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPackageAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPackageAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.customInfo != null && message.hasOwnProperty("customInfo")) {
          let error = $root.dnse.fo.LoanPkgCustom.verify(message.customInfo);
          if (error)
            return "customInfo." + error;
        }
        if (message.TradingFeeCustoms != null && message.hasOwnProperty("TradingFeeCustoms")) {
          if (!Array.isArray(message.TradingFeeCustoms))
            return "TradingFeeCustoms: array expected";
          for (let i = 0; i < message.TradingFeeCustoms.length; ++i) {
            let error = $root.dnse.fo.TradingFeeCustom.verify(message.TradingFeeCustoms[i]);
            if (error)
              return "TradingFeeCustoms." + error;
          }
        }
        return null;
      };
      LoanPackageAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPackageAccount)
          return object;
        let message = new $root.dnse.fo.LoanPackageAccount();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.customInfo != null) {
          if (typeof object.customInfo !== "object")
            throw TypeError(".dnse.fo.LoanPackageAccount.customInfo: object expected");
          message.customInfo = $root.dnse.fo.LoanPkgCustom.fromObject(object.customInfo);
        }
        if (object.TradingFeeCustoms) {
          if (!Array.isArray(object.TradingFeeCustoms))
            throw TypeError(".dnse.fo.LoanPackageAccount.TradingFeeCustoms: array expected");
          message.TradingFeeCustoms = [];
          for (let i = 0; i < object.TradingFeeCustoms.length; ++i) {
            if (typeof object.TradingFeeCustoms[i] !== "object")
              throw TypeError(".dnse.fo.LoanPackageAccount.TradingFeeCustoms: object expected");
            message.TradingFeeCustoms[i] = $root.dnse.fo.TradingFeeCustom.fromObject(object.TradingFeeCustoms[i]);
          }
        }
        return message;
      };
      LoanPackageAccount.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.TradingFeeCustoms = [];
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.loanPackageId = 0;
          object.customInfo = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.customInfo != null && message.hasOwnProperty("customInfo"))
          object.customInfo = $root.dnse.fo.LoanPkgCustom.toObject(message.customInfo, options);
        if (message.TradingFeeCustoms && message.TradingFeeCustoms.length) {
          object.TradingFeeCustoms = [];
          for (let j = 0; j < message.TradingFeeCustoms.length; ++j)
            object.TradingFeeCustoms[j] = $root.dnse.fo.TradingFeeCustom.toObject(message.TradingFeeCustoms[j], options);
        }
        return object;
      };
      LoanPackageAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPackageAccount;
    }();
    fo.LoanPackageAccountWrap = function() {
      function LoanPackageAccountWrap(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPackageAccountWrap.prototype.loanPackageAccount = null;
      LoanPackageAccountWrap.prototype.metadata = null;
      LoanPackageAccountWrap.create = function create(properties) {
        return new LoanPackageAccountWrap(properties);
      };
      LoanPackageAccountWrap.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.loanPackageAccount != null && Object.hasOwnProperty.call(message, "loanPackageAccount"))
          $root.dnse.fo.LoanPackageAccount.encode(message.loanPackageAccount, writer.uint32(10).fork()).ldelim();
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          $root.dnse.fo.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      LoanPackageAccountWrap.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPackageAccountWrap.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPackageAccountWrap();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.loanPackageAccount = $root.dnse.fo.LoanPackageAccount.decode(reader, reader.uint32());
              break;
            case 2:
              message.metadata = $root.dnse.fo.Metadata.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPackageAccountWrap.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPackageAccountWrap.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.loanPackageAccount != null && message.hasOwnProperty("loanPackageAccount")) {
          let error = $root.dnse.fo.LoanPackageAccount.verify(message.loanPackageAccount);
          if (error)
            return "loanPackageAccount." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          let error = $root.dnse.fo.Metadata.verify(message.metadata);
          if (error)
            return "metadata." + error;
        }
        return null;
      };
      LoanPackageAccountWrap.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPackageAccountWrap)
          return object;
        let message = new $root.dnse.fo.LoanPackageAccountWrap();
        if (object.loanPackageAccount != null) {
          if (typeof object.loanPackageAccount !== "object")
            throw TypeError(".dnse.fo.LoanPackageAccountWrap.loanPackageAccount: object expected");
          message.loanPackageAccount = $root.dnse.fo.LoanPackageAccount.fromObject(object.loanPackageAccount);
        }
        if (object.metadata != null) {
          if (typeof object.metadata !== "object")
            throw TypeError(".dnse.fo.LoanPackageAccountWrap.metadata: object expected");
          message.metadata = $root.dnse.fo.Metadata.fromObject(object.metadata);
        }
        return message;
      };
      LoanPackageAccountWrap.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.loanPackageAccount = null;
          object.metadata = null;
        }
        if (message.loanPackageAccount != null && message.hasOwnProperty("loanPackageAccount"))
          object.loanPackageAccount = $root.dnse.fo.LoanPackageAccount.toObject(message.loanPackageAccount, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = $root.dnse.fo.Metadata.toObject(message.metadata, options);
        return object;
      };
      LoanPackageAccountWrap.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPackageAccountWrap;
    }();
    fo.TradingConfigV2 = function() {
      function TradingConfigV2(properties) {
        this.advanceFees = [];
        this.loanPackages = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      TradingConfigV2.prototype.accountNo = "";
      TradingConfigV2.prototype.accountType = "";
      TradingConfigV2.prototype.marginAccount = false;
      TradingConfigV2.prototype.tradeBasketRestrict = false;
      TradingConfigV2.prototype.autoAdvance = false;
      TradingConfigV2.prototype.maxLoanLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      TradingConfigV2.prototype.advanceFees = $util.emptyArray;
      TradingConfigV2.prototype.loanPackages = $util.emptyArray;
      TradingConfigV2.prototype.buyingTaxRate = 0;
      TradingConfigV2.prototype.sellingTaxRate = 0;
      TradingConfigV2.prototype.dividendTaxRate = 0;
      TradingConfigV2.create = function create(properties) {
        return new TradingConfigV2(properties);
      };
      TradingConfigV2.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
          writer.uint32(18).string(message.accountType);
        if (message.marginAccount != null && Object.hasOwnProperty.call(message, "marginAccount"))
          writer.uint32(24).bool(message.marginAccount);
        if (message.tradeBasketRestrict != null && Object.hasOwnProperty.call(message, "tradeBasketRestrict"))
          writer.uint32(32).bool(message.tradeBasketRestrict);
        if (message.autoAdvance != null && Object.hasOwnProperty.call(message, "autoAdvance"))
          writer.uint32(40).bool(message.autoAdvance);
        if (message.maxLoanLimit != null && Object.hasOwnProperty.call(message, "maxLoanLimit"))
          writer.uint32(48).int64(message.maxLoanLimit);
        if (message.advanceFees != null && message.advanceFees.length)
          for (let i = 0; i < message.advanceFees.length; ++i)
            $root.dnse.fo.AdvanceFee.encode(message.advanceFees[i], writer.uint32(66).fork()).ldelim();
        if (message.loanPackages != null && message.loanPackages.length)
          for (let i = 0; i < message.loanPackages.length; ++i)
            $root.dnse.fo.LoanPackage.encode(message.loanPackages[i], writer.uint32(74).fork()).ldelim();
        if (message.buyingTaxRate != null && Object.hasOwnProperty.call(message, "buyingTaxRate"))
          writer.uint32(81).double(message.buyingTaxRate);
        if (message.sellingTaxRate != null && Object.hasOwnProperty.call(message, "sellingTaxRate"))
          writer.uint32(89).double(message.sellingTaxRate);
        if (message.dividendTaxRate != null && Object.hasOwnProperty.call(message, "dividendTaxRate"))
          writer.uint32(97).double(message.dividendTaxRate);
        return writer;
      };
      TradingConfigV2.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      TradingConfigV2.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.TradingConfigV2();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.accountType = reader.string();
              break;
            case 3:
              message.marginAccount = reader.bool();
              break;
            case 4:
              message.tradeBasketRestrict = reader.bool();
              break;
            case 5:
              message.autoAdvance = reader.bool();
              break;
            case 6:
              message.maxLoanLimit = reader.int64();
              break;
            case 8:
              if (!(message.advanceFees && message.advanceFees.length))
                message.advanceFees = [];
              message.advanceFees.push($root.dnse.fo.AdvanceFee.decode(reader, reader.uint32()));
              break;
            case 9:
              if (!(message.loanPackages && message.loanPackages.length))
                message.loanPackages = [];
              message.loanPackages.push($root.dnse.fo.LoanPackage.decode(reader, reader.uint32()));
              break;
            case 10:
              message.buyingTaxRate = reader.double();
              break;
            case 11:
              message.sellingTaxRate = reader.double();
              break;
            case 12:
              message.dividendTaxRate = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      TradingConfigV2.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      TradingConfigV2.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          if (!$util.isString(message.accountType))
            return "accountType: string expected";
        }
        if (message.marginAccount != null && message.hasOwnProperty("marginAccount")) {
          if (typeof message.marginAccount !== "boolean")
            return "marginAccount: boolean expected";
        }
        if (message.tradeBasketRestrict != null && message.hasOwnProperty("tradeBasketRestrict")) {
          if (typeof message.tradeBasketRestrict !== "boolean")
            return "tradeBasketRestrict: boolean expected";
        }
        if (message.autoAdvance != null && message.hasOwnProperty("autoAdvance")) {
          if (typeof message.autoAdvance !== "boolean")
            return "autoAdvance: boolean expected";
        }
        if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit")) {
          if (!$util.isInteger(message.maxLoanLimit) && !(message.maxLoanLimit && $util.isInteger(message.maxLoanLimit.low) && $util.isInteger(message.maxLoanLimit.high)))
            return "maxLoanLimit: integer|Long expected";
        }
        if (message.advanceFees != null && message.hasOwnProperty("advanceFees")) {
          if (!Array.isArray(message.advanceFees))
            return "advanceFees: array expected";
          for (let i = 0; i < message.advanceFees.length; ++i) {
            let error = $root.dnse.fo.AdvanceFee.verify(message.advanceFees[i]);
            if (error)
              return "advanceFees." + error;
          }
        }
        if (message.loanPackages != null && message.hasOwnProperty("loanPackages")) {
          if (!Array.isArray(message.loanPackages))
            return "loanPackages: array expected";
          for (let i = 0; i < message.loanPackages.length; ++i) {
            let error = $root.dnse.fo.LoanPackage.verify(message.loanPackages[i]);
            if (error)
              return "loanPackages." + error;
          }
        }
        if (message.buyingTaxRate != null && message.hasOwnProperty("buyingTaxRate")) {
          if (typeof message.buyingTaxRate !== "number")
            return "buyingTaxRate: number expected";
        }
        if (message.sellingTaxRate != null && message.hasOwnProperty("sellingTaxRate")) {
          if (typeof message.sellingTaxRate !== "number")
            return "sellingTaxRate: number expected";
        }
        if (message.dividendTaxRate != null && message.hasOwnProperty("dividendTaxRate")) {
          if (typeof message.dividendTaxRate !== "number")
            return "dividendTaxRate: number expected";
        }
        return null;
      };
      TradingConfigV2.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.TradingConfigV2)
          return object;
        let message = new $root.dnse.fo.TradingConfigV2();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.accountType != null)
          message.accountType = String(object.accountType);
        if (object.marginAccount != null)
          message.marginAccount = Boolean(object.marginAccount);
        if (object.tradeBasketRestrict != null)
          message.tradeBasketRestrict = Boolean(object.tradeBasketRestrict);
        if (object.autoAdvance != null)
          message.autoAdvance = Boolean(object.autoAdvance);
        if (object.maxLoanLimit != null) {
          if ($util.Long)
            (message.maxLoanLimit = $util.Long.fromValue(object.maxLoanLimit)).unsigned = false;
          else if (typeof object.maxLoanLimit === "string")
            message.maxLoanLimit = parseInt(object.maxLoanLimit, 10);
          else if (typeof object.maxLoanLimit === "number")
            message.maxLoanLimit = object.maxLoanLimit;
          else if (typeof object.maxLoanLimit === "object")
            message.maxLoanLimit = new $util.LongBits(object.maxLoanLimit.low >>> 0, object.maxLoanLimit.high >>> 0).toNumber();
        }
        if (object.advanceFees) {
          if (!Array.isArray(object.advanceFees))
            throw TypeError(".dnse.fo.TradingConfigV2.advanceFees: array expected");
          message.advanceFees = [];
          for (let i = 0; i < object.advanceFees.length; ++i) {
            if (typeof object.advanceFees[i] !== "object")
              throw TypeError(".dnse.fo.TradingConfigV2.advanceFees: object expected");
            message.advanceFees[i] = $root.dnse.fo.AdvanceFee.fromObject(object.advanceFees[i]);
          }
        }
        if (object.loanPackages) {
          if (!Array.isArray(object.loanPackages))
            throw TypeError(".dnse.fo.TradingConfigV2.loanPackages: array expected");
          message.loanPackages = [];
          for (let i = 0; i < object.loanPackages.length; ++i) {
            if (typeof object.loanPackages[i] !== "object")
              throw TypeError(".dnse.fo.TradingConfigV2.loanPackages: object expected");
            message.loanPackages[i] = $root.dnse.fo.LoanPackage.fromObject(object.loanPackages[i]);
          }
        }
        if (object.buyingTaxRate != null)
          message.buyingTaxRate = Number(object.buyingTaxRate);
        if (object.sellingTaxRate != null)
          message.sellingTaxRate = Number(object.sellingTaxRate);
        if (object.dividendTaxRate != null)
          message.dividendTaxRate = Number(object.dividendTaxRate);
        return message;
      };
      TradingConfigV2.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.advanceFees = [];
          object.loanPackages = [];
        }
        if (options.defaults) {
          object.accountNo = "";
          object.accountType = "";
          object.marginAccount = false;
          object.tradeBasketRestrict = false;
          object.autoAdvance = false;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.maxLoanLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.maxLoanLimit = options.longs === String ? "0" : 0;
          object.buyingTaxRate = 0;
          object.sellingTaxRate = 0;
          object.dividendTaxRate = 0;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.accountType != null && message.hasOwnProperty("accountType"))
          object.accountType = message.accountType;
        if (message.marginAccount != null && message.hasOwnProperty("marginAccount"))
          object.marginAccount = message.marginAccount;
        if (message.tradeBasketRestrict != null && message.hasOwnProperty("tradeBasketRestrict"))
          object.tradeBasketRestrict = message.tradeBasketRestrict;
        if (message.autoAdvance != null && message.hasOwnProperty("autoAdvance"))
          object.autoAdvance = message.autoAdvance;
        if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit"))
          if (typeof message.maxLoanLimit === "number")
            object.maxLoanLimit = options.longs === String ? String(message.maxLoanLimit) : message.maxLoanLimit;
          else
            object.maxLoanLimit = options.longs === String ? $util.Long.prototype.toString.call(message.maxLoanLimit) : options.longs === Number ? new $util.LongBits(message.maxLoanLimit.low >>> 0, message.maxLoanLimit.high >>> 0).toNumber() : message.maxLoanLimit;
        if (message.advanceFees && message.advanceFees.length) {
          object.advanceFees = [];
          for (let j = 0; j < message.advanceFees.length; ++j)
            object.advanceFees[j] = $root.dnse.fo.AdvanceFee.toObject(message.advanceFees[j], options);
        }
        if (message.loanPackages && message.loanPackages.length) {
          object.loanPackages = [];
          for (let j = 0; j < message.loanPackages.length; ++j)
            object.loanPackages[j] = $root.dnse.fo.LoanPackage.toObject(message.loanPackages[j], options);
        }
        if (message.buyingTaxRate != null && message.hasOwnProperty("buyingTaxRate"))
          object.buyingTaxRate = options.json && !isFinite(message.buyingTaxRate) ? String(message.buyingTaxRate) : message.buyingTaxRate;
        if (message.sellingTaxRate != null && message.hasOwnProperty("sellingTaxRate"))
          object.sellingTaxRate = options.json && !isFinite(message.sellingTaxRate) ? String(message.sellingTaxRate) : message.sellingTaxRate;
        if (message.dividendTaxRate != null && message.hasOwnProperty("dividendTaxRate"))
          object.dividendTaxRate = options.json && !isFinite(message.dividendTaxRate) ? String(message.dividendTaxRate) : message.dividendTaxRate;
        return object;
      };
      TradingConfigV2.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return TradingConfigV2;
    }();
    fo.LoanV2 = function() {
      function LoanV2(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanV2.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      LoanV2.prototype.accountNo = "";
      LoanV2.prototype.type = "";
      LoanV2.prototype.referenceId = "";
      LoanV2.prototype.loanPackageId = 0;
      LoanV2.prototype.loanPackage = null;
      LoanV2.prototype.description = "";
      LoanV2.prototype.tradingDate = "";
      LoanV2.prototype.status = "";
      LoanV2.prototype.disbursementDate = null;
      LoanV2.prototype.dueDate = null;
      LoanV2.prototype.originalPrincipal = 0;
      LoanV2.prototype.paidPrincipal = 0;
      LoanV2.prototype.paidInterest = 0;
      LoanV2.prototype.unduePrincipal = 0;
      LoanV2.prototype.undueInterest = 0;
      LoanV2.prototype.duePrincipal = 0;
      LoanV2.prototype.dueInterest = 0;
      LoanV2.prototype.overduePrincipal = 0;
      LoanV2.prototype.overdueInterest = 0;
      LoanV2.prototype.toCollectPrincipal = 0;
      LoanV2.prototype.toCollectInterest = 0;
      LoanV2.prototype.interestOnOverdueLoan = 0;
      LoanV2.prototype.t0UnrealizedPrincipal = 0;
      LoanV2.prototype.t1UnrealizedPrincipal = 0;
      LoanV2.prototype.t2UnrealizedPrincipal = 0;
      LoanV2.prototype.t0UnrealizedInterest = 0;
      LoanV2.prototype.t1UnrealizedInterest = 0;
      LoanV2.prototype.t2UnrealizedInterest = 0;
      LoanV2.prototype.metadata = "";
      LoanV2.prototype.createdDate = null;
      LoanV2.prototype.updatedDate = null;
      LoanV2.prototype.t0PreCalInterestOnT2 = 0;
      LoanV2.prototype.t1PreCalInterestOnT2 = 0;
      LoanV2.prototype.investorId = "";
      LoanV2.prototype.custodyCode = "";
      LoanV2.prototype.souredPrincipal = 0;
      LoanV2.prototype.souredInterest = 0;
      LoanV2.prototype.loanPolicyId = 0;
      LoanV2.prototype.loanPolicy = null;
      LoanV2.prototype.coSponsorId = "";
      LoanV2.prototype.externalLoanId = "";
      LoanV2.prototype.symbol = "";
      LoanV2.create = function create(properties) {
        return new LoanV2(properties);
      };
      LoanV2.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(26).string(message.type);
        if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
          writer.uint32(34).string(message.referenceId);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(40).int32(message.loanPackageId);
        if (message.loanPackage != null && Object.hasOwnProperty.call(message, "loanPackage"))
          $root.dnse.fo.LoanPackage.encode(message.loanPackage, writer.uint32(50).fork()).ldelim();
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(58).string(message.description);
        if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
          writer.uint32(66).string(message.tradingDate);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(74).string(message.status);
        if (message.disbursementDate != null && Object.hasOwnProperty.call(message, "disbursementDate"))
          $root.google.protobuf.Timestamp.encode(message.disbursementDate, writer.uint32(82).fork()).ldelim();
        if (message.dueDate != null && Object.hasOwnProperty.call(message, "dueDate"))
          $root.google.protobuf.Timestamp.encode(message.dueDate, writer.uint32(90).fork()).ldelim();
        if (message.originalPrincipal != null && Object.hasOwnProperty.call(message, "originalPrincipal"))
          writer.uint32(97).double(message.originalPrincipal);
        if (message.paidPrincipal != null && Object.hasOwnProperty.call(message, "paidPrincipal"))
          writer.uint32(105).double(message.paidPrincipal);
        if (message.paidInterest != null && Object.hasOwnProperty.call(message, "paidInterest"))
          writer.uint32(113).double(message.paidInterest);
        if (message.unduePrincipal != null && Object.hasOwnProperty.call(message, "unduePrincipal"))
          writer.uint32(121).double(message.unduePrincipal);
        if (message.undueInterest != null && Object.hasOwnProperty.call(message, "undueInterest"))
          writer.uint32(129).double(message.undueInterest);
        if (message.duePrincipal != null && Object.hasOwnProperty.call(message, "duePrincipal"))
          writer.uint32(137).double(message.duePrincipal);
        if (message.dueInterest != null && Object.hasOwnProperty.call(message, "dueInterest"))
          writer.uint32(145).double(message.dueInterest);
        if (message.overduePrincipal != null && Object.hasOwnProperty.call(message, "overduePrincipal"))
          writer.uint32(153).double(message.overduePrincipal);
        if (message.overdueInterest != null && Object.hasOwnProperty.call(message, "overdueInterest"))
          writer.uint32(161).double(message.overdueInterest);
        if (message.toCollectPrincipal != null && Object.hasOwnProperty.call(message, "toCollectPrincipal"))
          writer.uint32(169).double(message.toCollectPrincipal);
        if (message.toCollectInterest != null && Object.hasOwnProperty.call(message, "toCollectInterest"))
          writer.uint32(177).double(message.toCollectInterest);
        if (message.interestOnOverdueLoan != null && Object.hasOwnProperty.call(message, "interestOnOverdueLoan"))
          writer.uint32(185).double(message.interestOnOverdueLoan);
        if (message.t0UnrealizedPrincipal != null && Object.hasOwnProperty.call(message, "t0UnrealizedPrincipal"))
          writer.uint32(193).double(message.t0UnrealizedPrincipal);
        if (message.t1UnrealizedPrincipal != null && Object.hasOwnProperty.call(message, "t1UnrealizedPrincipal"))
          writer.uint32(201).double(message.t1UnrealizedPrincipal);
        if (message.t2UnrealizedPrincipal != null && Object.hasOwnProperty.call(message, "t2UnrealizedPrincipal"))
          writer.uint32(209).double(message.t2UnrealizedPrincipal);
        if (message.t0UnrealizedInterest != null && Object.hasOwnProperty.call(message, "t0UnrealizedInterest"))
          writer.uint32(217).double(message.t0UnrealizedInterest);
        if (message.t1UnrealizedInterest != null && Object.hasOwnProperty.call(message, "t1UnrealizedInterest"))
          writer.uint32(225).double(message.t1UnrealizedInterest);
        if (message.t2UnrealizedInterest != null && Object.hasOwnProperty.call(message, "t2UnrealizedInterest"))
          writer.uint32(233).double(message.t2UnrealizedInterest);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          writer.uint32(242).string(message.metadata);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(250).fork()).ldelim();
        if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
          $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(258).fork()).ldelim();
        if (message.t0PreCalInterestOnT2 != null && Object.hasOwnProperty.call(message, "t0PreCalInterestOnT2"))
          writer.uint32(265).double(message.t0PreCalInterestOnT2);
        if (message.t1PreCalInterestOnT2 != null && Object.hasOwnProperty.call(message, "t1PreCalInterestOnT2"))
          writer.uint32(273).double(message.t1PreCalInterestOnT2);
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(282).string(message.investorId);
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(290).string(message.custodyCode);
        if (message.souredPrincipal != null && Object.hasOwnProperty.call(message, "souredPrincipal"))
          writer.uint32(297).double(message.souredPrincipal);
        if (message.souredInterest != null && Object.hasOwnProperty.call(message, "souredInterest"))
          writer.uint32(305).double(message.souredInterest);
        if (message.loanPolicyId != null && Object.hasOwnProperty.call(message, "loanPolicyId"))
          writer.uint32(312).int32(message.loanPolicyId);
        if (message.loanPolicy != null && Object.hasOwnProperty.call(message, "loanPolicy"))
          $root.dnse.fo.LoanPolicy.encode(message.loanPolicy, writer.uint32(322).fork()).ldelim();
        if (message.coSponsorId != null && Object.hasOwnProperty.call(message, "coSponsorId"))
          writer.uint32(330).string(message.coSponsorId);
        if (message.externalLoanId != null && Object.hasOwnProperty.call(message, "externalLoanId"))
          writer.uint32(338).string(message.externalLoanId);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(346).string(message.symbol);
        return writer;
      };
      LoanV2.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanV2.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanV2();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.type = reader.string();
              break;
            case 4:
              message.referenceId = reader.string();
              break;
            case 5:
              message.loanPackageId = reader.int32();
              break;
            case 6:
              message.loanPackage = $root.dnse.fo.LoanPackage.decode(reader, reader.uint32());
              break;
            case 7:
              message.description = reader.string();
              break;
            case 8:
              message.tradingDate = reader.string();
              break;
            case 9:
              message.status = reader.string();
              break;
            case 10:
              message.disbursementDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 11:
              message.dueDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 12:
              message.originalPrincipal = reader.double();
              break;
            case 13:
              message.paidPrincipal = reader.double();
              break;
            case 14:
              message.paidInterest = reader.double();
              break;
            case 15:
              message.unduePrincipal = reader.double();
              break;
            case 16:
              message.undueInterest = reader.double();
              break;
            case 17:
              message.duePrincipal = reader.double();
              break;
            case 18:
              message.dueInterest = reader.double();
              break;
            case 19:
              message.overduePrincipal = reader.double();
              break;
            case 20:
              message.overdueInterest = reader.double();
              break;
            case 21:
              message.toCollectPrincipal = reader.double();
              break;
            case 22:
              message.toCollectInterest = reader.double();
              break;
            case 23:
              message.interestOnOverdueLoan = reader.double();
              break;
            case 24:
              message.t0UnrealizedPrincipal = reader.double();
              break;
            case 25:
              message.t1UnrealizedPrincipal = reader.double();
              break;
            case 26:
              message.t2UnrealizedPrincipal = reader.double();
              break;
            case 27:
              message.t0UnrealizedInterest = reader.double();
              break;
            case 28:
              message.t1UnrealizedInterest = reader.double();
              break;
            case 29:
              message.t2UnrealizedInterest = reader.double();
              break;
            case 30:
              message.metadata = reader.string();
              break;
            case 31:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 32:
              message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 33:
              message.t0PreCalInterestOnT2 = reader.double();
              break;
            case 34:
              message.t1PreCalInterestOnT2 = reader.double();
              break;
            case 35:
              message.investorId = reader.string();
              break;
            case 36:
              message.custodyCode = reader.string();
              break;
            case 37:
              message.souredPrincipal = reader.double();
              break;
            case 38:
              message.souredInterest = reader.double();
              break;
            case 39:
              message.loanPolicyId = reader.int32();
              break;
            case 40:
              message.loanPolicy = $root.dnse.fo.LoanPolicy.decode(reader, reader.uint32());
              break;
            case 41:
              message.coSponsorId = reader.string();
              break;
            case 42:
              message.externalLoanId = reader.string();
              break;
            case 43:
              message.symbol = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanV2.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanV2.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
          if (!$util.isString(message.referenceId))
            return "referenceId: string expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.loanPackage != null && message.hasOwnProperty("loanPackage")) {
          let error = $root.dnse.fo.LoanPackage.verify(message.loanPackage);
          if (error)
            return "loanPackage." + error;
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
          if (!$util.isString(message.tradingDate))
            return "tradingDate: string expected";
        }
        if (message.status != null && message.hasOwnProperty("status")) {
          if (!$util.isString(message.status))
            return "status: string expected";
        }
        if (message.disbursementDate != null && message.hasOwnProperty("disbursementDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.disbursementDate);
          if (error)
            return "disbursementDate." + error;
        }
        if (message.dueDate != null && message.hasOwnProperty("dueDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.dueDate);
          if (error)
            return "dueDate." + error;
        }
        if (message.originalPrincipal != null && message.hasOwnProperty("originalPrincipal")) {
          if (typeof message.originalPrincipal !== "number")
            return "originalPrincipal: number expected";
        }
        if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal")) {
          if (typeof message.paidPrincipal !== "number")
            return "paidPrincipal: number expected";
        }
        if (message.paidInterest != null && message.hasOwnProperty("paidInterest")) {
          if (typeof message.paidInterest !== "number")
            return "paidInterest: number expected";
        }
        if (message.unduePrincipal != null && message.hasOwnProperty("unduePrincipal")) {
          if (typeof message.unduePrincipal !== "number")
            return "unduePrincipal: number expected";
        }
        if (message.undueInterest != null && message.hasOwnProperty("undueInterest")) {
          if (typeof message.undueInterest !== "number")
            return "undueInterest: number expected";
        }
        if (message.duePrincipal != null && message.hasOwnProperty("duePrincipal")) {
          if (typeof message.duePrincipal !== "number")
            return "duePrincipal: number expected";
        }
        if (message.dueInterest != null && message.hasOwnProperty("dueInterest")) {
          if (typeof message.dueInterest !== "number")
            return "dueInterest: number expected";
        }
        if (message.overduePrincipal != null && message.hasOwnProperty("overduePrincipal")) {
          if (typeof message.overduePrincipal !== "number")
            return "overduePrincipal: number expected";
        }
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest")) {
          if (typeof message.overdueInterest !== "number")
            return "overdueInterest: number expected";
        }
        if (message.toCollectPrincipal != null && message.hasOwnProperty("toCollectPrincipal")) {
          if (typeof message.toCollectPrincipal !== "number")
            return "toCollectPrincipal: number expected";
        }
        if (message.toCollectInterest != null && message.hasOwnProperty("toCollectInterest")) {
          if (typeof message.toCollectInterest !== "number")
            return "toCollectInterest: number expected";
        }
        if (message.interestOnOverdueLoan != null && message.hasOwnProperty("interestOnOverdueLoan")) {
          if (typeof message.interestOnOverdueLoan !== "number")
            return "interestOnOverdueLoan: number expected";
        }
        if (message.t0UnrealizedPrincipal != null && message.hasOwnProperty("t0UnrealizedPrincipal")) {
          if (typeof message.t0UnrealizedPrincipal !== "number")
            return "t0UnrealizedPrincipal: number expected";
        }
        if (message.t1UnrealizedPrincipal != null && message.hasOwnProperty("t1UnrealizedPrincipal")) {
          if (typeof message.t1UnrealizedPrincipal !== "number")
            return "t1UnrealizedPrincipal: number expected";
        }
        if (message.t2UnrealizedPrincipal != null && message.hasOwnProperty("t2UnrealizedPrincipal")) {
          if (typeof message.t2UnrealizedPrincipal !== "number")
            return "t2UnrealizedPrincipal: number expected";
        }
        if (message.t0UnrealizedInterest != null && message.hasOwnProperty("t0UnrealizedInterest")) {
          if (typeof message.t0UnrealizedInterest !== "number")
            return "t0UnrealizedInterest: number expected";
        }
        if (message.t1UnrealizedInterest != null && message.hasOwnProperty("t1UnrealizedInterest")) {
          if (typeof message.t1UnrealizedInterest !== "number")
            return "t1UnrealizedInterest: number expected";
        }
        if (message.t2UnrealizedInterest != null && message.hasOwnProperty("t2UnrealizedInterest")) {
          if (typeof message.t2UnrealizedInterest !== "number")
            return "t2UnrealizedInterest: number expected";
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          if (!$util.isString(message.metadata))
            return "metadata: string expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
          if (error)
            return "updatedDate." + error;
        }
        if (message.t0PreCalInterestOnT2 != null && message.hasOwnProperty("t0PreCalInterestOnT2")) {
          if (typeof message.t0PreCalInterestOnT2 !== "number")
            return "t0PreCalInterestOnT2: number expected";
        }
        if (message.t1PreCalInterestOnT2 != null && message.hasOwnProperty("t1PreCalInterestOnT2")) {
          if (typeof message.t1PreCalInterestOnT2 !== "number")
            return "t1PreCalInterestOnT2: number expected";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.souredPrincipal != null && message.hasOwnProperty("souredPrincipal")) {
          if (typeof message.souredPrincipal !== "number")
            return "souredPrincipal: number expected";
        }
        if (message.souredInterest != null && message.hasOwnProperty("souredInterest")) {
          if (typeof message.souredInterest !== "number")
            return "souredInterest: number expected";
        }
        if (message.loanPolicyId != null && message.hasOwnProperty("loanPolicyId")) {
          if (!$util.isInteger(message.loanPolicyId))
            return "loanPolicyId: integer expected";
        }
        if (message.loanPolicy != null && message.hasOwnProperty("loanPolicy")) {
          let error = $root.dnse.fo.LoanPolicy.verify(message.loanPolicy);
          if (error)
            return "loanPolicy." + error;
        }
        if (message.coSponsorId != null && message.hasOwnProperty("coSponsorId")) {
          if (!$util.isString(message.coSponsorId))
            return "coSponsorId: string expected";
        }
        if (message.externalLoanId != null && message.hasOwnProperty("externalLoanId")) {
          if (!$util.isString(message.externalLoanId))
            return "externalLoanId: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        return null;
      };
      LoanV2.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanV2)
          return object;
        let message = new $root.dnse.fo.LoanV2();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.type != null)
          message.type = String(object.type);
        if (object.referenceId != null)
          message.referenceId = String(object.referenceId);
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.loanPackage != null) {
          if (typeof object.loanPackage !== "object")
            throw TypeError(".dnse.fo.LoanV2.loanPackage: object expected");
          message.loanPackage = $root.dnse.fo.LoanPackage.fromObject(object.loanPackage);
        }
        if (object.description != null)
          message.description = String(object.description);
        if (object.tradingDate != null)
          message.tradingDate = String(object.tradingDate);
        if (object.status != null)
          message.status = String(object.status);
        if (object.disbursementDate != null) {
          if (typeof object.disbursementDate !== "object")
            throw TypeError(".dnse.fo.LoanV2.disbursementDate: object expected");
          message.disbursementDate = $root.google.protobuf.Timestamp.fromObject(object.disbursementDate);
        }
        if (object.dueDate != null) {
          if (typeof object.dueDate !== "object")
            throw TypeError(".dnse.fo.LoanV2.dueDate: object expected");
          message.dueDate = $root.google.protobuf.Timestamp.fromObject(object.dueDate);
        }
        if (object.originalPrincipal != null)
          message.originalPrincipal = Number(object.originalPrincipal);
        if (object.paidPrincipal != null)
          message.paidPrincipal = Number(object.paidPrincipal);
        if (object.paidInterest != null)
          message.paidInterest = Number(object.paidInterest);
        if (object.unduePrincipal != null)
          message.unduePrincipal = Number(object.unduePrincipal);
        if (object.undueInterest != null)
          message.undueInterest = Number(object.undueInterest);
        if (object.duePrincipal != null)
          message.duePrincipal = Number(object.duePrincipal);
        if (object.dueInterest != null)
          message.dueInterest = Number(object.dueInterest);
        if (object.overduePrincipal != null)
          message.overduePrincipal = Number(object.overduePrincipal);
        if (object.overdueInterest != null)
          message.overdueInterest = Number(object.overdueInterest);
        if (object.toCollectPrincipal != null)
          message.toCollectPrincipal = Number(object.toCollectPrincipal);
        if (object.toCollectInterest != null)
          message.toCollectInterest = Number(object.toCollectInterest);
        if (object.interestOnOverdueLoan != null)
          message.interestOnOverdueLoan = Number(object.interestOnOverdueLoan);
        if (object.t0UnrealizedPrincipal != null)
          message.t0UnrealizedPrincipal = Number(object.t0UnrealizedPrincipal);
        if (object.t1UnrealizedPrincipal != null)
          message.t1UnrealizedPrincipal = Number(object.t1UnrealizedPrincipal);
        if (object.t2UnrealizedPrincipal != null)
          message.t2UnrealizedPrincipal = Number(object.t2UnrealizedPrincipal);
        if (object.t0UnrealizedInterest != null)
          message.t0UnrealizedInterest = Number(object.t0UnrealizedInterest);
        if (object.t1UnrealizedInterest != null)
          message.t1UnrealizedInterest = Number(object.t1UnrealizedInterest);
        if (object.t2UnrealizedInterest != null)
          message.t2UnrealizedInterest = Number(object.t2UnrealizedInterest);
        if (object.metadata != null)
          message.metadata = String(object.metadata);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.LoanV2.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.updatedDate != null) {
          if (typeof object.updatedDate !== "object")
            throw TypeError(".dnse.fo.LoanV2.updatedDate: object expected");
          message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
        }
        if (object.t0PreCalInterestOnT2 != null)
          message.t0PreCalInterestOnT2 = Number(object.t0PreCalInterestOnT2);
        if (object.t1PreCalInterestOnT2 != null)
          message.t1PreCalInterestOnT2 = Number(object.t1PreCalInterestOnT2);
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.souredPrincipal != null)
          message.souredPrincipal = Number(object.souredPrincipal);
        if (object.souredInterest != null)
          message.souredInterest = Number(object.souredInterest);
        if (object.loanPolicyId != null)
          message.loanPolicyId = object.loanPolicyId | 0;
        if (object.loanPolicy != null) {
          if (typeof object.loanPolicy !== "object")
            throw TypeError(".dnse.fo.LoanV2.loanPolicy: object expected");
          message.loanPolicy = $root.dnse.fo.LoanPolicy.fromObject(object.loanPolicy);
        }
        if (object.coSponsorId != null)
          message.coSponsorId = String(object.coSponsorId);
        if (object.externalLoanId != null)
          message.externalLoanId = String(object.externalLoanId);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        return message;
      };
      LoanV2.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.type = "";
          object.referenceId = "";
          object.loanPackageId = 0;
          object.loanPackage = null;
          object.description = "";
          object.tradingDate = "";
          object.status = "";
          object.disbursementDate = null;
          object.dueDate = null;
          object.originalPrincipal = 0;
          object.paidPrincipal = 0;
          object.paidInterest = 0;
          object.unduePrincipal = 0;
          object.undueInterest = 0;
          object.duePrincipal = 0;
          object.dueInterest = 0;
          object.overduePrincipal = 0;
          object.overdueInterest = 0;
          object.toCollectPrincipal = 0;
          object.toCollectInterest = 0;
          object.interestOnOverdueLoan = 0;
          object.t0UnrealizedPrincipal = 0;
          object.t1UnrealizedPrincipal = 0;
          object.t2UnrealizedPrincipal = 0;
          object.t0UnrealizedInterest = 0;
          object.t1UnrealizedInterest = 0;
          object.t2UnrealizedInterest = 0;
          object.metadata = "";
          object.createdDate = null;
          object.updatedDate = null;
          object.t0PreCalInterestOnT2 = 0;
          object.t1PreCalInterestOnT2 = 0;
          object.investorId = "";
          object.custodyCode = "";
          object.souredPrincipal = 0;
          object.souredInterest = 0;
          object.loanPolicyId = 0;
          object.loanPolicy = null;
          object.coSponsorId = "";
          object.externalLoanId = "";
          object.symbol = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.referenceId != null && message.hasOwnProperty("referenceId"))
          object.referenceId = message.referenceId;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.loanPackage != null && message.hasOwnProperty("loanPackage"))
          object.loanPackage = $root.dnse.fo.LoanPackage.toObject(message.loanPackage, options);
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
          object.tradingDate = message.tradingDate;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = message.status;
        if (message.disbursementDate != null && message.hasOwnProperty("disbursementDate"))
          object.disbursementDate = $root.google.protobuf.Timestamp.toObject(message.disbursementDate, options);
        if (message.dueDate != null && message.hasOwnProperty("dueDate"))
          object.dueDate = $root.google.protobuf.Timestamp.toObject(message.dueDate, options);
        if (message.originalPrincipal != null && message.hasOwnProperty("originalPrincipal"))
          object.originalPrincipal = options.json && !isFinite(message.originalPrincipal) ? String(message.originalPrincipal) : message.originalPrincipal;
        if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal"))
          object.paidPrincipal = options.json && !isFinite(message.paidPrincipal) ? String(message.paidPrincipal) : message.paidPrincipal;
        if (message.paidInterest != null && message.hasOwnProperty("paidInterest"))
          object.paidInterest = options.json && !isFinite(message.paidInterest) ? String(message.paidInterest) : message.paidInterest;
        if (message.unduePrincipal != null && message.hasOwnProperty("unduePrincipal"))
          object.unduePrincipal = options.json && !isFinite(message.unduePrincipal) ? String(message.unduePrincipal) : message.unduePrincipal;
        if (message.undueInterest != null && message.hasOwnProperty("undueInterest"))
          object.undueInterest = options.json && !isFinite(message.undueInterest) ? String(message.undueInterest) : message.undueInterest;
        if (message.duePrincipal != null && message.hasOwnProperty("duePrincipal"))
          object.duePrincipal = options.json && !isFinite(message.duePrincipal) ? String(message.duePrincipal) : message.duePrincipal;
        if (message.dueInterest != null && message.hasOwnProperty("dueInterest"))
          object.dueInterest = options.json && !isFinite(message.dueInterest) ? String(message.dueInterest) : message.dueInterest;
        if (message.overduePrincipal != null && message.hasOwnProperty("overduePrincipal"))
          object.overduePrincipal = options.json && !isFinite(message.overduePrincipal) ? String(message.overduePrincipal) : message.overduePrincipal;
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest"))
          object.overdueInterest = options.json && !isFinite(message.overdueInterest) ? String(message.overdueInterest) : message.overdueInterest;
        if (message.toCollectPrincipal != null && message.hasOwnProperty("toCollectPrincipal"))
          object.toCollectPrincipal = options.json && !isFinite(message.toCollectPrincipal) ? String(message.toCollectPrincipal) : message.toCollectPrincipal;
        if (message.toCollectInterest != null && message.hasOwnProperty("toCollectInterest"))
          object.toCollectInterest = options.json && !isFinite(message.toCollectInterest) ? String(message.toCollectInterest) : message.toCollectInterest;
        if (message.interestOnOverdueLoan != null && message.hasOwnProperty("interestOnOverdueLoan"))
          object.interestOnOverdueLoan = options.json && !isFinite(message.interestOnOverdueLoan) ? String(message.interestOnOverdueLoan) : message.interestOnOverdueLoan;
        if (message.t0UnrealizedPrincipal != null && message.hasOwnProperty("t0UnrealizedPrincipal"))
          object.t0UnrealizedPrincipal = options.json && !isFinite(message.t0UnrealizedPrincipal) ? String(message.t0UnrealizedPrincipal) : message.t0UnrealizedPrincipal;
        if (message.t1UnrealizedPrincipal != null && message.hasOwnProperty("t1UnrealizedPrincipal"))
          object.t1UnrealizedPrincipal = options.json && !isFinite(message.t1UnrealizedPrincipal) ? String(message.t1UnrealizedPrincipal) : message.t1UnrealizedPrincipal;
        if (message.t2UnrealizedPrincipal != null && message.hasOwnProperty("t2UnrealizedPrincipal"))
          object.t2UnrealizedPrincipal = options.json && !isFinite(message.t2UnrealizedPrincipal) ? String(message.t2UnrealizedPrincipal) : message.t2UnrealizedPrincipal;
        if (message.t0UnrealizedInterest != null && message.hasOwnProperty("t0UnrealizedInterest"))
          object.t0UnrealizedInterest = options.json && !isFinite(message.t0UnrealizedInterest) ? String(message.t0UnrealizedInterest) : message.t0UnrealizedInterest;
        if (message.t1UnrealizedInterest != null && message.hasOwnProperty("t1UnrealizedInterest"))
          object.t1UnrealizedInterest = options.json && !isFinite(message.t1UnrealizedInterest) ? String(message.t1UnrealizedInterest) : message.t1UnrealizedInterest;
        if (message.t2UnrealizedInterest != null && message.hasOwnProperty("t2UnrealizedInterest"))
          object.t2UnrealizedInterest = options.json && !isFinite(message.t2UnrealizedInterest) ? String(message.t2UnrealizedInterest) : message.t2UnrealizedInterest;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = message.metadata;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
          object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
        if (message.t0PreCalInterestOnT2 != null && message.hasOwnProperty("t0PreCalInterestOnT2"))
          object.t0PreCalInterestOnT2 = options.json && !isFinite(message.t0PreCalInterestOnT2) ? String(message.t0PreCalInterestOnT2) : message.t0PreCalInterestOnT2;
        if (message.t1PreCalInterestOnT2 != null && message.hasOwnProperty("t1PreCalInterestOnT2"))
          object.t1PreCalInterestOnT2 = options.json && !isFinite(message.t1PreCalInterestOnT2) ? String(message.t1PreCalInterestOnT2) : message.t1PreCalInterestOnT2;
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.souredPrincipal != null && message.hasOwnProperty("souredPrincipal"))
          object.souredPrincipal = options.json && !isFinite(message.souredPrincipal) ? String(message.souredPrincipal) : message.souredPrincipal;
        if (message.souredInterest != null && message.hasOwnProperty("souredInterest"))
          object.souredInterest = options.json && !isFinite(message.souredInterest) ? String(message.souredInterest) : message.souredInterest;
        if (message.loanPolicyId != null && message.hasOwnProperty("loanPolicyId"))
          object.loanPolicyId = message.loanPolicyId;
        if (message.loanPolicy != null && message.hasOwnProperty("loanPolicy"))
          object.loanPolicy = $root.dnse.fo.LoanPolicy.toObject(message.loanPolicy, options);
        if (message.coSponsorId != null && message.hasOwnProperty("coSponsorId"))
          object.coSponsorId = message.coSponsorId;
        if (message.externalLoanId != null && message.hasOwnProperty("externalLoanId"))
          object.externalLoanId = message.externalLoanId;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        return object;
      };
      LoanV2.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanV2;
    }();
    fo.LoanV2Event = function() {
      function LoanV2Event(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanV2Event.prototype.loan = null;
      LoanV2Event.prototype.type = 0;
      LoanV2Event.prototype.metadata = "";
      LoanV2Event.prototype.prepay = null;
      let $oneOfFields;
      Object.defineProperty(LoanV2Event.prototype, "detail", {
        get: $util.oneOfGetter($oneOfFields = ["prepay"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      LoanV2Event.create = function create(properties) {
        return new LoanV2Event(properties);
      };
      LoanV2Event.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.loan != null && Object.hasOwnProperty.call(message, "loan"))
          $root.dnse.fo.LoanV2.encode(message.loan, writer.uint32(10).fork()).ldelim();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(16).int32(message.type);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          writer.uint32(26).string(message.metadata);
        if (message.prepay != null && Object.hasOwnProperty.call(message, "prepay"))
          $root.dnse.fo.LoanV2PrepayDetail.encode(message.prepay, writer.uint32(34).fork()).ldelim();
        return writer;
      };
      LoanV2Event.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanV2Event.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanV2Event();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.loan = $root.dnse.fo.LoanV2.decode(reader, reader.uint32());
              break;
            case 2:
              message.type = reader.int32();
              break;
            case 3:
              message.metadata = reader.string();
              break;
            case 4:
              message.prepay = $root.dnse.fo.LoanV2PrepayDetail.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanV2Event.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanV2Event.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.loan != null && message.hasOwnProperty("loan")) {
          let error = $root.dnse.fo.LoanV2.verify(message.loan);
          if (error)
            return "loan." + error;
        }
        if (message.type != null && message.hasOwnProperty("type"))
          switch (message.type) {
            default:
              return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
              break;
          }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          if (!$util.isString(message.metadata))
            return "metadata: string expected";
        }
        if (message.prepay != null && message.hasOwnProperty("prepay")) {
          {
            let error = $root.dnse.fo.LoanV2PrepayDetail.verify(message.prepay);
            if (error)
              return "prepay." + error;
          }
        }
        return null;
      };
      LoanV2Event.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanV2Event)
          return object;
        let message = new $root.dnse.fo.LoanV2Event();
        if (object.loan != null) {
          if (typeof object.loan !== "object")
            throw TypeError(".dnse.fo.LoanV2Event.loan: object expected");
          message.loan = $root.dnse.fo.LoanV2.fromObject(object.loan);
        }
        switch (object.type) {
          case "CREATE":
          case 0:
            message.type = 0;
            break;
          case "DISBURSED":
          case 1:
            message.type = 1;
            break;
          case "PREPAY_ON_SELL":
          case 2:
            message.type = 2;
            break;
          case "PREPAY_BY_CASH":
          case 3:
            message.type = 3;
            break;
          case "UPDATE":
          case 4:
            message.type = 4;
            break;
          case "PAID":
          case 5:
            message.type = 5;
            break;
          case "EXTEND":
          case 6:
            message.type = 6;
            break;
          case "COLLECT_DEBT":
          case 7:
            message.type = 7;
            break;
          case "BATCH":
          case 8:
            message.type = 8;
            break;
          case "UPDATE_MANUAL":
          case 9:
            message.type = 9;
            break;
        }
        if (object.metadata != null)
          message.metadata = String(object.metadata);
        if (object.prepay != null) {
          if (typeof object.prepay !== "object")
            throw TypeError(".dnse.fo.LoanV2Event.prepay: object expected");
          message.prepay = $root.dnse.fo.LoanV2PrepayDetail.fromObject(object.prepay);
        }
        return message;
      };
      LoanV2Event.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.loan = null;
          object.type = options.enums === String ? "CREATE" : 0;
          object.metadata = "";
        }
        if (message.loan != null && message.hasOwnProperty("loan"))
          object.loan = $root.dnse.fo.LoanV2.toObject(message.loan, options);
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = options.enums === String ? $root.dnse.fo.LoanV2Event.Type[message.type] : message.type;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = message.metadata;
        if (message.prepay != null && message.hasOwnProperty("prepay")) {
          object.prepay = $root.dnse.fo.LoanV2PrepayDetail.toObject(message.prepay, options);
          if (options.oneofs)
            object.detail = "prepay";
        }
        return object;
      };
      LoanV2Event.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      LoanV2Event.Type = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CREATE"] = 0;
        values[valuesById[1] = "DISBURSED"] = 1;
        values[valuesById[2] = "PREPAY_ON_SELL"] = 2;
        values[valuesById[3] = "PREPAY_BY_CASH"] = 3;
        values[valuesById[4] = "UPDATE"] = 4;
        values[valuesById[5] = "PAID"] = 5;
        values[valuesById[6] = "EXTEND"] = 6;
        values[valuesById[7] = "COLLECT_DEBT"] = 7;
        values[valuesById[8] = "BATCH"] = 8;
        values[valuesById[9] = "UPDATE_MANUAL"] = 9;
        return values;
      }();
      return LoanV2Event;
    }();
    fo.LoanV2PrepayDetail = function() {
      function LoanV2PrepayDetail(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanV2PrepayDetail.prototype.paidPrincipal = 0;
      LoanV2PrepayDetail.prototype.paidInterest = 0;
      LoanV2PrepayDetail.prototype.paidUnrealizedPrincipal = 0;
      LoanV2PrepayDetail.prototype.paidUnrealizedInterest = 0;
      LoanV2PrepayDetail.create = function create(properties) {
        return new LoanV2PrepayDetail(properties);
      };
      LoanV2PrepayDetail.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.paidPrincipal != null && Object.hasOwnProperty.call(message, "paidPrincipal"))
          writer.uint32(9).double(message.paidPrincipal);
        if (message.paidInterest != null && Object.hasOwnProperty.call(message, "paidInterest"))
          writer.uint32(17).double(message.paidInterest);
        if (message.paidUnrealizedPrincipal != null && Object.hasOwnProperty.call(message, "paidUnrealizedPrincipal"))
          writer.uint32(25).double(message.paidUnrealizedPrincipal);
        if (message.paidUnrealizedInterest != null && Object.hasOwnProperty.call(message, "paidUnrealizedInterest"))
          writer.uint32(33).double(message.paidUnrealizedInterest);
        return writer;
      };
      LoanV2PrepayDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanV2PrepayDetail.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanV2PrepayDetail();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.paidPrincipal = reader.double();
              break;
            case 2:
              message.paidInterest = reader.double();
              break;
            case 3:
              message.paidUnrealizedPrincipal = reader.double();
              break;
            case 4:
              message.paidUnrealizedInterest = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanV2PrepayDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanV2PrepayDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal")) {
          if (typeof message.paidPrincipal !== "number")
            return "paidPrincipal: number expected";
        }
        if (message.paidInterest != null && message.hasOwnProperty("paidInterest")) {
          if (typeof message.paidInterest !== "number")
            return "paidInterest: number expected";
        }
        if (message.paidUnrealizedPrincipal != null && message.hasOwnProperty("paidUnrealizedPrincipal")) {
          if (typeof message.paidUnrealizedPrincipal !== "number")
            return "paidUnrealizedPrincipal: number expected";
        }
        if (message.paidUnrealizedInterest != null && message.hasOwnProperty("paidUnrealizedInterest")) {
          if (typeof message.paidUnrealizedInterest !== "number")
            return "paidUnrealizedInterest: number expected";
        }
        return null;
      };
      LoanV2PrepayDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanV2PrepayDetail)
          return object;
        let message = new $root.dnse.fo.LoanV2PrepayDetail();
        if (object.paidPrincipal != null)
          message.paidPrincipal = Number(object.paidPrincipal);
        if (object.paidInterest != null)
          message.paidInterest = Number(object.paidInterest);
        if (object.paidUnrealizedPrincipal != null)
          message.paidUnrealizedPrincipal = Number(object.paidUnrealizedPrincipal);
        if (object.paidUnrealizedInterest != null)
          message.paidUnrealizedInterest = Number(object.paidUnrealizedInterest);
        return message;
      };
      LoanV2PrepayDetail.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.paidPrincipal = 0;
          object.paidInterest = 0;
          object.paidUnrealizedPrincipal = 0;
          object.paidUnrealizedInterest = 0;
        }
        if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal"))
          object.paidPrincipal = options.json && !isFinite(message.paidPrincipal) ? String(message.paidPrincipal) : message.paidPrincipal;
        if (message.paidInterest != null && message.hasOwnProperty("paidInterest"))
          object.paidInterest = options.json && !isFinite(message.paidInterest) ? String(message.paidInterest) : message.paidInterest;
        if (message.paidUnrealizedPrincipal != null && message.hasOwnProperty("paidUnrealizedPrincipal"))
          object.paidUnrealizedPrincipal = options.json && !isFinite(message.paidUnrealizedPrincipal) ? String(message.paidUnrealizedPrincipal) : message.paidUnrealizedPrincipal;
        if (message.paidUnrealizedInterest != null && message.hasOwnProperty("paidUnrealizedInterest"))
          object.paidUnrealizedInterest = options.json && !isFinite(message.paidUnrealizedInterest) ? String(message.paidUnrealizedInterest) : message.paidUnrealizedInterest;
        return object;
      };
      LoanV2PrepayDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanV2PrepayDetail;
    }();
    fo.DealCorporateActionEvent = function() {
      function DealCorporateActionEvent(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DealCorporateActionEvent.prototype.investorId = "";
      DealCorporateActionEvent.prototype.accountTypeName = "";
      DealCorporateActionEvent.prototype.accountNo = "";
      DealCorporateActionEvent.prototype.action = 0;
      DealCorporateActionEvent.prototype.deal = null;
      DealCorporateActionEvent.prototype.initialRate = 0;
      DealCorporateActionEvent.prototype.loanPackageId = 0;
      DealCorporateActionEvent.prototype.corporateAction = null;
      DealCorporateActionEvent.prototype.createdDate = null;
      DealCorporateActionEvent.prototype.loanPackageName = "";
      DealCorporateActionEvent.create = function create(properties) {
        return new DealCorporateActionEvent(properties);
      };
      DealCorporateActionEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(10).string(message.investorId);
        if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
          writer.uint32(18).string(message.accountTypeName);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(26).string(message.accountNo);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(32).int32(message.action);
        if (message.deal != null && Object.hasOwnProperty.call(message, "deal"))
          $root.dnse.fo.Deal.encode(message.deal, writer.uint32(42).fork()).ldelim();
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(49).double(message.initialRate);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(56).int32(message.loanPackageId);
        if (message.corporateAction != null && Object.hasOwnProperty.call(message, "corporateAction"))
          $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.encode(message.corporateAction, writer.uint32(66).fork()).ldelim();
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
        if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
          writer.uint32(82).string(message.loanPackageName);
        return writer;
      };
      DealCorporateActionEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DealCorporateActionEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DealCorporateActionEvent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.investorId = reader.string();
              break;
            case 2:
              message.accountTypeName = reader.string();
              break;
            case 3:
              message.accountNo = reader.string();
              break;
            case 4:
              message.action = reader.int32();
              break;
            case 5:
              message.deal = $root.dnse.fo.Deal.decode(reader, reader.uint32());
              break;
            case 6:
              message.initialRate = reader.double();
              break;
            case 7:
              message.loanPackageId = reader.int32();
              break;
            case 8:
              message.corporateAction = $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.decode(reader, reader.uint32());
              break;
            case 9:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 10:
              message.loanPackageName = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DealCorporateActionEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DealCorporateActionEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
          if (!$util.isString(message.accountTypeName))
            return "accountTypeName: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.deal != null && message.hasOwnProperty("deal")) {
          let error = $root.dnse.fo.Deal.verify(message.deal);
          if (error)
            return "deal." + error;
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.corporateAction != null && message.hasOwnProperty("corporateAction")) {
          let error = $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.verify(message.corporateAction);
          if (error)
            return "corporateAction." + error;
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
          if (!$util.isString(message.loanPackageName))
            return "loanPackageName: string expected";
        }
        return null;
      };
      DealCorporateActionEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DealCorporateActionEvent)
          return object;
        let message = new $root.dnse.fo.DealCorporateActionEvent();
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.accountTypeName != null)
          message.accountTypeName = String(object.accountTypeName);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        switch (object.action) {
          case "DIVIDEND_STOCK":
          case 0:
            message.action = 0;
            break;
          case "DIVIDEND_CASH":
          case 1:
            message.action = 1;
            break;
          case "BONUS_STOCK":
          case 2:
            message.action = 2;
            break;
          case "RIGHT":
          case 3:
            message.action = 3;
            break;
        }
        if (object.deal != null) {
          if (typeof object.deal !== "object")
            throw TypeError(".dnse.fo.DealCorporateActionEvent.deal: object expected");
          message.deal = $root.dnse.fo.Deal.fromObject(object.deal);
        }
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.corporateAction != null) {
          if (typeof object.corporateAction !== "object")
            throw TypeError(".dnse.fo.DealCorporateActionEvent.corporateAction: object expected");
          message.corporateAction = $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.fromObject(object.corporateAction);
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DealCorporateActionEvent.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.loanPackageName != null)
          message.loanPackageName = String(object.loanPackageName);
        return message;
      };
      DealCorporateActionEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.investorId = "";
          object.accountTypeName = "";
          object.accountNo = "";
          object.action = options.enums === String ? "DIVIDEND_STOCK" : 0;
          object.deal = null;
          object.initialRate = 0;
          object.loanPackageId = 0;
          object.corporateAction = null;
          object.createdDate = null;
          object.loanPackageName = "";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
          object.accountTypeName = message.accountTypeName;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.DealCorporateActionEvent.Action[message.action] : message.action;
        if (message.deal != null && message.hasOwnProperty("deal"))
          object.deal = $root.dnse.fo.Deal.toObject(message.deal, options);
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.corporateAction != null && message.hasOwnProperty("corporateAction"))
          object.corporateAction = $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.toObject(message.corporateAction, options);
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
          object.loanPackageName = message.loanPackageName;
        return object;
      };
      DealCorporateActionEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DealCorporateActionEvent.Action = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DIVIDEND_STOCK"] = 0;
        values[valuesById[1] = "DIVIDEND_CASH"] = 1;
        values[valuesById[2] = "BONUS_STOCK"] = 2;
        values[valuesById[3] = "RIGHT"] = 3;
        return values;
      }();
      DealCorporateActionEvent.CorporateActionDividendAndRight = function() {
        function CorporateActionDividendAndRight(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CorporateActionDividendAndRight.prototype.symbol = "";
        CorporateActionDividendAndRight.prototype.price = 0;
        CorporateActionDividendAndRight.prototype.priceNew = 0;
        CorporateActionDividendAndRight.prototype.priceAlpha = 0;
        CorporateActionDividendAndRight.prototype.rightRatio = "";
        CorporateActionDividendAndRight.prototype.dividendStockRatio = "";
        CorporateActionDividendAndRight.prototype.bonusStockRatio = "";
        CorporateActionDividendAndRight.prototype.dividendCash = 0;
        CorporateActionDividendAndRight.prototype.exDividendDate = null;
        CorporateActionDividendAndRight.prototype.timestamp = null;
        CorporateActionDividendAndRight.prototype.exerciseDate = null;
        CorporateActionDividendAndRight.prototype.estimateReceivingDate = null;
        CorporateActionDividendAndRight.prototype.rightSubscribeStartDate = null;
        CorporateActionDividendAndRight.prototype.rightSubscribeEndDate = null;
        CorporateActionDividendAndRight.prototype.rightOfferingRatio = "";
        CorporateActionDividendAndRight.prototype.rightToPurchaseSharesRatio = "";
        CorporateActionDividendAndRight.create = function create(properties) {
          return new CorporateActionDividendAndRight(properties);
        };
        CorporateActionDividendAndRight.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(10).string(message.symbol);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(17).double(message.price);
          if (message.priceNew != null && Object.hasOwnProperty.call(message, "priceNew"))
            writer.uint32(25).double(message.priceNew);
          if (message.priceAlpha != null && Object.hasOwnProperty.call(message, "priceAlpha"))
            writer.uint32(33).double(message.priceAlpha);
          if (message.rightRatio != null && Object.hasOwnProperty.call(message, "rightRatio"))
            writer.uint32(42).string(message.rightRatio);
          if (message.dividendStockRatio != null && Object.hasOwnProperty.call(message, "dividendStockRatio"))
            writer.uint32(50).string(message.dividendStockRatio);
          if (message.bonusStockRatio != null && Object.hasOwnProperty.call(message, "bonusStockRatio"))
            writer.uint32(58).string(message.bonusStockRatio);
          if (message.dividendCash != null && Object.hasOwnProperty.call(message, "dividendCash"))
            writer.uint32(65).double(message.dividendCash);
          if (message.exDividendDate != null && Object.hasOwnProperty.call(message, "exDividendDate"))
            $root.google.protobuf.Timestamp.encode(message.exDividendDate, writer.uint32(74).fork()).ldelim();
          if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(82).fork()).ldelim();
          if (message.exerciseDate != null && Object.hasOwnProperty.call(message, "exerciseDate"))
            $root.google.protobuf.Timestamp.encode(message.exerciseDate, writer.uint32(90).fork()).ldelim();
          if (message.estimateReceivingDate != null && Object.hasOwnProperty.call(message, "estimateReceivingDate"))
            $root.google.protobuf.Timestamp.encode(message.estimateReceivingDate, writer.uint32(98).fork()).ldelim();
          if (message.rightSubscribeStartDate != null && Object.hasOwnProperty.call(message, "rightSubscribeStartDate"))
            $root.google.protobuf.Timestamp.encode(message.rightSubscribeStartDate, writer.uint32(106).fork()).ldelim();
          if (message.rightSubscribeEndDate != null && Object.hasOwnProperty.call(message, "rightSubscribeEndDate"))
            $root.google.protobuf.Timestamp.encode(message.rightSubscribeEndDate, writer.uint32(114).fork()).ldelim();
          if (message.rightOfferingRatio != null && Object.hasOwnProperty.call(message, "rightOfferingRatio"))
            writer.uint32(122).string(message.rightOfferingRatio);
          if (message.rightToPurchaseSharesRatio != null && Object.hasOwnProperty.call(message, "rightToPurchaseSharesRatio"))
            writer.uint32(130).string(message.rightToPurchaseSharesRatio);
          return writer;
        };
        CorporateActionDividendAndRight.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CorporateActionDividendAndRight.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.symbol = reader.string();
                break;
              case 2:
                message.price = reader.double();
                break;
              case 3:
                message.priceNew = reader.double();
                break;
              case 4:
                message.priceAlpha = reader.double();
                break;
              case 5:
                message.rightRatio = reader.string();
                break;
              case 6:
                message.dividendStockRatio = reader.string();
                break;
              case 7:
                message.bonusStockRatio = reader.string();
                break;
              case 8:
                message.dividendCash = reader.double();
                break;
              case 9:
                message.exDividendDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 10:
                message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 11:
                message.exerciseDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 12:
                message.estimateReceivingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 13:
                message.rightSubscribeStartDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 14:
                message.rightSubscribeEndDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 15:
                message.rightOfferingRatio = reader.string();
                break;
              case 16:
                message.rightToPurchaseSharesRatio = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CorporateActionDividendAndRight.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CorporateActionDividendAndRight.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.priceNew != null && message.hasOwnProperty("priceNew")) {
            if (typeof message.priceNew !== "number")
              return "priceNew: number expected";
          }
          if (message.priceAlpha != null && message.hasOwnProperty("priceAlpha")) {
            if (typeof message.priceAlpha !== "number")
              return "priceAlpha: number expected";
          }
          if (message.rightRatio != null && message.hasOwnProperty("rightRatio")) {
            if (!$util.isString(message.rightRatio))
              return "rightRatio: string expected";
          }
          if (message.dividendStockRatio != null && message.hasOwnProperty("dividendStockRatio")) {
            if (!$util.isString(message.dividendStockRatio))
              return "dividendStockRatio: string expected";
          }
          if (message.bonusStockRatio != null && message.hasOwnProperty("bonusStockRatio")) {
            if (!$util.isString(message.bonusStockRatio))
              return "bonusStockRatio: string expected";
          }
          if (message.dividendCash != null && message.hasOwnProperty("dividendCash")) {
            if (typeof message.dividendCash !== "number")
              return "dividendCash: number expected";
          }
          if (message.exDividendDate != null && message.hasOwnProperty("exDividendDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.exDividendDate);
            if (error)
              return "exDividendDate." + error;
          }
          if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
            let error = $root.google.protobuf.Timestamp.verify(message.timestamp);
            if (error)
              return "timestamp." + error;
          }
          if (message.exerciseDate != null && message.hasOwnProperty("exerciseDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.exerciseDate);
            if (error)
              return "exerciseDate." + error;
          }
          if (message.estimateReceivingDate != null && message.hasOwnProperty("estimateReceivingDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.estimateReceivingDate);
            if (error)
              return "estimateReceivingDate." + error;
          }
          if (message.rightSubscribeStartDate != null && message.hasOwnProperty("rightSubscribeStartDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.rightSubscribeStartDate);
            if (error)
              return "rightSubscribeStartDate." + error;
          }
          if (message.rightSubscribeEndDate != null && message.hasOwnProperty("rightSubscribeEndDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.rightSubscribeEndDate);
            if (error)
              return "rightSubscribeEndDate." + error;
          }
          if (message.rightOfferingRatio != null && message.hasOwnProperty("rightOfferingRatio")) {
            if (!$util.isString(message.rightOfferingRatio))
              return "rightOfferingRatio: string expected";
          }
          if (message.rightToPurchaseSharesRatio != null && message.hasOwnProperty("rightToPurchaseSharesRatio")) {
            if (!$util.isString(message.rightToPurchaseSharesRatio))
              return "rightToPurchaseSharesRatio: string expected";
          }
          return null;
        };
        CorporateActionDividendAndRight.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight)
            return object;
          let message = new $root.dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight();
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.price != null)
            message.price = Number(object.price);
          if (object.priceNew != null)
            message.priceNew = Number(object.priceNew);
          if (object.priceAlpha != null)
            message.priceAlpha = Number(object.priceAlpha);
          if (object.rightRatio != null)
            message.rightRatio = String(object.rightRatio);
          if (object.dividendStockRatio != null)
            message.dividendStockRatio = String(object.dividendStockRatio);
          if (object.bonusStockRatio != null)
            message.bonusStockRatio = String(object.bonusStockRatio);
          if (object.dividendCash != null)
            message.dividendCash = Number(object.dividendCash);
          if (object.exDividendDate != null) {
            if (typeof object.exDividendDate !== "object")
              throw TypeError(".dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.exDividendDate: object expected");
            message.exDividendDate = $root.google.protobuf.Timestamp.fromObject(object.exDividendDate);
          }
          if (object.timestamp != null) {
            if (typeof object.timestamp !== "object")
              throw TypeError(".dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.timestamp: object expected");
            message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
          }
          if (object.exerciseDate != null) {
            if (typeof object.exerciseDate !== "object")
              throw TypeError(".dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.exerciseDate: object expected");
            message.exerciseDate = $root.google.protobuf.Timestamp.fromObject(object.exerciseDate);
          }
          if (object.estimateReceivingDate != null) {
            if (typeof object.estimateReceivingDate !== "object")
              throw TypeError(".dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.estimateReceivingDate: object expected");
            message.estimateReceivingDate = $root.google.protobuf.Timestamp.fromObject(object.estimateReceivingDate);
          }
          if (object.rightSubscribeStartDate != null) {
            if (typeof object.rightSubscribeStartDate !== "object")
              throw TypeError(".dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.rightSubscribeStartDate: object expected");
            message.rightSubscribeStartDate = $root.google.protobuf.Timestamp.fromObject(object.rightSubscribeStartDate);
          }
          if (object.rightSubscribeEndDate != null) {
            if (typeof object.rightSubscribeEndDate !== "object")
              throw TypeError(".dnse.fo.DealCorporateActionEvent.CorporateActionDividendAndRight.rightSubscribeEndDate: object expected");
            message.rightSubscribeEndDate = $root.google.protobuf.Timestamp.fromObject(object.rightSubscribeEndDate);
          }
          if (object.rightOfferingRatio != null)
            message.rightOfferingRatio = String(object.rightOfferingRatio);
          if (object.rightToPurchaseSharesRatio != null)
            message.rightToPurchaseSharesRatio = String(object.rightToPurchaseSharesRatio);
          return message;
        };
        CorporateActionDividendAndRight.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.symbol = "";
            object.price = 0;
            object.priceNew = 0;
            object.priceAlpha = 0;
            object.rightRatio = "";
            object.dividendStockRatio = "";
            object.bonusStockRatio = "";
            object.dividendCash = 0;
            object.exDividendDate = null;
            object.timestamp = null;
            object.exerciseDate = null;
            object.estimateReceivingDate = null;
            object.rightSubscribeStartDate = null;
            object.rightSubscribeEndDate = null;
            object.rightOfferingRatio = "";
            object.rightToPurchaseSharesRatio = "";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.priceNew != null && message.hasOwnProperty("priceNew"))
            object.priceNew = options.json && !isFinite(message.priceNew) ? String(message.priceNew) : message.priceNew;
          if (message.priceAlpha != null && message.hasOwnProperty("priceAlpha"))
            object.priceAlpha = options.json && !isFinite(message.priceAlpha) ? String(message.priceAlpha) : message.priceAlpha;
          if (message.rightRatio != null && message.hasOwnProperty("rightRatio"))
            object.rightRatio = message.rightRatio;
          if (message.dividendStockRatio != null && message.hasOwnProperty("dividendStockRatio"))
            object.dividendStockRatio = message.dividendStockRatio;
          if (message.bonusStockRatio != null && message.hasOwnProperty("bonusStockRatio"))
            object.bonusStockRatio = message.bonusStockRatio;
          if (message.dividendCash != null && message.hasOwnProperty("dividendCash"))
            object.dividendCash = options.json && !isFinite(message.dividendCash) ? String(message.dividendCash) : message.dividendCash;
          if (message.exDividendDate != null && message.hasOwnProperty("exDividendDate"))
            object.exDividendDate = $root.google.protobuf.Timestamp.toObject(message.exDividendDate, options);
          if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
          if (message.exerciseDate != null && message.hasOwnProperty("exerciseDate"))
            object.exerciseDate = $root.google.protobuf.Timestamp.toObject(message.exerciseDate, options);
          if (message.estimateReceivingDate != null && message.hasOwnProperty("estimateReceivingDate"))
            object.estimateReceivingDate = $root.google.protobuf.Timestamp.toObject(message.estimateReceivingDate, options);
          if (message.rightSubscribeStartDate != null && message.hasOwnProperty("rightSubscribeStartDate"))
            object.rightSubscribeStartDate = $root.google.protobuf.Timestamp.toObject(message.rightSubscribeStartDate, options);
          if (message.rightSubscribeEndDate != null && message.hasOwnProperty("rightSubscribeEndDate"))
            object.rightSubscribeEndDate = $root.google.protobuf.Timestamp.toObject(message.rightSubscribeEndDate, options);
          if (message.rightOfferingRatio != null && message.hasOwnProperty("rightOfferingRatio"))
            object.rightOfferingRatio = message.rightOfferingRatio;
          if (message.rightToPurchaseSharesRatio != null && message.hasOwnProperty("rightToPurchaseSharesRatio"))
            object.rightToPurchaseSharesRatio = message.rightToPurchaseSharesRatio;
          return object;
        };
        CorporateActionDividendAndRight.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CorporateActionDividendAndRight;
      }();
      return DealCorporateActionEvent;
    }();
    fo.AccountCorporateActionEvent = function() {
      function AccountCorporateActionEvent(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      AccountCorporateActionEvent.prototype.investorId = "";
      AccountCorporateActionEvent.prototype.accountTypeName = "";
      AccountCorporateActionEvent.prototype.accountNo = "";
      AccountCorporateActionEvent.prototype.action = 0;
      AccountCorporateActionEvent.prototype.corporateAction = null;
      AccountCorporateActionEvent.prototype.createdDate = null;
      AccountCorporateActionEvent.create = function create(properties) {
        return new AccountCorporateActionEvent(properties);
      };
      AccountCorporateActionEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(10).string(message.investorId);
        if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
          writer.uint32(18).string(message.accountTypeName);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(26).string(message.accountNo);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(32).int32(message.action);
        if (message.corporateAction != null && Object.hasOwnProperty.call(message, "corporateAction"))
          $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.encode(message.corporateAction, writer.uint32(66).fork()).ldelim();
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
        return writer;
      };
      AccountCorporateActionEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      AccountCorporateActionEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.AccountCorporateActionEvent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.investorId = reader.string();
              break;
            case 2:
              message.accountTypeName = reader.string();
              break;
            case 3:
              message.accountNo = reader.string();
              break;
            case 4:
              message.action = reader.int32();
              break;
            case 8:
              message.corporateAction = $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.decode(reader, reader.uint32());
              break;
            case 9:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      AccountCorporateActionEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      AccountCorporateActionEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
          if (!$util.isString(message.accountTypeName))
            return "accountTypeName: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.corporateAction != null && message.hasOwnProperty("corporateAction")) {
          let error = $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.verify(message.corporateAction);
          if (error)
            return "corporateAction." + error;
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        return null;
      };
      AccountCorporateActionEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.AccountCorporateActionEvent)
          return object;
        let message = new $root.dnse.fo.AccountCorporateActionEvent();
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.accountTypeName != null)
          message.accountTypeName = String(object.accountTypeName);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        switch (object.action) {
          case "DIVIDEND_STOCK":
          case 0:
            message.action = 0;
            break;
          case "DIVIDEND_CASH":
          case 1:
            message.action = 1;
            break;
          case "BONUS_STOCK":
          case 2:
            message.action = 2;
            break;
          case "RIGHT":
          case 3:
            message.action = 3;
            break;
        }
        if (object.corporateAction != null) {
          if (typeof object.corporateAction !== "object")
            throw TypeError(".dnse.fo.AccountCorporateActionEvent.corporateAction: object expected");
          message.corporateAction = $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.fromObject(object.corporateAction);
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.AccountCorporateActionEvent.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        return message;
      };
      AccountCorporateActionEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.investorId = "";
          object.accountTypeName = "";
          object.accountNo = "";
          object.action = options.enums === String ? "DIVIDEND_STOCK" : 0;
          object.corporateAction = null;
          object.createdDate = null;
        }
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
          object.accountTypeName = message.accountTypeName;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.AccountCorporateActionEvent.Action[message.action] : message.action;
        if (message.corporateAction != null && message.hasOwnProperty("corporateAction"))
          object.corporateAction = $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.toObject(message.corporateAction, options);
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        return object;
      };
      AccountCorporateActionEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      AccountCorporateActionEvent.Action = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DIVIDEND_STOCK"] = 0;
        values[valuesById[1] = "DIVIDEND_CASH"] = 1;
        values[valuesById[2] = "BONUS_STOCK"] = 2;
        values[valuesById[3] = "RIGHT"] = 3;
        return values;
      }();
      AccountCorporateActionEvent.CorporateActionDividendAndRight = function() {
        function CorporateActionDividendAndRight(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CorporateActionDividendAndRight.prototype.symbol = "";
        CorporateActionDividendAndRight.prototype.price = 0;
        CorporateActionDividendAndRight.prototype.priceNew = 0;
        CorporateActionDividendAndRight.prototype.priceAlpha = 0;
        CorporateActionDividendAndRight.prototype.rightRatio = "";
        CorporateActionDividendAndRight.prototype.dividendStockRatio = "";
        CorporateActionDividendAndRight.prototype.bonusStockRatio = "";
        CorporateActionDividendAndRight.prototype.dividendCash = 0;
        CorporateActionDividendAndRight.prototype.exDividendDate = null;
        CorporateActionDividendAndRight.prototype.timestamp = null;
        CorporateActionDividendAndRight.prototype.exerciseDate = null;
        CorporateActionDividendAndRight.prototype.estimateReceivingDate = null;
        CorporateActionDividendAndRight.prototype.rightSubscribeStartDate = null;
        CorporateActionDividendAndRight.prototype.rightSubscribeEndDate = null;
        CorporateActionDividendAndRight.prototype.rightOfferingRatio = "";
        CorporateActionDividendAndRight.prototype.rightToPurchaseSharesRatio = "";
        CorporateActionDividendAndRight.prototype.openQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CorporateActionDividendAndRight.prototype.dividendReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CorporateActionDividendAndRight.prototype.stockBonusReceivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CorporateActionDividendAndRight.prototype.cashReceiving = 0;
        CorporateActionDividendAndRight.prototype.maxRightQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CorporateActionDividendAndRight.create = function create(properties) {
          return new CorporateActionDividendAndRight(properties);
        };
        CorporateActionDividendAndRight.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(10).string(message.symbol);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(17).double(message.price);
          if (message.priceNew != null && Object.hasOwnProperty.call(message, "priceNew"))
            writer.uint32(25).double(message.priceNew);
          if (message.priceAlpha != null && Object.hasOwnProperty.call(message, "priceAlpha"))
            writer.uint32(33).double(message.priceAlpha);
          if (message.rightRatio != null && Object.hasOwnProperty.call(message, "rightRatio"))
            writer.uint32(42).string(message.rightRatio);
          if (message.dividendStockRatio != null && Object.hasOwnProperty.call(message, "dividendStockRatio"))
            writer.uint32(50).string(message.dividendStockRatio);
          if (message.bonusStockRatio != null && Object.hasOwnProperty.call(message, "bonusStockRatio"))
            writer.uint32(58).string(message.bonusStockRatio);
          if (message.dividendCash != null && Object.hasOwnProperty.call(message, "dividendCash"))
            writer.uint32(65).double(message.dividendCash);
          if (message.exDividendDate != null && Object.hasOwnProperty.call(message, "exDividendDate"))
            $root.google.protobuf.Timestamp.encode(message.exDividendDate, writer.uint32(74).fork()).ldelim();
          if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(82).fork()).ldelim();
          if (message.exerciseDate != null && Object.hasOwnProperty.call(message, "exerciseDate"))
            $root.google.protobuf.Timestamp.encode(message.exerciseDate, writer.uint32(90).fork()).ldelim();
          if (message.estimateReceivingDate != null && Object.hasOwnProperty.call(message, "estimateReceivingDate"))
            $root.google.protobuf.Timestamp.encode(message.estimateReceivingDate, writer.uint32(98).fork()).ldelim();
          if (message.rightSubscribeStartDate != null && Object.hasOwnProperty.call(message, "rightSubscribeStartDate"))
            $root.google.protobuf.Timestamp.encode(message.rightSubscribeStartDate, writer.uint32(106).fork()).ldelim();
          if (message.rightSubscribeEndDate != null && Object.hasOwnProperty.call(message, "rightSubscribeEndDate"))
            $root.google.protobuf.Timestamp.encode(message.rightSubscribeEndDate, writer.uint32(114).fork()).ldelim();
          if (message.rightOfferingRatio != null && Object.hasOwnProperty.call(message, "rightOfferingRatio"))
            writer.uint32(122).string(message.rightOfferingRatio);
          if (message.rightToPurchaseSharesRatio != null && Object.hasOwnProperty.call(message, "rightToPurchaseSharesRatio"))
            writer.uint32(130).string(message.rightToPurchaseSharesRatio);
          if (message.openQuantity != null && Object.hasOwnProperty.call(message, "openQuantity"))
            writer.uint32(136).int64(message.openQuantity);
          if (message.dividendReceivingQuantity != null && Object.hasOwnProperty.call(message, "dividendReceivingQuantity"))
            writer.uint32(144).int64(message.dividendReceivingQuantity);
          if (message.stockBonusReceivingQuantity != null && Object.hasOwnProperty.call(message, "stockBonusReceivingQuantity"))
            writer.uint32(152).int64(message.stockBonusReceivingQuantity);
          if (message.cashReceiving != null && Object.hasOwnProperty.call(message, "cashReceiving"))
            writer.uint32(161).double(message.cashReceiving);
          if (message.maxRightQuantity != null && Object.hasOwnProperty.call(message, "maxRightQuantity"))
            writer.uint32(168).int64(message.maxRightQuantity);
          return writer;
        };
        CorporateActionDividendAndRight.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CorporateActionDividendAndRight.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.symbol = reader.string();
                break;
              case 2:
                message.price = reader.double();
                break;
              case 3:
                message.priceNew = reader.double();
                break;
              case 4:
                message.priceAlpha = reader.double();
                break;
              case 5:
                message.rightRatio = reader.string();
                break;
              case 6:
                message.dividendStockRatio = reader.string();
                break;
              case 7:
                message.bonusStockRatio = reader.string();
                break;
              case 8:
                message.dividendCash = reader.double();
                break;
              case 9:
                message.exDividendDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 10:
                message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 11:
                message.exerciseDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 12:
                message.estimateReceivingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 13:
                message.rightSubscribeStartDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 14:
                message.rightSubscribeEndDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 15:
                message.rightOfferingRatio = reader.string();
                break;
              case 16:
                message.rightToPurchaseSharesRatio = reader.string();
                break;
              case 17:
                message.openQuantity = reader.int64();
                break;
              case 18:
                message.dividendReceivingQuantity = reader.int64();
                break;
              case 19:
                message.stockBonusReceivingQuantity = reader.int64();
                break;
              case 20:
                message.cashReceiving = reader.double();
                break;
              case 21:
                message.maxRightQuantity = reader.int64();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CorporateActionDividendAndRight.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CorporateActionDividendAndRight.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.priceNew != null && message.hasOwnProperty("priceNew")) {
            if (typeof message.priceNew !== "number")
              return "priceNew: number expected";
          }
          if (message.priceAlpha != null && message.hasOwnProperty("priceAlpha")) {
            if (typeof message.priceAlpha !== "number")
              return "priceAlpha: number expected";
          }
          if (message.rightRatio != null && message.hasOwnProperty("rightRatio")) {
            if (!$util.isString(message.rightRatio))
              return "rightRatio: string expected";
          }
          if (message.dividendStockRatio != null && message.hasOwnProperty("dividendStockRatio")) {
            if (!$util.isString(message.dividendStockRatio))
              return "dividendStockRatio: string expected";
          }
          if (message.bonusStockRatio != null && message.hasOwnProperty("bonusStockRatio")) {
            if (!$util.isString(message.bonusStockRatio))
              return "bonusStockRatio: string expected";
          }
          if (message.dividendCash != null && message.hasOwnProperty("dividendCash")) {
            if (typeof message.dividendCash !== "number")
              return "dividendCash: number expected";
          }
          if (message.exDividendDate != null && message.hasOwnProperty("exDividendDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.exDividendDate);
            if (error)
              return "exDividendDate." + error;
          }
          if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
            let error = $root.google.protobuf.Timestamp.verify(message.timestamp);
            if (error)
              return "timestamp." + error;
          }
          if (message.exerciseDate != null && message.hasOwnProperty("exerciseDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.exerciseDate);
            if (error)
              return "exerciseDate." + error;
          }
          if (message.estimateReceivingDate != null && message.hasOwnProperty("estimateReceivingDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.estimateReceivingDate);
            if (error)
              return "estimateReceivingDate." + error;
          }
          if (message.rightSubscribeStartDate != null && message.hasOwnProperty("rightSubscribeStartDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.rightSubscribeStartDate);
            if (error)
              return "rightSubscribeStartDate." + error;
          }
          if (message.rightSubscribeEndDate != null && message.hasOwnProperty("rightSubscribeEndDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.rightSubscribeEndDate);
            if (error)
              return "rightSubscribeEndDate." + error;
          }
          if (message.rightOfferingRatio != null && message.hasOwnProperty("rightOfferingRatio")) {
            if (!$util.isString(message.rightOfferingRatio))
              return "rightOfferingRatio: string expected";
          }
          if (message.rightToPurchaseSharesRatio != null && message.hasOwnProperty("rightToPurchaseSharesRatio")) {
            if (!$util.isString(message.rightToPurchaseSharesRatio))
              return "rightToPurchaseSharesRatio: string expected";
          }
          if (message.openQuantity != null && message.hasOwnProperty("openQuantity")) {
            if (!$util.isInteger(message.openQuantity) && !(message.openQuantity && $util.isInteger(message.openQuantity.low) && $util.isInteger(message.openQuantity.high)))
              return "openQuantity: integer|Long expected";
          }
          if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity")) {
            if (!$util.isInteger(message.dividendReceivingQuantity) && !(message.dividendReceivingQuantity && $util.isInteger(message.dividendReceivingQuantity.low) && $util.isInteger(message.dividendReceivingQuantity.high)))
              return "dividendReceivingQuantity: integer|Long expected";
          }
          if (message.stockBonusReceivingQuantity != null && message.hasOwnProperty("stockBonusReceivingQuantity")) {
            if (!$util.isInteger(message.stockBonusReceivingQuantity) && !(message.stockBonusReceivingQuantity && $util.isInteger(message.stockBonusReceivingQuantity.low) && $util.isInteger(message.stockBonusReceivingQuantity.high)))
              return "stockBonusReceivingQuantity: integer|Long expected";
          }
          if (message.cashReceiving != null && message.hasOwnProperty("cashReceiving")) {
            if (typeof message.cashReceiving !== "number")
              return "cashReceiving: number expected";
          }
          if (message.maxRightQuantity != null && message.hasOwnProperty("maxRightQuantity")) {
            if (!$util.isInteger(message.maxRightQuantity) && !(message.maxRightQuantity && $util.isInteger(message.maxRightQuantity.low) && $util.isInteger(message.maxRightQuantity.high)))
              return "maxRightQuantity: integer|Long expected";
          }
          return null;
        };
        CorporateActionDividendAndRight.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight)
            return object;
          let message = new $root.dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight();
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.price != null)
            message.price = Number(object.price);
          if (object.priceNew != null)
            message.priceNew = Number(object.priceNew);
          if (object.priceAlpha != null)
            message.priceAlpha = Number(object.priceAlpha);
          if (object.rightRatio != null)
            message.rightRatio = String(object.rightRatio);
          if (object.dividendStockRatio != null)
            message.dividendStockRatio = String(object.dividendStockRatio);
          if (object.bonusStockRatio != null)
            message.bonusStockRatio = String(object.bonusStockRatio);
          if (object.dividendCash != null)
            message.dividendCash = Number(object.dividendCash);
          if (object.exDividendDate != null) {
            if (typeof object.exDividendDate !== "object")
              throw TypeError(".dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.exDividendDate: object expected");
            message.exDividendDate = $root.google.protobuf.Timestamp.fromObject(object.exDividendDate);
          }
          if (object.timestamp != null) {
            if (typeof object.timestamp !== "object")
              throw TypeError(".dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.timestamp: object expected");
            message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
          }
          if (object.exerciseDate != null) {
            if (typeof object.exerciseDate !== "object")
              throw TypeError(".dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.exerciseDate: object expected");
            message.exerciseDate = $root.google.protobuf.Timestamp.fromObject(object.exerciseDate);
          }
          if (object.estimateReceivingDate != null) {
            if (typeof object.estimateReceivingDate !== "object")
              throw TypeError(".dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.estimateReceivingDate: object expected");
            message.estimateReceivingDate = $root.google.protobuf.Timestamp.fromObject(object.estimateReceivingDate);
          }
          if (object.rightSubscribeStartDate != null) {
            if (typeof object.rightSubscribeStartDate !== "object")
              throw TypeError(".dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.rightSubscribeStartDate: object expected");
            message.rightSubscribeStartDate = $root.google.protobuf.Timestamp.fromObject(object.rightSubscribeStartDate);
          }
          if (object.rightSubscribeEndDate != null) {
            if (typeof object.rightSubscribeEndDate !== "object")
              throw TypeError(".dnse.fo.AccountCorporateActionEvent.CorporateActionDividendAndRight.rightSubscribeEndDate: object expected");
            message.rightSubscribeEndDate = $root.google.protobuf.Timestamp.fromObject(object.rightSubscribeEndDate);
          }
          if (object.rightOfferingRatio != null)
            message.rightOfferingRatio = String(object.rightOfferingRatio);
          if (object.rightToPurchaseSharesRatio != null)
            message.rightToPurchaseSharesRatio = String(object.rightToPurchaseSharesRatio);
          if (object.openQuantity != null) {
            if ($util.Long)
              (message.openQuantity = $util.Long.fromValue(object.openQuantity)).unsigned = false;
            else if (typeof object.openQuantity === "string")
              message.openQuantity = parseInt(object.openQuantity, 10);
            else if (typeof object.openQuantity === "number")
              message.openQuantity = object.openQuantity;
            else if (typeof object.openQuantity === "object")
              message.openQuantity = new $util.LongBits(object.openQuantity.low >>> 0, object.openQuantity.high >>> 0).toNumber();
          }
          if (object.dividendReceivingQuantity != null) {
            if ($util.Long)
              (message.dividendReceivingQuantity = $util.Long.fromValue(object.dividendReceivingQuantity)).unsigned = false;
            else if (typeof object.dividendReceivingQuantity === "string")
              message.dividendReceivingQuantity = parseInt(object.dividendReceivingQuantity, 10);
            else if (typeof object.dividendReceivingQuantity === "number")
              message.dividendReceivingQuantity = object.dividendReceivingQuantity;
            else if (typeof object.dividendReceivingQuantity === "object")
              message.dividendReceivingQuantity = new $util.LongBits(object.dividendReceivingQuantity.low >>> 0, object.dividendReceivingQuantity.high >>> 0).toNumber();
          }
          if (object.stockBonusReceivingQuantity != null) {
            if ($util.Long)
              (message.stockBonusReceivingQuantity = $util.Long.fromValue(object.stockBonusReceivingQuantity)).unsigned = false;
            else if (typeof object.stockBonusReceivingQuantity === "string")
              message.stockBonusReceivingQuantity = parseInt(object.stockBonusReceivingQuantity, 10);
            else if (typeof object.stockBonusReceivingQuantity === "number")
              message.stockBonusReceivingQuantity = object.stockBonusReceivingQuantity;
            else if (typeof object.stockBonusReceivingQuantity === "object")
              message.stockBonusReceivingQuantity = new $util.LongBits(object.stockBonusReceivingQuantity.low >>> 0, object.stockBonusReceivingQuantity.high >>> 0).toNumber();
          }
          if (object.cashReceiving != null)
            message.cashReceiving = Number(object.cashReceiving);
          if (object.maxRightQuantity != null) {
            if ($util.Long)
              (message.maxRightQuantity = $util.Long.fromValue(object.maxRightQuantity)).unsigned = false;
            else if (typeof object.maxRightQuantity === "string")
              message.maxRightQuantity = parseInt(object.maxRightQuantity, 10);
            else if (typeof object.maxRightQuantity === "number")
              message.maxRightQuantity = object.maxRightQuantity;
            else if (typeof object.maxRightQuantity === "object")
              message.maxRightQuantity = new $util.LongBits(object.maxRightQuantity.low >>> 0, object.maxRightQuantity.high >>> 0).toNumber();
          }
          return message;
        };
        CorporateActionDividendAndRight.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.symbol = "";
            object.price = 0;
            object.priceNew = 0;
            object.priceAlpha = 0;
            object.rightRatio = "";
            object.dividendStockRatio = "";
            object.bonusStockRatio = "";
            object.dividendCash = 0;
            object.exDividendDate = null;
            object.timestamp = null;
            object.exerciseDate = null;
            object.estimateReceivingDate = null;
            object.rightSubscribeStartDate = null;
            object.rightSubscribeEndDate = null;
            object.rightOfferingRatio = "";
            object.rightToPurchaseSharesRatio = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.openQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.openQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.dividendReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.dividendReceivingQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.stockBonusReceivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.stockBonusReceivingQuantity = options.longs === String ? "0" : 0;
            object.cashReceiving = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.maxRightQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.maxRightQuantity = options.longs === String ? "0" : 0;
          }
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.priceNew != null && message.hasOwnProperty("priceNew"))
            object.priceNew = options.json && !isFinite(message.priceNew) ? String(message.priceNew) : message.priceNew;
          if (message.priceAlpha != null && message.hasOwnProperty("priceAlpha"))
            object.priceAlpha = options.json && !isFinite(message.priceAlpha) ? String(message.priceAlpha) : message.priceAlpha;
          if (message.rightRatio != null && message.hasOwnProperty("rightRatio"))
            object.rightRatio = message.rightRatio;
          if (message.dividendStockRatio != null && message.hasOwnProperty("dividendStockRatio"))
            object.dividendStockRatio = message.dividendStockRatio;
          if (message.bonusStockRatio != null && message.hasOwnProperty("bonusStockRatio"))
            object.bonusStockRatio = message.bonusStockRatio;
          if (message.dividendCash != null && message.hasOwnProperty("dividendCash"))
            object.dividendCash = options.json && !isFinite(message.dividendCash) ? String(message.dividendCash) : message.dividendCash;
          if (message.exDividendDate != null && message.hasOwnProperty("exDividendDate"))
            object.exDividendDate = $root.google.protobuf.Timestamp.toObject(message.exDividendDate, options);
          if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
          if (message.exerciseDate != null && message.hasOwnProperty("exerciseDate"))
            object.exerciseDate = $root.google.protobuf.Timestamp.toObject(message.exerciseDate, options);
          if (message.estimateReceivingDate != null && message.hasOwnProperty("estimateReceivingDate"))
            object.estimateReceivingDate = $root.google.protobuf.Timestamp.toObject(message.estimateReceivingDate, options);
          if (message.rightSubscribeStartDate != null && message.hasOwnProperty("rightSubscribeStartDate"))
            object.rightSubscribeStartDate = $root.google.protobuf.Timestamp.toObject(message.rightSubscribeStartDate, options);
          if (message.rightSubscribeEndDate != null && message.hasOwnProperty("rightSubscribeEndDate"))
            object.rightSubscribeEndDate = $root.google.protobuf.Timestamp.toObject(message.rightSubscribeEndDate, options);
          if (message.rightOfferingRatio != null && message.hasOwnProperty("rightOfferingRatio"))
            object.rightOfferingRatio = message.rightOfferingRatio;
          if (message.rightToPurchaseSharesRatio != null && message.hasOwnProperty("rightToPurchaseSharesRatio"))
            object.rightToPurchaseSharesRatio = message.rightToPurchaseSharesRatio;
          if (message.openQuantity != null && message.hasOwnProperty("openQuantity"))
            if (typeof message.openQuantity === "number")
              object.openQuantity = options.longs === String ? String(message.openQuantity) : message.openQuantity;
            else
              object.openQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.openQuantity) : options.longs === Number ? new $util.LongBits(message.openQuantity.low >>> 0, message.openQuantity.high >>> 0).toNumber() : message.openQuantity;
          if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity"))
            if (typeof message.dividendReceivingQuantity === "number")
              object.dividendReceivingQuantity = options.longs === String ? String(message.dividendReceivingQuantity) : message.dividendReceivingQuantity;
            else
              object.dividendReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.dividendReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.dividendReceivingQuantity.low >>> 0, message.dividendReceivingQuantity.high >>> 0).toNumber() : message.dividendReceivingQuantity;
          if (message.stockBonusReceivingQuantity != null && message.hasOwnProperty("stockBonusReceivingQuantity"))
            if (typeof message.stockBonusReceivingQuantity === "number")
              object.stockBonusReceivingQuantity = options.longs === String ? String(message.stockBonusReceivingQuantity) : message.stockBonusReceivingQuantity;
            else
              object.stockBonusReceivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.stockBonusReceivingQuantity) : options.longs === Number ? new $util.LongBits(message.stockBonusReceivingQuantity.low >>> 0, message.stockBonusReceivingQuantity.high >>> 0).toNumber() : message.stockBonusReceivingQuantity;
          if (message.cashReceiving != null && message.hasOwnProperty("cashReceiving"))
            object.cashReceiving = options.json && !isFinite(message.cashReceiving) ? String(message.cashReceiving) : message.cashReceiving;
          if (message.maxRightQuantity != null && message.hasOwnProperty("maxRightQuantity"))
            if (typeof message.maxRightQuantity === "number")
              object.maxRightQuantity = options.longs === String ? String(message.maxRightQuantity) : message.maxRightQuantity;
            else
              object.maxRightQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.maxRightQuantity) : options.longs === Number ? new $util.LongBits(message.maxRightQuantity.low >>> 0, message.maxRightQuantity.high >>> 0).toNumber() : message.maxRightQuantity;
          return object;
        };
        CorporateActionDividendAndRight.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CorporateActionDividendAndRight;
      }();
      return AccountCorporateActionEvent;
    }();
    fo.DerivativeLoanPackage = function() {
      function DerivativeLoanPackage(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoanPackage.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanPackage.prototype.name = "";
      DerivativeLoanPackage.prototype.source = "";
      DerivativeLoanPackage.prototype.basketId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanPackage.prototype.initialRate = 0;
      DerivativeLoanPackage.prototype.maintenanceRate = 0;
      DerivativeLoanPackage.prototype.warningRate = 0;
      DerivativeLoanPackage.prototype.liquidRate = 0;
      DerivativeLoanPackage.prototype.tradingFeeId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanPackage.prototype.description = "";
      DerivativeLoanPackage.prototype.effectiveDate = "";
      DerivativeLoanPackage.prototype.createdDate = null;
      DerivativeLoanPackage.prototype.modifiedDate = null;
      DerivativeLoanPackage.prototype.defaultPackage = false;
      DerivativeLoanPackage.prototype.coefficientWithdrawInSession = 0;
      DerivativeLoanPackage.prototype.coefficientWithdrawOutOfSession = 0;
      DerivativeLoanPackage.prototype.fdsCoefficientWithdrawInSession = 0;
      DerivativeLoanPackage.prototype.fdsCoefficientWithdrawOutOfSession = 0;
      DerivativeLoanPackage.prototype.loanPolicyForProfitAdvance = 0;
      DerivativeLoanPackage.prototype.loanPolicyForObligationPayment = 0;
      DerivativeLoanPackage.prototype.loanPolicyForCashAccountDealDebt = 0;
      DerivativeLoanPackage.prototype.coefficientWithdrawSecureInSession = 0;
      DerivativeLoanPackage.prototype.coefficientWithdrawSecureOutOfSession = 0;
      DerivativeLoanPackage.prototype.loanRate = 0;
      DerivativeLoanPackage.prototype.loanPolicyForVSDSecureAdvance = 0;
      DerivativeLoanPackage.prototype.coefficientProfitAdvance = 0;
      DerivativeLoanPackage.prototype.label = "";
      DerivativeLoanPackage.create = function create(properties) {
        return new DerivativeLoanPackage(properties);
      };
      DerivativeLoanPackage.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(18).string(message.name);
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(26).string(message.source);
        if (message.basketId != null && Object.hasOwnProperty.call(message, "basketId"))
          writer.uint32(32).int64(message.basketId);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(41).double(message.initialRate);
        if (message.maintenanceRate != null && Object.hasOwnProperty.call(message, "maintenanceRate"))
          writer.uint32(49).double(message.maintenanceRate);
        if (message.warningRate != null && Object.hasOwnProperty.call(message, "warningRate"))
          writer.uint32(57).double(message.warningRate);
        if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
          writer.uint32(65).double(message.liquidRate);
        if (message.tradingFeeId != null && Object.hasOwnProperty.call(message, "tradingFeeId"))
          writer.uint32(72).int64(message.tradingFeeId);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(90).string(message.description);
        if (message.effectiveDate != null && Object.hasOwnProperty.call(message, "effectiveDate"))
          writer.uint32(98).string(message.effectiveDate);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(106).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(114).fork()).ldelim();
        if (message.defaultPackage != null && Object.hasOwnProperty.call(message, "defaultPackage"))
          writer.uint32(120).bool(message.defaultPackage);
        if (message.coefficientWithdrawInSession != null && Object.hasOwnProperty.call(message, "coefficientWithdrawInSession"))
          writer.uint32(129).double(message.coefficientWithdrawInSession);
        if (message.coefficientWithdrawOutOfSession != null && Object.hasOwnProperty.call(message, "coefficientWithdrawOutOfSession"))
          writer.uint32(137).double(message.coefficientWithdrawOutOfSession);
        if (message.fdsCoefficientWithdrawInSession != null && Object.hasOwnProperty.call(message, "fdsCoefficientWithdrawInSession"))
          writer.uint32(145).double(message.fdsCoefficientWithdrawInSession);
        if (message.fdsCoefficientWithdrawOutOfSession != null && Object.hasOwnProperty.call(message, "fdsCoefficientWithdrawOutOfSession"))
          writer.uint32(153).double(message.fdsCoefficientWithdrawOutOfSession);
        if (message.loanPolicyForProfitAdvance != null && Object.hasOwnProperty.call(message, "loanPolicyForProfitAdvance"))
          writer.uint32(160).int32(message.loanPolicyForProfitAdvance);
        if (message.loanPolicyForObligationPayment != null && Object.hasOwnProperty.call(message, "loanPolicyForObligationPayment"))
          writer.uint32(168).int32(message.loanPolicyForObligationPayment);
        if (message.loanPolicyForCashAccountDealDebt != null && Object.hasOwnProperty.call(message, "loanPolicyForCashAccountDealDebt"))
          writer.uint32(176).int32(message.loanPolicyForCashAccountDealDebt);
        if (message.coefficientWithdrawSecureInSession != null && Object.hasOwnProperty.call(message, "coefficientWithdrawSecureInSession"))
          writer.uint32(185).double(message.coefficientWithdrawSecureInSession);
        if (message.coefficientWithdrawSecureOutOfSession != null && Object.hasOwnProperty.call(message, "coefficientWithdrawSecureOutOfSession"))
          writer.uint32(193).double(message.coefficientWithdrawSecureOutOfSession);
        if (message.loanRate != null && Object.hasOwnProperty.call(message, "loanRate"))
          writer.uint32(201).double(message.loanRate);
        if (message.loanPolicyForVSDSecureAdvance != null && Object.hasOwnProperty.call(message, "loanPolicyForVSDSecureAdvance"))
          writer.uint32(208).int32(message.loanPolicyForVSDSecureAdvance);
        if (message.coefficientProfitAdvance != null && Object.hasOwnProperty.call(message, "coefficientProfitAdvance"))
          writer.uint32(217).double(message.coefficientProfitAdvance);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
          writer.uint32(226).string(message.label);
        return writer;
      };
      DerivativeLoanPackage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoanPackage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoanPackage();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.source = reader.string();
              break;
            case 4:
              message.basketId = reader.int64();
              break;
            case 5:
              message.initialRate = reader.double();
              break;
            case 6:
              message.maintenanceRate = reader.double();
              break;
            case 7:
              message.warningRate = reader.double();
              break;
            case 8:
              message.liquidRate = reader.double();
              break;
            case 9:
              message.tradingFeeId = reader.int64();
              break;
            case 11:
              message.description = reader.string();
              break;
            case 12:
              message.effectiveDate = reader.string();
              break;
            case 13:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 14:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 15:
              message.defaultPackage = reader.bool();
              break;
            case 16:
              message.coefficientWithdrawInSession = reader.double();
              break;
            case 17:
              message.coefficientWithdrawOutOfSession = reader.double();
              break;
            case 18:
              message.fdsCoefficientWithdrawInSession = reader.double();
              break;
            case 19:
              message.fdsCoefficientWithdrawOutOfSession = reader.double();
              break;
            case 20:
              message.loanPolicyForProfitAdvance = reader.int32();
              break;
            case 21:
              message.loanPolicyForObligationPayment = reader.int32();
              break;
            case 22:
              message.loanPolicyForCashAccountDealDebt = reader.int32();
              break;
            case 23:
              message.coefficientWithdrawSecureInSession = reader.double();
              break;
            case 24:
              message.coefficientWithdrawSecureOutOfSession = reader.double();
              break;
            case 25:
              message.loanRate = reader.double();
              break;
            case 26:
              message.loanPolicyForVSDSecureAdvance = reader.int32();
              break;
            case 27:
              message.coefficientProfitAdvance = reader.double();
              break;
            case 28:
              message.label = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoanPackage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoanPackage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        if (message.basketId != null && message.hasOwnProperty("basketId")) {
          if (!$util.isInteger(message.basketId) && !(message.basketId && $util.isInteger(message.basketId.low) && $util.isInteger(message.basketId.high)))
            return "basketId: integer|Long expected";
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate")) {
          if (typeof message.maintenanceRate !== "number")
            return "maintenanceRate: number expected";
        }
        if (message.warningRate != null && message.hasOwnProperty("warningRate")) {
          if (typeof message.warningRate !== "number")
            return "warningRate: number expected";
        }
        if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
          if (typeof message.liquidRate !== "number")
            return "liquidRate: number expected";
        }
        if (message.tradingFeeId != null && message.hasOwnProperty("tradingFeeId")) {
          if (!$util.isInteger(message.tradingFeeId) && !(message.tradingFeeId && $util.isInteger(message.tradingFeeId.low) && $util.isInteger(message.tradingFeeId.high)))
            return "tradingFeeId: integer|Long expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.effectiveDate != null && message.hasOwnProperty("effectiveDate")) {
          if (!$util.isString(message.effectiveDate))
            return "effectiveDate: string expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.defaultPackage != null && message.hasOwnProperty("defaultPackage")) {
          if (typeof message.defaultPackage !== "boolean")
            return "defaultPackage: boolean expected";
        }
        if (message.coefficientWithdrawInSession != null && message.hasOwnProperty("coefficientWithdrawInSession")) {
          if (typeof message.coefficientWithdrawInSession !== "number")
            return "coefficientWithdrawInSession: number expected";
        }
        if (message.coefficientWithdrawOutOfSession != null && message.hasOwnProperty("coefficientWithdrawOutOfSession")) {
          if (typeof message.coefficientWithdrawOutOfSession !== "number")
            return "coefficientWithdrawOutOfSession: number expected";
        }
        if (message.fdsCoefficientWithdrawInSession != null && message.hasOwnProperty("fdsCoefficientWithdrawInSession")) {
          if (typeof message.fdsCoefficientWithdrawInSession !== "number")
            return "fdsCoefficientWithdrawInSession: number expected";
        }
        if (message.fdsCoefficientWithdrawOutOfSession != null && message.hasOwnProperty("fdsCoefficientWithdrawOutOfSession")) {
          if (typeof message.fdsCoefficientWithdrawOutOfSession !== "number")
            return "fdsCoefficientWithdrawOutOfSession: number expected";
        }
        if (message.loanPolicyForProfitAdvance != null && message.hasOwnProperty("loanPolicyForProfitAdvance")) {
          if (!$util.isInteger(message.loanPolicyForProfitAdvance))
            return "loanPolicyForProfitAdvance: integer expected";
        }
        if (message.loanPolicyForObligationPayment != null && message.hasOwnProperty("loanPolicyForObligationPayment")) {
          if (!$util.isInteger(message.loanPolicyForObligationPayment))
            return "loanPolicyForObligationPayment: integer expected";
        }
        if (message.loanPolicyForCashAccountDealDebt != null && message.hasOwnProperty("loanPolicyForCashAccountDealDebt")) {
          if (!$util.isInteger(message.loanPolicyForCashAccountDealDebt))
            return "loanPolicyForCashAccountDealDebt: integer expected";
        }
        if (message.coefficientWithdrawSecureInSession != null && message.hasOwnProperty("coefficientWithdrawSecureInSession")) {
          if (typeof message.coefficientWithdrawSecureInSession !== "number")
            return "coefficientWithdrawSecureInSession: number expected";
        }
        if (message.coefficientWithdrawSecureOutOfSession != null && message.hasOwnProperty("coefficientWithdrawSecureOutOfSession")) {
          if (typeof message.coefficientWithdrawSecureOutOfSession !== "number")
            return "coefficientWithdrawSecureOutOfSession: number expected";
        }
        if (message.loanRate != null && message.hasOwnProperty("loanRate")) {
          if (typeof message.loanRate !== "number")
            return "loanRate: number expected";
        }
        if (message.loanPolicyForVSDSecureAdvance != null && message.hasOwnProperty("loanPolicyForVSDSecureAdvance")) {
          if (!$util.isInteger(message.loanPolicyForVSDSecureAdvance))
            return "loanPolicyForVSDSecureAdvance: integer expected";
        }
        if (message.coefficientProfitAdvance != null && message.hasOwnProperty("coefficientProfitAdvance")) {
          if (typeof message.coefficientProfitAdvance !== "number")
            return "coefficientProfitAdvance: number expected";
        }
        if (message.label != null && message.hasOwnProperty("label")) {
          if (!$util.isString(message.label))
            return "label: string expected";
        }
        return null;
      };
      DerivativeLoanPackage.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoanPackage)
          return object;
        let message = new $root.dnse.fo.DerivativeLoanPackage();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.name != null)
          message.name = String(object.name);
        if (object.source != null)
          message.source = String(object.source);
        if (object.basketId != null) {
          if ($util.Long)
            (message.basketId = $util.Long.fromValue(object.basketId)).unsigned = false;
          else if (typeof object.basketId === "string")
            message.basketId = parseInt(object.basketId, 10);
          else if (typeof object.basketId === "number")
            message.basketId = object.basketId;
          else if (typeof object.basketId === "object")
            message.basketId = new $util.LongBits(object.basketId.low >>> 0, object.basketId.high >>> 0).toNumber();
        }
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        if (object.maintenanceRate != null)
          message.maintenanceRate = Number(object.maintenanceRate);
        if (object.warningRate != null)
          message.warningRate = Number(object.warningRate);
        if (object.liquidRate != null)
          message.liquidRate = Number(object.liquidRate);
        if (object.tradingFeeId != null) {
          if ($util.Long)
            (message.tradingFeeId = $util.Long.fromValue(object.tradingFeeId)).unsigned = false;
          else if (typeof object.tradingFeeId === "string")
            message.tradingFeeId = parseInt(object.tradingFeeId, 10);
          else if (typeof object.tradingFeeId === "number")
            message.tradingFeeId = object.tradingFeeId;
          else if (typeof object.tradingFeeId === "object")
            message.tradingFeeId = new $util.LongBits(object.tradingFeeId.low >>> 0, object.tradingFeeId.high >>> 0).toNumber();
        }
        if (object.description != null)
          message.description = String(object.description);
        if (object.effectiveDate != null)
          message.effectiveDate = String(object.effectiveDate);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPackage.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPackage.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.defaultPackage != null)
          message.defaultPackage = Boolean(object.defaultPackage);
        if (object.coefficientWithdrawInSession != null)
          message.coefficientWithdrawInSession = Number(object.coefficientWithdrawInSession);
        if (object.coefficientWithdrawOutOfSession != null)
          message.coefficientWithdrawOutOfSession = Number(object.coefficientWithdrawOutOfSession);
        if (object.fdsCoefficientWithdrawInSession != null)
          message.fdsCoefficientWithdrawInSession = Number(object.fdsCoefficientWithdrawInSession);
        if (object.fdsCoefficientWithdrawOutOfSession != null)
          message.fdsCoefficientWithdrawOutOfSession = Number(object.fdsCoefficientWithdrawOutOfSession);
        if (object.loanPolicyForProfitAdvance != null)
          message.loanPolicyForProfitAdvance = object.loanPolicyForProfitAdvance | 0;
        if (object.loanPolicyForObligationPayment != null)
          message.loanPolicyForObligationPayment = object.loanPolicyForObligationPayment | 0;
        if (object.loanPolicyForCashAccountDealDebt != null)
          message.loanPolicyForCashAccountDealDebt = object.loanPolicyForCashAccountDealDebt | 0;
        if (object.coefficientWithdrawSecureInSession != null)
          message.coefficientWithdrawSecureInSession = Number(object.coefficientWithdrawSecureInSession);
        if (object.coefficientWithdrawSecureOutOfSession != null)
          message.coefficientWithdrawSecureOutOfSession = Number(object.coefficientWithdrawSecureOutOfSession);
        if (object.loanRate != null)
          message.loanRate = Number(object.loanRate);
        if (object.loanPolicyForVSDSecureAdvance != null)
          message.loanPolicyForVSDSecureAdvance = object.loanPolicyForVSDSecureAdvance | 0;
        if (object.coefficientProfitAdvance != null)
          message.coefficientProfitAdvance = Number(object.coefficientProfitAdvance);
        if (object.label != null)
          message.label = String(object.label);
        return message;
      };
      DerivativeLoanPackage.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.name = "";
          object.source = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.basketId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.basketId = options.longs === String ? "0" : 0;
          object.initialRate = 0;
          object.maintenanceRate = 0;
          object.warningRate = 0;
          object.liquidRate = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.tradingFeeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.tradingFeeId = options.longs === String ? "0" : 0;
          object.description = "";
          object.effectiveDate = "";
          object.createdDate = null;
          object.modifiedDate = null;
          object.defaultPackage = false;
          object.coefficientWithdrawInSession = 0;
          object.coefficientWithdrawOutOfSession = 0;
          object.fdsCoefficientWithdrawInSession = 0;
          object.fdsCoefficientWithdrawOutOfSession = 0;
          object.loanPolicyForProfitAdvance = 0;
          object.loanPolicyForObligationPayment = 0;
          object.loanPolicyForCashAccountDealDebt = 0;
          object.coefficientWithdrawSecureInSession = 0;
          object.coefficientWithdrawSecureOutOfSession = 0;
          object.loanRate = 0;
          object.loanPolicyForVSDSecureAdvance = 0;
          object.coefficientProfitAdvance = 0;
          object.label = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        if (message.basketId != null && message.hasOwnProperty("basketId"))
          if (typeof message.basketId === "number")
            object.basketId = options.longs === String ? String(message.basketId) : message.basketId;
          else
            object.basketId = options.longs === String ? $util.Long.prototype.toString.call(message.basketId) : options.longs === Number ? new $util.LongBits(message.basketId.low >>> 0, message.basketId.high >>> 0).toNumber() : message.basketId;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate"))
          object.maintenanceRate = options.json && !isFinite(message.maintenanceRate) ? String(message.maintenanceRate) : message.maintenanceRate;
        if (message.warningRate != null && message.hasOwnProperty("warningRate"))
          object.warningRate = options.json && !isFinite(message.warningRate) ? String(message.warningRate) : message.warningRate;
        if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
          object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
        if (message.tradingFeeId != null && message.hasOwnProperty("tradingFeeId"))
          if (typeof message.tradingFeeId === "number")
            object.tradingFeeId = options.longs === String ? String(message.tradingFeeId) : message.tradingFeeId;
          else
            object.tradingFeeId = options.longs === String ? $util.Long.prototype.toString.call(message.tradingFeeId) : options.longs === Number ? new $util.LongBits(message.tradingFeeId.low >>> 0, message.tradingFeeId.high >>> 0).toNumber() : message.tradingFeeId;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.effectiveDate != null && message.hasOwnProperty("effectiveDate"))
          object.effectiveDate = message.effectiveDate;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.defaultPackage != null && message.hasOwnProperty("defaultPackage"))
          object.defaultPackage = message.defaultPackage;
        if (message.coefficientWithdrawInSession != null && message.hasOwnProperty("coefficientWithdrawInSession"))
          object.coefficientWithdrawInSession = options.json && !isFinite(message.coefficientWithdrawInSession) ? String(message.coefficientWithdrawInSession) : message.coefficientWithdrawInSession;
        if (message.coefficientWithdrawOutOfSession != null && message.hasOwnProperty("coefficientWithdrawOutOfSession"))
          object.coefficientWithdrawOutOfSession = options.json && !isFinite(message.coefficientWithdrawOutOfSession) ? String(message.coefficientWithdrawOutOfSession) : message.coefficientWithdrawOutOfSession;
        if (message.fdsCoefficientWithdrawInSession != null && message.hasOwnProperty("fdsCoefficientWithdrawInSession"))
          object.fdsCoefficientWithdrawInSession = options.json && !isFinite(message.fdsCoefficientWithdrawInSession) ? String(message.fdsCoefficientWithdrawInSession) : message.fdsCoefficientWithdrawInSession;
        if (message.fdsCoefficientWithdrawOutOfSession != null && message.hasOwnProperty("fdsCoefficientWithdrawOutOfSession"))
          object.fdsCoefficientWithdrawOutOfSession = options.json && !isFinite(message.fdsCoefficientWithdrawOutOfSession) ? String(message.fdsCoefficientWithdrawOutOfSession) : message.fdsCoefficientWithdrawOutOfSession;
        if (message.loanPolicyForProfitAdvance != null && message.hasOwnProperty("loanPolicyForProfitAdvance"))
          object.loanPolicyForProfitAdvance = message.loanPolicyForProfitAdvance;
        if (message.loanPolicyForObligationPayment != null && message.hasOwnProperty("loanPolicyForObligationPayment"))
          object.loanPolicyForObligationPayment = message.loanPolicyForObligationPayment;
        if (message.loanPolicyForCashAccountDealDebt != null && message.hasOwnProperty("loanPolicyForCashAccountDealDebt"))
          object.loanPolicyForCashAccountDealDebt = message.loanPolicyForCashAccountDealDebt;
        if (message.coefficientWithdrawSecureInSession != null && message.hasOwnProperty("coefficientWithdrawSecureInSession"))
          object.coefficientWithdrawSecureInSession = options.json && !isFinite(message.coefficientWithdrawSecureInSession) ? String(message.coefficientWithdrawSecureInSession) : message.coefficientWithdrawSecureInSession;
        if (message.coefficientWithdrawSecureOutOfSession != null && message.hasOwnProperty("coefficientWithdrawSecureOutOfSession"))
          object.coefficientWithdrawSecureOutOfSession = options.json && !isFinite(message.coefficientWithdrawSecureOutOfSession) ? String(message.coefficientWithdrawSecureOutOfSession) : message.coefficientWithdrawSecureOutOfSession;
        if (message.loanRate != null && message.hasOwnProperty("loanRate"))
          object.loanRate = options.json && !isFinite(message.loanRate) ? String(message.loanRate) : message.loanRate;
        if (message.loanPolicyForVSDSecureAdvance != null && message.hasOwnProperty("loanPolicyForVSDSecureAdvance"))
          object.loanPolicyForVSDSecureAdvance = message.loanPolicyForVSDSecureAdvance;
        if (message.coefficientProfitAdvance != null && message.hasOwnProperty("coefficientProfitAdvance"))
          object.coefficientProfitAdvance = options.json && !isFinite(message.coefficientProfitAdvance) ? String(message.coefficientProfitAdvance) : message.coefficientProfitAdvance;
        if (message.label != null && message.hasOwnProperty("label"))
          object.label = message.label;
        return object;
      };
      DerivativeLoanPackage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeLoanPackage;
    }();
    fo.DerivativeBasket = function() {
      function DerivativeBasket(properties) {
        this.symbols = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeBasket.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeBasket.prototype.name = "";
      DerivativeBasket.prototype.symbols = $util.emptyArray;
      DerivativeBasket.prototype.createdDate = null;
      DerivativeBasket.prototype.modifiedDate = null;
      DerivativeBasket.create = function create(properties) {
        return new DerivativeBasket(properties);
      };
      DerivativeBasket.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(18).string(message.name);
        if (message.symbols != null && message.symbols.length)
          for (let i = 0; i < message.symbols.length; ++i)
            writer.uint32(26).string(message.symbols[i]);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(42).fork()).ldelim();
        return writer;
      };
      DerivativeBasket.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeBasket.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeBasket();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              if (!(message.symbols && message.symbols.length))
                message.symbols = [];
              message.symbols.push(reader.string());
              break;
            case 4:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 5:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeBasket.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeBasket.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.symbols != null && message.hasOwnProperty("symbols")) {
          if (!Array.isArray(message.symbols))
            return "symbols: array expected";
          for (let i = 0; i < message.symbols.length; ++i)
            if (!$util.isString(message.symbols[i]))
              return "symbols: string[] expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        return null;
      };
      DerivativeBasket.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeBasket)
          return object;
        let message = new $root.dnse.fo.DerivativeBasket();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.name != null)
          message.name = String(object.name);
        if (object.symbols) {
          if (!Array.isArray(object.symbols))
            throw TypeError(".dnse.fo.DerivativeBasket.symbols: array expected");
          message.symbols = [];
          for (let i = 0; i < object.symbols.length; ++i)
            message.symbols[i] = String(object.symbols[i]);
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeBasket.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeBasket.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        return message;
      };
      DerivativeBasket.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.symbols = [];
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.name = "";
          object.createdDate = null;
          object.modifiedDate = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.symbols && message.symbols.length) {
          object.symbols = [];
          for (let j = 0; j < message.symbols.length; ++j)
            object.symbols[j] = message.symbols[j];
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        return object;
      };
      DerivativeBasket.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeBasket;
    }();
    fo.DerivativeLoanPackageAccount = function() {
      function DerivativeLoanPackageAccount(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoanPackageAccount.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanPackageAccount.prototype.accountNo = "";
      DerivativeLoanPackageAccount.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanPackageAccount.prototype.tradingFeeId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanPackageAccount.prototype.createdDate = null;
      DerivativeLoanPackageAccount.prototype.modifiedDate = null;
      DerivativeLoanPackageAccount.create = function create(properties) {
        return new DerivativeLoanPackageAccount(properties);
      };
      DerivativeLoanPackageAccount.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(24).int64(message.loanPackageId);
        if (message.tradingFeeId != null && Object.hasOwnProperty.call(message, "tradingFeeId"))
          writer.uint32(32).int64(message.tradingFeeId);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(42).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(50).fork()).ldelim();
        return writer;
      };
      DerivativeLoanPackageAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoanPackageAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoanPackageAccount();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.loanPackageId = reader.int64();
              break;
            case 4:
              message.tradingFeeId = reader.int64();
              break;
            case 5:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 6:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoanPackageAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoanPackageAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
            return "loanPackageId: integer|Long expected";
        }
        if (message.tradingFeeId != null && message.hasOwnProperty("tradingFeeId")) {
          if (!$util.isInteger(message.tradingFeeId) && !(message.tradingFeeId && $util.isInteger(message.tradingFeeId.low) && $util.isInteger(message.tradingFeeId.high)))
            return "tradingFeeId: integer|Long expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        return null;
      };
      DerivativeLoanPackageAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoanPackageAccount)
          return object;
        let message = new $root.dnse.fo.DerivativeLoanPackageAccount();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.loanPackageId != null) {
          if ($util.Long)
            (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
          else if (typeof object.loanPackageId === "string")
            message.loanPackageId = parseInt(object.loanPackageId, 10);
          else if (typeof object.loanPackageId === "number")
            message.loanPackageId = object.loanPackageId;
          else if (typeof object.loanPackageId === "object")
            message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
        }
        if (object.tradingFeeId != null) {
          if ($util.Long)
            (message.tradingFeeId = $util.Long.fromValue(object.tradingFeeId)).unsigned = false;
          else if (typeof object.tradingFeeId === "string")
            message.tradingFeeId = parseInt(object.tradingFeeId, 10);
          else if (typeof object.tradingFeeId === "number")
            message.tradingFeeId = object.tradingFeeId;
          else if (typeof object.tradingFeeId === "object")
            message.tradingFeeId = new $util.LongBits(object.tradingFeeId.low >>> 0, object.tradingFeeId.high >>> 0).toNumber();
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPackageAccount.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPackageAccount.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        return message;
      };
      DerivativeLoanPackageAccount.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.loanPackageId = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.tradingFeeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.tradingFeeId = options.longs === String ? "0" : 0;
          object.createdDate = null;
          object.modifiedDate = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          if (typeof message.loanPackageId === "number")
            object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
          else
            object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
        if (message.tradingFeeId != null && message.hasOwnProperty("tradingFeeId"))
          if (typeof message.tradingFeeId === "number")
            object.tradingFeeId = options.longs === String ? String(message.tradingFeeId) : message.tradingFeeId;
          else
            object.tradingFeeId = options.longs === String ? $util.Long.prototype.toString.call(message.tradingFeeId) : options.longs === Number ? new $util.LongBits(message.tradingFeeId.low >>> 0, message.tradingFeeId.high >>> 0).toNumber() : message.tradingFeeId;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        return object;
      };
      DerivativeLoanPackageAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeLoanPackageAccount;
    }();
    fo.DerivativeTradingFee = function() {
      function DerivativeTradingFee(properties) {
        this.progressiveTradingFee = [];
        this.progressiveDailyCloseTradingFee = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeTradingFee.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeTradingFee.prototype.name = "";
      DerivativeTradingFee.prototype.scope = 0;
      DerivativeTradingFee.prototype.chanel = "";
      DerivativeTradingFee.prototype.schemaType = 0;
      DerivativeTradingFee.prototype.fixedTradingFee = 0;
      DerivativeTradingFee.prototype.progressiveTradingFee = $util.emptyArray;
      DerivativeTradingFee.prototype.fixedDailyCloseTradingFee = 0;
      DerivativeTradingFee.prototype.progressiveDailyCloseTradingFee = $util.emptyArray;
      DerivativeTradingFee.prototype.startDay = "";
      DerivativeTradingFee.prototype.endDay = "";
      DerivativeTradingFee.prototype.createdDate = null;
      DerivativeTradingFee.prototype.modifiedDate = null;
      DerivativeTradingFee.create = function create(properties) {
        return new DerivativeTradingFee(properties);
      };
      DerivativeTradingFee.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(18).string(message.name);
        if (message.scope != null && Object.hasOwnProperty.call(message, "scope"))
          writer.uint32(24).int32(message.scope);
        if (message.chanel != null && Object.hasOwnProperty.call(message, "chanel"))
          writer.uint32(34).string(message.chanel);
        if (message.schemaType != null && Object.hasOwnProperty.call(message, "schemaType"))
          writer.uint32(40).int32(message.schemaType);
        if (message.fixedTradingFee != null && Object.hasOwnProperty.call(message, "fixedTradingFee"))
          writer.uint32(49).double(message.fixedTradingFee);
        if (message.progressiveTradingFee != null && message.progressiveTradingFee.length)
          for (let i = 0; i < message.progressiveTradingFee.length; ++i)
            $root.dnse.fo.ProgressiveFee.encode(message.progressiveTradingFee[i], writer.uint32(58).fork()).ldelim();
        if (message.fixedDailyCloseTradingFee != null && Object.hasOwnProperty.call(message, "fixedDailyCloseTradingFee"))
          writer.uint32(65).double(message.fixedDailyCloseTradingFee);
        if (message.progressiveDailyCloseTradingFee != null && message.progressiveDailyCloseTradingFee.length)
          for (let i = 0; i < message.progressiveDailyCloseTradingFee.length; ++i)
            $root.dnse.fo.ProgressiveFee.encode(message.progressiveDailyCloseTradingFee[i], writer.uint32(74).fork()).ldelim();
        if (message.startDay != null && Object.hasOwnProperty.call(message, "startDay"))
          writer.uint32(82).string(message.startDay);
        if (message.endDay != null && Object.hasOwnProperty.call(message, "endDay"))
          writer.uint32(90).string(message.endDay);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
        return writer;
      };
      DerivativeTradingFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeTradingFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeTradingFee();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.scope = reader.int32();
              break;
            case 4:
              message.chanel = reader.string();
              break;
            case 5:
              message.schemaType = reader.int32();
              break;
            case 6:
              message.fixedTradingFee = reader.double();
              break;
            case 7:
              if (!(message.progressiveTradingFee && message.progressiveTradingFee.length))
                message.progressiveTradingFee = [];
              message.progressiveTradingFee.push($root.dnse.fo.ProgressiveFee.decode(reader, reader.uint32()));
              break;
            case 8:
              message.fixedDailyCloseTradingFee = reader.double();
              break;
            case 9:
              if (!(message.progressiveDailyCloseTradingFee && message.progressiveDailyCloseTradingFee.length))
                message.progressiveDailyCloseTradingFee = [];
              message.progressiveDailyCloseTradingFee.push($root.dnse.fo.ProgressiveFee.decode(reader, reader.uint32()));
              break;
            case 10:
              message.startDay = reader.string();
              break;
            case 11:
              message.endDay = reader.string();
              break;
            case 12:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 13:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeTradingFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeTradingFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.scope != null && message.hasOwnProperty("scope"))
          switch (message.scope) {
            default:
              return "scope: enum value expected";
            case 0:
            case 1:
              break;
          }
        if (message.chanel != null && message.hasOwnProperty("chanel")) {
          if (!$util.isString(message.chanel))
            return "chanel: string expected";
        }
        if (message.schemaType != null && message.hasOwnProperty("schemaType"))
          switch (message.schemaType) {
            default:
              return "schemaType: enum value expected";
            case 0:
            case 1:
              break;
          }
        if (message.fixedTradingFee != null && message.hasOwnProperty("fixedTradingFee")) {
          if (typeof message.fixedTradingFee !== "number")
            return "fixedTradingFee: number expected";
        }
        if (message.progressiveTradingFee != null && message.hasOwnProperty("progressiveTradingFee")) {
          if (!Array.isArray(message.progressiveTradingFee))
            return "progressiveTradingFee: array expected";
          for (let i = 0; i < message.progressiveTradingFee.length; ++i) {
            let error = $root.dnse.fo.ProgressiveFee.verify(message.progressiveTradingFee[i]);
            if (error)
              return "progressiveTradingFee." + error;
          }
        }
        if (message.fixedDailyCloseTradingFee != null && message.hasOwnProperty("fixedDailyCloseTradingFee")) {
          if (typeof message.fixedDailyCloseTradingFee !== "number")
            return "fixedDailyCloseTradingFee: number expected";
        }
        if (message.progressiveDailyCloseTradingFee != null && message.hasOwnProperty("progressiveDailyCloseTradingFee")) {
          if (!Array.isArray(message.progressiveDailyCloseTradingFee))
            return "progressiveDailyCloseTradingFee: array expected";
          for (let i = 0; i < message.progressiveDailyCloseTradingFee.length; ++i) {
            let error = $root.dnse.fo.ProgressiveFee.verify(message.progressiveDailyCloseTradingFee[i]);
            if (error)
              return "progressiveDailyCloseTradingFee." + error;
          }
        }
        if (message.startDay != null && message.hasOwnProperty("startDay")) {
          if (!$util.isString(message.startDay))
            return "startDay: string expected";
        }
        if (message.endDay != null && message.hasOwnProperty("endDay")) {
          if (!$util.isString(message.endDay))
            return "endDay: string expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        return null;
      };
      DerivativeTradingFee.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeTradingFee)
          return object;
        let message = new $root.dnse.fo.DerivativeTradingFee();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.name != null)
          message.name = String(object.name);
        switch (object.scope) {
          case "PRODUCT":
          case 0:
            message.scope = 0;
            break;
          case "CUSTOMER":
          case 1:
            message.scope = 1;
            break;
        }
        if (object.chanel != null)
          message.chanel = String(object.chanel);
        switch (object.schemaType) {
          case "FIXED":
          case 0:
            message.schemaType = 0;
            break;
          case "PROGRESSIVE":
          case 1:
            message.schemaType = 1;
            break;
        }
        if (object.fixedTradingFee != null)
          message.fixedTradingFee = Number(object.fixedTradingFee);
        if (object.progressiveTradingFee) {
          if (!Array.isArray(object.progressiveTradingFee))
            throw TypeError(".dnse.fo.DerivativeTradingFee.progressiveTradingFee: array expected");
          message.progressiveTradingFee = [];
          for (let i = 0; i < object.progressiveTradingFee.length; ++i) {
            if (typeof object.progressiveTradingFee[i] !== "object")
              throw TypeError(".dnse.fo.DerivativeTradingFee.progressiveTradingFee: object expected");
            message.progressiveTradingFee[i] = $root.dnse.fo.ProgressiveFee.fromObject(object.progressiveTradingFee[i]);
          }
        }
        if (object.fixedDailyCloseTradingFee != null)
          message.fixedDailyCloseTradingFee = Number(object.fixedDailyCloseTradingFee);
        if (object.progressiveDailyCloseTradingFee) {
          if (!Array.isArray(object.progressiveDailyCloseTradingFee))
            throw TypeError(".dnse.fo.DerivativeTradingFee.progressiveDailyCloseTradingFee: array expected");
          message.progressiveDailyCloseTradingFee = [];
          for (let i = 0; i < object.progressiveDailyCloseTradingFee.length; ++i) {
            if (typeof object.progressiveDailyCloseTradingFee[i] !== "object")
              throw TypeError(".dnse.fo.DerivativeTradingFee.progressiveDailyCloseTradingFee: object expected");
            message.progressiveDailyCloseTradingFee[i] = $root.dnse.fo.ProgressiveFee.fromObject(object.progressiveDailyCloseTradingFee[i]);
          }
        }
        if (object.startDay != null)
          message.startDay = String(object.startDay);
        if (object.endDay != null)
          message.endDay = String(object.endDay);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeTradingFee.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeTradingFee.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        return message;
      };
      DerivativeTradingFee.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.progressiveTradingFee = [];
          object.progressiveDailyCloseTradingFee = [];
        }
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.name = "";
          object.scope = options.enums === String ? "PRODUCT" : 0;
          object.chanel = "";
          object.schemaType = options.enums === String ? "FIXED" : 0;
          object.fixedTradingFee = 0;
          object.fixedDailyCloseTradingFee = 0;
          object.startDay = "";
          object.endDay = "";
          object.createdDate = null;
          object.modifiedDate = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.scope != null && message.hasOwnProperty("scope"))
          object.scope = options.enums === String ? $root.dnse.fo.DerivativeTradingFee.Scope[message.scope] : message.scope;
        if (message.chanel != null && message.hasOwnProperty("chanel"))
          object.chanel = message.chanel;
        if (message.schemaType != null && message.hasOwnProperty("schemaType"))
          object.schemaType = options.enums === String ? $root.dnse.fo.DerivativeTradingFee.SchemaType[message.schemaType] : message.schemaType;
        if (message.fixedTradingFee != null && message.hasOwnProperty("fixedTradingFee"))
          object.fixedTradingFee = options.json && !isFinite(message.fixedTradingFee) ? String(message.fixedTradingFee) : message.fixedTradingFee;
        if (message.progressiveTradingFee && message.progressiveTradingFee.length) {
          object.progressiveTradingFee = [];
          for (let j = 0; j < message.progressiveTradingFee.length; ++j)
            object.progressiveTradingFee[j] = $root.dnse.fo.ProgressiveFee.toObject(message.progressiveTradingFee[j], options);
        }
        if (message.fixedDailyCloseTradingFee != null && message.hasOwnProperty("fixedDailyCloseTradingFee"))
          object.fixedDailyCloseTradingFee = options.json && !isFinite(message.fixedDailyCloseTradingFee) ? String(message.fixedDailyCloseTradingFee) : message.fixedDailyCloseTradingFee;
        if (message.progressiveDailyCloseTradingFee && message.progressiveDailyCloseTradingFee.length) {
          object.progressiveDailyCloseTradingFee = [];
          for (let j = 0; j < message.progressiveDailyCloseTradingFee.length; ++j)
            object.progressiveDailyCloseTradingFee[j] = $root.dnse.fo.ProgressiveFee.toObject(message.progressiveDailyCloseTradingFee[j], options);
        }
        if (message.startDay != null && message.hasOwnProperty("startDay"))
          object.startDay = message.startDay;
        if (message.endDay != null && message.hasOwnProperty("endDay"))
          object.endDay = message.endDay;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        return object;
      };
      DerivativeTradingFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DerivativeTradingFee.Scope = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PRODUCT"] = 0;
        values[valuesById[1] = "CUSTOMER"] = 1;
        return values;
      }();
      DerivativeTradingFee.SchemaType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FIXED"] = 0;
        values[valuesById[1] = "PROGRESSIVE"] = 1;
        return values;
      }();
      return DerivativeTradingFee;
    }();
    fo.ProgressiveFee = function() {
      function ProgressiveFee(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      ProgressiveFee.prototype.fromQuantity = 0;
      ProgressiveFee.prototype.toQuantity = 0;
      ProgressiveFee.prototype.fee = 0;
      ProgressiveFee.create = function create(properties) {
        return new ProgressiveFee(properties);
      };
      ProgressiveFee.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.fromQuantity != null && Object.hasOwnProperty.call(message, "fromQuantity"))
          writer.uint32(8).int32(message.fromQuantity);
        if (message.toQuantity != null && Object.hasOwnProperty.call(message, "toQuantity"))
          writer.uint32(16).int32(message.toQuantity);
        if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
          writer.uint32(25).double(message.fee);
        return writer;
      };
      ProgressiveFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      ProgressiveFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.ProgressiveFee();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.fromQuantity = reader.int32();
              break;
            case 2:
              message.toQuantity = reader.int32();
              break;
            case 3:
              message.fee = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      ProgressiveFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      ProgressiveFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.fromQuantity != null && message.hasOwnProperty("fromQuantity")) {
          if (!$util.isInteger(message.fromQuantity))
            return "fromQuantity: integer expected";
        }
        if (message.toQuantity != null && message.hasOwnProperty("toQuantity")) {
          if (!$util.isInteger(message.toQuantity))
            return "toQuantity: integer expected";
        }
        if (message.fee != null && message.hasOwnProperty("fee")) {
          if (typeof message.fee !== "number")
            return "fee: number expected";
        }
        return null;
      };
      ProgressiveFee.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.ProgressiveFee)
          return object;
        let message = new $root.dnse.fo.ProgressiveFee();
        if (object.fromQuantity != null)
          message.fromQuantity = object.fromQuantity | 0;
        if (object.toQuantity != null)
          message.toQuantity = object.toQuantity | 0;
        if (object.fee != null)
          message.fee = Number(object.fee);
        return message;
      };
      ProgressiveFee.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.fromQuantity = 0;
          object.toQuantity = 0;
          object.fee = 0;
        }
        if (message.fromQuantity != null && message.hasOwnProperty("fromQuantity"))
          object.fromQuantity = message.fromQuantity;
        if (message.toQuantity != null && message.hasOwnProperty("toQuantity"))
          object.toQuantity = message.toQuantity;
        if (message.fee != null && message.hasOwnProperty("fee"))
          object.fee = options.json && !isFinite(message.fee) ? String(message.fee) : message.fee;
        return object;
      };
      ProgressiveFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return ProgressiveFee;
    }();
    fo.DerivativeAccount = function() {
      function DerivativeAccount(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeAccount.prototype.accountNo = "";
      DerivativeAccount.prototype.custody = "";
      DerivativeAccount.prototype.flexAccountNo = "";
      DerivativeAccount.prototype.fdsAccountNo = "";
      DerivativeAccount.prototype.status = "";
      DerivativeAccount.prototype.customerType = "";
      DerivativeAccount.prototype.accountType = "";
      DerivativeAccount.prototype.careBy = "";
      DerivativeAccount.prototype.isNet = false;
      DerivativeAccount.prototype.createdDate = null;
      DerivativeAccount.prototype.modifiedDate = null;
      DerivativeAccount.prototype.isTax = false;
      DerivativeAccount.create = function create(properties) {
        return new DerivativeAccount(properties);
      };
      DerivativeAccount.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.custody != null && Object.hasOwnProperty.call(message, "custody"))
          writer.uint32(18).string(message.custody);
        if (message.flexAccountNo != null && Object.hasOwnProperty.call(message, "flexAccountNo"))
          writer.uint32(26).string(message.flexAccountNo);
        if (message.fdsAccountNo != null && Object.hasOwnProperty.call(message, "fdsAccountNo"))
          writer.uint32(34).string(message.fdsAccountNo);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(42).string(message.status);
        if (message.customerType != null && Object.hasOwnProperty.call(message, "customerType"))
          writer.uint32(50).string(message.customerType);
        if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
          writer.uint32(58).string(message.accountType);
        if (message.careBy != null && Object.hasOwnProperty.call(message, "careBy"))
          writer.uint32(66).string(message.careBy);
        if (message.isNet != null && Object.hasOwnProperty.call(message, "isNet"))
          writer.uint32(72).bool(message.isNet);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(90).fork()).ldelim();
        if (message.isTax != null && Object.hasOwnProperty.call(message, "isTax"))
          writer.uint32(96).bool(message.isTax);
        return writer;
      };
      DerivativeAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeAccount();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.custody = reader.string();
              break;
            case 3:
              message.flexAccountNo = reader.string();
              break;
            case 4:
              message.fdsAccountNo = reader.string();
              break;
            case 5:
              message.status = reader.string();
              break;
            case 6:
              message.customerType = reader.string();
              break;
            case 7:
              message.accountType = reader.string();
              break;
            case 8:
              message.careBy = reader.string();
              break;
            case 9:
              message.isNet = reader.bool();
              break;
            case 10:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 11:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 12:
              message.isTax = reader.bool();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.custody != null && message.hasOwnProperty("custody")) {
          if (!$util.isString(message.custody))
            return "custody: string expected";
        }
        if (message.flexAccountNo != null && message.hasOwnProperty("flexAccountNo")) {
          if (!$util.isString(message.flexAccountNo))
            return "flexAccountNo: string expected";
        }
        if (message.fdsAccountNo != null && message.hasOwnProperty("fdsAccountNo")) {
          if (!$util.isString(message.fdsAccountNo))
            return "fdsAccountNo: string expected";
        }
        if (message.status != null && message.hasOwnProperty("status")) {
          if (!$util.isString(message.status))
            return "status: string expected";
        }
        if (message.customerType != null && message.hasOwnProperty("customerType")) {
          if (!$util.isString(message.customerType))
            return "customerType: string expected";
        }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          if (!$util.isString(message.accountType))
            return "accountType: string expected";
        }
        if (message.careBy != null && message.hasOwnProperty("careBy")) {
          if (!$util.isString(message.careBy))
            return "careBy: string expected";
        }
        if (message.isNet != null && message.hasOwnProperty("isNet")) {
          if (typeof message.isNet !== "boolean")
            return "isNet: boolean expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.isTax != null && message.hasOwnProperty("isTax")) {
          if (typeof message.isTax !== "boolean")
            return "isTax: boolean expected";
        }
        return null;
      };
      DerivativeAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeAccount)
          return object;
        let message = new $root.dnse.fo.DerivativeAccount();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.custody != null)
          message.custody = String(object.custody);
        if (object.flexAccountNo != null)
          message.flexAccountNo = String(object.flexAccountNo);
        if (object.fdsAccountNo != null)
          message.fdsAccountNo = String(object.fdsAccountNo);
        if (object.status != null)
          message.status = String(object.status);
        if (object.customerType != null)
          message.customerType = String(object.customerType);
        if (object.accountType != null)
          message.accountType = String(object.accountType);
        if (object.careBy != null)
          message.careBy = String(object.careBy);
        if (object.isNet != null)
          message.isNet = Boolean(object.isNet);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeAccount.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeAccount.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.isTax != null)
          message.isTax = Boolean(object.isTax);
        return message;
      };
      DerivativeAccount.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.accountNo = "";
          object.custody = "";
          object.flexAccountNo = "";
          object.fdsAccountNo = "";
          object.status = "";
          object.customerType = "";
          object.accountType = "";
          object.careBy = "";
          object.isNet = false;
          object.createdDate = null;
          object.modifiedDate = null;
          object.isTax = false;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.custody != null && message.hasOwnProperty("custody"))
          object.custody = message.custody;
        if (message.flexAccountNo != null && message.hasOwnProperty("flexAccountNo"))
          object.flexAccountNo = message.flexAccountNo;
        if (message.fdsAccountNo != null && message.hasOwnProperty("fdsAccountNo"))
          object.fdsAccountNo = message.fdsAccountNo;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = message.status;
        if (message.customerType != null && message.hasOwnProperty("customerType"))
          object.customerType = message.customerType;
        if (message.accountType != null && message.hasOwnProperty("accountType"))
          object.accountType = message.accountType;
        if (message.careBy != null && message.hasOwnProperty("careBy"))
          object.careBy = message.careBy;
        if (message.isNet != null && message.hasOwnProperty("isNet"))
          object.isNet = message.isNet;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.isTax != null && message.hasOwnProperty("isTax"))
          object.isTax = message.isTax;
        return object;
      };
      DerivativeAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeAccount;
    }();
    fo.Instrument = function() {
      function Instrument(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      Instrument.prototype.symbol = "";
      Instrument.prototype.brokerFeeReferenceType = "";
      Instrument.prototype.underlyingSymbol = "";
      Instrument.prototype.nValue = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      Instrument.prototype.tradeLot = 0;
      Instrument.prototype.priceStep = 0;
      Instrument.prototype.listedDate = "";
      Instrument.prototype.deListedDate = "";
      Instrument.prototype.settlementDate = "";
      Instrument.prototype.ceilingPrice = 0;
      Instrument.prototype.floorPrice = 0;
      Instrument.prototype.basicPrice = 0;
      Instrument.prototype.floorCode = 0;
      Instrument.prototype.securityType = 0;
      Instrument.create = function create(properties) {
        return new Instrument(properties);
      };
      Instrument.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(10).string(message.symbol);
        if (message.brokerFeeReferenceType != null && Object.hasOwnProperty.call(message, "brokerFeeReferenceType"))
          writer.uint32(18).string(message.brokerFeeReferenceType);
        if (message.underlyingSymbol != null && Object.hasOwnProperty.call(message, "underlyingSymbol"))
          writer.uint32(26).string(message.underlyingSymbol);
        if (message.nValue != null && Object.hasOwnProperty.call(message, "nValue"))
          writer.uint32(32).int64(message.nValue);
        if (message.tradeLot != null && Object.hasOwnProperty.call(message, "tradeLot"))
          writer.uint32(40).int32(message.tradeLot);
        if (message.priceStep != null && Object.hasOwnProperty.call(message, "priceStep"))
          writer.uint32(49).double(message.priceStep);
        if (message.listedDate != null && Object.hasOwnProperty.call(message, "listedDate"))
          writer.uint32(58).string(message.listedDate);
        if (message.deListedDate != null && Object.hasOwnProperty.call(message, "deListedDate"))
          writer.uint32(66).string(message.deListedDate);
        if (message.settlementDate != null && Object.hasOwnProperty.call(message, "settlementDate"))
          writer.uint32(74).string(message.settlementDate);
        if (message.ceilingPrice != null && Object.hasOwnProperty.call(message, "ceilingPrice"))
          writer.uint32(81).double(message.ceilingPrice);
        if (message.floorPrice != null && Object.hasOwnProperty.call(message, "floorPrice"))
          writer.uint32(89).double(message.floorPrice);
        if (message.basicPrice != null && Object.hasOwnProperty.call(message, "basicPrice"))
          writer.uint32(97).double(message.basicPrice);
        if (message.floorCode != null && Object.hasOwnProperty.call(message, "floorCode"))
          writer.uint32(104).int32(message.floorCode);
        if (message.securityType != null && Object.hasOwnProperty.call(message, "securityType"))
          writer.uint32(112).int32(message.securityType);
        return writer;
      };
      Instrument.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      Instrument.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.Instrument();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.symbol = reader.string();
              break;
            case 2:
              message.brokerFeeReferenceType = reader.string();
              break;
            case 3:
              message.underlyingSymbol = reader.string();
              break;
            case 4:
              message.nValue = reader.int64();
              break;
            case 5:
              message.tradeLot = reader.int32();
              break;
            case 6:
              message.priceStep = reader.double();
              break;
            case 7:
              message.listedDate = reader.string();
              break;
            case 8:
              message.deListedDate = reader.string();
              break;
            case 9:
              message.settlementDate = reader.string();
              break;
            case 10:
              message.ceilingPrice = reader.double();
              break;
            case 11:
              message.floorPrice = reader.double();
              break;
            case 12:
              message.basicPrice = reader.double();
              break;
            case 13:
              message.floorCode = reader.int32();
              break;
            case 14:
              message.securityType = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      Instrument.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      Instrument.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.brokerFeeReferenceType != null && message.hasOwnProperty("brokerFeeReferenceType")) {
          if (!$util.isString(message.brokerFeeReferenceType))
            return "brokerFeeReferenceType: string expected";
        }
        if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol")) {
          if (!$util.isString(message.underlyingSymbol))
            return "underlyingSymbol: string expected";
        }
        if (message.nValue != null && message.hasOwnProperty("nValue")) {
          if (!$util.isInteger(message.nValue) && !(message.nValue && $util.isInteger(message.nValue.low) && $util.isInteger(message.nValue.high)))
            return "nValue: integer|Long expected";
        }
        if (message.tradeLot != null && message.hasOwnProperty("tradeLot")) {
          if (!$util.isInteger(message.tradeLot))
            return "tradeLot: integer expected";
        }
        if (message.priceStep != null && message.hasOwnProperty("priceStep")) {
          if (typeof message.priceStep !== "number")
            return "priceStep: number expected";
        }
        if (message.listedDate != null && message.hasOwnProperty("listedDate")) {
          if (!$util.isString(message.listedDate))
            return "listedDate: string expected";
        }
        if (message.deListedDate != null && message.hasOwnProperty("deListedDate")) {
          if (!$util.isString(message.deListedDate))
            return "deListedDate: string expected";
        }
        if (message.settlementDate != null && message.hasOwnProperty("settlementDate")) {
          if (!$util.isString(message.settlementDate))
            return "settlementDate: string expected";
        }
        if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice")) {
          if (typeof message.ceilingPrice !== "number")
            return "ceilingPrice: number expected";
        }
        if (message.floorPrice != null && message.hasOwnProperty("floorPrice")) {
          if (typeof message.floorPrice !== "number")
            return "floorPrice: number expected";
        }
        if (message.basicPrice != null && message.hasOwnProperty("basicPrice")) {
          if (typeof message.basicPrice !== "number")
            return "basicPrice: number expected";
        }
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          switch (message.floorCode) {
            default:
              return "floorCode: enum value expected";
            case 0:
            case 2:
            case 3:
            case 4:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 30:
              break;
          }
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          switch (message.securityType) {
            default:
              return "securityType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 100:
              break;
          }
        return null;
      };
      Instrument.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.Instrument)
          return object;
        let message = new $root.dnse.fo.Instrument();
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.brokerFeeReferenceType != null)
          message.brokerFeeReferenceType = String(object.brokerFeeReferenceType);
        if (object.underlyingSymbol != null)
          message.underlyingSymbol = String(object.underlyingSymbol);
        if (object.nValue != null) {
          if ($util.Long)
            (message.nValue = $util.Long.fromValue(object.nValue)).unsigned = false;
          else if (typeof object.nValue === "string")
            message.nValue = parseInt(object.nValue, 10);
          else if (typeof object.nValue === "number")
            message.nValue = object.nValue;
          else if (typeof object.nValue === "object")
            message.nValue = new $util.LongBits(object.nValue.low >>> 0, object.nValue.high >>> 0).toNumber();
        }
        if (object.tradeLot != null)
          message.tradeLot = object.tradeLot | 0;
        if (object.priceStep != null)
          message.priceStep = Number(object.priceStep);
        if (object.listedDate != null)
          message.listedDate = String(object.listedDate);
        if (object.deListedDate != null)
          message.deListedDate = String(object.deListedDate);
        if (object.settlementDate != null)
          message.settlementDate = String(object.settlementDate);
        if (object.ceilingPrice != null)
          message.ceilingPrice = Number(object.ceilingPrice);
        if (object.floorPrice != null)
          message.floorPrice = Number(object.floorPrice);
        if (object.basicPrice != null)
          message.basicPrice = Number(object.basicPrice);
        switch (object.floorCode) {
          case "UNKNOWN_EXCHANGE":
          case 0:
            message.floorCode = 0;
            break;
          case "HNX":
          case 2:
            message.floorCode = 2;
            break;
          case "UPCOM":
          case 3:
            message.floorCode = 3;
            break;
          case "HNX_BOND":
          case 4:
            message.floorCode = 4;
            break;
          case "HOSE":
          case 10:
            message.floorCode = 10;
            break;
          case "HOSE_ODD_LOT":
          case 11:
            message.floorCode = 11;
            break;
          case "HNX_DERIVATIVE":
          case 12:
            message.floorCode = 12;
            break;
          case "HNX_DERIVATIVE_BOND":
          case 13:
            message.floorCode = 13;
            break;
          case "HNX_PRIVATE_BOND":
          case 14:
            message.floorCode = 14;
            break;
          case "OTC":
          case 30:
            message.floorCode = 30;
            break;
        }
        switch (object.securityType) {
          case "UNKNOWN_TYPE":
          case 0:
            message.securityType = 0;
            break;
          case "STOCK":
          case 1:
            message.securityType = 1;
            break;
          case "BOND":
          case 2:
            message.securityType = 2;
            break;
          case "MUTUAL_FUND":
          case 3:
            message.securityType = 3;
            break;
          case "ETF":
          case 4:
            message.securityType = 4;
            break;
          case "FUTURE":
          case 5:
            message.securityType = 5;
            break;
          case "OPTION":
          case 6:
            message.securityType = 6;
            break;
          case "COVERED_WARRANT":
          case 7:
            message.securityType = 7;
            break;
          case "FUTURE_INDEX":
          case 8:
            message.securityType = 8;
            break;
          case "FUTURE_BOND":
          case 9:
            message.securityType = 9;
            break;
          case "CORPORATE_BOND":
          case 10:
            message.securityType = 10;
            break;
          case "PRIVATE_BOND":
          case 11:
            message.securityType = 11;
            break;
          case "ALL":
          case 100:
            message.securityType = 100;
            break;
        }
        return message;
      };
      Instrument.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = "";
          object.brokerFeeReferenceType = "";
          object.underlyingSymbol = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.nValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.nValue = options.longs === String ? "0" : 0;
          object.tradeLot = 0;
          object.priceStep = 0;
          object.listedDate = "";
          object.deListedDate = "";
          object.settlementDate = "";
          object.ceilingPrice = 0;
          object.floorPrice = 0;
          object.basicPrice = 0;
          object.floorCode = options.enums === String ? "UNKNOWN_EXCHANGE" : 0;
          object.securityType = options.enums === String ? "UNKNOWN_TYPE" : 0;
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.brokerFeeReferenceType != null && message.hasOwnProperty("brokerFeeReferenceType"))
          object.brokerFeeReferenceType = message.brokerFeeReferenceType;
        if (message.underlyingSymbol != null && message.hasOwnProperty("underlyingSymbol"))
          object.underlyingSymbol = message.underlyingSymbol;
        if (message.nValue != null && message.hasOwnProperty("nValue"))
          if (typeof message.nValue === "number")
            object.nValue = options.longs === String ? String(message.nValue) : message.nValue;
          else
            object.nValue = options.longs === String ? $util.Long.prototype.toString.call(message.nValue) : options.longs === Number ? new $util.LongBits(message.nValue.low >>> 0, message.nValue.high >>> 0).toNumber() : message.nValue;
        if (message.tradeLot != null && message.hasOwnProperty("tradeLot"))
          object.tradeLot = message.tradeLot;
        if (message.priceStep != null && message.hasOwnProperty("priceStep"))
          object.priceStep = options.json && !isFinite(message.priceStep) ? String(message.priceStep) : message.priceStep;
        if (message.listedDate != null && message.hasOwnProperty("listedDate"))
          object.listedDate = message.listedDate;
        if (message.deListedDate != null && message.hasOwnProperty("deListedDate"))
          object.deListedDate = message.deListedDate;
        if (message.settlementDate != null && message.hasOwnProperty("settlementDate"))
          object.settlementDate = message.settlementDate;
        if (message.ceilingPrice != null && message.hasOwnProperty("ceilingPrice"))
          object.ceilingPrice = options.json && !isFinite(message.ceilingPrice) ? String(message.ceilingPrice) : message.ceilingPrice;
        if (message.floorPrice != null && message.hasOwnProperty("floorPrice"))
          object.floorPrice = options.json && !isFinite(message.floorPrice) ? String(message.floorPrice) : message.floorPrice;
        if (message.basicPrice != null && message.hasOwnProperty("basicPrice"))
          object.basicPrice = options.json && !isFinite(message.basicPrice) ? String(message.basicPrice) : message.basicPrice;
        if (message.floorCode != null && message.hasOwnProperty("floorCode"))
          object.floorCode = options.enums === String ? $root.dnse.fo.Exchange[message.floorCode] : message.floorCode;
        if (message.securityType != null && message.hasOwnProperty("securityType"))
          object.securityType = options.enums === String ? $root.dnse.fo.SecurityType[message.securityType] : message.securityType;
        return object;
      };
      Instrument.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return Instrument;
    }();
    fo.DerivativeTradingConfig = function() {
      function DerivativeTradingConfig(properties) {
        this.loanPackages = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeTradingConfig.prototype.accountNo = "";
      DerivativeTradingConfig.prototype.accountType = "";
      DerivativeTradingConfig.prototype.loanPackages = $util.emptyArray;
      DerivativeTradingConfig.prototype.active = false;
      DerivativeTradingConfig.create = function create(properties) {
        return new DerivativeTradingConfig(properties);
      };
      DerivativeTradingConfig.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
          writer.uint32(18).string(message.accountType);
        if (message.loanPackages != null && message.loanPackages.length)
          for (let i = 0; i < message.loanPackages.length; ++i)
            $root.dnse.fo.DerivativeLoanPackage.encode(message.loanPackages[i], writer.uint32(26).fork()).ldelim();
        if (message.active != null && Object.hasOwnProperty.call(message, "active"))
          writer.uint32(32).bool(message.active);
        return writer;
      };
      DerivativeTradingConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeTradingConfig.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeTradingConfig();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.accountType = reader.string();
              break;
            case 3:
              if (!(message.loanPackages && message.loanPackages.length))
                message.loanPackages = [];
              message.loanPackages.push($root.dnse.fo.DerivativeLoanPackage.decode(reader, reader.uint32()));
              break;
            case 4:
              message.active = reader.bool();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeTradingConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeTradingConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          if (!$util.isString(message.accountType))
            return "accountType: string expected";
        }
        if (message.loanPackages != null && message.hasOwnProperty("loanPackages")) {
          if (!Array.isArray(message.loanPackages))
            return "loanPackages: array expected";
          for (let i = 0; i < message.loanPackages.length; ++i) {
            let error = $root.dnse.fo.DerivativeLoanPackage.verify(message.loanPackages[i]);
            if (error)
              return "loanPackages." + error;
          }
        }
        if (message.active != null && message.hasOwnProperty("active")) {
          if (typeof message.active !== "boolean")
            return "active: boolean expected";
        }
        return null;
      };
      DerivativeTradingConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeTradingConfig)
          return object;
        let message = new $root.dnse.fo.DerivativeTradingConfig();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.accountType != null)
          message.accountType = String(object.accountType);
        if (object.loanPackages) {
          if (!Array.isArray(object.loanPackages))
            throw TypeError(".dnse.fo.DerivativeTradingConfig.loanPackages: array expected");
          message.loanPackages = [];
          for (let i = 0; i < object.loanPackages.length; ++i) {
            if (typeof object.loanPackages[i] !== "object")
              throw TypeError(".dnse.fo.DerivativeTradingConfig.loanPackages: object expected");
            message.loanPackages[i] = $root.dnse.fo.DerivativeLoanPackage.fromObject(object.loanPackages[i]);
          }
        }
        if (object.active != null)
          message.active = Boolean(object.active);
        return message;
      };
      DerivativeTradingConfig.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.loanPackages = [];
        if (options.defaults) {
          object.accountNo = "";
          object.accountType = "";
          object.active = false;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.accountType != null && message.hasOwnProperty("accountType"))
          object.accountType = message.accountType;
        if (message.loanPackages && message.loanPackages.length) {
          object.loanPackages = [];
          for (let j = 0; j < message.loanPackages.length; ++j)
            object.loanPackages[j] = $root.dnse.fo.DerivativeLoanPackage.toObject(message.loanPackages[j], options);
        }
        if (message.active != null && message.hasOwnProperty("active"))
          object.active = message.active;
        return object;
      };
      DerivativeTradingConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeTradingConfig;
    }();
    fo.DerivativeSystemConfig = function() {
      function DerivativeSystemConfig(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeSystemConfig.prototype.currentTradingDate = "";
      DerivativeSystemConfig.prototype.nextTradingDate = "";
      DerivativeSystemConfig.prototype.sellDutyFee = 0;
      DerivativeSystemConfig.prototype.daysInYear = 0;
      DerivativeSystemConfig.prototype.futureIndexHnxFee = 0;
      DerivativeSystemConfig.prototype.futureBondHnxFee = 0;
      DerivativeSystemConfig.create = function create(properties) {
        return new DerivativeSystemConfig(properties);
      };
      DerivativeSystemConfig.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.currentTradingDate != null && Object.hasOwnProperty.call(message, "currentTradingDate"))
          writer.uint32(10).string(message.currentTradingDate);
        if (message.nextTradingDate != null && Object.hasOwnProperty.call(message, "nextTradingDate"))
          writer.uint32(18).string(message.nextTradingDate);
        if (message.sellDutyFee != null && Object.hasOwnProperty.call(message, "sellDutyFee"))
          writer.uint32(25).double(message.sellDutyFee);
        if (message.daysInYear != null && Object.hasOwnProperty.call(message, "daysInYear"))
          writer.uint32(32).int32(message.daysInYear);
        if (message.futureIndexHnxFee != null && Object.hasOwnProperty.call(message, "futureIndexHnxFee"))
          writer.uint32(41).double(message.futureIndexHnxFee);
        if (message.futureBondHnxFee != null && Object.hasOwnProperty.call(message, "futureBondHnxFee"))
          writer.uint32(49).double(message.futureBondHnxFee);
        return writer;
      };
      DerivativeSystemConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeSystemConfig.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeSystemConfig();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.currentTradingDate = reader.string();
              break;
            case 2:
              message.nextTradingDate = reader.string();
              break;
            case 3:
              message.sellDutyFee = reader.double();
              break;
            case 4:
              message.daysInYear = reader.int32();
              break;
            case 5:
              message.futureIndexHnxFee = reader.double();
              break;
            case 6:
              message.futureBondHnxFee = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeSystemConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeSystemConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.currentTradingDate != null && message.hasOwnProperty("currentTradingDate")) {
          if (!$util.isString(message.currentTradingDate))
            return "currentTradingDate: string expected";
        }
        if (message.nextTradingDate != null && message.hasOwnProperty("nextTradingDate")) {
          if (!$util.isString(message.nextTradingDate))
            return "nextTradingDate: string expected";
        }
        if (message.sellDutyFee != null && message.hasOwnProperty("sellDutyFee")) {
          if (typeof message.sellDutyFee !== "number")
            return "sellDutyFee: number expected";
        }
        if (message.daysInYear != null && message.hasOwnProperty("daysInYear")) {
          if (!$util.isInteger(message.daysInYear))
            return "daysInYear: integer expected";
        }
        if (message.futureIndexHnxFee != null && message.hasOwnProperty("futureIndexHnxFee")) {
          if (typeof message.futureIndexHnxFee !== "number")
            return "futureIndexHnxFee: number expected";
        }
        if (message.futureBondHnxFee != null && message.hasOwnProperty("futureBondHnxFee")) {
          if (typeof message.futureBondHnxFee !== "number")
            return "futureBondHnxFee: number expected";
        }
        return null;
      };
      DerivativeSystemConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeSystemConfig)
          return object;
        let message = new $root.dnse.fo.DerivativeSystemConfig();
        if (object.currentTradingDate != null)
          message.currentTradingDate = String(object.currentTradingDate);
        if (object.nextTradingDate != null)
          message.nextTradingDate = String(object.nextTradingDate);
        if (object.sellDutyFee != null)
          message.sellDutyFee = Number(object.sellDutyFee);
        if (object.daysInYear != null)
          message.daysInYear = object.daysInYear | 0;
        if (object.futureIndexHnxFee != null)
          message.futureIndexHnxFee = Number(object.futureIndexHnxFee);
        if (object.futureBondHnxFee != null)
          message.futureBondHnxFee = Number(object.futureBondHnxFee);
        return message;
      };
      DerivativeSystemConfig.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.currentTradingDate = "";
          object.nextTradingDate = "";
          object.sellDutyFee = 0;
          object.daysInYear = 0;
          object.futureIndexHnxFee = 0;
          object.futureBondHnxFee = 0;
        }
        if (message.currentTradingDate != null && message.hasOwnProperty("currentTradingDate"))
          object.currentTradingDate = message.currentTradingDate;
        if (message.nextTradingDate != null && message.hasOwnProperty("nextTradingDate"))
          object.nextTradingDate = message.nextTradingDate;
        if (message.sellDutyFee != null && message.hasOwnProperty("sellDutyFee"))
          object.sellDutyFee = options.json && !isFinite(message.sellDutyFee) ? String(message.sellDutyFee) : message.sellDutyFee;
        if (message.daysInYear != null && message.hasOwnProperty("daysInYear"))
          object.daysInYear = message.daysInYear;
        if (message.futureIndexHnxFee != null && message.hasOwnProperty("futureIndexHnxFee"))
          object.futureIndexHnxFee = options.json && !isFinite(message.futureIndexHnxFee) ? String(message.futureIndexHnxFee) : message.futureIndexHnxFee;
        if (message.futureBondHnxFee != null && message.hasOwnProperty("futureBondHnxFee"))
          object.futureBondHnxFee = options.json && !isFinite(message.futureBondHnxFee) ? String(message.futureBondHnxFee) : message.futureBondHnxFee;
        return object;
      };
      DerivativeSystemConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeSystemConfig;
    }();
    fo.DerivativeLoanPackageAccountWrap = function() {
      function DerivativeLoanPackageAccountWrap(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoanPackageAccountWrap.prototype.loanPackageAccount = null;
      DerivativeLoanPackageAccountWrap.prototype.metadata = null;
      DerivativeLoanPackageAccountWrap.create = function create(properties) {
        return new DerivativeLoanPackageAccountWrap(properties);
      };
      DerivativeLoanPackageAccountWrap.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.loanPackageAccount != null && Object.hasOwnProperty.call(message, "loanPackageAccount"))
          $root.dnse.fo.DerivativeLoanPackageAccount.encode(message.loanPackageAccount, writer.uint32(10).fork()).ldelim();
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          $root.dnse.fo.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      DerivativeLoanPackageAccountWrap.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoanPackageAccountWrap.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoanPackageAccountWrap();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.loanPackageAccount = $root.dnse.fo.DerivativeLoanPackageAccount.decode(reader, reader.uint32());
              break;
            case 2:
              message.metadata = $root.dnse.fo.Metadata.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoanPackageAccountWrap.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoanPackageAccountWrap.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.loanPackageAccount != null && message.hasOwnProperty("loanPackageAccount")) {
          let error = $root.dnse.fo.DerivativeLoanPackageAccount.verify(message.loanPackageAccount);
          if (error)
            return "loanPackageAccount." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          let error = $root.dnse.fo.Metadata.verify(message.metadata);
          if (error)
            return "metadata." + error;
        }
        return null;
      };
      DerivativeLoanPackageAccountWrap.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoanPackageAccountWrap)
          return object;
        let message = new $root.dnse.fo.DerivativeLoanPackageAccountWrap();
        if (object.loanPackageAccount != null) {
          if (typeof object.loanPackageAccount !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPackageAccountWrap.loanPackageAccount: object expected");
          message.loanPackageAccount = $root.dnse.fo.DerivativeLoanPackageAccount.fromObject(object.loanPackageAccount);
        }
        if (object.metadata != null) {
          if (typeof object.metadata !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPackageAccountWrap.metadata: object expected");
          message.metadata = $root.dnse.fo.Metadata.fromObject(object.metadata);
        }
        return message;
      };
      DerivativeLoanPackageAccountWrap.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.loanPackageAccount = null;
          object.metadata = null;
        }
        if (message.loanPackageAccount != null && message.hasOwnProperty("loanPackageAccount"))
          object.loanPackageAccount = $root.dnse.fo.DerivativeLoanPackageAccount.toObject(message.loanPackageAccount, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = $root.dnse.fo.Metadata.toObject(message.metadata, options);
        return object;
      };
      DerivativeLoanPackageAccountWrap.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeLoanPackageAccountWrap;
    }();
    fo.DerivativeIntraDayCashEvent = function() {
      function DerivativeIntraDayCashEvent(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeIntraDayCashEvent.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeIntraDayCashEvent.prototype.txNum = "";
      DerivativeIntraDayCashEvent.prototype.txCode = "";
      DerivativeIntraDayCashEvent.prototype.dtaAccount = "";
      DerivativeIntraDayCashEvent.prototype.field = "";
      DerivativeIntraDayCashEvent.prototype.value = 0;
      DerivativeIntraDayCashEvent.prototype.action = 0;
      DerivativeIntraDayCashEvent.prototype.txTime = null;
      DerivativeIntraDayCashEvent.prototype.bizDate = "";
      DerivativeIntraDayCashEvent.prototype.isRevert = false;
      DerivativeIntraDayCashEvent.prototype.ref = "";
      DerivativeIntraDayCashEvent.prototype.flag = "";
      DerivativeIntraDayCashEvent.prototype.errorMsg = "";
      DerivativeIntraDayCashEvent.create = function create(properties) {
        return new DerivativeIntraDayCashEvent(properties);
      };
      DerivativeIntraDayCashEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.txNum != null && Object.hasOwnProperty.call(message, "txNum"))
          writer.uint32(18).string(message.txNum);
        if (message.txCode != null && Object.hasOwnProperty.call(message, "txCode"))
          writer.uint32(26).string(message.txCode);
        if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
          writer.uint32(34).string(message.dtaAccount);
        if (message.field != null && Object.hasOwnProperty.call(message, "field"))
          writer.uint32(42).string(message.field);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(49).double(message.value);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(56).int32(message.action);
        if (message.txTime != null && Object.hasOwnProperty.call(message, "txTime"))
          $root.google.protobuf.Timestamp.encode(message.txTime, writer.uint32(66).fork()).ldelim();
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          writer.uint32(74).string(message.bizDate);
        if (message.isRevert != null && Object.hasOwnProperty.call(message, "isRevert"))
          writer.uint32(80).bool(message.isRevert);
        if (message.ref != null && Object.hasOwnProperty.call(message, "ref"))
          writer.uint32(90).string(message.ref);
        if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
          writer.uint32(98).string(message.flag);
        if (message.errorMsg != null && Object.hasOwnProperty.call(message, "errorMsg"))
          writer.uint32(106).string(message.errorMsg);
        return writer;
      };
      DerivativeIntraDayCashEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeIntraDayCashEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeIntraDayCashEvent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.txNum = reader.string();
              break;
            case 3:
              message.txCode = reader.string();
              break;
            case 4:
              message.dtaAccount = reader.string();
              break;
            case 5:
              message.field = reader.string();
              break;
            case 6:
              message.value = reader.double();
              break;
            case 7:
              message.action = reader.int32();
              break;
            case 8:
              message.txTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 9:
              message.bizDate = reader.string();
              break;
            case 10:
              message.isRevert = reader.bool();
              break;
            case 11:
              message.ref = reader.string();
              break;
            case 12:
              message.flag = reader.string();
              break;
            case 13:
              message.errorMsg = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeIntraDayCashEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeIntraDayCashEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.txNum != null && message.hasOwnProperty("txNum")) {
          if (!$util.isString(message.txNum))
            return "txNum: string expected";
        }
        if (message.txCode != null && message.hasOwnProperty("txCode")) {
          if (!$util.isString(message.txCode))
            return "txCode: string expected";
        }
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
          if (!$util.isString(message.dtaAccount))
            return "dtaAccount: string expected";
        }
        if (message.field != null && message.hasOwnProperty("field")) {
          if (!$util.isString(message.field))
            return "field: string expected";
        }
        if (message.value != null && message.hasOwnProperty("value")) {
          if (typeof message.value !== "number")
            return "value: number expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.txTime != null && message.hasOwnProperty("txTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.txTime);
          if (error)
            return "txTime." + error;
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          if (!$util.isString(message.bizDate))
            return "bizDate: string expected";
        }
        if (message.isRevert != null && message.hasOwnProperty("isRevert")) {
          if (typeof message.isRevert !== "boolean")
            return "isRevert: boolean expected";
        }
        if (message.ref != null && message.hasOwnProperty("ref")) {
          if (!$util.isString(message.ref))
            return "ref: string expected";
        }
        if (message.flag != null && message.hasOwnProperty("flag")) {
          if (!$util.isString(message.flag))
            return "flag: string expected";
        }
        if (message.errorMsg != null && message.hasOwnProperty("errorMsg")) {
          if (!$util.isString(message.errorMsg))
            return "errorMsg: string expected";
        }
        return null;
      };
      DerivativeIntraDayCashEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeIntraDayCashEvent)
          return object;
        let message = new $root.dnse.fo.DerivativeIntraDayCashEvent();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.txNum != null)
          message.txNum = String(object.txNum);
        if (object.txCode != null)
          message.txCode = String(object.txCode);
        if (object.dtaAccount != null)
          message.dtaAccount = String(object.dtaAccount);
        if (object.field != null)
          message.field = String(object.field);
        if (object.value != null)
          message.value = Number(object.value);
        switch (object.action) {
          case "C":
          case 0:
            message.action = 0;
            break;
          case "D":
          case 1:
            message.action = 1;
            break;
          case "U":
          case 2:
            message.action = 2;
            break;
        }
        if (object.txTime != null) {
          if (typeof object.txTime !== "object")
            throw TypeError(".dnse.fo.DerivativeIntraDayCashEvent.txTime: object expected");
          message.txTime = $root.google.protobuf.Timestamp.fromObject(object.txTime);
        }
        if (object.bizDate != null)
          message.bizDate = String(object.bizDate);
        if (object.isRevert != null)
          message.isRevert = Boolean(object.isRevert);
        if (object.ref != null)
          message.ref = String(object.ref);
        if (object.flag != null)
          message.flag = String(object.flag);
        if (object.errorMsg != null)
          message.errorMsg = String(object.errorMsg);
        return message;
      };
      DerivativeIntraDayCashEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.txNum = "";
          object.txCode = "";
          object.dtaAccount = "";
          object.field = "";
          object.value = 0;
          object.action = options.enums === String ? "C" : 0;
          object.txTime = null;
          object.bizDate = "";
          object.isRevert = false;
          object.ref = "";
          object.flag = "";
          object.errorMsg = "";
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.txNum != null && message.hasOwnProperty("txNum"))
          object.txNum = message.txNum;
        if (message.txCode != null && message.hasOwnProperty("txCode"))
          object.txCode = message.txCode;
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
          object.dtaAccount = message.dtaAccount;
        if (message.field != null && message.hasOwnProperty("field"))
          object.field = message.field;
        if (message.value != null && message.hasOwnProperty("value"))
          object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.IntraDayAction[message.action] : message.action;
        if (message.txTime != null && message.hasOwnProperty("txTime"))
          object.txTime = $root.google.protobuf.Timestamp.toObject(message.txTime, options);
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = message.bizDate;
        if (message.isRevert != null && message.hasOwnProperty("isRevert"))
          object.isRevert = message.isRevert;
        if (message.ref != null && message.hasOwnProperty("ref"))
          object.ref = message.ref;
        if (message.flag != null && message.hasOwnProperty("flag"))
          object.flag = message.flag;
        if (message.errorMsg != null && message.hasOwnProperty("errorMsg"))
          object.errorMsg = message.errorMsg;
        return object;
      };
      DerivativeIntraDayCashEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeIntraDayCashEvent;
    }();
    fo.SettlementPriceEvent = function() {
      function SettlementPriceEvent(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      SettlementPriceEvent.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      SettlementPriceEvent.prototype.type = "";
      SettlementPriceEvent.prototype.symbol = "";
      SettlementPriceEvent.prototype.dsp = 0;
      SettlementPriceEvent.prototype.createTime = null;
      SettlementPriceEvent.create = function create(properties) {
        return new SettlementPriceEvent(properties);
      };
      SettlementPriceEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(18).string(message.type);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(26).string(message.symbol);
        if (message.dsp != null && Object.hasOwnProperty.call(message, "dsp"))
          writer.uint32(33).double(message.dsp);
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
          $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(42).fork()).ldelim();
        return writer;
      };
      SettlementPriceEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      SettlementPriceEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.SettlementPriceEvent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.type = reader.string();
              break;
            case 3:
              message.symbol = reader.string();
              break;
            case 4:
              message.dsp = reader.double();
              break;
            case 5:
              message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      SettlementPriceEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      SettlementPriceEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.dsp != null && message.hasOwnProperty("dsp")) {
          if (typeof message.dsp !== "number")
            return "dsp: number expected";
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createTime);
          if (error)
            return "createTime." + error;
        }
        return null;
      };
      SettlementPriceEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.SettlementPriceEvent)
          return object;
        let message = new $root.dnse.fo.SettlementPriceEvent();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.type != null)
          message.type = String(object.type);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.dsp != null)
          message.dsp = Number(object.dsp);
        if (object.createTime != null) {
          if (typeof object.createTime !== "object")
            throw TypeError(".dnse.fo.SettlementPriceEvent.createTime: object expected");
          message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
        }
        return message;
      };
      SettlementPriceEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.type = "";
          object.symbol = "";
          object.dsp = 0;
          object.createTime = null;
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.dsp != null && message.hasOwnProperty("dsp"))
          object.dsp = options.json && !isFinite(message.dsp) ? String(message.dsp) : message.dsp;
        if (message.createTime != null && message.hasOwnProperty("createTime"))
          object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
        return object;
      };
      SettlementPriceEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return SettlementPriceEvent;
    }();
    fo.PaymentObligation = function() {
      function PaymentObligation(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      PaymentObligation.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      PaymentObligation.prototype.type = "";
      PaymentObligation.prototype.dtaAccount = "";
      PaymentObligation.prototype.dmaAccount = "";
      PaymentObligation.prototype.positionFeeAmount = 0;
      PaymentObligation.prototype.marginFeeAmount = 0;
      PaymentObligation.prototype.marginFeeAccumulate = 0;
      PaymentObligation.prototype.imInterestAmount = 0;
      PaymentObligation.prototype.vm = 0;
      PaymentObligation.prototype.feeAmountHNX = 0;
      PaymentObligation.prototype.feeAmountDNSE = 0;
      PaymentObligation.prototype.taxAmount = 0;
      PaymentObligation.prototype.createTime = null;
      PaymentObligation.prototype.cashOnHand = 0;
      PaymentObligation.prototype.totalOverDraftAmount = 0;
      PaymentObligation.prototype.maturityFee = 0;
      PaymentObligation.create = function create(properties) {
        return new PaymentObligation(properties);
      };
      PaymentObligation.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(18).string(message.type);
        if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
          writer.uint32(26).string(message.dtaAccount);
        if (message.dmaAccount != null && Object.hasOwnProperty.call(message, "dmaAccount"))
          writer.uint32(34).string(message.dmaAccount);
        if (message.positionFeeAmount != null && Object.hasOwnProperty.call(message, "positionFeeAmount"))
          writer.uint32(41).double(message.positionFeeAmount);
        if (message.marginFeeAmount != null && Object.hasOwnProperty.call(message, "marginFeeAmount"))
          writer.uint32(49).double(message.marginFeeAmount);
        if (message.marginFeeAccumulate != null && Object.hasOwnProperty.call(message, "marginFeeAccumulate"))
          writer.uint32(57).double(message.marginFeeAccumulate);
        if (message.imInterestAmount != null && Object.hasOwnProperty.call(message, "imInterestAmount"))
          writer.uint32(65).double(message.imInterestAmount);
        if (message.vm != null && Object.hasOwnProperty.call(message, "vm"))
          writer.uint32(73).double(message.vm);
        if (message.feeAmountHNX != null && Object.hasOwnProperty.call(message, "feeAmountHNX"))
          writer.uint32(81).double(message.feeAmountHNX);
        if (message.feeAmountDNSE != null && Object.hasOwnProperty.call(message, "feeAmountDNSE"))
          writer.uint32(89).double(message.feeAmountDNSE);
        if (message.taxAmount != null && Object.hasOwnProperty.call(message, "taxAmount"))
          writer.uint32(97).double(message.taxAmount);
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
          $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(106).fork()).ldelim();
        if (message.cashOnHand != null && Object.hasOwnProperty.call(message, "cashOnHand"))
          writer.uint32(113).double(message.cashOnHand);
        if (message.totalOverDraftAmount != null && Object.hasOwnProperty.call(message, "totalOverDraftAmount"))
          writer.uint32(121).double(message.totalOverDraftAmount);
        if (message.maturityFee != null && Object.hasOwnProperty.call(message, "maturityFee"))
          writer.uint32(129).double(message.maturityFee);
        return writer;
      };
      PaymentObligation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      PaymentObligation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.PaymentObligation();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.type = reader.string();
              break;
            case 3:
              message.dtaAccount = reader.string();
              break;
            case 4:
              message.dmaAccount = reader.string();
              break;
            case 5:
              message.positionFeeAmount = reader.double();
              break;
            case 6:
              message.marginFeeAmount = reader.double();
              break;
            case 7:
              message.marginFeeAccumulate = reader.double();
              break;
            case 8:
              message.imInterestAmount = reader.double();
              break;
            case 9:
              message.vm = reader.double();
              break;
            case 10:
              message.feeAmountHNX = reader.double();
              break;
            case 11:
              message.feeAmountDNSE = reader.double();
              break;
            case 12:
              message.taxAmount = reader.double();
              break;
            case 13:
              message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 14:
              message.cashOnHand = reader.double();
              break;
            case 15:
              message.totalOverDraftAmount = reader.double();
              break;
            case 16:
              message.maturityFee = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      PaymentObligation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      PaymentObligation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
          if (!$util.isString(message.dtaAccount))
            return "dtaAccount: string expected";
        }
        if (message.dmaAccount != null && message.hasOwnProperty("dmaAccount")) {
          if (!$util.isString(message.dmaAccount))
            return "dmaAccount: string expected";
        }
        if (message.positionFeeAmount != null && message.hasOwnProperty("positionFeeAmount")) {
          if (typeof message.positionFeeAmount !== "number")
            return "positionFeeAmount: number expected";
        }
        if (message.marginFeeAmount != null && message.hasOwnProperty("marginFeeAmount")) {
          if (typeof message.marginFeeAmount !== "number")
            return "marginFeeAmount: number expected";
        }
        if (message.marginFeeAccumulate != null && message.hasOwnProperty("marginFeeAccumulate")) {
          if (typeof message.marginFeeAccumulate !== "number")
            return "marginFeeAccumulate: number expected";
        }
        if (message.imInterestAmount != null && message.hasOwnProperty("imInterestAmount")) {
          if (typeof message.imInterestAmount !== "number")
            return "imInterestAmount: number expected";
        }
        if (message.vm != null && message.hasOwnProperty("vm")) {
          if (typeof message.vm !== "number")
            return "vm: number expected";
        }
        if (message.feeAmountHNX != null && message.hasOwnProperty("feeAmountHNX")) {
          if (typeof message.feeAmountHNX !== "number")
            return "feeAmountHNX: number expected";
        }
        if (message.feeAmountDNSE != null && message.hasOwnProperty("feeAmountDNSE")) {
          if (typeof message.feeAmountDNSE !== "number")
            return "feeAmountDNSE: number expected";
        }
        if (message.taxAmount != null && message.hasOwnProperty("taxAmount")) {
          if (typeof message.taxAmount !== "number")
            return "taxAmount: number expected";
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createTime);
          if (error)
            return "createTime." + error;
        }
        if (message.cashOnHand != null && message.hasOwnProperty("cashOnHand")) {
          if (typeof message.cashOnHand !== "number")
            return "cashOnHand: number expected";
        }
        if (message.totalOverDraftAmount != null && message.hasOwnProperty("totalOverDraftAmount")) {
          if (typeof message.totalOverDraftAmount !== "number")
            return "totalOverDraftAmount: number expected";
        }
        if (message.maturityFee != null && message.hasOwnProperty("maturityFee")) {
          if (typeof message.maturityFee !== "number")
            return "maturityFee: number expected";
        }
        return null;
      };
      PaymentObligation.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.PaymentObligation)
          return object;
        let message = new $root.dnse.fo.PaymentObligation();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.type != null)
          message.type = String(object.type);
        if (object.dtaAccount != null)
          message.dtaAccount = String(object.dtaAccount);
        if (object.dmaAccount != null)
          message.dmaAccount = String(object.dmaAccount);
        if (object.positionFeeAmount != null)
          message.positionFeeAmount = Number(object.positionFeeAmount);
        if (object.marginFeeAmount != null)
          message.marginFeeAmount = Number(object.marginFeeAmount);
        if (object.marginFeeAccumulate != null)
          message.marginFeeAccumulate = Number(object.marginFeeAccumulate);
        if (object.imInterestAmount != null)
          message.imInterestAmount = Number(object.imInterestAmount);
        if (object.vm != null)
          message.vm = Number(object.vm);
        if (object.feeAmountHNX != null)
          message.feeAmountHNX = Number(object.feeAmountHNX);
        if (object.feeAmountDNSE != null)
          message.feeAmountDNSE = Number(object.feeAmountDNSE);
        if (object.taxAmount != null)
          message.taxAmount = Number(object.taxAmount);
        if (object.createTime != null) {
          if (typeof object.createTime !== "object")
            throw TypeError(".dnse.fo.PaymentObligation.createTime: object expected");
          message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
        }
        if (object.cashOnHand != null)
          message.cashOnHand = Number(object.cashOnHand);
        if (object.totalOverDraftAmount != null)
          message.totalOverDraftAmount = Number(object.totalOverDraftAmount);
        if (object.maturityFee != null)
          message.maturityFee = Number(object.maturityFee);
        return message;
      };
      PaymentObligation.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.type = "";
          object.dtaAccount = "";
          object.dmaAccount = "";
          object.positionFeeAmount = 0;
          object.marginFeeAmount = 0;
          object.marginFeeAccumulate = 0;
          object.imInterestAmount = 0;
          object.vm = 0;
          object.feeAmountHNX = 0;
          object.feeAmountDNSE = 0;
          object.taxAmount = 0;
          object.createTime = null;
          object.cashOnHand = 0;
          object.totalOverDraftAmount = 0;
          object.maturityFee = 0;
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
          object.dtaAccount = message.dtaAccount;
        if (message.dmaAccount != null && message.hasOwnProperty("dmaAccount"))
          object.dmaAccount = message.dmaAccount;
        if (message.positionFeeAmount != null && message.hasOwnProperty("positionFeeAmount"))
          object.positionFeeAmount = options.json && !isFinite(message.positionFeeAmount) ? String(message.positionFeeAmount) : message.positionFeeAmount;
        if (message.marginFeeAmount != null && message.hasOwnProperty("marginFeeAmount"))
          object.marginFeeAmount = options.json && !isFinite(message.marginFeeAmount) ? String(message.marginFeeAmount) : message.marginFeeAmount;
        if (message.marginFeeAccumulate != null && message.hasOwnProperty("marginFeeAccumulate"))
          object.marginFeeAccumulate = options.json && !isFinite(message.marginFeeAccumulate) ? String(message.marginFeeAccumulate) : message.marginFeeAccumulate;
        if (message.imInterestAmount != null && message.hasOwnProperty("imInterestAmount"))
          object.imInterestAmount = options.json && !isFinite(message.imInterestAmount) ? String(message.imInterestAmount) : message.imInterestAmount;
        if (message.vm != null && message.hasOwnProperty("vm"))
          object.vm = options.json && !isFinite(message.vm) ? String(message.vm) : message.vm;
        if (message.feeAmountHNX != null && message.hasOwnProperty("feeAmountHNX"))
          object.feeAmountHNX = options.json && !isFinite(message.feeAmountHNX) ? String(message.feeAmountHNX) : message.feeAmountHNX;
        if (message.feeAmountDNSE != null && message.hasOwnProperty("feeAmountDNSE"))
          object.feeAmountDNSE = options.json && !isFinite(message.feeAmountDNSE) ? String(message.feeAmountDNSE) : message.feeAmountDNSE;
        if (message.taxAmount != null && message.hasOwnProperty("taxAmount"))
          object.taxAmount = options.json && !isFinite(message.taxAmount) ? String(message.taxAmount) : message.taxAmount;
        if (message.createTime != null && message.hasOwnProperty("createTime"))
          object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
        if (message.cashOnHand != null && message.hasOwnProperty("cashOnHand"))
          object.cashOnHand = options.json && !isFinite(message.cashOnHand) ? String(message.cashOnHand) : message.cashOnHand;
        if (message.totalOverDraftAmount != null && message.hasOwnProperty("totalOverDraftAmount"))
          object.totalOverDraftAmount = options.json && !isFinite(message.totalOverDraftAmount) ? String(message.totalOverDraftAmount) : message.totalOverDraftAmount;
        if (message.maturityFee != null && message.hasOwnProperty("maturityFee"))
          object.maturityFee = options.json && !isFinite(message.maturityFee) ? String(message.maturityFee) : message.maturityFee;
        return object;
      };
      PaymentObligation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return PaymentObligation;
    }();
    fo.PaidControlMessage = function() {
      function PaidControlMessage(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      PaidControlMessage.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      PaidControlMessage.prototype.type = "";
      PaidControlMessage.prototype.value = "";
      PaidControlMessage.prototype.bizDate = null;
      PaidControlMessage.prototype.createTime = null;
      PaidControlMessage.create = function create(properties) {
        return new PaidControlMessage(properties);
      };
      PaidControlMessage.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(18).string(message.type);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(26).string(message.value);
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          $root.google.protobuf.Timestamp.encode(message.bizDate, writer.uint32(34).fork()).ldelim();
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
          $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(42).fork()).ldelim();
        return writer;
      };
      PaidControlMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      PaidControlMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.PaidControlMessage();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.type = reader.string();
              break;
            case 3:
              message.value = reader.string();
              break;
            case 4:
              message.bizDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 5:
              message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      PaidControlMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      PaidControlMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.value != null && message.hasOwnProperty("value")) {
          if (!$util.isString(message.value))
            return "value: string expected";
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.bizDate);
          if (error)
            return "bizDate." + error;
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createTime);
          if (error)
            return "createTime." + error;
        }
        return null;
      };
      PaidControlMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.PaidControlMessage)
          return object;
        let message = new $root.dnse.fo.PaidControlMessage();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.type != null)
          message.type = String(object.type);
        if (object.value != null)
          message.value = String(object.value);
        if (object.bizDate != null) {
          if (typeof object.bizDate !== "object")
            throw TypeError(".dnse.fo.PaidControlMessage.bizDate: object expected");
          message.bizDate = $root.google.protobuf.Timestamp.fromObject(object.bizDate);
        }
        if (object.createTime != null) {
          if (typeof object.createTime !== "object")
            throw TypeError(".dnse.fo.PaidControlMessage.createTime: object expected");
          message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
        }
        return message;
      };
      PaidControlMessage.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.type = "";
          object.value = "";
          object.bizDate = null;
          object.createTime = null;
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.value != null && message.hasOwnProperty("value"))
          object.value = message.value;
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = $root.google.protobuf.Timestamp.toObject(message.bizDate, options);
        if (message.createTime != null && message.hasOwnProperty("createTime"))
          object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
        return object;
      };
      PaidControlMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return PaidControlMessage;
    }();
    fo.DerivativeDealWrap = function() {
      function DerivativeDealWrap(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeDealWrap.prototype.derivativeDeal = null;
      DerivativeDealWrap.prototype.metadata = null;
      DerivativeDealWrap.create = function create(properties) {
        return new DerivativeDealWrap(properties);
      };
      DerivativeDealWrap.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.derivativeDeal != null && Object.hasOwnProperty.call(message, "derivativeDeal"))
          $root.dnse.fo.DerivativeDeal.encode(message.derivativeDeal, writer.uint32(10).fork()).ldelim();
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          $root.dnse.fo.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      DerivativeDealWrap.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeDealWrap.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeDealWrap();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.derivativeDeal = $root.dnse.fo.DerivativeDeal.decode(reader, reader.uint32());
              break;
            case 2:
              message.metadata = $root.dnse.fo.Metadata.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeDealWrap.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeDealWrap.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.derivativeDeal != null && message.hasOwnProperty("derivativeDeal")) {
          let error = $root.dnse.fo.DerivativeDeal.verify(message.derivativeDeal);
          if (error)
            return "derivativeDeal." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          let error = $root.dnse.fo.Metadata.verify(message.metadata);
          if (error)
            return "metadata." + error;
        }
        return null;
      };
      DerivativeDealWrap.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeDealWrap)
          return object;
        let message = new $root.dnse.fo.DerivativeDealWrap();
        if (object.derivativeDeal != null) {
          if (typeof object.derivativeDeal !== "object")
            throw TypeError(".dnse.fo.DerivativeDealWrap.derivativeDeal: object expected");
          message.derivativeDeal = $root.dnse.fo.DerivativeDeal.fromObject(object.derivativeDeal);
        }
        if (object.metadata != null) {
          if (typeof object.metadata !== "object")
            throw TypeError(".dnse.fo.DerivativeDealWrap.metadata: object expected");
          message.metadata = $root.dnse.fo.Metadata.fromObject(object.metadata);
        }
        return message;
      };
      DerivativeDealWrap.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.derivativeDeal = null;
          object.metadata = null;
        }
        if (message.derivativeDeal != null && message.hasOwnProperty("derivativeDeal"))
          object.derivativeDeal = $root.dnse.fo.DerivativeDeal.toObject(message.derivativeDeal, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = $root.dnse.fo.Metadata.toObject(message.metadata, options);
        return object;
      };
      DerivativeDealWrap.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeDealWrap;
    }();
    fo.DerivativeDeal = function() {
      function DerivativeDeal(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeDeal.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDeal.prototype.accountNo = "";
      DerivativeDeal.prototype.side = 0;
      DerivativeDeal.prototype.status = 0;
      DerivativeDeal.prototype.loanPackageId = 0;
      DerivativeDeal.prototype.symbol = "";
      DerivativeDeal.prototype.secure = 0;
      DerivativeDeal.prototype.openQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDeal.prototype.closedQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDeal.prototype.accumulateQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDeal.prototype.overNightQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDeal.prototype.breakEvenPrice = 0;
      DerivativeDeal.prototype.costPrice = 0;
      DerivativeDeal.prototype.costPriceVM = 0;
      DerivativeDeal.prototype.averageClosePrice = 0;
      DerivativeDeal.prototype.marketPrice = 0;
      DerivativeDeal.prototype.realizedProfitVM = 0;
      DerivativeDeal.prototype.unrealizedProfitVM = 0;
      DerivativeDeal.prototype.totalUnrealizedProfitVM = 0;
      DerivativeDeal.prototype.totalUnrealizedProfit = 0;
      DerivativeDeal.prototype.totalUnrealizedTaxAndFee = 0;
      DerivativeDeal.prototype.totalUnrealizedInterest = 0;
      DerivativeDeal.prototype.totalRealizedProfit = 0;
      DerivativeDeal.prototype.totalRealizedTaxAndFee = 0;
      DerivativeDeal.prototype.totalRealizedInterest = 0;
      DerivativeDeal.prototype.estimateRemainFee = 0;
      DerivativeDeal.prototype.estimateRemainTax = 0;
      DerivativeDeal.prototype.totalRealizedPositionFee = 0;
      DerivativeDeal.prototype.totalUnrealizedPositionFee = 0;
      DerivativeDeal.prototype.overDraftUnrealizedPrincipal = 0;
      DerivativeDeal.prototype.overDraftRealizedPrincipal = 0;
      DerivativeDeal.prototype.overDraftUnrealizedInterest = 0;
      DerivativeDeal.prototype.overDraftRealizedInterest = 0;
      DerivativeDeal.prototype.paidOverDraftPrincipal = 0;
      DerivativeDeal.prototype.paidOverDraftInterest = 0;
      DerivativeDeal.prototype.createdDate = null;
      DerivativeDeal.prototype.modifiedDate = null;
      DerivativeDeal.prototype.averageCostPrice = 0;
      DerivativeDeal.prototype.dailyPositionFee = 0;
      DerivativeDeal.prototype.depositSecure = 0;
      DerivativeDeal.prototype.accumulateSecure = 0;
      DerivativeDeal.prototype.totalRealizedProfitVM = 0;
      DerivativeDeal.prototype.dailyRealizedTaxAndFee = 0;
      DerivativeDeal.prototype.dailyRealizedInterest = 0;
      DerivativeDeal.prototype.dailyRealizedPositionFee = 0;
      DerivativeDeal.prototype.maturityFee = 0;
      DerivativeDeal.prototype.dailyTaxAndFeeObligation = 0;
      DerivativeDeal.prototype.dailyPositionObligation = 0;
      DerivativeDeal.prototype.dailyClosedTaxAndFeeObligation = 0;
      DerivativeDeal.prototype.dailyRealizedPaidProfitVM = 0;
      DerivativeDeal.create = function create(properties) {
        return new DerivativeDeal(properties);
      };
      DerivativeDeal.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
          writer.uint32(24).int32(message.side);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(32).int32(message.status);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(40).int32(message.loanPackageId);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(50).string(message.symbol);
        if (message.secure != null && Object.hasOwnProperty.call(message, "secure"))
          writer.uint32(57).double(message.secure);
        if (message.openQuantity != null && Object.hasOwnProperty.call(message, "openQuantity"))
          writer.uint32(64).int64(message.openQuantity);
        if (message.closedQuantity != null && Object.hasOwnProperty.call(message, "closedQuantity"))
          writer.uint32(72).int64(message.closedQuantity);
        if (message.accumulateQuantity != null && Object.hasOwnProperty.call(message, "accumulateQuantity"))
          writer.uint32(80).int64(message.accumulateQuantity);
        if (message.overNightQuantity != null && Object.hasOwnProperty.call(message, "overNightQuantity"))
          writer.uint32(88).int64(message.overNightQuantity);
        if (message.breakEvenPrice != null && Object.hasOwnProperty.call(message, "breakEvenPrice"))
          writer.uint32(97).double(message.breakEvenPrice);
        if (message.costPrice != null && Object.hasOwnProperty.call(message, "costPrice"))
          writer.uint32(105).double(message.costPrice);
        if (message.costPriceVM != null && Object.hasOwnProperty.call(message, "costPriceVM"))
          writer.uint32(113).double(message.costPriceVM);
        if (message.averageClosePrice != null && Object.hasOwnProperty.call(message, "averageClosePrice"))
          writer.uint32(121).double(message.averageClosePrice);
        if (message.marketPrice != null && Object.hasOwnProperty.call(message, "marketPrice"))
          writer.uint32(129).double(message.marketPrice);
        if (message.realizedProfitVM != null && Object.hasOwnProperty.call(message, "realizedProfitVM"))
          writer.uint32(137).double(message.realizedProfitVM);
        if (message.unrealizedProfitVM != null && Object.hasOwnProperty.call(message, "unrealizedProfitVM"))
          writer.uint32(145).double(message.unrealizedProfitVM);
        if (message.totalUnrealizedProfitVM != null && Object.hasOwnProperty.call(message, "totalUnrealizedProfitVM"))
          writer.uint32(153).double(message.totalUnrealizedProfitVM);
        if (message.totalUnrealizedProfit != null && Object.hasOwnProperty.call(message, "totalUnrealizedProfit"))
          writer.uint32(161).double(message.totalUnrealizedProfit);
        if (message.totalUnrealizedTaxAndFee != null && Object.hasOwnProperty.call(message, "totalUnrealizedTaxAndFee"))
          writer.uint32(169).double(message.totalUnrealizedTaxAndFee);
        if (message.totalUnrealizedInterest != null && Object.hasOwnProperty.call(message, "totalUnrealizedInterest"))
          writer.uint32(177).double(message.totalUnrealizedInterest);
        if (message.totalRealizedProfit != null && Object.hasOwnProperty.call(message, "totalRealizedProfit"))
          writer.uint32(185).double(message.totalRealizedProfit);
        if (message.totalRealizedTaxAndFee != null && Object.hasOwnProperty.call(message, "totalRealizedTaxAndFee"))
          writer.uint32(193).double(message.totalRealizedTaxAndFee);
        if (message.totalRealizedInterest != null && Object.hasOwnProperty.call(message, "totalRealizedInterest"))
          writer.uint32(201).double(message.totalRealizedInterest);
        if (message.estimateRemainFee != null && Object.hasOwnProperty.call(message, "estimateRemainFee"))
          writer.uint32(209).double(message.estimateRemainFee);
        if (message.estimateRemainTax != null && Object.hasOwnProperty.call(message, "estimateRemainTax"))
          writer.uint32(217).double(message.estimateRemainTax);
        if (message.totalRealizedPositionFee != null && Object.hasOwnProperty.call(message, "totalRealizedPositionFee"))
          writer.uint32(225).double(message.totalRealizedPositionFee);
        if (message.totalUnrealizedPositionFee != null && Object.hasOwnProperty.call(message, "totalUnrealizedPositionFee"))
          writer.uint32(233).double(message.totalUnrealizedPositionFee);
        if (message.overDraftUnrealizedPrincipal != null && Object.hasOwnProperty.call(message, "overDraftUnrealizedPrincipal"))
          writer.uint32(241).double(message.overDraftUnrealizedPrincipal);
        if (message.overDraftRealizedPrincipal != null && Object.hasOwnProperty.call(message, "overDraftRealizedPrincipal"))
          writer.uint32(249).double(message.overDraftRealizedPrincipal);
        if (message.overDraftUnrealizedInterest != null && Object.hasOwnProperty.call(message, "overDraftUnrealizedInterest"))
          writer.uint32(257).double(message.overDraftUnrealizedInterest);
        if (message.overDraftRealizedInterest != null && Object.hasOwnProperty.call(message, "overDraftRealizedInterest"))
          writer.uint32(265).double(message.overDraftRealizedInterest);
        if (message.paidOverDraftPrincipal != null && Object.hasOwnProperty.call(message, "paidOverDraftPrincipal"))
          writer.uint32(273).double(message.paidOverDraftPrincipal);
        if (message.paidOverDraftInterest != null && Object.hasOwnProperty.call(message, "paidOverDraftInterest"))
          writer.uint32(281).double(message.paidOverDraftInterest);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(290).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(298).fork()).ldelim();
        if (message.averageCostPrice != null && Object.hasOwnProperty.call(message, "averageCostPrice"))
          writer.uint32(305).double(message.averageCostPrice);
        if (message.dailyPositionFee != null && Object.hasOwnProperty.call(message, "dailyPositionFee"))
          writer.uint32(321).double(message.dailyPositionFee);
        if (message.depositSecure != null && Object.hasOwnProperty.call(message, "depositSecure"))
          writer.uint32(329).double(message.depositSecure);
        if (message.accumulateSecure != null && Object.hasOwnProperty.call(message, "accumulateSecure"))
          writer.uint32(337).double(message.accumulateSecure);
        if (message.totalRealizedProfitVM != null && Object.hasOwnProperty.call(message, "totalRealizedProfitVM"))
          writer.uint32(345).double(message.totalRealizedProfitVM);
        if (message.dailyRealizedTaxAndFee != null && Object.hasOwnProperty.call(message, "dailyRealizedTaxAndFee"))
          writer.uint32(353).double(message.dailyRealizedTaxAndFee);
        if (message.dailyRealizedInterest != null && Object.hasOwnProperty.call(message, "dailyRealizedInterest"))
          writer.uint32(361).double(message.dailyRealizedInterest);
        if (message.dailyRealizedPositionFee != null && Object.hasOwnProperty.call(message, "dailyRealizedPositionFee"))
          writer.uint32(369).double(message.dailyRealizedPositionFee);
        if (message.maturityFee != null && Object.hasOwnProperty.call(message, "maturityFee"))
          writer.uint32(377).double(message.maturityFee);
        if (message.dailyTaxAndFeeObligation != null && Object.hasOwnProperty.call(message, "dailyTaxAndFeeObligation"))
          writer.uint32(385).double(message.dailyTaxAndFeeObligation);
        if (message.dailyPositionObligation != null && Object.hasOwnProperty.call(message, "dailyPositionObligation"))
          writer.uint32(393).double(message.dailyPositionObligation);
        if (message.dailyClosedTaxAndFeeObligation != null && Object.hasOwnProperty.call(message, "dailyClosedTaxAndFeeObligation"))
          writer.uint32(401).double(message.dailyClosedTaxAndFeeObligation);
        if (message.dailyRealizedPaidProfitVM != null && Object.hasOwnProperty.call(message, "dailyRealizedPaidProfitVM"))
          writer.uint32(409).double(message.dailyRealizedPaidProfitVM);
        return writer;
      };
      DerivativeDeal.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeDeal.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeDeal();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.side = reader.int32();
              break;
            case 4:
              message.status = reader.int32();
              break;
            case 5:
              message.loanPackageId = reader.int32();
              break;
            case 6:
              message.symbol = reader.string();
              break;
            case 7:
              message.secure = reader.double();
              break;
            case 8:
              message.openQuantity = reader.int64();
              break;
            case 9:
              message.closedQuantity = reader.int64();
              break;
            case 10:
              message.accumulateQuantity = reader.int64();
              break;
            case 11:
              message.overNightQuantity = reader.int64();
              break;
            case 12:
              message.breakEvenPrice = reader.double();
              break;
            case 13:
              message.costPrice = reader.double();
              break;
            case 14:
              message.costPriceVM = reader.double();
              break;
            case 15:
              message.averageClosePrice = reader.double();
              break;
            case 16:
              message.marketPrice = reader.double();
              break;
            case 17:
              message.realizedProfitVM = reader.double();
              break;
            case 18:
              message.unrealizedProfitVM = reader.double();
              break;
            case 19:
              message.totalUnrealizedProfitVM = reader.double();
              break;
            case 20:
              message.totalUnrealizedProfit = reader.double();
              break;
            case 21:
              message.totalUnrealizedTaxAndFee = reader.double();
              break;
            case 22:
              message.totalUnrealizedInterest = reader.double();
              break;
            case 23:
              message.totalRealizedProfit = reader.double();
              break;
            case 24:
              message.totalRealizedTaxAndFee = reader.double();
              break;
            case 25:
              message.totalRealizedInterest = reader.double();
              break;
            case 26:
              message.estimateRemainFee = reader.double();
              break;
            case 27:
              message.estimateRemainTax = reader.double();
              break;
            case 28:
              message.totalRealizedPositionFee = reader.double();
              break;
            case 29:
              message.totalUnrealizedPositionFee = reader.double();
              break;
            case 30:
              message.overDraftUnrealizedPrincipal = reader.double();
              break;
            case 31:
              message.overDraftRealizedPrincipal = reader.double();
              break;
            case 32:
              message.overDraftUnrealizedInterest = reader.double();
              break;
            case 33:
              message.overDraftRealizedInterest = reader.double();
              break;
            case 34:
              message.paidOverDraftPrincipal = reader.double();
              break;
            case 35:
              message.paidOverDraftInterest = reader.double();
              break;
            case 36:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 37:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 38:
              message.averageCostPrice = reader.double();
              break;
            case 40:
              message.dailyPositionFee = reader.double();
              break;
            case 41:
              message.depositSecure = reader.double();
              break;
            case 42:
              message.accumulateSecure = reader.double();
              break;
            case 43:
              message.totalRealizedProfitVM = reader.double();
              break;
            case 44:
              message.dailyRealizedTaxAndFee = reader.double();
              break;
            case 45:
              message.dailyRealizedInterest = reader.double();
              break;
            case 46:
              message.dailyRealizedPositionFee = reader.double();
              break;
            case 47:
              message.maturityFee = reader.double();
              break;
            case 48:
              message.dailyTaxAndFeeObligation = reader.double();
              break;
            case 49:
              message.dailyPositionObligation = reader.double();
              break;
            case 50:
              message.dailyClosedTaxAndFeeObligation = reader.double();
              break;
            case 51:
              message.dailyRealizedPaidProfitVM = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeDeal.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeDeal.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.side != null && message.hasOwnProperty("side"))
          switch (message.side) {
            default:
              return "side: enum value expected";
            case 0:
            case 1:
            case 3:
            case 4:
              break;
          }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.secure != null && message.hasOwnProperty("secure")) {
          if (typeof message.secure !== "number")
            return "secure: number expected";
        }
        if (message.openQuantity != null && message.hasOwnProperty("openQuantity")) {
          if (!$util.isInteger(message.openQuantity) && !(message.openQuantity && $util.isInteger(message.openQuantity.low) && $util.isInteger(message.openQuantity.high)))
            return "openQuantity: integer|Long expected";
        }
        if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity")) {
          if (!$util.isInteger(message.closedQuantity) && !(message.closedQuantity && $util.isInteger(message.closedQuantity.low) && $util.isInteger(message.closedQuantity.high)))
            return "closedQuantity: integer|Long expected";
        }
        if (message.accumulateQuantity != null && message.hasOwnProperty("accumulateQuantity")) {
          if (!$util.isInteger(message.accumulateQuantity) && !(message.accumulateQuantity && $util.isInteger(message.accumulateQuantity.low) && $util.isInteger(message.accumulateQuantity.high)))
            return "accumulateQuantity: integer|Long expected";
        }
        if (message.overNightQuantity != null && message.hasOwnProperty("overNightQuantity")) {
          if (!$util.isInteger(message.overNightQuantity) && !(message.overNightQuantity && $util.isInteger(message.overNightQuantity.low) && $util.isInteger(message.overNightQuantity.high)))
            return "overNightQuantity: integer|Long expected";
        }
        if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice")) {
          if (typeof message.breakEvenPrice !== "number")
            return "breakEvenPrice: number expected";
        }
        if (message.costPrice != null && message.hasOwnProperty("costPrice")) {
          if (typeof message.costPrice !== "number")
            return "costPrice: number expected";
        }
        if (message.costPriceVM != null && message.hasOwnProperty("costPriceVM")) {
          if (typeof message.costPriceVM !== "number")
            return "costPriceVM: number expected";
        }
        if (message.averageClosePrice != null && message.hasOwnProperty("averageClosePrice")) {
          if (typeof message.averageClosePrice !== "number")
            return "averageClosePrice: number expected";
        }
        if (message.marketPrice != null && message.hasOwnProperty("marketPrice")) {
          if (typeof message.marketPrice !== "number")
            return "marketPrice: number expected";
        }
        if (message.realizedProfitVM != null && message.hasOwnProperty("realizedProfitVM")) {
          if (typeof message.realizedProfitVM !== "number")
            return "realizedProfitVM: number expected";
        }
        if (message.unrealizedProfitVM != null && message.hasOwnProperty("unrealizedProfitVM")) {
          if (typeof message.unrealizedProfitVM !== "number")
            return "unrealizedProfitVM: number expected";
        }
        if (message.totalUnrealizedProfitVM != null && message.hasOwnProperty("totalUnrealizedProfitVM")) {
          if (typeof message.totalUnrealizedProfitVM !== "number")
            return "totalUnrealizedProfitVM: number expected";
        }
        if (message.totalUnrealizedProfit != null && message.hasOwnProperty("totalUnrealizedProfit")) {
          if (typeof message.totalUnrealizedProfit !== "number")
            return "totalUnrealizedProfit: number expected";
        }
        if (message.totalUnrealizedTaxAndFee != null && message.hasOwnProperty("totalUnrealizedTaxAndFee")) {
          if (typeof message.totalUnrealizedTaxAndFee !== "number")
            return "totalUnrealizedTaxAndFee: number expected";
        }
        if (message.totalUnrealizedInterest != null && message.hasOwnProperty("totalUnrealizedInterest")) {
          if (typeof message.totalUnrealizedInterest !== "number")
            return "totalUnrealizedInterest: number expected";
        }
        if (message.totalRealizedProfit != null && message.hasOwnProperty("totalRealizedProfit")) {
          if (typeof message.totalRealizedProfit !== "number")
            return "totalRealizedProfit: number expected";
        }
        if (message.totalRealizedTaxAndFee != null && message.hasOwnProperty("totalRealizedTaxAndFee")) {
          if (typeof message.totalRealizedTaxAndFee !== "number")
            return "totalRealizedTaxAndFee: number expected";
        }
        if (message.totalRealizedInterest != null && message.hasOwnProperty("totalRealizedInterest")) {
          if (typeof message.totalRealizedInterest !== "number")
            return "totalRealizedInterest: number expected";
        }
        if (message.estimateRemainFee != null && message.hasOwnProperty("estimateRemainFee")) {
          if (typeof message.estimateRemainFee !== "number")
            return "estimateRemainFee: number expected";
        }
        if (message.estimateRemainTax != null && message.hasOwnProperty("estimateRemainTax")) {
          if (typeof message.estimateRemainTax !== "number")
            return "estimateRemainTax: number expected";
        }
        if (message.totalRealizedPositionFee != null && message.hasOwnProperty("totalRealizedPositionFee")) {
          if (typeof message.totalRealizedPositionFee !== "number")
            return "totalRealizedPositionFee: number expected";
        }
        if (message.totalUnrealizedPositionFee != null && message.hasOwnProperty("totalUnrealizedPositionFee")) {
          if (typeof message.totalUnrealizedPositionFee !== "number")
            return "totalUnrealizedPositionFee: number expected";
        }
        if (message.overDraftUnrealizedPrincipal != null && message.hasOwnProperty("overDraftUnrealizedPrincipal")) {
          if (typeof message.overDraftUnrealizedPrincipal !== "number")
            return "overDraftUnrealizedPrincipal: number expected";
        }
        if (message.overDraftRealizedPrincipal != null && message.hasOwnProperty("overDraftRealizedPrincipal")) {
          if (typeof message.overDraftRealizedPrincipal !== "number")
            return "overDraftRealizedPrincipal: number expected";
        }
        if (message.overDraftUnrealizedInterest != null && message.hasOwnProperty("overDraftUnrealizedInterest")) {
          if (typeof message.overDraftUnrealizedInterest !== "number")
            return "overDraftUnrealizedInterest: number expected";
        }
        if (message.overDraftRealizedInterest != null && message.hasOwnProperty("overDraftRealizedInterest")) {
          if (typeof message.overDraftRealizedInterest !== "number")
            return "overDraftRealizedInterest: number expected";
        }
        if (message.paidOverDraftPrincipal != null && message.hasOwnProperty("paidOverDraftPrincipal")) {
          if (typeof message.paidOverDraftPrincipal !== "number")
            return "paidOverDraftPrincipal: number expected";
        }
        if (message.paidOverDraftInterest != null && message.hasOwnProperty("paidOverDraftInterest")) {
          if (typeof message.paidOverDraftInterest !== "number")
            return "paidOverDraftInterest: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.averageCostPrice != null && message.hasOwnProperty("averageCostPrice")) {
          if (typeof message.averageCostPrice !== "number")
            return "averageCostPrice: number expected";
        }
        if (message.dailyPositionFee != null && message.hasOwnProperty("dailyPositionFee")) {
          if (typeof message.dailyPositionFee !== "number")
            return "dailyPositionFee: number expected";
        }
        if (message.depositSecure != null && message.hasOwnProperty("depositSecure")) {
          if (typeof message.depositSecure !== "number")
            return "depositSecure: number expected";
        }
        if (message.accumulateSecure != null && message.hasOwnProperty("accumulateSecure")) {
          if (typeof message.accumulateSecure !== "number")
            return "accumulateSecure: number expected";
        }
        if (message.totalRealizedProfitVM != null && message.hasOwnProperty("totalRealizedProfitVM")) {
          if (typeof message.totalRealizedProfitVM !== "number")
            return "totalRealizedProfitVM: number expected";
        }
        if (message.dailyRealizedTaxAndFee != null && message.hasOwnProperty("dailyRealizedTaxAndFee")) {
          if (typeof message.dailyRealizedTaxAndFee !== "number")
            return "dailyRealizedTaxAndFee: number expected";
        }
        if (message.dailyRealizedInterest != null && message.hasOwnProperty("dailyRealizedInterest")) {
          if (typeof message.dailyRealizedInterest !== "number")
            return "dailyRealizedInterest: number expected";
        }
        if (message.dailyRealizedPositionFee != null && message.hasOwnProperty("dailyRealizedPositionFee")) {
          if (typeof message.dailyRealizedPositionFee !== "number")
            return "dailyRealizedPositionFee: number expected";
        }
        if (message.maturityFee != null && message.hasOwnProperty("maturityFee")) {
          if (typeof message.maturityFee !== "number")
            return "maturityFee: number expected";
        }
        if (message.dailyTaxAndFeeObligation != null && message.hasOwnProperty("dailyTaxAndFeeObligation")) {
          if (typeof message.dailyTaxAndFeeObligation !== "number")
            return "dailyTaxAndFeeObligation: number expected";
        }
        if (message.dailyPositionObligation != null && message.hasOwnProperty("dailyPositionObligation")) {
          if (typeof message.dailyPositionObligation !== "number")
            return "dailyPositionObligation: number expected";
        }
        if (message.dailyClosedTaxAndFeeObligation != null && message.hasOwnProperty("dailyClosedTaxAndFeeObligation")) {
          if (typeof message.dailyClosedTaxAndFeeObligation !== "number")
            return "dailyClosedTaxAndFeeObligation: number expected";
        }
        if (message.dailyRealizedPaidProfitVM != null && message.hasOwnProperty("dailyRealizedPaidProfitVM")) {
          if (typeof message.dailyRealizedPaidProfitVM !== "number")
            return "dailyRealizedPaidProfitVM: number expected";
        }
        return null;
      };
      DerivativeDeal.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeDeal)
          return object;
        let message = new $root.dnse.fo.DerivativeDeal();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        switch (object.side) {
          case "NS":
          case 0:
            message.side = 0;
            break;
          case "NB":
          case 1:
            message.side = 1;
            break;
          case "CROSS":
          case 3:
            message.side = 3;
            break;
          case "UNDISCLOSED":
          case 4:
            message.side = 4;
            break;
        }
        switch (object.status) {
          case "OPEN":
          case 0:
            message.status = 0;
            break;
          case "CLOSED":
          case 1:
            message.status = 1;
            break;
          case "UNKNOWN":
          case 2:
            message.status = 2;
            break;
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.secure != null)
          message.secure = Number(object.secure);
        if (object.openQuantity != null) {
          if ($util.Long)
            (message.openQuantity = $util.Long.fromValue(object.openQuantity)).unsigned = false;
          else if (typeof object.openQuantity === "string")
            message.openQuantity = parseInt(object.openQuantity, 10);
          else if (typeof object.openQuantity === "number")
            message.openQuantity = object.openQuantity;
          else if (typeof object.openQuantity === "object")
            message.openQuantity = new $util.LongBits(object.openQuantity.low >>> 0, object.openQuantity.high >>> 0).toNumber();
        }
        if (object.closedQuantity != null) {
          if ($util.Long)
            (message.closedQuantity = $util.Long.fromValue(object.closedQuantity)).unsigned = false;
          else if (typeof object.closedQuantity === "string")
            message.closedQuantity = parseInt(object.closedQuantity, 10);
          else if (typeof object.closedQuantity === "number")
            message.closedQuantity = object.closedQuantity;
          else if (typeof object.closedQuantity === "object")
            message.closedQuantity = new $util.LongBits(object.closedQuantity.low >>> 0, object.closedQuantity.high >>> 0).toNumber();
        }
        if (object.accumulateQuantity != null) {
          if ($util.Long)
            (message.accumulateQuantity = $util.Long.fromValue(object.accumulateQuantity)).unsigned = false;
          else if (typeof object.accumulateQuantity === "string")
            message.accumulateQuantity = parseInt(object.accumulateQuantity, 10);
          else if (typeof object.accumulateQuantity === "number")
            message.accumulateQuantity = object.accumulateQuantity;
          else if (typeof object.accumulateQuantity === "object")
            message.accumulateQuantity = new $util.LongBits(object.accumulateQuantity.low >>> 0, object.accumulateQuantity.high >>> 0).toNumber();
        }
        if (object.overNightQuantity != null) {
          if ($util.Long)
            (message.overNightQuantity = $util.Long.fromValue(object.overNightQuantity)).unsigned = false;
          else if (typeof object.overNightQuantity === "string")
            message.overNightQuantity = parseInt(object.overNightQuantity, 10);
          else if (typeof object.overNightQuantity === "number")
            message.overNightQuantity = object.overNightQuantity;
          else if (typeof object.overNightQuantity === "object")
            message.overNightQuantity = new $util.LongBits(object.overNightQuantity.low >>> 0, object.overNightQuantity.high >>> 0).toNumber();
        }
        if (object.breakEvenPrice != null)
          message.breakEvenPrice = Number(object.breakEvenPrice);
        if (object.costPrice != null)
          message.costPrice = Number(object.costPrice);
        if (object.costPriceVM != null)
          message.costPriceVM = Number(object.costPriceVM);
        if (object.averageClosePrice != null)
          message.averageClosePrice = Number(object.averageClosePrice);
        if (object.marketPrice != null)
          message.marketPrice = Number(object.marketPrice);
        if (object.realizedProfitVM != null)
          message.realizedProfitVM = Number(object.realizedProfitVM);
        if (object.unrealizedProfitVM != null)
          message.unrealizedProfitVM = Number(object.unrealizedProfitVM);
        if (object.totalUnrealizedProfitVM != null)
          message.totalUnrealizedProfitVM = Number(object.totalUnrealizedProfitVM);
        if (object.totalUnrealizedProfit != null)
          message.totalUnrealizedProfit = Number(object.totalUnrealizedProfit);
        if (object.totalUnrealizedTaxAndFee != null)
          message.totalUnrealizedTaxAndFee = Number(object.totalUnrealizedTaxAndFee);
        if (object.totalUnrealizedInterest != null)
          message.totalUnrealizedInterest = Number(object.totalUnrealizedInterest);
        if (object.totalRealizedProfit != null)
          message.totalRealizedProfit = Number(object.totalRealizedProfit);
        if (object.totalRealizedTaxAndFee != null)
          message.totalRealizedTaxAndFee = Number(object.totalRealizedTaxAndFee);
        if (object.totalRealizedInterest != null)
          message.totalRealizedInterest = Number(object.totalRealizedInterest);
        if (object.estimateRemainFee != null)
          message.estimateRemainFee = Number(object.estimateRemainFee);
        if (object.estimateRemainTax != null)
          message.estimateRemainTax = Number(object.estimateRemainTax);
        if (object.totalRealizedPositionFee != null)
          message.totalRealizedPositionFee = Number(object.totalRealizedPositionFee);
        if (object.totalUnrealizedPositionFee != null)
          message.totalUnrealizedPositionFee = Number(object.totalUnrealizedPositionFee);
        if (object.overDraftUnrealizedPrincipal != null)
          message.overDraftUnrealizedPrincipal = Number(object.overDraftUnrealizedPrincipal);
        if (object.overDraftRealizedPrincipal != null)
          message.overDraftRealizedPrincipal = Number(object.overDraftRealizedPrincipal);
        if (object.overDraftUnrealizedInterest != null)
          message.overDraftUnrealizedInterest = Number(object.overDraftUnrealizedInterest);
        if (object.overDraftRealizedInterest != null)
          message.overDraftRealizedInterest = Number(object.overDraftRealizedInterest);
        if (object.paidOverDraftPrincipal != null)
          message.paidOverDraftPrincipal = Number(object.paidOverDraftPrincipal);
        if (object.paidOverDraftInterest != null)
          message.paidOverDraftInterest = Number(object.paidOverDraftInterest);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeDeal.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeDeal.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.averageCostPrice != null)
          message.averageCostPrice = Number(object.averageCostPrice);
        if (object.dailyPositionFee != null)
          message.dailyPositionFee = Number(object.dailyPositionFee);
        if (object.depositSecure != null)
          message.depositSecure = Number(object.depositSecure);
        if (object.accumulateSecure != null)
          message.accumulateSecure = Number(object.accumulateSecure);
        if (object.totalRealizedProfitVM != null)
          message.totalRealizedProfitVM = Number(object.totalRealizedProfitVM);
        if (object.dailyRealizedTaxAndFee != null)
          message.dailyRealizedTaxAndFee = Number(object.dailyRealizedTaxAndFee);
        if (object.dailyRealizedInterest != null)
          message.dailyRealizedInterest = Number(object.dailyRealizedInterest);
        if (object.dailyRealizedPositionFee != null)
          message.dailyRealizedPositionFee = Number(object.dailyRealizedPositionFee);
        if (object.maturityFee != null)
          message.maturityFee = Number(object.maturityFee);
        if (object.dailyTaxAndFeeObligation != null)
          message.dailyTaxAndFeeObligation = Number(object.dailyTaxAndFeeObligation);
        if (object.dailyPositionObligation != null)
          message.dailyPositionObligation = Number(object.dailyPositionObligation);
        if (object.dailyClosedTaxAndFeeObligation != null)
          message.dailyClosedTaxAndFeeObligation = Number(object.dailyClosedTaxAndFeeObligation);
        if (object.dailyRealizedPaidProfitVM != null)
          message.dailyRealizedPaidProfitVM = Number(object.dailyRealizedPaidProfitVM);
        return message;
      };
      DerivativeDeal.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.side = options.enums === String ? "NS" : 0;
          object.status = options.enums === String ? "OPEN" : 0;
          object.loanPackageId = 0;
          object.symbol = "";
          object.secure = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.openQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.openQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.closedQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.closedQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.accumulateQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.accumulateQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.overNightQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.overNightQuantity = options.longs === String ? "0" : 0;
          object.breakEvenPrice = 0;
          object.costPrice = 0;
          object.costPriceVM = 0;
          object.averageClosePrice = 0;
          object.marketPrice = 0;
          object.realizedProfitVM = 0;
          object.unrealizedProfitVM = 0;
          object.totalUnrealizedProfitVM = 0;
          object.totalUnrealizedProfit = 0;
          object.totalUnrealizedTaxAndFee = 0;
          object.totalUnrealizedInterest = 0;
          object.totalRealizedProfit = 0;
          object.totalRealizedTaxAndFee = 0;
          object.totalRealizedInterest = 0;
          object.estimateRemainFee = 0;
          object.estimateRemainTax = 0;
          object.totalRealizedPositionFee = 0;
          object.totalUnrealizedPositionFee = 0;
          object.overDraftUnrealizedPrincipal = 0;
          object.overDraftRealizedPrincipal = 0;
          object.overDraftUnrealizedInterest = 0;
          object.overDraftRealizedInterest = 0;
          object.paidOverDraftPrincipal = 0;
          object.paidOverDraftInterest = 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.averageCostPrice = 0;
          object.dailyPositionFee = 0;
          object.depositSecure = 0;
          object.accumulateSecure = 0;
          object.totalRealizedProfitVM = 0;
          object.dailyRealizedTaxAndFee = 0;
          object.dailyRealizedInterest = 0;
          object.dailyRealizedPositionFee = 0;
          object.maturityFee = 0;
          object.dailyTaxAndFeeObligation = 0;
          object.dailyPositionObligation = 0;
          object.dailyClosedTaxAndFeeObligation = 0;
          object.dailyRealizedPaidProfitVM = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.side != null && message.hasOwnProperty("side"))
          object.side = options.enums === String ? $root.dnse.fo.DerivativeDeal.Side[message.side] : message.side;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.DerivativeDeal.Status[message.status] : message.status;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.secure != null && message.hasOwnProperty("secure"))
          object.secure = options.json && !isFinite(message.secure) ? String(message.secure) : message.secure;
        if (message.openQuantity != null && message.hasOwnProperty("openQuantity"))
          if (typeof message.openQuantity === "number")
            object.openQuantity = options.longs === String ? String(message.openQuantity) : message.openQuantity;
          else
            object.openQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.openQuantity) : options.longs === Number ? new $util.LongBits(message.openQuantity.low >>> 0, message.openQuantity.high >>> 0).toNumber() : message.openQuantity;
        if (message.closedQuantity != null && message.hasOwnProperty("closedQuantity"))
          if (typeof message.closedQuantity === "number")
            object.closedQuantity = options.longs === String ? String(message.closedQuantity) : message.closedQuantity;
          else
            object.closedQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.closedQuantity) : options.longs === Number ? new $util.LongBits(message.closedQuantity.low >>> 0, message.closedQuantity.high >>> 0).toNumber() : message.closedQuantity;
        if (message.accumulateQuantity != null && message.hasOwnProperty("accumulateQuantity"))
          if (typeof message.accumulateQuantity === "number")
            object.accumulateQuantity = options.longs === String ? String(message.accumulateQuantity) : message.accumulateQuantity;
          else
            object.accumulateQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.accumulateQuantity) : options.longs === Number ? new $util.LongBits(message.accumulateQuantity.low >>> 0, message.accumulateQuantity.high >>> 0).toNumber() : message.accumulateQuantity;
        if (message.overNightQuantity != null && message.hasOwnProperty("overNightQuantity"))
          if (typeof message.overNightQuantity === "number")
            object.overNightQuantity = options.longs === String ? String(message.overNightQuantity) : message.overNightQuantity;
          else
            object.overNightQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.overNightQuantity) : options.longs === Number ? new $util.LongBits(message.overNightQuantity.low >>> 0, message.overNightQuantity.high >>> 0).toNumber() : message.overNightQuantity;
        if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice"))
          object.breakEvenPrice = options.json && !isFinite(message.breakEvenPrice) ? String(message.breakEvenPrice) : message.breakEvenPrice;
        if (message.costPrice != null && message.hasOwnProperty("costPrice"))
          object.costPrice = options.json && !isFinite(message.costPrice) ? String(message.costPrice) : message.costPrice;
        if (message.costPriceVM != null && message.hasOwnProperty("costPriceVM"))
          object.costPriceVM = options.json && !isFinite(message.costPriceVM) ? String(message.costPriceVM) : message.costPriceVM;
        if (message.averageClosePrice != null && message.hasOwnProperty("averageClosePrice"))
          object.averageClosePrice = options.json && !isFinite(message.averageClosePrice) ? String(message.averageClosePrice) : message.averageClosePrice;
        if (message.marketPrice != null && message.hasOwnProperty("marketPrice"))
          object.marketPrice = options.json && !isFinite(message.marketPrice) ? String(message.marketPrice) : message.marketPrice;
        if (message.realizedProfitVM != null && message.hasOwnProperty("realizedProfitVM"))
          object.realizedProfitVM = options.json && !isFinite(message.realizedProfitVM) ? String(message.realizedProfitVM) : message.realizedProfitVM;
        if (message.unrealizedProfitVM != null && message.hasOwnProperty("unrealizedProfitVM"))
          object.unrealizedProfitVM = options.json && !isFinite(message.unrealizedProfitVM) ? String(message.unrealizedProfitVM) : message.unrealizedProfitVM;
        if (message.totalUnrealizedProfitVM != null && message.hasOwnProperty("totalUnrealizedProfitVM"))
          object.totalUnrealizedProfitVM = options.json && !isFinite(message.totalUnrealizedProfitVM) ? String(message.totalUnrealizedProfitVM) : message.totalUnrealizedProfitVM;
        if (message.totalUnrealizedProfit != null && message.hasOwnProperty("totalUnrealizedProfit"))
          object.totalUnrealizedProfit = options.json && !isFinite(message.totalUnrealizedProfit) ? String(message.totalUnrealizedProfit) : message.totalUnrealizedProfit;
        if (message.totalUnrealizedTaxAndFee != null && message.hasOwnProperty("totalUnrealizedTaxAndFee"))
          object.totalUnrealizedTaxAndFee = options.json && !isFinite(message.totalUnrealizedTaxAndFee) ? String(message.totalUnrealizedTaxAndFee) : message.totalUnrealizedTaxAndFee;
        if (message.totalUnrealizedInterest != null && message.hasOwnProperty("totalUnrealizedInterest"))
          object.totalUnrealizedInterest = options.json && !isFinite(message.totalUnrealizedInterest) ? String(message.totalUnrealizedInterest) : message.totalUnrealizedInterest;
        if (message.totalRealizedProfit != null && message.hasOwnProperty("totalRealizedProfit"))
          object.totalRealizedProfit = options.json && !isFinite(message.totalRealizedProfit) ? String(message.totalRealizedProfit) : message.totalRealizedProfit;
        if (message.totalRealizedTaxAndFee != null && message.hasOwnProperty("totalRealizedTaxAndFee"))
          object.totalRealizedTaxAndFee = options.json && !isFinite(message.totalRealizedTaxAndFee) ? String(message.totalRealizedTaxAndFee) : message.totalRealizedTaxAndFee;
        if (message.totalRealizedInterest != null && message.hasOwnProperty("totalRealizedInterest"))
          object.totalRealizedInterest = options.json && !isFinite(message.totalRealizedInterest) ? String(message.totalRealizedInterest) : message.totalRealizedInterest;
        if (message.estimateRemainFee != null && message.hasOwnProperty("estimateRemainFee"))
          object.estimateRemainFee = options.json && !isFinite(message.estimateRemainFee) ? String(message.estimateRemainFee) : message.estimateRemainFee;
        if (message.estimateRemainTax != null && message.hasOwnProperty("estimateRemainTax"))
          object.estimateRemainTax = options.json && !isFinite(message.estimateRemainTax) ? String(message.estimateRemainTax) : message.estimateRemainTax;
        if (message.totalRealizedPositionFee != null && message.hasOwnProperty("totalRealizedPositionFee"))
          object.totalRealizedPositionFee = options.json && !isFinite(message.totalRealizedPositionFee) ? String(message.totalRealizedPositionFee) : message.totalRealizedPositionFee;
        if (message.totalUnrealizedPositionFee != null && message.hasOwnProperty("totalUnrealizedPositionFee"))
          object.totalUnrealizedPositionFee = options.json && !isFinite(message.totalUnrealizedPositionFee) ? String(message.totalUnrealizedPositionFee) : message.totalUnrealizedPositionFee;
        if (message.overDraftUnrealizedPrincipal != null && message.hasOwnProperty("overDraftUnrealizedPrincipal"))
          object.overDraftUnrealizedPrincipal = options.json && !isFinite(message.overDraftUnrealizedPrincipal) ? String(message.overDraftUnrealizedPrincipal) : message.overDraftUnrealizedPrincipal;
        if (message.overDraftRealizedPrincipal != null && message.hasOwnProperty("overDraftRealizedPrincipal"))
          object.overDraftRealizedPrincipal = options.json && !isFinite(message.overDraftRealizedPrincipal) ? String(message.overDraftRealizedPrincipal) : message.overDraftRealizedPrincipal;
        if (message.overDraftUnrealizedInterest != null && message.hasOwnProperty("overDraftUnrealizedInterest"))
          object.overDraftUnrealizedInterest = options.json && !isFinite(message.overDraftUnrealizedInterest) ? String(message.overDraftUnrealizedInterest) : message.overDraftUnrealizedInterest;
        if (message.overDraftRealizedInterest != null && message.hasOwnProperty("overDraftRealizedInterest"))
          object.overDraftRealizedInterest = options.json && !isFinite(message.overDraftRealizedInterest) ? String(message.overDraftRealizedInterest) : message.overDraftRealizedInterest;
        if (message.paidOverDraftPrincipal != null && message.hasOwnProperty("paidOverDraftPrincipal"))
          object.paidOverDraftPrincipal = options.json && !isFinite(message.paidOverDraftPrincipal) ? String(message.paidOverDraftPrincipal) : message.paidOverDraftPrincipal;
        if (message.paidOverDraftInterest != null && message.hasOwnProperty("paidOverDraftInterest"))
          object.paidOverDraftInterest = options.json && !isFinite(message.paidOverDraftInterest) ? String(message.paidOverDraftInterest) : message.paidOverDraftInterest;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.averageCostPrice != null && message.hasOwnProperty("averageCostPrice"))
          object.averageCostPrice = options.json && !isFinite(message.averageCostPrice) ? String(message.averageCostPrice) : message.averageCostPrice;
        if (message.dailyPositionFee != null && message.hasOwnProperty("dailyPositionFee"))
          object.dailyPositionFee = options.json && !isFinite(message.dailyPositionFee) ? String(message.dailyPositionFee) : message.dailyPositionFee;
        if (message.depositSecure != null && message.hasOwnProperty("depositSecure"))
          object.depositSecure = options.json && !isFinite(message.depositSecure) ? String(message.depositSecure) : message.depositSecure;
        if (message.accumulateSecure != null && message.hasOwnProperty("accumulateSecure"))
          object.accumulateSecure = options.json && !isFinite(message.accumulateSecure) ? String(message.accumulateSecure) : message.accumulateSecure;
        if (message.totalRealizedProfitVM != null && message.hasOwnProperty("totalRealizedProfitVM"))
          object.totalRealizedProfitVM = options.json && !isFinite(message.totalRealizedProfitVM) ? String(message.totalRealizedProfitVM) : message.totalRealizedProfitVM;
        if (message.dailyRealizedTaxAndFee != null && message.hasOwnProperty("dailyRealizedTaxAndFee"))
          object.dailyRealizedTaxAndFee = options.json && !isFinite(message.dailyRealizedTaxAndFee) ? String(message.dailyRealizedTaxAndFee) : message.dailyRealizedTaxAndFee;
        if (message.dailyRealizedInterest != null && message.hasOwnProperty("dailyRealizedInterest"))
          object.dailyRealizedInterest = options.json && !isFinite(message.dailyRealizedInterest) ? String(message.dailyRealizedInterest) : message.dailyRealizedInterest;
        if (message.dailyRealizedPositionFee != null && message.hasOwnProperty("dailyRealizedPositionFee"))
          object.dailyRealizedPositionFee = options.json && !isFinite(message.dailyRealizedPositionFee) ? String(message.dailyRealizedPositionFee) : message.dailyRealizedPositionFee;
        if (message.maturityFee != null && message.hasOwnProperty("maturityFee"))
          object.maturityFee = options.json && !isFinite(message.maturityFee) ? String(message.maturityFee) : message.maturityFee;
        if (message.dailyTaxAndFeeObligation != null && message.hasOwnProperty("dailyTaxAndFeeObligation"))
          object.dailyTaxAndFeeObligation = options.json && !isFinite(message.dailyTaxAndFeeObligation) ? String(message.dailyTaxAndFeeObligation) : message.dailyTaxAndFeeObligation;
        if (message.dailyPositionObligation != null && message.hasOwnProperty("dailyPositionObligation"))
          object.dailyPositionObligation = options.json && !isFinite(message.dailyPositionObligation) ? String(message.dailyPositionObligation) : message.dailyPositionObligation;
        if (message.dailyClosedTaxAndFeeObligation != null && message.hasOwnProperty("dailyClosedTaxAndFeeObligation"))
          object.dailyClosedTaxAndFeeObligation = options.json && !isFinite(message.dailyClosedTaxAndFeeObligation) ? String(message.dailyClosedTaxAndFeeObligation) : message.dailyClosedTaxAndFeeObligation;
        if (message.dailyRealizedPaidProfitVM != null && message.hasOwnProperty("dailyRealizedPaidProfitVM"))
          object.dailyRealizedPaidProfitVM = options.json && !isFinite(message.dailyRealizedPaidProfitVM) ? String(message.dailyRealizedPaidProfitVM) : message.dailyRealizedPaidProfitVM;
        return object;
      };
      DerivativeDeal.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DerivativeDeal.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OPEN"] = 0;
        values[valuesById[1] = "CLOSED"] = 1;
        values[valuesById[2] = "UNKNOWN"] = 2;
        return values;
      }();
      DerivativeDeal.Side = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NS"] = 0;
        values[valuesById[1] = "NB"] = 1;
        values[valuesById[3] = "CROSS"] = 3;
        values[valuesById[4] = "UNDISCLOSED"] = 4;
        return values;
      }();
      return DerivativeDeal;
    }();
    fo.SettlementControlMessage = function() {
      function SettlementControlMessage(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      SettlementControlMessage.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      SettlementControlMessage.prototype.type = "";
      SettlementControlMessage.prototype.value = "";
      SettlementControlMessage.prototype.bizDate = null;
      SettlementControlMessage.prototype.createTime = null;
      SettlementControlMessage.create = function create(properties) {
        return new SettlementControlMessage(properties);
      };
      SettlementControlMessage.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(18).string(message.type);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(26).string(message.value);
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          $root.google.protobuf.Timestamp.encode(message.bizDate, writer.uint32(34).fork()).ldelim();
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
          $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(42).fork()).ldelim();
        return writer;
      };
      SettlementControlMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      SettlementControlMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.SettlementControlMessage();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.type = reader.string();
              break;
            case 3:
              message.value = reader.string();
              break;
            case 4:
              message.bizDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 5:
              message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      SettlementControlMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      SettlementControlMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.value != null && message.hasOwnProperty("value")) {
          if (!$util.isString(message.value))
            return "value: string expected";
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.bizDate);
          if (error)
            return "bizDate." + error;
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createTime);
          if (error)
            return "createTime." + error;
        }
        return null;
      };
      SettlementControlMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.SettlementControlMessage)
          return object;
        let message = new $root.dnse.fo.SettlementControlMessage();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.type != null)
          message.type = String(object.type);
        if (object.value != null)
          message.value = String(object.value);
        if (object.bizDate != null) {
          if (typeof object.bizDate !== "object")
            throw TypeError(".dnse.fo.SettlementControlMessage.bizDate: object expected");
          message.bizDate = $root.google.protobuf.Timestamp.fromObject(object.bizDate);
        }
        if (object.createTime != null) {
          if (typeof object.createTime !== "object")
            throw TypeError(".dnse.fo.SettlementControlMessage.createTime: object expected");
          message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
        }
        return message;
      };
      SettlementControlMessage.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.type = "";
          object.value = "";
          object.bizDate = null;
          object.createTime = null;
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.value != null && message.hasOwnProperty("value"))
          object.value = message.value;
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = $root.google.protobuf.Timestamp.toObject(message.bizDate, options);
        if (message.createTime != null && message.hasOwnProperty("createTime"))
          object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
        return object;
      };
      SettlementControlMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return SettlementControlMessage;
    }();
    fo.InitialMargin = function() {
      function InitialMargin(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      InitialMargin.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      InitialMargin.prototype.type = "";
      InitialMargin.prototype.basketIMRateId = "";
      InitialMargin.prototype.basketIMRateName = "";
      InitialMargin.prototype.symbol = "";
      InitialMargin.prototype.imRate = 0;
      InitialMargin.prototype.dmE1Rate = 0;
      InitialMargin.prototype.dmE2Rate = 0;
      InitialMargin.prototype.status = "";
      InitialMargin.prototype.createTime = null;
      InitialMargin.create = function create(properties) {
        return new InitialMargin(properties);
      };
      InitialMargin.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(18).string(message.type);
        if (message.basketIMRateId != null && Object.hasOwnProperty.call(message, "basketIMRateId"))
          writer.uint32(26).string(message.basketIMRateId);
        if (message.basketIMRateName != null && Object.hasOwnProperty.call(message, "basketIMRateName"))
          writer.uint32(34).string(message.basketIMRateName);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(42).string(message.symbol);
        if (message.imRate != null && Object.hasOwnProperty.call(message, "imRate"))
          writer.uint32(49).double(message.imRate);
        if (message.dmE1Rate != null && Object.hasOwnProperty.call(message, "dmE1Rate"))
          writer.uint32(57).double(message.dmE1Rate);
        if (message.dmE2Rate != null && Object.hasOwnProperty.call(message, "dmE2Rate"))
          writer.uint32(65).double(message.dmE2Rate);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(74).string(message.status);
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
          $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(82).fork()).ldelim();
        return writer;
      };
      InitialMargin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      InitialMargin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.InitialMargin();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.type = reader.string();
              break;
            case 3:
              message.basketIMRateId = reader.string();
              break;
            case 4:
              message.basketIMRateName = reader.string();
              break;
            case 5:
              message.symbol = reader.string();
              break;
            case 6:
              message.imRate = reader.double();
              break;
            case 7:
              message.dmE1Rate = reader.double();
              break;
            case 8:
              message.dmE2Rate = reader.double();
              break;
            case 9:
              message.status = reader.string();
              break;
            case 10:
              message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      InitialMargin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      InitialMargin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.basketIMRateId != null && message.hasOwnProperty("basketIMRateId")) {
          if (!$util.isString(message.basketIMRateId))
            return "basketIMRateId: string expected";
        }
        if (message.basketIMRateName != null && message.hasOwnProperty("basketIMRateName")) {
          if (!$util.isString(message.basketIMRateName))
            return "basketIMRateName: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.imRate != null && message.hasOwnProperty("imRate")) {
          if (typeof message.imRate !== "number")
            return "imRate: number expected";
        }
        if (message.dmE1Rate != null && message.hasOwnProperty("dmE1Rate")) {
          if (typeof message.dmE1Rate !== "number")
            return "dmE1Rate: number expected";
        }
        if (message.dmE2Rate != null && message.hasOwnProperty("dmE2Rate")) {
          if (typeof message.dmE2Rate !== "number")
            return "dmE2Rate: number expected";
        }
        if (message.status != null && message.hasOwnProperty("status")) {
          if (!$util.isString(message.status))
            return "status: string expected";
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createTime);
          if (error)
            return "createTime." + error;
        }
        return null;
      };
      InitialMargin.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.InitialMargin)
          return object;
        let message = new $root.dnse.fo.InitialMargin();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.type != null)
          message.type = String(object.type);
        if (object.basketIMRateId != null)
          message.basketIMRateId = String(object.basketIMRateId);
        if (object.basketIMRateName != null)
          message.basketIMRateName = String(object.basketIMRateName);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.imRate != null)
          message.imRate = Number(object.imRate);
        if (object.dmE1Rate != null)
          message.dmE1Rate = Number(object.dmE1Rate);
        if (object.dmE2Rate != null)
          message.dmE2Rate = Number(object.dmE2Rate);
        if (object.status != null)
          message.status = String(object.status);
        if (object.createTime != null) {
          if (typeof object.createTime !== "object")
            throw TypeError(".dnse.fo.InitialMargin.createTime: object expected");
          message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
        }
        return message;
      };
      InitialMargin.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.type = "";
          object.basketIMRateId = "";
          object.basketIMRateName = "";
          object.symbol = "";
          object.imRate = 0;
          object.dmE1Rate = 0;
          object.dmE2Rate = 0;
          object.status = "";
          object.createTime = null;
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.basketIMRateId != null && message.hasOwnProperty("basketIMRateId"))
          object.basketIMRateId = message.basketIMRateId;
        if (message.basketIMRateName != null && message.hasOwnProperty("basketIMRateName"))
          object.basketIMRateName = message.basketIMRateName;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.imRate != null && message.hasOwnProperty("imRate"))
          object.imRate = options.json && !isFinite(message.imRate) ? String(message.imRate) : message.imRate;
        if (message.dmE1Rate != null && message.hasOwnProperty("dmE1Rate"))
          object.dmE1Rate = options.json && !isFinite(message.dmE1Rate) ? String(message.dmE1Rate) : message.dmE1Rate;
        if (message.dmE2Rate != null && message.hasOwnProperty("dmE2Rate"))
          object.dmE2Rate = options.json && !isFinite(message.dmE2Rate) ? String(message.dmE2Rate) : message.dmE2Rate;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = message.status;
        if (message.createTime != null && message.hasOwnProperty("createTime"))
          object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
        return object;
      };
      InitialMargin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return InitialMargin;
    }();
    fo.DerivativeCashAccount = function() {
      function DerivativeCashAccount(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeCashAccount.prototype.accountNo = "";
      DerivativeCashAccount.prototype.loanPackageId = 0;
      DerivativeCashAccount.prototype.vsdSecure = 0;
      DerivativeCashAccount.prototype.dailyRealizedProfit = 0;
      DerivativeCashAccount.prototype.dailyRealizedLoss = 0;
      DerivativeCashAccount.prototype.dailyRealizedExchangeFee = 0;
      DerivativeCashAccount.prototype.dailyRealizedTradingFee = 0;
      DerivativeCashAccount.prototype.dailyRealizedTradingTax = 0;
      DerivativeCashAccount.prototype.assetManagementDebt = 0;
      DerivativeCashAccount.prototype.assetManagementOvernightFee = 0;
      DerivativeCashAccount.prototype.dailyRealizedCloseDebt = 0;
      DerivativeCashAccount.prototype.otherDebt = 0;
      DerivativeCashAccount.prototype.collateralFee = 0;
      DerivativeCashAccount.prototype.modifiedDate = null;
      DerivativeCashAccount.prototype.createdDate = null;
      DerivativeCashAccount.prototype.remainTaxAndFee = 0;
      DerivativeCashAccount.prototype.dailyPositionFee = 0;
      DerivativeCashAccount.prototype.remainDebt = 0;
      DerivativeCashAccount.prototype.uncollectedCollateralFee = 0;
      DerivativeCashAccount.prototype.toCollectDebt = 0;
      DerivativeCashAccount.prototype.holdDailyRealizedTradingTaxAndFee = 0;
      DerivativeCashAccount.prototype.holdCollateralFee = 0;
      DerivativeCashAccount.prototype.totalLoanDebt = 0;
      DerivativeCashAccount.prototype.status = 0;
      DerivativeCashAccount.prototype.profitVmReceiving = 0;
      DerivativeCashAccount.prototype.maturityFee = 0;
      DerivativeCashAccount.prototype.totalDailyProfit = 0;
      DerivativeCashAccount.create = function create(properties) {
        return new DerivativeCashAccount(properties);
      };
      DerivativeCashAccount.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(16).int32(message.loanPackageId);
        if (message.vsdSecure != null && Object.hasOwnProperty.call(message, "vsdSecure"))
          writer.uint32(25).double(message.vsdSecure);
        if (message.dailyRealizedProfit != null && Object.hasOwnProperty.call(message, "dailyRealizedProfit"))
          writer.uint32(33).double(message.dailyRealizedProfit);
        if (message.dailyRealizedLoss != null && Object.hasOwnProperty.call(message, "dailyRealizedLoss"))
          writer.uint32(41).double(message.dailyRealizedLoss);
        if (message.dailyRealizedExchangeFee != null && Object.hasOwnProperty.call(message, "dailyRealizedExchangeFee"))
          writer.uint32(49).double(message.dailyRealizedExchangeFee);
        if (message.dailyRealizedTradingFee != null && Object.hasOwnProperty.call(message, "dailyRealizedTradingFee"))
          writer.uint32(57).double(message.dailyRealizedTradingFee);
        if (message.dailyRealizedTradingTax != null && Object.hasOwnProperty.call(message, "dailyRealizedTradingTax"))
          writer.uint32(65).double(message.dailyRealizedTradingTax);
        if (message.assetManagementDebt != null && Object.hasOwnProperty.call(message, "assetManagementDebt"))
          writer.uint32(73).double(message.assetManagementDebt);
        if (message.assetManagementOvernightFee != null && Object.hasOwnProperty.call(message, "assetManagementOvernightFee"))
          writer.uint32(81).double(message.assetManagementOvernightFee);
        if (message.dailyRealizedCloseDebt != null && Object.hasOwnProperty.call(message, "dailyRealizedCloseDebt"))
          writer.uint32(89).double(message.dailyRealizedCloseDebt);
        if (message.otherDebt != null && Object.hasOwnProperty.call(message, "otherDebt"))
          writer.uint32(97).double(message.otherDebt);
        if (message.collateralFee != null && Object.hasOwnProperty.call(message, "collateralFee"))
          writer.uint32(105).double(message.collateralFee);
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(114).fork()).ldelim();
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(122).fork()).ldelim();
        if (message.remainTaxAndFee != null && Object.hasOwnProperty.call(message, "remainTaxAndFee"))
          writer.uint32(129).double(message.remainTaxAndFee);
        if (message.dailyPositionFee != null && Object.hasOwnProperty.call(message, "dailyPositionFee"))
          writer.uint32(137).double(message.dailyPositionFee);
        if (message.remainDebt != null && Object.hasOwnProperty.call(message, "remainDebt"))
          writer.uint32(145).double(message.remainDebt);
        if (message.uncollectedCollateralFee != null && Object.hasOwnProperty.call(message, "uncollectedCollateralFee"))
          writer.uint32(153).double(message.uncollectedCollateralFee);
        if (message.toCollectDebt != null && Object.hasOwnProperty.call(message, "toCollectDebt"))
          writer.uint32(161).double(message.toCollectDebt);
        if (message.holdDailyRealizedTradingTaxAndFee != null && Object.hasOwnProperty.call(message, "holdDailyRealizedTradingTaxAndFee"))
          writer.uint32(169).double(message.holdDailyRealizedTradingTaxAndFee);
        if (message.holdCollateralFee != null && Object.hasOwnProperty.call(message, "holdCollateralFee"))
          writer.uint32(177).double(message.holdCollateralFee);
        if (message.totalLoanDebt != null && Object.hasOwnProperty.call(message, "totalLoanDebt"))
          writer.uint32(185).double(message.totalLoanDebt);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(192).int32(message.status);
        if (message.profitVmReceiving != null && Object.hasOwnProperty.call(message, "profitVmReceiving"))
          writer.uint32(201).double(message.profitVmReceiving);
        if (message.maturityFee != null && Object.hasOwnProperty.call(message, "maturityFee"))
          writer.uint32(209).double(message.maturityFee);
        if (message.totalDailyProfit != null && Object.hasOwnProperty.call(message, "totalDailyProfit"))
          writer.uint32(217).double(message.totalDailyProfit);
        return writer;
      };
      DerivativeCashAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeCashAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeCashAccount();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.loanPackageId = reader.int32();
              break;
            case 3:
              message.vsdSecure = reader.double();
              break;
            case 4:
              message.dailyRealizedProfit = reader.double();
              break;
            case 5:
              message.dailyRealizedLoss = reader.double();
              break;
            case 6:
              message.dailyRealizedExchangeFee = reader.double();
              break;
            case 7:
              message.dailyRealizedTradingFee = reader.double();
              break;
            case 8:
              message.dailyRealizedTradingTax = reader.double();
              break;
            case 9:
              message.assetManagementDebt = reader.double();
              break;
            case 10:
              message.assetManagementOvernightFee = reader.double();
              break;
            case 11:
              message.dailyRealizedCloseDebt = reader.double();
              break;
            case 12:
              message.otherDebt = reader.double();
              break;
            case 13:
              message.collateralFee = reader.double();
              break;
            case 14:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 15:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 16:
              message.remainTaxAndFee = reader.double();
              break;
            case 17:
              message.dailyPositionFee = reader.double();
              break;
            case 18:
              message.remainDebt = reader.double();
              break;
            case 19:
              message.uncollectedCollateralFee = reader.double();
              break;
            case 20:
              message.toCollectDebt = reader.double();
              break;
            case 21:
              message.holdDailyRealizedTradingTaxAndFee = reader.double();
              break;
            case 22:
              message.holdCollateralFee = reader.double();
              break;
            case 23:
              message.totalLoanDebt = reader.double();
              break;
            case 24:
              message.status = reader.int32();
              break;
            case 25:
              message.profitVmReceiving = reader.double();
              break;
            case 26:
              message.maturityFee = reader.double();
              break;
            case 27:
              message.totalDailyProfit = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeCashAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeCashAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.vsdSecure != null && message.hasOwnProperty("vsdSecure")) {
          if (typeof message.vsdSecure !== "number")
            return "vsdSecure: number expected";
        }
        if (message.dailyRealizedProfit != null && message.hasOwnProperty("dailyRealizedProfit")) {
          if (typeof message.dailyRealizedProfit !== "number")
            return "dailyRealizedProfit: number expected";
        }
        if (message.dailyRealizedLoss != null && message.hasOwnProperty("dailyRealizedLoss")) {
          if (typeof message.dailyRealizedLoss !== "number")
            return "dailyRealizedLoss: number expected";
        }
        if (message.dailyRealizedExchangeFee != null && message.hasOwnProperty("dailyRealizedExchangeFee")) {
          if (typeof message.dailyRealizedExchangeFee !== "number")
            return "dailyRealizedExchangeFee: number expected";
        }
        if (message.dailyRealizedTradingFee != null && message.hasOwnProperty("dailyRealizedTradingFee")) {
          if (typeof message.dailyRealizedTradingFee !== "number")
            return "dailyRealizedTradingFee: number expected";
        }
        if (message.dailyRealizedTradingTax != null && message.hasOwnProperty("dailyRealizedTradingTax")) {
          if (typeof message.dailyRealizedTradingTax !== "number")
            return "dailyRealizedTradingTax: number expected";
        }
        if (message.assetManagementDebt != null && message.hasOwnProperty("assetManagementDebt")) {
          if (typeof message.assetManagementDebt !== "number")
            return "assetManagementDebt: number expected";
        }
        if (message.assetManagementOvernightFee != null && message.hasOwnProperty("assetManagementOvernightFee")) {
          if (typeof message.assetManagementOvernightFee !== "number")
            return "assetManagementOvernightFee: number expected";
        }
        if (message.dailyRealizedCloseDebt != null && message.hasOwnProperty("dailyRealizedCloseDebt")) {
          if (typeof message.dailyRealizedCloseDebt !== "number")
            return "dailyRealizedCloseDebt: number expected";
        }
        if (message.otherDebt != null && message.hasOwnProperty("otherDebt")) {
          if (typeof message.otherDebt !== "number")
            return "otherDebt: number expected";
        }
        if (message.collateralFee != null && message.hasOwnProperty("collateralFee")) {
          if (typeof message.collateralFee !== "number")
            return "collateralFee: number expected";
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.remainTaxAndFee != null && message.hasOwnProperty("remainTaxAndFee")) {
          if (typeof message.remainTaxAndFee !== "number")
            return "remainTaxAndFee: number expected";
        }
        if (message.dailyPositionFee != null && message.hasOwnProperty("dailyPositionFee")) {
          if (typeof message.dailyPositionFee !== "number")
            return "dailyPositionFee: number expected";
        }
        if (message.remainDebt != null && message.hasOwnProperty("remainDebt")) {
          if (typeof message.remainDebt !== "number")
            return "remainDebt: number expected";
        }
        if (message.uncollectedCollateralFee != null && message.hasOwnProperty("uncollectedCollateralFee")) {
          if (typeof message.uncollectedCollateralFee !== "number")
            return "uncollectedCollateralFee: number expected";
        }
        if (message.toCollectDebt != null && message.hasOwnProperty("toCollectDebt")) {
          if (typeof message.toCollectDebt !== "number")
            return "toCollectDebt: number expected";
        }
        if (message.holdDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("holdDailyRealizedTradingTaxAndFee")) {
          if (typeof message.holdDailyRealizedTradingTaxAndFee !== "number")
            return "holdDailyRealizedTradingTaxAndFee: number expected";
        }
        if (message.holdCollateralFee != null && message.hasOwnProperty("holdCollateralFee")) {
          if (typeof message.holdCollateralFee !== "number")
            return "holdCollateralFee: number expected";
        }
        if (message.totalLoanDebt != null && message.hasOwnProperty("totalLoanDebt")) {
          if (typeof message.totalLoanDebt !== "number")
            return "totalLoanDebt: number expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
              break;
          }
        if (message.profitVmReceiving != null && message.hasOwnProperty("profitVmReceiving")) {
          if (typeof message.profitVmReceiving !== "number")
            return "profitVmReceiving: number expected";
        }
        if (message.maturityFee != null && message.hasOwnProperty("maturityFee")) {
          if (typeof message.maturityFee !== "number")
            return "maturityFee: number expected";
        }
        if (message.totalDailyProfit != null && message.hasOwnProperty("totalDailyProfit")) {
          if (typeof message.totalDailyProfit !== "number")
            return "totalDailyProfit: number expected";
        }
        return null;
      };
      DerivativeCashAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeCashAccount)
          return object;
        let message = new $root.dnse.fo.DerivativeCashAccount();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.vsdSecure != null)
          message.vsdSecure = Number(object.vsdSecure);
        if (object.dailyRealizedProfit != null)
          message.dailyRealizedProfit = Number(object.dailyRealizedProfit);
        if (object.dailyRealizedLoss != null)
          message.dailyRealizedLoss = Number(object.dailyRealizedLoss);
        if (object.dailyRealizedExchangeFee != null)
          message.dailyRealizedExchangeFee = Number(object.dailyRealizedExchangeFee);
        if (object.dailyRealizedTradingFee != null)
          message.dailyRealizedTradingFee = Number(object.dailyRealizedTradingFee);
        if (object.dailyRealizedTradingTax != null)
          message.dailyRealizedTradingTax = Number(object.dailyRealizedTradingTax);
        if (object.assetManagementDebt != null)
          message.assetManagementDebt = Number(object.assetManagementDebt);
        if (object.assetManagementOvernightFee != null)
          message.assetManagementOvernightFee = Number(object.assetManagementOvernightFee);
        if (object.dailyRealizedCloseDebt != null)
          message.dailyRealizedCloseDebt = Number(object.dailyRealizedCloseDebt);
        if (object.otherDebt != null)
          message.otherDebt = Number(object.otherDebt);
        if (object.collateralFee != null)
          message.collateralFee = Number(object.collateralFee);
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeCashAccount.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeCashAccount.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.remainTaxAndFee != null)
          message.remainTaxAndFee = Number(object.remainTaxAndFee);
        if (object.dailyPositionFee != null)
          message.dailyPositionFee = Number(object.dailyPositionFee);
        if (object.remainDebt != null)
          message.remainDebt = Number(object.remainDebt);
        if (object.uncollectedCollateralFee != null)
          message.uncollectedCollateralFee = Number(object.uncollectedCollateralFee);
        if (object.toCollectDebt != null)
          message.toCollectDebt = Number(object.toCollectDebt);
        if (object.holdDailyRealizedTradingTaxAndFee != null)
          message.holdDailyRealizedTradingTaxAndFee = Number(object.holdDailyRealizedTradingTaxAndFee);
        if (object.holdCollateralFee != null)
          message.holdCollateralFee = Number(object.holdCollateralFee);
        if (object.totalLoanDebt != null)
          message.totalLoanDebt = Number(object.totalLoanDebt);
        switch (object.status) {
          case "ACTIVE":
          case 0:
            message.status = 0;
            break;
          case "INACTIVE":
          case 1:
            message.status = 1;
            break;
        }
        if (object.profitVmReceiving != null)
          message.profitVmReceiving = Number(object.profitVmReceiving);
        if (object.maturityFee != null)
          message.maturityFee = Number(object.maturityFee);
        if (object.totalDailyProfit != null)
          message.totalDailyProfit = Number(object.totalDailyProfit);
        return message;
      };
      DerivativeCashAccount.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.accountNo = "";
          object.loanPackageId = 0;
          object.vsdSecure = 0;
          object.dailyRealizedProfit = 0;
          object.dailyRealizedLoss = 0;
          object.dailyRealizedExchangeFee = 0;
          object.dailyRealizedTradingFee = 0;
          object.dailyRealizedTradingTax = 0;
          object.assetManagementDebt = 0;
          object.assetManagementOvernightFee = 0;
          object.dailyRealizedCloseDebt = 0;
          object.otherDebt = 0;
          object.collateralFee = 0;
          object.modifiedDate = null;
          object.createdDate = null;
          object.remainTaxAndFee = 0;
          object.dailyPositionFee = 0;
          object.remainDebt = 0;
          object.uncollectedCollateralFee = 0;
          object.toCollectDebt = 0;
          object.holdDailyRealizedTradingTaxAndFee = 0;
          object.holdCollateralFee = 0;
          object.totalLoanDebt = 0;
          object.status = options.enums === String ? "ACTIVE" : 0;
          object.profitVmReceiving = 0;
          object.maturityFee = 0;
          object.totalDailyProfit = 0;
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.vsdSecure != null && message.hasOwnProperty("vsdSecure"))
          object.vsdSecure = options.json && !isFinite(message.vsdSecure) ? String(message.vsdSecure) : message.vsdSecure;
        if (message.dailyRealizedProfit != null && message.hasOwnProperty("dailyRealizedProfit"))
          object.dailyRealizedProfit = options.json && !isFinite(message.dailyRealizedProfit) ? String(message.dailyRealizedProfit) : message.dailyRealizedProfit;
        if (message.dailyRealizedLoss != null && message.hasOwnProperty("dailyRealizedLoss"))
          object.dailyRealizedLoss = options.json && !isFinite(message.dailyRealizedLoss) ? String(message.dailyRealizedLoss) : message.dailyRealizedLoss;
        if (message.dailyRealizedExchangeFee != null && message.hasOwnProperty("dailyRealizedExchangeFee"))
          object.dailyRealizedExchangeFee = options.json && !isFinite(message.dailyRealizedExchangeFee) ? String(message.dailyRealizedExchangeFee) : message.dailyRealizedExchangeFee;
        if (message.dailyRealizedTradingFee != null && message.hasOwnProperty("dailyRealizedTradingFee"))
          object.dailyRealizedTradingFee = options.json && !isFinite(message.dailyRealizedTradingFee) ? String(message.dailyRealizedTradingFee) : message.dailyRealizedTradingFee;
        if (message.dailyRealizedTradingTax != null && message.hasOwnProperty("dailyRealizedTradingTax"))
          object.dailyRealizedTradingTax = options.json && !isFinite(message.dailyRealizedTradingTax) ? String(message.dailyRealizedTradingTax) : message.dailyRealizedTradingTax;
        if (message.assetManagementDebt != null && message.hasOwnProperty("assetManagementDebt"))
          object.assetManagementDebt = options.json && !isFinite(message.assetManagementDebt) ? String(message.assetManagementDebt) : message.assetManagementDebt;
        if (message.assetManagementOvernightFee != null && message.hasOwnProperty("assetManagementOvernightFee"))
          object.assetManagementOvernightFee = options.json && !isFinite(message.assetManagementOvernightFee) ? String(message.assetManagementOvernightFee) : message.assetManagementOvernightFee;
        if (message.dailyRealizedCloseDebt != null && message.hasOwnProperty("dailyRealizedCloseDebt"))
          object.dailyRealizedCloseDebt = options.json && !isFinite(message.dailyRealizedCloseDebt) ? String(message.dailyRealizedCloseDebt) : message.dailyRealizedCloseDebt;
        if (message.otherDebt != null && message.hasOwnProperty("otherDebt"))
          object.otherDebt = options.json && !isFinite(message.otherDebt) ? String(message.otherDebt) : message.otherDebt;
        if (message.collateralFee != null && message.hasOwnProperty("collateralFee"))
          object.collateralFee = options.json && !isFinite(message.collateralFee) ? String(message.collateralFee) : message.collateralFee;
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.remainTaxAndFee != null && message.hasOwnProperty("remainTaxAndFee"))
          object.remainTaxAndFee = options.json && !isFinite(message.remainTaxAndFee) ? String(message.remainTaxAndFee) : message.remainTaxAndFee;
        if (message.dailyPositionFee != null && message.hasOwnProperty("dailyPositionFee"))
          object.dailyPositionFee = options.json && !isFinite(message.dailyPositionFee) ? String(message.dailyPositionFee) : message.dailyPositionFee;
        if (message.remainDebt != null && message.hasOwnProperty("remainDebt"))
          object.remainDebt = options.json && !isFinite(message.remainDebt) ? String(message.remainDebt) : message.remainDebt;
        if (message.uncollectedCollateralFee != null && message.hasOwnProperty("uncollectedCollateralFee"))
          object.uncollectedCollateralFee = options.json && !isFinite(message.uncollectedCollateralFee) ? String(message.uncollectedCollateralFee) : message.uncollectedCollateralFee;
        if (message.toCollectDebt != null && message.hasOwnProperty("toCollectDebt"))
          object.toCollectDebt = options.json && !isFinite(message.toCollectDebt) ? String(message.toCollectDebt) : message.toCollectDebt;
        if (message.holdDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("holdDailyRealizedTradingTaxAndFee"))
          object.holdDailyRealizedTradingTaxAndFee = options.json && !isFinite(message.holdDailyRealizedTradingTaxAndFee) ? String(message.holdDailyRealizedTradingTaxAndFee) : message.holdDailyRealizedTradingTaxAndFee;
        if (message.holdCollateralFee != null && message.hasOwnProperty("holdCollateralFee"))
          object.holdCollateralFee = options.json && !isFinite(message.holdCollateralFee) ? String(message.holdCollateralFee) : message.holdCollateralFee;
        if (message.totalLoanDebt != null && message.hasOwnProperty("totalLoanDebt"))
          object.totalLoanDebt = options.json && !isFinite(message.totalLoanDebt) ? String(message.totalLoanDebt) : message.totalLoanDebt;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.DerivativeCashAccount.Status[message.status] : message.status;
        if (message.profitVmReceiving != null && message.hasOwnProperty("profitVmReceiving"))
          object.profitVmReceiving = options.json && !isFinite(message.profitVmReceiving) ? String(message.profitVmReceiving) : message.profitVmReceiving;
        if (message.maturityFee != null && message.hasOwnProperty("maturityFee"))
          object.maturityFee = options.json && !isFinite(message.maturityFee) ? String(message.maturityFee) : message.maturityFee;
        if (message.totalDailyProfit != null && message.hasOwnProperty("totalDailyProfit"))
          object.totalDailyProfit = options.json && !isFinite(message.totalDailyProfit) ? String(message.totalDailyProfit) : message.totalDailyProfit;
        return object;
      };
      DerivativeCashAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DerivativeCashAccount.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ACTIVE"] = 0;
        values[valuesById[1] = "INACTIVE"] = 1;
        return values;
      }();
      return DerivativeCashAccount;
    }();
    fo.DerivativeDealRisk = function() {
      function DerivativeDealRisk(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeDealRisk.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDealRisk.prototype.accountNo = "";
      DerivativeDealRisk.prototype.side = "";
      DerivativeDealRisk.prototype.symbol = "";
      DerivativeDealRisk.prototype.openQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDealRisk.prototype.marketPrice = 0;
      DerivativeDealRisk.prototype.dealRate = 0;
      DerivativeDealRisk.prototype.status = 0;
      DerivativeDealRisk.prototype.liquidated = false;
      DerivativeDealRisk.prototype.callAmountToMaintenance = 0;
      DerivativeDealRisk.prototype.callAmountToInitial = 0;
      DerivativeDealRisk.prototype.liquidQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDealRisk.prototype.liquidPriceGain = 0;
      DerivativeDealRisk.prototype.liquidPriceLoss = 0;
      DerivativeDealRisk.prototype.maintenancePriceGain = 0;
      DerivativeDealRisk.prototype.maintenancePriceLoss = 0;
      DerivativeDealRisk.prototype.stopLossPrice = 0;
      DerivativeDealRisk.prototype.takeProfitPrice = 0;
      DerivativeDealRisk.prototype.createdDate = null;
      DerivativeDealRisk.prototype.modifiedDate = null;
      DerivativeDealRisk.prototype.lastCallAt = null;
      DerivativeDealRisk.prototype.liquidatedAt = null;
      DerivativeDealRisk.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeDealRisk.create = function create(properties) {
        return new DerivativeDealRisk(properties);
      };
      DerivativeDealRisk.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
          writer.uint32(8).int64(message.dealId);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
          writer.uint32(26).string(message.side);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(34).string(message.symbol);
        if (message.openQuantity != null && Object.hasOwnProperty.call(message, "openQuantity"))
          writer.uint32(40).int64(message.openQuantity);
        if (message.marketPrice != null && Object.hasOwnProperty.call(message, "marketPrice"))
          writer.uint32(49).double(message.marketPrice);
        if (message.dealRate != null && Object.hasOwnProperty.call(message, "dealRate"))
          writer.uint32(57).double(message.dealRate);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(64).int32(message.status);
        if (message.liquidated != null && Object.hasOwnProperty.call(message, "liquidated"))
          writer.uint32(72).bool(message.liquidated);
        if (message.callAmountToMaintenance != null && Object.hasOwnProperty.call(message, "callAmountToMaintenance"))
          writer.uint32(81).double(message.callAmountToMaintenance);
        if (message.callAmountToInitial != null && Object.hasOwnProperty.call(message, "callAmountToInitial"))
          writer.uint32(89).double(message.callAmountToInitial);
        if (message.liquidQuantity != null && Object.hasOwnProperty.call(message, "liquidQuantity"))
          writer.uint32(96).int64(message.liquidQuantity);
        if (message.liquidPriceGain != null && Object.hasOwnProperty.call(message, "liquidPriceGain"))
          writer.uint32(105).double(message.liquidPriceGain);
        if (message.liquidPriceLoss != null && Object.hasOwnProperty.call(message, "liquidPriceLoss"))
          writer.uint32(113).double(message.liquidPriceLoss);
        if (message.maintenancePriceGain != null && Object.hasOwnProperty.call(message, "maintenancePriceGain"))
          writer.uint32(121).double(message.maintenancePriceGain);
        if (message.maintenancePriceLoss != null && Object.hasOwnProperty.call(message, "maintenancePriceLoss"))
          writer.uint32(129).double(message.maintenancePriceLoss);
        if (message.stopLossPrice != null && Object.hasOwnProperty.call(message, "stopLossPrice"))
          writer.uint32(137).double(message.stopLossPrice);
        if (message.takeProfitPrice != null && Object.hasOwnProperty.call(message, "takeProfitPrice"))
          writer.uint32(145).double(message.takeProfitPrice);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(154).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(162).fork()).ldelim();
        if (message.lastCallAt != null && Object.hasOwnProperty.call(message, "lastCallAt"))
          $root.google.protobuf.Timestamp.encode(message.lastCallAt, writer.uint32(170).fork()).ldelim();
        if (message.liquidatedAt != null && Object.hasOwnProperty.call(message, "liquidatedAt"))
          $root.google.protobuf.Timestamp.encode(message.liquidatedAt, writer.uint32(178).fork()).ldelim();
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(184).int64(message.loanPackageId);
        return writer;
      };
      DerivativeDealRisk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeDealRisk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeDealRisk();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.dealId = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.side = reader.string();
              break;
            case 4:
              message.symbol = reader.string();
              break;
            case 5:
              message.openQuantity = reader.int64();
              break;
            case 6:
              message.marketPrice = reader.double();
              break;
            case 7:
              message.dealRate = reader.double();
              break;
            case 8:
              message.status = reader.int32();
              break;
            case 9:
              message.liquidated = reader.bool();
              break;
            case 10:
              message.callAmountToMaintenance = reader.double();
              break;
            case 11:
              message.callAmountToInitial = reader.double();
              break;
            case 12:
              message.liquidQuantity = reader.int64();
              break;
            case 13:
              message.liquidPriceGain = reader.double();
              break;
            case 14:
              message.liquidPriceLoss = reader.double();
              break;
            case 15:
              message.maintenancePriceGain = reader.double();
              break;
            case 16:
              message.maintenancePriceLoss = reader.double();
              break;
            case 17:
              message.stopLossPrice = reader.double();
              break;
            case 18:
              message.takeProfitPrice = reader.double();
              break;
            case 19:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 20:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 21:
              message.lastCallAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 22:
              message.liquidatedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 23:
              message.loanPackageId = reader.int64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeDealRisk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeDealRisk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.dealId != null && message.hasOwnProperty("dealId")) {
          if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
            return "dealId: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.side != null && message.hasOwnProperty("side")) {
          if (!$util.isString(message.side))
            return "side: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.openQuantity != null && message.hasOwnProperty("openQuantity")) {
          if (!$util.isInteger(message.openQuantity) && !(message.openQuantity && $util.isInteger(message.openQuantity.low) && $util.isInteger(message.openQuantity.high)))
            return "openQuantity: integer|Long expected";
        }
        if (message.marketPrice != null && message.hasOwnProperty("marketPrice")) {
          if (typeof message.marketPrice !== "number")
            return "marketPrice: number expected";
        }
        if (message.dealRate != null && message.hasOwnProperty("dealRate")) {
          if (typeof message.dealRate !== "number")
            return "dealRate: number expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.liquidated != null && message.hasOwnProperty("liquidated")) {
          if (typeof message.liquidated !== "boolean")
            return "liquidated: boolean expected";
        }
        if (message.callAmountToMaintenance != null && message.hasOwnProperty("callAmountToMaintenance")) {
          if (typeof message.callAmountToMaintenance !== "number")
            return "callAmountToMaintenance: number expected";
        }
        if (message.callAmountToInitial != null && message.hasOwnProperty("callAmountToInitial")) {
          if (typeof message.callAmountToInitial !== "number")
            return "callAmountToInitial: number expected";
        }
        if (message.liquidQuantity != null && message.hasOwnProperty("liquidQuantity")) {
          if (!$util.isInteger(message.liquidQuantity) && !(message.liquidQuantity && $util.isInteger(message.liquidQuantity.low) && $util.isInteger(message.liquidQuantity.high)))
            return "liquidQuantity: integer|Long expected";
        }
        if (message.liquidPriceGain != null && message.hasOwnProperty("liquidPriceGain")) {
          if (typeof message.liquidPriceGain !== "number")
            return "liquidPriceGain: number expected";
        }
        if (message.liquidPriceLoss != null && message.hasOwnProperty("liquidPriceLoss")) {
          if (typeof message.liquidPriceLoss !== "number")
            return "liquidPriceLoss: number expected";
        }
        if (message.maintenancePriceGain != null && message.hasOwnProperty("maintenancePriceGain")) {
          if (typeof message.maintenancePriceGain !== "number")
            return "maintenancePriceGain: number expected";
        }
        if (message.maintenancePriceLoss != null && message.hasOwnProperty("maintenancePriceLoss")) {
          if (typeof message.maintenancePriceLoss !== "number")
            return "maintenancePriceLoss: number expected";
        }
        if (message.stopLossPrice != null && message.hasOwnProperty("stopLossPrice")) {
          if (typeof message.stopLossPrice !== "number")
            return "stopLossPrice: number expected";
        }
        if (message.takeProfitPrice != null && message.hasOwnProperty("takeProfitPrice")) {
          if (typeof message.takeProfitPrice !== "number")
            return "takeProfitPrice: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.lastCallAt != null && message.hasOwnProperty("lastCallAt")) {
          let error = $root.google.protobuf.Timestamp.verify(message.lastCallAt);
          if (error)
            return "lastCallAt." + error;
        }
        if (message.liquidatedAt != null && message.hasOwnProperty("liquidatedAt")) {
          let error = $root.google.protobuf.Timestamp.verify(message.liquidatedAt);
          if (error)
            return "liquidatedAt." + error;
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
            return "loanPackageId: integer|Long expected";
        }
        return null;
      };
      DerivativeDealRisk.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeDealRisk)
          return object;
        let message = new $root.dnse.fo.DerivativeDealRisk();
        if (object.dealId != null) {
          if ($util.Long)
            (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
          else if (typeof object.dealId === "string")
            message.dealId = parseInt(object.dealId, 10);
          else if (typeof object.dealId === "number")
            message.dealId = object.dealId;
          else if (typeof object.dealId === "object")
            message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.side != null)
          message.side = String(object.side);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.openQuantity != null) {
          if ($util.Long)
            (message.openQuantity = $util.Long.fromValue(object.openQuantity)).unsigned = false;
          else if (typeof object.openQuantity === "string")
            message.openQuantity = parseInt(object.openQuantity, 10);
          else if (typeof object.openQuantity === "number")
            message.openQuantity = object.openQuantity;
          else if (typeof object.openQuantity === "object")
            message.openQuantity = new $util.LongBits(object.openQuantity.low >>> 0, object.openQuantity.high >>> 0).toNumber();
        }
        if (object.marketPrice != null)
          message.marketPrice = Number(object.marketPrice);
        if (object.dealRate != null)
          message.dealRate = Number(object.dealRate);
        switch (object.status) {
          case "NORMAL":
          case 0:
            message.status = 0;
            break;
          case "CALL":
          case 1:
            message.status = 1;
            break;
          case "LIQUIDATE":
          case 2:
            message.status = 2;
            break;
          case "CLOSED":
          case 3:
            message.status = 3;
            break;
        }
        if (object.liquidated != null)
          message.liquidated = Boolean(object.liquidated);
        if (object.callAmountToMaintenance != null)
          message.callAmountToMaintenance = Number(object.callAmountToMaintenance);
        if (object.callAmountToInitial != null)
          message.callAmountToInitial = Number(object.callAmountToInitial);
        if (object.liquidQuantity != null) {
          if ($util.Long)
            (message.liquidQuantity = $util.Long.fromValue(object.liquidQuantity)).unsigned = false;
          else if (typeof object.liquidQuantity === "string")
            message.liquidQuantity = parseInt(object.liquidQuantity, 10);
          else if (typeof object.liquidQuantity === "number")
            message.liquidQuantity = object.liquidQuantity;
          else if (typeof object.liquidQuantity === "object")
            message.liquidQuantity = new $util.LongBits(object.liquidQuantity.low >>> 0, object.liquidQuantity.high >>> 0).toNumber();
        }
        if (object.liquidPriceGain != null)
          message.liquidPriceGain = Number(object.liquidPriceGain);
        if (object.liquidPriceLoss != null)
          message.liquidPriceLoss = Number(object.liquidPriceLoss);
        if (object.maintenancePriceGain != null)
          message.maintenancePriceGain = Number(object.maintenancePriceGain);
        if (object.maintenancePriceLoss != null)
          message.maintenancePriceLoss = Number(object.maintenancePriceLoss);
        if (object.stopLossPrice != null)
          message.stopLossPrice = Number(object.stopLossPrice);
        if (object.takeProfitPrice != null)
          message.takeProfitPrice = Number(object.takeProfitPrice);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRisk.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRisk.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.lastCallAt != null) {
          if (typeof object.lastCallAt !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRisk.lastCallAt: object expected");
          message.lastCallAt = $root.google.protobuf.Timestamp.fromObject(object.lastCallAt);
        }
        if (object.liquidatedAt != null) {
          if (typeof object.liquidatedAt !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRisk.liquidatedAt: object expected");
          message.liquidatedAt = $root.google.protobuf.Timestamp.fromObject(object.liquidatedAt);
        }
        if (object.loanPackageId != null) {
          if ($util.Long)
            (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
          else if (typeof object.loanPackageId === "string")
            message.loanPackageId = parseInt(object.loanPackageId, 10);
          else if (typeof object.loanPackageId === "number")
            message.loanPackageId = object.loanPackageId;
          else if (typeof object.loanPackageId === "object")
            message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
        }
        return message;
      };
      DerivativeDealRisk.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.dealId = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.side = "";
          object.symbol = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.openQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.openQuantity = options.longs === String ? "0" : 0;
          object.marketPrice = 0;
          object.dealRate = 0;
          object.status = options.enums === String ? "NORMAL" : 0;
          object.liquidated = false;
          object.callAmountToMaintenance = 0;
          object.callAmountToInitial = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.liquidQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.liquidQuantity = options.longs === String ? "0" : 0;
          object.liquidPriceGain = 0;
          object.liquidPriceLoss = 0;
          object.maintenancePriceGain = 0;
          object.maintenancePriceLoss = 0;
          object.stopLossPrice = 0;
          object.takeProfitPrice = 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.lastCallAt = null;
          object.liquidatedAt = null;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.loanPackageId = options.longs === String ? "0" : 0;
        }
        if (message.dealId != null && message.hasOwnProperty("dealId"))
          if (typeof message.dealId === "number")
            object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
          else
            object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.side != null && message.hasOwnProperty("side"))
          object.side = message.side;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.openQuantity != null && message.hasOwnProperty("openQuantity"))
          if (typeof message.openQuantity === "number")
            object.openQuantity = options.longs === String ? String(message.openQuantity) : message.openQuantity;
          else
            object.openQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.openQuantity) : options.longs === Number ? new $util.LongBits(message.openQuantity.low >>> 0, message.openQuantity.high >>> 0).toNumber() : message.openQuantity;
        if (message.marketPrice != null && message.hasOwnProperty("marketPrice"))
          object.marketPrice = options.json && !isFinite(message.marketPrice) ? String(message.marketPrice) : message.marketPrice;
        if (message.dealRate != null && message.hasOwnProperty("dealRate"))
          object.dealRate = options.json && !isFinite(message.dealRate) ? String(message.dealRate) : message.dealRate;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.DerivativeDealRisk.Status[message.status] : message.status;
        if (message.liquidated != null && message.hasOwnProperty("liquidated"))
          object.liquidated = message.liquidated;
        if (message.callAmountToMaintenance != null && message.hasOwnProperty("callAmountToMaintenance"))
          object.callAmountToMaintenance = options.json && !isFinite(message.callAmountToMaintenance) ? String(message.callAmountToMaintenance) : message.callAmountToMaintenance;
        if (message.callAmountToInitial != null && message.hasOwnProperty("callAmountToInitial"))
          object.callAmountToInitial = options.json && !isFinite(message.callAmountToInitial) ? String(message.callAmountToInitial) : message.callAmountToInitial;
        if (message.liquidQuantity != null && message.hasOwnProperty("liquidQuantity"))
          if (typeof message.liquidQuantity === "number")
            object.liquidQuantity = options.longs === String ? String(message.liquidQuantity) : message.liquidQuantity;
          else
            object.liquidQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.liquidQuantity) : options.longs === Number ? new $util.LongBits(message.liquidQuantity.low >>> 0, message.liquidQuantity.high >>> 0).toNumber() : message.liquidQuantity;
        if (message.liquidPriceGain != null && message.hasOwnProperty("liquidPriceGain"))
          object.liquidPriceGain = options.json && !isFinite(message.liquidPriceGain) ? String(message.liquidPriceGain) : message.liquidPriceGain;
        if (message.liquidPriceLoss != null && message.hasOwnProperty("liquidPriceLoss"))
          object.liquidPriceLoss = options.json && !isFinite(message.liquidPriceLoss) ? String(message.liquidPriceLoss) : message.liquidPriceLoss;
        if (message.maintenancePriceGain != null && message.hasOwnProperty("maintenancePriceGain"))
          object.maintenancePriceGain = options.json && !isFinite(message.maintenancePriceGain) ? String(message.maintenancePriceGain) : message.maintenancePriceGain;
        if (message.maintenancePriceLoss != null && message.hasOwnProperty("maintenancePriceLoss"))
          object.maintenancePriceLoss = options.json && !isFinite(message.maintenancePriceLoss) ? String(message.maintenancePriceLoss) : message.maintenancePriceLoss;
        if (message.stopLossPrice != null && message.hasOwnProperty("stopLossPrice"))
          object.stopLossPrice = options.json && !isFinite(message.stopLossPrice) ? String(message.stopLossPrice) : message.stopLossPrice;
        if (message.takeProfitPrice != null && message.hasOwnProperty("takeProfitPrice"))
          object.takeProfitPrice = options.json && !isFinite(message.takeProfitPrice) ? String(message.takeProfitPrice) : message.takeProfitPrice;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.lastCallAt != null && message.hasOwnProperty("lastCallAt"))
          object.lastCallAt = $root.google.protobuf.Timestamp.toObject(message.lastCallAt, options);
        if (message.liquidatedAt != null && message.hasOwnProperty("liquidatedAt"))
          object.liquidatedAt = $root.google.protobuf.Timestamp.toObject(message.liquidatedAt, options);
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          if (typeof message.loanPackageId === "number")
            object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
          else
            object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
        return object;
      };
      DerivativeDealRisk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DerivativeDealRisk.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NORMAL"] = 0;
        values[valuesById[1] = "CALL"] = 1;
        values[valuesById[2] = "LIQUIDATE"] = 2;
        values[valuesById[3] = "CLOSED"] = 3;
        return values;
      }();
      return DerivativeDealRisk;
    }();
    fo.DerivativeVSDSecure = function() {
      function DerivativeVSDSecure(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeVSDSecure.prototype.custodyCode = "";
      DerivativeVSDSecure.prototype.accountNo = "";
      DerivativeVSDSecure.prototype.investorId = "";
      DerivativeVSDSecure.prototype.accountTypeName = "";
      DerivativeVSDSecure.prototype.amount = 0;
      DerivativeVSDSecure.prototype.vsdSecure = 0;
      DerivativeVSDSecure.prototype.fee = 0;
      DerivativeVSDSecure.prototype.totalDebt = 0;
      DerivativeVSDSecure.prototype.availableCash = 0;
      DerivativeVSDSecure.prototype.createdDate = null;
      DerivativeVSDSecure.prototype.loanPackageName = "";
      DerivativeVSDSecure.prototype.status = 0;
      DerivativeVSDSecure.prototype.initialRate = 0;
      DerivativeVSDSecure.prototype.type = 0;
      DerivativeVSDSecure.prototype.loanAmount = 0;
      DerivativeVSDSecure.prototype.profitAdvanceAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeVSDSecure.prototype.secureAdvanceAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeVSDSecure.prototype.secureWithdrawAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeVSDSecure.create = function create(properties) {
        return new DerivativeVSDSecure(properties);
      };
      DerivativeVSDSecure.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(10).string(message.custodyCode);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(26).string(message.investorId);
        if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
          writer.uint32(34).string(message.accountTypeName);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
          writer.uint32(41).double(message.amount);
        if (message.vsdSecure != null && Object.hasOwnProperty.call(message, "vsdSecure"))
          writer.uint32(49).double(message.vsdSecure);
        if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
          writer.uint32(57).double(message.fee);
        if (message.totalDebt != null && Object.hasOwnProperty.call(message, "totalDebt"))
          writer.uint32(65).double(message.totalDebt);
        if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
          writer.uint32(73).double(message.availableCash);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
        if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
          writer.uint32(90).string(message.loanPackageName);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(96).int32(message.status);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(105).double(message.initialRate);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(112).int32(message.type);
        if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
          writer.uint32(121).double(message.loanAmount);
        if (message.profitAdvanceAmount != null && Object.hasOwnProperty.call(message, "profitAdvanceAmount"))
          writer.uint32(128).int64(message.profitAdvanceAmount);
        if (message.secureAdvanceAmount != null && Object.hasOwnProperty.call(message, "secureAdvanceAmount"))
          writer.uint32(136).int64(message.secureAdvanceAmount);
        if (message.secureWithdrawAmount != null && Object.hasOwnProperty.call(message, "secureWithdrawAmount"))
          writer.uint32(144).int64(message.secureWithdrawAmount);
        return writer;
      };
      DerivativeVSDSecure.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeVSDSecure.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeVSDSecure();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.custodyCode = reader.string();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.investorId = reader.string();
              break;
            case 4:
              message.accountTypeName = reader.string();
              break;
            case 5:
              message.amount = reader.double();
              break;
            case 6:
              message.vsdSecure = reader.double();
              break;
            case 7:
              message.fee = reader.double();
              break;
            case 8:
              message.totalDebt = reader.double();
              break;
            case 9:
              message.availableCash = reader.double();
              break;
            case 10:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 11:
              message.loanPackageName = reader.string();
              break;
            case 12:
              message.status = reader.int32();
              break;
            case 13:
              message.initialRate = reader.double();
              break;
            case 14:
              message.type = reader.int32();
              break;
            case 15:
              message.loanAmount = reader.double();
              break;
            case 16:
              message.profitAdvanceAmount = reader.int64();
              break;
            case 17:
              message.secureAdvanceAmount = reader.int64();
              break;
            case 18:
              message.secureWithdrawAmount = reader.int64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeVSDSecure.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeVSDSecure.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
          if (!$util.isString(message.accountTypeName))
            return "accountTypeName: string expected";
        }
        if (message.amount != null && message.hasOwnProperty("amount")) {
          if (typeof message.amount !== "number")
            return "amount: number expected";
        }
        if (message.vsdSecure != null && message.hasOwnProperty("vsdSecure")) {
          if (typeof message.vsdSecure !== "number")
            return "vsdSecure: number expected";
        }
        if (message.fee != null && message.hasOwnProperty("fee")) {
          if (typeof message.fee !== "number")
            return "fee: number expected";
        }
        if (message.totalDebt != null && message.hasOwnProperty("totalDebt")) {
          if (typeof message.totalDebt !== "number")
            return "totalDebt: number expected";
        }
        if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
          if (typeof message.availableCash !== "number")
            return "availableCash: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
          if (!$util.isString(message.loanPackageName))
            return "loanPackageName: string expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              break;
          }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.type != null && message.hasOwnProperty("type"))
          switch (message.type) {
            default:
              return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
          if (typeof message.loanAmount !== "number")
            return "loanAmount: number expected";
        }
        if (message.profitAdvanceAmount != null && message.hasOwnProperty("profitAdvanceAmount")) {
          if (!$util.isInteger(message.profitAdvanceAmount) && !(message.profitAdvanceAmount && $util.isInteger(message.profitAdvanceAmount.low) && $util.isInteger(message.profitAdvanceAmount.high)))
            return "profitAdvanceAmount: integer|Long expected";
        }
        if (message.secureAdvanceAmount != null && message.hasOwnProperty("secureAdvanceAmount")) {
          if (!$util.isInteger(message.secureAdvanceAmount) && !(message.secureAdvanceAmount && $util.isInteger(message.secureAdvanceAmount.low) && $util.isInteger(message.secureAdvanceAmount.high)))
            return "secureAdvanceAmount: integer|Long expected";
        }
        if (message.secureWithdrawAmount != null && message.hasOwnProperty("secureWithdrawAmount")) {
          if (!$util.isInteger(message.secureWithdrawAmount) && !(message.secureWithdrawAmount && $util.isInteger(message.secureWithdrawAmount.low) && $util.isInteger(message.secureWithdrawAmount.high)))
            return "secureWithdrawAmount: integer|Long expected";
        }
        return null;
      };
      DerivativeVSDSecure.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeVSDSecure)
          return object;
        let message = new $root.dnse.fo.DerivativeVSDSecure();
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.accountTypeName != null)
          message.accountTypeName = String(object.accountTypeName);
        if (object.amount != null)
          message.amount = Number(object.amount);
        if (object.vsdSecure != null)
          message.vsdSecure = Number(object.vsdSecure);
        if (object.fee != null)
          message.fee = Number(object.fee);
        if (object.totalDebt != null)
          message.totalDebt = Number(object.totalDebt);
        if (object.availableCash != null)
          message.availableCash = Number(object.availableCash);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeVSDSecure.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.loanPackageName != null)
          message.loanPackageName = String(object.loanPackageName);
        switch (object.status) {
          case "WITHDRAW_SUCCESS":
          case 0:
            message.status = 0;
            break;
          case "WITHDRAW_FAILURE":
          case 1:
            message.status = 1;
            break;
          case "DEPOSIT_SUCCESS":
          case 2:
            message.status = 2;
            break;
          case "DEPOSIT_FAILURE":
          case 3:
            message.status = 3;
            break;
          case "DEPOSIT_ERROR":
          case 4:
            message.status = 4;
            break;
          case "DEPOSIT_PENDING_TO_VSD":
          case 5:
            message.status = 5;
            break;
        }
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        switch (object.type) {
          case "WITHDRAW":
          case 0:
            message.type = 0;
            break;
          case "DEPOSIT":
          case 1:
            message.type = 1;
            break;
          case "EOM_WITHDRAW":
          case 2:
            message.type = 2;
            break;
          case "ADVANCE_WITHDRAW":
          case 3:
            message.type = 3;
            break;
        }
        if (object.loanAmount != null)
          message.loanAmount = Number(object.loanAmount);
        if (object.profitAdvanceAmount != null) {
          if ($util.Long)
            (message.profitAdvanceAmount = $util.Long.fromValue(object.profitAdvanceAmount)).unsigned = false;
          else if (typeof object.profitAdvanceAmount === "string")
            message.profitAdvanceAmount = parseInt(object.profitAdvanceAmount, 10);
          else if (typeof object.profitAdvanceAmount === "number")
            message.profitAdvanceAmount = object.profitAdvanceAmount;
          else if (typeof object.profitAdvanceAmount === "object")
            message.profitAdvanceAmount = new $util.LongBits(object.profitAdvanceAmount.low >>> 0, object.profitAdvanceAmount.high >>> 0).toNumber();
        }
        if (object.secureAdvanceAmount != null) {
          if ($util.Long)
            (message.secureAdvanceAmount = $util.Long.fromValue(object.secureAdvanceAmount)).unsigned = false;
          else if (typeof object.secureAdvanceAmount === "string")
            message.secureAdvanceAmount = parseInt(object.secureAdvanceAmount, 10);
          else if (typeof object.secureAdvanceAmount === "number")
            message.secureAdvanceAmount = object.secureAdvanceAmount;
          else if (typeof object.secureAdvanceAmount === "object")
            message.secureAdvanceAmount = new $util.LongBits(object.secureAdvanceAmount.low >>> 0, object.secureAdvanceAmount.high >>> 0).toNumber();
        }
        if (object.secureWithdrawAmount != null) {
          if ($util.Long)
            (message.secureWithdrawAmount = $util.Long.fromValue(object.secureWithdrawAmount)).unsigned = false;
          else if (typeof object.secureWithdrawAmount === "string")
            message.secureWithdrawAmount = parseInt(object.secureWithdrawAmount, 10);
          else if (typeof object.secureWithdrawAmount === "number")
            message.secureWithdrawAmount = object.secureWithdrawAmount;
          else if (typeof object.secureWithdrawAmount === "object")
            message.secureWithdrawAmount = new $util.LongBits(object.secureWithdrawAmount.low >>> 0, object.secureWithdrawAmount.high >>> 0).toNumber();
        }
        return message;
      };
      DerivativeVSDSecure.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.custodyCode = "";
          object.accountNo = "";
          object.investorId = "";
          object.accountTypeName = "";
          object.amount = 0;
          object.vsdSecure = 0;
          object.fee = 0;
          object.totalDebt = 0;
          object.availableCash = 0;
          object.createdDate = null;
          object.loanPackageName = "";
          object.status = options.enums === String ? "WITHDRAW_SUCCESS" : 0;
          object.initialRate = 0;
          object.type = options.enums === String ? "WITHDRAW" : 0;
          object.loanAmount = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.profitAdvanceAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.profitAdvanceAmount = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.secureAdvanceAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.secureAdvanceAmount = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.secureWithdrawAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.secureWithdrawAmount = options.longs === String ? "0" : 0;
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
          object.accountTypeName = message.accountTypeName;
        if (message.amount != null && message.hasOwnProperty("amount"))
          object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
        if (message.vsdSecure != null && message.hasOwnProperty("vsdSecure"))
          object.vsdSecure = options.json && !isFinite(message.vsdSecure) ? String(message.vsdSecure) : message.vsdSecure;
        if (message.fee != null && message.hasOwnProperty("fee"))
          object.fee = options.json && !isFinite(message.fee) ? String(message.fee) : message.fee;
        if (message.totalDebt != null && message.hasOwnProperty("totalDebt"))
          object.totalDebt = options.json && !isFinite(message.totalDebt) ? String(message.totalDebt) : message.totalDebt;
        if (message.availableCash != null && message.hasOwnProperty("availableCash"))
          object.availableCash = options.json && !isFinite(message.availableCash) ? String(message.availableCash) : message.availableCash;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
          object.loanPackageName = message.loanPackageName;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.DerivativeVSDSecureStatus[message.status] : message.status;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = options.enums === String ? $root.dnse.fo.DerivativeVSDSecureType[message.type] : message.type;
        if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
          object.loanAmount = options.json && !isFinite(message.loanAmount) ? String(message.loanAmount) : message.loanAmount;
        if (message.profitAdvanceAmount != null && message.hasOwnProperty("profitAdvanceAmount"))
          if (typeof message.profitAdvanceAmount === "number")
            object.profitAdvanceAmount = options.longs === String ? String(message.profitAdvanceAmount) : message.profitAdvanceAmount;
          else
            object.profitAdvanceAmount = options.longs === String ? $util.Long.prototype.toString.call(message.profitAdvanceAmount) : options.longs === Number ? new $util.LongBits(message.profitAdvanceAmount.low >>> 0, message.profitAdvanceAmount.high >>> 0).toNumber() : message.profitAdvanceAmount;
        if (message.secureAdvanceAmount != null && message.hasOwnProperty("secureAdvanceAmount"))
          if (typeof message.secureAdvanceAmount === "number")
            object.secureAdvanceAmount = options.longs === String ? String(message.secureAdvanceAmount) : message.secureAdvanceAmount;
          else
            object.secureAdvanceAmount = options.longs === String ? $util.Long.prototype.toString.call(message.secureAdvanceAmount) : options.longs === Number ? new $util.LongBits(message.secureAdvanceAmount.low >>> 0, message.secureAdvanceAmount.high >>> 0).toNumber() : message.secureAdvanceAmount;
        if (message.secureWithdrawAmount != null && message.hasOwnProperty("secureWithdrawAmount"))
          if (typeof message.secureWithdrawAmount === "number")
            object.secureWithdrawAmount = options.longs === String ? String(message.secureWithdrawAmount) : message.secureWithdrawAmount;
          else
            object.secureWithdrawAmount = options.longs === String ? $util.Long.prototype.toString.call(message.secureWithdrawAmount) : options.longs === Number ? new $util.LongBits(message.secureWithdrawAmount.low >>> 0, message.secureWithdrawAmount.high >>> 0).toNumber() : message.secureWithdrawAmount;
        return object;
      };
      DerivativeVSDSecure.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeVSDSecure;
    }();
    fo.DerivativeVSDSecureType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "WITHDRAW"] = 0;
      values[valuesById[1] = "DEPOSIT"] = 1;
      values[valuesById[2] = "EOM_WITHDRAW"] = 2;
      values[valuesById[3] = "ADVANCE_WITHDRAW"] = 3;
      return values;
    }();
    fo.DerivativeVSDSecureStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "WITHDRAW_SUCCESS"] = 0;
      values[valuesById[1] = "WITHDRAW_FAILURE"] = 1;
      values[valuesById[2] = "DEPOSIT_SUCCESS"] = 2;
      values[valuesById[3] = "DEPOSIT_FAILURE"] = 3;
      values[valuesById[4] = "DEPOSIT_ERROR"] = 4;
      values[valuesById[5] = "DEPOSIT_PENDING_TO_VSD"] = 5;
      return values;
    }();
    fo.RiskPNLExecutionStrategy = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "PNL_RATE"] = 0;
      values[valuesById[1] = "PNL_AMOUNT"] = 1;
      values[valuesById[2] = "PNL_PRICE"] = 2;
      values[valuesById[3] = "PNL_DELTA_PRICE"] = 3;
      return values;
    }();
    fo.RiskPNLPlaceOrderType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "PNL_ORDER_TYPE_FASTEST"] = 0;
      values[valuesById[1] = "PNL_ORDER_TYPE_DELTA_PRICE"] = 1;
      return values;
    }();
    fo.DerivativePNLConfig = function() {
      function DerivativePNLConfig(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativePNLConfig.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativePNLConfig.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativePNLConfig.prototype.accountNo = "";
      DerivativePNLConfig.prototype.stopLossStrategy = 0;
      DerivativePNLConfig.prototype.takeProfitStrategy = 0;
      DerivativePNLConfig.prototype.status = "";
      DerivativePNLConfig.prototype.takeProfitEnabled = false;
      DerivativePNLConfig.prototype.stopLossEnabled = false;
      DerivativePNLConfig.prototype.takeProfitRate = 0;
      DerivativePNLConfig.prototype.stopLossRate = 0;
      DerivativePNLConfig.prototype.takeProfitPrice = 0;
      DerivativePNLConfig.prototype.stopLossPrice = 0;
      DerivativePNLConfig.prototype.takeProfitAmount = 0;
      DerivativePNLConfig.prototype.stopLossAmount = 0;
      DerivativePNLConfig.prototype.takeProfitDeltaPrice = 0;
      DerivativePNLConfig.prototype.stopLossDeltaPrice = 0;
      DerivativePNLConfig.prototype.takeProfitOrderDeltaPrice = 0;
      DerivativePNLConfig.prototype.stopLossOrderDeltaPrice = 0;
      DerivativePNLConfig.prototype.stopLossOrderType = 0;
      DerivativePNLConfig.prototype.takeProfitOrderType = 0;
      DerivativePNLConfig.create = function create(properties) {
        return new DerivativePNLConfig(properties);
      };
      DerivativePNLConfig.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
          writer.uint32(16).int64(message.dealId);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(26).string(message.accountNo);
        if (message.stopLossStrategy != null && Object.hasOwnProperty.call(message, "stopLossStrategy"))
          writer.uint32(32).int32(message.stopLossStrategy);
        if (message.takeProfitStrategy != null && Object.hasOwnProperty.call(message, "takeProfitStrategy"))
          writer.uint32(40).int32(message.takeProfitStrategy);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(50).string(message.status);
        if (message.takeProfitEnabled != null && Object.hasOwnProperty.call(message, "takeProfitEnabled"))
          writer.uint32(56).bool(message.takeProfitEnabled);
        if (message.stopLossEnabled != null && Object.hasOwnProperty.call(message, "stopLossEnabled"))
          writer.uint32(64).bool(message.stopLossEnabled);
        if (message.takeProfitRate != null && Object.hasOwnProperty.call(message, "takeProfitRate"))
          writer.uint32(73).double(message.takeProfitRate);
        if (message.stopLossRate != null && Object.hasOwnProperty.call(message, "stopLossRate"))
          writer.uint32(81).double(message.stopLossRate);
        if (message.takeProfitPrice != null && Object.hasOwnProperty.call(message, "takeProfitPrice"))
          writer.uint32(89).double(message.takeProfitPrice);
        if (message.stopLossPrice != null && Object.hasOwnProperty.call(message, "stopLossPrice"))
          writer.uint32(97).double(message.stopLossPrice);
        if (message.takeProfitAmount != null && Object.hasOwnProperty.call(message, "takeProfitAmount"))
          writer.uint32(105).double(message.takeProfitAmount);
        if (message.stopLossAmount != null && Object.hasOwnProperty.call(message, "stopLossAmount"))
          writer.uint32(113).double(message.stopLossAmount);
        if (message.takeProfitDeltaPrice != null && Object.hasOwnProperty.call(message, "takeProfitDeltaPrice"))
          writer.uint32(121).double(message.takeProfitDeltaPrice);
        if (message.stopLossDeltaPrice != null && Object.hasOwnProperty.call(message, "stopLossDeltaPrice"))
          writer.uint32(129).double(message.stopLossDeltaPrice);
        if (message.takeProfitOrderDeltaPrice != null && Object.hasOwnProperty.call(message, "takeProfitOrderDeltaPrice"))
          writer.uint32(137).double(message.takeProfitOrderDeltaPrice);
        if (message.stopLossOrderDeltaPrice != null && Object.hasOwnProperty.call(message, "stopLossOrderDeltaPrice"))
          writer.uint32(145).double(message.stopLossOrderDeltaPrice);
        if (message.stopLossOrderType != null && Object.hasOwnProperty.call(message, "stopLossOrderType"))
          writer.uint32(152).int32(message.stopLossOrderType);
        if (message.takeProfitOrderType != null && Object.hasOwnProperty.call(message, "takeProfitOrderType"))
          writer.uint32(160).int32(message.takeProfitOrderType);
        return writer;
      };
      DerivativePNLConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativePNLConfig.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativePNLConfig();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.dealId = reader.int64();
              break;
            case 3:
              message.accountNo = reader.string();
              break;
            case 4:
              message.stopLossStrategy = reader.int32();
              break;
            case 5:
              message.takeProfitStrategy = reader.int32();
              break;
            case 6:
              message.status = reader.string();
              break;
            case 7:
              message.takeProfitEnabled = reader.bool();
              break;
            case 8:
              message.stopLossEnabled = reader.bool();
              break;
            case 9:
              message.takeProfitRate = reader.double();
              break;
            case 10:
              message.stopLossRate = reader.double();
              break;
            case 11:
              message.takeProfitPrice = reader.double();
              break;
            case 12:
              message.stopLossPrice = reader.double();
              break;
            case 13:
              message.takeProfitAmount = reader.double();
              break;
            case 14:
              message.stopLossAmount = reader.double();
              break;
            case 15:
              message.takeProfitDeltaPrice = reader.double();
              break;
            case 16:
              message.stopLossDeltaPrice = reader.double();
              break;
            case 17:
              message.takeProfitOrderDeltaPrice = reader.double();
              break;
            case 18:
              message.stopLossOrderDeltaPrice = reader.double();
              break;
            case 19:
              message.stopLossOrderType = reader.int32();
              break;
            case 20:
              message.takeProfitOrderType = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativePNLConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativePNLConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.dealId != null && message.hasOwnProperty("dealId")) {
          if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
            return "dealId: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.stopLossStrategy != null && message.hasOwnProperty("stopLossStrategy"))
          switch (message.stopLossStrategy) {
            default:
              return "stopLossStrategy: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.takeProfitStrategy != null && message.hasOwnProperty("takeProfitStrategy"))
          switch (message.takeProfitStrategy) {
            default:
              return "takeProfitStrategy: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.status != null && message.hasOwnProperty("status")) {
          if (!$util.isString(message.status))
            return "status: string expected";
        }
        if (message.takeProfitEnabled != null && message.hasOwnProperty("takeProfitEnabled")) {
          if (typeof message.takeProfitEnabled !== "boolean")
            return "takeProfitEnabled: boolean expected";
        }
        if (message.stopLossEnabled != null && message.hasOwnProperty("stopLossEnabled")) {
          if (typeof message.stopLossEnabled !== "boolean")
            return "stopLossEnabled: boolean expected";
        }
        if (message.takeProfitRate != null && message.hasOwnProperty("takeProfitRate")) {
          if (typeof message.takeProfitRate !== "number")
            return "takeProfitRate: number expected";
        }
        if (message.stopLossRate != null && message.hasOwnProperty("stopLossRate")) {
          if (typeof message.stopLossRate !== "number")
            return "stopLossRate: number expected";
        }
        if (message.takeProfitPrice != null && message.hasOwnProperty("takeProfitPrice")) {
          if (typeof message.takeProfitPrice !== "number")
            return "takeProfitPrice: number expected";
        }
        if (message.stopLossPrice != null && message.hasOwnProperty("stopLossPrice")) {
          if (typeof message.stopLossPrice !== "number")
            return "stopLossPrice: number expected";
        }
        if (message.takeProfitAmount != null && message.hasOwnProperty("takeProfitAmount")) {
          if (typeof message.takeProfitAmount !== "number")
            return "takeProfitAmount: number expected";
        }
        if (message.stopLossAmount != null && message.hasOwnProperty("stopLossAmount")) {
          if (typeof message.stopLossAmount !== "number")
            return "stopLossAmount: number expected";
        }
        if (message.takeProfitDeltaPrice != null && message.hasOwnProperty("takeProfitDeltaPrice")) {
          if (typeof message.takeProfitDeltaPrice !== "number")
            return "takeProfitDeltaPrice: number expected";
        }
        if (message.stopLossDeltaPrice != null && message.hasOwnProperty("stopLossDeltaPrice")) {
          if (typeof message.stopLossDeltaPrice !== "number")
            return "stopLossDeltaPrice: number expected";
        }
        if (message.takeProfitOrderDeltaPrice != null && message.hasOwnProperty("takeProfitOrderDeltaPrice")) {
          if (typeof message.takeProfitOrderDeltaPrice !== "number")
            return "takeProfitOrderDeltaPrice: number expected";
        }
        if (message.stopLossOrderDeltaPrice != null && message.hasOwnProperty("stopLossOrderDeltaPrice")) {
          if (typeof message.stopLossOrderDeltaPrice !== "number")
            return "stopLossOrderDeltaPrice: number expected";
        }
        if (message.stopLossOrderType != null && message.hasOwnProperty("stopLossOrderType"))
          switch (message.stopLossOrderType) {
            default:
              return "stopLossOrderType: enum value expected";
            case 0:
            case 1:
              break;
          }
        if (message.takeProfitOrderType != null && message.hasOwnProperty("takeProfitOrderType"))
          switch (message.takeProfitOrderType) {
            default:
              return "takeProfitOrderType: enum value expected";
            case 0:
            case 1:
              break;
          }
        return null;
      };
      DerivativePNLConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativePNLConfig)
          return object;
        let message = new $root.dnse.fo.DerivativePNLConfig();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.dealId != null) {
          if ($util.Long)
            (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
          else if (typeof object.dealId === "string")
            message.dealId = parseInt(object.dealId, 10);
          else if (typeof object.dealId === "number")
            message.dealId = object.dealId;
          else if (typeof object.dealId === "object")
            message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        switch (object.stopLossStrategy) {
          case "PNL_RATE":
          case 0:
            message.stopLossStrategy = 0;
            break;
          case "PNL_AMOUNT":
          case 1:
            message.stopLossStrategy = 1;
            break;
          case "PNL_PRICE":
          case 2:
            message.stopLossStrategy = 2;
            break;
          case "PNL_DELTA_PRICE":
          case 3:
            message.stopLossStrategy = 3;
            break;
        }
        switch (object.takeProfitStrategy) {
          case "PNL_RATE":
          case 0:
            message.takeProfitStrategy = 0;
            break;
          case "PNL_AMOUNT":
          case 1:
            message.takeProfitStrategy = 1;
            break;
          case "PNL_PRICE":
          case 2:
            message.takeProfitStrategy = 2;
            break;
          case "PNL_DELTA_PRICE":
          case 3:
            message.takeProfitStrategy = 3;
            break;
        }
        if (object.status != null)
          message.status = String(object.status);
        if (object.takeProfitEnabled != null)
          message.takeProfitEnabled = Boolean(object.takeProfitEnabled);
        if (object.stopLossEnabled != null)
          message.stopLossEnabled = Boolean(object.stopLossEnabled);
        if (object.takeProfitRate != null)
          message.takeProfitRate = Number(object.takeProfitRate);
        if (object.stopLossRate != null)
          message.stopLossRate = Number(object.stopLossRate);
        if (object.takeProfitPrice != null)
          message.takeProfitPrice = Number(object.takeProfitPrice);
        if (object.stopLossPrice != null)
          message.stopLossPrice = Number(object.stopLossPrice);
        if (object.takeProfitAmount != null)
          message.takeProfitAmount = Number(object.takeProfitAmount);
        if (object.stopLossAmount != null)
          message.stopLossAmount = Number(object.stopLossAmount);
        if (object.takeProfitDeltaPrice != null)
          message.takeProfitDeltaPrice = Number(object.takeProfitDeltaPrice);
        if (object.stopLossDeltaPrice != null)
          message.stopLossDeltaPrice = Number(object.stopLossDeltaPrice);
        if (object.takeProfitOrderDeltaPrice != null)
          message.takeProfitOrderDeltaPrice = Number(object.takeProfitOrderDeltaPrice);
        if (object.stopLossOrderDeltaPrice != null)
          message.stopLossOrderDeltaPrice = Number(object.stopLossOrderDeltaPrice);
        switch (object.stopLossOrderType) {
          case "PNL_ORDER_TYPE_FASTEST":
          case 0:
            message.stopLossOrderType = 0;
            break;
          case "PNL_ORDER_TYPE_DELTA_PRICE":
          case 1:
            message.stopLossOrderType = 1;
            break;
        }
        switch (object.takeProfitOrderType) {
          case "PNL_ORDER_TYPE_FASTEST":
          case 0:
            message.takeProfitOrderType = 0;
            break;
          case "PNL_ORDER_TYPE_DELTA_PRICE":
          case 1:
            message.takeProfitOrderType = 1;
            break;
        }
        return message;
      };
      DerivativePNLConfig.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.dealId = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.stopLossStrategy = options.enums === String ? "PNL_RATE" : 0;
          object.takeProfitStrategy = options.enums === String ? "PNL_RATE" : 0;
          object.status = "";
          object.takeProfitEnabled = false;
          object.stopLossEnabled = false;
          object.takeProfitRate = 0;
          object.stopLossRate = 0;
          object.takeProfitPrice = 0;
          object.stopLossPrice = 0;
          object.takeProfitAmount = 0;
          object.stopLossAmount = 0;
          object.takeProfitDeltaPrice = 0;
          object.stopLossDeltaPrice = 0;
          object.takeProfitOrderDeltaPrice = 0;
          object.stopLossOrderDeltaPrice = 0;
          object.stopLossOrderType = options.enums === String ? "PNL_ORDER_TYPE_FASTEST" : 0;
          object.takeProfitOrderType = options.enums === String ? "PNL_ORDER_TYPE_FASTEST" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.dealId != null && message.hasOwnProperty("dealId"))
          if (typeof message.dealId === "number")
            object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
          else
            object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.stopLossStrategy != null && message.hasOwnProperty("stopLossStrategy"))
          object.stopLossStrategy = options.enums === String ? $root.dnse.fo.RiskPNLExecutionStrategy[message.stopLossStrategy] : message.stopLossStrategy;
        if (message.takeProfitStrategy != null && message.hasOwnProperty("takeProfitStrategy"))
          object.takeProfitStrategy = options.enums === String ? $root.dnse.fo.RiskPNLExecutionStrategy[message.takeProfitStrategy] : message.takeProfitStrategy;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = message.status;
        if (message.takeProfitEnabled != null && message.hasOwnProperty("takeProfitEnabled"))
          object.takeProfitEnabled = message.takeProfitEnabled;
        if (message.stopLossEnabled != null && message.hasOwnProperty("stopLossEnabled"))
          object.stopLossEnabled = message.stopLossEnabled;
        if (message.takeProfitRate != null && message.hasOwnProperty("takeProfitRate"))
          object.takeProfitRate = options.json && !isFinite(message.takeProfitRate) ? String(message.takeProfitRate) : message.takeProfitRate;
        if (message.stopLossRate != null && message.hasOwnProperty("stopLossRate"))
          object.stopLossRate = options.json && !isFinite(message.stopLossRate) ? String(message.stopLossRate) : message.stopLossRate;
        if (message.takeProfitPrice != null && message.hasOwnProperty("takeProfitPrice"))
          object.takeProfitPrice = options.json && !isFinite(message.takeProfitPrice) ? String(message.takeProfitPrice) : message.takeProfitPrice;
        if (message.stopLossPrice != null && message.hasOwnProperty("stopLossPrice"))
          object.stopLossPrice = options.json && !isFinite(message.stopLossPrice) ? String(message.stopLossPrice) : message.stopLossPrice;
        if (message.takeProfitAmount != null && message.hasOwnProperty("takeProfitAmount"))
          object.takeProfitAmount = options.json && !isFinite(message.takeProfitAmount) ? String(message.takeProfitAmount) : message.takeProfitAmount;
        if (message.stopLossAmount != null && message.hasOwnProperty("stopLossAmount"))
          object.stopLossAmount = options.json && !isFinite(message.stopLossAmount) ? String(message.stopLossAmount) : message.stopLossAmount;
        if (message.takeProfitDeltaPrice != null && message.hasOwnProperty("takeProfitDeltaPrice"))
          object.takeProfitDeltaPrice = options.json && !isFinite(message.takeProfitDeltaPrice) ? String(message.takeProfitDeltaPrice) : message.takeProfitDeltaPrice;
        if (message.stopLossDeltaPrice != null && message.hasOwnProperty("stopLossDeltaPrice"))
          object.stopLossDeltaPrice = options.json && !isFinite(message.stopLossDeltaPrice) ? String(message.stopLossDeltaPrice) : message.stopLossDeltaPrice;
        if (message.takeProfitOrderDeltaPrice != null && message.hasOwnProperty("takeProfitOrderDeltaPrice"))
          object.takeProfitOrderDeltaPrice = options.json && !isFinite(message.takeProfitOrderDeltaPrice) ? String(message.takeProfitOrderDeltaPrice) : message.takeProfitOrderDeltaPrice;
        if (message.stopLossOrderDeltaPrice != null && message.hasOwnProperty("stopLossOrderDeltaPrice"))
          object.stopLossOrderDeltaPrice = options.json && !isFinite(message.stopLossOrderDeltaPrice) ? String(message.stopLossOrderDeltaPrice) : message.stopLossOrderDeltaPrice;
        if (message.stopLossOrderType != null && message.hasOwnProperty("stopLossOrderType"))
          object.stopLossOrderType = options.enums === String ? $root.dnse.fo.RiskPNLPlaceOrderType[message.stopLossOrderType] : message.stopLossOrderType;
        if (message.takeProfitOrderType != null && message.hasOwnProperty("takeProfitOrderType"))
          object.takeProfitOrderType = options.enums === String ? $root.dnse.fo.RiskPNLPlaceOrderType[message.takeProfitOrderType] : message.takeProfitOrderType;
        return object;
      };
      DerivativePNLConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativePNLConfig;
    }();
    fo.DerivativeDealRiskWarning = function() {
      function DerivativeDealRiskWarning(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeDealRiskWarning.prototype.accountNo = "";
      DerivativeDealRiskWarning.prototype.accountTypeName = "";
      DerivativeDealRiskWarning.prototype.fullName = "";
      DerivativeDealRiskWarning.prototype.investorId = "";
      DerivativeDealRiskWarning.prototype.custodyCode = "";
      DerivativeDealRiskWarning.prototype.dealRisk = null;
      DerivativeDealRiskWarning.prototype.loanPackage = null;
      DerivativeDealRiskWarning.prototype.timestamp = null;
      DerivativeDealRiskWarning.prototype.pnlConfig = null;
      DerivativeDealRiskWarning.prototype.executedPrice = 0;
      DerivativeDealRiskWarning.prototype.isScheduledNotify = false;
      DerivativeDealRiskWarning.prototype.type = "";
      DerivativeDealRiskWarning.create = function create(properties) {
        return new DerivativeDealRiskWarning(properties);
      };
      DerivativeDealRiskWarning.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(10).string(message.accountNo);
        if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
          writer.uint32(18).string(message.accountTypeName);
        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
          writer.uint32(26).string(message.fullName);
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(34).string(message.investorId);
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(42).string(message.custodyCode);
        if (message.dealRisk != null && Object.hasOwnProperty.call(message, "dealRisk"))
          $root.dnse.fo.DerivativeDealRisk.encode(message.dealRisk, writer.uint32(50).fork()).ldelim();
        if (message.loanPackage != null && Object.hasOwnProperty.call(message, "loanPackage"))
          $root.dnse.fo.DerivativeLoanPackage.encode(message.loanPackage, writer.uint32(58).fork()).ldelim();
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
          $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(66).fork()).ldelim();
        if (message.pnlConfig != null && Object.hasOwnProperty.call(message, "pnlConfig"))
          $root.dnse.fo.DerivativePNLConfig.encode(message.pnlConfig, writer.uint32(74).fork()).ldelim();
        if (message.executedPrice != null && Object.hasOwnProperty.call(message, "executedPrice"))
          writer.uint32(81).double(message.executedPrice);
        if (message.isScheduledNotify != null && Object.hasOwnProperty.call(message, "isScheduledNotify"))
          writer.uint32(88).bool(message.isScheduledNotify);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(98).string(message.type);
        return writer;
      };
      DerivativeDealRiskWarning.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeDealRiskWarning.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeDealRiskWarning();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accountNo = reader.string();
              break;
            case 2:
              message.accountTypeName = reader.string();
              break;
            case 3:
              message.fullName = reader.string();
              break;
            case 4:
              message.investorId = reader.string();
              break;
            case 5:
              message.custodyCode = reader.string();
              break;
            case 6:
              message.dealRisk = $root.dnse.fo.DerivativeDealRisk.decode(reader, reader.uint32());
              break;
            case 7:
              message.loanPackage = $root.dnse.fo.DerivativeLoanPackage.decode(reader, reader.uint32());
              break;
            case 8:
              message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 9:
              message.pnlConfig = $root.dnse.fo.DerivativePNLConfig.decode(reader, reader.uint32());
              break;
            case 10:
              message.executedPrice = reader.double();
              break;
            case 11:
              message.isScheduledNotify = reader.bool();
              break;
            case 12:
              message.type = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeDealRiskWarning.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeDealRiskWarning.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
          if (!$util.isString(message.accountTypeName))
            return "accountTypeName: string expected";
        }
        if (message.fullName != null && message.hasOwnProperty("fullName")) {
          if (!$util.isString(message.fullName))
            return "fullName: string expected";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.dealRisk != null && message.hasOwnProperty("dealRisk")) {
          let error = $root.dnse.fo.DerivativeDealRisk.verify(message.dealRisk);
          if (error)
            return "dealRisk." + error;
        }
        if (message.loanPackage != null && message.hasOwnProperty("loanPackage")) {
          let error = $root.dnse.fo.DerivativeLoanPackage.verify(message.loanPackage);
          if (error)
            return "loanPackage." + error;
        }
        if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
          let error = $root.google.protobuf.Timestamp.verify(message.timestamp);
          if (error)
            return "timestamp." + error;
        }
        if (message.pnlConfig != null && message.hasOwnProperty("pnlConfig")) {
          let error = $root.dnse.fo.DerivativePNLConfig.verify(message.pnlConfig);
          if (error)
            return "pnlConfig." + error;
        }
        if (message.executedPrice != null && message.hasOwnProperty("executedPrice")) {
          if (typeof message.executedPrice !== "number")
            return "executedPrice: number expected";
        }
        if (message.isScheduledNotify != null && message.hasOwnProperty("isScheduledNotify")) {
          if (typeof message.isScheduledNotify !== "boolean")
            return "isScheduledNotify: boolean expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        return null;
      };
      DerivativeDealRiskWarning.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeDealRiskWarning)
          return object;
        let message = new $root.dnse.fo.DerivativeDealRiskWarning();
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.accountTypeName != null)
          message.accountTypeName = String(object.accountTypeName);
        if (object.fullName != null)
          message.fullName = String(object.fullName);
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.dealRisk != null) {
          if (typeof object.dealRisk !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRiskWarning.dealRisk: object expected");
          message.dealRisk = $root.dnse.fo.DerivativeDealRisk.fromObject(object.dealRisk);
        }
        if (object.loanPackage != null) {
          if (typeof object.loanPackage !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRiskWarning.loanPackage: object expected");
          message.loanPackage = $root.dnse.fo.DerivativeLoanPackage.fromObject(object.loanPackage);
        }
        if (object.timestamp != null) {
          if (typeof object.timestamp !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRiskWarning.timestamp: object expected");
          message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
        }
        if (object.pnlConfig != null) {
          if (typeof object.pnlConfig !== "object")
            throw TypeError(".dnse.fo.DerivativeDealRiskWarning.pnlConfig: object expected");
          message.pnlConfig = $root.dnse.fo.DerivativePNLConfig.fromObject(object.pnlConfig);
        }
        if (object.executedPrice != null)
          message.executedPrice = Number(object.executedPrice);
        if (object.isScheduledNotify != null)
          message.isScheduledNotify = Boolean(object.isScheduledNotify);
        if (object.type != null)
          message.type = String(object.type);
        return message;
      };
      DerivativeDealRiskWarning.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.accountNo = "";
          object.accountTypeName = "";
          object.fullName = "";
          object.investorId = "";
          object.custodyCode = "";
          object.dealRisk = null;
          object.loanPackage = null;
          object.timestamp = null;
          object.pnlConfig = null;
          object.executedPrice = 0;
          object.isScheduledNotify = false;
          object.type = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
          object.accountTypeName = message.accountTypeName;
        if (message.fullName != null && message.hasOwnProperty("fullName"))
          object.fullName = message.fullName;
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.dealRisk != null && message.hasOwnProperty("dealRisk"))
          object.dealRisk = $root.dnse.fo.DerivativeDealRisk.toObject(message.dealRisk, options);
        if (message.loanPackage != null && message.hasOwnProperty("loanPackage"))
          object.loanPackage = $root.dnse.fo.DerivativeLoanPackage.toObject(message.loanPackage, options);
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
          object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
        if (message.pnlConfig != null && message.hasOwnProperty("pnlConfig"))
          object.pnlConfig = $root.dnse.fo.DerivativePNLConfig.toObject(message.pnlConfig, options);
        if (message.executedPrice != null && message.hasOwnProperty("executedPrice"))
          object.executedPrice = options.json && !isFinite(message.executedPrice) ? String(message.executedPrice) : message.executedPrice;
        if (message.isScheduledNotify != null && message.hasOwnProperty("isScheduledNotify"))
          object.isScheduledNotify = message.isScheduledNotify;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        return object;
      };
      DerivativeDealRiskWarning.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeDealRiskWarning;
    }();
    fo.DerivativeOrder = function() {
      function DerivativeOrder(properties) {
        this.reports = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeOrder.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeOrder.prototype.side = "";
      DerivativeOrder.prototype.accountNo = "";
      DerivativeOrder.prototype.symbol = "";
      DerivativeOrder.prototype.price = 0;
      DerivativeOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeOrder.prototype.orderType = "";
      DerivativeOrder.prototype.orderStatus = "";
      DerivativeOrder.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeOrder.prototype.canceledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeOrder.prototype.lastQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeOrder.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeOrder.prototype.lastPrice = 0;
      DerivativeOrder.prototype.averagePrice = 0;
      DerivativeOrder.prototype.priceSecure = 0;
      DerivativeOrder.prototype.createdDate = null;
      DerivativeOrder.prototype.modifiedDate = null;
      DerivativeOrder.prototype.transDate = null;
      DerivativeOrder.prototype.execType = "";
      DerivativeOrder.prototype.custody = "";
      DerivativeOrder.prototype.taxRate = 0;
      DerivativeOrder.prototype.feeRate = 0;
      DerivativeOrder.prototype.clOrdId = "";
      DerivativeOrder.prototype.origClOrdId = "";
      DerivativeOrder.prototype.maker = "";
      DerivativeOrder.prototype.channel = "";
      DerivativeOrder.prototype.externalId = "";
      DerivativeOrder.prototype.exDestination = "";
      DerivativeOrder.prototype.error = "";
      DerivativeOrder.prototype.text = "";
      DerivativeOrder.prototype.reports = $util.emptyArray;
      DerivativeOrder.prototype.investorId = "";
      DerivativeOrder.prototype.loanPackageId = 0;
      DerivativeOrder.prototype.initialRate = 0;
      DerivativeOrder.prototype.dnseFee = 0;
      DerivativeOrder.prototype.hnxFee = 0;
      DerivativeOrder.prototype.tax = 0;
      DerivativeOrder.create = function create(properties) {
        return new DerivativeOrder(properties);
      };
      DerivativeOrder.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
          writer.uint32(18).string(message.side);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(26).string(message.accountNo);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(34).string(message.symbol);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
          writer.uint32(41).double(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
          writer.uint32(48).int64(message.quantity);
        if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
          writer.uint32(58).string(message.orderType);
        if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
          writer.uint32(66).string(message.orderStatus);
        if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
          writer.uint32(72).int64(message.fillQuantity);
        if (message.canceledQuantity != null && Object.hasOwnProperty.call(message, "canceledQuantity"))
          writer.uint32(80).int64(message.canceledQuantity);
        if (message.lastQuantity != null && Object.hasOwnProperty.call(message, "lastQuantity"))
          writer.uint32(88).int64(message.lastQuantity);
        if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
          writer.uint32(96).int64(message.leaveQuantity);
        if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
          writer.uint32(105).double(message.lastPrice);
        if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
          writer.uint32(113).double(message.averagePrice);
        if (message.priceSecure != null && Object.hasOwnProperty.call(message, "priceSecure"))
          writer.uint32(121).double(message.priceSecure);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(130).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(138).fork()).ldelim();
        if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
          $root.google.protobuf.Timestamp.encode(message.transDate, writer.uint32(146).fork()).ldelim();
        if (message.execType != null && Object.hasOwnProperty.call(message, "execType"))
          writer.uint32(154).string(message.execType);
        if (message.custody != null && Object.hasOwnProperty.call(message, "custody"))
          writer.uint32(162).string(message.custody);
        if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
          writer.uint32(169).double(message.taxRate);
        if (message.feeRate != null && Object.hasOwnProperty.call(message, "feeRate"))
          writer.uint32(177).double(message.feeRate);
        if (message.clOrdId != null && Object.hasOwnProperty.call(message, "clOrdId"))
          writer.uint32(186).string(message.clOrdId);
        if (message.origClOrdId != null && Object.hasOwnProperty.call(message, "origClOrdId"))
          writer.uint32(194).string(message.origClOrdId);
        if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
          writer.uint32(202).string(message.maker);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
          writer.uint32(210).string(message.channel);
        if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
          writer.uint32(218).string(message.externalId);
        if (message.exDestination != null && Object.hasOwnProperty.call(message, "exDestination"))
          writer.uint32(226).string(message.exDestination);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
          writer.uint32(234).string(message.error);
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
          writer.uint32(242).string(message.text);
        if (message.reports != null && message.reports.length)
          for (let i = 0; i < message.reports.length; ++i)
            $root.dnse.fo.DerivativeOrder.encode(message.reports[i], writer.uint32(250).fork()).ldelim();
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(258).string(message.investorId);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(264).int32(message.loanPackageId);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(273).double(message.initialRate);
        if (message.dnseFee != null && Object.hasOwnProperty.call(message, "dnseFee"))
          writer.uint32(281).double(message.dnseFee);
        if (message.hnxFee != null && Object.hasOwnProperty.call(message, "hnxFee"))
          writer.uint32(289).double(message.hnxFee);
        if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
          writer.uint32(297).double(message.tax);
        return writer;
      };
      DerivativeOrder.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeOrder.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeOrder();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.side = reader.string();
              break;
            case 3:
              message.accountNo = reader.string();
              break;
            case 4:
              message.symbol = reader.string();
              break;
            case 5:
              message.price = reader.double();
              break;
            case 6:
              message.quantity = reader.int64();
              break;
            case 7:
              message.orderType = reader.string();
              break;
            case 8:
              message.orderStatus = reader.string();
              break;
            case 9:
              message.fillQuantity = reader.int64();
              break;
            case 10:
              message.canceledQuantity = reader.int64();
              break;
            case 11:
              message.lastQuantity = reader.int64();
              break;
            case 12:
              message.leaveQuantity = reader.int64();
              break;
            case 13:
              message.lastPrice = reader.double();
              break;
            case 14:
              message.averagePrice = reader.double();
              break;
            case 15:
              message.priceSecure = reader.double();
              break;
            case 16:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 17:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 18:
              message.transDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 19:
              message.execType = reader.string();
              break;
            case 20:
              message.custody = reader.string();
              break;
            case 21:
              message.taxRate = reader.double();
              break;
            case 22:
              message.feeRate = reader.double();
              break;
            case 23:
              message.clOrdId = reader.string();
              break;
            case 24:
              message.origClOrdId = reader.string();
              break;
            case 25:
              message.maker = reader.string();
              break;
            case 26:
              message.channel = reader.string();
              break;
            case 27:
              message.externalId = reader.string();
              break;
            case 28:
              message.exDestination = reader.string();
              break;
            case 29:
              message.error = reader.string();
              break;
            case 30:
              message.text = reader.string();
              break;
            case 31:
              if (!(message.reports && message.reports.length))
                message.reports = [];
              message.reports.push($root.dnse.fo.DerivativeOrder.decode(reader, reader.uint32()));
              break;
            case 32:
              message.investorId = reader.string();
              break;
            case 33:
              message.loanPackageId = reader.int32();
              break;
            case 34:
              message.initialRate = reader.double();
              break;
            case 35:
              message.dnseFee = reader.double();
              break;
            case 36:
              message.hnxFee = reader.double();
              break;
            case 37:
              message.tax = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeOrder.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeOrder.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.side != null && message.hasOwnProperty("side")) {
          if (!$util.isString(message.side))
            return "side: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.price != null && message.hasOwnProperty("price")) {
          if (typeof message.price !== "number")
            return "price: number expected";
        }
        if (message.quantity != null && message.hasOwnProperty("quantity")) {
          if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
            return "quantity: integer|Long expected";
        }
        if (message.orderType != null && message.hasOwnProperty("orderType")) {
          if (!$util.isString(message.orderType))
            return "orderType: string expected";
        }
        if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
          if (!$util.isString(message.orderStatus))
            return "orderStatus: string expected";
        }
        if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
          if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
            return "fillQuantity: integer|Long expected";
        }
        if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity")) {
          if (!$util.isInteger(message.canceledQuantity) && !(message.canceledQuantity && $util.isInteger(message.canceledQuantity.low) && $util.isInteger(message.canceledQuantity.high)))
            return "canceledQuantity: integer|Long expected";
        }
        if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity")) {
          if (!$util.isInteger(message.lastQuantity) && !(message.lastQuantity && $util.isInteger(message.lastQuantity.low) && $util.isInteger(message.lastQuantity.high)))
            return "lastQuantity: integer|Long expected";
        }
        if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
          if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
            return "leaveQuantity: integer|Long expected";
        }
        if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
          if (typeof message.lastPrice !== "number")
            return "lastPrice: number expected";
        }
        if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
          if (typeof message.averagePrice !== "number")
            return "averagePrice: number expected";
        }
        if (message.priceSecure != null && message.hasOwnProperty("priceSecure")) {
          if (typeof message.priceSecure !== "number")
            return "priceSecure: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.transDate != null && message.hasOwnProperty("transDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.transDate);
          if (error)
            return "transDate." + error;
        }
        if (message.execType != null && message.hasOwnProperty("execType")) {
          if (!$util.isString(message.execType))
            return "execType: string expected";
        }
        if (message.custody != null && message.hasOwnProperty("custody")) {
          if (!$util.isString(message.custody))
            return "custody: string expected";
        }
        if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
          if (typeof message.taxRate !== "number")
            return "taxRate: number expected";
        }
        if (message.feeRate != null && message.hasOwnProperty("feeRate")) {
          if (typeof message.feeRate !== "number")
            return "feeRate: number expected";
        }
        if (message.clOrdId != null && message.hasOwnProperty("clOrdId")) {
          if (!$util.isString(message.clOrdId))
            return "clOrdId: string expected";
        }
        if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId")) {
          if (!$util.isString(message.origClOrdId))
            return "origClOrdId: string expected";
        }
        if (message.maker != null && message.hasOwnProperty("maker")) {
          if (!$util.isString(message.maker))
            return "maker: string expected";
        }
        if (message.channel != null && message.hasOwnProperty("channel")) {
          if (!$util.isString(message.channel))
            return "channel: string expected";
        }
        if (message.externalId != null && message.hasOwnProperty("externalId")) {
          if (!$util.isString(message.externalId))
            return "externalId: string expected";
        }
        if (message.exDestination != null && message.hasOwnProperty("exDestination")) {
          if (!$util.isString(message.exDestination))
            return "exDestination: string expected";
        }
        if (message.error != null && message.hasOwnProperty("error")) {
          if (!$util.isString(message.error))
            return "error: string expected";
        }
        if (message.text != null && message.hasOwnProperty("text")) {
          if (!$util.isString(message.text))
            return "text: string expected";
        }
        if (message.reports != null && message.hasOwnProperty("reports")) {
          if (!Array.isArray(message.reports))
            return "reports: array expected";
          for (let i = 0; i < message.reports.length; ++i) {
            let error = $root.dnse.fo.DerivativeOrder.verify(message.reports[i]);
            if (error)
              return "reports." + error;
          }
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.dnseFee != null && message.hasOwnProperty("dnseFee")) {
          if (typeof message.dnseFee !== "number")
            return "dnseFee: number expected";
        }
        if (message.hnxFee != null && message.hasOwnProperty("hnxFee")) {
          if (typeof message.hnxFee !== "number")
            return "hnxFee: number expected";
        }
        if (message.tax != null && message.hasOwnProperty("tax")) {
          if (typeof message.tax !== "number")
            return "tax: number expected";
        }
        return null;
      };
      DerivativeOrder.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeOrder)
          return object;
        let message = new $root.dnse.fo.DerivativeOrder();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.side != null)
          message.side = String(object.side);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.price != null)
          message.price = Number(object.price);
        if (object.quantity != null) {
          if ($util.Long)
            (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
          else if (typeof object.quantity === "string")
            message.quantity = parseInt(object.quantity, 10);
          else if (typeof object.quantity === "number")
            message.quantity = object.quantity;
          else if (typeof object.quantity === "object")
            message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        }
        if (object.orderType != null)
          message.orderType = String(object.orderType);
        if (object.orderStatus != null)
          message.orderStatus = String(object.orderStatus);
        if (object.fillQuantity != null) {
          if ($util.Long)
            (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
          else if (typeof object.fillQuantity === "string")
            message.fillQuantity = parseInt(object.fillQuantity, 10);
          else if (typeof object.fillQuantity === "number")
            message.fillQuantity = object.fillQuantity;
          else if (typeof object.fillQuantity === "object")
            message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
        }
        if (object.canceledQuantity != null) {
          if ($util.Long)
            (message.canceledQuantity = $util.Long.fromValue(object.canceledQuantity)).unsigned = false;
          else if (typeof object.canceledQuantity === "string")
            message.canceledQuantity = parseInt(object.canceledQuantity, 10);
          else if (typeof object.canceledQuantity === "number")
            message.canceledQuantity = object.canceledQuantity;
          else if (typeof object.canceledQuantity === "object")
            message.canceledQuantity = new $util.LongBits(object.canceledQuantity.low >>> 0, object.canceledQuantity.high >>> 0).toNumber();
        }
        if (object.lastQuantity != null) {
          if ($util.Long)
            (message.lastQuantity = $util.Long.fromValue(object.lastQuantity)).unsigned = false;
          else if (typeof object.lastQuantity === "string")
            message.lastQuantity = parseInt(object.lastQuantity, 10);
          else if (typeof object.lastQuantity === "number")
            message.lastQuantity = object.lastQuantity;
          else if (typeof object.lastQuantity === "object")
            message.lastQuantity = new $util.LongBits(object.lastQuantity.low >>> 0, object.lastQuantity.high >>> 0).toNumber();
        }
        if (object.leaveQuantity != null) {
          if ($util.Long)
            (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
          else if (typeof object.leaveQuantity === "string")
            message.leaveQuantity = parseInt(object.leaveQuantity, 10);
          else if (typeof object.leaveQuantity === "number")
            message.leaveQuantity = object.leaveQuantity;
          else if (typeof object.leaveQuantity === "object")
            message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
        }
        if (object.lastPrice != null)
          message.lastPrice = Number(object.lastPrice);
        if (object.averagePrice != null)
          message.averagePrice = Number(object.averagePrice);
        if (object.priceSecure != null)
          message.priceSecure = Number(object.priceSecure);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeOrder.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeOrder.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.transDate != null) {
          if (typeof object.transDate !== "object")
            throw TypeError(".dnse.fo.DerivativeOrder.transDate: object expected");
          message.transDate = $root.google.protobuf.Timestamp.fromObject(object.transDate);
        }
        if (object.execType != null)
          message.execType = String(object.execType);
        if (object.custody != null)
          message.custody = String(object.custody);
        if (object.taxRate != null)
          message.taxRate = Number(object.taxRate);
        if (object.feeRate != null)
          message.feeRate = Number(object.feeRate);
        if (object.clOrdId != null)
          message.clOrdId = String(object.clOrdId);
        if (object.origClOrdId != null)
          message.origClOrdId = String(object.origClOrdId);
        if (object.maker != null)
          message.maker = String(object.maker);
        if (object.channel != null)
          message.channel = String(object.channel);
        if (object.externalId != null)
          message.externalId = String(object.externalId);
        if (object.exDestination != null)
          message.exDestination = String(object.exDestination);
        if (object.error != null)
          message.error = String(object.error);
        if (object.text != null)
          message.text = String(object.text);
        if (object.reports) {
          if (!Array.isArray(object.reports))
            throw TypeError(".dnse.fo.DerivativeOrder.reports: array expected");
          message.reports = [];
          for (let i = 0; i < object.reports.length; ++i) {
            if (typeof object.reports[i] !== "object")
              throw TypeError(".dnse.fo.DerivativeOrder.reports: object expected");
            message.reports[i] = $root.dnse.fo.DerivativeOrder.fromObject(object.reports[i]);
          }
        }
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        if (object.dnseFee != null)
          message.dnseFee = Number(object.dnseFee);
        if (object.hnxFee != null)
          message.hnxFee = Number(object.hnxFee);
        if (object.tax != null)
          message.tax = Number(object.tax);
        return message;
      };
      DerivativeOrder.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.reports = [];
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.side = "";
          object.accountNo = "";
          object.symbol = "";
          object.price = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.quantity = options.longs === String ? "0" : 0;
          object.orderType = "";
          object.orderStatus = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.fillQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.canceledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.canceledQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.lastQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.lastQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.leaveQuantity = options.longs === String ? "0" : 0;
          object.lastPrice = 0;
          object.averagePrice = 0;
          object.priceSecure = 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.transDate = null;
          object.execType = "";
          object.custody = "";
          object.taxRate = 0;
          object.feeRate = 0;
          object.clOrdId = "";
          object.origClOrdId = "";
          object.maker = "";
          object.channel = "";
          object.externalId = "";
          object.exDestination = "";
          object.error = "";
          object.text = "";
          object.investorId = "";
          object.loanPackageId = 0;
          object.initialRate = 0;
          object.dnseFee = 0;
          object.hnxFee = 0;
          object.tax = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.side != null && message.hasOwnProperty("side"))
          object.side = message.side;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.price != null && message.hasOwnProperty("price"))
          object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
          if (typeof message.quantity === "number")
            object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
          else
            object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.orderType != null && message.hasOwnProperty("orderType"))
          object.orderType = message.orderType;
        if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
          object.orderStatus = message.orderStatus;
        if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
          if (typeof message.fillQuantity === "number")
            object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
          else
            object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
        if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity"))
          if (typeof message.canceledQuantity === "number")
            object.canceledQuantity = options.longs === String ? String(message.canceledQuantity) : message.canceledQuantity;
          else
            object.canceledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.canceledQuantity) : options.longs === Number ? new $util.LongBits(message.canceledQuantity.low >>> 0, message.canceledQuantity.high >>> 0).toNumber() : message.canceledQuantity;
        if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity"))
          if (typeof message.lastQuantity === "number")
            object.lastQuantity = options.longs === String ? String(message.lastQuantity) : message.lastQuantity;
          else
            object.lastQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.lastQuantity) : options.longs === Number ? new $util.LongBits(message.lastQuantity.low >>> 0, message.lastQuantity.high >>> 0).toNumber() : message.lastQuantity;
        if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
          if (typeof message.leaveQuantity === "number")
            object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
          else
            object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
        if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
          object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
        if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
          object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
        if (message.priceSecure != null && message.hasOwnProperty("priceSecure"))
          object.priceSecure = options.json && !isFinite(message.priceSecure) ? String(message.priceSecure) : message.priceSecure;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.transDate != null && message.hasOwnProperty("transDate"))
          object.transDate = $root.google.protobuf.Timestamp.toObject(message.transDate, options);
        if (message.execType != null && message.hasOwnProperty("execType"))
          object.execType = message.execType;
        if (message.custody != null && message.hasOwnProperty("custody"))
          object.custody = message.custody;
        if (message.taxRate != null && message.hasOwnProperty("taxRate"))
          object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
        if (message.feeRate != null && message.hasOwnProperty("feeRate"))
          object.feeRate = options.json && !isFinite(message.feeRate) ? String(message.feeRate) : message.feeRate;
        if (message.clOrdId != null && message.hasOwnProperty("clOrdId"))
          object.clOrdId = message.clOrdId;
        if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId"))
          object.origClOrdId = message.origClOrdId;
        if (message.maker != null && message.hasOwnProperty("maker"))
          object.maker = message.maker;
        if (message.channel != null && message.hasOwnProperty("channel"))
          object.channel = message.channel;
        if (message.externalId != null && message.hasOwnProperty("externalId"))
          object.externalId = message.externalId;
        if (message.exDestination != null && message.hasOwnProperty("exDestination"))
          object.exDestination = message.exDestination;
        if (message.error != null && message.hasOwnProperty("error"))
          object.error = message.error;
        if (message.text != null && message.hasOwnProperty("text"))
          object.text = message.text;
        if (message.reports && message.reports.length) {
          object.reports = [];
          for (let j = 0; j < message.reports.length; ++j)
            object.reports[j] = $root.dnse.fo.DerivativeOrder.toObject(message.reports[j], options);
        }
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.dnseFee != null && message.hasOwnProperty("dnseFee"))
          object.dnseFee = options.json && !isFinite(message.dnseFee) ? String(message.dnseFee) : message.dnseFee;
        if (message.hnxFee != null && message.hasOwnProperty("hnxFee"))
          object.hnxFee = options.json && !isFinite(message.hnxFee) ? String(message.hnxFee) : message.hnxFee;
        if (message.tax != null && message.hasOwnProperty("tax"))
          object.tax = options.json && !isFinite(message.tax) ? String(message.tax) : message.tax;
        return object;
      };
      DerivativeOrder.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeOrder;
    }();
    fo.DerivativeLoanPolicy = function() {
      function DerivativeLoanPolicy(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoanPolicy.prototype.id = 0;
      DerivativeLoanPolicy.prototype.description = "";
      DerivativeLoanPolicy.prototype.source = "";
      DerivativeLoanPolicy.prototype.interestRate = 0;
      DerivativeLoanPolicy.prototype.overDueInterestRate = 0;
      DerivativeLoanPolicy.prototype.preferentialPeriod = 0;
      DerivativeLoanPolicy.prototype.preferentialInterestRate = 0;
      DerivativeLoanPolicy.prototype.interestBasis = 0;
      DerivativeLoanPolicy.prototype.term = 0;
      DerivativeLoanPolicy.prototype.createdDate = null;
      DerivativeLoanPolicy.prototype.modifiedDate = null;
      DerivativeLoanPolicy.create = function create(properties) {
        return new DerivativeLoanPolicy(properties);
      };
      DerivativeLoanPolicy.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int32(message.id);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(18).string(message.description);
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(26).string(message.source);
        if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
          writer.uint32(33).double(message.interestRate);
        if (message.overDueInterestRate != null && Object.hasOwnProperty.call(message, "overDueInterestRate"))
          writer.uint32(41).double(message.overDueInterestRate);
        if (message.preferentialPeriod != null && Object.hasOwnProperty.call(message, "preferentialPeriod"))
          writer.uint32(48).int32(message.preferentialPeriod);
        if (message.preferentialInterestRate != null && Object.hasOwnProperty.call(message, "preferentialInterestRate"))
          writer.uint32(57).double(message.preferentialInterestRate);
        if (message.interestBasis != null && Object.hasOwnProperty.call(message, "interestBasis"))
          writer.uint32(64).int32(message.interestBasis);
        if (message.term != null && Object.hasOwnProperty.call(message, "term"))
          writer.uint32(72).int32(message.term);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(90).fork()).ldelim();
        return writer;
      };
      DerivativeLoanPolicy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoanPolicy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoanPolicy();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int32();
              break;
            case 2:
              message.description = reader.string();
              break;
            case 3:
              message.source = reader.string();
              break;
            case 4:
              message.interestRate = reader.double();
              break;
            case 5:
              message.overDueInterestRate = reader.double();
              break;
            case 6:
              message.preferentialPeriod = reader.int32();
              break;
            case 7:
              message.preferentialInterestRate = reader.double();
              break;
            case 8:
              message.interestBasis = reader.int32();
              break;
            case 9:
              message.term = reader.int32();
              break;
            case 10:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 11:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoanPolicy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoanPolicy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id))
            return "id: integer expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
          if (typeof message.interestRate !== "number")
            return "interestRate: number expected";
        }
        if (message.overDueInterestRate != null && message.hasOwnProperty("overDueInterestRate")) {
          if (typeof message.overDueInterestRate !== "number")
            return "overDueInterestRate: number expected";
        }
        if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod")) {
          if (!$util.isInteger(message.preferentialPeriod))
            return "preferentialPeriod: integer expected";
        }
        if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate")) {
          if (typeof message.preferentialInterestRate !== "number")
            return "preferentialInterestRate: number expected";
        }
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis")) {
          if (!$util.isInteger(message.interestBasis))
            return "interestBasis: integer expected";
        }
        if (message.term != null && message.hasOwnProperty("term")) {
          if (!$util.isInteger(message.term))
            return "term: integer expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        return null;
      };
      DerivativeLoanPolicy.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoanPolicy)
          return object;
        let message = new $root.dnse.fo.DerivativeLoanPolicy();
        if (object.id != null)
          message.id = object.id | 0;
        if (object.description != null)
          message.description = String(object.description);
        if (object.source != null)
          message.source = String(object.source);
        if (object.interestRate != null)
          message.interestRate = Number(object.interestRate);
        if (object.overDueInterestRate != null)
          message.overDueInterestRate = Number(object.overDueInterestRate);
        if (object.preferentialPeriod != null)
          message.preferentialPeriod = object.preferentialPeriod | 0;
        if (object.preferentialInterestRate != null)
          message.preferentialInterestRate = Number(object.preferentialInterestRate);
        if (object.interestBasis != null)
          message.interestBasis = object.interestBasis | 0;
        if (object.term != null)
          message.term = object.term | 0;
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPolicy.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanPolicy.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        return message;
      };
      DerivativeLoanPolicy.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.id = 0;
          object.description = "";
          object.source = "";
          object.interestRate = 0;
          object.overDueInterestRate = 0;
          object.preferentialPeriod = 0;
          object.preferentialInterestRate = 0;
          object.interestBasis = 0;
          object.term = 0;
          object.createdDate = null;
          object.modifiedDate = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        if (message.interestRate != null && message.hasOwnProperty("interestRate"))
          object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
        if (message.overDueInterestRate != null && message.hasOwnProperty("overDueInterestRate"))
          object.overDueInterestRate = options.json && !isFinite(message.overDueInterestRate) ? String(message.overDueInterestRate) : message.overDueInterestRate;
        if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod"))
          object.preferentialPeriod = message.preferentialPeriod;
        if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate"))
          object.preferentialInterestRate = options.json && !isFinite(message.preferentialInterestRate) ? String(message.preferentialInterestRate) : message.preferentialInterestRate;
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis"))
          object.interestBasis = message.interestBasis;
        if (message.term != null && message.hasOwnProperty("term"))
          object.term = message.term;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        return object;
      };
      DerivativeLoanPolicy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeLoanPolicy;
    }();
    fo.DerivativeLoan = function() {
      function DerivativeLoan(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoan.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoan.prototype.accountNo = "";
      DerivativeLoan.prototype.custodyCode = "";
      DerivativeLoan.prototype.dtaAccount = "";
      DerivativeLoan.prototype.type = 0;
      DerivativeLoan.prototype.referenceId = "";
      DerivativeLoan.prototype.loanPolicyId = 0;
      DerivativeLoan.prototype.subStatus = 0;
      DerivativeLoan.prototype.status = 0;
      DerivativeLoan.prototype.description = "";
      DerivativeLoan.prototype.dueDate = null;
      DerivativeLoan.prototype.originalPrincipal = 0;
      DerivativeLoan.prototype.paidPrincipal = 0;
      DerivativeLoan.prototype.paidInterest = 0;
      DerivativeLoan.prototype.remainPrincipal = 0;
      DerivativeLoan.prototype.remainInterest = 0;
      DerivativeLoan.prototype.interestOnOverdueLoan = 0;
      DerivativeLoan.prototype.createdDate = null;
      DerivativeLoan.prototype.modifiedDate = null;
      DerivativeLoan.prototype.disbursedDate = null;
      DerivativeLoan.prototype.loanPolicy = null;
      DerivativeLoan.prototype.loanPackageId = 0;
      DerivativeLoan.create = function create(properties) {
        return new DerivativeLoan(properties);
      };
      DerivativeLoan.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(26).string(message.custodyCode);
        if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
          writer.uint32(34).string(message.dtaAccount);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(40).int32(message.type);
        if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
          writer.uint32(50).string(message.referenceId);
        if (message.loanPolicyId != null && Object.hasOwnProperty.call(message, "loanPolicyId"))
          writer.uint32(56).int32(message.loanPolicyId);
        if (message.subStatus != null && Object.hasOwnProperty.call(message, "subStatus"))
          writer.uint32(64).int32(message.subStatus);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(72).int32(message.status);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(82).string(message.description);
        if (message.dueDate != null && Object.hasOwnProperty.call(message, "dueDate"))
          $root.google.protobuf.Timestamp.encode(message.dueDate, writer.uint32(90).fork()).ldelim();
        if (message.originalPrincipal != null && Object.hasOwnProperty.call(message, "originalPrincipal"))
          writer.uint32(97).double(message.originalPrincipal);
        if (message.paidPrincipal != null && Object.hasOwnProperty.call(message, "paidPrincipal"))
          writer.uint32(105).double(message.paidPrincipal);
        if (message.paidInterest != null && Object.hasOwnProperty.call(message, "paidInterest"))
          writer.uint32(113).double(message.paidInterest);
        if (message.remainPrincipal != null && Object.hasOwnProperty.call(message, "remainPrincipal"))
          writer.uint32(121).double(message.remainPrincipal);
        if (message.remainInterest != null && Object.hasOwnProperty.call(message, "remainInterest"))
          writer.uint32(129).double(message.remainInterest);
        if (message.interestOnOverdueLoan != null && Object.hasOwnProperty.call(message, "interestOnOverdueLoan"))
          writer.uint32(137).double(message.interestOnOverdueLoan);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(146).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(154).fork()).ldelim();
        if (message.disbursedDate != null && Object.hasOwnProperty.call(message, "disbursedDate"))
          $root.google.protobuf.Timestamp.encode(message.disbursedDate, writer.uint32(162).fork()).ldelim();
        if (message.loanPolicy != null && Object.hasOwnProperty.call(message, "loanPolicy"))
          $root.dnse.fo.DerivativeLoanPolicy.encode(message.loanPolicy, writer.uint32(170).fork()).ldelim();
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(176).int32(message.loanPackageId);
        return writer;
      };
      DerivativeLoan.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoan.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoan();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.custodyCode = reader.string();
              break;
            case 4:
              message.dtaAccount = reader.string();
              break;
            case 5:
              message.type = reader.int32();
              break;
            case 6:
              message.referenceId = reader.string();
              break;
            case 7:
              message.loanPolicyId = reader.int32();
              break;
            case 8:
              message.subStatus = reader.int32();
              break;
            case 9:
              message.status = reader.int32();
              break;
            case 10:
              message.description = reader.string();
              break;
            case 11:
              message.dueDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 12:
              message.originalPrincipal = reader.double();
              break;
            case 13:
              message.paidPrincipal = reader.double();
              break;
            case 14:
              message.paidInterest = reader.double();
              break;
            case 15:
              message.remainPrincipal = reader.double();
              break;
            case 16:
              message.remainInterest = reader.double();
              break;
            case 17:
              message.interestOnOverdueLoan = reader.double();
              break;
            case 18:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 19:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 20:
              message.disbursedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 21:
              message.loanPolicy = $root.dnse.fo.DerivativeLoanPolicy.decode(reader, reader.uint32());
              break;
            case 22:
              message.loanPackageId = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoan.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoan.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
          if (!$util.isString(message.dtaAccount))
            return "dtaAccount: string expected";
        }
        if (message.type != null && message.hasOwnProperty("type"))
          switch (message.type) {
            default:
              return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              break;
          }
        if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
          if (!$util.isString(message.referenceId))
            return "referenceId: string expected";
        }
        if (message.loanPolicyId != null && message.hasOwnProperty("loanPolicyId")) {
          if (!$util.isInteger(message.loanPolicyId))
            return "loanPolicyId: integer expected";
        }
        if (message.subStatus != null && message.hasOwnProperty("subStatus"))
          switch (message.subStatus) {
            default:
              return "subStatus: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.dueDate != null && message.hasOwnProperty("dueDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.dueDate);
          if (error)
            return "dueDate." + error;
        }
        if (message.originalPrincipal != null && message.hasOwnProperty("originalPrincipal")) {
          if (typeof message.originalPrincipal !== "number")
            return "originalPrincipal: number expected";
        }
        if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal")) {
          if (typeof message.paidPrincipal !== "number")
            return "paidPrincipal: number expected";
        }
        if (message.paidInterest != null && message.hasOwnProperty("paidInterest")) {
          if (typeof message.paidInterest !== "number")
            return "paidInterest: number expected";
        }
        if (message.remainPrincipal != null && message.hasOwnProperty("remainPrincipal")) {
          if (typeof message.remainPrincipal !== "number")
            return "remainPrincipal: number expected";
        }
        if (message.remainInterest != null && message.hasOwnProperty("remainInterest")) {
          if (typeof message.remainInterest !== "number")
            return "remainInterest: number expected";
        }
        if (message.interestOnOverdueLoan != null && message.hasOwnProperty("interestOnOverdueLoan")) {
          if (typeof message.interestOnOverdueLoan !== "number")
            return "interestOnOverdueLoan: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.disbursedDate != null && message.hasOwnProperty("disbursedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.disbursedDate);
          if (error)
            return "disbursedDate." + error;
        }
        if (message.loanPolicy != null && message.hasOwnProperty("loanPolicy")) {
          let error = $root.dnse.fo.DerivativeLoanPolicy.verify(message.loanPolicy);
          if (error)
            return "loanPolicy." + error;
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        return null;
      };
      DerivativeLoan.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoan)
          return object;
        let message = new $root.dnse.fo.DerivativeLoan();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.dtaAccount != null)
          message.dtaAccount = String(object.dtaAccount);
        switch (object.type) {
          case "TYPE_UNSPECIFIED":
          case 0:
            message.type = 0;
            break;
          case "CASH_ACCOUNT_PROFIT_ADVANCE":
          case 1:
            message.type = 1;
            break;
          case "CASH_ACCOUNT_OBLIGATION_PAYMENT":
          case 2:
            message.type = 2;
            break;
          case "CASH_ACCOUNT_DEAL_DEBT":
          case 3:
            message.type = 3;
            break;
          case "DEAL_OBLIGATION_PAYMENT":
          case 4:
            message.type = 4;
            break;
          case "CASH_ACCOUNT_SECURE_ADVANCE":
          case 5:
            message.type = 5;
            break;
        }
        if (object.referenceId != null)
          message.referenceId = String(object.referenceId);
        if (object.loanPolicyId != null)
          message.loanPolicyId = object.loanPolicyId | 0;
        switch (object.subStatus) {
          case "SUB_STATUS_UNSPECIFIED":
          case 0:
            message.subStatus = 0;
            break;
          case "UNDUE":
          case 1:
            message.subStatus = 1;
            break;
          case "DUE":
          case 2:
            message.subStatus = 2;
            break;
          case "OVERDUE":
          case 3:
            message.subStatus = 3;
            break;
        }
        switch (object.status) {
          case "STATUS_UNSPECIFIED":
          case 0:
            message.status = 0;
            break;
          case "DISBURSED":
          case 1:
            message.status = 1;
            break;
          case "PAID":
          case 2:
            message.status = 2;
            break;
          case "CANCELLED":
          case 3:
            message.status = 3;
            break;
        }
        if (object.description != null)
          message.description = String(object.description);
        if (object.dueDate != null) {
          if (typeof object.dueDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoan.dueDate: object expected");
          message.dueDate = $root.google.protobuf.Timestamp.fromObject(object.dueDate);
        }
        if (object.originalPrincipal != null)
          message.originalPrincipal = Number(object.originalPrincipal);
        if (object.paidPrincipal != null)
          message.paidPrincipal = Number(object.paidPrincipal);
        if (object.paidInterest != null)
          message.paidInterest = Number(object.paidInterest);
        if (object.remainPrincipal != null)
          message.remainPrincipal = Number(object.remainPrincipal);
        if (object.remainInterest != null)
          message.remainInterest = Number(object.remainInterest);
        if (object.interestOnOverdueLoan != null)
          message.interestOnOverdueLoan = Number(object.interestOnOverdueLoan);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoan.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoan.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.disbursedDate != null) {
          if (typeof object.disbursedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoan.disbursedDate: object expected");
          message.disbursedDate = $root.google.protobuf.Timestamp.fromObject(object.disbursedDate);
        }
        if (object.loanPolicy != null) {
          if (typeof object.loanPolicy !== "object")
            throw TypeError(".dnse.fo.DerivativeLoan.loanPolicy: object expected");
          message.loanPolicy = $root.dnse.fo.DerivativeLoanPolicy.fromObject(object.loanPolicy);
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        return message;
      };
      DerivativeLoan.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.custodyCode = "";
          object.dtaAccount = "";
          object.type = options.enums === String ? "TYPE_UNSPECIFIED" : 0;
          object.referenceId = "";
          object.loanPolicyId = 0;
          object.subStatus = options.enums === String ? "SUB_STATUS_UNSPECIFIED" : 0;
          object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          object.description = "";
          object.dueDate = null;
          object.originalPrincipal = 0;
          object.paidPrincipal = 0;
          object.paidInterest = 0;
          object.remainPrincipal = 0;
          object.remainInterest = 0;
          object.interestOnOverdueLoan = 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.disbursedDate = null;
          object.loanPolicy = null;
          object.loanPackageId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
          object.dtaAccount = message.dtaAccount;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = options.enums === String ? $root.dnse.fo.DerivativeLoan.Type[message.type] : message.type;
        if (message.referenceId != null && message.hasOwnProperty("referenceId"))
          object.referenceId = message.referenceId;
        if (message.loanPolicyId != null && message.hasOwnProperty("loanPolicyId"))
          object.loanPolicyId = message.loanPolicyId;
        if (message.subStatus != null && message.hasOwnProperty("subStatus"))
          object.subStatus = options.enums === String ? $root.dnse.fo.DerivativeLoan.SubStatus[message.subStatus] : message.subStatus;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.DerivativeLoan.Status[message.status] : message.status;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.dueDate != null && message.hasOwnProperty("dueDate"))
          object.dueDate = $root.google.protobuf.Timestamp.toObject(message.dueDate, options);
        if (message.originalPrincipal != null && message.hasOwnProperty("originalPrincipal"))
          object.originalPrincipal = options.json && !isFinite(message.originalPrincipal) ? String(message.originalPrincipal) : message.originalPrincipal;
        if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal"))
          object.paidPrincipal = options.json && !isFinite(message.paidPrincipal) ? String(message.paidPrincipal) : message.paidPrincipal;
        if (message.paidInterest != null && message.hasOwnProperty("paidInterest"))
          object.paidInterest = options.json && !isFinite(message.paidInterest) ? String(message.paidInterest) : message.paidInterest;
        if (message.remainPrincipal != null && message.hasOwnProperty("remainPrincipal"))
          object.remainPrincipal = options.json && !isFinite(message.remainPrincipal) ? String(message.remainPrincipal) : message.remainPrincipal;
        if (message.remainInterest != null && message.hasOwnProperty("remainInterest"))
          object.remainInterest = options.json && !isFinite(message.remainInterest) ? String(message.remainInterest) : message.remainInterest;
        if (message.interestOnOverdueLoan != null && message.hasOwnProperty("interestOnOverdueLoan"))
          object.interestOnOverdueLoan = options.json && !isFinite(message.interestOnOverdueLoan) ? String(message.interestOnOverdueLoan) : message.interestOnOverdueLoan;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.disbursedDate != null && message.hasOwnProperty("disbursedDate"))
          object.disbursedDate = $root.google.protobuf.Timestamp.toObject(message.disbursedDate, options);
        if (message.loanPolicy != null && message.hasOwnProperty("loanPolicy"))
          object.loanPolicy = $root.dnse.fo.DerivativeLoanPolicy.toObject(message.loanPolicy, options);
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        return object;
      };
      DerivativeLoan.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DerivativeLoan.Target = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEAL"] = 0;
        values[valuesById[1] = "CASH_ACCOUNT"] = 1;
        return values;
      }();
      DerivativeLoan.Type = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TYPE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "CASH_ACCOUNT_PROFIT_ADVANCE"] = 1;
        values[valuesById[2] = "CASH_ACCOUNT_OBLIGATION_PAYMENT"] = 2;
        values[valuesById[3] = "CASH_ACCOUNT_DEAL_DEBT"] = 3;
        values[valuesById[4] = "DEAL_OBLIGATION_PAYMENT"] = 4;
        values[valuesById[5] = "CASH_ACCOUNT_SECURE_ADVANCE"] = 5;
        return values;
      }();
      DerivativeLoan.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "DISBURSED"] = 1;
        values[valuesById[2] = "PAID"] = 2;
        values[valuesById[3] = "CANCELLED"] = 3;
        return values;
      }();
      DerivativeLoan.SubStatus = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SUB_STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "UNDUE"] = 1;
        values[valuesById[2] = "DUE"] = 2;
        values[valuesById[3] = "OVERDUE"] = 3;
        return values;
      }();
      return DerivativeLoan;
    }();
    fo.EstimateSettlementPrice = function() {
      function EstimateSettlementPrice(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      EstimateSettlementPrice.prototype.symbol = "";
      EstimateSettlementPrice.prototype.esp = 0;
      EstimateSettlementPrice.prototype.dsp = 0;
      EstimateSettlementPrice.prototype.isFinal = false;
      EstimateSettlementPrice.prototype.isActive = false;
      EstimateSettlementPrice.prototype.updatedTime = null;
      EstimateSettlementPrice.create = function create(properties) {
        return new EstimateSettlementPrice(properties);
      };
      EstimateSettlementPrice.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(10).string(message.symbol);
        if (message.esp != null && Object.hasOwnProperty.call(message, "esp"))
          writer.uint32(17).double(message.esp);
        if (message.dsp != null && Object.hasOwnProperty.call(message, "dsp"))
          writer.uint32(25).double(message.dsp);
        if (message.isFinal != null && Object.hasOwnProperty.call(message, "isFinal"))
          writer.uint32(32).bool(message.isFinal);
        if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
          writer.uint32(40).bool(message.isActive);
        if (message.updatedTime != null && Object.hasOwnProperty.call(message, "updatedTime"))
          $root.google.protobuf.Timestamp.encode(message.updatedTime, writer.uint32(50).fork()).ldelim();
        return writer;
      };
      EstimateSettlementPrice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      EstimateSettlementPrice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.EstimateSettlementPrice();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.symbol = reader.string();
              break;
            case 2:
              message.esp = reader.double();
              break;
            case 3:
              message.dsp = reader.double();
              break;
            case 4:
              message.isFinal = reader.bool();
              break;
            case 5:
              message.isActive = reader.bool();
              break;
            case 6:
              message.updatedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      EstimateSettlementPrice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      EstimateSettlementPrice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.esp != null && message.hasOwnProperty("esp")) {
          if (typeof message.esp !== "number")
            return "esp: number expected";
        }
        if (message.dsp != null && message.hasOwnProperty("dsp")) {
          if (typeof message.dsp !== "number")
            return "dsp: number expected";
        }
        if (message.isFinal != null && message.hasOwnProperty("isFinal")) {
          if (typeof message.isFinal !== "boolean")
            return "isFinal: boolean expected";
        }
        if (message.isActive != null && message.hasOwnProperty("isActive")) {
          if (typeof message.isActive !== "boolean")
            return "isActive: boolean expected";
        }
        if (message.updatedTime != null && message.hasOwnProperty("updatedTime")) {
          let error = $root.google.protobuf.Timestamp.verify(message.updatedTime);
          if (error)
            return "updatedTime." + error;
        }
        return null;
      };
      EstimateSettlementPrice.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.EstimateSettlementPrice)
          return object;
        let message = new $root.dnse.fo.EstimateSettlementPrice();
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.esp != null)
          message.esp = Number(object.esp);
        if (object.dsp != null)
          message.dsp = Number(object.dsp);
        if (object.isFinal != null)
          message.isFinal = Boolean(object.isFinal);
        if (object.isActive != null)
          message.isActive = Boolean(object.isActive);
        if (object.updatedTime != null) {
          if (typeof object.updatedTime !== "object")
            throw TypeError(".dnse.fo.EstimateSettlementPrice.updatedTime: object expected");
          message.updatedTime = $root.google.protobuf.Timestamp.fromObject(object.updatedTime);
        }
        return message;
      };
      EstimateSettlementPrice.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = "";
          object.esp = 0;
          object.dsp = 0;
          object.isFinal = false;
          object.isActive = false;
          object.updatedTime = null;
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.esp != null && message.hasOwnProperty("esp"))
          object.esp = options.json && !isFinite(message.esp) ? String(message.esp) : message.esp;
        if (message.dsp != null && message.hasOwnProperty("dsp"))
          object.dsp = options.json && !isFinite(message.dsp) ? String(message.dsp) : message.dsp;
        if (message.isFinal != null && message.hasOwnProperty("isFinal"))
          object.isFinal = message.isFinal;
        if (message.isActive != null && message.hasOwnProperty("isActive"))
          object.isActive = message.isActive;
        if (message.updatedTime != null && message.hasOwnProperty("updatedTime"))
          object.updatedTime = $root.google.protobuf.Timestamp.toObject(message.updatedTime, options);
        return object;
      };
      EstimateSettlementPrice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return EstimateSettlementPrice;
    }();
    fo.LoanProduct = function() {
      function LoanProduct(properties) {
        this.loanPolicies = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanProduct.prototype.id = 0;
      LoanProduct.prototype.name = "";
      LoanProduct.prototype.symbol = "";
      LoanProduct.prototype.loanRate = null;
      LoanProduct.prototype.loanPolicies = $util.emptyArray;
      LoanProduct.prototype.createdDate = null;
      LoanProduct.prototype.modifiedDate = null;
      LoanProduct.prototype.productCategoryId = 0;
      LoanProduct.create = function create(properties) {
        return new LoanProduct(properties);
      };
      LoanProduct.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int32(message.id);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(18).string(message.name);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(26).string(message.symbol);
        if (message.loanRate != null && Object.hasOwnProperty.call(message, "loanRate"))
          $root.dnse.fo.LoanRate.encode(message.loanRate, writer.uint32(34).fork()).ldelim();
        if (message.loanPolicies != null && message.loanPolicies.length)
          for (let i = 0; i < message.loanPolicies.length; ++i)
            $root.dnse.fo.LoanPolicyBalance.encode(message.loanPolicies[i], writer.uint32(42).fork()).ldelim();
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(58).fork()).ldelim();
        if (message.productCategoryId != null && Object.hasOwnProperty.call(message, "productCategoryId"))
          writer.uint32(64).int32(message.productCategoryId);
        return writer;
      };
      LoanProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanProduct.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanProduct();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int32();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.symbol = reader.string();
              break;
            case 4:
              message.loanRate = $root.dnse.fo.LoanRate.decode(reader, reader.uint32());
              break;
            case 5:
              if (!(message.loanPolicies && message.loanPolicies.length))
                message.loanPolicies = [];
              message.loanPolicies.push($root.dnse.fo.LoanPolicyBalance.decode(reader, reader.uint32()));
              break;
            case 6:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 7:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 8:
              message.productCategoryId = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id))
            return "id: integer expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.loanRate != null && message.hasOwnProperty("loanRate")) {
          let error = $root.dnse.fo.LoanRate.verify(message.loanRate);
          if (error)
            return "loanRate." + error;
        }
        if (message.loanPolicies != null && message.hasOwnProperty("loanPolicies")) {
          if (!Array.isArray(message.loanPolicies))
            return "loanPolicies: array expected";
          for (let i = 0; i < message.loanPolicies.length; ++i) {
            let error = $root.dnse.fo.LoanPolicyBalance.verify(message.loanPolicies[i]);
            if (error)
              return "loanPolicies." + error;
          }
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.productCategoryId != null && message.hasOwnProperty("productCategoryId")) {
          if (!$util.isInteger(message.productCategoryId))
            return "productCategoryId: integer expected";
        }
        return null;
      };
      LoanProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanProduct)
          return object;
        let message = new $root.dnse.fo.LoanProduct();
        if (object.id != null)
          message.id = object.id | 0;
        if (object.name != null)
          message.name = String(object.name);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.loanRate != null) {
          if (typeof object.loanRate !== "object")
            throw TypeError(".dnse.fo.LoanProduct.loanRate: object expected");
          message.loanRate = $root.dnse.fo.LoanRate.fromObject(object.loanRate);
        }
        if (object.loanPolicies) {
          if (!Array.isArray(object.loanPolicies))
            throw TypeError(".dnse.fo.LoanProduct.loanPolicies: array expected");
          message.loanPolicies = [];
          for (let i = 0; i < object.loanPolicies.length; ++i) {
            if (typeof object.loanPolicies[i] !== "object")
              throw TypeError(".dnse.fo.LoanProduct.loanPolicies: object expected");
            message.loanPolicies[i] = $root.dnse.fo.LoanPolicyBalance.fromObject(object.loanPolicies[i]);
          }
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.LoanProduct.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.LoanProduct.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.productCategoryId != null)
          message.productCategoryId = object.productCategoryId | 0;
        return message;
      };
      LoanProduct.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.loanPolicies = [];
        if (options.defaults) {
          object.id = 0;
          object.name = "";
          object.symbol = "";
          object.loanRate = null;
          object.createdDate = null;
          object.modifiedDate = null;
          object.productCategoryId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.loanRate != null && message.hasOwnProperty("loanRate"))
          object.loanRate = $root.dnse.fo.LoanRate.toObject(message.loanRate, options);
        if (message.loanPolicies && message.loanPolicies.length) {
          object.loanPolicies = [];
          for (let j = 0; j < message.loanPolicies.length; ++j)
            object.loanPolicies[j] = $root.dnse.fo.LoanPolicyBalance.toObject(message.loanPolicies[j], options);
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.productCategoryId != null && message.hasOwnProperty("productCategoryId"))
          object.productCategoryId = message.productCategoryId;
        return object;
      };
      LoanProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanProduct;
    }();
    fo.LoanPolicyBalance = function() {
      function LoanPolicyBalance(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPolicyBalance.prototype.rate = 0;
      LoanPolicyBalance.prototype.loanPolicy = null;
      LoanPolicyBalance.prototype.rateForWithdraw = 0;
      LoanPolicyBalance.create = function create(properties) {
        return new LoanPolicyBalance(properties);
      };
      LoanPolicyBalance.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
          writer.uint32(9).double(message.rate);
        if (message.loanPolicy != null && Object.hasOwnProperty.call(message, "loanPolicy"))
          $root.dnse.fo.LoanPolicy.encode(message.loanPolicy, writer.uint32(18).fork()).ldelim();
        if (message.rateForWithdraw != null && Object.hasOwnProperty.call(message, "rateForWithdraw"))
          writer.uint32(25).double(message.rateForWithdraw);
        return writer;
      };
      LoanPolicyBalance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPolicyBalance.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPolicyBalance();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.rate = reader.double();
              break;
            case 2:
              message.loanPolicy = $root.dnse.fo.LoanPolicy.decode(reader, reader.uint32());
              break;
            case 3:
              message.rateForWithdraw = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPolicyBalance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPolicyBalance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.rate != null && message.hasOwnProperty("rate")) {
          if (typeof message.rate !== "number")
            return "rate: number expected";
        }
        if (message.loanPolicy != null && message.hasOwnProperty("loanPolicy")) {
          let error = $root.dnse.fo.LoanPolicy.verify(message.loanPolicy);
          if (error)
            return "loanPolicy." + error;
        }
        if (message.rateForWithdraw != null && message.hasOwnProperty("rateForWithdraw")) {
          if (typeof message.rateForWithdraw !== "number")
            return "rateForWithdraw: number expected";
        }
        return null;
      };
      LoanPolicyBalance.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPolicyBalance)
          return object;
        let message = new $root.dnse.fo.LoanPolicyBalance();
        if (object.rate != null)
          message.rate = Number(object.rate);
        if (object.loanPolicy != null) {
          if (typeof object.loanPolicy !== "object")
            throw TypeError(".dnse.fo.LoanPolicyBalance.loanPolicy: object expected");
          message.loanPolicy = $root.dnse.fo.LoanPolicy.fromObject(object.loanPolicy);
        }
        if (object.rateForWithdraw != null)
          message.rateForWithdraw = Number(object.rateForWithdraw);
        return message;
      };
      LoanPolicyBalance.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.rate = 0;
          object.loanPolicy = null;
          object.rateForWithdraw = 0;
        }
        if (message.rate != null && message.hasOwnProperty("rate"))
          object.rate = options.json && !isFinite(message.rate) ? String(message.rate) : message.rate;
        if (message.loanPolicy != null && message.hasOwnProperty("loanPolicy"))
          object.loanPolicy = $root.dnse.fo.LoanPolicy.toObject(message.loanPolicy, options);
        if (message.rateForWithdraw != null && message.hasOwnProperty("rateForWithdraw"))
          object.rateForWithdraw = options.json && !isFinite(message.rateForWithdraw) ? String(message.rateForWithdraw) : message.rateForWithdraw;
        return object;
      };
      LoanPolicyBalance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPolicyBalance;
    }();
    fo.LoanPolicy = function() {
      function LoanPolicy(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanPolicy.prototype.id = 0;
      LoanPolicy.prototype.name = "";
      LoanPolicy.prototype.source = "";
      LoanPolicy.prototype.interestRate = 0;
      LoanPolicy.prototype.interestBasis = 0;
      LoanPolicy.prototype.term = 0;
      LoanPolicy.prototype.overdueInterest = 0;
      LoanPolicy.prototype.allowExtendLoanTerm = false;
      LoanPolicy.prototype.allowEarlyPayment = false;
      LoanPolicy.prototype.preferentialPeriod = 0;
      LoanPolicy.prototype.preferentialInterestRate = 0;
      LoanPolicy.prototype.createdDate = null;
      LoanPolicy.prototype.modifiedDate = null;
      LoanPolicy.prototype.allowOverdueLoanDays = 0;
      LoanPolicy.create = function create(properties) {
        return new LoanPolicy(properties);
      };
      LoanPolicy.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int32(message.id);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(18).string(message.name);
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(26).string(message.source);
        if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
          writer.uint32(33).double(message.interestRate);
        if (message.interestBasis != null && Object.hasOwnProperty.call(message, "interestBasis"))
          writer.uint32(40).int32(message.interestBasis);
        if (message.term != null && Object.hasOwnProperty.call(message, "term"))
          writer.uint32(48).int32(message.term);
        if (message.overdueInterest != null && Object.hasOwnProperty.call(message, "overdueInterest"))
          writer.uint32(57).double(message.overdueInterest);
        if (message.allowExtendLoanTerm != null && Object.hasOwnProperty.call(message, "allowExtendLoanTerm"))
          writer.uint32(64).bool(message.allowExtendLoanTerm);
        if (message.allowEarlyPayment != null && Object.hasOwnProperty.call(message, "allowEarlyPayment"))
          writer.uint32(72).bool(message.allowEarlyPayment);
        if (message.preferentialPeriod != null && Object.hasOwnProperty.call(message, "preferentialPeriod"))
          writer.uint32(80).int32(message.preferentialPeriod);
        if (message.preferentialInterestRate != null && Object.hasOwnProperty.call(message, "preferentialInterestRate"))
          writer.uint32(89).double(message.preferentialInterestRate);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
        if (message.allowOverdueLoanDays != null && Object.hasOwnProperty.call(message, "allowOverdueLoanDays"))
          writer.uint32(112).int32(message.allowOverdueLoanDays);
        return writer;
      };
      LoanPolicy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanPolicy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanPolicy();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int32();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.source = reader.string();
              break;
            case 4:
              message.interestRate = reader.double();
              break;
            case 5:
              message.interestBasis = reader.int32();
              break;
            case 6:
              message.term = reader.int32();
              break;
            case 7:
              message.overdueInterest = reader.double();
              break;
            case 8:
              message.allowExtendLoanTerm = reader.bool();
              break;
            case 9:
              message.allowEarlyPayment = reader.bool();
              break;
            case 10:
              message.preferentialPeriod = reader.int32();
              break;
            case 11:
              message.preferentialInterestRate = reader.double();
              break;
            case 12:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 13:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 14:
              message.allowOverdueLoanDays = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanPolicy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanPolicy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id))
            return "id: integer expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
          if (typeof message.interestRate !== "number")
            return "interestRate: number expected";
        }
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis")) {
          if (!$util.isInteger(message.interestBasis))
            return "interestBasis: integer expected";
        }
        if (message.term != null && message.hasOwnProperty("term")) {
          if (!$util.isInteger(message.term))
            return "term: integer expected";
        }
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest")) {
          if (typeof message.overdueInterest !== "number")
            return "overdueInterest: number expected";
        }
        if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm")) {
          if (typeof message.allowExtendLoanTerm !== "boolean")
            return "allowExtendLoanTerm: boolean expected";
        }
        if (message.allowEarlyPayment != null && message.hasOwnProperty("allowEarlyPayment")) {
          if (typeof message.allowEarlyPayment !== "boolean")
            return "allowEarlyPayment: boolean expected";
        }
        if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod")) {
          if (!$util.isInteger(message.preferentialPeriod))
            return "preferentialPeriod: integer expected";
        }
        if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate")) {
          if (typeof message.preferentialInterestRate !== "number")
            return "preferentialInterestRate: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.allowOverdueLoanDays != null && message.hasOwnProperty("allowOverdueLoanDays")) {
          if (!$util.isInteger(message.allowOverdueLoanDays))
            return "allowOverdueLoanDays: integer expected";
        }
        return null;
      };
      LoanPolicy.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanPolicy)
          return object;
        let message = new $root.dnse.fo.LoanPolicy();
        if (object.id != null)
          message.id = object.id | 0;
        if (object.name != null)
          message.name = String(object.name);
        if (object.source != null)
          message.source = String(object.source);
        if (object.interestRate != null)
          message.interestRate = Number(object.interestRate);
        if (object.interestBasis != null)
          message.interestBasis = object.interestBasis | 0;
        if (object.term != null)
          message.term = object.term | 0;
        if (object.overdueInterest != null)
          message.overdueInterest = Number(object.overdueInterest);
        if (object.allowExtendLoanTerm != null)
          message.allowExtendLoanTerm = Boolean(object.allowExtendLoanTerm);
        if (object.allowEarlyPayment != null)
          message.allowEarlyPayment = Boolean(object.allowEarlyPayment);
        if (object.preferentialPeriod != null)
          message.preferentialPeriod = object.preferentialPeriod | 0;
        if (object.preferentialInterestRate != null)
          message.preferentialInterestRate = Number(object.preferentialInterestRate);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.LoanPolicy.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.LoanPolicy.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.allowOverdueLoanDays != null)
          message.allowOverdueLoanDays = object.allowOverdueLoanDays | 0;
        return message;
      };
      LoanPolicy.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.id = 0;
          object.name = "";
          object.source = "";
          object.interestRate = 0;
          object.interestBasis = 0;
          object.term = 0;
          object.overdueInterest = 0;
          object.allowExtendLoanTerm = false;
          object.allowEarlyPayment = false;
          object.preferentialPeriod = 0;
          object.preferentialInterestRate = 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.allowOverdueLoanDays = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        if (message.interestRate != null && message.hasOwnProperty("interestRate"))
          object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
        if (message.interestBasis != null && message.hasOwnProperty("interestBasis"))
          object.interestBasis = message.interestBasis;
        if (message.term != null && message.hasOwnProperty("term"))
          object.term = message.term;
        if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest"))
          object.overdueInterest = options.json && !isFinite(message.overdueInterest) ? String(message.overdueInterest) : message.overdueInterest;
        if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm"))
          object.allowExtendLoanTerm = message.allowExtendLoanTerm;
        if (message.allowEarlyPayment != null && message.hasOwnProperty("allowEarlyPayment"))
          object.allowEarlyPayment = message.allowEarlyPayment;
        if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod"))
          object.preferentialPeriod = message.preferentialPeriod;
        if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate"))
          object.preferentialInterestRate = options.json && !isFinite(message.preferentialInterestRate) ? String(message.preferentialInterestRate) : message.preferentialInterestRate;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.allowOverdueLoanDays != null && message.hasOwnProperty("allowOverdueLoanDays"))
          object.allowOverdueLoanDays = message.allowOverdueLoanDays;
        return object;
      };
      LoanPolicy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanPolicy;
    }();
    fo.LoanRate = function() {
      function LoanRate(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      LoanRate.prototype.id = 0;
      LoanRate.prototype.name = "";
      LoanRate.prototype.initialRate = 0;
      LoanRate.prototype.initialRateForWithdraw = 0;
      LoanRate.prototype.maintenanceRate = 0;
      LoanRate.prototype.liquidRate = 0;
      LoanRate.prototype.createdDate = null;
      LoanRate.prototype.modifiedDate = null;
      LoanRate.create = function create(properties) {
        return new LoanRate(properties);
      };
      LoanRate.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int32(message.id);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(18).string(message.name);
        if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
          writer.uint32(25).double(message.initialRate);
        if (message.initialRateForWithdraw != null && Object.hasOwnProperty.call(message, "initialRateForWithdraw"))
          writer.uint32(33).double(message.initialRateForWithdraw);
        if (message.maintenanceRate != null && Object.hasOwnProperty.call(message, "maintenanceRate"))
          writer.uint32(41).double(message.maintenanceRate);
        if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
          writer.uint32(49).double(message.liquidRate);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(66).fork()).ldelim();
        return writer;
      };
      LoanRate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      LoanRate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.LoanRate();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int32();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.initialRate = reader.double();
              break;
            case 4:
              message.initialRateForWithdraw = reader.double();
              break;
            case 5:
              message.maintenanceRate = reader.double();
              break;
            case 6:
              message.liquidRate = reader.double();
              break;
            case 7:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 8:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      LoanRate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      LoanRate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id))
            return "id: integer expected";
        }
        if (message.name != null && message.hasOwnProperty("name")) {
          if (!$util.isString(message.name))
            return "name: string expected";
        }
        if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
          if (typeof message.initialRate !== "number")
            return "initialRate: number expected";
        }
        if (message.initialRateForWithdraw != null && message.hasOwnProperty("initialRateForWithdraw")) {
          if (typeof message.initialRateForWithdraw !== "number")
            return "initialRateForWithdraw: number expected";
        }
        if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate")) {
          if (typeof message.maintenanceRate !== "number")
            return "maintenanceRate: number expected";
        }
        if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
          if (typeof message.liquidRate !== "number")
            return "liquidRate: number expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        return null;
      };
      LoanRate.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.LoanRate)
          return object;
        let message = new $root.dnse.fo.LoanRate();
        if (object.id != null)
          message.id = object.id | 0;
        if (object.name != null)
          message.name = String(object.name);
        if (object.initialRate != null)
          message.initialRate = Number(object.initialRate);
        if (object.initialRateForWithdraw != null)
          message.initialRateForWithdraw = Number(object.initialRateForWithdraw);
        if (object.maintenanceRate != null)
          message.maintenanceRate = Number(object.maintenanceRate);
        if (object.liquidRate != null)
          message.liquidRate = Number(object.liquidRate);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.LoanRate.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.LoanRate.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        return message;
      };
      LoanRate.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.id = 0;
          object.name = "";
          object.initialRate = 0;
          object.initialRateForWithdraw = 0;
          object.maintenanceRate = 0;
          object.liquidRate = 0;
          object.createdDate = null;
          object.modifiedDate = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.initialRate != null && message.hasOwnProperty("initialRate"))
          object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
        if (message.initialRateForWithdraw != null && message.hasOwnProperty("initialRateForWithdraw"))
          object.initialRateForWithdraw = options.json && !isFinite(message.initialRateForWithdraw) ? String(message.initialRateForWithdraw) : message.initialRateForWithdraw;
        if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate"))
          object.maintenanceRate = options.json && !isFinite(message.maintenanceRate) ? String(message.maintenanceRate) : message.maintenanceRate;
        if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
          object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        return object;
      };
      LoanRate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return LoanRate;
    }();
    fo.OrderPnlNotification = function() {
      function OrderPnlNotification(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      OrderPnlNotification.prototype.orderId = "";
      OrderPnlNotification.prototype.symbol = "";
      OrderPnlNotification.prototype.pnl = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      OrderPnlNotification.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      OrderPnlNotification.prototype.investorId = "";
      OrderPnlNotification.prototype.pnlPercent = 0;
      OrderPnlNotification.create = function create(properties) {
        return new OrderPnlNotification(properties);
      };
      OrderPnlNotification.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
          writer.uint32(10).string(message.orderId);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(18).string(message.symbol);
        if (message.pnl != null && Object.hasOwnProperty.call(message, "pnl"))
          writer.uint32(24).int64(message.pnl);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
          writer.uint32(32).int64(message.quantity);
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(42).string(message.investorId);
        if (message.pnlPercent != null && Object.hasOwnProperty.call(message, "pnlPercent"))
          writer.uint32(49).double(message.pnlPercent);
        return writer;
      };
      OrderPnlNotification.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      OrderPnlNotification.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.OrderPnlNotification();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.orderId = reader.string();
              break;
            case 2:
              message.symbol = reader.string();
              break;
            case 3:
              message.pnl = reader.int64();
              break;
            case 4:
              message.quantity = reader.int64();
              break;
            case 5:
              message.investorId = reader.string();
              break;
            case 6:
              message.pnlPercent = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      OrderPnlNotification.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      OrderPnlNotification.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.orderId != null && message.hasOwnProperty("orderId")) {
          if (!$util.isString(message.orderId))
            return "orderId: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.pnl != null && message.hasOwnProperty("pnl")) {
          if (!$util.isInteger(message.pnl) && !(message.pnl && $util.isInteger(message.pnl.low) && $util.isInteger(message.pnl.high)))
            return "pnl: integer|Long expected";
        }
        if (message.quantity != null && message.hasOwnProperty("quantity")) {
          if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
            return "quantity: integer|Long expected";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.pnlPercent != null && message.hasOwnProperty("pnlPercent")) {
          if (typeof message.pnlPercent !== "number")
            return "pnlPercent: number expected";
        }
        return null;
      };
      OrderPnlNotification.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.OrderPnlNotification)
          return object;
        let message = new $root.dnse.fo.OrderPnlNotification();
        if (object.orderId != null)
          message.orderId = String(object.orderId);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.pnl != null) {
          if ($util.Long)
            (message.pnl = $util.Long.fromValue(object.pnl)).unsigned = false;
          else if (typeof object.pnl === "string")
            message.pnl = parseInt(object.pnl, 10);
          else if (typeof object.pnl === "number")
            message.pnl = object.pnl;
          else if (typeof object.pnl === "object")
            message.pnl = new $util.LongBits(object.pnl.low >>> 0, object.pnl.high >>> 0).toNumber();
        }
        if (object.quantity != null) {
          if ($util.Long)
            (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
          else if (typeof object.quantity === "string")
            message.quantity = parseInt(object.quantity, 10);
          else if (typeof object.quantity === "number")
            message.quantity = object.quantity;
          else if (typeof object.quantity === "object")
            message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        }
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.pnlPercent != null)
          message.pnlPercent = Number(object.pnlPercent);
        return message;
      };
      OrderPnlNotification.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.orderId = "";
          object.symbol = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.pnl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.pnl = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.quantity = options.longs === String ? "0" : 0;
          object.investorId = "";
          object.pnlPercent = 0;
        }
        if (message.orderId != null && message.hasOwnProperty("orderId"))
          object.orderId = message.orderId;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.pnl != null && message.hasOwnProperty("pnl"))
          if (typeof message.pnl === "number")
            object.pnl = options.longs === String ? String(message.pnl) : message.pnl;
          else
            object.pnl = options.longs === String ? $util.Long.prototype.toString.call(message.pnl) : options.longs === Number ? new $util.LongBits(message.pnl.low >>> 0, message.pnl.high >>> 0).toNumber() : message.pnl;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
          if (typeof message.quantity === "number")
            object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
          else
            object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.pnlPercent != null && message.hasOwnProperty("pnlPercent"))
          object.pnlPercent = options.json && !isFinite(message.pnlPercent) ? String(message.pnlPercent) : message.pnlPercent;
        return object;
      };
      OrderPnlNotification.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return OrderPnlNotification;
    }();
    fo.CorporateActionNotification = function() {
      function CorporateActionNotification(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      CorporateActionNotification.prototype.corporateActionId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CorporateActionNotification.prototype.investorId = "";
      CorporateActionNotification.prototype.type = "";
      CorporateActionNotification.prototype.symbol = "";
      CorporateActionNotification.prototype.value = null;
      CorporateActionNotification.prototype.qty = null;
      CorporateActionNotification.prototype.exPrice = null;
      CorporateActionNotification.prototype.dueDate = null;
      CorporateActionNotification.prototype.createdDate = null;
      CorporateActionNotification.prototype.accountName = null;
      CorporateActionNotification.prototype.ratio = null;
      CorporateActionNotification.prototype.reportDate = null;
      CorporateActionNotification.prototype.actionDate = null;
      CorporateActionNotification.prototype.accountType = null;
      CorporateActionNotification.prototype.email = null;
      CorporateActionNotification.prototype.fullName = null;
      CorporateActionNotification.prototype.custodyCode = null;
      let $oneOfFields;
      Object.defineProperty(CorporateActionNotification.prototype, "_value", {
        get: $util.oneOfGetter($oneOfFields = ["value"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_qty", {
        get: $util.oneOfGetter($oneOfFields = ["qty"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_exPrice", {
        get: $util.oneOfGetter($oneOfFields = ["exPrice"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_dueDate", {
        get: $util.oneOfGetter($oneOfFields = ["dueDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_accountName", {
        get: $util.oneOfGetter($oneOfFields = ["accountName"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_ratio", {
        get: $util.oneOfGetter($oneOfFields = ["ratio"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_reportDate", {
        get: $util.oneOfGetter($oneOfFields = ["reportDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_actionDate", {
        get: $util.oneOfGetter($oneOfFields = ["actionDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_accountType", {
        get: $util.oneOfGetter($oneOfFields = ["accountType"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_email", {
        get: $util.oneOfGetter($oneOfFields = ["email"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_fullName", {
        get: $util.oneOfGetter($oneOfFields = ["fullName"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(CorporateActionNotification.prototype, "_custodyCode", {
        get: $util.oneOfGetter($oneOfFields = ["custodyCode"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      CorporateActionNotification.create = function create(properties) {
        return new CorporateActionNotification(properties);
      };
      CorporateActionNotification.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.corporateActionId != null && Object.hasOwnProperty.call(message, "corporateActionId"))
          writer.uint32(8).int64(message.corporateActionId);
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(18).string(message.investorId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(26).string(message.type);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(34).string(message.symbol);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
          writer.uint32(41).double(message.value);
        if (message.qty != null && Object.hasOwnProperty.call(message, "qty"))
          writer.uint32(48).int32(message.qty);
        if (message.exPrice != null && Object.hasOwnProperty.call(message, "exPrice"))
          writer.uint32(57).double(message.exPrice);
        if (message.dueDate != null && Object.hasOwnProperty.call(message, "dueDate"))
          $root.google.protobuf.Timestamp.encode(message.dueDate, writer.uint32(66).fork()).ldelim();
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
        if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
          writer.uint32(82).string(message.accountName);
        if (message.ratio != null && Object.hasOwnProperty.call(message, "ratio"))
          writer.uint32(90).string(message.ratio);
        if (message.reportDate != null && Object.hasOwnProperty.call(message, "reportDate"))
          $root.google.protobuf.Timestamp.encode(message.reportDate, writer.uint32(98).fork()).ldelim();
        if (message.actionDate != null && Object.hasOwnProperty.call(message, "actionDate"))
          $root.google.protobuf.Timestamp.encode(message.actionDate, writer.uint32(106).fork()).ldelim();
        if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
          writer.uint32(114).string(message.accountType);
        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
          writer.uint32(122).string(message.email);
        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
          writer.uint32(130).string(message.fullName);
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(138).string(message.custodyCode);
        return writer;
      };
      CorporateActionNotification.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      CorporateActionNotification.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.CorporateActionNotification();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.corporateActionId = reader.int64();
              break;
            case 2:
              message.investorId = reader.string();
              break;
            case 3:
              message.type = reader.string();
              break;
            case 4:
              message.symbol = reader.string();
              break;
            case 5:
              message.value = reader.double();
              break;
            case 6:
              message.qty = reader.int32();
              break;
            case 7:
              message.exPrice = reader.double();
              break;
            case 8:
              message.dueDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 9:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 10:
              message.accountName = reader.string();
              break;
            case 11:
              message.ratio = reader.string();
              break;
            case 12:
              message.reportDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 13:
              message.actionDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 14:
              message.accountType = reader.string();
              break;
            case 15:
              message.email = reader.string();
              break;
            case 16:
              message.fullName = reader.string();
              break;
            case 17:
              message.custodyCode = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      CorporateActionNotification.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      CorporateActionNotification.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.corporateActionId != null && message.hasOwnProperty("corporateActionId")) {
          if (!$util.isInteger(message.corporateActionId) && !(message.corporateActionId && $util.isInteger(message.corporateActionId.low) && $util.isInteger(message.corporateActionId.high)))
            return "corporateActionId: integer|Long expected";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.value != null && message.hasOwnProperty("value")) {
          if (typeof message.value !== "number")
            return "value: number expected";
        }
        if (message.qty != null && message.hasOwnProperty("qty")) {
          if (!$util.isInteger(message.qty))
            return "qty: integer expected";
        }
        if (message.exPrice != null && message.hasOwnProperty("exPrice")) {
          if (typeof message.exPrice !== "number")
            return "exPrice: number expected";
        }
        if (message.dueDate != null && message.hasOwnProperty("dueDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.dueDate);
            if (error)
              return "dueDate." + error;
          }
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.accountName != null && message.hasOwnProperty("accountName")) {
          if (!$util.isString(message.accountName))
            return "accountName: string expected";
        }
        if (message.ratio != null && message.hasOwnProperty("ratio")) {
          if (!$util.isString(message.ratio))
            return "ratio: string expected";
        }
        if (message.reportDate != null && message.hasOwnProperty("reportDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.reportDate);
            if (error)
              return "reportDate." + error;
          }
        }
        if (message.actionDate != null && message.hasOwnProperty("actionDate")) {
          {
            let error = $root.google.protobuf.Timestamp.verify(message.actionDate);
            if (error)
              return "actionDate." + error;
          }
        }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          if (!$util.isString(message.accountType))
            return "accountType: string expected";
        }
        if (message.email != null && message.hasOwnProperty("email")) {
          if (!$util.isString(message.email))
            return "email: string expected";
        }
        if (message.fullName != null && message.hasOwnProperty("fullName")) {
          if (!$util.isString(message.fullName))
            return "fullName: string expected";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        return null;
      };
      CorporateActionNotification.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.CorporateActionNotification)
          return object;
        let message = new $root.dnse.fo.CorporateActionNotification();
        if (object.corporateActionId != null) {
          if ($util.Long)
            (message.corporateActionId = $util.Long.fromValue(object.corporateActionId)).unsigned = false;
          else if (typeof object.corporateActionId === "string")
            message.corporateActionId = parseInt(object.corporateActionId, 10);
          else if (typeof object.corporateActionId === "number")
            message.corporateActionId = object.corporateActionId;
          else if (typeof object.corporateActionId === "object")
            message.corporateActionId = new $util.LongBits(object.corporateActionId.low >>> 0, object.corporateActionId.high >>> 0).toNumber();
        }
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.type != null)
          message.type = String(object.type);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.value != null)
          message.value = Number(object.value);
        if (object.qty != null)
          message.qty = object.qty | 0;
        if (object.exPrice != null)
          message.exPrice = Number(object.exPrice);
        if (object.dueDate != null) {
          if (typeof object.dueDate !== "object")
            throw TypeError(".dnse.fo.CorporateActionNotification.dueDate: object expected");
          message.dueDate = $root.google.protobuf.Timestamp.fromObject(object.dueDate);
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.CorporateActionNotification.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.accountName != null)
          message.accountName = String(object.accountName);
        if (object.ratio != null)
          message.ratio = String(object.ratio);
        if (object.reportDate != null) {
          if (typeof object.reportDate !== "object")
            throw TypeError(".dnse.fo.CorporateActionNotification.reportDate: object expected");
          message.reportDate = $root.google.protobuf.Timestamp.fromObject(object.reportDate);
        }
        if (object.actionDate != null) {
          if (typeof object.actionDate !== "object")
            throw TypeError(".dnse.fo.CorporateActionNotification.actionDate: object expected");
          message.actionDate = $root.google.protobuf.Timestamp.fromObject(object.actionDate);
        }
        if (object.accountType != null)
          message.accountType = String(object.accountType);
        if (object.email != null)
          message.email = String(object.email);
        if (object.fullName != null)
          message.fullName = String(object.fullName);
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        return message;
      };
      CorporateActionNotification.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.corporateActionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.corporateActionId = options.longs === String ? "0" : 0;
          object.investorId = "";
          object.type = "";
          object.symbol = "";
          object.createdDate = null;
        }
        if (message.corporateActionId != null && message.hasOwnProperty("corporateActionId"))
          if (typeof message.corporateActionId === "number")
            object.corporateActionId = options.longs === String ? String(message.corporateActionId) : message.corporateActionId;
          else
            object.corporateActionId = options.longs === String ? $util.Long.prototype.toString.call(message.corporateActionId) : options.longs === Number ? new $util.LongBits(message.corporateActionId.low >>> 0, message.corporateActionId.high >>> 0).toNumber() : message.corporateActionId;
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.value != null && message.hasOwnProperty("value")) {
          object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
          if (options.oneofs)
            object._value = "value";
        }
        if (message.qty != null && message.hasOwnProperty("qty")) {
          object.qty = message.qty;
          if (options.oneofs)
            object._qty = "qty";
        }
        if (message.exPrice != null && message.hasOwnProperty("exPrice")) {
          object.exPrice = options.json && !isFinite(message.exPrice) ? String(message.exPrice) : message.exPrice;
          if (options.oneofs)
            object._exPrice = "exPrice";
        }
        if (message.dueDate != null && message.hasOwnProperty("dueDate")) {
          object.dueDate = $root.google.protobuf.Timestamp.toObject(message.dueDate, options);
          if (options.oneofs)
            object._dueDate = "dueDate";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.accountName != null && message.hasOwnProperty("accountName")) {
          object.accountName = message.accountName;
          if (options.oneofs)
            object._accountName = "accountName";
        }
        if (message.ratio != null && message.hasOwnProperty("ratio")) {
          object.ratio = message.ratio;
          if (options.oneofs)
            object._ratio = "ratio";
        }
        if (message.reportDate != null && message.hasOwnProperty("reportDate")) {
          object.reportDate = $root.google.protobuf.Timestamp.toObject(message.reportDate, options);
          if (options.oneofs)
            object._reportDate = "reportDate";
        }
        if (message.actionDate != null && message.hasOwnProperty("actionDate")) {
          object.actionDate = $root.google.protobuf.Timestamp.toObject(message.actionDate, options);
          if (options.oneofs)
            object._actionDate = "actionDate";
        }
        if (message.accountType != null && message.hasOwnProperty("accountType")) {
          object.accountType = message.accountType;
          if (options.oneofs)
            object._accountType = "accountType";
        }
        if (message.email != null && message.hasOwnProperty("email")) {
          object.email = message.email;
          if (options.oneofs)
            object._email = "email";
        }
        if (message.fullName != null && message.hasOwnProperty("fullName")) {
          object.fullName = message.fullName;
          if (options.oneofs)
            object._fullName = "fullName";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          object.custodyCode = message.custodyCode;
          if (options.oneofs)
            object._custodyCode = "custodyCode";
        }
        return object;
      };
      CorporateActionNotification.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return CorporateActionNotification;
    }();
    fo.DerivativeLoanWrap = function() {
      function DerivativeLoanWrap(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoanWrap.prototype.payload = null;
      DerivativeLoanWrap.prototype.metadata = null;
      DerivativeLoanWrap.create = function create(properties) {
        return new DerivativeLoanWrap(properties);
      };
      DerivativeLoanWrap.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
          $root.dnse.fo.DerivativeLoan.encode(message.payload, writer.uint32(10).fork()).ldelim();
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          $root.dnse.fo.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      DerivativeLoanWrap.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoanWrap.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoanWrap();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.payload = $root.dnse.fo.DerivativeLoan.decode(reader, reader.uint32());
              break;
            case 2:
              message.metadata = $root.dnse.fo.Metadata.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoanWrap.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoanWrap.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.payload != null && message.hasOwnProperty("payload")) {
          let error = $root.dnse.fo.DerivativeLoan.verify(message.payload);
          if (error)
            return "payload." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          let error = $root.dnse.fo.Metadata.verify(message.metadata);
          if (error)
            return "metadata." + error;
        }
        return null;
      };
      DerivativeLoanWrap.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoanWrap)
          return object;
        let message = new $root.dnse.fo.DerivativeLoanWrap();
        if (object.payload != null) {
          if (typeof object.payload !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanWrap.payload: object expected");
          message.payload = $root.dnse.fo.DerivativeLoan.fromObject(object.payload);
        }
        if (object.metadata != null) {
          if (typeof object.metadata !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanWrap.metadata: object expected");
          message.metadata = $root.dnse.fo.Metadata.fromObject(object.metadata);
        }
        return message;
      };
      DerivativeLoanWrap.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.payload = null;
          object.metadata = null;
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
          object.payload = $root.dnse.fo.DerivativeLoan.toObject(message.payload, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = $root.dnse.fo.Metadata.toObject(message.metadata, options);
        return object;
      };
      DerivativeLoanWrap.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativeLoanWrap;
    }();
    fo.InternalPerson = function() {
      function InternalPerson(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      InternalPerson.prototype.custodyCode = "";
      InternalPerson.prototype.symbol = "";
      InternalPerson.prototype.internalPersonType = "";
      InternalPerson.prototype.relationship = "";
      InternalPerson.prototype.startDate = "";
      InternalPerson.prototype.endDate = "";
      InternalPerson.prototype.expectedTradingTimeFrom = "";
      InternalPerson.prototype.expectedTradingTimeTo = "";
      InternalPerson.prototype.expectedTradingVolume = 0;
      InternalPerson.prototype.executedBuyVolumeThisMonth = 0;
      InternalPerson.prototype.executedSellVolumeThisMonth = 0;
      InternalPerson.prototype.tradingType = "";
      InternalPerson.prototype.informationAnnouncementStatus = "";
      InternalPerson.prototype.isInformationAnnouncement = false;
      InternalPerson.prototype.description = "";
      InternalPerson.prototype.transactionCompletionDate = "";
      InternalPerson.create = function create(properties) {
        return new InternalPerson(properties);
      };
      InternalPerson.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(10).string(message.custodyCode);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(18).string(message.symbol);
        if (message.internalPersonType != null && Object.hasOwnProperty.call(message, "internalPersonType"))
          writer.uint32(26).string(message.internalPersonType);
        if (message.relationship != null && Object.hasOwnProperty.call(message, "relationship"))
          writer.uint32(34).string(message.relationship);
        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
          writer.uint32(42).string(message.startDate);
        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
          writer.uint32(50).string(message.endDate);
        if (message.expectedTradingTimeFrom != null && Object.hasOwnProperty.call(message, "expectedTradingTimeFrom"))
          writer.uint32(58).string(message.expectedTradingTimeFrom);
        if (message.expectedTradingTimeTo != null && Object.hasOwnProperty.call(message, "expectedTradingTimeTo"))
          writer.uint32(66).string(message.expectedTradingTimeTo);
        if (message.expectedTradingVolume != null && Object.hasOwnProperty.call(message, "expectedTradingVolume"))
          writer.uint32(73).double(message.expectedTradingVolume);
        if (message.executedBuyVolumeThisMonth != null && Object.hasOwnProperty.call(message, "executedBuyVolumeThisMonth"))
          writer.uint32(81).double(message.executedBuyVolumeThisMonth);
        if (message.executedSellVolumeThisMonth != null && Object.hasOwnProperty.call(message, "executedSellVolumeThisMonth"))
          writer.uint32(89).double(message.executedSellVolumeThisMonth);
        if (message.tradingType != null && Object.hasOwnProperty.call(message, "tradingType"))
          writer.uint32(98).string(message.tradingType);
        if (message.informationAnnouncementStatus != null && Object.hasOwnProperty.call(message, "informationAnnouncementStatus"))
          writer.uint32(106).string(message.informationAnnouncementStatus);
        if (message.isInformationAnnouncement != null && Object.hasOwnProperty.call(message, "isInformationAnnouncement"))
          writer.uint32(112).bool(message.isInformationAnnouncement);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(122).string(message.description);
        if (message.transactionCompletionDate != null && Object.hasOwnProperty.call(message, "transactionCompletionDate"))
          writer.uint32(130).string(message.transactionCompletionDate);
        return writer;
      };
      InternalPerson.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      InternalPerson.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.InternalPerson();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.custodyCode = reader.string();
              break;
            case 2:
              message.symbol = reader.string();
              break;
            case 3:
              message.internalPersonType = reader.string();
              break;
            case 4:
              message.relationship = reader.string();
              break;
            case 5:
              message.startDate = reader.string();
              break;
            case 6:
              message.endDate = reader.string();
              break;
            case 7:
              message.expectedTradingTimeFrom = reader.string();
              break;
            case 8:
              message.expectedTradingTimeTo = reader.string();
              break;
            case 9:
              message.expectedTradingVolume = reader.double();
              break;
            case 10:
              message.executedBuyVolumeThisMonth = reader.double();
              break;
            case 11:
              message.executedSellVolumeThisMonth = reader.double();
              break;
            case 12:
              message.tradingType = reader.string();
              break;
            case 13:
              message.informationAnnouncementStatus = reader.string();
              break;
            case 14:
              message.isInformationAnnouncement = reader.bool();
              break;
            case 15:
              message.description = reader.string();
              break;
            case 16:
              message.transactionCompletionDate = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      InternalPerson.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      InternalPerson.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.internalPersonType != null && message.hasOwnProperty("internalPersonType")) {
          if (!$util.isString(message.internalPersonType))
            return "internalPersonType: string expected";
        }
        if (message.relationship != null && message.hasOwnProperty("relationship")) {
          if (!$util.isString(message.relationship))
            return "relationship: string expected";
        }
        if (message.startDate != null && message.hasOwnProperty("startDate")) {
          if (!$util.isString(message.startDate))
            return "startDate: string expected";
        }
        if (message.endDate != null && message.hasOwnProperty("endDate")) {
          if (!$util.isString(message.endDate))
            return "endDate: string expected";
        }
        if (message.expectedTradingTimeFrom != null && message.hasOwnProperty("expectedTradingTimeFrom")) {
          if (!$util.isString(message.expectedTradingTimeFrom))
            return "expectedTradingTimeFrom: string expected";
        }
        if (message.expectedTradingTimeTo != null && message.hasOwnProperty("expectedTradingTimeTo")) {
          if (!$util.isString(message.expectedTradingTimeTo))
            return "expectedTradingTimeTo: string expected";
        }
        if (message.expectedTradingVolume != null && message.hasOwnProperty("expectedTradingVolume")) {
          if (typeof message.expectedTradingVolume !== "number")
            return "expectedTradingVolume: number expected";
        }
        if (message.executedBuyVolumeThisMonth != null && message.hasOwnProperty("executedBuyVolumeThisMonth")) {
          if (typeof message.executedBuyVolumeThisMonth !== "number")
            return "executedBuyVolumeThisMonth: number expected";
        }
        if (message.executedSellVolumeThisMonth != null && message.hasOwnProperty("executedSellVolumeThisMonth")) {
          if (typeof message.executedSellVolumeThisMonth !== "number")
            return "executedSellVolumeThisMonth: number expected";
        }
        if (message.tradingType != null && message.hasOwnProperty("tradingType")) {
          if (!$util.isString(message.tradingType))
            return "tradingType: string expected";
        }
        if (message.informationAnnouncementStatus != null && message.hasOwnProperty("informationAnnouncementStatus")) {
          if (!$util.isString(message.informationAnnouncementStatus))
            return "informationAnnouncementStatus: string expected";
        }
        if (message.isInformationAnnouncement != null && message.hasOwnProperty("isInformationAnnouncement")) {
          if (typeof message.isInformationAnnouncement !== "boolean")
            return "isInformationAnnouncement: boolean expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.transactionCompletionDate != null && message.hasOwnProperty("transactionCompletionDate")) {
          if (!$util.isString(message.transactionCompletionDate))
            return "transactionCompletionDate: string expected";
        }
        return null;
      };
      InternalPerson.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.InternalPerson)
          return object;
        let message = new $root.dnse.fo.InternalPerson();
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.internalPersonType != null)
          message.internalPersonType = String(object.internalPersonType);
        if (object.relationship != null)
          message.relationship = String(object.relationship);
        if (object.startDate != null)
          message.startDate = String(object.startDate);
        if (object.endDate != null)
          message.endDate = String(object.endDate);
        if (object.expectedTradingTimeFrom != null)
          message.expectedTradingTimeFrom = String(object.expectedTradingTimeFrom);
        if (object.expectedTradingTimeTo != null)
          message.expectedTradingTimeTo = String(object.expectedTradingTimeTo);
        if (object.expectedTradingVolume != null)
          message.expectedTradingVolume = Number(object.expectedTradingVolume);
        if (object.executedBuyVolumeThisMonth != null)
          message.executedBuyVolumeThisMonth = Number(object.executedBuyVolumeThisMonth);
        if (object.executedSellVolumeThisMonth != null)
          message.executedSellVolumeThisMonth = Number(object.executedSellVolumeThisMonth);
        if (object.tradingType != null)
          message.tradingType = String(object.tradingType);
        if (object.informationAnnouncementStatus != null)
          message.informationAnnouncementStatus = String(object.informationAnnouncementStatus);
        if (object.isInformationAnnouncement != null)
          message.isInformationAnnouncement = Boolean(object.isInformationAnnouncement);
        if (object.description != null)
          message.description = String(object.description);
        if (object.transactionCompletionDate != null)
          message.transactionCompletionDate = String(object.transactionCompletionDate);
        return message;
      };
      InternalPerson.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.custodyCode = "";
          object.symbol = "";
          object.internalPersonType = "";
          object.relationship = "";
          object.startDate = "";
          object.endDate = "";
          object.expectedTradingTimeFrom = "";
          object.expectedTradingTimeTo = "";
          object.expectedTradingVolume = 0;
          object.executedBuyVolumeThisMonth = 0;
          object.executedSellVolumeThisMonth = 0;
          object.tradingType = "";
          object.informationAnnouncementStatus = "";
          object.isInformationAnnouncement = false;
          object.description = "";
          object.transactionCompletionDate = "";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.internalPersonType != null && message.hasOwnProperty("internalPersonType"))
          object.internalPersonType = message.internalPersonType;
        if (message.relationship != null && message.hasOwnProperty("relationship"))
          object.relationship = message.relationship;
        if (message.startDate != null && message.hasOwnProperty("startDate"))
          object.startDate = message.startDate;
        if (message.endDate != null && message.hasOwnProperty("endDate"))
          object.endDate = message.endDate;
        if (message.expectedTradingTimeFrom != null && message.hasOwnProperty("expectedTradingTimeFrom"))
          object.expectedTradingTimeFrom = message.expectedTradingTimeFrom;
        if (message.expectedTradingTimeTo != null && message.hasOwnProperty("expectedTradingTimeTo"))
          object.expectedTradingTimeTo = message.expectedTradingTimeTo;
        if (message.expectedTradingVolume != null && message.hasOwnProperty("expectedTradingVolume"))
          object.expectedTradingVolume = options.json && !isFinite(message.expectedTradingVolume) ? String(message.expectedTradingVolume) : message.expectedTradingVolume;
        if (message.executedBuyVolumeThisMonth != null && message.hasOwnProperty("executedBuyVolumeThisMonth"))
          object.executedBuyVolumeThisMonth = options.json && !isFinite(message.executedBuyVolumeThisMonth) ? String(message.executedBuyVolumeThisMonth) : message.executedBuyVolumeThisMonth;
        if (message.executedSellVolumeThisMonth != null && message.hasOwnProperty("executedSellVolumeThisMonth"))
          object.executedSellVolumeThisMonth = options.json && !isFinite(message.executedSellVolumeThisMonth) ? String(message.executedSellVolumeThisMonth) : message.executedSellVolumeThisMonth;
        if (message.tradingType != null && message.hasOwnProperty("tradingType"))
          object.tradingType = message.tradingType;
        if (message.informationAnnouncementStatus != null && message.hasOwnProperty("informationAnnouncementStatus"))
          object.informationAnnouncementStatus = message.informationAnnouncementStatus;
        if (message.isInformationAnnouncement != null && message.hasOwnProperty("isInformationAnnouncement"))
          object.isInformationAnnouncement = message.isInformationAnnouncement;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.transactionCompletionDate != null && message.hasOwnProperty("transactionCompletionDate"))
          object.transactionCompletionDate = message.transactionCompletionDate;
        return object;
      };
      InternalPerson.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return InternalPerson;
    }();
    fo.InternalPersonEvent = function() {
      function InternalPersonEvent(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      InternalPersonEvent.prototype.custodyCode = "";
      InternalPersonEvent.prototype.symbol = "";
      InternalPersonEvent.prototype.internalPersonType = "";
      InternalPersonEvent.prototype.relationship = "";
      InternalPersonEvent.prototype.startDate = "";
      InternalPersonEvent.prototype.endDate = "";
      InternalPersonEvent.prototype.expectedTradingTimeFrom = "";
      InternalPersonEvent.prototype.expectedTradingTimeTo = "";
      InternalPersonEvent.prototype.expectedTradingVolume = 0;
      InternalPersonEvent.prototype.tradingType = "";
      InternalPersonEvent.prototype.informationAnnouncementStatus = "";
      InternalPersonEvent.prototype.isInformationAnnouncement = false;
      InternalPersonEvent.prototype.description = "";
      InternalPersonEvent.prototype.transactionCompletionDate = "";
      InternalPersonEvent.create = function create(properties) {
        return new InternalPersonEvent(properties);
      };
      InternalPersonEvent.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(10).string(message.custodyCode);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(18).string(message.symbol);
        if (message.internalPersonType != null && Object.hasOwnProperty.call(message, "internalPersonType"))
          writer.uint32(26).string(message.internalPersonType);
        if (message.relationship != null && Object.hasOwnProperty.call(message, "relationship"))
          writer.uint32(34).string(message.relationship);
        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
          writer.uint32(42).string(message.startDate);
        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
          writer.uint32(50).string(message.endDate);
        if (message.expectedTradingTimeFrom != null && Object.hasOwnProperty.call(message, "expectedTradingTimeFrom"))
          writer.uint32(58).string(message.expectedTradingTimeFrom);
        if (message.expectedTradingTimeTo != null && Object.hasOwnProperty.call(message, "expectedTradingTimeTo"))
          writer.uint32(66).string(message.expectedTradingTimeTo);
        if (message.expectedTradingVolume != null && Object.hasOwnProperty.call(message, "expectedTradingVolume"))
          writer.uint32(73).double(message.expectedTradingVolume);
        if (message.tradingType != null && Object.hasOwnProperty.call(message, "tradingType"))
          writer.uint32(82).string(message.tradingType);
        if (message.informationAnnouncementStatus != null && Object.hasOwnProperty.call(message, "informationAnnouncementStatus"))
          writer.uint32(90).string(message.informationAnnouncementStatus);
        if (message.isInformationAnnouncement != null && Object.hasOwnProperty.call(message, "isInformationAnnouncement"))
          writer.uint32(96).bool(message.isInformationAnnouncement);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(106).string(message.description);
        if (message.transactionCompletionDate != null && Object.hasOwnProperty.call(message, "transactionCompletionDate"))
          writer.uint32(114).string(message.transactionCompletionDate);
        return writer;
      };
      InternalPersonEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      InternalPersonEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.InternalPersonEvent();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.custodyCode = reader.string();
              break;
            case 2:
              message.symbol = reader.string();
              break;
            case 3:
              message.internalPersonType = reader.string();
              break;
            case 4:
              message.relationship = reader.string();
              break;
            case 5:
              message.startDate = reader.string();
              break;
            case 6:
              message.endDate = reader.string();
              break;
            case 7:
              message.expectedTradingTimeFrom = reader.string();
              break;
            case 8:
              message.expectedTradingTimeTo = reader.string();
              break;
            case 9:
              message.expectedTradingVolume = reader.double();
              break;
            case 10:
              message.tradingType = reader.string();
              break;
            case 11:
              message.informationAnnouncementStatus = reader.string();
              break;
            case 12:
              message.isInformationAnnouncement = reader.bool();
              break;
            case 13:
              message.description = reader.string();
              break;
            case 14:
              message.transactionCompletionDate = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      InternalPersonEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      InternalPersonEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.internalPersonType != null && message.hasOwnProperty("internalPersonType")) {
          if (!$util.isString(message.internalPersonType))
            return "internalPersonType: string expected";
        }
        if (message.relationship != null && message.hasOwnProperty("relationship")) {
          if (!$util.isString(message.relationship))
            return "relationship: string expected";
        }
        if (message.startDate != null && message.hasOwnProperty("startDate")) {
          if (!$util.isString(message.startDate))
            return "startDate: string expected";
        }
        if (message.endDate != null && message.hasOwnProperty("endDate")) {
          if (!$util.isString(message.endDate))
            return "endDate: string expected";
        }
        if (message.expectedTradingTimeFrom != null && message.hasOwnProperty("expectedTradingTimeFrom")) {
          if (!$util.isString(message.expectedTradingTimeFrom))
            return "expectedTradingTimeFrom: string expected";
        }
        if (message.expectedTradingTimeTo != null && message.hasOwnProperty("expectedTradingTimeTo")) {
          if (!$util.isString(message.expectedTradingTimeTo))
            return "expectedTradingTimeTo: string expected";
        }
        if (message.expectedTradingVolume != null && message.hasOwnProperty("expectedTradingVolume")) {
          if (typeof message.expectedTradingVolume !== "number")
            return "expectedTradingVolume: number expected";
        }
        if (message.tradingType != null && message.hasOwnProperty("tradingType")) {
          if (!$util.isString(message.tradingType))
            return "tradingType: string expected";
        }
        if (message.informationAnnouncementStatus != null && message.hasOwnProperty("informationAnnouncementStatus")) {
          if (!$util.isString(message.informationAnnouncementStatus))
            return "informationAnnouncementStatus: string expected";
        }
        if (message.isInformationAnnouncement != null && message.hasOwnProperty("isInformationAnnouncement")) {
          if (typeof message.isInformationAnnouncement !== "boolean")
            return "isInformationAnnouncement: boolean expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.transactionCompletionDate != null && message.hasOwnProperty("transactionCompletionDate")) {
          if (!$util.isString(message.transactionCompletionDate))
            return "transactionCompletionDate: string expected";
        }
        return null;
      };
      InternalPersonEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.InternalPersonEvent)
          return object;
        let message = new $root.dnse.fo.InternalPersonEvent();
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.internalPersonType != null)
          message.internalPersonType = String(object.internalPersonType);
        if (object.relationship != null)
          message.relationship = String(object.relationship);
        if (object.startDate != null)
          message.startDate = String(object.startDate);
        if (object.endDate != null)
          message.endDate = String(object.endDate);
        if (object.expectedTradingTimeFrom != null)
          message.expectedTradingTimeFrom = String(object.expectedTradingTimeFrom);
        if (object.expectedTradingTimeTo != null)
          message.expectedTradingTimeTo = String(object.expectedTradingTimeTo);
        if (object.expectedTradingVolume != null)
          message.expectedTradingVolume = Number(object.expectedTradingVolume);
        if (object.tradingType != null)
          message.tradingType = String(object.tradingType);
        if (object.informationAnnouncementStatus != null)
          message.informationAnnouncementStatus = String(object.informationAnnouncementStatus);
        if (object.isInformationAnnouncement != null)
          message.isInformationAnnouncement = Boolean(object.isInformationAnnouncement);
        if (object.description != null)
          message.description = String(object.description);
        if (object.transactionCompletionDate != null)
          message.transactionCompletionDate = String(object.transactionCompletionDate);
        return message;
      };
      InternalPersonEvent.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.custodyCode = "";
          object.symbol = "";
          object.internalPersonType = "";
          object.relationship = "";
          object.startDate = "";
          object.endDate = "";
          object.expectedTradingTimeFrom = "";
          object.expectedTradingTimeTo = "";
          object.expectedTradingVolume = 0;
          object.tradingType = "";
          object.informationAnnouncementStatus = "";
          object.isInformationAnnouncement = false;
          object.description = "";
          object.transactionCompletionDate = "";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.internalPersonType != null && message.hasOwnProperty("internalPersonType"))
          object.internalPersonType = message.internalPersonType;
        if (message.relationship != null && message.hasOwnProperty("relationship"))
          object.relationship = message.relationship;
        if (message.startDate != null && message.hasOwnProperty("startDate"))
          object.startDate = message.startDate;
        if (message.endDate != null && message.hasOwnProperty("endDate"))
          object.endDate = message.endDate;
        if (message.expectedTradingTimeFrom != null && message.hasOwnProperty("expectedTradingTimeFrom"))
          object.expectedTradingTimeFrom = message.expectedTradingTimeFrom;
        if (message.expectedTradingTimeTo != null && message.hasOwnProperty("expectedTradingTimeTo"))
          object.expectedTradingTimeTo = message.expectedTradingTimeTo;
        if (message.expectedTradingVolume != null && message.hasOwnProperty("expectedTradingVolume"))
          object.expectedTradingVolume = options.json && !isFinite(message.expectedTradingVolume) ? String(message.expectedTradingVolume) : message.expectedTradingVolume;
        if (message.tradingType != null && message.hasOwnProperty("tradingType"))
          object.tradingType = message.tradingType;
        if (message.informationAnnouncementStatus != null && message.hasOwnProperty("informationAnnouncementStatus"))
          object.informationAnnouncementStatus = message.informationAnnouncementStatus;
        if (message.isInformationAnnouncement != null && message.hasOwnProperty("isInformationAnnouncement"))
          object.isInformationAnnouncement = message.isInformationAnnouncement;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.transactionCompletionDate != null && message.hasOwnProperty("transactionCompletionDate"))
          object.transactionCompletionDate = message.transactionCompletionDate;
        return object;
      };
      InternalPersonEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return InternalPersonEvent;
    }();
    fo.DerivativePositionLimit = function() {
      function DerivativePositionLimit(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativePositionLimit.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativePositionLimit.prototype.type = "";
      DerivativePositionLimit.prototype.referenceType = "";
      DerivativePositionLimit.prototype.referenceCode = "";
      DerivativePositionLimit.prototype.individualLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativePositionLimit.prototype.organizationLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativePositionLimit.prototype.professionalLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativePositionLimit.create = function create(properties) {
        return new DerivativePositionLimit(properties);
      };
      DerivativePositionLimit.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
          writer.uint32(8).int64(message.seq);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(18).string(message.type);
        if (message.referenceType != null && Object.hasOwnProperty.call(message, "referenceType"))
          writer.uint32(26).string(message.referenceType);
        if (message.referenceCode != null && Object.hasOwnProperty.call(message, "referenceCode"))
          writer.uint32(34).string(message.referenceCode);
        if (message.individualLimit != null && Object.hasOwnProperty.call(message, "individualLimit"))
          writer.uint32(40).int64(message.individualLimit);
        if (message.organizationLimit != null && Object.hasOwnProperty.call(message, "organizationLimit"))
          writer.uint32(48).int64(message.organizationLimit);
        if (message.professionalLimit != null && Object.hasOwnProperty.call(message, "professionalLimit"))
          writer.uint32(56).int64(message.professionalLimit);
        return writer;
      };
      DerivativePositionLimit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativePositionLimit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativePositionLimit();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.seq = reader.int64();
              break;
            case 2:
              message.type = reader.string();
              break;
            case 3:
              message.referenceType = reader.string();
              break;
            case 4:
              message.referenceCode = reader.string();
              break;
            case 5:
              message.individualLimit = reader.int64();
              break;
            case 6:
              message.organizationLimit = reader.int64();
              break;
            case 7:
              message.professionalLimit = reader.int64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativePositionLimit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativePositionLimit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.seq != null && message.hasOwnProperty("seq")) {
          if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
            return "seq: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.referenceType != null && message.hasOwnProperty("referenceType")) {
          if (!$util.isString(message.referenceType))
            return "referenceType: string expected";
        }
        if (message.referenceCode != null && message.hasOwnProperty("referenceCode")) {
          if (!$util.isString(message.referenceCode))
            return "referenceCode: string expected";
        }
        if (message.individualLimit != null && message.hasOwnProperty("individualLimit")) {
          if (!$util.isInteger(message.individualLimit) && !(message.individualLimit && $util.isInteger(message.individualLimit.low) && $util.isInteger(message.individualLimit.high)))
            return "individualLimit: integer|Long expected";
        }
        if (message.organizationLimit != null && message.hasOwnProperty("organizationLimit")) {
          if (!$util.isInteger(message.organizationLimit) && !(message.organizationLimit && $util.isInteger(message.organizationLimit.low) && $util.isInteger(message.organizationLimit.high)))
            return "organizationLimit: integer|Long expected";
        }
        if (message.professionalLimit != null && message.hasOwnProperty("professionalLimit")) {
          if (!$util.isInteger(message.professionalLimit) && !(message.professionalLimit && $util.isInteger(message.professionalLimit.low) && $util.isInteger(message.professionalLimit.high)))
            return "professionalLimit: integer|Long expected";
        }
        return null;
      };
      DerivativePositionLimit.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativePositionLimit)
          return object;
        let message = new $root.dnse.fo.DerivativePositionLimit();
        if (object.seq != null) {
          if ($util.Long)
            (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
          else if (typeof object.seq === "string")
            message.seq = parseInt(object.seq, 10);
          else if (typeof object.seq === "number")
            message.seq = object.seq;
          else if (typeof object.seq === "object")
            message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
        }
        if (object.type != null)
          message.type = String(object.type);
        if (object.referenceType != null)
          message.referenceType = String(object.referenceType);
        if (object.referenceCode != null)
          message.referenceCode = String(object.referenceCode);
        if (object.individualLimit != null) {
          if ($util.Long)
            (message.individualLimit = $util.Long.fromValue(object.individualLimit)).unsigned = false;
          else if (typeof object.individualLimit === "string")
            message.individualLimit = parseInt(object.individualLimit, 10);
          else if (typeof object.individualLimit === "number")
            message.individualLimit = object.individualLimit;
          else if (typeof object.individualLimit === "object")
            message.individualLimit = new $util.LongBits(object.individualLimit.low >>> 0, object.individualLimit.high >>> 0).toNumber();
        }
        if (object.organizationLimit != null) {
          if ($util.Long)
            (message.organizationLimit = $util.Long.fromValue(object.organizationLimit)).unsigned = false;
          else if (typeof object.organizationLimit === "string")
            message.organizationLimit = parseInt(object.organizationLimit, 10);
          else if (typeof object.organizationLimit === "number")
            message.organizationLimit = object.organizationLimit;
          else if (typeof object.organizationLimit === "object")
            message.organizationLimit = new $util.LongBits(object.organizationLimit.low >>> 0, object.organizationLimit.high >>> 0).toNumber();
        }
        if (object.professionalLimit != null) {
          if ($util.Long)
            (message.professionalLimit = $util.Long.fromValue(object.professionalLimit)).unsigned = false;
          else if (typeof object.professionalLimit === "string")
            message.professionalLimit = parseInt(object.professionalLimit, 10);
          else if (typeof object.professionalLimit === "number")
            message.professionalLimit = object.professionalLimit;
          else if (typeof object.professionalLimit === "object")
            message.professionalLimit = new $util.LongBits(object.professionalLimit.low >>> 0, object.professionalLimit.high >>> 0).toNumber();
        }
        return message;
      };
      DerivativePositionLimit.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.seq = options.longs === String ? "0" : 0;
          object.type = "";
          object.referenceType = "";
          object.referenceCode = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.individualLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.individualLimit = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.organizationLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.organizationLimit = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.professionalLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.professionalLimit = options.longs === String ? "0" : 0;
        }
        if (message.seq != null && message.hasOwnProperty("seq"))
          if (typeof message.seq === "number")
            object.seq = options.longs === String ? String(message.seq) : message.seq;
          else
            object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.referenceType != null && message.hasOwnProperty("referenceType"))
          object.referenceType = message.referenceType;
        if (message.referenceCode != null && message.hasOwnProperty("referenceCode"))
          object.referenceCode = message.referenceCode;
        if (message.individualLimit != null && message.hasOwnProperty("individualLimit"))
          if (typeof message.individualLimit === "number")
            object.individualLimit = options.longs === String ? String(message.individualLimit) : message.individualLimit;
          else
            object.individualLimit = options.longs === String ? $util.Long.prototype.toString.call(message.individualLimit) : options.longs === Number ? new $util.LongBits(message.individualLimit.low >>> 0, message.individualLimit.high >>> 0).toNumber() : message.individualLimit;
        if (message.organizationLimit != null && message.hasOwnProperty("organizationLimit"))
          if (typeof message.organizationLimit === "number")
            object.organizationLimit = options.longs === String ? String(message.organizationLimit) : message.organizationLimit;
          else
            object.organizationLimit = options.longs === String ? $util.Long.prototype.toString.call(message.organizationLimit) : options.longs === Number ? new $util.LongBits(message.organizationLimit.low >>> 0, message.organizationLimit.high >>> 0).toNumber() : message.organizationLimit;
        if (message.professionalLimit != null && message.hasOwnProperty("professionalLimit"))
          if (typeof message.professionalLimit === "number")
            object.professionalLimit = options.longs === String ? String(message.professionalLimit) : message.professionalLimit;
          else
            object.professionalLimit = options.longs === String ? $util.Long.prototype.toString.call(message.professionalLimit) : options.longs === Number ? new $util.LongBits(message.professionalLimit.low >>> 0, message.professionalLimit.high >>> 0).toNumber() : message.professionalLimit;
        return object;
      };
      DerivativePositionLimit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DerivativePositionLimit;
    }();
    fo.CrossOrder = function() {
      function CrossOrder(properties) {
        this.actions = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      CrossOrder.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CrossOrder.prototype.crossType = 0;
      CrossOrder.prototype.side = "";
      CrossOrder.prototype.investorId = "";
      CrossOrder.prototype.accountNo = "";
      CrossOrder.prototype.symbol = "";
      CrossOrder.prototype.price = 0;
      CrossOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      CrossOrder.prototype.orderStatus = "";
      CrossOrder.prototype.execType = "";
      CrossOrder.prototype.transDate = null;
      CrossOrder.prototype.createdDate = null;
      CrossOrder.prototype.modifiedDate = null;
      CrossOrder.prototype.externalId = "";
      CrossOrder.prototype.error = "";
      CrossOrder.prototype.text = "";
      CrossOrder.prototype.custody = "";
      CrossOrder.prototype.buyAccountNo = "";
      CrossOrder.prototype.buyCustody = "";
      CrossOrder.prototype.buyInvestorId = "";
      CrossOrder.prototype.firmId = "";
      CrossOrder.prototype.traderId = "";
      CrossOrder.prototype.buyFirmId = "";
      CrossOrder.prototype.buyTraderId = "";
      CrossOrder.prototype.clOrdId = "";
      CrossOrder.prototype.origClOrdId = "";
      CrossOrder.prototype.exDestination = "";
      CrossOrder.prototype.maker = "";
      CrossOrder.prototype.channel = "";
      CrossOrder.prototype.feeRate = 0;
      CrossOrder.prototype.taxRate = 0;
      CrossOrder.prototype.buyFeeRate = 0;
      CrossOrder.prototype.buyTaxRate = 0;
      CrossOrder.prototype.externalAdvOrderId = "";
      CrossOrder.prototype.actions = $util.emptyArray;
      CrossOrder.prototype.loanPackageId = 0;
      CrossOrder.prototype.buyLoanPackageId = 0;
      CrossOrder.prototype.buyInitialRate = 0;
      CrossOrder.prototype.metadata = "";
      CrossOrder.prototype.buyMaker = "";
      CrossOrder.prototype.buyChannel = "";
      CrossOrder.create = function create(properties) {
        return new CrossOrder(properties);
      };
      CrossOrder.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.crossType != null && Object.hasOwnProperty.call(message, "crossType"))
          writer.uint32(16).int32(message.crossType);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
          writer.uint32(26).string(message.side);
        if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
          writer.uint32(34).string(message.investorId);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(42).string(message.accountNo);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(50).string(message.symbol);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
          writer.uint32(57).double(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
          writer.uint32(64).int64(message.quantity);
        if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
          writer.uint32(74).string(message.orderStatus);
        if (message.execType != null && Object.hasOwnProperty.call(message, "execType"))
          writer.uint32(82).string(message.execType);
        if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
          $root.google.protobuf.Timestamp.encode(message.transDate, writer.uint32(90).fork()).ldelim();
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
        if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
          writer.uint32(114).string(message.externalId);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
          writer.uint32(122).string(message.error);
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
          writer.uint32(130).string(message.text);
        if (message.custody != null && Object.hasOwnProperty.call(message, "custody"))
          writer.uint32(138).string(message.custody);
        if (message.buyAccountNo != null && Object.hasOwnProperty.call(message, "buyAccountNo"))
          writer.uint32(146).string(message.buyAccountNo);
        if (message.buyCustody != null && Object.hasOwnProperty.call(message, "buyCustody"))
          writer.uint32(154).string(message.buyCustody);
        if (message.buyInvestorId != null && Object.hasOwnProperty.call(message, "buyInvestorId"))
          writer.uint32(162).string(message.buyInvestorId);
        if (message.firmId != null && Object.hasOwnProperty.call(message, "firmId"))
          writer.uint32(170).string(message.firmId);
        if (message.traderId != null && Object.hasOwnProperty.call(message, "traderId"))
          writer.uint32(178).string(message.traderId);
        if (message.buyFirmId != null && Object.hasOwnProperty.call(message, "buyFirmId"))
          writer.uint32(186).string(message.buyFirmId);
        if (message.buyTraderId != null && Object.hasOwnProperty.call(message, "buyTraderId"))
          writer.uint32(194).string(message.buyTraderId);
        if (message.clOrdId != null && Object.hasOwnProperty.call(message, "clOrdId"))
          writer.uint32(202).string(message.clOrdId);
        if (message.origClOrdId != null && Object.hasOwnProperty.call(message, "origClOrdId"))
          writer.uint32(210).string(message.origClOrdId);
        if (message.exDestination != null && Object.hasOwnProperty.call(message, "exDestination"))
          writer.uint32(218).string(message.exDestination);
        if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
          writer.uint32(226).string(message.maker);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
          writer.uint32(234).string(message.channel);
        if (message.feeRate != null && Object.hasOwnProperty.call(message, "feeRate"))
          writer.uint32(241).double(message.feeRate);
        if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
          writer.uint32(249).double(message.taxRate);
        if (message.buyFeeRate != null && Object.hasOwnProperty.call(message, "buyFeeRate"))
          writer.uint32(257).double(message.buyFeeRate);
        if (message.buyTaxRate != null && Object.hasOwnProperty.call(message, "buyTaxRate"))
          writer.uint32(265).double(message.buyTaxRate);
        if (message.externalAdvOrderId != null && Object.hasOwnProperty.call(message, "externalAdvOrderId"))
          writer.uint32(274).string(message.externalAdvOrderId);
        if (message.actions != null && message.actions.length)
          for (let i = 0; i < message.actions.length; ++i)
            writer.uint32(282).string(message.actions[i]);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(288).int32(message.loanPackageId);
        if (message.buyLoanPackageId != null && Object.hasOwnProperty.call(message, "buyLoanPackageId"))
          writer.uint32(296).int32(message.buyLoanPackageId);
        if (message.buyInitialRate != null && Object.hasOwnProperty.call(message, "buyInitialRate"))
          writer.uint32(305).double(message.buyInitialRate);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          writer.uint32(314).string(message.metadata);
        if (message.buyMaker != null && Object.hasOwnProperty.call(message, "buyMaker"))
          writer.uint32(322).string(message.buyMaker);
        if (message.buyChannel != null && Object.hasOwnProperty.call(message, "buyChannel"))
          writer.uint32(330).string(message.buyChannel);
        return writer;
      };
      CrossOrder.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      CrossOrder.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.CrossOrder();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.crossType = reader.int32();
              break;
            case 3:
              message.side = reader.string();
              break;
            case 4:
              message.investorId = reader.string();
              break;
            case 5:
              message.accountNo = reader.string();
              break;
            case 6:
              message.symbol = reader.string();
              break;
            case 7:
              message.price = reader.double();
              break;
            case 8:
              message.quantity = reader.int64();
              break;
            case 9:
              message.orderStatus = reader.string();
              break;
            case 10:
              message.execType = reader.string();
              break;
            case 11:
              message.transDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 12:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 13:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 14:
              message.externalId = reader.string();
              break;
            case 15:
              message.error = reader.string();
              break;
            case 16:
              message.text = reader.string();
              break;
            case 17:
              message.custody = reader.string();
              break;
            case 18:
              message.buyAccountNo = reader.string();
              break;
            case 19:
              message.buyCustody = reader.string();
              break;
            case 20:
              message.buyInvestorId = reader.string();
              break;
            case 21:
              message.firmId = reader.string();
              break;
            case 22:
              message.traderId = reader.string();
              break;
            case 23:
              message.buyFirmId = reader.string();
              break;
            case 24:
              message.buyTraderId = reader.string();
              break;
            case 25:
              message.clOrdId = reader.string();
              break;
            case 26:
              message.origClOrdId = reader.string();
              break;
            case 27:
              message.exDestination = reader.string();
              break;
            case 28:
              message.maker = reader.string();
              break;
            case 29:
              message.channel = reader.string();
              break;
            case 30:
              message.feeRate = reader.double();
              break;
            case 31:
              message.taxRate = reader.double();
              break;
            case 32:
              message.buyFeeRate = reader.double();
              break;
            case 33:
              message.buyTaxRate = reader.double();
              break;
            case 34:
              message.externalAdvOrderId = reader.string();
              break;
            case 35:
              if (!(message.actions && message.actions.length))
                message.actions = [];
              message.actions.push(reader.string());
              break;
            case 36:
              message.loanPackageId = reader.int32();
              break;
            case 37:
              message.buyLoanPackageId = reader.int32();
              break;
            case 38:
              message.buyInitialRate = reader.double();
              break;
            case 39:
              message.metadata = reader.string();
              break;
            case 40:
              message.buyMaker = reader.string();
              break;
            case 41:
              message.buyChannel = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      CrossOrder.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      CrossOrder.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.crossType != null && message.hasOwnProperty("crossType"))
          switch (message.crossType) {
            default:
              return "crossType: enum value expected";
            case 0:
            case 1:
              break;
          }
        if (message.side != null && message.hasOwnProperty("side")) {
          if (!$util.isString(message.side))
            return "side: string expected";
        }
        if (message.investorId != null && message.hasOwnProperty("investorId")) {
          if (!$util.isString(message.investorId))
            return "investorId: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.price != null && message.hasOwnProperty("price")) {
          if (typeof message.price !== "number")
            return "price: number expected";
        }
        if (message.quantity != null && message.hasOwnProperty("quantity")) {
          if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
            return "quantity: integer|Long expected";
        }
        if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
          if (!$util.isString(message.orderStatus))
            return "orderStatus: string expected";
        }
        if (message.execType != null && message.hasOwnProperty("execType")) {
          if (!$util.isString(message.execType))
            return "execType: string expected";
        }
        if (message.transDate != null && message.hasOwnProperty("transDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.transDate);
          if (error)
            return "transDate." + error;
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.externalId != null && message.hasOwnProperty("externalId")) {
          if (!$util.isString(message.externalId))
            return "externalId: string expected";
        }
        if (message.error != null && message.hasOwnProperty("error")) {
          if (!$util.isString(message.error))
            return "error: string expected";
        }
        if (message.text != null && message.hasOwnProperty("text")) {
          if (!$util.isString(message.text))
            return "text: string expected";
        }
        if (message.custody != null && message.hasOwnProperty("custody")) {
          if (!$util.isString(message.custody))
            return "custody: string expected";
        }
        if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo")) {
          if (!$util.isString(message.buyAccountNo))
            return "buyAccountNo: string expected";
        }
        if (message.buyCustody != null && message.hasOwnProperty("buyCustody")) {
          if (!$util.isString(message.buyCustody))
            return "buyCustody: string expected";
        }
        if (message.buyInvestorId != null && message.hasOwnProperty("buyInvestorId")) {
          if (!$util.isString(message.buyInvestorId))
            return "buyInvestorId: string expected";
        }
        if (message.firmId != null && message.hasOwnProperty("firmId")) {
          if (!$util.isString(message.firmId))
            return "firmId: string expected";
        }
        if (message.traderId != null && message.hasOwnProperty("traderId")) {
          if (!$util.isString(message.traderId))
            return "traderId: string expected";
        }
        if (message.buyFirmId != null && message.hasOwnProperty("buyFirmId")) {
          if (!$util.isString(message.buyFirmId))
            return "buyFirmId: string expected";
        }
        if (message.buyTraderId != null && message.hasOwnProperty("buyTraderId")) {
          if (!$util.isString(message.buyTraderId))
            return "buyTraderId: string expected";
        }
        if (message.clOrdId != null && message.hasOwnProperty("clOrdId")) {
          if (!$util.isString(message.clOrdId))
            return "clOrdId: string expected";
        }
        if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId")) {
          if (!$util.isString(message.origClOrdId))
            return "origClOrdId: string expected";
        }
        if (message.exDestination != null && message.hasOwnProperty("exDestination")) {
          if (!$util.isString(message.exDestination))
            return "exDestination: string expected";
        }
        if (message.maker != null && message.hasOwnProperty("maker")) {
          if (!$util.isString(message.maker))
            return "maker: string expected";
        }
        if (message.channel != null && message.hasOwnProperty("channel")) {
          if (!$util.isString(message.channel))
            return "channel: string expected";
        }
        if (message.feeRate != null && message.hasOwnProperty("feeRate")) {
          if (typeof message.feeRate !== "number")
            return "feeRate: number expected";
        }
        if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
          if (typeof message.taxRate !== "number")
            return "taxRate: number expected";
        }
        if (message.buyFeeRate != null && message.hasOwnProperty("buyFeeRate")) {
          if (typeof message.buyFeeRate !== "number")
            return "buyFeeRate: number expected";
        }
        if (message.buyTaxRate != null && message.hasOwnProperty("buyTaxRate")) {
          if (typeof message.buyTaxRate !== "number")
            return "buyTaxRate: number expected";
        }
        if (message.externalAdvOrderId != null && message.hasOwnProperty("externalAdvOrderId")) {
          if (!$util.isString(message.externalAdvOrderId))
            return "externalAdvOrderId: string expected";
        }
        if (message.actions != null && message.hasOwnProperty("actions")) {
          if (!Array.isArray(message.actions))
            return "actions: array expected";
          for (let i = 0; i < message.actions.length; ++i)
            if (!$util.isString(message.actions[i]))
              return "actions: string[] expected";
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId")) {
          if (!$util.isInteger(message.buyLoanPackageId))
            return "buyLoanPackageId: integer expected";
        }
        if (message.buyInitialRate != null && message.hasOwnProperty("buyInitialRate")) {
          if (typeof message.buyInitialRate !== "number")
            return "buyInitialRate: number expected";
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          if (!$util.isString(message.metadata))
            return "metadata: string expected";
        }
        if (message.buyMaker != null && message.hasOwnProperty("buyMaker")) {
          if (!$util.isString(message.buyMaker))
            return "buyMaker: string expected";
        }
        if (message.buyChannel != null && message.hasOwnProperty("buyChannel")) {
          if (!$util.isString(message.buyChannel))
            return "buyChannel: string expected";
        }
        return null;
      };
      CrossOrder.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.CrossOrder)
          return object;
        let message = new $root.dnse.fo.CrossOrder();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        switch (object.crossType) {
          case "ONE_FIRM":
          case 0:
            message.crossType = 0;
            break;
          case "TWO_FIRM":
          case 1:
            message.crossType = 1;
            break;
        }
        if (object.side != null)
          message.side = String(object.side);
        if (object.investorId != null)
          message.investorId = String(object.investorId);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.price != null)
          message.price = Number(object.price);
        if (object.quantity != null) {
          if ($util.Long)
            (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
          else if (typeof object.quantity === "string")
            message.quantity = parseInt(object.quantity, 10);
          else if (typeof object.quantity === "number")
            message.quantity = object.quantity;
          else if (typeof object.quantity === "object")
            message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        }
        if (object.orderStatus != null)
          message.orderStatus = String(object.orderStatus);
        if (object.execType != null)
          message.execType = String(object.execType);
        if (object.transDate != null) {
          if (typeof object.transDate !== "object")
            throw TypeError(".dnse.fo.CrossOrder.transDate: object expected");
          message.transDate = $root.google.protobuf.Timestamp.fromObject(object.transDate);
        }
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.CrossOrder.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.CrossOrder.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.externalId != null)
          message.externalId = String(object.externalId);
        if (object.error != null)
          message.error = String(object.error);
        if (object.text != null)
          message.text = String(object.text);
        if (object.custody != null)
          message.custody = String(object.custody);
        if (object.buyAccountNo != null)
          message.buyAccountNo = String(object.buyAccountNo);
        if (object.buyCustody != null)
          message.buyCustody = String(object.buyCustody);
        if (object.buyInvestorId != null)
          message.buyInvestorId = String(object.buyInvestorId);
        if (object.firmId != null)
          message.firmId = String(object.firmId);
        if (object.traderId != null)
          message.traderId = String(object.traderId);
        if (object.buyFirmId != null)
          message.buyFirmId = String(object.buyFirmId);
        if (object.buyTraderId != null)
          message.buyTraderId = String(object.buyTraderId);
        if (object.clOrdId != null)
          message.clOrdId = String(object.clOrdId);
        if (object.origClOrdId != null)
          message.origClOrdId = String(object.origClOrdId);
        if (object.exDestination != null)
          message.exDestination = String(object.exDestination);
        if (object.maker != null)
          message.maker = String(object.maker);
        if (object.channel != null)
          message.channel = String(object.channel);
        if (object.feeRate != null)
          message.feeRate = Number(object.feeRate);
        if (object.taxRate != null)
          message.taxRate = Number(object.taxRate);
        if (object.buyFeeRate != null)
          message.buyFeeRate = Number(object.buyFeeRate);
        if (object.buyTaxRate != null)
          message.buyTaxRate = Number(object.buyTaxRate);
        if (object.externalAdvOrderId != null)
          message.externalAdvOrderId = String(object.externalAdvOrderId);
        if (object.actions) {
          if (!Array.isArray(object.actions))
            throw TypeError(".dnse.fo.CrossOrder.actions: array expected");
          message.actions = [];
          for (let i = 0; i < object.actions.length; ++i)
            message.actions[i] = String(object.actions[i]);
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.buyLoanPackageId != null)
          message.buyLoanPackageId = object.buyLoanPackageId | 0;
        if (object.buyInitialRate != null)
          message.buyInitialRate = Number(object.buyInitialRate);
        if (object.metadata != null)
          message.metadata = String(object.metadata);
        if (object.buyMaker != null)
          message.buyMaker = String(object.buyMaker);
        if (object.buyChannel != null)
          message.buyChannel = String(object.buyChannel);
        return message;
      };
      CrossOrder.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.actions = [];
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.crossType = options.enums === String ? "ONE_FIRM" : 0;
          object.side = "";
          object.investorId = "";
          object.accountNo = "";
          object.symbol = "";
          object.price = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.quantity = options.longs === String ? "0" : 0;
          object.orderStatus = "";
          object.execType = "";
          object.transDate = null;
          object.createdDate = null;
          object.modifiedDate = null;
          object.externalId = "";
          object.error = "";
          object.text = "";
          object.custody = "";
          object.buyAccountNo = "";
          object.buyCustody = "";
          object.buyInvestorId = "";
          object.firmId = "";
          object.traderId = "";
          object.buyFirmId = "";
          object.buyTraderId = "";
          object.clOrdId = "";
          object.origClOrdId = "";
          object.exDestination = "";
          object.maker = "";
          object.channel = "";
          object.feeRate = 0;
          object.taxRate = 0;
          object.buyFeeRate = 0;
          object.buyTaxRate = 0;
          object.externalAdvOrderId = "";
          object.loanPackageId = 0;
          object.buyLoanPackageId = 0;
          object.buyInitialRate = 0;
          object.metadata = "";
          object.buyMaker = "";
          object.buyChannel = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.crossType != null && message.hasOwnProperty("crossType"))
          object.crossType = options.enums === String ? $root.dnse.fo.CrossOrder.CrossType[message.crossType] : message.crossType;
        if (message.side != null && message.hasOwnProperty("side"))
          object.side = message.side;
        if (message.investorId != null && message.hasOwnProperty("investorId"))
          object.investorId = message.investorId;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.price != null && message.hasOwnProperty("price"))
          object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
          if (typeof message.quantity === "number")
            object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
          else
            object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
          object.orderStatus = message.orderStatus;
        if (message.execType != null && message.hasOwnProperty("execType"))
          object.execType = message.execType;
        if (message.transDate != null && message.hasOwnProperty("transDate"))
          object.transDate = $root.google.protobuf.Timestamp.toObject(message.transDate, options);
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.externalId != null && message.hasOwnProperty("externalId"))
          object.externalId = message.externalId;
        if (message.error != null && message.hasOwnProperty("error"))
          object.error = message.error;
        if (message.text != null && message.hasOwnProperty("text"))
          object.text = message.text;
        if (message.custody != null && message.hasOwnProperty("custody"))
          object.custody = message.custody;
        if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo"))
          object.buyAccountNo = message.buyAccountNo;
        if (message.buyCustody != null && message.hasOwnProperty("buyCustody"))
          object.buyCustody = message.buyCustody;
        if (message.buyInvestorId != null && message.hasOwnProperty("buyInvestorId"))
          object.buyInvestorId = message.buyInvestorId;
        if (message.firmId != null && message.hasOwnProperty("firmId"))
          object.firmId = message.firmId;
        if (message.traderId != null && message.hasOwnProperty("traderId"))
          object.traderId = message.traderId;
        if (message.buyFirmId != null && message.hasOwnProperty("buyFirmId"))
          object.buyFirmId = message.buyFirmId;
        if (message.buyTraderId != null && message.hasOwnProperty("buyTraderId"))
          object.buyTraderId = message.buyTraderId;
        if (message.clOrdId != null && message.hasOwnProperty("clOrdId"))
          object.clOrdId = message.clOrdId;
        if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId"))
          object.origClOrdId = message.origClOrdId;
        if (message.exDestination != null && message.hasOwnProperty("exDestination"))
          object.exDestination = message.exDestination;
        if (message.maker != null && message.hasOwnProperty("maker"))
          object.maker = message.maker;
        if (message.channel != null && message.hasOwnProperty("channel"))
          object.channel = message.channel;
        if (message.feeRate != null && message.hasOwnProperty("feeRate"))
          object.feeRate = options.json && !isFinite(message.feeRate) ? String(message.feeRate) : message.feeRate;
        if (message.taxRate != null && message.hasOwnProperty("taxRate"))
          object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
        if (message.buyFeeRate != null && message.hasOwnProperty("buyFeeRate"))
          object.buyFeeRate = options.json && !isFinite(message.buyFeeRate) ? String(message.buyFeeRate) : message.buyFeeRate;
        if (message.buyTaxRate != null && message.hasOwnProperty("buyTaxRate"))
          object.buyTaxRate = options.json && !isFinite(message.buyTaxRate) ? String(message.buyTaxRate) : message.buyTaxRate;
        if (message.externalAdvOrderId != null && message.hasOwnProperty("externalAdvOrderId"))
          object.externalAdvOrderId = message.externalAdvOrderId;
        if (message.actions && message.actions.length) {
          object.actions = [];
          for (let j = 0; j < message.actions.length; ++j)
            object.actions[j] = message.actions[j];
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId"))
          object.buyLoanPackageId = message.buyLoanPackageId;
        if (message.buyInitialRate != null && message.hasOwnProperty("buyInitialRate"))
          object.buyInitialRate = options.json && !isFinite(message.buyInitialRate) ? String(message.buyInitialRate) : message.buyInitialRate;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = message.metadata;
        if (message.buyMaker != null && message.hasOwnProperty("buyMaker"))
          object.buyMaker = message.buyMaker;
        if (message.buyChannel != null && message.hasOwnProperty("buyChannel"))
          object.buyChannel = message.buyChannel;
        return object;
      };
      CrossOrder.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      CrossOrder.CrossType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ONE_FIRM"] = 0;
        values[valuesById[1] = "TWO_FIRM"] = 1;
        return values;
      }();
      return CrossOrder;
    }();
    fo.RoomRuleItem = function() {
      function RoomRuleItem(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      RoomRuleItem.prototype.fromQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      RoomRuleItem.prototype.toQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      RoomRuleItem.prototype.action = 0;
      RoomRuleItem.create = function create(properties) {
        return new RoomRuleItem(properties);
      };
      RoomRuleItem.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.fromQuantity != null && Object.hasOwnProperty.call(message, "fromQuantity"))
          writer.uint32(8).int64(message.fromQuantity);
        if (message.toQuantity != null && Object.hasOwnProperty.call(message, "toQuantity"))
          writer.uint32(16).int64(message.toQuantity);
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
          writer.uint32(24).int32(message.action);
        return writer;
      };
      RoomRuleItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      RoomRuleItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.RoomRuleItem();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.fromQuantity = reader.int64();
              break;
            case 2:
              message.toQuantity = reader.int64();
              break;
            case 3:
              message.action = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      RoomRuleItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      RoomRuleItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.fromQuantity != null && message.hasOwnProperty("fromQuantity")) {
          if (!$util.isInteger(message.fromQuantity) && !(message.fromQuantity && $util.isInteger(message.fromQuantity.low) && $util.isInteger(message.fromQuantity.high)))
            return "fromQuantity: integer|Long expected";
        }
        if (message.toQuantity != null && message.hasOwnProperty("toQuantity")) {
          if (!$util.isInteger(message.toQuantity) && !(message.toQuantity && $util.isInteger(message.toQuantity.low) && $util.isInteger(message.toQuantity.high)))
            return "toQuantity: integer|Long expected";
        }
        if (message.action != null && message.hasOwnProperty("action"))
          switch (message.action) {
            default:
              return "action: enum value expected";
            case 0:
            case 1:
              break;
          }
        return null;
      };
      RoomRuleItem.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.RoomRuleItem)
          return object;
        let message = new $root.dnse.fo.RoomRuleItem();
        if (object.fromQuantity != null) {
          if ($util.Long)
            (message.fromQuantity = $util.Long.fromValue(object.fromQuantity)).unsigned = false;
          else if (typeof object.fromQuantity === "string")
            message.fromQuantity = parseInt(object.fromQuantity, 10);
          else if (typeof object.fromQuantity === "number")
            message.fromQuantity = object.fromQuantity;
          else if (typeof object.fromQuantity === "object")
            message.fromQuantity = new $util.LongBits(object.fromQuantity.low >>> 0, object.fromQuantity.high >>> 0).toNumber();
        }
        if (object.toQuantity != null) {
          if ($util.Long)
            (message.toQuantity = $util.Long.fromValue(object.toQuantity)).unsigned = false;
          else if (typeof object.toQuantity === "string")
            message.toQuantity = parseInt(object.toQuantity, 10);
          else if (typeof object.toQuantity === "number")
            message.toQuantity = object.toQuantity;
          else if (typeof object.toQuantity === "object")
            message.toQuantity = new $util.LongBits(object.toQuantity.low >>> 0, object.toQuantity.high >>> 0).toNumber();
        }
        switch (object.action) {
          case "PASS":
          case 0:
            message.action = 0;
            break;
          case "REJECT":
          case 1:
            message.action = 1;
            break;
        }
        return message;
      };
      RoomRuleItem.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.fromQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.fromQuantity = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.toQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.toQuantity = options.longs === String ? "0" : 0;
          object.action = options.enums === String ? "PASS" : 0;
        }
        if (message.fromQuantity != null && message.hasOwnProperty("fromQuantity"))
          if (typeof message.fromQuantity === "number")
            object.fromQuantity = options.longs === String ? String(message.fromQuantity) : message.fromQuantity;
          else
            object.fromQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fromQuantity) : options.longs === Number ? new $util.LongBits(message.fromQuantity.low >>> 0, message.fromQuantity.high >>> 0).toNumber() : message.fromQuantity;
        if (message.toQuantity != null && message.hasOwnProperty("toQuantity"))
          if (typeof message.toQuantity === "number")
            object.toQuantity = options.longs === String ? String(message.toQuantity) : message.toQuantity;
          else
            object.toQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.toQuantity) : options.longs === Number ? new $util.LongBits(message.toQuantity.low >>> 0, message.toQuantity.high >>> 0).toNumber() : message.toQuantity;
        if (message.action != null && message.hasOwnProperty("action"))
          object.action = options.enums === String ? $root.dnse.fo.RoomRuleItem.Action[message.action] : message.action;
        return object;
      };
      RoomRuleItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      RoomRuleItem.Action = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PASS"] = 0;
        values[valuesById[1] = "REJECT"] = 1;
        return values;
      }();
      return RoomRuleItem;
    }();
    fo.RoomRule = function() {
      function RoomRule(properties) {
        this.rules = [];
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      RoomRule.prototype.source = "";
      RoomRule.prototype.accountNo = "";
      RoomRule.prototype.symbol = "";
      RoomRule.prototype.rules = $util.emptyArray;
      RoomRule.prototype.loanPackageId = 0;
      RoomRule.create = function create(properties) {
        return new RoomRule(properties);
      };
      RoomRule.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
          writer.uint32(10).string(message.source);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
          writer.uint32(26).string(message.symbol);
        if (message.rules != null && message.rules.length)
          for (let i = 0; i < message.rules.length; ++i)
            $root.dnse.fo.RoomRuleItem.encode(message.rules[i], writer.uint32(34).fork()).ldelim();
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(40).int32(message.loanPackageId);
        return writer;
      };
      RoomRule.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      RoomRule.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.RoomRule();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.source = reader.string();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.symbol = reader.string();
              break;
            case 4:
              if (!(message.rules && message.rules.length))
                message.rules = [];
              message.rules.push($root.dnse.fo.RoomRuleItem.decode(reader, reader.uint32()));
              break;
            case 5:
              message.loanPackageId = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      RoomRule.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      RoomRule.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.source != null && message.hasOwnProperty("source")) {
          if (!$util.isString(message.source))
            return "source: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
          if (!$util.isString(message.symbol))
            return "symbol: string expected";
        }
        if (message.rules != null && message.hasOwnProperty("rules")) {
          if (!Array.isArray(message.rules))
            return "rules: array expected";
          for (let i = 0; i < message.rules.length; ++i) {
            let error = $root.dnse.fo.RoomRuleItem.verify(message.rules[i]);
            if (error)
              return "rules." + error;
          }
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        return null;
      };
      RoomRule.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.RoomRule)
          return object;
        let message = new $root.dnse.fo.RoomRule();
        if (object.source != null)
          message.source = String(object.source);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.symbol != null)
          message.symbol = String(object.symbol);
        if (object.rules) {
          if (!Array.isArray(object.rules))
            throw TypeError(".dnse.fo.RoomRule.rules: array expected");
          message.rules = [];
          for (let i = 0; i < object.rules.length; ++i) {
            if (typeof object.rules[i] !== "object")
              throw TypeError(".dnse.fo.RoomRule.rules: object expected");
            message.rules[i] = $root.dnse.fo.RoomRuleItem.fromObject(object.rules[i]);
          }
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        return message;
      };
      RoomRule.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.arrays || options.defaults)
          object.rules = [];
        if (options.defaults) {
          object.source = "";
          object.accountNo = "";
          object.symbol = "";
          object.loanPackageId = 0;
        }
        if (message.source != null && message.hasOwnProperty("source"))
          object.source = message.source;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
          object.symbol = message.symbol;
        if (message.rules && message.rules.length) {
          object.rules = [];
          for (let j = 0; j < message.rules.length; ++j)
            object.rules[j] = $root.dnse.fo.RoomRuleItem.toObject(message.rules[j], options);
        }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        return object;
      };
      RoomRule.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return RoomRule;
    }();
    fo.RoomRuleWrap = function() {
      function RoomRuleWrap(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      RoomRuleWrap.prototype.roomRule = null;
      RoomRuleWrap.prototype.metadata = null;
      RoomRuleWrap.create = function create(properties) {
        return new RoomRuleWrap(properties);
      };
      RoomRuleWrap.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.roomRule != null && Object.hasOwnProperty.call(message, "roomRule"))
          $root.dnse.fo.RoomRule.encode(message.roomRule, writer.uint32(10).fork()).ldelim();
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
          $root.dnse.fo.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      RoomRuleWrap.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      RoomRuleWrap.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.RoomRuleWrap();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.roomRule = $root.dnse.fo.RoomRule.decode(reader, reader.uint32());
              break;
            case 2:
              message.metadata = $root.dnse.fo.Metadata.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      RoomRuleWrap.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      RoomRuleWrap.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.roomRule != null && message.hasOwnProperty("roomRule")) {
          let error = $root.dnse.fo.RoomRule.verify(message.roomRule);
          if (error)
            return "roomRule." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
          let error = $root.dnse.fo.Metadata.verify(message.metadata);
          if (error)
            return "metadata." + error;
        }
        return null;
      };
      RoomRuleWrap.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.RoomRuleWrap)
          return object;
        let message = new $root.dnse.fo.RoomRuleWrap();
        if (object.roomRule != null) {
          if (typeof object.roomRule !== "object")
            throw TypeError(".dnse.fo.RoomRuleWrap.roomRule: object expected");
          message.roomRule = $root.dnse.fo.RoomRule.fromObject(object.roomRule);
        }
        if (object.metadata != null) {
          if (typeof object.metadata !== "object")
            throw TypeError(".dnse.fo.RoomRuleWrap.metadata: object expected");
          message.metadata = $root.dnse.fo.Metadata.fromObject(object.metadata);
        }
        return message;
      };
      RoomRuleWrap.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.roomRule = null;
          object.metadata = null;
        }
        if (message.roomRule != null && message.hasOwnProperty("roomRule"))
          object.roomRule = $root.dnse.fo.RoomRule.toObject(message.roomRule, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
          object.metadata = $root.dnse.fo.Metadata.toObject(message.metadata, options);
        return object;
      };
      RoomRuleWrap.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return RoomRuleWrap;
    }();
    fo.DerivativeLoanTransaction = function() {
      function DerivativeLoanTransaction(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DerivativeLoanTransaction.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      DerivativeLoanTransaction.prototype.accountNo = "";
      DerivativeLoanTransaction.prototype.custodyCode = "";
      DerivativeLoanTransaction.prototype.dtaAccount = "";
      DerivativeLoanTransaction.prototype.type = "";
      DerivativeLoanTransaction.prototype.status = 0;
      DerivativeLoanTransaction.prototype.loanPackageId = 0;
      DerivativeLoanTransaction.prototype.description = "";
      DerivativeLoanTransaction.prototype.referenceId = "";
      DerivativeLoanTransaction.prototype.amount = 0;
      DerivativeLoanTransaction.prototype.data = "";
      DerivativeLoanTransaction.prototype.createdDate = null;
      DerivativeLoanTransaction.prototype.modifiedDate = null;
      DerivativeLoanTransaction.prototype.bizDate = "";
      DerivativeLoanTransaction.create = function create(properties) {
        return new DerivativeLoanTransaction(properties);
      };
      DerivativeLoanTransaction.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).int64(message.id);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(18).string(message.accountNo);
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(26).string(message.custodyCode);
        if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
          writer.uint32(34).string(message.dtaAccount);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(42).string(message.type);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          writer.uint32(48).int32(message.status);
        if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
          writer.uint32(56).int32(message.loanPackageId);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
          writer.uint32(66).string(message.description);
        if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
          writer.uint32(74).string(message.referenceId);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
          writer.uint32(81).double(message.amount);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
          writer.uint32(90).string(message.data);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
        if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
          writer.uint32(114).string(message.bizDate);
        return writer;
      };
      DerivativeLoanTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DerivativeLoanTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.DerivativeLoanTransaction();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.int64();
              break;
            case 2:
              message.accountNo = reader.string();
              break;
            case 3:
              message.custodyCode = reader.string();
              break;
            case 4:
              message.dtaAccount = reader.string();
              break;
            case 5:
              message.type = reader.string();
              break;
            case 6:
              message.status = reader.int32();
              break;
            case 7:
              message.loanPackageId = reader.int32();
              break;
            case 8:
              message.description = reader.string();
              break;
            case 9:
              message.referenceId = reader.string();
              break;
            case 10:
              message.amount = reader.double();
              break;
            case 11:
              message.data = reader.string();
              break;
            case 12:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 13:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 14:
              message.bizDate = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DerivativeLoanTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DerivativeLoanTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
          if (!$util.isString(message.dtaAccount))
            return "dtaAccount: string expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
          if (!$util.isString(message.type))
            return "type: string expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
          switch (message.status) {
            default:
              return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
          if (!$util.isInteger(message.loanPackageId))
            return "loanPackageId: integer expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
          if (!$util.isString(message.description))
            return "description: string expected";
        }
        if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
          if (!$util.isString(message.referenceId))
            return "referenceId: string expected";
        }
        if (message.amount != null && message.hasOwnProperty("amount")) {
          if (typeof message.amount !== "number")
            return "amount: number expected";
        }
        if (message.data != null && message.hasOwnProperty("data")) {
          if (!$util.isString(message.data))
            return "data: string expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
          if (!$util.isString(message.bizDate))
            return "bizDate: string expected";
        }
        return null;
      };
      DerivativeLoanTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.fo.DerivativeLoanTransaction)
          return object;
        let message = new $root.dnse.fo.DerivativeLoanTransaction();
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
        }
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.dtaAccount != null)
          message.dtaAccount = String(object.dtaAccount);
        if (object.type != null)
          message.type = String(object.type);
        switch (object.status) {
          case "STATUS_UNSPECIFIED":
          case 0:
            message.status = 0;
            break;
          case "PENDING":
          case 1:
            message.status = 1;
            break;
          case "SUCCESS":
          case 2:
            message.status = 2;
            break;
          case "FAILURE":
          case 3:
            message.status = 3;
            break;
        }
        if (object.loanPackageId != null)
          message.loanPackageId = object.loanPackageId | 0;
        if (object.description != null)
          message.description = String(object.description);
        if (object.referenceId != null)
          message.referenceId = String(object.referenceId);
        if (object.amount != null)
          message.amount = Number(object.amount);
        if (object.data != null)
          message.data = String(object.data);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanTransaction.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.fo.DerivativeLoanTransaction.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.bizDate != null)
          message.bizDate = String(object.bizDate);
        return message;
      };
      DerivativeLoanTransaction.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
          object.accountNo = "";
          object.custodyCode = "";
          object.dtaAccount = "";
          object.type = "";
          object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          object.loanPackageId = 0;
          object.description = "";
          object.referenceId = "";
          object.amount = 0;
          object.data = "";
          object.createdDate = null;
          object.modifiedDate = null;
          object.bizDate = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
          object.dtaAccount = message.dtaAccount;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = message.type;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = options.enums === String ? $root.dnse.fo.DerivativeLoanTransaction.Status[message.status] : message.status;
        if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
          object.loanPackageId = message.loanPackageId;
        if (message.description != null && message.hasOwnProperty("description"))
          object.description = message.description;
        if (message.referenceId != null && message.hasOwnProperty("referenceId"))
          object.referenceId = message.referenceId;
        if (message.amount != null && message.hasOwnProperty("amount"))
          object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
        if (message.data != null && message.hasOwnProperty("data"))
          object.data = message.data;
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.bizDate != null && message.hasOwnProperty("bizDate"))
          object.bizDate = message.bizDate;
        return object;
      };
      DerivativeLoanTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      DerivativeLoanTransaction.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "SUCCESS"] = 2;
        values[valuesById[3] = "FAILURE"] = 3;
        return values;
      }();
      return DerivativeLoanTransaction;
    }();
    fo.derivatives = function() {
      const derivatives = {};
      derivatives.v1 = function() {
        const v1 = {};
        v1.DepositSecureFromBankFailed = function() {
          function DepositSecureFromBankFailed(properties) {
            if (properties) {
              for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
            }
          }
          DepositSecureFromBankFailed.prototype.accountTypeName = null;
          DepositSecureFromBankFailed.prototype.loanPackageName = "";
          DepositSecureFromBankFailed.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
          DepositSecureFromBankFailed.prototype.createdAt = null;
          DepositSecureFromBankFailed.prototype.investorId = "";
          DepositSecureFromBankFailed.prototype.loanPackageInitialRate = "";
          let $oneOfFields;
          Object.defineProperty(DepositSecureFromBankFailed.prototype, "_accountTypeName", {
            get: $util.oneOfGetter($oneOfFields = ["accountTypeName"]),
            set: $util.oneOfSetter($oneOfFields)
          });
          DepositSecureFromBankFailed.create = function create(properties) {
            return new DepositSecureFromBankFailed(properties);
          };
          DepositSecureFromBankFailed.encode = function encode(message, writer) {
            if (!writer)
              writer = $Writer.create();
            if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
              writer.uint32(10).string(message.accountTypeName);
            if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
              writer.uint32(18).string(message.loanPackageName);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
              writer.uint32(24).int64(message.amount);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
              $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(34).fork()).ldelim();
            if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
              writer.uint32(42).string(message.investorId);
            if (message.loanPackageInitialRate != null && Object.hasOwnProperty.call(message, "loanPackageInitialRate"))
              writer.uint32(50).string(message.loanPackageInitialRate);
            return writer;
          };
          DepositSecureFromBankFailed.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
          };
          DepositSecureFromBankFailed.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
              reader = $Reader.create(reader);
            let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.derivatives.v1.DepositSecureFromBankFailed();
            while (reader.pos < end) {
              let tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.accountTypeName = reader.string();
                  break;
                case 2:
                  message.loanPackageName = reader.string();
                  break;
                case 3:
                  message.amount = reader.int64();
                  break;
                case 4:
                  message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                  break;
                case 5:
                  message.investorId = reader.string();
                  break;
                case 6:
                  message.loanPackageInitialRate = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };
          DepositSecureFromBankFailed.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
              reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
          };
          DepositSecureFromBankFailed.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
              return "object expected";
            if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
              if (!$util.isString(message.accountTypeName))
                return "accountTypeName: string expected";
            }
            if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
              if (!$util.isString(message.loanPackageName))
                return "loanPackageName: string expected";
            }
            if (message.amount != null && message.hasOwnProperty("amount")) {
              if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            }
            if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
              let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
              if (error)
                return "createdAt." + error;
            }
            if (message.investorId != null && message.hasOwnProperty("investorId")) {
              if (!$util.isString(message.investorId))
                return "investorId: string expected";
            }
            if (message.loanPackageInitialRate != null && message.hasOwnProperty("loanPackageInitialRate")) {
              if (!$util.isString(message.loanPackageInitialRate))
                return "loanPackageInitialRate: string expected";
            }
            return null;
          };
          DepositSecureFromBankFailed.fromObject = function fromObject(object) {
            if (object instanceof $root.dnse.fo.derivatives.v1.DepositSecureFromBankFailed)
              return object;
            let message = new $root.dnse.fo.derivatives.v1.DepositSecureFromBankFailed();
            if (object.accountTypeName != null)
              message.accountTypeName = String(object.accountTypeName);
            if (object.loanPackageName != null)
              message.loanPackageName = String(object.loanPackageName);
            if (object.amount != null) {
              if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
              else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
              else if (typeof object.amount === "number")
                message.amount = object.amount;
              else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            }
            if (object.createdAt != null) {
              if (typeof object.createdAt !== "object")
                throw TypeError(".dnse.fo.derivatives.v1.DepositSecureFromBankFailed.createdAt: object expected");
              message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
            }
            if (object.investorId != null)
              message.investorId = String(object.investorId);
            if (object.loanPackageInitialRate != null)
              message.loanPackageInitialRate = String(object.loanPackageInitialRate);
            return message;
          };
          DepositSecureFromBankFailed.toObject = function toObject(message, options) {
            if (!options)
              options = {};
            let object = {};
            if (options.defaults) {
              object.loanPackageName = "";
              if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
              } else
                object.amount = options.longs === String ? "0" : 0;
              object.createdAt = null;
              object.investorId = "";
              object.loanPackageInitialRate = "";
            }
            if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
              object.accountTypeName = message.accountTypeName;
              if (options.oneofs)
                object._accountTypeName = "accountTypeName";
            }
            if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
              object.loanPackageName = message.loanPackageName;
            if (message.amount != null && message.hasOwnProperty("amount"))
              if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
              else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
              object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
            if (message.investorId != null && message.hasOwnProperty("investorId"))
              object.investorId = message.investorId;
            if (message.loanPackageInitialRate != null && message.hasOwnProperty("loanPackageInitialRate"))
              object.loanPackageInitialRate = message.loanPackageInitialRate;
            return object;
          };
          DepositSecureFromBankFailed.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
          };
          return DepositSecureFromBankFailed;
        }();
        v1.DerivativeTransaction = function() {
          function DerivativeTransaction(properties) {
            if (properties) {
              for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
            }
          }
          DerivativeTransaction.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
          DerivativeTransaction.prototype.accountNo = "";
          DerivativeTransaction.prototype.type = "";
          DerivativeTransaction.prototype.status = "";
          DerivativeTransaction.prototype.description = "";
          DerivativeTransaction.prototype.error = "";
          DerivativeTransaction.prototype.actor = "";
          DerivativeTransaction.prototype.referenceId = "";
          DerivativeTransaction.prototype.createdDate = null;
          DerivativeTransaction.prototype.modifiedDate = null;
          DerivativeTransaction.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
          DerivativeTransaction.prototype.data = "";
          DerivativeTransaction.create = function create(properties) {
            return new DerivativeTransaction(properties);
          };
          DerivativeTransaction.encode = function encode(message, writer) {
            if (!writer)
              writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(8).int64(message.id);
            if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
              writer.uint32(18).string(message.accountNo);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
              writer.uint32(26).string(message.type);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
              writer.uint32(34).string(message.status);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
              writer.uint32(42).string(message.description);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
              writer.uint32(50).string(message.error);
            if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
              writer.uint32(58).string(message.actor);
            if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
              writer.uint32(66).string(message.referenceId);
            if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
              $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
            if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
              $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(82).fork()).ldelim();
            if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
              writer.uint32(88).int64(message.loanPackageId);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
              writer.uint32(98).string(message.data);
            return writer;
          };
          DerivativeTransaction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
          };
          DerivativeTransaction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
              reader = $Reader.create(reader);
            let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.fo.derivatives.v1.DerivativeTransaction();
            while (reader.pos < end) {
              let tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.int64();
                  break;
                case 2:
                  message.accountNo = reader.string();
                  break;
                case 3:
                  message.type = reader.string();
                  break;
                case 4:
                  message.status = reader.string();
                  break;
                case 5:
                  message.description = reader.string();
                  break;
                case 6:
                  message.error = reader.string();
                  break;
                case 7:
                  message.actor = reader.string();
                  break;
                case 8:
                  message.referenceId = reader.string();
                  break;
                case 9:
                  message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                  break;
                case 10:
                  message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                  break;
                case 11:
                  message.loanPackageId = reader.int64();
                  break;
                case 12:
                  message.data = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };
          DerivativeTransaction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
              reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
          };
          DerivativeTransaction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
              return "object expected";
            if (message.id != null && message.hasOwnProperty("id")) {
              if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                return "id: integer|Long expected";
            }
            if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
              if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
            }
            if (message.type != null && message.hasOwnProperty("type")) {
              if (!$util.isString(message.type))
                return "type: string expected";
            }
            if (message.status != null && message.hasOwnProperty("status")) {
              if (!$util.isString(message.status))
                return "status: string expected";
            }
            if (message.description != null && message.hasOwnProperty("description")) {
              if (!$util.isString(message.description))
                return "description: string expected";
            }
            if (message.error != null && message.hasOwnProperty("error")) {
              if (!$util.isString(message.error))
                return "error: string expected";
            }
            if (message.actor != null && message.hasOwnProperty("actor")) {
              if (!$util.isString(message.actor))
                return "actor: string expected";
            }
            if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
              if (!$util.isString(message.referenceId))
                return "referenceId: string expected";
            }
            if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
              let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
              if (error)
                return "createdDate." + error;
            }
            if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
              let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
              if (error)
                return "modifiedDate." + error;
            }
            if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
              if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
                return "loanPackageId: integer|Long expected";
            }
            if (message.data != null && message.hasOwnProperty("data")) {
              if (!$util.isString(message.data))
                return "data: string expected";
            }
            return null;
          };
          DerivativeTransaction.fromObject = function fromObject(object) {
            if (object instanceof $root.dnse.fo.derivatives.v1.DerivativeTransaction)
              return object;
            let message = new $root.dnse.fo.derivatives.v1.DerivativeTransaction();
            if (object.id != null) {
              if ($util.Long)
                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
              else if (typeof object.id === "string")
                message.id = parseInt(object.id, 10);
              else if (typeof object.id === "number")
                message.id = object.id;
              else if (typeof object.id === "object")
                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            }
            if (object.accountNo != null)
              message.accountNo = String(object.accountNo);
            if (object.type != null)
              message.type = String(object.type);
            if (object.status != null)
              message.status = String(object.status);
            if (object.description != null)
              message.description = String(object.description);
            if (object.error != null)
              message.error = String(object.error);
            if (object.actor != null)
              message.actor = String(object.actor);
            if (object.referenceId != null)
              message.referenceId = String(object.referenceId);
            if (object.createdDate != null) {
              if (typeof object.createdDate !== "object")
                throw TypeError(".dnse.fo.derivatives.v1.DerivativeTransaction.createdDate: object expected");
              message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
            }
            if (object.modifiedDate != null) {
              if (typeof object.modifiedDate !== "object")
                throw TypeError(".dnse.fo.derivatives.v1.DerivativeTransaction.modifiedDate: object expected");
              message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
            }
            if (object.loanPackageId != null) {
              if ($util.Long)
                (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
              else if (typeof object.loanPackageId === "string")
                message.loanPackageId = parseInt(object.loanPackageId, 10);
              else if (typeof object.loanPackageId === "number")
                message.loanPackageId = object.loanPackageId;
              else if (typeof object.loanPackageId === "object")
                message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
            }
            if (object.data != null)
              message.data = String(object.data);
            return message;
          };
          DerivativeTransaction.toObject = function toObject(message, options) {
            if (!options)
              options = {};
            let object = {};
            if (options.defaults) {
              if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
              } else
                object.id = options.longs === String ? "0" : 0;
              object.accountNo = "";
              object.type = "";
              object.status = "";
              object.description = "";
              object.error = "";
              object.actor = "";
              object.referenceId = "";
              object.createdDate = null;
              object.modifiedDate = null;
              if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
              } else
                object.loanPackageId = options.longs === String ? "0" : 0;
              object.data = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              if (typeof message.id === "number")
                object.id = options.longs === String ? String(message.id) : message.id;
              else
                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.accountNo != null && message.hasOwnProperty("accountNo"))
              object.accountNo = message.accountNo;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type = message.type;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status = message.status;
            if (message.description != null && message.hasOwnProperty("description"))
              object.description = message.description;
            if (message.error != null && message.hasOwnProperty("error"))
              object.error = message.error;
            if (message.actor != null && message.hasOwnProperty("actor"))
              object.actor = message.actor;
            if (message.referenceId != null && message.hasOwnProperty("referenceId"))
              object.referenceId = message.referenceId;
            if (message.createdDate != null && message.hasOwnProperty("createdDate"))
              object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
            if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
              object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
            if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
              if (typeof message.loanPackageId === "number")
                object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
              else
                object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
            if (message.data != null && message.hasOwnProperty("data"))
              object.data = message.data;
            return object;
          };
          DerivativeTransaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
          };
          return DerivativeTransaction;
        }();
        return v1;
      }();
      return derivatives;
    }();
    return fo;
  }();
  dnse2.broker = function() {
    const broker = {};
    broker.v1 = function() {
      const v1 = {};
      v1.Wrapper = function() {
        function Wrapper(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Wrapper.prototype.user = null;
        Wrapper.prototype.groupUser = null;
        Wrapper.prototype.tlGroupUser = null;
        Wrapper.prototype.careByCustody = null;
        Wrapper.prototype.careByAccountNo = null;
        Wrapper.prototype.userResp = null;
        Wrapper.prototype.groupUserResp = null;
        Wrapper.prototype.tlGroupUserResp = null;
        Wrapper.prototype.careByCustodyResp = null;
        Wrapper.prototype.careByAccountNoResp = null;
        Wrapper.prototype.newBrokerCreated = null;
        Wrapper.prototype.brokerOperationRequest = null;
        Wrapper.prototype.careByCustomerResp = null;
        Wrapper.prototype.notifyBrokerReferral = null;
        Wrapper.prototype.careByRequestAcceptedByBroker = null;
        Wrapper.prototype.careByRequestAcceptedByCustomer = null;
        Wrapper.prototype.brokerMargin = null;
        Wrapper.prototype.careByContract = null;
        Wrapper.prototype.brokerContract = null;
        Wrapper.prototype.financingOfferLoanPackageRequest = null;
        let $oneOfFields;
        Object.defineProperty(Wrapper.prototype, "kind", {
          get: $util.oneOfGetter($oneOfFields = ["user", "groupUser", "tlGroupUser", "careByCustody", "careByAccountNo", "userResp", "groupUserResp", "tlGroupUserResp", "careByCustodyResp", "careByAccountNoResp", "newBrokerCreated", "brokerOperationRequest", "careByCustomerResp", "notifyBrokerReferral", "careByRequestAcceptedByBroker", "careByRequestAcceptedByCustomer", "brokerMargin", "careByContract", "brokerContract", "financingOfferLoanPackageRequest"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Wrapper.create = function create(properties) {
          return new Wrapper(properties);
        };
        Wrapper.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.user != null && Object.hasOwnProperty.call(message, "user"))
            $root.dnse.broker.v1.User.encode(message.user, writer.uint32(10).fork()).ldelim();
          if (message.groupUser != null && Object.hasOwnProperty.call(message, "groupUser"))
            $root.dnse.broker.v1.GroupUser.encode(message.groupUser, writer.uint32(18).fork()).ldelim();
          if (message.tlGroupUser != null && Object.hasOwnProperty.call(message, "tlGroupUser"))
            $root.dnse.broker.v1.TlGroupUser.encode(message.tlGroupUser, writer.uint32(26).fork()).ldelim();
          if (message.careByCustody != null && Object.hasOwnProperty.call(message, "careByCustody"))
            $root.dnse.broker.v1.CareByCustody.encode(message.careByCustody, writer.uint32(34).fork()).ldelim();
          if (message.careByAccountNo != null && Object.hasOwnProperty.call(message, "careByAccountNo"))
            $root.dnse.broker.v1.CareByAccountNo.encode(message.careByAccountNo, writer.uint32(42).fork()).ldelim();
          if (message.userResp != null && Object.hasOwnProperty.call(message, "userResp"))
            $root.dnse.broker.v1.UserResp.encode(message.userResp, writer.uint32(50).fork()).ldelim();
          if (message.groupUserResp != null && Object.hasOwnProperty.call(message, "groupUserResp"))
            $root.dnse.broker.v1.GroupUserResp.encode(message.groupUserResp, writer.uint32(58).fork()).ldelim();
          if (message.tlGroupUserResp != null && Object.hasOwnProperty.call(message, "tlGroupUserResp"))
            $root.dnse.broker.v1.TlGroupUserResp.encode(message.tlGroupUserResp, writer.uint32(66).fork()).ldelim();
          if (message.careByCustodyResp != null && Object.hasOwnProperty.call(message, "careByCustodyResp"))
            $root.dnse.broker.v1.CareByCustodyResp.encode(message.careByCustodyResp, writer.uint32(74).fork()).ldelim();
          if (message.careByAccountNoResp != null && Object.hasOwnProperty.call(message, "careByAccountNoResp"))
            $root.dnse.broker.v1.CareByAccountNoResp.encode(message.careByAccountNoResp, writer.uint32(82).fork()).ldelim();
          if (message.newBrokerCreated != null && Object.hasOwnProperty.call(message, "newBrokerCreated"))
            $root.dnse.broker.v1.NewBrokerCreated.encode(message.newBrokerCreated, writer.uint32(90).fork()).ldelim();
          if (message.brokerOperationRequest != null && Object.hasOwnProperty.call(message, "brokerOperationRequest"))
            $root.dnse.broker.v1.BrokerOperationRequest.encode(message.brokerOperationRequest, writer.uint32(98).fork()).ldelim();
          if (message.careByCustomerResp != null && Object.hasOwnProperty.call(message, "careByCustomerResp"))
            $root.dnse.broker.v1.CareByCustomerResp.encode(message.careByCustomerResp, writer.uint32(106).fork()).ldelim();
          if (message.notifyBrokerReferral != null && Object.hasOwnProperty.call(message, "notifyBrokerReferral"))
            $root.dnse.broker.v1.NotifyBrokerReferral.encode(message.notifyBrokerReferral, writer.uint32(114).fork()).ldelim();
          if (message.careByRequestAcceptedByBroker != null && Object.hasOwnProperty.call(message, "careByRequestAcceptedByBroker"))
            $root.dnse.broker.v1.CareByRequestAcceptedByBroker.encode(message.careByRequestAcceptedByBroker, writer.uint32(122).fork()).ldelim();
          if (message.careByRequestAcceptedByCustomer != null && Object.hasOwnProperty.call(message, "careByRequestAcceptedByCustomer"))
            $root.dnse.broker.v1.CareByRequestAcceptedByCustomer.encode(message.careByRequestAcceptedByCustomer, writer.uint32(130).fork()).ldelim();
          if (message.brokerMargin != null && Object.hasOwnProperty.call(message, "brokerMargin"))
            $root.dnse.broker.v1.BrokerMargin.encode(message.brokerMargin, writer.uint32(138).fork()).ldelim();
          if (message.careByContract != null && Object.hasOwnProperty.call(message, "careByContract"))
            $root.dnse.broker.v1.CareByContract.encode(message.careByContract, writer.uint32(146).fork()).ldelim();
          if (message.brokerContract != null && Object.hasOwnProperty.call(message, "brokerContract"))
            $root.dnse.broker.v1.BrokerContract.encode(message.brokerContract, writer.uint32(154).fork()).ldelim();
          if (message.financingOfferLoanPackageRequest != null && Object.hasOwnProperty.call(message, "financingOfferLoanPackageRequest"))
            $root.dnse.broker.v1.FinancingOfferLoanPackageRequest.encode(message.financingOfferLoanPackageRequest, writer.uint32(162).fork()).ldelim();
          return writer;
        };
        Wrapper.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Wrapper.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.Wrapper();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.user = $root.dnse.broker.v1.User.decode(reader, reader.uint32());
                break;
              case 2:
                message.groupUser = $root.dnse.broker.v1.GroupUser.decode(reader, reader.uint32());
                break;
              case 3:
                message.tlGroupUser = $root.dnse.broker.v1.TlGroupUser.decode(reader, reader.uint32());
                break;
              case 4:
                message.careByCustody = $root.dnse.broker.v1.CareByCustody.decode(reader, reader.uint32());
                break;
              case 5:
                message.careByAccountNo = $root.dnse.broker.v1.CareByAccountNo.decode(reader, reader.uint32());
                break;
              case 6:
                message.userResp = $root.dnse.broker.v1.UserResp.decode(reader, reader.uint32());
                break;
              case 7:
                message.groupUserResp = $root.dnse.broker.v1.GroupUserResp.decode(reader, reader.uint32());
                break;
              case 8:
                message.tlGroupUserResp = $root.dnse.broker.v1.TlGroupUserResp.decode(reader, reader.uint32());
                break;
              case 9:
                message.careByCustodyResp = $root.dnse.broker.v1.CareByCustodyResp.decode(reader, reader.uint32());
                break;
              case 10:
                message.careByAccountNoResp = $root.dnse.broker.v1.CareByAccountNoResp.decode(reader, reader.uint32());
                break;
              case 11:
                message.newBrokerCreated = $root.dnse.broker.v1.NewBrokerCreated.decode(reader, reader.uint32());
                break;
              case 12:
                message.brokerOperationRequest = $root.dnse.broker.v1.BrokerOperationRequest.decode(reader, reader.uint32());
                break;
              case 13:
                message.careByCustomerResp = $root.dnse.broker.v1.CareByCustomerResp.decode(reader, reader.uint32());
                break;
              case 14:
                message.notifyBrokerReferral = $root.dnse.broker.v1.NotifyBrokerReferral.decode(reader, reader.uint32());
                break;
              case 15:
                message.careByRequestAcceptedByBroker = $root.dnse.broker.v1.CareByRequestAcceptedByBroker.decode(reader, reader.uint32());
                break;
              case 16:
                message.careByRequestAcceptedByCustomer = $root.dnse.broker.v1.CareByRequestAcceptedByCustomer.decode(reader, reader.uint32());
                break;
              case 17:
                message.brokerMargin = $root.dnse.broker.v1.BrokerMargin.decode(reader, reader.uint32());
                break;
              case 18:
                message.careByContract = $root.dnse.broker.v1.CareByContract.decode(reader, reader.uint32());
                break;
              case 19:
                message.brokerContract = $root.dnse.broker.v1.BrokerContract.decode(reader, reader.uint32());
                break;
              case 20:
                message.financingOfferLoanPackageRequest = $root.dnse.broker.v1.FinancingOfferLoanPackageRequest.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Wrapper.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Wrapper.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          let properties = {};
          if (message.user != null && message.hasOwnProperty("user")) {
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.User.verify(message.user);
              if (error)
                return "user." + error;
            }
          }
          if (message.groupUser != null && message.hasOwnProperty("groupUser")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.GroupUser.verify(message.groupUser);
              if (error)
                return "groupUser." + error;
            }
          }
          if (message.tlGroupUser != null && message.hasOwnProperty("tlGroupUser")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.TlGroupUser.verify(message.tlGroupUser);
              if (error)
                return "tlGroupUser." + error;
            }
          }
          if (message.careByCustody != null && message.hasOwnProperty("careByCustody")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByCustody.verify(message.careByCustody);
              if (error)
                return "careByCustody." + error;
            }
          }
          if (message.careByAccountNo != null && message.hasOwnProperty("careByAccountNo")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByAccountNo.verify(message.careByAccountNo);
              if (error)
                return "careByAccountNo." + error;
            }
          }
          if (message.userResp != null && message.hasOwnProperty("userResp")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.UserResp.verify(message.userResp);
              if (error)
                return "userResp." + error;
            }
          }
          if (message.groupUserResp != null && message.hasOwnProperty("groupUserResp")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.GroupUserResp.verify(message.groupUserResp);
              if (error)
                return "groupUserResp." + error;
            }
          }
          if (message.tlGroupUserResp != null && message.hasOwnProperty("tlGroupUserResp")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.TlGroupUserResp.verify(message.tlGroupUserResp);
              if (error)
                return "tlGroupUserResp." + error;
            }
          }
          if (message.careByCustodyResp != null && message.hasOwnProperty("careByCustodyResp")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByCustodyResp.verify(message.careByCustodyResp);
              if (error)
                return "careByCustodyResp." + error;
            }
          }
          if (message.careByAccountNoResp != null && message.hasOwnProperty("careByAccountNoResp")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByAccountNoResp.verify(message.careByAccountNoResp);
              if (error)
                return "careByAccountNoResp." + error;
            }
          }
          if (message.newBrokerCreated != null && message.hasOwnProperty("newBrokerCreated")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.NewBrokerCreated.verify(message.newBrokerCreated);
              if (error)
                return "newBrokerCreated." + error;
            }
          }
          if (message.brokerOperationRequest != null && message.hasOwnProperty("brokerOperationRequest")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.BrokerOperationRequest.verify(message.brokerOperationRequest);
              if (error)
                return "brokerOperationRequest." + error;
            }
          }
          if (message.careByCustomerResp != null && message.hasOwnProperty("careByCustomerResp")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByCustomerResp.verify(message.careByCustomerResp);
              if (error)
                return "careByCustomerResp." + error;
            }
          }
          if (message.notifyBrokerReferral != null && message.hasOwnProperty("notifyBrokerReferral")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.NotifyBrokerReferral.verify(message.notifyBrokerReferral);
              if (error)
                return "notifyBrokerReferral." + error;
            }
          }
          if (message.careByRequestAcceptedByBroker != null && message.hasOwnProperty("careByRequestAcceptedByBroker")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByRequestAcceptedByBroker.verify(message.careByRequestAcceptedByBroker);
              if (error)
                return "careByRequestAcceptedByBroker." + error;
            }
          }
          if (message.careByRequestAcceptedByCustomer != null && message.hasOwnProperty("careByRequestAcceptedByCustomer")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByRequestAcceptedByCustomer.verify(message.careByRequestAcceptedByCustomer);
              if (error)
                return "careByRequestAcceptedByCustomer." + error;
            }
          }
          if (message.brokerMargin != null && message.hasOwnProperty("brokerMargin")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.BrokerMargin.verify(message.brokerMargin);
              if (error)
                return "brokerMargin." + error;
            }
          }
          if (message.careByContract != null && message.hasOwnProperty("careByContract")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.CareByContract.verify(message.careByContract);
              if (error)
                return "careByContract." + error;
            }
          }
          if (message.brokerContract != null && message.hasOwnProperty("brokerContract")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.BrokerContract.verify(message.brokerContract);
              if (error)
                return "brokerContract." + error;
            }
          }
          if (message.financingOfferLoanPackageRequest != null && message.hasOwnProperty("financingOfferLoanPackageRequest")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.broker.v1.FinancingOfferLoanPackageRequest.verify(message.financingOfferLoanPackageRequest);
              if (error)
                return "financingOfferLoanPackageRequest." + error;
            }
          }
          return null;
        };
        Wrapper.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.Wrapper)
            return object;
          let message = new $root.dnse.broker.v1.Wrapper();
          if (object.user != null) {
            if (typeof object.user !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.user: object expected");
            message.user = $root.dnse.broker.v1.User.fromObject(object.user);
          }
          if (object.groupUser != null) {
            if (typeof object.groupUser !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.groupUser: object expected");
            message.groupUser = $root.dnse.broker.v1.GroupUser.fromObject(object.groupUser);
          }
          if (object.tlGroupUser != null) {
            if (typeof object.tlGroupUser !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.tlGroupUser: object expected");
            message.tlGroupUser = $root.dnse.broker.v1.TlGroupUser.fromObject(object.tlGroupUser);
          }
          if (object.careByCustody != null) {
            if (typeof object.careByCustody !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByCustody: object expected");
            message.careByCustody = $root.dnse.broker.v1.CareByCustody.fromObject(object.careByCustody);
          }
          if (object.careByAccountNo != null) {
            if (typeof object.careByAccountNo !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByAccountNo: object expected");
            message.careByAccountNo = $root.dnse.broker.v1.CareByAccountNo.fromObject(object.careByAccountNo);
          }
          if (object.userResp != null) {
            if (typeof object.userResp !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.userResp: object expected");
            message.userResp = $root.dnse.broker.v1.UserResp.fromObject(object.userResp);
          }
          if (object.groupUserResp != null) {
            if (typeof object.groupUserResp !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.groupUserResp: object expected");
            message.groupUserResp = $root.dnse.broker.v1.GroupUserResp.fromObject(object.groupUserResp);
          }
          if (object.tlGroupUserResp != null) {
            if (typeof object.tlGroupUserResp !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.tlGroupUserResp: object expected");
            message.tlGroupUserResp = $root.dnse.broker.v1.TlGroupUserResp.fromObject(object.tlGroupUserResp);
          }
          if (object.careByCustodyResp != null) {
            if (typeof object.careByCustodyResp !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByCustodyResp: object expected");
            message.careByCustodyResp = $root.dnse.broker.v1.CareByCustodyResp.fromObject(object.careByCustodyResp);
          }
          if (object.careByAccountNoResp != null) {
            if (typeof object.careByAccountNoResp !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByAccountNoResp: object expected");
            message.careByAccountNoResp = $root.dnse.broker.v1.CareByAccountNoResp.fromObject(object.careByAccountNoResp);
          }
          if (object.newBrokerCreated != null) {
            if (typeof object.newBrokerCreated !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.newBrokerCreated: object expected");
            message.newBrokerCreated = $root.dnse.broker.v1.NewBrokerCreated.fromObject(object.newBrokerCreated);
          }
          if (object.brokerOperationRequest != null) {
            if (typeof object.brokerOperationRequest !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.brokerOperationRequest: object expected");
            message.brokerOperationRequest = $root.dnse.broker.v1.BrokerOperationRequest.fromObject(object.brokerOperationRequest);
          }
          if (object.careByCustomerResp != null) {
            if (typeof object.careByCustomerResp !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByCustomerResp: object expected");
            message.careByCustomerResp = $root.dnse.broker.v1.CareByCustomerResp.fromObject(object.careByCustomerResp);
          }
          if (object.notifyBrokerReferral != null) {
            if (typeof object.notifyBrokerReferral !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.notifyBrokerReferral: object expected");
            message.notifyBrokerReferral = $root.dnse.broker.v1.NotifyBrokerReferral.fromObject(object.notifyBrokerReferral);
          }
          if (object.careByRequestAcceptedByBroker != null) {
            if (typeof object.careByRequestAcceptedByBroker !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByRequestAcceptedByBroker: object expected");
            message.careByRequestAcceptedByBroker = $root.dnse.broker.v1.CareByRequestAcceptedByBroker.fromObject(object.careByRequestAcceptedByBroker);
          }
          if (object.careByRequestAcceptedByCustomer != null) {
            if (typeof object.careByRequestAcceptedByCustomer !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByRequestAcceptedByCustomer: object expected");
            message.careByRequestAcceptedByCustomer = $root.dnse.broker.v1.CareByRequestAcceptedByCustomer.fromObject(object.careByRequestAcceptedByCustomer);
          }
          if (object.brokerMargin != null) {
            if (typeof object.brokerMargin !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.brokerMargin: object expected");
            message.brokerMargin = $root.dnse.broker.v1.BrokerMargin.fromObject(object.brokerMargin);
          }
          if (object.careByContract != null) {
            if (typeof object.careByContract !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.careByContract: object expected");
            message.careByContract = $root.dnse.broker.v1.CareByContract.fromObject(object.careByContract);
          }
          if (object.brokerContract != null) {
            if (typeof object.brokerContract !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.brokerContract: object expected");
            message.brokerContract = $root.dnse.broker.v1.BrokerContract.fromObject(object.brokerContract);
          }
          if (object.financingOfferLoanPackageRequest != null) {
            if (typeof object.financingOfferLoanPackageRequest !== "object")
              throw TypeError(".dnse.broker.v1.Wrapper.financingOfferLoanPackageRequest: object expected");
            message.financingOfferLoanPackageRequest = $root.dnse.broker.v1.FinancingOfferLoanPackageRequest.fromObject(object.financingOfferLoanPackageRequest);
          }
          return message;
        };
        Wrapper.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (message.user != null && message.hasOwnProperty("user")) {
            object.user = $root.dnse.broker.v1.User.toObject(message.user, options);
            if (options.oneofs)
              object.kind = "user";
          }
          if (message.groupUser != null && message.hasOwnProperty("groupUser")) {
            object.groupUser = $root.dnse.broker.v1.GroupUser.toObject(message.groupUser, options);
            if (options.oneofs)
              object.kind = "groupUser";
          }
          if (message.tlGroupUser != null && message.hasOwnProperty("tlGroupUser")) {
            object.tlGroupUser = $root.dnse.broker.v1.TlGroupUser.toObject(message.tlGroupUser, options);
            if (options.oneofs)
              object.kind = "tlGroupUser";
          }
          if (message.careByCustody != null && message.hasOwnProperty("careByCustody")) {
            object.careByCustody = $root.dnse.broker.v1.CareByCustody.toObject(message.careByCustody, options);
            if (options.oneofs)
              object.kind = "careByCustody";
          }
          if (message.careByAccountNo != null && message.hasOwnProperty("careByAccountNo")) {
            object.careByAccountNo = $root.dnse.broker.v1.CareByAccountNo.toObject(message.careByAccountNo, options);
            if (options.oneofs)
              object.kind = "careByAccountNo";
          }
          if (message.userResp != null && message.hasOwnProperty("userResp")) {
            object.userResp = $root.dnse.broker.v1.UserResp.toObject(message.userResp, options);
            if (options.oneofs)
              object.kind = "userResp";
          }
          if (message.groupUserResp != null && message.hasOwnProperty("groupUserResp")) {
            object.groupUserResp = $root.dnse.broker.v1.GroupUserResp.toObject(message.groupUserResp, options);
            if (options.oneofs)
              object.kind = "groupUserResp";
          }
          if (message.tlGroupUserResp != null && message.hasOwnProperty("tlGroupUserResp")) {
            object.tlGroupUserResp = $root.dnse.broker.v1.TlGroupUserResp.toObject(message.tlGroupUserResp, options);
            if (options.oneofs)
              object.kind = "tlGroupUserResp";
          }
          if (message.careByCustodyResp != null && message.hasOwnProperty("careByCustodyResp")) {
            object.careByCustodyResp = $root.dnse.broker.v1.CareByCustodyResp.toObject(message.careByCustodyResp, options);
            if (options.oneofs)
              object.kind = "careByCustodyResp";
          }
          if (message.careByAccountNoResp != null && message.hasOwnProperty("careByAccountNoResp")) {
            object.careByAccountNoResp = $root.dnse.broker.v1.CareByAccountNoResp.toObject(message.careByAccountNoResp, options);
            if (options.oneofs)
              object.kind = "careByAccountNoResp";
          }
          if (message.newBrokerCreated != null && message.hasOwnProperty("newBrokerCreated")) {
            object.newBrokerCreated = $root.dnse.broker.v1.NewBrokerCreated.toObject(message.newBrokerCreated, options);
            if (options.oneofs)
              object.kind = "newBrokerCreated";
          }
          if (message.brokerOperationRequest != null && message.hasOwnProperty("brokerOperationRequest")) {
            object.brokerOperationRequest = $root.dnse.broker.v1.BrokerOperationRequest.toObject(message.brokerOperationRequest, options);
            if (options.oneofs)
              object.kind = "brokerOperationRequest";
          }
          if (message.careByCustomerResp != null && message.hasOwnProperty("careByCustomerResp")) {
            object.careByCustomerResp = $root.dnse.broker.v1.CareByCustomerResp.toObject(message.careByCustomerResp, options);
            if (options.oneofs)
              object.kind = "careByCustomerResp";
          }
          if (message.notifyBrokerReferral != null && message.hasOwnProperty("notifyBrokerReferral")) {
            object.notifyBrokerReferral = $root.dnse.broker.v1.NotifyBrokerReferral.toObject(message.notifyBrokerReferral, options);
            if (options.oneofs)
              object.kind = "notifyBrokerReferral";
          }
          if (message.careByRequestAcceptedByBroker != null && message.hasOwnProperty("careByRequestAcceptedByBroker")) {
            object.careByRequestAcceptedByBroker = $root.dnse.broker.v1.CareByRequestAcceptedByBroker.toObject(message.careByRequestAcceptedByBroker, options);
            if (options.oneofs)
              object.kind = "careByRequestAcceptedByBroker";
          }
          if (message.careByRequestAcceptedByCustomer != null && message.hasOwnProperty("careByRequestAcceptedByCustomer")) {
            object.careByRequestAcceptedByCustomer = $root.dnse.broker.v1.CareByRequestAcceptedByCustomer.toObject(message.careByRequestAcceptedByCustomer, options);
            if (options.oneofs)
              object.kind = "careByRequestAcceptedByCustomer";
          }
          if (message.brokerMargin != null && message.hasOwnProperty("brokerMargin")) {
            object.brokerMargin = $root.dnse.broker.v1.BrokerMargin.toObject(message.brokerMargin, options);
            if (options.oneofs)
              object.kind = "brokerMargin";
          }
          if (message.careByContract != null && message.hasOwnProperty("careByContract")) {
            object.careByContract = $root.dnse.broker.v1.CareByContract.toObject(message.careByContract, options);
            if (options.oneofs)
              object.kind = "careByContract";
          }
          if (message.brokerContract != null && message.hasOwnProperty("brokerContract")) {
            object.brokerContract = $root.dnse.broker.v1.BrokerContract.toObject(message.brokerContract, options);
            if (options.oneofs)
              object.kind = "brokerContract";
          }
          if (message.financingOfferLoanPackageRequest != null && message.hasOwnProperty("financingOfferLoanPackageRequest")) {
            object.financingOfferLoanPackageRequest = $root.dnse.broker.v1.FinancingOfferLoanPackageRequest.toObject(message.financingOfferLoanPackageRequest, options);
            if (options.oneofs)
              object.kind = "financingOfferLoanPackageRequest";
          }
          return object;
        };
        Wrapper.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return Wrapper;
      }();
      v1.Status = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "STATUS_SUCCESS"] = 1;
        values[valuesById[2] = "STATUS_FAILED"] = 2;
        values[valuesById[3] = "STATUS_PENDING"] = 3;
        values[valuesById[4] = "STATUS_EXPIRED"] = 4;
        return values;
      }();
      v1.Product = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDERLYING_STOCK"] = 0;
        values[valuesById[1] = "DERIVATIVE_STOCK"] = 1;
        return values;
      }();
      v1.SourceRequestType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "REGULAR"] = 0;
        values[valuesById[1] = "SACO_REFERRAL_REGISTER"] = 1;
        return values;
      }();
      v1.CareByContractType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CARE_BY_TO_SACO"] = 0;
        values[valuesById[1] = "CARE_BY_TO_CUSTOMER"] = 1;
        values[valuesById[2] = "CARE_BY_CHANGE_PERMISSION_TO_SACO"] = 2;
        values[valuesById[3] = "CARE_BY_CHANGE_PERMISSION_TO_CUSTOMER"] = 3;
        values[valuesById[4] = "CARE_BY_CANCEL_AUTH_TO_SACO"] = 4;
        values[valuesById[5] = "CARE_BY_CANCEL_AUTH_TO_CUSTOMER"] = 5;
        return values;
      }();
      v1.User = function() {
        function User(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        User.prototype.requestId = "";
        User.prototype.userId = null;
        User.prototype.username = "";
        User.prototype.password = "";
        User.prototype.fullName = null;
        User.prototype.branchId = null;
        User.prototype.groupId = "";
        User.prototype.title = null;
        User.prototype.idCode = null;
        User.prototype.phone = null;
        User.prototype.type = null;
        User.prototype.description = null;
        let $oneOfFields;
        Object.defineProperty(User.prototype, "_userId", {
          get: $util.oneOfGetter($oneOfFields = ["userId"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_fullName", {
          get: $util.oneOfGetter($oneOfFields = ["fullName"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_branchId", {
          get: $util.oneOfGetter($oneOfFields = ["branchId"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_title", {
          get: $util.oneOfGetter($oneOfFields = ["title"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_idCode", {
          get: $util.oneOfGetter($oneOfFields = ["idCode"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_phone", {
          get: $util.oneOfGetter($oneOfFields = ["phone"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_type", {
          get: $util.oneOfGetter($oneOfFields = ["type"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(User.prototype, "_description", {
          get: $util.oneOfGetter($oneOfFields = ["description"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        User.create = function create(properties) {
          return new User(properties);
        };
        User.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(18).string(message.userId);
          if (message.username != null && Object.hasOwnProperty.call(message, "username"))
            writer.uint32(26).string(message.username);
          if (message.password != null && Object.hasOwnProperty.call(message, "password"))
            writer.uint32(34).string(message.password);
          if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
            writer.uint32(42).string(message.fullName);
          if (message.branchId != null && Object.hasOwnProperty.call(message, "branchId"))
            writer.uint32(50).string(message.branchId);
          if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
            writer.uint32(58).string(message.groupId);
          if (message.title != null && Object.hasOwnProperty.call(message, "title"))
            writer.uint32(66).string(message.title);
          if (message.idCode != null && Object.hasOwnProperty.call(message, "idCode"))
            writer.uint32(74).string(message.idCode);
          if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
            writer.uint32(82).string(message.phone);
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(90).string(message.type);
          if (message.description != null && Object.hasOwnProperty.call(message, "description"))
            writer.uint32(98).string(message.description);
          return writer;
        };
        User.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        User.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.User();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.userId = reader.string();
                break;
              case 3:
                message.username = reader.string();
                break;
              case 4:
                message.password = reader.string();
                break;
              case 5:
                message.fullName = reader.string();
                break;
              case 6:
                message.branchId = reader.string();
                break;
              case 7:
                message.groupId = reader.string();
                break;
              case 8:
                message.title = reader.string();
                break;
              case 9:
                message.idCode = reader.string();
                break;
              case 10:
                message.phone = reader.string();
                break;
              case 11:
                message.type = reader.string();
                break;
              case 12:
                message.description = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        User.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        User.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.userId != null && message.hasOwnProperty("userId")) {
            if (!$util.isString(message.userId))
              return "userId: string expected";
          }
          if (message.username != null && message.hasOwnProperty("username")) {
            if (!$util.isString(message.username))
              return "username: string expected";
          }
          if (message.password != null && message.hasOwnProperty("password")) {
            if (!$util.isString(message.password))
              return "password: string expected";
          }
          if (message.fullName != null && message.hasOwnProperty("fullName")) {
            if (!$util.isString(message.fullName))
              return "fullName: string expected";
          }
          if (message.branchId != null && message.hasOwnProperty("branchId")) {
            if (!$util.isString(message.branchId))
              return "branchId: string expected";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$util.isString(message.groupId))
              return "groupId: string expected";
          }
          if (message.title != null && message.hasOwnProperty("title")) {
            if (!$util.isString(message.title))
              return "title: string expected";
          }
          if (message.idCode != null && message.hasOwnProperty("idCode")) {
            if (!$util.isString(message.idCode))
              return "idCode: string expected";
          }
          if (message.phone != null && message.hasOwnProperty("phone")) {
            if (!$util.isString(message.phone))
              return "phone: string expected";
          }
          if (message.type != null && message.hasOwnProperty("type")) {
            if (!$util.isString(message.type))
              return "type: string expected";
          }
          if (message.description != null && message.hasOwnProperty("description")) {
            if (!$util.isString(message.description))
              return "description: string expected";
          }
          return null;
        };
        User.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.User)
            return object;
          let message = new $root.dnse.broker.v1.User();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          if (object.userId != null)
            message.userId = String(object.userId);
          if (object.username != null)
            message.username = String(object.username);
          if (object.password != null)
            message.password = String(object.password);
          if (object.fullName != null)
            message.fullName = String(object.fullName);
          if (object.branchId != null)
            message.branchId = String(object.branchId);
          if (object.groupId != null)
            message.groupId = String(object.groupId);
          if (object.title != null)
            message.title = String(object.title);
          if (object.idCode != null)
            message.idCode = String(object.idCode);
          if (object.phone != null)
            message.phone = String(object.phone);
          if (object.type != null)
            message.type = String(object.type);
          if (object.description != null)
            message.description = String(object.description);
          return message;
        };
        User.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.username = "";
            object.password = "";
            object.groupId = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.userId != null && message.hasOwnProperty("userId")) {
            object.userId = message.userId;
            if (options.oneofs)
              object._userId = "userId";
          }
          if (message.username != null && message.hasOwnProperty("username"))
            object.username = message.username;
          if (message.password != null && message.hasOwnProperty("password"))
            object.password = message.password;
          if (message.fullName != null && message.hasOwnProperty("fullName")) {
            object.fullName = message.fullName;
            if (options.oneofs)
              object._fullName = "fullName";
          }
          if (message.branchId != null && message.hasOwnProperty("branchId")) {
            object.branchId = message.branchId;
            if (options.oneofs)
              object._branchId = "branchId";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId"))
            object.groupId = message.groupId;
          if (message.title != null && message.hasOwnProperty("title")) {
            object.title = message.title;
            if (options.oneofs)
              object._title = "title";
          }
          if (message.idCode != null && message.hasOwnProperty("idCode")) {
            object.idCode = message.idCode;
            if (options.oneofs)
              object._idCode = "idCode";
          }
          if (message.phone != null && message.hasOwnProperty("phone")) {
            object.phone = message.phone;
            if (options.oneofs)
              object._phone = "phone";
          }
          if (message.type != null && message.hasOwnProperty("type")) {
            object.type = message.type;
            if (options.oneofs)
              object._type = "type";
          }
          if (message.description != null && message.hasOwnProperty("description")) {
            object.description = message.description;
            if (options.oneofs)
              object._description = "description";
          }
          return object;
        };
        User.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return User;
      }();
      v1.UserResp = function() {
        function UserResp(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        UserResp.prototype.requestId = "";
        UserResp.prototype.status = 0;
        UserResp.prototype.error = null;
        let $oneOfFields;
        Object.defineProperty(UserResp.prototype, "_error", {
          get: $util.oneOfGetter($oneOfFields = ["error"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        UserResp.create = function create(properties) {
          return new UserResp(properties);
        };
        UserResp.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(26).string(message.error);
          return writer;
        };
        UserResp.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        UserResp.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.UserResp();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.error = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        UserResp.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        UserResp.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.error != null && message.hasOwnProperty("error")) {
            if (!$util.isString(message.error))
              return "error: string expected";
          }
          return null;
        };
        UserResp.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.UserResp)
            return object;
          let message = new $root.dnse.broker.v1.UserResp();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.error != null)
            message.error = String(object.error);
          return message;
        };
        UserResp.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.error != null && message.hasOwnProperty("error")) {
            object.error = message.error;
            if (options.oneofs)
              object._error = "error";
          }
          return object;
        };
        UserResp.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return UserResp;
      }();
      v1.GroupUser = function() {
        function GroupUser(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        GroupUser.prototype.requestId = "";
        GroupUser.prototype.groupId = null;
        GroupUser.prototype.groupName = "";
        GroupUser.prototype.branchId = "";
        GroupUser.prototype.groupType = "";
        GroupUser.prototype.description = null;
        let $oneOfFields;
        Object.defineProperty(GroupUser.prototype, "_groupId", {
          get: $util.oneOfGetter($oneOfFields = ["groupId"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(GroupUser.prototype, "_description", {
          get: $util.oneOfGetter($oneOfFields = ["description"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        GroupUser.create = function create(properties) {
          return new GroupUser(properties);
        };
        GroupUser.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
            writer.uint32(18).string(message.groupId);
          if (message.groupName != null && Object.hasOwnProperty.call(message, "groupName"))
            writer.uint32(26).string(message.groupName);
          if (message.branchId != null && Object.hasOwnProperty.call(message, "branchId"))
            writer.uint32(34).string(message.branchId);
          if (message.groupType != null && Object.hasOwnProperty.call(message, "groupType"))
            writer.uint32(42).string(message.groupType);
          if (message.description != null && Object.hasOwnProperty.call(message, "description"))
            writer.uint32(50).string(message.description);
          return writer;
        };
        GroupUser.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        GroupUser.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.GroupUser();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.groupId = reader.string();
                break;
              case 3:
                message.groupName = reader.string();
                break;
              case 4:
                message.branchId = reader.string();
                break;
              case 5:
                message.groupType = reader.string();
                break;
              case 6:
                message.description = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        GroupUser.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        GroupUser.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$util.isString(message.groupId))
              return "groupId: string expected";
          }
          if (message.groupName != null && message.hasOwnProperty("groupName")) {
            if (!$util.isString(message.groupName))
              return "groupName: string expected";
          }
          if (message.branchId != null && message.hasOwnProperty("branchId")) {
            if (!$util.isString(message.branchId))
              return "branchId: string expected";
          }
          if (message.groupType != null && message.hasOwnProperty("groupType")) {
            if (!$util.isString(message.groupType))
              return "groupType: string expected";
          }
          if (message.description != null && message.hasOwnProperty("description")) {
            if (!$util.isString(message.description))
              return "description: string expected";
          }
          return null;
        };
        GroupUser.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.GroupUser)
            return object;
          let message = new $root.dnse.broker.v1.GroupUser();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          if (object.groupId != null)
            message.groupId = String(object.groupId);
          if (object.groupName != null)
            message.groupName = String(object.groupName);
          if (object.branchId != null)
            message.branchId = String(object.branchId);
          if (object.groupType != null)
            message.groupType = String(object.groupType);
          if (object.description != null)
            message.description = String(object.description);
          return message;
        };
        GroupUser.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.groupName = "";
            object.branchId = "";
            object.groupType = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            object.groupId = message.groupId;
            if (options.oneofs)
              object._groupId = "groupId";
          }
          if (message.groupName != null && message.hasOwnProperty("groupName"))
            object.groupName = message.groupName;
          if (message.branchId != null && message.hasOwnProperty("branchId"))
            object.branchId = message.branchId;
          if (message.groupType != null && message.hasOwnProperty("groupType"))
            object.groupType = message.groupType;
          if (message.description != null && message.hasOwnProperty("description")) {
            object.description = message.description;
            if (options.oneofs)
              object._description = "description";
          }
          return object;
        };
        GroupUser.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return GroupUser;
      }();
      v1.GroupUserResp = function() {
        function GroupUserResp(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        GroupUserResp.prototype.requestId = "";
        GroupUserResp.prototype.status = 0;
        GroupUserResp.prototype.error = null;
        GroupUserResp.prototype.groupId = "";
        let $oneOfFields;
        Object.defineProperty(GroupUserResp.prototype, "_error", {
          get: $util.oneOfGetter($oneOfFields = ["error"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        GroupUserResp.create = function create(properties) {
          return new GroupUserResp(properties);
        };
        GroupUserResp.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(26).string(message.error);
          if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
            writer.uint32(34).string(message.groupId);
          return writer;
        };
        GroupUserResp.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        GroupUserResp.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.GroupUserResp();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.error = reader.string();
                break;
              case 4:
                message.groupId = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        GroupUserResp.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        GroupUserResp.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.error != null && message.hasOwnProperty("error")) {
            if (!$util.isString(message.error))
              return "error: string expected";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$util.isString(message.groupId))
              return "groupId: string expected";
          }
          return null;
        };
        GroupUserResp.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.GroupUserResp)
            return object;
          let message = new $root.dnse.broker.v1.GroupUserResp();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.error != null)
            message.error = String(object.error);
          if (object.groupId != null)
            message.groupId = String(object.groupId);
          return message;
        };
        GroupUserResp.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
            object.groupId = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.error != null && message.hasOwnProperty("error")) {
            object.error = message.error;
            if (options.oneofs)
              object._error = "error";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId"))
            object.groupId = message.groupId;
          return object;
        };
        GroupUserResp.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return GroupUserResp;
      }();
      v1.TlGroupUser = function() {
        function TlGroupUser(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        TlGroupUser.prototype.requestId = "";
        TlGroupUser.prototype.groupId = "";
        TlGroupUser.prototype.userId = "";
        TlGroupUser.create = function create(properties) {
          return new TlGroupUser(properties);
        };
        TlGroupUser.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
            writer.uint32(18).string(message.groupId);
          if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(26).string(message.userId);
          return writer;
        };
        TlGroupUser.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        TlGroupUser.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.TlGroupUser();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.groupId = reader.string();
                break;
              case 3:
                message.userId = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        TlGroupUser.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        TlGroupUser.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$util.isString(message.groupId))
              return "groupId: string expected";
          }
          if (message.userId != null && message.hasOwnProperty("userId")) {
            if (!$util.isString(message.userId))
              return "userId: string expected";
          }
          return null;
        };
        TlGroupUser.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.TlGroupUser)
            return object;
          let message = new $root.dnse.broker.v1.TlGroupUser();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          if (object.groupId != null)
            message.groupId = String(object.groupId);
          if (object.userId != null)
            message.userId = String(object.userId);
          return message;
        };
        TlGroupUser.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.groupId = "";
            object.userId = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.groupId != null && message.hasOwnProperty("groupId"))
            object.groupId = message.groupId;
          if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
          return object;
        };
        TlGroupUser.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return TlGroupUser;
      }();
      v1.TlGroupUserResp = function() {
        function TlGroupUserResp(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        TlGroupUserResp.prototype.requestId = "";
        TlGroupUserResp.prototype.status = 0;
        TlGroupUserResp.prototype.error = null;
        let $oneOfFields;
        Object.defineProperty(TlGroupUserResp.prototype, "_error", {
          get: $util.oneOfGetter($oneOfFields = ["error"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        TlGroupUserResp.create = function create(properties) {
          return new TlGroupUserResp(properties);
        };
        TlGroupUserResp.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(26).string(message.error);
          return writer;
        };
        TlGroupUserResp.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        TlGroupUserResp.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.TlGroupUserResp();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.error = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        TlGroupUserResp.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        TlGroupUserResp.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.error != null && message.hasOwnProperty("error")) {
            if (!$util.isString(message.error))
              return "error: string expected";
          }
          return null;
        };
        TlGroupUserResp.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.TlGroupUserResp)
            return object;
          let message = new $root.dnse.broker.v1.TlGroupUserResp();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.error != null)
            message.error = String(object.error);
          return message;
        };
        TlGroupUserResp.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.error != null && message.hasOwnProperty("error")) {
            object.error = message.error;
            if (options.oneofs)
              object._error = "error";
          }
          return object;
        };
        TlGroupUserResp.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return TlGroupUserResp;
      }();
      v1.CareByCustody = function() {
        function CareByCustody(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByCustody.prototype.requestId = "";
        CareByCustody.prototype.groupId = "";
        CareByCustody.prototype.custodyCode = "";
        CareByCustody.create = function create(properties) {
          return new CareByCustody(properties);
        };
        CareByCustody.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
            writer.uint32(18).string(message.groupId);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(26).string(message.custodyCode);
          return writer;
        };
        CareByCustody.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByCustody.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByCustody();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.groupId = reader.string();
                break;
              case 3:
                message.custodyCode = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByCustody.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByCustody.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$util.isString(message.groupId))
              return "groupId: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          return null;
        };
        CareByCustody.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByCustody)
            return object;
          let message = new $root.dnse.broker.v1.CareByCustody();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          if (object.groupId != null)
            message.groupId = String(object.groupId);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          return message;
        };
        CareByCustody.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.groupId = "";
            object.custodyCode = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.groupId != null && message.hasOwnProperty("groupId"))
            object.groupId = message.groupId;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          return object;
        };
        CareByCustody.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByCustody;
      }();
      v1.CareByCustodyResp = function() {
        function CareByCustodyResp(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByCustodyResp.prototype.requestId = "";
        CareByCustodyResp.prototype.status = 0;
        CareByCustodyResp.prototype.error = null;
        let $oneOfFields;
        Object.defineProperty(CareByCustodyResp.prototype, "_error", {
          get: $util.oneOfGetter($oneOfFields = ["error"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        CareByCustodyResp.create = function create(properties) {
          return new CareByCustodyResp(properties);
        };
        CareByCustodyResp.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(26).string(message.error);
          return writer;
        };
        CareByCustodyResp.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByCustodyResp.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByCustodyResp();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.error = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByCustodyResp.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByCustodyResp.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.error != null && message.hasOwnProperty("error")) {
            if (!$util.isString(message.error))
              return "error: string expected";
          }
          return null;
        };
        CareByCustodyResp.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByCustodyResp)
            return object;
          let message = new $root.dnse.broker.v1.CareByCustodyResp();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.error != null)
            message.error = String(object.error);
          return message;
        };
        CareByCustodyResp.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.error != null && message.hasOwnProperty("error")) {
            object.error = message.error;
            if (options.oneofs)
              object._error = "error";
          }
          return object;
        };
        CareByCustodyResp.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByCustodyResp;
      }();
      v1.CareByAccountNo = function() {
        function CareByAccountNo(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByAccountNo.prototype.requestId = "";
        CareByAccountNo.prototype.groupId = "";
        CareByAccountNo.prototype.accountNo = "";
        CareByAccountNo.create = function create(properties) {
          return new CareByAccountNo(properties);
        };
        CareByAccountNo.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
            writer.uint32(18).string(message.groupId);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(26).string(message.accountNo);
          return writer;
        };
        CareByAccountNo.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByAccountNo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByAccountNo();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.groupId = reader.string();
                break;
              case 3:
                message.accountNo = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByAccountNo.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByAccountNo.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$util.isString(message.groupId))
              return "groupId: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          return null;
        };
        CareByAccountNo.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByAccountNo)
            return object;
          let message = new $root.dnse.broker.v1.CareByAccountNo();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          if (object.groupId != null)
            message.groupId = String(object.groupId);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          return message;
        };
        CareByAccountNo.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.groupId = "";
            object.accountNo = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.groupId != null && message.hasOwnProperty("groupId"))
            object.groupId = message.groupId;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          return object;
        };
        CareByAccountNo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByAccountNo;
      }();
      v1.CareByAccountNoResp = function() {
        function CareByAccountNoResp(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByAccountNoResp.prototype.requestId = "";
        CareByAccountNoResp.prototype.status = 0;
        CareByAccountNoResp.prototype.error = null;
        let $oneOfFields;
        Object.defineProperty(CareByAccountNoResp.prototype, "_error", {
          get: $util.oneOfGetter($oneOfFields = ["error"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        CareByAccountNoResp.create = function create(properties) {
          return new CareByAccountNoResp(properties);
        };
        CareByAccountNoResp.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(10).string(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(26).string(message.error);
          return writer;
        };
        CareByAccountNoResp.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByAccountNoResp.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByAccountNoResp();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.error = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByAccountNoResp.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByAccountNoResp.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isString(message.requestId))
              return "requestId: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.error != null && message.hasOwnProperty("error")) {
            if (!$util.isString(message.error))
              return "error: string expected";
          }
          return null;
        };
        CareByAccountNoResp.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByAccountNoResp)
            return object;
          let message = new $root.dnse.broker.v1.CareByAccountNoResp();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.error != null)
            message.error = String(object.error);
          return message;
        };
        CareByAccountNoResp.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.error != null && message.hasOwnProperty("error")) {
            object.error = message.error;
            if (options.oneofs)
              object._error = "error";
          }
          return object;
        };
        CareByAccountNoResp.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByAccountNoResp;
      }();
      v1.NewBrokerCreated = function() {
        function NewBrokerCreated(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        NewBrokerCreated.prototype.brokerId = "";
        NewBrokerCreated.prototype.enId = "";
        NewBrokerCreated.prototype.status = 0;
        NewBrokerCreated.prototype.investorId = "";
        NewBrokerCreated.create = function create(properties) {
          return new NewBrokerCreated(properties);
        };
        NewBrokerCreated.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.brokerId != null && Object.hasOwnProperty.call(message, "brokerId"))
            writer.uint32(10).string(message.brokerId);
          if (message.enId != null && Object.hasOwnProperty.call(message, "enId"))
            writer.uint32(18).string(message.enId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(24).int32(message.status);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(34).string(message.investorId);
          return writer;
        };
        NewBrokerCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        NewBrokerCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.NewBrokerCreated();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.brokerId = reader.string();
                break;
              case 2:
                message.enId = reader.string();
                break;
              case 3:
                message.status = reader.int32();
                break;
              case 4:
                message.investorId = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        NewBrokerCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        NewBrokerCreated.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.brokerId != null && message.hasOwnProperty("brokerId")) {
            if (!$util.isString(message.brokerId))
              return "brokerId: string expected";
          }
          if (message.enId != null && message.hasOwnProperty("enId")) {
            if (!$util.isString(message.enId))
              return "enId: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          return null;
        };
        NewBrokerCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.NewBrokerCreated)
            return object;
          let message = new $root.dnse.broker.v1.NewBrokerCreated();
          if (object.brokerId != null)
            message.brokerId = String(object.brokerId);
          if (object.enId != null)
            message.enId = String(object.enId);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          return message;
        };
        NewBrokerCreated.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.brokerId = "";
            object.enId = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
            object.investorId = "";
          }
          if (message.brokerId != null && message.hasOwnProperty("brokerId"))
            object.brokerId = message.brokerId;
          if (message.enId != null && message.hasOwnProperty("enId"))
            object.enId = message.enId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          return object;
        };
        NewBrokerCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return NewBrokerCreated;
      }();
      v1.BrokerOperationRequest = function() {
        function BrokerOperationRequest(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        BrokerOperationRequest.prototype.id = 0;
        BrokerOperationRequest.prototype.status = "";
        BrokerOperationRequest.prototype.senderUuid = "";
        BrokerOperationRequest.prototype.receiverUuid = "";
        BrokerOperationRequest.prototype.receiverId = "";
        BrokerOperationRequest.prototype.requestType = "";
        BrokerOperationRequest.prototype.brokerName = "";
        BrokerOperationRequest.prototype.createdDate = null;
        BrokerOperationRequest.create = function create(properties) {
          return new BrokerOperationRequest(properties);
        };
        BrokerOperationRequest.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int32(message.id);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(18).string(message.status);
          if (message.senderUuid != null && Object.hasOwnProperty.call(message, "senderUuid"))
            writer.uint32(26).string(message.senderUuid);
          if (message.receiverUuid != null && Object.hasOwnProperty.call(message, "receiverUuid"))
            writer.uint32(34).string(message.receiverUuid);
          if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
            writer.uint32(42).string(message.receiverId);
          if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
            writer.uint32(50).string(message.requestType);
          if (message.brokerName != null && Object.hasOwnProperty.call(message, "brokerName"))
            writer.uint32(58).string(message.brokerName);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
          return writer;
        };
        BrokerOperationRequest.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        BrokerOperationRequest.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.BrokerOperationRequest();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int32();
                break;
              case 2:
                message.status = reader.string();
                break;
              case 3:
                message.senderUuid = reader.string();
                break;
              case 4:
                message.receiverUuid = reader.string();
                break;
              case 5:
                message.receiverId = reader.string();
                break;
              case 6:
                message.requestType = reader.string();
                break;
              case 7:
                message.brokerName = reader.string();
                break;
              case 8:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        BrokerOperationRequest.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        BrokerOperationRequest.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id))
              return "id: integer expected";
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isString(message.status))
              return "status: string expected";
          }
          if (message.senderUuid != null && message.hasOwnProperty("senderUuid")) {
            if (!$util.isString(message.senderUuid))
              return "senderUuid: string expected";
          }
          if (message.receiverUuid != null && message.hasOwnProperty("receiverUuid")) {
            if (!$util.isString(message.receiverUuid))
              return "receiverUuid: string expected";
          }
          if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
            if (!$util.isString(message.receiverId))
              return "receiverId: string expected";
          }
          if (message.requestType != null && message.hasOwnProperty("requestType")) {
            if (!$util.isString(message.requestType))
              return "requestType: string expected";
          }
          if (message.brokerName != null && message.hasOwnProperty("brokerName")) {
            if (!$util.isString(message.brokerName))
              return "brokerName: string expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          return null;
        };
        BrokerOperationRequest.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.BrokerOperationRequest)
            return object;
          let message = new $root.dnse.broker.v1.BrokerOperationRequest();
          if (object.id != null)
            message.id = object.id | 0;
          if (object.status != null)
            message.status = String(object.status);
          if (object.senderUuid != null)
            message.senderUuid = String(object.senderUuid);
          if (object.receiverUuid != null)
            message.receiverUuid = String(object.receiverUuid);
          if (object.receiverId != null)
            message.receiverId = String(object.receiverId);
          if (object.requestType != null)
            message.requestType = String(object.requestType);
          if (object.brokerName != null)
            message.brokerName = String(object.brokerName);
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.broker.v1.BrokerOperationRequest.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          return message;
        };
        BrokerOperationRequest.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.id = 0;
            object.status = "";
            object.senderUuid = "";
            object.receiverUuid = "";
            object.receiverId = "";
            object.requestType = "";
            object.brokerName = "";
            object.createdDate = null;
          }
          if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          if (message.senderUuid != null && message.hasOwnProperty("senderUuid"))
            object.senderUuid = message.senderUuid;
          if (message.receiverUuid != null && message.hasOwnProperty("receiverUuid"))
            object.receiverUuid = message.receiverUuid;
          if (message.receiverId != null && message.hasOwnProperty("receiverId"))
            object.receiverId = message.receiverId;
          if (message.requestType != null && message.hasOwnProperty("requestType"))
            object.requestType = message.requestType;
          if (message.brokerName != null && message.hasOwnProperty("brokerName"))
            object.brokerName = message.brokerName;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          return object;
        };
        BrokerOperationRequest.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return BrokerOperationRequest;
      }();
      v1.CareByCustomerResp = function() {
        function CareByCustomerResp(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByCustomerResp.prototype.status = 0;
        CareByCustomerResp.prototype.requestId = 0;
        CareByCustomerResp.prototype.senderName = "";
        CareByCustomerResp.prototype.receiverId = "";
        CareByCustomerResp.prototype.customerId = "";
        CareByCustomerResp.prototype.customerName = "";
        CareByCustomerResp.prototype.custodyCode = "";
        CareByCustomerResp.create = function create(properties) {
          return new CareByCustomerResp(properties);
        };
        CareByCustomerResp.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(8).int32(message.status);
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(16).int32(message.requestId);
          if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
            writer.uint32(26).string(message.senderName);
          if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
            writer.uint32(34).string(message.receiverId);
          if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
            writer.uint32(42).string(message.customerId);
          if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
            writer.uint32(50).string(message.customerName);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(58).string(message.custodyCode);
          return writer;
        };
        CareByCustomerResp.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByCustomerResp.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByCustomerResp();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.status = reader.int32();
                break;
              case 2:
                message.requestId = reader.int32();
                break;
              case 3:
                message.senderName = reader.string();
                break;
              case 4:
                message.receiverId = reader.string();
                break;
              case 5:
                message.customerId = reader.string();
                break;
              case 6:
                message.customerName = reader.string();
                break;
              case 7:
                message.custodyCode = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByCustomerResp.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByCustomerResp.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isInteger(message.requestId))
              return "requestId: integer expected";
          }
          if (message.senderName != null && message.hasOwnProperty("senderName")) {
            if (!$util.isString(message.senderName))
              return "senderName: string expected";
          }
          if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
            if (!$util.isString(message.receiverId))
              return "receiverId: string expected";
          }
          if (message.customerId != null && message.hasOwnProperty("customerId")) {
            if (!$util.isString(message.customerId))
              return "customerId: string expected";
          }
          if (message.customerName != null && message.hasOwnProperty("customerName")) {
            if (!$util.isString(message.customerName))
              return "customerName: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          return null;
        };
        CareByCustomerResp.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByCustomerResp)
            return object;
          let message = new $root.dnse.broker.v1.CareByCustomerResp();
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.requestId != null)
            message.requestId = object.requestId | 0;
          if (object.senderName != null)
            message.senderName = String(object.senderName);
          if (object.receiverId != null)
            message.receiverId = String(object.receiverId);
          if (object.customerId != null)
            message.customerId = String(object.customerId);
          if (object.customerName != null)
            message.customerName = String(object.customerName);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          return message;
        };
        CareByCustomerResp.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
            object.requestId = 0;
            object.senderName = "";
            object.receiverId = "";
            object.customerId = "";
            object.customerName = "";
            object.custodyCode = "";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.senderName != null && message.hasOwnProperty("senderName"))
            object.senderName = message.senderName;
          if (message.receiverId != null && message.hasOwnProperty("receiverId"))
            object.receiverId = message.receiverId;
          if (message.customerId != null && message.hasOwnProperty("customerId"))
            object.customerId = message.customerId;
          if (message.customerName != null && message.hasOwnProperty("customerName"))
            object.customerName = message.customerName;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          return object;
        };
        CareByCustomerResp.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByCustomerResp;
      }();
      v1.NotifyBrokerReferral = function() {
        function NotifyBrokerReferral(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        NotifyBrokerReferral.prototype.receiverId = "";
        NotifyBrokerReferral.prototype.referredName = "";
        NotifyBrokerReferral.prototype.referredCustodyCode = "";
        NotifyBrokerReferral.prototype.status = 0;
        NotifyBrokerReferral.create = function create(properties) {
          return new NotifyBrokerReferral(properties);
        };
        NotifyBrokerReferral.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
            writer.uint32(10).string(message.receiverId);
          if (message.referredName != null && Object.hasOwnProperty.call(message, "referredName"))
            writer.uint32(18).string(message.referredName);
          if (message.referredCustodyCode != null && Object.hasOwnProperty.call(message, "referredCustodyCode"))
            writer.uint32(26).string(message.referredCustodyCode);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(32).int32(message.status);
          return writer;
        };
        NotifyBrokerReferral.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        NotifyBrokerReferral.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.NotifyBrokerReferral();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.receiverId = reader.string();
                break;
              case 2:
                message.referredName = reader.string();
                break;
              case 3:
                message.referredCustodyCode = reader.string();
                break;
              case 4:
                message.status = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        NotifyBrokerReferral.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        NotifyBrokerReferral.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
            if (!$util.isString(message.receiverId))
              return "receiverId: string expected";
          }
          if (message.referredName != null && message.hasOwnProperty("referredName")) {
            if (!$util.isString(message.referredName))
              return "referredName: string expected";
          }
          if (message.referredCustodyCode != null && message.hasOwnProperty("referredCustodyCode")) {
            if (!$util.isString(message.referredCustodyCode))
              return "referredCustodyCode: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          return null;
        };
        NotifyBrokerReferral.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.NotifyBrokerReferral)
            return object;
          let message = new $root.dnse.broker.v1.NotifyBrokerReferral();
          if (object.receiverId != null)
            message.receiverId = String(object.receiverId);
          if (object.referredName != null)
            message.referredName = String(object.referredName);
          if (object.referredCustodyCode != null)
            message.referredCustodyCode = String(object.referredCustodyCode);
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          return message;
        };
        NotifyBrokerReferral.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.receiverId = "";
            object.referredName = "";
            object.referredCustodyCode = "";
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
          }
          if (message.receiverId != null && message.hasOwnProperty("receiverId"))
            object.receiverId = message.receiverId;
          if (message.referredName != null && message.hasOwnProperty("referredName"))
            object.referredName = message.referredName;
          if (message.referredCustodyCode != null && message.hasOwnProperty("referredCustodyCode"))
            object.referredCustodyCode = message.referredCustodyCode;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          return object;
        };
        NotifyBrokerReferral.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return NotifyBrokerReferral;
      }();
      v1.CareByRequestAcceptedByBroker = function() {
        function CareByRequestAcceptedByBroker(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByRequestAcceptedByBroker.prototype.requestId = 0;
        CareByRequestAcceptedByBroker.prototype.status = 0;
        CareByRequestAcceptedByBroker.prototype.receiverId = "";
        CareByRequestAcceptedByBroker.prototype.senderName = "";
        CareByRequestAcceptedByBroker.prototype.brokerId = "";
        CareByRequestAcceptedByBroker.prototype.brokerName = "";
        CareByRequestAcceptedByBroker.prototype.customerId = "";
        CareByRequestAcceptedByBroker.prototype.customerName = "";
        CareByRequestAcceptedByBroker.prototype.custodyCode = "";
        CareByRequestAcceptedByBroker.prototype.commissionFee = null;
        CareByRequestAcceptedByBroker.prototype.requestType = "";
        CareByRequestAcceptedByBroker.prototype.acceptedBy = "";
        CareByRequestAcceptedByBroker.prototype.previousUnderlyingRole = "";
        CareByRequestAcceptedByBroker.prototype.currentUnderlyingRole = "";
        CareByRequestAcceptedByBroker.prototype.previousDerivativeRole = "";
        CareByRequestAcceptedByBroker.prototype.currentDerivativeRole = "";
        CareByRequestAcceptedByBroker.prototype.product = 0;
        CareByRequestAcceptedByBroker.prototype.sourceRequestType = 0;
        CareByRequestAcceptedByBroker.prototype.derivativeCommissionFee = null;
        let $oneOfFields;
        Object.defineProperty(CareByRequestAcceptedByBroker.prototype, "_commissionFee", {
          get: $util.oneOfGetter($oneOfFields = ["commissionFee"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(CareByRequestAcceptedByBroker.prototype, "_derivativeCommissionFee", {
          get: $util.oneOfGetter($oneOfFields = ["derivativeCommissionFee"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        CareByRequestAcceptedByBroker.create = function create(properties) {
          return new CareByRequestAcceptedByBroker(properties);
        };
        CareByRequestAcceptedByBroker.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(8).int32(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
            writer.uint32(26).string(message.receiverId);
          if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
            writer.uint32(34).string(message.senderName);
          if (message.brokerId != null && Object.hasOwnProperty.call(message, "brokerId"))
            writer.uint32(42).string(message.brokerId);
          if (message.brokerName != null && Object.hasOwnProperty.call(message, "brokerName"))
            writer.uint32(50).string(message.brokerName);
          if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
            writer.uint32(58).string(message.customerId);
          if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
            writer.uint32(66).string(message.customerName);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(74).string(message.custodyCode);
          if (message.commissionFee != null && Object.hasOwnProperty.call(message, "commissionFee"))
            writer.uint32(81).double(message.commissionFee);
          if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
            writer.uint32(90).string(message.requestType);
          if (message.acceptedBy != null && Object.hasOwnProperty.call(message, "acceptedBy"))
            writer.uint32(98).string(message.acceptedBy);
          if (message.previousUnderlyingRole != null && Object.hasOwnProperty.call(message, "previousUnderlyingRole"))
            writer.uint32(106).string(message.previousUnderlyingRole);
          if (message.currentUnderlyingRole != null && Object.hasOwnProperty.call(message, "currentUnderlyingRole"))
            writer.uint32(114).string(message.currentUnderlyingRole);
          if (message.previousDerivativeRole != null && Object.hasOwnProperty.call(message, "previousDerivativeRole"))
            writer.uint32(122).string(message.previousDerivativeRole);
          if (message.currentDerivativeRole != null && Object.hasOwnProperty.call(message, "currentDerivativeRole"))
            writer.uint32(130).string(message.currentDerivativeRole);
          if (message.product != null && Object.hasOwnProperty.call(message, "product"))
            writer.uint32(136).int32(message.product);
          if (message.sourceRequestType != null && Object.hasOwnProperty.call(message, "sourceRequestType"))
            writer.uint32(144).int32(message.sourceRequestType);
          if (message.derivativeCommissionFee != null && Object.hasOwnProperty.call(message, "derivativeCommissionFee"))
            writer.uint32(152).int32(message.derivativeCommissionFee);
          return writer;
        };
        CareByRequestAcceptedByBroker.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByRequestAcceptedByBroker.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByRequestAcceptedByBroker();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.int32();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.receiverId = reader.string();
                break;
              case 4:
                message.senderName = reader.string();
                break;
              case 5:
                message.brokerId = reader.string();
                break;
              case 6:
                message.brokerName = reader.string();
                break;
              case 7:
                message.customerId = reader.string();
                break;
              case 8:
                message.customerName = reader.string();
                break;
              case 9:
                message.custodyCode = reader.string();
                break;
              case 10:
                message.commissionFee = reader.double();
                break;
              case 11:
                message.requestType = reader.string();
                break;
              case 12:
                message.acceptedBy = reader.string();
                break;
              case 13:
                message.previousUnderlyingRole = reader.string();
                break;
              case 14:
                message.currentUnderlyingRole = reader.string();
                break;
              case 15:
                message.previousDerivativeRole = reader.string();
                break;
              case 16:
                message.currentDerivativeRole = reader.string();
                break;
              case 17:
                message.product = reader.int32();
                break;
              case 18:
                message.sourceRequestType = reader.int32();
                break;
              case 19:
                message.derivativeCommissionFee = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByRequestAcceptedByBroker.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByRequestAcceptedByBroker.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isInteger(message.requestId))
              return "requestId: integer expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
            if (!$util.isString(message.receiverId))
              return "receiverId: string expected";
          }
          if (message.senderName != null && message.hasOwnProperty("senderName")) {
            if (!$util.isString(message.senderName))
              return "senderName: string expected";
          }
          if (message.brokerId != null && message.hasOwnProperty("brokerId")) {
            if (!$util.isString(message.brokerId))
              return "brokerId: string expected";
          }
          if (message.brokerName != null && message.hasOwnProperty("brokerName")) {
            if (!$util.isString(message.brokerName))
              return "brokerName: string expected";
          }
          if (message.customerId != null && message.hasOwnProperty("customerId")) {
            if (!$util.isString(message.customerId))
              return "customerId: string expected";
          }
          if (message.customerName != null && message.hasOwnProperty("customerName")) {
            if (!$util.isString(message.customerName))
              return "customerName: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.commissionFee != null && message.hasOwnProperty("commissionFee")) {
            if (typeof message.commissionFee !== "number")
              return "commissionFee: number expected";
          }
          if (message.requestType != null && message.hasOwnProperty("requestType")) {
            if (!$util.isString(message.requestType))
              return "requestType: string expected";
          }
          if (message.acceptedBy != null && message.hasOwnProperty("acceptedBy")) {
            if (!$util.isString(message.acceptedBy))
              return "acceptedBy: string expected";
          }
          if (message.previousUnderlyingRole != null && message.hasOwnProperty("previousUnderlyingRole")) {
            if (!$util.isString(message.previousUnderlyingRole))
              return "previousUnderlyingRole: string expected";
          }
          if (message.currentUnderlyingRole != null && message.hasOwnProperty("currentUnderlyingRole")) {
            if (!$util.isString(message.currentUnderlyingRole))
              return "currentUnderlyingRole: string expected";
          }
          if (message.previousDerivativeRole != null && message.hasOwnProperty("previousDerivativeRole")) {
            if (!$util.isString(message.previousDerivativeRole))
              return "previousDerivativeRole: string expected";
          }
          if (message.currentDerivativeRole != null && message.hasOwnProperty("currentDerivativeRole")) {
            if (!$util.isString(message.currentDerivativeRole))
              return "currentDerivativeRole: string expected";
          }
          if (message.product != null && message.hasOwnProperty("product"))
            switch (message.product) {
              default:
                return "product: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.sourceRequestType != null && message.hasOwnProperty("sourceRequestType"))
            switch (message.sourceRequestType) {
              default:
                return "sourceRequestType: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.derivativeCommissionFee != null && message.hasOwnProperty("derivativeCommissionFee")) {
            if (!$util.isInteger(message.derivativeCommissionFee))
              return "derivativeCommissionFee: integer expected";
          }
          return null;
        };
        CareByRequestAcceptedByBroker.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByRequestAcceptedByBroker)
            return object;
          let message = new $root.dnse.broker.v1.CareByRequestAcceptedByBroker();
          if (object.requestId != null)
            message.requestId = object.requestId | 0;
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.receiverId != null)
            message.receiverId = String(object.receiverId);
          if (object.senderName != null)
            message.senderName = String(object.senderName);
          if (object.brokerId != null)
            message.brokerId = String(object.brokerId);
          if (object.brokerName != null)
            message.brokerName = String(object.brokerName);
          if (object.customerId != null)
            message.customerId = String(object.customerId);
          if (object.customerName != null)
            message.customerName = String(object.customerName);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.commissionFee != null)
            message.commissionFee = Number(object.commissionFee);
          if (object.requestType != null)
            message.requestType = String(object.requestType);
          if (object.acceptedBy != null)
            message.acceptedBy = String(object.acceptedBy);
          if (object.previousUnderlyingRole != null)
            message.previousUnderlyingRole = String(object.previousUnderlyingRole);
          if (object.currentUnderlyingRole != null)
            message.currentUnderlyingRole = String(object.currentUnderlyingRole);
          if (object.previousDerivativeRole != null)
            message.previousDerivativeRole = String(object.previousDerivativeRole);
          if (object.currentDerivativeRole != null)
            message.currentDerivativeRole = String(object.currentDerivativeRole);
          switch (object.product) {
            case "UNDERLYING_STOCK":
            case 0:
              message.product = 0;
              break;
            case "DERIVATIVE_STOCK":
            case 1:
              message.product = 1;
              break;
          }
          switch (object.sourceRequestType) {
            case "REGULAR":
            case 0:
              message.sourceRequestType = 0;
              break;
            case "SACO_REFERRAL_REGISTER":
            case 1:
              message.sourceRequestType = 1;
              break;
          }
          if (object.derivativeCommissionFee != null)
            message.derivativeCommissionFee = object.derivativeCommissionFee | 0;
          return message;
        };
        CareByRequestAcceptedByBroker.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = 0;
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
            object.receiverId = "";
            object.senderName = "";
            object.brokerId = "";
            object.brokerName = "";
            object.customerId = "";
            object.customerName = "";
            object.custodyCode = "";
            object.requestType = "";
            object.acceptedBy = "";
            object.previousUnderlyingRole = "";
            object.currentUnderlyingRole = "";
            object.previousDerivativeRole = "";
            object.currentDerivativeRole = "";
            object.product = options.enums === String ? "UNDERLYING_STOCK" : 0;
            object.sourceRequestType = options.enums === String ? "REGULAR" : 0;
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.receiverId != null && message.hasOwnProperty("receiverId"))
            object.receiverId = message.receiverId;
          if (message.senderName != null && message.hasOwnProperty("senderName"))
            object.senderName = message.senderName;
          if (message.brokerId != null && message.hasOwnProperty("brokerId"))
            object.brokerId = message.brokerId;
          if (message.brokerName != null && message.hasOwnProperty("brokerName"))
            object.brokerName = message.brokerName;
          if (message.customerId != null && message.hasOwnProperty("customerId"))
            object.customerId = message.customerId;
          if (message.customerName != null && message.hasOwnProperty("customerName"))
            object.customerName = message.customerName;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.commissionFee != null && message.hasOwnProperty("commissionFee")) {
            object.commissionFee = options.json && !isFinite(message.commissionFee) ? String(message.commissionFee) : message.commissionFee;
            if (options.oneofs)
              object._commissionFee = "commissionFee";
          }
          if (message.requestType != null && message.hasOwnProperty("requestType"))
            object.requestType = message.requestType;
          if (message.acceptedBy != null && message.hasOwnProperty("acceptedBy"))
            object.acceptedBy = message.acceptedBy;
          if (message.previousUnderlyingRole != null && message.hasOwnProperty("previousUnderlyingRole"))
            object.previousUnderlyingRole = message.previousUnderlyingRole;
          if (message.currentUnderlyingRole != null && message.hasOwnProperty("currentUnderlyingRole"))
            object.currentUnderlyingRole = message.currentUnderlyingRole;
          if (message.previousDerivativeRole != null && message.hasOwnProperty("previousDerivativeRole"))
            object.previousDerivativeRole = message.previousDerivativeRole;
          if (message.currentDerivativeRole != null && message.hasOwnProperty("currentDerivativeRole"))
            object.currentDerivativeRole = message.currentDerivativeRole;
          if (message.product != null && message.hasOwnProperty("product"))
            object.product = options.enums === String ? $root.dnse.broker.v1.Product[message.product] : message.product;
          if (message.sourceRequestType != null && message.hasOwnProperty("sourceRequestType"))
            object.sourceRequestType = options.enums === String ? $root.dnse.broker.v1.SourceRequestType[message.sourceRequestType] : message.sourceRequestType;
          if (message.derivativeCommissionFee != null && message.hasOwnProperty("derivativeCommissionFee")) {
            object.derivativeCommissionFee = message.derivativeCommissionFee;
            if (options.oneofs)
              object._derivativeCommissionFee = "derivativeCommissionFee";
          }
          return object;
        };
        CareByRequestAcceptedByBroker.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByRequestAcceptedByBroker;
      }();
      v1.CareByRequestAcceptedByCustomer = function() {
        function CareByRequestAcceptedByCustomer(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByRequestAcceptedByCustomer.prototype.requestId = 0;
        CareByRequestAcceptedByCustomer.prototype.status = 0;
        CareByRequestAcceptedByCustomer.prototype.receiverId = "";
        CareByRequestAcceptedByCustomer.prototype.senderName = "";
        CareByRequestAcceptedByCustomer.prototype.brokerId = "";
        CareByRequestAcceptedByCustomer.prototype.brokerName = "";
        CareByRequestAcceptedByCustomer.prototype.customerId = "";
        CareByRequestAcceptedByCustomer.prototype.customerName = "";
        CareByRequestAcceptedByCustomer.prototype.custodyCode = "";
        CareByRequestAcceptedByCustomer.prototype.commissionFee = null;
        CareByRequestAcceptedByCustomer.prototype.requestType = "";
        CareByRequestAcceptedByCustomer.prototype.acceptedBy = "";
        CareByRequestAcceptedByCustomer.prototype.previousUnderlyingRole = "";
        CareByRequestAcceptedByCustomer.prototype.currentUnderlyingRole = "";
        CareByRequestAcceptedByCustomer.prototype.previousDerivativeRole = "";
        CareByRequestAcceptedByCustomer.prototype.currentDerivativeRole = "";
        CareByRequestAcceptedByCustomer.prototype.product = 0;
        CareByRequestAcceptedByCustomer.prototype.sourceRequestType = 0;
        CareByRequestAcceptedByCustomer.prototype.derivativeCommissionFee = null;
        let $oneOfFields;
        Object.defineProperty(CareByRequestAcceptedByCustomer.prototype, "_commissionFee", {
          get: $util.oneOfGetter($oneOfFields = ["commissionFee"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(CareByRequestAcceptedByCustomer.prototype, "_derivativeCommissionFee", {
          get: $util.oneOfGetter($oneOfFields = ["derivativeCommissionFee"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        CareByRequestAcceptedByCustomer.create = function create(properties) {
          return new CareByRequestAcceptedByCustomer(properties);
        };
        CareByRequestAcceptedByCustomer.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(8).int32(message.requestId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(16).int32(message.status);
          if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
            writer.uint32(26).string(message.receiverId);
          if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
            writer.uint32(34).string(message.senderName);
          if (message.brokerId != null && Object.hasOwnProperty.call(message, "brokerId"))
            writer.uint32(42).string(message.brokerId);
          if (message.brokerName != null && Object.hasOwnProperty.call(message, "brokerName"))
            writer.uint32(50).string(message.brokerName);
          if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
            writer.uint32(58).string(message.customerId);
          if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
            writer.uint32(66).string(message.customerName);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(74).string(message.custodyCode);
          if (message.commissionFee != null && Object.hasOwnProperty.call(message, "commissionFee"))
            writer.uint32(81).double(message.commissionFee);
          if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
            writer.uint32(90).string(message.requestType);
          if (message.acceptedBy != null && Object.hasOwnProperty.call(message, "acceptedBy"))
            writer.uint32(98).string(message.acceptedBy);
          if (message.previousUnderlyingRole != null && Object.hasOwnProperty.call(message, "previousUnderlyingRole"))
            writer.uint32(106).string(message.previousUnderlyingRole);
          if (message.currentUnderlyingRole != null && Object.hasOwnProperty.call(message, "currentUnderlyingRole"))
            writer.uint32(114).string(message.currentUnderlyingRole);
          if (message.previousDerivativeRole != null && Object.hasOwnProperty.call(message, "previousDerivativeRole"))
            writer.uint32(122).string(message.previousDerivativeRole);
          if (message.currentDerivativeRole != null && Object.hasOwnProperty.call(message, "currentDerivativeRole"))
            writer.uint32(130).string(message.currentDerivativeRole);
          if (message.product != null && Object.hasOwnProperty.call(message, "product"))
            writer.uint32(136).int32(message.product);
          if (message.sourceRequestType != null && Object.hasOwnProperty.call(message, "sourceRequestType"))
            writer.uint32(144).int32(message.sourceRequestType);
          if (message.derivativeCommissionFee != null && Object.hasOwnProperty.call(message, "derivativeCommissionFee"))
            writer.uint32(152).int32(message.derivativeCommissionFee);
          return writer;
        };
        CareByRequestAcceptedByCustomer.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByRequestAcceptedByCustomer.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByRequestAcceptedByCustomer();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.int32();
                break;
              case 2:
                message.status = reader.int32();
                break;
              case 3:
                message.receiverId = reader.string();
                break;
              case 4:
                message.senderName = reader.string();
                break;
              case 5:
                message.brokerId = reader.string();
                break;
              case 6:
                message.brokerName = reader.string();
                break;
              case 7:
                message.customerId = reader.string();
                break;
              case 8:
                message.customerName = reader.string();
                break;
              case 9:
                message.custodyCode = reader.string();
                break;
              case 10:
                message.commissionFee = reader.double();
                break;
              case 11:
                message.requestType = reader.string();
                break;
              case 12:
                message.acceptedBy = reader.string();
                break;
              case 13:
                message.previousUnderlyingRole = reader.string();
                break;
              case 14:
                message.currentUnderlyingRole = reader.string();
                break;
              case 15:
                message.previousDerivativeRole = reader.string();
                break;
              case 16:
                message.currentDerivativeRole = reader.string();
                break;
              case 17:
                message.product = reader.int32();
                break;
              case 18:
                message.sourceRequestType = reader.int32();
                break;
              case 19:
                message.derivativeCommissionFee = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByRequestAcceptedByCustomer.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByRequestAcceptedByCustomer.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.requestId != null && message.hasOwnProperty("requestId")) {
            if (!$util.isInteger(message.requestId))
              return "requestId: integer expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
                break;
            }
          if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
            if (!$util.isString(message.receiverId))
              return "receiverId: string expected";
          }
          if (message.senderName != null && message.hasOwnProperty("senderName")) {
            if (!$util.isString(message.senderName))
              return "senderName: string expected";
          }
          if (message.brokerId != null && message.hasOwnProperty("brokerId")) {
            if (!$util.isString(message.brokerId))
              return "brokerId: string expected";
          }
          if (message.brokerName != null && message.hasOwnProperty("brokerName")) {
            if (!$util.isString(message.brokerName))
              return "brokerName: string expected";
          }
          if (message.customerId != null && message.hasOwnProperty("customerId")) {
            if (!$util.isString(message.customerId))
              return "customerId: string expected";
          }
          if (message.customerName != null && message.hasOwnProperty("customerName")) {
            if (!$util.isString(message.customerName))
              return "customerName: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.commissionFee != null && message.hasOwnProperty("commissionFee")) {
            if (typeof message.commissionFee !== "number")
              return "commissionFee: number expected";
          }
          if (message.requestType != null && message.hasOwnProperty("requestType")) {
            if (!$util.isString(message.requestType))
              return "requestType: string expected";
          }
          if (message.acceptedBy != null && message.hasOwnProperty("acceptedBy")) {
            if (!$util.isString(message.acceptedBy))
              return "acceptedBy: string expected";
          }
          if (message.previousUnderlyingRole != null && message.hasOwnProperty("previousUnderlyingRole")) {
            if (!$util.isString(message.previousUnderlyingRole))
              return "previousUnderlyingRole: string expected";
          }
          if (message.currentUnderlyingRole != null && message.hasOwnProperty("currentUnderlyingRole")) {
            if (!$util.isString(message.currentUnderlyingRole))
              return "currentUnderlyingRole: string expected";
          }
          if (message.previousDerivativeRole != null && message.hasOwnProperty("previousDerivativeRole")) {
            if (!$util.isString(message.previousDerivativeRole))
              return "previousDerivativeRole: string expected";
          }
          if (message.currentDerivativeRole != null && message.hasOwnProperty("currentDerivativeRole")) {
            if (!$util.isString(message.currentDerivativeRole))
              return "currentDerivativeRole: string expected";
          }
          if (message.product != null && message.hasOwnProperty("product"))
            switch (message.product) {
              default:
                return "product: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.sourceRequestType != null && message.hasOwnProperty("sourceRequestType"))
            switch (message.sourceRequestType) {
              default:
                return "sourceRequestType: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.derivativeCommissionFee != null && message.hasOwnProperty("derivativeCommissionFee")) {
            if (!$util.isInteger(message.derivativeCommissionFee))
              return "derivativeCommissionFee: integer expected";
          }
          return null;
        };
        CareByRequestAcceptedByCustomer.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByRequestAcceptedByCustomer)
            return object;
          let message = new $root.dnse.broker.v1.CareByRequestAcceptedByCustomer();
          if (object.requestId != null)
            message.requestId = object.requestId | 0;
          switch (object.status) {
            case "STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "STATUS_SUCCESS":
            case 1:
              message.status = 1;
              break;
            case "STATUS_FAILED":
            case 2:
              message.status = 2;
              break;
            case "STATUS_PENDING":
            case 3:
              message.status = 3;
              break;
            case "STATUS_EXPIRED":
            case 4:
              message.status = 4;
              break;
          }
          if (object.receiverId != null)
            message.receiverId = String(object.receiverId);
          if (object.senderName != null)
            message.senderName = String(object.senderName);
          if (object.brokerId != null)
            message.brokerId = String(object.brokerId);
          if (object.brokerName != null)
            message.brokerName = String(object.brokerName);
          if (object.customerId != null)
            message.customerId = String(object.customerId);
          if (object.customerName != null)
            message.customerName = String(object.customerName);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.commissionFee != null)
            message.commissionFee = Number(object.commissionFee);
          if (object.requestType != null)
            message.requestType = String(object.requestType);
          if (object.acceptedBy != null)
            message.acceptedBy = String(object.acceptedBy);
          if (object.previousUnderlyingRole != null)
            message.previousUnderlyingRole = String(object.previousUnderlyingRole);
          if (object.currentUnderlyingRole != null)
            message.currentUnderlyingRole = String(object.currentUnderlyingRole);
          if (object.previousDerivativeRole != null)
            message.previousDerivativeRole = String(object.previousDerivativeRole);
          if (object.currentDerivativeRole != null)
            message.currentDerivativeRole = String(object.currentDerivativeRole);
          switch (object.product) {
            case "UNDERLYING_STOCK":
            case 0:
              message.product = 0;
              break;
            case "DERIVATIVE_STOCK":
            case 1:
              message.product = 1;
              break;
          }
          switch (object.sourceRequestType) {
            case "REGULAR":
            case 0:
              message.sourceRequestType = 0;
              break;
            case "SACO_REFERRAL_REGISTER":
            case 1:
              message.sourceRequestType = 1;
              break;
          }
          if (object.derivativeCommissionFee != null)
            message.derivativeCommissionFee = object.derivativeCommissionFee | 0;
          return message;
        };
        CareByRequestAcceptedByCustomer.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.requestId = 0;
            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
            object.receiverId = "";
            object.senderName = "";
            object.brokerId = "";
            object.brokerName = "";
            object.customerId = "";
            object.customerName = "";
            object.custodyCode = "";
            object.requestType = "";
            object.acceptedBy = "";
            object.previousUnderlyingRole = "";
            object.currentUnderlyingRole = "";
            object.previousDerivativeRole = "";
            object.currentDerivativeRole = "";
            object.product = options.enums === String ? "UNDERLYING_STOCK" : 0;
            object.sourceRequestType = options.enums === String ? "REGULAR" : 0;
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.broker.v1.Status[message.status] : message.status;
          if (message.receiverId != null && message.hasOwnProperty("receiverId"))
            object.receiverId = message.receiverId;
          if (message.senderName != null && message.hasOwnProperty("senderName"))
            object.senderName = message.senderName;
          if (message.brokerId != null && message.hasOwnProperty("brokerId"))
            object.brokerId = message.brokerId;
          if (message.brokerName != null && message.hasOwnProperty("brokerName"))
            object.brokerName = message.brokerName;
          if (message.customerId != null && message.hasOwnProperty("customerId"))
            object.customerId = message.customerId;
          if (message.customerName != null && message.hasOwnProperty("customerName"))
            object.customerName = message.customerName;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.commissionFee != null && message.hasOwnProperty("commissionFee")) {
            object.commissionFee = options.json && !isFinite(message.commissionFee) ? String(message.commissionFee) : message.commissionFee;
            if (options.oneofs)
              object._commissionFee = "commissionFee";
          }
          if (message.requestType != null && message.hasOwnProperty("requestType"))
            object.requestType = message.requestType;
          if (message.acceptedBy != null && message.hasOwnProperty("acceptedBy"))
            object.acceptedBy = message.acceptedBy;
          if (message.previousUnderlyingRole != null && message.hasOwnProperty("previousUnderlyingRole"))
            object.previousUnderlyingRole = message.previousUnderlyingRole;
          if (message.currentUnderlyingRole != null && message.hasOwnProperty("currentUnderlyingRole"))
            object.currentUnderlyingRole = message.currentUnderlyingRole;
          if (message.previousDerivativeRole != null && message.hasOwnProperty("previousDerivativeRole"))
            object.previousDerivativeRole = message.previousDerivativeRole;
          if (message.currentDerivativeRole != null && message.hasOwnProperty("currentDerivativeRole"))
            object.currentDerivativeRole = message.currentDerivativeRole;
          if (message.product != null && message.hasOwnProperty("product"))
            object.product = options.enums === String ? $root.dnse.broker.v1.Product[message.product] : message.product;
          if (message.sourceRequestType != null && message.hasOwnProperty("sourceRequestType"))
            object.sourceRequestType = options.enums === String ? $root.dnse.broker.v1.SourceRequestType[message.sourceRequestType] : message.sourceRequestType;
          if (message.derivativeCommissionFee != null && message.hasOwnProperty("derivativeCommissionFee")) {
            object.derivativeCommissionFee = message.derivativeCommissionFee;
            if (options.oneofs)
              object._derivativeCommissionFee = "derivativeCommissionFee";
          }
          return object;
        };
        CareByRequestAcceptedByCustomer.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByRequestAcceptedByCustomer;
      }();
      v1.BrokerMargin = function() {
        function BrokerMargin(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        BrokerMargin.prototype.accountNo = "";
        BrokerMargin.prototype.custodyCode = "";
        BrokerMargin.prototype.poolGroupId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BrokerMargin.prototype.name = "";
        BrokerMargin.prototype.status = "";
        BrokerMargin.prototype.totalCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BrokerMargin.prototype.allocatedCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BrokerMargin.prototype.createdDate = null;
        BrokerMargin.prototype.updatedDate = null;
        BrokerMargin.create = function create(properties) {
          return new BrokerMargin(properties);
        };
        BrokerMargin.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(10).string(message.accountNo);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(18).string(message.custodyCode);
          if (message.poolGroupId != null && Object.hasOwnProperty.call(message, "poolGroupId"))
            writer.uint32(24).int64(message.poolGroupId);
          if (message.name != null && Object.hasOwnProperty.call(message, "name"))
            writer.uint32(34).string(message.name);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(42).string(message.status);
          if (message.totalCash != null && Object.hasOwnProperty.call(message, "totalCash"))
            writer.uint32(48).int64(message.totalCash);
          if (message.allocatedCash != null && Object.hasOwnProperty.call(message, "allocatedCash"))
            writer.uint32(56).int64(message.allocatedCash);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
          if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
            $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(74).fork()).ldelim();
          return writer;
        };
        BrokerMargin.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        BrokerMargin.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.BrokerMargin();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.accountNo = reader.string();
                break;
              case 2:
                message.custodyCode = reader.string();
                break;
              case 3:
                message.poolGroupId = reader.int64();
                break;
              case 4:
                message.name = reader.string();
                break;
              case 5:
                message.status = reader.string();
                break;
              case 6:
                message.totalCash = reader.int64();
                break;
              case 7:
                message.allocatedCash = reader.int64();
                break;
              case 8:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 9:
                message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        BrokerMargin.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        BrokerMargin.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.poolGroupId != null && message.hasOwnProperty("poolGroupId")) {
            if (!$util.isInteger(message.poolGroupId) && !(message.poolGroupId && $util.isInteger(message.poolGroupId.low) && $util.isInteger(message.poolGroupId.high)))
              return "poolGroupId: integer|Long expected";
          }
          if (message.name != null && message.hasOwnProperty("name")) {
            if (!$util.isString(message.name))
              return "name: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isString(message.status))
              return "status: string expected";
          }
          if (message.totalCash != null && message.hasOwnProperty("totalCash")) {
            if (!$util.isInteger(message.totalCash) && !(message.totalCash && $util.isInteger(message.totalCash.low) && $util.isInteger(message.totalCash.high)))
              return "totalCash: integer|Long expected";
          }
          if (message.allocatedCash != null && message.hasOwnProperty("allocatedCash")) {
            if (!$util.isInteger(message.allocatedCash) && !(message.allocatedCash && $util.isInteger(message.allocatedCash.low) && $util.isInteger(message.allocatedCash.high)))
              return "allocatedCash: integer|Long expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
            if (error)
              return "updatedDate." + error;
          }
          return null;
        };
        BrokerMargin.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.BrokerMargin)
            return object;
          let message = new $root.dnse.broker.v1.BrokerMargin();
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.poolGroupId != null) {
            if ($util.Long)
              (message.poolGroupId = $util.Long.fromValue(object.poolGroupId)).unsigned = false;
            else if (typeof object.poolGroupId === "string")
              message.poolGroupId = parseInt(object.poolGroupId, 10);
            else if (typeof object.poolGroupId === "number")
              message.poolGroupId = object.poolGroupId;
            else if (typeof object.poolGroupId === "object")
              message.poolGroupId = new $util.LongBits(object.poolGroupId.low >>> 0, object.poolGroupId.high >>> 0).toNumber();
          }
          if (object.name != null)
            message.name = String(object.name);
          if (object.status != null)
            message.status = String(object.status);
          if (object.totalCash != null) {
            if ($util.Long)
              (message.totalCash = $util.Long.fromValue(object.totalCash)).unsigned = false;
            else if (typeof object.totalCash === "string")
              message.totalCash = parseInt(object.totalCash, 10);
            else if (typeof object.totalCash === "number")
              message.totalCash = object.totalCash;
            else if (typeof object.totalCash === "object")
              message.totalCash = new $util.LongBits(object.totalCash.low >>> 0, object.totalCash.high >>> 0).toNumber();
          }
          if (object.allocatedCash != null) {
            if ($util.Long)
              (message.allocatedCash = $util.Long.fromValue(object.allocatedCash)).unsigned = false;
            else if (typeof object.allocatedCash === "string")
              message.allocatedCash = parseInt(object.allocatedCash, 10);
            else if (typeof object.allocatedCash === "number")
              message.allocatedCash = object.allocatedCash;
            else if (typeof object.allocatedCash === "object")
              message.allocatedCash = new $util.LongBits(object.allocatedCash.low >>> 0, object.allocatedCash.high >>> 0).toNumber();
          }
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.broker.v1.BrokerMargin.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.updatedDate != null) {
            if (typeof object.updatedDate !== "object")
              throw TypeError(".dnse.broker.v1.BrokerMargin.updatedDate: object expected");
            message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
          }
          return message;
        };
        BrokerMargin.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.accountNo = "";
            object.custodyCode = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.poolGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.poolGroupId = options.longs === String ? "0" : 0;
            object.name = "";
            object.status = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.totalCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.totalCash = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.allocatedCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.allocatedCash = options.longs === String ? "0" : 0;
            object.createdDate = null;
            object.updatedDate = null;
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.poolGroupId != null && message.hasOwnProperty("poolGroupId"))
            if (typeof message.poolGroupId === "number")
              object.poolGroupId = options.longs === String ? String(message.poolGroupId) : message.poolGroupId;
            else
              object.poolGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.poolGroupId) : options.longs === Number ? new $util.LongBits(message.poolGroupId.low >>> 0, message.poolGroupId.high >>> 0).toNumber() : message.poolGroupId;
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          if (message.totalCash != null && message.hasOwnProperty("totalCash"))
            if (typeof message.totalCash === "number")
              object.totalCash = options.longs === String ? String(message.totalCash) : message.totalCash;
            else
              object.totalCash = options.longs === String ? $util.Long.prototype.toString.call(message.totalCash) : options.longs === Number ? new $util.LongBits(message.totalCash.low >>> 0, message.totalCash.high >>> 0).toNumber() : message.totalCash;
          if (message.allocatedCash != null && message.hasOwnProperty("allocatedCash"))
            if (typeof message.allocatedCash === "number")
              object.allocatedCash = options.longs === String ? String(message.allocatedCash) : message.allocatedCash;
            else
              object.allocatedCash = options.longs === String ? $util.Long.prototype.toString.call(message.allocatedCash) : options.longs === Number ? new $util.LongBits(message.allocatedCash.low >>> 0, message.allocatedCash.high >>> 0).toNumber() : message.allocatedCash;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
            object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
          return object;
        };
        BrokerMargin.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return BrokerMargin;
      }();
      v1.CareByContract = function() {
        function CareByContract(properties) {
          this.fileId = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CareByContract.prototype.careByContractType = 0;
        CareByContract.prototype.customerFullName = "";
        CareByContract.prototype.customerIdentityNumber = "";
        CareByContract.prototype.customerIdIssueDate = "";
        CareByContract.prototype.customerIdIssuePlace = "";
        CareByContract.prototype.customerMobile = "";
        CareByContract.prototype.customerEmail = "";
        CareByContract.prototype.customerAddress = "";
        CareByContract.prototype.customerCustodyCode = "";
        CareByContract.prototype.customerEmailSubject = "";
        CareByContract.prototype.brokerFullName = "";
        CareByContract.prototype.brokerIdentificationNumber = "";
        CareByContract.prototype.brokerIdIssueDate = "";
        CareByContract.prototype.brokerIdIssuePlace = "";
        CareByContract.prototype.brokerAddress = "";
        CareByContract.prototype.brokerMobile = "";
        CareByContract.prototype.brokerEmail = "";
        CareByContract.prototype.brokerEmailSubject = "";
        CareByContract.prototype.sentDate = "";
        CareByContract.prototype.expireDate = "";
        CareByContract.prototype.customerAcceptDate = "";
        CareByContract.prototype.cancelDate = "";
        CareByContract.prototype.authorizationDocumentNumber = "";
        CareByContract.prototype.authorizationDate = "";
        CareByContract.prototype.checkedViewUnderlying = "";
        CareByContract.prototype.checkedViewDerivative = "";
        CareByContract.prototype.checkedMakeUnderlying = "";
        CareByContract.prototype.checkedMakeDerivative = "";
        CareByContract.prototype.isPermissionRequest = false;
        CareByContract.prototype.fileId = $util.emptyArray;
        CareByContract.create = function create(properties) {
          return new CareByContract(properties);
        };
        CareByContract.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.careByContractType != null && Object.hasOwnProperty.call(message, "careByContractType"))
            writer.uint32(8).int32(message.careByContractType);
          if (message.customerFullName != null && Object.hasOwnProperty.call(message, "customerFullName"))
            writer.uint32(18).string(message.customerFullName);
          if (message.customerIdentityNumber != null && Object.hasOwnProperty.call(message, "customerIdentityNumber"))
            writer.uint32(26).string(message.customerIdentityNumber);
          if (message.customerIdIssueDate != null && Object.hasOwnProperty.call(message, "customerIdIssueDate"))
            writer.uint32(34).string(message.customerIdIssueDate);
          if (message.customerIdIssuePlace != null && Object.hasOwnProperty.call(message, "customerIdIssuePlace"))
            writer.uint32(42).string(message.customerIdIssuePlace);
          if (message.customerMobile != null && Object.hasOwnProperty.call(message, "customerMobile"))
            writer.uint32(50).string(message.customerMobile);
          if (message.customerEmail != null && Object.hasOwnProperty.call(message, "customerEmail"))
            writer.uint32(58).string(message.customerEmail);
          if (message.customerAddress != null && Object.hasOwnProperty.call(message, "customerAddress"))
            writer.uint32(66).string(message.customerAddress);
          if (message.customerCustodyCode != null && Object.hasOwnProperty.call(message, "customerCustodyCode"))
            writer.uint32(74).string(message.customerCustodyCode);
          if (message.customerEmailSubject != null && Object.hasOwnProperty.call(message, "customerEmailSubject"))
            writer.uint32(82).string(message.customerEmailSubject);
          if (message.brokerFullName != null && Object.hasOwnProperty.call(message, "brokerFullName"))
            writer.uint32(90).string(message.brokerFullName);
          if (message.brokerIdentificationNumber != null && Object.hasOwnProperty.call(message, "brokerIdentificationNumber"))
            writer.uint32(98).string(message.brokerIdentificationNumber);
          if (message.brokerIdIssueDate != null && Object.hasOwnProperty.call(message, "brokerIdIssueDate"))
            writer.uint32(106).string(message.brokerIdIssueDate);
          if (message.brokerIdIssuePlace != null && Object.hasOwnProperty.call(message, "brokerIdIssuePlace"))
            writer.uint32(114).string(message.brokerIdIssuePlace);
          if (message.brokerAddress != null && Object.hasOwnProperty.call(message, "brokerAddress"))
            writer.uint32(122).string(message.brokerAddress);
          if (message.brokerMobile != null && Object.hasOwnProperty.call(message, "brokerMobile"))
            writer.uint32(130).string(message.brokerMobile);
          if (message.brokerEmail != null && Object.hasOwnProperty.call(message, "brokerEmail"))
            writer.uint32(138).string(message.brokerEmail);
          if (message.brokerEmailSubject != null && Object.hasOwnProperty.call(message, "brokerEmailSubject"))
            writer.uint32(146).string(message.brokerEmailSubject);
          if (message.sentDate != null && Object.hasOwnProperty.call(message, "sentDate"))
            writer.uint32(154).string(message.sentDate);
          if (message.expireDate != null && Object.hasOwnProperty.call(message, "expireDate"))
            writer.uint32(162).string(message.expireDate);
          if (message.customerAcceptDate != null && Object.hasOwnProperty.call(message, "customerAcceptDate"))
            writer.uint32(170).string(message.customerAcceptDate);
          if (message.cancelDate != null && Object.hasOwnProperty.call(message, "cancelDate"))
            writer.uint32(178).string(message.cancelDate);
          if (message.authorizationDocumentNumber != null && Object.hasOwnProperty.call(message, "authorizationDocumentNumber"))
            writer.uint32(186).string(message.authorizationDocumentNumber);
          if (message.authorizationDate != null && Object.hasOwnProperty.call(message, "authorizationDate"))
            writer.uint32(194).string(message.authorizationDate);
          if (message.checkedViewUnderlying != null && Object.hasOwnProperty.call(message, "checkedViewUnderlying"))
            writer.uint32(202).string(message.checkedViewUnderlying);
          if (message.checkedViewDerivative != null && Object.hasOwnProperty.call(message, "checkedViewDerivative"))
            writer.uint32(210).string(message.checkedViewDerivative);
          if (message.checkedMakeUnderlying != null && Object.hasOwnProperty.call(message, "checkedMakeUnderlying"))
            writer.uint32(218).string(message.checkedMakeUnderlying);
          if (message.checkedMakeDerivative != null && Object.hasOwnProperty.call(message, "checkedMakeDerivative"))
            writer.uint32(226).string(message.checkedMakeDerivative);
          if (message.isPermissionRequest != null && Object.hasOwnProperty.call(message, "isPermissionRequest"))
            writer.uint32(232).bool(message.isPermissionRequest);
          if (message.fileId != null && message.fileId.length)
            for (let i = 0; i < message.fileId.length; ++i)
              writer.uint32(242).string(message.fileId[i]);
          return writer;
        };
        CareByContract.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CareByContract.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.CareByContract();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.careByContractType = reader.int32();
                break;
              case 2:
                message.customerFullName = reader.string();
                break;
              case 3:
                message.customerIdentityNumber = reader.string();
                break;
              case 4:
                message.customerIdIssueDate = reader.string();
                break;
              case 5:
                message.customerIdIssuePlace = reader.string();
                break;
              case 6:
                message.customerMobile = reader.string();
                break;
              case 7:
                message.customerEmail = reader.string();
                break;
              case 8:
                message.customerAddress = reader.string();
                break;
              case 9:
                message.customerCustodyCode = reader.string();
                break;
              case 10:
                message.customerEmailSubject = reader.string();
                break;
              case 11:
                message.brokerFullName = reader.string();
                break;
              case 12:
                message.brokerIdentificationNumber = reader.string();
                break;
              case 13:
                message.brokerIdIssueDate = reader.string();
                break;
              case 14:
                message.brokerIdIssuePlace = reader.string();
                break;
              case 15:
                message.brokerAddress = reader.string();
                break;
              case 16:
                message.brokerMobile = reader.string();
                break;
              case 17:
                message.brokerEmail = reader.string();
                break;
              case 18:
                message.brokerEmailSubject = reader.string();
                break;
              case 19:
                message.sentDate = reader.string();
                break;
              case 20:
                message.expireDate = reader.string();
                break;
              case 21:
                message.customerAcceptDate = reader.string();
                break;
              case 22:
                message.cancelDate = reader.string();
                break;
              case 23:
                message.authorizationDocumentNumber = reader.string();
                break;
              case 24:
                message.authorizationDate = reader.string();
                break;
              case 25:
                message.checkedViewUnderlying = reader.string();
                break;
              case 26:
                message.checkedViewDerivative = reader.string();
                break;
              case 27:
                message.checkedMakeUnderlying = reader.string();
                break;
              case 28:
                message.checkedMakeDerivative = reader.string();
                break;
              case 29:
                message.isPermissionRequest = reader.bool();
                break;
              case 30:
                if (!(message.fileId && message.fileId.length))
                  message.fileId = [];
                message.fileId.push(reader.string());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CareByContract.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CareByContract.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.careByContractType != null && message.hasOwnProperty("careByContractType"))
            switch (message.careByContractType) {
              default:
                return "careByContractType: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
            }
          if (message.customerFullName != null && message.hasOwnProperty("customerFullName")) {
            if (!$util.isString(message.customerFullName))
              return "customerFullName: string expected";
          }
          if (message.customerIdentityNumber != null && message.hasOwnProperty("customerIdentityNumber")) {
            if (!$util.isString(message.customerIdentityNumber))
              return "customerIdentityNumber: string expected";
          }
          if (message.customerIdIssueDate != null && message.hasOwnProperty("customerIdIssueDate")) {
            if (!$util.isString(message.customerIdIssueDate))
              return "customerIdIssueDate: string expected";
          }
          if (message.customerIdIssuePlace != null && message.hasOwnProperty("customerIdIssuePlace")) {
            if (!$util.isString(message.customerIdIssuePlace))
              return "customerIdIssuePlace: string expected";
          }
          if (message.customerMobile != null && message.hasOwnProperty("customerMobile")) {
            if (!$util.isString(message.customerMobile))
              return "customerMobile: string expected";
          }
          if (message.customerEmail != null && message.hasOwnProperty("customerEmail")) {
            if (!$util.isString(message.customerEmail))
              return "customerEmail: string expected";
          }
          if (message.customerAddress != null && message.hasOwnProperty("customerAddress")) {
            if (!$util.isString(message.customerAddress))
              return "customerAddress: string expected";
          }
          if (message.customerCustodyCode != null && message.hasOwnProperty("customerCustodyCode")) {
            if (!$util.isString(message.customerCustodyCode))
              return "customerCustodyCode: string expected";
          }
          if (message.customerEmailSubject != null && message.hasOwnProperty("customerEmailSubject")) {
            if (!$util.isString(message.customerEmailSubject))
              return "customerEmailSubject: string expected";
          }
          if (message.brokerFullName != null && message.hasOwnProperty("brokerFullName")) {
            if (!$util.isString(message.brokerFullName))
              return "brokerFullName: string expected";
          }
          if (message.brokerIdentificationNumber != null && message.hasOwnProperty("brokerIdentificationNumber")) {
            if (!$util.isString(message.brokerIdentificationNumber))
              return "brokerIdentificationNumber: string expected";
          }
          if (message.brokerIdIssueDate != null && message.hasOwnProperty("brokerIdIssueDate")) {
            if (!$util.isString(message.brokerIdIssueDate))
              return "brokerIdIssueDate: string expected";
          }
          if (message.brokerIdIssuePlace != null && message.hasOwnProperty("brokerIdIssuePlace")) {
            if (!$util.isString(message.brokerIdIssuePlace))
              return "brokerIdIssuePlace: string expected";
          }
          if (message.brokerAddress != null && message.hasOwnProperty("brokerAddress")) {
            if (!$util.isString(message.brokerAddress))
              return "brokerAddress: string expected";
          }
          if (message.brokerMobile != null && message.hasOwnProperty("brokerMobile")) {
            if (!$util.isString(message.brokerMobile))
              return "brokerMobile: string expected";
          }
          if (message.brokerEmail != null && message.hasOwnProperty("brokerEmail")) {
            if (!$util.isString(message.brokerEmail))
              return "brokerEmail: string expected";
          }
          if (message.brokerEmailSubject != null && message.hasOwnProperty("brokerEmailSubject")) {
            if (!$util.isString(message.brokerEmailSubject))
              return "brokerEmailSubject: string expected";
          }
          if (message.sentDate != null && message.hasOwnProperty("sentDate")) {
            if (!$util.isString(message.sentDate))
              return "sentDate: string expected";
          }
          if (message.expireDate != null && message.hasOwnProperty("expireDate")) {
            if (!$util.isString(message.expireDate))
              return "expireDate: string expected";
          }
          if (message.customerAcceptDate != null && message.hasOwnProperty("customerAcceptDate")) {
            if (!$util.isString(message.customerAcceptDate))
              return "customerAcceptDate: string expected";
          }
          if (message.cancelDate != null && message.hasOwnProperty("cancelDate")) {
            if (!$util.isString(message.cancelDate))
              return "cancelDate: string expected";
          }
          if (message.authorizationDocumentNumber != null && message.hasOwnProperty("authorizationDocumentNumber")) {
            if (!$util.isString(message.authorizationDocumentNumber))
              return "authorizationDocumentNumber: string expected";
          }
          if (message.authorizationDate != null && message.hasOwnProperty("authorizationDate")) {
            if (!$util.isString(message.authorizationDate))
              return "authorizationDate: string expected";
          }
          if (message.checkedViewUnderlying != null && message.hasOwnProperty("checkedViewUnderlying")) {
            if (!$util.isString(message.checkedViewUnderlying))
              return "checkedViewUnderlying: string expected";
          }
          if (message.checkedViewDerivative != null && message.hasOwnProperty("checkedViewDerivative")) {
            if (!$util.isString(message.checkedViewDerivative))
              return "checkedViewDerivative: string expected";
          }
          if (message.checkedMakeUnderlying != null && message.hasOwnProperty("checkedMakeUnderlying")) {
            if (!$util.isString(message.checkedMakeUnderlying))
              return "checkedMakeUnderlying: string expected";
          }
          if (message.checkedMakeDerivative != null && message.hasOwnProperty("checkedMakeDerivative")) {
            if (!$util.isString(message.checkedMakeDerivative))
              return "checkedMakeDerivative: string expected";
          }
          if (message.isPermissionRequest != null && message.hasOwnProperty("isPermissionRequest")) {
            if (typeof message.isPermissionRequest !== "boolean")
              return "isPermissionRequest: boolean expected";
          }
          if (message.fileId != null && message.hasOwnProperty("fileId")) {
            if (!Array.isArray(message.fileId))
              return "fileId: array expected";
            for (let i = 0; i < message.fileId.length; ++i)
              if (!$util.isString(message.fileId[i]))
                return "fileId: string[] expected";
          }
          return null;
        };
        CareByContract.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.CareByContract)
            return object;
          let message = new $root.dnse.broker.v1.CareByContract();
          switch (object.careByContractType) {
            case "CARE_BY_TO_SACO":
            case 0:
              message.careByContractType = 0;
              break;
            case "CARE_BY_TO_CUSTOMER":
            case 1:
              message.careByContractType = 1;
              break;
            case "CARE_BY_CHANGE_PERMISSION_TO_SACO":
            case 2:
              message.careByContractType = 2;
              break;
            case "CARE_BY_CHANGE_PERMISSION_TO_CUSTOMER":
            case 3:
              message.careByContractType = 3;
              break;
            case "CARE_BY_CANCEL_AUTH_TO_SACO":
            case 4:
              message.careByContractType = 4;
              break;
            case "CARE_BY_CANCEL_AUTH_TO_CUSTOMER":
            case 5:
              message.careByContractType = 5;
              break;
          }
          if (object.customerFullName != null)
            message.customerFullName = String(object.customerFullName);
          if (object.customerIdentityNumber != null)
            message.customerIdentityNumber = String(object.customerIdentityNumber);
          if (object.customerIdIssueDate != null)
            message.customerIdIssueDate = String(object.customerIdIssueDate);
          if (object.customerIdIssuePlace != null)
            message.customerIdIssuePlace = String(object.customerIdIssuePlace);
          if (object.customerMobile != null)
            message.customerMobile = String(object.customerMobile);
          if (object.customerEmail != null)
            message.customerEmail = String(object.customerEmail);
          if (object.customerAddress != null)
            message.customerAddress = String(object.customerAddress);
          if (object.customerCustodyCode != null)
            message.customerCustodyCode = String(object.customerCustodyCode);
          if (object.customerEmailSubject != null)
            message.customerEmailSubject = String(object.customerEmailSubject);
          if (object.brokerFullName != null)
            message.brokerFullName = String(object.brokerFullName);
          if (object.brokerIdentificationNumber != null)
            message.brokerIdentificationNumber = String(object.brokerIdentificationNumber);
          if (object.brokerIdIssueDate != null)
            message.brokerIdIssueDate = String(object.brokerIdIssueDate);
          if (object.brokerIdIssuePlace != null)
            message.brokerIdIssuePlace = String(object.brokerIdIssuePlace);
          if (object.brokerAddress != null)
            message.brokerAddress = String(object.brokerAddress);
          if (object.brokerMobile != null)
            message.brokerMobile = String(object.brokerMobile);
          if (object.brokerEmail != null)
            message.brokerEmail = String(object.brokerEmail);
          if (object.brokerEmailSubject != null)
            message.brokerEmailSubject = String(object.brokerEmailSubject);
          if (object.sentDate != null)
            message.sentDate = String(object.sentDate);
          if (object.expireDate != null)
            message.expireDate = String(object.expireDate);
          if (object.customerAcceptDate != null)
            message.customerAcceptDate = String(object.customerAcceptDate);
          if (object.cancelDate != null)
            message.cancelDate = String(object.cancelDate);
          if (object.authorizationDocumentNumber != null)
            message.authorizationDocumentNumber = String(object.authorizationDocumentNumber);
          if (object.authorizationDate != null)
            message.authorizationDate = String(object.authorizationDate);
          if (object.checkedViewUnderlying != null)
            message.checkedViewUnderlying = String(object.checkedViewUnderlying);
          if (object.checkedViewDerivative != null)
            message.checkedViewDerivative = String(object.checkedViewDerivative);
          if (object.checkedMakeUnderlying != null)
            message.checkedMakeUnderlying = String(object.checkedMakeUnderlying);
          if (object.checkedMakeDerivative != null)
            message.checkedMakeDerivative = String(object.checkedMakeDerivative);
          if (object.isPermissionRequest != null)
            message.isPermissionRequest = Boolean(object.isPermissionRequest);
          if (object.fileId) {
            if (!Array.isArray(object.fileId))
              throw TypeError(".dnse.broker.v1.CareByContract.fileId: array expected");
            message.fileId = [];
            for (let i = 0; i < object.fileId.length; ++i)
              message.fileId[i] = String(object.fileId[i]);
          }
          return message;
        };
        CareByContract.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.fileId = [];
          if (options.defaults) {
            object.careByContractType = options.enums === String ? "CARE_BY_TO_SACO" : 0;
            object.customerFullName = "";
            object.customerIdentityNumber = "";
            object.customerIdIssueDate = "";
            object.customerIdIssuePlace = "";
            object.customerMobile = "";
            object.customerEmail = "";
            object.customerAddress = "";
            object.customerCustodyCode = "";
            object.customerEmailSubject = "";
            object.brokerFullName = "";
            object.brokerIdentificationNumber = "";
            object.brokerIdIssueDate = "";
            object.brokerIdIssuePlace = "";
            object.brokerAddress = "";
            object.brokerMobile = "";
            object.brokerEmail = "";
            object.brokerEmailSubject = "";
            object.sentDate = "";
            object.expireDate = "";
            object.customerAcceptDate = "";
            object.cancelDate = "";
            object.authorizationDocumentNumber = "";
            object.authorizationDate = "";
            object.checkedViewUnderlying = "";
            object.checkedViewDerivative = "";
            object.checkedMakeUnderlying = "";
            object.checkedMakeDerivative = "";
            object.isPermissionRequest = false;
          }
          if (message.careByContractType != null && message.hasOwnProperty("careByContractType"))
            object.careByContractType = options.enums === String ? $root.dnse.broker.v1.CareByContractType[message.careByContractType] : message.careByContractType;
          if (message.customerFullName != null && message.hasOwnProperty("customerFullName"))
            object.customerFullName = message.customerFullName;
          if (message.customerIdentityNumber != null && message.hasOwnProperty("customerIdentityNumber"))
            object.customerIdentityNumber = message.customerIdentityNumber;
          if (message.customerIdIssueDate != null && message.hasOwnProperty("customerIdIssueDate"))
            object.customerIdIssueDate = message.customerIdIssueDate;
          if (message.customerIdIssuePlace != null && message.hasOwnProperty("customerIdIssuePlace"))
            object.customerIdIssuePlace = message.customerIdIssuePlace;
          if (message.customerMobile != null && message.hasOwnProperty("customerMobile"))
            object.customerMobile = message.customerMobile;
          if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
            object.customerEmail = message.customerEmail;
          if (message.customerAddress != null && message.hasOwnProperty("customerAddress"))
            object.customerAddress = message.customerAddress;
          if (message.customerCustodyCode != null && message.hasOwnProperty("customerCustodyCode"))
            object.customerCustodyCode = message.customerCustodyCode;
          if (message.customerEmailSubject != null && message.hasOwnProperty("customerEmailSubject"))
            object.customerEmailSubject = message.customerEmailSubject;
          if (message.brokerFullName != null && message.hasOwnProperty("brokerFullName"))
            object.brokerFullName = message.brokerFullName;
          if (message.brokerIdentificationNumber != null && message.hasOwnProperty("brokerIdentificationNumber"))
            object.brokerIdentificationNumber = message.brokerIdentificationNumber;
          if (message.brokerIdIssueDate != null && message.hasOwnProperty("brokerIdIssueDate"))
            object.brokerIdIssueDate = message.brokerIdIssueDate;
          if (message.brokerIdIssuePlace != null && message.hasOwnProperty("brokerIdIssuePlace"))
            object.brokerIdIssuePlace = message.brokerIdIssuePlace;
          if (message.brokerAddress != null && message.hasOwnProperty("brokerAddress"))
            object.brokerAddress = message.brokerAddress;
          if (message.brokerMobile != null && message.hasOwnProperty("brokerMobile"))
            object.brokerMobile = message.brokerMobile;
          if (message.brokerEmail != null && message.hasOwnProperty("brokerEmail"))
            object.brokerEmail = message.brokerEmail;
          if (message.brokerEmailSubject != null && message.hasOwnProperty("brokerEmailSubject"))
            object.brokerEmailSubject = message.brokerEmailSubject;
          if (message.sentDate != null && message.hasOwnProperty("sentDate"))
            object.sentDate = message.sentDate;
          if (message.expireDate != null && message.hasOwnProperty("expireDate"))
            object.expireDate = message.expireDate;
          if (message.customerAcceptDate != null && message.hasOwnProperty("customerAcceptDate"))
            object.customerAcceptDate = message.customerAcceptDate;
          if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
            object.cancelDate = message.cancelDate;
          if (message.authorizationDocumentNumber != null && message.hasOwnProperty("authorizationDocumentNumber"))
            object.authorizationDocumentNumber = message.authorizationDocumentNumber;
          if (message.authorizationDate != null && message.hasOwnProperty("authorizationDate"))
            object.authorizationDate = message.authorizationDate;
          if (message.checkedViewUnderlying != null && message.hasOwnProperty("checkedViewUnderlying"))
            object.checkedViewUnderlying = message.checkedViewUnderlying;
          if (message.checkedViewDerivative != null && message.hasOwnProperty("checkedViewDerivative"))
            object.checkedViewDerivative = message.checkedViewDerivative;
          if (message.checkedMakeUnderlying != null && message.hasOwnProperty("checkedMakeUnderlying"))
            object.checkedMakeUnderlying = message.checkedMakeUnderlying;
          if (message.checkedMakeDerivative != null && message.hasOwnProperty("checkedMakeDerivative"))
            object.checkedMakeDerivative = message.checkedMakeDerivative;
          if (message.isPermissionRequest != null && message.hasOwnProperty("isPermissionRequest"))
            object.isPermissionRequest = message.isPermissionRequest;
          if (message.fileId && message.fileId.length) {
            object.fileId = [];
            for (let j = 0; j < message.fileId.length; ++j)
              object.fileId[j] = message.fileId[j];
          }
          return object;
        };
        CareByContract.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CareByContract;
      }();
      v1.BrokerContract = function() {
        function BrokerContract(properties) {
          this.fileId = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        BrokerContract.prototype.commissionFeesAttachment = "";
        BrokerContract.prototype.emailSubject = "";
        BrokerContract.prototype.email = "";
        BrokerContract.prototype.contractDay = "";
        BrokerContract.prototype.contractMonth = "";
        BrokerContract.prototype.contractYear = "";
        BrokerContract.prototype.fullName = "";
        BrokerContract.prototype.identityNumber = "";
        BrokerContract.prototype.idIssuePlace = "";
        BrokerContract.prototype.idIssueDate = "";
        BrokerContract.prototype.address = "";
        BrokerContract.prototype.mobile = "";
        BrokerContract.prototype.signedDate = "";
        BrokerContract.prototype.custodyCode = "";
        BrokerContract.prototype.fileId = $util.emptyArray;
        BrokerContract.create = function create(properties) {
          return new BrokerContract(properties);
        };
        BrokerContract.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.commissionFeesAttachment != null && Object.hasOwnProperty.call(message, "commissionFeesAttachment"))
            writer.uint32(10).string(message.commissionFeesAttachment);
          if (message.emailSubject != null && Object.hasOwnProperty.call(message, "emailSubject"))
            writer.uint32(18).string(message.emailSubject);
          if (message.email != null && Object.hasOwnProperty.call(message, "email"))
            writer.uint32(26).string(message.email);
          if (message.contractDay != null && Object.hasOwnProperty.call(message, "contractDay"))
            writer.uint32(34).string(message.contractDay);
          if (message.contractMonth != null && Object.hasOwnProperty.call(message, "contractMonth"))
            writer.uint32(42).string(message.contractMonth);
          if (message.contractYear != null && Object.hasOwnProperty.call(message, "contractYear"))
            writer.uint32(50).string(message.contractYear);
          if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
            writer.uint32(58).string(message.fullName);
          if (message.identityNumber != null && Object.hasOwnProperty.call(message, "identityNumber"))
            writer.uint32(66).string(message.identityNumber);
          if (message.idIssuePlace != null && Object.hasOwnProperty.call(message, "idIssuePlace"))
            writer.uint32(74).string(message.idIssuePlace);
          if (message.idIssueDate != null && Object.hasOwnProperty.call(message, "idIssueDate"))
            writer.uint32(82).string(message.idIssueDate);
          if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(90).string(message.address);
          if (message.mobile != null && Object.hasOwnProperty.call(message, "mobile"))
            writer.uint32(98).string(message.mobile);
          if (message.signedDate != null && Object.hasOwnProperty.call(message, "signedDate"))
            writer.uint32(106).string(message.signedDate);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(114).string(message.custodyCode);
          if (message.fileId != null && message.fileId.length)
            for (let i = 0; i < message.fileId.length; ++i)
              writer.uint32(122).string(message.fileId[i]);
          return writer;
        };
        BrokerContract.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        BrokerContract.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.BrokerContract();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.commissionFeesAttachment = reader.string();
                break;
              case 2:
                message.emailSubject = reader.string();
                break;
              case 3:
                message.email = reader.string();
                break;
              case 4:
                message.contractDay = reader.string();
                break;
              case 5:
                message.contractMonth = reader.string();
                break;
              case 6:
                message.contractYear = reader.string();
                break;
              case 7:
                message.fullName = reader.string();
                break;
              case 8:
                message.identityNumber = reader.string();
                break;
              case 9:
                message.idIssuePlace = reader.string();
                break;
              case 10:
                message.idIssueDate = reader.string();
                break;
              case 11:
                message.address = reader.string();
                break;
              case 12:
                message.mobile = reader.string();
                break;
              case 13:
                message.signedDate = reader.string();
                break;
              case 14:
                message.custodyCode = reader.string();
                break;
              case 15:
                if (!(message.fileId && message.fileId.length))
                  message.fileId = [];
                message.fileId.push(reader.string());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        BrokerContract.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        BrokerContract.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.commissionFeesAttachment != null && message.hasOwnProperty("commissionFeesAttachment")) {
            if (!$util.isString(message.commissionFeesAttachment))
              return "commissionFeesAttachment: string expected";
          }
          if (message.emailSubject != null && message.hasOwnProperty("emailSubject")) {
            if (!$util.isString(message.emailSubject))
              return "emailSubject: string expected";
          }
          if (message.email != null && message.hasOwnProperty("email")) {
            if (!$util.isString(message.email))
              return "email: string expected";
          }
          if (message.contractDay != null && message.hasOwnProperty("contractDay")) {
            if (!$util.isString(message.contractDay))
              return "contractDay: string expected";
          }
          if (message.contractMonth != null && message.hasOwnProperty("contractMonth")) {
            if (!$util.isString(message.contractMonth))
              return "contractMonth: string expected";
          }
          if (message.contractYear != null && message.hasOwnProperty("contractYear")) {
            if (!$util.isString(message.contractYear))
              return "contractYear: string expected";
          }
          if (message.fullName != null && message.hasOwnProperty("fullName")) {
            if (!$util.isString(message.fullName))
              return "fullName: string expected";
          }
          if (message.identityNumber != null && message.hasOwnProperty("identityNumber")) {
            if (!$util.isString(message.identityNumber))
              return "identityNumber: string expected";
          }
          if (message.idIssuePlace != null && message.hasOwnProperty("idIssuePlace")) {
            if (!$util.isString(message.idIssuePlace))
              return "idIssuePlace: string expected";
          }
          if (message.idIssueDate != null && message.hasOwnProperty("idIssueDate")) {
            if (!$util.isString(message.idIssueDate))
              return "idIssueDate: string expected";
          }
          if (message.address != null && message.hasOwnProperty("address")) {
            if (!$util.isString(message.address))
              return "address: string expected";
          }
          if (message.mobile != null && message.hasOwnProperty("mobile")) {
            if (!$util.isString(message.mobile))
              return "mobile: string expected";
          }
          if (message.signedDate != null && message.hasOwnProperty("signedDate")) {
            if (!$util.isString(message.signedDate))
              return "signedDate: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.fileId != null && message.hasOwnProperty("fileId")) {
            if (!Array.isArray(message.fileId))
              return "fileId: array expected";
            for (let i = 0; i < message.fileId.length; ++i)
              if (!$util.isString(message.fileId[i]))
                return "fileId: string[] expected";
          }
          return null;
        };
        BrokerContract.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.BrokerContract)
            return object;
          let message = new $root.dnse.broker.v1.BrokerContract();
          if (object.commissionFeesAttachment != null)
            message.commissionFeesAttachment = String(object.commissionFeesAttachment);
          if (object.emailSubject != null)
            message.emailSubject = String(object.emailSubject);
          if (object.email != null)
            message.email = String(object.email);
          if (object.contractDay != null)
            message.contractDay = String(object.contractDay);
          if (object.contractMonth != null)
            message.contractMonth = String(object.contractMonth);
          if (object.contractYear != null)
            message.contractYear = String(object.contractYear);
          if (object.fullName != null)
            message.fullName = String(object.fullName);
          if (object.identityNumber != null)
            message.identityNumber = String(object.identityNumber);
          if (object.idIssuePlace != null)
            message.idIssuePlace = String(object.idIssuePlace);
          if (object.idIssueDate != null)
            message.idIssueDate = String(object.idIssueDate);
          if (object.address != null)
            message.address = String(object.address);
          if (object.mobile != null)
            message.mobile = String(object.mobile);
          if (object.signedDate != null)
            message.signedDate = String(object.signedDate);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.fileId) {
            if (!Array.isArray(object.fileId))
              throw TypeError(".dnse.broker.v1.BrokerContract.fileId: array expected");
            message.fileId = [];
            for (let i = 0; i < object.fileId.length; ++i)
              message.fileId[i] = String(object.fileId[i]);
          }
          return message;
        };
        BrokerContract.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.fileId = [];
          if (options.defaults) {
            object.commissionFeesAttachment = "";
            object.emailSubject = "";
            object.email = "";
            object.contractDay = "";
            object.contractMonth = "";
            object.contractYear = "";
            object.fullName = "";
            object.identityNumber = "";
            object.idIssuePlace = "";
            object.idIssueDate = "";
            object.address = "";
            object.mobile = "";
            object.signedDate = "";
            object.custodyCode = "";
          }
          if (message.commissionFeesAttachment != null && message.hasOwnProperty("commissionFeesAttachment"))
            object.commissionFeesAttachment = message.commissionFeesAttachment;
          if (message.emailSubject != null && message.hasOwnProperty("emailSubject"))
            object.emailSubject = message.emailSubject;
          if (message.email != null && message.hasOwnProperty("email"))
            object.email = message.email;
          if (message.contractDay != null && message.hasOwnProperty("contractDay"))
            object.contractDay = message.contractDay;
          if (message.contractMonth != null && message.hasOwnProperty("contractMonth"))
            object.contractMonth = message.contractMonth;
          if (message.contractYear != null && message.hasOwnProperty("contractYear"))
            object.contractYear = message.contractYear;
          if (message.fullName != null && message.hasOwnProperty("fullName"))
            object.fullName = message.fullName;
          if (message.identityNumber != null && message.hasOwnProperty("identityNumber"))
            object.identityNumber = message.identityNumber;
          if (message.idIssuePlace != null && message.hasOwnProperty("idIssuePlace"))
            object.idIssuePlace = message.idIssuePlace;
          if (message.idIssueDate != null && message.hasOwnProperty("idIssueDate"))
            object.idIssueDate = message.idIssueDate;
          if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
          if (message.mobile != null && message.hasOwnProperty("mobile"))
            object.mobile = message.mobile;
          if (message.signedDate != null && message.hasOwnProperty("signedDate"))
            object.signedDate = message.signedDate;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.fileId && message.fileId.length) {
            object.fileId = [];
            for (let j = 0; j < message.fileId.length; ++j)
              object.fileId[j] = message.fileId[j];
          }
          return object;
        };
        BrokerContract.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return BrokerContract;
      }();
      v1.FinancingOfferLoanPackageRequest = function() {
        function FinancingOfferLoanPackageRequest(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        FinancingOfferLoanPackageRequest.prototype.customerInvestorId = "";
        FinancingOfferLoanPackageRequest.prototype.customerCustodyCode = "";
        FinancingOfferLoanPackageRequest.prototype.customerAccountNo = "";
        FinancingOfferLoanPackageRequest.prototype.loanRate = 0;
        FinancingOfferLoanPackageRequest.prototype.type = "";
        FinancingOfferLoanPackageRequest.prototype.limitAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        FinancingOfferLoanPackageRequest.prototype.symbol = "";
        FinancingOfferLoanPackageRequest.prototype.guaranteedDuration = 0;
        FinancingOfferLoanPackageRequest.prototype.createdDate = null;
        FinancingOfferLoanPackageRequest.prototype.customerFullName = "";
        FinancingOfferLoanPackageRequest.prototype.receiverId = "";
        FinancingOfferLoanPackageRequest.create = function create(properties) {
          return new FinancingOfferLoanPackageRequest(properties);
        };
        FinancingOfferLoanPackageRequest.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.customerInvestorId != null && Object.hasOwnProperty.call(message, "customerInvestorId"))
            writer.uint32(10).string(message.customerInvestorId);
          if (message.customerCustodyCode != null && Object.hasOwnProperty.call(message, "customerCustodyCode"))
            writer.uint32(18).string(message.customerCustodyCode);
          if (message.customerAccountNo != null && Object.hasOwnProperty.call(message, "customerAccountNo"))
            writer.uint32(26).string(message.customerAccountNo);
          if (message.loanRate != null && Object.hasOwnProperty.call(message, "loanRate"))
            writer.uint32(33).double(message.loanRate);
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(42).string(message.type);
          if (message.limitAmount != null && Object.hasOwnProperty.call(message, "limitAmount"))
            writer.uint32(48).int64(message.limitAmount);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(58).string(message.symbol);
          if (message.guaranteedDuration != null && Object.hasOwnProperty.call(message, "guaranteedDuration"))
            writer.uint32(64).int32(message.guaranteedDuration);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
          if (message.customerFullName != null && Object.hasOwnProperty.call(message, "customerFullName"))
            writer.uint32(82).string(message.customerFullName);
          if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
            writer.uint32(90).string(message.receiverId);
          return writer;
        };
        FinancingOfferLoanPackageRequest.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        FinancingOfferLoanPackageRequest.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.broker.v1.FinancingOfferLoanPackageRequest();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.customerInvestorId = reader.string();
                break;
              case 2:
                message.customerCustodyCode = reader.string();
                break;
              case 3:
                message.customerAccountNo = reader.string();
                break;
              case 4:
                message.loanRate = reader.double();
                break;
              case 5:
                message.type = reader.string();
                break;
              case 6:
                message.limitAmount = reader.int64();
                break;
              case 7:
                message.symbol = reader.string();
                break;
              case 8:
                message.guaranteedDuration = reader.int32();
                break;
              case 9:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 10:
                message.customerFullName = reader.string();
                break;
              case 11:
                message.receiverId = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        FinancingOfferLoanPackageRequest.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        FinancingOfferLoanPackageRequest.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.customerInvestorId != null && message.hasOwnProperty("customerInvestorId")) {
            if (!$util.isString(message.customerInvestorId))
              return "customerInvestorId: string expected";
          }
          if (message.customerCustodyCode != null && message.hasOwnProperty("customerCustodyCode")) {
            if (!$util.isString(message.customerCustodyCode))
              return "customerCustodyCode: string expected";
          }
          if (message.customerAccountNo != null && message.hasOwnProperty("customerAccountNo")) {
            if (!$util.isString(message.customerAccountNo))
              return "customerAccountNo: string expected";
          }
          if (message.loanRate != null && message.hasOwnProperty("loanRate")) {
            if (typeof message.loanRate !== "number")
              return "loanRate: number expected";
          }
          if (message.type != null && message.hasOwnProperty("type")) {
            if (!$util.isString(message.type))
              return "type: string expected";
          }
          if (message.limitAmount != null && message.hasOwnProperty("limitAmount")) {
            if (!$util.isInteger(message.limitAmount) && !(message.limitAmount && $util.isInteger(message.limitAmount.low) && $util.isInteger(message.limitAmount.high)))
              return "limitAmount: integer|Long expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.guaranteedDuration != null && message.hasOwnProperty("guaranteedDuration")) {
            if (!$util.isInteger(message.guaranteedDuration))
              return "guaranteedDuration: integer expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.customerFullName != null && message.hasOwnProperty("customerFullName")) {
            if (!$util.isString(message.customerFullName))
              return "customerFullName: string expected";
          }
          if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
            if (!$util.isString(message.receiverId))
              return "receiverId: string expected";
          }
          return null;
        };
        FinancingOfferLoanPackageRequest.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.broker.v1.FinancingOfferLoanPackageRequest)
            return object;
          let message = new $root.dnse.broker.v1.FinancingOfferLoanPackageRequest();
          if (object.customerInvestorId != null)
            message.customerInvestorId = String(object.customerInvestorId);
          if (object.customerCustodyCode != null)
            message.customerCustodyCode = String(object.customerCustodyCode);
          if (object.customerAccountNo != null)
            message.customerAccountNo = String(object.customerAccountNo);
          if (object.loanRate != null)
            message.loanRate = Number(object.loanRate);
          if (object.type != null)
            message.type = String(object.type);
          if (object.limitAmount != null) {
            if ($util.Long)
              (message.limitAmount = $util.Long.fromValue(object.limitAmount)).unsigned = false;
            else if (typeof object.limitAmount === "string")
              message.limitAmount = parseInt(object.limitAmount, 10);
            else if (typeof object.limitAmount === "number")
              message.limitAmount = object.limitAmount;
            else if (typeof object.limitAmount === "object")
              message.limitAmount = new $util.LongBits(object.limitAmount.low >>> 0, object.limitAmount.high >>> 0).toNumber();
          }
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.guaranteedDuration != null)
            message.guaranteedDuration = object.guaranteedDuration | 0;
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.broker.v1.FinancingOfferLoanPackageRequest.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.customerFullName != null)
            message.customerFullName = String(object.customerFullName);
          if (object.receiverId != null)
            message.receiverId = String(object.receiverId);
          return message;
        };
        FinancingOfferLoanPackageRequest.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.customerInvestorId = "";
            object.customerCustodyCode = "";
            object.customerAccountNo = "";
            object.loanRate = 0;
            object.type = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.limitAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.limitAmount = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.guaranteedDuration = 0;
            object.createdDate = null;
            object.customerFullName = "";
            object.receiverId = "";
          }
          if (message.customerInvestorId != null && message.hasOwnProperty("customerInvestorId"))
            object.customerInvestorId = message.customerInvestorId;
          if (message.customerCustodyCode != null && message.hasOwnProperty("customerCustodyCode"))
            object.customerCustodyCode = message.customerCustodyCode;
          if (message.customerAccountNo != null && message.hasOwnProperty("customerAccountNo"))
            object.customerAccountNo = message.customerAccountNo;
          if (message.loanRate != null && message.hasOwnProperty("loanRate"))
            object.loanRate = options.json && !isFinite(message.loanRate) ? String(message.loanRate) : message.loanRate;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
          if (message.limitAmount != null && message.hasOwnProperty("limitAmount"))
            if (typeof message.limitAmount === "number")
              object.limitAmount = options.longs === String ? String(message.limitAmount) : message.limitAmount;
            else
              object.limitAmount = options.longs === String ? $util.Long.prototype.toString.call(message.limitAmount) : options.longs === Number ? new $util.LongBits(message.limitAmount.low >>> 0, message.limitAmount.high >>> 0).toNumber() : message.limitAmount;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.guaranteedDuration != null && message.hasOwnProperty("guaranteedDuration"))
            object.guaranteedDuration = message.guaranteedDuration;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.customerFullName != null && message.hasOwnProperty("customerFullName"))
            object.customerFullName = message.customerFullName;
          if (message.receiverId != null && message.hasOwnProperty("receiverId"))
            object.receiverId = message.receiverId;
          return object;
        };
        FinancingOfferLoanPackageRequest.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return FinancingOfferLoanPackageRequest;
      }();
      return v1;
    }();
    return broker;
  }();
  dnse2.Order = function() {
    function Order(properties) {
      this.reports = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Order.prototype.id = "";
    Order.prototype.investorId = "";
    Order.prototype.custodyCode = "";
    Order.prototype.investorAccountId = "";
    Order.prototype.symbol = "";
    Order.prototype.quantity = 0;
    Order.prototype.side = 0;
    Order.prototype.orderType = 0;
    Order.prototype.status = 0;
    Order.prototype.filledQuantity = 0;
    Order.prototype.price = 0;
    Order.prototype.avgPrice = 0;
    Order.prototype.stopPrice = 0;
    Order.prototype.createdDate = null;
    Order.prototype.modifiedDate = null;
    Order.prototype.reports = $util.emptyArray;
    Order.create = function create(properties) {
      return new Order(properties);
    };
    Order.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(34).string(message.investorAccountId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(48).int32(message.quantity);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(56).int32(message.side);
      if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
        writer.uint32(64).int32(message.orderType);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(72).int32(message.status);
      if (message.filledQuantity != null && Object.hasOwnProperty.call(message, "filledQuantity"))
        writer.uint32(80).int32(message.filledQuantity);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(88).int32(message.price);
      if (message.avgPrice != null && Object.hasOwnProperty.call(message, "avgPrice"))
        writer.uint32(97).double(message.avgPrice);
      if (message.stopPrice != null && Object.hasOwnProperty.call(message, "stopPrice"))
        writer.uint32(104).int32(message.stopPrice);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(114).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(122).fork()).ldelim();
      if (message.reports != null && message.reports.length)
        for (let i = 0; i < message.reports.length; ++i)
          $root.dnse.OrderReport.encode(message.reports[i], writer.uint32(130).fork()).ldelim();
      return writer;
    };
    Order.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Order.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Order();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.investorAccountId = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.quantity = reader.int32();
            break;
          case 7:
            message.side = reader.int32();
            break;
          case 8:
            message.orderType = reader.int32();
            break;
          case 9:
            message.status = reader.int32();
            break;
          case 10:
            message.filledQuantity = reader.int32();
            break;
          case 11:
            message.price = reader.int32();
            break;
          case 12:
            message.avgPrice = reader.double();
            break;
          case 13:
            message.stopPrice = reader.int32();
            break;
          case 14:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 15:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 16:
            if (!(message.reports && message.reports.length))
              message.reports = [];
            message.reports.push($root.dnse.OrderReport.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Order.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Order.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isString(message.investorAccountId))
          return "investorAccountId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity))
          return "quantity: integer expected";
      }
      if (message.side != null && message.hasOwnProperty("side"))
        switch (message.side) {
          default:
            return "side: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.orderType != null && message.hasOwnProperty("orderType"))
        switch (message.orderType) {
          default:
            return "orderType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
            break;
        }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
            break;
        }
      if (message.filledQuantity != null && message.hasOwnProperty("filledQuantity")) {
        if (!$util.isInteger(message.filledQuantity))
          return "filledQuantity: integer expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (!$util.isInteger(message.price))
          return "price: integer expected";
      }
      if (message.avgPrice != null && message.hasOwnProperty("avgPrice")) {
        if (typeof message.avgPrice !== "number")
          return "avgPrice: number expected";
      }
      if (message.stopPrice != null && message.hasOwnProperty("stopPrice")) {
        if (!$util.isInteger(message.stopPrice))
          return "stopPrice: integer expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.reports != null && message.hasOwnProperty("reports")) {
        if (!Array.isArray(message.reports))
          return "reports: array expected";
        for (let i = 0; i < message.reports.length; ++i) {
          let error = $root.dnse.OrderReport.verify(message.reports[i]);
          if (error)
            return "reports." + error;
        }
      }
      return null;
    };
    Order.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Order)
        return object;
      let message = new $root.dnse.Order();
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorAccountId != null)
        message.investorAccountId = String(object.investorAccountId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.quantity != null)
        message.quantity = object.quantity | 0;
      switch (object.side) {
        case "UNKNOWN_SIDE":
        case 0:
          message.side = 0;
          break;
        case "BUY":
        case 1:
          message.side = 1;
          break;
        case "SELL":
        case 2:
          message.side = 2;
          break;
      }
      switch (object.orderType) {
        case "UNKNOWN_TYPE":
        case 0:
          message.orderType = 0;
          break;
        case "LO":
        case 1:
          message.orderType = 1;
          break;
        case "MP":
        case 2:
          message.orderType = 2;
          break;
        case "MTL":
        case 3:
          message.orderType = 3;
          break;
        case "MOK":
        case 4:
          message.orderType = 4;
          break;
        case "MAK":
        case 5:
          message.orderType = 5;
          break;
        case "ATO":
        case 6:
          message.orderType = 6;
          break;
        case "ATC":
        case 7:
          message.orderType = 7;
          break;
        case "PLO":
        case 8:
          message.orderType = 8;
          break;
      }
      switch (object.status) {
        case "UNKNOWN_STATUS":
        case 0:
          message.status = 0;
          break;
        case "PENDING_NEW":
        case 1:
          message.status = 1;
          break;
        case "NEW":
        case 2:
          message.status = 2;
          break;
        case "FILLED":
        case 3:
          message.status = 3;
          break;
        case "PARTIALLY_FILLED":
        case 4:
          message.status = 4;
          break;
        case "CANCELLED":
        case 5:
          message.status = 5;
          break;
        case "PENDING_CANCEL":
        case 6:
          message.status = 6;
          break;
        case "REJECTED":
        case 7:
          message.status = 7;
          break;
        case "EXPIRED":
        case 8:
          message.status = 8;
          break;
      }
      if (object.filledQuantity != null)
        message.filledQuantity = object.filledQuantity | 0;
      if (object.price != null)
        message.price = object.price | 0;
      if (object.avgPrice != null)
        message.avgPrice = Number(object.avgPrice);
      if (object.stopPrice != null)
        message.stopPrice = object.stopPrice | 0;
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.Order.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.Order.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.reports) {
        if (!Array.isArray(object.reports))
          throw TypeError(".dnse.Order.reports: array expected");
        message.reports = [];
        for (let i = 0; i < object.reports.length; ++i) {
          if (typeof object.reports[i] !== "object")
            throw TypeError(".dnse.Order.reports: object expected");
          message.reports[i] = $root.dnse.OrderReport.fromObject(object.reports[i]);
        }
      }
      return message;
    };
    Order.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.reports = [];
      if (options.defaults) {
        object.id = "";
        object.investorId = "";
        object.custodyCode = "";
        object.investorAccountId = "";
        object.symbol = "";
        object.quantity = 0;
        object.side = options.enums === String ? "UNKNOWN_SIDE" : 0;
        object.orderType = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.status = options.enums === String ? "UNKNOWN_STATUS" : 0;
        object.filledQuantity = 0;
        object.price = 0;
        object.avgPrice = 0;
        object.stopPrice = 0;
        object.createdDate = null;
        object.modifiedDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        object.quantity = message.quantity;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = options.enums === String ? $root.dnse.Order.OrderSide[message.side] : message.side;
      if (message.orderType != null && message.hasOwnProperty("orderType"))
        object.orderType = options.enums === String ? $root.dnse.Order.OrderType[message.orderType] : message.orderType;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.Order.OrderStatus[message.status] : message.status;
      if (message.filledQuantity != null && message.hasOwnProperty("filledQuantity"))
        object.filledQuantity = message.filledQuantity;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = message.price;
      if (message.avgPrice != null && message.hasOwnProperty("avgPrice"))
        object.avgPrice = options.json && !isFinite(message.avgPrice) ? String(message.avgPrice) : message.avgPrice;
      if (message.stopPrice != null && message.hasOwnProperty("stopPrice"))
        object.stopPrice = message.stopPrice;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.reports && message.reports.length) {
        object.reports = [];
        for (let j = 0; j < message.reports.length; ++j)
          object.reports[j] = $root.dnse.OrderReport.toObject(message.reports[j], options);
      }
      return object;
    };
    Order.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    Order.OrderStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_STATUS"] = 0;
      values[valuesById[1] = "PENDING_NEW"] = 1;
      values[valuesById[2] = "NEW"] = 2;
      values[valuesById[3] = "FILLED"] = 3;
      values[valuesById[4] = "PARTIALLY_FILLED"] = 4;
      values[valuesById[5] = "CANCELLED"] = 5;
      values[valuesById[6] = "PENDING_CANCEL"] = 6;
      values[valuesById[7] = "REJECTED"] = 7;
      values[valuesById[8] = "EXPIRED"] = 8;
      return values;
    }();
    Order.OrderSide = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_SIDE"] = 0;
      values[valuesById[1] = "BUY"] = 1;
      values[valuesById[2] = "SELL"] = 2;
      return values;
    }();
    Order.OrderType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_TYPE"] = 0;
      values[valuesById[1] = "LO"] = 1;
      values[valuesById[2] = "MP"] = 2;
      values[valuesById[3] = "MTL"] = 3;
      values[valuesById[4] = "MOK"] = 4;
      values[valuesById[5] = "MAK"] = 5;
      values[valuesById[6] = "ATO"] = 6;
      values[valuesById[7] = "ATC"] = 7;
      values[valuesById[8] = "PLO"] = 8;
      return values;
    }();
    return Order;
  }();
  dnse2.OrderReport = function() {
    function OrderReport(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OrderReport.prototype.matchQuantity = 0;
    OrderReport.prototype.matchPrice = 0;
    OrderReport.prototype.action = 0;
    OrderReport.prototype.createdDate = null;
    OrderReport.create = function create(properties) {
      return new OrderReport(properties);
    };
    OrderReport.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.matchQuantity != null && Object.hasOwnProperty.call(message, "matchQuantity"))
        writer.uint32(8).int32(message.matchQuantity);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(16).int32(message.matchPrice);
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(24).int32(message.action);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    OrderReport.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OrderReport.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.OrderReport();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.matchQuantity = reader.int32();
            break;
          case 2:
            message.matchPrice = reader.int32();
            break;
          case 3:
            message.action = reader.int32();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OrderReport.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OrderReport.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.matchQuantity != null && message.hasOwnProperty("matchQuantity")) {
        if (!$util.isInteger(message.matchQuantity))
          return "matchQuantity: integer expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (!$util.isInteger(message.matchPrice))
          return "matchPrice: integer expected";
      }
      if (message.action != null && message.hasOwnProperty("action"))
        switch (message.action) {
          default:
            return "action: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    OrderReport.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.OrderReport)
        return object;
      let message = new $root.dnse.OrderReport();
      if (object.matchQuantity != null)
        message.matchQuantity = object.matchQuantity | 0;
      if (object.matchPrice != null)
        message.matchPrice = object.matchPrice | 0;
      switch (object.action) {
        case "UNKNOWN":
        case 0:
          message.action = 0;
          break;
        case "NEW":
        case 1:
          message.action = 1;
          break;
        case "SENT":
        case 2:
          message.action = 2;
          break;
        case "FILL":
        case 3:
          message.action = 3;
          break;
        case "CANCEL":
        case 4:
          message.action = 4;
          break;
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.OrderReport.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    OrderReport.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.matchQuantity = 0;
        object.matchPrice = 0;
        object.action = options.enums === String ? "UNKNOWN" : 0;
        object.createdDate = null;
      }
      if (message.matchQuantity != null && message.hasOwnProperty("matchQuantity"))
        object.matchQuantity = message.matchQuantity;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = message.matchPrice;
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = options.enums === String ? $root.dnse.OrderReport.Action[message.action] : message.action;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    OrderReport.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    OrderReport.Action = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "NEW"] = 1;
      values[valuesById[2] = "SENT"] = 2;
      values[valuesById[3] = "FILL"] = 3;
      values[valuesById[4] = "CANCEL"] = 4;
      return values;
    }();
    return OrderReport;
  }();
  dnse2.AccountBalance = function() {
    function AccountBalance(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AccountBalance.prototype.id = "";
    AccountBalance.prototype.investorId = "";
    AccountBalance.prototype.custodyCode = "";
    AccountBalance.prototype.investorAccountId = "";
    AccountBalance.prototype.totalCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.termDeposit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.depositInterest = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.stockValue = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.marginableAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.nonMarginableAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.totalDebt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.netAssetValue = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.receivingAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.secureAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.depositFeeAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.maxLoanLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.withdrawableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.collateralValue = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.orderSecured = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.purchasingPower = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.cashDividendReceiving = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.marginDebt = 0;
    AccountBalance.prototype.marginRate = 0;
    AccountBalance.prototype.blockMoney = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.totalRemainDebt = 0;
    AccountBalance.prototype.totalUnrealizedDebt = 0;
    AccountBalance.prototype.ppWithdraw = 0;
    AccountBalance.prototype.createdDate = null;
    AccountBalance.prototype.modifiedDate = null;
    AccountBalance.prototype.blockedAmount = 0;
    AccountBalance.prototype.advancedAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AccountBalance.prototype.dealAccount = false;
    AccountBalance.create = function create(properties) {
      return new AccountBalance(properties);
    };
    AccountBalance.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(34).string(message.investorAccountId);
      if (message.totalCash != null && Object.hasOwnProperty.call(message, "totalCash"))
        writer.uint32(40).int64(message.totalCash);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(48).int64(message.availableCash);
      if (message.termDeposit != null && Object.hasOwnProperty.call(message, "termDeposit"))
        writer.uint32(56).int64(message.termDeposit);
      if (message.depositInterest != null && Object.hasOwnProperty.call(message, "depositInterest"))
        writer.uint32(64).int64(message.depositInterest);
      if (message.stockValue != null && Object.hasOwnProperty.call(message, "stockValue"))
        writer.uint32(72).int64(message.stockValue);
      if (message.marginableAmount != null && Object.hasOwnProperty.call(message, "marginableAmount"))
        writer.uint32(80).int64(message.marginableAmount);
      if (message.nonMarginableAmount != null && Object.hasOwnProperty.call(message, "nonMarginableAmount"))
        writer.uint32(88).int64(message.nonMarginableAmount);
      if (message.totalDebt != null && Object.hasOwnProperty.call(message, "totalDebt"))
        writer.uint32(96).int64(message.totalDebt);
      if (message.netAssetValue != null && Object.hasOwnProperty.call(message, "netAssetValue"))
        writer.uint32(104).int64(message.netAssetValue);
      if (message.receivingAmount != null && Object.hasOwnProperty.call(message, "receivingAmount"))
        writer.uint32(112).int64(message.receivingAmount);
      if (message.secureAmount != null && Object.hasOwnProperty.call(message, "secureAmount"))
        writer.uint32(120).int64(message.secureAmount);
      if (message.depositFeeAmount != null && Object.hasOwnProperty.call(message, "depositFeeAmount"))
        writer.uint32(128).int64(message.depositFeeAmount);
      if (message.maxLoanLimit != null && Object.hasOwnProperty.call(message, "maxLoanLimit"))
        writer.uint32(136).int64(message.maxLoanLimit);
      if (message.withdrawableCash != null && Object.hasOwnProperty.call(message, "withdrawableCash"))
        writer.uint32(144).int64(message.withdrawableCash);
      if (message.collateralValue != null && Object.hasOwnProperty.call(message, "collateralValue"))
        writer.uint32(152).int64(message.collateralValue);
      if (message.orderSecured != null && Object.hasOwnProperty.call(message, "orderSecured"))
        writer.uint32(160).int64(message.orderSecured);
      if (message.purchasingPower != null && Object.hasOwnProperty.call(message, "purchasingPower"))
        writer.uint32(168).int64(message.purchasingPower);
      if (message.cashDividendReceiving != null && Object.hasOwnProperty.call(message, "cashDividendReceiving"))
        writer.uint32(176).int64(message.cashDividendReceiving);
      if (message.marginDebt != null && Object.hasOwnProperty.call(message, "marginDebt"))
        writer.uint32(185).double(message.marginDebt);
      if (message.marginRate != null && Object.hasOwnProperty.call(message, "marginRate"))
        writer.uint32(193).double(message.marginRate);
      if (message.blockMoney != null && Object.hasOwnProperty.call(message, "blockMoney"))
        writer.uint32(200).int64(message.blockMoney);
      if (message.totalRemainDebt != null && Object.hasOwnProperty.call(message, "totalRemainDebt"))
        writer.uint32(209).double(message.totalRemainDebt);
      if (message.totalUnrealizedDebt != null && Object.hasOwnProperty.call(message, "totalUnrealizedDebt"))
        writer.uint32(217).double(message.totalUnrealizedDebt);
      if (message.ppWithdraw != null && Object.hasOwnProperty.call(message, "ppWithdraw"))
        writer.uint32(225).double(message.ppWithdraw);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(234).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(242).fork()).ldelim();
      if (message.blockedAmount != null && Object.hasOwnProperty.call(message, "blockedAmount"))
        writer.uint32(249).double(message.blockedAmount);
      if (message.advancedAmount != null && Object.hasOwnProperty.call(message, "advancedAmount"))
        writer.uint32(256).int64(message.advancedAmount);
      if (message.dealAccount != null && Object.hasOwnProperty.call(message, "dealAccount"))
        writer.uint32(264).bool(message.dealAccount);
      return writer;
    };
    AccountBalance.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AccountBalance.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.AccountBalance();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.investorAccountId = reader.string();
            break;
          case 5:
            message.totalCash = reader.int64();
            break;
          case 6:
            message.availableCash = reader.int64();
            break;
          case 7:
            message.termDeposit = reader.int64();
            break;
          case 8:
            message.depositInterest = reader.int64();
            break;
          case 9:
            message.stockValue = reader.int64();
            break;
          case 10:
            message.marginableAmount = reader.int64();
            break;
          case 11:
            message.nonMarginableAmount = reader.int64();
            break;
          case 12:
            message.totalDebt = reader.int64();
            break;
          case 13:
            message.netAssetValue = reader.int64();
            break;
          case 14:
            message.receivingAmount = reader.int64();
            break;
          case 15:
            message.secureAmount = reader.int64();
            break;
          case 16:
            message.depositFeeAmount = reader.int64();
            break;
          case 17:
            message.maxLoanLimit = reader.int64();
            break;
          case 18:
            message.withdrawableCash = reader.int64();
            break;
          case 19:
            message.collateralValue = reader.int64();
            break;
          case 20:
            message.orderSecured = reader.int64();
            break;
          case 21:
            message.purchasingPower = reader.int64();
            break;
          case 22:
            message.cashDividendReceiving = reader.int64();
            break;
          case 23:
            message.marginDebt = reader.double();
            break;
          case 24:
            message.marginRate = reader.double();
            break;
          case 25:
            message.blockMoney = reader.int64();
            break;
          case 26:
            message.totalRemainDebt = reader.double();
            break;
          case 27:
            message.totalUnrealizedDebt = reader.double();
            break;
          case 28:
            message.ppWithdraw = reader.double();
            break;
          case 29:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 30:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 31:
            message.blockedAmount = reader.double();
            break;
          case 32:
            message.advancedAmount = reader.int64();
            break;
          case 33:
            message.dealAccount = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AccountBalance.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AccountBalance.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isString(message.investorAccountId))
          return "investorAccountId: string expected";
      }
      if (message.totalCash != null && message.hasOwnProperty("totalCash")) {
        if (!$util.isInteger(message.totalCash) && !(message.totalCash && $util.isInteger(message.totalCash.low) && $util.isInteger(message.totalCash.high)))
          return "totalCash: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.termDeposit != null && message.hasOwnProperty("termDeposit")) {
        if (!$util.isInteger(message.termDeposit) && !(message.termDeposit && $util.isInteger(message.termDeposit.low) && $util.isInteger(message.termDeposit.high)))
          return "termDeposit: integer|Long expected";
      }
      if (message.depositInterest != null && message.hasOwnProperty("depositInterest")) {
        if (!$util.isInteger(message.depositInterest) && !(message.depositInterest && $util.isInteger(message.depositInterest.low) && $util.isInteger(message.depositInterest.high)))
          return "depositInterest: integer|Long expected";
      }
      if (message.stockValue != null && message.hasOwnProperty("stockValue")) {
        if (!$util.isInteger(message.stockValue) && !(message.stockValue && $util.isInteger(message.stockValue.low) && $util.isInteger(message.stockValue.high)))
          return "stockValue: integer|Long expected";
      }
      if (message.marginableAmount != null && message.hasOwnProperty("marginableAmount")) {
        if (!$util.isInteger(message.marginableAmount) && !(message.marginableAmount && $util.isInteger(message.marginableAmount.low) && $util.isInteger(message.marginableAmount.high)))
          return "marginableAmount: integer|Long expected";
      }
      if (message.nonMarginableAmount != null && message.hasOwnProperty("nonMarginableAmount")) {
        if (!$util.isInteger(message.nonMarginableAmount) && !(message.nonMarginableAmount && $util.isInteger(message.nonMarginableAmount.low) && $util.isInteger(message.nonMarginableAmount.high)))
          return "nonMarginableAmount: integer|Long expected";
      }
      if (message.totalDebt != null && message.hasOwnProperty("totalDebt")) {
        if (!$util.isInteger(message.totalDebt) && !(message.totalDebt && $util.isInteger(message.totalDebt.low) && $util.isInteger(message.totalDebt.high)))
          return "totalDebt: integer|Long expected";
      }
      if (message.netAssetValue != null && message.hasOwnProperty("netAssetValue")) {
        if (!$util.isInteger(message.netAssetValue) && !(message.netAssetValue && $util.isInteger(message.netAssetValue.low) && $util.isInteger(message.netAssetValue.high)))
          return "netAssetValue: integer|Long expected";
      }
      if (message.receivingAmount != null && message.hasOwnProperty("receivingAmount")) {
        if (!$util.isInteger(message.receivingAmount) && !(message.receivingAmount && $util.isInteger(message.receivingAmount.low) && $util.isInteger(message.receivingAmount.high)))
          return "receivingAmount: integer|Long expected";
      }
      if (message.secureAmount != null && message.hasOwnProperty("secureAmount")) {
        if (!$util.isInteger(message.secureAmount) && !(message.secureAmount && $util.isInteger(message.secureAmount.low) && $util.isInteger(message.secureAmount.high)))
          return "secureAmount: integer|Long expected";
      }
      if (message.depositFeeAmount != null && message.hasOwnProperty("depositFeeAmount")) {
        if (!$util.isInteger(message.depositFeeAmount) && !(message.depositFeeAmount && $util.isInteger(message.depositFeeAmount.low) && $util.isInteger(message.depositFeeAmount.high)))
          return "depositFeeAmount: integer|Long expected";
      }
      if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit")) {
        if (!$util.isInteger(message.maxLoanLimit) && !(message.maxLoanLimit && $util.isInteger(message.maxLoanLimit.low) && $util.isInteger(message.maxLoanLimit.high)))
          return "maxLoanLimit: integer|Long expected";
      }
      if (message.withdrawableCash != null && message.hasOwnProperty("withdrawableCash")) {
        if (!$util.isInteger(message.withdrawableCash) && !(message.withdrawableCash && $util.isInteger(message.withdrawableCash.low) && $util.isInteger(message.withdrawableCash.high)))
          return "withdrawableCash: integer|Long expected";
      }
      if (message.collateralValue != null && message.hasOwnProperty("collateralValue")) {
        if (!$util.isInteger(message.collateralValue) && !(message.collateralValue && $util.isInteger(message.collateralValue.low) && $util.isInteger(message.collateralValue.high)))
          return "collateralValue: integer|Long expected";
      }
      if (message.orderSecured != null && message.hasOwnProperty("orderSecured")) {
        if (!$util.isInteger(message.orderSecured) && !(message.orderSecured && $util.isInteger(message.orderSecured.low) && $util.isInteger(message.orderSecured.high)))
          return "orderSecured: integer|Long expected";
      }
      if (message.purchasingPower != null && message.hasOwnProperty("purchasingPower")) {
        if (!$util.isInteger(message.purchasingPower) && !(message.purchasingPower && $util.isInteger(message.purchasingPower.low) && $util.isInteger(message.purchasingPower.high)))
          return "purchasingPower: integer|Long expected";
      }
      if (message.cashDividendReceiving != null && message.hasOwnProperty("cashDividendReceiving")) {
        if (!$util.isInteger(message.cashDividendReceiving) && !(message.cashDividendReceiving && $util.isInteger(message.cashDividendReceiving.low) && $util.isInteger(message.cashDividendReceiving.high)))
          return "cashDividendReceiving: integer|Long expected";
      }
      if (message.marginDebt != null && message.hasOwnProperty("marginDebt")) {
        if (typeof message.marginDebt !== "number")
          return "marginDebt: number expected";
      }
      if (message.marginRate != null && message.hasOwnProperty("marginRate")) {
        if (typeof message.marginRate !== "number")
          return "marginRate: number expected";
      }
      if (message.blockMoney != null && message.hasOwnProperty("blockMoney")) {
        if (!$util.isInteger(message.blockMoney) && !(message.blockMoney && $util.isInteger(message.blockMoney.low) && $util.isInteger(message.blockMoney.high)))
          return "blockMoney: integer|Long expected";
      }
      if (message.totalRemainDebt != null && message.hasOwnProperty("totalRemainDebt")) {
        if (typeof message.totalRemainDebt !== "number")
          return "totalRemainDebt: number expected";
      }
      if (message.totalUnrealizedDebt != null && message.hasOwnProperty("totalUnrealizedDebt")) {
        if (typeof message.totalUnrealizedDebt !== "number")
          return "totalUnrealizedDebt: number expected";
      }
      if (message.ppWithdraw != null && message.hasOwnProperty("ppWithdraw")) {
        if (typeof message.ppWithdraw !== "number")
          return "ppWithdraw: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.blockedAmount != null && message.hasOwnProperty("blockedAmount")) {
        if (typeof message.blockedAmount !== "number")
          return "blockedAmount: number expected";
      }
      if (message.advancedAmount != null && message.hasOwnProperty("advancedAmount")) {
        if (!$util.isInteger(message.advancedAmount) && !(message.advancedAmount && $util.isInteger(message.advancedAmount.low) && $util.isInteger(message.advancedAmount.high)))
          return "advancedAmount: integer|Long expected";
      }
      if (message.dealAccount != null && message.hasOwnProperty("dealAccount")) {
        if (typeof message.dealAccount !== "boolean")
          return "dealAccount: boolean expected";
      }
      return null;
    };
    AccountBalance.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.AccountBalance)
        return object;
      let message = new $root.dnse.AccountBalance();
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorAccountId != null)
        message.investorAccountId = String(object.investorAccountId);
      if (object.totalCash != null) {
        if ($util.Long)
          (message.totalCash = $util.Long.fromValue(object.totalCash)).unsigned = false;
        else if (typeof object.totalCash === "string")
          message.totalCash = parseInt(object.totalCash, 10);
        else if (typeof object.totalCash === "number")
          message.totalCash = object.totalCash;
        else if (typeof object.totalCash === "object")
          message.totalCash = new $util.LongBits(object.totalCash.low >>> 0, object.totalCash.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.termDeposit != null) {
        if ($util.Long)
          (message.termDeposit = $util.Long.fromValue(object.termDeposit)).unsigned = false;
        else if (typeof object.termDeposit === "string")
          message.termDeposit = parseInt(object.termDeposit, 10);
        else if (typeof object.termDeposit === "number")
          message.termDeposit = object.termDeposit;
        else if (typeof object.termDeposit === "object")
          message.termDeposit = new $util.LongBits(object.termDeposit.low >>> 0, object.termDeposit.high >>> 0).toNumber();
      }
      if (object.depositInterest != null) {
        if ($util.Long)
          (message.depositInterest = $util.Long.fromValue(object.depositInterest)).unsigned = false;
        else if (typeof object.depositInterest === "string")
          message.depositInterest = parseInt(object.depositInterest, 10);
        else if (typeof object.depositInterest === "number")
          message.depositInterest = object.depositInterest;
        else if (typeof object.depositInterest === "object")
          message.depositInterest = new $util.LongBits(object.depositInterest.low >>> 0, object.depositInterest.high >>> 0).toNumber();
      }
      if (object.stockValue != null) {
        if ($util.Long)
          (message.stockValue = $util.Long.fromValue(object.stockValue)).unsigned = false;
        else if (typeof object.stockValue === "string")
          message.stockValue = parseInt(object.stockValue, 10);
        else if (typeof object.stockValue === "number")
          message.stockValue = object.stockValue;
        else if (typeof object.stockValue === "object")
          message.stockValue = new $util.LongBits(object.stockValue.low >>> 0, object.stockValue.high >>> 0).toNumber();
      }
      if (object.marginableAmount != null) {
        if ($util.Long)
          (message.marginableAmount = $util.Long.fromValue(object.marginableAmount)).unsigned = false;
        else if (typeof object.marginableAmount === "string")
          message.marginableAmount = parseInt(object.marginableAmount, 10);
        else if (typeof object.marginableAmount === "number")
          message.marginableAmount = object.marginableAmount;
        else if (typeof object.marginableAmount === "object")
          message.marginableAmount = new $util.LongBits(object.marginableAmount.low >>> 0, object.marginableAmount.high >>> 0).toNumber();
      }
      if (object.nonMarginableAmount != null) {
        if ($util.Long)
          (message.nonMarginableAmount = $util.Long.fromValue(object.nonMarginableAmount)).unsigned = false;
        else if (typeof object.nonMarginableAmount === "string")
          message.nonMarginableAmount = parseInt(object.nonMarginableAmount, 10);
        else if (typeof object.nonMarginableAmount === "number")
          message.nonMarginableAmount = object.nonMarginableAmount;
        else if (typeof object.nonMarginableAmount === "object")
          message.nonMarginableAmount = new $util.LongBits(object.nonMarginableAmount.low >>> 0, object.nonMarginableAmount.high >>> 0).toNumber();
      }
      if (object.totalDebt != null) {
        if ($util.Long)
          (message.totalDebt = $util.Long.fromValue(object.totalDebt)).unsigned = false;
        else if (typeof object.totalDebt === "string")
          message.totalDebt = parseInt(object.totalDebt, 10);
        else if (typeof object.totalDebt === "number")
          message.totalDebt = object.totalDebt;
        else if (typeof object.totalDebt === "object")
          message.totalDebt = new $util.LongBits(object.totalDebt.low >>> 0, object.totalDebt.high >>> 0).toNumber();
      }
      if (object.netAssetValue != null) {
        if ($util.Long)
          (message.netAssetValue = $util.Long.fromValue(object.netAssetValue)).unsigned = false;
        else if (typeof object.netAssetValue === "string")
          message.netAssetValue = parseInt(object.netAssetValue, 10);
        else if (typeof object.netAssetValue === "number")
          message.netAssetValue = object.netAssetValue;
        else if (typeof object.netAssetValue === "object")
          message.netAssetValue = new $util.LongBits(object.netAssetValue.low >>> 0, object.netAssetValue.high >>> 0).toNumber();
      }
      if (object.receivingAmount != null) {
        if ($util.Long)
          (message.receivingAmount = $util.Long.fromValue(object.receivingAmount)).unsigned = false;
        else if (typeof object.receivingAmount === "string")
          message.receivingAmount = parseInt(object.receivingAmount, 10);
        else if (typeof object.receivingAmount === "number")
          message.receivingAmount = object.receivingAmount;
        else if (typeof object.receivingAmount === "object")
          message.receivingAmount = new $util.LongBits(object.receivingAmount.low >>> 0, object.receivingAmount.high >>> 0).toNumber();
      }
      if (object.secureAmount != null) {
        if ($util.Long)
          (message.secureAmount = $util.Long.fromValue(object.secureAmount)).unsigned = false;
        else if (typeof object.secureAmount === "string")
          message.secureAmount = parseInt(object.secureAmount, 10);
        else if (typeof object.secureAmount === "number")
          message.secureAmount = object.secureAmount;
        else if (typeof object.secureAmount === "object")
          message.secureAmount = new $util.LongBits(object.secureAmount.low >>> 0, object.secureAmount.high >>> 0).toNumber();
      }
      if (object.depositFeeAmount != null) {
        if ($util.Long)
          (message.depositFeeAmount = $util.Long.fromValue(object.depositFeeAmount)).unsigned = false;
        else if (typeof object.depositFeeAmount === "string")
          message.depositFeeAmount = parseInt(object.depositFeeAmount, 10);
        else if (typeof object.depositFeeAmount === "number")
          message.depositFeeAmount = object.depositFeeAmount;
        else if (typeof object.depositFeeAmount === "object")
          message.depositFeeAmount = new $util.LongBits(object.depositFeeAmount.low >>> 0, object.depositFeeAmount.high >>> 0).toNumber();
      }
      if (object.maxLoanLimit != null) {
        if ($util.Long)
          (message.maxLoanLimit = $util.Long.fromValue(object.maxLoanLimit)).unsigned = false;
        else if (typeof object.maxLoanLimit === "string")
          message.maxLoanLimit = parseInt(object.maxLoanLimit, 10);
        else if (typeof object.maxLoanLimit === "number")
          message.maxLoanLimit = object.maxLoanLimit;
        else if (typeof object.maxLoanLimit === "object")
          message.maxLoanLimit = new $util.LongBits(object.maxLoanLimit.low >>> 0, object.maxLoanLimit.high >>> 0).toNumber();
      }
      if (object.withdrawableCash != null) {
        if ($util.Long)
          (message.withdrawableCash = $util.Long.fromValue(object.withdrawableCash)).unsigned = false;
        else if (typeof object.withdrawableCash === "string")
          message.withdrawableCash = parseInt(object.withdrawableCash, 10);
        else if (typeof object.withdrawableCash === "number")
          message.withdrawableCash = object.withdrawableCash;
        else if (typeof object.withdrawableCash === "object")
          message.withdrawableCash = new $util.LongBits(object.withdrawableCash.low >>> 0, object.withdrawableCash.high >>> 0).toNumber();
      }
      if (object.collateralValue != null) {
        if ($util.Long)
          (message.collateralValue = $util.Long.fromValue(object.collateralValue)).unsigned = false;
        else if (typeof object.collateralValue === "string")
          message.collateralValue = parseInt(object.collateralValue, 10);
        else if (typeof object.collateralValue === "number")
          message.collateralValue = object.collateralValue;
        else if (typeof object.collateralValue === "object")
          message.collateralValue = new $util.LongBits(object.collateralValue.low >>> 0, object.collateralValue.high >>> 0).toNumber();
      }
      if (object.orderSecured != null) {
        if ($util.Long)
          (message.orderSecured = $util.Long.fromValue(object.orderSecured)).unsigned = false;
        else if (typeof object.orderSecured === "string")
          message.orderSecured = parseInt(object.orderSecured, 10);
        else if (typeof object.orderSecured === "number")
          message.orderSecured = object.orderSecured;
        else if (typeof object.orderSecured === "object")
          message.orderSecured = new $util.LongBits(object.orderSecured.low >>> 0, object.orderSecured.high >>> 0).toNumber();
      }
      if (object.purchasingPower != null) {
        if ($util.Long)
          (message.purchasingPower = $util.Long.fromValue(object.purchasingPower)).unsigned = false;
        else if (typeof object.purchasingPower === "string")
          message.purchasingPower = parseInt(object.purchasingPower, 10);
        else if (typeof object.purchasingPower === "number")
          message.purchasingPower = object.purchasingPower;
        else if (typeof object.purchasingPower === "object")
          message.purchasingPower = new $util.LongBits(object.purchasingPower.low >>> 0, object.purchasingPower.high >>> 0).toNumber();
      }
      if (object.cashDividendReceiving != null) {
        if ($util.Long)
          (message.cashDividendReceiving = $util.Long.fromValue(object.cashDividendReceiving)).unsigned = false;
        else if (typeof object.cashDividendReceiving === "string")
          message.cashDividendReceiving = parseInt(object.cashDividendReceiving, 10);
        else if (typeof object.cashDividendReceiving === "number")
          message.cashDividendReceiving = object.cashDividendReceiving;
        else if (typeof object.cashDividendReceiving === "object")
          message.cashDividendReceiving = new $util.LongBits(object.cashDividendReceiving.low >>> 0, object.cashDividendReceiving.high >>> 0).toNumber();
      }
      if (object.marginDebt != null)
        message.marginDebt = Number(object.marginDebt);
      if (object.marginRate != null)
        message.marginRate = Number(object.marginRate);
      if (object.blockMoney != null) {
        if ($util.Long)
          (message.blockMoney = $util.Long.fromValue(object.blockMoney)).unsigned = false;
        else if (typeof object.blockMoney === "string")
          message.blockMoney = parseInt(object.blockMoney, 10);
        else if (typeof object.blockMoney === "number")
          message.blockMoney = object.blockMoney;
        else if (typeof object.blockMoney === "object")
          message.blockMoney = new $util.LongBits(object.blockMoney.low >>> 0, object.blockMoney.high >>> 0).toNumber();
      }
      if (object.totalRemainDebt != null)
        message.totalRemainDebt = Number(object.totalRemainDebt);
      if (object.totalUnrealizedDebt != null)
        message.totalUnrealizedDebt = Number(object.totalUnrealizedDebt);
      if (object.ppWithdraw != null)
        message.ppWithdraw = Number(object.ppWithdraw);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.AccountBalance.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.AccountBalance.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.blockedAmount != null)
        message.blockedAmount = Number(object.blockedAmount);
      if (object.advancedAmount != null) {
        if ($util.Long)
          (message.advancedAmount = $util.Long.fromValue(object.advancedAmount)).unsigned = false;
        else if (typeof object.advancedAmount === "string")
          message.advancedAmount = parseInt(object.advancedAmount, 10);
        else if (typeof object.advancedAmount === "number")
          message.advancedAmount = object.advancedAmount;
        else if (typeof object.advancedAmount === "object")
          message.advancedAmount = new $util.LongBits(object.advancedAmount.low >>> 0, object.advancedAmount.high >>> 0).toNumber();
      }
      if (object.dealAccount != null)
        message.dealAccount = Boolean(object.dealAccount);
      return message;
    };
    AccountBalance.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.investorId = "";
        object.custodyCode = "";
        object.investorAccountId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalCash = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.termDeposit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.termDeposit = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.depositInterest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.depositInterest = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.stockValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.stockValue = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.marginableAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.marginableAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.nonMarginableAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.nonMarginableAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalDebt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalDebt = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.netAssetValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.netAssetValue = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.receivingAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivingAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.secureAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.secureAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.depositFeeAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.depositFeeAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.maxLoanLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.maxLoanLimit = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.withdrawableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.withdrawableCash = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.collateralValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.collateralValue = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.orderSecured = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.orderSecured = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.purchasingPower = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.purchasingPower = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.cashDividendReceiving = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.cashDividendReceiving = options.longs === String ? "0" : 0;
        object.marginDebt = 0;
        object.marginRate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.blockMoney = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.blockMoney = options.longs === String ? "0" : 0;
        object.totalRemainDebt = 0;
        object.totalUnrealizedDebt = 0;
        object.ppWithdraw = 0;
        object.createdDate = null;
        object.modifiedDate = null;
        object.blockedAmount = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.advancedAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.advancedAmount = options.longs === String ? "0" : 0;
        object.dealAccount = false;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.totalCash != null && message.hasOwnProperty("totalCash"))
        if (typeof message.totalCash === "number")
          object.totalCash = options.longs === String ? String(message.totalCash) : message.totalCash;
        else
          object.totalCash = options.longs === String ? $util.Long.prototype.toString.call(message.totalCash) : options.longs === Number ? new $util.LongBits(message.totalCash.low >>> 0, message.totalCash.high >>> 0).toNumber() : message.totalCash;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.termDeposit != null && message.hasOwnProperty("termDeposit"))
        if (typeof message.termDeposit === "number")
          object.termDeposit = options.longs === String ? String(message.termDeposit) : message.termDeposit;
        else
          object.termDeposit = options.longs === String ? $util.Long.prototype.toString.call(message.termDeposit) : options.longs === Number ? new $util.LongBits(message.termDeposit.low >>> 0, message.termDeposit.high >>> 0).toNumber() : message.termDeposit;
      if (message.depositInterest != null && message.hasOwnProperty("depositInterest"))
        if (typeof message.depositInterest === "number")
          object.depositInterest = options.longs === String ? String(message.depositInterest) : message.depositInterest;
        else
          object.depositInterest = options.longs === String ? $util.Long.prototype.toString.call(message.depositInterest) : options.longs === Number ? new $util.LongBits(message.depositInterest.low >>> 0, message.depositInterest.high >>> 0).toNumber() : message.depositInterest;
      if (message.stockValue != null && message.hasOwnProperty("stockValue"))
        if (typeof message.stockValue === "number")
          object.stockValue = options.longs === String ? String(message.stockValue) : message.stockValue;
        else
          object.stockValue = options.longs === String ? $util.Long.prototype.toString.call(message.stockValue) : options.longs === Number ? new $util.LongBits(message.stockValue.low >>> 0, message.stockValue.high >>> 0).toNumber() : message.stockValue;
      if (message.marginableAmount != null && message.hasOwnProperty("marginableAmount"))
        if (typeof message.marginableAmount === "number")
          object.marginableAmount = options.longs === String ? String(message.marginableAmount) : message.marginableAmount;
        else
          object.marginableAmount = options.longs === String ? $util.Long.prototype.toString.call(message.marginableAmount) : options.longs === Number ? new $util.LongBits(message.marginableAmount.low >>> 0, message.marginableAmount.high >>> 0).toNumber() : message.marginableAmount;
      if (message.nonMarginableAmount != null && message.hasOwnProperty("nonMarginableAmount"))
        if (typeof message.nonMarginableAmount === "number")
          object.nonMarginableAmount = options.longs === String ? String(message.nonMarginableAmount) : message.nonMarginableAmount;
        else
          object.nonMarginableAmount = options.longs === String ? $util.Long.prototype.toString.call(message.nonMarginableAmount) : options.longs === Number ? new $util.LongBits(message.nonMarginableAmount.low >>> 0, message.nonMarginableAmount.high >>> 0).toNumber() : message.nonMarginableAmount;
      if (message.totalDebt != null && message.hasOwnProperty("totalDebt"))
        if (typeof message.totalDebt === "number")
          object.totalDebt = options.longs === String ? String(message.totalDebt) : message.totalDebt;
        else
          object.totalDebt = options.longs === String ? $util.Long.prototype.toString.call(message.totalDebt) : options.longs === Number ? new $util.LongBits(message.totalDebt.low >>> 0, message.totalDebt.high >>> 0).toNumber() : message.totalDebt;
      if (message.netAssetValue != null && message.hasOwnProperty("netAssetValue"))
        if (typeof message.netAssetValue === "number")
          object.netAssetValue = options.longs === String ? String(message.netAssetValue) : message.netAssetValue;
        else
          object.netAssetValue = options.longs === String ? $util.Long.prototype.toString.call(message.netAssetValue) : options.longs === Number ? new $util.LongBits(message.netAssetValue.low >>> 0, message.netAssetValue.high >>> 0).toNumber() : message.netAssetValue;
      if (message.receivingAmount != null && message.hasOwnProperty("receivingAmount"))
        if (typeof message.receivingAmount === "number")
          object.receivingAmount = options.longs === String ? String(message.receivingAmount) : message.receivingAmount;
        else
          object.receivingAmount = options.longs === String ? $util.Long.prototype.toString.call(message.receivingAmount) : options.longs === Number ? new $util.LongBits(message.receivingAmount.low >>> 0, message.receivingAmount.high >>> 0).toNumber() : message.receivingAmount;
      if (message.secureAmount != null && message.hasOwnProperty("secureAmount"))
        if (typeof message.secureAmount === "number")
          object.secureAmount = options.longs === String ? String(message.secureAmount) : message.secureAmount;
        else
          object.secureAmount = options.longs === String ? $util.Long.prototype.toString.call(message.secureAmount) : options.longs === Number ? new $util.LongBits(message.secureAmount.low >>> 0, message.secureAmount.high >>> 0).toNumber() : message.secureAmount;
      if (message.depositFeeAmount != null && message.hasOwnProperty("depositFeeAmount"))
        if (typeof message.depositFeeAmount === "number")
          object.depositFeeAmount = options.longs === String ? String(message.depositFeeAmount) : message.depositFeeAmount;
        else
          object.depositFeeAmount = options.longs === String ? $util.Long.prototype.toString.call(message.depositFeeAmount) : options.longs === Number ? new $util.LongBits(message.depositFeeAmount.low >>> 0, message.depositFeeAmount.high >>> 0).toNumber() : message.depositFeeAmount;
      if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit"))
        if (typeof message.maxLoanLimit === "number")
          object.maxLoanLimit = options.longs === String ? String(message.maxLoanLimit) : message.maxLoanLimit;
        else
          object.maxLoanLimit = options.longs === String ? $util.Long.prototype.toString.call(message.maxLoanLimit) : options.longs === Number ? new $util.LongBits(message.maxLoanLimit.low >>> 0, message.maxLoanLimit.high >>> 0).toNumber() : message.maxLoanLimit;
      if (message.withdrawableCash != null && message.hasOwnProperty("withdrawableCash"))
        if (typeof message.withdrawableCash === "number")
          object.withdrawableCash = options.longs === String ? String(message.withdrawableCash) : message.withdrawableCash;
        else
          object.withdrawableCash = options.longs === String ? $util.Long.prototype.toString.call(message.withdrawableCash) : options.longs === Number ? new $util.LongBits(message.withdrawableCash.low >>> 0, message.withdrawableCash.high >>> 0).toNumber() : message.withdrawableCash;
      if (message.collateralValue != null && message.hasOwnProperty("collateralValue"))
        if (typeof message.collateralValue === "number")
          object.collateralValue = options.longs === String ? String(message.collateralValue) : message.collateralValue;
        else
          object.collateralValue = options.longs === String ? $util.Long.prototype.toString.call(message.collateralValue) : options.longs === Number ? new $util.LongBits(message.collateralValue.low >>> 0, message.collateralValue.high >>> 0).toNumber() : message.collateralValue;
      if (message.orderSecured != null && message.hasOwnProperty("orderSecured"))
        if (typeof message.orderSecured === "number")
          object.orderSecured = options.longs === String ? String(message.orderSecured) : message.orderSecured;
        else
          object.orderSecured = options.longs === String ? $util.Long.prototype.toString.call(message.orderSecured) : options.longs === Number ? new $util.LongBits(message.orderSecured.low >>> 0, message.orderSecured.high >>> 0).toNumber() : message.orderSecured;
      if (message.purchasingPower != null && message.hasOwnProperty("purchasingPower"))
        if (typeof message.purchasingPower === "number")
          object.purchasingPower = options.longs === String ? String(message.purchasingPower) : message.purchasingPower;
        else
          object.purchasingPower = options.longs === String ? $util.Long.prototype.toString.call(message.purchasingPower) : options.longs === Number ? new $util.LongBits(message.purchasingPower.low >>> 0, message.purchasingPower.high >>> 0).toNumber() : message.purchasingPower;
      if (message.cashDividendReceiving != null && message.hasOwnProperty("cashDividendReceiving"))
        if (typeof message.cashDividendReceiving === "number")
          object.cashDividendReceiving = options.longs === String ? String(message.cashDividendReceiving) : message.cashDividendReceiving;
        else
          object.cashDividendReceiving = options.longs === String ? $util.Long.prototype.toString.call(message.cashDividendReceiving) : options.longs === Number ? new $util.LongBits(message.cashDividendReceiving.low >>> 0, message.cashDividendReceiving.high >>> 0).toNumber() : message.cashDividendReceiving;
      if (message.marginDebt != null && message.hasOwnProperty("marginDebt"))
        object.marginDebt = options.json && !isFinite(message.marginDebt) ? String(message.marginDebt) : message.marginDebt;
      if (message.marginRate != null && message.hasOwnProperty("marginRate"))
        object.marginRate = options.json && !isFinite(message.marginRate) ? String(message.marginRate) : message.marginRate;
      if (message.blockMoney != null && message.hasOwnProperty("blockMoney"))
        if (typeof message.blockMoney === "number")
          object.blockMoney = options.longs === String ? String(message.blockMoney) : message.blockMoney;
        else
          object.blockMoney = options.longs === String ? $util.Long.prototype.toString.call(message.blockMoney) : options.longs === Number ? new $util.LongBits(message.blockMoney.low >>> 0, message.blockMoney.high >>> 0).toNumber() : message.blockMoney;
      if (message.totalRemainDebt != null && message.hasOwnProperty("totalRemainDebt"))
        object.totalRemainDebt = options.json && !isFinite(message.totalRemainDebt) ? String(message.totalRemainDebt) : message.totalRemainDebt;
      if (message.totalUnrealizedDebt != null && message.hasOwnProperty("totalUnrealizedDebt"))
        object.totalUnrealizedDebt = options.json && !isFinite(message.totalUnrealizedDebt) ? String(message.totalUnrealizedDebt) : message.totalUnrealizedDebt;
      if (message.ppWithdraw != null && message.hasOwnProperty("ppWithdraw"))
        object.ppWithdraw = options.json && !isFinite(message.ppWithdraw) ? String(message.ppWithdraw) : message.ppWithdraw;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.blockedAmount != null && message.hasOwnProperty("blockedAmount"))
        object.blockedAmount = options.json && !isFinite(message.blockedAmount) ? String(message.blockedAmount) : message.blockedAmount;
      if (message.advancedAmount != null && message.hasOwnProperty("advancedAmount"))
        if (typeof message.advancedAmount === "number")
          object.advancedAmount = options.longs === String ? String(message.advancedAmount) : message.advancedAmount;
        else
          object.advancedAmount = options.longs === String ? $util.Long.prototype.toString.call(message.advancedAmount) : options.longs === Number ? new $util.LongBits(message.advancedAmount.low >>> 0, message.advancedAmount.high >>> 0).toNumber() : message.advancedAmount;
      if (message.dealAccount != null && message.hasOwnProperty("dealAccount"))
        object.dealAccount = message.dealAccount;
      return object;
    };
    AccountBalance.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return AccountBalance;
  }();
  dnse2.PortfolioItem = function() {
    function PortfolioItem(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    PortfolioItem.prototype.symbol = "";
    PortfolioItem.prototype.totalQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.tradeQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.blockedQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.vsdMortgage = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.mortgage = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.restrict = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.receivingRightQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.receivingT0Quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.receivingT1Quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.receivingT2Quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.costPrice = 0;
    PortfolioItem.prototype.initialValue = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.stockValue = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.marketPrice = 0;
    PortfolioItem.prototype.marginRatio = 0;
    PortfolioItem.prototype.requiredMarginAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.marginAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.unrealizedProfit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PortfolioItem.prototype.unrealizedProfitRate = 0;
    PortfolioItem.create = function create(properties) {
      return new PortfolioItem(properties);
    };
    PortfolioItem.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.totalQuantity != null && Object.hasOwnProperty.call(message, "totalQuantity"))
        writer.uint32(16).int64(message.totalQuantity);
      if (message.tradeQuantity != null && Object.hasOwnProperty.call(message, "tradeQuantity"))
        writer.uint32(24).int64(message.tradeQuantity);
      if (message.blockedQuantity != null && Object.hasOwnProperty.call(message, "blockedQuantity"))
        writer.uint32(32).int64(message.blockedQuantity);
      if (message.vsdMortgage != null && Object.hasOwnProperty.call(message, "vsdMortgage"))
        writer.uint32(40).int64(message.vsdMortgage);
      if (message.mortgage != null && Object.hasOwnProperty.call(message, "mortgage"))
        writer.uint32(48).int64(message.mortgage);
      if (message.restrict != null && Object.hasOwnProperty.call(message, "restrict"))
        writer.uint32(56).int64(message.restrict);
      if (message.receivingRightQuantity != null && Object.hasOwnProperty.call(message, "receivingRightQuantity"))
        writer.uint32(64).int64(message.receivingRightQuantity);
      if (message.receivingT0Quantity != null && Object.hasOwnProperty.call(message, "receivingT0Quantity"))
        writer.uint32(72).int64(message.receivingT0Quantity);
      if (message.receivingT1Quantity != null && Object.hasOwnProperty.call(message, "receivingT1Quantity"))
        writer.uint32(80).int64(message.receivingT1Quantity);
      if (message.receivingT2Quantity != null && Object.hasOwnProperty.call(message, "receivingT2Quantity"))
        writer.uint32(88).int64(message.receivingT2Quantity);
      if (message.costPrice != null && Object.hasOwnProperty.call(message, "costPrice"))
        writer.uint32(97).double(message.costPrice);
      if (message.initialValue != null && Object.hasOwnProperty.call(message, "initialValue"))
        writer.uint32(104).int64(message.initialValue);
      if (message.stockValue != null && Object.hasOwnProperty.call(message, "stockValue"))
        writer.uint32(112).int64(message.stockValue);
      if (message.marketPrice != null && Object.hasOwnProperty.call(message, "marketPrice"))
        writer.uint32(121).double(message.marketPrice);
      if (message.marginRatio != null && Object.hasOwnProperty.call(message, "marginRatio"))
        writer.uint32(129).double(message.marginRatio);
      if (message.requiredMarginAmount != null && Object.hasOwnProperty.call(message, "requiredMarginAmount"))
        writer.uint32(136).int64(message.requiredMarginAmount);
      if (message.marginAmount != null && Object.hasOwnProperty.call(message, "marginAmount"))
        writer.uint32(144).int64(message.marginAmount);
      if (message.unrealizedProfit != null && Object.hasOwnProperty.call(message, "unrealizedProfit"))
        writer.uint32(152).int64(message.unrealizedProfit);
      if (message.unrealizedProfitRate != null && Object.hasOwnProperty.call(message, "unrealizedProfitRate"))
        writer.uint32(161).double(message.unrealizedProfitRate);
      return writer;
    };
    PortfolioItem.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    PortfolioItem.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.PortfolioItem();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.totalQuantity = reader.int64();
            break;
          case 3:
            message.tradeQuantity = reader.int64();
            break;
          case 4:
            message.blockedQuantity = reader.int64();
            break;
          case 5:
            message.vsdMortgage = reader.int64();
            break;
          case 6:
            message.mortgage = reader.int64();
            break;
          case 7:
            message.restrict = reader.int64();
            break;
          case 8:
            message.receivingRightQuantity = reader.int64();
            break;
          case 9:
            message.receivingT0Quantity = reader.int64();
            break;
          case 10:
            message.receivingT1Quantity = reader.int64();
            break;
          case 11:
            message.receivingT2Quantity = reader.int64();
            break;
          case 12:
            message.costPrice = reader.double();
            break;
          case 13:
            message.initialValue = reader.int64();
            break;
          case 14:
            message.stockValue = reader.int64();
            break;
          case 15:
            message.marketPrice = reader.double();
            break;
          case 16:
            message.marginRatio = reader.double();
            break;
          case 17:
            message.requiredMarginAmount = reader.int64();
            break;
          case 18:
            message.marginAmount = reader.int64();
            break;
          case 19:
            message.unrealizedProfit = reader.int64();
            break;
          case 20:
            message.unrealizedProfitRate = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    PortfolioItem.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    PortfolioItem.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.totalQuantity != null && message.hasOwnProperty("totalQuantity")) {
        if (!$util.isInteger(message.totalQuantity) && !(message.totalQuantity && $util.isInteger(message.totalQuantity.low) && $util.isInteger(message.totalQuantity.high)))
          return "totalQuantity: integer|Long expected";
      }
      if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity")) {
        if (!$util.isInteger(message.tradeQuantity) && !(message.tradeQuantity && $util.isInteger(message.tradeQuantity.low) && $util.isInteger(message.tradeQuantity.high)))
          return "tradeQuantity: integer|Long expected";
      }
      if (message.blockedQuantity != null && message.hasOwnProperty("blockedQuantity")) {
        if (!$util.isInteger(message.blockedQuantity) && !(message.blockedQuantity && $util.isInteger(message.blockedQuantity.low) && $util.isInteger(message.blockedQuantity.high)))
          return "blockedQuantity: integer|Long expected";
      }
      if (message.vsdMortgage != null && message.hasOwnProperty("vsdMortgage")) {
        if (!$util.isInteger(message.vsdMortgage) && !(message.vsdMortgage && $util.isInteger(message.vsdMortgage.low) && $util.isInteger(message.vsdMortgage.high)))
          return "vsdMortgage: integer|Long expected";
      }
      if (message.mortgage != null && message.hasOwnProperty("mortgage")) {
        if (!$util.isInteger(message.mortgage) && !(message.mortgage && $util.isInteger(message.mortgage.low) && $util.isInteger(message.mortgage.high)))
          return "mortgage: integer|Long expected";
      }
      if (message.restrict != null && message.hasOwnProperty("restrict")) {
        if (!$util.isInteger(message.restrict) && !(message.restrict && $util.isInteger(message.restrict.low) && $util.isInteger(message.restrict.high)))
          return "restrict: integer|Long expected";
      }
      if (message.receivingRightQuantity != null && message.hasOwnProperty("receivingRightQuantity")) {
        if (!$util.isInteger(message.receivingRightQuantity) && !(message.receivingRightQuantity && $util.isInteger(message.receivingRightQuantity.low) && $util.isInteger(message.receivingRightQuantity.high)))
          return "receivingRightQuantity: integer|Long expected";
      }
      if (message.receivingT0Quantity != null && message.hasOwnProperty("receivingT0Quantity")) {
        if (!$util.isInteger(message.receivingT0Quantity) && !(message.receivingT0Quantity && $util.isInteger(message.receivingT0Quantity.low) && $util.isInteger(message.receivingT0Quantity.high)))
          return "receivingT0Quantity: integer|Long expected";
      }
      if (message.receivingT1Quantity != null && message.hasOwnProperty("receivingT1Quantity")) {
        if (!$util.isInteger(message.receivingT1Quantity) && !(message.receivingT1Quantity && $util.isInteger(message.receivingT1Quantity.low) && $util.isInteger(message.receivingT1Quantity.high)))
          return "receivingT1Quantity: integer|Long expected";
      }
      if (message.receivingT2Quantity != null && message.hasOwnProperty("receivingT2Quantity")) {
        if (!$util.isInteger(message.receivingT2Quantity) && !(message.receivingT2Quantity && $util.isInteger(message.receivingT2Quantity.low) && $util.isInteger(message.receivingT2Quantity.high)))
          return "receivingT2Quantity: integer|Long expected";
      }
      if (message.costPrice != null && message.hasOwnProperty("costPrice")) {
        if (typeof message.costPrice !== "number")
          return "costPrice: number expected";
      }
      if (message.initialValue != null && message.hasOwnProperty("initialValue")) {
        if (!$util.isInteger(message.initialValue) && !(message.initialValue && $util.isInteger(message.initialValue.low) && $util.isInteger(message.initialValue.high)))
          return "initialValue: integer|Long expected";
      }
      if (message.stockValue != null && message.hasOwnProperty("stockValue")) {
        if (!$util.isInteger(message.stockValue) && !(message.stockValue && $util.isInteger(message.stockValue.low) && $util.isInteger(message.stockValue.high)))
          return "stockValue: integer|Long expected";
      }
      if (message.marketPrice != null && message.hasOwnProperty("marketPrice")) {
        if (typeof message.marketPrice !== "number")
          return "marketPrice: number expected";
      }
      if (message.marginRatio != null && message.hasOwnProperty("marginRatio")) {
        if (typeof message.marginRatio !== "number")
          return "marginRatio: number expected";
      }
      if (message.requiredMarginAmount != null && message.hasOwnProperty("requiredMarginAmount")) {
        if (!$util.isInteger(message.requiredMarginAmount) && !(message.requiredMarginAmount && $util.isInteger(message.requiredMarginAmount.low) && $util.isInteger(message.requiredMarginAmount.high)))
          return "requiredMarginAmount: integer|Long expected";
      }
      if (message.marginAmount != null && message.hasOwnProperty("marginAmount")) {
        if (!$util.isInteger(message.marginAmount) && !(message.marginAmount && $util.isInteger(message.marginAmount.low) && $util.isInteger(message.marginAmount.high)))
          return "marginAmount: integer|Long expected";
      }
      if (message.unrealizedProfit != null && message.hasOwnProperty("unrealizedProfit")) {
        if (!$util.isInteger(message.unrealizedProfit) && !(message.unrealizedProfit && $util.isInteger(message.unrealizedProfit.low) && $util.isInteger(message.unrealizedProfit.high)))
          return "unrealizedProfit: integer|Long expected";
      }
      if (message.unrealizedProfitRate != null && message.hasOwnProperty("unrealizedProfitRate")) {
        if (typeof message.unrealizedProfitRate !== "number")
          return "unrealizedProfitRate: number expected";
      }
      return null;
    };
    PortfolioItem.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.PortfolioItem)
        return object;
      let message = new $root.dnse.PortfolioItem();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.totalQuantity != null) {
        if ($util.Long)
          (message.totalQuantity = $util.Long.fromValue(object.totalQuantity)).unsigned = false;
        else if (typeof object.totalQuantity === "string")
          message.totalQuantity = parseInt(object.totalQuantity, 10);
        else if (typeof object.totalQuantity === "number")
          message.totalQuantity = object.totalQuantity;
        else if (typeof object.totalQuantity === "object")
          message.totalQuantity = new $util.LongBits(object.totalQuantity.low >>> 0, object.totalQuantity.high >>> 0).toNumber();
      }
      if (object.tradeQuantity != null) {
        if ($util.Long)
          (message.tradeQuantity = $util.Long.fromValue(object.tradeQuantity)).unsigned = false;
        else if (typeof object.tradeQuantity === "string")
          message.tradeQuantity = parseInt(object.tradeQuantity, 10);
        else if (typeof object.tradeQuantity === "number")
          message.tradeQuantity = object.tradeQuantity;
        else if (typeof object.tradeQuantity === "object")
          message.tradeQuantity = new $util.LongBits(object.tradeQuantity.low >>> 0, object.tradeQuantity.high >>> 0).toNumber();
      }
      if (object.blockedQuantity != null) {
        if ($util.Long)
          (message.blockedQuantity = $util.Long.fromValue(object.blockedQuantity)).unsigned = false;
        else if (typeof object.blockedQuantity === "string")
          message.blockedQuantity = parseInt(object.blockedQuantity, 10);
        else if (typeof object.blockedQuantity === "number")
          message.blockedQuantity = object.blockedQuantity;
        else if (typeof object.blockedQuantity === "object")
          message.blockedQuantity = new $util.LongBits(object.blockedQuantity.low >>> 0, object.blockedQuantity.high >>> 0).toNumber();
      }
      if (object.vsdMortgage != null) {
        if ($util.Long)
          (message.vsdMortgage = $util.Long.fromValue(object.vsdMortgage)).unsigned = false;
        else if (typeof object.vsdMortgage === "string")
          message.vsdMortgage = parseInt(object.vsdMortgage, 10);
        else if (typeof object.vsdMortgage === "number")
          message.vsdMortgage = object.vsdMortgage;
        else if (typeof object.vsdMortgage === "object")
          message.vsdMortgage = new $util.LongBits(object.vsdMortgage.low >>> 0, object.vsdMortgage.high >>> 0).toNumber();
      }
      if (object.mortgage != null) {
        if ($util.Long)
          (message.mortgage = $util.Long.fromValue(object.mortgage)).unsigned = false;
        else if (typeof object.mortgage === "string")
          message.mortgage = parseInt(object.mortgage, 10);
        else if (typeof object.mortgage === "number")
          message.mortgage = object.mortgage;
        else if (typeof object.mortgage === "object")
          message.mortgage = new $util.LongBits(object.mortgage.low >>> 0, object.mortgage.high >>> 0).toNumber();
      }
      if (object.restrict != null) {
        if ($util.Long)
          (message.restrict = $util.Long.fromValue(object.restrict)).unsigned = false;
        else if (typeof object.restrict === "string")
          message.restrict = parseInt(object.restrict, 10);
        else if (typeof object.restrict === "number")
          message.restrict = object.restrict;
        else if (typeof object.restrict === "object")
          message.restrict = new $util.LongBits(object.restrict.low >>> 0, object.restrict.high >>> 0).toNumber();
      }
      if (object.receivingRightQuantity != null) {
        if ($util.Long)
          (message.receivingRightQuantity = $util.Long.fromValue(object.receivingRightQuantity)).unsigned = false;
        else if (typeof object.receivingRightQuantity === "string")
          message.receivingRightQuantity = parseInt(object.receivingRightQuantity, 10);
        else if (typeof object.receivingRightQuantity === "number")
          message.receivingRightQuantity = object.receivingRightQuantity;
        else if (typeof object.receivingRightQuantity === "object")
          message.receivingRightQuantity = new $util.LongBits(object.receivingRightQuantity.low >>> 0, object.receivingRightQuantity.high >>> 0).toNumber();
      }
      if (object.receivingT0Quantity != null) {
        if ($util.Long)
          (message.receivingT0Quantity = $util.Long.fromValue(object.receivingT0Quantity)).unsigned = false;
        else if (typeof object.receivingT0Quantity === "string")
          message.receivingT0Quantity = parseInt(object.receivingT0Quantity, 10);
        else if (typeof object.receivingT0Quantity === "number")
          message.receivingT0Quantity = object.receivingT0Quantity;
        else if (typeof object.receivingT0Quantity === "object")
          message.receivingT0Quantity = new $util.LongBits(object.receivingT0Quantity.low >>> 0, object.receivingT0Quantity.high >>> 0).toNumber();
      }
      if (object.receivingT1Quantity != null) {
        if ($util.Long)
          (message.receivingT1Quantity = $util.Long.fromValue(object.receivingT1Quantity)).unsigned = false;
        else if (typeof object.receivingT1Quantity === "string")
          message.receivingT1Quantity = parseInt(object.receivingT1Quantity, 10);
        else if (typeof object.receivingT1Quantity === "number")
          message.receivingT1Quantity = object.receivingT1Quantity;
        else if (typeof object.receivingT1Quantity === "object")
          message.receivingT1Quantity = new $util.LongBits(object.receivingT1Quantity.low >>> 0, object.receivingT1Quantity.high >>> 0).toNumber();
      }
      if (object.receivingT2Quantity != null) {
        if ($util.Long)
          (message.receivingT2Quantity = $util.Long.fromValue(object.receivingT2Quantity)).unsigned = false;
        else if (typeof object.receivingT2Quantity === "string")
          message.receivingT2Quantity = parseInt(object.receivingT2Quantity, 10);
        else if (typeof object.receivingT2Quantity === "number")
          message.receivingT2Quantity = object.receivingT2Quantity;
        else if (typeof object.receivingT2Quantity === "object")
          message.receivingT2Quantity = new $util.LongBits(object.receivingT2Quantity.low >>> 0, object.receivingT2Quantity.high >>> 0).toNumber();
      }
      if (object.costPrice != null)
        message.costPrice = Number(object.costPrice);
      if (object.initialValue != null) {
        if ($util.Long)
          (message.initialValue = $util.Long.fromValue(object.initialValue)).unsigned = false;
        else if (typeof object.initialValue === "string")
          message.initialValue = parseInt(object.initialValue, 10);
        else if (typeof object.initialValue === "number")
          message.initialValue = object.initialValue;
        else if (typeof object.initialValue === "object")
          message.initialValue = new $util.LongBits(object.initialValue.low >>> 0, object.initialValue.high >>> 0).toNumber();
      }
      if (object.stockValue != null) {
        if ($util.Long)
          (message.stockValue = $util.Long.fromValue(object.stockValue)).unsigned = false;
        else if (typeof object.stockValue === "string")
          message.stockValue = parseInt(object.stockValue, 10);
        else if (typeof object.stockValue === "number")
          message.stockValue = object.stockValue;
        else if (typeof object.stockValue === "object")
          message.stockValue = new $util.LongBits(object.stockValue.low >>> 0, object.stockValue.high >>> 0).toNumber();
      }
      if (object.marketPrice != null)
        message.marketPrice = Number(object.marketPrice);
      if (object.marginRatio != null)
        message.marginRatio = Number(object.marginRatio);
      if (object.requiredMarginAmount != null) {
        if ($util.Long)
          (message.requiredMarginAmount = $util.Long.fromValue(object.requiredMarginAmount)).unsigned = false;
        else if (typeof object.requiredMarginAmount === "string")
          message.requiredMarginAmount = parseInt(object.requiredMarginAmount, 10);
        else if (typeof object.requiredMarginAmount === "number")
          message.requiredMarginAmount = object.requiredMarginAmount;
        else if (typeof object.requiredMarginAmount === "object")
          message.requiredMarginAmount = new $util.LongBits(object.requiredMarginAmount.low >>> 0, object.requiredMarginAmount.high >>> 0).toNumber();
      }
      if (object.marginAmount != null) {
        if ($util.Long)
          (message.marginAmount = $util.Long.fromValue(object.marginAmount)).unsigned = false;
        else if (typeof object.marginAmount === "string")
          message.marginAmount = parseInt(object.marginAmount, 10);
        else if (typeof object.marginAmount === "number")
          message.marginAmount = object.marginAmount;
        else if (typeof object.marginAmount === "object")
          message.marginAmount = new $util.LongBits(object.marginAmount.low >>> 0, object.marginAmount.high >>> 0).toNumber();
      }
      if (object.unrealizedProfit != null) {
        if ($util.Long)
          (message.unrealizedProfit = $util.Long.fromValue(object.unrealizedProfit)).unsigned = false;
        else if (typeof object.unrealizedProfit === "string")
          message.unrealizedProfit = parseInt(object.unrealizedProfit, 10);
        else if (typeof object.unrealizedProfit === "number")
          message.unrealizedProfit = object.unrealizedProfit;
        else if (typeof object.unrealizedProfit === "object")
          message.unrealizedProfit = new $util.LongBits(object.unrealizedProfit.low >>> 0, object.unrealizedProfit.high >>> 0).toNumber();
      }
      if (object.unrealizedProfitRate != null)
        message.unrealizedProfitRate = Number(object.unrealizedProfitRate);
      return message;
    };
    PortfolioItem.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradeQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tradeQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.blockedQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.blockedQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.vsdMortgage = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.vsdMortgage = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.mortgage = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.mortgage = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.restrict = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.restrict = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.receivingRightQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivingRightQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.receivingT0Quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivingT0Quantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.receivingT1Quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivingT1Quantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.receivingT2Quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivingT2Quantity = options.longs === String ? "0" : 0;
        object.costPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.initialValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.initialValue = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.stockValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.stockValue = options.longs === String ? "0" : 0;
        object.marketPrice = 0;
        object.marginRatio = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.requiredMarginAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.requiredMarginAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.marginAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.marginAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.unrealizedProfit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.unrealizedProfit = options.longs === String ? "0" : 0;
        object.unrealizedProfitRate = 0;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.totalQuantity != null && message.hasOwnProperty("totalQuantity"))
        if (typeof message.totalQuantity === "number")
          object.totalQuantity = options.longs === String ? String(message.totalQuantity) : message.totalQuantity;
        else
          object.totalQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.totalQuantity) : options.longs === Number ? new $util.LongBits(message.totalQuantity.low >>> 0, message.totalQuantity.high >>> 0).toNumber() : message.totalQuantity;
      if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity"))
        if (typeof message.tradeQuantity === "number")
          object.tradeQuantity = options.longs === String ? String(message.tradeQuantity) : message.tradeQuantity;
        else
          object.tradeQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.tradeQuantity) : options.longs === Number ? new $util.LongBits(message.tradeQuantity.low >>> 0, message.tradeQuantity.high >>> 0).toNumber() : message.tradeQuantity;
      if (message.blockedQuantity != null && message.hasOwnProperty("blockedQuantity"))
        if (typeof message.blockedQuantity === "number")
          object.blockedQuantity = options.longs === String ? String(message.blockedQuantity) : message.blockedQuantity;
        else
          object.blockedQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.blockedQuantity) : options.longs === Number ? new $util.LongBits(message.blockedQuantity.low >>> 0, message.blockedQuantity.high >>> 0).toNumber() : message.blockedQuantity;
      if (message.vsdMortgage != null && message.hasOwnProperty("vsdMortgage"))
        if (typeof message.vsdMortgage === "number")
          object.vsdMortgage = options.longs === String ? String(message.vsdMortgage) : message.vsdMortgage;
        else
          object.vsdMortgage = options.longs === String ? $util.Long.prototype.toString.call(message.vsdMortgage) : options.longs === Number ? new $util.LongBits(message.vsdMortgage.low >>> 0, message.vsdMortgage.high >>> 0).toNumber() : message.vsdMortgage;
      if (message.mortgage != null && message.hasOwnProperty("mortgage"))
        if (typeof message.mortgage === "number")
          object.mortgage = options.longs === String ? String(message.mortgage) : message.mortgage;
        else
          object.mortgage = options.longs === String ? $util.Long.prototype.toString.call(message.mortgage) : options.longs === Number ? new $util.LongBits(message.mortgage.low >>> 0, message.mortgage.high >>> 0).toNumber() : message.mortgage;
      if (message.restrict != null && message.hasOwnProperty("restrict"))
        if (typeof message.restrict === "number")
          object.restrict = options.longs === String ? String(message.restrict) : message.restrict;
        else
          object.restrict = options.longs === String ? $util.Long.prototype.toString.call(message.restrict) : options.longs === Number ? new $util.LongBits(message.restrict.low >>> 0, message.restrict.high >>> 0).toNumber() : message.restrict;
      if (message.receivingRightQuantity != null && message.hasOwnProperty("receivingRightQuantity"))
        if (typeof message.receivingRightQuantity === "number")
          object.receivingRightQuantity = options.longs === String ? String(message.receivingRightQuantity) : message.receivingRightQuantity;
        else
          object.receivingRightQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.receivingRightQuantity) : options.longs === Number ? new $util.LongBits(message.receivingRightQuantity.low >>> 0, message.receivingRightQuantity.high >>> 0).toNumber() : message.receivingRightQuantity;
      if (message.receivingT0Quantity != null && message.hasOwnProperty("receivingT0Quantity"))
        if (typeof message.receivingT0Quantity === "number")
          object.receivingT0Quantity = options.longs === String ? String(message.receivingT0Quantity) : message.receivingT0Quantity;
        else
          object.receivingT0Quantity = options.longs === String ? $util.Long.prototype.toString.call(message.receivingT0Quantity) : options.longs === Number ? new $util.LongBits(message.receivingT0Quantity.low >>> 0, message.receivingT0Quantity.high >>> 0).toNumber() : message.receivingT0Quantity;
      if (message.receivingT1Quantity != null && message.hasOwnProperty("receivingT1Quantity"))
        if (typeof message.receivingT1Quantity === "number")
          object.receivingT1Quantity = options.longs === String ? String(message.receivingT1Quantity) : message.receivingT1Quantity;
        else
          object.receivingT1Quantity = options.longs === String ? $util.Long.prototype.toString.call(message.receivingT1Quantity) : options.longs === Number ? new $util.LongBits(message.receivingT1Quantity.low >>> 0, message.receivingT1Quantity.high >>> 0).toNumber() : message.receivingT1Quantity;
      if (message.receivingT2Quantity != null && message.hasOwnProperty("receivingT2Quantity"))
        if (typeof message.receivingT2Quantity === "number")
          object.receivingT2Quantity = options.longs === String ? String(message.receivingT2Quantity) : message.receivingT2Quantity;
        else
          object.receivingT2Quantity = options.longs === String ? $util.Long.prototype.toString.call(message.receivingT2Quantity) : options.longs === Number ? new $util.LongBits(message.receivingT2Quantity.low >>> 0, message.receivingT2Quantity.high >>> 0).toNumber() : message.receivingT2Quantity;
      if (message.costPrice != null && message.hasOwnProperty("costPrice"))
        object.costPrice = options.json && !isFinite(message.costPrice) ? String(message.costPrice) : message.costPrice;
      if (message.initialValue != null && message.hasOwnProperty("initialValue"))
        if (typeof message.initialValue === "number")
          object.initialValue = options.longs === String ? String(message.initialValue) : message.initialValue;
        else
          object.initialValue = options.longs === String ? $util.Long.prototype.toString.call(message.initialValue) : options.longs === Number ? new $util.LongBits(message.initialValue.low >>> 0, message.initialValue.high >>> 0).toNumber() : message.initialValue;
      if (message.stockValue != null && message.hasOwnProperty("stockValue"))
        if (typeof message.stockValue === "number")
          object.stockValue = options.longs === String ? String(message.stockValue) : message.stockValue;
        else
          object.stockValue = options.longs === String ? $util.Long.prototype.toString.call(message.stockValue) : options.longs === Number ? new $util.LongBits(message.stockValue.low >>> 0, message.stockValue.high >>> 0).toNumber() : message.stockValue;
      if (message.marketPrice != null && message.hasOwnProperty("marketPrice"))
        object.marketPrice = options.json && !isFinite(message.marketPrice) ? String(message.marketPrice) : message.marketPrice;
      if (message.marginRatio != null && message.hasOwnProperty("marginRatio"))
        object.marginRatio = options.json && !isFinite(message.marginRatio) ? String(message.marginRatio) : message.marginRatio;
      if (message.requiredMarginAmount != null && message.hasOwnProperty("requiredMarginAmount"))
        if (typeof message.requiredMarginAmount === "number")
          object.requiredMarginAmount = options.longs === String ? String(message.requiredMarginAmount) : message.requiredMarginAmount;
        else
          object.requiredMarginAmount = options.longs === String ? $util.Long.prototype.toString.call(message.requiredMarginAmount) : options.longs === Number ? new $util.LongBits(message.requiredMarginAmount.low >>> 0, message.requiredMarginAmount.high >>> 0).toNumber() : message.requiredMarginAmount;
      if (message.marginAmount != null && message.hasOwnProperty("marginAmount"))
        if (typeof message.marginAmount === "number")
          object.marginAmount = options.longs === String ? String(message.marginAmount) : message.marginAmount;
        else
          object.marginAmount = options.longs === String ? $util.Long.prototype.toString.call(message.marginAmount) : options.longs === Number ? new $util.LongBits(message.marginAmount.low >>> 0, message.marginAmount.high >>> 0).toNumber() : message.marginAmount;
      if (message.unrealizedProfit != null && message.hasOwnProperty("unrealizedProfit"))
        if (typeof message.unrealizedProfit === "number")
          object.unrealizedProfit = options.longs === String ? String(message.unrealizedProfit) : message.unrealizedProfit;
        else
          object.unrealizedProfit = options.longs === String ? $util.Long.prototype.toString.call(message.unrealizedProfit) : options.longs === Number ? new $util.LongBits(message.unrealizedProfit.low >>> 0, message.unrealizedProfit.high >>> 0).toNumber() : message.unrealizedProfit;
      if (message.unrealizedProfitRate != null && message.hasOwnProperty("unrealizedProfitRate"))
        object.unrealizedProfitRate = options.json && !isFinite(message.unrealizedProfitRate) ? String(message.unrealizedProfitRate) : message.unrealizedProfitRate;
      return object;
    };
    PortfolioItem.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return PortfolioItem;
  }();
  dnse2.Portfolio = function() {
    function Portfolio(properties) {
      this.stocks = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Portfolio.prototype.id = "";
    Portfolio.prototype.investorId = "";
    Portfolio.prototype.custodyCode = "";
    Portfolio.prototype.investorAccountId = "";
    Portfolio.prototype.stocks = $util.emptyArray;
    Portfolio.create = function create(properties) {
      return new Portfolio(properties);
    };
    Portfolio.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(34).string(message.investorAccountId);
      if (message.stocks != null && message.stocks.length)
        for (let i = 0; i < message.stocks.length; ++i)
          $root.dnse.PortfolioItem.encode(message.stocks[i], writer.uint32(42).fork()).ldelim();
      return writer;
    };
    Portfolio.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Portfolio.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Portfolio();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.investorAccountId = reader.string();
            break;
          case 5:
            if (!(message.stocks && message.stocks.length))
              message.stocks = [];
            message.stocks.push($root.dnse.PortfolioItem.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Portfolio.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Portfolio.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isString(message.investorAccountId))
          return "investorAccountId: string expected";
      }
      if (message.stocks != null && message.hasOwnProperty("stocks")) {
        if (!Array.isArray(message.stocks))
          return "stocks: array expected";
        for (let i = 0; i < message.stocks.length; ++i) {
          let error = $root.dnse.PortfolioItem.verify(message.stocks[i]);
          if (error)
            return "stocks." + error;
        }
      }
      return null;
    };
    Portfolio.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Portfolio)
        return object;
      let message = new $root.dnse.Portfolio();
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorAccountId != null)
        message.investorAccountId = String(object.investorAccountId);
      if (object.stocks) {
        if (!Array.isArray(object.stocks))
          throw TypeError(".dnse.Portfolio.stocks: array expected");
        message.stocks = [];
        for (let i = 0; i < object.stocks.length; ++i) {
          if (typeof object.stocks[i] !== "object")
            throw TypeError(".dnse.Portfolio.stocks: object expected");
          message.stocks[i] = $root.dnse.PortfolioItem.fromObject(object.stocks[i]);
        }
      }
      return message;
    };
    Portfolio.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.stocks = [];
      if (options.defaults) {
        object.id = "";
        object.investorId = "";
        object.custodyCode = "";
        object.investorAccountId = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.stocks && message.stocks.length) {
        object.stocks = [];
        for (let j = 0; j < message.stocks.length; ++j)
          object.stocks[j] = $root.dnse.PortfolioItem.toObject(message.stocks[j], options);
      }
      return object;
    };
    Portfolio.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Portfolio;
  }();
  dnse2.EmailVerification = function() {
    function EmailVerification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EmailVerification.prototype.investorId = "";
    EmailVerification.prototype.email = "";
    EmailVerification.prototype.code = "";
    EmailVerification.prototype.fullName = "";
    EmailVerification.prototype.custodyCode = "";
    EmailVerification.prototype.custodyCodeExpireTime = null;
    EmailVerification.prototype.isChangeEmail = false;
    EmailVerification.create = function create(properties) {
      return new EmailVerification(properties);
    };
    EmailVerification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(18).string(message.email);
      if (message.code != null && Object.hasOwnProperty.call(message, "code"))
        writer.uint32(26).string(message.code);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(34).string(message.fullName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(42).string(message.custodyCode);
      if (message.custodyCodeExpireTime != null && Object.hasOwnProperty.call(message, "custodyCodeExpireTime"))
        $root.google.protobuf.Timestamp.encode(message.custodyCodeExpireTime, writer.uint32(50).fork()).ldelim();
      if (message.isChangeEmail != null && Object.hasOwnProperty.call(message, "isChangeEmail"))
        writer.uint32(56).bool(message.isChangeEmail);
      return writer;
    };
    EmailVerification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EmailVerification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EmailVerification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.email = reader.string();
            break;
          case 3:
            message.code = reader.string();
            break;
          case 4:
            message.fullName = reader.string();
            break;
          case 5:
            message.custodyCode = reader.string();
            break;
          case 6:
            message.custodyCodeExpireTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.isChangeEmail = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EmailVerification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EmailVerification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.code != null && message.hasOwnProperty("code")) {
        if (!$util.isString(message.code))
          return "code: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.custodyCodeExpireTime != null && message.hasOwnProperty("custodyCodeExpireTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.custodyCodeExpireTime);
        if (error)
          return "custodyCodeExpireTime." + error;
      }
      if (message.isChangeEmail != null && message.hasOwnProperty("isChangeEmail")) {
        if (typeof message.isChangeEmail !== "boolean")
          return "isChangeEmail: boolean expected";
      }
      return null;
    };
    EmailVerification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EmailVerification)
        return object;
      let message = new $root.dnse.EmailVerification();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.email != null)
        message.email = String(object.email);
      if (object.code != null)
        message.code = String(object.code);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.custodyCodeExpireTime != null) {
        if (typeof object.custodyCodeExpireTime !== "object")
          throw TypeError(".dnse.EmailVerification.custodyCodeExpireTime: object expected");
        message.custodyCodeExpireTime = $root.google.protobuf.Timestamp.fromObject(object.custodyCodeExpireTime);
      }
      if (object.isChangeEmail != null)
        message.isChangeEmail = Boolean(object.isChangeEmail);
      return message;
    };
    EmailVerification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.email = "";
        object.code = "";
        object.fullName = "";
        object.custodyCode = "";
        object.custodyCodeExpireTime = null;
        object.isChangeEmail = false;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.code != null && message.hasOwnProperty("code"))
        object.code = message.code;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.custodyCodeExpireTime != null && message.hasOwnProperty("custodyCodeExpireTime"))
        object.custodyCodeExpireTime = $root.google.protobuf.Timestamp.toObject(message.custodyCodeExpireTime, options);
      if (message.isChangeEmail != null && message.hasOwnProperty("isChangeEmail"))
        object.isChangeEmail = message.isChangeEmail;
      return object;
    };
    EmailVerification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EmailVerification;
  }();
  dnse2.CI = function() {
    function CI(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CI.prototype.custodyCode = "";
    CI.prototype.accountId = "";
    CI.prototype.createTime = null;
    CI.prototype.balance = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CI.prototype.baldefovd = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CI.prototype.avlWithdraw = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CI.prototype.avlAdvance = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CI.prototype.pp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CI.create = function create(properties) {
      return new CI(properties);
    };
    CI.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
        writer.uint32(18).string(message.accountId);
      if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
        $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(26).fork()).ldelim();
      if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
        writer.uint32(32).int64(message.balance);
      if (message.baldefovd != null && Object.hasOwnProperty.call(message, "baldefovd"))
        writer.uint32(40).int64(message.baldefovd);
      if (message.avlWithdraw != null && Object.hasOwnProperty.call(message, "avlWithdraw"))
        writer.uint32(48).int64(message.avlWithdraw);
      if (message.avlAdvance != null && Object.hasOwnProperty.call(message, "avlAdvance"))
        writer.uint32(56).int64(message.avlAdvance);
      if (message.pp != null && Object.hasOwnProperty.call(message, "pp"))
        writer.uint32(64).int64(message.pp);
      return writer;
    };
    CI.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CI.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CI();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.accountId = reader.string();
            break;
          case 3:
            message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.balance = reader.int64();
            break;
          case 5:
            message.baldefovd = reader.int64();
            break;
          case 6:
            message.avlWithdraw = reader.int64();
            break;
          case 7:
            message.avlAdvance = reader.int64();
            break;
          case 8:
            message.pp = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CI.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CI.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountId != null && message.hasOwnProperty("accountId")) {
        if (!$util.isString(message.accountId))
          return "accountId: string expected";
      }
      if (message.createTime != null && message.hasOwnProperty("createTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createTime);
        if (error)
          return "createTime." + error;
      }
      if (message.balance != null && message.hasOwnProperty("balance")) {
        if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
          return "balance: integer|Long expected";
      }
      if (message.baldefovd != null && message.hasOwnProperty("baldefovd")) {
        if (!$util.isInteger(message.baldefovd) && !(message.baldefovd && $util.isInteger(message.baldefovd.low) && $util.isInteger(message.baldefovd.high)))
          return "baldefovd: integer|Long expected";
      }
      if (message.avlWithdraw != null && message.hasOwnProperty("avlWithdraw")) {
        if (!$util.isInteger(message.avlWithdraw) && !(message.avlWithdraw && $util.isInteger(message.avlWithdraw.low) && $util.isInteger(message.avlWithdraw.high)))
          return "avlWithdraw: integer|Long expected";
      }
      if (message.avlAdvance != null && message.hasOwnProperty("avlAdvance")) {
        if (!$util.isInteger(message.avlAdvance) && !(message.avlAdvance && $util.isInteger(message.avlAdvance.low) && $util.isInteger(message.avlAdvance.high)))
          return "avlAdvance: integer|Long expected";
      }
      if (message.pp != null && message.hasOwnProperty("pp")) {
        if (!$util.isInteger(message.pp) && !(message.pp && $util.isInteger(message.pp.low) && $util.isInteger(message.pp.high)))
          return "pp: integer|Long expected";
      }
      return null;
    };
    CI.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CI)
        return object;
      let message = new $root.dnse.CI();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountId != null)
        message.accountId = String(object.accountId);
      if (object.createTime != null) {
        if (typeof object.createTime !== "object")
          throw TypeError(".dnse.CI.createTime: object expected");
        message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
      }
      if (object.balance != null) {
        if ($util.Long)
          (message.balance = $util.Long.fromValue(object.balance)).unsigned = false;
        else if (typeof object.balance === "string")
          message.balance = parseInt(object.balance, 10);
        else if (typeof object.balance === "number")
          message.balance = object.balance;
        else if (typeof object.balance === "object")
          message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber();
      }
      if (object.baldefovd != null) {
        if ($util.Long)
          (message.baldefovd = $util.Long.fromValue(object.baldefovd)).unsigned = false;
        else if (typeof object.baldefovd === "string")
          message.baldefovd = parseInt(object.baldefovd, 10);
        else if (typeof object.baldefovd === "number")
          message.baldefovd = object.baldefovd;
        else if (typeof object.baldefovd === "object")
          message.baldefovd = new $util.LongBits(object.baldefovd.low >>> 0, object.baldefovd.high >>> 0).toNumber();
      }
      if (object.avlWithdraw != null) {
        if ($util.Long)
          (message.avlWithdraw = $util.Long.fromValue(object.avlWithdraw)).unsigned = false;
        else if (typeof object.avlWithdraw === "string")
          message.avlWithdraw = parseInt(object.avlWithdraw, 10);
        else if (typeof object.avlWithdraw === "number")
          message.avlWithdraw = object.avlWithdraw;
        else if (typeof object.avlWithdraw === "object")
          message.avlWithdraw = new $util.LongBits(object.avlWithdraw.low >>> 0, object.avlWithdraw.high >>> 0).toNumber();
      }
      if (object.avlAdvance != null) {
        if ($util.Long)
          (message.avlAdvance = $util.Long.fromValue(object.avlAdvance)).unsigned = false;
        else if (typeof object.avlAdvance === "string")
          message.avlAdvance = parseInt(object.avlAdvance, 10);
        else if (typeof object.avlAdvance === "number")
          message.avlAdvance = object.avlAdvance;
        else if (typeof object.avlAdvance === "object")
          message.avlAdvance = new $util.LongBits(object.avlAdvance.low >>> 0, object.avlAdvance.high >>> 0).toNumber();
      }
      if (object.pp != null) {
        if ($util.Long)
          (message.pp = $util.Long.fromValue(object.pp)).unsigned = false;
        else if (typeof object.pp === "string")
          message.pp = parseInt(object.pp, 10);
        else if (typeof object.pp === "number")
          message.pp = object.pp;
        else if (typeof object.pp === "object")
          message.pp = new $util.LongBits(object.pp.low >>> 0, object.pp.high >>> 0).toNumber();
      }
      return message;
    };
    CI.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.accountId = "";
        object.createTime = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.balance = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.baldefovd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.baldefovd = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.avlWithdraw = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.avlWithdraw = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.avlAdvance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.avlAdvance = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.pp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.pp = options.longs === String ? "0" : 0;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountId != null && message.hasOwnProperty("accountId"))
        object.accountId = message.accountId;
      if (message.createTime != null && message.hasOwnProperty("createTime"))
        object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
      if (message.balance != null && message.hasOwnProperty("balance"))
        if (typeof message.balance === "number")
          object.balance = options.longs === String ? String(message.balance) : message.balance;
        else
          object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber() : message.balance;
      if (message.baldefovd != null && message.hasOwnProperty("baldefovd"))
        if (typeof message.baldefovd === "number")
          object.baldefovd = options.longs === String ? String(message.baldefovd) : message.baldefovd;
        else
          object.baldefovd = options.longs === String ? $util.Long.prototype.toString.call(message.baldefovd) : options.longs === Number ? new $util.LongBits(message.baldefovd.low >>> 0, message.baldefovd.high >>> 0).toNumber() : message.baldefovd;
      if (message.avlWithdraw != null && message.hasOwnProperty("avlWithdraw"))
        if (typeof message.avlWithdraw === "number")
          object.avlWithdraw = options.longs === String ? String(message.avlWithdraw) : message.avlWithdraw;
        else
          object.avlWithdraw = options.longs === String ? $util.Long.prototype.toString.call(message.avlWithdraw) : options.longs === Number ? new $util.LongBits(message.avlWithdraw.low >>> 0, message.avlWithdraw.high >>> 0).toNumber() : message.avlWithdraw;
      if (message.avlAdvance != null && message.hasOwnProperty("avlAdvance"))
        if (typeof message.avlAdvance === "number")
          object.avlAdvance = options.longs === String ? String(message.avlAdvance) : message.avlAdvance;
        else
          object.avlAdvance = options.longs === String ? $util.Long.prototype.toString.call(message.avlAdvance) : options.longs === Number ? new $util.LongBits(message.avlAdvance.low >>> 0, message.avlAdvance.high >>> 0).toNumber() : message.avlAdvance;
      if (message.pp != null && message.hasOwnProperty("pp"))
        if (typeof message.pp === "number")
          object.pp = options.longs === String ? String(message.pp) : message.pp;
        else
          object.pp = options.longs === String ? $util.Long.prototype.toString.call(message.pp) : options.longs === Number ? new $util.LongBits(message.pp.low >>> 0, message.pp.high >>> 0).toNumber() : message.pp;
      return object;
    };
    CI.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CI;
  }();
  dnse2.SE = function() {
    function SE(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SE.prototype.custodyCode = "";
    SE.prototype.accountId = "";
    SE.prototype.createTime = null;
    SE.prototype.symbol = "";
    SE.prototype.trade = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SE.prototype.totalQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SE.create = function create(properties) {
      return new SE(properties);
    };
    SE.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
        writer.uint32(18).string(message.accountId);
      if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
        $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(26).fork()).ldelim();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.trade != null && Object.hasOwnProperty.call(message, "trade"))
        writer.uint32(40).int64(message.trade);
      if (message.totalQuantity != null && Object.hasOwnProperty.call(message, "totalQuantity"))
        writer.uint32(48).int64(message.totalQuantity);
      return writer;
    };
    SE.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SE.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SE();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.accountId = reader.string();
            break;
          case 3:
            message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.trade = reader.int64();
            break;
          case 6:
            message.totalQuantity = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SE.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SE.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountId != null && message.hasOwnProperty("accountId")) {
        if (!$util.isString(message.accountId))
          return "accountId: string expected";
      }
      if (message.createTime != null && message.hasOwnProperty("createTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createTime);
        if (error)
          return "createTime." + error;
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.trade != null && message.hasOwnProperty("trade")) {
        if (!$util.isInteger(message.trade) && !(message.trade && $util.isInteger(message.trade.low) && $util.isInteger(message.trade.high)))
          return "trade: integer|Long expected";
      }
      if (message.totalQuantity != null && message.hasOwnProperty("totalQuantity")) {
        if (!$util.isInteger(message.totalQuantity) && !(message.totalQuantity && $util.isInteger(message.totalQuantity.low) && $util.isInteger(message.totalQuantity.high)))
          return "totalQuantity: integer|Long expected";
      }
      return null;
    };
    SE.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SE)
        return object;
      let message = new $root.dnse.SE();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountId != null)
        message.accountId = String(object.accountId);
      if (object.createTime != null) {
        if (typeof object.createTime !== "object")
          throw TypeError(".dnse.SE.createTime: object expected");
        message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.trade != null) {
        if ($util.Long)
          (message.trade = $util.Long.fromValue(object.trade)).unsigned = false;
        else if (typeof object.trade === "string")
          message.trade = parseInt(object.trade, 10);
        else if (typeof object.trade === "number")
          message.trade = object.trade;
        else if (typeof object.trade === "object")
          message.trade = new $util.LongBits(object.trade.low >>> 0, object.trade.high >>> 0).toNumber();
      }
      if (object.totalQuantity != null) {
        if ($util.Long)
          (message.totalQuantity = $util.Long.fromValue(object.totalQuantity)).unsigned = false;
        else if (typeof object.totalQuantity === "string")
          message.totalQuantity = parseInt(object.totalQuantity, 10);
        else if (typeof object.totalQuantity === "number")
          message.totalQuantity = object.totalQuantity;
        else if (typeof object.totalQuantity === "object")
          message.totalQuantity = new $util.LongBits(object.totalQuantity.low >>> 0, object.totalQuantity.high >>> 0).toNumber();
      }
      return message;
    };
    SE.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.accountId = "";
        object.createTime = null;
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.trade = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.trade = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalQuantity = options.longs === String ? "0" : 0;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountId != null && message.hasOwnProperty("accountId"))
        object.accountId = message.accountId;
      if (message.createTime != null && message.hasOwnProperty("createTime"))
        object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.trade != null && message.hasOwnProperty("trade"))
        if (typeof message.trade === "number")
          object.trade = options.longs === String ? String(message.trade) : message.trade;
        else
          object.trade = options.longs === String ? $util.Long.prototype.toString.call(message.trade) : options.longs === Number ? new $util.LongBits(message.trade.low >>> 0, message.trade.high >>> 0).toNumber() : message.trade;
      if (message.totalQuantity != null && message.hasOwnProperty("totalQuantity"))
        if (typeof message.totalQuantity === "number")
          object.totalQuantity = options.longs === String ? String(message.totalQuantity) : message.totalQuantity;
        else
          object.totalQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.totalQuantity) : options.longs === Number ? new $util.LongBits(message.totalQuantity.low >>> 0, message.totalQuantity.high >>> 0).toNumber() : message.totalQuantity;
      return object;
    };
    SE.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SE;
  }();
  dnse2.OD = function() {
    function OD(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OD.prototype.custodyCode = "";
    OD.prototype.accountId = "";
    OD.prototype.createTime = null;
    OD.prototype.orderId = "";
    OD.prototype.symbol = "";
    OD.prototype.quoteQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OD.prototype.quotePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OD.prototype.side = "";
    OD.prototype.status = "";
    OD.prototype.execQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OD.prototype.remainQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OD.prototype.cancelQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    OD.create = function create(properties) {
      return new OD(properties);
    };
    OD.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
        writer.uint32(18).string(message.accountId);
      if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
        $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(26).fork()).ldelim();
      if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
        writer.uint32(34).string(message.orderId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.quoteQuantity != null && Object.hasOwnProperty.call(message, "quoteQuantity"))
        writer.uint32(48).int64(message.quoteQuantity);
      if (message.quotePrice != null && Object.hasOwnProperty.call(message, "quotePrice"))
        writer.uint32(56).int64(message.quotePrice);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(66).string(message.side);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(74).string(message.status);
      if (message.execQuantity != null && Object.hasOwnProperty.call(message, "execQuantity"))
        writer.uint32(80).int64(message.execQuantity);
      if (message.remainQuantity != null && Object.hasOwnProperty.call(message, "remainQuantity"))
        writer.uint32(88).int64(message.remainQuantity);
      if (message.cancelQuantity != null && Object.hasOwnProperty.call(message, "cancelQuantity"))
        writer.uint32(96).int64(message.cancelQuantity);
      return writer;
    };
    OD.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OD.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.OD();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.accountId = reader.string();
            break;
          case 3:
            message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.orderId = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.quoteQuantity = reader.int64();
            break;
          case 7:
            message.quotePrice = reader.int64();
            break;
          case 8:
            message.side = reader.string();
            break;
          case 9:
            message.status = reader.string();
            break;
          case 10:
            message.execQuantity = reader.int64();
            break;
          case 11:
            message.remainQuantity = reader.int64();
            break;
          case 12:
            message.cancelQuantity = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OD.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OD.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountId != null && message.hasOwnProperty("accountId")) {
        if (!$util.isString(message.accountId))
          return "accountId: string expected";
      }
      if (message.createTime != null && message.hasOwnProperty("createTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createTime);
        if (error)
          return "createTime." + error;
      }
      if (message.orderId != null && message.hasOwnProperty("orderId")) {
        if (!$util.isString(message.orderId))
          return "orderId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.quoteQuantity != null && message.hasOwnProperty("quoteQuantity")) {
        if (!$util.isInteger(message.quoteQuantity) && !(message.quoteQuantity && $util.isInteger(message.quoteQuantity.low) && $util.isInteger(message.quoteQuantity.high)))
          return "quoteQuantity: integer|Long expected";
      }
      if (message.quotePrice != null && message.hasOwnProperty("quotePrice")) {
        if (!$util.isInteger(message.quotePrice) && !(message.quotePrice && $util.isInteger(message.quotePrice.low) && $util.isInteger(message.quotePrice.high)))
          return "quotePrice: integer|Long expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.execQuantity != null && message.hasOwnProperty("execQuantity")) {
        if (!$util.isInteger(message.execQuantity) && !(message.execQuantity && $util.isInteger(message.execQuantity.low) && $util.isInteger(message.execQuantity.high)))
          return "execQuantity: integer|Long expected";
      }
      if (message.remainQuantity != null && message.hasOwnProperty("remainQuantity")) {
        if (!$util.isInteger(message.remainQuantity) && !(message.remainQuantity && $util.isInteger(message.remainQuantity.low) && $util.isInteger(message.remainQuantity.high)))
          return "remainQuantity: integer|Long expected";
      }
      if (message.cancelQuantity != null && message.hasOwnProperty("cancelQuantity")) {
        if (!$util.isInteger(message.cancelQuantity) && !(message.cancelQuantity && $util.isInteger(message.cancelQuantity.low) && $util.isInteger(message.cancelQuantity.high)))
          return "cancelQuantity: integer|Long expected";
      }
      return null;
    };
    OD.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.OD)
        return object;
      let message = new $root.dnse.OD();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountId != null)
        message.accountId = String(object.accountId);
      if (object.createTime != null) {
        if (typeof object.createTime !== "object")
          throw TypeError(".dnse.OD.createTime: object expected");
        message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
      }
      if (object.orderId != null)
        message.orderId = String(object.orderId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.quoteQuantity != null) {
        if ($util.Long)
          (message.quoteQuantity = $util.Long.fromValue(object.quoteQuantity)).unsigned = false;
        else if (typeof object.quoteQuantity === "string")
          message.quoteQuantity = parseInt(object.quoteQuantity, 10);
        else if (typeof object.quoteQuantity === "number")
          message.quoteQuantity = object.quoteQuantity;
        else if (typeof object.quoteQuantity === "object")
          message.quoteQuantity = new $util.LongBits(object.quoteQuantity.low >>> 0, object.quoteQuantity.high >>> 0).toNumber();
      }
      if (object.quotePrice != null) {
        if ($util.Long)
          (message.quotePrice = $util.Long.fromValue(object.quotePrice)).unsigned = false;
        else if (typeof object.quotePrice === "string")
          message.quotePrice = parseInt(object.quotePrice, 10);
        else if (typeof object.quotePrice === "number")
          message.quotePrice = object.quotePrice;
        else if (typeof object.quotePrice === "object")
          message.quotePrice = new $util.LongBits(object.quotePrice.low >>> 0, object.quotePrice.high >>> 0).toNumber();
      }
      if (object.side != null)
        message.side = String(object.side);
      if (object.status != null)
        message.status = String(object.status);
      if (object.execQuantity != null) {
        if ($util.Long)
          (message.execQuantity = $util.Long.fromValue(object.execQuantity)).unsigned = false;
        else if (typeof object.execQuantity === "string")
          message.execQuantity = parseInt(object.execQuantity, 10);
        else if (typeof object.execQuantity === "number")
          message.execQuantity = object.execQuantity;
        else if (typeof object.execQuantity === "object")
          message.execQuantity = new $util.LongBits(object.execQuantity.low >>> 0, object.execQuantity.high >>> 0).toNumber();
      }
      if (object.remainQuantity != null) {
        if ($util.Long)
          (message.remainQuantity = $util.Long.fromValue(object.remainQuantity)).unsigned = false;
        else if (typeof object.remainQuantity === "string")
          message.remainQuantity = parseInt(object.remainQuantity, 10);
        else if (typeof object.remainQuantity === "number")
          message.remainQuantity = object.remainQuantity;
        else if (typeof object.remainQuantity === "object")
          message.remainQuantity = new $util.LongBits(object.remainQuantity.low >>> 0, object.remainQuantity.high >>> 0).toNumber();
      }
      if (object.cancelQuantity != null) {
        if ($util.Long)
          (message.cancelQuantity = $util.Long.fromValue(object.cancelQuantity)).unsigned = false;
        else if (typeof object.cancelQuantity === "string")
          message.cancelQuantity = parseInt(object.cancelQuantity, 10);
        else if (typeof object.cancelQuantity === "number")
          message.cancelQuantity = object.cancelQuantity;
        else if (typeof object.cancelQuantity === "object")
          message.cancelQuantity = new $util.LongBits(object.cancelQuantity.low >>> 0, object.cancelQuantity.high >>> 0).toNumber();
      }
      return message;
    };
    OD.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.accountId = "";
        object.createTime = null;
        object.orderId = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quoteQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quoteQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quotePrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quotePrice = options.longs === String ? "0" : 0;
        object.side = "";
        object.status = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.execQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.execQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.remainQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.remainQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.cancelQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.cancelQuantity = options.longs === String ? "0" : 0;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountId != null && message.hasOwnProperty("accountId"))
        object.accountId = message.accountId;
      if (message.createTime != null && message.hasOwnProperty("createTime"))
        object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
      if (message.orderId != null && message.hasOwnProperty("orderId"))
        object.orderId = message.orderId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.quoteQuantity != null && message.hasOwnProperty("quoteQuantity"))
        if (typeof message.quoteQuantity === "number")
          object.quoteQuantity = options.longs === String ? String(message.quoteQuantity) : message.quoteQuantity;
        else
          object.quoteQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.quoteQuantity) : options.longs === Number ? new $util.LongBits(message.quoteQuantity.low >>> 0, message.quoteQuantity.high >>> 0).toNumber() : message.quoteQuantity;
      if (message.quotePrice != null && message.hasOwnProperty("quotePrice"))
        if (typeof message.quotePrice === "number")
          object.quotePrice = options.longs === String ? String(message.quotePrice) : message.quotePrice;
        else
          object.quotePrice = options.longs === String ? $util.Long.prototype.toString.call(message.quotePrice) : options.longs === Number ? new $util.LongBits(message.quotePrice.low >>> 0, message.quotePrice.high >>> 0).toNumber() : message.quotePrice;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.execQuantity != null && message.hasOwnProperty("execQuantity"))
        if (typeof message.execQuantity === "number")
          object.execQuantity = options.longs === String ? String(message.execQuantity) : message.execQuantity;
        else
          object.execQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.execQuantity) : options.longs === Number ? new $util.LongBits(message.execQuantity.low >>> 0, message.execQuantity.high >>> 0).toNumber() : message.execQuantity;
      if (message.remainQuantity != null && message.hasOwnProperty("remainQuantity"))
        if (typeof message.remainQuantity === "number")
          object.remainQuantity = options.longs === String ? String(message.remainQuantity) : message.remainQuantity;
        else
          object.remainQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.remainQuantity) : options.longs === Number ? new $util.LongBits(message.remainQuantity.low >>> 0, message.remainQuantity.high >>> 0).toNumber() : message.remainQuantity;
      if (message.cancelQuantity != null && message.hasOwnProperty("cancelQuantity"))
        if (typeof message.cancelQuantity === "number")
          object.cancelQuantity = options.longs === String ? String(message.cancelQuantity) : message.cancelQuantity;
        else
          object.cancelQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.cancelQuantity) : options.longs === Number ? new $util.LongBits(message.cancelQuantity.low >>> 0, message.cancelQuantity.high >>> 0).toNumber() : message.cancelQuantity;
      return object;
    };
    OD.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return OD;
  }();
  dnse2.InvestorAccount = function() {
    function InvestorAccount(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InvestorAccount.prototype.id = "";
    InvestorAccount.prototype.custodyCode = "";
    InvestorAccount.prototype.createdDate = null;
    InvestorAccount.prototype.investorId = "";
    InvestorAccount.prototype.accountType = "";
    InvestorAccount.prototype.accountNo = "";
    InvestorAccount.prototype.dnseType = "";
    InvestorAccount.create = function create(properties) {
      return new InvestorAccount(properties);
    };
    InvestorAccount.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(26).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
        writer.uint32(42).string(message.accountType);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(50).string(message.accountNo);
      if (message.dnseType != null && Object.hasOwnProperty.call(message, "dnseType"))
        writer.uint32(58).string(message.dnseType);
      return writer;
    };
    InvestorAccount.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InvestorAccount.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.InvestorAccount();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.accountType = reader.string();
            break;
          case 6:
            message.accountNo = reader.string();
            break;
          case 7:
            message.dnseType = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InvestorAccount.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InvestorAccount.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountType != null && message.hasOwnProperty("accountType")) {
        if (!$util.isString(message.accountType))
          return "accountType: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.dnseType != null && message.hasOwnProperty("dnseType")) {
        if (!$util.isString(message.dnseType))
          return "dnseType: string expected";
      }
      return null;
    };
    InvestorAccount.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.InvestorAccount)
        return object;
      let message = new $root.dnse.InvestorAccount();
      if (object.id != null)
        message.id = String(object.id);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.InvestorAccount.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountType != null)
        message.accountType = String(object.accountType);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.dnseType != null)
        message.dnseType = String(object.dnseType);
      return message;
    };
    InvestorAccount.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.custodyCode = "";
        object.createdDate = null;
        object.investorId = "";
        object.accountType = "";
        object.accountNo = "";
        object.dnseType = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountType != null && message.hasOwnProperty("accountType"))
        object.accountType = message.accountType;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.dnseType != null && message.hasOwnProperty("dnseType"))
        object.dnseType = message.dnseType;
      return object;
    };
    InvestorAccount.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return InvestorAccount;
  }();
  dnse2.Promotion = function() {
    function Promotion(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Promotion.prototype.campaignCode = "";
    Promotion.prototype.symbol = "";
    Promotion.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Promotion.prototype.signingTime = null;
    Promotion.create = function create(properties) {
      return new Promotion(properties);
    };
    Promotion.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.campaignCode != null && Object.hasOwnProperty.call(message, "campaignCode"))
        writer.uint32(10).string(message.campaignCode);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(24).int64(message.quantity);
      if (message.signingTime != null && Object.hasOwnProperty.call(message, "signingTime"))
        $root.google.protobuf.Timestamp.encode(message.signingTime, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    Promotion.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Promotion.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Promotion();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.campaignCode = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.quantity = reader.int64();
            break;
          case 4:
            message.signingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Promotion.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Promotion.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.campaignCode != null && message.hasOwnProperty("campaignCode")) {
        if (!$util.isString(message.campaignCode))
          return "campaignCode: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.signingTime != null && message.hasOwnProperty("signingTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.signingTime);
        if (error)
          return "signingTime." + error;
      }
      return null;
    };
    Promotion.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Promotion)
        return object;
      let message = new $root.dnse.Promotion();
      if (object.campaignCode != null)
        message.campaignCode = String(object.campaignCode);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.signingTime != null) {
        if (typeof object.signingTime !== "object")
          throw TypeError(".dnse.Promotion.signingTime: object expected");
        message.signingTime = $root.google.protobuf.Timestamp.fromObject(object.signingTime);
      }
      return message;
    };
    Promotion.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.campaignCode = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        object.signingTime = null;
      }
      if (message.campaignCode != null && message.hasOwnProperty("campaignCode"))
        object.campaignCode = message.campaignCode;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.signingTime != null && message.hasOwnProperty("signingTime"))
        object.signingTime = $root.google.protobuf.Timestamp.toObject(message.signingTime, options);
      return object;
    };
    Promotion.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Promotion;
  }();
  dnse2.Investor = function() {
    function Investor(properties) {
      this.subStatuses = [];
      this.promotions = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Investor.prototype.id = "";
    Investor.prototype.name = "";
    Investor.prototype.email = "";
    Investor.prototype.mobile = "";
    Investor.prototype.custodyCode = "";
    Investor.prototype.address = "";
    Investor.prototype.gender = 0;
    Investor.prototype.createdDate = null;
    Investor.prototype.modifiedDate = null;
    Investor.prototype.identificationCode = "";
    Investor.prototype.identificationType = "";
    Investor.prototype.identificationPlace = "";
    Investor.prototype.identificationExpiredDate = null;
    Investor.prototype.identificationDate = null;
    Investor.prototype.birthday = null;
    Investor.prototype.idFrontFileId = "";
    Investor.prototype.idBackFileId = "";
    Investor.prototype.selfieFileId = "";
    Investor.prototype.signatureFileId = "";
    Investor.prototype.kycStatus = "";
    Investor.prototype.holdInfo = null;
    Investor.prototype.status = 0;
    Investor.prototype.subStatuses = $util.emptyArray;
    Investor.prototype.statusDescription = "";
    Investor.prototype.ekycRequestId = "";
    Investor.prototype.referralCode = "";
    Investor.prototype.referBy = "";
    Investor.prototype.referralUrl = "";
    Investor.prototype.enId = "";
    Investor.prototype.referChannel = "";
    Investor.prototype.password = "";
    Investor.prototype.googleId = "";
    Investor.prototype.isPreRegisterMargin = null;
    Investor.prototype.isPremier = false;
    Investor.prototype.isPreRegisterDerivative = null;
    Investor.prototype.derivativeSigningTime = null;
    Investor.prototype.marginSigningTime = null;
    Investor.prototype.signingTime = null;
    Investor.prototype.referPlatform = null;
    Investor.prototype.promotions = $util.emptyArray;
    Investor.prototype.isManualApprove = null;
    Investor.prototype.flexCustomerId = "";
    Investor.prototype.avatarUrl = "";
    let $oneOfFields;
    Object.defineProperty(Investor.prototype, "_isPreRegisterMargin", {
      get: $util.oneOfGetter($oneOfFields = ["isPreRegisterMargin"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(Investor.prototype, "_isPreRegisterDerivative", {
      get: $util.oneOfGetter($oneOfFields = ["isPreRegisterDerivative"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(Investor.prototype, "_derivativeSigningTime", {
      get: $util.oneOfGetter($oneOfFields = ["derivativeSigningTime"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(Investor.prototype, "_marginSigningTime", {
      get: $util.oneOfGetter($oneOfFields = ["marginSigningTime"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(Investor.prototype, "_signingTime", {
      get: $util.oneOfGetter($oneOfFields = ["signingTime"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(Investor.prototype, "_referPlatform", {
      get: $util.oneOfGetter($oneOfFields = ["referPlatform"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(Investor.prototype, "_isManualApprove", {
      get: $util.oneOfGetter($oneOfFields = ["isManualApprove"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Investor.create = function create(properties) {
      return new Investor(properties);
    };
    Investor.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(18).string(message.name);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(26).string(message.email);
      if (message.mobile != null && Object.hasOwnProperty.call(message, "mobile"))
        writer.uint32(34).string(message.mobile);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(42).string(message.custodyCode);
      if (message.address != null && Object.hasOwnProperty.call(message, "address"))
        writer.uint32(50).string(message.address);
      if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
        writer.uint32(56).int32(message.gender);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(74).fork()).ldelim();
      if (message.identificationCode != null && Object.hasOwnProperty.call(message, "identificationCode"))
        writer.uint32(82).string(message.identificationCode);
      if (message.identificationType != null && Object.hasOwnProperty.call(message, "identificationType"))
        writer.uint32(90).string(message.identificationType);
      if (message.identificationPlace != null && Object.hasOwnProperty.call(message, "identificationPlace"))
        writer.uint32(98).string(message.identificationPlace);
      if (message.identificationExpiredDate != null && Object.hasOwnProperty.call(message, "identificationExpiredDate"))
        $root.google.protobuf.Timestamp.encode(message.identificationExpiredDate, writer.uint32(106).fork()).ldelim();
      if (message.identificationDate != null && Object.hasOwnProperty.call(message, "identificationDate"))
        $root.google.protobuf.Timestamp.encode(message.identificationDate, writer.uint32(114).fork()).ldelim();
      if (message.birthday != null && Object.hasOwnProperty.call(message, "birthday"))
        $root.google.protobuf.Timestamp.encode(message.birthday, writer.uint32(122).fork()).ldelim();
      if (message.idFrontFileId != null && Object.hasOwnProperty.call(message, "idFrontFileId"))
        writer.uint32(130).string(message.idFrontFileId);
      if (message.idBackFileId != null && Object.hasOwnProperty.call(message, "idBackFileId"))
        writer.uint32(138).string(message.idBackFileId);
      if (message.selfieFileId != null && Object.hasOwnProperty.call(message, "selfieFileId"))
        writer.uint32(146).string(message.selfieFileId);
      if (message.signatureFileId != null && Object.hasOwnProperty.call(message, "signatureFileId"))
        writer.uint32(154).string(message.signatureFileId);
      if (message.kycStatus != null && Object.hasOwnProperty.call(message, "kycStatus"))
        writer.uint32(162).string(message.kycStatus);
      if (message.holdInfo != null && Object.hasOwnProperty.call(message, "holdInfo"))
        $root.dnse.Investor.CustodyCodeHold.encode(message.holdInfo, writer.uint32(170).fork()).ldelim();
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(176).int32(message.status);
      if (message.subStatuses != null && message.subStatuses.length) {
        writer.uint32(186).fork();
        for (let i = 0; i < message.subStatuses.length; ++i)
          writer.int32(message.subStatuses[i]);
        writer.ldelim();
      }
      if (message.statusDescription != null && Object.hasOwnProperty.call(message, "statusDescription"))
        writer.uint32(194).string(message.statusDescription);
      if (message.ekycRequestId != null && Object.hasOwnProperty.call(message, "ekycRequestId"))
        writer.uint32(202).string(message.ekycRequestId);
      if (message.referralCode != null && Object.hasOwnProperty.call(message, "referralCode"))
        writer.uint32(210).string(message.referralCode);
      if (message.referBy != null && Object.hasOwnProperty.call(message, "referBy"))
        writer.uint32(218).string(message.referBy);
      if (message.referralUrl != null && Object.hasOwnProperty.call(message, "referralUrl"))
        writer.uint32(226).string(message.referralUrl);
      if (message.enId != null && Object.hasOwnProperty.call(message, "enId"))
        writer.uint32(234).string(message.enId);
      if (message.referChannel != null && Object.hasOwnProperty.call(message, "referChannel"))
        writer.uint32(242).string(message.referChannel);
      if (message.password != null && Object.hasOwnProperty.call(message, "password"))
        writer.uint32(250).string(message.password);
      if (message.googleId != null && Object.hasOwnProperty.call(message, "googleId"))
        writer.uint32(258).string(message.googleId);
      if (message.isPreRegisterMargin != null && Object.hasOwnProperty.call(message, "isPreRegisterMargin"))
        writer.uint32(264).bool(message.isPreRegisterMargin);
      if (message.isPremier != null && Object.hasOwnProperty.call(message, "isPremier"))
        writer.uint32(272).bool(message.isPremier);
      if (message.isPreRegisterDerivative != null && Object.hasOwnProperty.call(message, "isPreRegisterDerivative"))
        writer.uint32(280).bool(message.isPreRegisterDerivative);
      if (message.derivativeSigningTime != null && Object.hasOwnProperty.call(message, "derivativeSigningTime"))
        $root.google.protobuf.Timestamp.encode(message.derivativeSigningTime, writer.uint32(290).fork()).ldelim();
      if (message.marginSigningTime != null && Object.hasOwnProperty.call(message, "marginSigningTime"))
        $root.google.protobuf.Timestamp.encode(message.marginSigningTime, writer.uint32(298).fork()).ldelim();
      if (message.signingTime != null && Object.hasOwnProperty.call(message, "signingTime"))
        $root.google.protobuf.Timestamp.encode(message.signingTime, writer.uint32(306).fork()).ldelim();
      if (message.referPlatform != null && Object.hasOwnProperty.call(message, "referPlatform"))
        writer.uint32(314).string(message.referPlatform);
      if (message.promotions != null && message.promotions.length)
        for (let i = 0; i < message.promotions.length; ++i)
          $root.dnse.Promotion.encode(message.promotions[i], writer.uint32(322).fork()).ldelim();
      if (message.isManualApprove != null && Object.hasOwnProperty.call(message, "isManualApprove"))
        writer.uint32(328).bool(message.isManualApprove);
      if (message.flexCustomerId != null && Object.hasOwnProperty.call(message, "flexCustomerId"))
        writer.uint32(338).string(message.flexCustomerId);
      if (message.avatarUrl != null && Object.hasOwnProperty.call(message, "avatarUrl"))
        writer.uint32(346).string(message.avatarUrl);
      return writer;
    };
    Investor.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Investor.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Investor();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.name = reader.string();
            break;
          case 3:
            message.email = reader.string();
            break;
          case 4:
            message.mobile = reader.string();
            break;
          case 5:
            message.custodyCode = reader.string();
            break;
          case 6:
            message.address = reader.string();
            break;
          case 7:
            message.gender = reader.int32();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.identificationCode = reader.string();
            break;
          case 11:
            message.identificationType = reader.string();
            break;
          case 12:
            message.identificationPlace = reader.string();
            break;
          case 13:
            message.identificationExpiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 14:
            message.identificationDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 15:
            message.birthday = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 16:
            message.idFrontFileId = reader.string();
            break;
          case 17:
            message.idBackFileId = reader.string();
            break;
          case 18:
            message.selfieFileId = reader.string();
            break;
          case 19:
            message.signatureFileId = reader.string();
            break;
          case 20:
            message.kycStatus = reader.string();
            break;
          case 21:
            message.holdInfo = $root.dnse.Investor.CustodyCodeHold.decode(reader, reader.uint32());
            break;
          case 22:
            message.status = reader.int32();
            break;
          case 23:
            if (!(message.subStatuses && message.subStatuses.length))
              message.subStatuses = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2)
                message.subStatuses.push(reader.int32());
            } else
              message.subStatuses.push(reader.int32());
            break;
          case 24:
            message.statusDescription = reader.string();
            break;
          case 25:
            message.ekycRequestId = reader.string();
            break;
          case 26:
            message.referralCode = reader.string();
            break;
          case 27:
            message.referBy = reader.string();
            break;
          case 28:
            message.referralUrl = reader.string();
            break;
          case 29:
            message.enId = reader.string();
            break;
          case 30:
            message.referChannel = reader.string();
            break;
          case 31:
            message.password = reader.string();
            break;
          case 32:
            message.googleId = reader.string();
            break;
          case 33:
            message.isPreRegisterMargin = reader.bool();
            break;
          case 34:
            message.isPremier = reader.bool();
            break;
          case 35:
            message.isPreRegisterDerivative = reader.bool();
            break;
          case 36:
            message.derivativeSigningTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 37:
            message.marginSigningTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 38:
            message.signingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 39:
            message.referPlatform = reader.string();
            break;
          case 40:
            if (!(message.promotions && message.promotions.length))
              message.promotions = [];
            message.promotions.push($root.dnse.Promotion.decode(reader, reader.uint32()));
            break;
          case 41:
            message.isManualApprove = reader.bool();
            break;
          case 42:
            message.flexCustomerId = reader.string();
            break;
          case 43:
            message.avatarUrl = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Investor.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Investor.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.mobile != null && message.hasOwnProperty("mobile")) {
        if (!$util.isString(message.mobile))
          return "mobile: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.address != null && message.hasOwnProperty("address")) {
        if (!$util.isString(message.address))
          return "address: string expected";
      }
      if (message.gender != null && message.hasOwnProperty("gender"))
        switch (message.gender) {
          default:
            return "gender: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.identificationCode != null && message.hasOwnProperty("identificationCode")) {
        if (!$util.isString(message.identificationCode))
          return "identificationCode: string expected";
      }
      if (message.identificationType != null && message.hasOwnProperty("identificationType")) {
        if (!$util.isString(message.identificationType))
          return "identificationType: string expected";
      }
      if (message.identificationPlace != null && message.hasOwnProperty("identificationPlace")) {
        if (!$util.isString(message.identificationPlace))
          return "identificationPlace: string expected";
      }
      if (message.identificationExpiredDate != null && message.hasOwnProperty("identificationExpiredDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.identificationExpiredDate);
        if (error)
          return "identificationExpiredDate." + error;
      }
      if (message.identificationDate != null && message.hasOwnProperty("identificationDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.identificationDate);
        if (error)
          return "identificationDate." + error;
      }
      if (message.birthday != null && message.hasOwnProperty("birthday")) {
        let error = $root.google.protobuf.Timestamp.verify(message.birthday);
        if (error)
          return "birthday." + error;
      }
      if (message.idFrontFileId != null && message.hasOwnProperty("idFrontFileId")) {
        if (!$util.isString(message.idFrontFileId))
          return "idFrontFileId: string expected";
      }
      if (message.idBackFileId != null && message.hasOwnProperty("idBackFileId")) {
        if (!$util.isString(message.idBackFileId))
          return "idBackFileId: string expected";
      }
      if (message.selfieFileId != null && message.hasOwnProperty("selfieFileId")) {
        if (!$util.isString(message.selfieFileId))
          return "selfieFileId: string expected";
      }
      if (message.signatureFileId != null && message.hasOwnProperty("signatureFileId")) {
        if (!$util.isString(message.signatureFileId))
          return "signatureFileId: string expected";
      }
      if (message.kycStatus != null && message.hasOwnProperty("kycStatus")) {
        if (!$util.isString(message.kycStatus))
          return "kycStatus: string expected";
      }
      if (message.holdInfo != null && message.hasOwnProperty("holdInfo")) {
        let error = $root.dnse.Investor.CustodyCodeHold.verify(message.holdInfo);
        if (error)
          return "holdInfo." + error;
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
            break;
        }
      if (message.subStatuses != null && message.hasOwnProperty("subStatuses")) {
        if (!Array.isArray(message.subStatuses))
          return "subStatuses: array expected";
        for (let i = 0; i < message.subStatuses.length; ++i)
          switch (message.subStatuses[i]) {
            default:
              return "subStatuses: enum value[] expected";
            case 0:
            case 1:
            case 2:
              break;
          }
      }
      if (message.statusDescription != null && message.hasOwnProperty("statusDescription")) {
        if (!$util.isString(message.statusDescription))
          return "statusDescription: string expected";
      }
      if (message.ekycRequestId != null && message.hasOwnProperty("ekycRequestId")) {
        if (!$util.isString(message.ekycRequestId))
          return "ekycRequestId: string expected";
      }
      if (message.referralCode != null && message.hasOwnProperty("referralCode")) {
        if (!$util.isString(message.referralCode))
          return "referralCode: string expected";
      }
      if (message.referBy != null && message.hasOwnProperty("referBy")) {
        if (!$util.isString(message.referBy))
          return "referBy: string expected";
      }
      if (message.referralUrl != null && message.hasOwnProperty("referralUrl")) {
        if (!$util.isString(message.referralUrl))
          return "referralUrl: string expected";
      }
      if (message.enId != null && message.hasOwnProperty("enId")) {
        if (!$util.isString(message.enId))
          return "enId: string expected";
      }
      if (message.referChannel != null && message.hasOwnProperty("referChannel")) {
        if (!$util.isString(message.referChannel))
          return "referChannel: string expected";
      }
      if (message.password != null && message.hasOwnProperty("password")) {
        if (!$util.isString(message.password))
          return "password: string expected";
      }
      if (message.googleId != null && message.hasOwnProperty("googleId")) {
        if (!$util.isString(message.googleId))
          return "googleId: string expected";
      }
      if (message.isPreRegisterMargin != null && message.hasOwnProperty("isPreRegisterMargin")) {
        if (typeof message.isPreRegisterMargin !== "boolean")
          return "isPreRegisterMargin: boolean expected";
      }
      if (message.isPremier != null && message.hasOwnProperty("isPremier")) {
        if (typeof message.isPremier !== "boolean")
          return "isPremier: boolean expected";
      }
      if (message.isPreRegisterDerivative != null && message.hasOwnProperty("isPreRegisterDerivative")) {
        if (typeof message.isPreRegisterDerivative !== "boolean")
          return "isPreRegisterDerivative: boolean expected";
      }
      if (message.derivativeSigningTime != null && message.hasOwnProperty("derivativeSigningTime")) {
        {
          let error = $root.google.protobuf.Timestamp.verify(message.derivativeSigningTime);
          if (error)
            return "derivativeSigningTime." + error;
        }
      }
      if (message.marginSigningTime != null && message.hasOwnProperty("marginSigningTime")) {
        {
          let error = $root.google.protobuf.Timestamp.verify(message.marginSigningTime);
          if (error)
            return "marginSigningTime." + error;
        }
      }
      if (message.signingTime != null && message.hasOwnProperty("signingTime")) {
        {
          let error = $root.google.protobuf.Timestamp.verify(message.signingTime);
          if (error)
            return "signingTime." + error;
        }
      }
      if (message.referPlatform != null && message.hasOwnProperty("referPlatform")) {
        if (!$util.isString(message.referPlatform))
          return "referPlatform: string expected";
      }
      if (message.promotions != null && message.hasOwnProperty("promotions")) {
        if (!Array.isArray(message.promotions))
          return "promotions: array expected";
        for (let i = 0; i < message.promotions.length; ++i) {
          let error = $root.dnse.Promotion.verify(message.promotions[i]);
          if (error)
            return "promotions." + error;
        }
      }
      if (message.isManualApprove != null && message.hasOwnProperty("isManualApprove")) {
        if (typeof message.isManualApprove !== "boolean")
          return "isManualApprove: boolean expected";
      }
      if (message.flexCustomerId != null && message.hasOwnProperty("flexCustomerId")) {
        if (!$util.isString(message.flexCustomerId))
          return "flexCustomerId: string expected";
      }
      if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl")) {
        if (!$util.isString(message.avatarUrl))
          return "avatarUrl: string expected";
      }
      return null;
    };
    Investor.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Investor)
        return object;
      let message = new $root.dnse.Investor();
      if (object.id != null)
        message.id = String(object.id);
      if (object.name != null)
        message.name = String(object.name);
      if (object.email != null)
        message.email = String(object.email);
      if (object.mobile != null)
        message.mobile = String(object.mobile);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.address != null)
        message.address = String(object.address);
      switch (object.gender) {
        case "MALE":
        case 0:
          message.gender = 0;
          break;
        case "FEMALE":
        case 1:
          message.gender = 1;
          break;
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.Investor.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.Investor.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.identificationCode != null)
        message.identificationCode = String(object.identificationCode);
      if (object.identificationType != null)
        message.identificationType = String(object.identificationType);
      if (object.identificationPlace != null)
        message.identificationPlace = String(object.identificationPlace);
      if (object.identificationExpiredDate != null) {
        if (typeof object.identificationExpiredDate !== "object")
          throw TypeError(".dnse.Investor.identificationExpiredDate: object expected");
        message.identificationExpiredDate = $root.google.protobuf.Timestamp.fromObject(object.identificationExpiredDate);
      }
      if (object.identificationDate != null) {
        if (typeof object.identificationDate !== "object")
          throw TypeError(".dnse.Investor.identificationDate: object expected");
        message.identificationDate = $root.google.protobuf.Timestamp.fromObject(object.identificationDate);
      }
      if (object.birthday != null) {
        if (typeof object.birthday !== "object")
          throw TypeError(".dnse.Investor.birthday: object expected");
        message.birthday = $root.google.protobuf.Timestamp.fromObject(object.birthday);
      }
      if (object.idFrontFileId != null)
        message.idFrontFileId = String(object.idFrontFileId);
      if (object.idBackFileId != null)
        message.idBackFileId = String(object.idBackFileId);
      if (object.selfieFileId != null)
        message.selfieFileId = String(object.selfieFileId);
      if (object.signatureFileId != null)
        message.signatureFileId = String(object.signatureFileId);
      if (object.kycStatus != null)
        message.kycStatus = String(object.kycStatus);
      if (object.holdInfo != null) {
        if (typeof object.holdInfo !== "object")
          throw TypeError(".dnse.Investor.holdInfo: object expected");
        message.holdInfo = $root.dnse.Investor.CustodyCodeHold.fromObject(object.holdInfo);
      }
      switch (object.status) {
        case "NEW":
        case 0:
          message.status = 0;
          break;
        case "VERIFIED":
        case 1:
          message.status = 1;
          break;
        case "KYC_SUBMITTED":
        case 2:
          message.status = 2;
          break;
        case "INFO_SUBMITTED":
        case 3:
          message.status = 3;
          break;
        case "SUBMITTED":
        case 4:
          message.status = 4;
          break;
        case "REJECTED":
        case 5:
          message.status = 5;
          break;
        case "APPROVED":
        case 6:
          message.status = 6;
          break;
        case "CORE_ACTIVE":
        case 7:
          message.status = 7;
          break;
        case "CORE_FAILED":
        case 8:
          message.status = 8;
          break;
        case "VSD_ACTIVE":
        case 9:
          message.status = 9;
          break;
        case "VSD_FAILED":
        case 10:
          message.status = 10;
          break;
        case "INACTIVE":
        case 11:
          message.status = 11;
          break;
        case "ACTIVE":
        case 12:
          message.status = 12;
          break;
        case "PENDING_CLOSE":
        case 13:
          message.status = 13;
          break;
        case "CLOSED":
        case 14:
          message.status = 14;
          break;
      }
      if (object.subStatuses) {
        if (!Array.isArray(object.subStatuses))
          throw TypeError(".dnse.Investor.subStatuses: array expected");
        message.subStatuses = [];
        for (let i = 0; i < object.subStatuses.length; ++i)
          switch (object.subStatuses[i]) {
            default:
            case "KYC_REJECTED":
            case 0:
              message.subStatuses[i] = 0;
              break;
            case "INFO_REJECTED":
            case 1:
              message.subStatuses[i] = 1;
              break;
            case "SIGNATURE_REJECTED":
            case 2:
              message.subStatuses[i] = 2;
              break;
          }
      }
      if (object.statusDescription != null)
        message.statusDescription = String(object.statusDescription);
      if (object.ekycRequestId != null)
        message.ekycRequestId = String(object.ekycRequestId);
      if (object.referralCode != null)
        message.referralCode = String(object.referralCode);
      if (object.referBy != null)
        message.referBy = String(object.referBy);
      if (object.referralUrl != null)
        message.referralUrl = String(object.referralUrl);
      if (object.enId != null)
        message.enId = String(object.enId);
      if (object.referChannel != null)
        message.referChannel = String(object.referChannel);
      if (object.password != null)
        message.password = String(object.password);
      if (object.googleId != null)
        message.googleId = String(object.googleId);
      if (object.isPreRegisterMargin != null)
        message.isPreRegisterMargin = Boolean(object.isPreRegisterMargin);
      if (object.isPremier != null)
        message.isPremier = Boolean(object.isPremier);
      if (object.isPreRegisterDerivative != null)
        message.isPreRegisterDerivative = Boolean(object.isPreRegisterDerivative);
      if (object.derivativeSigningTime != null) {
        if (typeof object.derivativeSigningTime !== "object")
          throw TypeError(".dnse.Investor.derivativeSigningTime: object expected");
        message.derivativeSigningTime = $root.google.protobuf.Timestamp.fromObject(object.derivativeSigningTime);
      }
      if (object.marginSigningTime != null) {
        if (typeof object.marginSigningTime !== "object")
          throw TypeError(".dnse.Investor.marginSigningTime: object expected");
        message.marginSigningTime = $root.google.protobuf.Timestamp.fromObject(object.marginSigningTime);
      }
      if (object.signingTime != null) {
        if (typeof object.signingTime !== "object")
          throw TypeError(".dnse.Investor.signingTime: object expected");
        message.signingTime = $root.google.protobuf.Timestamp.fromObject(object.signingTime);
      }
      if (object.referPlatform != null)
        message.referPlatform = String(object.referPlatform);
      if (object.promotions) {
        if (!Array.isArray(object.promotions))
          throw TypeError(".dnse.Investor.promotions: array expected");
        message.promotions = [];
        for (let i = 0; i < object.promotions.length; ++i) {
          if (typeof object.promotions[i] !== "object")
            throw TypeError(".dnse.Investor.promotions: object expected");
          message.promotions[i] = $root.dnse.Promotion.fromObject(object.promotions[i]);
        }
      }
      if (object.isManualApprove != null)
        message.isManualApprove = Boolean(object.isManualApprove);
      if (object.flexCustomerId != null)
        message.flexCustomerId = String(object.flexCustomerId);
      if (object.avatarUrl != null)
        message.avatarUrl = String(object.avatarUrl);
      return message;
    };
    Investor.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.subStatuses = [];
        object.promotions = [];
      }
      if (options.defaults) {
        object.id = "";
        object.name = "";
        object.email = "";
        object.mobile = "";
        object.custodyCode = "";
        object.address = "";
        object.gender = options.enums === String ? "MALE" : 0;
        object.createdDate = null;
        object.modifiedDate = null;
        object.identificationCode = "";
        object.identificationType = "";
        object.identificationPlace = "";
        object.identificationExpiredDate = null;
        object.identificationDate = null;
        object.birthday = null;
        object.idFrontFileId = "";
        object.idBackFileId = "";
        object.selfieFileId = "";
        object.signatureFileId = "";
        object.kycStatus = "";
        object.holdInfo = null;
        object.status = options.enums === String ? "NEW" : 0;
        object.statusDescription = "";
        object.ekycRequestId = "";
        object.referralCode = "";
        object.referBy = "";
        object.referralUrl = "";
        object.enId = "";
        object.referChannel = "";
        object.password = "";
        object.googleId = "";
        object.isPremier = false;
        object.flexCustomerId = "";
        object.avatarUrl = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.mobile != null && message.hasOwnProperty("mobile"))
        object.mobile = message.mobile;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.address != null && message.hasOwnProperty("address"))
        object.address = message.address;
      if (message.gender != null && message.hasOwnProperty("gender"))
        object.gender = options.enums === String ? $root.dnse.Investor.Gender[message.gender] : message.gender;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.identificationCode != null && message.hasOwnProperty("identificationCode"))
        object.identificationCode = message.identificationCode;
      if (message.identificationType != null && message.hasOwnProperty("identificationType"))
        object.identificationType = message.identificationType;
      if (message.identificationPlace != null && message.hasOwnProperty("identificationPlace"))
        object.identificationPlace = message.identificationPlace;
      if (message.identificationExpiredDate != null && message.hasOwnProperty("identificationExpiredDate"))
        object.identificationExpiredDate = $root.google.protobuf.Timestamp.toObject(message.identificationExpiredDate, options);
      if (message.identificationDate != null && message.hasOwnProperty("identificationDate"))
        object.identificationDate = $root.google.protobuf.Timestamp.toObject(message.identificationDate, options);
      if (message.birthday != null && message.hasOwnProperty("birthday"))
        object.birthday = $root.google.protobuf.Timestamp.toObject(message.birthday, options);
      if (message.idFrontFileId != null && message.hasOwnProperty("idFrontFileId"))
        object.idFrontFileId = message.idFrontFileId;
      if (message.idBackFileId != null && message.hasOwnProperty("idBackFileId"))
        object.idBackFileId = message.idBackFileId;
      if (message.selfieFileId != null && message.hasOwnProperty("selfieFileId"))
        object.selfieFileId = message.selfieFileId;
      if (message.signatureFileId != null && message.hasOwnProperty("signatureFileId"))
        object.signatureFileId = message.signatureFileId;
      if (message.kycStatus != null && message.hasOwnProperty("kycStatus"))
        object.kycStatus = message.kycStatus;
      if (message.holdInfo != null && message.hasOwnProperty("holdInfo"))
        object.holdInfo = $root.dnse.Investor.CustodyCodeHold.toObject(message.holdInfo, options);
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.Investor.Status[message.status] : message.status;
      if (message.subStatuses && message.subStatuses.length) {
        object.subStatuses = [];
        for (let j = 0; j < message.subStatuses.length; ++j)
          object.subStatuses[j] = options.enums === String ? $root.dnse.Investor.SubStatus[message.subStatuses[j]] : message.subStatuses[j];
      }
      if (message.statusDescription != null && message.hasOwnProperty("statusDescription"))
        object.statusDescription = message.statusDescription;
      if (message.ekycRequestId != null && message.hasOwnProperty("ekycRequestId"))
        object.ekycRequestId = message.ekycRequestId;
      if (message.referralCode != null && message.hasOwnProperty("referralCode"))
        object.referralCode = message.referralCode;
      if (message.referBy != null && message.hasOwnProperty("referBy"))
        object.referBy = message.referBy;
      if (message.referralUrl != null && message.hasOwnProperty("referralUrl"))
        object.referralUrl = message.referralUrl;
      if (message.enId != null && message.hasOwnProperty("enId"))
        object.enId = message.enId;
      if (message.referChannel != null && message.hasOwnProperty("referChannel"))
        object.referChannel = message.referChannel;
      if (message.password != null && message.hasOwnProperty("password"))
        object.password = message.password;
      if (message.googleId != null && message.hasOwnProperty("googleId"))
        object.googleId = message.googleId;
      if (message.isPreRegisterMargin != null && message.hasOwnProperty("isPreRegisterMargin")) {
        object.isPreRegisterMargin = message.isPreRegisterMargin;
        if (options.oneofs)
          object._isPreRegisterMargin = "isPreRegisterMargin";
      }
      if (message.isPremier != null && message.hasOwnProperty("isPremier"))
        object.isPremier = message.isPremier;
      if (message.isPreRegisterDerivative != null && message.hasOwnProperty("isPreRegisterDerivative")) {
        object.isPreRegisterDerivative = message.isPreRegisterDerivative;
        if (options.oneofs)
          object._isPreRegisterDerivative = "isPreRegisterDerivative";
      }
      if (message.derivativeSigningTime != null && message.hasOwnProperty("derivativeSigningTime")) {
        object.derivativeSigningTime = $root.google.protobuf.Timestamp.toObject(message.derivativeSigningTime, options);
        if (options.oneofs)
          object._derivativeSigningTime = "derivativeSigningTime";
      }
      if (message.marginSigningTime != null && message.hasOwnProperty("marginSigningTime")) {
        object.marginSigningTime = $root.google.protobuf.Timestamp.toObject(message.marginSigningTime, options);
        if (options.oneofs)
          object._marginSigningTime = "marginSigningTime";
      }
      if (message.signingTime != null && message.hasOwnProperty("signingTime")) {
        object.signingTime = $root.google.protobuf.Timestamp.toObject(message.signingTime, options);
        if (options.oneofs)
          object._signingTime = "signingTime";
      }
      if (message.referPlatform != null && message.hasOwnProperty("referPlatform")) {
        object.referPlatform = message.referPlatform;
        if (options.oneofs)
          object._referPlatform = "referPlatform";
      }
      if (message.promotions && message.promotions.length) {
        object.promotions = [];
        for (let j = 0; j < message.promotions.length; ++j)
          object.promotions[j] = $root.dnse.Promotion.toObject(message.promotions[j], options);
      }
      if (message.isManualApprove != null && message.hasOwnProperty("isManualApprove")) {
        object.isManualApprove = message.isManualApprove;
        if (options.oneofs)
          object._isManualApprove = "isManualApprove";
      }
      if (message.flexCustomerId != null && message.hasOwnProperty("flexCustomerId"))
        object.flexCustomerId = message.flexCustomerId;
      if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
        object.avatarUrl = message.avatarUrl;
      return object;
    };
    Investor.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    Investor.Gender = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "MALE"] = 0;
      values[valuesById[1] = "FEMALE"] = 1;
      return values;
    }();
    Investor.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "NEW"] = 0;
      values[valuesById[1] = "VERIFIED"] = 1;
      values[valuesById[2] = "KYC_SUBMITTED"] = 2;
      values[valuesById[3] = "INFO_SUBMITTED"] = 3;
      values[valuesById[4] = "SUBMITTED"] = 4;
      values[valuesById[5] = "REJECTED"] = 5;
      values[valuesById[6] = "APPROVED"] = 6;
      values[valuesById[7] = "CORE_ACTIVE"] = 7;
      values[valuesById[8] = "CORE_FAILED"] = 8;
      values[valuesById[9] = "VSD_ACTIVE"] = 9;
      values[valuesById[10] = "VSD_FAILED"] = 10;
      values[valuesById[11] = "INACTIVE"] = 11;
      values[valuesById[12] = "ACTIVE"] = 12;
      values[valuesById[13] = "PENDING_CLOSE"] = 13;
      values[valuesById[14] = "CLOSED"] = 14;
      return values;
    }();
    Investor.SubStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "KYC_REJECTED"] = 0;
      values[valuesById[1] = "INFO_REJECTED"] = 1;
      values[valuesById[2] = "SIGNATURE_REJECTED"] = 2;
      return values;
    }();
    Investor.CustodyCodeHold = function() {
      function CustodyCodeHold(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      CustodyCodeHold.prototype.custodyCode = "";
      CustodyCodeHold.prototype.expiredDate = null;
      CustodyCodeHold.create = function create(properties) {
        return new CustodyCodeHold(properties);
      };
      CustodyCodeHold.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(10).string(message.custodyCode);
        if (message.expiredDate != null && Object.hasOwnProperty.call(message, "expiredDate"))
          $root.google.protobuf.Timestamp.encode(message.expiredDate, writer.uint32(18).fork()).ldelim();
        return writer;
      };
      CustodyCodeHold.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      CustodyCodeHold.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Investor.CustodyCodeHold();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.custodyCode = reader.string();
              break;
            case 2:
              message.expiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      CustodyCodeHold.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      CustodyCodeHold.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.expiredDate != null && message.hasOwnProperty("expiredDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.expiredDate);
          if (error)
            return "expiredDate." + error;
        }
        return null;
      };
      CustodyCodeHold.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.Investor.CustodyCodeHold)
          return object;
        let message = new $root.dnse.Investor.CustodyCodeHold();
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.expiredDate != null) {
          if (typeof object.expiredDate !== "object")
            throw TypeError(".dnse.Investor.CustodyCodeHold.expiredDate: object expected");
          message.expiredDate = $root.google.protobuf.Timestamp.fromObject(object.expiredDate);
        }
        return message;
      };
      CustodyCodeHold.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.custodyCode = "";
          object.expiredDate = null;
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.expiredDate != null && message.hasOwnProperty("expiredDate"))
          object.expiredDate = $root.google.protobuf.Timestamp.toObject(message.expiredDate, options);
        return object;
      };
      CustodyCodeHold.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return CustodyCodeHold;
    }();
    return Investor;
  }();
  dnse2.SacoInvestorActivatedEvent = function() {
    function SacoInvestorActivatedEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SacoInvestorActivatedEvent.prototype.investorId = "";
    SacoInvestorActivatedEvent.prototype.status = 0;
    SacoInvestorActivatedEvent.prototype.sacoReferralCode = "";
    SacoInvestorActivatedEvent.prototype.name = "";
    SacoInvestorActivatedEvent.prototype.phoneNumber = "";
    SacoInvestorActivatedEvent.create = function create(properties) {
      return new SacoInvestorActivatedEvent(properties);
    };
    SacoInvestorActivatedEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(16).int32(message.status);
      if (message.sacoReferralCode != null && Object.hasOwnProperty.call(message, "sacoReferralCode"))
        writer.uint32(26).string(message.sacoReferralCode);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(34).string(message.name);
      if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
        writer.uint32(42).string(message.phoneNumber);
      return writer;
    };
    SacoInvestorActivatedEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SacoInvestorActivatedEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SacoInvestorActivatedEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.status = reader.int32();
            break;
          case 3:
            message.sacoReferralCode = reader.string();
            break;
          case 4:
            message.name = reader.string();
            break;
          case 5:
            message.phoneNumber = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SacoInvestorActivatedEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SacoInvestorActivatedEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.sacoReferralCode != null && message.hasOwnProperty("sacoReferralCode")) {
        if (!$util.isString(message.sacoReferralCode))
          return "sacoReferralCode: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber")) {
        if (!$util.isString(message.phoneNumber))
          return "phoneNumber: string expected";
      }
      return null;
    };
    SacoInvestorActivatedEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SacoInvestorActivatedEvent)
        return object;
      let message = new $root.dnse.SacoInvestorActivatedEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      switch (object.status) {
        case "UNDEFINED":
        case 0:
          message.status = 0;
          break;
        case "NEW":
        case 1:
          message.status = 1;
          break;
        case "ACTIVE":
        case 2:
          message.status = 2;
          break;
      }
      if (object.sacoReferralCode != null)
        message.sacoReferralCode = String(object.sacoReferralCode);
      if (object.name != null)
        message.name = String(object.name);
      if (object.phoneNumber != null)
        message.phoneNumber = String(object.phoneNumber);
      return message;
    };
    SacoInvestorActivatedEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.status = options.enums === String ? "UNDEFINED" : 0;
        object.sacoReferralCode = "";
        object.name = "";
        object.phoneNumber = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.SacoInvestorActivatedEvent.InvestorStatus[message.status] : message.status;
      if (message.sacoReferralCode != null && message.hasOwnProperty("sacoReferralCode"))
        object.sacoReferralCode = message.sacoReferralCode;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
        object.phoneNumber = message.phoneNumber;
      return object;
    };
    SacoInvestorActivatedEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    SacoInvestorActivatedEvent.InvestorStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNDEFINED"] = 0;
      values[valuesById[1] = "NEW"] = 1;
      values[valuesById[2] = "ACTIVE"] = 2;
      return values;
    }();
    return SacoInvestorActivatedEvent;
  }();
  dnse2.BankWithdraw = function() {
    function BankWithdraw(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BankWithdraw.prototype.id = "";
    BankWithdraw.prototype.type = "";
    BankWithdraw.prototype.bankAccountNumber = "";
    BankWithdraw.prototype.bankAccountType = "";
    BankWithdraw.prototype.bankAccountName = "";
    BankWithdraw.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BankWithdraw.prototype.bankName = "";
    BankWithdraw.prototype.bankCode = "";
    BankWithdraw.prototype.bankNapasCode = "";
    BankWithdraw.prototype.bankBranchCode = "";
    BankWithdraw.prototype.description = "";
    BankWithdraw.prototype.transactionTime = null;
    BankWithdraw.prototype.sourceTransactionId = "";
    BankWithdraw.prototype.txCode = "";
    BankWithdraw.prototype.withdrawType = "";
    BankWithdraw.create = function create(properties) {
      return new BankWithdraw(properties);
    };
    BankWithdraw.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(18).string(message.type);
      if (message.bankAccountNumber != null && Object.hasOwnProperty.call(message, "bankAccountNumber"))
        writer.uint32(26).string(message.bankAccountNumber);
      if (message.bankAccountType != null && Object.hasOwnProperty.call(message, "bankAccountType"))
        writer.uint32(34).string(message.bankAccountType);
      if (message.bankAccountName != null && Object.hasOwnProperty.call(message, "bankAccountName"))
        writer.uint32(42).string(message.bankAccountName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(48).int64(message.amount);
      if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
        writer.uint32(58).string(message.bankName);
      if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
        writer.uint32(66).string(message.bankCode);
      if (message.bankNapasCode != null && Object.hasOwnProperty.call(message, "bankNapasCode"))
        writer.uint32(74).string(message.bankNapasCode);
      if (message.bankBranchCode != null && Object.hasOwnProperty.call(message, "bankBranchCode"))
        writer.uint32(82).string(message.bankBranchCode);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(90).string(message.description);
      if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
        $root.google.protobuf.Timestamp.encode(message.transactionTime, writer.uint32(98).fork()).ldelim();
      if (message.sourceTransactionId != null && Object.hasOwnProperty.call(message, "sourceTransactionId"))
        writer.uint32(106).string(message.sourceTransactionId);
      if (message.txCode != null && Object.hasOwnProperty.call(message, "txCode"))
        writer.uint32(114).string(message.txCode);
      if (message.withdrawType != null && Object.hasOwnProperty.call(message, "withdrawType"))
        writer.uint32(122).string(message.withdrawType);
      return writer;
    };
    BankWithdraw.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BankWithdraw.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BankWithdraw();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.type = reader.string();
            break;
          case 3:
            message.bankAccountNumber = reader.string();
            break;
          case 4:
            message.bankAccountType = reader.string();
            break;
          case 5:
            message.bankAccountName = reader.string();
            break;
          case 6:
            message.amount = reader.int64();
            break;
          case 7:
            message.bankName = reader.string();
            break;
          case 8:
            message.bankCode = reader.string();
            break;
          case 9:
            message.bankNapasCode = reader.string();
            break;
          case 10:
            message.bankBranchCode = reader.string();
            break;
          case 11:
            message.description = reader.string();
            break;
          case 12:
            message.transactionTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.sourceTransactionId = reader.string();
            break;
          case 14:
            message.txCode = reader.string();
            break;
          case 15:
            message.withdrawType = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BankWithdraw.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BankWithdraw.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber")) {
        if (!$util.isString(message.bankAccountNumber))
          return "bankAccountNumber: string expected";
      }
      if (message.bankAccountType != null && message.hasOwnProperty("bankAccountType")) {
        if (!$util.isString(message.bankAccountType))
          return "bankAccountType: string expected";
      }
      if (message.bankAccountName != null && message.hasOwnProperty("bankAccountName")) {
        if (!$util.isString(message.bankAccountName))
          return "bankAccountName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.bankName != null && message.hasOwnProperty("bankName")) {
        if (!$util.isString(message.bankName))
          return "bankName: string expected";
      }
      if (message.bankCode != null && message.hasOwnProperty("bankCode")) {
        if (!$util.isString(message.bankCode))
          return "bankCode: string expected";
      }
      if (message.bankNapasCode != null && message.hasOwnProperty("bankNapasCode")) {
        if (!$util.isString(message.bankNapasCode))
          return "bankNapasCode: string expected";
      }
      if (message.bankBranchCode != null && message.hasOwnProperty("bankBranchCode")) {
        if (!$util.isString(message.bankBranchCode))
          return "bankBranchCode: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.transactionTime);
        if (error)
          return "transactionTime." + error;
      }
      if (message.sourceTransactionId != null && message.hasOwnProperty("sourceTransactionId")) {
        if (!$util.isString(message.sourceTransactionId))
          return "sourceTransactionId: string expected";
      }
      if (message.txCode != null && message.hasOwnProperty("txCode")) {
        if (!$util.isString(message.txCode))
          return "txCode: string expected";
      }
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType")) {
        if (!$util.isString(message.withdrawType))
          return "withdrawType: string expected";
      }
      return null;
    };
    BankWithdraw.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BankWithdraw)
        return object;
      let message = new $root.dnse.BankWithdraw();
      if (object.id != null)
        message.id = String(object.id);
      if (object.type != null)
        message.type = String(object.type);
      if (object.bankAccountNumber != null)
        message.bankAccountNumber = String(object.bankAccountNumber);
      if (object.bankAccountType != null)
        message.bankAccountType = String(object.bankAccountType);
      if (object.bankAccountName != null)
        message.bankAccountName = String(object.bankAccountName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.bankName != null)
        message.bankName = String(object.bankName);
      if (object.bankCode != null)
        message.bankCode = String(object.bankCode);
      if (object.bankNapasCode != null)
        message.bankNapasCode = String(object.bankNapasCode);
      if (object.bankBranchCode != null)
        message.bankBranchCode = String(object.bankBranchCode);
      if (object.description != null)
        message.description = String(object.description);
      if (object.transactionTime != null) {
        if (typeof object.transactionTime !== "object")
          throw TypeError(".dnse.BankWithdraw.transactionTime: object expected");
        message.transactionTime = $root.google.protobuf.Timestamp.fromObject(object.transactionTime);
      }
      if (object.sourceTransactionId != null)
        message.sourceTransactionId = String(object.sourceTransactionId);
      if (object.txCode != null)
        message.txCode = String(object.txCode);
      if (object.withdrawType != null)
        message.withdrawType = String(object.withdrawType);
      return message;
    };
    BankWithdraw.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.type = "";
        object.bankAccountNumber = "";
        object.bankAccountType = "";
        object.bankAccountName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.bankName = "";
        object.bankCode = "";
        object.bankNapasCode = "";
        object.bankBranchCode = "";
        object.description = "";
        object.transactionTime = null;
        object.sourceTransactionId = "";
        object.txCode = "";
        object.withdrawType = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber"))
        object.bankAccountNumber = message.bankAccountNumber;
      if (message.bankAccountType != null && message.hasOwnProperty("bankAccountType"))
        object.bankAccountType = message.bankAccountType;
      if (message.bankAccountName != null && message.hasOwnProperty("bankAccountName"))
        object.bankAccountName = message.bankAccountName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.bankName != null && message.hasOwnProperty("bankName"))
        object.bankName = message.bankName;
      if (message.bankCode != null && message.hasOwnProperty("bankCode"))
        object.bankCode = message.bankCode;
      if (message.bankNapasCode != null && message.hasOwnProperty("bankNapasCode"))
        object.bankNapasCode = message.bankNapasCode;
      if (message.bankBranchCode != null && message.hasOwnProperty("bankBranchCode"))
        object.bankBranchCode = message.bankBranchCode;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
        object.transactionTime = $root.google.protobuf.Timestamp.toObject(message.transactionTime, options);
      if (message.sourceTransactionId != null && message.hasOwnProperty("sourceTransactionId"))
        object.sourceTransactionId = message.sourceTransactionId;
      if (message.txCode != null && message.hasOwnProperty("txCode"))
        object.txCode = message.txCode;
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType"))
        object.withdrawType = message.withdrawType;
      return object;
    };
    BankWithdraw.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BankWithdraw;
  }();
  dnse2.DepositMessage = function() {
    function DepositMessage(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DepositMessage.prototype.from = "";
    DepositMessage.prototype.name = "";
    DepositMessage.prototype.content = "";
    DepositMessage.create = function create(properties) {
      return new DepositMessage(properties);
    };
    DepositMessage.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.from != null && Object.hasOwnProperty.call(message, "from"))
        writer.uint32(10).string(message.from);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(18).string(message.name);
      if (message.content != null && Object.hasOwnProperty.call(message, "content"))
        writer.uint32(26).string(message.content);
      return writer;
    };
    DepositMessage.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DepositMessage.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DepositMessage();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.from = reader.string();
            break;
          case 2:
            message.name = reader.string();
            break;
          case 3:
            message.content = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DepositMessage.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DepositMessage.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.from != null && message.hasOwnProperty("from")) {
        if (!$util.isString(message.from))
          return "from: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.content != null && message.hasOwnProperty("content")) {
        if (!$util.isString(message.content))
          return "content: string expected";
      }
      return null;
    };
    DepositMessage.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DepositMessage)
        return object;
      let message = new $root.dnse.DepositMessage();
      if (object.from != null)
        message.from = String(object.from);
      if (object.name != null)
        message.name = String(object.name);
      if (object.content != null)
        message.content = String(object.content);
      return message;
    };
    DepositMessage.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.from = "";
        object.name = "";
        object.content = "";
      }
      if (message.from != null && message.hasOwnProperty("from"))
        object.from = message.from;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.content != null && message.hasOwnProperty("content"))
        object.content = message.content;
      return object;
    };
    DepositMessage.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DepositMessage;
  }();
  dnse2.BankCommissionPaid = function() {
    function BankCommissionPaid(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BankCommissionPaid.prototype.referenceNumber = "";
    BankCommissionPaid.prototype.bankAccountNumber = "";
    BankCommissionPaid.prototype.bankAccountName = "";
    BankCommissionPaid.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BankCommissionPaid.prototype.bankName = "";
    BankCommissionPaid.prototype.bankCode = "";
    BankCommissionPaid.prototype.bankBranchCode = "";
    BankCommissionPaid.prototype.description = "";
    BankCommissionPaid.prototype.transactionTime = null;
    BankCommissionPaid.prototype.sourceTransactionId = "";
    BankCommissionPaid.prototype.createdDate = null;
    BankCommissionPaid.prototype.sourceBankAccount = "";
    BankCommissionPaid.prototype.signature = "";
    BankCommissionPaid.create = function create(properties) {
      return new BankCommissionPaid(properties);
    };
    BankCommissionPaid.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.referenceNumber != null && Object.hasOwnProperty.call(message, "referenceNumber"))
        writer.uint32(10).string(message.referenceNumber);
      if (message.bankAccountNumber != null && Object.hasOwnProperty.call(message, "bankAccountNumber"))
        writer.uint32(18).string(message.bankAccountNumber);
      if (message.bankAccountName != null && Object.hasOwnProperty.call(message, "bankAccountName"))
        writer.uint32(26).string(message.bankAccountName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(32).int64(message.amount);
      if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
        writer.uint32(42).string(message.bankName);
      if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
        writer.uint32(50).string(message.bankCode);
      if (message.bankBranchCode != null && Object.hasOwnProperty.call(message, "bankBranchCode"))
        writer.uint32(58).string(message.bankBranchCode);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(66).string(message.description);
      if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
        $root.google.protobuf.Timestamp.encode(message.transactionTime, writer.uint32(74).fork()).ldelim();
      if (message.sourceTransactionId != null && Object.hasOwnProperty.call(message, "sourceTransactionId"))
        writer.uint32(82).string(message.sourceTransactionId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(90).fork()).ldelim();
      if (message.sourceBankAccount != null && Object.hasOwnProperty.call(message, "sourceBankAccount"))
        writer.uint32(98).string(message.sourceBankAccount);
      if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
        writer.uint32(106).string(message.signature);
      return writer;
    };
    BankCommissionPaid.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BankCommissionPaid.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BankCommissionPaid();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.referenceNumber = reader.string();
            break;
          case 2:
            message.bankAccountNumber = reader.string();
            break;
          case 3:
            message.bankAccountName = reader.string();
            break;
          case 4:
            message.amount = reader.int64();
            break;
          case 5:
            message.bankName = reader.string();
            break;
          case 6:
            message.bankCode = reader.string();
            break;
          case 7:
            message.bankBranchCode = reader.string();
            break;
          case 8:
            message.description = reader.string();
            break;
          case 9:
            message.transactionTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.sourceTransactionId = reader.string();
            break;
          case 11:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.sourceBankAccount = reader.string();
            break;
          case 13:
            message.signature = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BankCommissionPaid.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BankCommissionPaid.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.referenceNumber != null && message.hasOwnProperty("referenceNumber")) {
        if (!$util.isString(message.referenceNumber))
          return "referenceNumber: string expected";
      }
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber")) {
        if (!$util.isString(message.bankAccountNumber))
          return "bankAccountNumber: string expected";
      }
      if (message.bankAccountName != null && message.hasOwnProperty("bankAccountName")) {
        if (!$util.isString(message.bankAccountName))
          return "bankAccountName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.bankName != null && message.hasOwnProperty("bankName")) {
        if (!$util.isString(message.bankName))
          return "bankName: string expected";
      }
      if (message.bankCode != null && message.hasOwnProperty("bankCode")) {
        if (!$util.isString(message.bankCode))
          return "bankCode: string expected";
      }
      if (message.bankBranchCode != null && message.hasOwnProperty("bankBranchCode")) {
        if (!$util.isString(message.bankBranchCode))
          return "bankBranchCode: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.transactionTime);
        if (error)
          return "transactionTime." + error;
      }
      if (message.sourceTransactionId != null && message.hasOwnProperty("sourceTransactionId")) {
        if (!$util.isString(message.sourceTransactionId))
          return "sourceTransactionId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.sourceBankAccount != null && message.hasOwnProperty("sourceBankAccount")) {
        if (!$util.isString(message.sourceBankAccount))
          return "sourceBankAccount: string expected";
      }
      if (message.signature != null && message.hasOwnProperty("signature")) {
        if (!$util.isString(message.signature))
          return "signature: string expected";
      }
      return null;
    };
    BankCommissionPaid.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BankCommissionPaid)
        return object;
      let message = new $root.dnse.BankCommissionPaid();
      if (object.referenceNumber != null)
        message.referenceNumber = String(object.referenceNumber);
      if (object.bankAccountNumber != null)
        message.bankAccountNumber = String(object.bankAccountNumber);
      if (object.bankAccountName != null)
        message.bankAccountName = String(object.bankAccountName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.bankName != null)
        message.bankName = String(object.bankName);
      if (object.bankCode != null)
        message.bankCode = String(object.bankCode);
      if (object.bankBranchCode != null)
        message.bankBranchCode = String(object.bankBranchCode);
      if (object.description != null)
        message.description = String(object.description);
      if (object.transactionTime != null) {
        if (typeof object.transactionTime !== "object")
          throw TypeError(".dnse.BankCommissionPaid.transactionTime: object expected");
        message.transactionTime = $root.google.protobuf.Timestamp.fromObject(object.transactionTime);
      }
      if (object.sourceTransactionId != null)
        message.sourceTransactionId = String(object.sourceTransactionId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.BankCommissionPaid.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.sourceBankAccount != null)
        message.sourceBankAccount = String(object.sourceBankAccount);
      if (object.signature != null)
        message.signature = String(object.signature);
      return message;
    };
    BankCommissionPaid.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.referenceNumber = "";
        object.bankAccountNumber = "";
        object.bankAccountName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.bankName = "";
        object.bankCode = "";
        object.bankBranchCode = "";
        object.description = "";
        object.transactionTime = null;
        object.sourceTransactionId = "";
        object.createdDate = null;
        object.sourceBankAccount = "";
        object.signature = "";
      }
      if (message.referenceNumber != null && message.hasOwnProperty("referenceNumber"))
        object.referenceNumber = message.referenceNumber;
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber"))
        object.bankAccountNumber = message.bankAccountNumber;
      if (message.bankAccountName != null && message.hasOwnProperty("bankAccountName"))
        object.bankAccountName = message.bankAccountName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.bankName != null && message.hasOwnProperty("bankName"))
        object.bankName = message.bankName;
      if (message.bankCode != null && message.hasOwnProperty("bankCode"))
        object.bankCode = message.bankCode;
      if (message.bankBranchCode != null && message.hasOwnProperty("bankBranchCode"))
        object.bankBranchCode = message.bankBranchCode;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
        object.transactionTime = $root.google.protobuf.Timestamp.toObject(message.transactionTime, options);
      if (message.sourceTransactionId != null && message.hasOwnProperty("sourceTransactionId"))
        object.sourceTransactionId = message.sourceTransactionId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.sourceBankAccount != null && message.hasOwnProperty("sourceBankAccount"))
        object.sourceBankAccount = message.sourceBankAccount;
      if (message.signature != null && message.hasOwnProperty("signature"))
        object.signature = message.signature;
      return object;
    };
    BankCommissionPaid.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BankCommissionPaid;
  }();
  dnse2.BankDeposit = function() {
    function BankDeposit(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BankDeposit.prototype.investorAccountId = "";
    BankDeposit.prototype.accountTypeName = "";
    BankDeposit.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BankDeposit.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BankDeposit.prototype.createdDate = null;
    BankDeposit.prototype.investorId = "";
    BankDeposit.prototype.channel = "";
    BankDeposit.prototype.refund = false;
    BankDeposit.prototype.description = "";
    BankDeposit.create = function create(properties) {
      return new BankDeposit(properties);
    };
    BankDeposit.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(10).string(message.investorAccountId);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(18).string(message.accountTypeName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).int64(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(32).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(42).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
        writer.uint32(58).string(message.channel);
      if (message.refund != null && Object.hasOwnProperty.call(message, "refund"))
        writer.uint32(64).bool(message.refund);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(74).string(message.description);
      return writer;
    };
    BankDeposit.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BankDeposit.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BankDeposit();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorAccountId = reader.string();
            break;
          case 2:
            message.accountTypeName = reader.string();
            break;
          case 3:
            message.amount = reader.int64();
            break;
          case 4:
            message.availableCash = reader.int64();
            break;
          case 5:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.channel = reader.string();
            break;
          case 8:
            message.refund = reader.bool();
            break;
          case 9:
            message.description = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BankDeposit.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BankDeposit.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isString(message.investorAccountId))
          return "investorAccountId: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.channel != null && message.hasOwnProperty("channel")) {
        if (!$util.isString(message.channel))
          return "channel: string expected";
      }
      if (message.refund != null && message.hasOwnProperty("refund")) {
        if (typeof message.refund !== "boolean")
          return "refund: boolean expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      return null;
    };
    BankDeposit.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BankDeposit)
        return object;
      let message = new $root.dnse.BankDeposit();
      if (object.investorAccountId != null)
        message.investorAccountId = String(object.investorAccountId);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.BankDeposit.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.channel != null)
        message.channel = String(object.channel);
      if (object.refund != null)
        message.refund = Boolean(object.refund);
      if (object.description != null)
        message.description = String(object.description);
      return message;
    };
    BankDeposit.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorAccountId = "";
        object.accountTypeName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.investorId = "";
        object.channel = "";
        object.refund = false;
        object.description = "";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.channel != null && message.hasOwnProperty("channel"))
        object.channel = message.channel;
      if (message.refund != null && message.hasOwnProperty("refund"))
        object.refund = message.refund;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      return object;
    };
    BankDeposit.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BankDeposit;
  }();
  dnse2.WithdrawTransaction = function() {
    function WithdrawTransaction(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    WithdrawTransaction.prototype.accountTypeName = "";
    WithdrawTransaction.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    WithdrawTransaction.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    WithdrawTransaction.prototype.createdDate = null;
    WithdrawTransaction.prototype.bankShortName = "";
    WithdrawTransaction.prototype.investorId = "";
    WithdrawTransaction.prototype.investorAccountId = "";
    WithdrawTransaction.prototype.bankAccountNumber = "";
    WithdrawTransaction.create = function create(properties) {
      return new WithdrawTransaction(properties);
    };
    WithdrawTransaction.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(10).string(message.accountTypeName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).int64(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(24).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.bankShortName != null && Object.hasOwnProperty.call(message, "bankShortName"))
        writer.uint32(42).string(message.bankShortName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(58).string(message.investorAccountId);
      if (message.bankAccountNumber != null && Object.hasOwnProperty.call(message, "bankAccountNumber"))
        writer.uint32(66).string(message.bankAccountNumber);
      return writer;
    };
    WithdrawTransaction.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    WithdrawTransaction.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.WithdrawTransaction();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountTypeName = reader.string();
            break;
          case 2:
            message.amount = reader.int64();
            break;
          case 3:
            message.availableCash = reader.int64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.bankShortName = reader.string();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.investorAccountId = reader.string();
            break;
          case 8:
            message.bankAccountNumber = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    WithdrawTransaction.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    WithdrawTransaction.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.bankShortName != null && message.hasOwnProperty("bankShortName")) {
        if (!$util.isString(message.bankShortName))
          return "bankShortName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isString(message.investorAccountId))
          return "investorAccountId: string expected";
      }
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber")) {
        if (!$util.isString(message.bankAccountNumber))
          return "bankAccountNumber: string expected";
      }
      return null;
    };
    WithdrawTransaction.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.WithdrawTransaction)
        return object;
      let message = new $root.dnse.WithdrawTransaction();
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.WithdrawTransaction.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.bankShortName != null)
        message.bankShortName = String(object.bankShortName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.investorAccountId != null)
        message.investorAccountId = String(object.investorAccountId);
      if (object.bankAccountNumber != null)
        message.bankAccountNumber = String(object.bankAccountNumber);
      return message;
    };
    WithdrawTransaction.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountTypeName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.bankShortName = "";
        object.investorId = "";
        object.investorAccountId = "";
        object.bankAccountNumber = "";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.bankShortName != null && message.hasOwnProperty("bankShortName"))
        object.bankShortName = message.bankShortName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber"))
        object.bankAccountNumber = message.bankAccountNumber;
      return object;
    };
    WithdrawTransaction.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return WithdrawTransaction;
  }();
  dnse2.DeadlineReminder = function() {
    function DeadlineReminder(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DeadlineReminder.prototype.email = "";
    DeadlineReminder.prototype.name = "";
    DeadlineReminder.prototype.dealine = "";
    DeadlineReminder.prototype.custodyCode = "";
    DeadlineReminder.prototype.investorId = "";
    DeadlineReminder.create = function create(properties) {
      return new DeadlineReminder(properties);
    };
    DeadlineReminder.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(10).string(message.email);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(18).string(message.name);
      if (message.dealine != null && Object.hasOwnProperty.call(message, "dealine"))
        writer.uint32(26).string(message.dealine);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(34).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      return writer;
    };
    DeadlineReminder.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DeadlineReminder.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DeadlineReminder();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.email = reader.string();
            break;
          case 2:
            message.name = reader.string();
            break;
          case 3:
            message.dealine = reader.string();
            break;
          case 4:
            message.custodyCode = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DeadlineReminder.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DeadlineReminder.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.dealine != null && message.hasOwnProperty("dealine")) {
        if (!$util.isString(message.dealine))
          return "dealine: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    DeadlineReminder.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DeadlineReminder)
        return object;
      let message = new $root.dnse.DeadlineReminder();
      if (object.email != null)
        message.email = String(object.email);
      if (object.name != null)
        message.name = String(object.name);
      if (object.dealine != null)
        message.dealine = String(object.dealine);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    DeadlineReminder.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.email = "";
        object.name = "";
        object.dealine = "";
        object.custodyCode = "";
        object.investorId = "";
      }
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.dealine != null && message.hasOwnProperty("dealine"))
        object.dealine = message.dealine;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    DeadlineReminder.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DeadlineReminder;
  }();
  dnse2.Referral = function() {
    function Referral(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Referral.prototype.referralCode = "";
    Referral.prototype.referrerInvestorId = "";
    Referral.prototype.referrerCustodyCode = "";
    Referral.prototype.referrerName = "";
    Referral.prototype.investorId = "";
    Referral.prototype.custodyCode = "";
    Referral.prototype.investorName = "";
    Referral.prototype.type = "";
    Referral.prototype.status = "";
    Referral.prototype.reward = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Referral.prototype.referrerAccountType = "";
    Referral.prototype.metadata = "";
    Referral.prototype.createdDate = null;
    Referral.prototype.modifiedDate = null;
    Referral.prototype.rewardForNewUser = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Referral.prototype.accountType = "";
    Referral.create = function create(properties) {
      return new Referral(properties);
    };
    Referral.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.referralCode != null && Object.hasOwnProperty.call(message, "referralCode"))
        writer.uint32(10).string(message.referralCode);
      if (message.referrerInvestorId != null && Object.hasOwnProperty.call(message, "referrerInvestorId"))
        writer.uint32(18).string(message.referrerInvestorId);
      if (message.referrerCustodyCode != null && Object.hasOwnProperty.call(message, "referrerCustodyCode"))
        writer.uint32(26).string(message.referrerCustodyCode);
      if (message.referrerName != null && Object.hasOwnProperty.call(message, "referrerName"))
        writer.uint32(34).string(message.referrerName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(50).string(message.custodyCode);
      if (message.investorName != null && Object.hasOwnProperty.call(message, "investorName"))
        writer.uint32(58).string(message.investorName);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(66).string(message.type);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(74).string(message.status);
      if (message.reward != null && Object.hasOwnProperty.call(message, "reward"))
        writer.uint32(80).int64(message.reward);
      if (message.referrerAccountType != null && Object.hasOwnProperty.call(message, "referrerAccountType"))
        writer.uint32(98).string(message.referrerAccountType);
      if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
        writer.uint32(106).string(message.metadata);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(114).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(122).fork()).ldelim();
      if (message.rewardForNewUser != null && Object.hasOwnProperty.call(message, "rewardForNewUser"))
        writer.uint32(128).int64(message.rewardForNewUser);
      if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
        writer.uint32(138).string(message.accountType);
      return writer;
    };
    Referral.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Referral.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Referral();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.referralCode = reader.string();
            break;
          case 2:
            message.referrerInvestorId = reader.string();
            break;
          case 3:
            message.referrerCustodyCode = reader.string();
            break;
          case 4:
            message.referrerName = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.custodyCode = reader.string();
            break;
          case 7:
            message.investorName = reader.string();
            break;
          case 8:
            message.type = reader.string();
            break;
          case 9:
            message.status = reader.string();
            break;
          case 10:
            message.reward = reader.int64();
            break;
          case 12:
            message.referrerAccountType = reader.string();
            break;
          case 13:
            message.metadata = reader.string();
            break;
          case 14:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 15:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 16:
            message.rewardForNewUser = reader.int64();
            break;
          case 17:
            message.accountType = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Referral.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Referral.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.referralCode != null && message.hasOwnProperty("referralCode")) {
        if (!$util.isString(message.referralCode))
          return "referralCode: string expected";
      }
      if (message.referrerInvestorId != null && message.hasOwnProperty("referrerInvestorId")) {
        if (!$util.isString(message.referrerInvestorId))
          return "referrerInvestorId: string expected";
      }
      if (message.referrerCustodyCode != null && message.hasOwnProperty("referrerCustodyCode")) {
        if (!$util.isString(message.referrerCustodyCode))
          return "referrerCustodyCode: string expected";
      }
      if (message.referrerName != null && message.hasOwnProperty("referrerName")) {
        if (!$util.isString(message.referrerName))
          return "referrerName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorName != null && message.hasOwnProperty("investorName")) {
        if (!$util.isString(message.investorName))
          return "investorName: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.reward != null && message.hasOwnProperty("reward")) {
        if (!$util.isInteger(message.reward) && !(message.reward && $util.isInteger(message.reward.low) && $util.isInteger(message.reward.high)))
          return "reward: integer|Long expected";
      }
      if (message.referrerAccountType != null && message.hasOwnProperty("referrerAccountType")) {
        if (!$util.isString(message.referrerAccountType))
          return "referrerAccountType: string expected";
      }
      if (message.metadata != null && message.hasOwnProperty("metadata")) {
        if (!$util.isString(message.metadata))
          return "metadata: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.rewardForNewUser != null && message.hasOwnProperty("rewardForNewUser")) {
        if (!$util.isInteger(message.rewardForNewUser) && !(message.rewardForNewUser && $util.isInteger(message.rewardForNewUser.low) && $util.isInteger(message.rewardForNewUser.high)))
          return "rewardForNewUser: integer|Long expected";
      }
      if (message.accountType != null && message.hasOwnProperty("accountType")) {
        if (!$util.isString(message.accountType))
          return "accountType: string expected";
      }
      return null;
    };
    Referral.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Referral)
        return object;
      let message = new $root.dnse.Referral();
      if (object.referralCode != null)
        message.referralCode = String(object.referralCode);
      if (object.referrerInvestorId != null)
        message.referrerInvestorId = String(object.referrerInvestorId);
      if (object.referrerCustodyCode != null)
        message.referrerCustodyCode = String(object.referrerCustodyCode);
      if (object.referrerName != null)
        message.referrerName = String(object.referrerName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorName != null)
        message.investorName = String(object.investorName);
      if (object.type != null)
        message.type = String(object.type);
      if (object.status != null)
        message.status = String(object.status);
      if (object.reward != null) {
        if ($util.Long)
          (message.reward = $util.Long.fromValue(object.reward)).unsigned = false;
        else if (typeof object.reward === "string")
          message.reward = parseInt(object.reward, 10);
        else if (typeof object.reward === "number")
          message.reward = object.reward;
        else if (typeof object.reward === "object")
          message.reward = new $util.LongBits(object.reward.low >>> 0, object.reward.high >>> 0).toNumber();
      }
      if (object.referrerAccountType != null)
        message.referrerAccountType = String(object.referrerAccountType);
      if (object.metadata != null)
        message.metadata = String(object.metadata);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.Referral.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.Referral.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.rewardForNewUser != null) {
        if ($util.Long)
          (message.rewardForNewUser = $util.Long.fromValue(object.rewardForNewUser)).unsigned = false;
        else if (typeof object.rewardForNewUser === "string")
          message.rewardForNewUser = parseInt(object.rewardForNewUser, 10);
        else if (typeof object.rewardForNewUser === "number")
          message.rewardForNewUser = object.rewardForNewUser;
        else if (typeof object.rewardForNewUser === "object")
          message.rewardForNewUser = new $util.LongBits(object.rewardForNewUser.low >>> 0, object.rewardForNewUser.high >>> 0).toNumber();
      }
      if (object.accountType != null)
        message.accountType = String(object.accountType);
      return message;
    };
    Referral.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.referralCode = "";
        object.referrerInvestorId = "";
        object.referrerCustodyCode = "";
        object.referrerName = "";
        object.investorId = "";
        object.custodyCode = "";
        object.investorName = "";
        object.type = "";
        object.status = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.reward = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.reward = options.longs === String ? "0" : 0;
        object.referrerAccountType = "";
        object.metadata = "";
        object.createdDate = null;
        object.modifiedDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.rewardForNewUser = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.rewardForNewUser = options.longs === String ? "0" : 0;
        object.accountType = "";
      }
      if (message.referralCode != null && message.hasOwnProperty("referralCode"))
        object.referralCode = message.referralCode;
      if (message.referrerInvestorId != null && message.hasOwnProperty("referrerInvestorId"))
        object.referrerInvestorId = message.referrerInvestorId;
      if (message.referrerCustodyCode != null && message.hasOwnProperty("referrerCustodyCode"))
        object.referrerCustodyCode = message.referrerCustodyCode;
      if (message.referrerName != null && message.hasOwnProperty("referrerName"))
        object.referrerName = message.referrerName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorName != null && message.hasOwnProperty("investorName"))
        object.investorName = message.investorName;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.reward != null && message.hasOwnProperty("reward"))
        if (typeof message.reward === "number")
          object.reward = options.longs === String ? String(message.reward) : message.reward;
        else
          object.reward = options.longs === String ? $util.Long.prototype.toString.call(message.reward) : options.longs === Number ? new $util.LongBits(message.reward.low >>> 0, message.reward.high >>> 0).toNumber() : message.reward;
      if (message.referrerAccountType != null && message.hasOwnProperty("referrerAccountType"))
        object.referrerAccountType = message.referrerAccountType;
      if (message.metadata != null && message.hasOwnProperty("metadata"))
        object.metadata = message.metadata;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.rewardForNewUser != null && message.hasOwnProperty("rewardForNewUser"))
        if (typeof message.rewardForNewUser === "number")
          object.rewardForNewUser = options.longs === String ? String(message.rewardForNewUser) : message.rewardForNewUser;
        else
          object.rewardForNewUser = options.longs === String ? $util.Long.prototype.toString.call(message.rewardForNewUser) : options.longs === Number ? new $util.LongBits(message.rewardForNewUser.low >>> 0, message.rewardForNewUser.high >>> 0).toNumber() : message.rewardForNewUser;
      if (message.accountType != null && message.hasOwnProperty("accountType"))
        object.accountType = message.accountType;
      return object;
    };
    Referral.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Referral;
  }();
  dnse2.MarginAccountOffer = function() {
    function MarginAccountOffer(properties) {
      this.loanPackageIds = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MarginAccountOffer.prototype.id = 0;
    MarginAccountOffer.prototype.custodyCode = "";
    MarginAccountOffer.prototype.name = "";
    MarginAccountOffer.prototype.accountType = "";
    MarginAccountOffer.prototype.maxLoanLimit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarginAccountOffer.prototype.signatureLink = "";
    MarginAccountOffer.prototype.registerStatus = 0;
    MarginAccountOffer.prototype.createdDate = null;
    MarginAccountOffer.prototype.modifiedDate = null;
    MarginAccountOffer.prototype.investor = null;
    MarginAccountOffer.prototype.accountNo = "";
    MarginAccountOffer.prototype.type = "";
    MarginAccountOffer.prototype.loanPackageIds = $util.emptyArray;
    MarginAccountOffer.prototype.isPreRegisterMargin = false;
    MarginAccountOffer.prototype.registerChannel = "";
    MarginAccountOffer.create = function create(properties) {
      return new MarginAccountOffer(properties);
    };
    MarginAccountOffer.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(26).string(message.name);
      if (message.accountType != null && Object.hasOwnProperty.call(message, "accountType"))
        writer.uint32(34).string(message.accountType);
      if (message.maxLoanLimit != null && Object.hasOwnProperty.call(message, "maxLoanLimit"))
        writer.uint32(40).int64(message.maxLoanLimit);
      if (message.signatureLink != null && Object.hasOwnProperty.call(message, "signatureLink"))
        writer.uint32(50).string(message.signatureLink);
      if (message.registerStatus != null && Object.hasOwnProperty.call(message, "registerStatus"))
        writer.uint32(56).int32(message.registerStatus);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(74).fork()).ldelim();
      if (message.investor != null && Object.hasOwnProperty.call(message, "investor"))
        $root.dnse.Investor.encode(message.investor, writer.uint32(82).fork()).ldelim();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(90).string(message.accountNo);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(98).string(message.type);
      if (message.loanPackageIds != null && message.loanPackageIds.length) {
        writer.uint32(106).fork();
        for (let i = 0; i < message.loanPackageIds.length; ++i)
          writer.int32(message.loanPackageIds[i]);
        writer.ldelim();
      }
      if (message.isPreRegisterMargin != null && Object.hasOwnProperty.call(message, "isPreRegisterMargin"))
        writer.uint32(112).bool(message.isPreRegisterMargin);
      if (message.registerChannel != null && Object.hasOwnProperty.call(message, "registerChannel"))
        writer.uint32(122).string(message.registerChannel);
      return writer;
    };
    MarginAccountOffer.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MarginAccountOffer.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.MarginAccountOffer();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.name = reader.string();
            break;
          case 4:
            message.accountType = reader.string();
            break;
          case 5:
            message.maxLoanLimit = reader.int64();
            break;
          case 6:
            message.signatureLink = reader.string();
            break;
          case 7:
            message.registerStatus = reader.int32();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.investor = $root.dnse.Investor.decode(reader, reader.uint32());
            break;
          case 11:
            message.accountNo = reader.string();
            break;
          case 12:
            message.type = reader.string();
            break;
          case 13:
            if (!(message.loanPackageIds && message.loanPackageIds.length))
              message.loanPackageIds = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2)
                message.loanPackageIds.push(reader.int32());
            } else
              message.loanPackageIds.push(reader.int32());
            break;
          case 14:
            message.isPreRegisterMargin = reader.bool();
            break;
          case 15:
            message.registerChannel = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MarginAccountOffer.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MarginAccountOffer.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.accountType != null && message.hasOwnProperty("accountType")) {
        if (!$util.isString(message.accountType))
          return "accountType: string expected";
      }
      if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit")) {
        if (!$util.isInteger(message.maxLoanLimit) && !(message.maxLoanLimit && $util.isInteger(message.maxLoanLimit.low) && $util.isInteger(message.maxLoanLimit.high)))
          return "maxLoanLimit: integer|Long expected";
      }
      if (message.signatureLink != null && message.hasOwnProperty("signatureLink")) {
        if (!$util.isString(message.signatureLink))
          return "signatureLink: string expected";
      }
      if (message.registerStatus != null && message.hasOwnProperty("registerStatus"))
        switch (message.registerStatus) {
          default:
            return "registerStatus: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.investor != null && message.hasOwnProperty("investor")) {
        let error = $root.dnse.Investor.verify(message.investor);
        if (error)
          return "investor." + error;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.loanPackageIds != null && message.hasOwnProperty("loanPackageIds")) {
        if (!Array.isArray(message.loanPackageIds))
          return "loanPackageIds: array expected";
        for (let i = 0; i < message.loanPackageIds.length; ++i)
          if (!$util.isInteger(message.loanPackageIds[i]))
            return "loanPackageIds: integer[] expected";
      }
      if (message.isPreRegisterMargin != null && message.hasOwnProperty("isPreRegisterMargin")) {
        if (typeof message.isPreRegisterMargin !== "boolean")
          return "isPreRegisterMargin: boolean expected";
      }
      if (message.registerChannel != null && message.hasOwnProperty("registerChannel")) {
        if (!$util.isString(message.registerChannel))
          return "registerChannel: string expected";
      }
      return null;
    };
    MarginAccountOffer.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.MarginAccountOffer)
        return object;
      let message = new $root.dnse.MarginAccountOffer();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.name != null)
        message.name = String(object.name);
      if (object.accountType != null)
        message.accountType = String(object.accountType);
      if (object.maxLoanLimit != null) {
        if ($util.Long)
          (message.maxLoanLimit = $util.Long.fromValue(object.maxLoanLimit)).unsigned = false;
        else if (typeof object.maxLoanLimit === "string")
          message.maxLoanLimit = parseInt(object.maxLoanLimit, 10);
        else if (typeof object.maxLoanLimit === "number")
          message.maxLoanLimit = object.maxLoanLimit;
        else if (typeof object.maxLoanLimit === "object")
          message.maxLoanLimit = new $util.LongBits(object.maxLoanLimit.low >>> 0, object.maxLoanLimit.high >>> 0).toNumber();
      }
      if (object.signatureLink != null)
        message.signatureLink = String(object.signatureLink);
      switch (object.registerStatus) {
        case "OFFER":
        case 0:
          message.registerStatus = 0;
          break;
        case "PENDING":
        case 1:
          message.registerStatus = 1;
          break;
        case "APPROVAL":
        case 2:
          message.registerStatus = 2;
          break;
        case "REJECTED":
        case 3:
          message.registerStatus = 3;
          break;
        case "ACTIVE":
        case 4:
          message.registerStatus = 4;
          break;
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.MarginAccountOffer.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.MarginAccountOffer.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.investor != null) {
        if (typeof object.investor !== "object")
          throw TypeError(".dnse.MarginAccountOffer.investor: object expected");
        message.investor = $root.dnse.Investor.fromObject(object.investor);
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.type != null)
        message.type = String(object.type);
      if (object.loanPackageIds) {
        if (!Array.isArray(object.loanPackageIds))
          throw TypeError(".dnse.MarginAccountOffer.loanPackageIds: array expected");
        message.loanPackageIds = [];
        for (let i = 0; i < object.loanPackageIds.length; ++i)
          message.loanPackageIds[i] = object.loanPackageIds[i] | 0;
      }
      if (object.isPreRegisterMargin != null)
        message.isPreRegisterMargin = Boolean(object.isPreRegisterMargin);
      if (object.registerChannel != null)
        message.registerChannel = String(object.registerChannel);
      return message;
    };
    MarginAccountOffer.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.loanPackageIds = [];
      if (options.defaults) {
        object.id = 0;
        object.custodyCode = "";
        object.name = "";
        object.accountType = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.maxLoanLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.maxLoanLimit = options.longs === String ? "0" : 0;
        object.signatureLink = "";
        object.registerStatus = options.enums === String ? "OFFER" : 0;
        object.createdDate = null;
        object.modifiedDate = null;
        object.investor = null;
        object.accountNo = "";
        object.type = "";
        object.isPreRegisterMargin = false;
        object.registerChannel = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.accountType != null && message.hasOwnProperty("accountType"))
        object.accountType = message.accountType;
      if (message.maxLoanLimit != null && message.hasOwnProperty("maxLoanLimit"))
        if (typeof message.maxLoanLimit === "number")
          object.maxLoanLimit = options.longs === String ? String(message.maxLoanLimit) : message.maxLoanLimit;
        else
          object.maxLoanLimit = options.longs === String ? $util.Long.prototype.toString.call(message.maxLoanLimit) : options.longs === Number ? new $util.LongBits(message.maxLoanLimit.low >>> 0, message.maxLoanLimit.high >>> 0).toNumber() : message.maxLoanLimit;
      if (message.signatureLink != null && message.hasOwnProperty("signatureLink"))
        object.signatureLink = message.signatureLink;
      if (message.registerStatus != null && message.hasOwnProperty("registerStatus"))
        object.registerStatus = options.enums === String ? $root.dnse.MarginAccountOffer.RegisterStatus[message.registerStatus] : message.registerStatus;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.investor != null && message.hasOwnProperty("investor"))
        object.investor = $root.dnse.Investor.toObject(message.investor, options);
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.loanPackageIds && message.loanPackageIds.length) {
        object.loanPackageIds = [];
        for (let j = 0; j < message.loanPackageIds.length; ++j)
          object.loanPackageIds[j] = message.loanPackageIds[j];
      }
      if (message.isPreRegisterMargin != null && message.hasOwnProperty("isPreRegisterMargin"))
        object.isPreRegisterMargin = message.isPreRegisterMargin;
      if (message.registerChannel != null && message.hasOwnProperty("registerChannel"))
        object.registerChannel = message.registerChannel;
      return object;
    };
    MarginAccountOffer.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    MarginAccountOffer.RegisterStatus = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "OFFER"] = 0;
      values[valuesById[1] = "PENDING"] = 1;
      values[valuesById[2] = "APPROVAL"] = 2;
      values[valuesById[3] = "REJECTED"] = 3;
      values[valuesById[4] = "ACTIVE"] = 4;
      return values;
    }();
    return MarginAccountOffer;
  }();
  dnse2.CorporateActionDividendAndRight = function() {
    function CorporateActionDividendAndRight(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CorporateActionDividendAndRight.prototype.symbol = "";
    CorporateActionDividendAndRight.prototype.price = 0;
    CorporateActionDividendAndRight.prototype.priceNew = 0;
    CorporateActionDividendAndRight.prototype.priceAlpha = 0;
    CorporateActionDividendAndRight.prototype.alpha = "";
    CorporateActionDividendAndRight.prototype.beta = "";
    CorporateActionDividendAndRight.prototype.dividendCash = 0;
    CorporateActionDividendAndRight.prototype.ratio = 0;
    CorporateActionDividendAndRight.prototype.exDividendDate = null;
    CorporateActionDividendAndRight.prototype.timestamp = null;
    CorporateActionDividendAndRight.prototype.exerciseDate = null;
    CorporateActionDividendAndRight.prototype.estimateReceivingDate = null;
    CorporateActionDividendAndRight.prototype.rightSubscribeStartDate = null;
    CorporateActionDividendAndRight.prototype.rightSubscribeEndDate = null;
    CorporateActionDividendAndRight.prototype.bonusStockRatio = "";
    CorporateActionDividendAndRight.prototype.rightOfferingRatio = "";
    CorporateActionDividendAndRight.prototype.rightToPurchaseSharesRatio = "";
    CorporateActionDividendAndRight.prototype.dividendStockRatio = "";
    CorporateActionDividendAndRight.prototype.rightEventIdInFlex = "";
    CorporateActionDividendAndRight.prototype.dividendCashEventIdInFlex = "";
    CorporateActionDividendAndRight.prototype.dividendStockEventIdInFlex = "";
    CorporateActionDividendAndRight.prototype.stockBonusEventIdInFlex = "";
    CorporateActionDividendAndRight.create = function create(properties) {
      return new CorporateActionDividendAndRight(properties);
    };
    CorporateActionDividendAndRight.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(10).string(message.symbol);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(17).double(message.price);
      if (message.priceNew != null && Object.hasOwnProperty.call(message, "priceNew"))
        writer.uint32(25).double(message.priceNew);
      if (message.priceAlpha != null && Object.hasOwnProperty.call(message, "priceAlpha"))
        writer.uint32(33).double(message.priceAlpha);
      if (message.alpha != null && Object.hasOwnProperty.call(message, "alpha"))
        writer.uint32(42).string(message.alpha);
      if (message.beta != null && Object.hasOwnProperty.call(message, "beta"))
        writer.uint32(50).string(message.beta);
      if (message.dividendCash != null && Object.hasOwnProperty.call(message, "dividendCash"))
        writer.uint32(57).double(message.dividendCash);
      if (message.ratio != null && Object.hasOwnProperty.call(message, "ratio"))
        writer.uint32(65).double(message.ratio);
      if (message.exDividendDate != null && Object.hasOwnProperty.call(message, "exDividendDate"))
        $root.google.protobuf.Timestamp.encode(message.exDividendDate, writer.uint32(74).fork()).ldelim();
      if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
        $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(82).fork()).ldelim();
      if (message.exerciseDate != null && Object.hasOwnProperty.call(message, "exerciseDate"))
        $root.google.protobuf.Timestamp.encode(message.exerciseDate, writer.uint32(90).fork()).ldelim();
      if (message.estimateReceivingDate != null && Object.hasOwnProperty.call(message, "estimateReceivingDate"))
        $root.google.protobuf.Timestamp.encode(message.estimateReceivingDate, writer.uint32(98).fork()).ldelim();
      if (message.rightSubscribeStartDate != null && Object.hasOwnProperty.call(message, "rightSubscribeStartDate"))
        $root.google.protobuf.Timestamp.encode(message.rightSubscribeStartDate, writer.uint32(106).fork()).ldelim();
      if (message.rightSubscribeEndDate != null && Object.hasOwnProperty.call(message, "rightSubscribeEndDate"))
        $root.google.protobuf.Timestamp.encode(message.rightSubscribeEndDate, writer.uint32(114).fork()).ldelim();
      if (message.bonusStockRatio != null && Object.hasOwnProperty.call(message, "bonusStockRatio"))
        writer.uint32(122).string(message.bonusStockRatio);
      if (message.rightOfferingRatio != null && Object.hasOwnProperty.call(message, "rightOfferingRatio"))
        writer.uint32(130).string(message.rightOfferingRatio);
      if (message.rightToPurchaseSharesRatio != null && Object.hasOwnProperty.call(message, "rightToPurchaseSharesRatio"))
        writer.uint32(138).string(message.rightToPurchaseSharesRatio);
      if (message.dividendStockRatio != null && Object.hasOwnProperty.call(message, "dividendStockRatio"))
        writer.uint32(146).string(message.dividendStockRatio);
      if (message.rightEventIdInFlex != null && Object.hasOwnProperty.call(message, "rightEventIdInFlex"))
        writer.uint32(154).string(message.rightEventIdInFlex);
      if (message.dividendCashEventIdInFlex != null && Object.hasOwnProperty.call(message, "dividendCashEventIdInFlex"))
        writer.uint32(162).string(message.dividendCashEventIdInFlex);
      if (message.dividendStockEventIdInFlex != null && Object.hasOwnProperty.call(message, "dividendStockEventIdInFlex"))
        writer.uint32(170).string(message.dividendStockEventIdInFlex);
      if (message.stockBonusEventIdInFlex != null && Object.hasOwnProperty.call(message, "stockBonusEventIdInFlex"))
        writer.uint32(178).string(message.stockBonusEventIdInFlex);
      return writer;
    };
    CorporateActionDividendAndRight.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CorporateActionDividendAndRight.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CorporateActionDividendAndRight();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.symbol = reader.string();
            break;
          case 2:
            message.price = reader.double();
            break;
          case 3:
            message.priceNew = reader.double();
            break;
          case 4:
            message.priceAlpha = reader.double();
            break;
          case 5:
            message.alpha = reader.string();
            break;
          case 6:
            message.beta = reader.string();
            break;
          case 7:
            message.dividendCash = reader.double();
            break;
          case 8:
            message.ratio = reader.double();
            break;
          case 9:
            message.exDividendDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.exerciseDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.estimateReceivingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.rightSubscribeStartDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 14:
            message.rightSubscribeEndDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 15:
            message.bonusStockRatio = reader.string();
            break;
          case 16:
            message.rightOfferingRatio = reader.string();
            break;
          case 17:
            message.rightToPurchaseSharesRatio = reader.string();
            break;
          case 18:
            message.dividendStockRatio = reader.string();
            break;
          case 19:
            message.rightEventIdInFlex = reader.string();
            break;
          case 20:
            message.dividendCashEventIdInFlex = reader.string();
            break;
          case 21:
            message.dividendStockEventIdInFlex = reader.string();
            break;
          case 22:
            message.stockBonusEventIdInFlex = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CorporateActionDividendAndRight.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CorporateActionDividendAndRight.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.priceNew != null && message.hasOwnProperty("priceNew")) {
        if (typeof message.priceNew !== "number")
          return "priceNew: number expected";
      }
      if (message.priceAlpha != null && message.hasOwnProperty("priceAlpha")) {
        if (typeof message.priceAlpha !== "number")
          return "priceAlpha: number expected";
      }
      if (message.alpha != null && message.hasOwnProperty("alpha")) {
        if (!$util.isString(message.alpha))
          return "alpha: string expected";
      }
      if (message.beta != null && message.hasOwnProperty("beta")) {
        if (!$util.isString(message.beta))
          return "beta: string expected";
      }
      if (message.dividendCash != null && message.hasOwnProperty("dividendCash")) {
        if (typeof message.dividendCash !== "number")
          return "dividendCash: number expected";
      }
      if (message.ratio != null && message.hasOwnProperty("ratio")) {
        if (typeof message.ratio !== "number")
          return "ratio: number expected";
      }
      if (message.exDividendDate != null && message.hasOwnProperty("exDividendDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.exDividendDate);
        if (error)
          return "exDividendDate." + error;
      }
      if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
        let error = $root.google.protobuf.Timestamp.verify(message.timestamp);
        if (error)
          return "timestamp." + error;
      }
      if (message.exerciseDate != null && message.hasOwnProperty("exerciseDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.exerciseDate);
        if (error)
          return "exerciseDate." + error;
      }
      if (message.estimateReceivingDate != null && message.hasOwnProperty("estimateReceivingDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.estimateReceivingDate);
        if (error)
          return "estimateReceivingDate." + error;
      }
      if (message.rightSubscribeStartDate != null && message.hasOwnProperty("rightSubscribeStartDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.rightSubscribeStartDate);
        if (error)
          return "rightSubscribeStartDate." + error;
      }
      if (message.rightSubscribeEndDate != null && message.hasOwnProperty("rightSubscribeEndDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.rightSubscribeEndDate);
        if (error)
          return "rightSubscribeEndDate." + error;
      }
      if (message.bonusStockRatio != null && message.hasOwnProperty("bonusStockRatio")) {
        if (!$util.isString(message.bonusStockRatio))
          return "bonusStockRatio: string expected";
      }
      if (message.rightOfferingRatio != null && message.hasOwnProperty("rightOfferingRatio")) {
        if (!$util.isString(message.rightOfferingRatio))
          return "rightOfferingRatio: string expected";
      }
      if (message.rightToPurchaseSharesRatio != null && message.hasOwnProperty("rightToPurchaseSharesRatio")) {
        if (!$util.isString(message.rightToPurchaseSharesRatio))
          return "rightToPurchaseSharesRatio: string expected";
      }
      if (message.dividendStockRatio != null && message.hasOwnProperty("dividendStockRatio")) {
        if (!$util.isString(message.dividendStockRatio))
          return "dividendStockRatio: string expected";
      }
      if (message.rightEventIdInFlex != null && message.hasOwnProperty("rightEventIdInFlex")) {
        if (!$util.isString(message.rightEventIdInFlex))
          return "rightEventIdInFlex: string expected";
      }
      if (message.dividendCashEventIdInFlex != null && message.hasOwnProperty("dividendCashEventIdInFlex")) {
        if (!$util.isString(message.dividendCashEventIdInFlex))
          return "dividendCashEventIdInFlex: string expected";
      }
      if (message.dividendStockEventIdInFlex != null && message.hasOwnProperty("dividendStockEventIdInFlex")) {
        if (!$util.isString(message.dividendStockEventIdInFlex))
          return "dividendStockEventIdInFlex: string expected";
      }
      if (message.stockBonusEventIdInFlex != null && message.hasOwnProperty("stockBonusEventIdInFlex")) {
        if (!$util.isString(message.stockBonusEventIdInFlex))
          return "stockBonusEventIdInFlex: string expected";
      }
      return null;
    };
    CorporateActionDividendAndRight.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CorporateActionDividendAndRight)
        return object;
      let message = new $root.dnse.CorporateActionDividendAndRight();
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.price != null)
        message.price = Number(object.price);
      if (object.priceNew != null)
        message.priceNew = Number(object.priceNew);
      if (object.priceAlpha != null)
        message.priceAlpha = Number(object.priceAlpha);
      if (object.alpha != null)
        message.alpha = String(object.alpha);
      if (object.beta != null)
        message.beta = String(object.beta);
      if (object.dividendCash != null)
        message.dividendCash = Number(object.dividendCash);
      if (object.ratio != null)
        message.ratio = Number(object.ratio);
      if (object.exDividendDate != null) {
        if (typeof object.exDividendDate !== "object")
          throw TypeError(".dnse.CorporateActionDividendAndRight.exDividendDate: object expected");
        message.exDividendDate = $root.google.protobuf.Timestamp.fromObject(object.exDividendDate);
      }
      if (object.timestamp != null) {
        if (typeof object.timestamp !== "object")
          throw TypeError(".dnse.CorporateActionDividendAndRight.timestamp: object expected");
        message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
      }
      if (object.exerciseDate != null) {
        if (typeof object.exerciseDate !== "object")
          throw TypeError(".dnse.CorporateActionDividendAndRight.exerciseDate: object expected");
        message.exerciseDate = $root.google.protobuf.Timestamp.fromObject(object.exerciseDate);
      }
      if (object.estimateReceivingDate != null) {
        if (typeof object.estimateReceivingDate !== "object")
          throw TypeError(".dnse.CorporateActionDividendAndRight.estimateReceivingDate: object expected");
        message.estimateReceivingDate = $root.google.protobuf.Timestamp.fromObject(object.estimateReceivingDate);
      }
      if (object.rightSubscribeStartDate != null) {
        if (typeof object.rightSubscribeStartDate !== "object")
          throw TypeError(".dnse.CorporateActionDividendAndRight.rightSubscribeStartDate: object expected");
        message.rightSubscribeStartDate = $root.google.protobuf.Timestamp.fromObject(object.rightSubscribeStartDate);
      }
      if (object.rightSubscribeEndDate != null) {
        if (typeof object.rightSubscribeEndDate !== "object")
          throw TypeError(".dnse.CorporateActionDividendAndRight.rightSubscribeEndDate: object expected");
        message.rightSubscribeEndDate = $root.google.protobuf.Timestamp.fromObject(object.rightSubscribeEndDate);
      }
      if (object.bonusStockRatio != null)
        message.bonusStockRatio = String(object.bonusStockRatio);
      if (object.rightOfferingRatio != null)
        message.rightOfferingRatio = String(object.rightOfferingRatio);
      if (object.rightToPurchaseSharesRatio != null)
        message.rightToPurchaseSharesRatio = String(object.rightToPurchaseSharesRatio);
      if (object.dividendStockRatio != null)
        message.dividendStockRatio = String(object.dividendStockRatio);
      if (object.rightEventIdInFlex != null)
        message.rightEventIdInFlex = String(object.rightEventIdInFlex);
      if (object.dividendCashEventIdInFlex != null)
        message.dividendCashEventIdInFlex = String(object.dividendCashEventIdInFlex);
      if (object.dividendStockEventIdInFlex != null)
        message.dividendStockEventIdInFlex = String(object.dividendStockEventIdInFlex);
      if (object.stockBonusEventIdInFlex != null)
        message.stockBonusEventIdInFlex = String(object.stockBonusEventIdInFlex);
      return message;
    };
    CorporateActionDividendAndRight.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = "";
        object.price = 0;
        object.priceNew = 0;
        object.priceAlpha = 0;
        object.alpha = "";
        object.beta = "";
        object.dividendCash = 0;
        object.ratio = 0;
        object.exDividendDate = null;
        object.timestamp = null;
        object.exerciseDate = null;
        object.estimateReceivingDate = null;
        object.rightSubscribeStartDate = null;
        object.rightSubscribeEndDate = null;
        object.bonusStockRatio = "";
        object.rightOfferingRatio = "";
        object.rightToPurchaseSharesRatio = "";
        object.dividendStockRatio = "";
        object.rightEventIdInFlex = "";
        object.dividendCashEventIdInFlex = "";
        object.dividendStockEventIdInFlex = "";
        object.stockBonusEventIdInFlex = "";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.priceNew != null && message.hasOwnProperty("priceNew"))
        object.priceNew = options.json && !isFinite(message.priceNew) ? String(message.priceNew) : message.priceNew;
      if (message.priceAlpha != null && message.hasOwnProperty("priceAlpha"))
        object.priceAlpha = options.json && !isFinite(message.priceAlpha) ? String(message.priceAlpha) : message.priceAlpha;
      if (message.alpha != null && message.hasOwnProperty("alpha"))
        object.alpha = message.alpha;
      if (message.beta != null && message.hasOwnProperty("beta"))
        object.beta = message.beta;
      if (message.dividendCash != null && message.hasOwnProperty("dividendCash"))
        object.dividendCash = options.json && !isFinite(message.dividendCash) ? String(message.dividendCash) : message.dividendCash;
      if (message.ratio != null && message.hasOwnProperty("ratio"))
        object.ratio = options.json && !isFinite(message.ratio) ? String(message.ratio) : message.ratio;
      if (message.exDividendDate != null && message.hasOwnProperty("exDividendDate"))
        object.exDividendDate = $root.google.protobuf.Timestamp.toObject(message.exDividendDate, options);
      if (message.timestamp != null && message.hasOwnProperty("timestamp"))
        object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
      if (message.exerciseDate != null && message.hasOwnProperty("exerciseDate"))
        object.exerciseDate = $root.google.protobuf.Timestamp.toObject(message.exerciseDate, options);
      if (message.estimateReceivingDate != null && message.hasOwnProperty("estimateReceivingDate"))
        object.estimateReceivingDate = $root.google.protobuf.Timestamp.toObject(message.estimateReceivingDate, options);
      if (message.rightSubscribeStartDate != null && message.hasOwnProperty("rightSubscribeStartDate"))
        object.rightSubscribeStartDate = $root.google.protobuf.Timestamp.toObject(message.rightSubscribeStartDate, options);
      if (message.rightSubscribeEndDate != null && message.hasOwnProperty("rightSubscribeEndDate"))
        object.rightSubscribeEndDate = $root.google.protobuf.Timestamp.toObject(message.rightSubscribeEndDate, options);
      if (message.bonusStockRatio != null && message.hasOwnProperty("bonusStockRatio"))
        object.bonusStockRatio = message.bonusStockRatio;
      if (message.rightOfferingRatio != null && message.hasOwnProperty("rightOfferingRatio"))
        object.rightOfferingRatio = message.rightOfferingRatio;
      if (message.rightToPurchaseSharesRatio != null && message.hasOwnProperty("rightToPurchaseSharesRatio"))
        object.rightToPurchaseSharesRatio = message.rightToPurchaseSharesRatio;
      if (message.dividendStockRatio != null && message.hasOwnProperty("dividendStockRatio"))
        object.dividendStockRatio = message.dividendStockRatio;
      if (message.rightEventIdInFlex != null && message.hasOwnProperty("rightEventIdInFlex"))
        object.rightEventIdInFlex = message.rightEventIdInFlex;
      if (message.dividendCashEventIdInFlex != null && message.hasOwnProperty("dividendCashEventIdInFlex"))
        object.dividendCashEventIdInFlex = message.dividendCashEventIdInFlex;
      if (message.dividendStockEventIdInFlex != null && message.hasOwnProperty("dividendStockEventIdInFlex"))
        object.dividendStockEventIdInFlex = message.dividendStockEventIdInFlex;
      if (message.stockBonusEventIdInFlex != null && message.hasOwnProperty("stockBonusEventIdInFlex"))
        object.stockBonusEventIdInFlex = message.stockBonusEventIdInFlex;
      return object;
    };
    CorporateActionDividendAndRight.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CorporateActionDividendAndRight;
  }();
  dnse2.WithdrawPPseTransaction = function() {
    function WithdrawPPseTransaction(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    WithdrawPPseTransaction.prototype.accountTypeName = "";
    WithdrawPPseTransaction.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    WithdrawPPseTransaction.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    WithdrawPPseTransaction.prototype.createdDate = null;
    WithdrawPPseTransaction.prototype.bankShortName = "";
    WithdrawPPseTransaction.prototype.investorId = "";
    WithdrawPPseTransaction.prototype.investorAccountId = "";
    WithdrawPPseTransaction.prototype.bankAccountNumber = "";
    WithdrawPPseTransaction.prototype.transferFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    WithdrawPPseTransaction.prototype.withdrawFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    WithdrawPPseTransaction.create = function create(properties) {
      return new WithdrawPPseTransaction(properties);
    };
    WithdrawPPseTransaction.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(10).string(message.accountTypeName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).int64(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(24).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.bankShortName != null && Object.hasOwnProperty.call(message, "bankShortName"))
        writer.uint32(42).string(message.bankShortName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.investorAccountId != null && Object.hasOwnProperty.call(message, "investorAccountId"))
        writer.uint32(58).string(message.investorAccountId);
      if (message.bankAccountNumber != null && Object.hasOwnProperty.call(message, "bankAccountNumber"))
        writer.uint32(66).string(message.bankAccountNumber);
      if (message.transferFee != null && Object.hasOwnProperty.call(message, "transferFee"))
        writer.uint32(72).int64(message.transferFee);
      if (message.withdrawFee != null && Object.hasOwnProperty.call(message, "withdrawFee"))
        writer.uint32(80).int64(message.withdrawFee);
      return writer;
    };
    WithdrawPPseTransaction.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    WithdrawPPseTransaction.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.WithdrawPPseTransaction();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountTypeName = reader.string();
            break;
          case 2:
            message.amount = reader.int64();
            break;
          case 3:
            message.availableCash = reader.int64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.bankShortName = reader.string();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.investorAccountId = reader.string();
            break;
          case 8:
            message.bankAccountNumber = reader.string();
            break;
          case 9:
            message.transferFee = reader.int64();
            break;
          case 10:
            message.withdrawFee = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    WithdrawPPseTransaction.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    WithdrawPPseTransaction.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.bankShortName != null && message.hasOwnProperty("bankShortName")) {
        if (!$util.isString(message.bankShortName))
          return "bankShortName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId")) {
        if (!$util.isString(message.investorAccountId))
          return "investorAccountId: string expected";
      }
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber")) {
        if (!$util.isString(message.bankAccountNumber))
          return "bankAccountNumber: string expected";
      }
      if (message.transferFee != null && message.hasOwnProperty("transferFee")) {
        if (!$util.isInteger(message.transferFee) && !(message.transferFee && $util.isInteger(message.transferFee.low) && $util.isInteger(message.transferFee.high)))
          return "transferFee: integer|Long expected";
      }
      if (message.withdrawFee != null && message.hasOwnProperty("withdrawFee")) {
        if (!$util.isInteger(message.withdrawFee) && !(message.withdrawFee && $util.isInteger(message.withdrawFee.low) && $util.isInteger(message.withdrawFee.high)))
          return "withdrawFee: integer|Long expected";
      }
      return null;
    };
    WithdrawPPseTransaction.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.WithdrawPPseTransaction)
        return object;
      let message = new $root.dnse.WithdrawPPseTransaction();
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.WithdrawPPseTransaction.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.bankShortName != null)
        message.bankShortName = String(object.bankShortName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.investorAccountId != null)
        message.investorAccountId = String(object.investorAccountId);
      if (object.bankAccountNumber != null)
        message.bankAccountNumber = String(object.bankAccountNumber);
      if (object.transferFee != null) {
        if ($util.Long)
          (message.transferFee = $util.Long.fromValue(object.transferFee)).unsigned = false;
        else if (typeof object.transferFee === "string")
          message.transferFee = parseInt(object.transferFee, 10);
        else if (typeof object.transferFee === "number")
          message.transferFee = object.transferFee;
        else if (typeof object.transferFee === "object")
          message.transferFee = new $util.LongBits(object.transferFee.low >>> 0, object.transferFee.high >>> 0).toNumber();
      }
      if (object.withdrawFee != null) {
        if ($util.Long)
          (message.withdrawFee = $util.Long.fromValue(object.withdrawFee)).unsigned = false;
        else if (typeof object.withdrawFee === "string")
          message.withdrawFee = parseInt(object.withdrawFee, 10);
        else if (typeof object.withdrawFee === "number")
          message.withdrawFee = object.withdrawFee;
        else if (typeof object.withdrawFee === "object")
          message.withdrawFee = new $util.LongBits(object.withdrawFee.low >>> 0, object.withdrawFee.high >>> 0).toNumber();
      }
      return message;
    };
    WithdrawPPseTransaction.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountTypeName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.bankShortName = "";
        object.investorId = "";
        object.investorAccountId = "";
        object.bankAccountNumber = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.transferFee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.transferFee = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.withdrawFee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.withdrawFee = options.longs === String ? "0" : 0;
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.bankShortName != null && message.hasOwnProperty("bankShortName"))
        object.bankShortName = message.bankShortName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.investorAccountId != null && message.hasOwnProperty("investorAccountId"))
        object.investorAccountId = message.investorAccountId;
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber"))
        object.bankAccountNumber = message.bankAccountNumber;
      if (message.transferFee != null && message.hasOwnProperty("transferFee"))
        if (typeof message.transferFee === "number")
          object.transferFee = options.longs === String ? String(message.transferFee) : message.transferFee;
        else
          object.transferFee = options.longs === String ? $util.Long.prototype.toString.call(message.transferFee) : options.longs === Number ? new $util.LongBits(message.transferFee.low >>> 0, message.transferFee.high >>> 0).toNumber() : message.transferFee;
      if (message.withdrawFee != null && message.hasOwnProperty("withdrawFee"))
        if (typeof message.withdrawFee === "number")
          object.withdrawFee = options.longs === String ? String(message.withdrawFee) : message.withdrawFee;
        else
          object.withdrawFee = options.longs === String ? $util.Long.prototype.toString.call(message.withdrawFee) : options.longs === Number ? new $util.LongBits(message.withdrawFee.low >>> 0, message.withdrawFee.high >>> 0).toNumber() : message.withdrawFee;
      return object;
    };
    WithdrawPPseTransaction.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return WithdrawPPseTransaction;
  }();
  dnse2.DealPPSEWithdrawTransaction = function() {
    function DealPPSEWithdrawTransaction(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealPPSEWithdrawTransaction.prototype.accountTypeName = "";
    DealPPSEWithdrawTransaction.prototype.withdrawAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPPSEWithdrawTransaction.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPPSEWithdrawTransaction.prototype.createdDate = null;
    DealPPSEWithdrawTransaction.prototype.investorId = "";
    DealPPSEWithdrawTransaction.prototype.accountNo = "";
    DealPPSEWithdrawTransaction.prototype.withdrawFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPPSEWithdrawTransaction.create = function create(properties) {
      return new DealPPSEWithdrawTransaction(properties);
    };
    DealPPSEWithdrawTransaction.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(10).string(message.accountTypeName);
      if (message.withdrawAmount != null && Object.hasOwnProperty.call(message, "withdrawAmount"))
        writer.uint32(16).int64(message.withdrawAmount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(24).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(50).string(message.accountNo);
      if (message.withdrawFee != null && Object.hasOwnProperty.call(message, "withdrawFee"))
        writer.uint32(56).int64(message.withdrawFee);
      return writer;
    };
    DealPPSEWithdrawTransaction.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealPPSEWithdrawTransaction.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealPPSEWithdrawTransaction();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountTypeName = reader.string();
            break;
          case 2:
            message.withdrawAmount = reader.int64();
            break;
          case 3:
            message.availableCash = reader.int64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.accountNo = reader.string();
            break;
          case 7:
            message.withdrawFee = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealPPSEWithdrawTransaction.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealPPSEWithdrawTransaction.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.withdrawAmount != null && message.hasOwnProperty("withdrawAmount")) {
        if (!$util.isInteger(message.withdrawAmount) && !(message.withdrawAmount && $util.isInteger(message.withdrawAmount.low) && $util.isInteger(message.withdrawAmount.high)))
          return "withdrawAmount: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.withdrawFee != null && message.hasOwnProperty("withdrawFee")) {
        if (!$util.isInteger(message.withdrawFee) && !(message.withdrawFee && $util.isInteger(message.withdrawFee.low) && $util.isInteger(message.withdrawFee.high)))
          return "withdrawFee: integer|Long expected";
      }
      return null;
    };
    DealPPSEWithdrawTransaction.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealPPSEWithdrawTransaction)
        return object;
      let message = new $root.dnse.DealPPSEWithdrawTransaction();
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.withdrawAmount != null) {
        if ($util.Long)
          (message.withdrawAmount = $util.Long.fromValue(object.withdrawAmount)).unsigned = false;
        else if (typeof object.withdrawAmount === "string")
          message.withdrawAmount = parseInt(object.withdrawAmount, 10);
        else if (typeof object.withdrawAmount === "number")
          message.withdrawAmount = object.withdrawAmount;
        else if (typeof object.withdrawAmount === "object")
          message.withdrawAmount = new $util.LongBits(object.withdrawAmount.low >>> 0, object.withdrawAmount.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DealPPSEWithdrawTransaction.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.withdrawFee != null) {
        if ($util.Long)
          (message.withdrawFee = $util.Long.fromValue(object.withdrawFee)).unsigned = false;
        else if (typeof object.withdrawFee === "string")
          message.withdrawFee = parseInt(object.withdrawFee, 10);
        else if (typeof object.withdrawFee === "number")
          message.withdrawFee = object.withdrawFee;
        else if (typeof object.withdrawFee === "object")
          message.withdrawFee = new $util.LongBits(object.withdrawFee.low >>> 0, object.withdrawFee.high >>> 0).toNumber();
      }
      return message;
    };
    DealPPSEWithdrawTransaction.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountTypeName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.withdrawAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.withdrawAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.withdrawFee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.withdrawFee = options.longs === String ? "0" : 0;
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.withdrawAmount != null && message.hasOwnProperty("withdrawAmount"))
        if (typeof message.withdrawAmount === "number")
          object.withdrawAmount = options.longs === String ? String(message.withdrawAmount) : message.withdrawAmount;
        else
          object.withdrawAmount = options.longs === String ? $util.Long.prototype.toString.call(message.withdrawAmount) : options.longs === Number ? new $util.LongBits(message.withdrawAmount.low >>> 0, message.withdrawAmount.high >>> 0).toNumber() : message.withdrawAmount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.withdrawFee != null && message.hasOwnProperty("withdrawFee"))
        if (typeof message.withdrawFee === "number")
          object.withdrawFee = options.longs === String ? String(message.withdrawFee) : message.withdrawFee;
        else
          object.withdrawFee = options.longs === String ? $util.Long.prototype.toString.call(message.withdrawFee) : options.longs === Number ? new $util.LongBits(message.withdrawFee.low >>> 0, message.withdrawFee.high >>> 0).toNumber() : message.withdrawFee;
      return object;
    };
    DealPPSEWithdrawTransaction.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealPPSEWithdrawTransaction;
  }();
  dnse2.DealPrepaymentTransaction = function() {
    function DealPrepaymentTransaction(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealPrepaymentTransaction.prototype.accountTypeName = "";
    DealPrepaymentTransaction.prototype.symbol = "";
    DealPrepaymentTransaction.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPrepaymentTransaction.prototype.createdDate = null;
    DealPrepaymentTransaction.prototype.investorId = "";
    DealPrepaymentTransaction.prototype.accountNo = "";
    DealPrepaymentTransaction.prototype.initialRate = 0;
    DealPrepaymentTransaction.prototype.toCollectAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPrepaymentTransaction.prototype.collectedPrincipal = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPrepaymentTransaction.prototype.collectedInterest = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealPrepaymentTransaction.prototype.loanPackageName = "";
    DealPrepaymentTransaction.create = function create(properties) {
      return new DealPrepaymentTransaction(properties);
    };
    DealPrepaymentTransaction.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(10).string(message.accountTypeName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(24).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(50).string(message.accountNo);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(57).double(message.initialRate);
      if (message.toCollectAmount != null && Object.hasOwnProperty.call(message, "toCollectAmount"))
        writer.uint32(64).int64(message.toCollectAmount);
      if (message.collectedPrincipal != null && Object.hasOwnProperty.call(message, "collectedPrincipal"))
        writer.uint32(72).int64(message.collectedPrincipal);
      if (message.collectedInterest != null && Object.hasOwnProperty.call(message, "collectedInterest"))
        writer.uint32(80).int64(message.collectedInterest);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(90).string(message.loanPackageName);
      return writer;
    };
    DealPrepaymentTransaction.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealPrepaymentTransaction.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealPrepaymentTransaction();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountTypeName = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.availableCash = reader.int64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.accountNo = reader.string();
            break;
          case 7:
            message.initialRate = reader.double();
            break;
          case 8:
            message.toCollectAmount = reader.int64();
            break;
          case 9:
            message.collectedPrincipal = reader.int64();
            break;
          case 10:
            message.collectedInterest = reader.int64();
            break;
          case 11:
            message.loanPackageName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealPrepaymentTransaction.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealPrepaymentTransaction.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.toCollectAmount != null && message.hasOwnProperty("toCollectAmount")) {
        if (!$util.isInteger(message.toCollectAmount) && !(message.toCollectAmount && $util.isInteger(message.toCollectAmount.low) && $util.isInteger(message.toCollectAmount.high)))
          return "toCollectAmount: integer|Long expected";
      }
      if (message.collectedPrincipal != null && message.hasOwnProperty("collectedPrincipal")) {
        if (!$util.isInteger(message.collectedPrincipal) && !(message.collectedPrincipal && $util.isInteger(message.collectedPrincipal.low) && $util.isInteger(message.collectedPrincipal.high)))
          return "collectedPrincipal: integer|Long expected";
      }
      if (message.collectedInterest != null && message.hasOwnProperty("collectedInterest")) {
        if (!$util.isInteger(message.collectedInterest) && !(message.collectedInterest && $util.isInteger(message.collectedInterest.low) && $util.isInteger(message.collectedInterest.high)))
          return "collectedInterest: integer|Long expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      return null;
    };
    DealPrepaymentTransaction.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealPrepaymentTransaction)
        return object;
      let message = new $root.dnse.DealPrepaymentTransaction();
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DealPrepaymentTransaction.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.toCollectAmount != null) {
        if ($util.Long)
          (message.toCollectAmount = $util.Long.fromValue(object.toCollectAmount)).unsigned = false;
        else if (typeof object.toCollectAmount === "string")
          message.toCollectAmount = parseInt(object.toCollectAmount, 10);
        else if (typeof object.toCollectAmount === "number")
          message.toCollectAmount = object.toCollectAmount;
        else if (typeof object.toCollectAmount === "object")
          message.toCollectAmount = new $util.LongBits(object.toCollectAmount.low >>> 0, object.toCollectAmount.high >>> 0).toNumber();
      }
      if (object.collectedPrincipal != null) {
        if ($util.Long)
          (message.collectedPrincipal = $util.Long.fromValue(object.collectedPrincipal)).unsigned = false;
        else if (typeof object.collectedPrincipal === "string")
          message.collectedPrincipal = parseInt(object.collectedPrincipal, 10);
        else if (typeof object.collectedPrincipal === "number")
          message.collectedPrincipal = object.collectedPrincipal;
        else if (typeof object.collectedPrincipal === "object")
          message.collectedPrincipal = new $util.LongBits(object.collectedPrincipal.low >>> 0, object.collectedPrincipal.high >>> 0).toNumber();
      }
      if (object.collectedInterest != null) {
        if ($util.Long)
          (message.collectedInterest = $util.Long.fromValue(object.collectedInterest)).unsigned = false;
        else if (typeof object.collectedInterest === "string")
          message.collectedInterest = parseInt(object.collectedInterest, 10);
        else if (typeof object.collectedInterest === "number")
          message.collectedInterest = object.collectedInterest;
        else if (typeof object.collectedInterest === "object")
          message.collectedInterest = new $util.LongBits(object.collectedInterest.low >>> 0, object.collectedInterest.high >>> 0).toNumber();
      }
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      return message;
    };
    DealPrepaymentTransaction.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountTypeName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.investorId = "";
        object.accountNo = "";
        object.initialRate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.toCollectAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.toCollectAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.collectedPrincipal = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.collectedPrincipal = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.collectedInterest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.collectedInterest = options.longs === String ? "0" : 0;
        object.loanPackageName = "";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.toCollectAmount != null && message.hasOwnProperty("toCollectAmount"))
        if (typeof message.toCollectAmount === "number")
          object.toCollectAmount = options.longs === String ? String(message.toCollectAmount) : message.toCollectAmount;
        else
          object.toCollectAmount = options.longs === String ? $util.Long.prototype.toString.call(message.toCollectAmount) : options.longs === Number ? new $util.LongBits(message.toCollectAmount.low >>> 0, message.toCollectAmount.high >>> 0).toNumber() : message.toCollectAmount;
      if (message.collectedPrincipal != null && message.hasOwnProperty("collectedPrincipal"))
        if (typeof message.collectedPrincipal === "number")
          object.collectedPrincipal = options.longs === String ? String(message.collectedPrincipal) : message.collectedPrincipal;
        else
          object.collectedPrincipal = options.longs === String ? $util.Long.prototype.toString.call(message.collectedPrincipal) : options.longs === Number ? new $util.LongBits(message.collectedPrincipal.low >>> 0, message.collectedPrincipal.high >>> 0).toNumber() : message.collectedPrincipal;
      if (message.collectedInterest != null && message.hasOwnProperty("collectedInterest"))
        if (typeof message.collectedInterest === "number")
          object.collectedInterest = options.longs === String ? String(message.collectedInterest) : message.collectedInterest;
        else
          object.collectedInterest = options.longs === String ? $util.Long.prototype.toString.call(message.collectedInterest) : options.longs === Number ? new $util.LongBits(message.collectedInterest.low >>> 0, message.collectedInterest.high >>> 0).toNumber() : message.collectedInterest;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      return object;
    };
    DealPrepaymentTransaction.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealPrepaymentTransaction;
  }();
  dnse2.Loan = function() {
    function Loan(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Loan.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Loan.prototype.custodyCode = "";
    Loan.prototype.accountNo = "";
    Loan.prototype.lnTypeId = "";
    Loan.prototype.lnAccountNo = "";
    Loan.prototype.releaseDate = "";
    Loan.prototype.t1 = "";
    Loan.prototype.dueDate = "";
    Loan.prototype.unduePrincipal = 0;
    Loan.prototype.duePrincipal = 0;
    Loan.prototype.overduePrincipal = 0;
    Loan.prototype.undueInterest = 0;
    Loan.prototype.dueInterest = 0;
    Loan.prototype.overdueInterest = 0;
    Loan.prototype.interestOnOverduePrincipal = 0;
    Loan.prototype.undueFee = 0;
    Loan.prototype.dueFee = 0;
    Loan.prototype.overdueFee = 0;
    Loan.prototype.feeOnOverduePrincipal = 0;
    Loan.prototype.interestRate1 = 0;
    Loan.prototype.interestRate2 = 0;
    Loan.prototype.interestRate3 = 0;
    Loan.prototype.feeRate1 = 0;
    Loan.prototype.feeRate2 = 0;
    Loan.prototype.feeRate3 = 0;
    Loan.prototype.extendTimes = 0;
    Loan.prototype.createdDate = null;
    Loan.create = function create(properties) {
      return new Loan(properties);
    };
    Loan.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.lnTypeId != null && Object.hasOwnProperty.call(message, "lnTypeId"))
        writer.uint32(34).string(message.lnTypeId);
      if (message.lnAccountNo != null && Object.hasOwnProperty.call(message, "lnAccountNo"))
        writer.uint32(42).string(message.lnAccountNo);
      if (message.releaseDate != null && Object.hasOwnProperty.call(message, "releaseDate"))
        writer.uint32(50).string(message.releaseDate);
      if (message.t1 != null && Object.hasOwnProperty.call(message, "t1"))
        writer.uint32(58).string(message.t1);
      if (message.dueDate != null && Object.hasOwnProperty.call(message, "dueDate"))
        writer.uint32(66).string(message.dueDate);
      if (message.unduePrincipal != null && Object.hasOwnProperty.call(message, "unduePrincipal"))
        writer.uint32(73).double(message.unduePrincipal);
      if (message.duePrincipal != null && Object.hasOwnProperty.call(message, "duePrincipal"))
        writer.uint32(81).double(message.duePrincipal);
      if (message.overduePrincipal != null && Object.hasOwnProperty.call(message, "overduePrincipal"))
        writer.uint32(89).double(message.overduePrincipal);
      if (message.undueInterest != null && Object.hasOwnProperty.call(message, "undueInterest"))
        writer.uint32(97).double(message.undueInterest);
      if (message.dueInterest != null && Object.hasOwnProperty.call(message, "dueInterest"))
        writer.uint32(105).double(message.dueInterest);
      if (message.overdueInterest != null && Object.hasOwnProperty.call(message, "overdueInterest"))
        writer.uint32(113).double(message.overdueInterest);
      if (message.interestOnOverduePrincipal != null && Object.hasOwnProperty.call(message, "interestOnOverduePrincipal"))
        writer.uint32(121).double(message.interestOnOverduePrincipal);
      if (message.undueFee != null && Object.hasOwnProperty.call(message, "undueFee"))
        writer.uint32(129).double(message.undueFee);
      if (message.dueFee != null && Object.hasOwnProperty.call(message, "dueFee"))
        writer.uint32(137).double(message.dueFee);
      if (message.overdueFee != null && Object.hasOwnProperty.call(message, "overdueFee"))
        writer.uint32(145).double(message.overdueFee);
      if (message.feeOnOverduePrincipal != null && Object.hasOwnProperty.call(message, "feeOnOverduePrincipal"))
        writer.uint32(153).double(message.feeOnOverduePrincipal);
      if (message.interestRate1 != null && Object.hasOwnProperty.call(message, "interestRate1"))
        writer.uint32(161).double(message.interestRate1);
      if (message.interestRate2 != null && Object.hasOwnProperty.call(message, "interestRate2"))
        writer.uint32(169).double(message.interestRate2);
      if (message.interestRate3 != null && Object.hasOwnProperty.call(message, "interestRate3"))
        writer.uint32(177).double(message.interestRate3);
      if (message.feeRate1 != null && Object.hasOwnProperty.call(message, "feeRate1"))
        writer.uint32(185).double(message.feeRate1);
      if (message.feeRate2 != null && Object.hasOwnProperty.call(message, "feeRate2"))
        writer.uint32(193).double(message.feeRate2);
      if (message.feeRate3 != null && Object.hasOwnProperty.call(message, "feeRate3"))
        writer.uint32(201).double(message.feeRate3);
      if (message.extendTimes != null && Object.hasOwnProperty.call(message, "extendTimes"))
        writer.uint32(208).int32(message.extendTimes);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(218).fork()).ldelim();
      return writer;
    };
    Loan.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Loan.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Loan();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.lnTypeId = reader.string();
            break;
          case 5:
            message.lnAccountNo = reader.string();
            break;
          case 6:
            message.releaseDate = reader.string();
            break;
          case 7:
            message.t1 = reader.string();
            break;
          case 8:
            message.dueDate = reader.string();
            break;
          case 9:
            message.unduePrincipal = reader.double();
            break;
          case 10:
            message.duePrincipal = reader.double();
            break;
          case 11:
            message.overduePrincipal = reader.double();
            break;
          case 12:
            message.undueInterest = reader.double();
            break;
          case 13:
            message.dueInterest = reader.double();
            break;
          case 14:
            message.overdueInterest = reader.double();
            break;
          case 15:
            message.interestOnOverduePrincipal = reader.double();
            break;
          case 16:
            message.undueFee = reader.double();
            break;
          case 17:
            message.dueFee = reader.double();
            break;
          case 18:
            message.overdueFee = reader.double();
            break;
          case 19:
            message.feeOnOverduePrincipal = reader.double();
            break;
          case 20:
            message.interestRate1 = reader.double();
            break;
          case 21:
            message.interestRate2 = reader.double();
            break;
          case 22:
            message.interestRate3 = reader.double();
            break;
          case 23:
            message.feeRate1 = reader.double();
            break;
          case 24:
            message.feeRate2 = reader.double();
            break;
          case 25:
            message.feeRate3 = reader.double();
            break;
          case 26:
            message.extendTimes = reader.int32();
            break;
          case 27:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Loan.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Loan.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.lnTypeId != null && message.hasOwnProperty("lnTypeId")) {
        if (!$util.isString(message.lnTypeId))
          return "lnTypeId: string expected";
      }
      if (message.lnAccountNo != null && message.hasOwnProperty("lnAccountNo")) {
        if (!$util.isString(message.lnAccountNo))
          return "lnAccountNo: string expected";
      }
      if (message.releaseDate != null && message.hasOwnProperty("releaseDate")) {
        if (!$util.isString(message.releaseDate))
          return "releaseDate: string expected";
      }
      if (message.t1 != null && message.hasOwnProperty("t1")) {
        if (!$util.isString(message.t1))
          return "t1: string expected";
      }
      if (message.dueDate != null && message.hasOwnProperty("dueDate")) {
        if (!$util.isString(message.dueDate))
          return "dueDate: string expected";
      }
      if (message.unduePrincipal != null && message.hasOwnProperty("unduePrincipal")) {
        if (typeof message.unduePrincipal !== "number")
          return "unduePrincipal: number expected";
      }
      if (message.duePrincipal != null && message.hasOwnProperty("duePrincipal")) {
        if (typeof message.duePrincipal !== "number")
          return "duePrincipal: number expected";
      }
      if (message.overduePrincipal != null && message.hasOwnProperty("overduePrincipal")) {
        if (typeof message.overduePrincipal !== "number")
          return "overduePrincipal: number expected";
      }
      if (message.undueInterest != null && message.hasOwnProperty("undueInterest")) {
        if (typeof message.undueInterest !== "number")
          return "undueInterest: number expected";
      }
      if (message.dueInterest != null && message.hasOwnProperty("dueInterest")) {
        if (typeof message.dueInterest !== "number")
          return "dueInterest: number expected";
      }
      if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest")) {
        if (typeof message.overdueInterest !== "number")
          return "overdueInterest: number expected";
      }
      if (message.interestOnOverduePrincipal != null && message.hasOwnProperty("interestOnOverduePrincipal")) {
        if (typeof message.interestOnOverduePrincipal !== "number")
          return "interestOnOverduePrincipal: number expected";
      }
      if (message.undueFee != null && message.hasOwnProperty("undueFee")) {
        if (typeof message.undueFee !== "number")
          return "undueFee: number expected";
      }
      if (message.dueFee != null && message.hasOwnProperty("dueFee")) {
        if (typeof message.dueFee !== "number")
          return "dueFee: number expected";
      }
      if (message.overdueFee != null && message.hasOwnProperty("overdueFee")) {
        if (typeof message.overdueFee !== "number")
          return "overdueFee: number expected";
      }
      if (message.feeOnOverduePrincipal != null && message.hasOwnProperty("feeOnOverduePrincipal")) {
        if (typeof message.feeOnOverduePrincipal !== "number")
          return "feeOnOverduePrincipal: number expected";
      }
      if (message.interestRate1 != null && message.hasOwnProperty("interestRate1")) {
        if (typeof message.interestRate1 !== "number")
          return "interestRate1: number expected";
      }
      if (message.interestRate2 != null && message.hasOwnProperty("interestRate2")) {
        if (typeof message.interestRate2 !== "number")
          return "interestRate2: number expected";
      }
      if (message.interestRate3 != null && message.hasOwnProperty("interestRate3")) {
        if (typeof message.interestRate3 !== "number")
          return "interestRate3: number expected";
      }
      if (message.feeRate1 != null && message.hasOwnProperty("feeRate1")) {
        if (typeof message.feeRate1 !== "number")
          return "feeRate1: number expected";
      }
      if (message.feeRate2 != null && message.hasOwnProperty("feeRate2")) {
        if (typeof message.feeRate2 !== "number")
          return "feeRate2: number expected";
      }
      if (message.feeRate3 != null && message.hasOwnProperty("feeRate3")) {
        if (typeof message.feeRate3 !== "number")
          return "feeRate3: number expected";
      }
      if (message.extendTimes != null && message.hasOwnProperty("extendTimes")) {
        if (!$util.isInteger(message.extendTimes))
          return "extendTimes: integer expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    Loan.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Loan)
        return object;
      let message = new $root.dnse.Loan();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.lnTypeId != null)
        message.lnTypeId = String(object.lnTypeId);
      if (object.lnAccountNo != null)
        message.lnAccountNo = String(object.lnAccountNo);
      if (object.releaseDate != null)
        message.releaseDate = String(object.releaseDate);
      if (object.t1 != null)
        message.t1 = String(object.t1);
      if (object.dueDate != null)
        message.dueDate = String(object.dueDate);
      if (object.unduePrincipal != null)
        message.unduePrincipal = Number(object.unduePrincipal);
      if (object.duePrincipal != null)
        message.duePrincipal = Number(object.duePrincipal);
      if (object.overduePrincipal != null)
        message.overduePrincipal = Number(object.overduePrincipal);
      if (object.undueInterest != null)
        message.undueInterest = Number(object.undueInterest);
      if (object.dueInterest != null)
        message.dueInterest = Number(object.dueInterest);
      if (object.overdueInterest != null)
        message.overdueInterest = Number(object.overdueInterest);
      if (object.interestOnOverduePrincipal != null)
        message.interestOnOverduePrincipal = Number(object.interestOnOverduePrincipal);
      if (object.undueFee != null)
        message.undueFee = Number(object.undueFee);
      if (object.dueFee != null)
        message.dueFee = Number(object.dueFee);
      if (object.overdueFee != null)
        message.overdueFee = Number(object.overdueFee);
      if (object.feeOnOverduePrincipal != null)
        message.feeOnOverduePrincipal = Number(object.feeOnOverduePrincipal);
      if (object.interestRate1 != null)
        message.interestRate1 = Number(object.interestRate1);
      if (object.interestRate2 != null)
        message.interestRate2 = Number(object.interestRate2);
      if (object.interestRate3 != null)
        message.interestRate3 = Number(object.interestRate3);
      if (object.feeRate1 != null)
        message.feeRate1 = Number(object.feeRate1);
      if (object.feeRate2 != null)
        message.feeRate2 = Number(object.feeRate2);
      if (object.feeRate3 != null)
        message.feeRate3 = Number(object.feeRate3);
      if (object.extendTimes != null)
        message.extendTimes = object.extendTimes | 0;
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.Loan.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    Loan.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.custodyCode = "";
        object.accountNo = "";
        object.lnTypeId = "";
        object.lnAccountNo = "";
        object.releaseDate = "";
        object.t1 = "";
        object.dueDate = "";
        object.unduePrincipal = 0;
        object.duePrincipal = 0;
        object.overduePrincipal = 0;
        object.undueInterest = 0;
        object.dueInterest = 0;
        object.overdueInterest = 0;
        object.interestOnOverduePrincipal = 0;
        object.undueFee = 0;
        object.dueFee = 0;
        object.overdueFee = 0;
        object.feeOnOverduePrincipal = 0;
        object.interestRate1 = 0;
        object.interestRate2 = 0;
        object.interestRate3 = 0;
        object.feeRate1 = 0;
        object.feeRate2 = 0;
        object.feeRate3 = 0;
        object.extendTimes = 0;
        object.createdDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.lnTypeId != null && message.hasOwnProperty("lnTypeId"))
        object.lnTypeId = message.lnTypeId;
      if (message.lnAccountNo != null && message.hasOwnProperty("lnAccountNo"))
        object.lnAccountNo = message.lnAccountNo;
      if (message.releaseDate != null && message.hasOwnProperty("releaseDate"))
        object.releaseDate = message.releaseDate;
      if (message.t1 != null && message.hasOwnProperty("t1"))
        object.t1 = message.t1;
      if (message.dueDate != null && message.hasOwnProperty("dueDate"))
        object.dueDate = message.dueDate;
      if (message.unduePrincipal != null && message.hasOwnProperty("unduePrincipal"))
        object.unduePrincipal = options.json && !isFinite(message.unduePrincipal) ? String(message.unduePrincipal) : message.unduePrincipal;
      if (message.duePrincipal != null && message.hasOwnProperty("duePrincipal"))
        object.duePrincipal = options.json && !isFinite(message.duePrincipal) ? String(message.duePrincipal) : message.duePrincipal;
      if (message.overduePrincipal != null && message.hasOwnProperty("overduePrincipal"))
        object.overduePrincipal = options.json && !isFinite(message.overduePrincipal) ? String(message.overduePrincipal) : message.overduePrincipal;
      if (message.undueInterest != null && message.hasOwnProperty("undueInterest"))
        object.undueInterest = options.json && !isFinite(message.undueInterest) ? String(message.undueInterest) : message.undueInterest;
      if (message.dueInterest != null && message.hasOwnProperty("dueInterest"))
        object.dueInterest = options.json && !isFinite(message.dueInterest) ? String(message.dueInterest) : message.dueInterest;
      if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest"))
        object.overdueInterest = options.json && !isFinite(message.overdueInterest) ? String(message.overdueInterest) : message.overdueInterest;
      if (message.interestOnOverduePrincipal != null && message.hasOwnProperty("interestOnOverduePrincipal"))
        object.interestOnOverduePrincipal = options.json && !isFinite(message.interestOnOverduePrincipal) ? String(message.interestOnOverduePrincipal) : message.interestOnOverduePrincipal;
      if (message.undueFee != null && message.hasOwnProperty("undueFee"))
        object.undueFee = options.json && !isFinite(message.undueFee) ? String(message.undueFee) : message.undueFee;
      if (message.dueFee != null && message.hasOwnProperty("dueFee"))
        object.dueFee = options.json && !isFinite(message.dueFee) ? String(message.dueFee) : message.dueFee;
      if (message.overdueFee != null && message.hasOwnProperty("overdueFee"))
        object.overdueFee = options.json && !isFinite(message.overdueFee) ? String(message.overdueFee) : message.overdueFee;
      if (message.feeOnOverduePrincipal != null && message.hasOwnProperty("feeOnOverduePrincipal"))
        object.feeOnOverduePrincipal = options.json && !isFinite(message.feeOnOverduePrincipal) ? String(message.feeOnOverduePrincipal) : message.feeOnOverduePrincipal;
      if (message.interestRate1 != null && message.hasOwnProperty("interestRate1"))
        object.interestRate1 = options.json && !isFinite(message.interestRate1) ? String(message.interestRate1) : message.interestRate1;
      if (message.interestRate2 != null && message.hasOwnProperty("interestRate2"))
        object.interestRate2 = options.json && !isFinite(message.interestRate2) ? String(message.interestRate2) : message.interestRate2;
      if (message.interestRate3 != null && message.hasOwnProperty("interestRate3"))
        object.interestRate3 = options.json && !isFinite(message.interestRate3) ? String(message.interestRate3) : message.interestRate3;
      if (message.feeRate1 != null && message.hasOwnProperty("feeRate1"))
        object.feeRate1 = options.json && !isFinite(message.feeRate1) ? String(message.feeRate1) : message.feeRate1;
      if (message.feeRate2 != null && message.hasOwnProperty("feeRate2"))
        object.feeRate2 = options.json && !isFinite(message.feeRate2) ? String(message.feeRate2) : message.feeRate2;
      if (message.feeRate3 != null && message.hasOwnProperty("feeRate3"))
        object.feeRate3 = options.json && !isFinite(message.feeRate3) ? String(message.feeRate3) : message.feeRate3;
      if (message.extendTimes != null && message.hasOwnProperty("extendTimes"))
        object.extendTimes = message.extendTimes;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    Loan.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Loan;
  }();
  dnse2.LoanControl = function() {
    function LoanControl(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanControl.prototype.value = "";
    LoanControl.prototype.bizDate = "";
    LoanControl.create = function create(properties) {
      return new LoanControl(properties);
    };
    LoanControl.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, "value"))
        writer.uint32(10).string(message.value);
      if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
        writer.uint32(18).string(message.bizDate);
      return writer;
    };
    LoanControl.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanControl.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanControl();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.value = reader.string();
            break;
          case 2:
            message.bizDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanControl.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanControl.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.value != null && message.hasOwnProperty("value")) {
        if (!$util.isString(message.value))
          return "value: string expected";
      }
      if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
        if (!$util.isString(message.bizDate))
          return "bizDate: string expected";
      }
      return null;
    };
    LoanControl.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanControl)
        return object;
      let message = new $root.dnse.LoanControl();
      if (object.value != null)
        message.value = String(object.value);
      if (object.bizDate != null)
        message.bizDate = String(object.bizDate);
      return message;
    };
    LoanControl.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.value = "";
        object.bizDate = "";
      }
      if (message.value != null && message.hasOwnProperty("value"))
        object.value = message.value;
      if (message.bizDate != null && message.hasOwnProperty("bizDate"))
        object.bizDate = message.bizDate;
      return object;
    };
    LoanControl.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanControl;
  }();
  dnse2.SavingEvent = function() {
    function SavingEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingEvent.prototype.id = "";
    SavingEvent.prototype.accountNo = "";
    SavingEvent.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SavingEvent.prototype.transactionTime = null;
    SavingEvent.prototype.custodyCode = "";
    SavingEvent.prototype.txNum = "";
    SavingEvent.prototype.bizDate = "";
    SavingEvent.create = function create(properties) {
      return new SavingEvent(properties);
    };
    SavingEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).int64(message.amount);
      if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
        $root.google.protobuf.Timestamp.encode(message.transactionTime, writer.uint32(34).fork()).ldelim();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(42).string(message.custodyCode);
      if (message.txNum != null && Object.hasOwnProperty.call(message, "txNum"))
        writer.uint32(50).string(message.txNum);
      if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
        writer.uint32(58).string(message.bizDate);
      return writer;
    };
    SavingEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.amount = reader.int64();
            break;
          case 4:
            message.transactionTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.custodyCode = reader.string();
            break;
          case 6:
            message.txNum = reader.string();
            break;
          case 7:
            message.bizDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.transactionTime);
        if (error)
          return "transactionTime." + error;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.txNum != null && message.hasOwnProperty("txNum")) {
        if (!$util.isString(message.txNum))
          return "txNum: string expected";
      }
      if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
        if (!$util.isString(message.bizDate))
          return "bizDate: string expected";
      }
      return null;
    };
    SavingEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingEvent)
        return object;
      let message = new $root.dnse.SavingEvent();
      if (object.id != null)
        message.id = String(object.id);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.transactionTime != null) {
        if (typeof object.transactionTime !== "object")
          throw TypeError(".dnse.SavingEvent.transactionTime: object expected");
        message.transactionTime = $root.google.protobuf.Timestamp.fromObject(object.transactionTime);
      }
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.txNum != null)
        message.txNum = String(object.txNum);
      if (object.bizDate != null)
        message.bizDate = String(object.bizDate);
      return message;
    };
    SavingEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.transactionTime = null;
        object.custodyCode = "";
        object.txNum = "";
        object.bizDate = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
        object.transactionTime = $root.google.protobuf.Timestamp.toObject(message.transactionTime, options);
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.txNum != null && message.hasOwnProperty("txNum"))
        object.txNum = message.txNum;
      if (message.bizDate != null && message.hasOwnProperty("bizDate"))
        object.bizDate = message.bizDate;
      return object;
    };
    SavingEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingEvent;
  }();
  dnse2.CashInAdvanceEvent = function() {
    function CashInAdvanceEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CashInAdvanceEvent.prototype.custodyCode = "";
    CashInAdvanceEvent.prototype.investorId = "";
    CashInAdvanceEvent.prototype.accountNo = "";
    CashInAdvanceEvent.prototype.advanceAmountT0 = 0;
    CashInAdvanceEvent.prototype.holdAmountT0 = 0;
    CashInAdvanceEvent.prototype.advanceAmountT1 = 0;
    CashInAdvanceEvent.prototype.holdAmountT1 = 0;
    CashInAdvanceEvent.prototype.advanceAmountT2 = 0;
    CashInAdvanceEvent.prototype.holdAmountT2 = 0;
    CashInAdvanceEvent.prototype.createdDate = null;
    CashInAdvanceEvent.create = function create(properties) {
      return new CashInAdvanceEvent(properties);
    };
    CashInAdvanceEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.advanceAmountT0 != null && Object.hasOwnProperty.call(message, "advanceAmountT0"))
        writer.uint32(33).double(message.advanceAmountT0);
      if (message.holdAmountT0 != null && Object.hasOwnProperty.call(message, "holdAmountT0"))
        writer.uint32(41).double(message.holdAmountT0);
      if (message.advanceAmountT1 != null && Object.hasOwnProperty.call(message, "advanceAmountT1"))
        writer.uint32(49).double(message.advanceAmountT1);
      if (message.holdAmountT1 != null && Object.hasOwnProperty.call(message, "holdAmountT1"))
        writer.uint32(57).double(message.holdAmountT1);
      if (message.advanceAmountT2 != null && Object.hasOwnProperty.call(message, "advanceAmountT2"))
        writer.uint32(65).double(message.advanceAmountT2);
      if (message.holdAmountT2 != null && Object.hasOwnProperty.call(message, "holdAmountT2"))
        writer.uint32(73).double(message.holdAmountT2);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
      return writer;
    };
    CashInAdvanceEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CashInAdvanceEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CashInAdvanceEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.advanceAmountT0 = reader.double();
            break;
          case 5:
            message.holdAmountT0 = reader.double();
            break;
          case 6:
            message.advanceAmountT1 = reader.double();
            break;
          case 7:
            message.holdAmountT1 = reader.double();
            break;
          case 8:
            message.advanceAmountT2 = reader.double();
            break;
          case 9:
            message.holdAmountT2 = reader.double();
            break;
          case 10:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CashInAdvanceEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CashInAdvanceEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.advanceAmountT0 != null && message.hasOwnProperty("advanceAmountT0")) {
        if (typeof message.advanceAmountT0 !== "number")
          return "advanceAmountT0: number expected";
      }
      if (message.holdAmountT0 != null && message.hasOwnProperty("holdAmountT0")) {
        if (typeof message.holdAmountT0 !== "number")
          return "holdAmountT0: number expected";
      }
      if (message.advanceAmountT1 != null && message.hasOwnProperty("advanceAmountT1")) {
        if (typeof message.advanceAmountT1 !== "number")
          return "advanceAmountT1: number expected";
      }
      if (message.holdAmountT1 != null && message.hasOwnProperty("holdAmountT1")) {
        if (typeof message.holdAmountT1 !== "number")
          return "holdAmountT1: number expected";
      }
      if (message.advanceAmountT2 != null && message.hasOwnProperty("advanceAmountT2")) {
        if (typeof message.advanceAmountT2 !== "number")
          return "advanceAmountT2: number expected";
      }
      if (message.holdAmountT2 != null && message.hasOwnProperty("holdAmountT2")) {
        if (typeof message.holdAmountT2 !== "number")
          return "holdAmountT2: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    CashInAdvanceEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CashInAdvanceEvent)
        return object;
      let message = new $root.dnse.CashInAdvanceEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.advanceAmountT0 != null)
        message.advanceAmountT0 = Number(object.advanceAmountT0);
      if (object.holdAmountT0 != null)
        message.holdAmountT0 = Number(object.holdAmountT0);
      if (object.advanceAmountT1 != null)
        message.advanceAmountT1 = Number(object.advanceAmountT1);
      if (object.holdAmountT1 != null)
        message.holdAmountT1 = Number(object.holdAmountT1);
      if (object.advanceAmountT2 != null)
        message.advanceAmountT2 = Number(object.advanceAmountT2);
      if (object.holdAmountT2 != null)
        message.holdAmountT2 = Number(object.holdAmountT2);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.CashInAdvanceEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    CashInAdvanceEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.investorId = "";
        object.accountNo = "";
        object.advanceAmountT0 = 0;
        object.holdAmountT0 = 0;
        object.advanceAmountT1 = 0;
        object.holdAmountT1 = 0;
        object.advanceAmountT2 = 0;
        object.holdAmountT2 = 0;
        object.createdDate = null;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.advanceAmountT0 != null && message.hasOwnProperty("advanceAmountT0"))
        object.advanceAmountT0 = options.json && !isFinite(message.advanceAmountT0) ? String(message.advanceAmountT0) : message.advanceAmountT0;
      if (message.holdAmountT0 != null && message.hasOwnProperty("holdAmountT0"))
        object.holdAmountT0 = options.json && !isFinite(message.holdAmountT0) ? String(message.holdAmountT0) : message.holdAmountT0;
      if (message.advanceAmountT1 != null && message.hasOwnProperty("advanceAmountT1"))
        object.advanceAmountT1 = options.json && !isFinite(message.advanceAmountT1) ? String(message.advanceAmountT1) : message.advanceAmountT1;
      if (message.holdAmountT1 != null && message.hasOwnProperty("holdAmountT1"))
        object.holdAmountT1 = options.json && !isFinite(message.holdAmountT1) ? String(message.holdAmountT1) : message.holdAmountT1;
      if (message.advanceAmountT2 != null && message.hasOwnProperty("advanceAmountT2"))
        object.advanceAmountT2 = options.json && !isFinite(message.advanceAmountT2) ? String(message.advanceAmountT2) : message.advanceAmountT2;
      if (message.holdAmountT2 != null && message.hasOwnProperty("holdAmountT2"))
        object.holdAmountT2 = options.json && !isFinite(message.holdAmountT2) ? String(message.holdAmountT2) : message.holdAmountT2;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    CashInAdvanceEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CashInAdvanceEvent;
  }();
  dnse2.DealRiskCallEvent = function() {
    function DealRiskCallEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealRiskCallEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRiskCallEvent.prototype.accountNo = "";
    DealRiskCallEvent.prototype.symbol = "";
    DealRiskCallEvent.prototype.initialRate = 0;
    DealRiskCallEvent.prototype.loanPackageId = 0;
    DealRiskCallEvent.prototype.liquidatePrice = 0;
    DealRiskCallEvent.prototype.liquidateQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRiskCallEvent.prototype.callAmount = 0;
    DealRiskCallEvent.prototype.loanPackageName = "";
    DealRiskCallEvent.prototype.custodyCode = "";
    DealRiskCallEvent.prototype.fullName = "";
    DealRiskCallEvent.prototype.createdAt = null;
    DealRiskCallEvent.prototype.investorId = "";
    DealRiskCallEvent.prototype.maintenanceRate = 0;
    DealRiskCallEvent.prototype.liquidRate = 0;
    DealRiskCallEvent.prototype.accountTypeName = "";
    DealRiskCallEvent.create = function create(properties) {
      return new DealRiskCallEvent(properties);
    };
    DealRiskCallEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(8).int64(message.dealId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(33).double(message.initialRate);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.liquidatePrice != null && Object.hasOwnProperty.call(message, "liquidatePrice"))
        writer.uint32(49).double(message.liquidatePrice);
      if (message.liquidateQuantity != null && Object.hasOwnProperty.call(message, "liquidateQuantity"))
        writer.uint32(56).int64(message.liquidateQuantity);
      if (message.callAmount != null && Object.hasOwnProperty.call(message, "callAmount"))
        writer.uint32(65).double(message.callAmount);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(74).string(message.loanPackageName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(82).string(message.custodyCode);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(90).string(message.fullName);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(98).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(106).string(message.investorId);
      if (message.maintenanceRate != null && Object.hasOwnProperty.call(message, "maintenanceRate"))
        writer.uint32(113).double(message.maintenanceRate);
      if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
        writer.uint32(121).double(message.liquidRate);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(130).string(message.accountTypeName);
      return writer;
    };
    DealRiskCallEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealRiskCallEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealRiskCallEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealId = reader.int64();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.initialRate = reader.double();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.liquidatePrice = reader.double();
            break;
          case 7:
            message.liquidateQuantity = reader.int64();
            break;
          case 8:
            message.callAmount = reader.double();
            break;
          case 9:
            message.loanPackageName = reader.string();
            break;
          case 10:
            message.custodyCode = reader.string();
            break;
          case 11:
            message.fullName = reader.string();
            break;
          case 12:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.investorId = reader.string();
            break;
          case 14:
            message.maintenanceRate = reader.double();
            break;
          case 15:
            message.liquidRate = reader.double();
            break;
          case 16:
            message.accountTypeName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealRiskCallEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealRiskCallEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.liquidatePrice != null && message.hasOwnProperty("liquidatePrice")) {
        if (typeof message.liquidatePrice !== "number")
          return "liquidatePrice: number expected";
      }
      if (message.liquidateQuantity != null && message.hasOwnProperty("liquidateQuantity")) {
        if (!$util.isInteger(message.liquidateQuantity) && !(message.liquidateQuantity && $util.isInteger(message.liquidateQuantity.low) && $util.isInteger(message.liquidateQuantity.high)))
          return "liquidateQuantity: integer|Long expected";
      }
      if (message.callAmount != null && message.hasOwnProperty("callAmount")) {
        if (typeof message.callAmount !== "number")
          return "callAmount: number expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate")) {
        if (typeof message.maintenanceRate !== "number")
          return "maintenanceRate: number expected";
      }
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
        if (typeof message.liquidRate !== "number")
          return "liquidRate: number expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      return null;
    };
    DealRiskCallEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealRiskCallEvent)
        return object;
      let message = new $root.dnse.DealRiskCallEvent();
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.liquidatePrice != null)
        message.liquidatePrice = Number(object.liquidatePrice);
      if (object.liquidateQuantity != null) {
        if ($util.Long)
          (message.liquidateQuantity = $util.Long.fromValue(object.liquidateQuantity)).unsigned = false;
        else if (typeof object.liquidateQuantity === "string")
          message.liquidateQuantity = parseInt(object.liquidateQuantity, 10);
        else if (typeof object.liquidateQuantity === "number")
          message.liquidateQuantity = object.liquidateQuantity;
        else if (typeof object.liquidateQuantity === "object")
          message.liquidateQuantity = new $util.LongBits(object.liquidateQuantity.low >>> 0, object.liquidateQuantity.high >>> 0).toNumber();
      }
      if (object.callAmount != null)
        message.callAmount = Number(object.callAmount);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.DealRiskCallEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.maintenanceRate != null)
        message.maintenanceRate = Number(object.maintenanceRate);
      if (object.liquidRate != null)
        message.liquidRate = Number(object.liquidRate);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      return message;
    };
    DealRiskCallEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
        object.accountNo = "";
        object.symbol = "";
        object.initialRate = 0;
        object.loanPackageId = 0;
        object.liquidatePrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.liquidateQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.liquidateQuantity = options.longs === String ? "0" : 0;
        object.callAmount = 0;
        object.loanPackageName = "";
        object.custodyCode = "";
        object.fullName = "";
        object.createdAt = null;
        object.investorId = "";
        object.maintenanceRate = 0;
        object.liquidRate = 0;
        object.accountTypeName = "";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.liquidatePrice != null && message.hasOwnProperty("liquidatePrice"))
        object.liquidatePrice = options.json && !isFinite(message.liquidatePrice) ? String(message.liquidatePrice) : message.liquidatePrice;
      if (message.liquidateQuantity != null && message.hasOwnProperty("liquidateQuantity"))
        if (typeof message.liquidateQuantity === "number")
          object.liquidateQuantity = options.longs === String ? String(message.liquidateQuantity) : message.liquidateQuantity;
        else
          object.liquidateQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.liquidateQuantity) : options.longs === Number ? new $util.LongBits(message.liquidateQuantity.low >>> 0, message.liquidateQuantity.high >>> 0).toNumber() : message.liquidateQuantity;
      if (message.callAmount != null && message.hasOwnProperty("callAmount"))
        object.callAmount = options.json && !isFinite(message.callAmount) ? String(message.callAmount) : message.callAmount;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate"))
        object.maintenanceRate = options.json && !isFinite(message.maintenanceRate) ? String(message.maintenanceRate) : message.maintenanceRate;
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
        object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      return object;
    };
    DealRiskCallEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealRiskCallEvent;
  }();
  dnse2.ProductSuggestionEvent = function() {
    function ProductSuggestionEvent(properties) {
      this.productNames = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ProductSuggestionEvent.prototype.investorId = "";
    ProductSuggestionEvent.prototype.name = "";
    ProductSuggestionEvent.prototype.email = "";
    ProductSuggestionEvent.prototype.custodyCode = "";
    ProductSuggestionEvent.prototype.productNames = $util.emptyArray;
    ProductSuggestionEvent.create = function create(properties) {
      return new ProductSuggestionEvent(properties);
    };
    ProductSuggestionEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(18).string(message.name);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(26).string(message.email);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(34).string(message.custodyCode);
      if (message.productNames != null && message.productNames.length)
        for (let i = 0; i < message.productNames.length; ++i)
          writer.uint32(42).string(message.productNames[i]);
      return writer;
    };
    ProductSuggestionEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ProductSuggestionEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.ProductSuggestionEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.name = reader.string();
            break;
          case 3:
            message.email = reader.string();
            break;
          case 4:
            message.custodyCode = reader.string();
            break;
          case 5:
            if (!(message.productNames && message.productNames.length))
              message.productNames = [];
            message.productNames.push(reader.string());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ProductSuggestionEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ProductSuggestionEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.productNames != null && message.hasOwnProperty("productNames")) {
        if (!Array.isArray(message.productNames))
          return "productNames: array expected";
        for (let i = 0; i < message.productNames.length; ++i)
          if (!$util.isString(message.productNames[i]))
            return "productNames: string[] expected";
      }
      return null;
    };
    ProductSuggestionEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.ProductSuggestionEvent)
        return object;
      let message = new $root.dnse.ProductSuggestionEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.name != null)
        message.name = String(object.name);
      if (object.email != null)
        message.email = String(object.email);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.productNames) {
        if (!Array.isArray(object.productNames))
          throw TypeError(".dnse.ProductSuggestionEvent.productNames: array expected");
        message.productNames = [];
        for (let i = 0; i < object.productNames.length; ++i)
          message.productNames[i] = String(object.productNames[i]);
      }
      return message;
    };
    ProductSuggestionEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.productNames = [];
      if (options.defaults) {
        object.investorId = "";
        object.name = "";
        object.email = "";
        object.custodyCode = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.productNames && message.productNames.length) {
        object.productNames = [];
        for (let j = 0; j < message.productNames.length; ++j)
          object.productNames[j] = message.productNames[j];
      }
      return object;
    };
    ProductSuggestionEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ProductSuggestionEvent;
  }();
  dnse2.InvestorActivatedEvent = function() {
    function InvestorActivatedEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InvestorActivatedEvent.prototype.custodyCode = "";
    InvestorActivatedEvent.prototype.investorId = "";
    InvestorActivatedEvent.prototype.activatedDate = null;
    InvestorActivatedEvent.create = function create(properties) {
      return new InvestorActivatedEvent(properties);
    };
    InvestorActivatedEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.activatedDate != null && Object.hasOwnProperty.call(message, "activatedDate"))
        $root.google.protobuf.Timestamp.encode(message.activatedDate, writer.uint32(218).fork()).ldelim();
      return writer;
    };
    InvestorActivatedEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InvestorActivatedEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.InvestorActivatedEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 27:
            message.activatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InvestorActivatedEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InvestorActivatedEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.activatedDate != null && message.hasOwnProperty("activatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.activatedDate);
        if (error)
          return "activatedDate." + error;
      }
      return null;
    };
    InvestorActivatedEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.InvestorActivatedEvent)
        return object;
      let message = new $root.dnse.InvestorActivatedEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.activatedDate != null) {
        if (typeof object.activatedDate !== "object")
          throw TypeError(".dnse.InvestorActivatedEvent.activatedDate: object expected");
        message.activatedDate = $root.google.protobuf.Timestamp.fromObject(object.activatedDate);
      }
      return message;
    };
    InvestorActivatedEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.investorId = "";
        object.activatedDate = null;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.activatedDate != null && message.hasOwnProperty("activatedDate"))
        object.activatedDate = $root.google.protobuf.Timestamp.toObject(message.activatedDate, options);
      return object;
    };
    InvestorActivatedEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return InvestorActivatedEvent;
  }();
  dnse2.FlexCustomerActiveEvent = function() {
    function FlexCustomerActiveEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FlexCustomerActiveEvent.prototype.custodyCode = "";
    FlexCustomerActiveEvent.prototype.activatedDate = null;
    FlexCustomerActiveEvent.create = function create(properties) {
      return new FlexCustomerActiveEvent(properties);
    };
    FlexCustomerActiveEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.activatedDate != null && Object.hasOwnProperty.call(message, "activatedDate"))
        $root.google.protobuf.Timestamp.encode(message.activatedDate, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    FlexCustomerActiveEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FlexCustomerActiveEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FlexCustomerActiveEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.activatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FlexCustomerActiveEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FlexCustomerActiveEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.activatedDate != null && message.hasOwnProperty("activatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.activatedDate);
        if (error)
          return "activatedDate." + error;
      }
      return null;
    };
    FlexCustomerActiveEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FlexCustomerActiveEvent)
        return object;
      let message = new $root.dnse.FlexCustomerActiveEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.activatedDate != null) {
        if (typeof object.activatedDate !== "object")
          throw TypeError(".dnse.FlexCustomerActiveEvent.activatedDate: object expected");
        message.activatedDate = $root.google.protobuf.Timestamp.fromObject(object.activatedDate);
      }
      return message;
    };
    FlexCustomerActiveEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.activatedDate = null;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.activatedDate != null && message.hasOwnProperty("activatedDate"))
        object.activatedDate = $root.google.protobuf.Timestamp.toObject(message.activatedDate, options);
      return object;
    };
    FlexCustomerActiveEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FlexCustomerActiveEvent;
  }();
  dnse2.DealRiskLiquidEvent = function() {
    function DealRiskLiquidEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealRiskLiquidEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRiskLiquidEvent.prototype.accountNo = "";
    DealRiskLiquidEvent.prototype.symbol = "";
    DealRiskLiquidEvent.prototype.initialRate = 0;
    DealRiskLiquidEvent.prototype.loanPackageId = 0;
    DealRiskLiquidEvent.prototype.liquidRate = 0;
    DealRiskLiquidEvent.prototype.liquidatePrice = 0;
    DealRiskLiquidEvent.prototype.liquidateQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRiskLiquidEvent.prototype.accountTypeName = "";
    DealRiskLiquidEvent.prototype.loanPackageName = "";
    DealRiskLiquidEvent.prototype.custodyCode = "";
    DealRiskLiquidEvent.prototype.fullName = "";
    DealRiskLiquidEvent.prototype.investorId = "";
    DealRiskLiquidEvent.prototype.createdAt = null;
    DealRiskLiquidEvent.create = function create(properties) {
      return new DealRiskLiquidEvent(properties);
    };
    DealRiskLiquidEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(8).int64(message.dealId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(33).double(message.initialRate);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
        writer.uint32(49).double(message.liquidRate);
      if (message.liquidatePrice != null && Object.hasOwnProperty.call(message, "liquidatePrice"))
        writer.uint32(57).double(message.liquidatePrice);
      if (message.liquidateQuantity != null && Object.hasOwnProperty.call(message, "liquidateQuantity"))
        writer.uint32(64).int64(message.liquidateQuantity);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(74).string(message.accountTypeName);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(82).string(message.loanPackageName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(90).string(message.custodyCode);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(98).string(message.fullName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(106).string(message.investorId);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(114).fork()).ldelim();
      return writer;
    };
    DealRiskLiquidEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealRiskLiquidEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealRiskLiquidEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealId = reader.int64();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.initialRate = reader.double();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.liquidRate = reader.double();
            break;
          case 7:
            message.liquidatePrice = reader.double();
            break;
          case 8:
            message.liquidateQuantity = reader.int64();
            break;
          case 9:
            message.accountTypeName = reader.string();
            break;
          case 10:
            message.loanPackageName = reader.string();
            break;
          case 11:
            message.custodyCode = reader.string();
            break;
          case 12:
            message.fullName = reader.string();
            break;
          case 13:
            message.investorId = reader.string();
            break;
          case 14:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealRiskLiquidEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealRiskLiquidEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
        if (typeof message.liquidRate !== "number")
          return "liquidRate: number expected";
      }
      if (message.liquidatePrice != null && message.hasOwnProperty("liquidatePrice")) {
        if (typeof message.liquidatePrice !== "number")
          return "liquidatePrice: number expected";
      }
      if (message.liquidateQuantity != null && message.hasOwnProperty("liquidateQuantity")) {
        if (!$util.isInteger(message.liquidateQuantity) && !(message.liquidateQuantity && $util.isInteger(message.liquidateQuantity.low) && $util.isInteger(message.liquidateQuantity.high)))
          return "liquidateQuantity: integer|Long expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    DealRiskLiquidEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealRiskLiquidEvent)
        return object;
      let message = new $root.dnse.DealRiskLiquidEvent();
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.liquidRate != null)
        message.liquidRate = Number(object.liquidRate);
      if (object.liquidatePrice != null)
        message.liquidatePrice = Number(object.liquidatePrice);
      if (object.liquidateQuantity != null) {
        if ($util.Long)
          (message.liquidateQuantity = $util.Long.fromValue(object.liquidateQuantity)).unsigned = false;
        else if (typeof object.liquidateQuantity === "string")
          message.liquidateQuantity = parseInt(object.liquidateQuantity, 10);
        else if (typeof object.liquidateQuantity === "number")
          message.liquidateQuantity = object.liquidateQuantity;
        else if (typeof object.liquidateQuantity === "object")
          message.liquidateQuantity = new $util.LongBits(object.liquidateQuantity.low >>> 0, object.liquidateQuantity.high >>> 0).toNumber();
      }
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.DealRiskLiquidEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    DealRiskLiquidEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
        object.accountNo = "";
        object.symbol = "";
        object.initialRate = 0;
        object.loanPackageId = 0;
        object.liquidRate = 0;
        object.liquidatePrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.liquidateQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.liquidateQuantity = options.longs === String ? "0" : 0;
        object.accountTypeName = "";
        object.loanPackageName = "";
        object.custodyCode = "";
        object.fullName = "";
        object.investorId = "";
        object.createdAt = null;
      }
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
        object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
      if (message.liquidatePrice != null && message.hasOwnProperty("liquidatePrice"))
        object.liquidatePrice = options.json && !isFinite(message.liquidatePrice) ? String(message.liquidatePrice) : message.liquidatePrice;
      if (message.liquidateQuantity != null && message.hasOwnProperty("liquidateQuantity"))
        if (typeof message.liquidateQuantity === "number")
          object.liquidateQuantity = options.longs === String ? String(message.liquidateQuantity) : message.liquidateQuantity;
        else
          object.liquidateQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.liquidateQuantity) : options.longs === Number ? new $util.LongBits(message.liquidateQuantity.low >>> 0, message.liquidateQuantity.high >>> 0).toNumber() : message.liquidateQuantity;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    DealRiskLiquidEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealRiskLiquidEvent;
  }();
  dnse2.DealRiskLiquidDelayEvent = function() {
    function DealRiskLiquidDelayEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealRiskLiquidDelayEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRiskLiquidDelayEvent.prototype.accountNo = "";
    DealRiskLiquidDelayEvent.prototype.symbol = "";
    DealRiskLiquidDelayEvent.prototype.initialRate = 0;
    DealRiskLiquidDelayEvent.prototype.loanPackageId = 0;
    DealRiskLiquidDelayEvent.prototype.liquidRate = 0;
    DealRiskLiquidDelayEvent.prototype.accountTypeName = "";
    DealRiskLiquidDelayEvent.prototype.loanPackageName = "";
    DealRiskLiquidDelayEvent.prototype.custodyCode = "";
    DealRiskLiquidDelayEvent.prototype.fullName = "";
    DealRiskLiquidDelayEvent.prototype.investorId = "";
    DealRiskLiquidDelayEvent.prototype.delayExpireAt = null;
    DealRiskLiquidDelayEvent.prototype.createdAt = null;
    DealRiskLiquidDelayEvent.create = function create(properties) {
      return new DealRiskLiquidDelayEvent(properties);
    };
    DealRiskLiquidDelayEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(8).int64(message.dealId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(33).double(message.initialRate);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
        writer.uint32(49).double(message.liquidRate);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(58).string(message.accountTypeName);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(66).string(message.loanPackageName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(74).string(message.custodyCode);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(82).string(message.fullName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(90).string(message.investorId);
      if (message.delayExpireAt != null && Object.hasOwnProperty.call(message, "delayExpireAt"))
        $root.google.protobuf.Timestamp.encode(message.delayExpireAt, writer.uint32(98).fork()).ldelim();
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(106).fork()).ldelim();
      return writer;
    };
    DealRiskLiquidDelayEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealRiskLiquidDelayEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealRiskLiquidDelayEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealId = reader.int64();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.initialRate = reader.double();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.liquidRate = reader.double();
            break;
          case 7:
            message.accountTypeName = reader.string();
            break;
          case 8:
            message.loanPackageName = reader.string();
            break;
          case 9:
            message.custodyCode = reader.string();
            break;
          case 10:
            message.fullName = reader.string();
            break;
          case 11:
            message.investorId = reader.string();
            break;
          case 12:
            message.delayExpireAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealRiskLiquidDelayEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealRiskLiquidDelayEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
        if (typeof message.liquidRate !== "number")
          return "liquidRate: number expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.delayExpireAt != null && message.hasOwnProperty("delayExpireAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.delayExpireAt);
        if (error)
          return "delayExpireAt." + error;
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    DealRiskLiquidDelayEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealRiskLiquidDelayEvent)
        return object;
      let message = new $root.dnse.DealRiskLiquidDelayEvent();
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.liquidRate != null)
        message.liquidRate = Number(object.liquidRate);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.delayExpireAt != null) {
        if (typeof object.delayExpireAt !== "object")
          throw TypeError(".dnse.DealRiskLiquidDelayEvent.delayExpireAt: object expected");
        message.delayExpireAt = $root.google.protobuf.Timestamp.fromObject(object.delayExpireAt);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.DealRiskLiquidDelayEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    DealRiskLiquidDelayEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
        object.accountNo = "";
        object.symbol = "";
        object.initialRate = 0;
        object.loanPackageId = 0;
        object.liquidRate = 0;
        object.accountTypeName = "";
        object.loanPackageName = "";
        object.custodyCode = "";
        object.fullName = "";
        object.investorId = "";
        object.delayExpireAt = null;
        object.createdAt = null;
      }
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
        object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.delayExpireAt != null && message.hasOwnProperty("delayExpireAt"))
        object.delayExpireAt = $root.google.protobuf.Timestamp.toObject(message.delayExpireAt, options);
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    DealRiskLiquidDelayEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealRiskLiquidDelayEvent;
  }();
  dnse2.DealAccountEvent = function() {
    function DealAccountEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealAccountEvent.prototype.investorId = "";
    DealAccountEvent.prototype.custodyCode = "";
    DealAccountEvent.prototype.accountNo = "";
    DealAccountEvent.create = function create(properties) {
      return new DealAccountEvent(properties);
    };
    DealAccountEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      return writer;
    };
    DealAccountEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealAccountEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealAccountEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealAccountEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealAccountEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      return null;
    };
    DealAccountEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealAccountEvent)
        return object;
      let message = new $root.dnse.DealAccountEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      return message;
    };
    DealAccountEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.accountNo = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      return object;
    };
    DealAccountEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealAccountEvent;
  }();
  dnse2.SmartOrder = function() {
    function SmartOrder2(properties) {
      this.executions = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SmartOrder2.prototype.id = "";
    SmartOrder2.prototype.accountNo = "";
    SmartOrder2.prototype.symbol = "";
    SmartOrder2.prototype.side = "";
    SmartOrder2.prototype.type = "";
    SmartOrder2.prototype.targetPrice = 0;
    SmartOrder2.prototype.averagePrice = 0;
    SmartOrder2.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SmartOrder2.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SmartOrder2.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SmartOrder2.prototype.executions = $util.emptyArray;
    SmartOrder2.prototype.expireTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SmartOrder2.prototype.createdDate = null;
    SmartOrder2.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SmartOrder2.prototype.modifiedDate = null;
    SmartOrder2.create = function create(properties) {
      return new SmartOrder2(properties);
    };
    SmartOrder2.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(34).string(message.side);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(42).string(message.type);
      if (message.targetPrice != null && Object.hasOwnProperty.call(message, "targetPrice"))
        writer.uint32(49).double(message.targetPrice);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(57).double(message.averagePrice);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(64).int64(message.quantity);
      if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
        writer.uint32(72).int64(message.fillQuantity);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(80).int64(message.loanPackageId);
      if (message.executions != null && message.executions.length)
        for (let i = 0; i < message.executions.length; ++i)
          $root.dnse.Execution.encode(message.executions[i], writer.uint32(90).fork()).ldelim();
      if (message.expireTime != null && Object.hasOwnProperty.call(message, "expireTime"))
        writer.uint32(96).int64(message.expireTime);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(106).fork()).ldelim();
      if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
        writer.uint32(112).int64(message.leaveQuantity);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(122).fork()).ldelim();
      return writer;
    };
    SmartOrder2.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SmartOrder2.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SmartOrder();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.side = reader.string();
            break;
          case 5:
            message.type = reader.string();
            break;
          case 6:
            message.targetPrice = reader.double();
            break;
          case 7:
            message.averagePrice = reader.double();
            break;
          case 8:
            message.quantity = reader.int64();
            break;
          case 9:
            message.fillQuantity = reader.int64();
            break;
          case 10:
            message.loanPackageId = reader.int64();
            break;
          case 11:
            if (!(message.executions && message.executions.length))
              message.executions = [];
            message.executions.push($root.dnse.Execution.decode(reader, reader.uint32()));
            break;
          case 12:
            message.expireTime = reader.int64();
            break;
          case 13:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 14:
            message.leaveQuantity = reader.int64();
            break;
          case 15:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SmartOrder2.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SmartOrder2.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.targetPrice != null && message.hasOwnProperty("targetPrice")) {
        if (typeof message.targetPrice !== "number")
          return "targetPrice: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
        if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
          return "fillQuantity: integer|Long expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
          return "loanPackageId: integer|Long expected";
      }
      if (message.executions != null && message.hasOwnProperty("executions")) {
        if (!Array.isArray(message.executions))
          return "executions: array expected";
        for (let i = 0; i < message.executions.length; ++i) {
          let error = $root.dnse.Execution.verify(message.executions[i]);
          if (error)
            return "executions." + error;
        }
      }
      if (message.expireTime != null && message.hasOwnProperty("expireTime")) {
        if (!$util.isInteger(message.expireTime) && !(message.expireTime && $util.isInteger(message.expireTime.low) && $util.isInteger(message.expireTime.high)))
          return "expireTime: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
        if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
          return "leaveQuantity: integer|Long expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    SmartOrder2.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SmartOrder)
        return object;
      let message = new $root.dnse.SmartOrder();
      if (object.id != null)
        message.id = String(object.id);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.side != null)
        message.side = String(object.side);
      if (object.type != null)
        message.type = String(object.type);
      if (object.targetPrice != null)
        message.targetPrice = Number(object.targetPrice);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.fillQuantity != null) {
        if ($util.Long)
          (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
        else if (typeof object.fillQuantity === "string")
          message.fillQuantity = parseInt(object.fillQuantity, 10);
        else if (typeof object.fillQuantity === "number")
          message.fillQuantity = object.fillQuantity;
        else if (typeof object.fillQuantity === "object")
          message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
      }
      if (object.loanPackageId != null) {
        if ($util.Long)
          (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
        else if (typeof object.loanPackageId === "string")
          message.loanPackageId = parseInt(object.loanPackageId, 10);
        else if (typeof object.loanPackageId === "number")
          message.loanPackageId = object.loanPackageId;
        else if (typeof object.loanPackageId === "object")
          message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
      }
      if (object.executions) {
        if (!Array.isArray(object.executions))
          throw TypeError(".dnse.SmartOrder.executions: array expected");
        message.executions = [];
        for (let i = 0; i < object.executions.length; ++i) {
          if (typeof object.executions[i] !== "object")
            throw TypeError(".dnse.SmartOrder.executions: object expected");
          message.executions[i] = $root.dnse.Execution.fromObject(object.executions[i]);
        }
      }
      if (object.expireTime != null) {
        if ($util.Long)
          (message.expireTime = $util.Long.fromValue(object.expireTime)).unsigned = false;
        else if (typeof object.expireTime === "string")
          message.expireTime = parseInt(object.expireTime, 10);
        else if (typeof object.expireTime === "number")
          message.expireTime = object.expireTime;
        else if (typeof object.expireTime === "object")
          message.expireTime = new $util.LongBits(object.expireTime.low >>> 0, object.expireTime.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SmartOrder.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.leaveQuantity != null) {
        if ($util.Long)
          (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
        else if (typeof object.leaveQuantity === "string")
          message.leaveQuantity = parseInt(object.leaveQuantity, 10);
        else if (typeof object.leaveQuantity === "number")
          message.leaveQuantity = object.leaveQuantity;
        else if (typeof object.leaveQuantity === "object")
          message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.SmartOrder.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    SmartOrder2.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.executions = [];
      if (options.defaults) {
        object.id = "";
        object.accountNo = "";
        object.symbol = "";
        object.side = "";
        object.type = "";
        object.targetPrice = 0;
        object.averagePrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fillQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanPackageId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.expireTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.expireTime = options.longs === String ? "0" : 0;
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.leaveQuantity = options.longs === String ? "0" : 0;
        object.modifiedDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.targetPrice != null && message.hasOwnProperty("targetPrice"))
        object.targetPrice = options.json && !isFinite(message.targetPrice) ? String(message.targetPrice) : message.targetPrice;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
        if (typeof message.fillQuantity === "number")
          object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
        else
          object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        if (typeof message.loanPackageId === "number")
          object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
        else
          object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
      if (message.executions && message.executions.length) {
        object.executions = [];
        for (let j = 0; j < message.executions.length; ++j)
          object.executions[j] = $root.dnse.Execution.toObject(message.executions[j], options);
      }
      if (message.expireTime != null && message.hasOwnProperty("expireTime"))
        if (typeof message.expireTime === "number")
          object.expireTime = options.longs === String ? String(message.expireTime) : message.expireTime;
        else
          object.expireTime = options.longs === String ? $util.Long.prototype.toString.call(message.expireTime) : options.longs === Number ? new $util.LongBits(message.expireTime.low >>> 0, message.expireTime.high >>> 0).toNumber() : message.expireTime;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
        if (typeof message.leaveQuantity === "number")
          object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
        else
          object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    SmartOrder2.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SmartOrder2;
  }();
  dnse2.Execution = function() {
    function Execution(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Execution.prototype.price = 0;
    Execution.prototype.averagePrice = 0;
    Execution.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Execution.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Execution.prototype.bizDate = "";
    Execution.prototype.referenceOrderId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Execution.prototype.description = "";
    Execution.prototype.createdDate = null;
    Execution.prototype.modifiedDate = null;
    Execution.prototype.type = "";
    Execution.prototype.status = "";
    Execution.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Execution.create = function create(properties) {
      return new Execution(properties);
    };
    Execution.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(9).double(message.price);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(17).double(message.averagePrice);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(24).int64(message.quantity);
      if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
        writer.uint32(32).int64(message.fillQuantity);
      if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
        writer.uint32(42).string(message.bizDate);
      if (message.referenceOrderId != null && Object.hasOwnProperty.call(message, "referenceOrderId"))
        writer.uint32(48).int64(message.referenceOrderId);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(58).string(message.description);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(74).fork()).ldelim();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(82).string(message.type);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(90).string(message.status);
      if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
        writer.uint32(96).int64(message.leaveQuantity);
      return writer;
    };
    Execution.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Execution.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Execution();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.price = reader.double();
            break;
          case 2:
            message.averagePrice = reader.double();
            break;
          case 3:
            message.quantity = reader.int64();
            break;
          case 4:
            message.fillQuantity = reader.int64();
            break;
          case 5:
            message.bizDate = reader.string();
            break;
          case 6:
            message.referenceOrderId = reader.int64();
            break;
          case 7:
            message.description = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.type = reader.string();
            break;
          case 11:
            message.status = reader.string();
            break;
          case 12:
            message.leaveQuantity = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Execution.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Execution.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
        if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
          return "fillQuantity: integer|Long expected";
      }
      if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
        if (!$util.isString(message.bizDate))
          return "bizDate: string expected";
      }
      if (message.referenceOrderId != null && message.hasOwnProperty("referenceOrderId")) {
        if (!$util.isInteger(message.referenceOrderId) && !(message.referenceOrderId && $util.isInteger(message.referenceOrderId.low) && $util.isInteger(message.referenceOrderId.high)))
          return "referenceOrderId: integer|Long expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
        if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
          return "leaveQuantity: integer|Long expected";
      }
      return null;
    };
    Execution.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Execution)
        return object;
      let message = new $root.dnse.Execution();
      if (object.price != null)
        message.price = Number(object.price);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.fillQuantity != null) {
        if ($util.Long)
          (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
        else if (typeof object.fillQuantity === "string")
          message.fillQuantity = parseInt(object.fillQuantity, 10);
        else if (typeof object.fillQuantity === "number")
          message.fillQuantity = object.fillQuantity;
        else if (typeof object.fillQuantity === "object")
          message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
      }
      if (object.bizDate != null)
        message.bizDate = String(object.bizDate);
      if (object.referenceOrderId != null) {
        if ($util.Long)
          (message.referenceOrderId = $util.Long.fromValue(object.referenceOrderId)).unsigned = false;
        else if (typeof object.referenceOrderId === "string")
          message.referenceOrderId = parseInt(object.referenceOrderId, 10);
        else if (typeof object.referenceOrderId === "number")
          message.referenceOrderId = object.referenceOrderId;
        else if (typeof object.referenceOrderId === "object")
          message.referenceOrderId = new $util.LongBits(object.referenceOrderId.low >>> 0, object.referenceOrderId.high >>> 0).toNumber();
      }
      if (object.description != null)
        message.description = String(object.description);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.Execution.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.Execution.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.type != null)
        message.type = String(object.type);
      if (object.status != null)
        message.status = String(object.status);
      if (object.leaveQuantity != null) {
        if ($util.Long)
          (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
        else if (typeof object.leaveQuantity === "string")
          message.leaveQuantity = parseInt(object.leaveQuantity, 10);
        else if (typeof object.leaveQuantity === "number")
          message.leaveQuantity = object.leaveQuantity;
        else if (typeof object.leaveQuantity === "object")
          message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
      }
      return message;
    };
    Execution.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.price = 0;
        object.averagePrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fillQuantity = options.longs === String ? "0" : 0;
        object.bizDate = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.referenceOrderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.referenceOrderId = options.longs === String ? "0" : 0;
        object.description = "";
        object.createdDate = null;
        object.modifiedDate = null;
        object.type = "";
        object.status = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.leaveQuantity = options.longs === String ? "0" : 0;
      }
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
        if (typeof message.fillQuantity === "number")
          object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
        else
          object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
      if (message.bizDate != null && message.hasOwnProperty("bizDate"))
        object.bizDate = message.bizDate;
      if (message.referenceOrderId != null && message.hasOwnProperty("referenceOrderId"))
        if (typeof message.referenceOrderId === "number")
          object.referenceOrderId = options.longs === String ? String(message.referenceOrderId) : message.referenceOrderId;
        else
          object.referenceOrderId = options.longs === String ? $util.Long.prototype.toString.call(message.referenceOrderId) : options.longs === Number ? new $util.LongBits(message.referenceOrderId.low >>> 0, message.referenceOrderId.high >>> 0).toNumber() : message.referenceOrderId;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
        if (typeof message.leaveQuantity === "number")
          object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
        else
          object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
      return object;
    };
    Execution.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Execution;
  }();
  dnse2.FirstOrderRewardEvent = function() {
    function FirstOrderRewardEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FirstOrderRewardEvent.prototype.investorId = "";
    FirstOrderRewardEvent.prototype.custodyCode = "";
    FirstOrderRewardEvent.prototype.createdAt = null;
    FirstOrderRewardEvent.create = function create(properties) {
      return new FirstOrderRewardEvent(properties);
    };
    FirstOrderRewardEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    FirstOrderRewardEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FirstOrderRewardEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FirstOrderRewardEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FirstOrderRewardEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FirstOrderRewardEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FirstOrderRewardEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FirstOrderRewardEvent)
        return object;
      let message = new $root.dnse.FirstOrderRewardEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FirstOrderRewardEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FirstOrderRewardEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FirstOrderRewardEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FirstOrderRewardEvent;
  }();
  dnse2.FirstOrderRewardPaidEvent = function() {
    function FirstOrderRewardPaidEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FirstOrderRewardPaidEvent.prototype.investorId = "";
    FirstOrderRewardPaidEvent.prototype.custodyCode = "";
    FirstOrderRewardPaidEvent.prototype.reward = 0;
    FirstOrderRewardPaidEvent.prototype.createdAt = null;
    FirstOrderRewardPaidEvent.create = function create(properties) {
      return new FirstOrderRewardPaidEvent(properties);
    };
    FirstOrderRewardPaidEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.reward != null && Object.hasOwnProperty.call(message, "reward"))
        writer.uint32(24).int32(message.reward);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    FirstOrderRewardPaidEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FirstOrderRewardPaidEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FirstOrderRewardPaidEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.reward = reader.int32();
            break;
          case 4:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FirstOrderRewardPaidEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FirstOrderRewardPaidEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.reward != null && message.hasOwnProperty("reward")) {
        if (!$util.isInteger(message.reward))
          return "reward: integer expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FirstOrderRewardPaidEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FirstOrderRewardPaidEvent)
        return object;
      let message = new $root.dnse.FirstOrderRewardPaidEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.reward != null)
        message.reward = object.reward | 0;
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FirstOrderRewardPaidEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FirstOrderRewardPaidEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.reward = 0;
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.reward != null && message.hasOwnProperty("reward"))
        object.reward = message.reward;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FirstOrderRewardPaidEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FirstOrderRewardPaidEvent;
  }();
  dnse2.RewardProgressEvent = function() {
    function RewardProgressEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    RewardProgressEvent.prototype.investorId = "";
    RewardProgressEvent.prototype.event = "";
    RewardProgressEvent.prototype.createdAt = null;
    RewardProgressEvent.create = function create(properties) {
      return new RewardProgressEvent(properties);
    };
    RewardProgressEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.event != null && Object.hasOwnProperty.call(message, "event"))
        writer.uint32(18).string(message.event);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    RewardProgressEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    RewardProgressEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.RewardProgressEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.event = reader.string();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    RewardProgressEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    RewardProgressEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.event != null && message.hasOwnProperty("event")) {
        if (!$util.isString(message.event))
          return "event: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    RewardProgressEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.RewardProgressEvent)
        return object;
      let message = new $root.dnse.RewardProgressEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.event != null)
        message.event = String(object.event);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.RewardProgressEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    RewardProgressEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.event = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.event != null && message.hasOwnProperty("event"))
        object.event = message.event;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    RewardProgressEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return RewardProgressEvent;
  }();
  dnse2.HandoffOTPEvent = function() {
    function HandoffOTPEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    HandoffOTPEvent.prototype.id = "";
    HandoffOTPEvent.prototype.investorId = "";
    HandoffOTPEvent.prototype.type = "";
    HandoffOTPEvent.prototype.status = 0;
    HandoffOTPEvent.prototype.data = "";
    HandoffOTPEvent.prototype.createdAt = null;
    HandoffOTPEvent.prototype.updatedAt = null;
    HandoffOTPEvent.prototype.expiredAt = null;
    HandoffOTPEvent.prototype.otp = "";
    HandoffOTPEvent.create = function create(properties) {
      return new HandoffOTPEvent(properties);
    };
    HandoffOTPEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(26).string(message.type);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(32).int32(message.status);
      if (message.data != null && Object.hasOwnProperty.call(message, "data"))
        writer.uint32(42).string(message.data);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
      if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
        $root.google.protobuf.Timestamp.encode(message.updatedAt, writer.uint32(58).fork()).ldelim();
      if (message.expiredAt != null && Object.hasOwnProperty.call(message, "expiredAt"))
        $root.google.protobuf.Timestamp.encode(message.expiredAt, writer.uint32(66).fork()).ldelim();
      if (message.otp != null && Object.hasOwnProperty.call(message, "otp"))
        writer.uint32(74).string(message.otp);
      return writer;
    };
    HandoffOTPEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    HandoffOTPEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.HandoffOTPEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.type = reader.string();
            break;
          case 4:
            message.status = reader.int32();
            break;
          case 5:
            message.data = reader.string();
            break;
          case 6:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.updatedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.expiredAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.otp = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    HandoffOTPEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    HandoffOTPEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.data != null && message.hasOwnProperty("data")) {
        if (!$util.isString(message.data))
          return "data: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.updatedAt);
        if (error)
          return "updatedAt." + error;
      }
      if (message.expiredAt != null && message.hasOwnProperty("expiredAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.expiredAt);
        if (error)
          return "expiredAt." + error;
      }
      if (message.otp != null && message.hasOwnProperty("otp")) {
        if (!$util.isString(message.otp))
          return "otp: string expected";
      }
      return null;
    };
    HandoffOTPEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.HandoffOTPEvent)
        return object;
      let message = new $root.dnse.HandoffOTPEvent();
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.type != null)
        message.type = String(object.type);
      switch (object.status) {
        case "WAITING":
        case 0:
          message.status = 0;
          break;
        case "APPROVED":
        case 1:
          message.status = 1;
          break;
        case "REJECTED":
        case 2:
          message.status = 2;
          break;
        case "CANCELLED":
        case 3:
          message.status = 3;
          break;
        case "EXPIRED":
        case 4:
          message.status = 4;
          break;
      }
      if (object.data != null)
        message.data = String(object.data);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.HandoffOTPEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.updatedAt != null) {
        if (typeof object.updatedAt !== "object")
          throw TypeError(".dnse.HandoffOTPEvent.updatedAt: object expected");
        message.updatedAt = $root.google.protobuf.Timestamp.fromObject(object.updatedAt);
      }
      if (object.expiredAt != null) {
        if (typeof object.expiredAt !== "object")
          throw TypeError(".dnse.HandoffOTPEvent.expiredAt: object expected");
        message.expiredAt = $root.google.protobuf.Timestamp.fromObject(object.expiredAt);
      }
      if (object.otp != null)
        message.otp = String(object.otp);
      return message;
    };
    HandoffOTPEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.investorId = "";
        object.type = "";
        object.status = options.enums === String ? "WAITING" : 0;
        object.data = "";
        object.createdAt = null;
        object.updatedAt = null;
        object.expiredAt = null;
        object.otp = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.HandoffOTPEvent.Status[message.status] : message.status;
      if (message.data != null && message.hasOwnProperty("data"))
        object.data = message.data;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
        object.updatedAt = $root.google.protobuf.Timestamp.toObject(message.updatedAt, options);
      if (message.expiredAt != null && message.hasOwnProperty("expiredAt"))
        object.expiredAt = $root.google.protobuf.Timestamp.toObject(message.expiredAt, options);
      if (message.otp != null && message.hasOwnProperty("otp"))
        object.otp = message.otp;
      return object;
    };
    HandoffOTPEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    HandoffOTPEvent.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "WAITING"] = 0;
      values[valuesById[1] = "APPROVED"] = 1;
      values[valuesById[2] = "REJECTED"] = 2;
      values[valuesById[3] = "CANCELLED"] = 3;
      values[valuesById[4] = "EXPIRED"] = 4;
      return values;
    }();
    return HandoffOTPEvent;
  }();
  dnse2.DealDepositReq = function() {
    function DealDepositReq(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealDepositReq.prototype.accountNo = "";
    DealDepositReq.prototype.symbol = "";
    DealDepositReq.prototype.referenceId = "";
    DealDepositReq.prototype.tradeQuantity = 0;
    DealDepositReq.prototype.t_0ReceivingQuantity = 0;
    DealDepositReq.prototype.t_1ReceivingQuantity = 0;
    DealDepositReq.prototype.t_2ReceivingQuantity = 0;
    DealDepositReq.prototype.rightReceivingQuantity = 0;
    DealDepositReq.prototype.dividendReceivingQuantity = 0;
    DealDepositReq.prototype.dividendQuantity = 0;
    DealDepositReq.prototype.costPrice = 0;
    DealDepositReq.prototype.loanPackageId = "";
    DealDepositReq.prototype.dealId = "";
    DealDepositReq.prototype.description = "";
    DealDepositReq.prototype.maker = "";
    DealDepositReq.create = function create(properties) {
      return new DealDepositReq(properties);
    };
    DealDepositReq.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
        writer.uint32(26).string(message.referenceId);
      if (message.tradeQuantity != null && Object.hasOwnProperty.call(message, "tradeQuantity"))
        writer.uint32(32).int32(message.tradeQuantity);
      if (message.t_0ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t_0ReceivingQuantity"))
        writer.uint32(40).int32(message.t_0ReceivingQuantity);
      if (message.t_1ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t_1ReceivingQuantity"))
        writer.uint32(48).int32(message.t_1ReceivingQuantity);
      if (message.t_2ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t_2ReceivingQuantity"))
        writer.uint32(56).int32(message.t_2ReceivingQuantity);
      if (message.rightReceivingQuantity != null && Object.hasOwnProperty.call(message, "rightReceivingQuantity"))
        writer.uint32(64).int32(message.rightReceivingQuantity);
      if (message.dividendReceivingQuantity != null && Object.hasOwnProperty.call(message, "dividendReceivingQuantity"))
        writer.uint32(72).int32(message.dividendReceivingQuantity);
      if (message.dividendQuantity != null && Object.hasOwnProperty.call(message, "dividendQuantity"))
        writer.uint32(80).int32(message.dividendQuantity);
      if (message.costPrice != null && Object.hasOwnProperty.call(message, "costPrice"))
        writer.uint32(89).double(message.costPrice);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(98).string(message.loanPackageId);
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(106).string(message.dealId);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(114).string(message.description);
      if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
        writer.uint32(122).string(message.maker);
      return writer;
    };
    DealDepositReq.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealDepositReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealDepositReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.referenceId = reader.string();
            break;
          case 4:
            message.tradeQuantity = reader.int32();
            break;
          case 5:
            message.t_0ReceivingQuantity = reader.int32();
            break;
          case 6:
            message.t_1ReceivingQuantity = reader.int32();
            break;
          case 7:
            message.t_2ReceivingQuantity = reader.int32();
            break;
          case 8:
            message.rightReceivingQuantity = reader.int32();
            break;
          case 9:
            message.dividendReceivingQuantity = reader.int32();
            break;
          case 10:
            message.dividendQuantity = reader.int32();
            break;
          case 11:
            message.costPrice = reader.double();
            break;
          case 12:
            message.loanPackageId = reader.string();
            break;
          case 13:
            message.dealId = reader.string();
            break;
          case 14:
            message.description = reader.string();
            break;
          case 15:
            message.maker = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealDepositReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealDepositReq.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
        if (!$util.isString(message.referenceId))
          return "referenceId: string expected";
      }
      if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity")) {
        if (!$util.isInteger(message.tradeQuantity))
          return "tradeQuantity: integer expected";
      }
      if (message.t_0ReceivingQuantity != null && message.hasOwnProperty("t_0ReceivingQuantity")) {
        if (!$util.isInteger(message.t_0ReceivingQuantity))
          return "t_0ReceivingQuantity: integer expected";
      }
      if (message.t_1ReceivingQuantity != null && message.hasOwnProperty("t_1ReceivingQuantity")) {
        if (!$util.isInteger(message.t_1ReceivingQuantity))
          return "t_1ReceivingQuantity: integer expected";
      }
      if (message.t_2ReceivingQuantity != null && message.hasOwnProperty("t_2ReceivingQuantity")) {
        if (!$util.isInteger(message.t_2ReceivingQuantity))
          return "t_2ReceivingQuantity: integer expected";
      }
      if (message.rightReceivingQuantity != null && message.hasOwnProperty("rightReceivingQuantity")) {
        if (!$util.isInteger(message.rightReceivingQuantity))
          return "rightReceivingQuantity: integer expected";
      }
      if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity")) {
        if (!$util.isInteger(message.dividendReceivingQuantity))
          return "dividendReceivingQuantity: integer expected";
      }
      if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity")) {
        if (!$util.isInteger(message.dividendQuantity))
          return "dividendQuantity: integer expected";
      }
      if (message.costPrice != null && message.hasOwnProperty("costPrice")) {
        if (typeof message.costPrice !== "number")
          return "costPrice: number expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isString(message.loanPackageId))
          return "loanPackageId: string expected";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isString(message.dealId))
          return "dealId: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.maker != null && message.hasOwnProperty("maker")) {
        if (!$util.isString(message.maker))
          return "maker: string expected";
      }
      return null;
    };
    DealDepositReq.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealDepositReq)
        return object;
      let message = new $root.dnse.DealDepositReq();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.referenceId != null)
        message.referenceId = String(object.referenceId);
      if (object.tradeQuantity != null)
        message.tradeQuantity = object.tradeQuantity | 0;
      if (object.t_0ReceivingQuantity != null)
        message.t_0ReceivingQuantity = object.t_0ReceivingQuantity | 0;
      if (object.t_1ReceivingQuantity != null)
        message.t_1ReceivingQuantity = object.t_1ReceivingQuantity | 0;
      if (object.t_2ReceivingQuantity != null)
        message.t_2ReceivingQuantity = object.t_2ReceivingQuantity | 0;
      if (object.rightReceivingQuantity != null)
        message.rightReceivingQuantity = object.rightReceivingQuantity | 0;
      if (object.dividendReceivingQuantity != null)
        message.dividendReceivingQuantity = object.dividendReceivingQuantity | 0;
      if (object.dividendQuantity != null)
        message.dividendQuantity = object.dividendQuantity | 0;
      if (object.costPrice != null)
        message.costPrice = Number(object.costPrice);
      if (object.loanPackageId != null)
        message.loanPackageId = String(object.loanPackageId);
      if (object.dealId != null)
        message.dealId = String(object.dealId);
      if (object.description != null)
        message.description = String(object.description);
      if (object.maker != null)
        message.maker = String(object.maker);
      return message;
    };
    DealDepositReq.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.symbol = "";
        object.referenceId = "";
        object.tradeQuantity = 0;
        object.t_0ReceivingQuantity = 0;
        object.t_1ReceivingQuantity = 0;
        object.t_2ReceivingQuantity = 0;
        object.rightReceivingQuantity = 0;
        object.dividendReceivingQuantity = 0;
        object.dividendQuantity = 0;
        object.costPrice = 0;
        object.loanPackageId = "";
        object.dealId = "";
        object.description = "";
        object.maker = "";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.referenceId != null && message.hasOwnProperty("referenceId"))
        object.referenceId = message.referenceId;
      if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity"))
        object.tradeQuantity = message.tradeQuantity;
      if (message.t_0ReceivingQuantity != null && message.hasOwnProperty("t_0ReceivingQuantity"))
        object.t_0ReceivingQuantity = message.t_0ReceivingQuantity;
      if (message.t_1ReceivingQuantity != null && message.hasOwnProperty("t_1ReceivingQuantity"))
        object.t_1ReceivingQuantity = message.t_1ReceivingQuantity;
      if (message.t_2ReceivingQuantity != null && message.hasOwnProperty("t_2ReceivingQuantity"))
        object.t_2ReceivingQuantity = message.t_2ReceivingQuantity;
      if (message.rightReceivingQuantity != null && message.hasOwnProperty("rightReceivingQuantity"))
        object.rightReceivingQuantity = message.rightReceivingQuantity;
      if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity"))
        object.dividendReceivingQuantity = message.dividendReceivingQuantity;
      if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity"))
        object.dividendQuantity = message.dividendQuantity;
      if (message.costPrice != null && message.hasOwnProperty("costPrice"))
        object.costPrice = options.json && !isFinite(message.costPrice) ? String(message.costPrice) : message.costPrice;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        object.dealId = message.dealId;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.maker != null && message.hasOwnProperty("maker"))
        object.maker = message.maker;
      return object;
    };
    DealDepositReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealDepositReq;
  }();
  dnse2.DealWithdrawalReq = function() {
    function DealWithdrawalReq(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealWithdrawalReq.prototype.accountNo = "";
    DealWithdrawalReq.prototype.symbol = "";
    DealWithdrawalReq.prototype.referenceId = "";
    DealWithdrawalReq.prototype.tradeQuantity = 0;
    DealWithdrawalReq.prototype.t_0ReceivingQuantity = 0;
    DealWithdrawalReq.prototype.t_1ReceivingQuantity = 0;
    DealWithdrawalReq.prototype.t_2ReceivingQuantity = 0;
    DealWithdrawalReq.prototype.rightReceivingQuantity = 0;
    DealWithdrawalReq.prototype.dividendReceivingQuantity = 0;
    DealWithdrawalReq.prototype.dividendQuantity = 0;
    DealWithdrawalReq.prototype.costPrice = 0;
    DealWithdrawalReq.prototype.dealId = "";
    DealWithdrawalReq.prototype.description = "";
    DealWithdrawalReq.prototype.maker = "";
    DealWithdrawalReq.create = function create(properties) {
      return new DealWithdrawalReq(properties);
    };
    DealWithdrawalReq.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
        writer.uint32(26).string(message.referenceId);
      if (message.tradeQuantity != null && Object.hasOwnProperty.call(message, "tradeQuantity"))
        writer.uint32(32).int32(message.tradeQuantity);
      if (message.t_0ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t_0ReceivingQuantity"))
        writer.uint32(40).int32(message.t_0ReceivingQuantity);
      if (message.t_1ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t_1ReceivingQuantity"))
        writer.uint32(48).int32(message.t_1ReceivingQuantity);
      if (message.t_2ReceivingQuantity != null && Object.hasOwnProperty.call(message, "t_2ReceivingQuantity"))
        writer.uint32(56).int32(message.t_2ReceivingQuantity);
      if (message.rightReceivingQuantity != null && Object.hasOwnProperty.call(message, "rightReceivingQuantity"))
        writer.uint32(64).int32(message.rightReceivingQuantity);
      if (message.dividendReceivingQuantity != null && Object.hasOwnProperty.call(message, "dividendReceivingQuantity"))
        writer.uint32(72).int32(message.dividendReceivingQuantity);
      if (message.dividendQuantity != null && Object.hasOwnProperty.call(message, "dividendQuantity"))
        writer.uint32(80).int32(message.dividendQuantity);
      if (message.costPrice != null && Object.hasOwnProperty.call(message, "costPrice"))
        writer.uint32(89).double(message.costPrice);
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(98).string(message.dealId);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(106).string(message.description);
      if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
        writer.uint32(114).string(message.maker);
      return writer;
    };
    DealWithdrawalReq.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealWithdrawalReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealWithdrawalReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.referenceId = reader.string();
            break;
          case 4:
            message.tradeQuantity = reader.int32();
            break;
          case 5:
            message.t_0ReceivingQuantity = reader.int32();
            break;
          case 6:
            message.t_1ReceivingQuantity = reader.int32();
            break;
          case 7:
            message.t_2ReceivingQuantity = reader.int32();
            break;
          case 8:
            message.rightReceivingQuantity = reader.int32();
            break;
          case 9:
            message.dividendReceivingQuantity = reader.int32();
            break;
          case 10:
            message.dividendQuantity = reader.int32();
            break;
          case 11:
            message.costPrice = reader.double();
            break;
          case 12:
            message.dealId = reader.string();
            break;
          case 13:
            message.description = reader.string();
            break;
          case 14:
            message.maker = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealWithdrawalReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealWithdrawalReq.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
        if (!$util.isString(message.referenceId))
          return "referenceId: string expected";
      }
      if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity")) {
        if (!$util.isInteger(message.tradeQuantity))
          return "tradeQuantity: integer expected";
      }
      if (message.t_0ReceivingQuantity != null && message.hasOwnProperty("t_0ReceivingQuantity")) {
        if (!$util.isInteger(message.t_0ReceivingQuantity))
          return "t_0ReceivingQuantity: integer expected";
      }
      if (message.t_1ReceivingQuantity != null && message.hasOwnProperty("t_1ReceivingQuantity")) {
        if (!$util.isInteger(message.t_1ReceivingQuantity))
          return "t_1ReceivingQuantity: integer expected";
      }
      if (message.t_2ReceivingQuantity != null && message.hasOwnProperty("t_2ReceivingQuantity")) {
        if (!$util.isInteger(message.t_2ReceivingQuantity))
          return "t_2ReceivingQuantity: integer expected";
      }
      if (message.rightReceivingQuantity != null && message.hasOwnProperty("rightReceivingQuantity")) {
        if (!$util.isInteger(message.rightReceivingQuantity))
          return "rightReceivingQuantity: integer expected";
      }
      if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity")) {
        if (!$util.isInteger(message.dividendReceivingQuantity))
          return "dividendReceivingQuantity: integer expected";
      }
      if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity")) {
        if (!$util.isInteger(message.dividendQuantity))
          return "dividendQuantity: integer expected";
      }
      if (message.costPrice != null && message.hasOwnProperty("costPrice")) {
        if (typeof message.costPrice !== "number")
          return "costPrice: number expected";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isString(message.dealId))
          return "dealId: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.maker != null && message.hasOwnProperty("maker")) {
        if (!$util.isString(message.maker))
          return "maker: string expected";
      }
      return null;
    };
    DealWithdrawalReq.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealWithdrawalReq)
        return object;
      let message = new $root.dnse.DealWithdrawalReq();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.referenceId != null)
        message.referenceId = String(object.referenceId);
      if (object.tradeQuantity != null)
        message.tradeQuantity = object.tradeQuantity | 0;
      if (object.t_0ReceivingQuantity != null)
        message.t_0ReceivingQuantity = object.t_0ReceivingQuantity | 0;
      if (object.t_1ReceivingQuantity != null)
        message.t_1ReceivingQuantity = object.t_1ReceivingQuantity | 0;
      if (object.t_2ReceivingQuantity != null)
        message.t_2ReceivingQuantity = object.t_2ReceivingQuantity | 0;
      if (object.rightReceivingQuantity != null)
        message.rightReceivingQuantity = object.rightReceivingQuantity | 0;
      if (object.dividendReceivingQuantity != null)
        message.dividendReceivingQuantity = object.dividendReceivingQuantity | 0;
      if (object.dividendQuantity != null)
        message.dividendQuantity = object.dividendQuantity | 0;
      if (object.costPrice != null)
        message.costPrice = Number(object.costPrice);
      if (object.dealId != null)
        message.dealId = String(object.dealId);
      if (object.description != null)
        message.description = String(object.description);
      if (object.maker != null)
        message.maker = String(object.maker);
      return message;
    };
    DealWithdrawalReq.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.symbol = "";
        object.referenceId = "";
        object.tradeQuantity = 0;
        object.t_0ReceivingQuantity = 0;
        object.t_1ReceivingQuantity = 0;
        object.t_2ReceivingQuantity = 0;
        object.rightReceivingQuantity = 0;
        object.dividendReceivingQuantity = 0;
        object.dividendQuantity = 0;
        object.costPrice = 0;
        object.dealId = "";
        object.description = "";
        object.maker = "";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.referenceId != null && message.hasOwnProperty("referenceId"))
        object.referenceId = message.referenceId;
      if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity"))
        object.tradeQuantity = message.tradeQuantity;
      if (message.t_0ReceivingQuantity != null && message.hasOwnProperty("t_0ReceivingQuantity"))
        object.t_0ReceivingQuantity = message.t_0ReceivingQuantity;
      if (message.t_1ReceivingQuantity != null && message.hasOwnProperty("t_1ReceivingQuantity"))
        object.t_1ReceivingQuantity = message.t_1ReceivingQuantity;
      if (message.t_2ReceivingQuantity != null && message.hasOwnProperty("t_2ReceivingQuantity"))
        object.t_2ReceivingQuantity = message.t_2ReceivingQuantity;
      if (message.rightReceivingQuantity != null && message.hasOwnProperty("rightReceivingQuantity"))
        object.rightReceivingQuantity = message.rightReceivingQuantity;
      if (message.dividendReceivingQuantity != null && message.hasOwnProperty("dividendReceivingQuantity"))
        object.dividendReceivingQuantity = message.dividendReceivingQuantity;
      if (message.dividendQuantity != null && message.hasOwnProperty("dividendQuantity"))
        object.dividendQuantity = message.dividendQuantity;
      if (message.costPrice != null && message.hasOwnProperty("costPrice"))
        object.costPrice = options.json && !isFinite(message.costPrice) ? String(message.costPrice) : message.costPrice;
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        object.dealId = message.dealId;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.maker != null && message.hasOwnProperty("maker"))
        object.maker = message.maker;
      return object;
    };
    DealWithdrawalReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealWithdrawalReq;
  }();
  dnse2.LoanPackage = function() {
    function LoanPackage(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanPackage.prototype.id = 0;
    LoanPackage.prototype.loanType = "";
    LoanPackage.prototype.source = "";
    LoanPackage.prototype.initialRate = 0;
    LoanPackage.prototype.maintenanceRate = 0;
    LoanPackage.prototype.liquidRate = 0;
    LoanPackage.prototype.preferentialPeriod = 0;
    LoanPackage.prototype.preferentialInterestRate = 0;
    LoanPackage.prototype.interestRate = 0;
    LoanPackage.prototype.term = 0;
    LoanPackage.prototype.name = "";
    LoanPackage.prototype.allowExtendLoanTerm = false;
    LoanPackage.create = function create(properties) {
      return new LoanPackage(properties);
    };
    LoanPackage.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
        writer.uint32(18).string(message.loanType);
      if (message.source != null && Object.hasOwnProperty.call(message, "source"))
        writer.uint32(26).string(message.source);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(33).double(message.initialRate);
      if (message.maintenanceRate != null && Object.hasOwnProperty.call(message, "maintenanceRate"))
        writer.uint32(41).double(message.maintenanceRate);
      if (message.liquidRate != null && Object.hasOwnProperty.call(message, "liquidRate"))
        writer.uint32(49).double(message.liquidRate);
      if (message.preferentialPeriod != null && Object.hasOwnProperty.call(message, "preferentialPeriod"))
        writer.uint32(56).int32(message.preferentialPeriod);
      if (message.preferentialInterestRate != null && Object.hasOwnProperty.call(message, "preferentialInterestRate"))
        writer.uint32(65).double(message.preferentialInterestRate);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(73).double(message.interestRate);
      if (message.term != null && Object.hasOwnProperty.call(message, "term"))
        writer.uint32(80).int32(message.term);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(90).string(message.name);
      if (message.allowExtendLoanTerm != null && Object.hasOwnProperty.call(message, "allowExtendLoanTerm"))
        writer.uint32(96).bool(message.allowExtendLoanTerm);
      return writer;
    };
    LoanPackage.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanPackage.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanPackage();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.loanType = reader.string();
            break;
          case 3:
            message.source = reader.string();
            break;
          case 4:
            message.initialRate = reader.double();
            break;
          case 5:
            message.maintenanceRate = reader.double();
            break;
          case 6:
            message.liquidRate = reader.double();
            break;
          case 7:
            message.preferentialPeriod = reader.int32();
            break;
          case 8:
            message.preferentialInterestRate = reader.double();
            break;
          case 9:
            message.interestRate = reader.double();
            break;
          case 10:
            message.term = reader.int32();
            break;
          case 11:
            message.name = reader.string();
            break;
          case 12:
            message.allowExtendLoanTerm = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanPackage.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanPackage.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.loanType != null && message.hasOwnProperty("loanType")) {
        if (!$util.isString(message.loanType))
          return "loanType: string expected";
      }
      if (message.source != null && message.hasOwnProperty("source")) {
        if (!$util.isString(message.source))
          return "source: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate")) {
        if (typeof message.maintenanceRate !== "number")
          return "maintenanceRate: number expected";
      }
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate")) {
        if (typeof message.liquidRate !== "number")
          return "liquidRate: number expected";
      }
      if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod")) {
        if (!$util.isInteger(message.preferentialPeriod))
          return "preferentialPeriod: integer expected";
      }
      if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate")) {
        if (typeof message.preferentialInterestRate !== "number")
          return "preferentialInterestRate: number expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.term != null && message.hasOwnProperty("term")) {
        if (!$util.isInteger(message.term))
          return "term: integer expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm")) {
        if (typeof message.allowExtendLoanTerm !== "boolean")
          return "allowExtendLoanTerm: boolean expected";
      }
      return null;
    };
    LoanPackage.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanPackage)
        return object;
      let message = new $root.dnse.LoanPackage();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.loanType != null)
        message.loanType = String(object.loanType);
      if (object.source != null)
        message.source = String(object.source);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.maintenanceRate != null)
        message.maintenanceRate = Number(object.maintenanceRate);
      if (object.liquidRate != null)
        message.liquidRate = Number(object.liquidRate);
      if (object.preferentialPeriod != null)
        message.preferentialPeriod = object.preferentialPeriod | 0;
      if (object.preferentialInterestRate != null)
        message.preferentialInterestRate = Number(object.preferentialInterestRate);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.term != null)
        message.term = object.term | 0;
      if (object.name != null)
        message.name = String(object.name);
      if (object.allowExtendLoanTerm != null)
        message.allowExtendLoanTerm = Boolean(object.allowExtendLoanTerm);
      return message;
    };
    LoanPackage.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.loanType = "";
        object.source = "";
        object.initialRate = 0;
        object.maintenanceRate = 0;
        object.liquidRate = 0;
        object.preferentialPeriod = 0;
        object.preferentialInterestRate = 0;
        object.interestRate = 0;
        object.term = 0;
        object.name = "";
        object.allowExtendLoanTerm = false;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.loanType != null && message.hasOwnProperty("loanType"))
        object.loanType = message.loanType;
      if (message.source != null && message.hasOwnProperty("source"))
        object.source = message.source;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.maintenanceRate != null && message.hasOwnProperty("maintenanceRate"))
        object.maintenanceRate = options.json && !isFinite(message.maintenanceRate) ? String(message.maintenanceRate) : message.maintenanceRate;
      if (message.liquidRate != null && message.hasOwnProperty("liquidRate"))
        object.liquidRate = options.json && !isFinite(message.liquidRate) ? String(message.liquidRate) : message.liquidRate;
      if (message.preferentialPeriod != null && message.hasOwnProperty("preferentialPeriod"))
        object.preferentialPeriod = message.preferentialPeriod;
      if (message.preferentialInterestRate != null && message.hasOwnProperty("preferentialInterestRate"))
        object.preferentialInterestRate = options.json && !isFinite(message.preferentialInterestRate) ? String(message.preferentialInterestRate) : message.preferentialInterestRate;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.term != null && message.hasOwnProperty("term"))
        object.term = message.term;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm"))
        object.allowExtendLoanTerm = message.allowExtendLoanTerm;
      return object;
    };
    LoanPackage.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanPackage;
  }();
  dnse2.LoanWarningEvent = function() {
    function LoanWarningEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanWarningEvent.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    LoanWarningEvent.prototype.accountNo = "";
    LoanWarningEvent.prototype.type = "";
    LoanWarningEvent.prototype.referenceId = "";
    LoanWarningEvent.prototype.loanPackageId = 0;
    LoanWarningEvent.prototype.loanPackage = null;
    LoanWarningEvent.prototype.description = "";
    LoanWarningEvent.prototype.tradingDate = "";
    LoanWarningEvent.prototype.status = "";
    LoanWarningEvent.prototype.disbursementDate = null;
    LoanWarningEvent.prototype.dueDate = null;
    LoanWarningEvent.prototype.originalPrincipal = 0;
    LoanWarningEvent.prototype.paidPrincipal = 0;
    LoanWarningEvent.prototype.paidInterest = 0;
    LoanWarningEvent.prototype.unduePrincipal = 0;
    LoanWarningEvent.prototype.undueInterest = 0;
    LoanWarningEvent.prototype.duePrincipal = 0;
    LoanWarningEvent.prototype.dueInterest = 0;
    LoanWarningEvent.prototype.overduePrincipal = 0;
    LoanWarningEvent.prototype.overdueInterest = 0;
    LoanWarningEvent.prototype.toCollectPrincipal = 0;
    LoanWarningEvent.prototype.toCollectInterest = 0;
    LoanWarningEvent.prototype.interestOnOverdueLoan = 0;
    LoanWarningEvent.prototype.metadata = "";
    LoanWarningEvent.prototype.createdDate = null;
    LoanWarningEvent.prototype.updatedDate = null;
    LoanWarningEvent.prototype.t0PreCalInterestOnT2 = 0;
    LoanWarningEvent.prototype.t1PreCalInterestOnT2 = 0;
    LoanWarningEvent.prototype.investorId = "";
    LoanWarningEvent.prototype.custodyCode = "";
    LoanWarningEvent.prototype.fullName = "";
    LoanWarningEvent.prototype.accountTypeName = "";
    LoanWarningEvent.prototype.isOverDueDate = false;
    LoanWarningEvent.prototype.overdueThresholdDate = null;
    LoanWarningEvent.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    LoanWarningEvent.prototype.allowExtendLoanTerm = false;
    LoanWarningEvent.prototype.isWarningForceSell = false;
    LoanWarningEvent.create = function create(properties) {
      return new LoanWarningEvent(properties);
    };
    LoanWarningEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(26).string(message.type);
      if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
        writer.uint32(34).string(message.referenceId);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.loanPackage != null && Object.hasOwnProperty.call(message, "loanPackage"))
        $root.dnse.LoanPackage.encode(message.loanPackage, writer.uint32(50).fork()).ldelim();
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(58).string(message.description);
      if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
        writer.uint32(66).string(message.tradingDate);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(74).string(message.status);
      if (message.disbursementDate != null && Object.hasOwnProperty.call(message, "disbursementDate"))
        $root.google.protobuf.Timestamp.encode(message.disbursementDate, writer.uint32(82).fork()).ldelim();
      if (message.dueDate != null && Object.hasOwnProperty.call(message, "dueDate"))
        $root.google.protobuf.Timestamp.encode(message.dueDate, writer.uint32(90).fork()).ldelim();
      if (message.originalPrincipal != null && Object.hasOwnProperty.call(message, "originalPrincipal"))
        writer.uint32(97).double(message.originalPrincipal);
      if (message.paidPrincipal != null && Object.hasOwnProperty.call(message, "paidPrincipal"))
        writer.uint32(105).double(message.paidPrincipal);
      if (message.paidInterest != null && Object.hasOwnProperty.call(message, "paidInterest"))
        writer.uint32(113).double(message.paidInterest);
      if (message.unduePrincipal != null && Object.hasOwnProperty.call(message, "unduePrincipal"))
        writer.uint32(121).double(message.unduePrincipal);
      if (message.undueInterest != null && Object.hasOwnProperty.call(message, "undueInterest"))
        writer.uint32(129).double(message.undueInterest);
      if (message.duePrincipal != null && Object.hasOwnProperty.call(message, "duePrincipal"))
        writer.uint32(137).double(message.duePrincipal);
      if (message.dueInterest != null && Object.hasOwnProperty.call(message, "dueInterest"))
        writer.uint32(145).double(message.dueInterest);
      if (message.overduePrincipal != null && Object.hasOwnProperty.call(message, "overduePrincipal"))
        writer.uint32(153).double(message.overduePrincipal);
      if (message.overdueInterest != null && Object.hasOwnProperty.call(message, "overdueInterest"))
        writer.uint32(161).double(message.overdueInterest);
      if (message.toCollectPrincipal != null && Object.hasOwnProperty.call(message, "toCollectPrincipal"))
        writer.uint32(169).double(message.toCollectPrincipal);
      if (message.toCollectInterest != null && Object.hasOwnProperty.call(message, "toCollectInterest"))
        writer.uint32(177).double(message.toCollectInterest);
      if (message.interestOnOverdueLoan != null && Object.hasOwnProperty.call(message, "interestOnOverdueLoan"))
        writer.uint32(185).double(message.interestOnOverdueLoan);
      if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
        writer.uint32(194).string(message.metadata);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(202).fork()).ldelim();
      if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
        $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(210).fork()).ldelim();
      if (message.t0PreCalInterestOnT2 != null && Object.hasOwnProperty.call(message, "t0PreCalInterestOnT2"))
        writer.uint32(217).double(message.t0PreCalInterestOnT2);
      if (message.t1PreCalInterestOnT2 != null && Object.hasOwnProperty.call(message, "t1PreCalInterestOnT2"))
        writer.uint32(225).double(message.t1PreCalInterestOnT2);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(234).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(242).string(message.custodyCode);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(250).string(message.fullName);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(258).string(message.accountTypeName);
      if (message.isOverDueDate != null && Object.hasOwnProperty.call(message, "isOverDueDate"))
        writer.uint32(264).bool(message.isOverDueDate);
      if (message.overdueThresholdDate != null && Object.hasOwnProperty.call(message, "overdueThresholdDate"))
        $root.google.protobuf.Timestamp.encode(message.overdueThresholdDate, writer.uint32(274).fork()).ldelim();
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(280).int64(message.quantity);
      if (message.allowExtendLoanTerm != null && Object.hasOwnProperty.call(message, "allowExtendLoanTerm"))
        writer.uint32(288).bool(message.allowExtendLoanTerm);
      if (message.isWarningForceSell != null && Object.hasOwnProperty.call(message, "isWarningForceSell"))
        writer.uint32(296).bool(message.isWarningForceSell);
      return writer;
    };
    LoanWarningEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanWarningEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanWarningEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.type = reader.string();
            break;
          case 4:
            message.referenceId = reader.string();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.loanPackage = $root.dnse.LoanPackage.decode(reader, reader.uint32());
            break;
          case 7:
            message.description = reader.string();
            break;
          case 8:
            message.tradingDate = reader.string();
            break;
          case 9:
            message.status = reader.string();
            break;
          case 10:
            message.disbursementDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.dueDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.originalPrincipal = reader.double();
            break;
          case 13:
            message.paidPrincipal = reader.double();
            break;
          case 14:
            message.paidInterest = reader.double();
            break;
          case 15:
            message.unduePrincipal = reader.double();
            break;
          case 16:
            message.undueInterest = reader.double();
            break;
          case 17:
            message.duePrincipal = reader.double();
            break;
          case 18:
            message.dueInterest = reader.double();
            break;
          case 19:
            message.overduePrincipal = reader.double();
            break;
          case 20:
            message.overdueInterest = reader.double();
            break;
          case 21:
            message.toCollectPrincipal = reader.double();
            break;
          case 22:
            message.toCollectInterest = reader.double();
            break;
          case 23:
            message.interestOnOverdueLoan = reader.double();
            break;
          case 24:
            message.metadata = reader.string();
            break;
          case 25:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 26:
            message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 27:
            message.t0PreCalInterestOnT2 = reader.double();
            break;
          case 28:
            message.t1PreCalInterestOnT2 = reader.double();
            break;
          case 29:
            message.investorId = reader.string();
            break;
          case 30:
            message.custodyCode = reader.string();
            break;
          case 31:
            message.fullName = reader.string();
            break;
          case 32:
            message.accountTypeName = reader.string();
            break;
          case 33:
            message.isOverDueDate = reader.bool();
            break;
          case 34:
            message.overdueThresholdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 35:
            message.quantity = reader.int64();
            break;
          case 36:
            message.allowExtendLoanTerm = reader.bool();
            break;
          case 37:
            message.isWarningForceSell = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanWarningEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanWarningEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
        if (!$util.isString(message.referenceId))
          return "referenceId: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.loanPackage != null && message.hasOwnProperty("loanPackage")) {
        let error = $root.dnse.LoanPackage.verify(message.loanPackage);
        if (error)
          return "loanPackage." + error;
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
        if (!$util.isString(message.tradingDate))
          return "tradingDate: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.disbursementDate != null && message.hasOwnProperty("disbursementDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.disbursementDate);
        if (error)
          return "disbursementDate." + error;
      }
      if (message.dueDate != null && message.hasOwnProperty("dueDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.dueDate);
        if (error)
          return "dueDate." + error;
      }
      if (message.originalPrincipal != null && message.hasOwnProperty("originalPrincipal")) {
        if (typeof message.originalPrincipal !== "number")
          return "originalPrincipal: number expected";
      }
      if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal")) {
        if (typeof message.paidPrincipal !== "number")
          return "paidPrincipal: number expected";
      }
      if (message.paidInterest != null && message.hasOwnProperty("paidInterest")) {
        if (typeof message.paidInterest !== "number")
          return "paidInterest: number expected";
      }
      if (message.unduePrincipal != null && message.hasOwnProperty("unduePrincipal")) {
        if (typeof message.unduePrincipal !== "number")
          return "unduePrincipal: number expected";
      }
      if (message.undueInterest != null && message.hasOwnProperty("undueInterest")) {
        if (typeof message.undueInterest !== "number")
          return "undueInterest: number expected";
      }
      if (message.duePrincipal != null && message.hasOwnProperty("duePrincipal")) {
        if (typeof message.duePrincipal !== "number")
          return "duePrincipal: number expected";
      }
      if (message.dueInterest != null && message.hasOwnProperty("dueInterest")) {
        if (typeof message.dueInterest !== "number")
          return "dueInterest: number expected";
      }
      if (message.overduePrincipal != null && message.hasOwnProperty("overduePrincipal")) {
        if (typeof message.overduePrincipal !== "number")
          return "overduePrincipal: number expected";
      }
      if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest")) {
        if (typeof message.overdueInterest !== "number")
          return "overdueInterest: number expected";
      }
      if (message.toCollectPrincipal != null && message.hasOwnProperty("toCollectPrincipal")) {
        if (typeof message.toCollectPrincipal !== "number")
          return "toCollectPrincipal: number expected";
      }
      if (message.toCollectInterest != null && message.hasOwnProperty("toCollectInterest")) {
        if (typeof message.toCollectInterest !== "number")
          return "toCollectInterest: number expected";
      }
      if (message.interestOnOverdueLoan != null && message.hasOwnProperty("interestOnOverdueLoan")) {
        if (typeof message.interestOnOverdueLoan !== "number")
          return "interestOnOverdueLoan: number expected";
      }
      if (message.metadata != null && message.hasOwnProperty("metadata")) {
        if (!$util.isString(message.metadata))
          return "metadata: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
        if (error)
          return "updatedDate." + error;
      }
      if (message.t0PreCalInterestOnT2 != null && message.hasOwnProperty("t0PreCalInterestOnT2")) {
        if (typeof message.t0PreCalInterestOnT2 !== "number")
          return "t0PreCalInterestOnT2: number expected";
      }
      if (message.t1PreCalInterestOnT2 != null && message.hasOwnProperty("t1PreCalInterestOnT2")) {
        if (typeof message.t1PreCalInterestOnT2 !== "number")
          return "t1PreCalInterestOnT2: number expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.isOverDueDate != null && message.hasOwnProperty("isOverDueDate")) {
        if (typeof message.isOverDueDate !== "boolean")
          return "isOverDueDate: boolean expected";
      }
      if (message.overdueThresholdDate != null && message.hasOwnProperty("overdueThresholdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.overdueThresholdDate);
        if (error)
          return "overdueThresholdDate." + error;
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm")) {
        if (typeof message.allowExtendLoanTerm !== "boolean")
          return "allowExtendLoanTerm: boolean expected";
      }
      if (message.isWarningForceSell != null && message.hasOwnProperty("isWarningForceSell")) {
        if (typeof message.isWarningForceSell !== "boolean")
          return "isWarningForceSell: boolean expected";
      }
      return null;
    };
    LoanWarningEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanWarningEvent)
        return object;
      let message = new $root.dnse.LoanWarningEvent();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.type != null)
        message.type = String(object.type);
      if (object.referenceId != null)
        message.referenceId = String(object.referenceId);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.loanPackage != null) {
        if (typeof object.loanPackage !== "object")
          throw TypeError(".dnse.LoanWarningEvent.loanPackage: object expected");
        message.loanPackage = $root.dnse.LoanPackage.fromObject(object.loanPackage);
      }
      if (object.description != null)
        message.description = String(object.description);
      if (object.tradingDate != null)
        message.tradingDate = String(object.tradingDate);
      if (object.status != null)
        message.status = String(object.status);
      if (object.disbursementDate != null) {
        if (typeof object.disbursementDate !== "object")
          throw TypeError(".dnse.LoanWarningEvent.disbursementDate: object expected");
        message.disbursementDate = $root.google.protobuf.Timestamp.fromObject(object.disbursementDate);
      }
      if (object.dueDate != null) {
        if (typeof object.dueDate !== "object")
          throw TypeError(".dnse.LoanWarningEvent.dueDate: object expected");
        message.dueDate = $root.google.protobuf.Timestamp.fromObject(object.dueDate);
      }
      if (object.originalPrincipal != null)
        message.originalPrincipal = Number(object.originalPrincipal);
      if (object.paidPrincipal != null)
        message.paidPrincipal = Number(object.paidPrincipal);
      if (object.paidInterest != null)
        message.paidInterest = Number(object.paidInterest);
      if (object.unduePrincipal != null)
        message.unduePrincipal = Number(object.unduePrincipal);
      if (object.undueInterest != null)
        message.undueInterest = Number(object.undueInterest);
      if (object.duePrincipal != null)
        message.duePrincipal = Number(object.duePrincipal);
      if (object.dueInterest != null)
        message.dueInterest = Number(object.dueInterest);
      if (object.overduePrincipal != null)
        message.overduePrincipal = Number(object.overduePrincipal);
      if (object.overdueInterest != null)
        message.overdueInterest = Number(object.overdueInterest);
      if (object.toCollectPrincipal != null)
        message.toCollectPrincipal = Number(object.toCollectPrincipal);
      if (object.toCollectInterest != null)
        message.toCollectInterest = Number(object.toCollectInterest);
      if (object.interestOnOverdueLoan != null)
        message.interestOnOverdueLoan = Number(object.interestOnOverdueLoan);
      if (object.metadata != null)
        message.metadata = String(object.metadata);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.LoanWarningEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.updatedDate != null) {
        if (typeof object.updatedDate !== "object")
          throw TypeError(".dnse.LoanWarningEvent.updatedDate: object expected");
        message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
      }
      if (object.t0PreCalInterestOnT2 != null)
        message.t0PreCalInterestOnT2 = Number(object.t0PreCalInterestOnT2);
      if (object.t1PreCalInterestOnT2 != null)
        message.t1PreCalInterestOnT2 = Number(object.t1PreCalInterestOnT2);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.isOverDueDate != null)
        message.isOverDueDate = Boolean(object.isOverDueDate);
      if (object.overdueThresholdDate != null) {
        if (typeof object.overdueThresholdDate !== "object")
          throw TypeError(".dnse.LoanWarningEvent.overdueThresholdDate: object expected");
        message.overdueThresholdDate = $root.google.protobuf.Timestamp.fromObject(object.overdueThresholdDate);
      }
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.allowExtendLoanTerm != null)
        message.allowExtendLoanTerm = Boolean(object.allowExtendLoanTerm);
      if (object.isWarningForceSell != null)
        message.isWarningForceSell = Boolean(object.isWarningForceSell);
      return message;
    };
    LoanWarningEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.accountNo = "";
        object.type = "";
        object.referenceId = "";
        object.loanPackageId = 0;
        object.loanPackage = null;
        object.description = "";
        object.tradingDate = "";
        object.status = "";
        object.disbursementDate = null;
        object.dueDate = null;
        object.originalPrincipal = 0;
        object.paidPrincipal = 0;
        object.paidInterest = 0;
        object.unduePrincipal = 0;
        object.undueInterest = 0;
        object.duePrincipal = 0;
        object.dueInterest = 0;
        object.overduePrincipal = 0;
        object.overdueInterest = 0;
        object.toCollectPrincipal = 0;
        object.toCollectInterest = 0;
        object.interestOnOverdueLoan = 0;
        object.metadata = "";
        object.createdDate = null;
        object.updatedDate = null;
        object.t0PreCalInterestOnT2 = 0;
        object.t1PreCalInterestOnT2 = 0;
        object.investorId = "";
        object.custodyCode = "";
        object.fullName = "";
        object.accountTypeName = "";
        object.isOverDueDate = false;
        object.overdueThresholdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        object.allowExtendLoanTerm = false;
        object.isWarningForceSell = false;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.referenceId != null && message.hasOwnProperty("referenceId"))
        object.referenceId = message.referenceId;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.loanPackage != null && message.hasOwnProperty("loanPackage"))
        object.loanPackage = $root.dnse.LoanPackage.toObject(message.loanPackage, options);
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
        object.tradingDate = message.tradingDate;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.disbursementDate != null && message.hasOwnProperty("disbursementDate"))
        object.disbursementDate = $root.google.protobuf.Timestamp.toObject(message.disbursementDate, options);
      if (message.dueDate != null && message.hasOwnProperty("dueDate"))
        object.dueDate = $root.google.protobuf.Timestamp.toObject(message.dueDate, options);
      if (message.originalPrincipal != null && message.hasOwnProperty("originalPrincipal"))
        object.originalPrincipal = options.json && !isFinite(message.originalPrincipal) ? String(message.originalPrincipal) : message.originalPrincipal;
      if (message.paidPrincipal != null && message.hasOwnProperty("paidPrincipal"))
        object.paidPrincipal = options.json && !isFinite(message.paidPrincipal) ? String(message.paidPrincipal) : message.paidPrincipal;
      if (message.paidInterest != null && message.hasOwnProperty("paidInterest"))
        object.paidInterest = options.json && !isFinite(message.paidInterest) ? String(message.paidInterest) : message.paidInterest;
      if (message.unduePrincipal != null && message.hasOwnProperty("unduePrincipal"))
        object.unduePrincipal = options.json && !isFinite(message.unduePrincipal) ? String(message.unduePrincipal) : message.unduePrincipal;
      if (message.undueInterest != null && message.hasOwnProperty("undueInterest"))
        object.undueInterest = options.json && !isFinite(message.undueInterest) ? String(message.undueInterest) : message.undueInterest;
      if (message.duePrincipal != null && message.hasOwnProperty("duePrincipal"))
        object.duePrincipal = options.json && !isFinite(message.duePrincipal) ? String(message.duePrincipal) : message.duePrincipal;
      if (message.dueInterest != null && message.hasOwnProperty("dueInterest"))
        object.dueInterest = options.json && !isFinite(message.dueInterest) ? String(message.dueInterest) : message.dueInterest;
      if (message.overduePrincipal != null && message.hasOwnProperty("overduePrincipal"))
        object.overduePrincipal = options.json && !isFinite(message.overduePrincipal) ? String(message.overduePrincipal) : message.overduePrincipal;
      if (message.overdueInterest != null && message.hasOwnProperty("overdueInterest"))
        object.overdueInterest = options.json && !isFinite(message.overdueInterest) ? String(message.overdueInterest) : message.overdueInterest;
      if (message.toCollectPrincipal != null && message.hasOwnProperty("toCollectPrincipal"))
        object.toCollectPrincipal = options.json && !isFinite(message.toCollectPrincipal) ? String(message.toCollectPrincipal) : message.toCollectPrincipal;
      if (message.toCollectInterest != null && message.hasOwnProperty("toCollectInterest"))
        object.toCollectInterest = options.json && !isFinite(message.toCollectInterest) ? String(message.toCollectInterest) : message.toCollectInterest;
      if (message.interestOnOverdueLoan != null && message.hasOwnProperty("interestOnOverdueLoan"))
        object.interestOnOverdueLoan = options.json && !isFinite(message.interestOnOverdueLoan) ? String(message.interestOnOverdueLoan) : message.interestOnOverdueLoan;
      if (message.metadata != null && message.hasOwnProperty("metadata"))
        object.metadata = message.metadata;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
        object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
      if (message.t0PreCalInterestOnT2 != null && message.hasOwnProperty("t0PreCalInterestOnT2"))
        object.t0PreCalInterestOnT2 = options.json && !isFinite(message.t0PreCalInterestOnT2) ? String(message.t0PreCalInterestOnT2) : message.t0PreCalInterestOnT2;
      if (message.t1PreCalInterestOnT2 != null && message.hasOwnProperty("t1PreCalInterestOnT2"))
        object.t1PreCalInterestOnT2 = options.json && !isFinite(message.t1PreCalInterestOnT2) ? String(message.t1PreCalInterestOnT2) : message.t1PreCalInterestOnT2;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.isOverDueDate != null && message.hasOwnProperty("isOverDueDate"))
        object.isOverDueDate = message.isOverDueDate;
      if (message.overdueThresholdDate != null && message.hasOwnProperty("overdueThresholdDate"))
        object.overdueThresholdDate = $root.google.protobuf.Timestamp.toObject(message.overdueThresholdDate, options);
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.allowExtendLoanTerm != null && message.hasOwnProperty("allowExtendLoanTerm"))
        object.allowExtendLoanTerm = message.allowExtendLoanTerm;
      if (message.isWarningForceSell != null && message.hasOwnProperty("isWarningForceSell"))
        object.isWarningForceSell = message.isWarningForceSell;
      return object;
    };
    LoanWarningEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanWarningEvent;
  }();
  dnse2.DealMigrate = function() {
    function DealMigrate(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealMigrate.prototype.id = "";
    DealMigrate.prototype.custodyCode = "";
    DealMigrate.prototype.investorId = "";
    DealMigrate.prototype.status = "";
    DealMigrate.prototype.blockBuyOrder = false;
    DealMigrate.prototype.createdDate = null;
    DealMigrate.create = function create(properties) {
      return new DealMigrate(properties);
    };
    DealMigrate.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(34).string(message.status);
      if (message.blockBuyOrder != null && Object.hasOwnProperty.call(message, "blockBuyOrder"))
        writer.uint32(40).bool(message.blockBuyOrder);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    DealMigrate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealMigrate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealMigrate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.status = reader.string();
            break;
          case 5:
            message.blockBuyOrder = reader.bool();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealMigrate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealMigrate.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.blockBuyOrder != null && message.hasOwnProperty("blockBuyOrder")) {
        if (typeof message.blockBuyOrder !== "boolean")
          return "blockBuyOrder: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    DealMigrate.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealMigrate)
        return object;
      let message = new $root.dnse.DealMigrate();
      if (object.id != null)
        message.id = String(object.id);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.status != null)
        message.status = String(object.status);
      if (object.blockBuyOrder != null)
        message.blockBuyOrder = Boolean(object.blockBuyOrder);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DealMigrate.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    DealMigrate.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.custodyCode = "";
        object.investorId = "";
        object.status = "";
        object.blockBuyOrder = false;
        object.createdDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.blockBuyOrder != null && message.hasOwnProperty("blockBuyOrder"))
        object.blockBuyOrder = message.blockBuyOrder;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    DealMigrate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealMigrate;
  }();
  dnse2.SmartOTP = function() {
    function SmartOTP(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SmartOTP.prototype.id = 0;
    SmartOTP.prototype.issuer = "";
    SmartOTP.prototype.userId = "";
    SmartOTP.prototype.message = "";
    SmartOTP.prototype.status = "";
    SmartOTP.prototype.deviceId = "";
    SmartOTP.create = function create(properties) {
      return new SmartOTP(properties);
    };
    SmartOTP.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
        writer.uint32(18).string(message.issuer);
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(26).string(message.userId);
      if (message.message != null && Object.hasOwnProperty.call(message, "message"))
        writer.uint32(34).string(message.message);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(42).string(message.status);
      if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
        writer.uint32(50).string(message.deviceId);
      return writer;
    };
    SmartOTP.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SmartOTP.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SmartOTP();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.issuer = reader.string();
            break;
          case 3:
            message.userId = reader.string();
            break;
          case 4:
            message.message = reader.string();
            break;
          case 5:
            message.status = reader.string();
            break;
          case 6:
            message.deviceId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SmartOTP.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SmartOTP.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.issuer != null && message.hasOwnProperty("issuer")) {
        if (!$util.isString(message.issuer))
          return "issuer: string expected";
      }
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isString(message.userId))
          return "userId: string expected";
      }
      if (message.message != null && message.hasOwnProperty("message")) {
        if (!$util.isString(message.message))
          return "message: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.deviceId != null && message.hasOwnProperty("deviceId")) {
        if (!$util.isString(message.deviceId))
          return "deviceId: string expected";
      }
      return null;
    };
    SmartOTP.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SmartOTP)
        return object;
      let message = new $root.dnse.SmartOTP();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.issuer != null)
        message.issuer = String(object.issuer);
      if (object.userId != null)
        message.userId = String(object.userId);
      if (object.message != null)
        message.message = String(object.message);
      if (object.status != null)
        message.status = String(object.status);
      if (object.deviceId != null)
        message.deviceId = String(object.deviceId);
      return message;
    };
    SmartOTP.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.issuer = "";
        object.userId = "";
        object.message = "";
        object.status = "";
        object.deviceId = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.issuer != null && message.hasOwnProperty("issuer"))
        object.issuer = message.issuer;
      if (message.userId != null && message.hasOwnProperty("userId"))
        object.userId = message.userId;
      if (message.message != null && message.hasOwnProperty("message"))
        object.message = message.message;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.deviceId != null && message.hasOwnProperty("deviceId"))
        object.deviceId = message.deviceId;
      return object;
    };
    SmartOTP.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SmartOTP;
  }();
  dnse2.InvestorUpdate = function() {
    function InvestorUpdate(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InvestorUpdate.prototype.investorId = "";
    InvestorUpdate.prototype.source = 0;
    InvestorUpdate.prototype.smartOTP = null;
    let $oneOfFields;
    Object.defineProperty(InvestorUpdate.prototype, "data", {
      get: $util.oneOfGetter($oneOfFields = ["smartOTP"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    InvestorUpdate.create = function create(properties) {
      return new InvestorUpdate(properties);
    };
    InvestorUpdate.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.source != null && Object.hasOwnProperty.call(message, "source"))
        writer.uint32(16).int32(message.source);
      if (message.smartOTP != null && Object.hasOwnProperty.call(message, "smartOTP"))
        $root.dnse.SmartOTP.encode(message.smartOTP, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    InvestorUpdate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InvestorUpdate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.InvestorUpdate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.source = reader.int32();
            break;
          case 3:
            message.smartOTP = $root.dnse.SmartOTP.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InvestorUpdate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InvestorUpdate.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.source != null && message.hasOwnProperty("source"))
        switch (message.source) {
          default:
            return "source: enum value expected";
          case 0:
            break;
        }
      if (message.smartOTP != null && message.hasOwnProperty("smartOTP")) {
        {
          let error = $root.dnse.SmartOTP.verify(message.smartOTP);
          if (error)
            return "smartOTP." + error;
        }
      }
      return null;
    };
    InvestorUpdate.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.InvestorUpdate)
        return object;
      let message = new $root.dnse.InvestorUpdate();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      switch (object.source) {
        case "SMART_OTP":
        case 0:
          message.source = 0;
          break;
      }
      if (object.smartOTP != null) {
        if (typeof object.smartOTP !== "object")
          throw TypeError(".dnse.InvestorUpdate.smartOTP: object expected");
        message.smartOTP = $root.dnse.SmartOTP.fromObject(object.smartOTP);
      }
      return message;
    };
    InvestorUpdate.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.source = options.enums === String ? "SMART_OTP" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.source != null && message.hasOwnProperty("source"))
        object.source = options.enums === String ? $root.dnse.InvestorUpdate.Source[message.source] : message.source;
      if (message.smartOTP != null && message.hasOwnProperty("smartOTP")) {
        object.smartOTP = $root.dnse.SmartOTP.toObject(message.smartOTP, options);
        if (options.oneofs)
          object.data = "smartOTP";
      }
      return object;
    };
    InvestorUpdate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    InvestorUpdate.Source = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "SMART_OTP"] = 0;
      return values;
    }();
    return InvestorUpdate;
  }();
  dnse2.CoveredWarrantSettlementEvent = function() {
    function CoveredWarrantSettlementEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoveredWarrantSettlementEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CoveredWarrantSettlementEvent.prototype.investorId = "";
    CoveredWarrantSettlementEvent.prototype.accountNo = "";
    CoveredWarrantSettlementEvent.prototype.symbol = "";
    CoveredWarrantSettlementEvent.prototype.expirationDate = "";
    CoveredWarrantSettlementEvent.prototype.strikePrice = 0;
    CoveredWarrantSettlementEvent.prototype.ratio = "";
    CoveredWarrantSettlementEvent.prototype.settlementDate = "";
    CoveredWarrantSettlementEvent.prototype.settlementPrice = 0;
    CoveredWarrantSettlementEvent.prototype.amount = 0;
    CoveredWarrantSettlementEvent.prototype.sellingTax = 0;
    CoveredWarrantSettlementEvent.prototype.createdDate = null;
    CoveredWarrantSettlementEvent.create = function create(properties) {
      return new CoveredWarrantSettlementEvent(properties);
    };
    CoveredWarrantSettlementEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(8).int64(message.dealId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.expirationDate != null && Object.hasOwnProperty.call(message, "expirationDate"))
        writer.uint32(42).string(message.expirationDate);
      if (message.strikePrice != null && Object.hasOwnProperty.call(message, "strikePrice"))
        writer.uint32(49).double(message.strikePrice);
      if (message.ratio != null && Object.hasOwnProperty.call(message, "ratio"))
        writer.uint32(58).string(message.ratio);
      if (message.settlementDate != null && Object.hasOwnProperty.call(message, "settlementDate"))
        writer.uint32(66).string(message.settlementDate);
      if (message.settlementPrice != null && Object.hasOwnProperty.call(message, "settlementPrice"))
        writer.uint32(73).double(message.settlementPrice);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(81).double(message.amount);
      if (message.sellingTax != null && Object.hasOwnProperty.call(message, "sellingTax"))
        writer.uint32(89).double(message.sellingTax);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
      return writer;
    };
    CoveredWarrantSettlementEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoveredWarrantSettlementEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoveredWarrantSettlementEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealId = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.expirationDate = reader.string();
            break;
          case 6:
            message.strikePrice = reader.double();
            break;
          case 7:
            message.ratio = reader.string();
            break;
          case 8:
            message.settlementDate = reader.string();
            break;
          case 9:
            message.settlementPrice = reader.double();
            break;
          case 10:
            message.amount = reader.double();
            break;
          case 11:
            message.sellingTax = reader.double();
            break;
          case 12:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoveredWarrantSettlementEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoveredWarrantSettlementEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.expirationDate != null && message.hasOwnProperty("expirationDate")) {
        if (!$util.isString(message.expirationDate))
          return "expirationDate: string expected";
      }
      if (message.strikePrice != null && message.hasOwnProperty("strikePrice")) {
        if (typeof message.strikePrice !== "number")
          return "strikePrice: number expected";
      }
      if (message.ratio != null && message.hasOwnProperty("ratio")) {
        if (!$util.isString(message.ratio))
          return "ratio: string expected";
      }
      if (message.settlementDate != null && message.hasOwnProperty("settlementDate")) {
        if (!$util.isString(message.settlementDate))
          return "settlementDate: string expected";
      }
      if (message.settlementPrice != null && message.hasOwnProperty("settlementPrice")) {
        if (typeof message.settlementPrice !== "number")
          return "settlementPrice: number expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.sellingTax != null && message.hasOwnProperty("sellingTax")) {
        if (typeof message.sellingTax !== "number")
          return "sellingTax: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    CoveredWarrantSettlementEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoveredWarrantSettlementEvent)
        return object;
      let message = new $root.dnse.CoveredWarrantSettlementEvent();
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.expirationDate != null)
        message.expirationDate = String(object.expirationDate);
      if (object.strikePrice != null)
        message.strikePrice = Number(object.strikePrice);
      if (object.ratio != null)
        message.ratio = String(object.ratio);
      if (object.settlementDate != null)
        message.settlementDate = String(object.settlementDate);
      if (object.settlementPrice != null)
        message.settlementPrice = Number(object.settlementPrice);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.sellingTax != null)
        message.sellingTax = Number(object.sellingTax);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.CoveredWarrantSettlementEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    CoveredWarrantSettlementEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        object.symbol = "";
        object.expirationDate = "";
        object.strikePrice = 0;
        object.ratio = "";
        object.settlementDate = "";
        object.settlementPrice = 0;
        object.amount = 0;
        object.sellingTax = 0;
        object.createdDate = null;
      }
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.expirationDate != null && message.hasOwnProperty("expirationDate"))
        object.expirationDate = message.expirationDate;
      if (message.strikePrice != null && message.hasOwnProperty("strikePrice"))
        object.strikePrice = options.json && !isFinite(message.strikePrice) ? String(message.strikePrice) : message.strikePrice;
      if (message.ratio != null && message.hasOwnProperty("ratio"))
        object.ratio = message.ratio;
      if (message.settlementDate != null && message.hasOwnProperty("settlementDate"))
        object.settlementDate = message.settlementDate;
      if (message.settlementPrice != null && message.hasOwnProperty("settlementPrice"))
        object.settlementPrice = options.json && !isFinite(message.settlementPrice) ? String(message.settlementPrice) : message.settlementPrice;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.sellingTax != null && message.hasOwnProperty("sellingTax"))
        object.sellingTax = options.json && !isFinite(message.sellingTax) ? String(message.sellingTax) : message.sellingTax;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    CoveredWarrantSettlementEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CoveredWarrantSettlementEvent;
  }();
  dnse2.AvailableCashEvent = function() {
    function AvailableCashEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AvailableCashEvent.prototype.accountTypeName = "";
    AvailableCashEvent.prototype.symbol = "";
    AvailableCashEvent.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AvailableCashEvent.prototype.createdDate = null;
    AvailableCashEvent.prototype.investorId = "";
    AvailableCashEvent.prototype.accountNo = "";
    AvailableCashEvent.prototype.initialRate = 0;
    AvailableCashEvent.prototype.changeAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AvailableCashEvent.prototype.source = 0;
    AvailableCashEvent.prototype.loanPackageName = "";
    AvailableCashEvent.create = function create(properties) {
      return new AvailableCashEvent(properties);
    };
    AvailableCashEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(10).string(message.accountTypeName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(24).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(50).string(message.accountNo);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(57).double(message.initialRate);
      if (message.changeAmount != null && Object.hasOwnProperty.call(message, "changeAmount"))
        writer.uint32(64).int64(message.changeAmount);
      if (message.source != null && Object.hasOwnProperty.call(message, "source"))
        writer.uint32(72).int32(message.source);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(82).string(message.loanPackageName);
      return writer;
    };
    AvailableCashEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AvailableCashEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.AvailableCashEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountTypeName = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.availableCash = reader.int64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.accountNo = reader.string();
            break;
          case 7:
            message.initialRate = reader.double();
            break;
          case 8:
            message.changeAmount = reader.int64();
            break;
          case 9:
            message.source = reader.int32();
            break;
          case 10:
            message.loanPackageName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AvailableCashEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AvailableCashEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.changeAmount != null && message.hasOwnProperty("changeAmount")) {
        if (!$util.isInteger(message.changeAmount) && !(message.changeAmount && $util.isInteger(message.changeAmount.low) && $util.isInteger(message.changeAmount.high)))
          return "changeAmount: integer|Long expected";
      }
      if (message.source != null && message.hasOwnProperty("source"))
        switch (message.source) {
          default:
            return "source: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      return null;
    };
    AvailableCashEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.AvailableCashEvent)
        return object;
      let message = new $root.dnse.AvailableCashEvent();
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.AvailableCashEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.changeAmount != null) {
        if ($util.Long)
          (message.changeAmount = $util.Long.fromValue(object.changeAmount)).unsigned = false;
        else if (typeof object.changeAmount === "string")
          message.changeAmount = parseInt(object.changeAmount, 10);
        else if (typeof object.changeAmount === "number")
          message.changeAmount = object.changeAmount;
        else if (typeof object.changeAmount === "object")
          message.changeAmount = new $util.LongBits(object.changeAmount.low >>> 0, object.changeAmount.high >>> 0).toNumber();
      }
      switch (object.source) {
        case "PREPAY_LOAN":
        case 0:
          message.source = 0;
          break;
        case "EXTEND_LOAN":
        case 1:
          message.source = 1;
          break;
        case "AUTO_PREPAY_LOAN":
        case 2:
          message.source = 2;
          break;
      }
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      return message;
    };
    AvailableCashEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountTypeName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.investorId = "";
        object.accountNo = "";
        object.initialRate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.changeAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.changeAmount = options.longs === String ? "0" : 0;
        object.source = options.enums === String ? "PREPAY_LOAN" : 0;
        object.loanPackageName = "";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.changeAmount != null && message.hasOwnProperty("changeAmount"))
        if (typeof message.changeAmount === "number")
          object.changeAmount = options.longs === String ? String(message.changeAmount) : message.changeAmount;
        else
          object.changeAmount = options.longs === String ? $util.Long.prototype.toString.call(message.changeAmount) : options.longs === Number ? new $util.LongBits(message.changeAmount.low >>> 0, message.changeAmount.high >>> 0).toNumber() : message.changeAmount;
      if (message.source != null && message.hasOwnProperty("source"))
        object.source = options.enums === String ? $root.dnse.AvailableCashEvent.Source[message.source] : message.source;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      return object;
    };
    AvailableCashEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    AvailableCashEvent.Source = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "PREPAY_LOAN"] = 0;
      values[valuesById[1] = "EXTEND_LOAN"] = 1;
      values[valuesById[2] = "AUTO_PREPAY_LOAN"] = 2;
      return values;
    }();
    return AvailableCashEvent;
  }();
  dnse2.DealRiskAutoCallPaymentEvent = function() {
    function DealRiskAutoCallPaymentEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealRiskAutoCallPaymentEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealRiskAutoCallPaymentEvent.prototype.accountNo = "";
    DealRiskAutoCallPaymentEvent.prototype.symbol = "";
    DealRiskAutoCallPaymentEvent.prototype.initialRate = 0;
    DealRiskAutoCallPaymentEvent.prototype.loanPackageId = 0;
    DealRiskAutoCallPaymentEvent.prototype.paidAmount = 0;
    DealRiskAutoCallPaymentEvent.prototype.availableCash = 0;
    DealRiskAutoCallPaymentEvent.prototype.callAmount = 0;
    DealRiskAutoCallPaymentEvent.prototype.loanPackageName = "";
    DealRiskAutoCallPaymentEvent.prototype.custodyCode = "";
    DealRiskAutoCallPaymentEvent.prototype.fullName = "";
    DealRiskAutoCallPaymentEvent.prototype.createdAt = null;
    DealRiskAutoCallPaymentEvent.prototype.investorId = "";
    DealRiskAutoCallPaymentEvent.prototype.accountTypeName = "";
    DealRiskAutoCallPaymentEvent.create = function create(properties) {
      return new DealRiskAutoCallPaymentEvent(properties);
    };
    DealRiskAutoCallPaymentEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(8).int64(message.dealId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(33).double(message.initialRate);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.paidAmount != null && Object.hasOwnProperty.call(message, "paidAmount"))
        writer.uint32(49).double(message.paidAmount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(57).double(message.availableCash);
      if (message.callAmount != null && Object.hasOwnProperty.call(message, "callAmount"))
        writer.uint32(65).double(message.callAmount);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(74).string(message.loanPackageName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(82).string(message.custodyCode);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(90).string(message.fullName);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(98).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(106).string(message.investorId);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(114).string(message.accountTypeName);
      return writer;
    };
    DealRiskAutoCallPaymentEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealRiskAutoCallPaymentEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealRiskAutoCallPaymentEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealId = reader.int64();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.initialRate = reader.double();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.paidAmount = reader.double();
            break;
          case 7:
            message.availableCash = reader.double();
            break;
          case 8:
            message.callAmount = reader.double();
            break;
          case 9:
            message.loanPackageName = reader.string();
            break;
          case 10:
            message.custodyCode = reader.string();
            break;
          case 11:
            message.fullName = reader.string();
            break;
          case 12:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.investorId = reader.string();
            break;
          case 14:
            message.accountTypeName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealRiskAutoCallPaymentEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealRiskAutoCallPaymentEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.paidAmount != null && message.hasOwnProperty("paidAmount")) {
        if (typeof message.paidAmount !== "number")
          return "paidAmount: number expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (typeof message.availableCash !== "number")
          return "availableCash: number expected";
      }
      if (message.callAmount != null && message.hasOwnProperty("callAmount")) {
        if (typeof message.callAmount !== "number")
          return "callAmount: number expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      return null;
    };
    DealRiskAutoCallPaymentEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealRiskAutoCallPaymentEvent)
        return object;
      let message = new $root.dnse.DealRiskAutoCallPaymentEvent();
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.paidAmount != null)
        message.paidAmount = Number(object.paidAmount);
      if (object.availableCash != null)
        message.availableCash = Number(object.availableCash);
      if (object.callAmount != null)
        message.callAmount = Number(object.callAmount);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.DealRiskAutoCallPaymentEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      return message;
    };
    DealRiskAutoCallPaymentEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
        object.accountNo = "";
        object.symbol = "";
        object.initialRate = 0;
        object.loanPackageId = 0;
        object.paidAmount = 0;
        object.availableCash = 0;
        object.callAmount = 0;
        object.loanPackageName = "";
        object.custodyCode = "";
        object.fullName = "";
        object.createdAt = null;
        object.investorId = "";
        object.accountTypeName = "";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.paidAmount != null && message.hasOwnProperty("paidAmount"))
        object.paidAmount = options.json && !isFinite(message.paidAmount) ? String(message.paidAmount) : message.paidAmount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        object.availableCash = options.json && !isFinite(message.availableCash) ? String(message.availableCash) : message.availableCash;
      if (message.callAmount != null && message.hasOwnProperty("callAmount"))
        object.callAmount = options.json && !isFinite(message.callAmount) ? String(message.callAmount) : message.callAmount;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      return object;
    };
    DealRiskAutoCallPaymentEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealRiskAutoCallPaymentEvent;
  }();
  dnse2.FlexCustomerEvent = function() {
    function FlexCustomerEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FlexCustomerEvent.prototype.custodyCode = "";
    FlexCustomerEvent.prototype.customerId = "";
    FlexCustomerEvent.prototype.customerType = "";
    FlexCustomerEvent.prototype.nationality = "";
    FlexCustomerEvent.prototype.status = "";
    FlexCustomerEvent.prototype.isVSDActived = "";
    FlexCustomerEvent.prototype.vsdMsgStatus = "";
    FlexCustomerEvent.prototype.modifiedDate = null;
    FlexCustomerEvent.create = function create(properties) {
      return new FlexCustomerEvent(properties);
    };
    FlexCustomerEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
        writer.uint32(18).string(message.customerId);
      if (message.customerType != null && Object.hasOwnProperty.call(message, "customerType"))
        writer.uint32(26).string(message.customerType);
      if (message.nationality != null && Object.hasOwnProperty.call(message, "nationality"))
        writer.uint32(34).string(message.nationality);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(42).string(message.status);
      if (message.isVSDActived != null && Object.hasOwnProperty.call(message, "isVSDActived"))
        writer.uint32(50).string(message.isVSDActived);
      if (message.vsdMsgStatus != null && Object.hasOwnProperty.call(message, "vsdMsgStatus"))
        writer.uint32(58).string(message.vsdMsgStatus);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    FlexCustomerEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FlexCustomerEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FlexCustomerEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.customerId = reader.string();
            break;
          case 3:
            message.customerType = reader.string();
            break;
          case 4:
            message.nationality = reader.string();
            break;
          case 5:
            message.status = reader.string();
            break;
          case 6:
            message.isVSDActived = reader.string();
            break;
          case 7:
            message.vsdMsgStatus = reader.string();
            break;
          case 8:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FlexCustomerEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FlexCustomerEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.customerId != null && message.hasOwnProperty("customerId")) {
        if (!$util.isString(message.customerId))
          return "customerId: string expected";
      }
      if (message.customerType != null && message.hasOwnProperty("customerType")) {
        if (!$util.isString(message.customerType))
          return "customerType: string expected";
      }
      if (message.nationality != null && message.hasOwnProperty("nationality")) {
        if (!$util.isString(message.nationality))
          return "nationality: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.isVSDActived != null && message.hasOwnProperty("isVSDActived")) {
        if (!$util.isString(message.isVSDActived))
          return "isVSDActived: string expected";
      }
      if (message.vsdMsgStatus != null && message.hasOwnProperty("vsdMsgStatus")) {
        if (!$util.isString(message.vsdMsgStatus))
          return "vsdMsgStatus: string expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    FlexCustomerEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FlexCustomerEvent)
        return object;
      let message = new $root.dnse.FlexCustomerEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.customerId != null)
        message.customerId = String(object.customerId);
      if (object.customerType != null)
        message.customerType = String(object.customerType);
      if (object.nationality != null)
        message.nationality = String(object.nationality);
      if (object.status != null)
        message.status = String(object.status);
      if (object.isVSDActived != null)
        message.isVSDActived = String(object.isVSDActived);
      if (object.vsdMsgStatus != null)
        message.vsdMsgStatus = String(object.vsdMsgStatus);
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.FlexCustomerEvent.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    FlexCustomerEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.customerId = "";
        object.customerType = "";
        object.nationality = "";
        object.status = "";
        object.isVSDActived = "";
        object.vsdMsgStatus = "";
        object.modifiedDate = null;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.customerId != null && message.hasOwnProperty("customerId"))
        object.customerId = message.customerId;
      if (message.customerType != null && message.hasOwnProperty("customerType"))
        object.customerType = message.customerType;
      if (message.nationality != null && message.hasOwnProperty("nationality"))
        object.nationality = message.nationality;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.isVSDActived != null && message.hasOwnProperty("isVSDActived"))
        object.isVSDActived = message.isVSDActived;
      if (message.vsdMsgStatus != null && message.hasOwnProperty("vsdMsgStatus"))
        object.vsdMsgStatus = message.vsdMsgStatus;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    FlexCustomerEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FlexCustomerEvent;
  }();
  dnse2.DtaAccount = function() {
    function DtaAccount(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DtaAccount.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DtaAccount.prototype.txNum = "";
    DtaAccount.prototype.custodyCode = "";
    DtaAccount.prototype.customerId = "";
    DtaAccount.prototype.customerType = "";
    DtaAccount.prototype.dtaAccount = "";
    DtaAccount.prototype.acType = "";
    DtaAccount.prototype.careBy = "";
    DtaAccount.prototype.isNet = false;
    DtaAccount.prototype.status = "";
    DtaAccount.prototype.dtaStatus = "";
    DtaAccount.prototype.isRevert = false;
    DtaAccount.prototype.txTime = null;
    DtaAccount.prototype.isTax = false;
    DtaAccount.create = function create(properties) {
      return new DtaAccount(properties);
    };
    DtaAccount.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
        writer.uint32(8).int64(message.seq);
      if (message.txNum != null && Object.hasOwnProperty.call(message, "txNum"))
        writer.uint32(18).string(message.txNum);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
        writer.uint32(34).string(message.customerId);
      if (message.customerType != null && Object.hasOwnProperty.call(message, "customerType"))
        writer.uint32(42).string(message.customerType);
      if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
        writer.uint32(50).string(message.dtaAccount);
      if (message.acType != null && Object.hasOwnProperty.call(message, "acType"))
        writer.uint32(58).string(message.acType);
      if (message.careBy != null && Object.hasOwnProperty.call(message, "careBy"))
        writer.uint32(66).string(message.careBy);
      if (message.isNet != null && Object.hasOwnProperty.call(message, "isNet"))
        writer.uint32(72).bool(message.isNet);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(82).string(message.status);
      if (message.dtaStatus != null && Object.hasOwnProperty.call(message, "dtaStatus"))
        writer.uint32(90).string(message.dtaStatus);
      if (message.isRevert != null && Object.hasOwnProperty.call(message, "isRevert"))
        writer.uint32(96).bool(message.isRevert);
      if (message.txTime != null && Object.hasOwnProperty.call(message, "txTime"))
        $root.google.protobuf.Timestamp.encode(message.txTime, writer.uint32(106).fork()).ldelim();
      if (message.isTax != null && Object.hasOwnProperty.call(message, "isTax"))
        writer.uint32(112).bool(message.isTax);
      return writer;
    };
    DtaAccount.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DtaAccount.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DtaAccount();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.seq = reader.int64();
            break;
          case 2:
            message.txNum = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.customerId = reader.string();
            break;
          case 5:
            message.customerType = reader.string();
            break;
          case 6:
            message.dtaAccount = reader.string();
            break;
          case 7:
            message.acType = reader.string();
            break;
          case 8:
            message.careBy = reader.string();
            break;
          case 9:
            message.isNet = reader.bool();
            break;
          case 10:
            message.status = reader.string();
            break;
          case 11:
            message.dtaStatus = reader.string();
            break;
          case 12:
            message.isRevert = reader.bool();
            break;
          case 13:
            message.txTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 14:
            message.isTax = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DtaAccount.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DtaAccount.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.seq != null && message.hasOwnProperty("seq")) {
        if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
          return "seq: integer|Long expected";
      }
      if (message.txNum != null && message.hasOwnProperty("txNum")) {
        if (!$util.isString(message.txNum))
          return "txNum: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.customerId != null && message.hasOwnProperty("customerId")) {
        if (!$util.isString(message.customerId))
          return "customerId: string expected";
      }
      if (message.customerType != null && message.hasOwnProperty("customerType")) {
        if (!$util.isString(message.customerType))
          return "customerType: string expected";
      }
      if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
        if (!$util.isString(message.dtaAccount))
          return "dtaAccount: string expected";
      }
      if (message.acType != null && message.hasOwnProperty("acType")) {
        if (!$util.isString(message.acType))
          return "acType: string expected";
      }
      if (message.careBy != null && message.hasOwnProperty("careBy")) {
        if (!$util.isString(message.careBy))
          return "careBy: string expected";
      }
      if (message.isNet != null && message.hasOwnProperty("isNet")) {
        if (typeof message.isNet !== "boolean")
          return "isNet: boolean expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.dtaStatus != null && message.hasOwnProperty("dtaStatus")) {
        if (!$util.isString(message.dtaStatus))
          return "dtaStatus: string expected";
      }
      if (message.isRevert != null && message.hasOwnProperty("isRevert")) {
        if (typeof message.isRevert !== "boolean")
          return "isRevert: boolean expected";
      }
      if (message.txTime != null && message.hasOwnProperty("txTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.txTime);
        if (error)
          return "txTime." + error;
      }
      if (message.isTax != null && message.hasOwnProperty("isTax")) {
        if (typeof message.isTax !== "boolean")
          return "isTax: boolean expected";
      }
      return null;
    };
    DtaAccount.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DtaAccount)
        return object;
      let message = new $root.dnse.DtaAccount();
      if (object.seq != null) {
        if ($util.Long)
          (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
        else if (typeof object.seq === "string")
          message.seq = parseInt(object.seq, 10);
        else if (typeof object.seq === "number")
          message.seq = object.seq;
        else if (typeof object.seq === "object")
          message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
      }
      if (object.txNum != null)
        message.txNum = String(object.txNum);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.customerId != null)
        message.customerId = String(object.customerId);
      if (object.customerType != null)
        message.customerType = String(object.customerType);
      if (object.dtaAccount != null)
        message.dtaAccount = String(object.dtaAccount);
      if (object.acType != null)
        message.acType = String(object.acType);
      if (object.careBy != null)
        message.careBy = String(object.careBy);
      if (object.isNet != null)
        message.isNet = Boolean(object.isNet);
      if (object.status != null)
        message.status = String(object.status);
      if (object.dtaStatus != null)
        message.dtaStatus = String(object.dtaStatus);
      if (object.isRevert != null)
        message.isRevert = Boolean(object.isRevert);
      if (object.txTime != null) {
        if (typeof object.txTime !== "object")
          throw TypeError(".dnse.DtaAccount.txTime: object expected");
        message.txTime = $root.google.protobuf.Timestamp.fromObject(object.txTime);
      }
      if (object.isTax != null)
        message.isTax = Boolean(object.isTax);
      return message;
    };
    DtaAccount.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.seq = options.longs === String ? "0" : 0;
        object.txNum = "";
        object.custodyCode = "";
        object.customerId = "";
        object.customerType = "";
        object.dtaAccount = "";
        object.acType = "";
        object.careBy = "";
        object.isNet = false;
        object.status = "";
        object.dtaStatus = "";
        object.isRevert = false;
        object.txTime = null;
        object.isTax = false;
      }
      if (message.seq != null && message.hasOwnProperty("seq"))
        if (typeof message.seq === "number")
          object.seq = options.longs === String ? String(message.seq) : message.seq;
        else
          object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
      if (message.txNum != null && message.hasOwnProperty("txNum"))
        object.txNum = message.txNum;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.customerId != null && message.hasOwnProperty("customerId"))
        object.customerId = message.customerId;
      if (message.customerType != null && message.hasOwnProperty("customerType"))
        object.customerType = message.customerType;
      if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
        object.dtaAccount = message.dtaAccount;
      if (message.acType != null && message.hasOwnProperty("acType"))
        object.acType = message.acType;
      if (message.careBy != null && message.hasOwnProperty("careBy"))
        object.careBy = message.careBy;
      if (message.isNet != null && message.hasOwnProperty("isNet"))
        object.isNet = message.isNet;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.dtaStatus != null && message.hasOwnProperty("dtaStatus"))
        object.dtaStatus = message.dtaStatus;
      if (message.isRevert != null && message.hasOwnProperty("isRevert"))
        object.isRevert = message.isRevert;
      if (message.txTime != null && message.hasOwnProperty("txTime"))
        object.txTime = $root.google.protobuf.Timestamp.toObject(message.txTime, options);
      if (message.isTax != null && message.hasOwnProperty("isTax"))
        object.isTax = message.isTax;
      return object;
    };
    DtaAccount.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DtaAccount;
  }();
  dnse2.DtaCash = function() {
    function DtaCash(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DtaCash.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DtaCash.prototype.custodyCode = "";
    DtaCash.prototype.dtaAccount = "";
    DtaCash.prototype.cashOnHand = 0;
    DtaCash.prototype.imCash = 0;
    DtaCash.prototype.positionFeeAccumulate = 0;
    DtaCash.prototype.positionFeeAmount = 0;
    DtaCash.prototype.marginFeeAccumulate = 0;
    DtaCash.prototype.marginFeeAmount = 0;
    DtaCash.prototype.imInterstAccumulate = 0;
    DtaCash.prototype.imInterstAmount = 0;
    DtaCash.prototype.totalFeeAmount = 0;
    DtaCash.prototype.overdraftAmount = 0;
    DtaCash.prototype.overdraftInterestAmount = 0;
    DtaCash.prototype.cashInterestAccumulate = 0;
    DtaCash.prototype.holdCollateralFee = 0;
    DtaCash.create = function create(properties) {
      return new DtaCash(properties);
    };
    DtaCash.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
        writer.uint32(8).int64(message.seq);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
        writer.uint32(26).string(message.dtaAccount);
      if (message.cashOnHand != null && Object.hasOwnProperty.call(message, "cashOnHand"))
        writer.uint32(33).double(message.cashOnHand);
      if (message.imCash != null && Object.hasOwnProperty.call(message, "imCash"))
        writer.uint32(41).double(message.imCash);
      if (message.positionFeeAccumulate != null && Object.hasOwnProperty.call(message, "positionFeeAccumulate"))
        writer.uint32(49).double(message.positionFeeAccumulate);
      if (message.positionFeeAmount != null && Object.hasOwnProperty.call(message, "positionFeeAmount"))
        writer.uint32(57).double(message.positionFeeAmount);
      if (message.marginFeeAccumulate != null && Object.hasOwnProperty.call(message, "marginFeeAccumulate"))
        writer.uint32(65).double(message.marginFeeAccumulate);
      if (message.marginFeeAmount != null && Object.hasOwnProperty.call(message, "marginFeeAmount"))
        writer.uint32(73).double(message.marginFeeAmount);
      if (message.imInterstAccumulate != null && Object.hasOwnProperty.call(message, "imInterstAccumulate"))
        writer.uint32(81).double(message.imInterstAccumulate);
      if (message.imInterstAmount != null && Object.hasOwnProperty.call(message, "imInterstAmount"))
        writer.uint32(89).double(message.imInterstAmount);
      if (message.totalFeeAmount != null && Object.hasOwnProperty.call(message, "totalFeeAmount"))
        writer.uint32(97).double(message.totalFeeAmount);
      if (message.overdraftAmount != null && Object.hasOwnProperty.call(message, "overdraftAmount"))
        writer.uint32(105).double(message.overdraftAmount);
      if (message.overdraftInterestAmount != null && Object.hasOwnProperty.call(message, "overdraftInterestAmount"))
        writer.uint32(113).double(message.overdraftInterestAmount);
      if (message.cashInterestAccumulate != null && Object.hasOwnProperty.call(message, "cashInterestAccumulate"))
        writer.uint32(121).double(message.cashInterestAccumulate);
      if (message.holdCollateralFee != null && Object.hasOwnProperty.call(message, "holdCollateralFee"))
        writer.uint32(129).double(message.holdCollateralFee);
      return writer;
    };
    DtaCash.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DtaCash.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DtaCash();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.seq = reader.int64();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.dtaAccount = reader.string();
            break;
          case 4:
            message.cashOnHand = reader.double();
            break;
          case 5:
            message.imCash = reader.double();
            break;
          case 6:
            message.positionFeeAccumulate = reader.double();
            break;
          case 7:
            message.positionFeeAmount = reader.double();
            break;
          case 8:
            message.marginFeeAccumulate = reader.double();
            break;
          case 9:
            message.marginFeeAmount = reader.double();
            break;
          case 10:
            message.imInterstAccumulate = reader.double();
            break;
          case 11:
            message.imInterstAmount = reader.double();
            break;
          case 12:
            message.totalFeeAmount = reader.double();
            break;
          case 13:
            message.overdraftAmount = reader.double();
            break;
          case 14:
            message.overdraftInterestAmount = reader.double();
            break;
          case 15:
            message.cashInterestAccumulate = reader.double();
            break;
          case 16:
            message.holdCollateralFee = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DtaCash.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DtaCash.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.seq != null && message.hasOwnProperty("seq")) {
        if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
          return "seq: integer|Long expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
        if (!$util.isString(message.dtaAccount))
          return "dtaAccount: string expected";
      }
      if (message.cashOnHand != null && message.hasOwnProperty("cashOnHand")) {
        if (typeof message.cashOnHand !== "number")
          return "cashOnHand: number expected";
      }
      if (message.imCash != null && message.hasOwnProperty("imCash")) {
        if (typeof message.imCash !== "number")
          return "imCash: number expected";
      }
      if (message.positionFeeAccumulate != null && message.hasOwnProperty("positionFeeAccumulate")) {
        if (typeof message.positionFeeAccumulate !== "number")
          return "positionFeeAccumulate: number expected";
      }
      if (message.positionFeeAmount != null && message.hasOwnProperty("positionFeeAmount")) {
        if (typeof message.positionFeeAmount !== "number")
          return "positionFeeAmount: number expected";
      }
      if (message.marginFeeAccumulate != null && message.hasOwnProperty("marginFeeAccumulate")) {
        if (typeof message.marginFeeAccumulate !== "number")
          return "marginFeeAccumulate: number expected";
      }
      if (message.marginFeeAmount != null && message.hasOwnProperty("marginFeeAmount")) {
        if (typeof message.marginFeeAmount !== "number")
          return "marginFeeAmount: number expected";
      }
      if (message.imInterstAccumulate != null && message.hasOwnProperty("imInterstAccumulate")) {
        if (typeof message.imInterstAccumulate !== "number")
          return "imInterstAccumulate: number expected";
      }
      if (message.imInterstAmount != null && message.hasOwnProperty("imInterstAmount")) {
        if (typeof message.imInterstAmount !== "number")
          return "imInterstAmount: number expected";
      }
      if (message.totalFeeAmount != null && message.hasOwnProperty("totalFeeAmount")) {
        if (typeof message.totalFeeAmount !== "number")
          return "totalFeeAmount: number expected";
      }
      if (message.overdraftAmount != null && message.hasOwnProperty("overdraftAmount")) {
        if (typeof message.overdraftAmount !== "number")
          return "overdraftAmount: number expected";
      }
      if (message.overdraftInterestAmount != null && message.hasOwnProperty("overdraftInterestAmount")) {
        if (typeof message.overdraftInterestAmount !== "number")
          return "overdraftInterestAmount: number expected";
      }
      if (message.cashInterestAccumulate != null && message.hasOwnProperty("cashInterestAccumulate")) {
        if (typeof message.cashInterestAccumulate !== "number")
          return "cashInterestAccumulate: number expected";
      }
      if (message.holdCollateralFee != null && message.hasOwnProperty("holdCollateralFee")) {
        if (typeof message.holdCollateralFee !== "number")
          return "holdCollateralFee: number expected";
      }
      return null;
    };
    DtaCash.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DtaCash)
        return object;
      let message = new $root.dnse.DtaCash();
      if (object.seq != null) {
        if ($util.Long)
          (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
        else if (typeof object.seq === "string")
          message.seq = parseInt(object.seq, 10);
        else if (typeof object.seq === "number")
          message.seq = object.seq;
        else if (typeof object.seq === "object")
          message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
      }
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.dtaAccount != null)
        message.dtaAccount = String(object.dtaAccount);
      if (object.cashOnHand != null)
        message.cashOnHand = Number(object.cashOnHand);
      if (object.imCash != null)
        message.imCash = Number(object.imCash);
      if (object.positionFeeAccumulate != null)
        message.positionFeeAccumulate = Number(object.positionFeeAccumulate);
      if (object.positionFeeAmount != null)
        message.positionFeeAmount = Number(object.positionFeeAmount);
      if (object.marginFeeAccumulate != null)
        message.marginFeeAccumulate = Number(object.marginFeeAccumulate);
      if (object.marginFeeAmount != null)
        message.marginFeeAmount = Number(object.marginFeeAmount);
      if (object.imInterstAccumulate != null)
        message.imInterstAccumulate = Number(object.imInterstAccumulate);
      if (object.imInterstAmount != null)
        message.imInterstAmount = Number(object.imInterstAmount);
      if (object.totalFeeAmount != null)
        message.totalFeeAmount = Number(object.totalFeeAmount);
      if (object.overdraftAmount != null)
        message.overdraftAmount = Number(object.overdraftAmount);
      if (object.overdraftInterestAmount != null)
        message.overdraftInterestAmount = Number(object.overdraftInterestAmount);
      if (object.cashInterestAccumulate != null)
        message.cashInterestAccumulate = Number(object.cashInterestAccumulate);
      if (object.holdCollateralFee != null)
        message.holdCollateralFee = Number(object.holdCollateralFee);
      return message;
    };
    DtaCash.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.seq = options.longs === String ? "0" : 0;
        object.custodyCode = "";
        object.dtaAccount = "";
        object.cashOnHand = 0;
        object.imCash = 0;
        object.positionFeeAccumulate = 0;
        object.positionFeeAmount = 0;
        object.marginFeeAccumulate = 0;
        object.marginFeeAmount = 0;
        object.imInterstAccumulate = 0;
        object.imInterstAmount = 0;
        object.totalFeeAmount = 0;
        object.overdraftAmount = 0;
        object.overdraftInterestAmount = 0;
        object.cashInterestAccumulate = 0;
        object.holdCollateralFee = 0;
      }
      if (message.seq != null && message.hasOwnProperty("seq"))
        if (typeof message.seq === "number")
          object.seq = options.longs === String ? String(message.seq) : message.seq;
        else
          object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
        object.dtaAccount = message.dtaAccount;
      if (message.cashOnHand != null && message.hasOwnProperty("cashOnHand"))
        object.cashOnHand = options.json && !isFinite(message.cashOnHand) ? String(message.cashOnHand) : message.cashOnHand;
      if (message.imCash != null && message.hasOwnProperty("imCash"))
        object.imCash = options.json && !isFinite(message.imCash) ? String(message.imCash) : message.imCash;
      if (message.positionFeeAccumulate != null && message.hasOwnProperty("positionFeeAccumulate"))
        object.positionFeeAccumulate = options.json && !isFinite(message.positionFeeAccumulate) ? String(message.positionFeeAccumulate) : message.positionFeeAccumulate;
      if (message.positionFeeAmount != null && message.hasOwnProperty("positionFeeAmount"))
        object.positionFeeAmount = options.json && !isFinite(message.positionFeeAmount) ? String(message.positionFeeAmount) : message.positionFeeAmount;
      if (message.marginFeeAccumulate != null && message.hasOwnProperty("marginFeeAccumulate"))
        object.marginFeeAccumulate = options.json && !isFinite(message.marginFeeAccumulate) ? String(message.marginFeeAccumulate) : message.marginFeeAccumulate;
      if (message.marginFeeAmount != null && message.hasOwnProperty("marginFeeAmount"))
        object.marginFeeAmount = options.json && !isFinite(message.marginFeeAmount) ? String(message.marginFeeAmount) : message.marginFeeAmount;
      if (message.imInterstAccumulate != null && message.hasOwnProperty("imInterstAccumulate"))
        object.imInterstAccumulate = options.json && !isFinite(message.imInterstAccumulate) ? String(message.imInterstAccumulate) : message.imInterstAccumulate;
      if (message.imInterstAmount != null && message.hasOwnProperty("imInterstAmount"))
        object.imInterstAmount = options.json && !isFinite(message.imInterstAmount) ? String(message.imInterstAmount) : message.imInterstAmount;
      if (message.totalFeeAmount != null && message.hasOwnProperty("totalFeeAmount"))
        object.totalFeeAmount = options.json && !isFinite(message.totalFeeAmount) ? String(message.totalFeeAmount) : message.totalFeeAmount;
      if (message.overdraftAmount != null && message.hasOwnProperty("overdraftAmount"))
        object.overdraftAmount = options.json && !isFinite(message.overdraftAmount) ? String(message.overdraftAmount) : message.overdraftAmount;
      if (message.overdraftInterestAmount != null && message.hasOwnProperty("overdraftInterestAmount"))
        object.overdraftInterestAmount = options.json && !isFinite(message.overdraftInterestAmount) ? String(message.overdraftInterestAmount) : message.overdraftInterestAmount;
      if (message.cashInterestAccumulate != null && message.hasOwnProperty("cashInterestAccumulate"))
        object.cashInterestAccumulate = options.json && !isFinite(message.cashInterestAccumulate) ? String(message.cashInterestAccumulate) : message.cashInterestAccumulate;
      if (message.holdCollateralFee != null && message.hasOwnProperty("holdCollateralFee"))
        object.holdCollateralFee = options.json && !isFinite(message.holdCollateralFee) ? String(message.holdCollateralFee) : message.holdCollateralFee;
      return object;
    };
    DtaCash.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DtaCash;
  }();
  dnse2.ResetPasswordEvent = function() {
    function ResetPasswordEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    ResetPasswordEvent.prototype.custodyCode = "";
    ResetPasswordEvent.prototype.otp = "";
    ResetPasswordEvent.prototype.email = "";
    ResetPasswordEvent.prototype.name = "";
    ResetPasswordEvent.prototype.os = "";
    ResetPasswordEvent.prototype.browser = "";
    ResetPasswordEvent.prototype.createdDate = null;
    ResetPasswordEvent.prototype.username = "";
    ResetPasswordEvent.create = function create(properties) {
      return new ResetPasswordEvent(properties);
    };
    ResetPasswordEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.otp != null && Object.hasOwnProperty.call(message, "otp"))
        writer.uint32(18).string(message.otp);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(26).string(message.email);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(34).string(message.name);
      if (message.os != null && Object.hasOwnProperty.call(message, "os"))
        writer.uint32(42).string(message.os);
      if (message.browser != null && Object.hasOwnProperty.call(message, "browser"))
        writer.uint32(50).string(message.browser);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.username != null && Object.hasOwnProperty.call(message, "username"))
        writer.uint32(66).string(message.username);
      return writer;
    };
    ResetPasswordEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    ResetPasswordEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.ResetPasswordEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.otp = reader.string();
            break;
          case 3:
            message.email = reader.string();
            break;
          case 4:
            message.name = reader.string();
            break;
          case 5:
            message.os = reader.string();
            break;
          case 6:
            message.browser = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.username = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    ResetPasswordEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    ResetPasswordEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.otp != null && message.hasOwnProperty("otp")) {
        if (!$util.isString(message.otp))
          return "otp: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.os != null && message.hasOwnProperty("os")) {
        if (!$util.isString(message.os))
          return "os: string expected";
      }
      if (message.browser != null && message.hasOwnProperty("browser")) {
        if (!$util.isString(message.browser))
          return "browser: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.username != null && message.hasOwnProperty("username")) {
        if (!$util.isString(message.username))
          return "username: string expected";
      }
      return null;
    };
    ResetPasswordEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.ResetPasswordEvent)
        return object;
      let message = new $root.dnse.ResetPasswordEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.otp != null)
        message.otp = String(object.otp);
      if (object.email != null)
        message.email = String(object.email);
      if (object.name != null)
        message.name = String(object.name);
      if (object.os != null)
        message.os = String(object.os);
      if (object.browser != null)
        message.browser = String(object.browser);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.ResetPasswordEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.username != null)
        message.username = String(object.username);
      return message;
    };
    ResetPasswordEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.otp = "";
        object.email = "";
        object.name = "";
        object.os = "";
        object.browser = "";
        object.createdDate = null;
        object.username = "";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.otp != null && message.hasOwnProperty("otp"))
        object.otp = message.otp;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.os != null && message.hasOwnProperty("os"))
        object.os = message.os;
      if (message.browser != null && message.hasOwnProperty("browser"))
        object.browser = message.browser;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.username != null && message.hasOwnProperty("username"))
        object.username = message.username;
      return object;
    };
    ResetPasswordEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return ResetPasswordEvent;
  }();
  dnse2.FlexHoStatus = function() {
    function FlexHoStatus(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FlexHoStatus.prototype.active = false;
    FlexHoStatus.prototype.currentTradingDate = "";
    FlexHoStatus.prototype.nextTradingDate = "";
    FlexHoStatus.create = function create(properties) {
      return new FlexHoStatus(properties);
    };
    FlexHoStatus.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.active != null && Object.hasOwnProperty.call(message, "active"))
        writer.uint32(8).bool(message.active);
      if (message.currentTradingDate != null && Object.hasOwnProperty.call(message, "currentTradingDate"))
        writer.uint32(18).string(message.currentTradingDate);
      if (message.nextTradingDate != null && Object.hasOwnProperty.call(message, "nextTradingDate"))
        writer.uint32(26).string(message.nextTradingDate);
      return writer;
    };
    FlexHoStatus.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FlexHoStatus.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FlexHoStatus();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.active = reader.bool();
            break;
          case 2:
            message.currentTradingDate = reader.string();
            break;
          case 3:
            message.nextTradingDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FlexHoStatus.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FlexHoStatus.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.active != null && message.hasOwnProperty("active")) {
        if (typeof message.active !== "boolean")
          return "active: boolean expected";
      }
      if (message.currentTradingDate != null && message.hasOwnProperty("currentTradingDate")) {
        if (!$util.isString(message.currentTradingDate))
          return "currentTradingDate: string expected";
      }
      if (message.nextTradingDate != null && message.hasOwnProperty("nextTradingDate")) {
        if (!$util.isString(message.nextTradingDate))
          return "nextTradingDate: string expected";
      }
      return null;
    };
    FlexHoStatus.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FlexHoStatus)
        return object;
      let message = new $root.dnse.FlexHoStatus();
      if (object.active != null)
        message.active = Boolean(object.active);
      if (object.currentTradingDate != null)
        message.currentTradingDate = String(object.currentTradingDate);
      if (object.nextTradingDate != null)
        message.nextTradingDate = String(object.nextTradingDate);
      return message;
    };
    FlexHoStatus.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.active = false;
        object.currentTradingDate = "";
        object.nextTradingDate = "";
      }
      if (message.active != null && message.hasOwnProperty("active"))
        object.active = message.active;
      if (message.currentTradingDate != null && message.hasOwnProperty("currentTradingDate"))
        object.currentTradingDate = message.currentTradingDate;
      if (message.nextTradingDate != null && message.hasOwnProperty("nextTradingDate"))
        object.nextTradingDate = message.nextTradingDate;
      return object;
    };
    FlexHoStatus.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FlexHoStatus;
  }();
  dnse2.NewsNotice = function() {
    function NewsNotice(properties) {
      this.symbols = [];
      this.investorIds = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NewsNotice.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewsNotice.prototype.title = "";
    NewsNotice.prototype.content = "";
    NewsNotice.prototype.symbols = $util.emptyArray;
    NewsNotice.prototype.summary = "";
    NewsNotice.prototype.url = "";
    NewsNotice.prototype.investorIds = $util.emptyArray;
    NewsNotice.prototype.inPortfolio = false;
    NewsNotice.prototype.createdAt = null;
    NewsNotice.create = function create(properties) {
      return new NewsNotice(properties);
    };
    NewsNotice.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.title != null && Object.hasOwnProperty.call(message, "title"))
        writer.uint32(18).string(message.title);
      if (message.content != null && Object.hasOwnProperty.call(message, "content"))
        writer.uint32(26).string(message.content);
      if (message.symbols != null && message.symbols.length)
        for (let i = 0; i < message.symbols.length; ++i)
          writer.uint32(34).string(message.symbols[i]);
      if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
        writer.uint32(42).string(message.summary);
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(50).string(message.url);
      if (message.investorIds != null && message.investorIds.length)
        for (let i = 0; i < message.investorIds.length; ++i)
          writer.uint32(58).string(message.investorIds[i]);
      if (message.inPortfolio != null && Object.hasOwnProperty.call(message, "inPortfolio"))
        writer.uint32(64).bool(message.inPortfolio);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(74).fork()).ldelim();
      return writer;
    };
    NewsNotice.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NewsNotice.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NewsNotice();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.title = reader.string();
            break;
          case 3:
            message.content = reader.string();
            break;
          case 4:
            if (!(message.symbols && message.symbols.length))
              message.symbols = [];
            message.symbols.push(reader.string());
            break;
          case 5:
            message.summary = reader.string();
            break;
          case 6:
            message.url = reader.string();
            break;
          case 7:
            if (!(message.investorIds && message.investorIds.length))
              message.investorIds = [];
            message.investorIds.push(reader.string());
            break;
          case 8:
            message.inPortfolio = reader.bool();
            break;
          case 9:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NewsNotice.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NewsNotice.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.title != null && message.hasOwnProperty("title")) {
        if (!$util.isString(message.title))
          return "title: string expected";
      }
      if (message.content != null && message.hasOwnProperty("content")) {
        if (!$util.isString(message.content))
          return "content: string expected";
      }
      if (message.symbols != null && message.hasOwnProperty("symbols")) {
        if (!Array.isArray(message.symbols))
          return "symbols: array expected";
        for (let i = 0; i < message.symbols.length; ++i)
          if (!$util.isString(message.symbols[i]))
            return "symbols: string[] expected";
      }
      if (message.summary != null && message.hasOwnProperty("summary")) {
        if (!$util.isString(message.summary))
          return "summary: string expected";
      }
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      if (message.investorIds != null && message.hasOwnProperty("investorIds")) {
        if (!Array.isArray(message.investorIds))
          return "investorIds: array expected";
        for (let i = 0; i < message.investorIds.length; ++i)
          if (!$util.isString(message.investorIds[i]))
            return "investorIds: string[] expected";
      }
      if (message.inPortfolio != null && message.hasOwnProperty("inPortfolio")) {
        if (typeof message.inPortfolio !== "boolean")
          return "inPortfolio: boolean expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    NewsNotice.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NewsNotice)
        return object;
      let message = new $root.dnse.NewsNotice();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.title != null)
        message.title = String(object.title);
      if (object.content != null)
        message.content = String(object.content);
      if (object.symbols) {
        if (!Array.isArray(object.symbols))
          throw TypeError(".dnse.NewsNotice.symbols: array expected");
        message.symbols = [];
        for (let i = 0; i < object.symbols.length; ++i)
          message.symbols[i] = String(object.symbols[i]);
      }
      if (object.summary != null)
        message.summary = String(object.summary);
      if (object.url != null)
        message.url = String(object.url);
      if (object.investorIds) {
        if (!Array.isArray(object.investorIds))
          throw TypeError(".dnse.NewsNotice.investorIds: array expected");
        message.investorIds = [];
        for (let i = 0; i < object.investorIds.length; ++i)
          message.investorIds[i] = String(object.investorIds[i]);
      }
      if (object.inPortfolio != null)
        message.inPortfolio = Boolean(object.inPortfolio);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.NewsNotice.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    NewsNotice.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.symbols = [];
        object.investorIds = [];
      }
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.title = "";
        object.content = "";
        object.summary = "";
        object.url = "";
        object.inPortfolio = false;
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.title != null && message.hasOwnProperty("title"))
        object.title = message.title;
      if (message.content != null && message.hasOwnProperty("content"))
        object.content = message.content;
      if (message.symbols && message.symbols.length) {
        object.symbols = [];
        for (let j = 0; j < message.symbols.length; ++j)
          object.symbols[j] = message.symbols[j];
      }
      if (message.summary != null && message.hasOwnProperty("summary"))
        object.summary = message.summary;
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      if (message.investorIds && message.investorIds.length) {
        object.investorIds = [];
        for (let j = 0; j < message.investorIds.length; ++j)
          object.investorIds[j] = message.investorIds[j];
      }
      if (message.inPortfolio != null && message.hasOwnProperty("inPortfolio"))
        object.inPortfolio = message.inPortfolio;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    NewsNotice.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return NewsNotice;
  }();
  dnse2.News = function() {
    function News(properties) {
      this.symbols = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    News.prototype.newsId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    News.prototype.articleId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    News.prototype.eventId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    News.prototype.source = "";
    News.prototype.exchangeNewsName = "";
    News.prototype.isBreakingNews = false;
    News.prototype.isCrawled = false;
    News.prototype.stockEx = "";
    News.prototype.topic = "";
    News.prototype.domain = "";
    News.prototype.summary = "";
    News.prototype.tag = "";
    News.prototype.url = "";
    News.prototype.thumbImageUrl = "";
    News.prototype.content = "";
    News.prototype.publishTime = null;
    News.prototype.headImageUrl = "";
    News.prototype.head = "";
    News.prototype.title = "";
    News.prototype.vietstockArticleId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    News.prototype.isMacro = false;
    News.prototype.nganhCap1 = "";
    News.prototype.newsType = "";
    News.prototype.symbols = $util.emptyArray;
    News.prototype.author = "";
    News.prototype.symbol = "";
    News.prototype.createdAt = null;
    News.create = function create(properties) {
      return new News(properties);
    };
    News.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.newsId != null && Object.hasOwnProperty.call(message, "newsId"))
        writer.uint32(8).int64(message.newsId);
      if (message.articleId != null && Object.hasOwnProperty.call(message, "articleId"))
        writer.uint32(16).int64(message.articleId);
      if (message.eventId != null && Object.hasOwnProperty.call(message, "eventId"))
        writer.uint32(24).int64(message.eventId);
      if (message.source != null && Object.hasOwnProperty.call(message, "source"))
        writer.uint32(34).string(message.source);
      if (message.exchangeNewsName != null && Object.hasOwnProperty.call(message, "exchangeNewsName"))
        writer.uint32(42).string(message.exchangeNewsName);
      if (message.isBreakingNews != null && Object.hasOwnProperty.call(message, "isBreakingNews"))
        writer.uint32(48).bool(message.isBreakingNews);
      if (message.isCrawled != null && Object.hasOwnProperty.call(message, "isCrawled"))
        writer.uint32(56).bool(message.isCrawled);
      if (message.stockEx != null && Object.hasOwnProperty.call(message, "stockEx"))
        writer.uint32(66).string(message.stockEx);
      if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
        writer.uint32(74).string(message.topic);
      if (message.domain != null && Object.hasOwnProperty.call(message, "domain"))
        writer.uint32(82).string(message.domain);
      if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
        writer.uint32(90).string(message.summary);
      if (message.tag != null && Object.hasOwnProperty.call(message, "tag"))
        writer.uint32(98).string(message.tag);
      if (message.url != null && Object.hasOwnProperty.call(message, "url"))
        writer.uint32(106).string(message.url);
      if (message.thumbImageUrl != null && Object.hasOwnProperty.call(message, "thumbImageUrl"))
        writer.uint32(114).string(message.thumbImageUrl);
      if (message.content != null && Object.hasOwnProperty.call(message, "content"))
        writer.uint32(122).string(message.content);
      if (message.publishTime != null && Object.hasOwnProperty.call(message, "publishTime"))
        $root.google.protobuf.Timestamp.encode(message.publishTime, writer.uint32(130).fork()).ldelim();
      if (message.headImageUrl != null && Object.hasOwnProperty.call(message, "headImageUrl"))
        writer.uint32(138).string(message.headImageUrl);
      if (message.head != null && Object.hasOwnProperty.call(message, "head"))
        writer.uint32(146).string(message.head);
      if (message.title != null && Object.hasOwnProperty.call(message, "title"))
        writer.uint32(154).string(message.title);
      if (message.vietstockArticleId != null && Object.hasOwnProperty.call(message, "vietstockArticleId"))
        writer.uint32(160).int64(message.vietstockArticleId);
      if (message.isMacro != null && Object.hasOwnProperty.call(message, "isMacro"))
        writer.uint32(168).bool(message.isMacro);
      if (message.nganhCap1 != null && Object.hasOwnProperty.call(message, "nganhCap1"))
        writer.uint32(178).string(message.nganhCap1);
      if (message.newsType != null && Object.hasOwnProperty.call(message, "newsType"))
        writer.uint32(186).string(message.newsType);
      if (message.symbols != null && message.symbols.length)
        for (let i = 0; i < message.symbols.length; ++i)
          writer.uint32(194).string(message.symbols[i]);
      if (message.author != null && Object.hasOwnProperty.call(message, "author"))
        writer.uint32(202).string(message.author);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(210).string(message.symbol);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(218).fork()).ldelim();
      return writer;
    };
    News.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    News.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.News();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.newsId = reader.int64();
            break;
          case 2:
            message.articleId = reader.int64();
            break;
          case 3:
            message.eventId = reader.int64();
            break;
          case 4:
            message.source = reader.string();
            break;
          case 5:
            message.exchangeNewsName = reader.string();
            break;
          case 6:
            message.isBreakingNews = reader.bool();
            break;
          case 7:
            message.isCrawled = reader.bool();
            break;
          case 8:
            message.stockEx = reader.string();
            break;
          case 9:
            message.topic = reader.string();
            break;
          case 10:
            message.domain = reader.string();
            break;
          case 11:
            message.summary = reader.string();
            break;
          case 12:
            message.tag = reader.string();
            break;
          case 13:
            message.url = reader.string();
            break;
          case 14:
            message.thumbImageUrl = reader.string();
            break;
          case 15:
            message.content = reader.string();
            break;
          case 16:
            message.publishTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 17:
            message.headImageUrl = reader.string();
            break;
          case 18:
            message.head = reader.string();
            break;
          case 19:
            message.title = reader.string();
            break;
          case 20:
            message.vietstockArticleId = reader.int64();
            break;
          case 21:
            message.isMacro = reader.bool();
            break;
          case 22:
            message.nganhCap1 = reader.string();
            break;
          case 23:
            message.newsType = reader.string();
            break;
          case 24:
            if (!(message.symbols && message.symbols.length))
              message.symbols = [];
            message.symbols.push(reader.string());
            break;
          case 25:
            message.author = reader.string();
            break;
          case 26:
            message.symbol = reader.string();
            break;
          case 27:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    News.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    News.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.newsId != null && message.hasOwnProperty("newsId")) {
        if (!$util.isInteger(message.newsId) && !(message.newsId && $util.isInteger(message.newsId.low) && $util.isInteger(message.newsId.high)))
          return "newsId: integer|Long expected";
      }
      if (message.articleId != null && message.hasOwnProperty("articleId")) {
        if (!$util.isInteger(message.articleId) && !(message.articleId && $util.isInteger(message.articleId.low) && $util.isInteger(message.articleId.high)))
          return "articleId: integer|Long expected";
      }
      if (message.eventId != null && message.hasOwnProperty("eventId")) {
        if (!$util.isInteger(message.eventId) && !(message.eventId && $util.isInteger(message.eventId.low) && $util.isInteger(message.eventId.high)))
          return "eventId: integer|Long expected";
      }
      if (message.source != null && message.hasOwnProperty("source")) {
        if (!$util.isString(message.source))
          return "source: string expected";
      }
      if (message.exchangeNewsName != null && message.hasOwnProperty("exchangeNewsName")) {
        if (!$util.isString(message.exchangeNewsName))
          return "exchangeNewsName: string expected";
      }
      if (message.isBreakingNews != null && message.hasOwnProperty("isBreakingNews")) {
        if (typeof message.isBreakingNews !== "boolean")
          return "isBreakingNews: boolean expected";
      }
      if (message.isCrawled != null && message.hasOwnProperty("isCrawled")) {
        if (typeof message.isCrawled !== "boolean")
          return "isCrawled: boolean expected";
      }
      if (message.stockEx != null && message.hasOwnProperty("stockEx")) {
        if (!$util.isString(message.stockEx))
          return "stockEx: string expected";
      }
      if (message.topic != null && message.hasOwnProperty("topic")) {
        if (!$util.isString(message.topic))
          return "topic: string expected";
      }
      if (message.domain != null && message.hasOwnProperty("domain")) {
        if (!$util.isString(message.domain))
          return "domain: string expected";
      }
      if (message.summary != null && message.hasOwnProperty("summary")) {
        if (!$util.isString(message.summary))
          return "summary: string expected";
      }
      if (message.tag != null && message.hasOwnProperty("tag")) {
        if (!$util.isString(message.tag))
          return "tag: string expected";
      }
      if (message.url != null && message.hasOwnProperty("url")) {
        if (!$util.isString(message.url))
          return "url: string expected";
      }
      if (message.thumbImageUrl != null && message.hasOwnProperty("thumbImageUrl")) {
        if (!$util.isString(message.thumbImageUrl))
          return "thumbImageUrl: string expected";
      }
      if (message.content != null && message.hasOwnProperty("content")) {
        if (!$util.isString(message.content))
          return "content: string expected";
      }
      if (message.publishTime != null && message.hasOwnProperty("publishTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.publishTime);
        if (error)
          return "publishTime." + error;
      }
      if (message.headImageUrl != null && message.hasOwnProperty("headImageUrl")) {
        if (!$util.isString(message.headImageUrl))
          return "headImageUrl: string expected";
      }
      if (message.head != null && message.hasOwnProperty("head")) {
        if (!$util.isString(message.head))
          return "head: string expected";
      }
      if (message.title != null && message.hasOwnProperty("title")) {
        if (!$util.isString(message.title))
          return "title: string expected";
      }
      if (message.vietstockArticleId != null && message.hasOwnProperty("vietstockArticleId")) {
        if (!$util.isInteger(message.vietstockArticleId) && !(message.vietstockArticleId && $util.isInteger(message.vietstockArticleId.low) && $util.isInteger(message.vietstockArticleId.high)))
          return "vietstockArticleId: integer|Long expected";
      }
      if (message.isMacro != null && message.hasOwnProperty("isMacro")) {
        if (typeof message.isMacro !== "boolean")
          return "isMacro: boolean expected";
      }
      if (message.nganhCap1 != null && message.hasOwnProperty("nganhCap1")) {
        if (!$util.isString(message.nganhCap1))
          return "nganhCap1: string expected";
      }
      if (message.newsType != null && message.hasOwnProperty("newsType")) {
        if (!$util.isString(message.newsType))
          return "newsType: string expected";
      }
      if (message.symbols != null && message.hasOwnProperty("symbols")) {
        if (!Array.isArray(message.symbols))
          return "symbols: array expected";
        for (let i = 0; i < message.symbols.length; ++i)
          if (!$util.isString(message.symbols[i]))
            return "symbols: string[] expected";
      }
      if (message.author != null && message.hasOwnProperty("author")) {
        if (!$util.isString(message.author))
          return "author: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    News.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.News)
        return object;
      let message = new $root.dnse.News();
      if (object.newsId != null) {
        if ($util.Long)
          (message.newsId = $util.Long.fromValue(object.newsId)).unsigned = false;
        else if (typeof object.newsId === "string")
          message.newsId = parseInt(object.newsId, 10);
        else if (typeof object.newsId === "number")
          message.newsId = object.newsId;
        else if (typeof object.newsId === "object")
          message.newsId = new $util.LongBits(object.newsId.low >>> 0, object.newsId.high >>> 0).toNumber();
      }
      if (object.articleId != null) {
        if ($util.Long)
          (message.articleId = $util.Long.fromValue(object.articleId)).unsigned = false;
        else if (typeof object.articleId === "string")
          message.articleId = parseInt(object.articleId, 10);
        else if (typeof object.articleId === "number")
          message.articleId = object.articleId;
        else if (typeof object.articleId === "object")
          message.articleId = new $util.LongBits(object.articleId.low >>> 0, object.articleId.high >>> 0).toNumber();
      }
      if (object.eventId != null) {
        if ($util.Long)
          (message.eventId = $util.Long.fromValue(object.eventId)).unsigned = false;
        else if (typeof object.eventId === "string")
          message.eventId = parseInt(object.eventId, 10);
        else if (typeof object.eventId === "number")
          message.eventId = object.eventId;
        else if (typeof object.eventId === "object")
          message.eventId = new $util.LongBits(object.eventId.low >>> 0, object.eventId.high >>> 0).toNumber();
      }
      if (object.source != null)
        message.source = String(object.source);
      if (object.exchangeNewsName != null)
        message.exchangeNewsName = String(object.exchangeNewsName);
      if (object.isBreakingNews != null)
        message.isBreakingNews = Boolean(object.isBreakingNews);
      if (object.isCrawled != null)
        message.isCrawled = Boolean(object.isCrawled);
      if (object.stockEx != null)
        message.stockEx = String(object.stockEx);
      if (object.topic != null)
        message.topic = String(object.topic);
      if (object.domain != null)
        message.domain = String(object.domain);
      if (object.summary != null)
        message.summary = String(object.summary);
      if (object.tag != null)
        message.tag = String(object.tag);
      if (object.url != null)
        message.url = String(object.url);
      if (object.thumbImageUrl != null)
        message.thumbImageUrl = String(object.thumbImageUrl);
      if (object.content != null)
        message.content = String(object.content);
      if (object.publishTime != null) {
        if (typeof object.publishTime !== "object")
          throw TypeError(".dnse.News.publishTime: object expected");
        message.publishTime = $root.google.protobuf.Timestamp.fromObject(object.publishTime);
      }
      if (object.headImageUrl != null)
        message.headImageUrl = String(object.headImageUrl);
      if (object.head != null)
        message.head = String(object.head);
      if (object.title != null)
        message.title = String(object.title);
      if (object.vietstockArticleId != null) {
        if ($util.Long)
          (message.vietstockArticleId = $util.Long.fromValue(object.vietstockArticleId)).unsigned = false;
        else if (typeof object.vietstockArticleId === "string")
          message.vietstockArticleId = parseInt(object.vietstockArticleId, 10);
        else if (typeof object.vietstockArticleId === "number")
          message.vietstockArticleId = object.vietstockArticleId;
        else if (typeof object.vietstockArticleId === "object")
          message.vietstockArticleId = new $util.LongBits(object.vietstockArticleId.low >>> 0, object.vietstockArticleId.high >>> 0).toNumber();
      }
      if (object.isMacro != null)
        message.isMacro = Boolean(object.isMacro);
      if (object.nganhCap1 != null)
        message.nganhCap1 = String(object.nganhCap1);
      if (object.newsType != null)
        message.newsType = String(object.newsType);
      if (object.symbols) {
        if (!Array.isArray(object.symbols))
          throw TypeError(".dnse.News.symbols: array expected");
        message.symbols = [];
        for (let i = 0; i < object.symbols.length; ++i)
          message.symbols[i] = String(object.symbols[i]);
      }
      if (object.author != null)
        message.author = String(object.author);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.News.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    News.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.symbols = [];
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.newsId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.newsId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.articleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.articleId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.eventId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.eventId = options.longs === String ? "0" : 0;
        object.source = "";
        object.exchangeNewsName = "";
        object.isBreakingNews = false;
        object.isCrawled = false;
        object.stockEx = "";
        object.topic = "";
        object.domain = "";
        object.summary = "";
        object.tag = "";
        object.url = "";
        object.thumbImageUrl = "";
        object.content = "";
        object.publishTime = null;
        object.headImageUrl = "";
        object.head = "";
        object.title = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.vietstockArticleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.vietstockArticleId = options.longs === String ? "0" : 0;
        object.isMacro = false;
        object.nganhCap1 = "";
        object.newsType = "";
        object.author = "";
        object.symbol = "";
        object.createdAt = null;
      }
      if (message.newsId != null && message.hasOwnProperty("newsId"))
        if (typeof message.newsId === "number")
          object.newsId = options.longs === String ? String(message.newsId) : message.newsId;
        else
          object.newsId = options.longs === String ? $util.Long.prototype.toString.call(message.newsId) : options.longs === Number ? new $util.LongBits(message.newsId.low >>> 0, message.newsId.high >>> 0).toNumber() : message.newsId;
      if (message.articleId != null && message.hasOwnProperty("articleId"))
        if (typeof message.articleId === "number")
          object.articleId = options.longs === String ? String(message.articleId) : message.articleId;
        else
          object.articleId = options.longs === String ? $util.Long.prototype.toString.call(message.articleId) : options.longs === Number ? new $util.LongBits(message.articleId.low >>> 0, message.articleId.high >>> 0).toNumber() : message.articleId;
      if (message.eventId != null && message.hasOwnProperty("eventId"))
        if (typeof message.eventId === "number")
          object.eventId = options.longs === String ? String(message.eventId) : message.eventId;
        else
          object.eventId = options.longs === String ? $util.Long.prototype.toString.call(message.eventId) : options.longs === Number ? new $util.LongBits(message.eventId.low >>> 0, message.eventId.high >>> 0).toNumber() : message.eventId;
      if (message.source != null && message.hasOwnProperty("source"))
        object.source = message.source;
      if (message.exchangeNewsName != null && message.hasOwnProperty("exchangeNewsName"))
        object.exchangeNewsName = message.exchangeNewsName;
      if (message.isBreakingNews != null && message.hasOwnProperty("isBreakingNews"))
        object.isBreakingNews = message.isBreakingNews;
      if (message.isCrawled != null && message.hasOwnProperty("isCrawled"))
        object.isCrawled = message.isCrawled;
      if (message.stockEx != null && message.hasOwnProperty("stockEx"))
        object.stockEx = message.stockEx;
      if (message.topic != null && message.hasOwnProperty("topic"))
        object.topic = message.topic;
      if (message.domain != null && message.hasOwnProperty("domain"))
        object.domain = message.domain;
      if (message.summary != null && message.hasOwnProperty("summary"))
        object.summary = message.summary;
      if (message.tag != null && message.hasOwnProperty("tag"))
        object.tag = message.tag;
      if (message.url != null && message.hasOwnProperty("url"))
        object.url = message.url;
      if (message.thumbImageUrl != null && message.hasOwnProperty("thumbImageUrl"))
        object.thumbImageUrl = message.thumbImageUrl;
      if (message.content != null && message.hasOwnProperty("content"))
        object.content = message.content;
      if (message.publishTime != null && message.hasOwnProperty("publishTime"))
        object.publishTime = $root.google.protobuf.Timestamp.toObject(message.publishTime, options);
      if (message.headImageUrl != null && message.hasOwnProperty("headImageUrl"))
        object.headImageUrl = message.headImageUrl;
      if (message.head != null && message.hasOwnProperty("head"))
        object.head = message.head;
      if (message.title != null && message.hasOwnProperty("title"))
        object.title = message.title;
      if (message.vietstockArticleId != null && message.hasOwnProperty("vietstockArticleId"))
        if (typeof message.vietstockArticleId === "number")
          object.vietstockArticleId = options.longs === String ? String(message.vietstockArticleId) : message.vietstockArticleId;
        else
          object.vietstockArticleId = options.longs === String ? $util.Long.prototype.toString.call(message.vietstockArticleId) : options.longs === Number ? new $util.LongBits(message.vietstockArticleId.low >>> 0, message.vietstockArticleId.high >>> 0).toNumber() : message.vietstockArticleId;
      if (message.isMacro != null && message.hasOwnProperty("isMacro"))
        object.isMacro = message.isMacro;
      if (message.nganhCap1 != null && message.hasOwnProperty("nganhCap1"))
        object.nganhCap1 = message.nganhCap1;
      if (message.newsType != null && message.hasOwnProperty("newsType"))
        object.newsType = message.newsType;
      if (message.symbols && message.symbols.length) {
        object.symbols = [];
        for (let j = 0; j < message.symbols.length; ++j)
          object.symbols[j] = message.symbols[j];
      }
      if (message.author != null && message.hasOwnProperty("author"))
        object.author = message.author;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    News.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return News;
  }();
  dnse2.BreakingNewsNotification = function() {
    function BreakingNewsNotification(properties) {
      this.data = [];
      this.investorIds = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BreakingNewsNotification.prototype.data = $util.emptyArray;
    BreakingNewsNotification.prototype.investorIds = $util.emptyArray;
    BreakingNewsNotification.prototype.isPushNotice = false;
    BreakingNewsNotification.prototype.createdAt = null;
    BreakingNewsNotification.prototype.type = 0;
    BreakingNewsNotification.create = function create(properties) {
      return new BreakingNewsNotification(properties);
    };
    BreakingNewsNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.data != null && message.data.length)
        for (let i = 0; i < message.data.length; ++i)
          $root.dnse.NewsNotice.encode(message.data[i], writer.uint32(10).fork()).ldelim();
      if (message.investorIds != null && message.investorIds.length)
        for (let i = 0; i < message.investorIds.length; ++i)
          writer.uint32(18).string(message.investorIds[i]);
      if (message.isPushNotice != null && Object.hasOwnProperty.call(message, "isPushNotice"))
        writer.uint32(24).bool(message.isPushNotice);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(34).fork()).ldelim();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(40).int32(message.type);
      return writer;
    };
    BreakingNewsNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BreakingNewsNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BreakingNewsNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.data && message.data.length))
              message.data = [];
            message.data.push($root.dnse.NewsNotice.decode(reader, reader.uint32()));
            break;
          case 2:
            if (!(message.investorIds && message.investorIds.length))
              message.investorIds = [];
            message.investorIds.push(reader.string());
            break;
          case 3:
            message.isPushNotice = reader.bool();
            break;
          case 4:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.type = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BreakingNewsNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BreakingNewsNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.data != null && message.hasOwnProperty("data")) {
        if (!Array.isArray(message.data))
          return "data: array expected";
        for (let i = 0; i < message.data.length; ++i) {
          let error = $root.dnse.NewsNotice.verify(message.data[i]);
          if (error)
            return "data." + error;
        }
      }
      if (message.investorIds != null && message.hasOwnProperty("investorIds")) {
        if (!Array.isArray(message.investorIds))
          return "investorIds: array expected";
        for (let i = 0; i < message.investorIds.length; ++i)
          if (!$util.isString(message.investorIds[i]))
            return "investorIds: string[] expected";
      }
      if (message.isPushNotice != null && message.hasOwnProperty("isPushNotice")) {
        if (typeof message.isPushNotice !== "boolean")
          return "isPushNotice: boolean expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return null;
    };
    BreakingNewsNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BreakingNewsNotification)
        return object;
      let message = new $root.dnse.BreakingNewsNotification();
      if (object.data) {
        if (!Array.isArray(object.data))
          throw TypeError(".dnse.BreakingNewsNotification.data: array expected");
        message.data = [];
        for (let i = 0; i < object.data.length; ++i) {
          if (typeof object.data[i] !== "object")
            throw TypeError(".dnse.BreakingNewsNotification.data: object expected");
          message.data[i] = $root.dnse.NewsNotice.fromObject(object.data[i]);
        }
      }
      if (object.investorIds) {
        if (!Array.isArray(object.investorIds))
          throw TypeError(".dnse.BreakingNewsNotification.investorIds: array expected");
        message.investorIds = [];
        for (let i = 0; i < object.investorIds.length; ++i)
          message.investorIds[i] = String(object.investorIds[i]);
      }
      if (object.isPushNotice != null)
        message.isPushNotice = Boolean(object.isPushNotice);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.BreakingNewsNotification.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      switch (object.type) {
        case "UNKNOWN":
        case 0:
          message.type = 0;
          break;
        case "BREAKING_NEWS":
        case 1:
          message.type = 1;
          break;
        case "FINANCIAL_REPORT":
        case 2:
          message.type = 2;
          break;
      }
      return message;
    };
    BreakingNewsNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.data = [];
        object.investorIds = [];
      }
      if (options.defaults) {
        object.isPushNotice = false;
        object.createdAt = null;
        object.type = options.enums === String ? "UNKNOWN" : 0;
      }
      if (message.data && message.data.length) {
        object.data = [];
        for (let j = 0; j < message.data.length; ++j)
          object.data[j] = $root.dnse.NewsNotice.toObject(message.data[j], options);
      }
      if (message.investorIds && message.investorIds.length) {
        object.investorIds = [];
        for (let j = 0; j < message.investorIds.length; ++j)
          object.investorIds[j] = message.investorIds[j];
      }
      if (message.isPushNotice != null && message.hasOwnProperty("isPushNotice"))
        object.isPushNotice = message.isPushNotice;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.BreakingNewsNotification.Type[message.type] : message.type;
      return object;
    };
    BreakingNewsNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    BreakingNewsNotification.Type = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "BREAKING_NEWS"] = 1;
      values[valuesById[2] = "FINANCIAL_REPORT"] = 2;
      return values;
    }();
    return BreakingNewsNotification;
  }();
  dnse2.RegisterDerivativeEvent = function() {
    function RegisterDerivativeEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    RegisterDerivativeEvent.prototype.investorId = "";
    RegisterDerivativeEvent.prototype.custodyCode = "";
    RegisterDerivativeEvent.prototype.registerWhenSignContract = false;
    RegisterDerivativeEvent.prototype.createdDate = null;
    RegisterDerivativeEvent.prototype.signingTime = null;
    RegisterDerivativeEvent.create = function create(properties) {
      return new RegisterDerivativeEvent(properties);
    };
    RegisterDerivativeEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.registerWhenSignContract != null && Object.hasOwnProperty.call(message, "registerWhenSignContract"))
        writer.uint32(24).bool(message.registerWhenSignContract);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.signingTime != null && Object.hasOwnProperty.call(message, "signingTime"))
        $root.google.protobuf.Timestamp.encode(message.signingTime, writer.uint32(42).fork()).ldelim();
      return writer;
    };
    RegisterDerivativeEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    RegisterDerivativeEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.RegisterDerivativeEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.registerWhenSignContract = reader.bool();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.signingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    RegisterDerivativeEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    RegisterDerivativeEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.registerWhenSignContract != null && message.hasOwnProperty("registerWhenSignContract")) {
        if (typeof message.registerWhenSignContract !== "boolean")
          return "registerWhenSignContract: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.signingTime != null && message.hasOwnProperty("signingTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.signingTime);
        if (error)
          return "signingTime." + error;
      }
      return null;
    };
    RegisterDerivativeEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.RegisterDerivativeEvent)
        return object;
      let message = new $root.dnse.RegisterDerivativeEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.registerWhenSignContract != null)
        message.registerWhenSignContract = Boolean(object.registerWhenSignContract);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.RegisterDerivativeEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.signingTime != null) {
        if (typeof object.signingTime !== "object")
          throw TypeError(".dnse.RegisterDerivativeEvent.signingTime: object expected");
        message.signingTime = $root.google.protobuf.Timestamp.fromObject(object.signingTime);
      }
      return message;
    };
    RegisterDerivativeEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.registerWhenSignContract = false;
        object.createdDate = null;
        object.signingTime = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.registerWhenSignContract != null && message.hasOwnProperty("registerWhenSignContract"))
        object.registerWhenSignContract = message.registerWhenSignContract;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.signingTime != null && message.hasOwnProperty("signingTime"))
        object.signingTime = $root.google.protobuf.Timestamp.toObject(message.signingTime, options);
      return object;
    };
    RegisterDerivativeEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return RegisterDerivativeEvent;
  }();
  dnse2.DerivativeAccountActiveEvent = function() {
    function DerivativeAccountActiveEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeAccountActiveEvent.prototype.investorId = "";
    DerivativeAccountActiveEvent.prototype.custodyCode = "";
    DerivativeAccountActiveEvent.prototype.createdDate = null;
    DerivativeAccountActiveEvent.create = function create(properties) {
      return new DerivativeAccountActiveEvent(properties);
    };
    DerivativeAccountActiveEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    DerivativeAccountActiveEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeAccountActiveEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeAccountActiveEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeAccountActiveEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeAccountActiveEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    DerivativeAccountActiveEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeAccountActiveEvent)
        return object;
      let message = new $root.dnse.DerivativeAccountActiveEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativeAccountActiveEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    DerivativeAccountActiveEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    DerivativeAccountActiveEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeAccountActiveEvent;
  }();
  dnse2.TypeBaseWithdraw = function() {
    function TypeBaseWithdraw(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    TypeBaseWithdraw.prototype.id = "";
    TypeBaseWithdraw.prototype.type = "";
    TypeBaseWithdraw.prototype.accountNo = "";
    TypeBaseWithdraw.prototype.withdrawType = "";
    TypeBaseWithdraw.prototype.withdrawTypeName = "";
    TypeBaseWithdraw.prototype.transactionId = "";
    TypeBaseWithdraw.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    TypeBaseWithdraw.prototype.referenceId = "";
    TypeBaseWithdraw.prototype.description = "";
    TypeBaseWithdraw.prototype.transactionTime = null;
    TypeBaseWithdraw.create = function create(properties) {
      return new TypeBaseWithdraw(properties);
    };
    TypeBaseWithdraw.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(18).string(message.type);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.withdrawType != null && Object.hasOwnProperty.call(message, "withdrawType"))
        writer.uint32(34).string(message.withdrawType);
      if (message.withdrawTypeName != null && Object.hasOwnProperty.call(message, "withdrawTypeName"))
        writer.uint32(42).string(message.withdrawTypeName);
      if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
        writer.uint32(50).string(message.transactionId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(56).int64(message.amount);
      if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
        writer.uint32(66).string(message.referenceId);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(74).string(message.description);
      if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
        $root.google.protobuf.Timestamp.encode(message.transactionTime, writer.uint32(82).fork()).ldelim();
      return writer;
    };
    TypeBaseWithdraw.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    TypeBaseWithdraw.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.TypeBaseWithdraw();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.type = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.withdrawType = reader.string();
            break;
          case 5:
            message.withdrawTypeName = reader.string();
            break;
          case 6:
            message.transactionId = reader.string();
            break;
          case 7:
            message.amount = reader.int64();
            break;
          case 8:
            message.referenceId = reader.string();
            break;
          case 9:
            message.description = reader.string();
            break;
          case 10:
            message.transactionTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    TypeBaseWithdraw.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    TypeBaseWithdraw.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType")) {
        if (!$util.isString(message.withdrawType))
          return "withdrawType: string expected";
      }
      if (message.withdrawTypeName != null && message.hasOwnProperty("withdrawTypeName")) {
        if (!$util.isString(message.withdrawTypeName))
          return "withdrawTypeName: string expected";
      }
      if (message.transactionId != null && message.hasOwnProperty("transactionId")) {
        if (!$util.isString(message.transactionId))
          return "transactionId: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
        if (!$util.isString(message.referenceId))
          return "referenceId: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.transactionTime);
        if (error)
          return "transactionTime." + error;
      }
      return null;
    };
    TypeBaseWithdraw.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.TypeBaseWithdraw)
        return object;
      let message = new $root.dnse.TypeBaseWithdraw();
      if (object.id != null)
        message.id = String(object.id);
      if (object.type != null)
        message.type = String(object.type);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.withdrawType != null)
        message.withdrawType = String(object.withdrawType);
      if (object.withdrawTypeName != null)
        message.withdrawTypeName = String(object.withdrawTypeName);
      if (object.transactionId != null)
        message.transactionId = String(object.transactionId);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.referenceId != null)
        message.referenceId = String(object.referenceId);
      if (object.description != null)
        message.description = String(object.description);
      if (object.transactionTime != null) {
        if (typeof object.transactionTime !== "object")
          throw TypeError(".dnse.TypeBaseWithdraw.transactionTime: object expected");
        message.transactionTime = $root.google.protobuf.Timestamp.fromObject(object.transactionTime);
      }
      return message;
    };
    TypeBaseWithdraw.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.type = "";
        object.accountNo = "";
        object.withdrawType = "";
        object.withdrawTypeName = "";
        object.transactionId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.referenceId = "";
        object.description = "";
        object.transactionTime = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType"))
        object.withdrawType = message.withdrawType;
      if (message.withdrawTypeName != null && message.hasOwnProperty("withdrawTypeName"))
        object.withdrawTypeName = message.withdrawTypeName;
      if (message.transactionId != null && message.hasOwnProperty("transactionId"))
        object.transactionId = message.transactionId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.referenceId != null && message.hasOwnProperty("referenceId"))
        object.referenceId = message.referenceId;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
        object.transactionTime = $root.google.protobuf.Timestamp.toObject(message.transactionTime, options);
      return object;
    };
    TypeBaseWithdraw.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return TypeBaseWithdraw;
  }();
  dnse2.AdvanceWithdrawTransaction = function() {
    function AdvanceWithdrawTransaction(properties) {
      this.metadata = {};
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AdvanceWithdrawTransaction.prototype.investorId = "";
    AdvanceWithdrawTransaction.prototype.accountNo = "";
    AdvanceWithdrawTransaction.prototype.accountTypeName = "";
    AdvanceWithdrawTransaction.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AdvanceWithdrawTransaction.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AdvanceWithdrawTransaction.prototype.createdDate = null;
    AdvanceWithdrawTransaction.prototype.withdrawType = "";
    AdvanceWithdrawTransaction.prototype.withdrawTypeDesc = "";
    AdvanceWithdrawTransaction.prototype.description = "";
    AdvanceWithdrawTransaction.prototype.beneficiary = null;
    AdvanceWithdrawTransaction.prototype.metadata = $util.emptyObject;
    let $oneOfFields;
    Object.defineProperty(AdvanceWithdrawTransaction.prototype, "_beneficiary", {
      get: $util.oneOfGetter($oneOfFields = ["beneficiary"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    AdvanceWithdrawTransaction.create = function create(properties) {
      return new AdvanceWithdrawTransaction(properties);
    };
    AdvanceWithdrawTransaction.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(26).string(message.accountTypeName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(32).int64(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(40).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.withdrawType != null && Object.hasOwnProperty.call(message, "withdrawType"))
        writer.uint32(58).string(message.withdrawType);
      if (message.withdrawTypeDesc != null && Object.hasOwnProperty.call(message, "withdrawTypeDesc"))
        writer.uint32(66).string(message.withdrawTypeDesc);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(74).string(message.description);
      if (message.beneficiary != null && Object.hasOwnProperty.call(message, "beneficiary"))
        writer.uint32(82).string(message.beneficiary);
      if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
        for (let keys = Object.keys(message.metadata), i = 0; i < keys.length; ++i)
          writer.uint32(90).fork().uint32(10).string(keys[i]).uint32(18).string(message.metadata[keys[i]]).ldelim();
      return writer;
    };
    AdvanceWithdrawTransaction.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AdvanceWithdrawTransaction.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.AdvanceWithdrawTransaction(), key, value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.accountTypeName = reader.string();
            break;
          case 4:
            message.amount = reader.int64();
            break;
          case 5:
            message.availableCash = reader.int64();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.withdrawType = reader.string();
            break;
          case 8:
            message.withdrawTypeDesc = reader.string();
            break;
          case 9:
            message.description = reader.string();
            break;
          case 10:
            message.beneficiary = reader.string();
            break;
          case 11:
            if (message.metadata === $util.emptyObject)
              message.metadata = {};
            let end2 = reader.uint32() + reader.pos;
            key = "";
            value = "";
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = reader.string();
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.metadata[key] = value;
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AdvanceWithdrawTransaction.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AdvanceWithdrawTransaction.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType")) {
        if (!$util.isString(message.withdrawType))
          return "withdrawType: string expected";
      }
      if (message.withdrawTypeDesc != null && message.hasOwnProperty("withdrawTypeDesc")) {
        if (!$util.isString(message.withdrawTypeDesc))
          return "withdrawTypeDesc: string expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.beneficiary != null && message.hasOwnProperty("beneficiary")) {
        if (!$util.isString(message.beneficiary))
          return "beneficiary: string expected";
      }
      if (message.metadata != null && message.hasOwnProperty("metadata")) {
        if (!$util.isObject(message.metadata))
          return "metadata: object expected";
        let key = Object.keys(message.metadata);
        for (let i = 0; i < key.length; ++i)
          if (!$util.isString(message.metadata[key[i]]))
            return "metadata: string{k:string} expected";
      }
      return null;
    };
    AdvanceWithdrawTransaction.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.AdvanceWithdrawTransaction)
        return object;
      let message = new $root.dnse.AdvanceWithdrawTransaction();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.AdvanceWithdrawTransaction.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.withdrawType != null)
        message.withdrawType = String(object.withdrawType);
      if (object.withdrawTypeDesc != null)
        message.withdrawTypeDesc = String(object.withdrawTypeDesc);
      if (object.description != null)
        message.description = String(object.description);
      if (object.beneficiary != null)
        message.beneficiary = String(object.beneficiary);
      if (object.metadata) {
        if (typeof object.metadata !== "object")
          throw TypeError(".dnse.AdvanceWithdrawTransaction.metadata: object expected");
        message.metadata = {};
        for (let keys = Object.keys(object.metadata), i = 0; i < keys.length; ++i)
          message.metadata[keys[i]] = String(object.metadata[keys[i]]);
      }
      return message;
    };
    AdvanceWithdrawTransaction.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.objects || options.defaults)
        object.metadata = {};
      if (options.defaults) {
        object.investorId = "";
        object.accountNo = "";
        object.accountTypeName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.withdrawType = "";
        object.withdrawTypeDesc = "";
        object.description = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType"))
        object.withdrawType = message.withdrawType;
      if (message.withdrawTypeDesc != null && message.hasOwnProperty("withdrawTypeDesc"))
        object.withdrawTypeDesc = message.withdrawTypeDesc;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.beneficiary != null && message.hasOwnProperty("beneficiary")) {
        object.beneficiary = message.beneficiary;
        if (options.oneofs)
          object._beneficiary = "beneficiary";
      }
      let keys2;
      if (message.metadata && (keys2 = Object.keys(message.metadata)).length) {
        object.metadata = {};
        for (let j = 0; j < keys2.length; ++j)
          object.metadata[keys2[j]] = message.metadata[keys2[j]];
      }
      return object;
    };
    AdvanceWithdrawTransaction.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return AdvanceWithdrawTransaction;
  }();
  dnse2.DealSecureDepositEvent = function() {
    function DealSecureDepositEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealSecureDepositEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealSecureDepositEvent.prototype.accountNo = "";
    DealSecureDepositEvent.prototype.investorId = "";
    DealSecureDepositEvent.prototype.symbol = "";
    DealSecureDepositEvent.prototype.loanPackageId = 0;
    DealSecureDepositEvent.prototype.loanPackageName = "";
    DealSecureDepositEvent.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealSecureDepositEvent.prototype.totalAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealSecureDepositEvent.prototype.createdDate = null;
    DealSecureDepositEvent.prototype.triggerFromSystem = false;
    DealSecureDepositEvent.prototype.accountTypeName = "";
    DealSecureDepositEvent.create = function create(properties) {
      return new DealSecureDepositEvent(properties);
    };
    DealSecureDepositEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(8).int64(message.dealId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(50).string(message.loanPackageName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(56).int64(message.amount);
      if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
        writer.uint32(64).int64(message.totalAmount);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
      if (message.triggerFromSystem != null && Object.hasOwnProperty.call(message, "triggerFromSystem"))
        writer.uint32(80).bool(message.triggerFromSystem);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(90).string(message.accountTypeName);
      return writer;
    };
    DealSecureDepositEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealSecureDepositEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealSecureDepositEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.dealId = reader.int64();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.loanPackageName = reader.string();
            break;
          case 7:
            message.amount = reader.int64();
            break;
          case 8:
            message.totalAmount = reader.int64();
            break;
          case 9:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.triggerFromSystem = reader.bool();
            break;
          case 11:
            message.accountTypeName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealSecureDepositEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealSecureDepositEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.totalAmount != null && message.hasOwnProperty("totalAmount")) {
        if (!$util.isInteger(message.totalAmount) && !(message.totalAmount && $util.isInteger(message.totalAmount.low) && $util.isInteger(message.totalAmount.high)))
          return "totalAmount: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.triggerFromSystem != null && message.hasOwnProperty("triggerFromSystem")) {
        if (typeof message.triggerFromSystem !== "boolean")
          return "triggerFromSystem: boolean expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      return null;
    };
    DealSecureDepositEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealSecureDepositEvent)
        return object;
      let message = new $root.dnse.DealSecureDepositEvent();
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.totalAmount != null) {
        if ($util.Long)
          (message.totalAmount = $util.Long.fromValue(object.totalAmount)).unsigned = false;
        else if (typeof object.totalAmount === "string")
          message.totalAmount = parseInt(object.totalAmount, 10);
        else if (typeof object.totalAmount === "number")
          message.totalAmount = object.totalAmount;
        else if (typeof object.totalAmount === "object")
          message.totalAmount = new $util.LongBits(object.totalAmount.low >>> 0, object.totalAmount.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DealSecureDepositEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.triggerFromSystem != null)
        message.triggerFromSystem = Boolean(object.triggerFromSystem);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      return message;
    };
    DealSecureDepositEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
        object.accountNo = "";
        object.investorId = "";
        object.symbol = "";
        object.loanPackageId = 0;
        object.loanPackageName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalAmount = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.triggerFromSystem = false;
        object.accountTypeName = "";
      }
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
        if (typeof message.totalAmount === "number")
          object.totalAmount = options.longs === String ? String(message.totalAmount) : message.totalAmount;
        else
          object.totalAmount = options.longs === String ? $util.Long.prototype.toString.call(message.totalAmount) : options.longs === Number ? new $util.LongBits(message.totalAmount.low >>> 0, message.totalAmount.high >>> 0).toNumber() : message.totalAmount;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.triggerFromSystem != null && message.hasOwnProperty("triggerFromSystem"))
        object.triggerFromSystem = message.triggerFromSystem;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      return object;
    };
    DealSecureDepositEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealSecureDepositEvent;
  }();
  dnse2.DerivativePaymentObligationEODEvent = function() {
    function DerivativePaymentObligationEODEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativePaymentObligationEODEvent.prototype.accountNo = "";
    DerivativePaymentObligationEODEvent.prototype.investorId = "";
    DerivativePaymentObligationEODEvent.prototype.custodyCode = "";
    DerivativePaymentObligationEODEvent.prototype.accountTypeName = "";
    DerivativePaymentObligationEODEvent.prototype.amount = 0;
    DerivativePaymentObligationEODEvent.prototype.createdDate = null;
    DerivativePaymentObligationEODEvent.prototype.fullName = "";
    DerivativePaymentObligationEODEvent.prototype.paid = 0;
    DerivativePaymentObligationEODEvent.prototype.dailyProfit = 0;
    DerivativePaymentObligationEODEvent.prototype.dailyTaxAndFee = 0;
    DerivativePaymentObligationEODEvent.prototype.endOfDayProfit = 0;
    DerivativePaymentObligationEODEvent.prototype.endOfMonthCollateralFee = 0;
    DerivativePaymentObligationEODEvent.prototype.endOfDayHoldDailyRealizedTradingTaxAndFee = 0;
    DerivativePaymentObligationEODEvent.prototype.disbursedAmount = 0;
    DerivativePaymentObligationEODEvent.prototype.endOfDayTaxAndFee = 0;
    DerivativePaymentObligationEODEvent.prototype.loanPackageName = "";
    DerivativePaymentObligationEODEvent.prototype.endOfMonthHoldCollateralFee = 0;
    DerivativePaymentObligationEODEvent.prototype.endOfDayCollectedDebt = 0;
    DerivativePaymentObligationEODEvent.create = function create(properties) {
      return new DerivativePaymentObligationEODEvent(properties);
    };
    DerivativePaymentObligationEODEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(41).double(message.amount);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(58).string(message.fullName);
      if (message.paid != null && Object.hasOwnProperty.call(message, "paid"))
        writer.uint32(65).double(message.paid);
      if (message.dailyProfit != null && Object.hasOwnProperty.call(message, "dailyProfit"))
        writer.uint32(73).double(message.dailyProfit);
      if (message.dailyTaxAndFee != null && Object.hasOwnProperty.call(message, "dailyTaxAndFee"))
        writer.uint32(81).double(message.dailyTaxAndFee);
      if (message.endOfDayProfit != null && Object.hasOwnProperty.call(message, "endOfDayProfit"))
        writer.uint32(89).double(message.endOfDayProfit);
      if (message.endOfMonthCollateralFee != null && Object.hasOwnProperty.call(message, "endOfMonthCollateralFee"))
        writer.uint32(97).double(message.endOfMonthCollateralFee);
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && Object.hasOwnProperty.call(message, "endOfDayHoldDailyRealizedTradingTaxAndFee"))
        writer.uint32(105).double(message.endOfDayHoldDailyRealizedTradingTaxAndFee);
      if (message.disbursedAmount != null && Object.hasOwnProperty.call(message, "disbursedAmount"))
        writer.uint32(113).double(message.disbursedAmount);
      if (message.endOfDayTaxAndFee != null && Object.hasOwnProperty.call(message, "endOfDayTaxAndFee"))
        writer.uint32(121).double(message.endOfDayTaxAndFee);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(130).string(message.loanPackageName);
      if (message.endOfMonthHoldCollateralFee != null && Object.hasOwnProperty.call(message, "endOfMonthHoldCollateralFee"))
        writer.uint32(137).double(message.endOfMonthHoldCollateralFee);
      if (message.endOfDayCollectedDebt != null && Object.hasOwnProperty.call(message, "endOfDayCollectedDebt"))
        writer.uint32(145).double(message.endOfDayCollectedDebt);
      return writer;
    };
    DerivativePaymentObligationEODEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativePaymentObligationEODEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativePaymentObligationEODEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.amount = reader.double();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.fullName = reader.string();
            break;
          case 8:
            message.paid = reader.double();
            break;
          case 9:
            message.dailyProfit = reader.double();
            break;
          case 10:
            message.dailyTaxAndFee = reader.double();
            break;
          case 11:
            message.endOfDayProfit = reader.double();
            break;
          case 12:
            message.endOfMonthCollateralFee = reader.double();
            break;
          case 13:
            message.endOfDayHoldDailyRealizedTradingTaxAndFee = reader.double();
            break;
          case 14:
            message.disbursedAmount = reader.double();
            break;
          case 15:
            message.endOfDayTaxAndFee = reader.double();
            break;
          case 16:
            message.loanPackageName = reader.string();
            break;
          case 17:
            message.endOfMonthHoldCollateralFee = reader.double();
            break;
          case 18:
            message.endOfDayCollectedDebt = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativePaymentObligationEODEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativePaymentObligationEODEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.paid != null && message.hasOwnProperty("paid")) {
        if (typeof message.paid !== "number")
          return "paid: number expected";
      }
      if (message.dailyProfit != null && message.hasOwnProperty("dailyProfit")) {
        if (typeof message.dailyProfit !== "number")
          return "dailyProfit: number expected";
      }
      if (message.dailyTaxAndFee != null && message.hasOwnProperty("dailyTaxAndFee")) {
        if (typeof message.dailyTaxAndFee !== "number")
          return "dailyTaxAndFee: number expected";
      }
      if (message.endOfDayProfit != null && message.hasOwnProperty("endOfDayProfit")) {
        if (typeof message.endOfDayProfit !== "number")
          return "endOfDayProfit: number expected";
      }
      if (message.endOfMonthCollateralFee != null && message.hasOwnProperty("endOfMonthCollateralFee")) {
        if (typeof message.endOfMonthCollateralFee !== "number")
          return "endOfMonthCollateralFee: number expected";
      }
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("endOfDayHoldDailyRealizedTradingTaxAndFee")) {
        if (typeof message.endOfDayHoldDailyRealizedTradingTaxAndFee !== "number")
          return "endOfDayHoldDailyRealizedTradingTaxAndFee: number expected";
      }
      if (message.disbursedAmount != null && message.hasOwnProperty("disbursedAmount")) {
        if (typeof message.disbursedAmount !== "number")
          return "disbursedAmount: number expected";
      }
      if (message.endOfDayTaxAndFee != null && message.hasOwnProperty("endOfDayTaxAndFee")) {
        if (typeof message.endOfDayTaxAndFee !== "number")
          return "endOfDayTaxAndFee: number expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.endOfMonthHoldCollateralFee != null && message.hasOwnProperty("endOfMonthHoldCollateralFee")) {
        if (typeof message.endOfMonthHoldCollateralFee !== "number")
          return "endOfMonthHoldCollateralFee: number expected";
      }
      if (message.endOfDayCollectedDebt != null && message.hasOwnProperty("endOfDayCollectedDebt")) {
        if (typeof message.endOfDayCollectedDebt !== "number")
          return "endOfDayCollectedDebt: number expected";
      }
      return null;
    };
    DerivativePaymentObligationEODEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativePaymentObligationEODEvent)
        return object;
      let message = new $root.dnse.DerivativePaymentObligationEODEvent();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativePaymentObligationEODEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.paid != null)
        message.paid = Number(object.paid);
      if (object.dailyProfit != null)
        message.dailyProfit = Number(object.dailyProfit);
      if (object.dailyTaxAndFee != null)
        message.dailyTaxAndFee = Number(object.dailyTaxAndFee);
      if (object.endOfDayProfit != null)
        message.endOfDayProfit = Number(object.endOfDayProfit);
      if (object.endOfMonthCollateralFee != null)
        message.endOfMonthCollateralFee = Number(object.endOfMonthCollateralFee);
      if (object.endOfDayHoldDailyRealizedTradingTaxAndFee != null)
        message.endOfDayHoldDailyRealizedTradingTaxAndFee = Number(object.endOfDayHoldDailyRealizedTradingTaxAndFee);
      if (object.disbursedAmount != null)
        message.disbursedAmount = Number(object.disbursedAmount);
      if (object.endOfDayTaxAndFee != null)
        message.endOfDayTaxAndFee = Number(object.endOfDayTaxAndFee);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.endOfMonthHoldCollateralFee != null)
        message.endOfMonthHoldCollateralFee = Number(object.endOfMonthHoldCollateralFee);
      if (object.endOfDayCollectedDebt != null)
        message.endOfDayCollectedDebt = Number(object.endOfDayCollectedDebt);
      return message;
    };
    DerivativePaymentObligationEODEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.investorId = "";
        object.custodyCode = "";
        object.accountTypeName = "";
        object.amount = 0;
        object.createdDate = null;
        object.fullName = "";
        object.paid = 0;
        object.dailyProfit = 0;
        object.dailyTaxAndFee = 0;
        object.endOfDayProfit = 0;
        object.endOfMonthCollateralFee = 0;
        object.endOfDayHoldDailyRealizedTradingTaxAndFee = 0;
        object.disbursedAmount = 0;
        object.endOfDayTaxAndFee = 0;
        object.loanPackageName = "";
        object.endOfMonthHoldCollateralFee = 0;
        object.endOfDayCollectedDebt = 0;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.paid != null && message.hasOwnProperty("paid"))
        object.paid = options.json && !isFinite(message.paid) ? String(message.paid) : message.paid;
      if (message.dailyProfit != null && message.hasOwnProperty("dailyProfit"))
        object.dailyProfit = options.json && !isFinite(message.dailyProfit) ? String(message.dailyProfit) : message.dailyProfit;
      if (message.dailyTaxAndFee != null && message.hasOwnProperty("dailyTaxAndFee"))
        object.dailyTaxAndFee = options.json && !isFinite(message.dailyTaxAndFee) ? String(message.dailyTaxAndFee) : message.dailyTaxAndFee;
      if (message.endOfDayProfit != null && message.hasOwnProperty("endOfDayProfit"))
        object.endOfDayProfit = options.json && !isFinite(message.endOfDayProfit) ? String(message.endOfDayProfit) : message.endOfDayProfit;
      if (message.endOfMonthCollateralFee != null && message.hasOwnProperty("endOfMonthCollateralFee"))
        object.endOfMonthCollateralFee = options.json && !isFinite(message.endOfMonthCollateralFee) ? String(message.endOfMonthCollateralFee) : message.endOfMonthCollateralFee;
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("endOfDayHoldDailyRealizedTradingTaxAndFee"))
        object.endOfDayHoldDailyRealizedTradingTaxAndFee = options.json && !isFinite(message.endOfDayHoldDailyRealizedTradingTaxAndFee) ? String(message.endOfDayHoldDailyRealizedTradingTaxAndFee) : message.endOfDayHoldDailyRealizedTradingTaxAndFee;
      if (message.disbursedAmount != null && message.hasOwnProperty("disbursedAmount"))
        object.disbursedAmount = options.json && !isFinite(message.disbursedAmount) ? String(message.disbursedAmount) : message.disbursedAmount;
      if (message.endOfDayTaxAndFee != null && message.hasOwnProperty("endOfDayTaxAndFee"))
        object.endOfDayTaxAndFee = options.json && !isFinite(message.endOfDayTaxAndFee) ? String(message.endOfDayTaxAndFee) : message.endOfDayTaxAndFee;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.endOfMonthHoldCollateralFee != null && message.hasOwnProperty("endOfMonthHoldCollateralFee"))
        object.endOfMonthHoldCollateralFee = options.json && !isFinite(message.endOfMonthHoldCollateralFee) ? String(message.endOfMonthHoldCollateralFee) : message.endOfMonthHoldCollateralFee;
      if (message.endOfDayCollectedDebt != null && message.hasOwnProperty("endOfDayCollectedDebt"))
        object.endOfDayCollectedDebt = options.json && !isFinite(message.endOfDayCollectedDebt) ? String(message.endOfDayCollectedDebt) : message.endOfDayCollectedDebt;
      return object;
    };
    DerivativePaymentObligationEODEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativePaymentObligationEODEvent;
  }();
  dnse2.DerivativeReceiveProfitEvent = function() {
    function DerivativeReceiveProfitEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeReceiveProfitEvent.prototype.accountNo = "";
    DerivativeReceiveProfitEvent.prototype.investorId = "";
    DerivativeReceiveProfitEvent.prototype.custodyCode = "";
    DerivativeReceiveProfitEvent.prototype.accountTypeName = "";
    DerivativeReceiveProfitEvent.prototype.grossAmount = 0;
    DerivativeReceiveProfitEvent.prototype.netAmount = 0;
    DerivativeReceiveProfitEvent.prototype.createdDate = null;
    DerivativeReceiveProfitEvent.prototype.fullName = "";
    DerivativeReceiveProfitEvent.prototype.dailyProfit = 0;
    DerivativeReceiveProfitEvent.prototype.dailyTaxAndFee = 0;
    DerivativeReceiveProfitEvent.prototype.endOfDayProfit = 0;
    DerivativeReceiveProfitEvent.prototype.endOfDayTaxAndFee = 0;
    DerivativeReceiveProfitEvent.prototype.endOfMonthCollateralFee = 0;
    DerivativeReceiveProfitEvent.prototype.endOfDayHoldDailyRealizedTradingTaxAndFee = 0;
    DerivativeReceiveProfitEvent.prototype.deltaCollateralFee = 0;
    DerivativeReceiveProfitEvent.prototype.paymentCashAccount = 0;
    DerivativeReceiveProfitEvent.prototype.loanPackageName = "";
    DerivativeReceiveProfitEvent.prototype.endOfMonthHoldCollateralFee = 0;
    DerivativeReceiveProfitEvent.prototype.endOfDayCollectedDebt = 0;
    DerivativeReceiveProfitEvent.prototype.initDayCollectedDebt = 0;
    DerivativeReceiveProfitEvent.create = function create(properties) {
      return new DerivativeReceiveProfitEvent(properties);
    };
    DerivativeReceiveProfitEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.grossAmount != null && Object.hasOwnProperty.call(message, "grossAmount"))
        writer.uint32(41).double(message.grossAmount);
      if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
        writer.uint32(49).double(message.netAmount);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(66).string(message.fullName);
      if (message.dailyProfit != null && Object.hasOwnProperty.call(message, "dailyProfit"))
        writer.uint32(73).double(message.dailyProfit);
      if (message.dailyTaxAndFee != null && Object.hasOwnProperty.call(message, "dailyTaxAndFee"))
        writer.uint32(81).double(message.dailyTaxAndFee);
      if (message.endOfDayProfit != null && Object.hasOwnProperty.call(message, "endOfDayProfit"))
        writer.uint32(89).double(message.endOfDayProfit);
      if (message.endOfDayTaxAndFee != null && Object.hasOwnProperty.call(message, "endOfDayTaxAndFee"))
        writer.uint32(97).double(message.endOfDayTaxAndFee);
      if (message.endOfMonthCollateralFee != null && Object.hasOwnProperty.call(message, "endOfMonthCollateralFee"))
        writer.uint32(105).double(message.endOfMonthCollateralFee);
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && Object.hasOwnProperty.call(message, "endOfDayHoldDailyRealizedTradingTaxAndFee"))
        writer.uint32(113).double(message.endOfDayHoldDailyRealizedTradingTaxAndFee);
      if (message.deltaCollateralFee != null && Object.hasOwnProperty.call(message, "deltaCollateralFee"))
        writer.uint32(121).double(message.deltaCollateralFee);
      if (message.paymentCashAccount != null && Object.hasOwnProperty.call(message, "paymentCashAccount"))
        writer.uint32(129).double(message.paymentCashAccount);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(138).string(message.loanPackageName);
      if (message.endOfMonthHoldCollateralFee != null && Object.hasOwnProperty.call(message, "endOfMonthHoldCollateralFee"))
        writer.uint32(145).double(message.endOfMonthHoldCollateralFee);
      if (message.endOfDayCollectedDebt != null && Object.hasOwnProperty.call(message, "endOfDayCollectedDebt"))
        writer.uint32(153).double(message.endOfDayCollectedDebt);
      if (message.initDayCollectedDebt != null && Object.hasOwnProperty.call(message, "initDayCollectedDebt"))
        writer.uint32(161).double(message.initDayCollectedDebt);
      return writer;
    };
    DerivativeReceiveProfitEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeReceiveProfitEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeReceiveProfitEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.grossAmount = reader.double();
            break;
          case 6:
            message.netAmount = reader.double();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.fullName = reader.string();
            break;
          case 9:
            message.dailyProfit = reader.double();
            break;
          case 10:
            message.dailyTaxAndFee = reader.double();
            break;
          case 11:
            message.endOfDayProfit = reader.double();
            break;
          case 12:
            message.endOfDayTaxAndFee = reader.double();
            break;
          case 13:
            message.endOfMonthCollateralFee = reader.double();
            break;
          case 14:
            message.endOfDayHoldDailyRealizedTradingTaxAndFee = reader.double();
            break;
          case 15:
            message.deltaCollateralFee = reader.double();
            break;
          case 16:
            message.paymentCashAccount = reader.double();
            break;
          case 17:
            message.loanPackageName = reader.string();
            break;
          case 18:
            message.endOfMonthHoldCollateralFee = reader.double();
            break;
          case 19:
            message.endOfDayCollectedDebt = reader.double();
            break;
          case 20:
            message.initDayCollectedDebt = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeReceiveProfitEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeReceiveProfitEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.grossAmount != null && message.hasOwnProperty("grossAmount")) {
        if (typeof message.grossAmount !== "number")
          return "grossAmount: number expected";
      }
      if (message.netAmount != null && message.hasOwnProperty("netAmount")) {
        if (typeof message.netAmount !== "number")
          return "netAmount: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.dailyProfit != null && message.hasOwnProperty("dailyProfit")) {
        if (typeof message.dailyProfit !== "number")
          return "dailyProfit: number expected";
      }
      if (message.dailyTaxAndFee != null && message.hasOwnProperty("dailyTaxAndFee")) {
        if (typeof message.dailyTaxAndFee !== "number")
          return "dailyTaxAndFee: number expected";
      }
      if (message.endOfDayProfit != null && message.hasOwnProperty("endOfDayProfit")) {
        if (typeof message.endOfDayProfit !== "number")
          return "endOfDayProfit: number expected";
      }
      if (message.endOfDayTaxAndFee != null && message.hasOwnProperty("endOfDayTaxAndFee")) {
        if (typeof message.endOfDayTaxAndFee !== "number")
          return "endOfDayTaxAndFee: number expected";
      }
      if (message.endOfMonthCollateralFee != null && message.hasOwnProperty("endOfMonthCollateralFee")) {
        if (typeof message.endOfMonthCollateralFee !== "number")
          return "endOfMonthCollateralFee: number expected";
      }
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("endOfDayHoldDailyRealizedTradingTaxAndFee")) {
        if (typeof message.endOfDayHoldDailyRealizedTradingTaxAndFee !== "number")
          return "endOfDayHoldDailyRealizedTradingTaxAndFee: number expected";
      }
      if (message.deltaCollateralFee != null && message.hasOwnProperty("deltaCollateralFee")) {
        if (typeof message.deltaCollateralFee !== "number")
          return "deltaCollateralFee: number expected";
      }
      if (message.paymentCashAccount != null && message.hasOwnProperty("paymentCashAccount")) {
        if (typeof message.paymentCashAccount !== "number")
          return "paymentCashAccount: number expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.endOfMonthHoldCollateralFee != null && message.hasOwnProperty("endOfMonthHoldCollateralFee")) {
        if (typeof message.endOfMonthHoldCollateralFee !== "number")
          return "endOfMonthHoldCollateralFee: number expected";
      }
      if (message.endOfDayCollectedDebt != null && message.hasOwnProperty("endOfDayCollectedDebt")) {
        if (typeof message.endOfDayCollectedDebt !== "number")
          return "endOfDayCollectedDebt: number expected";
      }
      if (message.initDayCollectedDebt != null && message.hasOwnProperty("initDayCollectedDebt")) {
        if (typeof message.initDayCollectedDebt !== "number")
          return "initDayCollectedDebt: number expected";
      }
      return null;
    };
    DerivativeReceiveProfitEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeReceiveProfitEvent)
        return object;
      let message = new $root.dnse.DerivativeReceiveProfitEvent();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.grossAmount != null)
        message.grossAmount = Number(object.grossAmount);
      if (object.netAmount != null)
        message.netAmount = Number(object.netAmount);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativeReceiveProfitEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.dailyProfit != null)
        message.dailyProfit = Number(object.dailyProfit);
      if (object.dailyTaxAndFee != null)
        message.dailyTaxAndFee = Number(object.dailyTaxAndFee);
      if (object.endOfDayProfit != null)
        message.endOfDayProfit = Number(object.endOfDayProfit);
      if (object.endOfDayTaxAndFee != null)
        message.endOfDayTaxAndFee = Number(object.endOfDayTaxAndFee);
      if (object.endOfMonthCollateralFee != null)
        message.endOfMonthCollateralFee = Number(object.endOfMonthCollateralFee);
      if (object.endOfDayHoldDailyRealizedTradingTaxAndFee != null)
        message.endOfDayHoldDailyRealizedTradingTaxAndFee = Number(object.endOfDayHoldDailyRealizedTradingTaxAndFee);
      if (object.deltaCollateralFee != null)
        message.deltaCollateralFee = Number(object.deltaCollateralFee);
      if (object.paymentCashAccount != null)
        message.paymentCashAccount = Number(object.paymentCashAccount);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.endOfMonthHoldCollateralFee != null)
        message.endOfMonthHoldCollateralFee = Number(object.endOfMonthHoldCollateralFee);
      if (object.endOfDayCollectedDebt != null)
        message.endOfDayCollectedDebt = Number(object.endOfDayCollectedDebt);
      if (object.initDayCollectedDebt != null)
        message.initDayCollectedDebt = Number(object.initDayCollectedDebt);
      return message;
    };
    DerivativeReceiveProfitEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.investorId = "";
        object.custodyCode = "";
        object.accountTypeName = "";
        object.grossAmount = 0;
        object.netAmount = 0;
        object.createdDate = null;
        object.fullName = "";
        object.dailyProfit = 0;
        object.dailyTaxAndFee = 0;
        object.endOfDayProfit = 0;
        object.endOfDayTaxAndFee = 0;
        object.endOfMonthCollateralFee = 0;
        object.endOfDayHoldDailyRealizedTradingTaxAndFee = 0;
        object.deltaCollateralFee = 0;
        object.paymentCashAccount = 0;
        object.loanPackageName = "";
        object.endOfMonthHoldCollateralFee = 0;
        object.endOfDayCollectedDebt = 0;
        object.initDayCollectedDebt = 0;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.grossAmount != null && message.hasOwnProperty("grossAmount"))
        object.grossAmount = options.json && !isFinite(message.grossAmount) ? String(message.grossAmount) : message.grossAmount;
      if (message.netAmount != null && message.hasOwnProperty("netAmount"))
        object.netAmount = options.json && !isFinite(message.netAmount) ? String(message.netAmount) : message.netAmount;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.dailyProfit != null && message.hasOwnProperty("dailyProfit"))
        object.dailyProfit = options.json && !isFinite(message.dailyProfit) ? String(message.dailyProfit) : message.dailyProfit;
      if (message.dailyTaxAndFee != null && message.hasOwnProperty("dailyTaxAndFee"))
        object.dailyTaxAndFee = options.json && !isFinite(message.dailyTaxAndFee) ? String(message.dailyTaxAndFee) : message.dailyTaxAndFee;
      if (message.endOfDayProfit != null && message.hasOwnProperty("endOfDayProfit"))
        object.endOfDayProfit = options.json && !isFinite(message.endOfDayProfit) ? String(message.endOfDayProfit) : message.endOfDayProfit;
      if (message.endOfDayTaxAndFee != null && message.hasOwnProperty("endOfDayTaxAndFee"))
        object.endOfDayTaxAndFee = options.json && !isFinite(message.endOfDayTaxAndFee) ? String(message.endOfDayTaxAndFee) : message.endOfDayTaxAndFee;
      if (message.endOfMonthCollateralFee != null && message.hasOwnProperty("endOfMonthCollateralFee"))
        object.endOfMonthCollateralFee = options.json && !isFinite(message.endOfMonthCollateralFee) ? String(message.endOfMonthCollateralFee) : message.endOfMonthCollateralFee;
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("endOfDayHoldDailyRealizedTradingTaxAndFee"))
        object.endOfDayHoldDailyRealizedTradingTaxAndFee = options.json && !isFinite(message.endOfDayHoldDailyRealizedTradingTaxAndFee) ? String(message.endOfDayHoldDailyRealizedTradingTaxAndFee) : message.endOfDayHoldDailyRealizedTradingTaxAndFee;
      if (message.deltaCollateralFee != null && message.hasOwnProperty("deltaCollateralFee"))
        object.deltaCollateralFee = options.json && !isFinite(message.deltaCollateralFee) ? String(message.deltaCollateralFee) : message.deltaCollateralFee;
      if (message.paymentCashAccount != null && message.hasOwnProperty("paymentCashAccount"))
        object.paymentCashAccount = options.json && !isFinite(message.paymentCashAccount) ? String(message.paymentCashAccount) : message.paymentCashAccount;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.endOfMonthHoldCollateralFee != null && message.hasOwnProperty("endOfMonthHoldCollateralFee"))
        object.endOfMonthHoldCollateralFee = options.json && !isFinite(message.endOfMonthHoldCollateralFee) ? String(message.endOfMonthHoldCollateralFee) : message.endOfMonthHoldCollateralFee;
      if (message.endOfDayCollectedDebt != null && message.hasOwnProperty("endOfDayCollectedDebt"))
        object.endOfDayCollectedDebt = options.json && !isFinite(message.endOfDayCollectedDebt) ? String(message.endOfDayCollectedDebt) : message.endOfDayCollectedDebt;
      if (message.initDayCollectedDebt != null && message.hasOwnProperty("initDayCollectedDebt"))
        object.initDayCollectedDebt = options.json && !isFinite(message.initDayCollectedDebt) ? String(message.initDayCollectedDebt) : message.initDayCollectedDebt;
      return object;
    };
    DerivativeReceiveProfitEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeReceiveProfitEvent;
  }();
  dnse2.DerivativeInitDayPaymentReport = function() {
    function DerivativeInitDayPaymentReport(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeInitDayPaymentReport.prototype.accountNo = "";
    DerivativeInitDayPaymentReport.prototype.investorId = "";
    DerivativeInitDayPaymentReport.prototype.custodyCode = "";
    DerivativeInitDayPaymentReport.prototype.dtaAccount = "";
    DerivativeInitDayPaymentReport.prototype.loanPackageId = 0;
    DerivativeInitDayPaymentReport.prototype.createdDate = null;
    DerivativeInitDayPaymentReport.prototype.endOfDayProfit = 0;
    DerivativeInitDayPaymentReport.prototype.endOfDayTaxAndFee = 0;
    DerivativeInitDayPaymentReport.prototype.endOfMonthCollateralFee = 0;
    DerivativeInitDayPaymentReport.prototype.endOfDayHoldDailyRealizedTradingTaxAndFee = 0;
    DerivativeInitDayPaymentReport.prototype.deltaCollateralFee = 0;
    DerivativeInitDayPaymentReport.prototype.endOfMonthHoldCollateralFee = 0;
    DerivativeInitDayPaymentReport.prototype.endOfDayCollectedDebt = 0;
    DerivativeInitDayPaymentReport.prototype.initDayCollectedDebt = 0;
    DerivativeInitDayPaymentReport.create = function create(properties) {
      return new DerivativeInitDayPaymentReport(properties);
    };
    DerivativeInitDayPaymentReport.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.dtaAccount != null && Object.hasOwnProperty.call(message, "dtaAccount"))
        writer.uint32(34).string(message.dtaAccount);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.endOfDayProfit != null && Object.hasOwnProperty.call(message, "endOfDayProfit"))
        writer.uint32(57).double(message.endOfDayProfit);
      if (message.endOfDayTaxAndFee != null && Object.hasOwnProperty.call(message, "endOfDayTaxAndFee"))
        writer.uint32(65).double(message.endOfDayTaxAndFee);
      if (message.endOfMonthCollateralFee != null && Object.hasOwnProperty.call(message, "endOfMonthCollateralFee"))
        writer.uint32(73).double(message.endOfMonthCollateralFee);
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && Object.hasOwnProperty.call(message, "endOfDayHoldDailyRealizedTradingTaxAndFee"))
        writer.uint32(81).double(message.endOfDayHoldDailyRealizedTradingTaxAndFee);
      if (message.deltaCollateralFee != null && Object.hasOwnProperty.call(message, "deltaCollateralFee"))
        writer.uint32(89).double(message.deltaCollateralFee);
      if (message.endOfMonthHoldCollateralFee != null && Object.hasOwnProperty.call(message, "endOfMonthHoldCollateralFee"))
        writer.uint32(97).double(message.endOfMonthHoldCollateralFee);
      if (message.endOfDayCollectedDebt != null && Object.hasOwnProperty.call(message, "endOfDayCollectedDebt"))
        writer.uint32(105).double(message.endOfDayCollectedDebt);
      if (message.initDayCollectedDebt != null && Object.hasOwnProperty.call(message, "initDayCollectedDebt"))
        writer.uint32(113).double(message.initDayCollectedDebt);
      return writer;
    };
    DerivativeInitDayPaymentReport.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeInitDayPaymentReport.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeInitDayPaymentReport();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.dtaAccount = reader.string();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.endOfDayProfit = reader.double();
            break;
          case 8:
            message.endOfDayTaxAndFee = reader.double();
            break;
          case 9:
            message.endOfMonthCollateralFee = reader.double();
            break;
          case 10:
            message.endOfDayHoldDailyRealizedTradingTaxAndFee = reader.double();
            break;
          case 11:
            message.deltaCollateralFee = reader.double();
            break;
          case 12:
            message.endOfMonthHoldCollateralFee = reader.double();
            break;
          case 13:
            message.endOfDayCollectedDebt = reader.double();
            break;
          case 14:
            message.initDayCollectedDebt = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeInitDayPaymentReport.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeInitDayPaymentReport.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount")) {
        if (!$util.isString(message.dtaAccount))
          return "dtaAccount: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.endOfDayProfit != null && message.hasOwnProperty("endOfDayProfit")) {
        if (typeof message.endOfDayProfit !== "number")
          return "endOfDayProfit: number expected";
      }
      if (message.endOfDayTaxAndFee != null && message.hasOwnProperty("endOfDayTaxAndFee")) {
        if (typeof message.endOfDayTaxAndFee !== "number")
          return "endOfDayTaxAndFee: number expected";
      }
      if (message.endOfMonthCollateralFee != null && message.hasOwnProperty("endOfMonthCollateralFee")) {
        if (typeof message.endOfMonthCollateralFee !== "number")
          return "endOfMonthCollateralFee: number expected";
      }
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("endOfDayHoldDailyRealizedTradingTaxAndFee")) {
        if (typeof message.endOfDayHoldDailyRealizedTradingTaxAndFee !== "number")
          return "endOfDayHoldDailyRealizedTradingTaxAndFee: number expected";
      }
      if (message.deltaCollateralFee != null && message.hasOwnProperty("deltaCollateralFee")) {
        if (typeof message.deltaCollateralFee !== "number")
          return "deltaCollateralFee: number expected";
      }
      if (message.endOfMonthHoldCollateralFee != null && message.hasOwnProperty("endOfMonthHoldCollateralFee")) {
        if (typeof message.endOfMonthHoldCollateralFee !== "number")
          return "endOfMonthHoldCollateralFee: number expected";
      }
      if (message.endOfDayCollectedDebt != null && message.hasOwnProperty("endOfDayCollectedDebt")) {
        if (typeof message.endOfDayCollectedDebt !== "number")
          return "endOfDayCollectedDebt: number expected";
      }
      if (message.initDayCollectedDebt != null && message.hasOwnProperty("initDayCollectedDebt")) {
        if (typeof message.initDayCollectedDebt !== "number")
          return "initDayCollectedDebt: number expected";
      }
      return null;
    };
    DerivativeInitDayPaymentReport.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeInitDayPaymentReport)
        return object;
      let message = new $root.dnse.DerivativeInitDayPaymentReport();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.dtaAccount != null)
        message.dtaAccount = String(object.dtaAccount);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativeInitDayPaymentReport.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.endOfDayProfit != null)
        message.endOfDayProfit = Number(object.endOfDayProfit);
      if (object.endOfDayTaxAndFee != null)
        message.endOfDayTaxAndFee = Number(object.endOfDayTaxAndFee);
      if (object.endOfMonthCollateralFee != null)
        message.endOfMonthCollateralFee = Number(object.endOfMonthCollateralFee);
      if (object.endOfDayHoldDailyRealizedTradingTaxAndFee != null)
        message.endOfDayHoldDailyRealizedTradingTaxAndFee = Number(object.endOfDayHoldDailyRealizedTradingTaxAndFee);
      if (object.deltaCollateralFee != null)
        message.deltaCollateralFee = Number(object.deltaCollateralFee);
      if (object.endOfMonthHoldCollateralFee != null)
        message.endOfMonthHoldCollateralFee = Number(object.endOfMonthHoldCollateralFee);
      if (object.endOfDayCollectedDebt != null)
        message.endOfDayCollectedDebt = Number(object.endOfDayCollectedDebt);
      if (object.initDayCollectedDebt != null)
        message.initDayCollectedDebt = Number(object.initDayCollectedDebt);
      return message;
    };
    DerivativeInitDayPaymentReport.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.investorId = "";
        object.custodyCode = "";
        object.dtaAccount = "";
        object.loanPackageId = 0;
        object.createdDate = null;
        object.endOfDayProfit = 0;
        object.endOfDayTaxAndFee = 0;
        object.endOfMonthCollateralFee = 0;
        object.endOfDayHoldDailyRealizedTradingTaxAndFee = 0;
        object.deltaCollateralFee = 0;
        object.endOfMonthHoldCollateralFee = 0;
        object.endOfDayCollectedDebt = 0;
        object.initDayCollectedDebt = 0;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.dtaAccount != null && message.hasOwnProperty("dtaAccount"))
        object.dtaAccount = message.dtaAccount;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.endOfDayProfit != null && message.hasOwnProperty("endOfDayProfit"))
        object.endOfDayProfit = options.json && !isFinite(message.endOfDayProfit) ? String(message.endOfDayProfit) : message.endOfDayProfit;
      if (message.endOfDayTaxAndFee != null && message.hasOwnProperty("endOfDayTaxAndFee"))
        object.endOfDayTaxAndFee = options.json && !isFinite(message.endOfDayTaxAndFee) ? String(message.endOfDayTaxAndFee) : message.endOfDayTaxAndFee;
      if (message.endOfMonthCollateralFee != null && message.hasOwnProperty("endOfMonthCollateralFee"))
        object.endOfMonthCollateralFee = options.json && !isFinite(message.endOfMonthCollateralFee) ? String(message.endOfMonthCollateralFee) : message.endOfMonthCollateralFee;
      if (message.endOfDayHoldDailyRealizedTradingTaxAndFee != null && message.hasOwnProperty("endOfDayHoldDailyRealizedTradingTaxAndFee"))
        object.endOfDayHoldDailyRealizedTradingTaxAndFee = options.json && !isFinite(message.endOfDayHoldDailyRealizedTradingTaxAndFee) ? String(message.endOfDayHoldDailyRealizedTradingTaxAndFee) : message.endOfDayHoldDailyRealizedTradingTaxAndFee;
      if (message.deltaCollateralFee != null && message.hasOwnProperty("deltaCollateralFee"))
        object.deltaCollateralFee = options.json && !isFinite(message.deltaCollateralFee) ? String(message.deltaCollateralFee) : message.deltaCollateralFee;
      if (message.endOfMonthHoldCollateralFee != null && message.hasOwnProperty("endOfMonthHoldCollateralFee"))
        object.endOfMonthHoldCollateralFee = options.json && !isFinite(message.endOfMonthHoldCollateralFee) ? String(message.endOfMonthHoldCollateralFee) : message.endOfMonthHoldCollateralFee;
      if (message.endOfDayCollectedDebt != null && message.hasOwnProperty("endOfDayCollectedDebt"))
        object.endOfDayCollectedDebt = options.json && !isFinite(message.endOfDayCollectedDebt) ? String(message.endOfDayCollectedDebt) : message.endOfDayCollectedDebt;
      if (message.initDayCollectedDebt != null && message.hasOwnProperty("initDayCollectedDebt"))
        object.initDayCollectedDebt = options.json && !isFinite(message.initDayCollectedDebt) ? String(message.initDayCollectedDebt) : message.initDayCollectedDebt;
      return object;
    };
    DerivativeInitDayPaymentReport.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeInitDayPaymentReport;
  }();
  dnse2.DerivativeMaturityEvent = function() {
    function DerivativeMaturityEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeMaturityEvent.prototype.investorId = "";
    DerivativeMaturityEvent.prototype.symbol = "";
    DerivativeMaturityEvent.prototype.deListedDate = null;
    DerivativeMaturityEvent.prototype.createdDate = null;
    DerivativeMaturityEvent.prototype.custodyCode = "";
    DerivativeMaturityEvent.prototype.accountNo = "";
    DerivativeMaturityEvent.prototype.fullName = "";
    DerivativeMaturityEvent.create = function create(properties) {
      return new DerivativeMaturityEvent(properties);
    };
    DerivativeMaturityEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.deListedDate != null && Object.hasOwnProperty.call(message, "deListedDate"))
        $root.google.protobuf.Timestamp.encode(message.deListedDate, writer.uint32(26).fork()).ldelim();
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(42).string(message.custodyCode);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(50).string(message.accountNo);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(58).string(message.fullName);
      return writer;
    };
    DerivativeMaturityEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeMaturityEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeMaturityEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.deListedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.custodyCode = reader.string();
            break;
          case 6:
            message.accountNo = reader.string();
            break;
          case 7:
            message.fullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeMaturityEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeMaturityEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.deListedDate != null && message.hasOwnProperty("deListedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.deListedDate);
        if (error)
          return "deListedDate." + error;
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      return null;
    };
    DerivativeMaturityEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeMaturityEvent)
        return object;
      let message = new $root.dnse.DerivativeMaturityEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.deListedDate != null) {
        if (typeof object.deListedDate !== "object")
          throw TypeError(".dnse.DerivativeMaturityEvent.deListedDate: object expected");
        message.deListedDate = $root.google.protobuf.Timestamp.fromObject(object.deListedDate);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativeMaturityEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      return message;
    };
    DerivativeMaturityEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.symbol = "";
        object.deListedDate = null;
        object.createdDate = null;
        object.custodyCode = "";
        object.accountNo = "";
        object.fullName = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.deListedDate != null && message.hasOwnProperty("deListedDate"))
        object.deListedDate = $root.google.protobuf.Timestamp.toObject(message.deListedDate, options);
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      return object;
    };
    DerivativeMaturityEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeMaturityEvent;
  }();
  dnse2.SacoBrokerRequestEvent = function() {
    function SacoBrokerRequestEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SacoBrokerRequestEvent.prototype.brokerId = "";
    SacoBrokerRequestEvent.prototype.customerId = "";
    SacoBrokerRequestEvent.prototype.custodyCode = "";
    SacoBrokerRequestEvent.prototype.requestType = "";
    SacoBrokerRequestEvent.prototype.customerName = "";
    SacoBrokerRequestEvent.prototype.brokerName = "";
    SacoBrokerRequestEvent.prototype.investorId = "";
    SacoBrokerRequestEvent.prototype.createdDate = null;
    SacoBrokerRequestEvent.prototype.requestId = 0;
    SacoBrokerRequestEvent.prototype.brokerEnId = "";
    SacoBrokerRequestEvent.prototype.status = "";
    SacoBrokerRequestEvent.prototype.commissionFee = null;
    SacoBrokerRequestEvent.prototype.creator = "";
    SacoBrokerRequestEvent.prototype.updater = "";
    SacoBrokerRequestEvent.prototype.updatedDate = null;
    SacoBrokerRequestEvent.prototype.senderName = "";
    SacoBrokerRequestEvent.prototype.acceptedBy = "";
    let $oneOfFields;
    Object.defineProperty(SacoBrokerRequestEvent.prototype, "_commissionFee", {
      get: $util.oneOfGetter($oneOfFields = ["commissionFee"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    SacoBrokerRequestEvent.create = function create(properties) {
      return new SacoBrokerRequestEvent(properties);
    };
    SacoBrokerRequestEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.brokerId != null && Object.hasOwnProperty.call(message, "brokerId"))
        writer.uint32(10).string(message.brokerId);
      if (message.customerId != null && Object.hasOwnProperty.call(message, "customerId"))
        writer.uint32(18).string(message.customerId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
        writer.uint32(34).string(message.requestType);
      if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
        writer.uint32(42).string(message.customerName);
      if (message.brokerName != null && Object.hasOwnProperty.call(message, "brokerName"))
        writer.uint32(50).string(message.brokerName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(58).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
        writer.uint32(72).int32(message.requestId);
      if (message.brokerEnId != null && Object.hasOwnProperty.call(message, "brokerEnId"))
        writer.uint32(82).string(message.brokerEnId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(90).string(message.status);
      if (message.commissionFee != null && Object.hasOwnProperty.call(message, "commissionFee"))
        writer.uint32(97).double(message.commissionFee);
      if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
        writer.uint32(106).string(message.creator);
      if (message.updater != null && Object.hasOwnProperty.call(message, "updater"))
        writer.uint32(114).string(message.updater);
      if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
        $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(122).fork()).ldelim();
      if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
        writer.uint32(130).string(message.senderName);
      if (message.acceptedBy != null && Object.hasOwnProperty.call(message, "acceptedBy"))
        writer.uint32(138).string(message.acceptedBy);
      return writer;
    };
    SacoBrokerRequestEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SacoBrokerRequestEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SacoBrokerRequestEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.brokerId = reader.string();
            break;
          case 2:
            message.customerId = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.requestType = reader.string();
            break;
          case 5:
            message.customerName = reader.string();
            break;
          case 6:
            message.brokerName = reader.string();
            break;
          case 7:
            message.investorId = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.requestId = reader.int32();
            break;
          case 10:
            message.brokerEnId = reader.string();
            break;
          case 11:
            message.status = reader.string();
            break;
          case 12:
            message.commissionFee = reader.double();
            break;
          case 13:
            message.creator = reader.string();
            break;
          case 14:
            message.updater = reader.string();
            break;
          case 15:
            message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 16:
            message.senderName = reader.string();
            break;
          case 17:
            message.acceptedBy = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SacoBrokerRequestEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SacoBrokerRequestEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.brokerId != null && message.hasOwnProperty("brokerId")) {
        if (!$util.isString(message.brokerId))
          return "brokerId: string expected";
      }
      if (message.customerId != null && message.hasOwnProperty("customerId")) {
        if (!$util.isString(message.customerId))
          return "customerId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.requestType != null && message.hasOwnProperty("requestType")) {
        if (!$util.isString(message.requestType))
          return "requestType: string expected";
      }
      if (message.customerName != null && message.hasOwnProperty("customerName")) {
        if (!$util.isString(message.customerName))
          return "customerName: string expected";
      }
      if (message.brokerName != null && message.hasOwnProperty("brokerName")) {
        if (!$util.isString(message.brokerName))
          return "brokerName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.requestId != null && message.hasOwnProperty("requestId")) {
        if (!$util.isInteger(message.requestId))
          return "requestId: integer expected";
      }
      if (message.brokerEnId != null && message.hasOwnProperty("brokerEnId")) {
        if (!$util.isString(message.brokerEnId))
          return "brokerEnId: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.commissionFee != null && message.hasOwnProperty("commissionFee")) {
        if (typeof message.commissionFee !== "number")
          return "commissionFee: number expected";
      }
      if (message.creator != null && message.hasOwnProperty("creator")) {
        if (!$util.isString(message.creator))
          return "creator: string expected";
      }
      if (message.updater != null && message.hasOwnProperty("updater")) {
        if (!$util.isString(message.updater))
          return "updater: string expected";
      }
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
        if (error)
          return "updatedDate." + error;
      }
      if (message.senderName != null && message.hasOwnProperty("senderName")) {
        if (!$util.isString(message.senderName))
          return "senderName: string expected";
      }
      if (message.acceptedBy != null && message.hasOwnProperty("acceptedBy")) {
        if (!$util.isString(message.acceptedBy))
          return "acceptedBy: string expected";
      }
      return null;
    };
    SacoBrokerRequestEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SacoBrokerRequestEvent)
        return object;
      let message = new $root.dnse.SacoBrokerRequestEvent();
      if (object.brokerId != null)
        message.brokerId = String(object.brokerId);
      if (object.customerId != null)
        message.customerId = String(object.customerId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.requestType != null)
        message.requestType = String(object.requestType);
      if (object.customerName != null)
        message.customerName = String(object.customerName);
      if (object.brokerName != null)
        message.brokerName = String(object.brokerName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SacoBrokerRequestEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.requestId != null)
        message.requestId = object.requestId | 0;
      if (object.brokerEnId != null)
        message.brokerEnId = String(object.brokerEnId);
      if (object.status != null)
        message.status = String(object.status);
      if (object.commissionFee != null)
        message.commissionFee = Number(object.commissionFee);
      if (object.creator != null)
        message.creator = String(object.creator);
      if (object.updater != null)
        message.updater = String(object.updater);
      if (object.updatedDate != null) {
        if (typeof object.updatedDate !== "object")
          throw TypeError(".dnse.SacoBrokerRequestEvent.updatedDate: object expected");
        message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
      }
      if (object.senderName != null)
        message.senderName = String(object.senderName);
      if (object.acceptedBy != null)
        message.acceptedBy = String(object.acceptedBy);
      return message;
    };
    SacoBrokerRequestEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.brokerId = "";
        object.customerId = "";
        object.custodyCode = "";
        object.requestType = "";
        object.customerName = "";
        object.brokerName = "";
        object.investorId = "";
        object.createdDate = null;
        object.requestId = 0;
        object.brokerEnId = "";
        object.status = "";
        object.creator = "";
        object.updater = "";
        object.updatedDate = null;
        object.senderName = "";
        object.acceptedBy = "";
      }
      if (message.brokerId != null && message.hasOwnProperty("brokerId"))
        object.brokerId = message.brokerId;
      if (message.customerId != null && message.hasOwnProperty("customerId"))
        object.customerId = message.customerId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.requestType != null && message.hasOwnProperty("requestType"))
        object.requestType = message.requestType;
      if (message.customerName != null && message.hasOwnProperty("customerName"))
        object.customerName = message.customerName;
      if (message.brokerName != null && message.hasOwnProperty("brokerName"))
        object.brokerName = message.brokerName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.requestId != null && message.hasOwnProperty("requestId"))
        object.requestId = message.requestId;
      if (message.brokerEnId != null && message.hasOwnProperty("brokerEnId"))
        object.brokerEnId = message.brokerEnId;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.commissionFee != null && message.hasOwnProperty("commissionFee")) {
        object.commissionFee = options.json && !isFinite(message.commissionFee) ? String(message.commissionFee) : message.commissionFee;
        if (options.oneofs)
          object._commissionFee = "commissionFee";
      }
      if (message.creator != null && message.hasOwnProperty("creator"))
        object.creator = message.creator;
      if (message.updater != null && message.hasOwnProperty("updater"))
        object.updater = message.updater;
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
        object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
      if (message.senderName != null && message.hasOwnProperty("senderName"))
        object.senderName = message.senderName;
      if (message.acceptedBy != null && message.hasOwnProperty("acceptedBy"))
        object.acceptedBy = message.acceptedBy;
      return object;
    };
    SacoBrokerRequestEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SacoBrokerRequestEvent;
  }();
  dnse2.DerivativeProfitLossCloseDealEvent = function() {
    function DerivativeProfitLossCloseDealEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeProfitLossCloseDealEvent.prototype.investorId = "";
    DerivativeProfitLossCloseDealEvent.prototype.accountNo = "";
    DerivativeProfitLossCloseDealEvent.prototype.custodyCode = "";
    DerivativeProfitLossCloseDealEvent.prototype.symbol = "";
    DerivativeProfitLossCloseDealEvent.prototype.side = "";
    DerivativeProfitLossCloseDealEvent.prototype.pnl = 0;
    DerivativeProfitLossCloseDealEvent.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativeProfitLossCloseDealEvent.prototype.createdDate = null;
    DerivativeProfitLossCloseDealEvent.prototype.dealId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativeProfitLossCloseDealEvent.create = function create(properties) {
      return new DerivativeProfitLossCloseDealEvent(properties);
    };
    DerivativeProfitLossCloseDealEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(42).string(message.side);
      if (message.pnl != null && Object.hasOwnProperty.call(message, "pnl"))
        writer.uint32(49).double(message.pnl);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(56).int64(message.quantity);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.dealId != null && Object.hasOwnProperty.call(message, "dealId"))
        writer.uint32(72).int64(message.dealId);
      return writer;
    };
    DerivativeProfitLossCloseDealEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeProfitLossCloseDealEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeProfitLossCloseDealEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.side = reader.string();
            break;
          case 6:
            message.pnl = reader.double();
            break;
          case 7:
            message.quantity = reader.int64();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.dealId = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeProfitLossCloseDealEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeProfitLossCloseDealEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.pnl != null && message.hasOwnProperty("pnl")) {
        if (typeof message.pnl !== "number")
          return "pnl: number expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.dealId != null && message.hasOwnProperty("dealId")) {
        if (!$util.isInteger(message.dealId) && !(message.dealId && $util.isInteger(message.dealId.low) && $util.isInteger(message.dealId.high)))
          return "dealId: integer|Long expected";
      }
      return null;
    };
    DerivativeProfitLossCloseDealEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeProfitLossCloseDealEvent)
        return object;
      let message = new $root.dnse.DerivativeProfitLossCloseDealEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.side != null)
        message.side = String(object.side);
      if (object.pnl != null)
        message.pnl = Number(object.pnl);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativeProfitLossCloseDealEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.dealId != null) {
        if ($util.Long)
          (message.dealId = $util.Long.fromValue(object.dealId)).unsigned = false;
        else if (typeof object.dealId === "string")
          message.dealId = parseInt(object.dealId, 10);
        else if (typeof object.dealId === "number")
          message.dealId = object.dealId;
        else if (typeof object.dealId === "object")
          message.dealId = new $util.LongBits(object.dealId.low >>> 0, object.dealId.high >>> 0).toNumber();
      }
      return message;
    };
    DerivativeProfitLossCloseDealEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.accountNo = "";
        object.custodyCode = "";
        object.symbol = "";
        object.side = "";
        object.pnl = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dealId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.dealId = options.longs === String ? "0" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.pnl != null && message.hasOwnProperty("pnl"))
        object.pnl = options.json && !isFinite(message.pnl) ? String(message.pnl) : message.pnl;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.dealId != null && message.hasOwnProperty("dealId"))
        if (typeof message.dealId === "number")
          object.dealId = options.longs === String ? String(message.dealId) : message.dealId;
        else
          object.dealId = options.longs === String ? $util.Long.prototype.toString.call(message.dealId) : options.longs === Number ? new $util.LongBits(message.dealId.low >>> 0, message.dealId.high >>> 0).toNumber() : message.dealId;
      return object;
    };
    DerivativeProfitLossCloseDealEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeProfitLossCloseDealEvent;
  }();
  dnse2.PendingDepositEvent = function() {
    function PendingDepositEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    PendingDepositEvent.prototype.custodyCode = "";
    PendingDepositEvent.prototype.investorId = "";
    PendingDepositEvent.prototype.accountNo = "";
    PendingDepositEvent.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PendingDepositEvent.prototype.amount = 0;
    PendingDepositEvent.create = function create(properties) {
      return new PendingDepositEvent(properties);
    };
    PendingDepositEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(32).int64(message.loanPackageId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(41).double(message.amount);
      return writer;
    };
    PendingDepositEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    PendingDepositEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.PendingDepositEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.loanPackageId = reader.int64();
            break;
          case 5:
            message.amount = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    PendingDepositEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    PendingDepositEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
          return "loanPackageId: integer|Long expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      return null;
    };
    PendingDepositEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.PendingDepositEvent)
        return object;
      let message = new $root.dnse.PendingDepositEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanPackageId != null) {
        if ($util.Long)
          (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
        else if (typeof object.loanPackageId === "string")
          message.loanPackageId = parseInt(object.loanPackageId, 10);
        else if (typeof object.loanPackageId === "number")
          message.loanPackageId = object.loanPackageId;
        else if (typeof object.loanPackageId === "object")
          message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
      }
      if (object.amount != null)
        message.amount = Number(object.amount);
      return message;
    };
    PendingDepositEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanPackageId = options.longs === String ? "0" : 0;
        object.amount = 0;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        if (typeof message.loanPackageId === "number")
          object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
        else
          object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      return object;
    };
    PendingDepositEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return PendingDepositEvent;
  }();
  dnse2.DerivativePrepayLoanEvent = function() {
    function DerivativePrepayLoanEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativePrepayLoanEvent.prototype.custodyCode = "";
    DerivativePrepayLoanEvent.prototype.investorId = "";
    DerivativePrepayLoanEvent.prototype.accountNo = "";
    DerivativePrepayLoanEvent.prototype.accountTypeName = "";
    DerivativePrepayLoanEvent.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativePrepayLoanEvent.prototype.amount = 0;
    DerivativePrepayLoanEvent.prototype.availableCash = 0;
    DerivativePrepayLoanEvent.prototype.remainDebt = 0;
    DerivativePrepayLoanEvent.prototype.symbol = "";
    DerivativePrepayLoanEvent.prototype.createdDate = null;
    DerivativePrepayLoanEvent.prototype.initialRate = 0;
    DerivativePrepayLoanEvent.prototype.remainSecureAmount = 0;
    DerivativePrepayLoanEvent.prototype.loanType = "";
    DerivativePrepayLoanEvent.prototype.loanPackageName = "";
    DerivativePrepayLoanEvent.create = function create(properties) {
      return new DerivativePrepayLoanEvent(properties);
    };
    DerivativePrepayLoanEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int64(message.loanPackageId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(49).double(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(57).double(message.availableCash);
      if (message.remainDebt != null && Object.hasOwnProperty.call(message, "remainDebt"))
        writer.uint32(65).double(message.remainDebt);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(74).string(message.symbol);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(89).double(message.initialRate);
      if (message.remainSecureAmount != null && Object.hasOwnProperty.call(message, "remainSecureAmount"))
        writer.uint32(97).double(message.remainSecureAmount);
      if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
        writer.uint32(106).string(message.loanType);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(114).string(message.loanPackageName);
      return writer;
    };
    DerivativePrepayLoanEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativePrepayLoanEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativePrepayLoanEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.loanPackageId = reader.int64();
            break;
          case 6:
            message.amount = reader.double();
            break;
          case 7:
            message.availableCash = reader.double();
            break;
          case 8:
            message.remainDebt = reader.double();
            break;
          case 9:
            message.symbol = reader.string();
            break;
          case 10:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.initialRate = reader.double();
            break;
          case 12:
            message.remainSecureAmount = reader.double();
            break;
          case 13:
            message.loanType = reader.string();
            break;
          case 14:
            message.loanPackageName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativePrepayLoanEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativePrepayLoanEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
          return "loanPackageId: integer|Long expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (typeof message.availableCash !== "number")
          return "availableCash: number expected";
      }
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt")) {
        if (typeof message.remainDebt !== "number")
          return "remainDebt: number expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      if (message.remainSecureAmount != null && message.hasOwnProperty("remainSecureAmount")) {
        if (typeof message.remainSecureAmount !== "number")
          return "remainSecureAmount: number expected";
      }
      if (message.loanType != null && message.hasOwnProperty("loanType")) {
        if (!$util.isString(message.loanType))
          return "loanType: string expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      return null;
    };
    DerivativePrepayLoanEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativePrepayLoanEvent)
        return object;
      let message = new $root.dnse.DerivativePrepayLoanEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.loanPackageId != null) {
        if ($util.Long)
          (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
        else if (typeof object.loanPackageId === "string")
          message.loanPackageId = parseInt(object.loanPackageId, 10);
        else if (typeof object.loanPackageId === "number")
          message.loanPackageId = object.loanPackageId;
        else if (typeof object.loanPackageId === "object")
          message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
      }
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.availableCash != null)
        message.availableCash = Number(object.availableCash);
      if (object.remainDebt != null)
        message.remainDebt = Number(object.remainDebt);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DerivativePrepayLoanEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      if (object.remainSecureAmount != null)
        message.remainSecureAmount = Number(object.remainSecureAmount);
      if (object.loanType != null)
        message.loanType = String(object.loanType);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      return message;
    };
    DerivativePrepayLoanEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.investorId = "";
        object.accountNo = "";
        object.accountTypeName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanPackageId = options.longs === String ? "0" : 0;
        object.amount = 0;
        object.availableCash = 0;
        object.remainDebt = 0;
        object.symbol = "";
        object.createdDate = null;
        object.initialRate = 0;
        object.remainSecureAmount = 0;
        object.loanType = "";
        object.loanPackageName = "";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        if (typeof message.loanPackageId === "number")
          object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
        else
          object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        object.availableCash = options.json && !isFinite(message.availableCash) ? String(message.availableCash) : message.availableCash;
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt"))
        object.remainDebt = options.json && !isFinite(message.remainDebt) ? String(message.remainDebt) : message.remainDebt;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      if (message.remainSecureAmount != null && message.hasOwnProperty("remainSecureAmount"))
        object.remainSecureAmount = options.json && !isFinite(message.remainSecureAmount) ? String(message.remainSecureAmount) : message.remainSecureAmount;
      if (message.loanType != null && message.hasOwnProperty("loanType"))
        object.loanType = message.loanType;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      return object;
    };
    DerivativePrepayLoanEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativePrepayLoanEvent;
  }();
  dnse2.AutoDerivativePrepayLoanEvent = function() {
    function AutoDerivativePrepayLoanEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AutoDerivativePrepayLoanEvent.prototype.custodyCode = "";
    AutoDerivativePrepayLoanEvent.prototype.investorId = "";
    AutoDerivativePrepayLoanEvent.prototype.accountNo = "";
    AutoDerivativePrepayLoanEvent.prototype.accountTypeName = "";
    AutoDerivativePrepayLoanEvent.prototype.loanPackageName = "";
    AutoDerivativePrepayLoanEvent.prototype.amount = 0;
    AutoDerivativePrepayLoanEvent.prototype.availableCash = 0;
    AutoDerivativePrepayLoanEvent.prototype.remainDebt = 0;
    AutoDerivativePrepayLoanEvent.prototype.symbol = "";
    AutoDerivativePrepayLoanEvent.prototype.disbursedDate = null;
    AutoDerivativePrepayLoanEvent.prototype.loanType = "";
    AutoDerivativePrepayLoanEvent.prototype.loanId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AutoDerivativePrepayLoanEvent.create = function create(properties) {
      return new AutoDerivativePrepayLoanEvent(properties);
    };
    AutoDerivativePrepayLoanEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(42).string(message.loanPackageName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(49).double(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(57).double(message.availableCash);
      if (message.remainDebt != null && Object.hasOwnProperty.call(message, "remainDebt"))
        writer.uint32(65).double(message.remainDebt);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(74).string(message.symbol);
      if (message.disbursedDate != null && Object.hasOwnProperty.call(message, "disbursedDate"))
        $root.google.protobuf.Timestamp.encode(message.disbursedDate, writer.uint32(82).fork()).ldelim();
      if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
        writer.uint32(90).string(message.loanType);
      if (message.loanId != null && Object.hasOwnProperty.call(message, "loanId"))
        writer.uint32(96).int64(message.loanId);
      return writer;
    };
    AutoDerivativePrepayLoanEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AutoDerivativePrepayLoanEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.AutoDerivativePrepayLoanEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.loanPackageName = reader.string();
            break;
          case 6:
            message.amount = reader.double();
            break;
          case 7:
            message.availableCash = reader.double();
            break;
          case 8:
            message.remainDebt = reader.double();
            break;
          case 9:
            message.symbol = reader.string();
            break;
          case 10:
            message.disbursedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.loanType = reader.string();
            break;
          case 12:
            message.loanId = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AutoDerivativePrepayLoanEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AutoDerivativePrepayLoanEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (typeof message.availableCash !== "number")
          return "availableCash: number expected";
      }
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt")) {
        if (typeof message.remainDebt !== "number")
          return "remainDebt: number expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.disbursedDate != null && message.hasOwnProperty("disbursedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.disbursedDate);
        if (error)
          return "disbursedDate." + error;
      }
      if (message.loanType != null && message.hasOwnProperty("loanType")) {
        if (!$util.isString(message.loanType))
          return "loanType: string expected";
      }
      if (message.loanId != null && message.hasOwnProperty("loanId")) {
        if (!$util.isInteger(message.loanId) && !(message.loanId && $util.isInteger(message.loanId.low) && $util.isInteger(message.loanId.high)))
          return "loanId: integer|Long expected";
      }
      return null;
    };
    AutoDerivativePrepayLoanEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.AutoDerivativePrepayLoanEvent)
        return object;
      let message = new $root.dnse.AutoDerivativePrepayLoanEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.availableCash != null)
        message.availableCash = Number(object.availableCash);
      if (object.remainDebt != null)
        message.remainDebt = Number(object.remainDebt);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.disbursedDate != null) {
        if (typeof object.disbursedDate !== "object")
          throw TypeError(".dnse.AutoDerivativePrepayLoanEvent.disbursedDate: object expected");
        message.disbursedDate = $root.google.protobuf.Timestamp.fromObject(object.disbursedDate);
      }
      if (object.loanType != null)
        message.loanType = String(object.loanType);
      if (object.loanId != null) {
        if ($util.Long)
          (message.loanId = $util.Long.fromValue(object.loanId)).unsigned = false;
        else if (typeof object.loanId === "string")
          message.loanId = parseInt(object.loanId, 10);
        else if (typeof object.loanId === "number")
          message.loanId = object.loanId;
        else if (typeof object.loanId === "object")
          message.loanId = new $util.LongBits(object.loanId.low >>> 0, object.loanId.high >>> 0).toNumber();
      }
      return message;
    };
    AutoDerivativePrepayLoanEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.investorId = "";
        object.accountNo = "";
        object.accountTypeName = "";
        object.loanPackageName = "";
        object.amount = 0;
        object.availableCash = 0;
        object.remainDebt = 0;
        object.symbol = "";
        object.disbursedDate = null;
        object.loanType = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanId = options.longs === String ? "0" : 0;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        object.availableCash = options.json && !isFinite(message.availableCash) ? String(message.availableCash) : message.availableCash;
      if (message.remainDebt != null && message.hasOwnProperty("remainDebt"))
        object.remainDebt = options.json && !isFinite(message.remainDebt) ? String(message.remainDebt) : message.remainDebt;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.disbursedDate != null && message.hasOwnProperty("disbursedDate"))
        object.disbursedDate = $root.google.protobuf.Timestamp.toObject(message.disbursedDate, options);
      if (message.loanType != null && message.hasOwnProperty("loanType"))
        object.loanType = message.loanType;
      if (message.loanId != null && message.hasOwnProperty("loanId"))
        if (typeof message.loanId === "number")
          object.loanId = options.longs === String ? String(message.loanId) : message.loanId;
        else
          object.loanId = options.longs === String ? $util.Long.prototype.toString.call(message.loanId) : options.longs === Number ? new $util.LongBits(message.loanId.low >>> 0, message.loanId.high >>> 0).toNumber() : message.loanId;
      return object;
    };
    AutoDerivativePrepayLoanEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return AutoDerivativePrepayLoanEvent;
  }();
  dnse2.EndOfMonthInterestPaymentEvent = function() {
    function EndOfMonthInterestPaymentEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EndOfMonthInterestPaymentEvent.prototype.investorId = "";
    EndOfMonthInterestPaymentEvent.prototype.accountNo = "";
    EndOfMonthInterestPaymentEvent.prototype.custodyCode = "";
    EndOfMonthInterestPaymentEvent.prototype.accountTypeName = "";
    EndOfMonthInterestPaymentEvent.prototype.amount = 0;
    EndOfMonthInterestPaymentEvent.prototype.availableCash = 0;
    EndOfMonthInterestPaymentEvent.prototype.createdDate = null;
    EndOfMonthInterestPaymentEvent.create = function create(properties) {
      return new EndOfMonthInterestPaymentEvent(properties);
    };
    EndOfMonthInterestPaymentEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(41).double(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(49).double(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EndOfMonthInterestPaymentEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EndOfMonthInterestPaymentEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EndOfMonthInterestPaymentEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.amount = reader.double();
            break;
          case 6:
            message.availableCash = reader.double();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EndOfMonthInterestPaymentEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EndOfMonthInterestPaymentEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (typeof message.availableCash !== "number")
          return "availableCash: number expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    EndOfMonthInterestPaymentEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EndOfMonthInterestPaymentEvent)
        return object;
      let message = new $root.dnse.EndOfMonthInterestPaymentEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.availableCash != null)
        message.availableCash = Number(object.availableCash);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.EndOfMonthInterestPaymentEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    EndOfMonthInterestPaymentEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.accountNo = "";
        object.custodyCode = "";
        object.accountTypeName = "";
        object.amount = 0;
        object.availableCash = 0;
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        object.availableCash = options.json && !isFinite(message.availableCash) ? String(message.availableCash) : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    EndOfMonthInterestPaymentEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EndOfMonthInterestPaymentEvent;
  }();
  dnse2.InternalEndOfMonthFdsInterestPayment = function() {
    function InternalEndOfMonthFdsInterestPayment(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InternalEndOfMonthFdsInterestPayment.prototype.investorId = "";
    InternalEndOfMonthFdsInterestPayment.prototype.custodyCode = "";
    InternalEndOfMonthFdsInterestPayment.prototype.accountNo = "";
    InternalEndOfMonthFdsInterestPayment.prototype.dtaAccountNo = "";
    InternalEndOfMonthFdsInterestPayment.prototype.amount = 0;
    InternalEndOfMonthFdsInterestPayment.prototype.bizDate = "";
    InternalEndOfMonthFdsInterestPayment.prototype.createdDate = null;
    InternalEndOfMonthFdsInterestPayment.prototype.interestAmount = 0;
    InternalEndOfMonthFdsInterestPayment.create = function create(properties) {
      return new InternalEndOfMonthFdsInterestPayment(properties);
    };
    InternalEndOfMonthFdsInterestPayment.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.dtaAccountNo != null && Object.hasOwnProperty.call(message, "dtaAccountNo"))
        writer.uint32(34).string(message.dtaAccountNo);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(41).double(message.amount);
      if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
        writer.uint32(50).string(message.bizDate);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.interestAmount != null && Object.hasOwnProperty.call(message, "interestAmount"))
        writer.uint32(65).double(message.interestAmount);
      return writer;
    };
    InternalEndOfMonthFdsInterestPayment.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InternalEndOfMonthFdsInterestPayment.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.InternalEndOfMonthFdsInterestPayment();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.dtaAccountNo = reader.string();
            break;
          case 5:
            message.amount = reader.double();
            break;
          case 6:
            message.bizDate = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.interestAmount = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InternalEndOfMonthFdsInterestPayment.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InternalEndOfMonthFdsInterestPayment.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.dtaAccountNo != null && message.hasOwnProperty("dtaAccountNo")) {
        if (!$util.isString(message.dtaAccountNo))
          return "dtaAccountNo: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
        if (!$util.isString(message.bizDate))
          return "bizDate: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.interestAmount != null && message.hasOwnProperty("interestAmount")) {
        if (typeof message.interestAmount !== "number")
          return "interestAmount: number expected";
      }
      return null;
    };
    InternalEndOfMonthFdsInterestPayment.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.InternalEndOfMonthFdsInterestPayment)
        return object;
      let message = new $root.dnse.InternalEndOfMonthFdsInterestPayment();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.dtaAccountNo != null)
        message.dtaAccountNo = String(object.dtaAccountNo);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.bizDate != null)
        message.bizDate = String(object.bizDate);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.InternalEndOfMonthFdsInterestPayment.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.interestAmount != null)
        message.interestAmount = Number(object.interestAmount);
      return message;
    };
    InternalEndOfMonthFdsInterestPayment.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.accountNo = "";
        object.dtaAccountNo = "";
        object.amount = 0;
        object.bizDate = "";
        object.createdDate = null;
        object.interestAmount = 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.dtaAccountNo != null && message.hasOwnProperty("dtaAccountNo"))
        object.dtaAccountNo = message.dtaAccountNo;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.bizDate != null && message.hasOwnProperty("bizDate"))
        object.bizDate = message.bizDate;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.interestAmount != null && message.hasOwnProperty("interestAmount"))
        object.interestAmount = options.json && !isFinite(message.interestAmount) ? String(message.interestAmount) : message.interestAmount;
      return object;
    };
    InternalEndOfMonthFdsInterestPayment.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return InternalEndOfMonthFdsInterestPayment;
  }();
  dnse2.SystemMaintain = function() {
    function SystemMaintain(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SystemMaintain.prototype.id = "";
    SystemMaintain.prototype.status = "";
    SystemMaintain.prototype.maintainWeb = false;
    SystemMaintain.prototype.maintainApp = false;
    SystemMaintain.prototype.note = "";
    SystemMaintain.prototype.maintainFrom = null;
    SystemMaintain.prototype.maintainTo = null;
    SystemMaintain.prototype.modifiedDate = null;
    SystemMaintain.create = function create(properties) {
      return new SystemMaintain(properties);
    };
    SystemMaintain.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(18).string(message.status);
      if (message.maintainWeb != null && Object.hasOwnProperty.call(message, "maintainWeb"))
        writer.uint32(24).bool(message.maintainWeb);
      if (message.maintainApp != null && Object.hasOwnProperty.call(message, "maintainApp"))
        writer.uint32(32).bool(message.maintainApp);
      if (message.note != null && Object.hasOwnProperty.call(message, "note"))
        writer.uint32(42).string(message.note);
      if (message.maintainFrom != null && Object.hasOwnProperty.call(message, "maintainFrom"))
        $root.google.protobuf.Timestamp.encode(message.maintainFrom, writer.uint32(50).fork()).ldelim();
      if (message.maintainTo != null && Object.hasOwnProperty.call(message, "maintainTo"))
        $root.google.protobuf.Timestamp.encode(message.maintainTo, writer.uint32(58).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    SystemMaintain.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SystemMaintain.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SystemMaintain();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.status = reader.string();
            break;
          case 3:
            message.maintainWeb = reader.bool();
            break;
          case 4:
            message.maintainApp = reader.bool();
            break;
          case 5:
            message.note = reader.string();
            break;
          case 6:
            message.maintainFrom = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.maintainTo = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SystemMaintain.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SystemMaintain.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.maintainWeb != null && message.hasOwnProperty("maintainWeb")) {
        if (typeof message.maintainWeb !== "boolean")
          return "maintainWeb: boolean expected";
      }
      if (message.maintainApp != null && message.hasOwnProperty("maintainApp")) {
        if (typeof message.maintainApp !== "boolean")
          return "maintainApp: boolean expected";
      }
      if (message.note != null && message.hasOwnProperty("note")) {
        if (!$util.isString(message.note))
          return "note: string expected";
      }
      if (message.maintainFrom != null && message.hasOwnProperty("maintainFrom")) {
        let error = $root.google.protobuf.Timestamp.verify(message.maintainFrom);
        if (error)
          return "maintainFrom." + error;
      }
      if (message.maintainTo != null && message.hasOwnProperty("maintainTo")) {
        let error = $root.google.protobuf.Timestamp.verify(message.maintainTo);
        if (error)
          return "maintainTo." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      return null;
    };
    SystemMaintain.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SystemMaintain)
        return object;
      let message = new $root.dnse.SystemMaintain();
      if (object.id != null)
        message.id = String(object.id);
      if (object.status != null)
        message.status = String(object.status);
      if (object.maintainWeb != null)
        message.maintainWeb = Boolean(object.maintainWeb);
      if (object.maintainApp != null)
        message.maintainApp = Boolean(object.maintainApp);
      if (object.note != null)
        message.note = String(object.note);
      if (object.maintainFrom != null) {
        if (typeof object.maintainFrom !== "object")
          throw TypeError(".dnse.SystemMaintain.maintainFrom: object expected");
        message.maintainFrom = $root.google.protobuf.Timestamp.fromObject(object.maintainFrom);
      }
      if (object.maintainTo != null) {
        if (typeof object.maintainTo !== "object")
          throw TypeError(".dnse.SystemMaintain.maintainTo: object expected");
        message.maintainTo = $root.google.protobuf.Timestamp.fromObject(object.maintainTo);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.SystemMaintain.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      return message;
    };
    SystemMaintain.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.status = "";
        object.maintainWeb = false;
        object.maintainApp = false;
        object.note = "";
        object.maintainFrom = null;
        object.maintainTo = null;
        object.modifiedDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.maintainWeb != null && message.hasOwnProperty("maintainWeb"))
        object.maintainWeb = message.maintainWeb;
      if (message.maintainApp != null && message.hasOwnProperty("maintainApp"))
        object.maintainApp = message.maintainApp;
      if (message.note != null && message.hasOwnProperty("note"))
        object.note = message.note;
      if (message.maintainFrom != null && message.hasOwnProperty("maintainFrom"))
        object.maintainFrom = $root.google.protobuf.Timestamp.toObject(message.maintainFrom, options);
      if (message.maintainTo != null && message.hasOwnProperty("maintainTo"))
        object.maintainTo = $root.google.protobuf.Timestamp.toObject(message.maintainTo, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      return object;
    };
    SystemMaintain.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SystemMaintain;
  }();
  dnse2.PendingDepositAndWithdrawEvent = function() {
    function PendingDepositAndWithdrawEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    PendingDepositAndWithdrawEvent.prototype.custodyCode = "";
    PendingDepositAndWithdrawEvent.prototype.investorId = "";
    PendingDepositAndWithdrawEvent.prototype.accountNo = "";
    PendingDepositAndWithdrawEvent.prototype.amount = 0;
    PendingDepositAndWithdrawEvent.create = function create(properties) {
      return new PendingDepositAndWithdrawEvent(properties);
    };
    PendingDepositAndWithdrawEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(33).double(message.amount);
      return writer;
    };
    PendingDepositAndWithdrawEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    PendingDepositAndWithdrawEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.PendingDepositAndWithdrawEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.amount = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    PendingDepositAndWithdrawEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    PendingDepositAndWithdrawEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      return null;
    };
    PendingDepositAndWithdrawEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.PendingDepositAndWithdrawEvent)
        return object;
      let message = new $root.dnse.PendingDepositAndWithdrawEvent();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.amount != null)
        message.amount = Number(object.amount);
      return message;
    };
    PendingDepositAndWithdrawEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.investorId = "";
        object.accountNo = "";
        object.amount = 0;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      return object;
    };
    PendingDepositAndWithdrawEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return PendingDepositAndWithdrawEvent;
  }();
  dnse2.DealSecureWithdrawEvent = function() {
    function DealSecureWithdrawEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DealSecureWithdrawEvent.prototype.accountNo = "";
    DealSecureWithdrawEvent.prototype.investorId = "";
    DealSecureWithdrawEvent.prototype.symbol = "";
    DealSecureWithdrawEvent.prototype.accountTypeName = "";
    DealSecureWithdrawEvent.prototype.loanPackageId = 0;
    DealSecureWithdrawEvent.prototype.loanPackageName = "";
    DealSecureWithdrawEvent.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DealSecureWithdrawEvent.prototype.createdDate = null;
    DealSecureWithdrawEvent.prototype.triggerFromSystem = false;
    DealSecureWithdrawEvent.create = function create(properties) {
      return new DealSecureWithdrawEvent(properties);
    };
    DealSecureWithdrawEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(40).int32(message.loanPackageId);
      if (message.loanPackageName != null && Object.hasOwnProperty.call(message, "loanPackageName"))
        writer.uint32(50).string(message.loanPackageName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(56).int64(message.amount);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.triggerFromSystem != null && Object.hasOwnProperty.call(message, "triggerFromSystem"))
        writer.uint32(72).bool(message.triggerFromSystem);
      return writer;
    };
    DealSecureWithdrawEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DealSecureWithdrawEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DealSecureWithdrawEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.loanPackageId = reader.int32();
            break;
          case 6:
            message.loanPackageName = reader.string();
            break;
          case 7:
            message.amount = reader.int64();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.triggerFromSystem = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DealSecureWithdrawEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DealSecureWithdrawEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName")) {
        if (!$util.isString(message.loanPackageName))
          return "loanPackageName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.triggerFromSystem != null && message.hasOwnProperty("triggerFromSystem")) {
        if (typeof message.triggerFromSystem !== "boolean")
          return "triggerFromSystem: boolean expected";
      }
      return null;
    };
    DealSecureWithdrawEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DealSecureWithdrawEvent)
        return object;
      let message = new $root.dnse.DealSecureWithdrawEvent();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.loanPackageName != null)
        message.loanPackageName = String(object.loanPackageName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.DealSecureWithdrawEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.triggerFromSystem != null)
        message.triggerFromSystem = Boolean(object.triggerFromSystem);
      return message;
    };
    DealSecureWithdrawEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.investorId = "";
        object.symbol = "";
        object.accountTypeName = "";
        object.loanPackageId = 0;
        object.loanPackageName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.triggerFromSystem = false;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.loanPackageName != null && message.hasOwnProperty("loanPackageName"))
        object.loanPackageName = message.loanPackageName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.triggerFromSystem != null && message.hasOwnProperty("triggerFromSystem"))
        object.triggerFromSystem = message.triggerFromSystem;
      return object;
    };
    DealSecureWithdrawEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DealSecureWithdrawEvent;
  }();
  dnse2.DerivativeHoldCollateralFeeEvent = function() {
    function DerivativeHoldCollateralFeeEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeHoldCollateralFeeEvent.prototype.accountNo = "";
    DerivativeHoldCollateralFeeEvent.prototype.amount = 0;
    DerivativeHoldCollateralFeeEvent.prototype.type = "";
    DerivativeHoldCollateralFeeEvent.prototype.loanPackageId = 0;
    DerivativeHoldCollateralFeeEvent.create = function create(properties) {
      return new DerivativeHoldCollateralFeeEvent(properties);
    };
    DerivativeHoldCollateralFeeEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(17).double(message.amount);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(26).string(message.type);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(32).int32(message.loanPackageId);
      return writer;
    };
    DerivativeHoldCollateralFeeEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeHoldCollateralFeeEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeHoldCollateralFeeEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.amount = reader.double();
            break;
          case 3:
            message.type = reader.string();
            break;
          case 4:
            message.loanPackageId = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeHoldCollateralFeeEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeHoldCollateralFeeEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      return null;
    };
    DerivativeHoldCollateralFeeEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeHoldCollateralFeeEvent)
        return object;
      let message = new $root.dnse.DerivativeHoldCollateralFeeEvent();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.type != null)
        message.type = String(object.type);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      return message;
    };
    DerivativeHoldCollateralFeeEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.amount = 0;
        object.type = "";
        object.loanPackageId = 0;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      return object;
    };
    DerivativeHoldCollateralFeeEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeHoldCollateralFeeEvent;
  }();
  dnse2.UserChangeRequestStatus = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "OPEN"] = 0;
    values[valuesById[1] = "MAKER_APPROVED"] = 1;
    values[valuesById[2] = "CANCELED"] = 2;
    values[valuesById[3] = "CHECKER_APPROVED"] = 3;
    values[valuesById[4] = "APPROVED"] = 4;
    values[valuesById[5] = "REJECTED"] = 5;
    return values;
  }();
  dnse2.BpmUserChangeRequestUpdateEvent = function() {
    function BpmUserChangeRequestUpdateEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BpmUserChangeRequestUpdateEvent.prototype.requestId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BpmUserChangeRequestUpdateEvent.prototype.action = 0;
    BpmUserChangeRequestUpdateEvent.prototype.status = 0;
    BpmUserChangeRequestUpdateEvent.prototype.error = null;
    BpmUserChangeRequestUpdateEvent.prototype.makerApprovedData = null;
    BpmUserChangeRequestUpdateEvent.prototype.note = null;
    BpmUserChangeRequestUpdateEvent.prototype.rejectionReason = null;
    let $oneOfFields;
    Object.defineProperty(BpmUserChangeRequestUpdateEvent.prototype, "_error", {
      get: $util.oneOfGetter($oneOfFields = ["error"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(BpmUserChangeRequestUpdateEvent.prototype, "_makerApprovedData", {
      get: $util.oneOfGetter($oneOfFields = ["makerApprovedData"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(BpmUserChangeRequestUpdateEvent.prototype, "_note", {
      get: $util.oneOfGetter($oneOfFields = ["note"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(BpmUserChangeRequestUpdateEvent.prototype, "_rejectionReason", {
      get: $util.oneOfGetter($oneOfFields = ["rejectionReason"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    BpmUserChangeRequestUpdateEvent.create = function create(properties) {
      return new BpmUserChangeRequestUpdateEvent(properties);
    };
    BpmUserChangeRequestUpdateEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
        writer.uint32(8).int64(message.requestId);
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(16).int32(message.action);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(24).int32(message.status);
      if (message.error != null && Object.hasOwnProperty.call(message, "error"))
        writer.uint32(34).string(message.error);
      if (message.makerApprovedData != null && Object.hasOwnProperty.call(message, "makerApprovedData"))
        writer.uint32(42).string(message.makerApprovedData);
      if (message.note != null && Object.hasOwnProperty.call(message, "note"))
        writer.uint32(50).string(message.note);
      if (message.rejectionReason != null && Object.hasOwnProperty.call(message, "rejectionReason"))
        writer.uint32(56).int32(message.rejectionReason);
      return writer;
    };
    BpmUserChangeRequestUpdateEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BpmUserChangeRequestUpdateEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BpmUserChangeRequestUpdateEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.requestId = reader.int64();
            break;
          case 2:
            message.action = reader.int32();
            break;
          case 3:
            message.status = reader.int32();
            break;
          case 4:
            message.error = reader.string();
            break;
          case 5:
            message.makerApprovedData = reader.string();
            break;
          case 6:
            message.note = reader.string();
            break;
          case 7:
            message.rejectionReason = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BpmUserChangeRequestUpdateEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BpmUserChangeRequestUpdateEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.requestId != null && message.hasOwnProperty("requestId")) {
        if (!$util.isInteger(message.requestId) && !(message.requestId && $util.isInteger(message.requestId.low) && $util.isInteger(message.requestId.high)))
          return "requestId: integer|Long expected";
      }
      if (message.action != null && message.hasOwnProperty("action"))
        switch (message.action) {
          default:
            return "action: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
        }
      if (message.error != null && message.hasOwnProperty("error")) {
        if (!$util.isString(message.error))
          return "error: string expected";
      }
      if (message.makerApprovedData != null && message.hasOwnProperty("makerApprovedData")) {
        if (!$util.isString(message.makerApprovedData))
          return "makerApprovedData: string expected";
      }
      if (message.note != null && message.hasOwnProperty("note")) {
        if (!$util.isString(message.note))
          return "note: string expected";
      }
      if (message.rejectionReason != null && message.hasOwnProperty("rejectionReason")) {
        switch (message.rejectionReason) {
          default:
            return "rejectionReason: enum value expected";
          case 0:
          case 1:
            break;
        }
      }
      return null;
    };
    BpmUserChangeRequestUpdateEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BpmUserChangeRequestUpdateEvent)
        return object;
      let message = new $root.dnse.BpmUserChangeRequestUpdateEvent();
      if (object.requestId != null) {
        if ($util.Long)
          (message.requestId = $util.Long.fromValue(object.requestId)).unsigned = false;
        else if (typeof object.requestId === "string")
          message.requestId = parseInt(object.requestId, 10);
        else if (typeof object.requestId === "number")
          message.requestId = object.requestId;
        else if (typeof object.requestId === "object")
          message.requestId = new $util.LongBits(object.requestId.low >>> 0, object.requestId.high >>> 0).toNumber();
      }
      switch (object.action) {
        case "UPDATE_STATUS":
        case 0:
          message.action = 0;
          break;
        case "UNABLE_TO_PROCESS":
        case 1:
          message.action = 1;
          break;
      }
      switch (object.status) {
        case "OPEN":
        case 0:
          message.status = 0;
          break;
        case "MAKER_APPROVED":
        case 1:
          message.status = 1;
          break;
        case "CANCELED":
        case 2:
          message.status = 2;
          break;
        case "CHECKER_APPROVED":
        case 3:
          message.status = 3;
          break;
        case "APPROVED":
        case 4:
          message.status = 4;
          break;
        case "REJECTED":
        case 5:
          message.status = 5;
          break;
      }
      if (object.error != null)
        message.error = String(object.error);
      if (object.makerApprovedData != null)
        message.makerApprovedData = String(object.makerApprovedData);
      if (object.note != null)
        message.note = String(object.note);
      switch (object.rejectionReason) {
        case "INFO_REJECTED":
        case 0:
          message.rejectionReason = 0;
          break;
        case "KYC_REJECTED":
        case 1:
          message.rejectionReason = 1;
          break;
      }
      return message;
    };
    BpmUserChangeRequestUpdateEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.requestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.requestId = options.longs === String ? "0" : 0;
        object.action = options.enums === String ? "UPDATE_STATUS" : 0;
        object.status = options.enums === String ? "OPEN" : 0;
      }
      if (message.requestId != null && message.hasOwnProperty("requestId"))
        if (typeof message.requestId === "number")
          object.requestId = options.longs === String ? String(message.requestId) : message.requestId;
        else
          object.requestId = options.longs === String ? $util.Long.prototype.toString.call(message.requestId) : options.longs === Number ? new $util.LongBits(message.requestId.low >>> 0, message.requestId.high >>> 0).toNumber() : message.requestId;
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = options.enums === String ? $root.dnse.BpmUserChangeRequestUpdateEvent.Action[message.action] : message.action;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.UserChangeRequestStatus[message.status] : message.status;
      if (message.error != null && message.hasOwnProperty("error")) {
        object.error = message.error;
        if (options.oneofs)
          object._error = "error";
      }
      if (message.makerApprovedData != null && message.hasOwnProperty("makerApprovedData")) {
        object.makerApprovedData = message.makerApprovedData;
        if (options.oneofs)
          object._makerApprovedData = "makerApprovedData";
      }
      if (message.note != null && message.hasOwnProperty("note")) {
        object.note = message.note;
        if (options.oneofs)
          object._note = "note";
      }
      if (message.rejectionReason != null && message.hasOwnProperty("rejectionReason")) {
        object.rejectionReason = options.enums === String ? $root.dnse.BpmUserChangeRequestUpdateEvent.RejectionReason[message.rejectionReason] : message.rejectionReason;
        if (options.oneofs)
          object._rejectionReason = "rejectionReason";
      }
      return object;
    };
    BpmUserChangeRequestUpdateEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    BpmUserChangeRequestUpdateEvent.Action = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UPDATE_STATUS"] = 0;
      values[valuesById[1] = "UNABLE_TO_PROCESS"] = 1;
      return values;
    }();
    BpmUserChangeRequestUpdateEvent.RejectionReason = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "INFO_REJECTED"] = 0;
      values[valuesById[1] = "KYC_REJECTED"] = 1;
      return values;
    }();
    return BpmUserChangeRequestUpdateEvent;
  }();
  dnse2.UserChangeRequestUpdateEvent = function() {
    function UserChangeRequestUpdateEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    UserChangeRequestUpdateEvent.prototype.requestId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserChangeRequestUpdateEvent.prototype.investorId = "";
    UserChangeRequestUpdateEvent.prototype.action = 0;
    UserChangeRequestUpdateEvent.prototype.status = 0;
    UserChangeRequestUpdateEvent.create = function create(properties) {
      return new UserChangeRequestUpdateEvent(properties);
    };
    UserChangeRequestUpdateEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
        writer.uint32(8).int64(message.requestId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(24).int32(message.action);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(32).int32(message.status);
      return writer;
    };
    UserChangeRequestUpdateEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    UserChangeRequestUpdateEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.UserChangeRequestUpdateEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.requestId = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.action = reader.int32();
            break;
          case 4:
            message.status = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    UserChangeRequestUpdateEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    UserChangeRequestUpdateEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.requestId != null && message.hasOwnProperty("requestId")) {
        if (!$util.isInteger(message.requestId) && !(message.requestId && $util.isInteger(message.requestId.low) && $util.isInteger(message.requestId.high)))
          return "requestId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.action != null && message.hasOwnProperty("action"))
        switch (message.action) {
          default:
            return "action: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
        }
      return null;
    };
    UserChangeRequestUpdateEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.UserChangeRequestUpdateEvent)
        return object;
      let message = new $root.dnse.UserChangeRequestUpdateEvent();
      if (object.requestId != null) {
        if ($util.Long)
          (message.requestId = $util.Long.fromValue(object.requestId)).unsigned = false;
        else if (typeof object.requestId === "string")
          message.requestId = parseInt(object.requestId, 10);
        else if (typeof object.requestId === "number")
          message.requestId = object.requestId;
        else if (typeof object.requestId === "object")
          message.requestId = new $util.LongBits(object.requestId.low >>> 0, object.requestId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      switch (object.action) {
        case "CREATE":
        case 0:
          message.action = 0;
          break;
        case "CANCEL":
        case 1:
          message.action = 1;
          break;
      }
      switch (object.status) {
        case "OPEN":
        case 0:
          message.status = 0;
          break;
        case "MAKER_APPROVED":
        case 1:
          message.status = 1;
          break;
        case "CANCELED":
        case 2:
          message.status = 2;
          break;
        case "CHECKER_APPROVED":
        case 3:
          message.status = 3;
          break;
        case "APPROVED":
        case 4:
          message.status = 4;
          break;
        case "REJECTED":
        case 5:
          message.status = 5;
          break;
      }
      return message;
    };
    UserChangeRequestUpdateEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.requestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.requestId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.action = options.enums === String ? "CREATE" : 0;
        object.status = options.enums === String ? "OPEN" : 0;
      }
      if (message.requestId != null && message.hasOwnProperty("requestId"))
        if (typeof message.requestId === "number")
          object.requestId = options.longs === String ? String(message.requestId) : message.requestId;
        else
          object.requestId = options.longs === String ? $util.Long.prototype.toString.call(message.requestId) : options.longs === Number ? new $util.LongBits(message.requestId.low >>> 0, message.requestId.high >>> 0).toNumber() : message.requestId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = options.enums === String ? $root.dnse.UserChangeRequestUpdateEvent.Action[message.action] : message.action;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.UserChangeRequestStatus[message.status] : message.status;
      return object;
    };
    UserChangeRequestUpdateEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    UserChangeRequestUpdateEvent.Action = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "CREATE"] = 0;
      values[valuesById[1] = "CANCEL"] = 1;
      return values;
    }();
    return UserChangeRequestUpdateEvent;
  }();
  dnse2.NotifyUserChangeRequestResult = function() {
    function NotifyUserChangeRequestResult(properties) {
      this.changeMap = {};
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NotifyUserChangeRequestResult.prototype.type = 0;
    NotifyUserChangeRequestResult.prototype.result = 0;
    NotifyUserChangeRequestResult.prototype.changeMap = $util.emptyObject;
    NotifyUserChangeRequestResult.prototype.investorId = "";
    NotifyUserChangeRequestResult.prototype.note = null;
    NotifyUserChangeRequestResult.prototype.rejectionReason = null;
    NotifyUserChangeRequestResult.prototype.fullName = null;
    NotifyUserChangeRequestResult.prototype.custodyCode = null;
    let $oneOfFields;
    Object.defineProperty(NotifyUserChangeRequestResult.prototype, "_note", {
      get: $util.oneOfGetter($oneOfFields = ["note"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(NotifyUserChangeRequestResult.prototype, "_rejectionReason", {
      get: $util.oneOfGetter($oneOfFields = ["rejectionReason"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(NotifyUserChangeRequestResult.prototype, "_fullName", {
      get: $util.oneOfGetter($oneOfFields = ["fullName"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(NotifyUserChangeRequestResult.prototype, "_custodyCode", {
      get: $util.oneOfGetter($oneOfFields = ["custodyCode"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    NotifyUserChangeRequestResult.create = function create(properties) {
      return new NotifyUserChangeRequestResult(properties);
    };
    NotifyUserChangeRequestResult.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.result != null && Object.hasOwnProperty.call(message, "result"))
        writer.uint32(16).int32(message.result);
      if (message.changeMap != null && Object.hasOwnProperty.call(message, "changeMap"))
        for (let keys = Object.keys(message.changeMap), i = 0; i < keys.length; ++i)
          writer.uint32(26).fork().uint32(10).string(keys[i]).uint32(18).string(message.changeMap[keys[i]]).ldelim();
      if (message.note != null && Object.hasOwnProperty.call(message, "note"))
        writer.uint32(34).string(message.note);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.rejectionReason != null && Object.hasOwnProperty.call(message, "rejectionReason"))
        writer.uint32(48).int32(message.rejectionReason);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(58).string(message.fullName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(66).string(message.custodyCode);
      return writer;
    };
    NotifyUserChangeRequestResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NotifyUserChangeRequestResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NotifyUserChangeRequestResult(), key, value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.result = reader.int32();
            break;
          case 3:
            if (message.changeMap === $util.emptyObject)
              message.changeMap = {};
            let end2 = reader.uint32() + reader.pos;
            key = "";
            value = "";
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = reader.string();
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.changeMap[key] = value;
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 4:
            message.note = reader.string();
            break;
          case 6:
            message.rejectionReason = reader.int32();
            break;
          case 7:
            message.fullName = reader.string();
            break;
          case 8:
            message.custodyCode = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NotifyUserChangeRequestResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NotifyUserChangeRequestResult.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.result != null && message.hasOwnProperty("result"))
        switch (message.result) {
          default:
            return "result: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.changeMap != null && message.hasOwnProperty("changeMap")) {
        if (!$util.isObject(message.changeMap))
          return "changeMap: object expected";
        let key = Object.keys(message.changeMap);
        for (let i = 0; i < key.length; ++i)
          if (!$util.isString(message.changeMap[key[i]]))
            return "changeMap: string{k:string} expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.note != null && message.hasOwnProperty("note")) {
        if (!$util.isString(message.note))
          return "note: string expected";
      }
      if (message.rejectionReason != null && message.hasOwnProperty("rejectionReason")) {
        switch (message.rejectionReason) {
          default:
            return "rejectionReason: enum value expected";
          case 0:
          case 1:
            break;
        }
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      return null;
    };
    NotifyUserChangeRequestResult.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NotifyUserChangeRequestResult)
        return object;
      let message = new $root.dnse.NotifyUserChangeRequestResult();
      switch (object.type) {
        case "ADDRESS":
        case 0:
          message.type = 0;
          break;
        case "KYC":
        case 1:
          message.type = 1;
          break;
      }
      switch (object.result) {
        case "SUCCESSED":
        case 0:
          message.result = 0;
          break;
        case "FAILED":
        case 1:
          message.result = 1;
          break;
        case "CANCEL_FAILED":
        case 2:
          message.result = 2;
          break;
      }
      if (object.changeMap) {
        if (typeof object.changeMap !== "object")
          throw TypeError(".dnse.NotifyUserChangeRequestResult.changeMap: object expected");
        message.changeMap = {};
        for (let keys = Object.keys(object.changeMap), i = 0; i < keys.length; ++i)
          message.changeMap[keys[i]] = String(object.changeMap[keys[i]]);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.note != null)
        message.note = String(object.note);
      switch (object.rejectionReason) {
        case "INFO_REJECTED":
        case 0:
          message.rejectionReason = 0;
          break;
        case "KYC_REJECTED":
        case 1:
          message.rejectionReason = 1;
          break;
      }
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      return message;
    };
    NotifyUserChangeRequestResult.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.objects || options.defaults)
        object.changeMap = {};
      if (options.defaults) {
        object.type = options.enums === String ? "ADDRESS" : 0;
        object.result = options.enums === String ? "SUCCESSED" : 0;
        object.investorId = "";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.NotifyUserChangeRequestResult.UpdateType[message.type] : message.type;
      if (message.result != null && message.hasOwnProperty("result"))
        object.result = options.enums === String ? $root.dnse.NotifyUserChangeRequestResult.Result[message.result] : message.result;
      let keys2;
      if (message.changeMap && (keys2 = Object.keys(message.changeMap)).length) {
        object.changeMap = {};
        for (let j = 0; j < keys2.length; ++j)
          object.changeMap[keys2[j]] = message.changeMap[keys2[j]];
      }
      if (message.note != null && message.hasOwnProperty("note")) {
        object.note = message.note;
        if (options.oneofs)
          object._note = "note";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.rejectionReason != null && message.hasOwnProperty("rejectionReason")) {
        object.rejectionReason = options.enums === String ? $root.dnse.NotifyUserChangeRequestResult.RejectionReason[message.rejectionReason] : message.rejectionReason;
        if (options.oneofs)
          object._rejectionReason = "rejectionReason";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        object.fullName = message.fullName;
        if (options.oneofs)
          object._fullName = "fullName";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        object.custodyCode = message.custodyCode;
        if (options.oneofs)
          object._custodyCode = "custodyCode";
      }
      return object;
    };
    NotifyUserChangeRequestResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    NotifyUserChangeRequestResult.Result = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "SUCCESSED"] = 0;
      values[valuesById[1] = "FAILED"] = 1;
      values[valuesById[2] = "CANCEL_FAILED"] = 2;
      return values;
    }();
    NotifyUserChangeRequestResult.UpdateType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "ADDRESS"] = 0;
      values[valuesById[1] = "KYC"] = 1;
      return values;
    }();
    NotifyUserChangeRequestResult.RejectionReason = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "INFO_REJECTED"] = 0;
      values[valuesById[1] = "KYC_REJECTED"] = 1;
      return values;
    }();
    return NotifyUserChangeRequestResult;
  }();
  dnse2.WarningUpdateInformation = function() {
    function WarningUpdateInformation(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    WarningUpdateInformation.prototype.investorId = "";
    WarningUpdateInformation.prototype.custodyCode = "";
    WarningUpdateInformation.prototype.name = "";
    WarningUpdateInformation.prototype.identificationCode = null;
    WarningUpdateInformation.prototype.issuedPlace = null;
    WarningUpdateInformation.prototype.expiredDate = null;
    WarningUpdateInformation.prototype.issuedDate = null;
    WarningUpdateInformation.prototype.warningReason = 0;
    WarningUpdateInformation.prototype.email = null;
    let $oneOfFields;
    Object.defineProperty(WarningUpdateInformation.prototype, "_identificationCode", {
      get: $util.oneOfGetter($oneOfFields = ["identificationCode"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(WarningUpdateInformation.prototype, "_issuedPlace", {
      get: $util.oneOfGetter($oneOfFields = ["issuedPlace"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(WarningUpdateInformation.prototype, "_expiredDate", {
      get: $util.oneOfGetter($oneOfFields = ["expiredDate"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(WarningUpdateInformation.prototype, "_issuedDate", {
      get: $util.oneOfGetter($oneOfFields = ["issuedDate"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(WarningUpdateInformation.prototype, "_email", {
      get: $util.oneOfGetter($oneOfFields = ["email"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    WarningUpdateInformation.create = function create(properties) {
      return new WarningUpdateInformation(properties);
    };
    WarningUpdateInformation.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(26).string(message.name);
      if (message.identificationCode != null && Object.hasOwnProperty.call(message, "identificationCode"))
        writer.uint32(34).string(message.identificationCode);
      if (message.issuedPlace != null && Object.hasOwnProperty.call(message, "issuedPlace"))
        writer.uint32(42).string(message.issuedPlace);
      if (message.expiredDate != null && Object.hasOwnProperty.call(message, "expiredDate"))
        $root.google.protobuf.Timestamp.encode(message.expiredDate, writer.uint32(50).fork()).ldelim();
      if (message.issuedDate != null && Object.hasOwnProperty.call(message, "issuedDate"))
        $root.google.protobuf.Timestamp.encode(message.issuedDate, writer.uint32(58).fork()).ldelim();
      if (message.warningReason != null && Object.hasOwnProperty.call(message, "warningReason"))
        writer.uint32(64).int32(message.warningReason);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(74).string(message.email);
      return writer;
    };
    WarningUpdateInformation.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    WarningUpdateInformation.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.WarningUpdateInformation();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.name = reader.string();
            break;
          case 4:
            message.identificationCode = reader.string();
            break;
          case 5:
            message.issuedPlace = reader.string();
            break;
          case 6:
            message.expiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.issuedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.warningReason = reader.int32();
            break;
          case 9:
            message.email = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    WarningUpdateInformation.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    WarningUpdateInformation.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.identificationCode != null && message.hasOwnProperty("identificationCode")) {
        if (!$util.isString(message.identificationCode))
          return "identificationCode: string expected";
      }
      if (message.issuedPlace != null && message.hasOwnProperty("issuedPlace")) {
        if (!$util.isString(message.issuedPlace))
          return "issuedPlace: string expected";
      }
      if (message.expiredDate != null && message.hasOwnProperty("expiredDate")) {
        {
          let error = $root.google.protobuf.Timestamp.verify(message.expiredDate);
          if (error)
            return "expiredDate." + error;
        }
      }
      if (message.issuedDate != null && message.hasOwnProperty("issuedDate")) {
        {
          let error = $root.google.protobuf.Timestamp.verify(message.issuedDate);
          if (error)
            return "issuedDate." + error;
        }
      }
      if (message.warningReason != null && message.hasOwnProperty("warningReason"))
        switch (message.warningReason) {
          default:
            return "warningReason: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      return null;
    };
    WarningUpdateInformation.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.WarningUpdateInformation)
        return object;
      let message = new $root.dnse.WarningUpdateInformation();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.name != null)
        message.name = String(object.name);
      if (object.identificationCode != null)
        message.identificationCode = String(object.identificationCode);
      if (object.issuedPlace != null)
        message.issuedPlace = String(object.issuedPlace);
      if (object.expiredDate != null) {
        if (typeof object.expiredDate !== "object")
          throw TypeError(".dnse.WarningUpdateInformation.expiredDate: object expected");
        message.expiredDate = $root.google.protobuf.Timestamp.fromObject(object.expiredDate);
      }
      if (object.issuedDate != null) {
        if (typeof object.issuedDate !== "object")
          throw TypeError(".dnse.WarningUpdateInformation.issuedDate: object expected");
        message.issuedDate = $root.google.protobuf.Timestamp.fromObject(object.issuedDate);
      }
      switch (object.warningReason) {
        case "IDENTIFICATION_EXPIRED":
        case 0:
          message.warningReason = 0;
          break;
        case "IDENTIFICATION_UNSUPPORTED":
        case 1:
          message.warningReason = 1;
          break;
        case "MPS_NOT_MATCH":
        case 2:
          message.warningReason = 2;
          break;
      }
      if (object.email != null)
        message.email = String(object.email);
      return message;
    };
    WarningUpdateInformation.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.name = "";
        object.warningReason = options.enums === String ? "IDENTIFICATION_EXPIRED" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.identificationCode != null && message.hasOwnProperty("identificationCode")) {
        object.identificationCode = message.identificationCode;
        if (options.oneofs)
          object._identificationCode = "identificationCode";
      }
      if (message.issuedPlace != null && message.hasOwnProperty("issuedPlace")) {
        object.issuedPlace = message.issuedPlace;
        if (options.oneofs)
          object._issuedPlace = "issuedPlace";
      }
      if (message.expiredDate != null && message.hasOwnProperty("expiredDate")) {
        object.expiredDate = $root.google.protobuf.Timestamp.toObject(message.expiredDate, options);
        if (options.oneofs)
          object._expiredDate = "expiredDate";
      }
      if (message.issuedDate != null && message.hasOwnProperty("issuedDate")) {
        object.issuedDate = $root.google.protobuf.Timestamp.toObject(message.issuedDate, options);
        if (options.oneofs)
          object._issuedDate = "issuedDate";
      }
      if (message.warningReason != null && message.hasOwnProperty("warningReason"))
        object.warningReason = options.enums === String ? $root.dnse.WarningUpdateInformation.WarningReason[message.warningReason] : message.warningReason;
      if (message.email != null && message.hasOwnProperty("email")) {
        object.email = message.email;
        if (options.oneofs)
          object._email = "email";
      }
      return object;
    };
    WarningUpdateInformation.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    WarningUpdateInformation.WarningReason = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "IDENTIFICATION_EXPIRED"] = 0;
      values[valuesById[1] = "IDENTIFICATION_UNSUPPORTED"] = 1;
      values[valuesById[2] = "MPS_NOT_MATCH"] = 2;
      return values;
    }();
    return WarningUpdateInformation;
  }();
  dnse2.LoyaltyPointChange = function() {
    function LoyaltyPointChange(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoyaltyPointChange.prototype.point = 0;
    LoyaltyPointChange.prototype.modifiedDate = "";
    LoyaltyPointChange.create = function create(properties) {
      return new LoyaltyPointChange(properties);
    };
    LoyaltyPointChange.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.point != null && Object.hasOwnProperty.call(message, "point"))
        writer.uint32(9).double(message.point);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        writer.uint32(18).string(message.modifiedDate);
      return writer;
    };
    LoyaltyPointChange.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoyaltyPointChange.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoyaltyPointChange();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.point = reader.double();
            break;
          case 2:
            message.modifiedDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoyaltyPointChange.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoyaltyPointChange.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.point != null && message.hasOwnProperty("point")) {
        if (typeof message.point !== "number")
          return "point: number expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        if (!$util.isString(message.modifiedDate))
          return "modifiedDate: string expected";
      }
      return null;
    };
    LoyaltyPointChange.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoyaltyPointChange)
        return object;
      let message = new $root.dnse.LoyaltyPointChange();
      if (object.point != null)
        message.point = Number(object.point);
      if (object.modifiedDate != null)
        message.modifiedDate = String(object.modifiedDate);
      return message;
    };
    LoyaltyPointChange.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.point = 0;
        object.modifiedDate = "";
      }
      if (message.point != null && message.hasOwnProperty("point"))
        object.point = options.json && !isFinite(message.point) ? String(message.point) : message.point;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = message.modifiedDate;
      return object;
    };
    LoyaltyPointChange.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoyaltyPointChange;
  }();
  dnse2.DeviceLoginSession = function() {
    function DeviceLoginSession(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DeviceLoginSession.prototype.userId = "";
    DeviceLoginSession.prototype.deviceId = "";
    DeviceLoginSession.prototype.ipAddress = "";
    DeviceLoginSession.prototype.location = "";
    DeviceLoginSession.prototype.deviceInfo = null;
    DeviceLoginSession.prototype.lastLoginSession = null;
    DeviceLoginSession.prototype.username = "";
    DeviceLoginSession.create = function create(properties) {
      return new DeviceLoginSession(properties);
    };
    DeviceLoginSession.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(10).string(message.userId);
      if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
        writer.uint32(18).string(message.deviceId);
      if (message.ipAddress != null && Object.hasOwnProperty.call(message, "ipAddress"))
        writer.uint32(26).string(message.ipAddress);
      if (message.location != null && Object.hasOwnProperty.call(message, "location"))
        writer.uint32(34).string(message.location);
      if (message.deviceInfo != null && Object.hasOwnProperty.call(message, "deviceInfo"))
        $root.dnse.DeviceLoginSession.DeviceInfo.encode(message.deviceInfo, writer.uint32(42).fork()).ldelim();
      if (message.lastLoginSession != null && Object.hasOwnProperty.call(message, "lastLoginSession"))
        $root.google.protobuf.Timestamp.encode(message.lastLoginSession, writer.uint32(50).fork()).ldelim();
      if (message.username != null && Object.hasOwnProperty.call(message, "username"))
        writer.uint32(58).string(message.username);
      return writer;
    };
    DeviceLoginSession.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DeviceLoginSession.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DeviceLoginSession();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.userId = reader.string();
            break;
          case 2:
            message.deviceId = reader.string();
            break;
          case 3:
            message.ipAddress = reader.string();
            break;
          case 4:
            message.location = reader.string();
            break;
          case 5:
            message.deviceInfo = $root.dnse.DeviceLoginSession.DeviceInfo.decode(reader, reader.uint32());
            break;
          case 6:
            message.lastLoginSession = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.username = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DeviceLoginSession.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DeviceLoginSession.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isString(message.userId))
          return "userId: string expected";
      }
      if (message.deviceId != null && message.hasOwnProperty("deviceId")) {
        if (!$util.isString(message.deviceId))
          return "deviceId: string expected";
      }
      if (message.ipAddress != null && message.hasOwnProperty("ipAddress")) {
        if (!$util.isString(message.ipAddress))
          return "ipAddress: string expected";
      }
      if (message.location != null && message.hasOwnProperty("location")) {
        if (!$util.isString(message.location))
          return "location: string expected";
      }
      if (message.deviceInfo != null && message.hasOwnProperty("deviceInfo")) {
        let error = $root.dnse.DeviceLoginSession.DeviceInfo.verify(message.deviceInfo);
        if (error)
          return "deviceInfo." + error;
      }
      if (message.lastLoginSession != null && message.hasOwnProperty("lastLoginSession")) {
        let error = $root.google.protobuf.Timestamp.verify(message.lastLoginSession);
        if (error)
          return "lastLoginSession." + error;
      }
      if (message.username != null && message.hasOwnProperty("username")) {
        if (!$util.isString(message.username))
          return "username: string expected";
      }
      return null;
    };
    DeviceLoginSession.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DeviceLoginSession)
        return object;
      let message = new $root.dnse.DeviceLoginSession();
      if (object.userId != null)
        message.userId = String(object.userId);
      if (object.deviceId != null)
        message.deviceId = String(object.deviceId);
      if (object.ipAddress != null)
        message.ipAddress = String(object.ipAddress);
      if (object.location != null)
        message.location = String(object.location);
      if (object.deviceInfo != null) {
        if (typeof object.deviceInfo !== "object")
          throw TypeError(".dnse.DeviceLoginSession.deviceInfo: object expected");
        message.deviceInfo = $root.dnse.DeviceLoginSession.DeviceInfo.fromObject(object.deviceInfo);
      }
      if (object.lastLoginSession != null) {
        if (typeof object.lastLoginSession !== "object")
          throw TypeError(".dnse.DeviceLoginSession.lastLoginSession: object expected");
        message.lastLoginSession = $root.google.protobuf.Timestamp.fromObject(object.lastLoginSession);
      }
      if (object.username != null)
        message.username = String(object.username);
      return message;
    };
    DeviceLoginSession.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.userId = "";
        object.deviceId = "";
        object.ipAddress = "";
        object.location = "";
        object.deviceInfo = null;
        object.lastLoginSession = null;
        object.username = "";
      }
      if (message.userId != null && message.hasOwnProperty("userId"))
        object.userId = message.userId;
      if (message.deviceId != null && message.hasOwnProperty("deviceId"))
        object.deviceId = message.deviceId;
      if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
        object.ipAddress = message.ipAddress;
      if (message.location != null && message.hasOwnProperty("location"))
        object.location = message.location;
      if (message.deviceInfo != null && message.hasOwnProperty("deviceInfo"))
        object.deviceInfo = $root.dnse.DeviceLoginSession.DeviceInfo.toObject(message.deviceInfo, options);
      if (message.lastLoginSession != null && message.hasOwnProperty("lastLoginSession"))
        object.lastLoginSession = $root.google.protobuf.Timestamp.toObject(message.lastLoginSession, options);
      if (message.username != null && message.hasOwnProperty("username"))
        object.username = message.username;
      return object;
    };
    DeviceLoginSession.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    DeviceLoginSession.DeviceInfo = function() {
      function DeviceInfo(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      DeviceInfo.prototype.userAgent = "";
      DeviceInfo.prototype.deviceName = "";
      DeviceInfo.prototype.screenSize = "";
      DeviceInfo.prototype.brand = "";
      DeviceInfo.create = function create(properties) {
        return new DeviceInfo(properties);
      };
      DeviceInfo.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
          writer.uint32(10).string(message.userAgent);
        if (message.deviceName != null && Object.hasOwnProperty.call(message, "deviceName"))
          writer.uint32(18).string(message.deviceName);
        if (message.screenSize != null && Object.hasOwnProperty.call(message, "screenSize"))
          writer.uint32(26).string(message.screenSize);
        if (message.brand != null && Object.hasOwnProperty.call(message, "brand"))
          writer.uint32(34).string(message.brand);
        return writer;
      };
      DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      DeviceInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DeviceLoginSession.DeviceInfo();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.userAgent = reader.string();
              break;
            case 2:
              message.deviceName = reader.string();
              break;
            case 3:
              message.screenSize = reader.string();
              break;
            case 4:
              message.brand = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      DeviceInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
          if (!$util.isString(message.userAgent))
            return "userAgent: string expected";
        }
        if (message.deviceName != null && message.hasOwnProperty("deviceName")) {
          if (!$util.isString(message.deviceName))
            return "deviceName: string expected";
        }
        if (message.screenSize != null && message.hasOwnProperty("screenSize")) {
          if (!$util.isString(message.screenSize))
            return "screenSize: string expected";
        }
        if (message.brand != null && message.hasOwnProperty("brand")) {
          if (!$util.isString(message.brand))
            return "brand: string expected";
        }
        return null;
      };
      DeviceInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.DeviceLoginSession.DeviceInfo)
          return object;
        let message = new $root.dnse.DeviceLoginSession.DeviceInfo();
        if (object.userAgent != null)
          message.userAgent = String(object.userAgent);
        if (object.deviceName != null)
          message.deviceName = String(object.deviceName);
        if (object.screenSize != null)
          message.screenSize = String(object.screenSize);
        if (object.brand != null)
          message.brand = String(object.brand);
        return message;
      };
      DeviceInfo.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.userAgent = "";
          object.deviceName = "";
          object.screenSize = "";
          object.brand = "";
        }
        if (message.userAgent != null && message.hasOwnProperty("userAgent"))
          object.userAgent = message.userAgent;
        if (message.deviceName != null && message.hasOwnProperty("deviceName"))
          object.deviceName = message.deviceName;
        if (message.screenSize != null && message.hasOwnProperty("screenSize"))
          object.screenSize = message.screenSize;
        if (message.brand != null && message.hasOwnProperty("brand"))
          object.brand = message.brand;
        return object;
      };
      DeviceInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      return DeviceInfo;
    }();
    return DeviceLoginSession;
  }();
  dnse2.NotifyOrderEvent = function() {
    function NotifyOrderEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NotifyOrderEvent.prototype.investorId = "";
    NotifyOrderEvent.prototype.side = "";
    NotifyOrderEvent.prototype.accountNo = "";
    NotifyOrderEvent.prototype.accountTypeName = "";
    NotifyOrderEvent.prototype.coInvestmentGroupName = "";
    NotifyOrderEvent.prototype.symbol = "";
    NotifyOrderEvent.prototype.price = 0;
    NotifyOrderEvent.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyOrderEvent.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyOrderEvent.prototype.orderType = "";
    NotifyOrderEvent.prototype.orderStatus = "";
    NotifyOrderEvent.prototype.canceledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyOrderEvent.prototype.lastQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyOrderEvent.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyOrderEvent.prototype.lastPrice = 0;
    NotifyOrderEvent.prototype.averagePrice = 0;
    NotifyOrderEvent.prototype.priceSecure = 0;
    NotifyOrderEvent.prototype.modifiedDate = null;
    NotifyOrderEvent.prototype.channel = "";
    NotifyOrderEvent.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyOrderEvent.create = function create(properties) {
      return new NotifyOrderEvent(properties);
    };
    NotifyOrderEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(18).string(message.side);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(34).string(message.accountTypeName);
      if (message.coInvestmentGroupName != null && Object.hasOwnProperty.call(message, "coInvestmentGroupName"))
        writer.uint32(42).string(message.coInvestmentGroupName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(50).string(message.symbol);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(57).double(message.price);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(64).int64(message.quantity);
      if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
        writer.uint32(72).int64(message.fillQuantity);
      if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
        writer.uint32(82).string(message.orderType);
      if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
        writer.uint32(90).string(message.orderStatus);
      if (message.canceledQuantity != null && Object.hasOwnProperty.call(message, "canceledQuantity"))
        writer.uint32(96).int64(message.canceledQuantity);
      if (message.lastQuantity != null && Object.hasOwnProperty.call(message, "lastQuantity"))
        writer.uint32(104).int64(message.lastQuantity);
      if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
        writer.uint32(112).int64(message.leaveQuantity);
      if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
        writer.uint32(121).double(message.lastPrice);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(129).double(message.averagePrice);
      if (message.priceSecure != null && Object.hasOwnProperty.call(message, "priceSecure"))
        writer.uint32(137).double(message.priceSecure);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(146).fork()).ldelim();
      if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
        writer.uint32(154).string(message.channel);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(160).int64(message.id);
      return writer;
    };
    NotifyOrderEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NotifyOrderEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NotifyOrderEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.side = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountTypeName = reader.string();
            break;
          case 5:
            message.coInvestmentGroupName = reader.string();
            break;
          case 6:
            message.symbol = reader.string();
            break;
          case 7:
            message.price = reader.double();
            break;
          case 8:
            message.quantity = reader.int64();
            break;
          case 9:
            message.fillQuantity = reader.int64();
            break;
          case 10:
            message.orderType = reader.string();
            break;
          case 11:
            message.orderStatus = reader.string();
            break;
          case 12:
            message.canceledQuantity = reader.int64();
            break;
          case 13:
            message.lastQuantity = reader.int64();
            break;
          case 14:
            message.leaveQuantity = reader.int64();
            break;
          case 15:
            message.lastPrice = reader.double();
            break;
          case 16:
            message.averagePrice = reader.double();
            break;
          case 17:
            message.priceSecure = reader.double();
            break;
          case 18:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 19:
            message.channel = reader.string();
            break;
          case 20:
            message.id = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NotifyOrderEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NotifyOrderEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.coInvestmentGroupName != null && message.hasOwnProperty("coInvestmentGroupName")) {
        if (!$util.isString(message.coInvestmentGroupName))
          return "coInvestmentGroupName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
        if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
          return "fillQuantity: integer|Long expected";
      }
      if (message.orderType != null && message.hasOwnProperty("orderType")) {
        if (!$util.isString(message.orderType))
          return "orderType: string expected";
      }
      if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
        if (!$util.isString(message.orderStatus))
          return "orderStatus: string expected";
      }
      if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity")) {
        if (!$util.isInteger(message.canceledQuantity) && !(message.canceledQuantity && $util.isInteger(message.canceledQuantity.low) && $util.isInteger(message.canceledQuantity.high)))
          return "canceledQuantity: integer|Long expected";
      }
      if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity")) {
        if (!$util.isInteger(message.lastQuantity) && !(message.lastQuantity && $util.isInteger(message.lastQuantity.low) && $util.isInteger(message.lastQuantity.high)))
          return "lastQuantity: integer|Long expected";
      }
      if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
        if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
          return "leaveQuantity: integer|Long expected";
      }
      if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
        if (typeof message.lastPrice !== "number")
          return "lastPrice: number expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.priceSecure != null && message.hasOwnProperty("priceSecure")) {
        if (typeof message.priceSecure !== "number")
          return "priceSecure: number expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.channel != null && message.hasOwnProperty("channel")) {
        if (!$util.isString(message.channel))
          return "channel: string expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      return null;
    };
    NotifyOrderEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NotifyOrderEvent)
        return object;
      let message = new $root.dnse.NotifyOrderEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.side != null)
        message.side = String(object.side);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.coInvestmentGroupName != null)
        message.coInvestmentGroupName = String(object.coInvestmentGroupName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.price != null)
        message.price = Number(object.price);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.fillQuantity != null) {
        if ($util.Long)
          (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
        else if (typeof object.fillQuantity === "string")
          message.fillQuantity = parseInt(object.fillQuantity, 10);
        else if (typeof object.fillQuantity === "number")
          message.fillQuantity = object.fillQuantity;
        else if (typeof object.fillQuantity === "object")
          message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
      }
      if (object.orderType != null)
        message.orderType = String(object.orderType);
      if (object.orderStatus != null)
        message.orderStatus = String(object.orderStatus);
      if (object.canceledQuantity != null) {
        if ($util.Long)
          (message.canceledQuantity = $util.Long.fromValue(object.canceledQuantity)).unsigned = false;
        else if (typeof object.canceledQuantity === "string")
          message.canceledQuantity = parseInt(object.canceledQuantity, 10);
        else if (typeof object.canceledQuantity === "number")
          message.canceledQuantity = object.canceledQuantity;
        else if (typeof object.canceledQuantity === "object")
          message.canceledQuantity = new $util.LongBits(object.canceledQuantity.low >>> 0, object.canceledQuantity.high >>> 0).toNumber();
      }
      if (object.lastQuantity != null) {
        if ($util.Long)
          (message.lastQuantity = $util.Long.fromValue(object.lastQuantity)).unsigned = false;
        else if (typeof object.lastQuantity === "string")
          message.lastQuantity = parseInt(object.lastQuantity, 10);
        else if (typeof object.lastQuantity === "number")
          message.lastQuantity = object.lastQuantity;
        else if (typeof object.lastQuantity === "object")
          message.lastQuantity = new $util.LongBits(object.lastQuantity.low >>> 0, object.lastQuantity.high >>> 0).toNumber();
      }
      if (object.leaveQuantity != null) {
        if ($util.Long)
          (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
        else if (typeof object.leaveQuantity === "string")
          message.leaveQuantity = parseInt(object.leaveQuantity, 10);
        else if (typeof object.leaveQuantity === "number")
          message.leaveQuantity = object.leaveQuantity;
        else if (typeof object.leaveQuantity === "object")
          message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
      }
      if (object.lastPrice != null)
        message.lastPrice = Number(object.lastPrice);
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.priceSecure != null)
        message.priceSecure = Number(object.priceSecure);
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.NotifyOrderEvent.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.channel != null)
        message.channel = String(object.channel);
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      return message;
    };
    NotifyOrderEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.side = "";
        object.accountNo = "";
        object.accountTypeName = "";
        object.coInvestmentGroupName = "";
        object.symbol = "";
        object.price = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.fillQuantity = options.longs === String ? "0" : 0;
        object.orderType = "";
        object.orderStatus = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.canceledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.canceledQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.lastQuantity = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.leaveQuantity = options.longs === String ? "0" : 0;
        object.lastPrice = 0;
        object.averagePrice = 0;
        object.priceSecure = 0;
        object.modifiedDate = null;
        object.channel = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.coInvestmentGroupName != null && message.hasOwnProperty("coInvestmentGroupName"))
        object.coInvestmentGroupName = message.coInvestmentGroupName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
        if (typeof message.fillQuantity === "number")
          object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
        else
          object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
      if (message.orderType != null && message.hasOwnProperty("orderType"))
        object.orderType = message.orderType;
      if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
        object.orderStatus = message.orderStatus;
      if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity"))
        if (typeof message.canceledQuantity === "number")
          object.canceledQuantity = options.longs === String ? String(message.canceledQuantity) : message.canceledQuantity;
        else
          object.canceledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.canceledQuantity) : options.longs === Number ? new $util.LongBits(message.canceledQuantity.low >>> 0, message.canceledQuantity.high >>> 0).toNumber() : message.canceledQuantity;
      if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity"))
        if (typeof message.lastQuantity === "number")
          object.lastQuantity = options.longs === String ? String(message.lastQuantity) : message.lastQuantity;
        else
          object.lastQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.lastQuantity) : options.longs === Number ? new $util.LongBits(message.lastQuantity.low >>> 0, message.lastQuantity.high >>> 0).toNumber() : message.lastQuantity;
      if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
        if (typeof message.leaveQuantity === "number")
          object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
        else
          object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
      if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
        object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.priceSecure != null && message.hasOwnProperty("priceSecure"))
        object.priceSecure = options.json && !isFinite(message.priceSecure) ? String(message.priceSecure) : message.priceSecure;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.channel != null && message.hasOwnProperty("channel"))
        object.channel = message.channel;
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      return object;
    };
    NotifyOrderEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return NotifyOrderEvent;
  }();
  dnse2.LoyaltyChangeState = function() {
    function LoyaltyChangeState(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoyaltyChangeState.prototype.point = 0;
    LoyaltyChangeState.prototype.ratingPoint = 0;
    LoyaltyChangeState.prototype.level = "";
    LoyaltyChangeState.prototype.modifiedDate = "";
    LoyaltyChangeState.create = function create(properties) {
      return new LoyaltyChangeState(properties);
    };
    LoyaltyChangeState.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.point != null && Object.hasOwnProperty.call(message, "point"))
        writer.uint32(9).double(message.point);
      if (message.ratingPoint != null && Object.hasOwnProperty.call(message, "ratingPoint"))
        writer.uint32(17).double(message.ratingPoint);
      if (message.level != null && Object.hasOwnProperty.call(message, "level"))
        writer.uint32(26).string(message.level);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        writer.uint32(34).string(message.modifiedDate);
      return writer;
    };
    LoyaltyChangeState.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoyaltyChangeState.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoyaltyChangeState();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.point = reader.double();
            break;
          case 2:
            message.ratingPoint = reader.double();
            break;
          case 3:
            message.level = reader.string();
            break;
          case 4:
            message.modifiedDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoyaltyChangeState.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoyaltyChangeState.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.point != null && message.hasOwnProperty("point")) {
        if (typeof message.point !== "number")
          return "point: number expected";
      }
      if (message.ratingPoint != null && message.hasOwnProperty("ratingPoint")) {
        if (typeof message.ratingPoint !== "number")
          return "ratingPoint: number expected";
      }
      if (message.level != null && message.hasOwnProperty("level")) {
        if (!$util.isString(message.level))
          return "level: string expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        if (!$util.isString(message.modifiedDate))
          return "modifiedDate: string expected";
      }
      return null;
    };
    LoyaltyChangeState.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoyaltyChangeState)
        return object;
      let message = new $root.dnse.LoyaltyChangeState();
      if (object.point != null)
        message.point = Number(object.point);
      if (object.ratingPoint != null)
        message.ratingPoint = Number(object.ratingPoint);
      if (object.level != null)
        message.level = String(object.level);
      if (object.modifiedDate != null)
        message.modifiedDate = String(object.modifiedDate);
      return message;
    };
    LoyaltyChangeState.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.point = 0;
        object.ratingPoint = 0;
        object.level = "";
        object.modifiedDate = "";
      }
      if (message.point != null && message.hasOwnProperty("point"))
        object.point = options.json && !isFinite(message.point) ? String(message.point) : message.point;
      if (message.ratingPoint != null && message.hasOwnProperty("ratingPoint"))
        object.ratingPoint = options.json && !isFinite(message.ratingPoint) ? String(message.ratingPoint) : message.ratingPoint;
      if (message.level != null && message.hasOwnProperty("level"))
        object.level = message.level;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = message.modifiedDate;
      return object;
    };
    LoyaltyChangeState.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoyaltyChangeState;
  }();
  dnse2.CoInvestmentGroup = function() {
    function CoInvestmentGroup(properties) {
      this.members = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoInvestmentGroup.prototype.id = 0;
    CoInvestmentGroup.prototype.name = "";
    CoInvestmentGroup.prototype.masterAccountNo = "";
    CoInvestmentGroup.prototype.masterCustodyCode = "";
    CoInvestmentGroup.prototype.indexNumber = 0;
    CoInvestmentGroup.prototype.investmentAmount = 0;
    CoInvestmentGroup.prototype.status = 0;
    CoInvestmentGroup.prototype.agreement = null;
    CoInvestmentGroup.prototype.createdDate = null;
    CoInvestmentGroup.prototype.modifiedDate = null;
    CoInvestmentGroup.prototype.members = $util.emptyArray;
    CoInvestmentGroup.prototype.totalMember = 0;
    CoInvestmentGroup.prototype.rateDesc = "";
    CoInvestmentGroup.create = function create(properties) {
      return new CoInvestmentGroup(properties);
    };
    CoInvestmentGroup.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(18).string(message.name);
      if (message.masterAccountNo != null && Object.hasOwnProperty.call(message, "masterAccountNo"))
        writer.uint32(26).string(message.masterAccountNo);
      if (message.masterCustodyCode != null && Object.hasOwnProperty.call(message, "masterCustodyCode"))
        writer.uint32(34).string(message.masterCustodyCode);
      if (message.indexNumber != null && Object.hasOwnProperty.call(message, "indexNumber"))
        writer.uint32(40).int32(message.indexNumber);
      if (message.investmentAmount != null && Object.hasOwnProperty.call(message, "investmentAmount"))
        writer.uint32(49).double(message.investmentAmount);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(56).int32(message.status);
      if (message.agreement != null && Object.hasOwnProperty.call(message, "agreement"))
        $root.dnse.CoInvestmentAgreement.encode(message.agreement, writer.uint32(66).fork()).ldelim();
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(82).fork()).ldelim();
      if (message.members != null && message.members.length)
        for (let i = 0; i < message.members.length; ++i)
          $root.dnse.CoInvestmentMember.encode(message.members[i], writer.uint32(90).fork()).ldelim();
      if (message.totalMember != null && Object.hasOwnProperty.call(message, "totalMember"))
        writer.uint32(96).int32(message.totalMember);
      if (message.rateDesc != null && Object.hasOwnProperty.call(message, "rateDesc"))
        writer.uint32(106).string(message.rateDesc);
      return writer;
    };
    CoInvestmentGroup.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoInvestmentGroup.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoInvestmentGroup();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.name = reader.string();
            break;
          case 3:
            message.masterAccountNo = reader.string();
            break;
          case 4:
            message.masterCustodyCode = reader.string();
            break;
          case 5:
            message.indexNumber = reader.int32();
            break;
          case 6:
            message.investmentAmount = reader.double();
            break;
          case 7:
            message.status = reader.int32();
            break;
          case 8:
            message.agreement = $root.dnse.CoInvestmentAgreement.decode(reader, reader.uint32());
            break;
          case 9:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            if (!(message.members && message.members.length))
              message.members = [];
            message.members.push($root.dnse.CoInvestmentMember.decode(reader, reader.uint32()));
            break;
          case 12:
            message.totalMember = reader.int32();
            break;
          case 13:
            message.rateDesc = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoInvestmentGroup.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoInvestmentGroup.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.masterAccountNo != null && message.hasOwnProperty("masterAccountNo")) {
        if (!$util.isString(message.masterAccountNo))
          return "masterAccountNo: string expected";
      }
      if (message.masterCustodyCode != null && message.hasOwnProperty("masterCustodyCode")) {
        if (!$util.isString(message.masterCustodyCode))
          return "masterCustodyCode: string expected";
      }
      if (message.indexNumber != null && message.hasOwnProperty("indexNumber")) {
        if (!$util.isInteger(message.indexNumber))
          return "indexNumber: integer expected";
      }
      if (message.investmentAmount != null && message.hasOwnProperty("investmentAmount")) {
        if (typeof message.investmentAmount !== "number")
          return "investmentAmount: number expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.agreement != null && message.hasOwnProperty("agreement")) {
        let error = $root.dnse.CoInvestmentAgreement.verify(message.agreement);
        if (error)
          return "agreement." + error;
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.members != null && message.hasOwnProperty("members")) {
        if (!Array.isArray(message.members))
          return "members: array expected";
        for (let i = 0; i < message.members.length; ++i) {
          let error = $root.dnse.CoInvestmentMember.verify(message.members[i]);
          if (error)
            return "members." + error;
        }
      }
      if (message.totalMember != null && message.hasOwnProperty("totalMember")) {
        if (!$util.isInteger(message.totalMember))
          return "totalMember: integer expected";
      }
      if (message.rateDesc != null && message.hasOwnProperty("rateDesc")) {
        if (!$util.isString(message.rateDesc))
          return "rateDesc: string expected";
      }
      return null;
    };
    CoInvestmentGroup.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoInvestmentGroup)
        return object;
      let message = new $root.dnse.CoInvestmentGroup();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.name != null)
        message.name = String(object.name);
      if (object.masterAccountNo != null)
        message.masterAccountNo = String(object.masterAccountNo);
      if (object.masterCustodyCode != null)
        message.masterCustodyCode = String(object.masterCustodyCode);
      if (object.indexNumber != null)
        message.indexNumber = object.indexNumber | 0;
      if (object.investmentAmount != null)
        message.investmentAmount = Number(object.investmentAmount);
      switch (object.status) {
        case "ACTIVE":
        case 0:
          message.status = 0;
          break;
        case "INACTIVE":
        case 1:
          message.status = 1;
          break;
        case "CLOSED":
        case 2:
          message.status = 2;
          break;
        case "UNKNOWN":
        case 3:
          message.status = 3;
          break;
      }
      if (object.agreement != null) {
        if (typeof object.agreement !== "object")
          throw TypeError(".dnse.CoInvestmentGroup.agreement: object expected");
        message.agreement = $root.dnse.CoInvestmentAgreement.fromObject(object.agreement);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.CoInvestmentGroup.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.CoInvestmentGroup.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.members) {
        if (!Array.isArray(object.members))
          throw TypeError(".dnse.CoInvestmentGroup.members: array expected");
        message.members = [];
        for (let i = 0; i < object.members.length; ++i) {
          if (typeof object.members[i] !== "object")
            throw TypeError(".dnse.CoInvestmentGroup.members: object expected");
          message.members[i] = $root.dnse.CoInvestmentMember.fromObject(object.members[i]);
        }
      }
      if (object.totalMember != null)
        message.totalMember = object.totalMember | 0;
      if (object.rateDesc != null)
        message.rateDesc = String(object.rateDesc);
      return message;
    };
    CoInvestmentGroup.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.members = [];
      if (options.defaults) {
        object.id = 0;
        object.name = "";
        object.masterAccountNo = "";
        object.masterCustodyCode = "";
        object.indexNumber = 0;
        object.investmentAmount = 0;
        object.status = options.enums === String ? "ACTIVE" : 0;
        object.agreement = null;
        object.createdDate = null;
        object.modifiedDate = null;
        object.totalMember = 0;
        object.rateDesc = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.masterAccountNo != null && message.hasOwnProperty("masterAccountNo"))
        object.masterAccountNo = message.masterAccountNo;
      if (message.masterCustodyCode != null && message.hasOwnProperty("masterCustodyCode"))
        object.masterCustodyCode = message.masterCustodyCode;
      if (message.indexNumber != null && message.hasOwnProperty("indexNumber"))
        object.indexNumber = message.indexNumber;
      if (message.investmentAmount != null && message.hasOwnProperty("investmentAmount"))
        object.investmentAmount = options.json && !isFinite(message.investmentAmount) ? String(message.investmentAmount) : message.investmentAmount;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.CoInvestmentGroup.Status[message.status] : message.status;
      if (message.agreement != null && message.hasOwnProperty("agreement"))
        object.agreement = $root.dnse.CoInvestmentAgreement.toObject(message.agreement, options);
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.members && message.members.length) {
        object.members = [];
        for (let j = 0; j < message.members.length; ++j)
          object.members[j] = $root.dnse.CoInvestmentMember.toObject(message.members[j], options);
      }
      if (message.totalMember != null && message.hasOwnProperty("totalMember"))
        object.totalMember = message.totalMember;
      if (message.rateDesc != null && message.hasOwnProperty("rateDesc"))
        object.rateDesc = message.rateDesc;
      return object;
    };
    CoInvestmentGroup.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    CoInvestmentGroup.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "ACTIVE"] = 0;
      values[valuesById[1] = "INACTIVE"] = 1;
      values[valuesById[2] = "CLOSED"] = 2;
      values[valuesById[3] = "UNKNOWN"] = 3;
      return values;
    }();
    return CoInvestmentGroup;
  }();
  dnse2.CoInvestmentShareDetail = function() {
    function CoInvestmentShareDetail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoInvestmentShareDetail.prototype.contributionRate = 0;
    CoInvestmentShareDetail.create = function create(properties) {
      return new CoInvestmentShareDetail(properties);
    };
    CoInvestmentShareDetail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.contributionRate != null && Object.hasOwnProperty.call(message, "contributionRate"))
        writer.uint32(9).double(message.contributionRate);
      return writer;
    };
    CoInvestmentShareDetail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoInvestmentShareDetail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoInvestmentShareDetail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.contributionRate = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoInvestmentShareDetail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoInvestmentShareDetail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.contributionRate != null && message.hasOwnProperty("contributionRate")) {
        if (typeof message.contributionRate !== "number")
          return "contributionRate: number expected";
      }
      return null;
    };
    CoInvestmentShareDetail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoInvestmentShareDetail)
        return object;
      let message = new $root.dnse.CoInvestmentShareDetail();
      if (object.contributionRate != null)
        message.contributionRate = Number(object.contributionRate);
      return message;
    };
    CoInvestmentShareDetail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.contributionRate = 0;
      if (message.contributionRate != null && message.hasOwnProperty("contributionRate"))
        object.contributionRate = options.json && !isFinite(message.contributionRate) ? String(message.contributionRate) : message.contributionRate;
      return object;
    };
    CoInvestmentShareDetail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CoInvestmentShareDetail;
  }();
  dnse2.CoInvestmentAgreement = function() {
    function CoInvestmentAgreement(properties) {
      this.shareDetail = {};
      this.symbols = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoInvestmentAgreement.prototype.shareDetail = $util.emptyObject;
    CoInvestmentAgreement.prototype.symbols = $util.emptyArray;
    CoInvestmentAgreement.create = function create(properties) {
      return new CoInvestmentAgreement(properties);
    };
    CoInvestmentAgreement.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.shareDetail != null && Object.hasOwnProperty.call(message, "shareDetail"))
        for (let keys = Object.keys(message.shareDetail), i = 0; i < keys.length; ++i) {
          writer.uint32(10).fork().uint32(10).string(keys[i]);
          $root.dnse.CoInvestmentShareDetail.encode(message.shareDetail[keys[i]], writer.uint32(18).fork()).ldelim().ldelim();
        }
      if (message.symbols != null && message.symbols.length)
        for (let i = 0; i < message.symbols.length; ++i)
          writer.uint32(18).string(message.symbols[i]);
      return writer;
    };
    CoInvestmentAgreement.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoInvestmentAgreement.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoInvestmentAgreement(), key, value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (message.shareDetail === $util.emptyObject)
              message.shareDetail = {};
            let end2 = reader.uint32() + reader.pos;
            key = "";
            value = null;
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = $root.dnse.CoInvestmentShareDetail.decode(reader, reader.uint32());
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.shareDetail[key] = value;
            break;
          case 2:
            if (!(message.symbols && message.symbols.length))
              message.symbols = [];
            message.symbols.push(reader.string());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoInvestmentAgreement.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoInvestmentAgreement.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.shareDetail != null && message.hasOwnProperty("shareDetail")) {
        if (!$util.isObject(message.shareDetail))
          return "shareDetail: object expected";
        let key = Object.keys(message.shareDetail);
        for (let i = 0; i < key.length; ++i) {
          let error = $root.dnse.CoInvestmentShareDetail.verify(message.shareDetail[key[i]]);
          if (error)
            return "shareDetail." + error;
        }
      }
      if (message.symbols != null && message.hasOwnProperty("symbols")) {
        if (!Array.isArray(message.symbols))
          return "symbols: array expected";
        for (let i = 0; i < message.symbols.length; ++i)
          if (!$util.isString(message.symbols[i]))
            return "symbols: string[] expected";
      }
      return null;
    };
    CoInvestmentAgreement.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoInvestmentAgreement)
        return object;
      let message = new $root.dnse.CoInvestmentAgreement();
      if (object.shareDetail) {
        if (typeof object.shareDetail !== "object")
          throw TypeError(".dnse.CoInvestmentAgreement.shareDetail: object expected");
        message.shareDetail = {};
        for (let keys = Object.keys(object.shareDetail), i = 0; i < keys.length; ++i) {
          if (typeof object.shareDetail[keys[i]] !== "object")
            throw TypeError(".dnse.CoInvestmentAgreement.shareDetail: object expected");
          message.shareDetail[keys[i]] = $root.dnse.CoInvestmentShareDetail.fromObject(object.shareDetail[keys[i]]);
        }
      }
      if (object.symbols) {
        if (!Array.isArray(object.symbols))
          throw TypeError(".dnse.CoInvestmentAgreement.symbols: array expected");
        message.symbols = [];
        for (let i = 0; i < object.symbols.length; ++i)
          message.symbols[i] = String(object.symbols[i]);
      }
      return message;
    };
    CoInvestmentAgreement.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.symbols = [];
      if (options.objects || options.defaults)
        object.shareDetail = {};
      let keys2;
      if (message.shareDetail && (keys2 = Object.keys(message.shareDetail)).length) {
        object.shareDetail = {};
        for (let j = 0; j < keys2.length; ++j)
          object.shareDetail[keys2[j]] = $root.dnse.CoInvestmentShareDetail.toObject(message.shareDetail[keys2[j]], options);
      }
      if (message.symbols && message.symbols.length) {
        object.symbols = [];
        for (let j = 0; j < message.symbols.length; ++j)
          object.symbols[j] = message.symbols[j];
      }
      return object;
    };
    CoInvestmentAgreement.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CoInvestmentAgreement;
  }();
  dnse2.CoInvestmentMember = function() {
    function CoInvestmentMember(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoInvestmentMember.prototype.id = 0;
    CoInvestmentMember.prototype.groupId = 0;
    CoInvestmentMember.prototype.indexNumber = "";
    CoInvestmentMember.prototype.custodyCode = "";
    CoInvestmentMember.prototype.status = 0;
    CoInvestmentMember.prototype.role = 0;
    CoInvestmentMember.prototype.principalAmount = 0;
    CoInvestmentMember.prototype.contributionRate = 0;
    CoInvestmentMember.prototype.contributionAmount = 0;
    CoInvestmentMember.prototype.excessAmount = 0;
    CoInvestmentMember.prototype.investorId = "";
    CoInvestmentMember.prototype.createdDate = null;
    CoInvestmentMember.prototype.modifiedDate = null;
    CoInvestmentMember.prototype.name = "";
    CoInvestmentMember.prototype.mobile = "";
    CoInvestmentMember.prototype.isCreatedVA = "";
    CoInvestmentMember.prototype.avatarUrl = "";
    CoInvestmentMember.create = function create(properties) {
      return new CoInvestmentMember(properties);
    };
    CoInvestmentMember.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int32(message.id);
      if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
        writer.uint32(16).int32(message.groupId);
      if (message.indexNumber != null && Object.hasOwnProperty.call(message, "indexNumber"))
        writer.uint32(26).string(message.indexNumber);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(34).string(message.custodyCode);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(40).int32(message.status);
      if (message.role != null && Object.hasOwnProperty.call(message, "role"))
        writer.uint32(48).int32(message.role);
      if (message.principalAmount != null && Object.hasOwnProperty.call(message, "principalAmount"))
        writer.uint32(57).double(message.principalAmount);
      if (message.contributionRate != null && Object.hasOwnProperty.call(message, "contributionRate"))
        writer.uint32(65).double(message.contributionRate);
      if (message.contributionAmount != null && Object.hasOwnProperty.call(message, "contributionAmount"))
        writer.uint32(73).double(message.contributionAmount);
      if (message.excessAmount != null && Object.hasOwnProperty.call(message, "excessAmount"))
        writer.uint32(81).double(message.excessAmount);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(90).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(114).string(message.name);
      if (message.mobile != null && Object.hasOwnProperty.call(message, "mobile"))
        writer.uint32(122).string(message.mobile);
      if (message.isCreatedVA != null && Object.hasOwnProperty.call(message, "isCreatedVA"))
        writer.uint32(130).string(message.isCreatedVA);
      if (message.avatarUrl != null && Object.hasOwnProperty.call(message, "avatarUrl"))
        writer.uint32(138).string(message.avatarUrl);
      return writer;
    };
    CoInvestmentMember.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoInvestmentMember.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoInvestmentMember();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int32();
            break;
          case 2:
            message.groupId = reader.int32();
            break;
          case 3:
            message.indexNumber = reader.string();
            break;
          case 4:
            message.custodyCode = reader.string();
            break;
          case 5:
            message.status = reader.int32();
            break;
          case 6:
            message.role = reader.int32();
            break;
          case 7:
            message.principalAmount = reader.double();
            break;
          case 8:
            message.contributionRate = reader.double();
            break;
          case 9:
            message.contributionAmount = reader.double();
            break;
          case 10:
            message.excessAmount = reader.double();
            break;
          case 11:
            message.investorId = reader.string();
            break;
          case 12:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 14:
            message.name = reader.string();
            break;
          case 15:
            message.mobile = reader.string();
            break;
          case 16:
            message.isCreatedVA = reader.string();
            break;
          case 17:
            message.avatarUrl = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoInvestmentMember.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoInvestmentMember.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.groupId != null && message.hasOwnProperty("groupId")) {
        if (!$util.isInteger(message.groupId))
          return "groupId: integer expected";
      }
      if (message.indexNumber != null && message.hasOwnProperty("indexNumber")) {
        if (!$util.isString(message.indexNumber))
          return "indexNumber: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.role != null && message.hasOwnProperty("role"))
        switch (message.role) {
          default:
            return "role: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.principalAmount != null && message.hasOwnProperty("principalAmount")) {
        if (typeof message.principalAmount !== "number")
          return "principalAmount: number expected";
      }
      if (message.contributionRate != null && message.hasOwnProperty("contributionRate")) {
        if (typeof message.contributionRate !== "number")
          return "contributionRate: number expected";
      }
      if (message.contributionAmount != null && message.hasOwnProperty("contributionAmount")) {
        if (typeof message.contributionAmount !== "number")
          return "contributionAmount: number expected";
      }
      if (message.excessAmount != null && message.hasOwnProperty("excessAmount")) {
        if (typeof message.excessAmount !== "number")
          return "excessAmount: number expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.mobile != null && message.hasOwnProperty("mobile")) {
        if (!$util.isString(message.mobile))
          return "mobile: string expected";
      }
      if (message.isCreatedVA != null && message.hasOwnProperty("isCreatedVA")) {
        if (!$util.isString(message.isCreatedVA))
          return "isCreatedVA: string expected";
      }
      if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl")) {
        if (!$util.isString(message.avatarUrl))
          return "avatarUrl: string expected";
      }
      return null;
    };
    CoInvestmentMember.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoInvestmentMember)
        return object;
      let message = new $root.dnse.CoInvestmentMember();
      if (object.id != null)
        message.id = object.id | 0;
      if (object.groupId != null)
        message.groupId = object.groupId | 0;
      if (object.indexNumber != null)
        message.indexNumber = String(object.indexNumber);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      switch (object.status) {
        case "STATUS_UNKNOWN":
        case 0:
          message.status = 0;
          break;
        case "DELETE":
        case 1:
          message.status = 1;
          break;
        case "ACTIVE":
        case 2:
          message.status = 2;
          break;
        case "WAITING_AGREEMENT":
        case 3:
          message.status = 3;
          break;
        case "WAITING_DEPOSIT":
        case 4:
          message.status = 4;
          break;
      }
      switch (object.role) {
        case "ROLE_UNKNOWN":
        case 0:
          message.role = 0;
          break;
        case "MASTER":
        case 1:
          message.role = 1;
          break;
        case "MEMBER":
        case 2:
          message.role = 2;
          break;
      }
      if (object.principalAmount != null)
        message.principalAmount = Number(object.principalAmount);
      if (object.contributionRate != null)
        message.contributionRate = Number(object.contributionRate);
      if (object.contributionAmount != null)
        message.contributionAmount = Number(object.contributionAmount);
      if (object.excessAmount != null)
        message.excessAmount = Number(object.excessAmount);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.CoInvestmentMember.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.CoInvestmentMember.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.name != null)
        message.name = String(object.name);
      if (object.mobile != null)
        message.mobile = String(object.mobile);
      if (object.isCreatedVA != null)
        message.isCreatedVA = String(object.isCreatedVA);
      if (object.avatarUrl != null)
        message.avatarUrl = String(object.avatarUrl);
      return message;
    };
    CoInvestmentMember.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.groupId = 0;
        object.indexNumber = "";
        object.custodyCode = "";
        object.status = options.enums === String ? "STATUS_UNKNOWN" : 0;
        object.role = options.enums === String ? "ROLE_UNKNOWN" : 0;
        object.principalAmount = 0;
        object.contributionRate = 0;
        object.contributionAmount = 0;
        object.excessAmount = 0;
        object.investorId = "";
        object.createdDate = null;
        object.modifiedDate = null;
        object.name = "";
        object.mobile = "";
        object.isCreatedVA = "";
        object.avatarUrl = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.groupId != null && message.hasOwnProperty("groupId"))
        object.groupId = message.groupId;
      if (message.indexNumber != null && message.hasOwnProperty("indexNumber"))
        object.indexNumber = message.indexNumber;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.CoInvestmentMember.Status[message.status] : message.status;
      if (message.role != null && message.hasOwnProperty("role"))
        object.role = options.enums === String ? $root.dnse.CoInvestmentMember.Role[message.role] : message.role;
      if (message.principalAmount != null && message.hasOwnProperty("principalAmount"))
        object.principalAmount = options.json && !isFinite(message.principalAmount) ? String(message.principalAmount) : message.principalAmount;
      if (message.contributionRate != null && message.hasOwnProperty("contributionRate"))
        object.contributionRate = options.json && !isFinite(message.contributionRate) ? String(message.contributionRate) : message.contributionRate;
      if (message.contributionAmount != null && message.hasOwnProperty("contributionAmount"))
        object.contributionAmount = options.json && !isFinite(message.contributionAmount) ? String(message.contributionAmount) : message.contributionAmount;
      if (message.excessAmount != null && message.hasOwnProperty("excessAmount"))
        object.excessAmount = options.json && !isFinite(message.excessAmount) ? String(message.excessAmount) : message.excessAmount;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.mobile != null && message.hasOwnProperty("mobile"))
        object.mobile = message.mobile;
      if (message.isCreatedVA != null && message.hasOwnProperty("isCreatedVA"))
        object.isCreatedVA = message.isCreatedVA;
      if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
        object.avatarUrl = message.avatarUrl;
      return object;
    };
    CoInvestmentMember.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    CoInvestmentMember.Role = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "ROLE_UNKNOWN"] = 0;
      values[valuesById[1] = "MASTER"] = 1;
      values[valuesById[2] = "MEMBER"] = 2;
      return values;
    }();
    CoInvestmentMember.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "STATUS_UNKNOWN"] = 0;
      values[valuesById[1] = "DELETE"] = 1;
      values[valuesById[2] = "ACTIVE"] = 2;
      values[valuesById[3] = "WAITING_AGREEMENT"] = 3;
      values[valuesById[4] = "WAITING_DEPOSIT"] = 4;
      return values;
    }();
    return CoInvestmentMember;
  }();
  dnse2.CoInvestmentNotifyEvent = function() {
    function CoInvestmentNotifyEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoInvestmentNotifyEvent.prototype.memberName = "";
    CoInvestmentNotifyEvent.prototype.masterName = "";
    CoInvestmentNotifyEvent.prototype.groupName = "";
    CoInvestmentNotifyEvent.prototype.groupId = "";
    CoInvestmentNotifyEvent.prototype.investorId = "";
    CoInvestmentNotifyEvent.prototype.custodyCode = "";
    CoInvestmentNotifyEvent.prototype.eventType = 0;
    CoInvestmentNotifyEvent.prototype.masterAccountNo = "";
    CoInvestmentNotifyEvent.create = function create(properties) {
      return new CoInvestmentNotifyEvent(properties);
    };
    CoInvestmentNotifyEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.memberName != null && Object.hasOwnProperty.call(message, "memberName"))
        writer.uint32(10).string(message.memberName);
      if (message.masterName != null && Object.hasOwnProperty.call(message, "masterName"))
        writer.uint32(18).string(message.masterName);
      if (message.groupName != null && Object.hasOwnProperty.call(message, "groupName"))
        writer.uint32(26).string(message.groupName);
      if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
        writer.uint32(34).string(message.groupId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(50).string(message.custodyCode);
      if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
        writer.uint32(56).int32(message.eventType);
      if (message.masterAccountNo != null && Object.hasOwnProperty.call(message, "masterAccountNo"))
        writer.uint32(66).string(message.masterAccountNo);
      return writer;
    };
    CoInvestmentNotifyEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoInvestmentNotifyEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoInvestmentNotifyEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.memberName = reader.string();
            break;
          case 2:
            message.masterName = reader.string();
            break;
          case 3:
            message.groupName = reader.string();
            break;
          case 4:
            message.groupId = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.custodyCode = reader.string();
            break;
          case 7:
            message.eventType = reader.int32();
            break;
          case 8:
            message.masterAccountNo = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoInvestmentNotifyEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoInvestmentNotifyEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.memberName != null && message.hasOwnProperty("memberName")) {
        if (!$util.isString(message.memberName))
          return "memberName: string expected";
      }
      if (message.masterName != null && message.hasOwnProperty("masterName")) {
        if (!$util.isString(message.masterName))
          return "masterName: string expected";
      }
      if (message.groupName != null && message.hasOwnProperty("groupName")) {
        if (!$util.isString(message.groupName))
          return "groupName: string expected";
      }
      if (message.groupId != null && message.hasOwnProperty("groupId")) {
        if (!$util.isString(message.groupId))
          return "groupId: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.eventType != null && message.hasOwnProperty("eventType"))
        switch (message.eventType) {
          default:
            return "eventType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.masterAccountNo != null && message.hasOwnProperty("masterAccountNo")) {
        if (!$util.isString(message.masterAccountNo))
          return "masterAccountNo: string expected";
      }
      return null;
    };
    CoInvestmentNotifyEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoInvestmentNotifyEvent)
        return object;
      let message = new $root.dnse.CoInvestmentNotifyEvent();
      if (object.memberName != null)
        message.memberName = String(object.memberName);
      if (object.masterName != null)
        message.masterName = String(object.masterName);
      if (object.groupName != null)
        message.groupName = String(object.groupName);
      if (object.groupId != null)
        message.groupId = String(object.groupId);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      switch (object.eventType) {
        case "SEND_AGREEMENT":
        case 0:
          message.eventType = 0;
          break;
        case "ACCEPT_AGREEMENT":
        case 1:
          message.eventType = 1;
          break;
        case "REMIND_DEPOSIT":
        case 2:
          message.eventType = 2;
          break;
        case "CLOSE_AGREEMENT":
        case 3:
          message.eventType = 3;
          break;
      }
      if (object.masterAccountNo != null)
        message.masterAccountNo = String(object.masterAccountNo);
      return message;
    };
    CoInvestmentNotifyEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.memberName = "";
        object.masterName = "";
        object.groupName = "";
        object.groupId = "";
        object.investorId = "";
        object.custodyCode = "";
        object.eventType = options.enums === String ? "SEND_AGREEMENT" : 0;
        object.masterAccountNo = "";
      }
      if (message.memberName != null && message.hasOwnProperty("memberName"))
        object.memberName = message.memberName;
      if (message.masterName != null && message.hasOwnProperty("masterName"))
        object.masterName = message.masterName;
      if (message.groupName != null && message.hasOwnProperty("groupName"))
        object.groupName = message.groupName;
      if (message.groupId != null && message.hasOwnProperty("groupId"))
        object.groupId = message.groupId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.eventType != null && message.hasOwnProperty("eventType"))
        object.eventType = options.enums === String ? $root.dnse.CoInvestmentNotifyEvent.EventType[message.eventType] : message.eventType;
      if (message.masterAccountNo != null && message.hasOwnProperty("masterAccountNo"))
        object.masterAccountNo = message.masterAccountNo;
      return object;
    };
    CoInvestmentNotifyEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    CoInvestmentNotifyEvent.EventType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "SEND_AGREEMENT"] = 0;
      values[valuesById[1] = "ACCEPT_AGREEMENT"] = 1;
      values[valuesById[2] = "REMIND_DEPOSIT"] = 2;
      values[valuesById[3] = "CLOSE_AGREEMENT"] = 3;
      return values;
    }();
    return CoInvestmentNotifyEvent;
  }();
  dnse2.CoInvestmentNotifyBalance = function() {
    function CoInvestmentNotifyBalance(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CoInvestmentNotifyBalance.prototype.groupName = "";
    CoInvestmentNotifyBalance.prototype.memberName = "";
    CoInvestmentNotifyBalance.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CoInvestmentNotifyBalance.prototype.availableCash = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CoInvestmentNotifyBalance.prototype.createdDate = null;
    CoInvestmentNotifyBalance.prototype.investorId = "";
    CoInvestmentNotifyBalance.prototype.accountNo = "";
    CoInvestmentNotifyBalance.prototype.accountTypeName = "";
    CoInvestmentNotifyBalance.prototype.eventType = 0;
    CoInvestmentNotifyBalance.create = function create(properties) {
      return new CoInvestmentNotifyBalance(properties);
    };
    CoInvestmentNotifyBalance.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.groupName != null && Object.hasOwnProperty.call(message, "groupName"))
        writer.uint32(10).string(message.groupName);
      if (message.memberName != null && Object.hasOwnProperty.call(message, "memberName"))
        writer.uint32(18).string(message.memberName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).int64(message.amount);
      if (message.availableCash != null && Object.hasOwnProperty.call(message, "availableCash"))
        writer.uint32(32).int64(message.availableCash);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(42).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(58).string(message.accountNo);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(66).string(message.accountTypeName);
      if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
        writer.uint32(72).int32(message.eventType);
      return writer;
    };
    CoInvestmentNotifyBalance.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CoInvestmentNotifyBalance.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CoInvestmentNotifyBalance();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.groupName = reader.string();
            break;
          case 2:
            message.memberName = reader.string();
            break;
          case 3:
            message.amount = reader.int64();
            break;
          case 4:
            message.availableCash = reader.int64();
            break;
          case 5:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.accountNo = reader.string();
            break;
          case 8:
            message.accountTypeName = reader.string();
            break;
          case 9:
            message.eventType = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CoInvestmentNotifyBalance.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CoInvestmentNotifyBalance.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.groupName != null && message.hasOwnProperty("groupName")) {
        if (!$util.isString(message.groupName))
          return "groupName: string expected";
      }
      if (message.memberName != null && message.hasOwnProperty("memberName")) {
        if (!$util.isString(message.memberName))
          return "memberName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.availableCash != null && message.hasOwnProperty("availableCash")) {
        if (!$util.isInteger(message.availableCash) && !(message.availableCash && $util.isInteger(message.availableCash.low) && $util.isInteger(message.availableCash.high)))
          return "availableCash: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.eventType != null && message.hasOwnProperty("eventType"))
        switch (message.eventType) {
          default:
            return "eventType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
        }
      return null;
    };
    CoInvestmentNotifyBalance.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CoInvestmentNotifyBalance)
        return object;
      let message = new $root.dnse.CoInvestmentNotifyBalance();
      if (object.groupName != null)
        message.groupName = String(object.groupName);
      if (object.memberName != null)
        message.memberName = String(object.memberName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.availableCash != null) {
        if ($util.Long)
          (message.availableCash = $util.Long.fromValue(object.availableCash)).unsigned = false;
        else if (typeof object.availableCash === "string")
          message.availableCash = parseInt(object.availableCash, 10);
        else if (typeof object.availableCash === "number")
          message.availableCash = object.availableCash;
        else if (typeof object.availableCash === "object")
          message.availableCash = new $util.LongBits(object.availableCash.low >>> 0, object.availableCash.high >>> 0).toNumber();
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.CoInvestmentNotifyBalance.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      switch (object.eventType) {
        case "GROUP_DEPOSIT":
        case 0:
          message.eventType = 0;
          break;
        case "GROUP_REFUND":
        case 1:
          message.eventType = 1;
          break;
        case "MEMBER_TRANSFER":
        case 2:
          message.eventType = 2;
          break;
        case "MEMBER_RECEIVE_REFUND":
        case 3:
          message.eventType = 3;
          break;
        case "MEMBER_RECEIVE_WITHDRAW":
        case 4:
          message.eventType = 4;
          break;
        case "GROUP_WITHDRAW":
        case 5:
          message.eventType = 5;
          break;
      }
      return message;
    };
    CoInvestmentNotifyBalance.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.groupName = "";
        object.memberName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.availableCash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.availableCash = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.investorId = "";
        object.accountNo = "";
        object.accountTypeName = "";
        object.eventType = options.enums === String ? "GROUP_DEPOSIT" : 0;
      }
      if (message.groupName != null && message.hasOwnProperty("groupName"))
        object.groupName = message.groupName;
      if (message.memberName != null && message.hasOwnProperty("memberName"))
        object.memberName = message.memberName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.availableCash != null && message.hasOwnProperty("availableCash"))
        if (typeof message.availableCash === "number")
          object.availableCash = options.longs === String ? String(message.availableCash) : message.availableCash;
        else
          object.availableCash = options.longs === String ? $util.Long.prototype.toString.call(message.availableCash) : options.longs === Number ? new $util.LongBits(message.availableCash.low >>> 0, message.availableCash.high >>> 0).toNumber() : message.availableCash;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.eventType != null && message.hasOwnProperty("eventType"))
        object.eventType = options.enums === String ? $root.dnse.CoInvestmentNotifyBalance.EventType[message.eventType] : message.eventType;
      return object;
    };
    CoInvestmentNotifyBalance.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    CoInvestmentNotifyBalance.EventType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "GROUP_DEPOSIT"] = 0;
      values[valuesById[1] = "GROUP_REFUND"] = 1;
      values[valuesById[2] = "MEMBER_TRANSFER"] = 2;
      values[valuesById[3] = "MEMBER_RECEIVE_REFUND"] = 3;
      values[valuesById[4] = "MEMBER_RECEIVE_WITHDRAW"] = 4;
      values[valuesById[5] = "GROUP_WITHDRAW"] = 5;
      return values;
    }();
    return CoInvestmentNotifyBalance;
  }();
  dnse2.WelcomeNewDerivativeCustomer = function() {
    function WelcomeNewDerivativeCustomer(properties) {
      this.fileId = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    WelcomeNewDerivativeCustomer.prototype.fullName = "";
    WelcomeNewDerivativeCustomer.prototype.fileId = $util.emptyArray;
    WelcomeNewDerivativeCustomer.create = function create(properties) {
      return new WelcomeNewDerivativeCustomer(properties);
    };
    WelcomeNewDerivativeCustomer.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(10).string(message.fullName);
      if (message.fileId != null && message.fileId.length)
        for (let i = 0; i < message.fileId.length; ++i)
          writer.uint32(18).string(message.fileId[i]);
      return writer;
    };
    WelcomeNewDerivativeCustomer.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    WelcomeNewDerivativeCustomer.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.WelcomeNewDerivativeCustomer();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.fullName = reader.string();
            break;
          case 2:
            if (!(message.fileId && message.fileId.length))
              message.fileId = [];
            message.fileId.push(reader.string());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    WelcomeNewDerivativeCustomer.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    WelcomeNewDerivativeCustomer.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.fileId != null && message.hasOwnProperty("fileId")) {
        if (!Array.isArray(message.fileId))
          return "fileId: array expected";
        for (let i = 0; i < message.fileId.length; ++i)
          if (!$util.isString(message.fileId[i]))
            return "fileId: string[] expected";
      }
      return null;
    };
    WelcomeNewDerivativeCustomer.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.WelcomeNewDerivativeCustomer)
        return object;
      let message = new $root.dnse.WelcomeNewDerivativeCustomer();
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.fileId) {
        if (!Array.isArray(object.fileId))
          throw TypeError(".dnse.WelcomeNewDerivativeCustomer.fileId: array expected");
        message.fileId = [];
        for (let i = 0; i < object.fileId.length; ++i)
          message.fileId[i] = String(object.fileId[i]);
      }
      return message;
    };
    WelcomeNewDerivativeCustomer.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.fileId = [];
      if (options.defaults)
        object.fullName = "";
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.fileId && message.fileId.length) {
        object.fileId = [];
        for (let j = 0; j < message.fileId.length; ++j)
          object.fileId[j] = message.fileId[j];
      }
      return object;
    };
    WelcomeNewDerivativeCustomer.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return WelcomeNewDerivativeCustomer;
  }();
  dnse2.CrossOrder = function() {
    function CrossOrder(properties) {
      this.actions = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CrossOrder.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CrossOrder.prototype.crossType = 0;
    CrossOrder.prototype.side = "";
    CrossOrder.prototype.investorId = "";
    CrossOrder.prototype.accountNo = "";
    CrossOrder.prototype.symbol = "";
    CrossOrder.prototype.price = 0;
    CrossOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CrossOrder.prototype.orderStatus = "";
    CrossOrder.prototype.execType = "";
    CrossOrder.prototype.transDate = null;
    CrossOrder.prototype.createdDate = null;
    CrossOrder.prototype.modifiedDate = null;
    CrossOrder.prototype.externalId = "";
    CrossOrder.prototype.error = "";
    CrossOrder.prototype.text = "";
    CrossOrder.prototype.custody = "";
    CrossOrder.prototype.buyAccountNo = "";
    CrossOrder.prototype.buyCustody = "";
    CrossOrder.prototype.buyInvestorId = "";
    CrossOrder.prototype.firmId = "";
    CrossOrder.prototype.traderId = "";
    CrossOrder.prototype.buyFirmId = "";
    CrossOrder.prototype.buyTraderId = "";
    CrossOrder.prototype.clOrdId = "";
    CrossOrder.prototype.origClOrdId = "";
    CrossOrder.prototype.exDestination = "";
    CrossOrder.prototype.maker = "";
    CrossOrder.prototype.channel = "";
    CrossOrder.prototype.feeRate = 0;
    CrossOrder.prototype.taxRate = 0;
    CrossOrder.prototype.buyFeeRate = 0;
    CrossOrder.prototype.buyTaxRate = 0;
    CrossOrder.prototype.externalAdvOrderId = "";
    CrossOrder.prototype.actions = $util.emptyArray;
    CrossOrder.prototype.loanPackageId = 0;
    CrossOrder.prototype.buyLoanPackageId = 0;
    CrossOrder.prototype.buyInitialRate = 0;
    CrossOrder.prototype.metadata = "";
    CrossOrder.prototype.buyMaker = "";
    CrossOrder.prototype.buyChannel = "";
    CrossOrder.prototype.exchangeFeeRate = 0;
    CrossOrder.prototype.initialRate = 0;
    CrossOrder.create = function create(properties) {
      return new CrossOrder(properties);
    };
    CrossOrder.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.crossType != null && Object.hasOwnProperty.call(message, "crossType"))
        writer.uint32(16).int32(message.crossType);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(26).string(message.side);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(42).string(message.accountNo);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(50).string(message.symbol);
      if (message.price != null && Object.hasOwnProperty.call(message, "price"))
        writer.uint32(57).double(message.price);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(64).int64(message.quantity);
      if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
        writer.uint32(74).string(message.orderStatus);
      if (message.execType != null && Object.hasOwnProperty.call(message, "execType"))
        writer.uint32(82).string(message.execType);
      if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
        $root.google.protobuf.Timestamp.encode(message.transDate, writer.uint32(90).fork()).ldelim();
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
      if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
        writer.uint32(114).string(message.externalId);
      if (message.error != null && Object.hasOwnProperty.call(message, "error"))
        writer.uint32(122).string(message.error);
      if (message.text != null && Object.hasOwnProperty.call(message, "text"))
        writer.uint32(130).string(message.text);
      if (message.custody != null && Object.hasOwnProperty.call(message, "custody"))
        writer.uint32(138).string(message.custody);
      if (message.buyAccountNo != null && Object.hasOwnProperty.call(message, "buyAccountNo"))
        writer.uint32(146).string(message.buyAccountNo);
      if (message.buyCustody != null && Object.hasOwnProperty.call(message, "buyCustody"))
        writer.uint32(154).string(message.buyCustody);
      if (message.buyInvestorId != null && Object.hasOwnProperty.call(message, "buyInvestorId"))
        writer.uint32(162).string(message.buyInvestorId);
      if (message.firmId != null && Object.hasOwnProperty.call(message, "firmId"))
        writer.uint32(170).string(message.firmId);
      if (message.traderId != null && Object.hasOwnProperty.call(message, "traderId"))
        writer.uint32(178).string(message.traderId);
      if (message.buyFirmId != null && Object.hasOwnProperty.call(message, "buyFirmId"))
        writer.uint32(186).string(message.buyFirmId);
      if (message.buyTraderId != null && Object.hasOwnProperty.call(message, "buyTraderId"))
        writer.uint32(194).string(message.buyTraderId);
      if (message.clOrdId != null && Object.hasOwnProperty.call(message, "clOrdId"))
        writer.uint32(202).string(message.clOrdId);
      if (message.origClOrdId != null && Object.hasOwnProperty.call(message, "origClOrdId"))
        writer.uint32(210).string(message.origClOrdId);
      if (message.exDestination != null && Object.hasOwnProperty.call(message, "exDestination"))
        writer.uint32(218).string(message.exDestination);
      if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
        writer.uint32(226).string(message.maker);
      if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
        writer.uint32(234).string(message.channel);
      if (message.feeRate != null && Object.hasOwnProperty.call(message, "feeRate"))
        writer.uint32(241).double(message.feeRate);
      if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
        writer.uint32(249).double(message.taxRate);
      if (message.buyFeeRate != null && Object.hasOwnProperty.call(message, "buyFeeRate"))
        writer.uint32(257).double(message.buyFeeRate);
      if (message.buyTaxRate != null && Object.hasOwnProperty.call(message, "buyTaxRate"))
        writer.uint32(265).double(message.buyTaxRate);
      if (message.externalAdvOrderId != null && Object.hasOwnProperty.call(message, "externalAdvOrderId"))
        writer.uint32(274).string(message.externalAdvOrderId);
      if (message.actions != null && message.actions.length)
        for (let i = 0; i < message.actions.length; ++i)
          writer.uint32(282).string(message.actions[i]);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(288).int32(message.loanPackageId);
      if (message.buyLoanPackageId != null && Object.hasOwnProperty.call(message, "buyLoanPackageId"))
        writer.uint32(296).int32(message.buyLoanPackageId);
      if (message.buyInitialRate != null && Object.hasOwnProperty.call(message, "buyInitialRate"))
        writer.uint32(305).double(message.buyInitialRate);
      if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
        writer.uint32(314).string(message.metadata);
      if (message.buyMaker != null && Object.hasOwnProperty.call(message, "buyMaker"))
        writer.uint32(322).string(message.buyMaker);
      if (message.buyChannel != null && Object.hasOwnProperty.call(message, "buyChannel"))
        writer.uint32(330).string(message.buyChannel);
      if (message.exchangeFeeRate != null && Object.hasOwnProperty.call(message, "exchangeFeeRate"))
        writer.uint32(337).double(message.exchangeFeeRate);
      if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
        writer.uint32(345).double(message.initialRate);
      return writer;
    };
    CrossOrder.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CrossOrder.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CrossOrder();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.crossType = reader.int32();
            break;
          case 3:
            message.side = reader.string();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.accountNo = reader.string();
            break;
          case 6:
            message.symbol = reader.string();
            break;
          case 7:
            message.price = reader.double();
            break;
          case 8:
            message.quantity = reader.int64();
            break;
          case 9:
            message.orderStatus = reader.string();
            break;
          case 10:
            message.execType = reader.string();
            break;
          case 11:
            message.transDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 14:
            message.externalId = reader.string();
            break;
          case 15:
            message.error = reader.string();
            break;
          case 16:
            message.text = reader.string();
            break;
          case 17:
            message.custody = reader.string();
            break;
          case 18:
            message.buyAccountNo = reader.string();
            break;
          case 19:
            message.buyCustody = reader.string();
            break;
          case 20:
            message.buyInvestorId = reader.string();
            break;
          case 21:
            message.firmId = reader.string();
            break;
          case 22:
            message.traderId = reader.string();
            break;
          case 23:
            message.buyFirmId = reader.string();
            break;
          case 24:
            message.buyTraderId = reader.string();
            break;
          case 25:
            message.clOrdId = reader.string();
            break;
          case 26:
            message.origClOrdId = reader.string();
            break;
          case 27:
            message.exDestination = reader.string();
            break;
          case 28:
            message.maker = reader.string();
            break;
          case 29:
            message.channel = reader.string();
            break;
          case 30:
            message.feeRate = reader.double();
            break;
          case 31:
            message.taxRate = reader.double();
            break;
          case 32:
            message.buyFeeRate = reader.double();
            break;
          case 33:
            message.buyTaxRate = reader.double();
            break;
          case 34:
            message.externalAdvOrderId = reader.string();
            break;
          case 35:
            if (!(message.actions && message.actions.length))
              message.actions = [];
            message.actions.push(reader.string());
            break;
          case 36:
            message.loanPackageId = reader.int32();
            break;
          case 37:
            message.buyLoanPackageId = reader.int32();
            break;
          case 38:
            message.buyInitialRate = reader.double();
            break;
          case 39:
            message.metadata = reader.string();
            break;
          case 40:
            message.buyMaker = reader.string();
            break;
          case 41:
            message.buyChannel = reader.string();
            break;
          case 42:
            message.exchangeFeeRate = reader.double();
            break;
          case 43:
            message.initialRate = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CrossOrder.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CrossOrder.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.crossType != null && message.hasOwnProperty("crossType"))
        switch (message.crossType) {
          default:
            return "crossType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.price != null && message.hasOwnProperty("price")) {
        if (typeof message.price !== "number")
          return "price: number expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
        if (!$util.isString(message.orderStatus))
          return "orderStatus: string expected";
      }
      if (message.execType != null && message.hasOwnProperty("execType")) {
        if (!$util.isString(message.execType))
          return "execType: string expected";
      }
      if (message.transDate != null && message.hasOwnProperty("transDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.transDate);
        if (error)
          return "transDate." + error;
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
        if (error)
          return "modifiedDate." + error;
      }
      if (message.externalId != null && message.hasOwnProperty("externalId")) {
        if (!$util.isString(message.externalId))
          return "externalId: string expected";
      }
      if (message.error != null && message.hasOwnProperty("error")) {
        if (!$util.isString(message.error))
          return "error: string expected";
      }
      if (message.text != null && message.hasOwnProperty("text")) {
        if (!$util.isString(message.text))
          return "text: string expected";
      }
      if (message.custody != null && message.hasOwnProperty("custody")) {
        if (!$util.isString(message.custody))
          return "custody: string expected";
      }
      if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo")) {
        if (!$util.isString(message.buyAccountNo))
          return "buyAccountNo: string expected";
      }
      if (message.buyCustody != null && message.hasOwnProperty("buyCustody")) {
        if (!$util.isString(message.buyCustody))
          return "buyCustody: string expected";
      }
      if (message.buyInvestorId != null && message.hasOwnProperty("buyInvestorId")) {
        if (!$util.isString(message.buyInvestorId))
          return "buyInvestorId: string expected";
      }
      if (message.firmId != null && message.hasOwnProperty("firmId")) {
        if (!$util.isString(message.firmId))
          return "firmId: string expected";
      }
      if (message.traderId != null && message.hasOwnProperty("traderId")) {
        if (!$util.isString(message.traderId))
          return "traderId: string expected";
      }
      if (message.buyFirmId != null && message.hasOwnProperty("buyFirmId")) {
        if (!$util.isString(message.buyFirmId))
          return "buyFirmId: string expected";
      }
      if (message.buyTraderId != null && message.hasOwnProperty("buyTraderId")) {
        if (!$util.isString(message.buyTraderId))
          return "buyTraderId: string expected";
      }
      if (message.clOrdId != null && message.hasOwnProperty("clOrdId")) {
        if (!$util.isString(message.clOrdId))
          return "clOrdId: string expected";
      }
      if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId")) {
        if (!$util.isString(message.origClOrdId))
          return "origClOrdId: string expected";
      }
      if (message.exDestination != null && message.hasOwnProperty("exDestination")) {
        if (!$util.isString(message.exDestination))
          return "exDestination: string expected";
      }
      if (message.maker != null && message.hasOwnProperty("maker")) {
        if (!$util.isString(message.maker))
          return "maker: string expected";
      }
      if (message.channel != null && message.hasOwnProperty("channel")) {
        if (!$util.isString(message.channel))
          return "channel: string expected";
      }
      if (message.feeRate != null && message.hasOwnProperty("feeRate")) {
        if (typeof message.feeRate !== "number")
          return "feeRate: number expected";
      }
      if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
        if (typeof message.taxRate !== "number")
          return "taxRate: number expected";
      }
      if (message.buyFeeRate != null && message.hasOwnProperty("buyFeeRate")) {
        if (typeof message.buyFeeRate !== "number")
          return "buyFeeRate: number expected";
      }
      if (message.buyTaxRate != null && message.hasOwnProperty("buyTaxRate")) {
        if (typeof message.buyTaxRate !== "number")
          return "buyTaxRate: number expected";
      }
      if (message.externalAdvOrderId != null && message.hasOwnProperty("externalAdvOrderId")) {
        if (!$util.isString(message.externalAdvOrderId))
          return "externalAdvOrderId: string expected";
      }
      if (message.actions != null && message.hasOwnProperty("actions")) {
        if (!Array.isArray(message.actions))
          return "actions: array expected";
        for (let i = 0; i < message.actions.length; ++i)
          if (!$util.isString(message.actions[i]))
            return "actions: string[] expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId")) {
        if (!$util.isInteger(message.buyLoanPackageId))
          return "buyLoanPackageId: integer expected";
      }
      if (message.buyInitialRate != null && message.hasOwnProperty("buyInitialRate")) {
        if (typeof message.buyInitialRate !== "number")
          return "buyInitialRate: number expected";
      }
      if (message.metadata != null && message.hasOwnProperty("metadata")) {
        if (!$util.isString(message.metadata))
          return "metadata: string expected";
      }
      if (message.buyMaker != null && message.hasOwnProperty("buyMaker")) {
        if (!$util.isString(message.buyMaker))
          return "buyMaker: string expected";
      }
      if (message.buyChannel != null && message.hasOwnProperty("buyChannel")) {
        if (!$util.isString(message.buyChannel))
          return "buyChannel: string expected";
      }
      if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate")) {
        if (typeof message.exchangeFeeRate !== "number")
          return "exchangeFeeRate: number expected";
      }
      if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
        if (typeof message.initialRate !== "number")
          return "initialRate: number expected";
      }
      return null;
    };
    CrossOrder.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CrossOrder)
        return object;
      let message = new $root.dnse.CrossOrder();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      switch (object.crossType) {
        case "UNKNOWN_TYPE":
        case 0:
          message.crossType = 0;
          break;
        case "ONE_FIRM":
        case 1:
          message.crossType = 1;
          break;
        case "TWO_FIRM":
        case 2:
          message.crossType = 2;
          break;
      }
      if (object.side != null)
        message.side = String(object.side);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.price != null)
        message.price = Number(object.price);
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.orderStatus != null)
        message.orderStatus = String(object.orderStatus);
      if (object.execType != null)
        message.execType = String(object.execType);
      if (object.transDate != null) {
        if (typeof object.transDate !== "object")
          throw TypeError(".dnse.CrossOrder.transDate: object expected");
        message.transDate = $root.google.protobuf.Timestamp.fromObject(object.transDate);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.CrossOrder.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.modifiedDate != null) {
        if (typeof object.modifiedDate !== "object")
          throw TypeError(".dnse.CrossOrder.modifiedDate: object expected");
        message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
      }
      if (object.externalId != null)
        message.externalId = String(object.externalId);
      if (object.error != null)
        message.error = String(object.error);
      if (object.text != null)
        message.text = String(object.text);
      if (object.custody != null)
        message.custody = String(object.custody);
      if (object.buyAccountNo != null)
        message.buyAccountNo = String(object.buyAccountNo);
      if (object.buyCustody != null)
        message.buyCustody = String(object.buyCustody);
      if (object.buyInvestorId != null)
        message.buyInvestorId = String(object.buyInvestorId);
      if (object.firmId != null)
        message.firmId = String(object.firmId);
      if (object.traderId != null)
        message.traderId = String(object.traderId);
      if (object.buyFirmId != null)
        message.buyFirmId = String(object.buyFirmId);
      if (object.buyTraderId != null)
        message.buyTraderId = String(object.buyTraderId);
      if (object.clOrdId != null)
        message.clOrdId = String(object.clOrdId);
      if (object.origClOrdId != null)
        message.origClOrdId = String(object.origClOrdId);
      if (object.exDestination != null)
        message.exDestination = String(object.exDestination);
      if (object.maker != null)
        message.maker = String(object.maker);
      if (object.channel != null)
        message.channel = String(object.channel);
      if (object.feeRate != null)
        message.feeRate = Number(object.feeRate);
      if (object.taxRate != null)
        message.taxRate = Number(object.taxRate);
      if (object.buyFeeRate != null)
        message.buyFeeRate = Number(object.buyFeeRate);
      if (object.buyTaxRate != null)
        message.buyTaxRate = Number(object.buyTaxRate);
      if (object.externalAdvOrderId != null)
        message.externalAdvOrderId = String(object.externalAdvOrderId);
      if (object.actions) {
        if (!Array.isArray(object.actions))
          throw TypeError(".dnse.CrossOrder.actions: array expected");
        message.actions = [];
        for (let i = 0; i < object.actions.length; ++i)
          message.actions[i] = String(object.actions[i]);
      }
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.buyLoanPackageId != null)
        message.buyLoanPackageId = object.buyLoanPackageId | 0;
      if (object.buyInitialRate != null)
        message.buyInitialRate = Number(object.buyInitialRate);
      if (object.metadata != null)
        message.metadata = String(object.metadata);
      if (object.buyMaker != null)
        message.buyMaker = String(object.buyMaker);
      if (object.buyChannel != null)
        message.buyChannel = String(object.buyChannel);
      if (object.exchangeFeeRate != null)
        message.exchangeFeeRate = Number(object.exchangeFeeRate);
      if (object.initialRate != null)
        message.initialRate = Number(object.initialRate);
      return message;
    };
    CrossOrder.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.actions = [];
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.crossType = options.enums === String ? "UNKNOWN_TYPE" : 0;
        object.side = "";
        object.investorId = "";
        object.accountNo = "";
        object.symbol = "";
        object.price = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        object.orderStatus = "";
        object.execType = "";
        object.transDate = null;
        object.createdDate = null;
        object.modifiedDate = null;
        object.externalId = "";
        object.error = "";
        object.text = "";
        object.custody = "";
        object.buyAccountNo = "";
        object.buyCustody = "";
        object.buyInvestorId = "";
        object.firmId = "";
        object.traderId = "";
        object.buyFirmId = "";
        object.buyTraderId = "";
        object.clOrdId = "";
        object.origClOrdId = "";
        object.exDestination = "";
        object.maker = "";
        object.channel = "";
        object.feeRate = 0;
        object.taxRate = 0;
        object.buyFeeRate = 0;
        object.buyTaxRate = 0;
        object.externalAdvOrderId = "";
        object.loanPackageId = 0;
        object.buyLoanPackageId = 0;
        object.buyInitialRate = 0;
        object.metadata = "";
        object.buyMaker = "";
        object.buyChannel = "";
        object.exchangeFeeRate = 0;
        object.initialRate = 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.crossType != null && message.hasOwnProperty("crossType"))
        object.crossType = options.enums === String ? $root.dnse.CrossOrder.CrossType[message.crossType] : message.crossType;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.price != null && message.hasOwnProperty("price"))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
        object.orderStatus = message.orderStatus;
      if (message.execType != null && message.hasOwnProperty("execType"))
        object.execType = message.execType;
      if (message.transDate != null && message.hasOwnProperty("transDate"))
        object.transDate = $root.google.protobuf.Timestamp.toObject(message.transDate, options);
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
      if (message.externalId != null && message.hasOwnProperty("externalId"))
        object.externalId = message.externalId;
      if (message.error != null && message.hasOwnProperty("error"))
        object.error = message.error;
      if (message.text != null && message.hasOwnProperty("text"))
        object.text = message.text;
      if (message.custody != null && message.hasOwnProperty("custody"))
        object.custody = message.custody;
      if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo"))
        object.buyAccountNo = message.buyAccountNo;
      if (message.buyCustody != null && message.hasOwnProperty("buyCustody"))
        object.buyCustody = message.buyCustody;
      if (message.buyInvestorId != null && message.hasOwnProperty("buyInvestorId"))
        object.buyInvestorId = message.buyInvestorId;
      if (message.firmId != null && message.hasOwnProperty("firmId"))
        object.firmId = message.firmId;
      if (message.traderId != null && message.hasOwnProperty("traderId"))
        object.traderId = message.traderId;
      if (message.buyFirmId != null && message.hasOwnProperty("buyFirmId"))
        object.buyFirmId = message.buyFirmId;
      if (message.buyTraderId != null && message.hasOwnProperty("buyTraderId"))
        object.buyTraderId = message.buyTraderId;
      if (message.clOrdId != null && message.hasOwnProperty("clOrdId"))
        object.clOrdId = message.clOrdId;
      if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId"))
        object.origClOrdId = message.origClOrdId;
      if (message.exDestination != null && message.hasOwnProperty("exDestination"))
        object.exDestination = message.exDestination;
      if (message.maker != null && message.hasOwnProperty("maker"))
        object.maker = message.maker;
      if (message.channel != null && message.hasOwnProperty("channel"))
        object.channel = message.channel;
      if (message.feeRate != null && message.hasOwnProperty("feeRate"))
        object.feeRate = options.json && !isFinite(message.feeRate) ? String(message.feeRate) : message.feeRate;
      if (message.taxRate != null && message.hasOwnProperty("taxRate"))
        object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
      if (message.buyFeeRate != null && message.hasOwnProperty("buyFeeRate"))
        object.buyFeeRate = options.json && !isFinite(message.buyFeeRate) ? String(message.buyFeeRate) : message.buyFeeRate;
      if (message.buyTaxRate != null && message.hasOwnProperty("buyTaxRate"))
        object.buyTaxRate = options.json && !isFinite(message.buyTaxRate) ? String(message.buyTaxRate) : message.buyTaxRate;
      if (message.externalAdvOrderId != null && message.hasOwnProperty("externalAdvOrderId"))
        object.externalAdvOrderId = message.externalAdvOrderId;
      if (message.actions && message.actions.length) {
        object.actions = [];
        for (let j = 0; j < message.actions.length; ++j)
          object.actions[j] = message.actions[j];
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId"))
        object.buyLoanPackageId = message.buyLoanPackageId;
      if (message.buyInitialRate != null && message.hasOwnProperty("buyInitialRate"))
        object.buyInitialRate = options.json && !isFinite(message.buyInitialRate) ? String(message.buyInitialRate) : message.buyInitialRate;
      if (message.metadata != null && message.hasOwnProperty("metadata"))
        object.metadata = message.metadata;
      if (message.buyMaker != null && message.hasOwnProperty("buyMaker"))
        object.buyMaker = message.buyMaker;
      if (message.buyChannel != null && message.hasOwnProperty("buyChannel"))
        object.buyChannel = message.buyChannel;
      if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate"))
        object.exchangeFeeRate = options.json && !isFinite(message.exchangeFeeRate) ? String(message.exchangeFeeRate) : message.exchangeFeeRate;
      if (message.initialRate != null && message.hasOwnProperty("initialRate"))
        object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
      return object;
    };
    CrossOrder.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    CrossOrder.CrossType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN_TYPE"] = 0;
      values[valuesById[1] = "ONE_FIRM"] = 1;
      values[valuesById[2] = "TWO_FIRM"] = 2;
      return values;
    }();
    return CrossOrder;
  }();
  dnse2.InternalCompanyPersonEvent = function() {
    function InternalCompanyPersonEvent(properties) {
      this.accountNos = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InternalCompanyPersonEvent.prototype.isActive = false;
    InternalCompanyPersonEvent.prototype.fullName = "";
    InternalCompanyPersonEvent.prototype.custodyCode = "";
    InternalCompanyPersonEvent.prototype.symbol = "";
    InternalCompanyPersonEvent.prototype.effectiveDate = null;
    InternalCompanyPersonEvent.prototype.investorId = "";
    InternalCompanyPersonEvent.prototype.accountNos = $util.emptyArray;
    InternalCompanyPersonEvent.create = function create(properties) {
      return new InternalCompanyPersonEvent(properties);
    };
    InternalCompanyPersonEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
        writer.uint32(8).bool(message.isActive);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(18).string(message.fullName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.effectiveDate != null && Object.hasOwnProperty.call(message, "effectiveDate"))
        $root.google.protobuf.Timestamp.encode(message.effectiveDate, writer.uint32(42).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.accountNos != null && message.accountNos.length)
        for (let i = 0; i < message.accountNos.length; ++i)
          writer.uint32(58).string(message.accountNos[i]);
      return writer;
    };
    InternalCompanyPersonEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InternalCompanyPersonEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.InternalCompanyPersonEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.isActive = reader.bool();
            break;
          case 2:
            message.fullName = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.effectiveDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            if (!(message.accountNos && message.accountNos.length))
              message.accountNos = [];
            message.accountNos.push(reader.string());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InternalCompanyPersonEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InternalCompanyPersonEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.isActive != null && message.hasOwnProperty("isActive")) {
        if (typeof message.isActive !== "boolean")
          return "isActive: boolean expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.effectiveDate != null && message.hasOwnProperty("effectiveDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.effectiveDate);
        if (error)
          return "effectiveDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNos != null && message.hasOwnProperty("accountNos")) {
        if (!Array.isArray(message.accountNos))
          return "accountNos: array expected";
        for (let i = 0; i < message.accountNos.length; ++i)
          if (!$util.isString(message.accountNos[i]))
            return "accountNos: string[] expected";
      }
      return null;
    };
    InternalCompanyPersonEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.InternalCompanyPersonEvent)
        return object;
      let message = new $root.dnse.InternalCompanyPersonEvent();
      if (object.isActive != null)
        message.isActive = Boolean(object.isActive);
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.effectiveDate != null) {
        if (typeof object.effectiveDate !== "object")
          throw TypeError(".dnse.InternalCompanyPersonEvent.effectiveDate: object expected");
        message.effectiveDate = $root.google.protobuf.Timestamp.fromObject(object.effectiveDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNos) {
        if (!Array.isArray(object.accountNos))
          throw TypeError(".dnse.InternalCompanyPersonEvent.accountNos: array expected");
        message.accountNos = [];
        for (let i = 0; i < object.accountNos.length; ++i)
          message.accountNos[i] = String(object.accountNos[i]);
      }
      return message;
    };
    InternalCompanyPersonEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.accountNos = [];
      if (options.defaults) {
        object.isActive = false;
        object.fullName = "";
        object.custodyCode = "";
        object.symbol = "";
        object.effectiveDate = null;
        object.investorId = "";
      }
      if (message.isActive != null && message.hasOwnProperty("isActive"))
        object.isActive = message.isActive;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.effectiveDate != null && message.hasOwnProperty("effectiveDate"))
        object.effectiveDate = $root.google.protobuf.Timestamp.toObject(message.effectiveDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNos && message.accountNos.length) {
        object.accountNos = [];
        for (let j = 0; j < message.accountNos.length; ++j)
          object.accountNos[j] = message.accountNos[j];
      }
      return object;
    };
    InternalCompanyPersonEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return InternalCompanyPersonEvent;
  }();
  dnse2.OpenMarginAccountSuccess = function() {
    function OpenMarginAccountSuccess(properties) {
      this.fileId = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OpenMarginAccountSuccess.prototype.fullName = "";
    OpenMarginAccountSuccess.prototype.mailSubject = "";
    OpenMarginAccountSuccess.prototype.fileId = $util.emptyArray;
    OpenMarginAccountSuccess.prototype.marginType = 0;
    OpenMarginAccountSuccess.create = function create(properties) {
      return new OpenMarginAccountSuccess(properties);
    };
    OpenMarginAccountSuccess.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(10).string(message.fullName);
      if (message.mailSubject != null && Object.hasOwnProperty.call(message, "mailSubject"))
        writer.uint32(18).string(message.mailSubject);
      if (message.fileId != null && message.fileId.length)
        for (let i = 0; i < message.fileId.length; ++i)
          writer.uint32(26).string(message.fileId[i]);
      if (message.marginType != null && Object.hasOwnProperty.call(message, "marginType"))
        writer.uint32(32).int32(message.marginType);
      return writer;
    };
    OpenMarginAccountSuccess.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OpenMarginAccountSuccess.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.OpenMarginAccountSuccess();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.fullName = reader.string();
            break;
          case 2:
            message.mailSubject = reader.string();
            break;
          case 3:
            if (!(message.fileId && message.fileId.length))
              message.fileId = [];
            message.fileId.push(reader.string());
            break;
          case 4:
            message.marginType = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OpenMarginAccountSuccess.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OpenMarginAccountSuccess.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      if (message.mailSubject != null && message.hasOwnProperty("mailSubject")) {
        if (!$util.isString(message.mailSubject))
          return "mailSubject: string expected";
      }
      if (message.fileId != null && message.hasOwnProperty("fileId")) {
        if (!Array.isArray(message.fileId))
          return "fileId: array expected";
        for (let i = 0; i < message.fileId.length; ++i)
          if (!$util.isString(message.fileId[i]))
            return "fileId: string[] expected";
      }
      if (message.marginType != null && message.hasOwnProperty("marginType"))
        switch (message.marginType) {
          default:
            return "marginType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return null;
    };
    OpenMarginAccountSuccess.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.OpenMarginAccountSuccess)
        return object;
      let message = new $root.dnse.OpenMarginAccountSuccess();
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      if (object.mailSubject != null)
        message.mailSubject = String(object.mailSubject);
      if (object.fileId) {
        if (!Array.isArray(object.fileId))
          throw TypeError(".dnse.OpenMarginAccountSuccess.fileId: array expected");
        message.fileId = [];
        for (let i = 0; i < object.fileId.length; ++i)
          message.fileId[i] = String(object.fileId[i]);
      }
      switch (object.marginType) {
        case "T10":
        case 0:
          message.marginType = 0;
          break;
        case "DEFAULT":
        case 1:
          message.marginType = 1;
          break;
        case "MARGIN_DEAL_DEFAULT":
        case 2:
          message.marginType = 2;
          break;
      }
      return message;
    };
    OpenMarginAccountSuccess.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.fileId = [];
      if (options.defaults) {
        object.fullName = "";
        object.mailSubject = "";
        object.marginType = options.enums === String ? "T10" : 0;
      }
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      if (message.mailSubject != null && message.hasOwnProperty("mailSubject"))
        object.mailSubject = message.mailSubject;
      if (message.fileId && message.fileId.length) {
        object.fileId = [];
        for (let j = 0; j < message.fileId.length; ++j)
          object.fileId[j] = message.fileId[j];
      }
      if (message.marginType != null && message.hasOwnProperty("marginType"))
        object.marginType = options.enums === String ? $root.dnse.OpenMarginAccountSuccess.MarginType[message.marginType] : message.marginType;
      return object;
    };
    OpenMarginAccountSuccess.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    OpenMarginAccountSuccess.MarginType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "T10"] = 0;
      values[valuesById[1] = "DEFAULT"] = 1;
      values[valuesById[2] = "MARGIN_DEAL_DEFAULT"] = 2;
      return values;
    }();
    return OpenMarginAccountSuccess;
  }();
  dnse2.EndOfMonthInterestEvent = function() {
    function EndOfMonthInterestEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EndOfMonthInterestEvent.prototype.id = "";
    EndOfMonthInterestEvent.prototype.txNum = "";
    EndOfMonthInterestEvent.prototype.type = "";
    EndOfMonthInterestEvent.prototype.accountNo = "";
    EndOfMonthInterestEvent.prototype.custodyCode = "";
    EndOfMonthInterestEvent.prototype.amount = 0;
    EndOfMonthInterestEvent.prototype.description = "";
    EndOfMonthInterestEvent.prototype.bizDate = "";
    EndOfMonthInterestEvent.create = function create(properties) {
      return new EndOfMonthInterestEvent(properties);
    };
    EndOfMonthInterestEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.txNum != null && Object.hasOwnProperty.call(message, "txNum"))
        writer.uint32(18).string(message.txNum);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(26).string(message.type);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(42).string(message.custodyCode);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(49).double(message.amount);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(58).string(message.description);
      if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
        writer.uint32(66).string(message.bizDate);
      return writer;
    };
    EndOfMonthInterestEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EndOfMonthInterestEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EndOfMonthInterestEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.txNum = reader.string();
            break;
          case 3:
            message.type = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.custodyCode = reader.string();
            break;
          case 6:
            message.amount = reader.double();
            break;
          case 7:
            message.description = reader.string();
            break;
          case 8:
            message.bizDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EndOfMonthInterestEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EndOfMonthInterestEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.txNum != null && message.hasOwnProperty("txNum")) {
        if (!$util.isString(message.txNum))
          return "txNum: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (typeof message.amount !== "number")
          return "amount: number expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
        if (!$util.isString(message.bizDate))
          return "bizDate: string expected";
      }
      return null;
    };
    EndOfMonthInterestEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EndOfMonthInterestEvent)
        return object;
      let message = new $root.dnse.EndOfMonthInterestEvent();
      if (object.id != null)
        message.id = String(object.id);
      if (object.txNum != null)
        message.txNum = String(object.txNum);
      if (object.type != null)
        message.type = String(object.type);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.amount != null)
        message.amount = Number(object.amount);
      if (object.description != null)
        message.description = String(object.description);
      if (object.bizDate != null)
        message.bizDate = String(object.bizDate);
      return message;
    };
    EndOfMonthInterestEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.txNum = "";
        object.type = "";
        object.accountNo = "";
        object.custodyCode = "";
        object.amount = 0;
        object.description = "";
        object.bizDate = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.txNum != null && message.hasOwnProperty("txNum"))
        object.txNum = message.txNum;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.amount != null && message.hasOwnProperty("amount"))
        object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.bizDate != null && message.hasOwnProperty("bizDate"))
        object.bizDate = message.bizDate;
      return object;
    };
    EndOfMonthInterestEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EndOfMonthInterestEvent;
  }();
  dnse2.AssetCashTransferExternal = function() {
    function AssetCashTransferExternal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AssetCashTransferExternal.prototype.referenceId = "";
    AssetCashTransferExternal.prototype.fromAccountNo = "";
    AssetCashTransferExternal.prototype.toAccountNo = "";
    AssetCashTransferExternal.prototype.withdrawType = "";
    AssetCashTransferExternal.prototype.transactionId = "";
    AssetCashTransferExternal.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AssetCashTransferExternal.prototype.description = "";
    AssetCashTransferExternal.prototype.transactionTime = null;
    AssetCashTransferExternal.create = function create(properties) {
      return new AssetCashTransferExternal(properties);
    };
    AssetCashTransferExternal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.referenceId != null && Object.hasOwnProperty.call(message, "referenceId"))
        writer.uint32(10).string(message.referenceId);
      if (message.fromAccountNo != null && Object.hasOwnProperty.call(message, "fromAccountNo"))
        writer.uint32(18).string(message.fromAccountNo);
      if (message.toAccountNo != null && Object.hasOwnProperty.call(message, "toAccountNo"))
        writer.uint32(26).string(message.toAccountNo);
      if (message.withdrawType != null && Object.hasOwnProperty.call(message, "withdrawType"))
        writer.uint32(34).string(message.withdrawType);
      if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
        writer.uint32(42).string(message.transactionId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(48).int64(message.amount);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(58).string(message.description);
      if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
        $root.google.protobuf.Timestamp.encode(message.transactionTime, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    AssetCashTransferExternal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AssetCashTransferExternal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.AssetCashTransferExternal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.referenceId = reader.string();
            break;
          case 2:
            message.fromAccountNo = reader.string();
            break;
          case 3:
            message.toAccountNo = reader.string();
            break;
          case 4:
            message.withdrawType = reader.string();
            break;
          case 5:
            message.transactionId = reader.string();
            break;
          case 6:
            message.amount = reader.int64();
            break;
          case 7:
            message.description = reader.string();
            break;
          case 8:
            message.transactionTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AssetCashTransferExternal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AssetCashTransferExternal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.referenceId != null && message.hasOwnProperty("referenceId")) {
        if (!$util.isString(message.referenceId))
          return "referenceId: string expected";
      }
      if (message.fromAccountNo != null && message.hasOwnProperty("fromAccountNo")) {
        if (!$util.isString(message.fromAccountNo))
          return "fromAccountNo: string expected";
      }
      if (message.toAccountNo != null && message.hasOwnProperty("toAccountNo")) {
        if (!$util.isString(message.toAccountNo))
          return "toAccountNo: string expected";
      }
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType")) {
        if (!$util.isString(message.withdrawType))
          return "withdrawType: string expected";
      }
      if (message.transactionId != null && message.hasOwnProperty("transactionId")) {
        if (!$util.isString(message.transactionId))
          return "transactionId: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.transactionTime);
        if (error)
          return "transactionTime." + error;
      }
      return null;
    };
    AssetCashTransferExternal.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.AssetCashTransferExternal)
        return object;
      let message = new $root.dnse.AssetCashTransferExternal();
      if (object.referenceId != null)
        message.referenceId = String(object.referenceId);
      if (object.fromAccountNo != null)
        message.fromAccountNo = String(object.fromAccountNo);
      if (object.toAccountNo != null)
        message.toAccountNo = String(object.toAccountNo);
      if (object.withdrawType != null)
        message.withdrawType = String(object.withdrawType);
      if (object.transactionId != null)
        message.transactionId = String(object.transactionId);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.description != null)
        message.description = String(object.description);
      if (object.transactionTime != null) {
        if (typeof object.transactionTime !== "object")
          throw TypeError(".dnse.AssetCashTransferExternal.transactionTime: object expected");
        message.transactionTime = $root.google.protobuf.Timestamp.fromObject(object.transactionTime);
      }
      return message;
    };
    AssetCashTransferExternal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.referenceId = "";
        object.fromAccountNo = "";
        object.toAccountNo = "";
        object.withdrawType = "";
        object.transactionId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.description = "";
        object.transactionTime = null;
      }
      if (message.referenceId != null && message.hasOwnProperty("referenceId"))
        object.referenceId = message.referenceId;
      if (message.fromAccountNo != null && message.hasOwnProperty("fromAccountNo"))
        object.fromAccountNo = message.fromAccountNo;
      if (message.toAccountNo != null && message.hasOwnProperty("toAccountNo"))
        object.toAccountNo = message.toAccountNo;
      if (message.withdrawType != null && message.hasOwnProperty("withdrawType"))
        object.withdrawType = message.withdrawType;
      if (message.transactionId != null && message.hasOwnProperty("transactionId"))
        object.transactionId = message.transactionId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.description != null && message.hasOwnProperty("description"))
        object.description = message.description;
      if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
        object.transactionTime = $root.google.protobuf.Timestamp.toObject(message.transactionTime, options);
      return object;
    };
    AssetCashTransferExternal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return AssetCashTransferExternal;
  }();
  dnse2.DerivativeCashAccountCommand = function() {
    function DerivativeCashAccountCommand(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativeCashAccountCommand.prototype.accountNo = "";
    DerivativeCashAccountCommand.prototype.loanPackageId = 0;
    DerivativeCashAccountCommand.prototype.action = "";
    DerivativeCashAccountCommand.create = function create(properties) {
      return new DerivativeCashAccountCommand(properties);
    };
    DerivativeCashAccountCommand.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(16).int32(message.loanPackageId);
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(26).string(message.action);
      return writer;
    };
    DerivativeCashAccountCommand.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativeCashAccountCommand.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativeCashAccountCommand();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.loanPackageId = reader.int32();
            break;
          case 3:
            message.action = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativeCashAccountCommand.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativeCashAccountCommand.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.action != null && message.hasOwnProperty("action")) {
        if (!$util.isString(message.action))
          return "action: string expected";
      }
      return null;
    };
    DerivativeCashAccountCommand.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativeCashAccountCommand)
        return object;
      let message = new $root.dnse.DerivativeCashAccountCommand();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.action != null)
        message.action = String(object.action);
      return message;
    };
    DerivativeCashAccountCommand.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.loanPackageId = 0;
        object.action = "";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = message.action;
      return object;
    };
    DerivativeCashAccountCommand.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativeCashAccountCommand;
  }();
  dnse2.EContractEvent = function() {
    function EContractEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EContractEvent.prototype.investorId = "";
    EContractEvent.prototype.contractId = "";
    EContractEvent.prototype.status = "";
    EContractEvent.prototype.webviewUrl = "";
    EContractEvent.prototype.webviewExpireTime = null;
    EContractEvent.prototype.createdDate = null;
    EContractEvent.create = function create(properties) {
      return new EContractEvent(properties);
    };
    EContractEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
        writer.uint32(18).string(message.contractId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(26).string(message.status);
      if (message.webviewUrl != null && Object.hasOwnProperty.call(message, "webviewUrl"))
        writer.uint32(34).string(message.webviewUrl);
      if (message.webviewExpireTime != null && Object.hasOwnProperty.call(message, "webviewExpireTime"))
        $root.google.protobuf.Timestamp.encode(message.webviewExpireTime, writer.uint32(42).fork()).ldelim();
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    EContractEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EContractEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EContractEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.contractId = reader.string();
            break;
          case 3:
            message.status = reader.string();
            break;
          case 4:
            message.webviewUrl = reader.string();
            break;
          case 5:
            message.webviewExpireTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EContractEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EContractEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.contractId != null && message.hasOwnProperty("contractId")) {
        if (!$util.isString(message.contractId))
          return "contractId: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.webviewUrl != null && message.hasOwnProperty("webviewUrl")) {
        if (!$util.isString(message.webviewUrl))
          return "webviewUrl: string expected";
      }
      if (message.webviewExpireTime != null && message.hasOwnProperty("webviewExpireTime")) {
        let error = $root.google.protobuf.Timestamp.verify(message.webviewExpireTime);
        if (error)
          return "webviewExpireTime." + error;
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    EContractEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EContractEvent)
        return object;
      let message = new $root.dnse.EContractEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.contractId != null)
        message.contractId = String(object.contractId);
      if (object.status != null)
        message.status = String(object.status);
      if (object.webviewUrl != null)
        message.webviewUrl = String(object.webviewUrl);
      if (object.webviewExpireTime != null) {
        if (typeof object.webviewExpireTime !== "object")
          throw TypeError(".dnse.EContractEvent.webviewExpireTime: object expected");
        message.webviewExpireTime = $root.google.protobuf.Timestamp.fromObject(object.webviewExpireTime);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.EContractEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    EContractEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.contractId = "";
        object.status = "";
        object.webviewUrl = "";
        object.webviewExpireTime = null;
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.contractId != null && message.hasOwnProperty("contractId"))
        object.contractId = message.contractId;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.webviewUrl != null && message.hasOwnProperty("webviewUrl"))
        object.webviewUrl = message.webviewUrl;
      if (message.webviewExpireTime != null && message.hasOwnProperty("webviewExpireTime"))
        object.webviewExpireTime = $root.google.protobuf.Timestamp.toObject(message.webviewExpireTime, options);
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    EContractEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EContractEvent;
  }();
  dnse2.AgentDealState = function() {
    function AgentDealState(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    AgentDealState.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AgentDealState.prototype.requestId = "";
    AgentDealState.prototype.status = "";
    AgentDealState.prototype.orderType = "";
    AgentDealState.prototype.accountNo = "";
    AgentDealState.prototype.custodyCode = "";
    AgentDealState.prototype.investorId = "";
    AgentDealState.prototype.loanPackageId = 0;
    AgentDealState.prototype.symbol = "";
    AgentDealState.prototype.version = 0;
    AgentDealState.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AgentDealState.prototype.side = "";
    AgentDealState.prototype.executeTime = 0;
    AgentDealState.prototype.remainedVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AgentDealState.prototype.executedVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AgentDealState.prototype.pendingVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AgentDealState.prototype.averagePrice = 0;
    AgentDealState.prototype.volumeStep = 0;
    AgentDealState.prototype.nRemainStep = 0;
    AgentDealState.prototype.createdDate = null;
    AgentDealState.prototype.updatedDate = null;
    AgentDealState.prototype.expireDate = null;
    AgentDealState.prototype.createdBy = "";
    AgentDealState.prototype.updatedBy = "";
    AgentDealState.prototype.agentName = "";
    AgentDealState.prototype.serviceName = "";
    AgentDealState.prototype.nPendingOrder = 0;
    AgentDealState.prototype.nExecutedOrder = 0;
    AgentDealState.prototype.nRejectedOrder = 0;
    AgentDealState.prototype.startDate = null;
    AgentDealState.prototype.vwap = 0;
    AgentDealState.prototype.conditionType = "";
    AgentDealState.prototype.triggerPrice = 0;
    AgentDealState.prototype.endDate = null;
    AgentDealState.prototype.marketType = "";
    AgentDealState.create = function create(properties) {
      return new AgentDealState(properties);
    };
    AgentDealState.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
        writer.uint32(18).string(message.requestId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(26).string(message.status);
      if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
        writer.uint32(34).string(message.orderType);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(42).string(message.accountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(50).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(58).string(message.investorId);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(64).int32(message.loanPackageId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(74).string(message.symbol);
      if (message.version != null && Object.hasOwnProperty.call(message, "version"))
        writer.uint32(80).int32(message.version);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(88).int64(message.quantity);
      if (message.side != null && Object.hasOwnProperty.call(message, "side"))
        writer.uint32(98).string(message.side);
      if (message.executeTime != null && Object.hasOwnProperty.call(message, "executeTime"))
        writer.uint32(104).int32(message.executeTime);
      if (message.remainedVolume != null && Object.hasOwnProperty.call(message, "remainedVolume"))
        writer.uint32(112).int64(message.remainedVolume);
      if (message.executedVolume != null && Object.hasOwnProperty.call(message, "executedVolume"))
        writer.uint32(120).int64(message.executedVolume);
      if (message.pendingVolume != null && Object.hasOwnProperty.call(message, "pendingVolume"))
        writer.uint32(128).int64(message.pendingVolume);
      if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
        writer.uint32(137).double(message.averagePrice);
      if (message.volumeStep != null && Object.hasOwnProperty.call(message, "volumeStep"))
        writer.uint32(144).int32(message.volumeStep);
      if (message.nRemainStep != null && Object.hasOwnProperty.call(message, "nRemainStep"))
        writer.uint32(152).int32(message.nRemainStep);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(162).fork()).ldelim();
      if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
        $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(170).fork()).ldelim();
      if (message.expireDate != null && Object.hasOwnProperty.call(message, "expireDate"))
        $root.google.protobuf.Timestamp.encode(message.expireDate, writer.uint32(178).fork()).ldelim();
      if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
        writer.uint32(186).string(message.createdBy);
      if (message.updatedBy != null && Object.hasOwnProperty.call(message, "updatedBy"))
        writer.uint32(194).string(message.updatedBy);
      if (message.agentName != null && Object.hasOwnProperty.call(message, "agentName"))
        writer.uint32(202).string(message.agentName);
      if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
        writer.uint32(210).string(message.serviceName);
      if (message.nPendingOrder != null && Object.hasOwnProperty.call(message, "nPendingOrder"))
        writer.uint32(216).int32(message.nPendingOrder);
      if (message.nExecutedOrder != null && Object.hasOwnProperty.call(message, "nExecutedOrder"))
        writer.uint32(224).int32(message.nExecutedOrder);
      if (message.nRejectedOrder != null && Object.hasOwnProperty.call(message, "nRejectedOrder"))
        writer.uint32(232).int32(message.nRejectedOrder);
      if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
        $root.google.protobuf.Timestamp.encode(message.startDate, writer.uint32(242).fork()).ldelim();
      if (message.vwap != null && Object.hasOwnProperty.call(message, "vwap"))
        writer.uint32(249).double(message.vwap);
      if (message.conditionType != null && Object.hasOwnProperty.call(message, "conditionType"))
        writer.uint32(258).string(message.conditionType);
      if (message.triggerPrice != null && Object.hasOwnProperty.call(message, "triggerPrice"))
        writer.uint32(265).double(message.triggerPrice);
      if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
        $root.google.protobuf.Timestamp.encode(message.endDate, writer.uint32(274).fork()).ldelim();
      if (message.marketType != null && Object.hasOwnProperty.call(message, "marketType"))
        writer.uint32(282).string(message.marketType);
      return writer;
    };
    AgentDealState.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    AgentDealState.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.AgentDealState();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.requestId = reader.string();
            break;
          case 3:
            message.status = reader.string();
            break;
          case 4:
            message.orderType = reader.string();
            break;
          case 5:
            message.accountNo = reader.string();
            break;
          case 6:
            message.custodyCode = reader.string();
            break;
          case 7:
            message.investorId = reader.string();
            break;
          case 8:
            message.loanPackageId = reader.int32();
            break;
          case 9:
            message.symbol = reader.string();
            break;
          case 10:
            message.version = reader.int32();
            break;
          case 11:
            message.quantity = reader.int64();
            break;
          case 12:
            message.side = reader.string();
            break;
          case 13:
            message.executeTime = reader.int32();
            break;
          case 14:
            message.remainedVolume = reader.int64();
            break;
          case 15:
            message.executedVolume = reader.int64();
            break;
          case 16:
            message.pendingVolume = reader.int64();
            break;
          case 17:
            message.averagePrice = reader.double();
            break;
          case 18:
            message.volumeStep = reader.int32();
            break;
          case 19:
            message.nRemainStep = reader.int32();
            break;
          case 20:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 21:
            message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 22:
            message.expireDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 23:
            message.createdBy = reader.string();
            break;
          case 24:
            message.updatedBy = reader.string();
            break;
          case 25:
            message.agentName = reader.string();
            break;
          case 26:
            message.serviceName = reader.string();
            break;
          case 27:
            message.nPendingOrder = reader.int32();
            break;
          case 28:
            message.nExecutedOrder = reader.int32();
            break;
          case 29:
            message.nRejectedOrder = reader.int32();
            break;
          case 30:
            message.startDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 31:
            message.vwap = reader.double();
            break;
          case 32:
            message.conditionType = reader.string();
            break;
          case 33:
            message.triggerPrice = reader.double();
            break;
          case 34:
            message.endDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 35:
            message.marketType = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    AgentDealState.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    AgentDealState.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.requestId != null && message.hasOwnProperty("requestId")) {
        if (!$util.isString(message.requestId))
          return "requestId: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status")) {
        if (!$util.isString(message.status))
          return "status: string expected";
      }
      if (message.orderType != null && message.hasOwnProperty("orderType")) {
        if (!$util.isString(message.orderType))
          return "orderType: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId))
          return "loanPackageId: integer expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.version != null && message.hasOwnProperty("version")) {
        if (!$util.isInteger(message.version))
          return "version: integer expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
          return "quantity: integer|Long expected";
      }
      if (message.side != null && message.hasOwnProperty("side")) {
        if (!$util.isString(message.side))
          return "side: string expected";
      }
      if (message.executeTime != null && message.hasOwnProperty("executeTime")) {
        if (!$util.isInteger(message.executeTime))
          return "executeTime: integer expected";
      }
      if (message.remainedVolume != null && message.hasOwnProperty("remainedVolume")) {
        if (!$util.isInteger(message.remainedVolume) && !(message.remainedVolume && $util.isInteger(message.remainedVolume.low) && $util.isInteger(message.remainedVolume.high)))
          return "remainedVolume: integer|Long expected";
      }
      if (message.executedVolume != null && message.hasOwnProperty("executedVolume")) {
        if (!$util.isInteger(message.executedVolume) && !(message.executedVolume && $util.isInteger(message.executedVolume.low) && $util.isInteger(message.executedVolume.high)))
          return "executedVolume: integer|Long expected";
      }
      if (message.pendingVolume != null && message.hasOwnProperty("pendingVolume")) {
        if (!$util.isInteger(message.pendingVolume) && !(message.pendingVolume && $util.isInteger(message.pendingVolume.low) && $util.isInteger(message.pendingVolume.high)))
          return "pendingVolume: integer|Long expected";
      }
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
        if (typeof message.averagePrice !== "number")
          return "averagePrice: number expected";
      }
      if (message.volumeStep != null && message.hasOwnProperty("volumeStep")) {
        if (!$util.isInteger(message.volumeStep))
          return "volumeStep: integer expected";
      }
      if (message.nRemainStep != null && message.hasOwnProperty("nRemainStep")) {
        if (!$util.isInteger(message.nRemainStep))
          return "nRemainStep: integer expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
        if (error)
          return "updatedDate." + error;
      }
      if (message.expireDate != null && message.hasOwnProperty("expireDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.expireDate);
        if (error)
          return "expireDate." + error;
      }
      if (message.createdBy != null && message.hasOwnProperty("createdBy")) {
        if (!$util.isString(message.createdBy))
          return "createdBy: string expected";
      }
      if (message.updatedBy != null && message.hasOwnProperty("updatedBy")) {
        if (!$util.isString(message.updatedBy))
          return "updatedBy: string expected";
      }
      if (message.agentName != null && message.hasOwnProperty("agentName")) {
        if (!$util.isString(message.agentName))
          return "agentName: string expected";
      }
      if (message.serviceName != null && message.hasOwnProperty("serviceName")) {
        if (!$util.isString(message.serviceName))
          return "serviceName: string expected";
      }
      if (message.nPendingOrder != null && message.hasOwnProperty("nPendingOrder")) {
        if (!$util.isInteger(message.nPendingOrder))
          return "nPendingOrder: integer expected";
      }
      if (message.nExecutedOrder != null && message.hasOwnProperty("nExecutedOrder")) {
        if (!$util.isInteger(message.nExecutedOrder))
          return "nExecutedOrder: integer expected";
      }
      if (message.nRejectedOrder != null && message.hasOwnProperty("nRejectedOrder")) {
        if (!$util.isInteger(message.nRejectedOrder))
          return "nRejectedOrder: integer expected";
      }
      if (message.startDate != null && message.hasOwnProperty("startDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.startDate);
        if (error)
          return "startDate." + error;
      }
      if (message.vwap != null && message.hasOwnProperty("vwap")) {
        if (typeof message.vwap !== "number")
          return "vwap: number expected";
      }
      if (message.conditionType != null && message.hasOwnProperty("conditionType")) {
        if (!$util.isString(message.conditionType))
          return "conditionType: string expected";
      }
      if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice")) {
        if (typeof message.triggerPrice !== "number")
          return "triggerPrice: number expected";
      }
      if (message.endDate != null && message.hasOwnProperty("endDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.endDate);
        if (error)
          return "endDate." + error;
      }
      if (message.marketType != null && message.hasOwnProperty("marketType")) {
        if (!$util.isString(message.marketType))
          return "marketType: string expected";
      }
      return null;
    };
    AgentDealState.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.AgentDealState)
        return object;
      let message = new $root.dnse.AgentDealState();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.requestId != null)
        message.requestId = String(object.requestId);
      if (object.status != null)
        message.status = String(object.status);
      if (object.orderType != null)
        message.orderType = String(object.orderType);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.loanPackageId != null)
        message.loanPackageId = object.loanPackageId | 0;
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.version != null)
        message.version = object.version | 0;
      if (object.quantity != null) {
        if ($util.Long)
          (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
        else if (typeof object.quantity === "string")
          message.quantity = parseInt(object.quantity, 10);
        else if (typeof object.quantity === "number")
          message.quantity = object.quantity;
        else if (typeof object.quantity === "object")
          message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
      }
      if (object.side != null)
        message.side = String(object.side);
      if (object.executeTime != null)
        message.executeTime = object.executeTime | 0;
      if (object.remainedVolume != null) {
        if ($util.Long)
          (message.remainedVolume = $util.Long.fromValue(object.remainedVolume)).unsigned = false;
        else if (typeof object.remainedVolume === "string")
          message.remainedVolume = parseInt(object.remainedVolume, 10);
        else if (typeof object.remainedVolume === "number")
          message.remainedVolume = object.remainedVolume;
        else if (typeof object.remainedVolume === "object")
          message.remainedVolume = new $util.LongBits(object.remainedVolume.low >>> 0, object.remainedVolume.high >>> 0).toNumber();
      }
      if (object.executedVolume != null) {
        if ($util.Long)
          (message.executedVolume = $util.Long.fromValue(object.executedVolume)).unsigned = false;
        else if (typeof object.executedVolume === "string")
          message.executedVolume = parseInt(object.executedVolume, 10);
        else if (typeof object.executedVolume === "number")
          message.executedVolume = object.executedVolume;
        else if (typeof object.executedVolume === "object")
          message.executedVolume = new $util.LongBits(object.executedVolume.low >>> 0, object.executedVolume.high >>> 0).toNumber();
      }
      if (object.pendingVolume != null) {
        if ($util.Long)
          (message.pendingVolume = $util.Long.fromValue(object.pendingVolume)).unsigned = false;
        else if (typeof object.pendingVolume === "string")
          message.pendingVolume = parseInt(object.pendingVolume, 10);
        else if (typeof object.pendingVolume === "number")
          message.pendingVolume = object.pendingVolume;
        else if (typeof object.pendingVolume === "object")
          message.pendingVolume = new $util.LongBits(object.pendingVolume.low >>> 0, object.pendingVolume.high >>> 0).toNumber();
      }
      if (object.averagePrice != null)
        message.averagePrice = Number(object.averagePrice);
      if (object.volumeStep != null)
        message.volumeStep = object.volumeStep | 0;
      if (object.nRemainStep != null)
        message.nRemainStep = object.nRemainStep | 0;
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.AgentDealState.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.updatedDate != null) {
        if (typeof object.updatedDate !== "object")
          throw TypeError(".dnse.AgentDealState.updatedDate: object expected");
        message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
      }
      if (object.expireDate != null) {
        if (typeof object.expireDate !== "object")
          throw TypeError(".dnse.AgentDealState.expireDate: object expected");
        message.expireDate = $root.google.protobuf.Timestamp.fromObject(object.expireDate);
      }
      if (object.createdBy != null)
        message.createdBy = String(object.createdBy);
      if (object.updatedBy != null)
        message.updatedBy = String(object.updatedBy);
      if (object.agentName != null)
        message.agentName = String(object.agentName);
      if (object.serviceName != null)
        message.serviceName = String(object.serviceName);
      if (object.nPendingOrder != null)
        message.nPendingOrder = object.nPendingOrder | 0;
      if (object.nExecutedOrder != null)
        message.nExecutedOrder = object.nExecutedOrder | 0;
      if (object.nRejectedOrder != null)
        message.nRejectedOrder = object.nRejectedOrder | 0;
      if (object.startDate != null) {
        if (typeof object.startDate !== "object")
          throw TypeError(".dnse.AgentDealState.startDate: object expected");
        message.startDate = $root.google.protobuf.Timestamp.fromObject(object.startDate);
      }
      if (object.vwap != null)
        message.vwap = Number(object.vwap);
      if (object.conditionType != null)
        message.conditionType = String(object.conditionType);
      if (object.triggerPrice != null)
        message.triggerPrice = Number(object.triggerPrice);
      if (object.endDate != null) {
        if (typeof object.endDate !== "object")
          throw TypeError(".dnse.AgentDealState.endDate: object expected");
        message.endDate = $root.google.protobuf.Timestamp.fromObject(object.endDate);
      }
      if (object.marketType != null)
        message.marketType = String(object.marketType);
      return message;
    };
    AgentDealState.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.requestId = "";
        object.status = "";
        object.orderType = "";
        object.accountNo = "";
        object.custodyCode = "";
        object.investorId = "";
        object.loanPackageId = 0;
        object.symbol = "";
        object.version = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.quantity = options.longs === String ? "0" : 0;
        object.side = "";
        object.executeTime = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.remainedVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.remainedVolume = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.executedVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.executedVolume = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.pendingVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.pendingVolume = options.longs === String ? "0" : 0;
        object.averagePrice = 0;
        object.volumeStep = 0;
        object.nRemainStep = 0;
        object.createdDate = null;
        object.updatedDate = null;
        object.expireDate = null;
        object.createdBy = "";
        object.updatedBy = "";
        object.agentName = "";
        object.serviceName = "";
        object.nPendingOrder = 0;
        object.nExecutedOrder = 0;
        object.nRejectedOrder = 0;
        object.startDate = null;
        object.vwap = 0;
        object.conditionType = "";
        object.triggerPrice = 0;
        object.endDate = null;
        object.marketType = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.requestId != null && message.hasOwnProperty("requestId"))
        object.requestId = message.requestId;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = message.status;
      if (message.orderType != null && message.hasOwnProperty("orderType"))
        object.orderType = message.orderType;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        object.loanPackageId = message.loanPackageId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.version != null && message.hasOwnProperty("version"))
        object.version = message.version;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        if (typeof message.quantity === "number")
          object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
        else
          object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
      if (message.side != null && message.hasOwnProperty("side"))
        object.side = message.side;
      if (message.executeTime != null && message.hasOwnProperty("executeTime"))
        object.executeTime = message.executeTime;
      if (message.remainedVolume != null && message.hasOwnProperty("remainedVolume"))
        if (typeof message.remainedVolume === "number")
          object.remainedVolume = options.longs === String ? String(message.remainedVolume) : message.remainedVolume;
        else
          object.remainedVolume = options.longs === String ? $util.Long.prototype.toString.call(message.remainedVolume) : options.longs === Number ? new $util.LongBits(message.remainedVolume.low >>> 0, message.remainedVolume.high >>> 0).toNumber() : message.remainedVolume;
      if (message.executedVolume != null && message.hasOwnProperty("executedVolume"))
        if (typeof message.executedVolume === "number")
          object.executedVolume = options.longs === String ? String(message.executedVolume) : message.executedVolume;
        else
          object.executedVolume = options.longs === String ? $util.Long.prototype.toString.call(message.executedVolume) : options.longs === Number ? new $util.LongBits(message.executedVolume.low >>> 0, message.executedVolume.high >>> 0).toNumber() : message.executedVolume;
      if (message.pendingVolume != null && message.hasOwnProperty("pendingVolume"))
        if (typeof message.pendingVolume === "number")
          object.pendingVolume = options.longs === String ? String(message.pendingVolume) : message.pendingVolume;
        else
          object.pendingVolume = options.longs === String ? $util.Long.prototype.toString.call(message.pendingVolume) : options.longs === Number ? new $util.LongBits(message.pendingVolume.low >>> 0, message.pendingVolume.high >>> 0).toNumber() : message.pendingVolume;
      if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
        object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
      if (message.volumeStep != null && message.hasOwnProperty("volumeStep"))
        object.volumeStep = message.volumeStep;
      if (message.nRemainStep != null && message.hasOwnProperty("nRemainStep"))
        object.nRemainStep = message.nRemainStep;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
        object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
      if (message.expireDate != null && message.hasOwnProperty("expireDate"))
        object.expireDate = $root.google.protobuf.Timestamp.toObject(message.expireDate, options);
      if (message.createdBy != null && message.hasOwnProperty("createdBy"))
        object.createdBy = message.createdBy;
      if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
        object.updatedBy = message.updatedBy;
      if (message.agentName != null && message.hasOwnProperty("agentName"))
        object.agentName = message.agentName;
      if (message.serviceName != null && message.hasOwnProperty("serviceName"))
        object.serviceName = message.serviceName;
      if (message.nPendingOrder != null && message.hasOwnProperty("nPendingOrder"))
        object.nPendingOrder = message.nPendingOrder;
      if (message.nExecutedOrder != null && message.hasOwnProperty("nExecutedOrder"))
        object.nExecutedOrder = message.nExecutedOrder;
      if (message.nRejectedOrder != null && message.hasOwnProperty("nRejectedOrder"))
        object.nRejectedOrder = message.nRejectedOrder;
      if (message.startDate != null && message.hasOwnProperty("startDate"))
        object.startDate = $root.google.protobuf.Timestamp.toObject(message.startDate, options);
      if (message.vwap != null && message.hasOwnProperty("vwap"))
        object.vwap = options.json && !isFinite(message.vwap) ? String(message.vwap) : message.vwap;
      if (message.conditionType != null && message.hasOwnProperty("conditionType"))
        object.conditionType = message.conditionType;
      if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
        object.triggerPrice = options.json && !isFinite(message.triggerPrice) ? String(message.triggerPrice) : message.triggerPrice;
      if (message.endDate != null && message.hasOwnProperty("endDate"))
        object.endDate = $root.google.protobuf.Timestamp.toObject(message.endDate, options);
      if (message.marketType != null && message.hasOwnProperty("marketType"))
        object.marketType = message.marketType;
      return object;
    };
    AgentDealState.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return AgentDealState;
  }();
  dnse2.InvestorChangeEmailEvent = function() {
    function InvestorChangeEmailEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    InvestorChangeEmailEvent.prototype.investorId = "";
    InvestorChangeEmailEvent.prototype.custodyCode = "";
    InvestorChangeEmailEvent.prototype.email = "";
    InvestorChangeEmailEvent.prototype.verifiedDate = null;
    InvestorChangeEmailEvent.create = function create(properties) {
      return new InvestorChangeEmailEvent(properties);
    };
    InvestorChangeEmailEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(26).string(message.email);
      if (message.verifiedDate != null && Object.hasOwnProperty.call(message, "verifiedDate"))
        $root.google.protobuf.Timestamp.encode(message.verifiedDate, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    InvestorChangeEmailEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    InvestorChangeEmailEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.InvestorChangeEmailEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.email = reader.string();
            break;
          case 4:
            message.verifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    InvestorChangeEmailEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    InvestorChangeEmailEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.verifiedDate != null && message.hasOwnProperty("verifiedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.verifiedDate);
        if (error)
          return "verifiedDate." + error;
      }
      return null;
    };
    InvestorChangeEmailEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.InvestorChangeEmailEvent)
        return object;
      let message = new $root.dnse.InvestorChangeEmailEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.email != null)
        message.email = String(object.email);
      if (object.verifiedDate != null) {
        if (typeof object.verifiedDate !== "object")
          throw TypeError(".dnse.InvestorChangeEmailEvent.verifiedDate: object expected");
        message.verifiedDate = $root.google.protobuf.Timestamp.fromObject(object.verifiedDate);
      }
      return message;
    };
    InvestorChangeEmailEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.email = "";
        object.verifiedDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.verifiedDate != null && message.hasOwnProperty("verifiedDate"))
        object.verifiedDate = $root.google.protobuf.Timestamp.toObject(message.verifiedDate, options);
      return object;
    };
    InvestorChangeEmailEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return InvestorChangeEmailEvent;
  }();
  dnse2.EnsaChartMessage = function() {
    function EnsaChartMessage(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EnsaChartMessage.prototype.data = null;
    EnsaChartMessage.create = function create(properties) {
      return new EnsaChartMessage(properties);
    };
    EnsaChartMessage.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.data != null && Object.hasOwnProperty.call(message, "data"))
        $root.dnse.EnsaChartMessageData.encode(message.data, writer.uint32(10).fork()).ldelim();
      return writer;
    };
    EnsaChartMessage.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EnsaChartMessage.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EnsaChartMessage();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.data = $root.dnse.EnsaChartMessageData.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EnsaChartMessage.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EnsaChartMessage.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.data != null && message.hasOwnProperty("data")) {
        let error = $root.dnse.EnsaChartMessageData.verify(message.data);
        if (error)
          return "data." + error;
      }
      return null;
    };
    EnsaChartMessage.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EnsaChartMessage)
        return object;
      let message = new $root.dnse.EnsaChartMessage();
      if (object.data != null) {
        if (typeof object.data !== "object")
          throw TypeError(".dnse.EnsaChartMessage.data: object expected");
        message.data = $root.dnse.EnsaChartMessageData.fromObject(object.data);
      }
      return message;
    };
    EnsaChartMessage.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.data = null;
      if (message.data != null && message.hasOwnProperty("data"))
        object.data = $root.dnse.EnsaChartMessageData.toObject(message.data, options);
      return object;
    };
    EnsaChartMessage.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EnsaChartMessage;
  }();
  dnse2.EnsaChartMessageData = function() {
    function EnsaChartMessageData(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EnsaChartMessageData.prototype.type = "";
    EnsaChartMessageData.prototype.createdAt = null;
    EnsaChartMessageData.prototype.messageId = "";
    EnsaChartMessageData.prototype.groupId = "";
    EnsaChartMessageData.prototype.investorId = "";
    EnsaChartMessageData.prototype.payload = $util.newBuffer([]);
    EnsaChartMessageData.prototype.questionId = "";
    EnsaChartMessageData.create = function create(properties) {
      return new EnsaChartMessageData(properties);
    };
    EnsaChartMessageData.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(10).string(message.type);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(18).fork()).ldelim();
      if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
        writer.uint32(26).string(message.messageId);
      if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
        writer.uint32(34).string(message.groupId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
        writer.uint32(50).bytes(message.payload);
      if (message.questionId != null && Object.hasOwnProperty.call(message, "questionId"))
        writer.uint32(58).string(message.questionId);
      return writer;
    };
    EnsaChartMessageData.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EnsaChartMessageData.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EnsaChartMessageData();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.string();
            break;
          case 2:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 3:
            message.messageId = reader.string();
            break;
          case 4:
            message.groupId = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.payload = reader.bytes();
            break;
          case 7:
            message.questionId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EnsaChartMessageData.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EnsaChartMessageData.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.messageId != null && message.hasOwnProperty("messageId")) {
        if (!$util.isString(message.messageId))
          return "messageId: string expected";
      }
      if (message.groupId != null && message.hasOwnProperty("groupId")) {
        if (!$util.isString(message.groupId))
          return "groupId: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.payload != null && message.hasOwnProperty("payload")) {
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
          return "payload: buffer expected";
      }
      if (message.questionId != null && message.hasOwnProperty("questionId")) {
        if (!$util.isString(message.questionId))
          return "questionId: string expected";
      }
      return null;
    };
    EnsaChartMessageData.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EnsaChartMessageData)
        return object;
      let message = new $root.dnse.EnsaChartMessageData();
      if (object.type != null)
        message.type = String(object.type);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EnsaChartMessageData.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.messageId != null)
        message.messageId = String(object.messageId);
      if (object.groupId != null)
        message.groupId = String(object.groupId);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.payload != null) {
        if (typeof object.payload === "string")
          $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
        else if (object.payload.length)
          message.payload = object.payload;
      }
      if (object.questionId != null)
        message.questionId = String(object.questionId);
      return message;
    };
    EnsaChartMessageData.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = "";
        object.createdAt = null;
        object.messageId = "";
        object.groupId = "";
        object.investorId = "";
        if (options.bytes === String)
          object.payload = "";
        else {
          object.payload = [];
          if (options.bytes !== Array)
            object.payload = $util.newBuffer(object.payload);
        }
        object.questionId = "";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.messageId != null && message.hasOwnProperty("messageId"))
        object.messageId = message.messageId;
      if (message.groupId != null && message.hasOwnProperty("groupId"))
        object.groupId = message.groupId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.payload != null && message.hasOwnProperty("payload"))
        object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
      if (message.questionId != null && message.hasOwnProperty("questionId"))
        object.questionId = message.questionId;
      return object;
    };
    EnsaChartMessageData.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EnsaChartMessageData;
  }();
  dnse2.OwnerCosponsorBankShouldConfirmTransactionEvent = function() {
    function OwnerCosponsorBankShouldConfirmTransactionEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    OwnerCosponsorBankShouldConfirmTransactionEvent.prototype.investorId = "";
    OwnerCosponsorBankShouldConfirmTransactionEvent.prototype.bizDate = "";
    OwnerCosponsorBankShouldConfirmTransactionEvent.prototype.createdDate = null;
    OwnerCosponsorBankShouldConfirmTransactionEvent.create = function create(properties) {
      return new OwnerCosponsorBankShouldConfirmTransactionEvent(properties);
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.bizDate != null && Object.hasOwnProperty.call(message, "bizDate"))
        writer.uint32(18).string(message.bizDate);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.OwnerCosponsorBankShouldConfirmTransactionEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.bizDate = reader.string();
            break;
          case 3:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.bizDate != null && message.hasOwnProperty("bizDate")) {
        if (!$util.isString(message.bizDate))
          return "bizDate: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.OwnerCosponsorBankShouldConfirmTransactionEvent)
        return object;
      let message = new $root.dnse.OwnerCosponsorBankShouldConfirmTransactionEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.bizDate != null)
        message.bizDate = String(object.bizDate);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.OwnerCosponsorBankShouldConfirmTransactionEvent.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.bizDate = "";
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.bizDate != null && message.hasOwnProperty("bizDate"))
        object.bizDate = message.bizDate;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    OwnerCosponsorBankShouldConfirmTransactionEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return OwnerCosponsorBankShouldConfirmTransactionEvent;
  }();
  dnse2.PromoRegisterEvent = function() {
    function PromoRegisterEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    PromoRegisterEvent.prototype.investorId = "";
    PromoRegisterEvent.prototype.ticket = "";
    PromoRegisterEvent.prototype.time = null;
    PromoRegisterEvent.create = function create(properties) {
      return new PromoRegisterEvent(properties);
    };
    PromoRegisterEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.ticket != null && Object.hasOwnProperty.call(message, "ticket"))
        writer.uint32(18).string(message.ticket);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    PromoRegisterEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    PromoRegisterEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.PromoRegisterEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.ticket = reader.string();
            break;
          case 3:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    PromoRegisterEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    PromoRegisterEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.ticket != null && message.hasOwnProperty("ticket")) {
        if (!$util.isString(message.ticket))
          return "ticket: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    PromoRegisterEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.PromoRegisterEvent)
        return object;
      let message = new $root.dnse.PromoRegisterEvent();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.ticket != null)
        message.ticket = String(object.ticket);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.PromoRegisterEvent.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    PromoRegisterEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.ticket = "";
        object.time = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.ticket != null && message.hasOwnProperty("ticket"))
        object.ticket = message.ticket;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    PromoRegisterEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return PromoRegisterEvent;
  }();
  dnse2.RewardStatus = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ON_HOLD"] = 0;
    values[valuesById[1] = "CLAIMED"] = 1;
    values[valuesById[2] = "OUT_OF_STOCK"] = 2;
    values[valuesById[3] = "TRIGGER_TRANSFERRED"] = 3;
    values[valuesById[4] = "RECEIVED"] = 4;
    values[valuesById[5] = "EXPIRED"] = 5;
    values[valuesById[6] = "CANCELLED"] = 6;
    return values;
  }();
  dnse2.StockRewardNotification = function() {
    function StockRewardNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockRewardNotification.prototype.campaignCode = "";
    StockRewardNotification.prototype.investorId = "";
    StockRewardNotification.prototype.symbol = "";
    StockRewardNotification.prototype.status = 0;
    StockRewardNotification.prototype.outOfStock = "";
    StockRewardNotification.prototype.time = null;
    StockRewardNotification.prototype.investorName = "";
    StockRewardNotification.prototype.custodyCode = "";
    StockRewardNotification.prototype.companyName = "";
    StockRewardNotification.create = function create(properties) {
      return new StockRewardNotification(properties);
    };
    StockRewardNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.campaignCode != null && Object.hasOwnProperty.call(message, "campaignCode"))
        writer.uint32(10).string(message.campaignCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(32).int32(message.status);
      if (message.outOfStock != null && Object.hasOwnProperty.call(message, "outOfStock"))
        writer.uint32(42).string(message.outOfStock);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
      if (message.investorName != null && Object.hasOwnProperty.call(message, "investorName"))
        writer.uint32(58).string(message.investorName);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(66).string(message.custodyCode);
      if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
        writer.uint32(74).string(message.companyName);
      return writer;
    };
    StockRewardNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockRewardNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.StockRewardNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.campaignCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.status = reader.int32();
            break;
          case 5:
            message.outOfStock = reader.string();
            break;
          case 6:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.investorName = reader.string();
            break;
          case 8:
            message.custodyCode = reader.string();
            break;
          case 9:
            message.companyName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockRewardNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockRewardNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.campaignCode != null && message.hasOwnProperty("campaignCode")) {
        if (!$util.isString(message.campaignCode))
          return "campaignCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (message.outOfStock != null && message.hasOwnProperty("outOfStock")) {
        if (!$util.isString(message.outOfStock))
          return "outOfStock: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.investorName != null && message.hasOwnProperty("investorName")) {
        if (!$util.isString(message.investorName))
          return "investorName: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.companyName != null && message.hasOwnProperty("companyName")) {
        if (!$util.isString(message.companyName))
          return "companyName: string expected";
      }
      return null;
    };
    StockRewardNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.StockRewardNotification)
        return object;
      let message = new $root.dnse.StockRewardNotification();
      if (object.campaignCode != null)
        message.campaignCode = String(object.campaignCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      switch (object.status) {
        case "ON_HOLD":
        case 0:
          message.status = 0;
          break;
        case "CLAIMED":
        case 1:
          message.status = 1;
          break;
        case "OUT_OF_STOCK":
        case 2:
          message.status = 2;
          break;
        case "TRIGGER_TRANSFERRED":
        case 3:
          message.status = 3;
          break;
        case "RECEIVED":
        case 4:
          message.status = 4;
          break;
        case "EXPIRED":
        case 5:
          message.status = 5;
          break;
        case "CANCELLED":
        case 6:
          message.status = 6;
          break;
      }
      if (object.outOfStock != null)
        message.outOfStock = String(object.outOfStock);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.StockRewardNotification.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.investorName != null)
        message.investorName = String(object.investorName);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.companyName != null)
        message.companyName = String(object.companyName);
      return message;
    };
    StockRewardNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.campaignCode = "";
        object.investorId = "";
        object.symbol = "";
        object.status = options.enums === String ? "ON_HOLD" : 0;
        object.outOfStock = "";
        object.time = null;
        object.investorName = "";
        object.custodyCode = "";
        object.companyName = "";
      }
      if (message.campaignCode != null && message.hasOwnProperty("campaignCode"))
        object.campaignCode = message.campaignCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.RewardStatus[message.status] : message.status;
      if (message.outOfStock != null && message.hasOwnProperty("outOfStock"))
        object.outOfStock = message.outOfStock;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.investorName != null && message.hasOwnProperty("investorName"))
        object.investorName = message.investorName;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.companyName != null && message.hasOwnProperty("companyName"))
        object.companyName = message.companyName;
      return object;
    };
    StockRewardNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockRewardNotification;
  }();
  dnse2.StockRewardPopup = function() {
    function StockRewardPopup(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockRewardPopup.prototype.campaignCode = "";
    StockRewardPopup.prototype.investorId = "";
    StockRewardPopup.prototype.type = 0;
    StockRewardPopup.prototype.action = 0;
    StockRewardPopup.prototype.symbol = "";
    StockRewardPopup.prototype.companyName = "";
    StockRewardPopup.prototype.quantity = 0;
    StockRewardPopup.prototype.matchPrice = 0;
    StockRewardPopup.prototype.breakEvenPrice = 0;
    StockRewardPopup.prototype.time = null;
    StockRewardPopup.create = function create(properties) {
      return new StockRewardPopup(properties);
    };
    StockRewardPopup.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.campaignCode != null && Object.hasOwnProperty.call(message, "campaignCode"))
        writer.uint32(10).string(message.campaignCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(24).int32(message.type);
      if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        writer.uint32(32).int32(message.action);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
        writer.uint32(50).string(message.companyName);
      if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
        writer.uint32(56).uint32(message.quantity);
      if (message.matchPrice != null && Object.hasOwnProperty.call(message, "matchPrice"))
        writer.uint32(65).double(message.matchPrice);
      if (message.breakEvenPrice != null && Object.hasOwnProperty.call(message, "breakEvenPrice"))
        writer.uint32(73).double(message.breakEvenPrice);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(82).fork()).ldelim();
      return writer;
    };
    StockRewardPopup.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockRewardPopup.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.StockRewardPopup();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.campaignCode = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.type = reader.int32();
            break;
          case 4:
            message.action = reader.int32();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.companyName = reader.string();
            break;
          case 7:
            message.quantity = reader.uint32();
            break;
          case 8:
            message.matchPrice = reader.double();
            break;
          case 9:
            message.breakEvenPrice = reader.double();
            break;
          case 10:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockRewardPopup.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockRewardPopup.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.campaignCode != null && message.hasOwnProperty("campaignCode")) {
        if (!$util.isString(message.campaignCode))
          return "campaignCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.action != null && message.hasOwnProperty("action"))
        switch (message.action) {
          default:
            return "action: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.companyName != null && message.hasOwnProperty("companyName")) {
        if (!$util.isString(message.companyName))
          return "companyName: string expected";
      }
      if (message.quantity != null && message.hasOwnProperty("quantity")) {
        if (!$util.isInteger(message.quantity))
          return "quantity: integer expected";
      }
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice")) {
        if (typeof message.matchPrice !== "number")
          return "matchPrice: number expected";
      }
      if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice")) {
        if (typeof message.breakEvenPrice !== "number")
          return "breakEvenPrice: number expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    StockRewardPopup.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.StockRewardPopup)
        return object;
      let message = new $root.dnse.StockRewardPopup();
      if (object.campaignCode != null)
        message.campaignCode = String(object.campaignCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      switch (object.type) {
        case "POPUP_CONGRATS_RECEIVED":
        case 0:
          message.type = 0;
          break;
        case "POPUP_CONFIRM_OUTOFSTOCK":
        case 1:
          message.type = 1;
          break;
      }
      switch (object.action) {
        case "HIDE":
        case 0:
          message.action = 0;
          break;
        case "SHOW":
        case 1:
          message.action = 1;
          break;
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.companyName != null)
        message.companyName = String(object.companyName);
      if (object.quantity != null)
        message.quantity = object.quantity >>> 0;
      if (object.matchPrice != null)
        message.matchPrice = Number(object.matchPrice);
      if (object.breakEvenPrice != null)
        message.breakEvenPrice = Number(object.breakEvenPrice);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.StockRewardPopup.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    StockRewardPopup.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.campaignCode = "";
        object.investorId = "";
        object.type = options.enums === String ? "POPUP_CONGRATS_RECEIVED" : 0;
        object.action = options.enums === String ? "HIDE" : 0;
        object.symbol = "";
        object.companyName = "";
        object.quantity = 0;
        object.matchPrice = 0;
        object.breakEvenPrice = 0;
        object.time = null;
      }
      if (message.campaignCode != null && message.hasOwnProperty("campaignCode"))
        object.campaignCode = message.campaignCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.StockRewardPopup.Type[message.type] : message.type;
      if (message.action != null && message.hasOwnProperty("action"))
        object.action = options.enums === String ? $root.dnse.StockRewardPopup.Action[message.action] : message.action;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.companyName != null && message.hasOwnProperty("companyName"))
        object.companyName = message.companyName;
      if (message.quantity != null && message.hasOwnProperty("quantity"))
        object.quantity = message.quantity;
      if (message.matchPrice != null && message.hasOwnProperty("matchPrice"))
        object.matchPrice = options.json && !isFinite(message.matchPrice) ? String(message.matchPrice) : message.matchPrice;
      if (message.breakEvenPrice != null && message.hasOwnProperty("breakEvenPrice"))
        object.breakEvenPrice = options.json && !isFinite(message.breakEvenPrice) ? String(message.breakEvenPrice) : message.breakEvenPrice;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    StockRewardPopup.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    StockRewardPopup.Type = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "POPUP_CONGRATS_RECEIVED"] = 0;
      values[valuesById[1] = "POPUP_CONFIRM_OUTOFSTOCK"] = 1;
      return values;
    }();
    StockRewardPopup.Action = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "HIDE"] = 0;
      values[valuesById[1] = "SHOW"] = 1;
      return values;
    }();
    return StockRewardPopup;
  }();
  dnse2.WichartFirstOrderReward = function() {
    function WichartFirstOrderReward(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    WichartFirstOrderReward.prototype.investorId = "";
    WichartFirstOrderReward.prototype.custodyCode = "";
    WichartFirstOrderReward.prototype.createdAt = null;
    WichartFirstOrderReward.create = function create(properties) {
      return new WichartFirstOrderReward(properties);
    };
    WichartFirstOrderReward.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    WichartFirstOrderReward.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    WichartFirstOrderReward.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.WichartFirstOrderReward();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    WichartFirstOrderReward.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    WichartFirstOrderReward.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    WichartFirstOrderReward.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.WichartFirstOrderReward)
        return object;
      let message = new $root.dnse.WichartFirstOrderReward();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.WichartFirstOrderReward.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    WichartFirstOrderReward.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    WichartFirstOrderReward.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return WichartFirstOrderReward;
  }();
  dnse2.StockReward24hStatus = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SR_24H_UNKOWN"] = 0;
    values[valuesById[1] = "SR_24H_WAIT_TO_TRANSFER"] = 1;
    values[valuesById[2] = "SR_24H_EXPIRING_SOON"] = 2;
    values[valuesById[3] = "SR_24H_SUCCESS"] = 3;
    values[valuesById[4] = "SR_24H_EXPIRED"] = 4;
    return values;
  }();
  dnse2.StockReward24H = function() {
    function StockReward24H(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    StockReward24H.prototype.status = 0;
    StockReward24H.prototype.investorId = "";
    StockReward24H.prototype.symbol = "";
    StockReward24H.prototype.createdAt = null;
    StockReward24H.create = function create(properties) {
      return new StockReward24H(properties);
    };
    StockReward24H.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(8).int32(message.status);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    StockReward24H.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    StockReward24H.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.StockReward24H();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.status = reader.int32();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    StockReward24H.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    StockReward24H.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    StockReward24H.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.StockReward24H)
        return object;
      let message = new $root.dnse.StockReward24H();
      switch (object.status) {
        case "SR_24H_UNKOWN":
        case 0:
          message.status = 0;
          break;
        case "SR_24H_WAIT_TO_TRANSFER":
        case 1:
          message.status = 1;
          break;
        case "SR_24H_EXPIRING_SOON":
        case 2:
          message.status = 2;
          break;
        case "SR_24H_SUCCESS":
        case 3:
          message.status = 3;
          break;
        case "SR_24H_EXPIRED":
        case 4:
          message.status = 4;
          break;
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.StockReward24H.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    StockReward24H.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.status = options.enums === String ? "SR_24H_UNKOWN" : 0;
        object.investorId = "";
        object.symbol = "";
        object.createdAt = null;
      }
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.StockReward24hStatus[message.status] : message.status;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    StockReward24H.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return StockReward24H;
  }();
  dnse2.CourseRegistrationSuccessEvent = function() {
    function CourseRegistrationSuccessEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    CourseRegistrationSuccessEvent.prototype.email = "";
    CourseRegistrationSuccessEvent.prototype.courseName = "";
    CourseRegistrationSuccessEvent.prototype.schedule = "";
    CourseRegistrationSuccessEvent.prototype.time = null;
    CourseRegistrationSuccessEvent.create = function create(properties) {
      return new CourseRegistrationSuccessEvent(properties);
    };
    CourseRegistrationSuccessEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        writer.uint32(10).string(message.email);
      if (message.courseName != null && Object.hasOwnProperty.call(message, "courseName"))
        writer.uint32(18).string(message.courseName);
      if (message.schedule != null && Object.hasOwnProperty.call(message, "schedule"))
        writer.uint32(26).string(message.schedule);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
      return writer;
    };
    CourseRegistrationSuccessEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    CourseRegistrationSuccessEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.CourseRegistrationSuccessEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.email = reader.string();
            break;
          case 2:
            message.courseName = reader.string();
            break;
          case 3:
            message.schedule = reader.string();
            break;
          case 4:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    CourseRegistrationSuccessEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    CourseRegistrationSuccessEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.email != null && message.hasOwnProperty("email")) {
        if (!$util.isString(message.email))
          return "email: string expected";
      }
      if (message.courseName != null && message.hasOwnProperty("courseName")) {
        if (!$util.isString(message.courseName))
          return "courseName: string expected";
      }
      if (message.schedule != null && message.hasOwnProperty("schedule")) {
        if (!$util.isString(message.schedule))
          return "schedule: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    CourseRegistrationSuccessEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.CourseRegistrationSuccessEvent)
        return object;
      let message = new $root.dnse.CourseRegistrationSuccessEvent();
      if (object.email != null)
        message.email = String(object.email);
      if (object.courseName != null)
        message.courseName = String(object.courseName);
      if (object.schedule != null)
        message.schedule = String(object.schedule);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.CourseRegistrationSuccessEvent.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    CourseRegistrationSuccessEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.email = "";
        object.courseName = "";
        object.schedule = "";
        object.time = null;
      }
      if (message.email != null && message.hasOwnProperty("email"))
        object.email = message.email;
      if (message.courseName != null && message.hasOwnProperty("courseName"))
        object.courseName = message.courseName;
      if (message.schedule != null && message.hasOwnProperty("schedule"))
        object.schedule = message.schedule;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    CourseRegistrationSuccessEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return CourseRegistrationSuccessEvent;
  }();
  dnse2.VolatilityIndexEvent = function() {
    function VolatilityIndexEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    VolatilityIndexEvent.prototype.currentVolatilityIndex = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VolatilityIndexEvent.prototype.time = null;
    VolatilityIndexEvent.create = function create(properties) {
      return new VolatilityIndexEvent(properties);
    };
    VolatilityIndexEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.currentVolatilityIndex != null && Object.hasOwnProperty.call(message, "currentVolatilityIndex"))
        writer.uint32(8).int64(message.currentVolatilityIndex);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    VolatilityIndexEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    VolatilityIndexEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.VolatilityIndexEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.currentVolatilityIndex = reader.int64();
            break;
          case 2:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    VolatilityIndexEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    VolatilityIndexEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.currentVolatilityIndex != null && message.hasOwnProperty("currentVolatilityIndex")) {
        if (!$util.isInteger(message.currentVolatilityIndex) && !(message.currentVolatilityIndex && $util.isInteger(message.currentVolatilityIndex.low) && $util.isInteger(message.currentVolatilityIndex.high)))
          return "currentVolatilityIndex: integer|Long expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    VolatilityIndexEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.VolatilityIndexEvent)
        return object;
      let message = new $root.dnse.VolatilityIndexEvent();
      if (object.currentVolatilityIndex != null) {
        if ($util.Long)
          (message.currentVolatilityIndex = $util.Long.fromValue(object.currentVolatilityIndex)).unsigned = false;
        else if (typeof object.currentVolatilityIndex === "string")
          message.currentVolatilityIndex = parseInt(object.currentVolatilityIndex, 10);
        else if (typeof object.currentVolatilityIndex === "number")
          message.currentVolatilityIndex = object.currentVolatilityIndex;
        else if (typeof object.currentVolatilityIndex === "object")
          message.currentVolatilityIndex = new $util.LongBits(object.currentVolatilityIndex.low >>> 0, object.currentVolatilityIndex.high >>> 0).toNumber();
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.VolatilityIndexEvent.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    VolatilityIndexEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.currentVolatilityIndex = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.currentVolatilityIndex = options.longs === String ? "0" : 0;
        object.time = null;
      }
      if (message.currentVolatilityIndex != null && message.hasOwnProperty("currentVolatilityIndex"))
        if (typeof message.currentVolatilityIndex === "number")
          object.currentVolatilityIndex = options.longs === String ? String(message.currentVolatilityIndex) : message.currentVolatilityIndex;
        else
          object.currentVolatilityIndex = options.longs === String ? $util.Long.prototype.toString.call(message.currentVolatilityIndex) : options.longs === Number ? new $util.LongBits(message.currentVolatilityIndex.low >>> 0, message.currentVolatilityIndex.high >>> 0).toNumber() : message.currentVolatilityIndex;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    VolatilityIndexEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return VolatilityIndexEvent;
  }();
  dnse2.GoldenEggCreated = function() {
    function GoldenEggCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggCreated.prototype.productName = "";
    GoldenEggCreated.prototype.symbol = "";
    GoldenEggCreated.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggCreated.prototype.interestRate = 0;
    GoldenEggCreated.prototype.periodDesc = "";
    GoldenEggCreated.prototype.id = "";
    GoldenEggCreated.prototype.investorId = "";
    GoldenEggCreated.prototype.createdDate = null;
    GoldenEggCreated.create = function create(properties) {
      return new GoldenEggCreated(properties);
    };
    GoldenEggCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(10).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).int64(message.amount);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(33).double(message.interestRate);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(42).string(message.periodDesc);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(50).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(58).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    GoldenEggCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.productName = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.amount = reader.int64();
            break;
          case 4:
            message.interestRate = reader.double();
            break;
          case 5:
            message.periodDesc = reader.string();
            break;
          case 6:
            message.id = reader.string();
            break;
          case 7:
            message.investorId = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    GoldenEggCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggCreated)
        return object;
      let message = new $root.dnse.GoldenEggCreated();
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggCreated.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    GoldenEggCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.interestRate = 0;
        object.periodDesc = "";
        object.id = "";
        object.investorId = "";
        object.createdDate = null;
      }
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    GoldenEggCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggCreated;
  }();
  dnse2.GoldenEggCreatedFail = function() {
    function GoldenEggCreatedFail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggCreatedFail.prototype.productName = "";
    GoldenEggCreatedFail.prototype.symbol = "";
    GoldenEggCreatedFail.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggCreatedFail.prototype.interestRate = 0;
    GoldenEggCreatedFail.prototype.periodDesc = "";
    GoldenEggCreatedFail.prototype.investorId = "";
    GoldenEggCreatedFail.prototype.id = "";
    GoldenEggCreatedFail.prototype.createdDate = null;
    GoldenEggCreatedFail.prototype.errorReason = "";
    GoldenEggCreatedFail.create = function create(properties) {
      return new GoldenEggCreatedFail(properties);
    };
    GoldenEggCreatedFail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(10).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).int64(message.amount);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(33).double(message.interestRate);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(42).string(message.periodDesc);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(58).string(message.id);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.errorReason != null && Object.hasOwnProperty.call(message, "errorReason"))
        writer.uint32(74).string(message.errorReason);
      return writer;
    };
    GoldenEggCreatedFail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggCreatedFail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggCreatedFail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.productName = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.amount = reader.int64();
            break;
          case 4:
            message.interestRate = reader.double();
            break;
          case 5:
            message.periodDesc = reader.string();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.id = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.errorReason = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggCreatedFail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggCreatedFail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.errorReason != null && message.hasOwnProperty("errorReason")) {
        if (!$util.isString(message.errorReason))
          return "errorReason: string expected";
      }
      return null;
    };
    GoldenEggCreatedFail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggCreatedFail)
        return object;
      let message = new $root.dnse.GoldenEggCreatedFail();
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.id != null)
        message.id = String(object.id);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggCreatedFail.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.errorReason != null)
        message.errorReason = String(object.errorReason);
      return message;
    };
    GoldenEggCreatedFail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.interestRate = 0;
        object.periodDesc = "";
        object.investorId = "";
        object.id = "";
        object.createdDate = null;
        object.errorReason = "";
      }
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.errorReason != null && message.hasOwnProperty("errorReason"))
        object.errorReason = message.errorReason;
      return object;
    };
    GoldenEggCreatedFail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggCreatedFail;
  }();
  dnse2.GoldenEggReceivedInterest = function() {
    function GoldenEggReceivedInterest(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggReceivedInterest.prototype.investorId = "";
    GoldenEggReceivedInterest.prototype.productName = "";
    GoldenEggReceivedInterest.prototype.symbol = "";
    GoldenEggReceivedInterest.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggReceivedInterest.prototype.interestDate = null;
    GoldenEggReceivedInterest.prototype.id = "";
    GoldenEggReceivedInterest.prototype.createdDate = null;
    GoldenEggReceivedInterest.create = function create(properties) {
      return new GoldenEggReceivedInterest(properties);
    };
    GoldenEggReceivedInterest.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(18).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(32).int64(message.amount);
      if (message.interestDate != null && Object.hasOwnProperty.call(message, "interestDate"))
        $root.google.protobuf.Timestamp.encode(message.interestDate, writer.uint32(42).fork()).ldelim();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(50).string(message.id);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    GoldenEggReceivedInterest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggReceivedInterest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggReceivedInterest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.productName = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.amount = reader.int64();
            break;
          case 5:
            message.interestDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.id = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggReceivedInterest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggReceivedInterest.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interestDate != null && message.hasOwnProperty("interestDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.interestDate);
        if (error)
          return "interestDate." + error;
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    GoldenEggReceivedInterest.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggReceivedInterest)
        return object;
      let message = new $root.dnse.GoldenEggReceivedInterest();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.interestDate != null) {
        if (typeof object.interestDate !== "object")
          throw TypeError(".dnse.GoldenEggReceivedInterest.interestDate: object expected");
        message.interestDate = $root.google.protobuf.Timestamp.fromObject(object.interestDate);
      }
      if (object.id != null)
        message.id = String(object.id);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggReceivedInterest.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    GoldenEggReceivedInterest.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.interestDate = null;
        object.id = "";
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.interestDate != null && message.hasOwnProperty("interestDate"))
        object.interestDate = $root.google.protobuf.Timestamp.toObject(message.interestDate, options);
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    GoldenEggReceivedInterest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggReceivedInterest;
  }();
  dnse2.GoldenEggDueDate = function() {
    function GoldenEggDueDate(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggDueDate.prototype.investorId = "";
    GoldenEggDueDate.prototype.productName = "";
    GoldenEggDueDate.prototype.symbol = "";
    GoldenEggDueDate.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggDueDate.prototype.interestDate = null;
    GoldenEggDueDate.prototype.id = "";
    GoldenEggDueDate.prototype.createdDate = null;
    GoldenEggDueDate.prototype.originalId = "";
    GoldenEggDueDate.create = function create(properties) {
      return new GoldenEggDueDate(properties);
    };
    GoldenEggDueDate.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(18).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(32).int64(message.amount);
      if (message.interestDate != null && Object.hasOwnProperty.call(message, "interestDate"))
        $root.google.protobuf.Timestamp.encode(message.interestDate, writer.uint32(42).fork()).ldelim();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(50).string(message.id);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.originalId != null && Object.hasOwnProperty.call(message, "originalId"))
        writer.uint32(66).string(message.originalId);
      return writer;
    };
    GoldenEggDueDate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggDueDate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggDueDate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.productName = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.amount = reader.int64();
            break;
          case 5:
            message.interestDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.id = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.originalId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggDueDate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggDueDate.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interestDate != null && message.hasOwnProperty("interestDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.interestDate);
        if (error)
          return "interestDate." + error;
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.originalId != null && message.hasOwnProperty("originalId")) {
        if (!$util.isString(message.originalId))
          return "originalId: string expected";
      }
      return null;
    };
    GoldenEggDueDate.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggDueDate)
        return object;
      let message = new $root.dnse.GoldenEggDueDate();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.interestDate != null) {
        if (typeof object.interestDate !== "object")
          throw TypeError(".dnse.GoldenEggDueDate.interestDate: object expected");
        message.interestDate = $root.google.protobuf.Timestamp.fromObject(object.interestDate);
      }
      if (object.id != null)
        message.id = String(object.id);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggDueDate.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.originalId != null)
        message.originalId = String(object.originalId);
      return message;
    };
    GoldenEggDueDate.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.interestDate = null;
        object.id = "";
        object.createdDate = null;
        object.originalId = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.interestDate != null && message.hasOwnProperty("interestDate"))
        object.interestDate = $root.google.protobuf.Timestamp.toObject(message.interestDate, options);
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.originalId != null && message.hasOwnProperty("originalId"))
        object.originalId = message.originalId;
      return object;
    };
    GoldenEggDueDate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggDueDate;
  }();
  dnse2.GoldenEggSellingConfirmation = function() {
    function GoldenEggSellingConfirmation(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggSellingConfirmation.prototype.investorId = "";
    GoldenEggSellingConfirmation.prototype.productName = "";
    GoldenEggSellingConfirmation.prototype.symbol = "";
    GoldenEggSellingConfirmation.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggSellingConfirmation.prototype.id = "";
    GoldenEggSellingConfirmation.prototype.createdDate = null;
    GoldenEggSellingConfirmation.create = function create(properties) {
      return new GoldenEggSellingConfirmation(properties);
    };
    GoldenEggSellingConfirmation.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(18).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(32).int64(message.amount);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(42).string(message.id);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    GoldenEggSellingConfirmation.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggSellingConfirmation.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggSellingConfirmation();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.productName = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.amount = reader.int64();
            break;
          case 5:
            message.id = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggSellingConfirmation.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggSellingConfirmation.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    GoldenEggSellingConfirmation.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggSellingConfirmation)
        return object;
      let message = new $root.dnse.GoldenEggSellingConfirmation();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.id != null)
        message.id = String(object.id);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggSellingConfirmation.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    GoldenEggSellingConfirmation.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.id = "";
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    GoldenEggSellingConfirmation.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggSellingConfirmation;
  }();
  dnse2.GoldenEggSucceedSellConfirmation = function() {
    function GoldenEggSucceedSellConfirmation(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggSucceedSellConfirmation.prototype.id = "";
    GoldenEggSucceedSellConfirmation.prototype.investorId = "";
    GoldenEggSucceedSellConfirmation.prototype.productName = "";
    GoldenEggSucceedSellConfirmation.prototype.symbol = "";
    GoldenEggSucceedSellConfirmation.prototype.receivedAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggSucceedSellConfirmation.prototype.sellingPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggSucceedSellConfirmation.prototype.isSellingPriceChanged = false;
    GoldenEggSucceedSellConfirmation.prototype.createdDate = null;
    GoldenEggSucceedSellConfirmation.create = function create(properties) {
      return new GoldenEggSucceedSellConfirmation(properties);
    };
    GoldenEggSucceedSellConfirmation.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(10).string(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(26).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(34).string(message.symbol);
      if (message.receivedAmount != null && Object.hasOwnProperty.call(message, "receivedAmount"))
        writer.uint32(40).int64(message.receivedAmount);
      if (message.sellingPrice != null && Object.hasOwnProperty.call(message, "sellingPrice"))
        writer.uint32(48).int64(message.sellingPrice);
      if (message.isSellingPriceChanged != null && Object.hasOwnProperty.call(message, "isSellingPriceChanged"))
        writer.uint32(56).bool(message.isSellingPriceChanged);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    GoldenEggSucceedSellConfirmation.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggSucceedSellConfirmation.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggSucceedSellConfirmation();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.string();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.productName = reader.string();
            break;
          case 4:
            message.symbol = reader.string();
            break;
          case 5:
            message.receivedAmount = reader.int64();
            break;
          case 6:
            message.sellingPrice = reader.int64();
            break;
          case 7:
            message.isSellingPriceChanged = reader.bool();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggSucceedSellConfirmation.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggSucceedSellConfirmation.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.receivedAmount != null && message.hasOwnProperty("receivedAmount")) {
        if (!$util.isInteger(message.receivedAmount) && !(message.receivedAmount && $util.isInteger(message.receivedAmount.low) && $util.isInteger(message.receivedAmount.high)))
          return "receivedAmount: integer|Long expected";
      }
      if (message.sellingPrice != null && message.hasOwnProperty("sellingPrice")) {
        if (!$util.isInteger(message.sellingPrice) && !(message.sellingPrice && $util.isInteger(message.sellingPrice.low) && $util.isInteger(message.sellingPrice.high)))
          return "sellingPrice: integer|Long expected";
      }
      if (message.isSellingPriceChanged != null && message.hasOwnProperty("isSellingPriceChanged")) {
        if (typeof message.isSellingPriceChanged !== "boolean")
          return "isSellingPriceChanged: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    GoldenEggSucceedSellConfirmation.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggSucceedSellConfirmation)
        return object;
      let message = new $root.dnse.GoldenEggSucceedSellConfirmation();
      if (object.id != null)
        message.id = String(object.id);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.receivedAmount != null) {
        if ($util.Long)
          (message.receivedAmount = $util.Long.fromValue(object.receivedAmount)).unsigned = false;
        else if (typeof object.receivedAmount === "string")
          message.receivedAmount = parseInt(object.receivedAmount, 10);
        else if (typeof object.receivedAmount === "number")
          message.receivedAmount = object.receivedAmount;
        else if (typeof object.receivedAmount === "object")
          message.receivedAmount = new $util.LongBits(object.receivedAmount.low >>> 0, object.receivedAmount.high >>> 0).toNumber();
      }
      if (object.sellingPrice != null) {
        if ($util.Long)
          (message.sellingPrice = $util.Long.fromValue(object.sellingPrice)).unsigned = false;
        else if (typeof object.sellingPrice === "string")
          message.sellingPrice = parseInt(object.sellingPrice, 10);
        else if (typeof object.sellingPrice === "number")
          message.sellingPrice = object.sellingPrice;
        else if (typeof object.sellingPrice === "object")
          message.sellingPrice = new $util.LongBits(object.sellingPrice.low >>> 0, object.sellingPrice.high >>> 0).toNumber();
      }
      if (object.isSellingPriceChanged != null)
        message.isSellingPriceChanged = Boolean(object.isSellingPriceChanged);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggSucceedSellConfirmation.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    GoldenEggSucceedSellConfirmation.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = "";
        object.investorId = "";
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.receivedAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivedAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sellingPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.sellingPrice = options.longs === String ? "0" : 0;
        object.isSellingPriceChanged = false;
        object.createdDate = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.receivedAmount != null && message.hasOwnProperty("receivedAmount"))
        if (typeof message.receivedAmount === "number")
          object.receivedAmount = options.longs === String ? String(message.receivedAmount) : message.receivedAmount;
        else
          object.receivedAmount = options.longs === String ? $util.Long.prototype.toString.call(message.receivedAmount) : options.longs === Number ? new $util.LongBits(message.receivedAmount.low >>> 0, message.receivedAmount.high >>> 0).toNumber() : message.receivedAmount;
      if (message.sellingPrice != null && message.hasOwnProperty("sellingPrice"))
        if (typeof message.sellingPrice === "number")
          object.sellingPrice = options.longs === String ? String(message.sellingPrice) : message.sellingPrice;
        else
          object.sellingPrice = options.longs === String ? $util.Long.prototype.toString.call(message.sellingPrice) : options.longs === Number ? new $util.LongBits(message.sellingPrice.low >>> 0, message.sellingPrice.high >>> 0).toNumber() : message.sellingPrice;
      if (message.isSellingPriceChanged != null && message.hasOwnProperty("isSellingPriceChanged"))
        object.isSellingPriceChanged = message.isSellingPriceChanged;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    GoldenEggSucceedSellConfirmation.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggSucceedSellConfirmation;
  }();
  dnse2.GoldenEggOverDueDate = function() {
    function GoldenEggOverDueDate(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggOverDueDate.prototype.investorId = "";
    GoldenEggOverDueDate.prototype.productName = "";
    GoldenEggOverDueDate.prototype.symbol = "";
    GoldenEggOverDueDate.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggOverDueDate.prototype.id = "";
    GoldenEggOverDueDate.prototype.createdDate = null;
    GoldenEggOverDueDate.prototype.originalId = "";
    GoldenEggOverDueDate.create = function create(properties) {
      return new GoldenEggOverDueDate(properties);
    };
    GoldenEggOverDueDate.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(18).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(26).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(32).int64(message.amount);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(42).string(message.id);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.originalId != null && Object.hasOwnProperty.call(message, "originalId"))
        writer.uint32(58).string(message.originalId);
      return writer;
    };
    GoldenEggOverDueDate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggOverDueDate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggOverDueDate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.productName = reader.string();
            break;
          case 3:
            message.symbol = reader.string();
            break;
          case 4:
            message.amount = reader.int64();
            break;
          case 5:
            message.id = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.originalId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggOverDueDate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggOverDueDate.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.originalId != null && message.hasOwnProperty("originalId")) {
        if (!$util.isString(message.originalId))
          return "originalId: string expected";
      }
      return null;
    };
    GoldenEggOverDueDate.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggOverDueDate)
        return object;
      let message = new $root.dnse.GoldenEggOverDueDate();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.id != null)
        message.id = String(object.id);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggOverDueDate.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.originalId != null)
        message.originalId = String(object.originalId);
      return message;
    };
    GoldenEggOverDueDate.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.id = "";
        object.createdDate = null;
        object.originalId = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.originalId != null && message.hasOwnProperty("originalId"))
        object.originalId = message.originalId;
      return object;
    };
    GoldenEggOverDueDate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggOverDueDate;
  }();
  dnse2.GoldenEggCreatedPreMarket = function() {
    function GoldenEggCreatedPreMarket(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggCreatedPreMarket.prototype.productName = "";
    GoldenEggCreatedPreMarket.prototype.symbol = "";
    GoldenEggCreatedPreMarket.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GoldenEggCreatedPreMarket.prototype.interestRate = 0;
    GoldenEggCreatedPreMarket.prototype.periodDesc = "";
    GoldenEggCreatedPreMarket.prototype.investorId = "";
    GoldenEggCreatedPreMarket.prototype.id = "";
    GoldenEggCreatedPreMarket.prototype.createdDate = null;
    GoldenEggCreatedPreMarket.prototype.accountNo = "";
    GoldenEggCreatedPreMarket.create = function create(properties) {
      return new GoldenEggCreatedPreMarket(properties);
    };
    GoldenEggCreatedPreMarket.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(10).string(message.productName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).int64(message.amount);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(33).double(message.interestRate);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(42).string(message.periodDesc);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(58).string(message.id);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(74).string(message.accountNo);
      return writer;
    };
    GoldenEggCreatedPreMarket.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggCreatedPreMarket.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggCreatedPreMarket();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.productName = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.amount = reader.int64();
            break;
          case 4:
            message.interestRate = reader.double();
            break;
          case 5:
            message.periodDesc = reader.string();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.id = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.accountNo = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggCreatedPreMarket.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggCreatedPreMarket.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      return null;
    };
    GoldenEggCreatedPreMarket.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggCreatedPreMarket)
        return object;
      let message = new $root.dnse.GoldenEggCreatedPreMarket();
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.id != null)
        message.id = String(object.id);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.GoldenEggCreatedPreMarket.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      return message;
    };
    GoldenEggCreatedPreMarket.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.productName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.interestRate = 0;
        object.periodDesc = "";
        object.investorId = "";
        object.id = "";
        object.createdDate = null;
        object.accountNo = "";
      }
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      return object;
    };
    GoldenEggCreatedPreMarket.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggCreatedPreMarket;
  }();
  dnse2.MGMEventType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SIGN_UP"] = 0;
    values[valuesById[1] = "VERIFIED"] = 1;
    values[valuesById[2] = "ACTIVE"] = 2;
    values[valuesById[3] = "FIRST_UNDERLYING_TRANSACTION"] = 3;
    values[valuesById[4] = "FIRST_DERIVATIVE_TRANSACTION"] = 4;
    values[valuesById[5] = "FIRST_TRANSACTION"] = 5;
    values[valuesById[6] = "FIRST_MARGIN_TRANSACTION"] = 6;
    return values;
  }();
  dnse2.MGMEvent = function() {
    function MGMEvent(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MGMEvent.prototype.transactionId = "";
    MGMEvent.prototype.type = 0;
    MGMEvent.prototype.refererId = "";
    MGMEvent.prototype.refereeId = "";
    MGMEvent.prototype.receiverId = "";
    MGMEvent.prototype.createdAt = null;
    MGMEvent.prototype.time = null;
    MGMEvent.create = function create(properties) {
      return new MGMEvent(properties);
    };
    MGMEvent.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
        writer.uint32(10).string(message.transactionId);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(16).int32(message.type);
      if (message.refererId != null && Object.hasOwnProperty.call(message, "refererId"))
        writer.uint32(26).string(message.refererId);
      if (message.refereeId != null && Object.hasOwnProperty.call(message, "refereeId"))
        writer.uint32(34).string(message.refereeId);
      if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
        writer.uint32(42).string(message.receiverId);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    MGMEvent.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MGMEvent.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.MGMEvent();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.transactionId = reader.string();
            break;
          case 2:
            message.type = reader.int32();
            break;
          case 3:
            message.refererId = reader.string();
            break;
          case 4:
            message.refereeId = reader.string();
            break;
          case 5:
            message.receiverId = reader.string();
            break;
          case 6:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MGMEvent.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MGMEvent.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.transactionId != null && message.hasOwnProperty("transactionId")) {
        if (!$util.isString(message.transactionId))
          return "transactionId: string expected";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (message.refererId != null && message.hasOwnProperty("refererId")) {
        if (!$util.isString(message.refererId))
          return "refererId: string expected";
      }
      if (message.refereeId != null && message.hasOwnProperty("refereeId")) {
        if (!$util.isString(message.refereeId))
          return "refereeId: string expected";
      }
      if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
        if (!$util.isString(message.receiverId))
          return "receiverId: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    MGMEvent.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.MGMEvent)
        return object;
      let message = new $root.dnse.MGMEvent();
      if (object.transactionId != null)
        message.transactionId = String(object.transactionId);
      switch (object.type) {
        case "SIGN_UP":
        case 0:
          message.type = 0;
          break;
        case "VERIFIED":
        case 1:
          message.type = 1;
          break;
        case "ACTIVE":
        case 2:
          message.type = 2;
          break;
        case "FIRST_UNDERLYING_TRANSACTION":
        case 3:
          message.type = 3;
          break;
        case "FIRST_DERIVATIVE_TRANSACTION":
        case 4:
          message.type = 4;
          break;
        case "FIRST_TRANSACTION":
        case 5:
          message.type = 5;
          break;
        case "FIRST_MARGIN_TRANSACTION":
        case 6:
          message.type = 6;
          break;
      }
      if (object.refererId != null)
        message.refererId = String(object.refererId);
      if (object.refereeId != null)
        message.refereeId = String(object.refereeId);
      if (object.receiverId != null)
        message.receiverId = String(object.receiverId);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.MGMEvent.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.MGMEvent.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    MGMEvent.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.transactionId = "";
        object.type = options.enums === String ? "SIGN_UP" : 0;
        object.refererId = "";
        object.refereeId = "";
        object.receiverId = "";
        object.createdAt = null;
        object.time = null;
      }
      if (message.transactionId != null && message.hasOwnProperty("transactionId"))
        object.transactionId = message.transactionId;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.MGMEventType[message.type] : message.type;
      if (message.refererId != null && message.hasOwnProperty("refererId"))
        object.refererId = message.refererId;
      if (message.refereeId != null && message.hasOwnProperty("refereeId"))
        object.refereeId = message.refereeId;
      if (message.receiverId != null && message.hasOwnProperty("receiverId"))
        object.receiverId = message.receiverId;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    MGMEvent.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MGMEvent;
  }();
  dnse2.MGMGetRewardNotification = function() {
    function MGMGetRewardNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MGMGetRewardNotification.prototype.eventType = 0;
    MGMGetRewardNotification.prototype.id = "";
    MGMGetRewardNotification.prototype.triggerId = "";
    MGMGetRewardNotification.prototype.receiverId = "";
    MGMGetRewardNotification.prototype.star = 0;
    MGMGetRewardNotification.prototype.cash = 0;
    MGMGetRewardNotification.prototype.referrerName = "";
    MGMGetRewardNotification.prototype.refereeName = "";
    MGMGetRewardNotification.prototype.time = null;
    MGMGetRewardNotification.create = function create(properties) {
      return new MGMGetRewardNotification(properties);
    };
    MGMGetRewardNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
        writer.uint32(8).int32(message.eventType);
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(18).string(message.id);
      if (message.triggerId != null && Object.hasOwnProperty.call(message, "triggerId"))
        writer.uint32(26).string(message.triggerId);
      if (message.receiverId != null && Object.hasOwnProperty.call(message, "receiverId"))
        writer.uint32(34).string(message.receiverId);
      if (message.star != null && Object.hasOwnProperty.call(message, "star"))
        writer.uint32(41).double(message.star);
      if (message.cash != null && Object.hasOwnProperty.call(message, "cash"))
        writer.uint32(49).double(message.cash);
      if (message.referrerName != null && Object.hasOwnProperty.call(message, "referrerName"))
        writer.uint32(58).string(message.referrerName);
      if (message.refereeName != null && Object.hasOwnProperty.call(message, "refereeName"))
        writer.uint32(66).string(message.refereeName);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(74).fork()).ldelim();
      return writer;
    };
    MGMGetRewardNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MGMGetRewardNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.MGMGetRewardNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.eventType = reader.int32();
            break;
          case 2:
            message.id = reader.string();
            break;
          case 3:
            message.triggerId = reader.string();
            break;
          case 4:
            message.receiverId = reader.string();
            break;
          case 5:
            message.star = reader.double();
            break;
          case 6:
            message.cash = reader.double();
            break;
          case 7:
            message.referrerName = reader.string();
            break;
          case 8:
            message.refereeName = reader.string();
            break;
          case 9:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MGMGetRewardNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MGMGetRewardNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.eventType != null && message.hasOwnProperty("eventType"))
        switch (message.eventType) {
          default:
            return "eventType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isString(message.id))
          return "id: string expected";
      }
      if (message.triggerId != null && message.hasOwnProperty("triggerId")) {
        if (!$util.isString(message.triggerId))
          return "triggerId: string expected";
      }
      if (message.receiverId != null && message.hasOwnProperty("receiverId")) {
        if (!$util.isString(message.receiverId))
          return "receiverId: string expected";
      }
      if (message.star != null && message.hasOwnProperty("star")) {
        if (typeof message.star !== "number")
          return "star: number expected";
      }
      if (message.cash != null && message.hasOwnProperty("cash")) {
        if (typeof message.cash !== "number")
          return "cash: number expected";
      }
      if (message.referrerName != null && message.hasOwnProperty("referrerName")) {
        if (!$util.isString(message.referrerName))
          return "referrerName: string expected";
      }
      if (message.refereeName != null && message.hasOwnProperty("refereeName")) {
        if (!$util.isString(message.refereeName))
          return "refereeName: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    MGMGetRewardNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.MGMGetRewardNotification)
        return object;
      let message = new $root.dnse.MGMGetRewardNotification();
      switch (object.eventType) {
        case "SIGN_UP":
        case 0:
          message.eventType = 0;
          break;
        case "VERIFIED":
        case 1:
          message.eventType = 1;
          break;
        case "ACTIVE":
        case 2:
          message.eventType = 2;
          break;
        case "FIRST_UNDERLYING_TRANSACTION":
        case 3:
          message.eventType = 3;
          break;
        case "FIRST_DERIVATIVE_TRANSACTION":
        case 4:
          message.eventType = 4;
          break;
        case "FIRST_TRANSACTION":
        case 5:
          message.eventType = 5;
          break;
        case "FIRST_MARGIN_TRANSACTION":
        case 6:
          message.eventType = 6;
          break;
      }
      if (object.id != null)
        message.id = String(object.id);
      if (object.triggerId != null)
        message.triggerId = String(object.triggerId);
      if (object.receiverId != null)
        message.receiverId = String(object.receiverId);
      if (object.star != null)
        message.star = Number(object.star);
      if (object.cash != null)
        message.cash = Number(object.cash);
      if (object.referrerName != null)
        message.referrerName = String(object.referrerName);
      if (object.refereeName != null)
        message.refereeName = String(object.refereeName);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.MGMGetRewardNotification.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    MGMGetRewardNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.eventType = options.enums === String ? "SIGN_UP" : 0;
        object.id = "";
        object.triggerId = "";
        object.receiverId = "";
        object.star = 0;
        object.cash = 0;
        object.referrerName = "";
        object.refereeName = "";
        object.time = null;
      }
      if (message.eventType != null && message.hasOwnProperty("eventType"))
        object.eventType = options.enums === String ? $root.dnse.MGMEventType[message.eventType] : message.eventType;
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.triggerId != null && message.hasOwnProperty("triggerId"))
        object.triggerId = message.triggerId;
      if (message.receiverId != null && message.hasOwnProperty("receiverId"))
        object.receiverId = message.receiverId;
      if (message.star != null && message.hasOwnProperty("star"))
        object.star = options.json && !isFinite(message.star) ? String(message.star) : message.star;
      if (message.cash != null && message.hasOwnProperty("cash"))
        object.cash = options.json && !isFinite(message.cash) ? String(message.cash) : message.cash;
      if (message.referrerName != null && message.hasOwnProperty("referrerName"))
        object.referrerName = message.referrerName;
      if (message.refereeName != null && message.hasOwnProperty("refereeName"))
        object.refereeName = message.refereeName;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    MGMGetRewardNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MGMGetRewardNotification;
  }();
  dnse2.FinancingOfferCreated = function() {
    function FinancingOfferCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferCreated.prototype.requestName = "";
    FinancingOfferCreated.prototype.symbol = "";
    FinancingOfferCreated.prototype.numberOfOffers = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferCreated.prototype.investorId = "";
    FinancingOfferCreated.prototype.accountNo = "";
    FinancingOfferCreated.prototype.accountNoDesc = "";
    FinancingOfferCreated.prototype.clearRequestTime = "";
    FinancingOfferCreated.prototype.createdAt = null;
    FinancingOfferCreated.create = function create(properties) {
      return new FinancingOfferCreated(properties);
    };
    FinancingOfferCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(10).string(message.requestName);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(18).string(message.symbol);
      if (message.numberOfOffers != null && Object.hasOwnProperty.call(message, "numberOfOffers"))
        writer.uint32(24).int64(message.numberOfOffers);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(42).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(50).string(message.accountNoDesc);
      if (message.clearRequestTime != null && Object.hasOwnProperty.call(message, "clearRequestTime"))
        writer.uint32(58).string(message.clearRequestTime);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    FinancingOfferCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.requestName = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.numberOfOffers = reader.int64();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.accountNo = reader.string();
            break;
          case 6:
            message.accountNoDesc = reader.string();
            break;
          case 7:
            message.clearRequestTime = reader.string();
            break;
          case 8:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.numberOfOffers != null && message.hasOwnProperty("numberOfOffers")) {
        if (!$util.isInteger(message.numberOfOffers) && !(message.numberOfOffers && $util.isInteger(message.numberOfOffers.low) && $util.isInteger(message.numberOfOffers.high)))
          return "numberOfOffers: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.clearRequestTime != null && message.hasOwnProperty("clearRequestTime")) {
        if (!$util.isString(message.clearRequestTime))
          return "clearRequestTime: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferCreated)
        return object;
      let message = new $root.dnse.FinancingOfferCreated();
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.numberOfOffers != null) {
        if ($util.Long)
          (message.numberOfOffers = $util.Long.fromValue(object.numberOfOffers)).unsigned = false;
        else if (typeof object.numberOfOffers === "string")
          message.numberOfOffers = parseInt(object.numberOfOffers, 10);
        else if (typeof object.numberOfOffers === "number")
          message.numberOfOffers = object.numberOfOffers;
        else if (typeof object.numberOfOffers === "object")
          message.numberOfOffers = new $util.LongBits(object.numberOfOffers.low >>> 0, object.numberOfOffers.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.clearRequestTime != null)
        message.clearRequestTime = String(object.clearRequestTime);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferCreated.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.requestName = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.numberOfOffers = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.numberOfOffers = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.clearRequestTime = "";
        object.createdAt = null;
      }
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.numberOfOffers != null && message.hasOwnProperty("numberOfOffers"))
        if (typeof message.numberOfOffers === "number")
          object.numberOfOffers = options.longs === String ? String(message.numberOfOffers) : message.numberOfOffers;
        else
          object.numberOfOffers = options.longs === String ? $util.Long.prototype.toString.call(message.numberOfOffers) : options.longs === Number ? new $util.LongBits(message.numberOfOffers.low >>> 0, message.numberOfOffers.high >>> 0).toNumber() : message.numberOfOffers;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.clearRequestTime != null && message.hasOwnProperty("clearRequestTime"))
        object.clearRequestTime = message.clearRequestTime;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferCreated;
  }();
  dnse2.FinancingOfferRequestDeclined = function() {
    function FinancingOfferRequestDeclined(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferRequestDeclined.prototype.investorId = "";
    FinancingOfferRequestDeclined.prototype.requestName = "";
    FinancingOfferRequestDeclined.prototype.accountNo = "";
    FinancingOfferRequestDeclined.prototype.accountNoDesc = "";
    FinancingOfferRequestDeclined.prototype.symbol = "";
    FinancingOfferRequestDeclined.prototype.createdAt = null;
    FinancingOfferRequestDeclined.create = function create(properties) {
      return new FinancingOfferRequestDeclined(properties);
    };
    FinancingOfferRequestDeclined.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    FinancingOfferRequestDeclined.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferRequestDeclined.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferRequestDeclined();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferRequestDeclined.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferRequestDeclined.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferRequestDeclined.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferRequestDeclined)
        return object;
      let message = new $root.dnse.FinancingOfferRequestDeclined();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferRequestDeclined.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferRequestDeclined.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.symbol = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferRequestDeclined.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferRequestDeclined;
  }();
  dnse2.FinancingOfferDerivativeRequestDeclined = function() {
    function FinancingOfferDerivativeRequestDeclined(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferDerivativeRequestDeclined.prototype.investorId = "";
    FinancingOfferDerivativeRequestDeclined.prototype.requestName = "";
    FinancingOfferDerivativeRequestDeclined.prototype.accountNo = "";
    FinancingOfferDerivativeRequestDeclined.prototype.accountNoDesc = "";
    FinancingOfferDerivativeRequestDeclined.prototype.symbol = "";
    FinancingOfferDerivativeRequestDeclined.prototype.assetType = "";
    FinancingOfferDerivativeRequestDeclined.prototype.createdAt = null;
    FinancingOfferDerivativeRequestDeclined.create = function create(properties) {
      return new FinancingOfferDerivativeRequestDeclined(properties);
    };
    FinancingOfferDerivativeRequestDeclined.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.assetType != null && Object.hasOwnProperty.call(message, "assetType"))
        writer.uint32(50).string(message.assetType);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    FinancingOfferDerivativeRequestDeclined.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferDerivativeRequestDeclined.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferDerivativeRequestDeclined();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.assetType = reader.string();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferDerivativeRequestDeclined.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferDerivativeRequestDeclined.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.assetType != null && message.hasOwnProperty("assetType")) {
        if (!$util.isString(message.assetType))
          return "assetType: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferDerivativeRequestDeclined.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferDerivativeRequestDeclined)
        return object;
      let message = new $root.dnse.FinancingOfferDerivativeRequestDeclined();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.assetType != null)
        message.assetType = String(object.assetType);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferDerivativeRequestDeclined.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferDerivativeRequestDeclined.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.symbol = "";
        object.assetType = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.assetType != null && message.hasOwnProperty("assetType"))
        object.assetType = message.assetType;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferDerivativeRequestDeclined.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferDerivativeRequestDeclined;
  }();
  dnse2.FinancingOfferOnlineConfirmation = function() {
    function FinancingOfferOnlineConfirmation(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferOnlineConfirmation.prototype.investorId = "";
    FinancingOfferOnlineConfirmation.prototype.requestName = "";
    FinancingOfferOnlineConfirmation.prototype.accountNo = "";
    FinancingOfferOnlineConfirmation.prototype.accountNoDesc = "";
    FinancingOfferOnlineConfirmation.prototype.offerId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferOnlineConfirmation.prototype.offerInterestId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferOnlineConfirmation.prototype.symbol = "";
    FinancingOfferOnlineConfirmation.prototype.createdAt = null;
    FinancingOfferOnlineConfirmation.create = function create(properties) {
      return new FinancingOfferOnlineConfirmation(properties);
    };
    FinancingOfferOnlineConfirmation.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.offerId != null && Object.hasOwnProperty.call(message, "offerId"))
        writer.uint32(40).int64(message.offerId);
      if (message.offerInterestId != null && Object.hasOwnProperty.call(message, "offerInterestId"))
        writer.uint32(48).int64(message.offerInterestId);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(58).string(message.symbol);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    FinancingOfferOnlineConfirmation.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferOnlineConfirmation.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferOnlineConfirmation();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.offerId = reader.int64();
            break;
          case 6:
            message.offerInterestId = reader.int64();
            break;
          case 7:
            message.symbol = reader.string();
            break;
          case 8:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferOnlineConfirmation.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferOnlineConfirmation.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.offerId != null && message.hasOwnProperty("offerId")) {
        if (!$util.isInteger(message.offerId) && !(message.offerId && $util.isInteger(message.offerId.low) && $util.isInteger(message.offerId.high)))
          return "offerId: integer|Long expected";
      }
      if (message.offerInterestId != null && message.hasOwnProperty("offerInterestId")) {
        if (!$util.isInteger(message.offerInterestId) && !(message.offerInterestId && $util.isInteger(message.offerInterestId.low) && $util.isInteger(message.offerInterestId.high)))
          return "offerInterestId: integer|Long expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferOnlineConfirmation.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferOnlineConfirmation)
        return object;
      let message = new $root.dnse.FinancingOfferOnlineConfirmation();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.offerId != null) {
        if ($util.Long)
          (message.offerId = $util.Long.fromValue(object.offerId)).unsigned = false;
        else if (typeof object.offerId === "string")
          message.offerId = parseInt(object.offerId, 10);
        else if (typeof object.offerId === "number")
          message.offerId = object.offerId;
        else if (typeof object.offerId === "object")
          message.offerId = new $util.LongBits(object.offerId.low >>> 0, object.offerId.high >>> 0).toNumber();
      }
      if (object.offerInterestId != null) {
        if ($util.Long)
          (message.offerInterestId = $util.Long.fromValue(object.offerInterestId)).unsigned = false;
        else if (typeof object.offerInterestId === "string")
          message.offerInterestId = parseInt(object.offerInterestId, 10);
        else if (typeof object.offerInterestId === "number")
          message.offerInterestId = object.offerInterestId;
        else if (typeof object.offerInterestId === "object")
          message.offerInterestId = new $util.LongBits(object.offerInterestId.low >>> 0, object.offerInterestId.high >>> 0).toNumber();
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferOnlineConfirmation.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferOnlineConfirmation.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerInterestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerInterestId = options.longs === String ? "0" : 0;
        object.symbol = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.offerId != null && message.hasOwnProperty("offerId"))
        if (typeof message.offerId === "number")
          object.offerId = options.longs === String ? String(message.offerId) : message.offerId;
        else
          object.offerId = options.longs === String ? $util.Long.prototype.toString.call(message.offerId) : options.longs === Number ? new $util.LongBits(message.offerId.low >>> 0, message.offerId.high >>> 0).toNumber() : message.offerId;
      if (message.offerInterestId != null && message.hasOwnProperty("offerInterestId"))
        if (typeof message.offerInterestId === "number")
          object.offerInterestId = options.longs === String ? String(message.offerInterestId) : message.offerInterestId;
        else
          object.offerInterestId = options.longs === String ? $util.Long.prototype.toString.call(message.offerInterestId) : options.longs === Number ? new $util.LongBits(message.offerInterestId.low >>> 0, message.offerInterestId.high >>> 0).toNumber() : message.offerInterestId;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferOnlineConfirmation.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferOnlineConfirmation;
  }();
  dnse2.FinancingOfferOfflineConfirmation = function() {
    function FinancingOfferOfflineConfirmation(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferOfflineConfirmation.prototype.investorId = "";
    FinancingOfferOfflineConfirmation.prototype.requestName = "";
    FinancingOfferOfflineConfirmation.prototype.accountNo = "";
    FinancingOfferOfflineConfirmation.prototype.accountNoDesc = "";
    FinancingOfferOfflineConfirmation.prototype.symbol = "";
    FinancingOfferOfflineConfirmation.prototype.createdAt = null;
    FinancingOfferOfflineConfirmation.create = function create(properties) {
      return new FinancingOfferOfflineConfirmation(properties);
    };
    FinancingOfferOfflineConfirmation.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    FinancingOfferOfflineConfirmation.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferOfflineConfirmation.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferOfflineConfirmation();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferOfflineConfirmation.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferOfflineConfirmation.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferOfflineConfirmation.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferOfflineConfirmation)
        return object;
      let message = new $root.dnse.FinancingOfferOfflineConfirmation();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferOfflineConfirmation.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferOfflineConfirmation.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.symbol = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferOfflineConfirmation.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferOfflineConfirmation;
  }();
  dnse2.FinancingOfferDerivativeOfflineConfirmation = function() {
    function FinancingOfferDerivativeOfflineConfirmation(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferDerivativeOfflineConfirmation.prototype.investorId = "";
    FinancingOfferDerivativeOfflineConfirmation.prototype.requestName = "";
    FinancingOfferDerivativeOfflineConfirmation.prototype.accountNo = "";
    FinancingOfferDerivativeOfflineConfirmation.prototype.accountNoDesc = "";
    FinancingOfferDerivativeOfflineConfirmation.prototype.symbol = "";
    FinancingOfferDerivativeOfflineConfirmation.prototype.assetType = "";
    FinancingOfferDerivativeOfflineConfirmation.prototype.createdAt = null;
    FinancingOfferDerivativeOfflineConfirmation.create = function create(properties) {
      return new FinancingOfferDerivativeOfflineConfirmation(properties);
    };
    FinancingOfferDerivativeOfflineConfirmation.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.assetType != null && Object.hasOwnProperty.call(message, "assetType"))
        writer.uint32(50).string(message.assetType);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    FinancingOfferDerivativeOfflineConfirmation.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferDerivativeOfflineConfirmation.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferDerivativeOfflineConfirmation();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.assetType = reader.string();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferDerivativeOfflineConfirmation.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferDerivativeOfflineConfirmation.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.assetType != null && message.hasOwnProperty("assetType")) {
        if (!$util.isString(message.assetType))
          return "assetType: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferDerivativeOfflineConfirmation.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferDerivativeOfflineConfirmation)
        return object;
      let message = new $root.dnse.FinancingOfferDerivativeOfflineConfirmation();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.assetType != null)
        message.assetType = String(object.assetType);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferDerivativeOfflineConfirmation.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferDerivativeOfflineConfirmation.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.symbol = "";
        object.assetType = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.assetType != null && message.hasOwnProperty("assetType"))
        object.assetType = message.assetType;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferDerivativeOfflineConfirmation.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferDerivativeOfflineConfirmation;
  }();
  dnse2.FinancingOfferLoanPackageReady = function() {
    function FinancingOfferLoanPackageReady(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferLoanPackageReady.prototype.investorId = "";
    FinancingOfferLoanPackageReady.prototype.requestName = "";
    FinancingOfferLoanPackageReady.prototype.accountNo = "";
    FinancingOfferLoanPackageReady.prototype.accountNoDesc = "";
    FinancingOfferLoanPackageReady.prototype.symbol = "";
    FinancingOfferLoanPackageReady.prototype.offerId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferLoanPackageReady.prototype.offerInterestId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferLoanPackageReady.prototype.loanRate = "";
    FinancingOfferLoanPackageReady.prototype.loanType = "";
    FinancingOfferLoanPackageReady.prototype.interestRate = "";
    FinancingOfferLoanPackageReady.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferLoanPackageReady.prototype.createdAt = null;
    FinancingOfferLoanPackageReady.create = function create(properties) {
      return new FinancingOfferLoanPackageReady(properties);
    };
    FinancingOfferLoanPackageReady.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.offerId != null && Object.hasOwnProperty.call(message, "offerId"))
        writer.uint32(48).int64(message.offerId);
      if (message.offerInterestId != null && Object.hasOwnProperty.call(message, "offerInterestId"))
        writer.uint32(56).int64(message.offerInterestId);
      if (message.loanRate != null && Object.hasOwnProperty.call(message, "loanRate"))
        writer.uint32(66).string(message.loanRate);
      if (message.loanType != null && Object.hasOwnProperty.call(message, "loanType"))
        writer.uint32(74).string(message.loanType);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(82).string(message.interestRate);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(88).int64(message.loanPackageId);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(98).fork()).ldelim();
      return writer;
    };
    FinancingOfferLoanPackageReady.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferLoanPackageReady.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferLoanPackageReady();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.offerId = reader.int64();
            break;
          case 7:
            message.offerInterestId = reader.int64();
            break;
          case 8:
            message.loanRate = reader.string();
            break;
          case 9:
            message.loanType = reader.string();
            break;
          case 10:
            message.interestRate = reader.string();
            break;
          case 11:
            message.loanPackageId = reader.int64();
            break;
          case 12:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferLoanPackageReady.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferLoanPackageReady.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.offerId != null && message.hasOwnProperty("offerId")) {
        if (!$util.isInteger(message.offerId) && !(message.offerId && $util.isInteger(message.offerId.low) && $util.isInteger(message.offerId.high)))
          return "offerId: integer|Long expected";
      }
      if (message.offerInterestId != null && message.hasOwnProperty("offerInterestId")) {
        if (!$util.isInteger(message.offerInterestId) && !(message.offerInterestId && $util.isInteger(message.offerInterestId.low) && $util.isInteger(message.offerInterestId.high)))
          return "offerInterestId: integer|Long expected";
      }
      if (message.loanRate != null && message.hasOwnProperty("loanRate")) {
        if (!$util.isString(message.loanRate))
          return "loanRate: string expected";
      }
      if (message.loanType != null && message.hasOwnProperty("loanType")) {
        if (!$util.isString(message.loanType))
          return "loanType: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (!$util.isString(message.interestRate))
          return "interestRate: string expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
          return "loanPackageId: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferLoanPackageReady.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferLoanPackageReady)
        return object;
      let message = new $root.dnse.FinancingOfferLoanPackageReady();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.offerId != null) {
        if ($util.Long)
          (message.offerId = $util.Long.fromValue(object.offerId)).unsigned = false;
        else if (typeof object.offerId === "string")
          message.offerId = parseInt(object.offerId, 10);
        else if (typeof object.offerId === "number")
          message.offerId = object.offerId;
        else if (typeof object.offerId === "object")
          message.offerId = new $util.LongBits(object.offerId.low >>> 0, object.offerId.high >>> 0).toNumber();
      }
      if (object.offerInterestId != null) {
        if ($util.Long)
          (message.offerInterestId = $util.Long.fromValue(object.offerInterestId)).unsigned = false;
        else if (typeof object.offerInterestId === "string")
          message.offerInterestId = parseInt(object.offerInterestId, 10);
        else if (typeof object.offerInterestId === "number")
          message.offerInterestId = object.offerInterestId;
        else if (typeof object.offerInterestId === "object")
          message.offerInterestId = new $util.LongBits(object.offerInterestId.low >>> 0, object.offerInterestId.high >>> 0).toNumber();
      }
      if (object.loanRate != null)
        message.loanRate = String(object.loanRate);
      if (object.loanType != null)
        message.loanType = String(object.loanType);
      if (object.interestRate != null)
        message.interestRate = String(object.interestRate);
      if (object.loanPackageId != null) {
        if ($util.Long)
          (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
        else if (typeof object.loanPackageId === "string")
          message.loanPackageId = parseInt(object.loanPackageId, 10);
        else if (typeof object.loanPackageId === "number")
          message.loanPackageId = object.loanPackageId;
        else if (typeof object.loanPackageId === "object")
          message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferLoanPackageReady.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferLoanPackageReady.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerInterestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerInterestId = options.longs === String ? "0" : 0;
        object.loanRate = "";
        object.loanType = "";
        object.interestRate = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanPackageId = options.longs === String ? "0" : 0;
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.offerId != null && message.hasOwnProperty("offerId"))
        if (typeof message.offerId === "number")
          object.offerId = options.longs === String ? String(message.offerId) : message.offerId;
        else
          object.offerId = options.longs === String ? $util.Long.prototype.toString.call(message.offerId) : options.longs === Number ? new $util.LongBits(message.offerId.low >>> 0, message.offerId.high >>> 0).toNumber() : message.offerId;
      if (message.offerInterestId != null && message.hasOwnProperty("offerInterestId"))
        if (typeof message.offerInterestId === "number")
          object.offerInterestId = options.longs === String ? String(message.offerInterestId) : message.offerInterestId;
        else
          object.offerInterestId = options.longs === String ? $util.Long.prototype.toString.call(message.offerInterestId) : options.longs === Number ? new $util.LongBits(message.offerInterestId.low >>> 0, message.offerInterestId.high >>> 0).toNumber() : message.offerInterestId;
      if (message.loanRate != null && message.hasOwnProperty("loanRate"))
        object.loanRate = message.loanRate;
      if (message.loanType != null && message.hasOwnProperty("loanType"))
        object.loanType = message.loanType;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = message.interestRate;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        if (typeof message.loanPackageId === "number")
          object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
        else
          object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferLoanPackageReady.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferLoanPackageReady;
  }();
  dnse2.FinancingOfferDerivativeLoanPackageReady = function() {
    function FinancingOfferDerivativeLoanPackageReady(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferDerivativeLoanPackageReady.prototype.investorId = "";
    FinancingOfferDerivativeLoanPackageReady.prototype.requestName = "";
    FinancingOfferDerivativeLoanPackageReady.prototype.accountNo = "";
    FinancingOfferDerivativeLoanPackageReady.prototype.accountNoDesc = "";
    FinancingOfferDerivativeLoanPackageReady.prototype.symbol = "";
    FinancingOfferDerivativeLoanPackageReady.prototype.offerId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferDerivativeLoanPackageReady.prototype.offerInterestId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferDerivativeLoanPackageReady.prototype.loanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferDerivativeLoanPackageReady.prototype.assetType = "";
    FinancingOfferDerivativeLoanPackageReady.prototype.createdAt = null;
    FinancingOfferDerivativeLoanPackageReady.create = function create(properties) {
      return new FinancingOfferDerivativeLoanPackageReady(properties);
    };
    FinancingOfferDerivativeLoanPackageReady.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.requestName != null && Object.hasOwnProperty.call(message, "requestName"))
        writer.uint32(18).string(message.requestName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(34).string(message.accountNoDesc);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(42).string(message.symbol);
      if (message.offerId != null && Object.hasOwnProperty.call(message, "offerId"))
        writer.uint32(48).int64(message.offerId);
      if (message.offerInterestId != null && Object.hasOwnProperty.call(message, "offerInterestId"))
        writer.uint32(56).int64(message.offerInterestId);
      if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
        writer.uint32(64).int64(message.loanPackageId);
      if (message.assetType != null && Object.hasOwnProperty.call(message, "assetType"))
        writer.uint32(74).string(message.assetType);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(82).fork()).ldelim();
      return writer;
    };
    FinancingOfferDerivativeLoanPackageReady.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferDerivativeLoanPackageReady.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferDerivativeLoanPackageReady();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.requestName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.accountNoDesc = reader.string();
            break;
          case 5:
            message.symbol = reader.string();
            break;
          case 6:
            message.offerId = reader.int64();
            break;
          case 7:
            message.offerInterestId = reader.int64();
            break;
          case 8:
            message.loanPackageId = reader.int64();
            break;
          case 9:
            message.assetType = reader.string();
            break;
          case 10:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferDerivativeLoanPackageReady.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferDerivativeLoanPackageReady.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.requestName != null && message.hasOwnProperty("requestName")) {
        if (!$util.isString(message.requestName))
          return "requestName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.offerId != null && message.hasOwnProperty("offerId")) {
        if (!$util.isInteger(message.offerId) && !(message.offerId && $util.isInteger(message.offerId.low) && $util.isInteger(message.offerId.high)))
          return "offerId: integer|Long expected";
      }
      if (message.offerInterestId != null && message.hasOwnProperty("offerInterestId")) {
        if (!$util.isInteger(message.offerInterestId) && !(message.offerInterestId && $util.isInteger(message.offerInterestId.low) && $util.isInteger(message.offerInterestId.high)))
          return "offerInterestId: integer|Long expected";
      }
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
        if (!$util.isInteger(message.loanPackageId) && !(message.loanPackageId && $util.isInteger(message.loanPackageId.low) && $util.isInteger(message.loanPackageId.high)))
          return "loanPackageId: integer|Long expected";
      }
      if (message.assetType != null && message.hasOwnProperty("assetType")) {
        if (!$util.isString(message.assetType))
          return "assetType: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferDerivativeLoanPackageReady.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferDerivativeLoanPackageReady)
        return object;
      let message = new $root.dnse.FinancingOfferDerivativeLoanPackageReady();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.requestName != null)
        message.requestName = String(object.requestName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.offerId != null) {
        if ($util.Long)
          (message.offerId = $util.Long.fromValue(object.offerId)).unsigned = false;
        else if (typeof object.offerId === "string")
          message.offerId = parseInt(object.offerId, 10);
        else if (typeof object.offerId === "number")
          message.offerId = object.offerId;
        else if (typeof object.offerId === "object")
          message.offerId = new $util.LongBits(object.offerId.low >>> 0, object.offerId.high >>> 0).toNumber();
      }
      if (object.offerInterestId != null) {
        if ($util.Long)
          (message.offerInterestId = $util.Long.fromValue(object.offerInterestId)).unsigned = false;
        else if (typeof object.offerInterestId === "string")
          message.offerInterestId = parseInt(object.offerInterestId, 10);
        else if (typeof object.offerInterestId === "number")
          message.offerInterestId = object.offerInterestId;
        else if (typeof object.offerInterestId === "object")
          message.offerInterestId = new $util.LongBits(object.offerInterestId.low >>> 0, object.offerInterestId.high >>> 0).toNumber();
      }
      if (object.loanPackageId != null) {
        if ($util.Long)
          (message.loanPackageId = $util.Long.fromValue(object.loanPackageId)).unsigned = false;
        else if (typeof object.loanPackageId === "string")
          message.loanPackageId = parseInt(object.loanPackageId, 10);
        else if (typeof object.loanPackageId === "number")
          message.loanPackageId = object.loanPackageId;
        else if (typeof object.loanPackageId === "object")
          message.loanPackageId = new $util.LongBits(object.loanPackageId.low >>> 0, object.loanPackageId.high >>> 0).toNumber();
      }
      if (object.assetType != null)
        message.assetType = String(object.assetType);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferDerivativeLoanPackageReady.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferDerivativeLoanPackageReady.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.requestName = "";
        object.accountNo = "";
        object.accountNoDesc = "";
        object.symbol = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.offerInterestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.offerInterestId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanPackageId = options.longs === String ? "0" : 0;
        object.assetType = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.requestName != null && message.hasOwnProperty("requestName"))
        object.requestName = message.requestName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.offerId != null && message.hasOwnProperty("offerId"))
        if (typeof message.offerId === "number")
          object.offerId = options.longs === String ? String(message.offerId) : message.offerId;
        else
          object.offerId = options.longs === String ? $util.Long.prototype.toString.call(message.offerId) : options.longs === Number ? new $util.LongBits(message.offerId.low >>> 0, message.offerId.high >>> 0).toNumber() : message.offerId;
      if (message.offerInterestId != null && message.hasOwnProperty("offerInterestId"))
        if (typeof message.offerInterestId === "number")
          object.offerInterestId = options.longs === String ? String(message.offerInterestId) : message.offerInterestId;
        else
          object.offerInterestId = options.longs === String ? $util.Long.prototype.toString.call(message.offerInterestId) : options.longs === Number ? new $util.LongBits(message.offerInterestId.low >>> 0, message.offerInterestId.high >>> 0).toNumber() : message.offerInterestId;
      if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
        if (typeof message.loanPackageId === "number")
          object.loanPackageId = options.longs === String ? String(message.loanPackageId) : message.loanPackageId;
        else
          object.loanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.loanPackageId) : options.longs === Number ? new $util.LongBits(message.loanPackageId.low >>> 0, message.loanPackageId.high >>> 0).toNumber() : message.loanPackageId;
      if (message.assetType != null && message.hasOwnProperty("assetType"))
        object.assetType = message.assetType;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferDerivativeLoanPackageReady.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferDerivativeLoanPackageReady;
  }();
  dnse2.FinancingOfferSuggestedOfferCreated = function() {
    function FinancingOfferSuggestedOfferCreated(properties) {
      this.symbols = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferSuggestedOfferCreated.prototype.investorId = "";
    FinancingOfferSuggestedOfferCreated.prototype.title = "";
    FinancingOfferSuggestedOfferCreated.prototype.accountNo = "";
    FinancingOfferSuggestedOfferCreated.prototype.symbols = $util.emptyArray;
    FinancingOfferSuggestedOfferCreated.prototype.createdAt = null;
    FinancingOfferSuggestedOfferCreated.create = function create(properties) {
      return new FinancingOfferSuggestedOfferCreated(properties);
    };
    FinancingOfferSuggestedOfferCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.title != null && Object.hasOwnProperty.call(message, "title"))
        writer.uint32(18).string(message.title);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.symbols != null && message.symbols.length)
        for (let i = 0; i < message.symbols.length; ++i)
          writer.uint32(34).string(message.symbols[i]);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(42).fork()).ldelim();
      return writer;
    };
    FinancingOfferSuggestedOfferCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferSuggestedOfferCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferSuggestedOfferCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.title = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            if (!(message.symbols && message.symbols.length))
              message.symbols = [];
            message.symbols.push(reader.string());
            break;
          case 5:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferSuggestedOfferCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferSuggestedOfferCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.title != null && message.hasOwnProperty("title")) {
        if (!$util.isString(message.title))
          return "title: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.symbols != null && message.hasOwnProperty("symbols")) {
        if (!Array.isArray(message.symbols))
          return "symbols: array expected";
        for (let i = 0; i < message.symbols.length; ++i)
          if (!$util.isString(message.symbols[i]))
            return "symbols: string[] expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferSuggestedOfferCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferSuggestedOfferCreated)
        return object;
      let message = new $root.dnse.FinancingOfferSuggestedOfferCreated();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.title != null)
        message.title = String(object.title);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.symbols) {
        if (!Array.isArray(object.symbols))
          throw TypeError(".dnse.FinancingOfferSuggestedOfferCreated.symbols: array expected");
        message.symbols = [];
        for (let i = 0; i < object.symbols.length; ++i)
          message.symbols[i] = String(object.symbols[i]);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferSuggestedOfferCreated.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferSuggestedOfferCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.symbols = [];
      if (options.defaults) {
        object.investorId = "";
        object.title = "";
        object.accountNo = "";
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.title != null && message.hasOwnProperty("title"))
        object.title = message.title;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.symbols && message.symbols.length) {
        object.symbols = [];
        for (let j = 0; j < message.symbols.length; ++j)
          object.symbols[j] = message.symbols[j];
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferSuggestedOfferCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferSuggestedOfferCreated;
  }();
  dnse2.FinancingOfferLoanPackageRequest = function() {
    function FinancingOfferLoanPackageRequest(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingOfferLoanPackageRequest.prototype.investorId = "";
    FinancingOfferLoanPackageRequest.prototype.custodyCode = "";
    FinancingOfferLoanPackageRequest.prototype.accountNo = "";
    FinancingOfferLoanPackageRequest.prototype.loanRate = 0;
    FinancingOfferLoanPackageRequest.prototype.type = "";
    FinancingOfferLoanPackageRequest.prototype.limitAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FinancingOfferLoanPackageRequest.prototype.symbol = "";
    FinancingOfferLoanPackageRequest.prototype.guaranteedDuration = 0;
    FinancingOfferLoanPackageRequest.prototype.createdAt = null;
    FinancingOfferLoanPackageRequest.create = function create(properties) {
      return new FinancingOfferLoanPackageRequest(properties);
    };
    FinancingOfferLoanPackageRequest.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.loanRate != null && Object.hasOwnProperty.call(message, "loanRate"))
        writer.uint32(33).double(message.loanRate);
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(42).string(message.type);
      if (message.limitAmount != null && Object.hasOwnProperty.call(message, "limitAmount"))
        writer.uint32(48).int64(message.limitAmount);
      if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
        writer.uint32(58).string(message.symbol);
      if (message.guaranteedDuration != null && Object.hasOwnProperty.call(message, "guaranteedDuration"))
        writer.uint32(64).int32(message.guaranteedDuration);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(74).fork()).ldelim();
      return writer;
    };
    FinancingOfferLoanPackageRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingOfferLoanPackageRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingOfferLoanPackageRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.loanRate = reader.double();
            break;
          case 5:
            message.type = reader.string();
            break;
          case 6:
            message.limitAmount = reader.int64();
            break;
          case 7:
            message.symbol = reader.string();
            break;
          case 8:
            message.guaranteedDuration = reader.int32();
            break;
          case 9:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingOfferLoanPackageRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingOfferLoanPackageRequest.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanRate != null && message.hasOwnProperty("loanRate")) {
        if (typeof message.loanRate !== "number")
          return "loanRate: number expected";
      }
      if (message.type != null && message.hasOwnProperty("type")) {
        if (!$util.isString(message.type))
          return "type: string expected";
      }
      if (message.limitAmount != null && message.hasOwnProperty("limitAmount")) {
        if (!$util.isInteger(message.limitAmount) && !(message.limitAmount && $util.isInteger(message.limitAmount.low) && $util.isInteger(message.limitAmount.high)))
          return "limitAmount: integer|Long expected";
      }
      if (message.symbol != null && message.hasOwnProperty("symbol")) {
        if (!$util.isString(message.symbol))
          return "symbol: string expected";
      }
      if (message.guaranteedDuration != null && message.hasOwnProperty("guaranteedDuration")) {
        if (!$util.isInteger(message.guaranteedDuration))
          return "guaranteedDuration: integer expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    FinancingOfferLoanPackageRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingOfferLoanPackageRequest)
        return object;
      let message = new $root.dnse.FinancingOfferLoanPackageRequest();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanRate != null)
        message.loanRate = Number(object.loanRate);
      if (object.type != null)
        message.type = String(object.type);
      if (object.limitAmount != null) {
        if ($util.Long)
          (message.limitAmount = $util.Long.fromValue(object.limitAmount)).unsigned = false;
        else if (typeof object.limitAmount === "string")
          message.limitAmount = parseInt(object.limitAmount, 10);
        else if (typeof object.limitAmount === "number")
          message.limitAmount = object.limitAmount;
        else if (typeof object.limitAmount === "object")
          message.limitAmount = new $util.LongBits(object.limitAmount.low >>> 0, object.limitAmount.high >>> 0).toNumber();
      }
      if (object.symbol != null)
        message.symbol = String(object.symbol);
      if (object.guaranteedDuration != null)
        message.guaranteedDuration = object.guaranteedDuration | 0;
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.FinancingOfferLoanPackageRequest.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    FinancingOfferLoanPackageRequest.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.accountNo = "";
        object.loanRate = 0;
        object.type = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.limitAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.limitAmount = options.longs === String ? "0" : 0;
        object.symbol = "";
        object.guaranteedDuration = 0;
        object.createdAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanRate != null && message.hasOwnProperty("loanRate"))
        object.loanRate = options.json && !isFinite(message.loanRate) ? String(message.loanRate) : message.loanRate;
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = message.type;
      if (message.limitAmount != null && message.hasOwnProperty("limitAmount"))
        if (typeof message.limitAmount === "number")
          object.limitAmount = options.longs === String ? String(message.limitAmount) : message.limitAmount;
        else
          object.limitAmount = options.longs === String ? $util.Long.prototype.toString.call(message.limitAmount) : options.longs === Number ? new $util.LongBits(message.limitAmount.low >>> 0, message.limitAmount.high >>> 0).toNumber() : message.limitAmount;
      if (message.symbol != null && message.hasOwnProperty("symbol"))
        object.symbol = message.symbol;
      if (message.guaranteedDuration != null && message.hasOwnProperty("guaranteedDuration"))
        object.guaranteedDuration = message.guaranteedDuration;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    FinancingOfferLoanPackageRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingOfferLoanPackageRequest;
  }();
  dnse2.EntradeLoanPackageCreated = function() {
    function EntradeLoanPackageCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanPackageCreated.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanPackageCreated.prototype.periodDesc = "";
    EntradeLoanPackageCreated.prototype.interestRate = 0;
    EntradeLoanPackageCreated.prototype.investorId = "";
    EntradeLoanPackageCreated.prototype.savingsAccountId = "";
    EntradeLoanPackageCreated.prototype.createdDate = null;
    EntradeLoanPackageCreated.create = function create(properties) {
      return new EntradeLoanPackageCreated(properties);
    };
    EntradeLoanPackageCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(8).uint64(message.amount);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(18).string(message.periodDesc);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(25).double(message.interestRate);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(42).string(message.savingsAccountId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    EntradeLoanPackageCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanPackageCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanPackageCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.amount = reader.uint64();
            break;
          case 2:
            message.periodDesc = reader.string();
            break;
          case 3:
            message.interestRate = reader.double();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.savingsAccountId = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanPackageCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanPackageCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isString(message.savingsAccountId))
          return "savingsAccountId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    EntradeLoanPackageCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanPackageCreated)
        return object;
      let message = new $root.dnse.EntradeLoanPackageCreated();
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.savingsAccountId != null)
        message.savingsAccountId = String(object.savingsAccountId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.EntradeLoanPackageCreated.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    EntradeLoanPackageCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.periodDesc = "";
        object.interestRate = 0;
        object.investorId = "";
        object.savingsAccountId = "";
        object.createdDate = null;
      }
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    EntradeLoanPackageCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanPackageCreated;
  }();
  dnse2.EntradeLoanPackageSettlement = function() {
    function EntradeLoanPackageSettlement(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanPackageSettlement.prototype.savingsAccountId = "";
    EntradeLoanPackageSettlement.prototype.receivedAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanPackageSettlement.prototype.bankName = "";
    EntradeLoanPackageSettlement.prototype.bankAccountNumber = "";
    EntradeLoanPackageSettlement.prototype.beneficiary = "";
    EntradeLoanPackageSettlement.prototype.investorId = "";
    EntradeLoanPackageSettlement.prototype.createdDate = null;
    EntradeLoanPackageSettlement.create = function create(properties) {
      return new EntradeLoanPackageSettlement(properties);
    };
    EntradeLoanPackageSettlement.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(10).string(message.savingsAccountId);
      if (message.receivedAmount != null && Object.hasOwnProperty.call(message, "receivedAmount"))
        writer.uint32(16).uint64(message.receivedAmount);
      if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
        writer.uint32(26).string(message.bankName);
      if (message.bankAccountNumber != null && Object.hasOwnProperty.call(message, "bankAccountNumber"))
        writer.uint32(34).string(message.bankAccountNumber);
      if (message.beneficiary != null && Object.hasOwnProperty.call(message, "beneficiary"))
        writer.uint32(42).string(message.beneficiary);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EntradeLoanPackageSettlement.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanPackageSettlement.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanPackageSettlement();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.savingsAccountId = reader.string();
            break;
          case 2:
            message.receivedAmount = reader.uint64();
            break;
          case 3:
            message.bankName = reader.string();
            break;
          case 4:
            message.bankAccountNumber = reader.string();
            break;
          case 5:
            message.beneficiary = reader.string();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanPackageSettlement.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanPackageSettlement.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isString(message.savingsAccountId))
          return "savingsAccountId: string expected";
      }
      if (message.receivedAmount != null && message.hasOwnProperty("receivedAmount")) {
        if (!$util.isInteger(message.receivedAmount) && !(message.receivedAmount && $util.isInteger(message.receivedAmount.low) && $util.isInteger(message.receivedAmount.high)))
          return "receivedAmount: integer|Long expected";
      }
      if (message.bankName != null && message.hasOwnProperty("bankName")) {
        if (!$util.isString(message.bankName))
          return "bankName: string expected";
      }
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber")) {
        if (!$util.isString(message.bankAccountNumber))
          return "bankAccountNumber: string expected";
      }
      if (message.beneficiary != null && message.hasOwnProperty("beneficiary")) {
        if (!$util.isString(message.beneficiary))
          return "beneficiary: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    EntradeLoanPackageSettlement.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanPackageSettlement)
        return object;
      let message = new $root.dnse.EntradeLoanPackageSettlement();
      if (object.savingsAccountId != null)
        message.savingsAccountId = String(object.savingsAccountId);
      if (object.receivedAmount != null) {
        if ($util.Long)
          (message.receivedAmount = $util.Long.fromValue(object.receivedAmount)).unsigned = true;
        else if (typeof object.receivedAmount === "string")
          message.receivedAmount = parseInt(object.receivedAmount, 10);
        else if (typeof object.receivedAmount === "number")
          message.receivedAmount = object.receivedAmount;
        else if (typeof object.receivedAmount === "object")
          message.receivedAmount = new $util.LongBits(object.receivedAmount.low >>> 0, object.receivedAmount.high >>> 0).toNumber(true);
      }
      if (object.bankName != null)
        message.bankName = String(object.bankName);
      if (object.bankAccountNumber != null)
        message.bankAccountNumber = String(object.bankAccountNumber);
      if (object.beneficiary != null)
        message.beneficiary = String(object.beneficiary);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.EntradeLoanPackageSettlement.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    EntradeLoanPackageSettlement.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.savingsAccountId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.receivedAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivedAmount = options.longs === String ? "0" : 0;
        object.bankName = "";
        object.bankAccountNumber = "";
        object.beneficiary = "";
        object.investorId = "";
        object.createdDate = null;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.receivedAmount != null && message.hasOwnProperty("receivedAmount"))
        if (typeof message.receivedAmount === "number")
          object.receivedAmount = options.longs === String ? String(message.receivedAmount) : message.receivedAmount;
        else
          object.receivedAmount = options.longs === String ? $util.Long.prototype.toString.call(message.receivedAmount) : options.longs === Number ? new $util.LongBits(message.receivedAmount.low >>> 0, message.receivedAmount.high >>> 0).toNumber(true) : message.receivedAmount;
      if (message.bankName != null && message.hasOwnProperty("bankName"))
        object.bankName = message.bankName;
      if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber"))
        object.bankAccountNumber = message.bankAccountNumber;
      if (message.beneficiary != null && message.hasOwnProperty("beneficiary"))
        object.beneficiary = message.beneficiary;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    EntradeLoanPackageSettlement.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanPackageSettlement;
  }();
  dnse2.EntradeLoanPackageWithdrawal = function() {
    function EntradeLoanPackageWithdrawal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanPackageWithdrawal.prototype.accountNoDesc = "";
    EntradeLoanPackageWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanPackageWithdrawal.prototype.balance = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanPackageWithdrawal.prototype.createdDate = null;
    EntradeLoanPackageWithdrawal.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanPackageWithdrawal.prototype.investorId = "";
    EntradeLoanPackageWithdrawal.create = function create(properties) {
      return new EntradeLoanPackageWithdrawal(properties);
    };
    EntradeLoanPackageWithdrawal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
        writer.uint32(24).uint64(message.balance);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(40).uint64(message.savingsAccountId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      return writer;
    };
    EntradeLoanPackageWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanPackageWithdrawal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanPackageWithdrawal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.balance = reader.uint64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.savingsAccountId = reader.uint64();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanPackageWithdrawal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanPackageWithdrawal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.balance != null && message.hasOwnProperty("balance")) {
        if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
          return "balance: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    EntradeLoanPackageWithdrawal.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanPackageWithdrawal)
        return object;
      let message = new $root.dnse.EntradeLoanPackageWithdrawal();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.balance != null) {
        if ($util.Long)
          (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
        else if (typeof object.balance === "string")
          message.balance = parseInt(object.balance, 10);
        else if (typeof object.balance === "number")
          message.balance = object.balance;
        else if (typeof object.balance === "object")
          message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.EntradeLoanPackageWithdrawal.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    EntradeLoanPackageWithdrawal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.balance = options.longs === String ? "0" : 0;
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        object.investorId = "";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.balance != null && message.hasOwnProperty("balance"))
        if (typeof message.balance === "number")
          object.balance = options.longs === String ? String(message.balance) : message.balance;
        else
          object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    EntradeLoanPackageWithdrawal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanPackageWithdrawal;
  }();
  dnse2.EntradeLoanContractSigned = function() {
    function EntradeLoanContractSigned(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanContractSigned.prototype.investorId = "";
    EntradeLoanContractSigned.prototype.contractSignedAt = null;
    EntradeLoanContractSigned.create = function create(properties) {
      return new EntradeLoanContractSigned(properties);
    };
    EntradeLoanContractSigned.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.contractSignedAt != null && Object.hasOwnProperty.call(message, "contractSignedAt"))
        $root.google.protobuf.Timestamp.encode(message.contractSignedAt, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    EntradeLoanContractSigned.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanContractSigned.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanContractSigned();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.contractSignedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanContractSigned.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanContractSigned.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.contractSignedAt);
        if (error)
          return "contractSignedAt." + error;
      }
      return null;
    };
    EntradeLoanContractSigned.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanContractSigned)
        return object;
      let message = new $root.dnse.EntradeLoanContractSigned();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.contractSignedAt != null) {
        if (typeof object.contractSignedAt !== "object")
          throw TypeError(".dnse.EntradeLoanContractSigned.contractSignedAt: object expected");
        message.contractSignedAt = $root.google.protobuf.Timestamp.fromObject(object.contractSignedAt);
      }
      return message;
    };
    EntradeLoanContractSigned.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.contractSignedAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt"))
        object.contractSignedAt = $root.google.protobuf.Timestamp.toObject(message.contractSignedAt, options);
      return object;
    };
    EntradeLoanContractSigned.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanContractSigned;
  }();
  dnse2.EntradeLoanMaturityAlert = function() {
    function EntradeLoanMaturityAlert(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanMaturityAlert.prototype.investorId = "";
    EntradeLoanMaturityAlert.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanMaturityAlert.prototype.maturityDate = "";
    EntradeLoanMaturityAlert.prototype.interestRate = 0;
    EntradeLoanMaturityAlert.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanMaturityAlert.prototype.periodDesc = "";
    EntradeLoanMaturityAlert.prototype.createdDate = null;
    EntradeLoanMaturityAlert.create = function create(properties) {
      return new EntradeLoanMaturityAlert(properties);
    };
    EntradeLoanMaturityAlert.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        writer.uint32(26).string(message.maturityDate);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(33).double(message.interestRate);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(40).uint64(message.savingsAccountId);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(50).string(message.periodDesc);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EntradeLoanMaturityAlert.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanMaturityAlert.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanMaturityAlert();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.maturityDate = reader.string();
            break;
          case 4:
            message.interestRate = reader.double();
            break;
          case 5:
            message.savingsAccountId = reader.uint64();
            break;
          case 6:
            message.periodDesc = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanMaturityAlert.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanMaturityAlert.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        if (!$util.isString(message.maturityDate))
          return "maturityDate: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    EntradeLoanMaturityAlert.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanMaturityAlert)
        return object;
      let message = new $root.dnse.EntradeLoanMaturityAlert();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.maturityDate != null)
        message.maturityDate = String(object.maturityDate);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.EntradeLoanMaturityAlert.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    EntradeLoanMaturityAlert.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.maturityDate = "";
        object.interestRate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        object.periodDesc = "";
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = message.maturityDate;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    EntradeLoanMaturityAlert.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanMaturityAlert;
  }();
  dnse2.EntradeLoanInvestorActivated = function() {
    function EntradeLoanInvestorActivated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanInvestorActivated.prototype.investorId = "";
    EntradeLoanInvestorActivated.prototype.interestRate = 0;
    EntradeLoanInvestorActivated.create = function create(properties) {
      return new EntradeLoanInvestorActivated(properties);
    };
    EntradeLoanInvestorActivated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(17).double(message.interestRate);
      return writer;
    };
    EntradeLoanInvestorActivated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanInvestorActivated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanInvestorActivated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.interestRate = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanInvestorActivated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanInvestorActivated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      return null;
    };
    EntradeLoanInvestorActivated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanInvestorActivated)
        return object;
      let message = new $root.dnse.EntradeLoanInvestorActivated();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      return message;
    };
    EntradeLoanInvestorActivated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.interestRate = 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      return object;
    };
    EntradeLoanInvestorActivated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanInvestorActivated;
  }();
  dnse2.EntradeLoanInvestorAccountDeposit = function() {
    function EntradeLoanInvestorAccountDeposit(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanInvestorAccountDeposit.prototype.investorId = "";
    EntradeLoanInvestorAccountDeposit.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanInvestorAccountDeposit.create = function create(properties) {
      return new EntradeLoanInvestorAccountDeposit(properties);
    };
    EntradeLoanInvestorAccountDeposit.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      return writer;
    };
    EntradeLoanInvestorAccountDeposit.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanInvestorAccountDeposit.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanInvestorAccountDeposit();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanInvestorAccountDeposit.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanInvestorAccountDeposit.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      return null;
    };
    EntradeLoanInvestorAccountDeposit.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanInvestorAccountDeposit)
        return object;
      let message = new $root.dnse.EntradeLoanInvestorAccountDeposit();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      return message;
    };
    EntradeLoanInvestorAccountDeposit.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      return object;
    };
    EntradeLoanInvestorAccountDeposit.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanInvestorAccountDeposit;
  }();
  dnse2.EntradeLoanInvestorAccountWithdrawal = function() {
    function EntradeLoanInvestorAccountWithdrawal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EntradeLoanInvestorAccountWithdrawal.prototype.investorId = "";
    EntradeLoanInvestorAccountWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    EntradeLoanInvestorAccountWithdrawal.create = function create(properties) {
      return new EntradeLoanInvestorAccountWithdrawal(properties);
    };
    EntradeLoanInvestorAccountWithdrawal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      return writer;
    };
    EntradeLoanInvestorAccountWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EntradeLoanInvestorAccountWithdrawal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EntradeLoanInvestorAccountWithdrawal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EntradeLoanInvestorAccountWithdrawal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EntradeLoanInvestorAccountWithdrawal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      return null;
    };
    EntradeLoanInvestorAccountWithdrawal.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EntradeLoanInvestorAccountWithdrawal)
        return object;
      let message = new $root.dnse.EntradeLoanInvestorAccountWithdrawal();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      return message;
    };
    EntradeLoanInvestorAccountWithdrawal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      return object;
    };
    EntradeLoanInvestorAccountWithdrawal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EntradeLoanInvestorAccountWithdrawal;
  }();
  dnse2.cross_order = function() {
    const cross_order = {};
    cross_order.v1 = function() {
      const v1 = {};
      v1.CrossOrderApprovalRequirement = function() {
        function CrossOrderApprovalRequirement(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CrossOrderApprovalRequirement.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CrossOrderApprovalRequirement.prototype.crossOrderId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CrossOrderApprovalRequirement.prototype.symbol = "";
        CrossOrderApprovalRequirement.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CrossOrderApprovalRequirement.prototype.price = 0;
        CrossOrderApprovalRequirement.prototype.sellCustodyCode = "";
        CrossOrderApprovalRequirement.prototype.sellAccountNo = "";
        CrossOrderApprovalRequirement.prototype.sellFirmId = "";
        CrossOrderApprovalRequirement.prototype.sellTraderId = "";
        CrossOrderApprovalRequirement.prototype.buyCustodyCode = "";
        CrossOrderApprovalRequirement.prototype.buyAccountNo = "";
        CrossOrderApprovalRequirement.prototype.buyFirmId = "";
        CrossOrderApprovalRequirement.prototype.buyTraderId = "";
        CrossOrderApprovalRequirement.prototype.buyLoanPackageId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CrossOrderApprovalRequirement.prototype.status = 0;
        CrossOrderApprovalRequirement.prototype.maker = "";
        CrossOrderApprovalRequirement.prototype.makerName = "";
        CrossOrderApprovalRequirement.prototype.channel = "";
        CrossOrderApprovalRequirement.prototype.tradingDate = null;
        CrossOrderApprovalRequirement.prototype.createdDate = null;
        CrossOrderApprovalRequirement.prototype.modifiedDate = null;
        CrossOrderApprovalRequirement.create = function create(properties) {
          return new CrossOrderApprovalRequirement(properties);
        };
        CrossOrderApprovalRequirement.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
          if (message.crossOrderId != null && Object.hasOwnProperty.call(message, "crossOrderId"))
            writer.uint32(16).int64(message.crossOrderId);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(26).string(message.symbol);
          if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(32).int64(message.quantity);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(41).double(message.price);
          if (message.sellCustodyCode != null && Object.hasOwnProperty.call(message, "sellCustodyCode"))
            writer.uint32(50).string(message.sellCustodyCode);
          if (message.sellAccountNo != null && Object.hasOwnProperty.call(message, "sellAccountNo"))
            writer.uint32(58).string(message.sellAccountNo);
          if (message.sellFirmId != null && Object.hasOwnProperty.call(message, "sellFirmId"))
            writer.uint32(66).string(message.sellFirmId);
          if (message.sellTraderId != null && Object.hasOwnProperty.call(message, "sellTraderId"))
            writer.uint32(74).string(message.sellTraderId);
          if (message.buyCustodyCode != null && Object.hasOwnProperty.call(message, "buyCustodyCode"))
            writer.uint32(82).string(message.buyCustodyCode);
          if (message.buyAccountNo != null && Object.hasOwnProperty.call(message, "buyAccountNo"))
            writer.uint32(90).string(message.buyAccountNo);
          if (message.buyFirmId != null && Object.hasOwnProperty.call(message, "buyFirmId"))
            writer.uint32(98).string(message.buyFirmId);
          if (message.buyTraderId != null && Object.hasOwnProperty.call(message, "buyTraderId"))
            writer.uint32(106).string(message.buyTraderId);
          if (message.buyLoanPackageId != null && Object.hasOwnProperty.call(message, "buyLoanPackageId"))
            writer.uint32(112).int64(message.buyLoanPackageId);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(120).int32(message.status);
          if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
            writer.uint32(130).string(message.maker);
          if (message.makerName != null && Object.hasOwnProperty.call(message, "makerName"))
            writer.uint32(138).string(message.makerName);
          if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(146).string(message.channel);
          if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
            $root.google.protobuf.Timestamp.encode(message.tradingDate, writer.uint32(154).fork()).ldelim();
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(162).fork()).ldelim();
          if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
            $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(170).fork()).ldelim();
          return writer;
        };
        CrossOrderApprovalRequirement.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CrossOrderApprovalRequirement.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.cross_order.v1.CrossOrderApprovalRequirement();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int64();
                break;
              case 2:
                message.crossOrderId = reader.int64();
                break;
              case 3:
                message.symbol = reader.string();
                break;
              case 4:
                message.quantity = reader.int64();
                break;
              case 5:
                message.price = reader.double();
                break;
              case 6:
                message.sellCustodyCode = reader.string();
                break;
              case 7:
                message.sellAccountNo = reader.string();
                break;
              case 8:
                message.sellFirmId = reader.string();
                break;
              case 9:
                message.sellTraderId = reader.string();
                break;
              case 10:
                message.buyCustodyCode = reader.string();
                break;
              case 11:
                message.buyAccountNo = reader.string();
                break;
              case 12:
                message.buyFirmId = reader.string();
                break;
              case 13:
                message.buyTraderId = reader.string();
                break;
              case 14:
                message.buyLoanPackageId = reader.int64();
                break;
              case 15:
                message.status = reader.int32();
                break;
              case 16:
                message.maker = reader.string();
                break;
              case 17:
                message.makerName = reader.string();
                break;
              case 18:
                message.channel = reader.string();
                break;
              case 19:
                message.tradingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 20:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 21:
                message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CrossOrderApprovalRequirement.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CrossOrderApprovalRequirement.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
              return "id: integer|Long expected";
          }
          if (message.crossOrderId != null && message.hasOwnProperty("crossOrderId")) {
            if (!$util.isInteger(message.crossOrderId) && !(message.crossOrderId && $util.isInteger(message.crossOrderId.low) && $util.isInteger(message.crossOrderId.high)))
              return "crossOrderId: integer|Long expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.quantity != null && message.hasOwnProperty("quantity")) {
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
              return "quantity: integer|Long expected";
          }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.sellCustodyCode != null && message.hasOwnProperty("sellCustodyCode")) {
            if (!$util.isString(message.sellCustodyCode))
              return "sellCustodyCode: string expected";
          }
          if (message.sellAccountNo != null && message.hasOwnProperty("sellAccountNo")) {
            if (!$util.isString(message.sellAccountNo))
              return "sellAccountNo: string expected";
          }
          if (message.sellFirmId != null && message.hasOwnProperty("sellFirmId")) {
            if (!$util.isString(message.sellFirmId))
              return "sellFirmId: string expected";
          }
          if (message.sellTraderId != null && message.hasOwnProperty("sellTraderId")) {
            if (!$util.isString(message.sellTraderId))
              return "sellTraderId: string expected";
          }
          if (message.buyCustodyCode != null && message.hasOwnProperty("buyCustodyCode")) {
            if (!$util.isString(message.buyCustodyCode))
              return "buyCustodyCode: string expected";
          }
          if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo")) {
            if (!$util.isString(message.buyAccountNo))
              return "buyAccountNo: string expected";
          }
          if (message.buyFirmId != null && message.hasOwnProperty("buyFirmId")) {
            if (!$util.isString(message.buyFirmId))
              return "buyFirmId: string expected";
          }
          if (message.buyTraderId != null && message.hasOwnProperty("buyTraderId")) {
            if (!$util.isString(message.buyTraderId))
              return "buyTraderId: string expected";
          }
          if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId")) {
            if (!$util.isInteger(message.buyLoanPackageId) && !(message.buyLoanPackageId && $util.isInteger(message.buyLoanPackageId.low) && $util.isInteger(message.buyLoanPackageId.high)))
              return "buyLoanPackageId: integer|Long expected";
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 6:
                break;
            }
          if (message.maker != null && message.hasOwnProperty("maker")) {
            if (!$util.isString(message.maker))
              return "maker: string expected";
          }
          if (message.makerName != null && message.hasOwnProperty("makerName")) {
            if (!$util.isString(message.makerName))
              return "makerName: string expected";
          }
          if (message.channel != null && message.hasOwnProperty("channel")) {
            if (!$util.isString(message.channel))
              return "channel: string expected";
          }
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.tradingDate);
            if (error)
              return "tradingDate." + error;
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
            if (error)
              return "modifiedDate." + error;
          }
          return null;
        };
        CrossOrderApprovalRequirement.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.cross_order.v1.CrossOrderApprovalRequirement)
            return object;
          let message = new $root.dnse.cross_order.v1.CrossOrderApprovalRequirement();
          if (object.id != null) {
            if ($util.Long)
              (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
              message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
              message.id = object.id;
            else if (typeof object.id === "object")
              message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
          }
          if (object.crossOrderId != null) {
            if ($util.Long)
              (message.crossOrderId = $util.Long.fromValue(object.crossOrderId)).unsigned = false;
            else if (typeof object.crossOrderId === "string")
              message.crossOrderId = parseInt(object.crossOrderId, 10);
            else if (typeof object.crossOrderId === "number")
              message.crossOrderId = object.crossOrderId;
            else if (typeof object.crossOrderId === "object")
              message.crossOrderId = new $util.LongBits(object.crossOrderId.low >>> 0, object.crossOrderId.high >>> 0).toNumber();
          }
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.quantity != null) {
            if ($util.Long)
              (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
              message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
              message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
              message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
          }
          if (object.price != null)
            message.price = Number(object.price);
          if (object.sellCustodyCode != null)
            message.sellCustodyCode = String(object.sellCustodyCode);
          if (object.sellAccountNo != null)
            message.sellAccountNo = String(object.sellAccountNo);
          if (object.sellFirmId != null)
            message.sellFirmId = String(object.sellFirmId);
          if (object.sellTraderId != null)
            message.sellTraderId = String(object.sellTraderId);
          if (object.buyCustodyCode != null)
            message.buyCustodyCode = String(object.buyCustodyCode);
          if (object.buyAccountNo != null)
            message.buyAccountNo = String(object.buyAccountNo);
          if (object.buyFirmId != null)
            message.buyFirmId = String(object.buyFirmId);
          if (object.buyTraderId != null)
            message.buyTraderId = String(object.buyTraderId);
          if (object.buyLoanPackageId != null) {
            if ($util.Long)
              (message.buyLoanPackageId = $util.Long.fromValue(object.buyLoanPackageId)).unsigned = false;
            else if (typeof object.buyLoanPackageId === "string")
              message.buyLoanPackageId = parseInt(object.buyLoanPackageId, 10);
            else if (typeof object.buyLoanPackageId === "number")
              message.buyLoanPackageId = object.buyLoanPackageId;
            else if (typeof object.buyLoanPackageId === "object")
              message.buyLoanPackageId = new $util.LongBits(object.buyLoanPackageId.low >>> 0, object.buyLoanPackageId.high >>> 0).toNumber();
          }
          switch (object.status) {
            case "UNKNOWN":
            case 0:
              message.status = 0;
              break;
            case "WAITING_TO_CONFIRM":
            case 1:
              message.status = 1;
              break;
            case "FILLED":
            case 2:
              message.status = 2;
              break;
            case "REJECTED":
            case 3:
              message.status = 3;
              break;
            case "CANCELLED":
            case 4:
              message.status = 4;
              break;
            case "PENDING":
            case 6:
              message.status = 6;
              break;
          }
          if (object.maker != null)
            message.maker = String(object.maker);
          if (object.makerName != null)
            message.makerName = String(object.makerName);
          if (object.channel != null)
            message.channel = String(object.channel);
          if (object.tradingDate != null) {
            if (typeof object.tradingDate !== "object")
              throw TypeError(".dnse.cross_order.v1.CrossOrderApprovalRequirement.tradingDate: object expected");
            message.tradingDate = $root.google.protobuf.Timestamp.fromObject(object.tradingDate);
          }
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.cross_order.v1.CrossOrderApprovalRequirement.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.modifiedDate != null) {
            if (typeof object.modifiedDate !== "object")
              throw TypeError(".dnse.cross_order.v1.CrossOrderApprovalRequirement.modifiedDate: object expected");
            message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
          }
          return message;
        };
        CrossOrderApprovalRequirement.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.id = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.crossOrderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.crossOrderId = options.longs === String ? "0" : 0;
            object.symbol = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.quantity = options.longs === String ? "0" : 0;
            object.price = 0;
            object.sellCustodyCode = "";
            object.sellAccountNo = "";
            object.sellFirmId = "";
            object.sellTraderId = "";
            object.buyCustodyCode = "";
            object.buyAccountNo = "";
            object.buyFirmId = "";
            object.buyTraderId = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.buyLoanPackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.buyLoanPackageId = options.longs === String ? "0" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.maker = "";
            object.makerName = "";
            object.channel = "";
            object.tradingDate = null;
            object.createdDate = null;
            object.modifiedDate = null;
          }
          if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
              object.id = options.longs === String ? String(message.id) : message.id;
            else
              object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
          if (message.crossOrderId != null && message.hasOwnProperty("crossOrderId"))
            if (typeof message.crossOrderId === "number")
              object.crossOrderId = options.longs === String ? String(message.crossOrderId) : message.crossOrderId;
            else
              object.crossOrderId = options.longs === String ? $util.Long.prototype.toString.call(message.crossOrderId) : options.longs === Number ? new $util.LongBits(message.crossOrderId.low >>> 0, message.crossOrderId.high >>> 0).toNumber() : message.crossOrderId;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
              object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
              object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.sellCustodyCode != null && message.hasOwnProperty("sellCustodyCode"))
            object.sellCustodyCode = message.sellCustodyCode;
          if (message.sellAccountNo != null && message.hasOwnProperty("sellAccountNo"))
            object.sellAccountNo = message.sellAccountNo;
          if (message.sellFirmId != null && message.hasOwnProperty("sellFirmId"))
            object.sellFirmId = message.sellFirmId;
          if (message.sellTraderId != null && message.hasOwnProperty("sellTraderId"))
            object.sellTraderId = message.sellTraderId;
          if (message.buyCustodyCode != null && message.hasOwnProperty("buyCustodyCode"))
            object.buyCustodyCode = message.buyCustodyCode;
          if (message.buyAccountNo != null && message.hasOwnProperty("buyAccountNo"))
            object.buyAccountNo = message.buyAccountNo;
          if (message.buyFirmId != null && message.hasOwnProperty("buyFirmId"))
            object.buyFirmId = message.buyFirmId;
          if (message.buyTraderId != null && message.hasOwnProperty("buyTraderId"))
            object.buyTraderId = message.buyTraderId;
          if (message.buyLoanPackageId != null && message.hasOwnProperty("buyLoanPackageId"))
            if (typeof message.buyLoanPackageId === "number")
              object.buyLoanPackageId = options.longs === String ? String(message.buyLoanPackageId) : message.buyLoanPackageId;
            else
              object.buyLoanPackageId = options.longs === String ? $util.Long.prototype.toString.call(message.buyLoanPackageId) : options.longs === Number ? new $util.LongBits(message.buyLoanPackageId.low >>> 0, message.buyLoanPackageId.high >>> 0).toNumber() : message.buyLoanPackageId;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.cross_order.v1.CrossOrderApprovalRequirementStatus[message.status] : message.status;
          if (message.maker != null && message.hasOwnProperty("maker"))
            object.maker = message.maker;
          if (message.makerName != null && message.hasOwnProperty("makerName"))
            object.makerName = message.makerName;
          if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
            object.tradingDate = $root.google.protobuf.Timestamp.toObject(message.tradingDate, options);
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
            object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
          return object;
        };
        CrossOrderApprovalRequirement.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return CrossOrderApprovalRequirement;
      }();
      v1.CrossOrderApprovalRequirementStatus = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "WAITING_TO_CONFIRM"] = 1;
        values[valuesById[2] = "FILLED"] = 2;
        values[valuesById[3] = "REJECTED"] = 3;
        values[valuesById[4] = "CANCELLED"] = 4;
        values[valuesById[6] = "PENDING"] = 6;
        return values;
      }();
      return v1;
    }();
    return cross_order;
  }();
  dnse2.group_order = function() {
    const group_order = {};
    group_order.v1 = function() {
      const v1 = {};
      v1.TradingGroupOrder = function() {
        function TradingGroupOrder(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        TradingGroupOrder.prototype.groupOrder = null;
        TradingGroupOrder.prototype.subOrder = null;
        TradingGroupOrder.prototype.groupOrderPlan = null;
        let $oneOfFields;
        Object.defineProperty(TradingGroupOrder.prototype, "kind", {
          get: $util.oneOfGetter($oneOfFields = ["groupOrder", "subOrder", "groupOrderPlan"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        TradingGroupOrder.create = function create(properties) {
          return new TradingGroupOrder(properties);
        };
        TradingGroupOrder.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.groupOrder != null && Object.hasOwnProperty.call(message, "groupOrder"))
            $root.dnse.group_order.v1.GroupOrder.encode(message.groupOrder, writer.uint32(10).fork()).ldelim();
          if (message.subOrder != null && Object.hasOwnProperty.call(message, "subOrder"))
            $root.dnse.group_order.v1.SubOrder.encode(message.subOrder, writer.uint32(18).fork()).ldelim();
          if (message.groupOrderPlan != null && Object.hasOwnProperty.call(message, "groupOrderPlan"))
            $root.dnse.group_order.v1.GroupOrderPlan.encode(message.groupOrderPlan, writer.uint32(26).fork()).ldelim();
          return writer;
        };
        TradingGroupOrder.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        TradingGroupOrder.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.group_order.v1.TradingGroupOrder();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.groupOrder = $root.dnse.group_order.v1.GroupOrder.decode(reader, reader.uint32());
                break;
              case 2:
                message.subOrder = $root.dnse.group_order.v1.SubOrder.decode(reader, reader.uint32());
                break;
              case 3:
                message.groupOrderPlan = $root.dnse.group_order.v1.GroupOrderPlan.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        TradingGroupOrder.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        TradingGroupOrder.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          let properties = {};
          if (message.groupOrder != null && message.hasOwnProperty("groupOrder")) {
            properties.kind = 1;
            {
              let error = $root.dnse.group_order.v1.GroupOrder.verify(message.groupOrder);
              if (error)
                return "groupOrder." + error;
            }
          }
          if (message.subOrder != null && message.hasOwnProperty("subOrder")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.group_order.v1.SubOrder.verify(message.subOrder);
              if (error)
                return "subOrder." + error;
            }
          }
          if (message.groupOrderPlan != null && message.hasOwnProperty("groupOrderPlan")) {
            if (properties.kind === 1)
              return "kind: multiple values";
            properties.kind = 1;
            {
              let error = $root.dnse.group_order.v1.GroupOrderPlan.verify(message.groupOrderPlan);
              if (error)
                return "groupOrderPlan." + error;
            }
          }
          return null;
        };
        TradingGroupOrder.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.group_order.v1.TradingGroupOrder)
            return object;
          let message = new $root.dnse.group_order.v1.TradingGroupOrder();
          if (object.groupOrder != null) {
            if (typeof object.groupOrder !== "object")
              throw TypeError(".dnse.group_order.v1.TradingGroupOrder.groupOrder: object expected");
            message.groupOrder = $root.dnse.group_order.v1.GroupOrder.fromObject(object.groupOrder);
          }
          if (object.subOrder != null) {
            if (typeof object.subOrder !== "object")
              throw TypeError(".dnse.group_order.v1.TradingGroupOrder.subOrder: object expected");
            message.subOrder = $root.dnse.group_order.v1.SubOrder.fromObject(object.subOrder);
          }
          if (object.groupOrderPlan != null) {
            if (typeof object.groupOrderPlan !== "object")
              throw TypeError(".dnse.group_order.v1.TradingGroupOrder.groupOrderPlan: object expected");
            message.groupOrderPlan = $root.dnse.group_order.v1.GroupOrderPlan.fromObject(object.groupOrderPlan);
          }
          return message;
        };
        TradingGroupOrder.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (message.groupOrder != null && message.hasOwnProperty("groupOrder")) {
            object.groupOrder = $root.dnse.group_order.v1.GroupOrder.toObject(message.groupOrder, options);
            if (options.oneofs)
              object.kind = "groupOrder";
          }
          if (message.subOrder != null && message.hasOwnProperty("subOrder")) {
            object.subOrder = $root.dnse.group_order.v1.SubOrder.toObject(message.subOrder, options);
            if (options.oneofs)
              object.kind = "subOrder";
          }
          if (message.groupOrderPlan != null && message.hasOwnProperty("groupOrderPlan")) {
            object.groupOrderPlan = $root.dnse.group_order.v1.GroupOrderPlan.toObject(message.groupOrderPlan, options);
            if (options.oneofs)
              object.kind = "groupOrderPlan";
          }
          return object;
        };
        TradingGroupOrder.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return TradingGroupOrder;
      }();
      v1.SubOrder = function() {
        function SubOrder(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        SubOrder.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.orderId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.side = "";
        SubOrder.prototype.accountNo = "";
        SubOrder.prototype.investorId = "";
        SubOrder.prototype.symbol = "";
        SubOrder.prototype.price = 0;
        SubOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.orderType = "";
        SubOrder.prototype.status = "";
        SubOrder.prototype.filledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.lastQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.lastPrice = 0;
        SubOrder.prototype.averagePrice = 0;
        SubOrder.prototype.tradingDate = "";
        SubOrder.prototype.createdDate = "";
        SubOrder.prototype.updatedDate = "";
        SubOrder.prototype.taxRate = 0;
        SubOrder.prototype.exchangeFeeRate = 0;
        SubOrder.prototype.feeRate = 0;
        SubOrder.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.canceledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.externalId = "";
        SubOrder.prototype.priceSecure = 0;
        SubOrder.prototype.custodyCode = "";
        SubOrder.prototype.execType = "";
        SubOrder.prototype.maker = "";
        SubOrder.prototype.channel = "";
        SubOrder.prototype.metadata = "";
        SubOrder.prototype.loanPackageId = 0;
        SubOrder.prototype.initialRate = 0;
        SubOrder.prototype.execId = "";
        SubOrder.prototype.groupOrderId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.accountGroupId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.prototype.accountGroupOrderPlanId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SubOrder.create = function create(properties) {
          return new SubOrder(properties);
        };
        SubOrder.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
          if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
            writer.uint32(16).int64(message.orderId);
          if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(26).string(message.side);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(34).string(message.accountNo);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(42).string(message.investorId);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(50).string(message.symbol);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(57).double(message.price);
          if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(64).int64(message.quantity);
          if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
            writer.uint32(74).string(message.orderType);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(82).string(message.status);
          if (message.filledQuantity != null && Object.hasOwnProperty.call(message, "filledQuantity"))
            writer.uint32(88).int64(message.filledQuantity);
          if (message.lastQuantity != null && Object.hasOwnProperty.call(message, "lastQuantity"))
            writer.uint32(96).int64(message.lastQuantity);
          if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
            writer.uint32(105).double(message.lastPrice);
          if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
            writer.uint32(113).double(message.averagePrice);
          if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
            writer.uint32(122).string(message.tradingDate);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            writer.uint32(130).string(message.createdDate);
          if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
            writer.uint32(138).string(message.updatedDate);
          if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
            writer.uint32(145).double(message.taxRate);
          if (message.exchangeFeeRate != null && Object.hasOwnProperty.call(message, "exchangeFeeRate"))
            writer.uint32(153).double(message.exchangeFeeRate);
          if (message.feeRate != null && Object.hasOwnProperty.call(message, "feeRate"))
            writer.uint32(161).double(message.feeRate);
          if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
            writer.uint32(168).int64(message.leaveQuantity);
          if (message.canceledQuantity != null && Object.hasOwnProperty.call(message, "canceledQuantity"))
            writer.uint32(176).int64(message.canceledQuantity);
          if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
            writer.uint32(186).string(message.externalId);
          if (message.priceSecure != null && Object.hasOwnProperty.call(message, "priceSecure"))
            writer.uint32(193).double(message.priceSecure);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(202).string(message.custodyCode);
          if (message.execType != null && Object.hasOwnProperty.call(message, "execType"))
            writer.uint32(210).string(message.execType);
          if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
            writer.uint32(218).string(message.maker);
          if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(226).string(message.channel);
          if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
            writer.uint32(234).string(message.metadata);
          if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
            writer.uint32(240).int32(message.loanPackageId);
          if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
            writer.uint32(249).double(message.initialRate);
          if (message.execId != null && Object.hasOwnProperty.call(message, "execId"))
            writer.uint32(258).string(message.execId);
          if (message.groupOrderId != null && Object.hasOwnProperty.call(message, "groupOrderId"))
            writer.uint32(264).int64(message.groupOrderId);
          if (message.accountGroupId != null && Object.hasOwnProperty.call(message, "accountGroupId"))
            writer.uint32(272).int64(message.accountGroupId);
          if (message.accountGroupOrderPlanId != null && Object.hasOwnProperty.call(message, "accountGroupOrderPlanId"))
            writer.uint32(280).int64(message.accountGroupOrderPlanId);
          return writer;
        };
        SubOrder.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        SubOrder.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.group_order.v1.SubOrder();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int64();
                break;
              case 2:
                message.orderId = reader.int64();
                break;
              case 3:
                message.side = reader.string();
                break;
              case 4:
                message.accountNo = reader.string();
                break;
              case 5:
                message.investorId = reader.string();
                break;
              case 6:
                message.symbol = reader.string();
                break;
              case 7:
                message.price = reader.double();
                break;
              case 8:
                message.quantity = reader.int64();
                break;
              case 9:
                message.orderType = reader.string();
                break;
              case 10:
                message.status = reader.string();
                break;
              case 11:
                message.filledQuantity = reader.int64();
                break;
              case 12:
                message.lastQuantity = reader.int64();
                break;
              case 13:
                message.lastPrice = reader.double();
                break;
              case 14:
                message.averagePrice = reader.double();
                break;
              case 15:
                message.tradingDate = reader.string();
                break;
              case 16:
                message.createdDate = reader.string();
                break;
              case 17:
                message.updatedDate = reader.string();
                break;
              case 18:
                message.taxRate = reader.double();
                break;
              case 19:
                message.exchangeFeeRate = reader.double();
                break;
              case 20:
                message.feeRate = reader.double();
                break;
              case 21:
                message.leaveQuantity = reader.int64();
                break;
              case 22:
                message.canceledQuantity = reader.int64();
                break;
              case 23:
                message.externalId = reader.string();
                break;
              case 24:
                message.priceSecure = reader.double();
                break;
              case 25:
                message.custodyCode = reader.string();
                break;
              case 26:
                message.execType = reader.string();
                break;
              case 27:
                message.maker = reader.string();
                break;
              case 28:
                message.channel = reader.string();
                break;
              case 29:
                message.metadata = reader.string();
                break;
              case 30:
                message.loanPackageId = reader.int32();
                break;
              case 31:
                message.initialRate = reader.double();
                break;
              case 32:
                message.execId = reader.string();
                break;
              case 33:
                message.groupOrderId = reader.int64();
                break;
              case 34:
                message.accountGroupId = reader.int64();
                break;
              case 35:
                message.accountGroupOrderPlanId = reader.int64();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        SubOrder.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        SubOrder.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
              return "id: integer|Long expected";
          }
          if (message.orderId != null && message.hasOwnProperty("orderId")) {
            if (!$util.isInteger(message.orderId) && !(message.orderId && $util.isInteger(message.orderId.low) && $util.isInteger(message.orderId.high)))
              return "orderId: integer|Long expected";
          }
          if (message.side != null && message.hasOwnProperty("side")) {
            if (!$util.isString(message.side))
              return "side: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.quantity != null && message.hasOwnProperty("quantity")) {
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
              return "quantity: integer|Long expected";
          }
          if (message.orderType != null && message.hasOwnProperty("orderType")) {
            if (!$util.isString(message.orderType))
              return "orderType: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isString(message.status))
              return "status: string expected";
          }
          if (message.filledQuantity != null && message.hasOwnProperty("filledQuantity")) {
            if (!$util.isInteger(message.filledQuantity) && !(message.filledQuantity && $util.isInteger(message.filledQuantity.low) && $util.isInteger(message.filledQuantity.high)))
              return "filledQuantity: integer|Long expected";
          }
          if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity")) {
            if (!$util.isInteger(message.lastQuantity) && !(message.lastQuantity && $util.isInteger(message.lastQuantity.low) && $util.isInteger(message.lastQuantity.high)))
              return "lastQuantity: integer|Long expected";
          }
          if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
            if (typeof message.lastPrice !== "number")
              return "lastPrice: number expected";
          }
          if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
            if (typeof message.averagePrice !== "number")
              return "averagePrice: number expected";
          }
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
            if (!$util.isString(message.tradingDate))
              return "tradingDate: string expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            if (!$util.isString(message.createdDate))
              return "createdDate: string expected";
          }
          if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
            if (!$util.isString(message.updatedDate))
              return "updatedDate: string expected";
          }
          if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
            if (typeof message.taxRate !== "number")
              return "taxRate: number expected";
          }
          if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate")) {
            if (typeof message.exchangeFeeRate !== "number")
              return "exchangeFeeRate: number expected";
          }
          if (message.feeRate != null && message.hasOwnProperty("feeRate")) {
            if (typeof message.feeRate !== "number")
              return "feeRate: number expected";
          }
          if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
            if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
              return "leaveQuantity: integer|Long expected";
          }
          if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity")) {
            if (!$util.isInteger(message.canceledQuantity) && !(message.canceledQuantity && $util.isInteger(message.canceledQuantity.low) && $util.isInteger(message.canceledQuantity.high)))
              return "canceledQuantity: integer|Long expected";
          }
          if (message.externalId != null && message.hasOwnProperty("externalId")) {
            if (!$util.isString(message.externalId))
              return "externalId: string expected";
          }
          if (message.priceSecure != null && message.hasOwnProperty("priceSecure")) {
            if (typeof message.priceSecure !== "number")
              return "priceSecure: number expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.execType != null && message.hasOwnProperty("execType")) {
            if (!$util.isString(message.execType))
              return "execType: string expected";
          }
          if (message.maker != null && message.hasOwnProperty("maker")) {
            if (!$util.isString(message.maker))
              return "maker: string expected";
          }
          if (message.channel != null && message.hasOwnProperty("channel")) {
            if (!$util.isString(message.channel))
              return "channel: string expected";
          }
          if (message.metadata != null && message.hasOwnProperty("metadata")) {
            if (!$util.isString(message.metadata))
              return "metadata: string expected";
          }
          if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
            if (!$util.isInteger(message.loanPackageId))
              return "loanPackageId: integer expected";
          }
          if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
            if (typeof message.initialRate !== "number")
              return "initialRate: number expected";
          }
          if (message.execId != null && message.hasOwnProperty("execId")) {
            if (!$util.isString(message.execId))
              return "execId: string expected";
          }
          if (message.groupOrderId != null && message.hasOwnProperty("groupOrderId")) {
            if (!$util.isInteger(message.groupOrderId) && !(message.groupOrderId && $util.isInteger(message.groupOrderId.low) && $util.isInteger(message.groupOrderId.high)))
              return "groupOrderId: integer|Long expected";
          }
          if (message.accountGroupId != null && message.hasOwnProperty("accountGroupId")) {
            if (!$util.isInteger(message.accountGroupId) && !(message.accountGroupId && $util.isInteger(message.accountGroupId.low) && $util.isInteger(message.accountGroupId.high)))
              return "accountGroupId: integer|Long expected";
          }
          if (message.accountGroupOrderPlanId != null && message.hasOwnProperty("accountGroupOrderPlanId")) {
            if (!$util.isInteger(message.accountGroupOrderPlanId) && !(message.accountGroupOrderPlanId && $util.isInteger(message.accountGroupOrderPlanId.low) && $util.isInteger(message.accountGroupOrderPlanId.high)))
              return "accountGroupOrderPlanId: integer|Long expected";
          }
          return null;
        };
        SubOrder.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.group_order.v1.SubOrder)
            return object;
          let message = new $root.dnse.group_order.v1.SubOrder();
          if (object.id != null) {
            if ($util.Long)
              (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
              message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
              message.id = object.id;
            else if (typeof object.id === "object")
              message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
          }
          if (object.orderId != null) {
            if ($util.Long)
              (message.orderId = $util.Long.fromValue(object.orderId)).unsigned = false;
            else if (typeof object.orderId === "string")
              message.orderId = parseInt(object.orderId, 10);
            else if (typeof object.orderId === "number")
              message.orderId = object.orderId;
            else if (typeof object.orderId === "object")
              message.orderId = new $util.LongBits(object.orderId.low >>> 0, object.orderId.high >>> 0).toNumber();
          }
          if (object.side != null)
            message.side = String(object.side);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.price != null)
            message.price = Number(object.price);
          if (object.quantity != null) {
            if ($util.Long)
              (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
              message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
              message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
              message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
          }
          if (object.orderType != null)
            message.orderType = String(object.orderType);
          if (object.status != null)
            message.status = String(object.status);
          if (object.filledQuantity != null) {
            if ($util.Long)
              (message.filledQuantity = $util.Long.fromValue(object.filledQuantity)).unsigned = false;
            else if (typeof object.filledQuantity === "string")
              message.filledQuantity = parseInt(object.filledQuantity, 10);
            else if (typeof object.filledQuantity === "number")
              message.filledQuantity = object.filledQuantity;
            else if (typeof object.filledQuantity === "object")
              message.filledQuantity = new $util.LongBits(object.filledQuantity.low >>> 0, object.filledQuantity.high >>> 0).toNumber();
          }
          if (object.lastQuantity != null) {
            if ($util.Long)
              (message.lastQuantity = $util.Long.fromValue(object.lastQuantity)).unsigned = false;
            else if (typeof object.lastQuantity === "string")
              message.lastQuantity = parseInt(object.lastQuantity, 10);
            else if (typeof object.lastQuantity === "number")
              message.lastQuantity = object.lastQuantity;
            else if (typeof object.lastQuantity === "object")
              message.lastQuantity = new $util.LongBits(object.lastQuantity.low >>> 0, object.lastQuantity.high >>> 0).toNumber();
          }
          if (object.lastPrice != null)
            message.lastPrice = Number(object.lastPrice);
          if (object.averagePrice != null)
            message.averagePrice = Number(object.averagePrice);
          if (object.tradingDate != null)
            message.tradingDate = String(object.tradingDate);
          if (object.createdDate != null)
            message.createdDate = String(object.createdDate);
          if (object.updatedDate != null)
            message.updatedDate = String(object.updatedDate);
          if (object.taxRate != null)
            message.taxRate = Number(object.taxRate);
          if (object.exchangeFeeRate != null)
            message.exchangeFeeRate = Number(object.exchangeFeeRate);
          if (object.feeRate != null)
            message.feeRate = Number(object.feeRate);
          if (object.leaveQuantity != null) {
            if ($util.Long)
              (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
            else if (typeof object.leaveQuantity === "string")
              message.leaveQuantity = parseInt(object.leaveQuantity, 10);
            else if (typeof object.leaveQuantity === "number")
              message.leaveQuantity = object.leaveQuantity;
            else if (typeof object.leaveQuantity === "object")
              message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
          }
          if (object.canceledQuantity != null) {
            if ($util.Long)
              (message.canceledQuantity = $util.Long.fromValue(object.canceledQuantity)).unsigned = false;
            else if (typeof object.canceledQuantity === "string")
              message.canceledQuantity = parseInt(object.canceledQuantity, 10);
            else if (typeof object.canceledQuantity === "number")
              message.canceledQuantity = object.canceledQuantity;
            else if (typeof object.canceledQuantity === "object")
              message.canceledQuantity = new $util.LongBits(object.canceledQuantity.low >>> 0, object.canceledQuantity.high >>> 0).toNumber();
          }
          if (object.externalId != null)
            message.externalId = String(object.externalId);
          if (object.priceSecure != null)
            message.priceSecure = Number(object.priceSecure);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.execType != null)
            message.execType = String(object.execType);
          if (object.maker != null)
            message.maker = String(object.maker);
          if (object.channel != null)
            message.channel = String(object.channel);
          if (object.metadata != null)
            message.metadata = String(object.metadata);
          if (object.loanPackageId != null)
            message.loanPackageId = object.loanPackageId | 0;
          if (object.initialRate != null)
            message.initialRate = Number(object.initialRate);
          if (object.execId != null)
            message.execId = String(object.execId);
          if (object.groupOrderId != null) {
            if ($util.Long)
              (message.groupOrderId = $util.Long.fromValue(object.groupOrderId)).unsigned = false;
            else if (typeof object.groupOrderId === "string")
              message.groupOrderId = parseInt(object.groupOrderId, 10);
            else if (typeof object.groupOrderId === "number")
              message.groupOrderId = object.groupOrderId;
            else if (typeof object.groupOrderId === "object")
              message.groupOrderId = new $util.LongBits(object.groupOrderId.low >>> 0, object.groupOrderId.high >>> 0).toNumber();
          }
          if (object.accountGroupId != null) {
            if ($util.Long)
              (message.accountGroupId = $util.Long.fromValue(object.accountGroupId)).unsigned = false;
            else if (typeof object.accountGroupId === "string")
              message.accountGroupId = parseInt(object.accountGroupId, 10);
            else if (typeof object.accountGroupId === "number")
              message.accountGroupId = object.accountGroupId;
            else if (typeof object.accountGroupId === "object")
              message.accountGroupId = new $util.LongBits(object.accountGroupId.low >>> 0, object.accountGroupId.high >>> 0).toNumber();
          }
          if (object.accountGroupOrderPlanId != null) {
            if ($util.Long)
              (message.accountGroupOrderPlanId = $util.Long.fromValue(object.accountGroupOrderPlanId)).unsigned = false;
            else if (typeof object.accountGroupOrderPlanId === "string")
              message.accountGroupOrderPlanId = parseInt(object.accountGroupOrderPlanId, 10);
            else if (typeof object.accountGroupOrderPlanId === "number")
              message.accountGroupOrderPlanId = object.accountGroupOrderPlanId;
            else if (typeof object.accountGroupOrderPlanId === "object")
              message.accountGroupOrderPlanId = new $util.LongBits(object.accountGroupOrderPlanId.low >>> 0, object.accountGroupOrderPlanId.high >>> 0).toNumber();
          }
          return message;
        };
        SubOrder.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.id = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.orderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.orderId = options.longs === String ? "0" : 0;
            object.side = "";
            object.accountNo = "";
            object.investorId = "";
            object.symbol = "";
            object.price = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.quantity = options.longs === String ? "0" : 0;
            object.orderType = "";
            object.status = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.filledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.filledQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.lastQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.lastQuantity = options.longs === String ? "0" : 0;
            object.lastPrice = 0;
            object.averagePrice = 0;
            object.tradingDate = "";
            object.createdDate = "";
            object.updatedDate = "";
            object.taxRate = 0;
            object.exchangeFeeRate = 0;
            object.feeRate = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.leaveQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.canceledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.canceledQuantity = options.longs === String ? "0" : 0;
            object.externalId = "";
            object.priceSecure = 0;
            object.custodyCode = "";
            object.execType = "";
            object.maker = "";
            object.channel = "";
            object.metadata = "";
            object.loanPackageId = 0;
            object.initialRate = 0;
            object.execId = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.groupOrderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.groupOrderId = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.accountGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.accountGroupId = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.accountGroupOrderPlanId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.accountGroupOrderPlanId = options.longs === String ? "0" : 0;
          }
          if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
              object.id = options.longs === String ? String(message.id) : message.id;
            else
              object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
          if (message.orderId != null && message.hasOwnProperty("orderId"))
            if (typeof message.orderId === "number")
              object.orderId = options.longs === String ? String(message.orderId) : message.orderId;
            else
              object.orderId = options.longs === String ? $util.Long.prototype.toString.call(message.orderId) : options.longs === Number ? new $util.LongBits(message.orderId.low >>> 0, message.orderId.high >>> 0).toNumber() : message.orderId;
          if (message.side != null && message.hasOwnProperty("side"))
            object.side = message.side;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
              object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
              object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
          if (message.orderType != null && message.hasOwnProperty("orderType"))
            object.orderType = message.orderType;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          if (message.filledQuantity != null && message.hasOwnProperty("filledQuantity"))
            if (typeof message.filledQuantity === "number")
              object.filledQuantity = options.longs === String ? String(message.filledQuantity) : message.filledQuantity;
            else
              object.filledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.filledQuantity) : options.longs === Number ? new $util.LongBits(message.filledQuantity.low >>> 0, message.filledQuantity.high >>> 0).toNumber() : message.filledQuantity;
          if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity"))
            if (typeof message.lastQuantity === "number")
              object.lastQuantity = options.longs === String ? String(message.lastQuantity) : message.lastQuantity;
            else
              object.lastQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.lastQuantity) : options.longs === Number ? new $util.LongBits(message.lastQuantity.low >>> 0, message.lastQuantity.high >>> 0).toNumber() : message.lastQuantity;
          if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
            object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
          if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
            object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
            object.tradingDate = message.tradingDate;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = message.createdDate;
          if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
            object.updatedDate = message.updatedDate;
          if (message.taxRate != null && message.hasOwnProperty("taxRate"))
            object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
          if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate"))
            object.exchangeFeeRate = options.json && !isFinite(message.exchangeFeeRate) ? String(message.exchangeFeeRate) : message.exchangeFeeRate;
          if (message.feeRate != null && message.hasOwnProperty("feeRate"))
            object.feeRate = options.json && !isFinite(message.feeRate) ? String(message.feeRate) : message.feeRate;
          if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
            if (typeof message.leaveQuantity === "number")
              object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
            else
              object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
          if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity"))
            if (typeof message.canceledQuantity === "number")
              object.canceledQuantity = options.longs === String ? String(message.canceledQuantity) : message.canceledQuantity;
            else
              object.canceledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.canceledQuantity) : options.longs === Number ? new $util.LongBits(message.canceledQuantity.low >>> 0, message.canceledQuantity.high >>> 0).toNumber() : message.canceledQuantity;
          if (message.externalId != null && message.hasOwnProperty("externalId"))
            object.externalId = message.externalId;
          if (message.priceSecure != null && message.hasOwnProperty("priceSecure"))
            object.priceSecure = options.json && !isFinite(message.priceSecure) ? String(message.priceSecure) : message.priceSecure;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.execType != null && message.hasOwnProperty("execType"))
            object.execType = message.execType;
          if (message.maker != null && message.hasOwnProperty("maker"))
            object.maker = message.maker;
          if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
          if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = message.metadata;
          if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
            object.loanPackageId = message.loanPackageId;
          if (message.initialRate != null && message.hasOwnProperty("initialRate"))
            object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
          if (message.execId != null && message.hasOwnProperty("execId"))
            object.execId = message.execId;
          if (message.groupOrderId != null && message.hasOwnProperty("groupOrderId"))
            if (typeof message.groupOrderId === "number")
              object.groupOrderId = options.longs === String ? String(message.groupOrderId) : message.groupOrderId;
            else
              object.groupOrderId = options.longs === String ? $util.Long.prototype.toString.call(message.groupOrderId) : options.longs === Number ? new $util.LongBits(message.groupOrderId.low >>> 0, message.groupOrderId.high >>> 0).toNumber() : message.groupOrderId;
          if (message.accountGroupId != null && message.hasOwnProperty("accountGroupId"))
            if (typeof message.accountGroupId === "number")
              object.accountGroupId = options.longs === String ? String(message.accountGroupId) : message.accountGroupId;
            else
              object.accountGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.accountGroupId) : options.longs === Number ? new $util.LongBits(message.accountGroupId.low >>> 0, message.accountGroupId.high >>> 0).toNumber() : message.accountGroupId;
          if (message.accountGroupOrderPlanId != null && message.hasOwnProperty("accountGroupOrderPlanId"))
            if (typeof message.accountGroupOrderPlanId === "number")
              object.accountGroupOrderPlanId = options.longs === String ? String(message.accountGroupOrderPlanId) : message.accountGroupOrderPlanId;
            else
              object.accountGroupOrderPlanId = options.longs === String ? $util.Long.prototype.toString.call(message.accountGroupOrderPlanId) : options.longs === Number ? new $util.LongBits(message.accountGroupOrderPlanId.low >>> 0, message.accountGroupOrderPlanId.high >>> 0).toNumber() : message.accountGroupOrderPlanId;
          return object;
        };
        SubOrder.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return SubOrder;
      }();
      v1.GroupOrderStatus = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GROUP_ORDER_STATUS_UNKNOWN"] = 0;
        values[valuesById[1] = "GROUP_ORDER_STATUS_PENDING"] = 1;
        values[valuesById[2] = "GROUP_ORDER_STATUS_PENDING_NEW"] = 2;
        values[valuesById[3] = "GROUP_ORDER_STATUS_NEW"] = 3;
        values[valuesById[4] = "GROUP_ORDER_STATUS_FILLED"] = 4;
        values[valuesById[5] = "GROUP_ORDER_STATUS_EXPIRED"] = 5;
        values[valuesById[6] = "GROUP_ORDER_STATUS_CANCELLED"] = 6;
        values[valuesById[7] = "GROUP_ORDER_STATUS_PARTIALLY_FILLED"] = 7;
        values[valuesById[8] = "GROUP_ORDER_STATUS_REJECTED"] = 8;
        return values;
      }();
      v1.Side = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SIDE_UNKNOWN"] = 0;
        values[valuesById[1] = "SIDE_BUY"] = 1;
        values[valuesById[2] = "SIDE_SELL"] = 2;
        return values;
      }();
      v1.Type = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "TYPE_LO"] = 1;
        values[valuesById[2] = "TYPE_MP"] = 2;
        values[valuesById[3] = "TYPE_MTL"] = 3;
        values[valuesById[4] = "TYPE_MOK"] = 4;
        values[valuesById[5] = "TYPE_MAK"] = 5;
        values[valuesById[6] = "TYPE_ATO"] = 6;
        values[valuesById[7] = "TYPE_ATC"] = 7;
        return values;
      }();
      v1.GroupOrder = function() {
        function GroupOrder(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        GroupOrder.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrder.prototype.symbol = "";
        GroupOrder.prototype.accountGroupId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrder.prototype.accountGroupOrderPlanId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrder.prototype.orderType = 0;
        GroupOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrder.prototype.filledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrder.prototype.price = 0;
        GroupOrder.prototype.side = 0;
        GroupOrder.prototype.status = 0;
        GroupOrder.prototype.tradingDate = null;
        GroupOrder.prototype.maker = "";
        GroupOrder.prototype.channel = "";
        GroupOrder.prototype.createdDate = null;
        GroupOrder.prototype.updatedDate = null;
        GroupOrder.create = function create(properties) {
          return new GroupOrder(properties);
        };
        GroupOrder.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(18).string(message.symbol);
          if (message.accountGroupId != null && Object.hasOwnProperty.call(message, "accountGroupId"))
            writer.uint32(24).int64(message.accountGroupId);
          if (message.accountGroupOrderPlanId != null && Object.hasOwnProperty.call(message, "accountGroupOrderPlanId"))
            writer.uint32(32).int64(message.accountGroupOrderPlanId);
          if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
            writer.uint32(40).int32(message.orderType);
          if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(48).int64(message.quantity);
          if (message.filledQuantity != null && Object.hasOwnProperty.call(message, "filledQuantity"))
            writer.uint32(56).int64(message.filledQuantity);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(65).double(message.price);
          if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(72).int32(message.side);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(80).int32(message.status);
          if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
            $root.google.protobuf.Timestamp.encode(message.tradingDate, writer.uint32(90).fork()).ldelim();
          if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
            writer.uint32(98).string(message.maker);
          if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(106).string(message.channel);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(114).fork()).ldelim();
          if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
            $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(122).fork()).ldelim();
          return writer;
        };
        GroupOrder.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        GroupOrder.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.group_order.v1.GroupOrder();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int64();
                break;
              case 2:
                message.symbol = reader.string();
                break;
              case 3:
                message.accountGroupId = reader.int64();
                break;
              case 4:
                message.accountGroupOrderPlanId = reader.int64();
                break;
              case 5:
                message.orderType = reader.int32();
                break;
              case 6:
                message.quantity = reader.int64();
                break;
              case 7:
                message.filledQuantity = reader.int64();
                break;
              case 8:
                message.price = reader.double();
                break;
              case 9:
                message.side = reader.int32();
                break;
              case 10:
                message.status = reader.int32();
                break;
              case 11:
                message.tradingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 12:
                message.maker = reader.string();
                break;
              case 13:
                message.channel = reader.string();
                break;
              case 14:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 15:
                message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        GroupOrder.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        GroupOrder.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
              return "id: integer|Long expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.accountGroupId != null && message.hasOwnProperty("accountGroupId")) {
            if (!$util.isInteger(message.accountGroupId) && !(message.accountGroupId && $util.isInteger(message.accountGroupId.low) && $util.isInteger(message.accountGroupId.high)))
              return "accountGroupId: integer|Long expected";
          }
          if (message.accountGroupOrderPlanId != null && message.hasOwnProperty("accountGroupOrderPlanId")) {
            if (!$util.isInteger(message.accountGroupOrderPlanId) && !(message.accountGroupOrderPlanId && $util.isInteger(message.accountGroupOrderPlanId.low) && $util.isInteger(message.accountGroupOrderPlanId.high)))
              return "accountGroupOrderPlanId: integer|Long expected";
          }
          if (message.orderType != null && message.hasOwnProperty("orderType"))
            switch (message.orderType) {
              default:
                return "orderType: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
                break;
            }
          if (message.quantity != null && message.hasOwnProperty("quantity")) {
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
              return "quantity: integer|Long expected";
          }
          if (message.filledQuantity != null && message.hasOwnProperty("filledQuantity")) {
            if (!$util.isInteger(message.filledQuantity) && !(message.filledQuantity && $util.isInteger(message.filledQuantity.low) && $util.isInteger(message.filledQuantity.high)))
              return "filledQuantity: integer|Long expected";
          }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.side != null && message.hasOwnProperty("side"))
            switch (message.side) {
              default:
                return "side: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
                break;
            }
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.tradingDate);
            if (error)
              return "tradingDate." + error;
          }
          if (message.maker != null && message.hasOwnProperty("maker")) {
            if (!$util.isString(message.maker))
              return "maker: string expected";
          }
          if (message.channel != null && message.hasOwnProperty("channel")) {
            if (!$util.isString(message.channel))
              return "channel: string expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
            if (error)
              return "updatedDate." + error;
          }
          return null;
        };
        GroupOrder.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.group_order.v1.GroupOrder)
            return object;
          let message = new $root.dnse.group_order.v1.GroupOrder();
          if (object.id != null) {
            if ($util.Long)
              (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
              message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
              message.id = object.id;
            else if (typeof object.id === "object")
              message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
          }
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.accountGroupId != null) {
            if ($util.Long)
              (message.accountGroupId = $util.Long.fromValue(object.accountGroupId)).unsigned = false;
            else if (typeof object.accountGroupId === "string")
              message.accountGroupId = parseInt(object.accountGroupId, 10);
            else if (typeof object.accountGroupId === "number")
              message.accountGroupId = object.accountGroupId;
            else if (typeof object.accountGroupId === "object")
              message.accountGroupId = new $util.LongBits(object.accountGroupId.low >>> 0, object.accountGroupId.high >>> 0).toNumber();
          }
          if (object.accountGroupOrderPlanId != null) {
            if ($util.Long)
              (message.accountGroupOrderPlanId = $util.Long.fromValue(object.accountGroupOrderPlanId)).unsigned = false;
            else if (typeof object.accountGroupOrderPlanId === "string")
              message.accountGroupOrderPlanId = parseInt(object.accountGroupOrderPlanId, 10);
            else if (typeof object.accountGroupOrderPlanId === "number")
              message.accountGroupOrderPlanId = object.accountGroupOrderPlanId;
            else if (typeof object.accountGroupOrderPlanId === "object")
              message.accountGroupOrderPlanId = new $util.LongBits(object.accountGroupOrderPlanId.low >>> 0, object.accountGroupOrderPlanId.high >>> 0).toNumber();
          }
          switch (object.orderType) {
            case "TYPE_UNKNOWN":
            case 0:
              message.orderType = 0;
              break;
            case "TYPE_LO":
            case 1:
              message.orderType = 1;
              break;
            case "TYPE_MP":
            case 2:
              message.orderType = 2;
              break;
            case "TYPE_MTL":
            case 3:
              message.orderType = 3;
              break;
            case "TYPE_MOK":
            case 4:
              message.orderType = 4;
              break;
            case "TYPE_MAK":
            case 5:
              message.orderType = 5;
              break;
            case "TYPE_ATO":
            case 6:
              message.orderType = 6;
              break;
            case "TYPE_ATC":
            case 7:
              message.orderType = 7;
              break;
          }
          if (object.quantity != null) {
            if ($util.Long)
              (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
              message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
              message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
              message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
          }
          if (object.filledQuantity != null) {
            if ($util.Long)
              (message.filledQuantity = $util.Long.fromValue(object.filledQuantity)).unsigned = false;
            else if (typeof object.filledQuantity === "string")
              message.filledQuantity = parseInt(object.filledQuantity, 10);
            else if (typeof object.filledQuantity === "number")
              message.filledQuantity = object.filledQuantity;
            else if (typeof object.filledQuantity === "object")
              message.filledQuantity = new $util.LongBits(object.filledQuantity.low >>> 0, object.filledQuantity.high >>> 0).toNumber();
          }
          if (object.price != null)
            message.price = Number(object.price);
          switch (object.side) {
            case "SIDE_UNKNOWN":
            case 0:
              message.side = 0;
              break;
            case "SIDE_BUY":
            case 1:
              message.side = 1;
              break;
            case "SIDE_SELL":
            case 2:
              message.side = 2;
              break;
          }
          switch (object.status) {
            case "GROUP_ORDER_STATUS_UNKNOWN":
            case 0:
              message.status = 0;
              break;
            case "GROUP_ORDER_STATUS_PENDING":
            case 1:
              message.status = 1;
              break;
            case "GROUP_ORDER_STATUS_PENDING_NEW":
            case 2:
              message.status = 2;
              break;
            case "GROUP_ORDER_STATUS_NEW":
            case 3:
              message.status = 3;
              break;
            case "GROUP_ORDER_STATUS_FILLED":
            case 4:
              message.status = 4;
              break;
            case "GROUP_ORDER_STATUS_EXPIRED":
            case 5:
              message.status = 5;
              break;
            case "GROUP_ORDER_STATUS_CANCELLED":
            case 6:
              message.status = 6;
              break;
            case "GROUP_ORDER_STATUS_PARTIALLY_FILLED":
            case 7:
              message.status = 7;
              break;
            case "GROUP_ORDER_STATUS_REJECTED":
            case 8:
              message.status = 8;
              break;
          }
          if (object.tradingDate != null) {
            if (typeof object.tradingDate !== "object")
              throw TypeError(".dnse.group_order.v1.GroupOrder.tradingDate: object expected");
            message.tradingDate = $root.google.protobuf.Timestamp.fromObject(object.tradingDate);
          }
          if (object.maker != null)
            message.maker = String(object.maker);
          if (object.channel != null)
            message.channel = String(object.channel);
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.group_order.v1.GroupOrder.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.updatedDate != null) {
            if (typeof object.updatedDate !== "object")
              throw TypeError(".dnse.group_order.v1.GroupOrder.updatedDate: object expected");
            message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
          }
          return message;
        };
        GroupOrder.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.id = options.longs === String ? "0" : 0;
            object.symbol = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.accountGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.accountGroupId = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.accountGroupOrderPlanId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.accountGroupOrderPlanId = options.longs === String ? "0" : 0;
            object.orderType = options.enums === String ? "TYPE_UNKNOWN" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.quantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.filledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.filledQuantity = options.longs === String ? "0" : 0;
            object.price = 0;
            object.side = options.enums === String ? "SIDE_UNKNOWN" : 0;
            object.status = options.enums === String ? "GROUP_ORDER_STATUS_UNKNOWN" : 0;
            object.tradingDate = null;
            object.maker = "";
            object.channel = "";
            object.createdDate = null;
            object.updatedDate = null;
          }
          if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
              object.id = options.longs === String ? String(message.id) : message.id;
            else
              object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.accountGroupId != null && message.hasOwnProperty("accountGroupId"))
            if (typeof message.accountGroupId === "number")
              object.accountGroupId = options.longs === String ? String(message.accountGroupId) : message.accountGroupId;
            else
              object.accountGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.accountGroupId) : options.longs === Number ? new $util.LongBits(message.accountGroupId.low >>> 0, message.accountGroupId.high >>> 0).toNumber() : message.accountGroupId;
          if (message.accountGroupOrderPlanId != null && message.hasOwnProperty("accountGroupOrderPlanId"))
            if (typeof message.accountGroupOrderPlanId === "number")
              object.accountGroupOrderPlanId = options.longs === String ? String(message.accountGroupOrderPlanId) : message.accountGroupOrderPlanId;
            else
              object.accountGroupOrderPlanId = options.longs === String ? $util.Long.prototype.toString.call(message.accountGroupOrderPlanId) : options.longs === Number ? new $util.LongBits(message.accountGroupOrderPlanId.low >>> 0, message.accountGroupOrderPlanId.high >>> 0).toNumber() : message.accountGroupOrderPlanId;
          if (message.orderType != null && message.hasOwnProperty("orderType"))
            object.orderType = options.enums === String ? $root.dnse.group_order.v1.Type[message.orderType] : message.orderType;
          if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
              object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
              object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
          if (message.filledQuantity != null && message.hasOwnProperty("filledQuantity"))
            if (typeof message.filledQuantity === "number")
              object.filledQuantity = options.longs === String ? String(message.filledQuantity) : message.filledQuantity;
            else
              object.filledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.filledQuantity) : options.longs === Number ? new $util.LongBits(message.filledQuantity.low >>> 0, message.filledQuantity.high >>> 0).toNumber() : message.filledQuantity;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.side != null && message.hasOwnProperty("side"))
            object.side = options.enums === String ? $root.dnse.group_order.v1.Side[message.side] : message.side;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.group_order.v1.GroupOrderStatus[message.status] : message.status;
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
            object.tradingDate = $root.google.protobuf.Timestamp.toObject(message.tradingDate, options);
          if (message.maker != null && message.hasOwnProperty("maker"))
            object.maker = message.maker;
          if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
            object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
          return object;
        };
        GroupOrder.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return GroupOrder;
      }();
      v1.GroupOrderPlan = function() {
        function GroupOrderPlan(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        GroupOrderPlan.prototype.id = 0;
        GroupOrderPlan.prototype.accountGroupId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrderPlan.prototype.symbol = "";
        GroupOrderPlan.prototype.side = "";
        GroupOrderPlan.prototype.rate = 0;
        GroupOrderPlan.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrderPlan.prototype.quantity = 0;
        GroupOrderPlan.prototype.disbursed = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrderPlan.prototype.pendingDisbursed = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GroupOrderPlan.prototype.expiredDate = null;
        GroupOrderPlan.prototype.status = "";
        GroupOrderPlan.create = function create(properties) {
          return new GroupOrderPlan(properties);
        };
        GroupOrderPlan.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int32(message.id);
          if (message.accountGroupId != null && Object.hasOwnProperty.call(message, "accountGroupId"))
            writer.uint32(16).int64(message.accountGroupId);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(26).string(message.symbol);
          if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(34).string(message.side);
          if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
            writer.uint32(41).double(message.rate);
          if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(48).int64(message.amount);
          if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(56).int32(message.quantity);
          if (message.disbursed != null && Object.hasOwnProperty.call(message, "disbursed"))
            writer.uint32(64).int64(message.disbursed);
          if (message.pendingDisbursed != null && Object.hasOwnProperty.call(message, "pendingDisbursed"))
            writer.uint32(72).int64(message.pendingDisbursed);
          if (message.expiredDate != null && Object.hasOwnProperty.call(message, "expiredDate"))
            $root.google.protobuf.Timestamp.encode(message.expiredDate, writer.uint32(82).fork()).ldelim();
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(90).string(message.status);
          return writer;
        };
        GroupOrderPlan.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        GroupOrderPlan.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.group_order.v1.GroupOrderPlan();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int32();
                break;
              case 2:
                message.accountGroupId = reader.int64();
                break;
              case 3:
                message.symbol = reader.string();
                break;
              case 4:
                message.side = reader.string();
                break;
              case 5:
                message.rate = reader.double();
                break;
              case 6:
                message.amount = reader.int64();
                break;
              case 7:
                message.quantity = reader.int32();
                break;
              case 8:
                message.disbursed = reader.int64();
                break;
              case 9:
                message.pendingDisbursed = reader.int64();
                break;
              case 10:
                message.expiredDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 11:
                message.status = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        GroupOrderPlan.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        GroupOrderPlan.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id))
              return "id: integer expected";
          }
          if (message.accountGroupId != null && message.hasOwnProperty("accountGroupId")) {
            if (!$util.isInteger(message.accountGroupId) && !(message.accountGroupId && $util.isInteger(message.accountGroupId.low) && $util.isInteger(message.accountGroupId.high)))
              return "accountGroupId: integer|Long expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.side != null && message.hasOwnProperty("side")) {
            if (!$util.isString(message.side))
              return "side: string expected";
          }
          if (message.rate != null && message.hasOwnProperty("rate")) {
            if (typeof message.rate !== "number")
              return "rate: number expected";
          }
          if (message.amount != null && message.hasOwnProperty("amount")) {
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
              return "amount: integer|Long expected";
          }
          if (message.quantity != null && message.hasOwnProperty("quantity")) {
            if (!$util.isInteger(message.quantity))
              return "quantity: integer expected";
          }
          if (message.disbursed != null && message.hasOwnProperty("disbursed")) {
            if (!$util.isInteger(message.disbursed) && !(message.disbursed && $util.isInteger(message.disbursed.low) && $util.isInteger(message.disbursed.high)))
              return "disbursed: integer|Long expected";
          }
          if (message.pendingDisbursed != null && message.hasOwnProperty("pendingDisbursed")) {
            if (!$util.isInteger(message.pendingDisbursed) && !(message.pendingDisbursed && $util.isInteger(message.pendingDisbursed.low) && $util.isInteger(message.pendingDisbursed.high)))
              return "pendingDisbursed: integer|Long expected";
          }
          if (message.expiredDate != null && message.hasOwnProperty("expiredDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.expiredDate);
            if (error)
              return "expiredDate." + error;
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isString(message.status))
              return "status: string expected";
          }
          return null;
        };
        GroupOrderPlan.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.group_order.v1.GroupOrderPlan)
            return object;
          let message = new $root.dnse.group_order.v1.GroupOrderPlan();
          if (object.id != null)
            message.id = object.id | 0;
          if (object.accountGroupId != null) {
            if ($util.Long)
              (message.accountGroupId = $util.Long.fromValue(object.accountGroupId)).unsigned = false;
            else if (typeof object.accountGroupId === "string")
              message.accountGroupId = parseInt(object.accountGroupId, 10);
            else if (typeof object.accountGroupId === "number")
              message.accountGroupId = object.accountGroupId;
            else if (typeof object.accountGroupId === "object")
              message.accountGroupId = new $util.LongBits(object.accountGroupId.low >>> 0, object.accountGroupId.high >>> 0).toNumber();
          }
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.side != null)
            message.side = String(object.side);
          if (object.rate != null)
            message.rate = Number(object.rate);
          if (object.amount != null) {
            if ($util.Long)
              (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
              message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
              message.amount = object.amount;
            else if (typeof object.amount === "object")
              message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
          }
          if (object.quantity != null)
            message.quantity = object.quantity | 0;
          if (object.disbursed != null) {
            if ($util.Long)
              (message.disbursed = $util.Long.fromValue(object.disbursed)).unsigned = false;
            else if (typeof object.disbursed === "string")
              message.disbursed = parseInt(object.disbursed, 10);
            else if (typeof object.disbursed === "number")
              message.disbursed = object.disbursed;
            else if (typeof object.disbursed === "object")
              message.disbursed = new $util.LongBits(object.disbursed.low >>> 0, object.disbursed.high >>> 0).toNumber();
          }
          if (object.pendingDisbursed != null) {
            if ($util.Long)
              (message.pendingDisbursed = $util.Long.fromValue(object.pendingDisbursed)).unsigned = false;
            else if (typeof object.pendingDisbursed === "string")
              message.pendingDisbursed = parseInt(object.pendingDisbursed, 10);
            else if (typeof object.pendingDisbursed === "number")
              message.pendingDisbursed = object.pendingDisbursed;
            else if (typeof object.pendingDisbursed === "object")
              message.pendingDisbursed = new $util.LongBits(object.pendingDisbursed.low >>> 0, object.pendingDisbursed.high >>> 0).toNumber();
          }
          if (object.expiredDate != null) {
            if (typeof object.expiredDate !== "object")
              throw TypeError(".dnse.group_order.v1.GroupOrderPlan.expiredDate: object expected");
            message.expiredDate = $root.google.protobuf.Timestamp.fromObject(object.expiredDate);
          }
          if (object.status != null)
            message.status = String(object.status);
          return message;
        };
        GroupOrderPlan.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.id = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.accountGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.accountGroupId = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.side = "";
            object.rate = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.amount = options.longs === String ? "0" : 0;
            object.quantity = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.disbursed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.disbursed = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.pendingDisbursed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.pendingDisbursed = options.longs === String ? "0" : 0;
            object.expiredDate = null;
            object.status = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
          if (message.accountGroupId != null && message.hasOwnProperty("accountGroupId"))
            if (typeof message.accountGroupId === "number")
              object.accountGroupId = options.longs === String ? String(message.accountGroupId) : message.accountGroupId;
            else
              object.accountGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.accountGroupId) : options.longs === Number ? new $util.LongBits(message.accountGroupId.low >>> 0, message.accountGroupId.high >>> 0).toNumber() : message.accountGroupId;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.side != null && message.hasOwnProperty("side"))
            object.side = message.side;
          if (message.rate != null && message.hasOwnProperty("rate"))
            object.rate = options.json && !isFinite(message.rate) ? String(message.rate) : message.rate;
          if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
              object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
              object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
          if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
          if (message.disbursed != null && message.hasOwnProperty("disbursed"))
            if (typeof message.disbursed === "number")
              object.disbursed = options.longs === String ? String(message.disbursed) : message.disbursed;
            else
              object.disbursed = options.longs === String ? $util.Long.prototype.toString.call(message.disbursed) : options.longs === Number ? new $util.LongBits(message.disbursed.low >>> 0, message.disbursed.high >>> 0).toNumber() : message.disbursed;
          if (message.pendingDisbursed != null && message.hasOwnProperty("pendingDisbursed"))
            if (typeof message.pendingDisbursed === "number")
              object.pendingDisbursed = options.longs === String ? String(message.pendingDisbursed) : message.pendingDisbursed;
            else
              object.pendingDisbursed = options.longs === String ? $util.Long.prototype.toString.call(message.pendingDisbursed) : options.longs === Number ? new $util.LongBits(message.pendingDisbursed.low >>> 0, message.pendingDisbursed.high >>> 0).toNumber() : message.pendingDisbursed;
          if (message.expiredDate != null && message.hasOwnProperty("expiredDate"))
            object.expiredDate = $root.google.protobuf.Timestamp.toObject(message.expiredDate, options);
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          return object;
        };
        GroupOrderPlan.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return GroupOrderPlan;
      }();
      return v1;
    }();
    return group_order;
  }();
  dnse2.LeaderboardGame = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "LB_GAME_UNKNOWN"] = 0;
    values[valuesById[1] = "LB_GAME_DERIVATIVES_ARENA"] = 1;
    return values;
  }();
  dnse2.LeaderboardType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "LB_TYPE_UNKNOWN"] = 0;
    values[valuesById[1] = "LB_TYPE_TOTAL_PROFIT_POINTS"] = 1;
    values[valuesById[2] = "LB_TYPE_HIGHEST_PROFIT_POINT"] = 2;
    values[valuesById[3] = "LB_TYPE_TOTAL_NET_REALIZED_PROFITS"] = 3;
    values[valuesById[4] = "LB_TYPE_WINNING_RATE"] = 4;
    return values;
  }();
  dnse2.DerivativesArenaUserRanks = function() {
    function DerivativesArenaUserRanks(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativesArenaUserRanks.prototype.userId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.totalProfitPointsRank = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.highestProfitPointRank = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.totalNetRealizedProfitsRank = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.winningRateRank = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.weekNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.monthNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.prototype.time = null;
    DerivativesArenaUserRanks.prototype.yearNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRanks.create = function create(properties) {
      return new DerivativesArenaUserRanks(properties);
    };
    DerivativesArenaUserRanks.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(8).int64(message.userId);
      if (message.totalProfitPointsRank != null && Object.hasOwnProperty.call(message, "totalProfitPointsRank"))
        writer.uint32(16).int64(message.totalProfitPointsRank);
      if (message.highestProfitPointRank != null && Object.hasOwnProperty.call(message, "highestProfitPointRank"))
        writer.uint32(24).int64(message.highestProfitPointRank);
      if (message.totalNetRealizedProfitsRank != null && Object.hasOwnProperty.call(message, "totalNetRealizedProfitsRank"))
        writer.uint32(32).int64(message.totalNetRealizedProfitsRank);
      if (message.winningRateRank != null && Object.hasOwnProperty.call(message, "winningRateRank"))
        writer.uint32(40).int64(message.winningRateRank);
      if (message.weekNumber != null && Object.hasOwnProperty.call(message, "weekNumber"))
        writer.uint32(48).int64(message.weekNumber);
      if (message.monthNumber != null && Object.hasOwnProperty.call(message, "monthNumber"))
        writer.uint32(56).int64(message.monthNumber);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(66).fork()).ldelim();
      if (message.yearNumber != null && Object.hasOwnProperty.call(message, "yearNumber"))
        writer.uint32(72).int64(message.yearNumber);
      return writer;
    };
    DerivativesArenaUserRanks.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativesArenaUserRanks.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativesArenaUserRanks();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.userId = reader.int64();
            break;
          case 2:
            message.totalProfitPointsRank = reader.int64();
            break;
          case 3:
            message.highestProfitPointRank = reader.int64();
            break;
          case 4:
            message.totalNetRealizedProfitsRank = reader.int64();
            break;
          case 5:
            message.winningRateRank = reader.int64();
            break;
          case 6:
            message.weekNumber = reader.int64();
            break;
          case 7:
            message.monthNumber = reader.int64();
            break;
          case 8:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.yearNumber = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativesArenaUserRanks.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativesArenaUserRanks.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
          return "userId: integer|Long expected";
      }
      if (message.totalProfitPointsRank != null && message.hasOwnProperty("totalProfitPointsRank")) {
        if (!$util.isInteger(message.totalProfitPointsRank) && !(message.totalProfitPointsRank && $util.isInteger(message.totalProfitPointsRank.low) && $util.isInteger(message.totalProfitPointsRank.high)))
          return "totalProfitPointsRank: integer|Long expected";
      }
      if (message.highestProfitPointRank != null && message.hasOwnProperty("highestProfitPointRank")) {
        if (!$util.isInteger(message.highestProfitPointRank) && !(message.highestProfitPointRank && $util.isInteger(message.highestProfitPointRank.low) && $util.isInteger(message.highestProfitPointRank.high)))
          return "highestProfitPointRank: integer|Long expected";
      }
      if (message.totalNetRealizedProfitsRank != null && message.hasOwnProperty("totalNetRealizedProfitsRank")) {
        if (!$util.isInteger(message.totalNetRealizedProfitsRank) && !(message.totalNetRealizedProfitsRank && $util.isInteger(message.totalNetRealizedProfitsRank.low) && $util.isInteger(message.totalNetRealizedProfitsRank.high)))
          return "totalNetRealizedProfitsRank: integer|Long expected";
      }
      if (message.winningRateRank != null && message.hasOwnProperty("winningRateRank")) {
        if (!$util.isInteger(message.winningRateRank) && !(message.winningRateRank && $util.isInteger(message.winningRateRank.low) && $util.isInteger(message.winningRateRank.high)))
          return "winningRateRank: integer|Long expected";
      }
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber")) {
        if (!$util.isInteger(message.weekNumber) && !(message.weekNumber && $util.isInteger(message.weekNumber.low) && $util.isInteger(message.weekNumber.high)))
          return "weekNumber: integer|Long expected";
      }
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber")) {
        if (!$util.isInteger(message.monthNumber) && !(message.monthNumber && $util.isInteger(message.monthNumber.low) && $util.isInteger(message.monthNumber.high)))
          return "monthNumber: integer|Long expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.yearNumber != null && message.hasOwnProperty("yearNumber")) {
        if (!$util.isInteger(message.yearNumber) && !(message.yearNumber && $util.isInteger(message.yearNumber.low) && $util.isInteger(message.yearNumber.high)))
          return "yearNumber: integer|Long expected";
      }
      return null;
    };
    DerivativesArenaUserRanks.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativesArenaUserRanks)
        return object;
      let message = new $root.dnse.DerivativesArenaUserRanks();
      if (object.userId != null) {
        if ($util.Long)
          (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
        else if (typeof object.userId === "string")
          message.userId = parseInt(object.userId, 10);
        else if (typeof object.userId === "number")
          message.userId = object.userId;
        else if (typeof object.userId === "object")
          message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
      }
      if (object.totalProfitPointsRank != null) {
        if ($util.Long)
          (message.totalProfitPointsRank = $util.Long.fromValue(object.totalProfitPointsRank)).unsigned = false;
        else if (typeof object.totalProfitPointsRank === "string")
          message.totalProfitPointsRank = parseInt(object.totalProfitPointsRank, 10);
        else if (typeof object.totalProfitPointsRank === "number")
          message.totalProfitPointsRank = object.totalProfitPointsRank;
        else if (typeof object.totalProfitPointsRank === "object")
          message.totalProfitPointsRank = new $util.LongBits(object.totalProfitPointsRank.low >>> 0, object.totalProfitPointsRank.high >>> 0).toNumber();
      }
      if (object.highestProfitPointRank != null) {
        if ($util.Long)
          (message.highestProfitPointRank = $util.Long.fromValue(object.highestProfitPointRank)).unsigned = false;
        else if (typeof object.highestProfitPointRank === "string")
          message.highestProfitPointRank = parseInt(object.highestProfitPointRank, 10);
        else if (typeof object.highestProfitPointRank === "number")
          message.highestProfitPointRank = object.highestProfitPointRank;
        else if (typeof object.highestProfitPointRank === "object")
          message.highestProfitPointRank = new $util.LongBits(object.highestProfitPointRank.low >>> 0, object.highestProfitPointRank.high >>> 0).toNumber();
      }
      if (object.totalNetRealizedProfitsRank != null) {
        if ($util.Long)
          (message.totalNetRealizedProfitsRank = $util.Long.fromValue(object.totalNetRealizedProfitsRank)).unsigned = false;
        else if (typeof object.totalNetRealizedProfitsRank === "string")
          message.totalNetRealizedProfitsRank = parseInt(object.totalNetRealizedProfitsRank, 10);
        else if (typeof object.totalNetRealizedProfitsRank === "number")
          message.totalNetRealizedProfitsRank = object.totalNetRealizedProfitsRank;
        else if (typeof object.totalNetRealizedProfitsRank === "object")
          message.totalNetRealizedProfitsRank = new $util.LongBits(object.totalNetRealizedProfitsRank.low >>> 0, object.totalNetRealizedProfitsRank.high >>> 0).toNumber();
      }
      if (object.winningRateRank != null) {
        if ($util.Long)
          (message.winningRateRank = $util.Long.fromValue(object.winningRateRank)).unsigned = false;
        else if (typeof object.winningRateRank === "string")
          message.winningRateRank = parseInt(object.winningRateRank, 10);
        else if (typeof object.winningRateRank === "number")
          message.winningRateRank = object.winningRateRank;
        else if (typeof object.winningRateRank === "object")
          message.winningRateRank = new $util.LongBits(object.winningRateRank.low >>> 0, object.winningRateRank.high >>> 0).toNumber();
      }
      if (object.weekNumber != null) {
        if ($util.Long)
          (message.weekNumber = $util.Long.fromValue(object.weekNumber)).unsigned = false;
        else if (typeof object.weekNumber === "string")
          message.weekNumber = parseInt(object.weekNumber, 10);
        else if (typeof object.weekNumber === "number")
          message.weekNumber = object.weekNumber;
        else if (typeof object.weekNumber === "object")
          message.weekNumber = new $util.LongBits(object.weekNumber.low >>> 0, object.weekNumber.high >>> 0).toNumber();
      }
      if (object.monthNumber != null) {
        if ($util.Long)
          (message.monthNumber = $util.Long.fromValue(object.monthNumber)).unsigned = false;
        else if (typeof object.monthNumber === "string")
          message.monthNumber = parseInt(object.monthNumber, 10);
        else if (typeof object.monthNumber === "number")
          message.monthNumber = object.monthNumber;
        else if (typeof object.monthNumber === "object")
          message.monthNumber = new $util.LongBits(object.monthNumber.low >>> 0, object.monthNumber.high >>> 0).toNumber();
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.DerivativesArenaUserRanks.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.yearNumber != null) {
        if ($util.Long)
          (message.yearNumber = $util.Long.fromValue(object.yearNumber)).unsigned = false;
        else if (typeof object.yearNumber === "string")
          message.yearNumber = parseInt(object.yearNumber, 10);
        else if (typeof object.yearNumber === "number")
          message.yearNumber = object.yearNumber;
        else if (typeof object.yearNumber === "object")
          message.yearNumber = new $util.LongBits(object.yearNumber.low >>> 0, object.yearNumber.high >>> 0).toNumber();
      }
      return message;
    };
    DerivativesArenaUserRanks.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.userId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalProfitPointsRank = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalProfitPointsRank = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.highestProfitPointRank = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.highestProfitPointRank = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalNetRealizedProfitsRank = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalNetRealizedProfitsRank = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.winningRateRank = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.winningRateRank = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.weekNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.weekNumber = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.monthNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.monthNumber = options.longs === String ? "0" : 0;
        object.time = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.yearNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.yearNumber = options.longs === String ? "0" : 0;
      }
      if (message.userId != null && message.hasOwnProperty("userId"))
        if (typeof message.userId === "number")
          object.userId = options.longs === String ? String(message.userId) : message.userId;
        else
          object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
      if (message.totalProfitPointsRank != null && message.hasOwnProperty("totalProfitPointsRank"))
        if (typeof message.totalProfitPointsRank === "number")
          object.totalProfitPointsRank = options.longs === String ? String(message.totalProfitPointsRank) : message.totalProfitPointsRank;
        else
          object.totalProfitPointsRank = options.longs === String ? $util.Long.prototype.toString.call(message.totalProfitPointsRank) : options.longs === Number ? new $util.LongBits(message.totalProfitPointsRank.low >>> 0, message.totalProfitPointsRank.high >>> 0).toNumber() : message.totalProfitPointsRank;
      if (message.highestProfitPointRank != null && message.hasOwnProperty("highestProfitPointRank"))
        if (typeof message.highestProfitPointRank === "number")
          object.highestProfitPointRank = options.longs === String ? String(message.highestProfitPointRank) : message.highestProfitPointRank;
        else
          object.highestProfitPointRank = options.longs === String ? $util.Long.prototype.toString.call(message.highestProfitPointRank) : options.longs === Number ? new $util.LongBits(message.highestProfitPointRank.low >>> 0, message.highestProfitPointRank.high >>> 0).toNumber() : message.highestProfitPointRank;
      if (message.totalNetRealizedProfitsRank != null && message.hasOwnProperty("totalNetRealizedProfitsRank"))
        if (typeof message.totalNetRealizedProfitsRank === "number")
          object.totalNetRealizedProfitsRank = options.longs === String ? String(message.totalNetRealizedProfitsRank) : message.totalNetRealizedProfitsRank;
        else
          object.totalNetRealizedProfitsRank = options.longs === String ? $util.Long.prototype.toString.call(message.totalNetRealizedProfitsRank) : options.longs === Number ? new $util.LongBits(message.totalNetRealizedProfitsRank.low >>> 0, message.totalNetRealizedProfitsRank.high >>> 0).toNumber() : message.totalNetRealizedProfitsRank;
      if (message.winningRateRank != null && message.hasOwnProperty("winningRateRank"))
        if (typeof message.winningRateRank === "number")
          object.winningRateRank = options.longs === String ? String(message.winningRateRank) : message.winningRateRank;
        else
          object.winningRateRank = options.longs === String ? $util.Long.prototype.toString.call(message.winningRateRank) : options.longs === Number ? new $util.LongBits(message.winningRateRank.low >>> 0, message.winningRateRank.high >>> 0).toNumber() : message.winningRateRank;
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber"))
        if (typeof message.weekNumber === "number")
          object.weekNumber = options.longs === String ? String(message.weekNumber) : message.weekNumber;
        else
          object.weekNumber = options.longs === String ? $util.Long.prototype.toString.call(message.weekNumber) : options.longs === Number ? new $util.LongBits(message.weekNumber.low >>> 0, message.weekNumber.high >>> 0).toNumber() : message.weekNumber;
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber"))
        if (typeof message.monthNumber === "number")
          object.monthNumber = options.longs === String ? String(message.monthNumber) : message.monthNumber;
        else
          object.monthNumber = options.longs === String ? $util.Long.prototype.toString.call(message.monthNumber) : options.longs === Number ? new $util.LongBits(message.monthNumber.low >>> 0, message.monthNumber.high >>> 0).toNumber() : message.monthNumber;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.yearNumber != null && message.hasOwnProperty("yearNumber"))
        if (typeof message.yearNumber === "number")
          object.yearNumber = options.longs === String ? String(message.yearNumber) : message.yearNumber;
        else
          object.yearNumber = options.longs === String ? $util.Long.prototype.toString.call(message.yearNumber) : options.longs === Number ? new $util.LongBits(message.yearNumber.low >>> 0, message.yearNumber.high >>> 0).toNumber() : message.yearNumber;
      return object;
    };
    DerivativesArenaUserRanks.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativesArenaUserRanks;
  }();
  dnse2.DerivativesArenaUserRank = function() {
    function DerivativesArenaUserRank(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativesArenaUserRank.prototype.leaderboardType = 0;
    DerivativesArenaUserRank.prototype.userId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRank.prototype.nickname = "";
    DerivativesArenaUserRank.prototype.rank = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRank.prototype.timePeriod = "";
    DerivativesArenaUserRank.prototype.weekNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRank.prototype.monthNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRank.prototype.startedAt = null;
    DerivativesArenaUserRank.prototype.endedAt = null;
    DerivativesArenaUserRank.prototype.totalProfitPoints = null;
    DerivativesArenaUserRank.prototype.highestProfitPoint = null;
    DerivativesArenaUserRank.prototype.totalNetRealizedProfits = null;
    DerivativesArenaUserRank.prototype.winningRate = null;
    DerivativesArenaUserRank.prototype.totalTransactions = null;
    DerivativesArenaUserRank.prototype.dealSide = null;
    DerivativesArenaUserRank.prototype.time = null;
    DerivativesArenaUserRank.prototype.avatarUrl = "";
    DerivativesArenaUserRank.prototype.yearNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaUserRank.prototype.totalTransactionsClosedInPeriod = null;
    let $oneOfFields;
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_totalProfitPoints", {
      get: $util.oneOfGetter($oneOfFields = ["totalProfitPoints"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_highestProfitPoint", {
      get: $util.oneOfGetter($oneOfFields = ["highestProfitPoint"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_totalNetRealizedProfits", {
      get: $util.oneOfGetter($oneOfFields = ["totalNetRealizedProfits"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_winningRate", {
      get: $util.oneOfGetter($oneOfFields = ["winningRate"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_totalTransactions", {
      get: $util.oneOfGetter($oneOfFields = ["totalTransactions"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_dealSide", {
      get: $util.oneOfGetter($oneOfFields = ["dealSide"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(DerivativesArenaUserRank.prototype, "_totalTransactionsClosedInPeriod", {
      get: $util.oneOfGetter($oneOfFields = ["totalTransactionsClosedInPeriod"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    DerivativesArenaUserRank.create = function create(properties) {
      return new DerivativesArenaUserRank(properties);
    };
    DerivativesArenaUserRank.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.leaderboardType != null && Object.hasOwnProperty.call(message, "leaderboardType"))
        writer.uint32(8).int32(message.leaderboardType);
      if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
        writer.uint32(16).int64(message.userId);
      if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
        writer.uint32(26).string(message.nickname);
      if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
        writer.uint32(32).int64(message.rank);
      if (message.timePeriod != null && Object.hasOwnProperty.call(message, "timePeriod"))
        writer.uint32(42).string(message.timePeriod);
      if (message.weekNumber != null && Object.hasOwnProperty.call(message, "weekNumber"))
        writer.uint32(48).int64(message.weekNumber);
      if (message.monthNumber != null && Object.hasOwnProperty.call(message, "monthNumber"))
        writer.uint32(56).int64(message.monthNumber);
      if (message.startedAt != null && Object.hasOwnProperty.call(message, "startedAt"))
        $root.google.protobuf.Timestamp.encode(message.startedAt, writer.uint32(66).fork()).ldelim();
      if (message.endedAt != null && Object.hasOwnProperty.call(message, "endedAt"))
        $root.google.protobuf.Timestamp.encode(message.endedAt, writer.uint32(74).fork()).ldelim();
      if (message.totalProfitPoints != null && Object.hasOwnProperty.call(message, "totalProfitPoints"))
        writer.uint32(81).double(message.totalProfitPoints);
      if (message.highestProfitPoint != null && Object.hasOwnProperty.call(message, "highestProfitPoint"))
        writer.uint32(89).double(message.highestProfitPoint);
      if (message.totalNetRealizedProfits != null && Object.hasOwnProperty.call(message, "totalNetRealizedProfits"))
        writer.uint32(97).double(message.totalNetRealizedProfits);
      if (message.winningRate != null && Object.hasOwnProperty.call(message, "winningRate"))
        writer.uint32(105).double(message.winningRate);
      if (message.totalTransactions != null && Object.hasOwnProperty.call(message, "totalTransactions"))
        writer.uint32(112).int64(message.totalTransactions);
      if (message.dealSide != null && Object.hasOwnProperty.call(message, "dealSide"))
        writer.uint32(122).string(message.dealSide);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(130).fork()).ldelim();
      if (message.avatarUrl != null && Object.hasOwnProperty.call(message, "avatarUrl"))
        writer.uint32(138).string(message.avatarUrl);
      if (message.yearNumber != null && Object.hasOwnProperty.call(message, "yearNumber"))
        writer.uint32(144).int64(message.yearNumber);
      if (message.totalTransactionsClosedInPeriod != null && Object.hasOwnProperty.call(message, "totalTransactionsClosedInPeriod"))
        writer.uint32(152).int64(message.totalTransactionsClosedInPeriod);
      return writer;
    };
    DerivativesArenaUserRank.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativesArenaUserRank.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativesArenaUserRank();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.leaderboardType = reader.int32();
            break;
          case 2:
            message.userId = reader.int64();
            break;
          case 3:
            message.nickname = reader.string();
            break;
          case 4:
            message.rank = reader.int64();
            break;
          case 5:
            message.timePeriod = reader.string();
            break;
          case 6:
            message.weekNumber = reader.int64();
            break;
          case 7:
            message.monthNumber = reader.int64();
            break;
          case 8:
            message.startedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.endedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.totalProfitPoints = reader.double();
            break;
          case 11:
            message.highestProfitPoint = reader.double();
            break;
          case 12:
            message.totalNetRealizedProfits = reader.double();
            break;
          case 13:
            message.winningRate = reader.double();
            break;
          case 14:
            message.totalTransactions = reader.int64();
            break;
          case 15:
            message.dealSide = reader.string();
            break;
          case 16:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 17:
            message.avatarUrl = reader.string();
            break;
          case 18:
            message.yearNumber = reader.int64();
            break;
          case 19:
            message.totalTransactionsClosedInPeriod = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativesArenaUserRank.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativesArenaUserRank.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.leaderboardType != null && message.hasOwnProperty("leaderboardType"))
        switch (message.leaderboardType) {
          default:
            return "leaderboardType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.userId != null && message.hasOwnProperty("userId")) {
        if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
          return "userId: integer|Long expected";
      }
      if (message.nickname != null && message.hasOwnProperty("nickname")) {
        if (!$util.isString(message.nickname))
          return "nickname: string expected";
      }
      if (message.rank != null && message.hasOwnProperty("rank")) {
        if (!$util.isInteger(message.rank) && !(message.rank && $util.isInteger(message.rank.low) && $util.isInteger(message.rank.high)))
          return "rank: integer|Long expected";
      }
      if (message.timePeriod != null && message.hasOwnProperty("timePeriod")) {
        if (!$util.isString(message.timePeriod))
          return "timePeriod: string expected";
      }
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber")) {
        if (!$util.isInteger(message.weekNumber) && !(message.weekNumber && $util.isInteger(message.weekNumber.low) && $util.isInteger(message.weekNumber.high)))
          return "weekNumber: integer|Long expected";
      }
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber")) {
        if (!$util.isInteger(message.monthNumber) && !(message.monthNumber && $util.isInteger(message.monthNumber.low) && $util.isInteger(message.monthNumber.high)))
          return "monthNumber: integer|Long expected";
      }
      if (message.startedAt != null && message.hasOwnProperty("startedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.startedAt);
        if (error)
          return "startedAt." + error;
      }
      if (message.endedAt != null && message.hasOwnProperty("endedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.endedAt);
        if (error)
          return "endedAt." + error;
      }
      if (message.totalProfitPoints != null && message.hasOwnProperty("totalProfitPoints")) {
        if (typeof message.totalProfitPoints !== "number")
          return "totalProfitPoints: number expected";
      }
      if (message.highestProfitPoint != null && message.hasOwnProperty("highestProfitPoint")) {
        if (typeof message.highestProfitPoint !== "number")
          return "highestProfitPoint: number expected";
      }
      if (message.totalNetRealizedProfits != null && message.hasOwnProperty("totalNetRealizedProfits")) {
        if (typeof message.totalNetRealizedProfits !== "number")
          return "totalNetRealizedProfits: number expected";
      }
      if (message.winningRate != null && message.hasOwnProperty("winningRate")) {
        if (typeof message.winningRate !== "number")
          return "winningRate: number expected";
      }
      if (message.totalTransactions != null && message.hasOwnProperty("totalTransactions")) {
        if (!$util.isInteger(message.totalTransactions) && !(message.totalTransactions && $util.isInteger(message.totalTransactions.low) && $util.isInteger(message.totalTransactions.high)))
          return "totalTransactions: integer|Long expected";
      }
      if (message.dealSide != null && message.hasOwnProperty("dealSide")) {
        if (!$util.isString(message.dealSide))
          return "dealSide: string expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl")) {
        if (!$util.isString(message.avatarUrl))
          return "avatarUrl: string expected";
      }
      if (message.yearNumber != null && message.hasOwnProperty("yearNumber")) {
        if (!$util.isInteger(message.yearNumber) && !(message.yearNumber && $util.isInteger(message.yearNumber.low) && $util.isInteger(message.yearNumber.high)))
          return "yearNumber: integer|Long expected";
      }
      if (message.totalTransactionsClosedInPeriod != null && message.hasOwnProperty("totalTransactionsClosedInPeriod")) {
        if (!$util.isInteger(message.totalTransactionsClosedInPeriod) && !(message.totalTransactionsClosedInPeriod && $util.isInteger(message.totalTransactionsClosedInPeriod.low) && $util.isInteger(message.totalTransactionsClosedInPeriod.high)))
          return "totalTransactionsClosedInPeriod: integer|Long expected";
      }
      return null;
    };
    DerivativesArenaUserRank.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativesArenaUserRank)
        return object;
      let message = new $root.dnse.DerivativesArenaUserRank();
      switch (object.leaderboardType) {
        case "LB_TYPE_UNKNOWN":
        case 0:
          message.leaderboardType = 0;
          break;
        case "LB_TYPE_TOTAL_PROFIT_POINTS":
        case 1:
          message.leaderboardType = 1;
          break;
        case "LB_TYPE_HIGHEST_PROFIT_POINT":
        case 2:
          message.leaderboardType = 2;
          break;
        case "LB_TYPE_TOTAL_NET_REALIZED_PROFITS":
        case 3:
          message.leaderboardType = 3;
          break;
        case "LB_TYPE_WINNING_RATE":
        case 4:
          message.leaderboardType = 4;
          break;
      }
      if (object.userId != null) {
        if ($util.Long)
          (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
        else if (typeof object.userId === "string")
          message.userId = parseInt(object.userId, 10);
        else if (typeof object.userId === "number")
          message.userId = object.userId;
        else if (typeof object.userId === "object")
          message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
      }
      if (object.nickname != null)
        message.nickname = String(object.nickname);
      if (object.rank != null) {
        if ($util.Long)
          (message.rank = $util.Long.fromValue(object.rank)).unsigned = false;
        else if (typeof object.rank === "string")
          message.rank = parseInt(object.rank, 10);
        else if (typeof object.rank === "number")
          message.rank = object.rank;
        else if (typeof object.rank === "object")
          message.rank = new $util.LongBits(object.rank.low >>> 0, object.rank.high >>> 0).toNumber();
      }
      if (object.timePeriod != null)
        message.timePeriod = String(object.timePeriod);
      if (object.weekNumber != null) {
        if ($util.Long)
          (message.weekNumber = $util.Long.fromValue(object.weekNumber)).unsigned = false;
        else if (typeof object.weekNumber === "string")
          message.weekNumber = parseInt(object.weekNumber, 10);
        else if (typeof object.weekNumber === "number")
          message.weekNumber = object.weekNumber;
        else if (typeof object.weekNumber === "object")
          message.weekNumber = new $util.LongBits(object.weekNumber.low >>> 0, object.weekNumber.high >>> 0).toNumber();
      }
      if (object.monthNumber != null) {
        if ($util.Long)
          (message.monthNumber = $util.Long.fromValue(object.monthNumber)).unsigned = false;
        else if (typeof object.monthNumber === "string")
          message.monthNumber = parseInt(object.monthNumber, 10);
        else if (typeof object.monthNumber === "number")
          message.monthNumber = object.monthNumber;
        else if (typeof object.monthNumber === "object")
          message.monthNumber = new $util.LongBits(object.monthNumber.low >>> 0, object.monthNumber.high >>> 0).toNumber();
      }
      if (object.startedAt != null) {
        if (typeof object.startedAt !== "object")
          throw TypeError(".dnse.DerivativesArenaUserRank.startedAt: object expected");
        message.startedAt = $root.google.protobuf.Timestamp.fromObject(object.startedAt);
      }
      if (object.endedAt != null) {
        if (typeof object.endedAt !== "object")
          throw TypeError(".dnse.DerivativesArenaUserRank.endedAt: object expected");
        message.endedAt = $root.google.protobuf.Timestamp.fromObject(object.endedAt);
      }
      if (object.totalProfitPoints != null)
        message.totalProfitPoints = Number(object.totalProfitPoints);
      if (object.highestProfitPoint != null)
        message.highestProfitPoint = Number(object.highestProfitPoint);
      if (object.totalNetRealizedProfits != null)
        message.totalNetRealizedProfits = Number(object.totalNetRealizedProfits);
      if (object.winningRate != null)
        message.winningRate = Number(object.winningRate);
      if (object.totalTransactions != null) {
        if ($util.Long)
          (message.totalTransactions = $util.Long.fromValue(object.totalTransactions)).unsigned = false;
        else if (typeof object.totalTransactions === "string")
          message.totalTransactions = parseInt(object.totalTransactions, 10);
        else if (typeof object.totalTransactions === "number")
          message.totalTransactions = object.totalTransactions;
        else if (typeof object.totalTransactions === "object")
          message.totalTransactions = new $util.LongBits(object.totalTransactions.low >>> 0, object.totalTransactions.high >>> 0).toNumber();
      }
      if (object.dealSide != null)
        message.dealSide = String(object.dealSide);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.DerivativesArenaUserRank.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.avatarUrl != null)
        message.avatarUrl = String(object.avatarUrl);
      if (object.yearNumber != null) {
        if ($util.Long)
          (message.yearNumber = $util.Long.fromValue(object.yearNumber)).unsigned = false;
        else if (typeof object.yearNumber === "string")
          message.yearNumber = parseInt(object.yearNumber, 10);
        else if (typeof object.yearNumber === "number")
          message.yearNumber = object.yearNumber;
        else if (typeof object.yearNumber === "object")
          message.yearNumber = new $util.LongBits(object.yearNumber.low >>> 0, object.yearNumber.high >>> 0).toNumber();
      }
      if (object.totalTransactionsClosedInPeriod != null) {
        if ($util.Long)
          (message.totalTransactionsClosedInPeriod = $util.Long.fromValue(object.totalTransactionsClosedInPeriod)).unsigned = false;
        else if (typeof object.totalTransactionsClosedInPeriod === "string")
          message.totalTransactionsClosedInPeriod = parseInt(object.totalTransactionsClosedInPeriod, 10);
        else if (typeof object.totalTransactionsClosedInPeriod === "number")
          message.totalTransactionsClosedInPeriod = object.totalTransactionsClosedInPeriod;
        else if (typeof object.totalTransactionsClosedInPeriod === "object")
          message.totalTransactionsClosedInPeriod = new $util.LongBits(object.totalTransactionsClosedInPeriod.low >>> 0, object.totalTransactionsClosedInPeriod.high >>> 0).toNumber();
      }
      return message;
    };
    DerivativesArenaUserRank.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.leaderboardType = options.enums === String ? "LB_TYPE_UNKNOWN" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.userId = options.longs === String ? "0" : 0;
        object.nickname = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.rank = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.rank = options.longs === String ? "0" : 0;
        object.timePeriod = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.weekNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.weekNumber = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.monthNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.monthNumber = options.longs === String ? "0" : 0;
        object.startedAt = null;
        object.endedAt = null;
        object.time = null;
        object.avatarUrl = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.yearNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.yearNumber = options.longs === String ? "0" : 0;
      }
      if (message.leaderboardType != null && message.hasOwnProperty("leaderboardType"))
        object.leaderboardType = options.enums === String ? $root.dnse.LeaderboardType[message.leaderboardType] : message.leaderboardType;
      if (message.userId != null && message.hasOwnProperty("userId"))
        if (typeof message.userId === "number")
          object.userId = options.longs === String ? String(message.userId) : message.userId;
        else
          object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
      if (message.nickname != null && message.hasOwnProperty("nickname"))
        object.nickname = message.nickname;
      if (message.rank != null && message.hasOwnProperty("rank"))
        if (typeof message.rank === "number")
          object.rank = options.longs === String ? String(message.rank) : message.rank;
        else
          object.rank = options.longs === String ? $util.Long.prototype.toString.call(message.rank) : options.longs === Number ? new $util.LongBits(message.rank.low >>> 0, message.rank.high >>> 0).toNumber() : message.rank;
      if (message.timePeriod != null && message.hasOwnProperty("timePeriod"))
        object.timePeriod = message.timePeriod;
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber"))
        if (typeof message.weekNumber === "number")
          object.weekNumber = options.longs === String ? String(message.weekNumber) : message.weekNumber;
        else
          object.weekNumber = options.longs === String ? $util.Long.prototype.toString.call(message.weekNumber) : options.longs === Number ? new $util.LongBits(message.weekNumber.low >>> 0, message.weekNumber.high >>> 0).toNumber() : message.weekNumber;
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber"))
        if (typeof message.monthNumber === "number")
          object.monthNumber = options.longs === String ? String(message.monthNumber) : message.monthNumber;
        else
          object.monthNumber = options.longs === String ? $util.Long.prototype.toString.call(message.monthNumber) : options.longs === Number ? new $util.LongBits(message.monthNumber.low >>> 0, message.monthNumber.high >>> 0).toNumber() : message.monthNumber;
      if (message.startedAt != null && message.hasOwnProperty("startedAt"))
        object.startedAt = $root.google.protobuf.Timestamp.toObject(message.startedAt, options);
      if (message.endedAt != null && message.hasOwnProperty("endedAt"))
        object.endedAt = $root.google.protobuf.Timestamp.toObject(message.endedAt, options);
      if (message.totalProfitPoints != null && message.hasOwnProperty("totalProfitPoints")) {
        object.totalProfitPoints = options.json && !isFinite(message.totalProfitPoints) ? String(message.totalProfitPoints) : message.totalProfitPoints;
        if (options.oneofs)
          object._totalProfitPoints = "totalProfitPoints";
      }
      if (message.highestProfitPoint != null && message.hasOwnProperty("highestProfitPoint")) {
        object.highestProfitPoint = options.json && !isFinite(message.highestProfitPoint) ? String(message.highestProfitPoint) : message.highestProfitPoint;
        if (options.oneofs)
          object._highestProfitPoint = "highestProfitPoint";
      }
      if (message.totalNetRealizedProfits != null && message.hasOwnProperty("totalNetRealizedProfits")) {
        object.totalNetRealizedProfits = options.json && !isFinite(message.totalNetRealizedProfits) ? String(message.totalNetRealizedProfits) : message.totalNetRealizedProfits;
        if (options.oneofs)
          object._totalNetRealizedProfits = "totalNetRealizedProfits";
      }
      if (message.winningRate != null && message.hasOwnProperty("winningRate")) {
        object.winningRate = options.json && !isFinite(message.winningRate) ? String(message.winningRate) : message.winningRate;
        if (options.oneofs)
          object._winningRate = "winningRate";
      }
      if (message.totalTransactions != null && message.hasOwnProperty("totalTransactions")) {
        if (typeof message.totalTransactions === "number")
          object.totalTransactions = options.longs === String ? String(message.totalTransactions) : message.totalTransactions;
        else
          object.totalTransactions = options.longs === String ? $util.Long.prototype.toString.call(message.totalTransactions) : options.longs === Number ? new $util.LongBits(message.totalTransactions.low >>> 0, message.totalTransactions.high >>> 0).toNumber() : message.totalTransactions;
        if (options.oneofs)
          object._totalTransactions = "totalTransactions";
      }
      if (message.dealSide != null && message.hasOwnProperty("dealSide")) {
        object.dealSide = message.dealSide;
        if (options.oneofs)
          object._dealSide = "dealSide";
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
        object.avatarUrl = message.avatarUrl;
      if (message.yearNumber != null && message.hasOwnProperty("yearNumber"))
        if (typeof message.yearNumber === "number")
          object.yearNumber = options.longs === String ? String(message.yearNumber) : message.yearNumber;
        else
          object.yearNumber = options.longs === String ? $util.Long.prototype.toString.call(message.yearNumber) : options.longs === Number ? new $util.LongBits(message.yearNumber.low >>> 0, message.yearNumber.high >>> 0).toNumber() : message.yearNumber;
      if (message.totalTransactionsClosedInPeriod != null && message.hasOwnProperty("totalTransactionsClosedInPeriod")) {
        if (typeof message.totalTransactionsClosedInPeriod === "number")
          object.totalTransactionsClosedInPeriod = options.longs === String ? String(message.totalTransactionsClosedInPeriod) : message.totalTransactionsClosedInPeriod;
        else
          object.totalTransactionsClosedInPeriod = options.longs === String ? $util.Long.prototype.toString.call(message.totalTransactionsClosedInPeriod) : options.longs === Number ? new $util.LongBits(message.totalTransactionsClosedInPeriod.low >>> 0, message.totalTransactionsClosedInPeriod.high >>> 0).toNumber() : message.totalTransactionsClosedInPeriod;
        if (options.oneofs)
          object._totalTransactionsClosedInPeriod = "totalTransactionsClosedInPeriod";
      }
      return object;
    };
    DerivativesArenaUserRank.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativesArenaUserRank;
  }();
  dnse2.DerivativesArenaTopUsers = function() {
    function DerivativesArenaTopUsers(properties) {
      this.topUsers = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DerivativesArenaTopUsers.prototype.leaderboardType = 0;
    DerivativesArenaTopUsers.prototype.topUsers = $util.emptyArray;
    DerivativesArenaTopUsers.prototype.hasWinner = false;
    DerivativesArenaTopUsers.prototype.yearNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaTopUsers.prototype.timePeriod = "";
    DerivativesArenaTopUsers.prototype.weekNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaTopUsers.prototype.monthNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DerivativesArenaTopUsers.prototype.startedAt = null;
    DerivativesArenaTopUsers.prototype.endedAt = null;
    DerivativesArenaTopUsers.prototype.nextStartedAt = null;
    DerivativesArenaTopUsers.prototype.time = null;
    let $oneOfFields;
    Object.defineProperty(DerivativesArenaTopUsers.prototype, "_nextStartedAt", {
      get: $util.oneOfGetter($oneOfFields = ["nextStartedAt"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    DerivativesArenaTopUsers.create = function create(properties) {
      return new DerivativesArenaTopUsers(properties);
    };
    DerivativesArenaTopUsers.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.leaderboardType != null && Object.hasOwnProperty.call(message, "leaderboardType"))
        writer.uint32(8).int32(message.leaderboardType);
      if (message.topUsers != null && message.topUsers.length)
        for (let i = 0; i < message.topUsers.length; ++i)
          $root.dnse.DerivativesArenaUserRank.encode(message.topUsers[i], writer.uint32(18).fork()).ldelim();
      if (message.hasWinner != null && Object.hasOwnProperty.call(message, "hasWinner"))
        writer.uint32(24).bool(message.hasWinner);
      if (message.yearNumber != null && Object.hasOwnProperty.call(message, "yearNumber"))
        writer.uint32(32).int64(message.yearNumber);
      if (message.timePeriod != null && Object.hasOwnProperty.call(message, "timePeriod"))
        writer.uint32(42).string(message.timePeriod);
      if (message.weekNumber != null && Object.hasOwnProperty.call(message, "weekNumber"))
        writer.uint32(48).int64(message.weekNumber);
      if (message.monthNumber != null && Object.hasOwnProperty.call(message, "monthNumber"))
        writer.uint32(56).int64(message.monthNumber);
      if (message.startedAt != null && Object.hasOwnProperty.call(message, "startedAt"))
        $root.google.protobuf.Timestamp.encode(message.startedAt, writer.uint32(66).fork()).ldelim();
      if (message.endedAt != null && Object.hasOwnProperty.call(message, "endedAt"))
        $root.google.protobuf.Timestamp.encode(message.endedAt, writer.uint32(74).fork()).ldelim();
      if (message.nextStartedAt != null && Object.hasOwnProperty.call(message, "nextStartedAt"))
        $root.google.protobuf.Timestamp.encode(message.nextStartedAt, writer.uint32(82).fork()).ldelim();
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(130).fork()).ldelim();
      return writer;
    };
    DerivativesArenaTopUsers.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DerivativesArenaTopUsers.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DerivativesArenaTopUsers();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.leaderboardType = reader.int32();
            break;
          case 2:
            if (!(message.topUsers && message.topUsers.length))
              message.topUsers = [];
            message.topUsers.push($root.dnse.DerivativesArenaUserRank.decode(reader, reader.uint32()));
            break;
          case 3:
            message.hasWinner = reader.bool();
            break;
          case 4:
            message.yearNumber = reader.int64();
            break;
          case 5:
            message.timePeriod = reader.string();
            break;
          case 6:
            message.weekNumber = reader.int64();
            break;
          case 7:
            message.monthNumber = reader.int64();
            break;
          case 8:
            message.startedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.endedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.nextStartedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 16:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DerivativesArenaTopUsers.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DerivativesArenaTopUsers.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.leaderboardType != null && message.hasOwnProperty("leaderboardType"))
        switch (message.leaderboardType) {
          default:
            return "leaderboardType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.topUsers != null && message.hasOwnProperty("topUsers")) {
        if (!Array.isArray(message.topUsers))
          return "topUsers: array expected";
        for (let i = 0; i < message.topUsers.length; ++i) {
          let error = $root.dnse.DerivativesArenaUserRank.verify(message.topUsers[i]);
          if (error)
            return "topUsers." + error;
        }
      }
      if (message.hasWinner != null && message.hasOwnProperty("hasWinner")) {
        if (typeof message.hasWinner !== "boolean")
          return "hasWinner: boolean expected";
      }
      if (message.yearNumber != null && message.hasOwnProperty("yearNumber")) {
        if (!$util.isInteger(message.yearNumber) && !(message.yearNumber && $util.isInteger(message.yearNumber.low) && $util.isInteger(message.yearNumber.high)))
          return "yearNumber: integer|Long expected";
      }
      if (message.timePeriod != null && message.hasOwnProperty("timePeriod")) {
        if (!$util.isString(message.timePeriod))
          return "timePeriod: string expected";
      }
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber")) {
        if (!$util.isInteger(message.weekNumber) && !(message.weekNumber && $util.isInteger(message.weekNumber.low) && $util.isInteger(message.weekNumber.high)))
          return "weekNumber: integer|Long expected";
      }
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber")) {
        if (!$util.isInteger(message.monthNumber) && !(message.monthNumber && $util.isInteger(message.monthNumber.low) && $util.isInteger(message.monthNumber.high)))
          return "monthNumber: integer|Long expected";
      }
      if (message.startedAt != null && message.hasOwnProperty("startedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.startedAt);
        if (error)
          return "startedAt." + error;
      }
      if (message.endedAt != null && message.hasOwnProperty("endedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.endedAt);
        if (error)
          return "endedAt." + error;
      }
      if (message.nextStartedAt != null && message.hasOwnProperty("nextStartedAt")) {
        {
          let error = $root.google.protobuf.Timestamp.verify(message.nextStartedAt);
          if (error)
            return "nextStartedAt." + error;
        }
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    DerivativesArenaTopUsers.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DerivativesArenaTopUsers)
        return object;
      let message = new $root.dnse.DerivativesArenaTopUsers();
      switch (object.leaderboardType) {
        case "LB_TYPE_UNKNOWN":
        case 0:
          message.leaderboardType = 0;
          break;
        case "LB_TYPE_TOTAL_PROFIT_POINTS":
        case 1:
          message.leaderboardType = 1;
          break;
        case "LB_TYPE_HIGHEST_PROFIT_POINT":
        case 2:
          message.leaderboardType = 2;
          break;
        case "LB_TYPE_TOTAL_NET_REALIZED_PROFITS":
        case 3:
          message.leaderboardType = 3;
          break;
        case "LB_TYPE_WINNING_RATE":
        case 4:
          message.leaderboardType = 4;
          break;
      }
      if (object.topUsers) {
        if (!Array.isArray(object.topUsers))
          throw TypeError(".dnse.DerivativesArenaTopUsers.topUsers: array expected");
        message.topUsers = [];
        for (let i = 0; i < object.topUsers.length; ++i) {
          if (typeof object.topUsers[i] !== "object")
            throw TypeError(".dnse.DerivativesArenaTopUsers.topUsers: object expected");
          message.topUsers[i] = $root.dnse.DerivativesArenaUserRank.fromObject(object.topUsers[i]);
        }
      }
      if (object.hasWinner != null)
        message.hasWinner = Boolean(object.hasWinner);
      if (object.yearNumber != null) {
        if ($util.Long)
          (message.yearNumber = $util.Long.fromValue(object.yearNumber)).unsigned = false;
        else if (typeof object.yearNumber === "string")
          message.yearNumber = parseInt(object.yearNumber, 10);
        else if (typeof object.yearNumber === "number")
          message.yearNumber = object.yearNumber;
        else if (typeof object.yearNumber === "object")
          message.yearNumber = new $util.LongBits(object.yearNumber.low >>> 0, object.yearNumber.high >>> 0).toNumber();
      }
      if (object.timePeriod != null)
        message.timePeriod = String(object.timePeriod);
      if (object.weekNumber != null) {
        if ($util.Long)
          (message.weekNumber = $util.Long.fromValue(object.weekNumber)).unsigned = false;
        else if (typeof object.weekNumber === "string")
          message.weekNumber = parseInt(object.weekNumber, 10);
        else if (typeof object.weekNumber === "number")
          message.weekNumber = object.weekNumber;
        else if (typeof object.weekNumber === "object")
          message.weekNumber = new $util.LongBits(object.weekNumber.low >>> 0, object.weekNumber.high >>> 0).toNumber();
      }
      if (object.monthNumber != null) {
        if ($util.Long)
          (message.monthNumber = $util.Long.fromValue(object.monthNumber)).unsigned = false;
        else if (typeof object.monthNumber === "string")
          message.monthNumber = parseInt(object.monthNumber, 10);
        else if (typeof object.monthNumber === "number")
          message.monthNumber = object.monthNumber;
        else if (typeof object.monthNumber === "object")
          message.monthNumber = new $util.LongBits(object.monthNumber.low >>> 0, object.monthNumber.high >>> 0).toNumber();
      }
      if (object.startedAt != null) {
        if (typeof object.startedAt !== "object")
          throw TypeError(".dnse.DerivativesArenaTopUsers.startedAt: object expected");
        message.startedAt = $root.google.protobuf.Timestamp.fromObject(object.startedAt);
      }
      if (object.endedAt != null) {
        if (typeof object.endedAt !== "object")
          throw TypeError(".dnse.DerivativesArenaTopUsers.endedAt: object expected");
        message.endedAt = $root.google.protobuf.Timestamp.fromObject(object.endedAt);
      }
      if (object.nextStartedAt != null) {
        if (typeof object.nextStartedAt !== "object")
          throw TypeError(".dnse.DerivativesArenaTopUsers.nextStartedAt: object expected");
        message.nextStartedAt = $root.google.protobuf.Timestamp.fromObject(object.nextStartedAt);
      }
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.DerivativesArenaTopUsers.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    DerivativesArenaTopUsers.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.topUsers = [];
      if (options.defaults) {
        object.leaderboardType = options.enums === String ? "LB_TYPE_UNKNOWN" : 0;
        object.hasWinner = false;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.yearNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.yearNumber = options.longs === String ? "0" : 0;
        object.timePeriod = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.weekNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.weekNumber = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.monthNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.monthNumber = options.longs === String ? "0" : 0;
        object.startedAt = null;
        object.endedAt = null;
        object.time = null;
      }
      if (message.leaderboardType != null && message.hasOwnProperty("leaderboardType"))
        object.leaderboardType = options.enums === String ? $root.dnse.LeaderboardType[message.leaderboardType] : message.leaderboardType;
      if (message.topUsers && message.topUsers.length) {
        object.topUsers = [];
        for (let j = 0; j < message.topUsers.length; ++j)
          object.topUsers[j] = $root.dnse.DerivativesArenaUserRank.toObject(message.topUsers[j], options);
      }
      if (message.hasWinner != null && message.hasOwnProperty("hasWinner"))
        object.hasWinner = message.hasWinner;
      if (message.yearNumber != null && message.hasOwnProperty("yearNumber"))
        if (typeof message.yearNumber === "number")
          object.yearNumber = options.longs === String ? String(message.yearNumber) : message.yearNumber;
        else
          object.yearNumber = options.longs === String ? $util.Long.prototype.toString.call(message.yearNumber) : options.longs === Number ? new $util.LongBits(message.yearNumber.low >>> 0, message.yearNumber.high >>> 0).toNumber() : message.yearNumber;
      if (message.timePeriod != null && message.hasOwnProperty("timePeriod"))
        object.timePeriod = message.timePeriod;
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber"))
        if (typeof message.weekNumber === "number")
          object.weekNumber = options.longs === String ? String(message.weekNumber) : message.weekNumber;
        else
          object.weekNumber = options.longs === String ? $util.Long.prototype.toString.call(message.weekNumber) : options.longs === Number ? new $util.LongBits(message.weekNumber.low >>> 0, message.weekNumber.high >>> 0).toNumber() : message.weekNumber;
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber"))
        if (typeof message.monthNumber === "number")
          object.monthNumber = options.longs === String ? String(message.monthNumber) : message.monthNumber;
        else
          object.monthNumber = options.longs === String ? $util.Long.prototype.toString.call(message.monthNumber) : options.longs === Number ? new $util.LongBits(message.monthNumber.low >>> 0, message.monthNumber.high >>> 0).toNumber() : message.monthNumber;
      if (message.startedAt != null && message.hasOwnProperty("startedAt"))
        object.startedAt = $root.google.protobuf.Timestamp.toObject(message.startedAt, options);
      if (message.endedAt != null && message.hasOwnProperty("endedAt"))
        object.endedAt = $root.google.protobuf.Timestamp.toObject(message.endedAt, options);
      if (message.nextStartedAt != null && message.hasOwnProperty("nextStartedAt")) {
        object.nextStartedAt = $root.google.protobuf.Timestamp.toObject(message.nextStartedAt, options);
        if (options.oneofs)
          object._nextStartedAt = "nextStartedAt";
      }
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    DerivativesArenaTopUsers.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DerivativesArenaTopUsers;
  }();
  dnse2.TimePeriod = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "WEEKLY"] = 0;
    values[valuesById[1] = "MONTHLY"] = 1;
    return values;
  }();
  dnse2.LeaderboardResult = function() {
    function LeaderboardResult(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LeaderboardResult.prototype.type = 0;
    LeaderboardResult.prototype.rank = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    LeaderboardResult.prototype.showedValue = 0;
    LeaderboardResult.create = function create(properties) {
      return new LeaderboardResult(properties);
    };
    LeaderboardResult.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
        writer.uint32(16).int64(message.rank);
      if (message.showedValue != null && Object.hasOwnProperty.call(message, "showedValue"))
        writer.uint32(25).double(message.showedValue);
      return writer;
    };
    LeaderboardResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LeaderboardResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LeaderboardResult();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.rank = reader.int64();
            break;
          case 3:
            message.showedValue = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LeaderboardResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LeaderboardResult.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.rank != null && message.hasOwnProperty("rank")) {
        if (!$util.isInteger(message.rank) && !(message.rank && $util.isInteger(message.rank.low) && $util.isInteger(message.rank.high)))
          return "rank: integer|Long expected";
      }
      if (message.showedValue != null && message.hasOwnProperty("showedValue")) {
        if (typeof message.showedValue !== "number")
          return "showedValue: number expected";
      }
      return null;
    };
    LeaderboardResult.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LeaderboardResult)
        return object;
      let message = new $root.dnse.LeaderboardResult();
      switch (object.type) {
        case "LB_TYPE_UNKNOWN":
        case 0:
          message.type = 0;
          break;
        case "LB_TYPE_TOTAL_PROFIT_POINTS":
        case 1:
          message.type = 1;
          break;
        case "LB_TYPE_HIGHEST_PROFIT_POINT":
        case 2:
          message.type = 2;
          break;
        case "LB_TYPE_TOTAL_NET_REALIZED_PROFITS":
        case 3:
          message.type = 3;
          break;
        case "LB_TYPE_WINNING_RATE":
        case 4:
          message.type = 4;
          break;
      }
      if (object.rank != null) {
        if ($util.Long)
          (message.rank = $util.Long.fromValue(object.rank)).unsigned = false;
        else if (typeof object.rank === "string")
          message.rank = parseInt(object.rank, 10);
        else if (typeof object.rank === "number")
          message.rank = object.rank;
        else if (typeof object.rank === "object")
          message.rank = new $util.LongBits(object.rank.low >>> 0, object.rank.high >>> 0).toNumber();
      }
      if (object.showedValue != null)
        message.showedValue = Number(object.showedValue);
      return message;
    };
    LeaderboardResult.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? "LB_TYPE_UNKNOWN" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.rank = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.rank = options.longs === String ? "0" : 0;
        object.showedValue = 0;
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.LeaderboardType[message.type] : message.type;
      if (message.rank != null && message.hasOwnProperty("rank"))
        if (typeof message.rank === "number")
          object.rank = options.longs === String ? String(message.rank) : message.rank;
        else
          object.rank = options.longs === String ? $util.Long.prototype.toString.call(message.rank) : options.longs === Number ? new $util.LongBits(message.rank.low >>> 0, message.rank.high >>> 0).toNumber() : message.rank;
      if (message.showedValue != null && message.hasOwnProperty("showedValue"))
        object.showedValue = options.json && !isFinite(message.showedValue) ? String(message.showedValue) : message.showedValue;
      return object;
    };
    LeaderboardResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LeaderboardResult;
  }();
  dnse2.NotifyEnboxLeaderboardResult = function() {
    function NotifyEnboxLeaderboardResult(properties) {
      this.results = [];
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NotifyEnboxLeaderboardResult.prototype.type = 0;
    NotifyEnboxLeaderboardResult.prototype.weekNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnboxLeaderboardResult.prototype.monthNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnboxLeaderboardResult.prototype.timePeriod = 0;
    NotifyEnboxLeaderboardResult.prototype.results = $util.emptyArray;
    NotifyEnboxLeaderboardResult.prototype.startDate = null;
    NotifyEnboxLeaderboardResult.prototype.endDate = null;
    NotifyEnboxLeaderboardResult.prototype.investorId = "";
    NotifyEnboxLeaderboardResult.create = function create(properties) {
      return new NotifyEnboxLeaderboardResult(properties);
    };
    NotifyEnboxLeaderboardResult.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.weekNumber != null && Object.hasOwnProperty.call(message, "weekNumber"))
        writer.uint32(16).int64(message.weekNumber);
      if (message.monthNumber != null && Object.hasOwnProperty.call(message, "monthNumber"))
        writer.uint32(24).int64(message.monthNumber);
      if (message.timePeriod != null && Object.hasOwnProperty.call(message, "timePeriod"))
        writer.uint32(32).int32(message.timePeriod);
      if (message.results != null && message.results.length)
        for (let i = 0; i < message.results.length; ++i)
          $root.dnse.LeaderboardResult.encode(message.results[i], writer.uint32(42).fork()).ldelim();
      if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
        $root.google.protobuf.Timestamp.encode(message.startDate, writer.uint32(50).fork()).ldelim();
      if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
        $root.google.protobuf.Timestamp.encode(message.endDate, writer.uint32(58).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(66).string(message.investorId);
      return writer;
    };
    NotifyEnboxLeaderboardResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NotifyEnboxLeaderboardResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NotifyEnboxLeaderboardResult();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.weekNumber = reader.int64();
            break;
          case 3:
            message.monthNumber = reader.int64();
            break;
          case 4:
            message.timePeriod = reader.int32();
            break;
          case 5:
            if (!(message.results && message.results.length))
              message.results = [];
            message.results.push($root.dnse.LeaderboardResult.decode(reader, reader.uint32()));
            break;
          case 6:
            message.startDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.endDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NotifyEnboxLeaderboardResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NotifyEnboxLeaderboardResult.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
            break;
        }
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber")) {
        if (!$util.isInteger(message.weekNumber) && !(message.weekNumber && $util.isInteger(message.weekNumber.low) && $util.isInteger(message.weekNumber.high)))
          return "weekNumber: integer|Long expected";
      }
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber")) {
        if (!$util.isInteger(message.monthNumber) && !(message.monthNumber && $util.isInteger(message.monthNumber.low) && $util.isInteger(message.monthNumber.high)))
          return "monthNumber: integer|Long expected";
      }
      if (message.timePeriod != null && message.hasOwnProperty("timePeriod"))
        switch (message.timePeriod) {
          default:
            return "timePeriod: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (message.results != null && message.hasOwnProperty("results")) {
        if (!Array.isArray(message.results))
          return "results: array expected";
        for (let i = 0; i < message.results.length; ++i) {
          let error = $root.dnse.LeaderboardResult.verify(message.results[i]);
          if (error)
            return "results." + error;
        }
      }
      if (message.startDate != null && message.hasOwnProperty("startDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.startDate);
        if (error)
          return "startDate." + error;
      }
      if (message.endDate != null && message.hasOwnProperty("endDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.endDate);
        if (error)
          return "endDate." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    NotifyEnboxLeaderboardResult.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NotifyEnboxLeaderboardResult)
        return object;
      let message = new $root.dnse.NotifyEnboxLeaderboardResult();
      switch (object.type) {
        case "NOTIFY_PERSONAL_LEADERBOARD_RESULT":
        case 0:
          message.type = 0;
          break;
      }
      if (object.weekNumber != null) {
        if ($util.Long)
          (message.weekNumber = $util.Long.fromValue(object.weekNumber)).unsigned = false;
        else if (typeof object.weekNumber === "string")
          message.weekNumber = parseInt(object.weekNumber, 10);
        else if (typeof object.weekNumber === "number")
          message.weekNumber = object.weekNumber;
        else if (typeof object.weekNumber === "object")
          message.weekNumber = new $util.LongBits(object.weekNumber.low >>> 0, object.weekNumber.high >>> 0).toNumber();
      }
      if (object.monthNumber != null) {
        if ($util.Long)
          (message.monthNumber = $util.Long.fromValue(object.monthNumber)).unsigned = false;
        else if (typeof object.monthNumber === "string")
          message.monthNumber = parseInt(object.monthNumber, 10);
        else if (typeof object.monthNumber === "number")
          message.monthNumber = object.monthNumber;
        else if (typeof object.monthNumber === "object")
          message.monthNumber = new $util.LongBits(object.monthNumber.low >>> 0, object.monthNumber.high >>> 0).toNumber();
      }
      switch (object.timePeriod) {
        case "WEEKLY":
        case 0:
          message.timePeriod = 0;
          break;
        case "MONTHLY":
        case 1:
          message.timePeriod = 1;
          break;
      }
      if (object.results) {
        if (!Array.isArray(object.results))
          throw TypeError(".dnse.NotifyEnboxLeaderboardResult.results: array expected");
        message.results = [];
        for (let i = 0; i < object.results.length; ++i) {
          if (typeof object.results[i] !== "object")
            throw TypeError(".dnse.NotifyEnboxLeaderboardResult.results: object expected");
          message.results[i] = $root.dnse.LeaderboardResult.fromObject(object.results[i]);
        }
      }
      if (object.startDate != null) {
        if (typeof object.startDate !== "object")
          throw TypeError(".dnse.NotifyEnboxLeaderboardResult.startDate: object expected");
        message.startDate = $root.google.protobuf.Timestamp.fromObject(object.startDate);
      }
      if (object.endDate != null) {
        if (typeof object.endDate !== "object")
          throw TypeError(".dnse.NotifyEnboxLeaderboardResult.endDate: object expected");
        message.endDate = $root.google.protobuf.Timestamp.fromObject(object.endDate);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    NotifyEnboxLeaderboardResult.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.arrays || options.defaults)
        object.results = [];
      if (options.defaults) {
        object.type = options.enums === String ? "NOTIFY_PERSONAL_LEADERBOARD_RESULT" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.weekNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.weekNumber = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.monthNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.monthNumber = options.longs === String ? "0" : 0;
        object.timePeriod = options.enums === String ? "WEEKLY" : 0;
        object.startDate = null;
        object.endDate = null;
        object.investorId = "";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.NotifyEnboxLeaderboardResult.Type[message.type] : message.type;
      if (message.weekNumber != null && message.hasOwnProperty("weekNumber"))
        if (typeof message.weekNumber === "number")
          object.weekNumber = options.longs === String ? String(message.weekNumber) : message.weekNumber;
        else
          object.weekNumber = options.longs === String ? $util.Long.prototype.toString.call(message.weekNumber) : options.longs === Number ? new $util.LongBits(message.weekNumber.low >>> 0, message.weekNumber.high >>> 0).toNumber() : message.weekNumber;
      if (message.monthNumber != null && message.hasOwnProperty("monthNumber"))
        if (typeof message.monthNumber === "number")
          object.monthNumber = options.longs === String ? String(message.monthNumber) : message.monthNumber;
        else
          object.monthNumber = options.longs === String ? $util.Long.prototype.toString.call(message.monthNumber) : options.longs === Number ? new $util.LongBits(message.monthNumber.low >>> 0, message.monthNumber.high >>> 0).toNumber() : message.monthNumber;
      if (message.timePeriod != null && message.hasOwnProperty("timePeriod"))
        object.timePeriod = options.enums === String ? $root.dnse.TimePeriod[message.timePeriod] : message.timePeriod;
      if (message.results && message.results.length) {
        object.results = [];
        for (let j = 0; j < message.results.length; ++j)
          object.results[j] = $root.dnse.LeaderboardResult.toObject(message.results[j], options);
      }
      if (message.startDate != null && message.hasOwnProperty("startDate"))
        object.startDate = $root.google.protobuf.Timestamp.toObject(message.startDate, options);
      if (message.endDate != null && message.hasOwnProperty("endDate"))
        object.endDate = $root.google.protobuf.Timestamp.toObject(message.endDate, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    NotifyEnboxLeaderboardResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    NotifyEnboxLeaderboardResult.Type = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "NOTIFY_PERSONAL_LEADERBOARD_RESULT"] = 0;
      return values;
    }();
    return NotifyEnboxLeaderboardResult;
  }();
  dnse2.LoyaltyState = function() {
    function LoyaltyState(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoyaltyState.prototype.point = 0;
    LoyaltyState.prototype.ratingPoint = 0;
    LoyaltyState.prototype.level = "";
    LoyaltyState.prototype.modifiedDate = "";
    LoyaltyState.create = function create(properties) {
      return new LoyaltyState(properties);
    };
    LoyaltyState.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.point != null && Object.hasOwnProperty.call(message, "point"))
        writer.uint32(9).double(message.point);
      if (message.ratingPoint != null && Object.hasOwnProperty.call(message, "ratingPoint"))
        writer.uint32(17).double(message.ratingPoint);
      if (message.level != null && Object.hasOwnProperty.call(message, "level"))
        writer.uint32(26).string(message.level);
      if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
        writer.uint32(34).string(message.modifiedDate);
      return writer;
    };
    LoyaltyState.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoyaltyState.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoyaltyState();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.point = reader.double();
            break;
          case 2:
            message.ratingPoint = reader.double();
            break;
          case 3:
            message.level = reader.string();
            break;
          case 4:
            message.modifiedDate = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoyaltyState.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoyaltyState.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.point != null && message.hasOwnProperty("point")) {
        if (typeof message.point !== "number")
          return "point: number expected";
      }
      if (message.ratingPoint != null && message.hasOwnProperty("ratingPoint")) {
        if (typeof message.ratingPoint !== "number")
          return "ratingPoint: number expected";
      }
      if (message.level != null && message.hasOwnProperty("level")) {
        if (!$util.isString(message.level))
          return "level: string expected";
      }
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
        if (!$util.isString(message.modifiedDate))
          return "modifiedDate: string expected";
      }
      return null;
    };
    LoyaltyState.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoyaltyState)
        return object;
      let message = new $root.dnse.LoyaltyState();
      if (object.point != null)
        message.point = Number(object.point);
      if (object.ratingPoint != null)
        message.ratingPoint = Number(object.ratingPoint);
      if (object.level != null)
        message.level = String(object.level);
      if (object.modifiedDate != null)
        message.modifiedDate = String(object.modifiedDate);
      return message;
    };
    LoyaltyState.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.point = 0;
        object.ratingPoint = 0;
        object.level = "";
        object.modifiedDate = "";
      }
      if (message.point != null && message.hasOwnProperty("point"))
        object.point = options.json && !isFinite(message.point) ? String(message.point) : message.point;
      if (message.ratingPoint != null && message.hasOwnProperty("ratingPoint"))
        object.ratingPoint = options.json && !isFinite(message.ratingPoint) ? String(message.ratingPoint) : message.ratingPoint;
      if (message.level != null && message.hasOwnProperty("level"))
        object.level = message.level;
      if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
        object.modifiedDate = message.modifiedDate;
      return object;
    };
    LoyaltyState.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoyaltyState;
  }();
  dnse2.LoyaltyStateChange = function() {
    function LoyaltyStateChange(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoyaltyStateChange.prototype.type = 0;
    LoyaltyStateChange.prototype.state = null;
    LoyaltyStateChange.prototype.transactionId = "";
    LoyaltyStateChange.prototype.pointChange = 0;
    LoyaltyStateChange.prototype.ratingPointChange = 0;
    LoyaltyStateChange.prototype.historyId = "";
    LoyaltyStateChange.create = function create(properties) {
      return new LoyaltyStateChange(properties);
    };
    LoyaltyStateChange.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.state != null && Object.hasOwnProperty.call(message, "state"))
        $root.dnse.LoyaltyState.encode(message.state, writer.uint32(18).fork()).ldelim();
      if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
        writer.uint32(26).string(message.transactionId);
      if (message.pointChange != null && Object.hasOwnProperty.call(message, "pointChange"))
        writer.uint32(33).double(message.pointChange);
      if (message.ratingPointChange != null && Object.hasOwnProperty.call(message, "ratingPointChange"))
        writer.uint32(41).double(message.ratingPointChange);
      if (message.historyId != null && Object.hasOwnProperty.call(message, "historyId"))
        writer.uint32(50).string(message.historyId);
      return writer;
    };
    LoyaltyStateChange.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoyaltyStateChange.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoyaltyStateChange();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.state = $root.dnse.LoyaltyState.decode(reader, reader.uint32());
            break;
          case 3:
            message.transactionId = reader.string();
            break;
          case 4:
            message.pointChange = reader.double();
            break;
          case 5:
            message.ratingPointChange = reader.double();
            break;
          case 6:
            message.historyId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoyaltyStateChange.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoyaltyStateChange.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
            break;
        }
      if (message.state != null && message.hasOwnProperty("state")) {
        let error = $root.dnse.LoyaltyState.verify(message.state);
        if (error)
          return "state." + error;
      }
      if (message.transactionId != null && message.hasOwnProperty("transactionId")) {
        if (!$util.isString(message.transactionId))
          return "transactionId: string expected";
      }
      if (message.pointChange != null && message.hasOwnProperty("pointChange")) {
        if (typeof message.pointChange !== "number")
          return "pointChange: number expected";
      }
      if (message.ratingPointChange != null && message.hasOwnProperty("ratingPointChange")) {
        if (typeof message.ratingPointChange !== "number")
          return "ratingPointChange: number expected";
      }
      if (message.historyId != null && message.hasOwnProperty("historyId")) {
        if (!$util.isString(message.historyId))
          return "historyId: string expected";
      }
      return null;
    };
    LoyaltyStateChange.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoyaltyStateChange)
        return object;
      let message = new $root.dnse.LoyaltyStateChange();
      switch (object.type) {
        case "UNDERLYING_ORDER":
        case 0:
          message.type = 0;
          break;
        case "DERIVATIVE_ORDER":
        case 1:
          message.type = 1;
          break;
        case "MARGIN":
        case 2:
          message.type = 2;
          break;
        case "MGM_OPEN_ACCOUNT_SUCCESS":
        case 3:
          message.type = 3;
          break;
        case "MGM_ACTIVE_ACCOUNT_SUCCESS":
        case 4:
          message.type = 4;
          break;
        case "MGM_FIRST_UNDERLYING_ORDER":
        case 5:
          message.type = 5;
          break;
        case "MGM_FIRST_DERIVATIVE_ORDER":
        case 6:
          message.type = 6;
          break;
        case "MGM_FIRST_MARGIN":
        case 7:
          message.type = 7;
          break;
      }
      if (object.state != null) {
        if (typeof object.state !== "object")
          throw TypeError(".dnse.LoyaltyStateChange.state: object expected");
        message.state = $root.dnse.LoyaltyState.fromObject(object.state);
      }
      if (object.transactionId != null)
        message.transactionId = String(object.transactionId);
      if (object.pointChange != null)
        message.pointChange = Number(object.pointChange);
      if (object.ratingPointChange != null)
        message.ratingPointChange = Number(object.ratingPointChange);
      if (object.historyId != null)
        message.historyId = String(object.historyId);
      return message;
    };
    LoyaltyStateChange.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? "UNDERLYING_ORDER" : 0;
        object.state = null;
        object.transactionId = "";
        object.pointChange = 0;
        object.ratingPointChange = 0;
        object.historyId = "";
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.LoyaltyStateChange.EventType[message.type] : message.type;
      if (message.state != null && message.hasOwnProperty("state"))
        object.state = $root.dnse.LoyaltyState.toObject(message.state, options);
      if (message.transactionId != null && message.hasOwnProperty("transactionId"))
        object.transactionId = message.transactionId;
      if (message.pointChange != null && message.hasOwnProperty("pointChange"))
        object.pointChange = options.json && !isFinite(message.pointChange) ? String(message.pointChange) : message.pointChange;
      if (message.ratingPointChange != null && message.hasOwnProperty("ratingPointChange"))
        object.ratingPointChange = options.json && !isFinite(message.ratingPointChange) ? String(message.ratingPointChange) : message.ratingPointChange;
      if (message.historyId != null && message.hasOwnProperty("historyId"))
        object.historyId = message.historyId;
      return object;
    };
    LoyaltyStateChange.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    LoyaltyStateChange.EventType = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNDERLYING_ORDER"] = 0;
      values[valuesById[1] = "DERIVATIVE_ORDER"] = 1;
      values[valuesById[2] = "MARGIN"] = 2;
      values[valuesById[3] = "MGM_OPEN_ACCOUNT_SUCCESS"] = 3;
      values[valuesById[4] = "MGM_ACTIVE_ACCOUNT_SUCCESS"] = 4;
      values[valuesById[5] = "MGM_FIRST_UNDERLYING_ORDER"] = 5;
      values[valuesById[6] = "MGM_FIRST_DERIVATIVE_ORDER"] = 6;
      values[valuesById[7] = "MGM_FIRST_MARGIN"] = 7;
      return values;
    }();
    return LoyaltyStateChange;
  }();
  dnse2.bond = function() {
    const bond = {};
    bond.v1 = function() {
      const v1 = {};
      v1.Portfolio = function() {
        function Portfolio(properties) {
          this.interestSchedules = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Portfolio.prototype.custodyCode = "";
        Portfolio.prototype.investorId = "";
        Portfolio.prototype.accountNo = "";
        Portfolio.prototype.symbol = "";
        Portfolio.prototype.tradeQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Portfolio.prototype.receivingQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Portfolio.prototype.holdQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Portfolio.prototype.restrictedQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Portfolio.prototype.marketPrice = 0;
        Portfolio.prototype.tradeMarketValue = 0;
        Portfolio.prototype.receivingMarketValue = 0;
        Portfolio.prototype.holdMarketValue = 0;
        Portfolio.prototype.totalMarketValue = 0;
        Portfolio.prototype.denominationPrice = 0;
        Portfolio.prototype.tradeDenominationValue = 0;
        Portfolio.prototype.receivingDenominationValue = 0;
        Portfolio.prototype.holdDenominationValue = 0;
        Portfolio.prototype.totalDenominationValue = 0;
        Portfolio.prototype.costPrice = 0;
        Portfolio.prototype.tradeCostValue = 0;
        Portfolio.prototype.receivingCostValue = 0;
        Portfolio.prototype.holdCostValue = 0;
        Portfolio.prototype.totalCostValue = 0;
        Portfolio.prototype.grossCouponInterestCurrentAmount = 0;
        Portfolio.prototype.netCouponInterestCurrentAmount = 0;
        Portfolio.prototype.estimateGrossBasicPrice = 0;
        Portfolio.prototype.estimateNetBasicPrice = 0;
        Portfolio.prototype.estimateTaxAndFee = 0;
        Portfolio.prototype.estimatePnl = 0;
        Portfolio.prototype.interestSchedules = $util.emptyArray;
        Portfolio.prototype.totalQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Portfolio.create = function create(properties) {
          return new Portfolio(properties);
        };
        Portfolio.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(10).string(message.custodyCode);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(18).string(message.investorId);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(26).string(message.accountNo);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(34).string(message.symbol);
          if (message.tradeQuantity != null && Object.hasOwnProperty.call(message, "tradeQuantity"))
            writer.uint32(40).int64(message.tradeQuantity);
          if (message.receivingQuantity != null && Object.hasOwnProperty.call(message, "receivingQuantity"))
            writer.uint32(48).int64(message.receivingQuantity);
          if (message.holdQuantity != null && Object.hasOwnProperty.call(message, "holdQuantity"))
            writer.uint32(56).int64(message.holdQuantity);
          if (message.restrictedQuantity != null && Object.hasOwnProperty.call(message, "restrictedQuantity"))
            writer.uint32(64).int64(message.restrictedQuantity);
          if (message.marketPrice != null && Object.hasOwnProperty.call(message, "marketPrice"))
            writer.uint32(73).double(message.marketPrice);
          if (message.tradeMarketValue != null && Object.hasOwnProperty.call(message, "tradeMarketValue"))
            writer.uint32(81).double(message.tradeMarketValue);
          if (message.receivingMarketValue != null && Object.hasOwnProperty.call(message, "receivingMarketValue"))
            writer.uint32(89).double(message.receivingMarketValue);
          if (message.holdMarketValue != null && Object.hasOwnProperty.call(message, "holdMarketValue"))
            writer.uint32(97).double(message.holdMarketValue);
          if (message.totalMarketValue != null && Object.hasOwnProperty.call(message, "totalMarketValue"))
            writer.uint32(105).double(message.totalMarketValue);
          if (message.denominationPrice != null && Object.hasOwnProperty.call(message, "denominationPrice"))
            writer.uint32(113).double(message.denominationPrice);
          if (message.tradeDenominationValue != null && Object.hasOwnProperty.call(message, "tradeDenominationValue"))
            writer.uint32(121).double(message.tradeDenominationValue);
          if (message.receivingDenominationValue != null && Object.hasOwnProperty.call(message, "receivingDenominationValue"))
            writer.uint32(129).double(message.receivingDenominationValue);
          if (message.holdDenominationValue != null && Object.hasOwnProperty.call(message, "holdDenominationValue"))
            writer.uint32(137).double(message.holdDenominationValue);
          if (message.totalDenominationValue != null && Object.hasOwnProperty.call(message, "totalDenominationValue"))
            writer.uint32(145).double(message.totalDenominationValue);
          if (message.costPrice != null && Object.hasOwnProperty.call(message, "costPrice"))
            writer.uint32(153).double(message.costPrice);
          if (message.tradeCostValue != null && Object.hasOwnProperty.call(message, "tradeCostValue"))
            writer.uint32(161).double(message.tradeCostValue);
          if (message.receivingCostValue != null && Object.hasOwnProperty.call(message, "receivingCostValue"))
            writer.uint32(169).double(message.receivingCostValue);
          if (message.holdCostValue != null && Object.hasOwnProperty.call(message, "holdCostValue"))
            writer.uint32(177).double(message.holdCostValue);
          if (message.totalCostValue != null && Object.hasOwnProperty.call(message, "totalCostValue"))
            writer.uint32(185).double(message.totalCostValue);
          if (message.grossCouponInterestCurrentAmount != null && Object.hasOwnProperty.call(message, "grossCouponInterestCurrentAmount"))
            writer.uint32(193).double(message.grossCouponInterestCurrentAmount);
          if (message.netCouponInterestCurrentAmount != null && Object.hasOwnProperty.call(message, "netCouponInterestCurrentAmount"))
            writer.uint32(201).double(message.netCouponInterestCurrentAmount);
          if (message.estimateGrossBasicPrice != null && Object.hasOwnProperty.call(message, "estimateGrossBasicPrice"))
            writer.uint32(209).double(message.estimateGrossBasicPrice);
          if (message.estimateNetBasicPrice != null && Object.hasOwnProperty.call(message, "estimateNetBasicPrice"))
            writer.uint32(217).double(message.estimateNetBasicPrice);
          if (message.estimateTaxAndFee != null && Object.hasOwnProperty.call(message, "estimateTaxAndFee"))
            writer.uint32(225).double(message.estimateTaxAndFee);
          if (message.estimatePnl != null && Object.hasOwnProperty.call(message, "estimatePnl"))
            writer.uint32(233).double(message.estimatePnl);
          if (message.interestSchedules != null && message.interestSchedules.length)
            for (let i = 0; i < message.interestSchedules.length; ++i)
              $root.dnse.bond.v1.PortfolioInterestSchedule.encode(message.interestSchedules[i], writer.uint32(242).fork()).ldelim();
          if (message.totalQuantity != null && Object.hasOwnProperty.call(message, "totalQuantity"))
            writer.uint32(248).int64(message.totalQuantity);
          return writer;
        };
        Portfolio.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Portfolio.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.bond.v1.Portfolio();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.custodyCode = reader.string();
                break;
              case 2:
                message.investorId = reader.string();
                break;
              case 3:
                message.accountNo = reader.string();
                break;
              case 4:
                message.symbol = reader.string();
                break;
              case 5:
                message.tradeQuantity = reader.int64();
                break;
              case 6:
                message.receivingQuantity = reader.int64();
                break;
              case 7:
                message.holdQuantity = reader.int64();
                break;
              case 8:
                message.restrictedQuantity = reader.int64();
                break;
              case 9:
                message.marketPrice = reader.double();
                break;
              case 10:
                message.tradeMarketValue = reader.double();
                break;
              case 11:
                message.receivingMarketValue = reader.double();
                break;
              case 12:
                message.holdMarketValue = reader.double();
                break;
              case 13:
                message.totalMarketValue = reader.double();
                break;
              case 14:
                message.denominationPrice = reader.double();
                break;
              case 15:
                message.tradeDenominationValue = reader.double();
                break;
              case 16:
                message.receivingDenominationValue = reader.double();
                break;
              case 17:
                message.holdDenominationValue = reader.double();
                break;
              case 18:
                message.totalDenominationValue = reader.double();
                break;
              case 19:
                message.costPrice = reader.double();
                break;
              case 20:
                message.tradeCostValue = reader.double();
                break;
              case 21:
                message.receivingCostValue = reader.double();
                break;
              case 22:
                message.holdCostValue = reader.double();
                break;
              case 23:
                message.totalCostValue = reader.double();
                break;
              case 24:
                message.grossCouponInterestCurrentAmount = reader.double();
                break;
              case 25:
                message.netCouponInterestCurrentAmount = reader.double();
                break;
              case 26:
                message.estimateGrossBasicPrice = reader.double();
                break;
              case 27:
                message.estimateNetBasicPrice = reader.double();
                break;
              case 28:
                message.estimateTaxAndFee = reader.double();
                break;
              case 29:
                message.estimatePnl = reader.double();
                break;
              case 30:
                if (!(message.interestSchedules && message.interestSchedules.length))
                  message.interestSchedules = [];
                message.interestSchedules.push($root.dnse.bond.v1.PortfolioInterestSchedule.decode(reader, reader.uint32()));
                break;
              case 31:
                message.totalQuantity = reader.int64();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Portfolio.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Portfolio.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity")) {
            if (!$util.isInteger(message.tradeQuantity) && !(message.tradeQuantity && $util.isInteger(message.tradeQuantity.low) && $util.isInteger(message.tradeQuantity.high)))
              return "tradeQuantity: integer|Long expected";
          }
          if (message.receivingQuantity != null && message.hasOwnProperty("receivingQuantity")) {
            if (!$util.isInteger(message.receivingQuantity) && !(message.receivingQuantity && $util.isInteger(message.receivingQuantity.low) && $util.isInteger(message.receivingQuantity.high)))
              return "receivingQuantity: integer|Long expected";
          }
          if (message.holdQuantity != null && message.hasOwnProperty("holdQuantity")) {
            if (!$util.isInteger(message.holdQuantity) && !(message.holdQuantity && $util.isInteger(message.holdQuantity.low) && $util.isInteger(message.holdQuantity.high)))
              return "holdQuantity: integer|Long expected";
          }
          if (message.restrictedQuantity != null && message.hasOwnProperty("restrictedQuantity")) {
            if (!$util.isInteger(message.restrictedQuantity) && !(message.restrictedQuantity && $util.isInteger(message.restrictedQuantity.low) && $util.isInteger(message.restrictedQuantity.high)))
              return "restrictedQuantity: integer|Long expected";
          }
          if (message.marketPrice != null && message.hasOwnProperty("marketPrice")) {
            if (typeof message.marketPrice !== "number")
              return "marketPrice: number expected";
          }
          if (message.tradeMarketValue != null && message.hasOwnProperty("tradeMarketValue")) {
            if (typeof message.tradeMarketValue !== "number")
              return "tradeMarketValue: number expected";
          }
          if (message.receivingMarketValue != null && message.hasOwnProperty("receivingMarketValue")) {
            if (typeof message.receivingMarketValue !== "number")
              return "receivingMarketValue: number expected";
          }
          if (message.holdMarketValue != null && message.hasOwnProperty("holdMarketValue")) {
            if (typeof message.holdMarketValue !== "number")
              return "holdMarketValue: number expected";
          }
          if (message.totalMarketValue != null && message.hasOwnProperty("totalMarketValue")) {
            if (typeof message.totalMarketValue !== "number")
              return "totalMarketValue: number expected";
          }
          if (message.denominationPrice != null && message.hasOwnProperty("denominationPrice")) {
            if (typeof message.denominationPrice !== "number")
              return "denominationPrice: number expected";
          }
          if (message.tradeDenominationValue != null && message.hasOwnProperty("tradeDenominationValue")) {
            if (typeof message.tradeDenominationValue !== "number")
              return "tradeDenominationValue: number expected";
          }
          if (message.receivingDenominationValue != null && message.hasOwnProperty("receivingDenominationValue")) {
            if (typeof message.receivingDenominationValue !== "number")
              return "receivingDenominationValue: number expected";
          }
          if (message.holdDenominationValue != null && message.hasOwnProperty("holdDenominationValue")) {
            if (typeof message.holdDenominationValue !== "number")
              return "holdDenominationValue: number expected";
          }
          if (message.totalDenominationValue != null && message.hasOwnProperty("totalDenominationValue")) {
            if (typeof message.totalDenominationValue !== "number")
              return "totalDenominationValue: number expected";
          }
          if (message.costPrice != null && message.hasOwnProperty("costPrice")) {
            if (typeof message.costPrice !== "number")
              return "costPrice: number expected";
          }
          if (message.tradeCostValue != null && message.hasOwnProperty("tradeCostValue")) {
            if (typeof message.tradeCostValue !== "number")
              return "tradeCostValue: number expected";
          }
          if (message.receivingCostValue != null && message.hasOwnProperty("receivingCostValue")) {
            if (typeof message.receivingCostValue !== "number")
              return "receivingCostValue: number expected";
          }
          if (message.holdCostValue != null && message.hasOwnProperty("holdCostValue")) {
            if (typeof message.holdCostValue !== "number")
              return "holdCostValue: number expected";
          }
          if (message.totalCostValue != null && message.hasOwnProperty("totalCostValue")) {
            if (typeof message.totalCostValue !== "number")
              return "totalCostValue: number expected";
          }
          if (message.grossCouponInterestCurrentAmount != null && message.hasOwnProperty("grossCouponInterestCurrentAmount")) {
            if (typeof message.grossCouponInterestCurrentAmount !== "number")
              return "grossCouponInterestCurrentAmount: number expected";
          }
          if (message.netCouponInterestCurrentAmount != null && message.hasOwnProperty("netCouponInterestCurrentAmount")) {
            if (typeof message.netCouponInterestCurrentAmount !== "number")
              return "netCouponInterestCurrentAmount: number expected";
          }
          if (message.estimateGrossBasicPrice != null && message.hasOwnProperty("estimateGrossBasicPrice")) {
            if (typeof message.estimateGrossBasicPrice !== "number")
              return "estimateGrossBasicPrice: number expected";
          }
          if (message.estimateNetBasicPrice != null && message.hasOwnProperty("estimateNetBasicPrice")) {
            if (typeof message.estimateNetBasicPrice !== "number")
              return "estimateNetBasicPrice: number expected";
          }
          if (message.estimateTaxAndFee != null && message.hasOwnProperty("estimateTaxAndFee")) {
            if (typeof message.estimateTaxAndFee !== "number")
              return "estimateTaxAndFee: number expected";
          }
          if (message.estimatePnl != null && message.hasOwnProperty("estimatePnl")) {
            if (typeof message.estimatePnl !== "number")
              return "estimatePnl: number expected";
          }
          if (message.interestSchedules != null && message.hasOwnProperty("interestSchedules")) {
            if (!Array.isArray(message.interestSchedules))
              return "interestSchedules: array expected";
            for (let i = 0; i < message.interestSchedules.length; ++i) {
              let error = $root.dnse.bond.v1.PortfolioInterestSchedule.verify(message.interestSchedules[i]);
              if (error)
                return "interestSchedules." + error;
            }
          }
          if (message.totalQuantity != null && message.hasOwnProperty("totalQuantity")) {
            if (!$util.isInteger(message.totalQuantity) && !(message.totalQuantity && $util.isInteger(message.totalQuantity.low) && $util.isInteger(message.totalQuantity.high)))
              return "totalQuantity: integer|Long expected";
          }
          return null;
        };
        Portfolio.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.bond.v1.Portfolio)
            return object;
          let message = new $root.dnse.bond.v1.Portfolio();
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.tradeQuantity != null) {
            if ($util.Long)
              (message.tradeQuantity = $util.Long.fromValue(object.tradeQuantity)).unsigned = false;
            else if (typeof object.tradeQuantity === "string")
              message.tradeQuantity = parseInt(object.tradeQuantity, 10);
            else if (typeof object.tradeQuantity === "number")
              message.tradeQuantity = object.tradeQuantity;
            else if (typeof object.tradeQuantity === "object")
              message.tradeQuantity = new $util.LongBits(object.tradeQuantity.low >>> 0, object.tradeQuantity.high >>> 0).toNumber();
          }
          if (object.receivingQuantity != null) {
            if ($util.Long)
              (message.receivingQuantity = $util.Long.fromValue(object.receivingQuantity)).unsigned = false;
            else if (typeof object.receivingQuantity === "string")
              message.receivingQuantity = parseInt(object.receivingQuantity, 10);
            else if (typeof object.receivingQuantity === "number")
              message.receivingQuantity = object.receivingQuantity;
            else if (typeof object.receivingQuantity === "object")
              message.receivingQuantity = new $util.LongBits(object.receivingQuantity.low >>> 0, object.receivingQuantity.high >>> 0).toNumber();
          }
          if (object.holdQuantity != null) {
            if ($util.Long)
              (message.holdQuantity = $util.Long.fromValue(object.holdQuantity)).unsigned = false;
            else if (typeof object.holdQuantity === "string")
              message.holdQuantity = parseInt(object.holdQuantity, 10);
            else if (typeof object.holdQuantity === "number")
              message.holdQuantity = object.holdQuantity;
            else if (typeof object.holdQuantity === "object")
              message.holdQuantity = new $util.LongBits(object.holdQuantity.low >>> 0, object.holdQuantity.high >>> 0).toNumber();
          }
          if (object.restrictedQuantity != null) {
            if ($util.Long)
              (message.restrictedQuantity = $util.Long.fromValue(object.restrictedQuantity)).unsigned = false;
            else if (typeof object.restrictedQuantity === "string")
              message.restrictedQuantity = parseInt(object.restrictedQuantity, 10);
            else if (typeof object.restrictedQuantity === "number")
              message.restrictedQuantity = object.restrictedQuantity;
            else if (typeof object.restrictedQuantity === "object")
              message.restrictedQuantity = new $util.LongBits(object.restrictedQuantity.low >>> 0, object.restrictedQuantity.high >>> 0).toNumber();
          }
          if (object.marketPrice != null)
            message.marketPrice = Number(object.marketPrice);
          if (object.tradeMarketValue != null)
            message.tradeMarketValue = Number(object.tradeMarketValue);
          if (object.receivingMarketValue != null)
            message.receivingMarketValue = Number(object.receivingMarketValue);
          if (object.holdMarketValue != null)
            message.holdMarketValue = Number(object.holdMarketValue);
          if (object.totalMarketValue != null)
            message.totalMarketValue = Number(object.totalMarketValue);
          if (object.denominationPrice != null)
            message.denominationPrice = Number(object.denominationPrice);
          if (object.tradeDenominationValue != null)
            message.tradeDenominationValue = Number(object.tradeDenominationValue);
          if (object.receivingDenominationValue != null)
            message.receivingDenominationValue = Number(object.receivingDenominationValue);
          if (object.holdDenominationValue != null)
            message.holdDenominationValue = Number(object.holdDenominationValue);
          if (object.totalDenominationValue != null)
            message.totalDenominationValue = Number(object.totalDenominationValue);
          if (object.costPrice != null)
            message.costPrice = Number(object.costPrice);
          if (object.tradeCostValue != null)
            message.tradeCostValue = Number(object.tradeCostValue);
          if (object.receivingCostValue != null)
            message.receivingCostValue = Number(object.receivingCostValue);
          if (object.holdCostValue != null)
            message.holdCostValue = Number(object.holdCostValue);
          if (object.totalCostValue != null)
            message.totalCostValue = Number(object.totalCostValue);
          if (object.grossCouponInterestCurrentAmount != null)
            message.grossCouponInterestCurrentAmount = Number(object.grossCouponInterestCurrentAmount);
          if (object.netCouponInterestCurrentAmount != null)
            message.netCouponInterestCurrentAmount = Number(object.netCouponInterestCurrentAmount);
          if (object.estimateGrossBasicPrice != null)
            message.estimateGrossBasicPrice = Number(object.estimateGrossBasicPrice);
          if (object.estimateNetBasicPrice != null)
            message.estimateNetBasicPrice = Number(object.estimateNetBasicPrice);
          if (object.estimateTaxAndFee != null)
            message.estimateTaxAndFee = Number(object.estimateTaxAndFee);
          if (object.estimatePnl != null)
            message.estimatePnl = Number(object.estimatePnl);
          if (object.interestSchedules) {
            if (!Array.isArray(object.interestSchedules))
              throw TypeError(".dnse.bond.v1.Portfolio.interestSchedules: array expected");
            message.interestSchedules = [];
            for (let i = 0; i < object.interestSchedules.length; ++i) {
              if (typeof object.interestSchedules[i] !== "object")
                throw TypeError(".dnse.bond.v1.Portfolio.interestSchedules: object expected");
              message.interestSchedules[i] = $root.dnse.bond.v1.PortfolioInterestSchedule.fromObject(object.interestSchedules[i]);
            }
          }
          if (object.totalQuantity != null) {
            if ($util.Long)
              (message.totalQuantity = $util.Long.fromValue(object.totalQuantity)).unsigned = false;
            else if (typeof object.totalQuantity === "string")
              message.totalQuantity = parseInt(object.totalQuantity, 10);
            else if (typeof object.totalQuantity === "number")
              message.totalQuantity = object.totalQuantity;
            else if (typeof object.totalQuantity === "object")
              message.totalQuantity = new $util.LongBits(object.totalQuantity.low >>> 0, object.totalQuantity.high >>> 0).toNumber();
          }
          return message;
        };
        Portfolio.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.interestSchedules = [];
          if (options.defaults) {
            object.custodyCode = "";
            object.investorId = "";
            object.accountNo = "";
            object.symbol = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.tradeQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.tradeQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.receivingQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.receivingQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.holdQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.holdQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.restrictedQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.restrictedQuantity = options.longs === String ? "0" : 0;
            object.marketPrice = 0;
            object.tradeMarketValue = 0;
            object.receivingMarketValue = 0;
            object.holdMarketValue = 0;
            object.totalMarketValue = 0;
            object.denominationPrice = 0;
            object.tradeDenominationValue = 0;
            object.receivingDenominationValue = 0;
            object.holdDenominationValue = 0;
            object.totalDenominationValue = 0;
            object.costPrice = 0;
            object.tradeCostValue = 0;
            object.receivingCostValue = 0;
            object.holdCostValue = 0;
            object.totalCostValue = 0;
            object.grossCouponInterestCurrentAmount = 0;
            object.netCouponInterestCurrentAmount = 0;
            object.estimateGrossBasicPrice = 0;
            object.estimateNetBasicPrice = 0;
            object.estimateTaxAndFee = 0;
            object.estimatePnl = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.totalQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.totalQuantity = options.longs === String ? "0" : 0;
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.tradeQuantity != null && message.hasOwnProperty("tradeQuantity"))
            if (typeof message.tradeQuantity === "number")
              object.tradeQuantity = options.longs === String ? String(message.tradeQuantity) : message.tradeQuantity;
            else
              object.tradeQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.tradeQuantity) : options.longs === Number ? new $util.LongBits(message.tradeQuantity.low >>> 0, message.tradeQuantity.high >>> 0).toNumber() : message.tradeQuantity;
          if (message.receivingQuantity != null && message.hasOwnProperty("receivingQuantity"))
            if (typeof message.receivingQuantity === "number")
              object.receivingQuantity = options.longs === String ? String(message.receivingQuantity) : message.receivingQuantity;
            else
              object.receivingQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.receivingQuantity) : options.longs === Number ? new $util.LongBits(message.receivingQuantity.low >>> 0, message.receivingQuantity.high >>> 0).toNumber() : message.receivingQuantity;
          if (message.holdQuantity != null && message.hasOwnProperty("holdQuantity"))
            if (typeof message.holdQuantity === "number")
              object.holdQuantity = options.longs === String ? String(message.holdQuantity) : message.holdQuantity;
            else
              object.holdQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.holdQuantity) : options.longs === Number ? new $util.LongBits(message.holdQuantity.low >>> 0, message.holdQuantity.high >>> 0).toNumber() : message.holdQuantity;
          if (message.restrictedQuantity != null && message.hasOwnProperty("restrictedQuantity"))
            if (typeof message.restrictedQuantity === "number")
              object.restrictedQuantity = options.longs === String ? String(message.restrictedQuantity) : message.restrictedQuantity;
            else
              object.restrictedQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.restrictedQuantity) : options.longs === Number ? new $util.LongBits(message.restrictedQuantity.low >>> 0, message.restrictedQuantity.high >>> 0).toNumber() : message.restrictedQuantity;
          if (message.marketPrice != null && message.hasOwnProperty("marketPrice"))
            object.marketPrice = options.json && !isFinite(message.marketPrice) ? String(message.marketPrice) : message.marketPrice;
          if (message.tradeMarketValue != null && message.hasOwnProperty("tradeMarketValue"))
            object.tradeMarketValue = options.json && !isFinite(message.tradeMarketValue) ? String(message.tradeMarketValue) : message.tradeMarketValue;
          if (message.receivingMarketValue != null && message.hasOwnProperty("receivingMarketValue"))
            object.receivingMarketValue = options.json && !isFinite(message.receivingMarketValue) ? String(message.receivingMarketValue) : message.receivingMarketValue;
          if (message.holdMarketValue != null && message.hasOwnProperty("holdMarketValue"))
            object.holdMarketValue = options.json && !isFinite(message.holdMarketValue) ? String(message.holdMarketValue) : message.holdMarketValue;
          if (message.totalMarketValue != null && message.hasOwnProperty("totalMarketValue"))
            object.totalMarketValue = options.json && !isFinite(message.totalMarketValue) ? String(message.totalMarketValue) : message.totalMarketValue;
          if (message.denominationPrice != null && message.hasOwnProperty("denominationPrice"))
            object.denominationPrice = options.json && !isFinite(message.denominationPrice) ? String(message.denominationPrice) : message.denominationPrice;
          if (message.tradeDenominationValue != null && message.hasOwnProperty("tradeDenominationValue"))
            object.tradeDenominationValue = options.json && !isFinite(message.tradeDenominationValue) ? String(message.tradeDenominationValue) : message.tradeDenominationValue;
          if (message.receivingDenominationValue != null && message.hasOwnProperty("receivingDenominationValue"))
            object.receivingDenominationValue = options.json && !isFinite(message.receivingDenominationValue) ? String(message.receivingDenominationValue) : message.receivingDenominationValue;
          if (message.holdDenominationValue != null && message.hasOwnProperty("holdDenominationValue"))
            object.holdDenominationValue = options.json && !isFinite(message.holdDenominationValue) ? String(message.holdDenominationValue) : message.holdDenominationValue;
          if (message.totalDenominationValue != null && message.hasOwnProperty("totalDenominationValue"))
            object.totalDenominationValue = options.json && !isFinite(message.totalDenominationValue) ? String(message.totalDenominationValue) : message.totalDenominationValue;
          if (message.costPrice != null && message.hasOwnProperty("costPrice"))
            object.costPrice = options.json && !isFinite(message.costPrice) ? String(message.costPrice) : message.costPrice;
          if (message.tradeCostValue != null && message.hasOwnProperty("tradeCostValue"))
            object.tradeCostValue = options.json && !isFinite(message.tradeCostValue) ? String(message.tradeCostValue) : message.tradeCostValue;
          if (message.receivingCostValue != null && message.hasOwnProperty("receivingCostValue"))
            object.receivingCostValue = options.json && !isFinite(message.receivingCostValue) ? String(message.receivingCostValue) : message.receivingCostValue;
          if (message.holdCostValue != null && message.hasOwnProperty("holdCostValue"))
            object.holdCostValue = options.json && !isFinite(message.holdCostValue) ? String(message.holdCostValue) : message.holdCostValue;
          if (message.totalCostValue != null && message.hasOwnProperty("totalCostValue"))
            object.totalCostValue = options.json && !isFinite(message.totalCostValue) ? String(message.totalCostValue) : message.totalCostValue;
          if (message.grossCouponInterestCurrentAmount != null && message.hasOwnProperty("grossCouponInterestCurrentAmount"))
            object.grossCouponInterestCurrentAmount = options.json && !isFinite(message.grossCouponInterestCurrentAmount) ? String(message.grossCouponInterestCurrentAmount) : message.grossCouponInterestCurrentAmount;
          if (message.netCouponInterestCurrentAmount != null && message.hasOwnProperty("netCouponInterestCurrentAmount"))
            object.netCouponInterestCurrentAmount = options.json && !isFinite(message.netCouponInterestCurrentAmount) ? String(message.netCouponInterestCurrentAmount) : message.netCouponInterestCurrentAmount;
          if (message.estimateGrossBasicPrice != null && message.hasOwnProperty("estimateGrossBasicPrice"))
            object.estimateGrossBasicPrice = options.json && !isFinite(message.estimateGrossBasicPrice) ? String(message.estimateGrossBasicPrice) : message.estimateGrossBasicPrice;
          if (message.estimateNetBasicPrice != null && message.hasOwnProperty("estimateNetBasicPrice"))
            object.estimateNetBasicPrice = options.json && !isFinite(message.estimateNetBasicPrice) ? String(message.estimateNetBasicPrice) : message.estimateNetBasicPrice;
          if (message.estimateTaxAndFee != null && message.hasOwnProperty("estimateTaxAndFee"))
            object.estimateTaxAndFee = options.json && !isFinite(message.estimateTaxAndFee) ? String(message.estimateTaxAndFee) : message.estimateTaxAndFee;
          if (message.estimatePnl != null && message.hasOwnProperty("estimatePnl"))
            object.estimatePnl = options.json && !isFinite(message.estimatePnl) ? String(message.estimatePnl) : message.estimatePnl;
          if (message.interestSchedules && message.interestSchedules.length) {
            object.interestSchedules = [];
            for (let j = 0; j < message.interestSchedules.length; ++j)
              object.interestSchedules[j] = $root.dnse.bond.v1.PortfolioInterestSchedule.toObject(message.interestSchedules[j], options);
          }
          if (message.totalQuantity != null && message.hasOwnProperty("totalQuantity"))
            if (typeof message.totalQuantity === "number")
              object.totalQuantity = options.longs === String ? String(message.totalQuantity) : message.totalQuantity;
            else
              object.totalQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.totalQuantity) : options.longs === Number ? new $util.LongBits(message.totalQuantity.low >>> 0, message.totalQuantity.high >>> 0).toNumber() : message.totalQuantity;
          return object;
        };
        Portfolio.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return Portfolio;
      }();
      v1.PortfolioInterestSchedule = function() {
        function PortfolioInterestSchedule(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        PortfolioInterestSchedule.prototype.beginDate = "";
        PortfolioInterestSchedule.prototype.interestDate = "";
        PortfolioInterestSchedule.prototype.closingDate = "";
        PortfolioInterestSchedule.prototype.couponRate = 0;
        PortfolioInterestSchedule.prototype.grossCouponInterestAmount = 0;
        PortfolioInterestSchedule.prototype.netCouponInterestAmount = 0;
        PortfolioInterestSchedule.create = function create(properties) {
          return new PortfolioInterestSchedule(properties);
        };
        PortfolioInterestSchedule.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.beginDate != null && Object.hasOwnProperty.call(message, "beginDate"))
            writer.uint32(10).string(message.beginDate);
          if (message.interestDate != null && Object.hasOwnProperty.call(message, "interestDate"))
            writer.uint32(18).string(message.interestDate);
          if (message.closingDate != null && Object.hasOwnProperty.call(message, "closingDate"))
            writer.uint32(26).string(message.closingDate);
          if (message.couponRate != null && Object.hasOwnProperty.call(message, "couponRate"))
            writer.uint32(33).double(message.couponRate);
          if (message.grossCouponInterestAmount != null && Object.hasOwnProperty.call(message, "grossCouponInterestAmount"))
            writer.uint32(41).double(message.grossCouponInterestAmount);
          if (message.netCouponInterestAmount != null && Object.hasOwnProperty.call(message, "netCouponInterestAmount"))
            writer.uint32(49).double(message.netCouponInterestAmount);
          return writer;
        };
        PortfolioInterestSchedule.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        PortfolioInterestSchedule.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.bond.v1.PortfolioInterestSchedule();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.beginDate = reader.string();
                break;
              case 2:
                message.interestDate = reader.string();
                break;
              case 3:
                message.closingDate = reader.string();
                break;
              case 4:
                message.couponRate = reader.double();
                break;
              case 5:
                message.grossCouponInterestAmount = reader.double();
                break;
              case 6:
                message.netCouponInterestAmount = reader.double();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        PortfolioInterestSchedule.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        PortfolioInterestSchedule.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.beginDate != null && message.hasOwnProperty("beginDate")) {
            if (!$util.isString(message.beginDate))
              return "beginDate: string expected";
          }
          if (message.interestDate != null && message.hasOwnProperty("interestDate")) {
            if (!$util.isString(message.interestDate))
              return "interestDate: string expected";
          }
          if (message.closingDate != null && message.hasOwnProperty("closingDate")) {
            if (!$util.isString(message.closingDate))
              return "closingDate: string expected";
          }
          if (message.couponRate != null && message.hasOwnProperty("couponRate")) {
            if (typeof message.couponRate !== "number")
              return "couponRate: number expected";
          }
          if (message.grossCouponInterestAmount != null && message.hasOwnProperty("grossCouponInterestAmount")) {
            if (typeof message.grossCouponInterestAmount !== "number")
              return "grossCouponInterestAmount: number expected";
          }
          if (message.netCouponInterestAmount != null && message.hasOwnProperty("netCouponInterestAmount")) {
            if (typeof message.netCouponInterestAmount !== "number")
              return "netCouponInterestAmount: number expected";
          }
          return null;
        };
        PortfolioInterestSchedule.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.bond.v1.PortfolioInterestSchedule)
            return object;
          let message = new $root.dnse.bond.v1.PortfolioInterestSchedule();
          if (object.beginDate != null)
            message.beginDate = String(object.beginDate);
          if (object.interestDate != null)
            message.interestDate = String(object.interestDate);
          if (object.closingDate != null)
            message.closingDate = String(object.closingDate);
          if (object.couponRate != null)
            message.couponRate = Number(object.couponRate);
          if (object.grossCouponInterestAmount != null)
            message.grossCouponInterestAmount = Number(object.grossCouponInterestAmount);
          if (object.netCouponInterestAmount != null)
            message.netCouponInterestAmount = Number(object.netCouponInterestAmount);
          return message;
        };
        PortfolioInterestSchedule.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.beginDate = "";
            object.interestDate = "";
            object.closingDate = "";
            object.couponRate = 0;
            object.grossCouponInterestAmount = 0;
            object.netCouponInterestAmount = 0;
          }
          if (message.beginDate != null && message.hasOwnProperty("beginDate"))
            object.beginDate = message.beginDate;
          if (message.interestDate != null && message.hasOwnProperty("interestDate"))
            object.interestDate = message.interestDate;
          if (message.closingDate != null && message.hasOwnProperty("closingDate"))
            object.closingDate = message.closingDate;
          if (message.couponRate != null && message.hasOwnProperty("couponRate"))
            object.couponRate = options.json && !isFinite(message.couponRate) ? String(message.couponRate) : message.couponRate;
          if (message.grossCouponInterestAmount != null && message.hasOwnProperty("grossCouponInterestAmount"))
            object.grossCouponInterestAmount = options.json && !isFinite(message.grossCouponInterestAmount) ? String(message.grossCouponInterestAmount) : message.grossCouponInterestAmount;
          if (message.netCouponInterestAmount != null && message.hasOwnProperty("netCouponInterestAmount"))
            object.netCouponInterestAmount = options.json && !isFinite(message.netCouponInterestAmount) ? String(message.netCouponInterestAmount) : message.netCouponInterestAmount;
          return object;
        };
        PortfolioInterestSchedule.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return PortfolioInterestSchedule;
      }();
      v1.InterestPaymentSchedule = function() {
        function InterestPaymentSchedule(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        InterestPaymentSchedule.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        InterestPaymentSchedule.prototype.symbol = "";
        InterestPaymentSchedule.prototype.beginDate = null;
        InterestPaymentSchedule.prototype.interestDate = null;
        InterestPaymentSchedule.prototype.closingDate = null;
        InterestPaymentSchedule.prototype.couponRate = 0;
        InterestPaymentSchedule.prototype.grossInterest = 0;
        InterestPaymentSchedule.prototype.netInterest = 0;
        InterestPaymentSchedule.prototype.createdDate = null;
        InterestPaymentSchedule.prototype.lastModifiedDate = null;
        InterestPaymentSchedule.prototype.numberOfDayInterest = 0;
        InterestPaymentSchedule.prototype.couponType = "";
        InterestPaymentSchedule.prototype.referenceRateDescription = "";
        InterestPaymentSchedule.create = function create(properties) {
          return new InterestPaymentSchedule(properties);
        };
        InterestPaymentSchedule.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(8).int64(message.id);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(18).string(message.symbol);
          if (message.beginDate != null && Object.hasOwnProperty.call(message, "beginDate"))
            $root.google.protobuf.Timestamp.encode(message.beginDate, writer.uint32(26).fork()).ldelim();
          if (message.interestDate != null && Object.hasOwnProperty.call(message, "interestDate"))
            $root.google.protobuf.Timestamp.encode(message.interestDate, writer.uint32(34).fork()).ldelim();
          if (message.closingDate != null && Object.hasOwnProperty.call(message, "closingDate"))
            $root.google.protobuf.Timestamp.encode(message.closingDate, writer.uint32(42).fork()).ldelim();
          if (message.couponRate != null && Object.hasOwnProperty.call(message, "couponRate"))
            writer.uint32(49).double(message.couponRate);
          if (message.grossInterest != null && Object.hasOwnProperty.call(message, "grossInterest"))
            writer.uint32(57).double(message.grossInterest);
          if (message.netInterest != null && Object.hasOwnProperty.call(message, "netInterest"))
            writer.uint32(65).double(message.netInterest);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
          if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
            $root.google.protobuf.Timestamp.encode(message.lastModifiedDate, writer.uint32(82).fork()).ldelim();
          if (message.numberOfDayInterest != null && Object.hasOwnProperty.call(message, "numberOfDayInterest"))
            writer.uint32(88).int32(message.numberOfDayInterest);
          if (message.couponType != null && Object.hasOwnProperty.call(message, "couponType"))
            writer.uint32(98).string(message.couponType);
          if (message.referenceRateDescription != null && Object.hasOwnProperty.call(message, "referenceRateDescription"))
            writer.uint32(106).string(message.referenceRateDescription);
          return writer;
        };
        InterestPaymentSchedule.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        InterestPaymentSchedule.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.bond.v1.InterestPaymentSchedule();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.int64();
                break;
              case 2:
                message.symbol = reader.string();
                break;
              case 3:
                message.beginDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 4:
                message.interestDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 5:
                message.closingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 6:
                message.couponRate = reader.double();
                break;
              case 7:
                message.grossInterest = reader.double();
                break;
              case 8:
                message.netInterest = reader.double();
                break;
              case 9:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 10:
                message.lastModifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 11:
                message.numberOfDayInterest = reader.int32();
                break;
              case 12:
                message.couponType = reader.string();
                break;
              case 13:
                message.referenceRateDescription = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        InterestPaymentSchedule.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        InterestPaymentSchedule.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
              return "id: integer|Long expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.beginDate != null && message.hasOwnProperty("beginDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.beginDate);
            if (error)
              return "beginDate." + error;
          }
          if (message.interestDate != null && message.hasOwnProperty("interestDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.interestDate);
            if (error)
              return "interestDate." + error;
          }
          if (message.closingDate != null && message.hasOwnProperty("closingDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.closingDate);
            if (error)
              return "closingDate." + error;
          }
          if (message.couponRate != null && message.hasOwnProperty("couponRate")) {
            if (typeof message.couponRate !== "number")
              return "couponRate: number expected";
          }
          if (message.grossInterest != null && message.hasOwnProperty("grossInterest")) {
            if (typeof message.grossInterest !== "number")
              return "grossInterest: number expected";
          }
          if (message.netInterest != null && message.hasOwnProperty("netInterest")) {
            if (typeof message.netInterest !== "number")
              return "netInterest: number expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.lastModifiedDate);
            if (error)
              return "lastModifiedDate." + error;
          }
          if (message.numberOfDayInterest != null && message.hasOwnProperty("numberOfDayInterest")) {
            if (!$util.isInteger(message.numberOfDayInterest))
              return "numberOfDayInterest: integer expected";
          }
          if (message.couponType != null && message.hasOwnProperty("couponType")) {
            if (!$util.isString(message.couponType))
              return "couponType: string expected";
          }
          if (message.referenceRateDescription != null && message.hasOwnProperty("referenceRateDescription")) {
            if (!$util.isString(message.referenceRateDescription))
              return "referenceRateDescription: string expected";
          }
          return null;
        };
        InterestPaymentSchedule.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.bond.v1.InterestPaymentSchedule)
            return object;
          let message = new $root.dnse.bond.v1.InterestPaymentSchedule();
          if (object.id != null) {
            if ($util.Long)
              (message.id = $util.Long.fromValue(object.id)).unsigned = false;
            else if (typeof object.id === "string")
              message.id = parseInt(object.id, 10);
            else if (typeof object.id === "number")
              message.id = object.id;
            else if (typeof object.id === "object")
              message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
          }
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.beginDate != null) {
            if (typeof object.beginDate !== "object")
              throw TypeError(".dnse.bond.v1.InterestPaymentSchedule.beginDate: object expected");
            message.beginDate = $root.google.protobuf.Timestamp.fromObject(object.beginDate);
          }
          if (object.interestDate != null) {
            if (typeof object.interestDate !== "object")
              throw TypeError(".dnse.bond.v1.InterestPaymentSchedule.interestDate: object expected");
            message.interestDate = $root.google.protobuf.Timestamp.fromObject(object.interestDate);
          }
          if (object.closingDate != null) {
            if (typeof object.closingDate !== "object")
              throw TypeError(".dnse.bond.v1.InterestPaymentSchedule.closingDate: object expected");
            message.closingDate = $root.google.protobuf.Timestamp.fromObject(object.closingDate);
          }
          if (object.couponRate != null)
            message.couponRate = Number(object.couponRate);
          if (object.grossInterest != null)
            message.grossInterest = Number(object.grossInterest);
          if (object.netInterest != null)
            message.netInterest = Number(object.netInterest);
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.bond.v1.InterestPaymentSchedule.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.lastModifiedDate != null) {
            if (typeof object.lastModifiedDate !== "object")
              throw TypeError(".dnse.bond.v1.InterestPaymentSchedule.lastModifiedDate: object expected");
            message.lastModifiedDate = $root.google.protobuf.Timestamp.fromObject(object.lastModifiedDate);
          }
          if (object.numberOfDayInterest != null)
            message.numberOfDayInterest = object.numberOfDayInterest | 0;
          if (object.couponType != null)
            message.couponType = String(object.couponType);
          if (object.referenceRateDescription != null)
            message.referenceRateDescription = String(object.referenceRateDescription);
          return message;
        };
        InterestPaymentSchedule.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.id = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.beginDate = null;
            object.interestDate = null;
            object.closingDate = null;
            object.couponRate = 0;
            object.grossInterest = 0;
            object.netInterest = 0;
            object.createdDate = null;
            object.lastModifiedDate = null;
            object.numberOfDayInterest = 0;
            object.couponType = "";
            object.referenceRateDescription = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            if (typeof message.id === "number")
              object.id = options.longs === String ? String(message.id) : message.id;
            else
              object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.beginDate != null && message.hasOwnProperty("beginDate"))
            object.beginDate = $root.google.protobuf.Timestamp.toObject(message.beginDate, options);
          if (message.interestDate != null && message.hasOwnProperty("interestDate"))
            object.interestDate = $root.google.protobuf.Timestamp.toObject(message.interestDate, options);
          if (message.closingDate != null && message.hasOwnProperty("closingDate"))
            object.closingDate = $root.google.protobuf.Timestamp.toObject(message.closingDate, options);
          if (message.couponRate != null && message.hasOwnProperty("couponRate"))
            object.couponRate = options.json && !isFinite(message.couponRate) ? String(message.couponRate) : message.couponRate;
          if (message.grossInterest != null && message.hasOwnProperty("grossInterest"))
            object.grossInterest = options.json && !isFinite(message.grossInterest) ? String(message.grossInterest) : message.grossInterest;
          if (message.netInterest != null && message.hasOwnProperty("netInterest"))
            object.netInterest = options.json && !isFinite(message.netInterest) ? String(message.netInterest) : message.netInterest;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
            object.lastModifiedDate = $root.google.protobuf.Timestamp.toObject(message.lastModifiedDate, options);
          if (message.numberOfDayInterest != null && message.hasOwnProperty("numberOfDayInterest"))
            object.numberOfDayInterest = message.numberOfDayInterest;
          if (message.couponType != null && message.hasOwnProperty("couponType"))
            object.couponType = message.couponType;
          if (message.referenceRateDescription != null && message.hasOwnProperty("referenceRateDescription"))
            object.referenceRateDescription = message.referenceRateDescription;
          return object;
        };
        InterestPaymentSchedule.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return InterestPaymentSchedule;
      }();
      v1.ListedBondOrder = function() {
        function ListedBondOrder(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        ListedBondOrder.prototype.id = "";
        ListedBondOrder.prototype.orderId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        ListedBondOrder.prototype.symbol = "";
        ListedBondOrder.prototype.side = "";
        ListedBondOrder.prototype.accountNo = "";
        ListedBondOrder.prototype.investorId = "";
        ListedBondOrder.prototype.price = 0;
        ListedBondOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        ListedBondOrder.prototype.orderType = "";
        ListedBondOrder.prototype.orderStatus = "";
        ListedBondOrder.prototype.fillQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        ListedBondOrder.prototype.lastQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        ListedBondOrder.prototype.lastPrice = 0;
        ListedBondOrder.prototype.averagePrice = 0;
        ListedBondOrder.prototype.tradingDate = null;
        ListedBondOrder.prototype.createdDate = null;
        ListedBondOrder.prototype.lastModifiedDate = null;
        ListedBondOrder.prototype.taxRate = 0;
        ListedBondOrder.prototype.exchangeFeeRate = 0;
        ListedBondOrder.prototype.feeRate = 0;
        ListedBondOrder.prototype.leaveQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        ListedBondOrder.prototype.canceledQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        ListedBondOrder.prototype.externalId = "";
        ListedBondOrder.prototype.error = "";
        ListedBondOrder.prototype.text = "";
        ListedBondOrder.prototype.priceSecure = 0;
        ListedBondOrder.prototype.custodyCode = "";
        ListedBondOrder.prototype.clOrdId = "";
        ListedBondOrder.prototype.origClOrdId = "";
        ListedBondOrder.prototype.execType = "";
        ListedBondOrder.prototype.maker = "";
        ListedBondOrder.prototype.channel = "";
        ListedBondOrder.prototype.metadata = "";
        ListedBondOrder.prototype.exDestination = "";
        ListedBondOrder.prototype.loanPackageId = 0;
        ListedBondOrder.prototype.initialRate = 0;
        ListedBondOrder.prototype.execId = "";
        ListedBondOrder.create = function create(properties) {
          return new ListedBondOrder(properties);
        };
        ListedBondOrder.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
          if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
            writer.uint32(16).int64(message.orderId);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(26).string(message.symbol);
          if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(34).string(message.side);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(42).string(message.accountNo);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(50).string(message.investorId);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(57).double(message.price);
          if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(64).int64(message.quantity);
          if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
            writer.uint32(74).string(message.orderType);
          if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
            writer.uint32(82).string(message.orderStatus);
          if (message.fillQuantity != null && Object.hasOwnProperty.call(message, "fillQuantity"))
            writer.uint32(88).int64(message.fillQuantity);
          if (message.lastQuantity != null && Object.hasOwnProperty.call(message, "lastQuantity"))
            writer.uint32(96).int64(message.lastQuantity);
          if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
            writer.uint32(105).double(message.lastPrice);
          if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
            writer.uint32(113).double(message.averagePrice);
          if (message.tradingDate != null && Object.hasOwnProperty.call(message, "tradingDate"))
            $root.google.protobuf.Timestamp.encode(message.tradingDate, writer.uint32(122).fork()).ldelim();
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(130).fork()).ldelim();
          if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
            $root.google.protobuf.Timestamp.encode(message.lastModifiedDate, writer.uint32(138).fork()).ldelim();
          if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
            writer.uint32(145).double(message.taxRate);
          if (message.exchangeFeeRate != null && Object.hasOwnProperty.call(message, "exchangeFeeRate"))
            writer.uint32(153).double(message.exchangeFeeRate);
          if (message.feeRate != null && Object.hasOwnProperty.call(message, "feeRate"))
            writer.uint32(161).double(message.feeRate);
          if (message.leaveQuantity != null && Object.hasOwnProperty.call(message, "leaveQuantity"))
            writer.uint32(168).int64(message.leaveQuantity);
          if (message.canceledQuantity != null && Object.hasOwnProperty.call(message, "canceledQuantity"))
            writer.uint32(176).int64(message.canceledQuantity);
          if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
            writer.uint32(186).string(message.externalId);
          if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(194).string(message.error);
          if (message.text != null && Object.hasOwnProperty.call(message, "text"))
            writer.uint32(202).string(message.text);
          if (message.priceSecure != null && Object.hasOwnProperty.call(message, "priceSecure"))
            writer.uint32(209).double(message.priceSecure);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(218).string(message.custodyCode);
          if (message.clOrdId != null && Object.hasOwnProperty.call(message, "clOrdId"))
            writer.uint32(226).string(message.clOrdId);
          if (message.origClOrdId != null && Object.hasOwnProperty.call(message, "origClOrdId"))
            writer.uint32(234).string(message.origClOrdId);
          if (message.execType != null && Object.hasOwnProperty.call(message, "execType"))
            writer.uint32(242).string(message.execType);
          if (message.maker != null && Object.hasOwnProperty.call(message, "maker"))
            writer.uint32(250).string(message.maker);
          if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(258).string(message.channel);
          if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
            writer.uint32(266).string(message.metadata);
          if (message.exDestination != null && Object.hasOwnProperty.call(message, "exDestination"))
            writer.uint32(274).string(message.exDestination);
          if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
            writer.uint32(280).int32(message.loanPackageId);
          if (message.initialRate != null && Object.hasOwnProperty.call(message, "initialRate"))
            writer.uint32(289).double(message.initialRate);
          if (message.execId != null && Object.hasOwnProperty.call(message, "execId"))
            writer.uint32(298).string(message.execId);
          return writer;
        };
        ListedBondOrder.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        ListedBondOrder.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.bond.v1.ListedBondOrder();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.string();
                break;
              case 2:
                message.orderId = reader.int64();
                break;
              case 3:
                message.symbol = reader.string();
                break;
              case 4:
                message.side = reader.string();
                break;
              case 5:
                message.accountNo = reader.string();
                break;
              case 6:
                message.investorId = reader.string();
                break;
              case 7:
                message.price = reader.double();
                break;
              case 8:
                message.quantity = reader.int64();
                break;
              case 9:
                message.orderType = reader.string();
                break;
              case 10:
                message.orderStatus = reader.string();
                break;
              case 11:
                message.fillQuantity = reader.int64();
                break;
              case 12:
                message.lastQuantity = reader.int64();
                break;
              case 13:
                message.lastPrice = reader.double();
                break;
              case 14:
                message.averagePrice = reader.double();
                break;
              case 15:
                message.tradingDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 16:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 17:
                message.lastModifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 18:
                message.taxRate = reader.double();
                break;
              case 19:
                message.exchangeFeeRate = reader.double();
                break;
              case 20:
                message.feeRate = reader.double();
                break;
              case 21:
                message.leaveQuantity = reader.int64();
                break;
              case 22:
                message.canceledQuantity = reader.int64();
                break;
              case 23:
                message.externalId = reader.string();
                break;
              case 24:
                message.error = reader.string();
                break;
              case 25:
                message.text = reader.string();
                break;
              case 26:
                message.priceSecure = reader.double();
                break;
              case 27:
                message.custodyCode = reader.string();
                break;
              case 28:
                message.clOrdId = reader.string();
                break;
              case 29:
                message.origClOrdId = reader.string();
                break;
              case 30:
                message.execType = reader.string();
                break;
              case 31:
                message.maker = reader.string();
                break;
              case 32:
                message.channel = reader.string();
                break;
              case 33:
                message.metadata = reader.string();
                break;
              case 34:
                message.exDestination = reader.string();
                break;
              case 35:
                message.loanPackageId = reader.int32();
                break;
              case 36:
                message.initialRate = reader.double();
                break;
              case 37:
                message.execId = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        ListedBondOrder.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        ListedBondOrder.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isString(message.id))
              return "id: string expected";
          }
          if (message.orderId != null && message.hasOwnProperty("orderId")) {
            if (!$util.isInteger(message.orderId) && !(message.orderId && $util.isInteger(message.orderId.low) && $util.isInteger(message.orderId.high)))
              return "orderId: integer|Long expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.side != null && message.hasOwnProperty("side")) {
            if (!$util.isString(message.side))
              return "side: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.quantity != null && message.hasOwnProperty("quantity")) {
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
              return "quantity: integer|Long expected";
          }
          if (message.orderType != null && message.hasOwnProperty("orderType")) {
            if (!$util.isString(message.orderType))
              return "orderType: string expected";
          }
          if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
            if (!$util.isString(message.orderStatus))
              return "orderStatus: string expected";
          }
          if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity")) {
            if (!$util.isInteger(message.fillQuantity) && !(message.fillQuantity && $util.isInteger(message.fillQuantity.low) && $util.isInteger(message.fillQuantity.high)))
              return "fillQuantity: integer|Long expected";
          }
          if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity")) {
            if (!$util.isInteger(message.lastQuantity) && !(message.lastQuantity && $util.isInteger(message.lastQuantity.low) && $util.isInteger(message.lastQuantity.high)))
              return "lastQuantity: integer|Long expected";
          }
          if (message.lastPrice != null && message.hasOwnProperty("lastPrice")) {
            if (typeof message.lastPrice !== "number")
              return "lastPrice: number expected";
          }
          if (message.averagePrice != null && message.hasOwnProperty("averagePrice")) {
            if (typeof message.averagePrice !== "number")
              return "averagePrice: number expected";
          }
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.tradingDate);
            if (error)
              return "tradingDate." + error;
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.lastModifiedDate);
            if (error)
              return "lastModifiedDate." + error;
          }
          if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
            if (typeof message.taxRate !== "number")
              return "taxRate: number expected";
          }
          if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate")) {
            if (typeof message.exchangeFeeRate !== "number")
              return "exchangeFeeRate: number expected";
          }
          if (message.feeRate != null && message.hasOwnProperty("feeRate")) {
            if (typeof message.feeRate !== "number")
              return "feeRate: number expected";
          }
          if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity")) {
            if (!$util.isInteger(message.leaveQuantity) && !(message.leaveQuantity && $util.isInteger(message.leaveQuantity.low) && $util.isInteger(message.leaveQuantity.high)))
              return "leaveQuantity: integer|Long expected";
          }
          if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity")) {
            if (!$util.isInteger(message.canceledQuantity) && !(message.canceledQuantity && $util.isInteger(message.canceledQuantity.low) && $util.isInteger(message.canceledQuantity.high)))
              return "canceledQuantity: integer|Long expected";
          }
          if (message.externalId != null && message.hasOwnProperty("externalId")) {
            if (!$util.isString(message.externalId))
              return "externalId: string expected";
          }
          if (message.error != null && message.hasOwnProperty("error")) {
            if (!$util.isString(message.error))
              return "error: string expected";
          }
          if (message.text != null && message.hasOwnProperty("text")) {
            if (!$util.isString(message.text))
              return "text: string expected";
          }
          if (message.priceSecure != null && message.hasOwnProperty("priceSecure")) {
            if (typeof message.priceSecure !== "number")
              return "priceSecure: number expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.clOrdId != null && message.hasOwnProperty("clOrdId")) {
            if (!$util.isString(message.clOrdId))
              return "clOrdId: string expected";
          }
          if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId")) {
            if (!$util.isString(message.origClOrdId))
              return "origClOrdId: string expected";
          }
          if (message.execType != null && message.hasOwnProperty("execType")) {
            if (!$util.isString(message.execType))
              return "execType: string expected";
          }
          if (message.maker != null && message.hasOwnProperty("maker")) {
            if (!$util.isString(message.maker))
              return "maker: string expected";
          }
          if (message.channel != null && message.hasOwnProperty("channel")) {
            if (!$util.isString(message.channel))
              return "channel: string expected";
          }
          if (message.metadata != null && message.hasOwnProperty("metadata")) {
            if (!$util.isString(message.metadata))
              return "metadata: string expected";
          }
          if (message.exDestination != null && message.hasOwnProperty("exDestination")) {
            if (!$util.isString(message.exDestination))
              return "exDestination: string expected";
          }
          if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
            if (!$util.isInteger(message.loanPackageId))
              return "loanPackageId: integer expected";
          }
          if (message.initialRate != null && message.hasOwnProperty("initialRate")) {
            if (typeof message.initialRate !== "number")
              return "initialRate: number expected";
          }
          if (message.execId != null && message.hasOwnProperty("execId")) {
            if (!$util.isString(message.execId))
              return "execId: string expected";
          }
          return null;
        };
        ListedBondOrder.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.bond.v1.ListedBondOrder)
            return object;
          let message = new $root.dnse.bond.v1.ListedBondOrder();
          if (object.id != null)
            message.id = String(object.id);
          if (object.orderId != null) {
            if ($util.Long)
              (message.orderId = $util.Long.fromValue(object.orderId)).unsigned = false;
            else if (typeof object.orderId === "string")
              message.orderId = parseInt(object.orderId, 10);
            else if (typeof object.orderId === "number")
              message.orderId = object.orderId;
            else if (typeof object.orderId === "object")
              message.orderId = new $util.LongBits(object.orderId.low >>> 0, object.orderId.high >>> 0).toNumber();
          }
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          if (object.side != null)
            message.side = String(object.side);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          if (object.price != null)
            message.price = Number(object.price);
          if (object.quantity != null) {
            if ($util.Long)
              (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
              message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
              message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
              message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
          }
          if (object.orderType != null)
            message.orderType = String(object.orderType);
          if (object.orderStatus != null)
            message.orderStatus = String(object.orderStatus);
          if (object.fillQuantity != null) {
            if ($util.Long)
              (message.fillQuantity = $util.Long.fromValue(object.fillQuantity)).unsigned = false;
            else if (typeof object.fillQuantity === "string")
              message.fillQuantity = parseInt(object.fillQuantity, 10);
            else if (typeof object.fillQuantity === "number")
              message.fillQuantity = object.fillQuantity;
            else if (typeof object.fillQuantity === "object")
              message.fillQuantity = new $util.LongBits(object.fillQuantity.low >>> 0, object.fillQuantity.high >>> 0).toNumber();
          }
          if (object.lastQuantity != null) {
            if ($util.Long)
              (message.lastQuantity = $util.Long.fromValue(object.lastQuantity)).unsigned = false;
            else if (typeof object.lastQuantity === "string")
              message.lastQuantity = parseInt(object.lastQuantity, 10);
            else if (typeof object.lastQuantity === "number")
              message.lastQuantity = object.lastQuantity;
            else if (typeof object.lastQuantity === "object")
              message.lastQuantity = new $util.LongBits(object.lastQuantity.low >>> 0, object.lastQuantity.high >>> 0).toNumber();
          }
          if (object.lastPrice != null)
            message.lastPrice = Number(object.lastPrice);
          if (object.averagePrice != null)
            message.averagePrice = Number(object.averagePrice);
          if (object.tradingDate != null) {
            if (typeof object.tradingDate !== "object")
              throw TypeError(".dnse.bond.v1.ListedBondOrder.tradingDate: object expected");
            message.tradingDate = $root.google.protobuf.Timestamp.fromObject(object.tradingDate);
          }
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.bond.v1.ListedBondOrder.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.lastModifiedDate != null) {
            if (typeof object.lastModifiedDate !== "object")
              throw TypeError(".dnse.bond.v1.ListedBondOrder.lastModifiedDate: object expected");
            message.lastModifiedDate = $root.google.protobuf.Timestamp.fromObject(object.lastModifiedDate);
          }
          if (object.taxRate != null)
            message.taxRate = Number(object.taxRate);
          if (object.exchangeFeeRate != null)
            message.exchangeFeeRate = Number(object.exchangeFeeRate);
          if (object.feeRate != null)
            message.feeRate = Number(object.feeRate);
          if (object.leaveQuantity != null) {
            if ($util.Long)
              (message.leaveQuantity = $util.Long.fromValue(object.leaveQuantity)).unsigned = false;
            else if (typeof object.leaveQuantity === "string")
              message.leaveQuantity = parseInt(object.leaveQuantity, 10);
            else if (typeof object.leaveQuantity === "number")
              message.leaveQuantity = object.leaveQuantity;
            else if (typeof object.leaveQuantity === "object")
              message.leaveQuantity = new $util.LongBits(object.leaveQuantity.low >>> 0, object.leaveQuantity.high >>> 0).toNumber();
          }
          if (object.canceledQuantity != null) {
            if ($util.Long)
              (message.canceledQuantity = $util.Long.fromValue(object.canceledQuantity)).unsigned = false;
            else if (typeof object.canceledQuantity === "string")
              message.canceledQuantity = parseInt(object.canceledQuantity, 10);
            else if (typeof object.canceledQuantity === "number")
              message.canceledQuantity = object.canceledQuantity;
            else if (typeof object.canceledQuantity === "object")
              message.canceledQuantity = new $util.LongBits(object.canceledQuantity.low >>> 0, object.canceledQuantity.high >>> 0).toNumber();
          }
          if (object.externalId != null)
            message.externalId = String(object.externalId);
          if (object.error != null)
            message.error = String(object.error);
          if (object.text != null)
            message.text = String(object.text);
          if (object.priceSecure != null)
            message.priceSecure = Number(object.priceSecure);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.clOrdId != null)
            message.clOrdId = String(object.clOrdId);
          if (object.origClOrdId != null)
            message.origClOrdId = String(object.origClOrdId);
          if (object.execType != null)
            message.execType = String(object.execType);
          if (object.maker != null)
            message.maker = String(object.maker);
          if (object.channel != null)
            message.channel = String(object.channel);
          if (object.metadata != null)
            message.metadata = String(object.metadata);
          if (object.exDestination != null)
            message.exDestination = String(object.exDestination);
          if (object.loanPackageId != null)
            message.loanPackageId = object.loanPackageId | 0;
          if (object.initialRate != null)
            message.initialRate = Number(object.initialRate);
          if (object.execId != null)
            message.execId = String(object.execId);
          return message;
        };
        ListedBondOrder.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.id = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.orderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.orderId = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.side = "";
            object.accountNo = "";
            object.investorId = "";
            object.price = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.quantity = options.longs === String ? "0" : 0;
            object.orderType = "";
            object.orderStatus = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.fillQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.fillQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.lastQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.lastQuantity = options.longs === String ? "0" : 0;
            object.lastPrice = 0;
            object.averagePrice = 0;
            object.tradingDate = null;
            object.createdDate = null;
            object.lastModifiedDate = null;
            object.taxRate = 0;
            object.exchangeFeeRate = 0;
            object.feeRate = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.leaveQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.leaveQuantity = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.canceledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.canceledQuantity = options.longs === String ? "0" : 0;
            object.externalId = "";
            object.error = "";
            object.text = "";
            object.priceSecure = 0;
            object.custodyCode = "";
            object.clOrdId = "";
            object.origClOrdId = "";
            object.execType = "";
            object.maker = "";
            object.channel = "";
            object.metadata = "";
            object.exDestination = "";
            object.loanPackageId = 0;
            object.initialRate = 0;
            object.execId = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
          if (message.orderId != null && message.hasOwnProperty("orderId"))
            if (typeof message.orderId === "number")
              object.orderId = options.longs === String ? String(message.orderId) : message.orderId;
            else
              object.orderId = options.longs === String ? $util.Long.prototype.toString.call(message.orderId) : options.longs === Number ? new $util.LongBits(message.orderId.low >>> 0, message.orderId.high >>> 0).toNumber() : message.orderId;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.side != null && message.hasOwnProperty("side"))
            object.side = message.side;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
              object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
              object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
          if (message.orderType != null && message.hasOwnProperty("orderType"))
            object.orderType = message.orderType;
          if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
            object.orderStatus = message.orderStatus;
          if (message.fillQuantity != null && message.hasOwnProperty("fillQuantity"))
            if (typeof message.fillQuantity === "number")
              object.fillQuantity = options.longs === String ? String(message.fillQuantity) : message.fillQuantity;
            else
              object.fillQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fillQuantity) : options.longs === Number ? new $util.LongBits(message.fillQuantity.low >>> 0, message.fillQuantity.high >>> 0).toNumber() : message.fillQuantity;
          if (message.lastQuantity != null && message.hasOwnProperty("lastQuantity"))
            if (typeof message.lastQuantity === "number")
              object.lastQuantity = options.longs === String ? String(message.lastQuantity) : message.lastQuantity;
            else
              object.lastQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.lastQuantity) : options.longs === Number ? new $util.LongBits(message.lastQuantity.low >>> 0, message.lastQuantity.high >>> 0).toNumber() : message.lastQuantity;
          if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
            object.lastPrice = options.json && !isFinite(message.lastPrice) ? String(message.lastPrice) : message.lastPrice;
          if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
            object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
          if (message.tradingDate != null && message.hasOwnProperty("tradingDate"))
            object.tradingDate = $root.google.protobuf.Timestamp.toObject(message.tradingDate, options);
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
            object.lastModifiedDate = $root.google.protobuf.Timestamp.toObject(message.lastModifiedDate, options);
          if (message.taxRate != null && message.hasOwnProperty("taxRate"))
            object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
          if (message.exchangeFeeRate != null && message.hasOwnProperty("exchangeFeeRate"))
            object.exchangeFeeRate = options.json && !isFinite(message.exchangeFeeRate) ? String(message.exchangeFeeRate) : message.exchangeFeeRate;
          if (message.feeRate != null && message.hasOwnProperty("feeRate"))
            object.feeRate = options.json && !isFinite(message.feeRate) ? String(message.feeRate) : message.feeRate;
          if (message.leaveQuantity != null && message.hasOwnProperty("leaveQuantity"))
            if (typeof message.leaveQuantity === "number")
              object.leaveQuantity = options.longs === String ? String(message.leaveQuantity) : message.leaveQuantity;
            else
              object.leaveQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.leaveQuantity) : options.longs === Number ? new $util.LongBits(message.leaveQuantity.low >>> 0, message.leaveQuantity.high >>> 0).toNumber() : message.leaveQuantity;
          if (message.canceledQuantity != null && message.hasOwnProperty("canceledQuantity"))
            if (typeof message.canceledQuantity === "number")
              object.canceledQuantity = options.longs === String ? String(message.canceledQuantity) : message.canceledQuantity;
            else
              object.canceledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.canceledQuantity) : options.longs === Number ? new $util.LongBits(message.canceledQuantity.low >>> 0, message.canceledQuantity.high >>> 0).toNumber() : message.canceledQuantity;
          if (message.externalId != null && message.hasOwnProperty("externalId"))
            object.externalId = message.externalId;
          if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
          if (message.text != null && message.hasOwnProperty("text"))
            object.text = message.text;
          if (message.priceSecure != null && message.hasOwnProperty("priceSecure"))
            object.priceSecure = options.json && !isFinite(message.priceSecure) ? String(message.priceSecure) : message.priceSecure;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.clOrdId != null && message.hasOwnProperty("clOrdId"))
            object.clOrdId = message.clOrdId;
          if (message.origClOrdId != null && message.hasOwnProperty("origClOrdId"))
            object.origClOrdId = message.origClOrdId;
          if (message.execType != null && message.hasOwnProperty("execType"))
            object.execType = message.execType;
          if (message.maker != null && message.hasOwnProperty("maker"))
            object.maker = message.maker;
          if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
          if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = message.metadata;
          if (message.exDestination != null && message.hasOwnProperty("exDestination"))
            object.exDestination = message.exDestination;
          if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
            object.loanPackageId = message.loanPackageId;
          if (message.initialRate != null && message.hasOwnProperty("initialRate"))
            object.initialRate = options.json && !isFinite(message.initialRate) ? String(message.initialRate) : message.initialRate;
          if (message.execId != null && message.hasOwnProperty("execId"))
            object.execId = message.execId;
          return object;
        };
        ListedBondOrder.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return ListedBondOrder;
      }();
      return v1;
    }();
    return bond;
  }();
  dnse2.RegistrationAnalytic = function() {
    function RegistrationAnalytic(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    RegistrationAnalytic.prototype.totalUserRegistered = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    RegistrationAnalytic.prototype.totalSharesRegistered = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    RegistrationAnalytic.prototype.totalShareholders = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    RegistrationAnalytic.prototype.totalShares = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    RegistrationAnalytic.prototype.stage = 0;
    RegistrationAnalytic.prototype.finalPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    RegistrationAnalytic.prototype.startPayment = "";
    RegistrationAnalytic.create = function create(properties) {
      return new RegistrationAnalytic(properties);
    };
    RegistrationAnalytic.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.totalUserRegistered != null && Object.hasOwnProperty.call(message, "totalUserRegistered"))
        writer.uint32(8).int64(message.totalUserRegistered);
      if (message.totalSharesRegistered != null && Object.hasOwnProperty.call(message, "totalSharesRegistered"))
        writer.uint32(16).int64(message.totalSharesRegistered);
      if (message.totalShareholders != null && Object.hasOwnProperty.call(message, "totalShareholders"))
        writer.uint32(24).int64(message.totalShareholders);
      if (message.totalShares != null && Object.hasOwnProperty.call(message, "totalShares"))
        writer.uint32(32).int64(message.totalShares);
      if (message.stage != null && Object.hasOwnProperty.call(message, "stage"))
        writer.uint32(40).int32(message.stage);
      if (message.finalPrice != null && Object.hasOwnProperty.call(message, "finalPrice"))
        writer.uint32(48).int64(message.finalPrice);
      if (message.startPayment != null && Object.hasOwnProperty.call(message, "startPayment"))
        writer.uint32(58).string(message.startPayment);
      return writer;
    };
    RegistrationAnalytic.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    RegistrationAnalytic.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.RegistrationAnalytic();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.totalUserRegistered = reader.int64();
            break;
          case 2:
            message.totalSharesRegistered = reader.int64();
            break;
          case 3:
            message.totalShareholders = reader.int64();
            break;
          case 4:
            message.totalShares = reader.int64();
            break;
          case 5:
            message.stage = reader.int32();
            break;
          case 6:
            message.finalPrice = reader.int64();
            break;
          case 7:
            message.startPayment = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    RegistrationAnalytic.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    RegistrationAnalytic.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.totalUserRegistered != null && message.hasOwnProperty("totalUserRegistered")) {
        if (!$util.isInteger(message.totalUserRegistered) && !(message.totalUserRegistered && $util.isInteger(message.totalUserRegistered.low) && $util.isInteger(message.totalUserRegistered.high)))
          return "totalUserRegistered: integer|Long expected";
      }
      if (message.totalSharesRegistered != null && message.hasOwnProperty("totalSharesRegistered")) {
        if (!$util.isInteger(message.totalSharesRegistered) && !(message.totalSharesRegistered && $util.isInteger(message.totalSharesRegistered.low) && $util.isInteger(message.totalSharesRegistered.high)))
          return "totalSharesRegistered: integer|Long expected";
      }
      if (message.totalShareholders != null && message.hasOwnProperty("totalShareholders")) {
        if (!$util.isInteger(message.totalShareholders) && !(message.totalShareholders && $util.isInteger(message.totalShareholders.low) && $util.isInteger(message.totalShareholders.high)))
          return "totalShareholders: integer|Long expected";
      }
      if (message.totalShares != null && message.hasOwnProperty("totalShares")) {
        if (!$util.isInteger(message.totalShares) && !(message.totalShares && $util.isInteger(message.totalShares.low) && $util.isInteger(message.totalShares.high)))
          return "totalShares: integer|Long expected";
      }
      if (message.stage != null && message.hasOwnProperty("stage"))
        switch (message.stage) {
          default:
            return "stage: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.finalPrice != null && message.hasOwnProperty("finalPrice")) {
        if (!$util.isInteger(message.finalPrice) && !(message.finalPrice && $util.isInteger(message.finalPrice.low) && $util.isInteger(message.finalPrice.high)))
          return "finalPrice: integer|Long expected";
      }
      if (message.startPayment != null && message.hasOwnProperty("startPayment")) {
        if (!$util.isString(message.startPayment))
          return "startPayment: string expected";
      }
      return null;
    };
    RegistrationAnalytic.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.RegistrationAnalytic)
        return object;
      let message = new $root.dnse.RegistrationAnalytic();
      if (object.totalUserRegistered != null) {
        if ($util.Long)
          (message.totalUserRegistered = $util.Long.fromValue(object.totalUserRegistered)).unsigned = false;
        else if (typeof object.totalUserRegistered === "string")
          message.totalUserRegistered = parseInt(object.totalUserRegistered, 10);
        else if (typeof object.totalUserRegistered === "number")
          message.totalUserRegistered = object.totalUserRegistered;
        else if (typeof object.totalUserRegistered === "object")
          message.totalUserRegistered = new $util.LongBits(object.totalUserRegistered.low >>> 0, object.totalUserRegistered.high >>> 0).toNumber();
      }
      if (object.totalSharesRegistered != null) {
        if ($util.Long)
          (message.totalSharesRegistered = $util.Long.fromValue(object.totalSharesRegistered)).unsigned = false;
        else if (typeof object.totalSharesRegistered === "string")
          message.totalSharesRegistered = parseInt(object.totalSharesRegistered, 10);
        else if (typeof object.totalSharesRegistered === "number")
          message.totalSharesRegistered = object.totalSharesRegistered;
        else if (typeof object.totalSharesRegistered === "object")
          message.totalSharesRegistered = new $util.LongBits(object.totalSharesRegistered.low >>> 0, object.totalSharesRegistered.high >>> 0).toNumber();
      }
      if (object.totalShareholders != null) {
        if ($util.Long)
          (message.totalShareholders = $util.Long.fromValue(object.totalShareholders)).unsigned = false;
        else if (typeof object.totalShareholders === "string")
          message.totalShareholders = parseInt(object.totalShareholders, 10);
        else if (typeof object.totalShareholders === "number")
          message.totalShareholders = object.totalShareholders;
        else if (typeof object.totalShareholders === "object")
          message.totalShareholders = new $util.LongBits(object.totalShareholders.low >>> 0, object.totalShareholders.high >>> 0).toNumber();
      }
      if (object.totalShares != null) {
        if ($util.Long)
          (message.totalShares = $util.Long.fromValue(object.totalShares)).unsigned = false;
        else if (typeof object.totalShares === "string")
          message.totalShares = parseInt(object.totalShares, 10);
        else if (typeof object.totalShares === "number")
          message.totalShares = object.totalShares;
        else if (typeof object.totalShares === "object")
          message.totalShares = new $util.LongBits(object.totalShares.low >>> 0, object.totalShares.high >>> 0).toNumber();
      }
      switch (object.stage) {
        case "STAGE_STOCK_OFFERING":
        case 0:
          message.stage = 0;
          break;
        case "STAGE_PAYMENT":
        case 1:
          message.stage = 1;
          break;
        case "STAGE_AUCTION_RESULT_FINALIZATION":
        case 2:
          message.stage = 2;
          break;
      }
      if (object.finalPrice != null) {
        if ($util.Long)
          (message.finalPrice = $util.Long.fromValue(object.finalPrice)).unsigned = false;
        else if (typeof object.finalPrice === "string")
          message.finalPrice = parseInt(object.finalPrice, 10);
        else if (typeof object.finalPrice === "number")
          message.finalPrice = object.finalPrice;
        else if (typeof object.finalPrice === "object")
          message.finalPrice = new $util.LongBits(object.finalPrice.low >>> 0, object.finalPrice.high >>> 0).toNumber();
      }
      if (object.startPayment != null)
        message.startPayment = String(object.startPayment);
      return message;
    };
    RegistrationAnalytic.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalUserRegistered = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalUserRegistered = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalSharesRegistered = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalSharesRegistered = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalShareholders = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalShareholders = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalShares = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalShares = options.longs === String ? "0" : 0;
        object.stage = options.enums === String ? "STAGE_STOCK_OFFERING" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.finalPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.finalPrice = options.longs === String ? "0" : 0;
        object.startPayment = "";
      }
      if (message.totalUserRegistered != null && message.hasOwnProperty("totalUserRegistered"))
        if (typeof message.totalUserRegistered === "number")
          object.totalUserRegistered = options.longs === String ? String(message.totalUserRegistered) : message.totalUserRegistered;
        else
          object.totalUserRegistered = options.longs === String ? $util.Long.prototype.toString.call(message.totalUserRegistered) : options.longs === Number ? new $util.LongBits(message.totalUserRegistered.low >>> 0, message.totalUserRegistered.high >>> 0).toNumber() : message.totalUserRegistered;
      if (message.totalSharesRegistered != null && message.hasOwnProperty("totalSharesRegistered"))
        if (typeof message.totalSharesRegistered === "number")
          object.totalSharesRegistered = options.longs === String ? String(message.totalSharesRegistered) : message.totalSharesRegistered;
        else
          object.totalSharesRegistered = options.longs === String ? $util.Long.prototype.toString.call(message.totalSharesRegistered) : options.longs === Number ? new $util.LongBits(message.totalSharesRegistered.low >>> 0, message.totalSharesRegistered.high >>> 0).toNumber() : message.totalSharesRegistered;
      if (message.totalShareholders != null && message.hasOwnProperty("totalShareholders"))
        if (typeof message.totalShareholders === "number")
          object.totalShareholders = options.longs === String ? String(message.totalShareholders) : message.totalShareholders;
        else
          object.totalShareholders = options.longs === String ? $util.Long.prototype.toString.call(message.totalShareholders) : options.longs === Number ? new $util.LongBits(message.totalShareholders.low >>> 0, message.totalShareholders.high >>> 0).toNumber() : message.totalShareholders;
      if (message.totalShares != null && message.hasOwnProperty("totalShares"))
        if (typeof message.totalShares === "number")
          object.totalShares = options.longs === String ? String(message.totalShares) : message.totalShares;
        else
          object.totalShares = options.longs === String ? $util.Long.prototype.toString.call(message.totalShares) : options.longs === Number ? new $util.LongBits(message.totalShares.low >>> 0, message.totalShares.high >>> 0).toNumber() : message.totalShares;
      if (message.stage != null && message.hasOwnProperty("stage"))
        object.stage = options.enums === String ? $root.dnse.RegistrationAnalytic.Stage[message.stage] : message.stage;
      if (message.finalPrice != null && message.hasOwnProperty("finalPrice"))
        if (typeof message.finalPrice === "number")
          object.finalPrice = options.longs === String ? String(message.finalPrice) : message.finalPrice;
        else
          object.finalPrice = options.longs === String ? $util.Long.prototype.toString.call(message.finalPrice) : options.longs === Number ? new $util.LongBits(message.finalPrice.low >>> 0, message.finalPrice.high >>> 0).toNumber() : message.finalPrice;
      if (message.startPayment != null && message.hasOwnProperty("startPayment"))
        object.startPayment = message.startPayment;
      return object;
    };
    RegistrationAnalytic.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    RegistrationAnalytic.Stage = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "STAGE_STOCK_OFFERING"] = 0;
      values[valuesById[1] = "STAGE_PAYMENT"] = 1;
      values[valuesById[2] = "STAGE_AUCTION_RESULT_FINALIZATION"] = 2;
      return values;
    }();
    return RegistrationAnalytic;
  }();
  dnse2.NotifyPaymentStatus = function() {
    function NotifyPaymentStatus(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NotifyPaymentStatus.prototype.investorId = "";
    NotifyPaymentStatus.prototype.paymentStatus = "";
    NotifyPaymentStatus.prototype.paymentAmount = 0;
    NotifyPaymentStatus.prototype.time = null;
    NotifyPaymentStatus.prototype.registrationStatus = "";
    NotifyPaymentStatus.create = function create(properties) {
      return new NotifyPaymentStatus(properties);
    };
    NotifyPaymentStatus.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.paymentStatus != null && Object.hasOwnProperty.call(message, "paymentStatus"))
        writer.uint32(18).string(message.paymentStatus);
      if (message.paymentAmount != null && Object.hasOwnProperty.call(message, "paymentAmount"))
        writer.uint32(25).double(message.paymentAmount);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
      if (message.registrationStatus != null && Object.hasOwnProperty.call(message, "registrationStatus"))
        writer.uint32(42).string(message.registrationStatus);
      return writer;
    };
    NotifyPaymentStatus.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NotifyPaymentStatus.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NotifyPaymentStatus();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.paymentStatus = reader.string();
            break;
          case 3:
            message.paymentAmount = reader.double();
            break;
          case 4:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.registrationStatus = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NotifyPaymentStatus.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NotifyPaymentStatus.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.paymentStatus != null && message.hasOwnProperty("paymentStatus")) {
        if (!$util.isString(message.paymentStatus))
          return "paymentStatus: string expected";
      }
      if (message.paymentAmount != null && message.hasOwnProperty("paymentAmount")) {
        if (typeof message.paymentAmount !== "number")
          return "paymentAmount: number expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.registrationStatus != null && message.hasOwnProperty("registrationStatus")) {
        if (!$util.isString(message.registrationStatus))
          return "registrationStatus: string expected";
      }
      return null;
    };
    NotifyPaymentStatus.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NotifyPaymentStatus)
        return object;
      let message = new $root.dnse.NotifyPaymentStatus();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.paymentStatus != null)
        message.paymentStatus = String(object.paymentStatus);
      if (object.paymentAmount != null)
        message.paymentAmount = Number(object.paymentAmount);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.NotifyPaymentStatus.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.registrationStatus != null)
        message.registrationStatus = String(object.registrationStatus);
      return message;
    };
    NotifyPaymentStatus.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.paymentStatus = "";
        object.paymentAmount = 0;
        object.time = null;
        object.registrationStatus = "";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.paymentStatus != null && message.hasOwnProperty("paymentStatus"))
        object.paymentStatus = message.paymentStatus;
      if (message.paymentAmount != null && message.hasOwnProperty("paymentAmount"))
        object.paymentAmount = options.json && !isFinite(message.paymentAmount) ? String(message.paymentAmount) : message.paymentAmount;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.registrationStatus != null && message.hasOwnProperty("registrationStatus"))
        object.registrationStatus = message.registrationStatus;
      return object;
    };
    NotifyPaymentStatus.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return NotifyPaymentStatus;
  }();
  dnse2.NotifyRegistrationFormStatus = function() {
    function NotifyRegistrationFormStatus(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NotifyRegistrationFormStatus.prototype.investorId = "";
    NotifyRegistrationFormStatus.prototype.approvalStatus = "";
    NotifyRegistrationFormStatus.prototype.approvalComment = "";
    NotifyRegistrationFormStatus.prototype.approvalReason = "";
    NotifyRegistrationFormStatus.prototype.isValid = false;
    NotifyRegistrationFormStatus.prototype.time = null;
    NotifyRegistrationFormStatus.create = function create(properties) {
      return new NotifyRegistrationFormStatus(properties);
    };
    NotifyRegistrationFormStatus.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.approvalStatus != null && Object.hasOwnProperty.call(message, "approvalStatus"))
        writer.uint32(18).string(message.approvalStatus);
      if (message.approvalComment != null && Object.hasOwnProperty.call(message, "approvalComment"))
        writer.uint32(26).string(message.approvalComment);
      if (message.approvalReason != null && Object.hasOwnProperty.call(message, "approvalReason"))
        writer.uint32(34).string(message.approvalReason);
      if (message.isValid != null && Object.hasOwnProperty.call(message, "isValid"))
        writer.uint32(40).bool(message.isValid);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    NotifyRegistrationFormStatus.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NotifyRegistrationFormStatus.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NotifyRegistrationFormStatus();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.approvalStatus = reader.string();
            break;
          case 3:
            message.approvalComment = reader.string();
            break;
          case 4:
            message.approvalReason = reader.string();
            break;
          case 5:
            message.isValid = reader.bool();
            break;
          case 6:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NotifyRegistrationFormStatus.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NotifyRegistrationFormStatus.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.approvalStatus != null && message.hasOwnProperty("approvalStatus")) {
        if (!$util.isString(message.approvalStatus))
          return "approvalStatus: string expected";
      }
      if (message.approvalComment != null && message.hasOwnProperty("approvalComment")) {
        if (!$util.isString(message.approvalComment))
          return "approvalComment: string expected";
      }
      if (message.approvalReason != null && message.hasOwnProperty("approvalReason")) {
        if (!$util.isString(message.approvalReason))
          return "approvalReason: string expected";
      }
      if (message.isValid != null && message.hasOwnProperty("isValid")) {
        if (typeof message.isValid !== "boolean")
          return "isValid: boolean expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      return null;
    };
    NotifyRegistrationFormStatus.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NotifyRegistrationFormStatus)
        return object;
      let message = new $root.dnse.NotifyRegistrationFormStatus();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.approvalStatus != null)
        message.approvalStatus = String(object.approvalStatus);
      if (object.approvalComment != null)
        message.approvalComment = String(object.approvalComment);
      if (object.approvalReason != null)
        message.approvalReason = String(object.approvalReason);
      if (object.isValid != null)
        message.isValid = Boolean(object.isValid);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.NotifyRegistrationFormStatus.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      return message;
    };
    NotifyRegistrationFormStatus.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.approvalStatus = "";
        object.approvalComment = "";
        object.approvalReason = "";
        object.isValid = false;
        object.time = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.approvalStatus != null && message.hasOwnProperty("approvalStatus"))
        object.approvalStatus = message.approvalStatus;
      if (message.approvalComment != null && message.hasOwnProperty("approvalComment"))
        object.approvalComment = message.approvalComment;
      if (message.approvalReason != null && message.hasOwnProperty("approvalReason"))
        object.approvalReason = message.approvalReason;
      if (message.isValid != null && message.hasOwnProperty("isValid"))
        object.isValid = message.isValid;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      return object;
    };
    NotifyRegistrationFormStatus.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return NotifyRegistrationFormStatus;
  }();
  dnse2.NotifyEnbox = function() {
    function NotifyEnbox(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    NotifyEnbox.prototype.type = 0;
    NotifyEnbox.prototype.endDate = "";
    NotifyEnbox.prototype.subscribedPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnbox.prototype.subscribedShares = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnbox.prototype.totalPaymentAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnbox.prototype.currentPaymentAmount = 0;
    NotifyEnbox.prototype.requiredDepositAmount = 0;
    NotifyEnbox.prototype.remainingDepositAmount = 0;
    NotifyEnbox.prototype.time = null;
    NotifyEnbox.prototype.investorId = "";
    NotifyEnbox.prototype.accountTypeName = "";
    NotifyEnbox.prototype.comment = "";
    NotifyEnbox.prototype.totalPaymentAmountAfterRegistrationResult = 0;
    NotifyEnbox.prototype.remainingPaymentAmount = 0;
    NotifyEnbox.prototype.allocatedShares = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnbox.prototype.sharePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NotifyEnbox.prototype.registrationFormStatus = "";
    NotifyEnbox.prototype.refundedAmount = 0;
    NotifyEnbox.create = function create(properties) {
      return new NotifyEnbox(properties);
    };
    NotifyEnbox.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, "type"))
        writer.uint32(8).int32(message.type);
      if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
        writer.uint32(18).string(message.endDate);
      if (message.subscribedPrice != null && Object.hasOwnProperty.call(message, "subscribedPrice"))
        writer.uint32(24).int64(message.subscribedPrice);
      if (message.subscribedShares != null && Object.hasOwnProperty.call(message, "subscribedShares"))
        writer.uint32(32).int64(message.subscribedShares);
      if (message.totalPaymentAmount != null && Object.hasOwnProperty.call(message, "totalPaymentAmount"))
        writer.uint32(40).int64(message.totalPaymentAmount);
      if (message.currentPaymentAmount != null && Object.hasOwnProperty.call(message, "currentPaymentAmount"))
        writer.uint32(49).double(message.currentPaymentAmount);
      if (message.requiredDepositAmount != null && Object.hasOwnProperty.call(message, "requiredDepositAmount"))
        writer.uint32(57).double(message.requiredDepositAmount);
      if (message.remainingDepositAmount != null && Object.hasOwnProperty.call(message, "remainingDepositAmount"))
        writer.uint32(65).double(message.remainingDepositAmount);
      if (message.time != null && Object.hasOwnProperty.call(message, "time"))
        $root.google.protobuf.Timestamp.encode(message.time, writer.uint32(74).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(82).string(message.investorId);
      if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
        writer.uint32(90).string(message.accountTypeName);
      if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
        writer.uint32(98).string(message.comment);
      if (message.totalPaymentAmountAfterRegistrationResult != null && Object.hasOwnProperty.call(message, "totalPaymentAmountAfterRegistrationResult"))
        writer.uint32(105).double(message.totalPaymentAmountAfterRegistrationResult);
      if (message.remainingPaymentAmount != null && Object.hasOwnProperty.call(message, "remainingPaymentAmount"))
        writer.uint32(113).double(message.remainingPaymentAmount);
      if (message.allocatedShares != null && Object.hasOwnProperty.call(message, "allocatedShares"))
        writer.uint32(120).int64(message.allocatedShares);
      if (message.sharePrice != null && Object.hasOwnProperty.call(message, "sharePrice"))
        writer.uint32(128).int64(message.sharePrice);
      if (message.registrationFormStatus != null && Object.hasOwnProperty.call(message, "registrationFormStatus"))
        writer.uint32(138).string(message.registrationFormStatus);
      if (message.refundedAmount != null && Object.hasOwnProperty.call(message, "refundedAmount"))
        writer.uint32(145).double(message.refundedAmount);
      return writer;
    };
    NotifyEnbox.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    NotifyEnbox.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.NotifyEnbox();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.type = reader.int32();
            break;
          case 2:
            message.endDate = reader.string();
            break;
          case 3:
            message.subscribedPrice = reader.int64();
            break;
          case 4:
            message.subscribedShares = reader.int64();
            break;
          case 5:
            message.totalPaymentAmount = reader.int64();
            break;
          case 6:
            message.currentPaymentAmount = reader.double();
            break;
          case 7:
            message.requiredDepositAmount = reader.double();
            break;
          case 8:
            message.remainingDepositAmount = reader.double();
            break;
          case 9:
            message.time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.investorId = reader.string();
            break;
          case 11:
            message.accountTypeName = reader.string();
            break;
          case 12:
            message.comment = reader.string();
            break;
          case 13:
            message.totalPaymentAmountAfterRegistrationResult = reader.double();
            break;
          case 14:
            message.remainingPaymentAmount = reader.double();
            break;
          case 15:
            message.allocatedShares = reader.int64();
            break;
          case 16:
            message.sharePrice = reader.int64();
            break;
          case 17:
            message.registrationFormStatus = reader.string();
            break;
          case 18:
            message.refundedAmount = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    NotifyEnbox.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    NotifyEnbox.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.type != null && message.hasOwnProperty("type"))
        switch (message.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
            break;
        }
      if (message.endDate != null && message.hasOwnProperty("endDate")) {
        if (!$util.isString(message.endDate))
          return "endDate: string expected";
      }
      if (message.subscribedPrice != null && message.hasOwnProperty("subscribedPrice")) {
        if (!$util.isInteger(message.subscribedPrice) && !(message.subscribedPrice && $util.isInteger(message.subscribedPrice.low) && $util.isInteger(message.subscribedPrice.high)))
          return "subscribedPrice: integer|Long expected";
      }
      if (message.subscribedShares != null && message.hasOwnProperty("subscribedShares")) {
        if (!$util.isInteger(message.subscribedShares) && !(message.subscribedShares && $util.isInteger(message.subscribedShares.low) && $util.isInteger(message.subscribedShares.high)))
          return "subscribedShares: integer|Long expected";
      }
      if (message.totalPaymentAmount != null && message.hasOwnProperty("totalPaymentAmount")) {
        if (!$util.isInteger(message.totalPaymentAmount) && !(message.totalPaymentAmount && $util.isInteger(message.totalPaymentAmount.low) && $util.isInteger(message.totalPaymentAmount.high)))
          return "totalPaymentAmount: integer|Long expected";
      }
      if (message.currentPaymentAmount != null && message.hasOwnProperty("currentPaymentAmount")) {
        if (typeof message.currentPaymentAmount !== "number")
          return "currentPaymentAmount: number expected";
      }
      if (message.requiredDepositAmount != null && message.hasOwnProperty("requiredDepositAmount")) {
        if (typeof message.requiredDepositAmount !== "number")
          return "requiredDepositAmount: number expected";
      }
      if (message.remainingDepositAmount != null && message.hasOwnProperty("remainingDepositAmount")) {
        if (typeof message.remainingDepositAmount !== "number")
          return "remainingDepositAmount: number expected";
      }
      if (message.time != null && message.hasOwnProperty("time")) {
        let error = $root.google.protobuf.Timestamp.verify(message.time);
        if (error)
          return "time." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
        if (!$util.isString(message.accountTypeName))
          return "accountTypeName: string expected";
      }
      if (message.comment != null && message.hasOwnProperty("comment")) {
        if (!$util.isString(message.comment))
          return "comment: string expected";
      }
      if (message.totalPaymentAmountAfterRegistrationResult != null && message.hasOwnProperty("totalPaymentAmountAfterRegistrationResult")) {
        if (typeof message.totalPaymentAmountAfterRegistrationResult !== "number")
          return "totalPaymentAmountAfterRegistrationResult: number expected";
      }
      if (message.remainingPaymentAmount != null && message.hasOwnProperty("remainingPaymentAmount")) {
        if (typeof message.remainingPaymentAmount !== "number")
          return "remainingPaymentAmount: number expected";
      }
      if (message.allocatedShares != null && message.hasOwnProperty("allocatedShares")) {
        if (!$util.isInteger(message.allocatedShares) && !(message.allocatedShares && $util.isInteger(message.allocatedShares.low) && $util.isInteger(message.allocatedShares.high)))
          return "allocatedShares: integer|Long expected";
      }
      if (message.sharePrice != null && message.hasOwnProperty("sharePrice")) {
        if (!$util.isInteger(message.sharePrice) && !(message.sharePrice && $util.isInteger(message.sharePrice.low) && $util.isInteger(message.sharePrice.high)))
          return "sharePrice: integer|Long expected";
      }
      if (message.registrationFormStatus != null && message.hasOwnProperty("registrationFormStatus")) {
        if (!$util.isString(message.registrationFormStatus))
          return "registrationFormStatus: string expected";
      }
      if (message.refundedAmount != null && message.hasOwnProperty("refundedAmount")) {
        if (typeof message.refundedAmount !== "number")
          return "refundedAmount: number expected";
      }
      return null;
    };
    NotifyEnbox.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.NotifyEnbox)
        return object;
      let message = new $root.dnse.NotifyEnbox();
      switch (object.type) {
        case "NOTIFY_SUBMITTED_REGISTRATION_FORM_PARTIALLY_DEPOSITED":
        case 0:
          message.type = 0;
          break;
        case "NOTIFY_SUBMITTED_REGISTRATION_FORM_DEPOSITED":
        case 1:
          message.type = 1;
          break;
        case "NOTIFY_NEW_REGISTRATION_FORM_PARTIALLY_DEPOSITED":
        case 2:
          message.type = 2;
          break;
        case "NOTIFY_NEW_REGISTRATION_FORM_DEPOSITED":
        case 3:
          message.type = 3;
          break;
        case "NOTIFY_REGISTRATION_FORM_SUBMISSION":
        case 4:
          message.type = 4;
          break;
        case "NOTIFY_REGISTRATION_FORM_MODIFICATION":
        case 5:
          message.type = 5;
          break;
        case "NOTIFY_PAYMENT_FAILED":
        case 6:
          message.type = 6;
          break;
        case "NOTIFY_NOT_ENOUGH_MONEY":
        case 7:
          message.type = 7;
          break;
        case "NOTIFY_REJECTED_REGISTRATION_FORM":
        case 8:
          message.type = 8;
          break;
        case "NOTIFY_VALID_REGISTRATION_FORM":
        case 9:
          message.type = 9;
          break;
        case "NOTIFY_SUCCESSFUL_PAID_AUCTION":
        case 10:
          message.type = 10;
          break;
        case "NOTIFY_SUCCESSFUL_UNPAID_AUCTION":
        case 11:
          message.type = 11;
          break;
        case "NOTIFY_AUCTION_FAILED":
        case 12:
          message.type = 12;
          break;
        case "NOTIFY_REJECTED_AUCTION":
        case 13:
          message.type = 13;
          break;
        case "NOTIFY_INCOMPLETE_REGISTRATION":
        case 14:
          message.type = 14;
          break;
        case "NOTIFY_FINAL_DAY_INCOMPLETE_REGISTRATION":
        case 15:
          message.type = 15;
          break;
        case "NOTIFY_DEPOSIT_PAYMENT":
        case 16:
          message.type = 16;
          break;
        case "NOTIFY_FINAL_DAY_DEPOSIT_PAYMENT":
        case 17:
          message.type = 17;
          break;
        case "NOTIFY_PAYMENT_REMINDER":
        case 18:
          message.type = 18;
          break;
        case "NOTIFY_DECLINED_AUCTION":
        case 19:
          message.type = 19;
          break;
        case "NOTIFY_BECAME_SHAREHOLDER":
        case 20:
          message.type = 20;
          break;
        case "NOTIFY_REFUNDED_PAYMENT":
        case 21:
          message.type = 21;
          break;
      }
      if (object.endDate != null)
        message.endDate = String(object.endDate);
      if (object.subscribedPrice != null) {
        if ($util.Long)
          (message.subscribedPrice = $util.Long.fromValue(object.subscribedPrice)).unsigned = false;
        else if (typeof object.subscribedPrice === "string")
          message.subscribedPrice = parseInt(object.subscribedPrice, 10);
        else if (typeof object.subscribedPrice === "number")
          message.subscribedPrice = object.subscribedPrice;
        else if (typeof object.subscribedPrice === "object")
          message.subscribedPrice = new $util.LongBits(object.subscribedPrice.low >>> 0, object.subscribedPrice.high >>> 0).toNumber();
      }
      if (object.subscribedShares != null) {
        if ($util.Long)
          (message.subscribedShares = $util.Long.fromValue(object.subscribedShares)).unsigned = false;
        else if (typeof object.subscribedShares === "string")
          message.subscribedShares = parseInt(object.subscribedShares, 10);
        else if (typeof object.subscribedShares === "number")
          message.subscribedShares = object.subscribedShares;
        else if (typeof object.subscribedShares === "object")
          message.subscribedShares = new $util.LongBits(object.subscribedShares.low >>> 0, object.subscribedShares.high >>> 0).toNumber();
      }
      if (object.totalPaymentAmount != null) {
        if ($util.Long)
          (message.totalPaymentAmount = $util.Long.fromValue(object.totalPaymentAmount)).unsigned = false;
        else if (typeof object.totalPaymentAmount === "string")
          message.totalPaymentAmount = parseInt(object.totalPaymentAmount, 10);
        else if (typeof object.totalPaymentAmount === "number")
          message.totalPaymentAmount = object.totalPaymentAmount;
        else if (typeof object.totalPaymentAmount === "object")
          message.totalPaymentAmount = new $util.LongBits(object.totalPaymentAmount.low >>> 0, object.totalPaymentAmount.high >>> 0).toNumber();
      }
      if (object.currentPaymentAmount != null)
        message.currentPaymentAmount = Number(object.currentPaymentAmount);
      if (object.requiredDepositAmount != null)
        message.requiredDepositAmount = Number(object.requiredDepositAmount);
      if (object.remainingDepositAmount != null)
        message.remainingDepositAmount = Number(object.remainingDepositAmount);
      if (object.time != null) {
        if (typeof object.time !== "object")
          throw TypeError(".dnse.NotifyEnbox.time: object expected");
        message.time = $root.google.protobuf.Timestamp.fromObject(object.time);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountTypeName != null)
        message.accountTypeName = String(object.accountTypeName);
      if (object.comment != null)
        message.comment = String(object.comment);
      if (object.totalPaymentAmountAfterRegistrationResult != null)
        message.totalPaymentAmountAfterRegistrationResult = Number(object.totalPaymentAmountAfterRegistrationResult);
      if (object.remainingPaymentAmount != null)
        message.remainingPaymentAmount = Number(object.remainingPaymentAmount);
      if (object.allocatedShares != null) {
        if ($util.Long)
          (message.allocatedShares = $util.Long.fromValue(object.allocatedShares)).unsigned = false;
        else if (typeof object.allocatedShares === "string")
          message.allocatedShares = parseInt(object.allocatedShares, 10);
        else if (typeof object.allocatedShares === "number")
          message.allocatedShares = object.allocatedShares;
        else if (typeof object.allocatedShares === "object")
          message.allocatedShares = new $util.LongBits(object.allocatedShares.low >>> 0, object.allocatedShares.high >>> 0).toNumber();
      }
      if (object.sharePrice != null) {
        if ($util.Long)
          (message.sharePrice = $util.Long.fromValue(object.sharePrice)).unsigned = false;
        else if (typeof object.sharePrice === "string")
          message.sharePrice = parseInt(object.sharePrice, 10);
        else if (typeof object.sharePrice === "number")
          message.sharePrice = object.sharePrice;
        else if (typeof object.sharePrice === "object")
          message.sharePrice = new $util.LongBits(object.sharePrice.low >>> 0, object.sharePrice.high >>> 0).toNumber();
      }
      if (object.registrationFormStatus != null)
        message.registrationFormStatus = String(object.registrationFormStatus);
      if (object.refundedAmount != null)
        message.refundedAmount = Number(object.refundedAmount);
      return message;
    };
    NotifyEnbox.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? "NOTIFY_SUBMITTED_REGISTRATION_FORM_PARTIALLY_DEPOSITED" : 0;
        object.endDate = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.subscribedPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.subscribedPrice = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.subscribedShares = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.subscribedShares = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.totalPaymentAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.totalPaymentAmount = options.longs === String ? "0" : 0;
        object.currentPaymentAmount = 0;
        object.requiredDepositAmount = 0;
        object.remainingDepositAmount = 0;
        object.time = null;
        object.investorId = "";
        object.accountTypeName = "";
        object.comment = "";
        object.totalPaymentAmountAfterRegistrationResult = 0;
        object.remainingPaymentAmount = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.allocatedShares = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.allocatedShares = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharePrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.sharePrice = options.longs === String ? "0" : 0;
        object.registrationFormStatus = "";
        object.refundedAmount = 0;
      }
      if (message.type != null && message.hasOwnProperty("type"))
        object.type = options.enums === String ? $root.dnse.NotifyEnbox.Type[message.type] : message.type;
      if (message.endDate != null && message.hasOwnProperty("endDate"))
        object.endDate = message.endDate;
      if (message.subscribedPrice != null && message.hasOwnProperty("subscribedPrice"))
        if (typeof message.subscribedPrice === "number")
          object.subscribedPrice = options.longs === String ? String(message.subscribedPrice) : message.subscribedPrice;
        else
          object.subscribedPrice = options.longs === String ? $util.Long.prototype.toString.call(message.subscribedPrice) : options.longs === Number ? new $util.LongBits(message.subscribedPrice.low >>> 0, message.subscribedPrice.high >>> 0).toNumber() : message.subscribedPrice;
      if (message.subscribedShares != null && message.hasOwnProperty("subscribedShares"))
        if (typeof message.subscribedShares === "number")
          object.subscribedShares = options.longs === String ? String(message.subscribedShares) : message.subscribedShares;
        else
          object.subscribedShares = options.longs === String ? $util.Long.prototype.toString.call(message.subscribedShares) : options.longs === Number ? new $util.LongBits(message.subscribedShares.low >>> 0, message.subscribedShares.high >>> 0).toNumber() : message.subscribedShares;
      if (message.totalPaymentAmount != null && message.hasOwnProperty("totalPaymentAmount"))
        if (typeof message.totalPaymentAmount === "number")
          object.totalPaymentAmount = options.longs === String ? String(message.totalPaymentAmount) : message.totalPaymentAmount;
        else
          object.totalPaymentAmount = options.longs === String ? $util.Long.prototype.toString.call(message.totalPaymentAmount) : options.longs === Number ? new $util.LongBits(message.totalPaymentAmount.low >>> 0, message.totalPaymentAmount.high >>> 0).toNumber() : message.totalPaymentAmount;
      if (message.currentPaymentAmount != null && message.hasOwnProperty("currentPaymentAmount"))
        object.currentPaymentAmount = options.json && !isFinite(message.currentPaymentAmount) ? String(message.currentPaymentAmount) : message.currentPaymentAmount;
      if (message.requiredDepositAmount != null && message.hasOwnProperty("requiredDepositAmount"))
        object.requiredDepositAmount = options.json && !isFinite(message.requiredDepositAmount) ? String(message.requiredDepositAmount) : message.requiredDepositAmount;
      if (message.remainingDepositAmount != null && message.hasOwnProperty("remainingDepositAmount"))
        object.remainingDepositAmount = options.json && !isFinite(message.remainingDepositAmount) ? String(message.remainingDepositAmount) : message.remainingDepositAmount;
      if (message.time != null && message.hasOwnProperty("time"))
        object.time = $root.google.protobuf.Timestamp.toObject(message.time, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
        object.accountTypeName = message.accountTypeName;
      if (message.comment != null && message.hasOwnProperty("comment"))
        object.comment = message.comment;
      if (message.totalPaymentAmountAfterRegistrationResult != null && message.hasOwnProperty("totalPaymentAmountAfterRegistrationResult"))
        object.totalPaymentAmountAfterRegistrationResult = options.json && !isFinite(message.totalPaymentAmountAfterRegistrationResult) ? String(message.totalPaymentAmountAfterRegistrationResult) : message.totalPaymentAmountAfterRegistrationResult;
      if (message.remainingPaymentAmount != null && message.hasOwnProperty("remainingPaymentAmount"))
        object.remainingPaymentAmount = options.json && !isFinite(message.remainingPaymentAmount) ? String(message.remainingPaymentAmount) : message.remainingPaymentAmount;
      if (message.allocatedShares != null && message.hasOwnProperty("allocatedShares"))
        if (typeof message.allocatedShares === "number")
          object.allocatedShares = options.longs === String ? String(message.allocatedShares) : message.allocatedShares;
        else
          object.allocatedShares = options.longs === String ? $util.Long.prototype.toString.call(message.allocatedShares) : options.longs === Number ? new $util.LongBits(message.allocatedShares.low >>> 0, message.allocatedShares.high >>> 0).toNumber() : message.allocatedShares;
      if (message.sharePrice != null && message.hasOwnProperty("sharePrice"))
        if (typeof message.sharePrice === "number")
          object.sharePrice = options.longs === String ? String(message.sharePrice) : message.sharePrice;
        else
          object.sharePrice = options.longs === String ? $util.Long.prototype.toString.call(message.sharePrice) : options.longs === Number ? new $util.LongBits(message.sharePrice.low >>> 0, message.sharePrice.high >>> 0).toNumber() : message.sharePrice;
      if (message.registrationFormStatus != null && message.hasOwnProperty("registrationFormStatus"))
        object.registrationFormStatus = message.registrationFormStatus;
      if (message.refundedAmount != null && message.hasOwnProperty("refundedAmount"))
        object.refundedAmount = options.json && !isFinite(message.refundedAmount) ? String(message.refundedAmount) : message.refundedAmount;
      return object;
    };
    NotifyEnbox.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    NotifyEnbox.Type = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "NOTIFY_SUBMITTED_REGISTRATION_FORM_PARTIALLY_DEPOSITED"] = 0;
      values[valuesById[1] = "NOTIFY_SUBMITTED_REGISTRATION_FORM_DEPOSITED"] = 1;
      values[valuesById[2] = "NOTIFY_NEW_REGISTRATION_FORM_PARTIALLY_DEPOSITED"] = 2;
      values[valuesById[3] = "NOTIFY_NEW_REGISTRATION_FORM_DEPOSITED"] = 3;
      values[valuesById[4] = "NOTIFY_REGISTRATION_FORM_SUBMISSION"] = 4;
      values[valuesById[5] = "NOTIFY_REGISTRATION_FORM_MODIFICATION"] = 5;
      values[valuesById[6] = "NOTIFY_PAYMENT_FAILED"] = 6;
      values[valuesById[7] = "NOTIFY_NOT_ENOUGH_MONEY"] = 7;
      values[valuesById[8] = "NOTIFY_REJECTED_REGISTRATION_FORM"] = 8;
      values[valuesById[9] = "NOTIFY_VALID_REGISTRATION_FORM"] = 9;
      values[valuesById[10] = "NOTIFY_SUCCESSFUL_PAID_AUCTION"] = 10;
      values[valuesById[11] = "NOTIFY_SUCCESSFUL_UNPAID_AUCTION"] = 11;
      values[valuesById[12] = "NOTIFY_AUCTION_FAILED"] = 12;
      values[valuesById[13] = "NOTIFY_REJECTED_AUCTION"] = 13;
      values[valuesById[14] = "NOTIFY_INCOMPLETE_REGISTRATION"] = 14;
      values[valuesById[15] = "NOTIFY_FINAL_DAY_INCOMPLETE_REGISTRATION"] = 15;
      values[valuesById[16] = "NOTIFY_DEPOSIT_PAYMENT"] = 16;
      values[valuesById[17] = "NOTIFY_FINAL_DAY_DEPOSIT_PAYMENT"] = 17;
      values[valuesById[18] = "NOTIFY_PAYMENT_REMINDER"] = 18;
      values[valuesById[19] = "NOTIFY_DECLINED_AUCTION"] = 19;
      values[valuesById[20] = "NOTIFY_BECAME_SHAREHOLDER"] = 20;
      values[valuesById[21] = "NOTIFY_REFUNDED_PAYMENT"] = 21;
      return values;
    }();
    return NotifyEnbox;
  }();
  dnse2.notice = function() {
    const notice = {};
    notice.v1 = function() {
      const v1 = {};
      v1.Product = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PRODUCT_UNSPECIFIED"] = 0;
        values[valuesById[1] = "PRODUCT_UNDERLYINGS"] = 1;
        values[valuesById[2] = "PRODUCT_DERIVATIVES"] = 2;
        return values;
      }();
      v1.AccountNAVChange = function() {
        function AccountNAVChange(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AccountNAVChange.prototype.accountNo = "";
        AccountNAVChange.prototype.custodyCode = "";
        AccountNAVChange.prototype.investorId = null;
        AccountNAVChange.prototype.product = 0;
        AccountNAVChange.prototype.nav = 0;
        AccountNAVChange.prototype.timestampUtc = null;
        let $oneOfFields;
        Object.defineProperty(AccountNAVChange.prototype, "_investorId", {
          get: $util.oneOfGetter($oneOfFields = ["investorId"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        AccountNAVChange.create = function create(properties) {
          return new AccountNAVChange(properties);
        };
        AccountNAVChange.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(10).string(message.accountNo);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(18).string(message.custodyCode);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(26).string(message.investorId);
          if (message.product != null && Object.hasOwnProperty.call(message, "product"))
            writer.uint32(32).int32(message.product);
          if (message.nav != null && Object.hasOwnProperty.call(message, "nav"))
            writer.uint32(41).double(message.nav);
          if (message.timestampUtc != null && Object.hasOwnProperty.call(message, "timestampUtc"))
            $root.google.protobuf.Timestamp.encode(message.timestampUtc, writer.uint32(50).fork()).ldelim();
          return writer;
        };
        AccountNAVChange.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AccountNAVChange.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.notice.v1.AccountNAVChange();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.accountNo = reader.string();
                break;
              case 2:
                message.custodyCode = reader.string();
                break;
              case 3:
                message.investorId = reader.string();
                break;
              case 4:
                message.product = reader.int32();
                break;
              case 5:
                message.nav = reader.double();
                break;
              case 6:
                message.timestampUtc = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AccountNAVChange.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AccountNAVChange.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.product != null && message.hasOwnProperty("product"))
            switch (message.product) {
              default:
                return "product: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.nav != null && message.hasOwnProperty("nav")) {
            if (typeof message.nav !== "number")
              return "nav: number expected";
          }
          if (message.timestampUtc != null && message.hasOwnProperty("timestampUtc")) {
            let error = $root.google.protobuf.Timestamp.verify(message.timestampUtc);
            if (error)
              return "timestampUtc." + error;
          }
          return null;
        };
        AccountNAVChange.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.notice.v1.AccountNAVChange)
            return object;
          let message = new $root.dnse.notice.v1.AccountNAVChange();
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          switch (object.product) {
            case "PRODUCT_UNSPECIFIED":
            case 0:
              message.product = 0;
              break;
            case "PRODUCT_UNDERLYINGS":
            case 1:
              message.product = 1;
              break;
            case "PRODUCT_DERIVATIVES":
            case 2:
              message.product = 2;
              break;
          }
          if (object.nav != null)
            message.nav = Number(object.nav);
          if (object.timestampUtc != null) {
            if (typeof object.timestampUtc !== "object")
              throw TypeError(".dnse.notice.v1.AccountNAVChange.timestampUtc: object expected");
            message.timestampUtc = $root.google.protobuf.Timestamp.fromObject(object.timestampUtc);
          }
          return message;
        };
        AccountNAVChange.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.accountNo = "";
            object.custodyCode = "";
            object.product = options.enums === String ? "PRODUCT_UNSPECIFIED" : 0;
            object.nav = 0;
            object.timestampUtc = null;
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            object.investorId = message.investorId;
            if (options.oneofs)
              object._investorId = "investorId";
          }
          if (message.product != null && message.hasOwnProperty("product"))
            object.product = options.enums === String ? $root.dnse.notice.v1.Product[message.product] : message.product;
          if (message.nav != null && message.hasOwnProperty("nav"))
            object.nav = options.json && !isFinite(message.nav) ? String(message.nav) : message.nav;
          if (message.timestampUtc != null && message.hasOwnProperty("timestampUtc"))
            object.timestampUtc = $root.google.protobuf.Timestamp.toObject(message.timestampUtc, options);
          return object;
        };
        AccountNAVChange.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return AccountNAVChange;
      }();
      v1.Wrapper = function() {
        function Wrapper(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Wrapper.prototype.accountFeeChange = null;
        let $oneOfFields;
        Object.defineProperty(Wrapper.prototype, "kind", {
          get: $util.oneOfGetter($oneOfFields = ["accountFeeChange"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Wrapper.create = function create(properties) {
          return new Wrapper(properties);
        };
        Wrapper.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.accountFeeChange != null && Object.hasOwnProperty.call(message, "accountFeeChange"))
            $root.dnse.notice.v1.AccountFeeChange.encode(message.accountFeeChange, writer.uint32(10).fork()).ldelim();
          return writer;
        };
        Wrapper.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Wrapper.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.notice.v1.Wrapper();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.accountFeeChange = $root.dnse.notice.v1.AccountFeeChange.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Wrapper.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Wrapper.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.accountFeeChange != null && message.hasOwnProperty("accountFeeChange")) {
            {
              let error = $root.dnse.notice.v1.AccountFeeChange.verify(message.accountFeeChange);
              if (error)
                return "accountFeeChange." + error;
            }
          }
          return null;
        };
        Wrapper.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.notice.v1.Wrapper)
            return object;
          let message = new $root.dnse.notice.v1.Wrapper();
          if (object.accountFeeChange != null) {
            if (typeof object.accountFeeChange !== "object")
              throw TypeError(".dnse.notice.v1.Wrapper.accountFeeChange: object expected");
            message.accountFeeChange = $root.dnse.notice.v1.AccountFeeChange.fromObject(object.accountFeeChange);
          }
          return message;
        };
        Wrapper.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (message.accountFeeChange != null && message.hasOwnProperty("accountFeeChange")) {
            object.accountFeeChange = $root.dnse.notice.v1.AccountFeeChange.toObject(message.accountFeeChange, options);
            if (options.oneofs)
              object.kind = "accountFeeChange";
          }
          return object;
        };
        Wrapper.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return Wrapper;
      }();
      v1.AccountFeeChange = function() {
        function AccountFeeChange(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AccountFeeChange.create = function create(properties) {
          return new AccountFeeChange(properties);
        };
        AccountFeeChange.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          return writer;
        };
        AccountFeeChange.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AccountFeeChange.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.notice.v1.AccountFeeChange();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AccountFeeChange.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AccountFeeChange.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          return null;
        };
        AccountFeeChange.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.notice.v1.AccountFeeChange)
            return object;
          return new $root.dnse.notice.v1.AccountFeeChange();
        };
        AccountFeeChange.toObject = function toObject() {
          return {};
        };
        AccountFeeChange.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return AccountFeeChange;
      }();
      return v1;
    }();
    return notice;
  }();
  dnse2.ActionType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ACTION_TYPE_UNKNOWN"] = 0;
    values[valuesById[1] = "ACTION_TYPE_NEW_SUB"] = 1;
    values[valuesById[2] = "ACTION_TYPE_RENEW_SUB"] = 2;
    values[valuesById[3] = "ACTION_TYPE_PRE_RENEW_SUB"] = 3;
    return values;
  }();
  dnse2.SubscriptionErrorType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SUBSCRIPTION_ERROR_UNKNOWN"] = 0;
    values[valuesById[1] = "SUBSCRIPTION_ERROR_NOT_ENOUGH_MONEY"] = 1;
    values[valuesById[2] = "SUBSCRIPTION_ERROR_PAYMENT_FAIL"] = 2;
    values[valuesById[3] = "SUBSCRIPTION_ERROR_INVALID_ACCOUNT_NO"] = 3;
    return values;
  }();
  dnse2.SubscriptionNotification = function() {
    function SubscriptionNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SubscriptionNotification.prototype.actionType = 0;
    SubscriptionNotification.prototype.investorId = "";
    SubscriptionNotification.prototype.period = "";
    SubscriptionNotification.prototype.errorType = null;
    SubscriptionNotification.prototype.startAt = null;
    SubscriptionNotification.prototype.endAt = null;
    SubscriptionNotification.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SubscriptionNotification.prototype.productCode = "";
    SubscriptionNotification.prototype.createdAt = null;
    SubscriptionNotification.prototype.accountNo = "";
    let $oneOfFields;
    Object.defineProperty(SubscriptionNotification.prototype, "_errorType", {
      get: $util.oneOfGetter($oneOfFields = ["errorType"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    SubscriptionNotification.create = function create(properties) {
      return new SubscriptionNotification(properties);
    };
    SubscriptionNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
        writer.uint32(8).int32(message.actionType);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.period != null && Object.hasOwnProperty.call(message, "period"))
        writer.uint32(26).string(message.period);
      if (message.errorType != null && Object.hasOwnProperty.call(message, "errorType"))
        writer.uint32(32).int32(message.errorType);
      if (message.startAt != null && Object.hasOwnProperty.call(message, "startAt"))
        $root.google.protobuf.Timestamp.encode(message.startAt, writer.uint32(42).fork()).ldelim();
      if (message.endAt != null && Object.hasOwnProperty.call(message, "endAt"))
        $root.google.protobuf.Timestamp.encode(message.endAt, writer.uint32(50).fork()).ldelim();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(56).int64(message.amount);
      if (message.productCode != null && Object.hasOwnProperty.call(message, "productCode"))
        writer.uint32(66).string(message.productCode);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(74).fork()).ldelim();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(82).string(message.accountNo);
      return writer;
    };
    SubscriptionNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SubscriptionNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SubscriptionNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.actionType = reader.int32();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.period = reader.string();
            break;
          case 4:
            message.errorType = reader.int32();
            break;
          case 5:
            message.startAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.endAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.amount = reader.int64();
            break;
          case 8:
            message.productCode = reader.string();
            break;
          case 9:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.accountNo = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SubscriptionNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SubscriptionNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.actionType != null && message.hasOwnProperty("actionType"))
        switch (message.actionType) {
          default:
            return "actionType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.period != null && message.hasOwnProperty("period")) {
        if (!$util.isString(message.period))
          return "period: string expected";
      }
      if (message.errorType != null && message.hasOwnProperty("errorType")) {
        switch (message.errorType) {
          default:
            return "errorType: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      }
      if (message.startAt != null && message.hasOwnProperty("startAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.startAt);
        if (error)
          return "startAt." + error;
      }
      if (message.endAt != null && message.hasOwnProperty("endAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.endAt);
        if (error)
          return "endAt." + error;
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.productCode != null && message.hasOwnProperty("productCode")) {
        if (!$util.isString(message.productCode))
          return "productCode: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      return null;
    };
    SubscriptionNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SubscriptionNotification)
        return object;
      let message = new $root.dnse.SubscriptionNotification();
      switch (object.actionType) {
        case "ACTION_TYPE_UNKNOWN":
        case 0:
          message.actionType = 0;
          break;
        case "ACTION_TYPE_NEW_SUB":
        case 1:
          message.actionType = 1;
          break;
        case "ACTION_TYPE_RENEW_SUB":
        case 2:
          message.actionType = 2;
          break;
        case "ACTION_TYPE_PRE_RENEW_SUB":
        case 3:
          message.actionType = 3;
          break;
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.period != null)
        message.period = String(object.period);
      switch (object.errorType) {
        case "SUBSCRIPTION_ERROR_UNKNOWN":
        case 0:
          message.errorType = 0;
          break;
        case "SUBSCRIPTION_ERROR_NOT_ENOUGH_MONEY":
        case 1:
          message.errorType = 1;
          break;
        case "SUBSCRIPTION_ERROR_PAYMENT_FAIL":
        case 2:
          message.errorType = 2;
          break;
        case "SUBSCRIPTION_ERROR_INVALID_ACCOUNT_NO":
        case 3:
          message.errorType = 3;
          break;
      }
      if (object.startAt != null) {
        if (typeof object.startAt !== "object")
          throw TypeError(".dnse.SubscriptionNotification.startAt: object expected");
        message.startAt = $root.google.protobuf.Timestamp.fromObject(object.startAt);
      }
      if (object.endAt != null) {
        if (typeof object.endAt !== "object")
          throw TypeError(".dnse.SubscriptionNotification.endAt: object expected");
        message.endAt = $root.google.protobuf.Timestamp.fromObject(object.endAt);
      }
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
      }
      if (object.productCode != null)
        message.productCode = String(object.productCode);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.SubscriptionNotification.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      return message;
    };
    SubscriptionNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.actionType = options.enums === String ? "ACTION_TYPE_UNKNOWN" : 0;
        object.investorId = "";
        object.period = "";
        object.startAt = null;
        object.endAt = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.productCode = "";
        object.createdAt = null;
        object.accountNo = "";
      }
      if (message.actionType != null && message.hasOwnProperty("actionType"))
        object.actionType = options.enums === String ? $root.dnse.ActionType[message.actionType] : message.actionType;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.period != null && message.hasOwnProperty("period"))
        object.period = message.period;
      if (message.errorType != null && message.hasOwnProperty("errorType")) {
        object.errorType = options.enums === String ? $root.dnse.SubscriptionErrorType[message.errorType] : message.errorType;
        if (options.oneofs)
          object._errorType = "errorType";
      }
      if (message.startAt != null && message.hasOwnProperty("startAt"))
        object.startAt = $root.google.protobuf.Timestamp.toObject(message.startAt, options);
      if (message.endAt != null && message.hasOwnProperty("endAt"))
        object.endAt = $root.google.protobuf.Timestamp.toObject(message.endAt, options);
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
      if (message.productCode != null && message.hasOwnProperty("productCode"))
        object.productCode = message.productCode;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      return object;
    };
    SubscriptionNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SubscriptionNotification;
  }();
  dnse2.GiftRedeemedNotification = function() {
    function GiftRedeemedNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GiftRedeemedNotification.prototype.giftName = "";
    GiftRedeemedNotification.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    GiftRedeemedNotification.prototype.receiverFullName = "";
    GiftRedeemedNotification.prototype.redeemedAt = null;
    GiftRedeemedNotification.prototype.investorId = "";
    GiftRedeemedNotification.create = function create(properties) {
      return new GiftRedeemedNotification(properties);
    };
    GiftRedeemedNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.giftName != null && Object.hasOwnProperty.call(message, "giftName"))
        writer.uint32(10).string(message.giftName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.receiverFullName != null && Object.hasOwnProperty.call(message, "receiverFullName"))
        writer.uint32(26).string(message.receiverFullName);
      if (message.redeemedAt != null && Object.hasOwnProperty.call(message, "redeemedAt"))
        $root.google.protobuf.Timestamp.encode(message.redeemedAt, writer.uint32(34).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      return writer;
    };
    GiftRedeemedNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GiftRedeemedNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GiftRedeemedNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.giftName = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.receiverFullName = reader.string();
            break;
          case 4:
            message.redeemedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GiftRedeemedNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GiftRedeemedNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.giftName != null && message.hasOwnProperty("giftName")) {
        if (!$util.isString(message.giftName))
          return "giftName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.receiverFullName != null && message.hasOwnProperty("receiverFullName")) {
        if (!$util.isString(message.receiverFullName))
          return "receiverFullName: string expected";
      }
      if (message.redeemedAt != null && message.hasOwnProperty("redeemedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.redeemedAt);
        if (error)
          return "redeemedAt." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    GiftRedeemedNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GiftRedeemedNotification)
        return object;
      let message = new $root.dnse.GiftRedeemedNotification();
      if (object.giftName != null)
        message.giftName = String(object.giftName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.receiverFullName != null)
        message.receiverFullName = String(object.receiverFullName);
      if (object.redeemedAt != null) {
        if (typeof object.redeemedAt !== "object")
          throw TypeError(".dnse.GiftRedeemedNotification.redeemedAt: object expected");
        message.redeemedAt = $root.google.protobuf.Timestamp.fromObject(object.redeemedAt);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    GiftRedeemedNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.giftName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.receiverFullName = "";
        object.redeemedAt = null;
        object.investorId = "";
      }
      if (message.giftName != null && message.hasOwnProperty("giftName"))
        object.giftName = message.giftName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.receiverFullName != null && message.hasOwnProperty("receiverFullName"))
        object.receiverFullName = message.receiverFullName;
      if (message.redeemedAt != null && message.hasOwnProperty("redeemedAt"))
        object.redeemedAt = $root.google.protobuf.Timestamp.toObject(message.redeemedAt, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    GiftRedeemedNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GiftRedeemedNotification;
  }();
  dnse2.GiftCreatedNotification = function() {
    function GiftCreatedNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GiftCreatedNotification.prototype.giftName = "";
    GiftCreatedNotification.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    GiftCreatedNotification.prototype.createdAt = null;
    GiftCreatedNotification.prototype.investorId = "";
    GiftCreatedNotification.create = function create(properties) {
      return new GiftCreatedNotification(properties);
    };
    GiftCreatedNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.giftName != null && Object.hasOwnProperty.call(message, "giftName"))
        writer.uint32(10).string(message.giftName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      return writer;
    };
    GiftCreatedNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GiftCreatedNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GiftCreatedNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.giftName = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GiftCreatedNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GiftCreatedNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.giftName != null && message.hasOwnProperty("giftName")) {
        if (!$util.isString(message.giftName))
          return "giftName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    GiftCreatedNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GiftCreatedNotification)
        return object;
      let message = new $root.dnse.GiftCreatedNotification();
      if (object.giftName != null)
        message.giftName = String(object.giftName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.GiftCreatedNotification.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    GiftCreatedNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.giftName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.createdAt = null;
        object.investorId = "";
      }
      if (message.giftName != null && message.hasOwnProperty("giftName"))
        object.giftName = message.giftName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    GiftCreatedNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GiftCreatedNotification;
  }();
  dnse2.GiftRejectedNotification = function() {
    function GiftRejectedNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GiftRejectedNotification.prototype.giftName = "";
    GiftRejectedNotification.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    GiftRejectedNotification.prototype.createdAt = null;
    GiftRejectedNotification.prototype.investorId = "";
    GiftRejectedNotification.create = function create(properties) {
      return new GiftRejectedNotification(properties);
    };
    GiftRejectedNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.giftName != null && Object.hasOwnProperty.call(message, "giftName"))
        writer.uint32(10).string(message.giftName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      return writer;
    };
    GiftRejectedNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GiftRejectedNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GiftRejectedNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.giftName = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GiftRejectedNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GiftRejectedNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.giftName != null && message.hasOwnProperty("giftName")) {
        if (!$util.isString(message.giftName))
          return "giftName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    GiftRejectedNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GiftRejectedNotification)
        return object;
      let message = new $root.dnse.GiftRejectedNotification();
      if (object.giftName != null)
        message.giftName = String(object.giftName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.GiftRejectedNotification.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    GiftRejectedNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.giftName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.createdAt = null;
        object.investorId = "";
      }
      if (message.giftName != null && message.hasOwnProperty("giftName"))
        object.giftName = message.giftName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    GiftRejectedNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GiftRejectedNotification;
  }();
  dnse2.GiftExpiredNotification = function() {
    function GiftExpiredNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GiftExpiredNotification.prototype.giftName = "";
    GiftExpiredNotification.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    GiftExpiredNotification.prototype.createdAt = null;
    GiftExpiredNotification.prototype.investorId = "";
    GiftExpiredNotification.prototype.cancelledBySender = false;
    GiftExpiredNotification.create = function create(properties) {
      return new GiftExpiredNotification(properties);
    };
    GiftExpiredNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.giftName != null && Object.hasOwnProperty.call(message, "giftName"))
        writer.uint32(10).string(message.giftName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.cancelledBySender != null && Object.hasOwnProperty.call(message, "cancelledBySender"))
        writer.uint32(40).bool(message.cancelledBySender);
      return writer;
    };
    GiftExpiredNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GiftExpiredNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GiftExpiredNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.giftName = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.cancelledBySender = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GiftExpiredNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GiftExpiredNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.giftName != null && message.hasOwnProperty("giftName")) {
        if (!$util.isString(message.giftName))
          return "giftName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.cancelledBySender != null && message.hasOwnProperty("cancelledBySender")) {
        if (typeof message.cancelledBySender !== "boolean")
          return "cancelledBySender: boolean expected";
      }
      return null;
    };
    GiftExpiredNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GiftExpiredNotification)
        return object;
      let message = new $root.dnse.GiftExpiredNotification();
      if (object.giftName != null)
        message.giftName = String(object.giftName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.GiftExpiredNotification.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.cancelledBySender != null)
        message.cancelledBySender = Boolean(object.cancelledBySender);
      return message;
    };
    GiftExpiredNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.giftName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.createdAt = null;
        object.investorId = "";
        object.cancelledBySender = false;
      }
      if (message.giftName != null && message.hasOwnProperty("giftName"))
        object.giftName = message.giftName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.cancelledBySender != null && message.hasOwnProperty("cancelledBySender"))
        object.cancelledBySender = message.cancelledBySender;
      return object;
    };
    GiftExpiredNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GiftExpiredNotification;
  }();
  dnse2.BPMGiftRejected = function() {
    function BPMGiftRejected(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BPMGiftRejected.prototype.giftLineId = "";
    BPMGiftRejected.prototype.flexTransactionRef = "";
    BPMGiftRejected.prototype.giftSourceAccountNo = "";
    BPMGiftRejected.prototype.rejectedBy = "";
    BPMGiftRejected.prototype.senderId = "";
    BPMGiftRejected.prototype.rejectedAt = null;
    BPMGiftRejected.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMGiftRejected.create = function create(properties) {
      return new BPMGiftRejected(properties);
    };
    BPMGiftRejected.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.giftLineId != null && Object.hasOwnProperty.call(message, "giftLineId"))
        writer.uint32(10).string(message.giftLineId);
      if (message.flexTransactionRef != null && Object.hasOwnProperty.call(message, "flexTransactionRef"))
        writer.uint32(18).string(message.flexTransactionRef);
      if (message.giftSourceAccountNo != null && Object.hasOwnProperty.call(message, "giftSourceAccountNo"))
        writer.uint32(26).string(message.giftSourceAccountNo);
      if (message.rejectedBy != null && Object.hasOwnProperty.call(message, "rejectedBy"))
        writer.uint32(34).string(message.rejectedBy);
      if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
        writer.uint32(42).string(message.senderId);
      if (message.rejectedAt != null && Object.hasOwnProperty.call(message, "rejectedAt"))
        $root.google.protobuf.Timestamp.encode(message.rejectedAt, writer.uint32(50).fork()).ldelim();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(56).uint64(message.amount);
      return writer;
    };
    BPMGiftRejected.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BPMGiftRejected.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BPMGiftRejected();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.giftLineId = reader.string();
            break;
          case 2:
            message.flexTransactionRef = reader.string();
            break;
          case 3:
            message.giftSourceAccountNo = reader.string();
            break;
          case 4:
            message.rejectedBy = reader.string();
            break;
          case 5:
            message.senderId = reader.string();
            break;
          case 6:
            message.rejectedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.amount = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BPMGiftRejected.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BPMGiftRejected.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.giftLineId != null && message.hasOwnProperty("giftLineId")) {
        if (!$util.isString(message.giftLineId))
          return "giftLineId: string expected";
      }
      if (message.flexTransactionRef != null && message.hasOwnProperty("flexTransactionRef")) {
        if (!$util.isString(message.flexTransactionRef))
          return "flexTransactionRef: string expected";
      }
      if (message.giftSourceAccountNo != null && message.hasOwnProperty("giftSourceAccountNo")) {
        if (!$util.isString(message.giftSourceAccountNo))
          return "giftSourceAccountNo: string expected";
      }
      if (message.rejectedBy != null && message.hasOwnProperty("rejectedBy")) {
        if (!$util.isString(message.rejectedBy))
          return "rejectedBy: string expected";
      }
      if (message.senderId != null && message.hasOwnProperty("senderId")) {
        if (!$util.isString(message.senderId))
          return "senderId: string expected";
      }
      if (message.rejectedAt != null && message.hasOwnProperty("rejectedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.rejectedAt);
        if (error)
          return "rejectedAt." + error;
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      return null;
    };
    BPMGiftRejected.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BPMGiftRejected)
        return object;
      let message = new $root.dnse.BPMGiftRejected();
      if (object.giftLineId != null)
        message.giftLineId = String(object.giftLineId);
      if (object.flexTransactionRef != null)
        message.flexTransactionRef = String(object.flexTransactionRef);
      if (object.giftSourceAccountNo != null)
        message.giftSourceAccountNo = String(object.giftSourceAccountNo);
      if (object.rejectedBy != null)
        message.rejectedBy = String(object.rejectedBy);
      if (object.senderId != null)
        message.senderId = String(object.senderId);
      if (object.rejectedAt != null) {
        if (typeof object.rejectedAt !== "object")
          throw TypeError(".dnse.BPMGiftRejected.rejectedAt: object expected");
        message.rejectedAt = $root.google.protobuf.Timestamp.fromObject(object.rejectedAt);
      }
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      return message;
    };
    BPMGiftRejected.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.giftLineId = "";
        object.flexTransactionRef = "";
        object.giftSourceAccountNo = "";
        object.rejectedBy = "";
        object.senderId = "";
        object.rejectedAt = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
      }
      if (message.giftLineId != null && message.hasOwnProperty("giftLineId"))
        object.giftLineId = message.giftLineId;
      if (message.flexTransactionRef != null && message.hasOwnProperty("flexTransactionRef"))
        object.flexTransactionRef = message.flexTransactionRef;
      if (message.giftSourceAccountNo != null && message.hasOwnProperty("giftSourceAccountNo"))
        object.giftSourceAccountNo = message.giftSourceAccountNo;
      if (message.rejectedBy != null && message.hasOwnProperty("rejectedBy"))
        object.rejectedBy = message.rejectedBy;
      if (message.senderId != null && message.hasOwnProperty("senderId"))
        object.senderId = message.senderId;
      if (message.rejectedAt != null && message.hasOwnProperty("rejectedAt"))
        object.rejectedAt = $root.google.protobuf.Timestamp.toObject(message.rejectedAt, options);
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      return object;
    };
    BPMGiftRejected.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BPMGiftRejected;
  }();
  dnse2.BPMGiftRedeemed = function() {
    function BPMGiftRedeemed(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BPMGiftRedeemed.prototype.giftLineId = "";
    BPMGiftRedeemed.prototype.flexTransactionRef = "";
    BPMGiftRedeemed.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMGiftRedeemed.prototype.productId = 0;
    BPMGiftRedeemed.prototype.toAccountNo = "";
    BPMGiftRedeemed.prototype.fromAccountNo = "";
    BPMGiftRedeemed.prototype.custodyCode = "";
    BPMGiftRedeemed.prototype.fromCustodyCode = "";
    BPMGiftRedeemed.prototype.toInvestorId = "";
    BPMGiftRedeemed.prototype.fromInvestorId = "";
    BPMGiftRedeemed.prototype.receiverFullName = "";
    BPMGiftRedeemed.prototype.redeemedAt = null;
    BPMGiftRedeemed.prototype.senderFullName = "";
    BPMGiftRedeemed.create = function create(properties) {
      return new BPMGiftRedeemed(properties);
    };
    BPMGiftRedeemed.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.giftLineId != null && Object.hasOwnProperty.call(message, "giftLineId"))
        writer.uint32(10).string(message.giftLineId);
      if (message.flexTransactionRef != null && Object.hasOwnProperty.call(message, "flexTransactionRef"))
        writer.uint32(18).string(message.flexTransactionRef);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).uint64(message.amount);
      if (message.productId != null && Object.hasOwnProperty.call(message, "productId"))
        writer.uint32(32).uint32(message.productId);
      if (message.toAccountNo != null && Object.hasOwnProperty.call(message, "toAccountNo"))
        writer.uint32(42).string(message.toAccountNo);
      if (message.fromAccountNo != null && Object.hasOwnProperty.call(message, "fromAccountNo"))
        writer.uint32(50).string(message.fromAccountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(58).string(message.custodyCode);
      if (message.fromCustodyCode != null && Object.hasOwnProperty.call(message, "fromCustodyCode"))
        writer.uint32(66).string(message.fromCustodyCode);
      if (message.toInvestorId != null && Object.hasOwnProperty.call(message, "toInvestorId"))
        writer.uint32(74).string(message.toInvestorId);
      if (message.fromInvestorId != null && Object.hasOwnProperty.call(message, "fromInvestorId"))
        writer.uint32(82).string(message.fromInvestorId);
      if (message.receiverFullName != null && Object.hasOwnProperty.call(message, "receiverFullName"))
        writer.uint32(90).string(message.receiverFullName);
      if (message.redeemedAt != null && Object.hasOwnProperty.call(message, "redeemedAt"))
        $root.google.protobuf.Timestamp.encode(message.redeemedAt, writer.uint32(98).fork()).ldelim();
      if (message.senderFullName != null && Object.hasOwnProperty.call(message, "senderFullName"))
        writer.uint32(106).string(message.senderFullName);
      return writer;
    };
    BPMGiftRedeemed.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BPMGiftRedeemed.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BPMGiftRedeemed();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.giftLineId = reader.string();
            break;
          case 2:
            message.flexTransactionRef = reader.string();
            break;
          case 3:
            message.amount = reader.uint64();
            break;
          case 4:
            message.productId = reader.uint32();
            break;
          case 5:
            message.toAccountNo = reader.string();
            break;
          case 6:
            message.fromAccountNo = reader.string();
            break;
          case 7:
            message.custodyCode = reader.string();
            break;
          case 8:
            message.fromCustodyCode = reader.string();
            break;
          case 9:
            message.toInvestorId = reader.string();
            break;
          case 10:
            message.fromInvestorId = reader.string();
            break;
          case 11:
            message.receiverFullName = reader.string();
            break;
          case 12:
            message.redeemedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 13:
            message.senderFullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BPMGiftRedeemed.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BPMGiftRedeemed.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.giftLineId != null && message.hasOwnProperty("giftLineId")) {
        if (!$util.isString(message.giftLineId))
          return "giftLineId: string expected";
      }
      if (message.flexTransactionRef != null && message.hasOwnProperty("flexTransactionRef")) {
        if (!$util.isString(message.flexTransactionRef))
          return "flexTransactionRef: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.productId != null && message.hasOwnProperty("productId")) {
        if (!$util.isInteger(message.productId))
          return "productId: integer expected";
      }
      if (message.toAccountNo != null && message.hasOwnProperty("toAccountNo")) {
        if (!$util.isString(message.toAccountNo))
          return "toAccountNo: string expected";
      }
      if (message.fromAccountNo != null && message.hasOwnProperty("fromAccountNo")) {
        if (!$util.isString(message.fromAccountNo))
          return "fromAccountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.fromCustodyCode != null && message.hasOwnProperty("fromCustodyCode")) {
        if (!$util.isString(message.fromCustodyCode))
          return "fromCustodyCode: string expected";
      }
      if (message.toInvestorId != null && message.hasOwnProperty("toInvestorId")) {
        if (!$util.isString(message.toInvestorId))
          return "toInvestorId: string expected";
      }
      if (message.fromInvestorId != null && message.hasOwnProperty("fromInvestorId")) {
        if (!$util.isString(message.fromInvestorId))
          return "fromInvestorId: string expected";
      }
      if (message.receiverFullName != null && message.hasOwnProperty("receiverFullName")) {
        if (!$util.isString(message.receiverFullName))
          return "receiverFullName: string expected";
      }
      if (message.redeemedAt != null && message.hasOwnProperty("redeemedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.redeemedAt);
        if (error)
          return "redeemedAt." + error;
      }
      if (message.senderFullName != null && message.hasOwnProperty("senderFullName")) {
        if (!$util.isString(message.senderFullName))
          return "senderFullName: string expected";
      }
      return null;
    };
    BPMGiftRedeemed.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BPMGiftRedeemed)
        return object;
      let message = new $root.dnse.BPMGiftRedeemed();
      if (object.giftLineId != null)
        message.giftLineId = String(object.giftLineId);
      if (object.flexTransactionRef != null)
        message.flexTransactionRef = String(object.flexTransactionRef);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.productId != null)
        message.productId = object.productId >>> 0;
      if (object.toAccountNo != null)
        message.toAccountNo = String(object.toAccountNo);
      if (object.fromAccountNo != null)
        message.fromAccountNo = String(object.fromAccountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.fromCustodyCode != null)
        message.fromCustodyCode = String(object.fromCustodyCode);
      if (object.toInvestorId != null)
        message.toInvestorId = String(object.toInvestorId);
      if (object.fromInvestorId != null)
        message.fromInvestorId = String(object.fromInvestorId);
      if (object.receiverFullName != null)
        message.receiverFullName = String(object.receiverFullName);
      if (object.redeemedAt != null) {
        if (typeof object.redeemedAt !== "object")
          throw TypeError(".dnse.BPMGiftRedeemed.redeemedAt: object expected");
        message.redeemedAt = $root.google.protobuf.Timestamp.fromObject(object.redeemedAt);
      }
      if (object.senderFullName != null)
        message.senderFullName = String(object.senderFullName);
      return message;
    };
    BPMGiftRedeemed.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.giftLineId = "";
        object.flexTransactionRef = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.productId = 0;
        object.toAccountNo = "";
        object.fromAccountNo = "";
        object.custodyCode = "";
        object.fromCustodyCode = "";
        object.toInvestorId = "";
        object.fromInvestorId = "";
        object.receiverFullName = "";
        object.redeemedAt = null;
        object.senderFullName = "";
      }
      if (message.giftLineId != null && message.hasOwnProperty("giftLineId"))
        object.giftLineId = message.giftLineId;
      if (message.flexTransactionRef != null && message.hasOwnProperty("flexTransactionRef"))
        object.flexTransactionRef = message.flexTransactionRef;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.productId != null && message.hasOwnProperty("productId"))
        object.productId = message.productId;
      if (message.toAccountNo != null && message.hasOwnProperty("toAccountNo"))
        object.toAccountNo = message.toAccountNo;
      if (message.fromAccountNo != null && message.hasOwnProperty("fromAccountNo"))
        object.fromAccountNo = message.fromAccountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.fromCustodyCode != null && message.hasOwnProperty("fromCustodyCode"))
        object.fromCustodyCode = message.fromCustodyCode;
      if (message.toInvestorId != null && message.hasOwnProperty("toInvestorId"))
        object.toInvestorId = message.toInvestorId;
      if (message.fromInvestorId != null && message.hasOwnProperty("fromInvestorId"))
        object.fromInvestorId = message.fromInvestorId;
      if (message.receiverFullName != null && message.hasOwnProperty("receiverFullName"))
        object.receiverFullName = message.receiverFullName;
      if (message.redeemedAt != null && message.hasOwnProperty("redeemedAt"))
        object.redeemedAt = $root.google.protobuf.Timestamp.toObject(message.redeemedAt, options);
      if (message.senderFullName != null && message.hasOwnProperty("senderFullName"))
        object.senderFullName = message.senderFullName;
      return object;
    };
    BPMGiftRedeemed.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BPMGiftRedeemed;
  }();
  dnse2.GiftContractSigned = function() {
    function GiftContractSigned(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GiftContractSigned.prototype.investorId = "";
    GiftContractSigned.prototype.custodyCode = "";
    GiftContractSigned.prototype.contractSignedAt = null;
    GiftContractSigned.create = function create(properties) {
      return new GiftContractSigned(properties);
    };
    GiftContractSigned.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.contractSignedAt != null && Object.hasOwnProperty.call(message, "contractSignedAt"))
        $root.google.protobuf.Timestamp.encode(message.contractSignedAt, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    GiftContractSigned.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GiftContractSigned.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GiftContractSigned();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.contractSignedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GiftContractSigned.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GiftContractSigned.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.contractSignedAt);
        if (error)
          return "contractSignedAt." + error;
      }
      return null;
    };
    GiftContractSigned.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GiftContractSigned)
        return object;
      let message = new $root.dnse.GiftContractSigned();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.contractSignedAt != null) {
        if (typeof object.contractSignedAt !== "object")
          throw TypeError(".dnse.GiftContractSigned.contractSignedAt: object expected");
        message.contractSignedAt = $root.google.protobuf.Timestamp.fromObject(object.contractSignedAt);
      }
      return message;
    };
    GiftContractSigned.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.contractSignedAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt"))
        object.contractSignedAt = $root.google.protobuf.Timestamp.toObject(message.contractSignedAt, options);
      return object;
    };
    GiftContractSigned.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GiftContractSigned;
  }();
  dnse2.LoanPackageCreated = function() {
    function LoanPackageCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanPackageCreated.prototype.accountNoDesc = "";
    LoanPackageCreated.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    LoanPackageCreated.prototype.periodDesc = "";
    LoanPackageCreated.prototype.interestRate = 0;
    LoanPackageCreated.prototype.investorId = "";
    LoanPackageCreated.prototype.savingsAccountId = "";
    LoanPackageCreated.prototype.createdDate = null;
    LoanPackageCreated.create = function create(properties) {
      return new LoanPackageCreated(properties);
    };
    LoanPackageCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(26).string(message.periodDesc);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(33).double(message.interestRate);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(50).string(message.savingsAccountId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    LoanPackageCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanPackageCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanPackageCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.periodDesc = reader.string();
            break;
          case 4:
            message.interestRate = reader.double();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.savingsAccountId = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanPackageCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanPackageCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isString(message.savingsAccountId))
          return "savingsAccountId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    LoanPackageCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanPackageCreated)
        return object;
      let message = new $root.dnse.LoanPackageCreated();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.savingsAccountId != null)
        message.savingsAccountId = String(object.savingsAccountId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.LoanPackageCreated.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    LoanPackageCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.periodDesc = "";
        object.interestRate = 0;
        object.investorId = "";
        object.savingsAccountId = "";
        object.createdDate = null;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    LoanPackageCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanPackageCreated;
  }();
  dnse2.MobilizedGoldenEggCreated = function() {
    function MobilizedGoldenEggCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    MobilizedGoldenEggCreated.prototype.accountNoDesc = "";
    MobilizedGoldenEggCreated.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    MobilizedGoldenEggCreated.prototype.periodDesc = "";
    MobilizedGoldenEggCreated.prototype.eggName = "";
    MobilizedGoldenEggCreated.prototype.interestRate = 0;
    MobilizedGoldenEggCreated.prototype.investorId = "";
    MobilizedGoldenEggCreated.prototype.savingsAccountId = "";
    MobilizedGoldenEggCreated.prototype.createdDate = null;
    MobilizedGoldenEggCreated.create = function create(properties) {
      return new MobilizedGoldenEggCreated(properties);
    };
    MobilizedGoldenEggCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(26).string(message.periodDesc);
      if (message.eggName != null && Object.hasOwnProperty.call(message, "eggName"))
        writer.uint32(34).string(message.eggName);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(41).double(message.interestRate);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(58).string(message.savingsAccountId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    MobilizedGoldenEggCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    MobilizedGoldenEggCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.MobilizedGoldenEggCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.periodDesc = reader.string();
            break;
          case 4:
            message.eggName = reader.string();
            break;
          case 5:
            message.interestRate = reader.double();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.savingsAccountId = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    MobilizedGoldenEggCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    MobilizedGoldenEggCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.eggName != null && message.hasOwnProperty("eggName")) {
        if (!$util.isString(message.eggName))
          return "eggName: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isString(message.savingsAccountId))
          return "savingsAccountId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    MobilizedGoldenEggCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.MobilizedGoldenEggCreated)
        return object;
      let message = new $root.dnse.MobilizedGoldenEggCreated();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.eggName != null)
        message.eggName = String(object.eggName);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.savingsAccountId != null)
        message.savingsAccountId = String(object.savingsAccountId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.MobilizedGoldenEggCreated.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    MobilizedGoldenEggCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.periodDesc = "";
        object.eggName = "";
        object.interestRate = 0;
        object.investorId = "";
        object.savingsAccountId = "";
        object.createdDate = null;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.eggName != null && message.hasOwnProperty("eggName"))
        object.eggName = message.eggName;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    MobilizedGoldenEggCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MobilizedGoldenEggCreated;
  }();
  dnse2.BPMLoanPackageSettlement = function() {
    function BPMLoanPackageSettlement(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BPMLoanPackageSettlement.prototype.savingsAccountId = "";
    BPMLoanPackageSettlement.prototype.accountNo = "";
    BPMLoanPackageSettlement.prototype.investorId = "";
    BPMLoanPackageSettlement.prototype.custodyCode = "";
    BPMLoanPackageSettlement.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMLoanPackageSettlement.prototype.interest = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMLoanPackageSettlement.prototype.tax = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMLoanPackageSettlement.prototype.createdDate = null;
    BPMLoanPackageSettlement.prototype.accountNoDesc = "";
    BPMLoanPackageSettlement.prototype.partialWithdrawalSavingsAccountId = "";
    BPMLoanPackageSettlement.create = function create(properties) {
      return new BPMLoanPackageSettlement(properties);
    };
    BPMLoanPackageSettlement.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(10).string(message.savingsAccountId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(34).string(message.custodyCode);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(40).uint64(message.amount);
      if (message.interest != null && Object.hasOwnProperty.call(message, "interest"))
        writer.uint32(48).uint64(message.interest);
      if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
        writer.uint32(56).uint64(message.tax);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(74).string(message.accountNoDesc);
      if (message.partialWithdrawalSavingsAccountId != null && Object.hasOwnProperty.call(message, "partialWithdrawalSavingsAccountId"))
        writer.uint32(82).string(message.partialWithdrawalSavingsAccountId);
      return writer;
    };
    BPMLoanPackageSettlement.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BPMLoanPackageSettlement.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BPMLoanPackageSettlement();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.savingsAccountId = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.custodyCode = reader.string();
            break;
          case 5:
            message.amount = reader.uint64();
            break;
          case 6:
            message.interest = reader.uint64();
            break;
          case 7:
            message.tax = reader.uint64();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.accountNoDesc = reader.string();
            break;
          case 10:
            message.partialWithdrawalSavingsAccountId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BPMLoanPackageSettlement.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BPMLoanPackageSettlement.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isString(message.savingsAccountId))
          return "savingsAccountId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interest != null && message.hasOwnProperty("interest")) {
        if (!$util.isInteger(message.interest) && !(message.interest && $util.isInteger(message.interest.low) && $util.isInteger(message.interest.high)))
          return "interest: integer|Long expected";
      }
      if (message.tax != null && message.hasOwnProperty("tax")) {
        if (!$util.isInteger(message.tax) && !(message.tax && $util.isInteger(message.tax.low) && $util.isInteger(message.tax.high)))
          return "tax: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.partialWithdrawalSavingsAccountId != null && message.hasOwnProperty("partialWithdrawalSavingsAccountId")) {
        if (!$util.isString(message.partialWithdrawalSavingsAccountId))
          return "partialWithdrawalSavingsAccountId: string expected";
      }
      return null;
    };
    BPMLoanPackageSettlement.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BPMLoanPackageSettlement)
        return object;
      let message = new $root.dnse.BPMLoanPackageSettlement();
      if (object.savingsAccountId != null)
        message.savingsAccountId = String(object.savingsAccountId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.interest != null) {
        if ($util.Long)
          (message.interest = $util.Long.fromValue(object.interest)).unsigned = true;
        else if (typeof object.interest === "string")
          message.interest = parseInt(object.interest, 10);
        else if (typeof object.interest === "number")
          message.interest = object.interest;
        else if (typeof object.interest === "object")
          message.interest = new $util.LongBits(object.interest.low >>> 0, object.interest.high >>> 0).toNumber(true);
      }
      if (object.tax != null) {
        if ($util.Long)
          (message.tax = $util.Long.fromValue(object.tax)).unsigned = true;
        else if (typeof object.tax === "string")
          message.tax = parseInt(object.tax, 10);
        else if (typeof object.tax === "number")
          message.tax = object.tax;
        else if (typeof object.tax === "object")
          message.tax = new $util.LongBits(object.tax.low >>> 0, object.tax.high >>> 0).toNumber(true);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.BPMLoanPackageSettlement.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.partialWithdrawalSavingsAccountId != null)
        message.partialWithdrawalSavingsAccountId = String(object.partialWithdrawalSavingsAccountId);
      return message;
    };
    BPMLoanPackageSettlement.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.savingsAccountId = "";
        object.accountNo = "";
        object.investorId = "";
        object.custodyCode = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.interest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.interest = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.tax = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tax = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.accountNoDesc = "";
        object.partialWithdrawalSavingsAccountId = "";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.interest != null && message.hasOwnProperty("interest"))
        if (typeof message.interest === "number")
          object.interest = options.longs === String ? String(message.interest) : message.interest;
        else
          object.interest = options.longs === String ? $util.Long.prototype.toString.call(message.interest) : options.longs === Number ? new $util.LongBits(message.interest.low >>> 0, message.interest.high >>> 0).toNumber(true) : message.interest;
      if (message.tax != null && message.hasOwnProperty("tax"))
        if (typeof message.tax === "number")
          object.tax = options.longs === String ? String(message.tax) : message.tax;
        else
          object.tax = options.longs === String ? $util.Long.prototype.toString.call(message.tax) : options.longs === Number ? new $util.LongBits(message.tax.low >>> 0, message.tax.high >>> 0).toNumber(true) : message.tax;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.partialWithdrawalSavingsAccountId != null && message.hasOwnProperty("partialWithdrawalSavingsAccountId"))
        object.partialWithdrawalSavingsAccountId = message.partialWithdrawalSavingsAccountId;
      return object;
    };
    BPMLoanPackageSettlement.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BPMLoanPackageSettlement;
  }();
  dnse2.LoanPackageWithdrawal = function() {
    function LoanPackageWithdrawal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanPackageWithdrawal.prototype.accountNoDesc = "";
    LoanPackageWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    LoanPackageWithdrawal.prototype.balance = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    LoanPackageWithdrawal.prototype.createdDate = null;
    LoanPackageWithdrawal.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    LoanPackageWithdrawal.prototype.investorId = "";
    LoanPackageWithdrawal.create = function create(properties) {
      return new LoanPackageWithdrawal(properties);
    };
    LoanPackageWithdrawal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
        writer.uint32(24).uint64(message.balance);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(34).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(40).uint64(message.savingsAccountId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      return writer;
    };
    LoanPackageWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanPackageWithdrawal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanPackageWithdrawal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.balance = reader.uint64();
            break;
          case 4:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 5:
            message.savingsAccountId = reader.uint64();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanPackageWithdrawal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanPackageWithdrawal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.balance != null && message.hasOwnProperty("balance")) {
        if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
          return "balance: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      return null;
    };
    LoanPackageWithdrawal.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanPackageWithdrawal)
        return object;
      let message = new $root.dnse.LoanPackageWithdrawal();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.balance != null) {
        if ($util.Long)
          (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
        else if (typeof object.balance === "string")
          message.balance = parseInt(object.balance, 10);
        else if (typeof object.balance === "number")
          message.balance = object.balance;
        else if (typeof object.balance === "object")
          message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.LoanPackageWithdrawal.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      return message;
    };
    LoanPackageWithdrawal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.balance = options.longs === String ? "0" : 0;
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        object.investorId = "";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.balance != null && message.hasOwnProperty("balance"))
        if (typeof message.balance === "number")
          object.balance = options.longs === String ? String(message.balance) : message.balance;
        else
          object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      return object;
    };
    LoanPackageWithdrawal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanPackageWithdrawal;
  }();
  dnse2.LoanContractSigned = function() {
    function LoanContractSigned(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanContractSigned.prototype.custodyCode = "";
    LoanContractSigned.prototype.contractSignedAt = null;
    LoanContractSigned.create = function create(properties) {
      return new LoanContractSigned(properties);
    };
    LoanContractSigned.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(10).string(message.custodyCode);
      if (message.contractSignedAt != null && Object.hasOwnProperty.call(message, "contractSignedAt"))
        $root.google.protobuf.Timestamp.encode(message.contractSignedAt, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    LoanContractSigned.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanContractSigned.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanContractSigned();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.custodyCode = reader.string();
            break;
          case 2:
            message.contractSignedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanContractSigned.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanContractSigned.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.contractSignedAt);
        if (error)
          return "contractSignedAt." + error;
      }
      return null;
    };
    LoanContractSigned.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanContractSigned)
        return object;
      let message = new $root.dnse.LoanContractSigned();
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.contractSignedAt != null) {
        if (typeof object.contractSignedAt !== "object")
          throw TypeError(".dnse.LoanContractSigned.contractSignedAt: object expected");
        message.contractSignedAt = $root.google.protobuf.Timestamp.fromObject(object.contractSignedAt);
      }
      return message;
    };
    LoanContractSigned.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.custodyCode = "";
        object.contractSignedAt = null;
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt"))
        object.contractSignedAt = $root.google.protobuf.Timestamp.toObject(message.contractSignedAt, options);
      return object;
    };
    LoanContractSigned.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanContractSigned;
  }();
  dnse2.LoanMaturityAlert = function() {
    function LoanMaturityAlert(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanMaturityAlert.prototype.investorId = "";
    LoanMaturityAlert.prototype.accountNoDesc = "";
    LoanMaturityAlert.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    LoanMaturityAlert.prototype.maturityDate = "";
    LoanMaturityAlert.prototype.interestRate = 0;
    LoanMaturityAlert.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    LoanMaturityAlert.prototype.periodDesc = "";
    LoanMaturityAlert.prototype.createdDate = null;
    LoanMaturityAlert.create = function create(properties) {
      return new LoanMaturityAlert(properties);
    };
    LoanMaturityAlert.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(18).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).uint64(message.amount);
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        writer.uint32(34).string(message.maturityDate);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(41).double(message.interestRate);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(48).uint64(message.savingsAccountId);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(58).string(message.periodDesc);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    LoanMaturityAlert.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanMaturityAlert.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanMaturityAlert();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.accountNoDesc = reader.string();
            break;
          case 3:
            message.amount = reader.uint64();
            break;
          case 4:
            message.maturityDate = reader.string();
            break;
          case 5:
            message.interestRate = reader.double();
            break;
          case 6:
            message.savingsAccountId = reader.uint64();
            break;
          case 7:
            message.periodDesc = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanMaturityAlert.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanMaturityAlert.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        if (!$util.isString(message.maturityDate))
          return "maturityDate: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      return null;
    };
    LoanMaturityAlert.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanMaturityAlert)
        return object;
      let message = new $root.dnse.LoanMaturityAlert();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.maturityDate != null)
        message.maturityDate = String(object.maturityDate);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.LoanMaturityAlert.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      return message;
    };
    LoanMaturityAlert.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.maturityDate = "";
        object.interestRate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        object.periodDesc = "";
        object.createdDate = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = message.maturityDate;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      return object;
    };
    LoanMaturityAlert.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanMaturityAlert;
  }();
  dnse2.LoanInvestorActivated = function() {
    function LoanInvestorActivated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    LoanInvestorActivated.prototype.investorId = "";
    LoanInvestorActivated.prototype.interestRate = 0;
    LoanInvestorActivated.create = function create(properties) {
      return new LoanInvestorActivated(properties);
    };
    LoanInvestorActivated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.interestRate != null && Object.hasOwnProperty.call(message, "interestRate"))
        writer.uint32(17).double(message.interestRate);
      return writer;
    };
    LoanInvestorActivated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    LoanInvestorActivated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.LoanInvestorActivated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.interestRate = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    LoanInvestorActivated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    LoanInvestorActivated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.interestRate != null && message.hasOwnProperty("interestRate")) {
        if (typeof message.interestRate !== "number")
          return "interestRate: number expected";
      }
      return null;
    };
    LoanInvestorActivated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.LoanInvestorActivated)
        return object;
      let message = new $root.dnse.LoanInvestorActivated();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.interestRate != null)
        message.interestRate = Number(object.interestRate);
      return message;
    };
    LoanInvestorActivated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.interestRate = 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.interestRate != null && message.hasOwnProperty("interestRate"))
        object.interestRate = options.json && !isFinite(message.interestRate) ? String(message.interestRate) : message.interestRate;
      return object;
    };
    LoanInvestorActivated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return LoanInvestorActivated;
  }();
  dnse2.lbs = function() {
    const lbs = {};
    lbs.v1 = function() {
      const v1 = {};
      v1.WalletTransaction = function() {
        function WalletTransaction(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        WalletTransaction.prototype.id = "";
        WalletTransaction.prototype.transDate = null;
        WalletTransaction.prototype.transDesc = "";
        WalletTransaction.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        WalletTransaction.prototype.custodyCode = "";
        WalletTransaction.prototype.payerId = "";
        WalletTransaction.prototype.payerName = "";
        WalletTransaction.prototype.accountNo = "";
        WalletTransaction.prototype.channelId = 0;
        WalletTransaction.prototype.type = 0;
        WalletTransaction.prototype.state = 0;
        WalletTransaction.prototype.confirmTransDate = null;
        WalletTransaction.prototype.confirmTransDesc = null;
        WalletTransaction.prototype.errorMessage = null;
        WalletTransaction.prototype.createdDate = null;
        WalletTransaction.prototype.modifiedDate = null;
        WalletTransaction.prototype.accountTypeName = "";
        let $oneOfFields;
        Object.defineProperty(WalletTransaction.prototype, "_confirmTransDate", {
          get: $util.oneOfGetter($oneOfFields = ["confirmTransDate"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(WalletTransaction.prototype, "_confirmTransDesc", {
          get: $util.oneOfGetter($oneOfFields = ["confirmTransDesc"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(WalletTransaction.prototype, "_errorMessage", {
          get: $util.oneOfGetter($oneOfFields = ["errorMessage"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        WalletTransaction.create = function create(properties) {
          return new WalletTransaction(properties);
        };
        WalletTransaction.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
          if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
            $root.google.type.Date.encode(message.transDate, writer.uint32(26).fork()).ldelim();
          if (message.transDesc != null && Object.hasOwnProperty.call(message, "transDesc"))
            writer.uint32(34).string(message.transDesc);
          if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(40).int64(message.amount);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(50).string(message.custodyCode);
          if (message.payerId != null && Object.hasOwnProperty.call(message, "payerId"))
            writer.uint32(58).string(message.payerId);
          if (message.payerName != null && Object.hasOwnProperty.call(message, "payerName"))
            writer.uint32(66).string(message.payerName);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(74).string(message.accountNo);
          if (message.channelId != null && Object.hasOwnProperty.call(message, "channelId"))
            writer.uint32(80).int32(message.channelId);
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(88).int32(message.type);
          if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(96).int32(message.state);
          if (message.confirmTransDate != null && Object.hasOwnProperty.call(message, "confirmTransDate"))
            $root.google.type.Date.encode(message.confirmTransDate, writer.uint32(114).fork()).ldelim();
          if (message.confirmTransDesc != null && Object.hasOwnProperty.call(message, "confirmTransDesc"))
            writer.uint32(122).string(message.confirmTransDesc);
          if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
            writer.uint32(130).string(message.errorMessage);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(138).fork()).ldelim();
          if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
            $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(146).fork()).ldelim();
          if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
            writer.uint32(154).string(message.accountTypeName);
          return writer;
        };
        WalletTransaction.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        WalletTransaction.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.lbs.v1.WalletTransaction();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.string();
                break;
              case 3:
                message.transDate = $root.google.type.Date.decode(reader, reader.uint32());
                break;
              case 4:
                message.transDesc = reader.string();
                break;
              case 5:
                message.amount = reader.int64();
                break;
              case 6:
                message.custodyCode = reader.string();
                break;
              case 7:
                message.payerId = reader.string();
                break;
              case 8:
                message.payerName = reader.string();
                break;
              case 9:
                message.accountNo = reader.string();
                break;
              case 10:
                message.channelId = reader.int32();
                break;
              case 11:
                message.type = reader.int32();
                break;
              case 12:
                message.state = reader.int32();
                break;
              case 14:
                message.confirmTransDate = $root.google.type.Date.decode(reader, reader.uint32());
                break;
              case 15:
                message.confirmTransDesc = reader.string();
                break;
              case 16:
                message.errorMessage = reader.string();
                break;
              case 17:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 18:
                message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 19:
                message.accountTypeName = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        WalletTransaction.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        WalletTransaction.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isString(message.id))
              return "id: string expected";
          }
          if (message.transDate != null && message.hasOwnProperty("transDate")) {
            let error = $root.google.type.Date.verify(message.transDate);
            if (error)
              return "transDate." + error;
          }
          if (message.transDesc != null && message.hasOwnProperty("transDesc")) {
            if (!$util.isString(message.transDesc))
              return "transDesc: string expected";
          }
          if (message.amount != null && message.hasOwnProperty("amount")) {
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
              return "amount: integer|Long expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.payerId != null && message.hasOwnProperty("payerId")) {
            if (!$util.isString(message.payerId))
              return "payerId: string expected";
          }
          if (message.payerName != null && message.hasOwnProperty("payerName")) {
            if (!$util.isString(message.payerName))
              return "payerName: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.channelId != null && message.hasOwnProperty("channelId"))
            switch (message.channelId) {
              default:
                return "channelId: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
              default:
                return "type: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.state != null && message.hasOwnProperty("state"))
            switch (message.state) {
              default:
                return "state: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
                break;
            }
          if (message.confirmTransDate != null && message.hasOwnProperty("confirmTransDate")) {
            {
              let error = $root.google.type.Date.verify(message.confirmTransDate);
              if (error)
                return "confirmTransDate." + error;
            }
          }
          if (message.confirmTransDesc != null && message.hasOwnProperty("confirmTransDesc")) {
            if (!$util.isString(message.confirmTransDesc))
              return "confirmTransDesc: string expected";
          }
          if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
            if (!$util.isString(message.errorMessage))
              return "errorMessage: string expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
            if (error)
              return "modifiedDate." + error;
          }
          if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
            if (!$util.isString(message.accountTypeName))
              return "accountTypeName: string expected";
          }
          return null;
        };
        WalletTransaction.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.lbs.v1.WalletTransaction)
            return object;
          let message = new $root.dnse.lbs.v1.WalletTransaction();
          if (object.id != null)
            message.id = String(object.id);
          if (object.transDate != null) {
            if (typeof object.transDate !== "object")
              throw TypeError(".dnse.lbs.v1.WalletTransaction.transDate: object expected");
            message.transDate = $root.google.type.Date.fromObject(object.transDate);
          }
          if (object.transDesc != null)
            message.transDesc = String(object.transDesc);
          if (object.amount != null) {
            if ($util.Long)
              (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
              message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
              message.amount = object.amount;
            else if (typeof object.amount === "object")
              message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
          }
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.payerId != null)
            message.payerId = String(object.payerId);
          if (object.payerName != null)
            message.payerName = String(object.payerName);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          switch (object.channelId) {
            case "CHANNEL_ID_UNSPECIFIED":
            case 0:
              message.channelId = 0;
              break;
            case "CHANNEL_ID_WEB":
            case 1:
              message.channelId = 1;
              break;
            case "CHANNEL_ID_MOBILE":
            case 2:
              message.channelId = 2;
              break;
          }
          switch (object.type) {
            case "TYPE_UNSPECIFIED":
            case 0:
              message.type = 0;
              break;
            case "TYPE_DEPOSIT":
            case 1:
              message.type = 1;
              break;
            case "TYPE_WITHDRAW":
            case 2:
              message.type = 2;
              break;
          }
          switch (object.state) {
            case "STATE_UNSPECIFIED":
            case 0:
              message.state = 0;
              break;
            case "STATE_WAITING_FOR_CONFIRM_OTP":
            case 1:
              message.state = 1;
              break;
            case "STATE_WAITING_FOR_EXECUTE":
            case 2:
              message.state = 2;
              break;
            case "STATE_SUCCESS":
            case 3:
              message.state = 3;
              break;
            case "STATE_FAILURE":
            case 4:
              message.state = 4;
              break;
            case "STATE_PENDING":
            case 5:
              message.state = 5;
              break;
            case "STATE_ERROR":
            case 6:
              message.state = 6;
              break;
          }
          if (object.confirmTransDate != null) {
            if (typeof object.confirmTransDate !== "object")
              throw TypeError(".dnse.lbs.v1.WalletTransaction.confirmTransDate: object expected");
            message.confirmTransDate = $root.google.type.Date.fromObject(object.confirmTransDate);
          }
          if (object.confirmTransDesc != null)
            message.confirmTransDesc = String(object.confirmTransDesc);
          if (object.errorMessage != null)
            message.errorMessage = String(object.errorMessage);
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.lbs.v1.WalletTransaction.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.modifiedDate != null) {
            if (typeof object.modifiedDate !== "object")
              throw TypeError(".dnse.lbs.v1.WalletTransaction.modifiedDate: object expected");
            message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
          }
          if (object.accountTypeName != null)
            message.accountTypeName = String(object.accountTypeName);
          return message;
        };
        WalletTransaction.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.id = "";
            object.transDate = null;
            object.transDesc = "";
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.amount = options.longs === String ? "0" : 0;
            object.custodyCode = "";
            object.payerId = "";
            object.payerName = "";
            object.accountNo = "";
            object.channelId = options.enums === String ? "CHANNEL_ID_UNSPECIFIED" : 0;
            object.type = options.enums === String ? "TYPE_UNSPECIFIED" : 0;
            object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
            object.createdDate = null;
            object.modifiedDate = null;
            object.accountTypeName = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
          if (message.transDate != null && message.hasOwnProperty("transDate"))
            object.transDate = $root.google.type.Date.toObject(message.transDate, options);
          if (message.transDesc != null && message.hasOwnProperty("transDesc"))
            object.transDesc = message.transDesc;
          if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
              object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
              object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.payerId != null && message.hasOwnProperty("payerId"))
            object.payerId = message.payerId;
          if (message.payerName != null && message.hasOwnProperty("payerName"))
            object.payerName = message.payerName;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.channelId != null && message.hasOwnProperty("channelId"))
            object.channelId = options.enums === String ? $root.dnse.lbs.v1.WalletTransaction.ChannelId[message.channelId] : message.channelId;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.dnse.lbs.v1.WalletTransaction.Type[message.type] : message.type;
          if (message.state != null && message.hasOwnProperty("state"))
            object.state = options.enums === String ? $root.dnse.lbs.v1.WalletTransaction.State[message.state] : message.state;
          if (message.confirmTransDate != null && message.hasOwnProperty("confirmTransDate")) {
            object.confirmTransDate = $root.google.type.Date.toObject(message.confirmTransDate, options);
            if (options.oneofs)
              object._confirmTransDate = "confirmTransDate";
          }
          if (message.confirmTransDesc != null && message.hasOwnProperty("confirmTransDesc")) {
            object.confirmTransDesc = message.confirmTransDesc;
            if (options.oneofs)
              object._confirmTransDesc = "confirmTransDesc";
          }
          if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
            object.errorMessage = message.errorMessage;
            if (options.oneofs)
              object._errorMessage = "errorMessage";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
            object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
          if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
            object.accountTypeName = message.accountTypeName;
          return object;
        };
        WalletTransaction.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        WalletTransaction.Type = function() {
          const valuesById = {}, values = Object.create(valuesById);
          values[valuesById[0] = "TYPE_UNSPECIFIED"] = 0;
          values[valuesById[1] = "TYPE_DEPOSIT"] = 1;
          values[valuesById[2] = "TYPE_WITHDRAW"] = 2;
          return values;
        }();
        WalletTransaction.State = function() {
          const valuesById = {}, values = Object.create(valuesById);
          values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
          values[valuesById[1] = "STATE_WAITING_FOR_CONFIRM_OTP"] = 1;
          values[valuesById[2] = "STATE_WAITING_FOR_EXECUTE"] = 2;
          values[valuesById[3] = "STATE_SUCCESS"] = 3;
          values[valuesById[4] = "STATE_FAILURE"] = 4;
          values[valuesById[5] = "STATE_PENDING"] = 5;
          values[valuesById[6] = "STATE_ERROR"] = 6;
          return values;
        }();
        WalletTransaction.ChannelId = function() {
          const valuesById = {}, values = Object.create(valuesById);
          values[valuesById[0] = "CHANNEL_ID_UNSPECIFIED"] = 0;
          values[valuesById[1] = "CHANNEL_ID_WEB"] = 1;
          values[valuesById[2] = "CHANNEL_ID_MOBILE"] = 2;
          return values;
        }();
        return WalletTransaction;
      }();
      v1.LinkTransaction = function() {
        function LinkTransaction(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        LinkTransaction.prototype.accountName = "";
        LinkTransaction.prototype.custodyCode = "";
        LinkTransaction.prototype.bankAccountNumber = "";
        LinkTransaction.prototype.identityCode = "";
        LinkTransaction.prototype.mobile = "";
        LinkTransaction.prototype.partnerCode = 0;
        LinkTransaction.prototype.redirectUrl = "";
        LinkTransaction.prototype.state = "";
        LinkTransaction.prototype.linkType = 0;
        LinkTransaction.prototype.enboxRedirectUrl = "";
        LinkTransaction.prototype.investorId = "";
        LinkTransaction.prototype.createdDate = null;
        LinkTransaction.prototype.modifiedDate = null;
        LinkTransaction.create = function create(properties) {
          return new LinkTransaction(properties);
        };
        LinkTransaction.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
            writer.uint32(10).string(message.accountName);
          if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
            writer.uint32(18).string(message.custodyCode);
          if (message.bankAccountNumber != null && Object.hasOwnProperty.call(message, "bankAccountNumber"))
            writer.uint32(26).string(message.bankAccountNumber);
          if (message.identityCode != null && Object.hasOwnProperty.call(message, "identityCode"))
            writer.uint32(34).string(message.identityCode);
          if (message.mobile != null && Object.hasOwnProperty.call(message, "mobile"))
            writer.uint32(42).string(message.mobile);
          if (message.partnerCode != null && Object.hasOwnProperty.call(message, "partnerCode"))
            writer.uint32(48).int32(message.partnerCode);
          if (message.redirectUrl != null && Object.hasOwnProperty.call(message, "redirectUrl"))
            writer.uint32(58).string(message.redirectUrl);
          if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(66).string(message.state);
          if (message.linkType != null && Object.hasOwnProperty.call(message, "linkType"))
            writer.uint32(72).int32(message.linkType);
          if (message.enboxRedirectUrl != null && Object.hasOwnProperty.call(message, "enboxRedirectUrl"))
            writer.uint32(82).string(message.enboxRedirectUrl);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(90).string(message.investorId);
          if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
            $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(98).fork()).ldelim();
          if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
            $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(106).fork()).ldelim();
          return writer;
        };
        LinkTransaction.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        LinkTransaction.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.lbs.v1.LinkTransaction();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.accountName = reader.string();
                break;
              case 2:
                message.custodyCode = reader.string();
                break;
              case 3:
                message.bankAccountNumber = reader.string();
                break;
              case 4:
                message.identityCode = reader.string();
                break;
              case 5:
                message.mobile = reader.string();
                break;
              case 6:
                message.partnerCode = reader.int32();
                break;
              case 7:
                message.redirectUrl = reader.string();
                break;
              case 8:
                message.state = reader.string();
                break;
              case 9:
                message.linkType = reader.int32();
                break;
              case 10:
                message.enboxRedirectUrl = reader.string();
                break;
              case 11:
                message.investorId = reader.string();
                break;
              case 12:
                message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 13:
                message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        LinkTransaction.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        LinkTransaction.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.accountName != null && message.hasOwnProperty("accountName")) {
            if (!$util.isString(message.accountName))
              return "accountName: string expected";
          }
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
            if (!$util.isString(message.custodyCode))
              return "custodyCode: string expected";
          }
          if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber")) {
            if (!$util.isString(message.bankAccountNumber))
              return "bankAccountNumber: string expected";
          }
          if (message.identityCode != null && message.hasOwnProperty("identityCode")) {
            if (!$util.isString(message.identityCode))
              return "identityCode: string expected";
          }
          if (message.mobile != null && message.hasOwnProperty("mobile")) {
            if (!$util.isString(message.mobile))
              return "mobile: string expected";
          }
          if (message.partnerCode != null && message.hasOwnProperty("partnerCode"))
            switch (message.partnerCode) {
              default:
                return "partnerCode: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.redirectUrl != null && message.hasOwnProperty("redirectUrl")) {
            if (!$util.isString(message.redirectUrl))
              return "redirectUrl: string expected";
          }
          if (message.state != null && message.hasOwnProperty("state")) {
            if (!$util.isString(message.state))
              return "state: string expected";
          }
          if (message.linkType != null && message.hasOwnProperty("linkType"))
            switch (message.linkType) {
              default:
                return "linkType: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.enboxRedirectUrl != null && message.hasOwnProperty("enboxRedirectUrl")) {
            if (!$util.isString(message.enboxRedirectUrl))
              return "enboxRedirectUrl: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
            if (error)
              return "createdDate." + error;
          }
          if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
            let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
            if (error)
              return "modifiedDate." + error;
          }
          return null;
        };
        LinkTransaction.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.lbs.v1.LinkTransaction)
            return object;
          let message = new $root.dnse.lbs.v1.LinkTransaction();
          if (object.accountName != null)
            message.accountName = String(object.accountName);
          if (object.custodyCode != null)
            message.custodyCode = String(object.custodyCode);
          if (object.bankAccountNumber != null)
            message.bankAccountNumber = String(object.bankAccountNumber);
          if (object.identityCode != null)
            message.identityCode = String(object.identityCode);
          if (object.mobile != null)
            message.mobile = String(object.mobile);
          switch (object.partnerCode) {
            case "PARTNER_CODE_UNSPECIFIED":
            case 0:
              message.partnerCode = 0;
              break;
            case "PARTNER_CODE_TCB":
            case 1:
              message.partnerCode = 1;
              break;
            case "PARTNER_CODE_BIDV":
            case 2:
              message.partnerCode = 2;
              break;
          }
          if (object.redirectUrl != null)
            message.redirectUrl = String(object.redirectUrl);
          if (object.state != null)
            message.state = String(object.state);
          switch (object.linkType) {
            case "LINK_TYPE_UNSPECIFIED":
            case 0:
              message.linkType = 0;
              break;
            case "LINK_TYPE_TOPUP":
            case 1:
              message.linkType = 1;
              break;
            case "LINK_TYPE_PPSE":
            case 2:
              message.linkType = 2;
              break;
          }
          if (object.enboxRedirectUrl != null)
            message.enboxRedirectUrl = String(object.enboxRedirectUrl);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          if (object.createdDate != null) {
            if (typeof object.createdDate !== "object")
              throw TypeError(".dnse.lbs.v1.LinkTransaction.createdDate: object expected");
            message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
          }
          if (object.modifiedDate != null) {
            if (typeof object.modifiedDate !== "object")
              throw TypeError(".dnse.lbs.v1.LinkTransaction.modifiedDate: object expected");
            message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
          }
          return message;
        };
        LinkTransaction.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.accountName = "";
            object.custodyCode = "";
            object.bankAccountNumber = "";
            object.identityCode = "";
            object.mobile = "";
            object.partnerCode = options.enums === String ? "PARTNER_CODE_UNSPECIFIED" : 0;
            object.redirectUrl = "";
            object.state = "";
            object.linkType = options.enums === String ? "LINK_TYPE_UNSPECIFIED" : 0;
            object.enboxRedirectUrl = "";
            object.investorId = "";
            object.createdDate = null;
            object.modifiedDate = null;
          }
          if (message.accountName != null && message.hasOwnProperty("accountName"))
            object.accountName = message.accountName;
          if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
            object.custodyCode = message.custodyCode;
          if (message.bankAccountNumber != null && message.hasOwnProperty("bankAccountNumber"))
            object.bankAccountNumber = message.bankAccountNumber;
          if (message.identityCode != null && message.hasOwnProperty("identityCode"))
            object.identityCode = message.identityCode;
          if (message.mobile != null && message.hasOwnProperty("mobile"))
            object.mobile = message.mobile;
          if (message.partnerCode != null && message.hasOwnProperty("partnerCode"))
            object.partnerCode = options.enums === String ? $root.dnse.lbs.v1.LinkTransaction.PartnerCode[message.partnerCode] : message.partnerCode;
          if (message.redirectUrl != null && message.hasOwnProperty("redirectUrl"))
            object.redirectUrl = message.redirectUrl;
          if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
          if (message.linkType != null && message.hasOwnProperty("linkType"))
            object.linkType = options.enums === String ? $root.dnse.lbs.v1.LinkTransaction.LinkType[message.linkType] : message.linkType;
          if (message.enboxRedirectUrl != null && message.hasOwnProperty("enboxRedirectUrl"))
            object.enboxRedirectUrl = message.enboxRedirectUrl;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          if (message.createdDate != null && message.hasOwnProperty("createdDate"))
            object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
          if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
            object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
          return object;
        };
        LinkTransaction.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        LinkTransaction.LinkType = function() {
          const valuesById = {}, values = Object.create(valuesById);
          values[valuesById[0] = "LINK_TYPE_UNSPECIFIED"] = 0;
          values[valuesById[1] = "LINK_TYPE_TOPUP"] = 1;
          values[valuesById[2] = "LINK_TYPE_PPSE"] = 2;
          return values;
        }();
        LinkTransaction.PartnerCode = function() {
          const valuesById = {}, values = Object.create(valuesById);
          values[valuesById[0] = "PARTNER_CODE_UNSPECIFIED"] = 0;
          values[valuesById[1] = "PARTNER_CODE_TCB"] = 1;
          values[valuesById[2] = "PARTNER_CODE_BIDV"] = 2;
          return values;
        }();
        return LinkTransaction;
      }();
      return v1;
    }();
    return lbs;
  }();
  dnse2.SavingsAccountFinancingCashCreated = function() {
    function SavingsAccountFinancingCashCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountFinancingCashCreated.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCashCreated.prototype.nominalAnnualInterestRate = 0;
    SavingsAccountFinancingCashCreated.prototype.productName = "";
    SavingsAccountFinancingCashCreated.prototype.investorId = "";
    SavingsAccountFinancingCashCreated.prototype.createdDate = null;
    SavingsAccountFinancingCashCreated.prototype.savingsAccountId = 0;
    SavingsAccountFinancingCashCreated.create = function create(properties) {
      return new SavingsAccountFinancingCashCreated(properties);
    };
    SavingsAccountFinancingCashCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(8).uint64(message.amount);
      if (message.nominalAnnualInterestRate != null && Object.hasOwnProperty.call(message, "nominalAnnualInterestRate"))
        writer.uint32(17).double(message.nominalAnnualInterestRate);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(26).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(42).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(48).uint32(message.savingsAccountId);
      return writer;
    };
    SavingsAccountFinancingCashCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountFinancingCashCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountFinancingCashCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.amount = reader.uint64();
            break;
          case 2:
            message.nominalAnnualInterestRate = reader.double();
            break;
          case 3:
            message.productName = reader.string();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.savingsAccountId = reader.uint32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountFinancingCashCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountFinancingCashCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate")) {
        if (typeof message.nominalAnnualInterestRate !== "number")
          return "nominalAnnualInterestRate: number expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId))
          return "savingsAccountId: integer expected";
      }
      return null;
    };
    SavingsAccountFinancingCashCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountFinancingCashCreated)
        return object;
      let message = new $root.dnse.SavingsAccountFinancingCashCreated();
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.nominalAnnualInterestRate != null)
        message.nominalAnnualInterestRate = Number(object.nominalAnnualInterestRate);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountFinancingCashCreated.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null)
        message.savingsAccountId = object.savingsAccountId >>> 0;
      return message;
    };
    SavingsAccountFinancingCashCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.nominalAnnualInterestRate = 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        object.savingsAccountId = 0;
      }
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate"))
        object.nominalAnnualInterestRate = options.json && !isFinite(message.nominalAnnualInterestRate) ? String(message.nominalAnnualInterestRate) : message.nominalAnnualInterestRate;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      return object;
    };
    SavingsAccountFinancingCashCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountFinancingCashCreated;
  }();
  dnse2.SavingsAccountFinancingCashCreatedFail = function() {
    function SavingsAccountFinancingCashCreatedFail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountFinancingCashCreatedFail.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCashCreatedFail.prototype.nominalAnnualInterestRate = 0;
    SavingsAccountFinancingCashCreatedFail.prototype.productName = "";
    SavingsAccountFinancingCashCreatedFail.prototype.investorId = "";
    SavingsAccountFinancingCashCreatedFail.prototype.createdDate = null;
    SavingsAccountFinancingCashCreatedFail.prototype.savingsAccountId = 0;
    SavingsAccountFinancingCashCreatedFail.prototype.errorMessage = "";
    SavingsAccountFinancingCashCreatedFail.create = function create(properties) {
      return new SavingsAccountFinancingCashCreatedFail(properties);
    };
    SavingsAccountFinancingCashCreatedFail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(8).uint64(message.amount);
      if (message.nominalAnnualInterestRate != null && Object.hasOwnProperty.call(message, "nominalAnnualInterestRate"))
        writer.uint32(17).double(message.nominalAnnualInterestRate);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(26).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(42).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(48).uint32(message.savingsAccountId);
      if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
        writer.uint32(58).string(message.errorMessage);
      return writer;
    };
    SavingsAccountFinancingCashCreatedFail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountFinancingCashCreatedFail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountFinancingCashCreatedFail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.amount = reader.uint64();
            break;
          case 2:
            message.nominalAnnualInterestRate = reader.double();
            break;
          case 3:
            message.productName = reader.string();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 6:
            message.savingsAccountId = reader.uint32();
            break;
          case 7:
            message.errorMessage = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountFinancingCashCreatedFail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountFinancingCashCreatedFail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate")) {
        if (typeof message.nominalAnnualInterestRate !== "number")
          return "nominalAnnualInterestRate: number expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId))
          return "savingsAccountId: integer expected";
      }
      if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
        if (!$util.isString(message.errorMessage))
          return "errorMessage: string expected";
      }
      return null;
    };
    SavingsAccountFinancingCashCreatedFail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountFinancingCashCreatedFail)
        return object;
      let message = new $root.dnse.SavingsAccountFinancingCashCreatedFail();
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.nominalAnnualInterestRate != null)
        message.nominalAnnualInterestRate = Number(object.nominalAnnualInterestRate);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountFinancingCashCreatedFail.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null)
        message.savingsAccountId = object.savingsAccountId >>> 0;
      if (object.errorMessage != null)
        message.errorMessage = String(object.errorMessage);
      return message;
    };
    SavingsAccountFinancingCashCreatedFail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.nominalAnnualInterestRate = 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        object.savingsAccountId = 0;
        object.errorMessage = "";
      }
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate"))
        object.nominalAnnualInterestRate = options.json && !isFinite(message.nominalAnnualInterestRate) ? String(message.nominalAnnualInterestRate) : message.nominalAnnualInterestRate;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
        object.errorMessage = message.errorMessage;
      return object;
    };
    SavingsAccountFinancingCashCreatedFail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountFinancingCashCreatedFail;
  }();
  dnse2.SavingsAccountFinancingCashWithdrawal = function() {
    function SavingsAccountFinancingCashWithdrawal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountFinancingCashWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCashWithdrawal.prototype.interestAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCashWithdrawal.prototype.taxAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCashWithdrawal.prototype.productName = "";
    SavingsAccountFinancingCashWithdrawal.prototype.investorId = "";
    SavingsAccountFinancingCashWithdrawal.prototype.createdDate = null;
    SavingsAccountFinancingCashWithdrawal.prototype.savingsAccountId = 0;
    SavingsAccountFinancingCashWithdrawal.prototype.partialWithdrawalId = 0;
    SavingsAccountFinancingCashWithdrawal.create = function create(properties) {
      return new SavingsAccountFinancingCashWithdrawal(properties);
    };
    SavingsAccountFinancingCashWithdrawal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(8).uint64(message.amount);
      if (message.interestAmount != null && Object.hasOwnProperty.call(message, "interestAmount"))
        writer.uint32(16).uint64(message.interestAmount);
      if (message.taxAmount != null && Object.hasOwnProperty.call(message, "taxAmount"))
        writer.uint32(24).uint64(message.taxAmount);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(34).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(56).uint32(message.savingsAccountId);
      if (message.partialWithdrawalId != null && Object.hasOwnProperty.call(message, "partialWithdrawalId"))
        writer.uint32(64).uint32(message.partialWithdrawalId);
      return writer;
    };
    SavingsAccountFinancingCashWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountFinancingCashWithdrawal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountFinancingCashWithdrawal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.amount = reader.uint64();
            break;
          case 2:
            message.interestAmount = reader.uint64();
            break;
          case 3:
            message.taxAmount = reader.uint64();
            break;
          case 4:
            message.productName = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.savingsAccountId = reader.uint32();
            break;
          case 8:
            message.partialWithdrawalId = reader.uint32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountFinancingCashWithdrawal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountFinancingCashWithdrawal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interestAmount != null && message.hasOwnProperty("interestAmount")) {
        if (!$util.isInteger(message.interestAmount) && !(message.interestAmount && $util.isInteger(message.interestAmount.low) && $util.isInteger(message.interestAmount.high)))
          return "interestAmount: integer|Long expected";
      }
      if (message.taxAmount != null && message.hasOwnProperty("taxAmount")) {
        if (!$util.isInteger(message.taxAmount) && !(message.taxAmount && $util.isInteger(message.taxAmount.low) && $util.isInteger(message.taxAmount.high)))
          return "taxAmount: integer|Long expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId))
          return "savingsAccountId: integer expected";
      }
      if (message.partialWithdrawalId != null && message.hasOwnProperty("partialWithdrawalId")) {
        if (!$util.isInteger(message.partialWithdrawalId))
          return "partialWithdrawalId: integer expected";
      }
      return null;
    };
    SavingsAccountFinancingCashWithdrawal.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountFinancingCashWithdrawal)
        return object;
      let message = new $root.dnse.SavingsAccountFinancingCashWithdrawal();
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.interestAmount != null) {
        if ($util.Long)
          (message.interestAmount = $util.Long.fromValue(object.interestAmount)).unsigned = true;
        else if (typeof object.interestAmount === "string")
          message.interestAmount = parseInt(object.interestAmount, 10);
        else if (typeof object.interestAmount === "number")
          message.interestAmount = object.interestAmount;
        else if (typeof object.interestAmount === "object")
          message.interestAmount = new $util.LongBits(object.interestAmount.low >>> 0, object.interestAmount.high >>> 0).toNumber(true);
      }
      if (object.taxAmount != null) {
        if ($util.Long)
          (message.taxAmount = $util.Long.fromValue(object.taxAmount)).unsigned = true;
        else if (typeof object.taxAmount === "string")
          message.taxAmount = parseInt(object.taxAmount, 10);
        else if (typeof object.taxAmount === "number")
          message.taxAmount = object.taxAmount;
        else if (typeof object.taxAmount === "object")
          message.taxAmount = new $util.LongBits(object.taxAmount.low >>> 0, object.taxAmount.high >>> 0).toNumber(true);
      }
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountFinancingCashWithdrawal.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null)
        message.savingsAccountId = object.savingsAccountId >>> 0;
      if (object.partialWithdrawalId != null)
        message.partialWithdrawalId = object.partialWithdrawalId >>> 0;
      return message;
    };
    SavingsAccountFinancingCashWithdrawal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.interestAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.interestAmount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.taxAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.taxAmount = options.longs === String ? "0" : 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        object.savingsAccountId = 0;
        object.partialWithdrawalId = 0;
      }
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.interestAmount != null && message.hasOwnProperty("interestAmount"))
        if (typeof message.interestAmount === "number")
          object.interestAmount = options.longs === String ? String(message.interestAmount) : message.interestAmount;
        else
          object.interestAmount = options.longs === String ? $util.Long.prototype.toString.call(message.interestAmount) : options.longs === Number ? new $util.LongBits(message.interestAmount.low >>> 0, message.interestAmount.high >>> 0).toNumber(true) : message.interestAmount;
      if (message.taxAmount != null && message.hasOwnProperty("taxAmount"))
        if (typeof message.taxAmount === "number")
          object.taxAmount = options.longs === String ? String(message.taxAmount) : message.taxAmount;
        else
          object.taxAmount = options.longs === String ? $util.Long.prototype.toString.call(message.taxAmount) : options.longs === Number ? new $util.LongBits(message.taxAmount.low >>> 0, message.taxAmount.high >>> 0).toNumber(true) : message.taxAmount;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.partialWithdrawalId != null && message.hasOwnProperty("partialWithdrawalId"))
        object.partialWithdrawalId = message.partialWithdrawalId;
      return object;
    };
    SavingsAccountFinancingCashWithdrawal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountFinancingCashWithdrawal;
  }();
  dnse2.FinancingCashDepositDetail = function() {
    function FinancingCashDepositDetail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    FinancingCashDepositDetail.prototype.accountNo = "";
    FinancingCashDepositDetail.create = function create(properties) {
      return new FinancingCashDepositDetail(properties);
    };
    FinancingCashDepositDetail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      return writer;
    };
    FinancingCashDepositDetail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    FinancingCashDepositDetail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.FinancingCashDepositDetail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    FinancingCashDepositDetail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    FinancingCashDepositDetail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      return null;
    };
    FinancingCashDepositDetail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.FinancingCashDepositDetail)
        return object;
      let message = new $root.dnse.FinancingCashDepositDetail();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      return message;
    };
    FinancingCashDepositDetail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults)
        object.accountNo = "";
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      return object;
    };
    FinancingCashDepositDetail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return FinancingCashDepositDetail;
  }();
  dnse2.SavingsAccountFinancingCash = function() {
    function SavingsAccountFinancingCash(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountFinancingCash.prototype.id = 0;
    SavingsAccountFinancingCash.prototype.investorId = "";
    SavingsAccountFinancingCash.prototype.depositDetail = null;
    SavingsAccountFinancingCash.prototype.savingAccountNo = null;
    SavingsAccountFinancingCash.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCash.prototype.initialAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountFinancingCash.prototype.investmentDate = null;
    SavingsAccountFinancingCash.prototype.savingsProductVersionId = null;
    SavingsAccountFinancingCash.prototype.status = 0;
    let $oneOfFields;
    Object.defineProperty(SavingsAccountFinancingCash.prototype, "_savingAccountNo", {
      get: $util.oneOfGetter($oneOfFields = ["savingAccountNo"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(SavingsAccountFinancingCash.prototype, "_savingsProductVersionId", {
      get: $util.oneOfGetter($oneOfFields = ["savingsProductVersionId"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    SavingsAccountFinancingCash.create = function create(properties) {
      return new SavingsAccountFinancingCash(properties);
    };
    SavingsAccountFinancingCash.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).uint32(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.depositDetail != null && Object.hasOwnProperty.call(message, "depositDetail"))
        $root.dnse.FinancingCashDepositDetail.encode(message.depositDetail, writer.uint32(26).fork()).ldelim();
      if (message.savingAccountNo != null && Object.hasOwnProperty.call(message, "savingAccountNo"))
        writer.uint32(34).string(message.savingAccountNo);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(40).uint64(message.amount);
      if (message.initialAmount != null && Object.hasOwnProperty.call(message, "initialAmount"))
        writer.uint32(48).uint64(message.initialAmount);
      if (message.investmentDate != null && Object.hasOwnProperty.call(message, "investmentDate"))
        $root.google.protobuf.Timestamp.encode(message.investmentDate, writer.uint32(58).fork()).ldelim();
      if (message.savingsProductVersionId != null && Object.hasOwnProperty.call(message, "savingsProductVersionId"))
        writer.uint32(64).uint64(message.savingsProductVersionId);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(72).int32(message.status);
      return writer;
    };
    SavingsAccountFinancingCash.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountFinancingCash.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountFinancingCash();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.uint32();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.depositDetail = $root.dnse.FinancingCashDepositDetail.decode(reader, reader.uint32());
            break;
          case 4:
            message.savingAccountNo = reader.string();
            break;
          case 5:
            message.amount = reader.uint64();
            break;
          case 6:
            message.initialAmount = reader.uint64();
            break;
          case 7:
            message.investmentDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.savingsProductVersionId = reader.uint64();
            break;
          case 9:
            message.status = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountFinancingCash.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountFinancingCash.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.depositDetail != null && message.hasOwnProperty("depositDetail")) {
        let error = $root.dnse.FinancingCashDepositDetail.verify(message.depositDetail);
        if (error)
          return "depositDetail." + error;
      }
      if (message.savingAccountNo != null && message.hasOwnProperty("savingAccountNo")) {
        if (!$util.isString(message.savingAccountNo))
          return "savingAccountNo: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.initialAmount != null && message.hasOwnProperty("initialAmount")) {
        if (!$util.isInteger(message.initialAmount) && !(message.initialAmount && $util.isInteger(message.initialAmount.low) && $util.isInteger(message.initialAmount.high)))
          return "initialAmount: integer|Long expected";
      }
      if (message.investmentDate != null && message.hasOwnProperty("investmentDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.investmentDate);
        if (error)
          return "investmentDate." + error;
      }
      if (message.savingsProductVersionId != null && message.hasOwnProperty("savingsProductVersionId")) {
        if (!$util.isInteger(message.savingsProductVersionId) && !(message.savingsProductVersionId && $util.isInteger(message.savingsProductVersionId.low) && $util.isInteger(message.savingsProductVersionId.high)))
          return "savingsProductVersionId: integer|Long expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
            break;
        }
      return null;
    };
    SavingsAccountFinancingCash.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountFinancingCash)
        return object;
      let message = new $root.dnse.SavingsAccountFinancingCash();
      if (object.id != null)
        message.id = object.id >>> 0;
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.depositDetail != null) {
        if (typeof object.depositDetail !== "object")
          throw TypeError(".dnse.SavingsAccountFinancingCash.depositDetail: object expected");
        message.depositDetail = $root.dnse.FinancingCashDepositDetail.fromObject(object.depositDetail);
      }
      if (object.savingAccountNo != null)
        message.savingAccountNo = String(object.savingAccountNo);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.initialAmount != null) {
        if ($util.Long)
          (message.initialAmount = $util.Long.fromValue(object.initialAmount)).unsigned = true;
        else if (typeof object.initialAmount === "string")
          message.initialAmount = parseInt(object.initialAmount, 10);
        else if (typeof object.initialAmount === "number")
          message.initialAmount = object.initialAmount;
        else if (typeof object.initialAmount === "object")
          message.initialAmount = new $util.LongBits(object.initialAmount.low >>> 0, object.initialAmount.high >>> 0).toNumber(true);
      }
      if (object.investmentDate != null) {
        if (typeof object.investmentDate !== "object")
          throw TypeError(".dnse.SavingsAccountFinancingCash.investmentDate: object expected");
        message.investmentDate = $root.google.protobuf.Timestamp.fromObject(object.investmentDate);
      }
      if (object.savingsProductVersionId != null) {
        if ($util.Long)
          (message.savingsProductVersionId = $util.Long.fromValue(object.savingsProductVersionId)).unsigned = true;
        else if (typeof object.savingsProductVersionId === "string")
          message.savingsProductVersionId = parseInt(object.savingsProductVersionId, 10);
        else if (typeof object.savingsProductVersionId === "number")
          message.savingsProductVersionId = object.savingsProductVersionId;
        else if (typeof object.savingsProductVersionId === "object")
          message.savingsProductVersionId = new $util.LongBits(object.savingsProductVersionId.low >>> 0, object.savingsProductVersionId.high >>> 0).toNumber(true);
      }
      switch (object.status) {
        case "UNKNOWN":
        case 0:
          message.status = 0;
          break;
        case "INACTIVE":
        case 1:
          message.status = 1;
          break;
        case "ACTIVE":
        case 2:
          message.status = 2;
          break;
        case "MATURED":
        case 3:
          message.status = 3;
          break;
        case "SETTLED":
        case 4:
          message.status = 4;
          break;
        case "ROLLOVER":
        case 5:
          message.status = 5;
          break;
        case "CLOSED":
        case 6:
          message.status = 6;
          break;
        case "CREATED":
        case 7:
          message.status = 7;
          break;
        case "SENT":
        case 8:
          message.status = 8;
          break;
        case "REJECTED":
        case 9:
          message.status = 9;
          break;
      }
      return message;
    };
    SavingsAccountFinancingCash.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.investorId = "";
        object.depositDetail = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.initialAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.initialAmount = options.longs === String ? "0" : 0;
        object.investmentDate = null;
        object.status = options.enums === String ? "UNKNOWN" : 0;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.depositDetail != null && message.hasOwnProperty("depositDetail"))
        object.depositDetail = $root.dnse.FinancingCashDepositDetail.toObject(message.depositDetail, options);
      if (message.savingAccountNo != null && message.hasOwnProperty("savingAccountNo")) {
        object.savingAccountNo = message.savingAccountNo;
        if (options.oneofs)
          object._savingAccountNo = "savingAccountNo";
      }
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.initialAmount != null && message.hasOwnProperty("initialAmount"))
        if (typeof message.initialAmount === "number")
          object.initialAmount = options.longs === String ? String(message.initialAmount) : message.initialAmount;
        else
          object.initialAmount = options.longs === String ? $util.Long.prototype.toString.call(message.initialAmount) : options.longs === Number ? new $util.LongBits(message.initialAmount.low >>> 0, message.initialAmount.high >>> 0).toNumber(true) : message.initialAmount;
      if (message.investmentDate != null && message.hasOwnProperty("investmentDate"))
        object.investmentDate = $root.google.protobuf.Timestamp.toObject(message.investmentDate, options);
      if (message.savingsProductVersionId != null && message.hasOwnProperty("savingsProductVersionId")) {
        if (typeof message.savingsProductVersionId === "number")
          object.savingsProductVersionId = options.longs === String ? String(message.savingsProductVersionId) : message.savingsProductVersionId;
        else
          object.savingsProductVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsProductVersionId) : options.longs === Number ? new $util.LongBits(message.savingsProductVersionId.low >>> 0, message.savingsProductVersionId.high >>> 0).toNumber(true) : message.savingsProductVersionId;
        if (options.oneofs)
          object._savingsProductVersionId = "savingsProductVersionId";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.SavingsAccountFinancingCash.Status[message.status] : message.status;
      return object;
    };
    SavingsAccountFinancingCash.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    SavingsAccountFinancingCash.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "INACTIVE"] = 1;
      values[valuesById[2] = "ACTIVE"] = 2;
      values[valuesById[3] = "MATURED"] = 3;
      values[valuesById[4] = "SETTLED"] = 4;
      values[valuesById[5] = "ROLLOVER"] = 5;
      values[valuesById[6] = "CLOSED"] = 6;
      values[valuesById[7] = "CREATED"] = 7;
      values[valuesById[8] = "SENT"] = 8;
      values[valuesById[9] = "REJECTED"] = 9;
      return values;
    }();
    return SavingsAccountFinancingCash;
  }();
  dnse2.bidv = function() {
    const bidv = {};
    bidv.WalletTransaction = function() {
      function WalletTransaction(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      WalletTransaction.prototype.id = "";
      WalletTransaction.prototype.transDate = null;
      WalletTransaction.prototype.transDesc = "";
      WalletTransaction.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
      WalletTransaction.prototype.custodyCode = "";
      WalletTransaction.prototype.payerId = "";
      WalletTransaction.prototype.payerName = "";
      WalletTransaction.prototype.accountNo = "";
      WalletTransaction.prototype.channelId = 0;
      WalletTransaction.prototype.type = 0;
      WalletTransaction.prototype.state = 0;
      WalletTransaction.prototype.confirmTransDate = null;
      WalletTransaction.prototype.confirmTransDesc = null;
      WalletTransaction.prototype.errorMessage = null;
      WalletTransaction.prototype.createdDate = null;
      WalletTransaction.prototype.modifiedDate = null;
      WalletTransaction.prototype.accountTypeName = "";
      let $oneOfFields;
      Object.defineProperty(WalletTransaction.prototype, "_confirmTransDate", {
        get: $util.oneOfGetter($oneOfFields = ["confirmTransDate"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(WalletTransaction.prototype, "_confirmTransDesc", {
        get: $util.oneOfGetter($oneOfFields = ["confirmTransDesc"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      Object.defineProperty(WalletTransaction.prototype, "_errorMessage", {
        get: $util.oneOfGetter($oneOfFields = ["errorMessage"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      WalletTransaction.create = function create(properties) {
        return new WalletTransaction(properties);
      };
      WalletTransaction.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(10).string(message.id);
        if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
          $root.google.type.Date.encode(message.transDate, writer.uint32(26).fork()).ldelim();
        if (message.transDesc != null && Object.hasOwnProperty.call(message, "transDesc"))
          writer.uint32(34).string(message.transDesc);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
          writer.uint32(40).int64(message.amount);
        if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
          writer.uint32(50).string(message.custodyCode);
        if (message.payerId != null && Object.hasOwnProperty.call(message, "payerId"))
          writer.uint32(58).string(message.payerId);
        if (message.payerName != null && Object.hasOwnProperty.call(message, "payerName"))
          writer.uint32(66).string(message.payerName);
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
          writer.uint32(74).string(message.accountNo);
        if (message.channelId != null && Object.hasOwnProperty.call(message, "channelId"))
          writer.uint32(80).int32(message.channelId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
          writer.uint32(88).int32(message.type);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
          writer.uint32(96).int32(message.state);
        if (message.confirmTransDate != null && Object.hasOwnProperty.call(message, "confirmTransDate"))
          $root.google.type.Date.encode(message.confirmTransDate, writer.uint32(114).fork()).ldelim();
        if (message.confirmTransDesc != null && Object.hasOwnProperty.call(message, "confirmTransDesc"))
          writer.uint32(122).string(message.confirmTransDesc);
        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
          writer.uint32(130).string(message.errorMessage);
        if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
          $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(138).fork()).ldelim();
        if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
          $root.google.protobuf.Timestamp.encode(message.modifiedDate, writer.uint32(146).fork()).ldelim();
        if (message.accountTypeName != null && Object.hasOwnProperty.call(message, "accountTypeName"))
          writer.uint32(154).string(message.accountTypeName);
        return writer;
      };
      WalletTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      WalletTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.bidv.WalletTransaction();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 3:
              message.transDate = $root.google.type.Date.decode(reader, reader.uint32());
              break;
            case 4:
              message.transDesc = reader.string();
              break;
            case 5:
              message.amount = reader.int64();
              break;
            case 6:
              message.custodyCode = reader.string();
              break;
            case 7:
              message.payerId = reader.string();
              break;
            case 8:
              message.payerName = reader.string();
              break;
            case 9:
              message.accountNo = reader.string();
              break;
            case 10:
              message.channelId = reader.int32();
              break;
            case 11:
              message.type = reader.int32();
              break;
            case 12:
              message.state = reader.int32();
              break;
            case 14:
              message.confirmTransDate = $root.google.type.Date.decode(reader, reader.uint32());
              break;
            case 15:
              message.confirmTransDesc = reader.string();
              break;
            case 16:
              message.errorMessage = reader.string();
              break;
            case 17:
              message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 18:
              message.modifiedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
              break;
            case 19:
              message.accountTypeName = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      WalletTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      WalletTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isString(message.id))
            return "id: string expected";
        }
        if (message.transDate != null && message.hasOwnProperty("transDate")) {
          let error = $root.google.type.Date.verify(message.transDate);
          if (error)
            return "transDate." + error;
        }
        if (message.transDesc != null && message.hasOwnProperty("transDesc")) {
          if (!$util.isString(message.transDesc))
            return "transDesc: string expected";
        }
        if (message.amount != null && message.hasOwnProperty("amount")) {
          if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        }
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
          if (!$util.isString(message.custodyCode))
            return "custodyCode: string expected";
        }
        if (message.payerId != null && message.hasOwnProperty("payerId")) {
          if (!$util.isString(message.payerId))
            return "payerId: string expected";
        }
        if (message.payerName != null && message.hasOwnProperty("payerName")) {
          if (!$util.isString(message.payerName))
            return "payerName: string expected";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
          if (!$util.isString(message.accountNo))
            return "accountNo: string expected";
        }
        if (message.channelId != null && message.hasOwnProperty("channelId"))
          switch (message.channelId) {
            default:
              return "channelId: enum value expected";
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.type != null && message.hasOwnProperty("type"))
          switch (message.type) {
            default:
              return "type: enum value expected";
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.state != null && message.hasOwnProperty("state"))
          switch (message.state) {
            default:
              return "state: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              break;
          }
        if (message.confirmTransDate != null && message.hasOwnProperty("confirmTransDate")) {
          {
            let error = $root.google.type.Date.verify(message.confirmTransDate);
            if (error)
              return "confirmTransDate." + error;
          }
        }
        if (message.confirmTransDesc != null && message.hasOwnProperty("confirmTransDesc")) {
          if (!$util.isString(message.confirmTransDesc))
            return "confirmTransDesc: string expected";
        }
        if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
          if (!$util.isString(message.errorMessage))
            return "errorMessage: string expected";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
          if (error)
            return "createdDate." + error;
        }
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate")) {
          let error = $root.google.protobuf.Timestamp.verify(message.modifiedDate);
          if (error)
            return "modifiedDate." + error;
        }
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName")) {
          if (!$util.isString(message.accountTypeName))
            return "accountTypeName: string expected";
        }
        return null;
      };
      WalletTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.dnse.bidv.WalletTransaction)
          return object;
        let message = new $root.dnse.bidv.WalletTransaction();
        if (object.id != null)
          message.id = String(object.id);
        if (object.transDate != null) {
          if (typeof object.transDate !== "object")
            throw TypeError(".dnse.bidv.WalletTransaction.transDate: object expected");
          message.transDate = $root.google.type.Date.fromObject(object.transDate);
        }
        if (object.transDesc != null)
          message.transDesc = String(object.transDesc);
        if (object.amount != null) {
          if ($util.Long)
            (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
          else if (typeof object.amount === "string")
            message.amount = parseInt(object.amount, 10);
          else if (typeof object.amount === "number")
            message.amount = object.amount;
          else if (typeof object.amount === "object")
            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        }
        if (object.custodyCode != null)
          message.custodyCode = String(object.custodyCode);
        if (object.payerId != null)
          message.payerId = String(object.payerId);
        if (object.payerName != null)
          message.payerName = String(object.payerName);
        if (object.accountNo != null)
          message.accountNo = String(object.accountNo);
        switch (object.channelId) {
          case "CHANNEL_ID_UNSPECIFIED":
          case 0:
            message.channelId = 0;
            break;
          case "CHANNEL_ID_WEB":
          case 1:
            message.channelId = 1;
            break;
          case "CHANNEL_ID_MOBILE":
          case 2:
            message.channelId = 2;
            break;
        }
        switch (object.type) {
          case "TYPE_UNSPECIFIED":
          case 0:
            message.type = 0;
            break;
          case "TYPE_DEPOSIT":
          case 1:
            message.type = 1;
            break;
          case "TYPE_WITHDRAW":
          case 2:
            message.type = 2;
            break;
        }
        switch (object.state) {
          case "STATE_UNSPECIFIED":
          case 0:
            message.state = 0;
            break;
          case "STATE_WAITING_FOR_CONFIRM_OTP":
          case 1:
            message.state = 1;
            break;
          case "STATE_WAITING_FOR_EXECUTE":
          case 2:
            message.state = 2;
            break;
          case "STATE_SUCCESS":
          case 3:
            message.state = 3;
            break;
          case "STATE_FAILURE":
          case 4:
            message.state = 4;
            break;
          case "STATE_PENDING":
          case 5:
            message.state = 5;
            break;
          case "STATE_ERROR":
          case 6:
            message.state = 6;
            break;
        }
        if (object.confirmTransDate != null) {
          if (typeof object.confirmTransDate !== "object")
            throw TypeError(".dnse.bidv.WalletTransaction.confirmTransDate: object expected");
          message.confirmTransDate = $root.google.type.Date.fromObject(object.confirmTransDate);
        }
        if (object.confirmTransDesc != null)
          message.confirmTransDesc = String(object.confirmTransDesc);
        if (object.errorMessage != null)
          message.errorMessage = String(object.errorMessage);
        if (object.createdDate != null) {
          if (typeof object.createdDate !== "object")
            throw TypeError(".dnse.bidv.WalletTransaction.createdDate: object expected");
          message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
        }
        if (object.modifiedDate != null) {
          if (typeof object.modifiedDate !== "object")
            throw TypeError(".dnse.bidv.WalletTransaction.modifiedDate: object expected");
          message.modifiedDate = $root.google.protobuf.Timestamp.fromObject(object.modifiedDate);
        }
        if (object.accountTypeName != null)
          message.accountTypeName = String(object.accountTypeName);
        return message;
      };
      WalletTransaction.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults) {
          object.id = "";
          object.transDate = null;
          object.transDesc = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.amount = options.longs === String ? "0" : 0;
          object.custodyCode = "";
          object.payerId = "";
          object.payerName = "";
          object.accountNo = "";
          object.channelId = options.enums === String ? "CHANNEL_ID_UNSPECIFIED" : 0;
          object.type = options.enums === String ? "TYPE_UNSPECIFIED" : 0;
          object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
          object.createdDate = null;
          object.modifiedDate = null;
          object.accountTypeName = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.transDate != null && message.hasOwnProperty("transDate"))
          object.transDate = $root.google.type.Date.toObject(message.transDate, options);
        if (message.transDesc != null && message.hasOwnProperty("transDesc"))
          object.transDesc = message.transDesc;
        if (message.amount != null && message.hasOwnProperty("amount"))
          if (typeof message.amount === "number")
            object.amount = options.longs === String ? String(message.amount) : message.amount;
          else
            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
          object.custodyCode = message.custodyCode;
        if (message.payerId != null && message.hasOwnProperty("payerId"))
          object.payerId = message.payerId;
        if (message.payerName != null && message.hasOwnProperty("payerName"))
          object.payerName = message.payerName;
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
          object.accountNo = message.accountNo;
        if (message.channelId != null && message.hasOwnProperty("channelId"))
          object.channelId = options.enums === String ? $root.dnse.bidv.WalletTransaction.ChannelId[message.channelId] : message.channelId;
        if (message.type != null && message.hasOwnProperty("type"))
          object.type = options.enums === String ? $root.dnse.bidv.WalletTransaction.Type[message.type] : message.type;
        if (message.state != null && message.hasOwnProperty("state"))
          object.state = options.enums === String ? $root.dnse.bidv.WalletTransaction.State[message.state] : message.state;
        if (message.confirmTransDate != null && message.hasOwnProperty("confirmTransDate")) {
          object.confirmTransDate = $root.google.type.Date.toObject(message.confirmTransDate, options);
          if (options.oneofs)
            object._confirmTransDate = "confirmTransDate";
        }
        if (message.confirmTransDesc != null && message.hasOwnProperty("confirmTransDesc")) {
          object.confirmTransDesc = message.confirmTransDesc;
          if (options.oneofs)
            object._confirmTransDesc = "confirmTransDesc";
        }
        if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
          object.errorMessage = message.errorMessage;
          if (options.oneofs)
            object._errorMessage = "errorMessage";
        }
        if (message.createdDate != null && message.hasOwnProperty("createdDate"))
          object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
        if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
          object.modifiedDate = $root.google.protobuf.Timestamp.toObject(message.modifiedDate, options);
        if (message.accountTypeName != null && message.hasOwnProperty("accountTypeName"))
          object.accountTypeName = message.accountTypeName;
        return object;
      };
      WalletTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      WalletTransaction.Type = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TYPE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "TYPE_DEPOSIT"] = 1;
        values[valuesById[2] = "TYPE_WITHDRAW"] = 2;
        return values;
      }();
      WalletTransaction.State = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "STATE_WAITING_FOR_CONFIRM_OTP"] = 1;
        values[valuesById[2] = "STATE_WAITING_FOR_EXECUTE"] = 2;
        values[valuesById[3] = "STATE_SUCCESS"] = 3;
        values[valuesById[4] = "STATE_FAILURE"] = 4;
        values[valuesById[5] = "STATE_PENDING"] = 5;
        values[valuesById[6] = "STATE_ERROR"] = 6;
        return values;
      }();
      WalletTransaction.ChannelId = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CHANNEL_ID_UNSPECIFIED"] = 0;
        values[valuesById[1] = "CHANNEL_ID_WEB"] = 1;
        values[valuesById[2] = "CHANNEL_ID_MOBILE"] = 2;
        return values;
      }();
      return WalletTransaction;
    }();
    return bidv;
  }();
  dnse2.EvfContractCreated = function() {
    function EvfContractCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfContractCreated.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractCreated.prototype.investorId = "";
    EvfContractCreated.prototype.accountNo = "";
    EvfContractCreated.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractCreated.prototype.createdAt = null;
    EvfContractCreated.create = function create(properties) {
      return new EvfContractCreated(properties);
    };
    EvfContractCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(32).int64(message.loanAmount);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(42).fork()).ldelim();
      return writer;
    };
    EvfContractCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfContractCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfContractCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.loanAmount = reader.int64();
            break;
          case 5:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfContractCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfContractCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfContractCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfContractCreated)
        return object;
      let message = new $root.dnse.EvfContractCreated();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfContractCreated.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfContractCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfContractCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfContractCreated;
  }();
  dnse2.EvfContractCancelled = function() {
    function EvfContractCancelled(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfContractCancelled.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractCancelled.prototype.investorId = "";
    EvfContractCancelled.prototype.accountNo = "";
    EvfContractCancelled.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractCancelled.prototype.failedReason = "";
    EvfContractCancelled.prototype.createdAt = null;
    EvfContractCancelled.create = function create(properties) {
      return new EvfContractCancelled(properties);
    };
    EvfContractCancelled.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(32).int64(message.loanAmount);
      if (message.failedReason != null && Object.hasOwnProperty.call(message, "failedReason"))
        writer.uint32(42).string(message.failedReason);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    EvfContractCancelled.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfContractCancelled.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfContractCancelled();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.loanAmount = reader.int64();
            break;
          case 5:
            message.failedReason = reader.string();
            break;
          case 6:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfContractCancelled.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfContractCancelled.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.failedReason != null && message.hasOwnProperty("failedReason")) {
        if (!$util.isString(message.failedReason))
          return "failedReason: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfContractCancelled.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfContractCancelled)
        return object;
      let message = new $root.dnse.EvfContractCancelled();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.failedReason != null)
        message.failedReason = String(object.failedReason);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfContractCancelled.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfContractCancelled.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.failedReason = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.failedReason != null && message.hasOwnProperty("failedReason"))
        object.failedReason = message.failedReason;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfContractCancelled.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfContractCancelled;
  }();
  dnse2.EvfContractRefused = function() {
    function EvfContractRefused(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfContractRefused.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractRefused.prototype.investorId = "";
    EvfContractRefused.prototype.accountNo = "";
    EvfContractRefused.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractRefused.prototype.failedReason = "";
    EvfContractRefused.prototype.resetDate = null;
    EvfContractRefused.prototype.createdAt = null;
    EvfContractRefused.create = function create(properties) {
      return new EvfContractRefused(properties);
    };
    EvfContractRefused.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(32).int64(message.loanAmount);
      if (message.failedReason != null && Object.hasOwnProperty.call(message, "failedReason"))
        writer.uint32(42).string(message.failedReason);
      if (message.resetDate != null && Object.hasOwnProperty.call(message, "resetDate"))
        $root.google.protobuf.Timestamp.encode(message.resetDate, writer.uint32(50).fork()).ldelim();
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EvfContractRefused.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfContractRefused.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfContractRefused();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.loanAmount = reader.int64();
            break;
          case 5:
            message.failedReason = reader.string();
            break;
          case 6:
            message.resetDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfContractRefused.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfContractRefused.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.failedReason != null && message.hasOwnProperty("failedReason")) {
        if (!$util.isString(message.failedReason))
          return "failedReason: string expected";
      }
      if (message.resetDate != null && message.hasOwnProperty("resetDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.resetDate);
        if (error)
          return "resetDate." + error;
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfContractRefused.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfContractRefused)
        return object;
      let message = new $root.dnse.EvfContractRefused();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.failedReason != null)
        message.failedReason = String(object.failedReason);
      if (object.resetDate != null) {
        if (typeof object.resetDate !== "object")
          throw TypeError(".dnse.EvfContractRefused.resetDate: object expected");
        message.resetDate = $root.google.protobuf.Timestamp.fromObject(object.resetDate);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfContractRefused.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfContractRefused.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.failedReason = "";
        object.resetDate = null;
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.failedReason != null && message.hasOwnProperty("failedReason"))
        object.failedReason = message.failedReason;
      if (message.resetDate != null && message.hasOwnProperty("resetDate"))
        object.resetDate = $root.google.protobuf.Timestamp.toObject(message.resetDate, options);
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfContractRefused.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfContractRefused;
  }();
  dnse2.EvfContractActivated = function() {
    function EvfContractActivated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfContractActivated.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractActivated.prototype.investorId = "";
    EvfContractActivated.prototype.accountNo = "";
    EvfContractActivated.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractActivated.prototype.createdAt = null;
    EvfContractActivated.create = function create(properties) {
      return new EvfContractActivated(properties);
    };
    EvfContractActivated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(32).int64(message.loanAmount);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(42).fork()).ldelim();
      return writer;
    };
    EvfContractActivated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfContractActivated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfContractActivated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.loanAmount = reader.int64();
            break;
          case 5:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfContractActivated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfContractActivated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfContractActivated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfContractActivated)
        return object;
      let message = new $root.dnse.EvfContractActivated();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfContractActivated.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfContractActivated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfContractActivated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfContractActivated;
  }();
  dnse2.EvfAckOfDebtCreated = function() {
    function EvfAckOfDebtCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtCreated.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtCreated.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtCreated.prototype.investorId = "";
    EvfAckOfDebtCreated.prototype.accountNo = "";
    EvfAckOfDebtCreated.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtCreated.prototype.bankNumber = "";
    EvfAckOfDebtCreated.prototype.createdAt = null;
    EvfAckOfDebtCreated.create = function create(properties) {
      return new EvfAckOfDebtCreated(properties);
    };
    EvfAckOfDebtCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(40).int64(message.loanAmount);
      if (message.bankNumber != null && Object.hasOwnProperty.call(message, "bankNumber"))
        writer.uint32(50).string(message.bankNumber);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.loanAmount = reader.int64();
            break;
          case 6:
            message.bankNumber = reader.string();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.bankNumber != null && message.hasOwnProperty("bankNumber")) {
        if (!$util.isString(message.bankNumber))
          return "bankNumber: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtCreated)
        return object;
      let message = new $root.dnse.EvfAckOfDebtCreated();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.bankNumber != null)
        message.bankNumber = String(object.bankNumber);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtCreated.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.bankNumber = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.bankNumber != null && message.hasOwnProperty("bankNumber"))
        object.bankNumber = message.bankNumber;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtCreated;
  }();
  dnse2.EvfAckOfDebtCancelled = function() {
    function EvfAckOfDebtCancelled(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtCancelled.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtCancelled.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtCancelled.prototype.investorId = "";
    EvfAckOfDebtCancelled.prototype.accountNo = "";
    EvfAckOfDebtCancelled.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtCancelled.prototype.failedReason = "";
    EvfAckOfDebtCancelled.prototype.createdAt = null;
    EvfAckOfDebtCancelled.create = function create(properties) {
      return new EvfAckOfDebtCancelled(properties);
    };
    EvfAckOfDebtCancelled.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(40).int64(message.loanAmount);
      if (message.failedReason != null && Object.hasOwnProperty.call(message, "failedReason"))
        writer.uint32(50).string(message.failedReason);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtCancelled.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtCancelled.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtCancelled();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.loanAmount = reader.int64();
            break;
          case 6:
            message.failedReason = reader.string();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtCancelled.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtCancelled.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.failedReason != null && message.hasOwnProperty("failedReason")) {
        if (!$util.isString(message.failedReason))
          return "failedReason: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtCancelled.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtCancelled)
        return object;
      let message = new $root.dnse.EvfAckOfDebtCancelled();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.failedReason != null)
        message.failedReason = String(object.failedReason);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtCancelled.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtCancelled.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.failedReason = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.failedReason != null && message.hasOwnProperty("failedReason"))
        object.failedReason = message.failedReason;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtCancelled.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtCancelled;
  }();
  dnse2.EvfAckOfDebtRefused = function() {
    function EvfAckOfDebtRefused(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtRefused.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtRefused.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtRefused.prototype.investorId = "";
    EvfAckOfDebtRefused.prototype.accountNo = "";
    EvfAckOfDebtRefused.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtRefused.prototype.failedReason = "";
    EvfAckOfDebtRefused.prototype.resetDate = null;
    EvfAckOfDebtRefused.prototype.createdAt = null;
    EvfAckOfDebtRefused.create = function create(properties) {
      return new EvfAckOfDebtRefused(properties);
    };
    EvfAckOfDebtRefused.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(40).int64(message.loanAmount);
      if (message.failedReason != null && Object.hasOwnProperty.call(message, "failedReason"))
        writer.uint32(50).string(message.failedReason);
      if (message.resetDate != null && Object.hasOwnProperty.call(message, "resetDate"))
        $root.google.protobuf.Timestamp.encode(message.resetDate, writer.uint32(58).fork()).ldelim();
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtRefused.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtRefused.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtRefused();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.loanAmount = reader.int64();
            break;
          case 6:
            message.failedReason = reader.string();
            break;
          case 7:
            message.resetDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtRefused.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtRefused.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.failedReason != null && message.hasOwnProperty("failedReason")) {
        if (!$util.isString(message.failedReason))
          return "failedReason: string expected";
      }
      if (message.resetDate != null && message.hasOwnProperty("resetDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.resetDate);
        if (error)
          return "resetDate." + error;
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtRefused.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtRefused)
        return object;
      let message = new $root.dnse.EvfAckOfDebtRefused();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.failedReason != null)
        message.failedReason = String(object.failedReason);
      if (object.resetDate != null) {
        if (typeof object.resetDate !== "object")
          throw TypeError(".dnse.EvfAckOfDebtRefused.resetDate: object expected");
        message.resetDate = $root.google.protobuf.Timestamp.fromObject(object.resetDate);
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtRefused.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtRefused.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.failedReason = "";
        object.resetDate = null;
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.failedReason != null && message.hasOwnProperty("failedReason"))
        object.failedReason = message.failedReason;
      if (message.resetDate != null && message.hasOwnProperty("resetDate"))
        object.resetDate = $root.google.protobuf.Timestamp.toObject(message.resetDate, options);
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtRefused.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtRefused;
  }();
  dnse2.EvfAckOfDebtActivatedInEvf = function() {
    function EvfAckOfDebtActivatedInEvf(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtActivatedInEvf.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInEvf.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInEvf.prototype.investorId = "";
    EvfAckOfDebtActivatedInEvf.prototype.accountNo = "";
    EvfAckOfDebtActivatedInEvf.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInEvf.prototype.bankNumber = "";
    EvfAckOfDebtActivatedInEvf.prototype.createdAt = null;
    EvfAckOfDebtActivatedInEvf.create = function create(properties) {
      return new EvfAckOfDebtActivatedInEvf(properties);
    };
    EvfAckOfDebtActivatedInEvf.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(40).int64(message.loanAmount);
      if (message.bankNumber != null && Object.hasOwnProperty.call(message, "bankNumber"))
        writer.uint32(50).string(message.bankNumber);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtActivatedInEvf.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtActivatedInEvf.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtActivatedInEvf();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.loanAmount = reader.int64();
            break;
          case 6:
            message.bankNumber = reader.string();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtActivatedInEvf.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtActivatedInEvf.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.bankNumber != null && message.hasOwnProperty("bankNumber")) {
        if (!$util.isString(message.bankNumber))
          return "bankNumber: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtActivatedInEvf.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtActivatedInEvf)
        return object;
      let message = new $root.dnse.EvfAckOfDebtActivatedInEvf();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.bankNumber != null)
        message.bankNumber = String(object.bankNumber);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtActivatedInEvf.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtActivatedInEvf.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.bankNumber = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.bankNumber != null && message.hasOwnProperty("bankNumber"))
        object.bankNumber = message.bankNumber;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtActivatedInEvf.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtActivatedInEvf;
  }();
  dnse2.EvfAckOfDebtActivatedInDnse = function() {
    function EvfAckOfDebtActivatedInDnse(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtActivatedInDnse.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInDnse.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInDnse.prototype.investorId = "";
    EvfAckOfDebtActivatedInDnse.prototype.accountNo = "";
    EvfAckOfDebtActivatedInDnse.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInDnse.prototype.createdAt = null;
    EvfAckOfDebtActivatedInDnse.create = function create(properties) {
      return new EvfAckOfDebtActivatedInDnse(properties);
    };
    EvfAckOfDebtActivatedInDnse.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(40).int64(message.loanAmount);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtActivatedInDnse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtActivatedInDnse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtActivatedInDnse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.loanAmount = reader.int64();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtActivatedInDnse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtActivatedInDnse.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtActivatedInDnse.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtActivatedInDnse)
        return object;
      let message = new $root.dnse.EvfAckOfDebtActivatedInDnse();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtActivatedInDnse.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtActivatedInDnse.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtActivatedInDnse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtActivatedInDnse;
  }();
  dnse2.EvfAckOfDebtActivatedInDnseFailed = function() {
    function EvfAckOfDebtActivatedInDnseFailed(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtActivatedInDnseFailed.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInDnseFailed.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInDnseFailed.prototype.investorId = "";
    EvfAckOfDebtActivatedInDnseFailed.prototype.accountNo = "";
    EvfAckOfDebtActivatedInDnseFailed.prototype.loanAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtActivatedInDnseFailed.prototype.failedReason = "";
    EvfAckOfDebtActivatedInDnseFailed.prototype.bankNumber = "";
    EvfAckOfDebtActivatedInDnseFailed.prototype.createdAt = null;
    EvfAckOfDebtActivatedInDnseFailed.create = function create(properties) {
      return new EvfAckOfDebtActivatedInDnseFailed(properties);
    };
    EvfAckOfDebtActivatedInDnseFailed.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.loanAmount != null && Object.hasOwnProperty.call(message, "loanAmount"))
        writer.uint32(40).int64(message.loanAmount);
      if (message.failedReason != null && Object.hasOwnProperty.call(message, "failedReason"))
        writer.uint32(50).string(message.failedReason);
      if (message.bankNumber != null && Object.hasOwnProperty.call(message, "bankNumber"))
        writer.uint32(58).string(message.bankNumber);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(66).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtActivatedInDnseFailed.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtActivatedInDnseFailed.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtActivatedInDnseFailed();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.loanAmount = reader.int64();
            break;
          case 6:
            message.failedReason = reader.string();
            break;
          case 7:
            message.bankNumber = reader.string();
            break;
          case 8:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtActivatedInDnseFailed.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtActivatedInDnseFailed.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount")) {
        if (!$util.isInteger(message.loanAmount) && !(message.loanAmount && $util.isInteger(message.loanAmount.low) && $util.isInteger(message.loanAmount.high)))
          return "loanAmount: integer|Long expected";
      }
      if (message.failedReason != null && message.hasOwnProperty("failedReason")) {
        if (!$util.isString(message.failedReason))
          return "failedReason: string expected";
      }
      if (message.bankNumber != null && message.hasOwnProperty("bankNumber")) {
        if (!$util.isString(message.bankNumber))
          return "bankNumber: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtActivatedInDnseFailed.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtActivatedInDnseFailed)
        return object;
      let message = new $root.dnse.EvfAckOfDebtActivatedInDnseFailed();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.loanAmount != null) {
        if ($util.Long)
          (message.loanAmount = $util.Long.fromValue(object.loanAmount)).unsigned = false;
        else if (typeof object.loanAmount === "string")
          message.loanAmount = parseInt(object.loanAmount, 10);
        else if (typeof object.loanAmount === "number")
          message.loanAmount = object.loanAmount;
        else if (typeof object.loanAmount === "object")
          message.loanAmount = new $util.LongBits(object.loanAmount.low >>> 0, object.loanAmount.high >>> 0).toNumber();
      }
      if (object.failedReason != null)
        message.failedReason = String(object.failedReason);
      if (object.bankNumber != null)
        message.bankNumber = String(object.bankNumber);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtActivatedInDnseFailed.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtActivatedInDnseFailed.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.loanAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.loanAmount = options.longs === String ? "0" : 0;
        object.failedReason = "";
        object.bankNumber = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.loanAmount != null && message.hasOwnProperty("loanAmount"))
        if (typeof message.loanAmount === "number")
          object.loanAmount = options.longs === String ? String(message.loanAmount) : message.loanAmount;
        else
          object.loanAmount = options.longs === String ? $util.Long.prototype.toString.call(message.loanAmount) : options.longs === Number ? new $util.LongBits(message.loanAmount.low >>> 0, message.loanAmount.high >>> 0).toNumber() : message.loanAmount;
      if (message.failedReason != null && message.hasOwnProperty("failedReason"))
        object.failedReason = message.failedReason;
      if (message.bankNumber != null && message.hasOwnProperty("bankNumber"))
        object.bankNumber = message.bankNumber;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtActivatedInDnseFailed.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtActivatedInDnseFailed;
  }();
  dnse2.EvfContractsStatusChanged = function() {
    function EvfContractsStatusChanged(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfContractsStatusChanged.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfContractsStatusChanged.prototype.investorId = "";
    EvfContractsStatusChanged.prototype.accountNo = "";
    EvfContractsStatusChanged.prototype.preStatus = "";
    EvfContractsStatusChanged.prototype.afterStatus = "";
    EvfContractsStatusChanged.prototype.createdAt = null;
    EvfContractsStatusChanged.create = function create(properties) {
      return new EvfContractsStatusChanged(properties);
    };
    EvfContractsStatusChanged.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.preStatus != null && Object.hasOwnProperty.call(message, "preStatus"))
        writer.uint32(34).string(message.preStatus);
      if (message.afterStatus != null && Object.hasOwnProperty.call(message, "afterStatus"))
        writer.uint32(42).string(message.afterStatus);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
      return writer;
    };
    EvfContractsStatusChanged.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfContractsStatusChanged.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfContractsStatusChanged();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.preStatus = reader.string();
            break;
          case 5:
            message.afterStatus = reader.string();
            break;
          case 6:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfContractsStatusChanged.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfContractsStatusChanged.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.preStatus != null && message.hasOwnProperty("preStatus")) {
        if (!$util.isString(message.preStatus))
          return "preStatus: string expected";
      }
      if (message.afterStatus != null && message.hasOwnProperty("afterStatus")) {
        if (!$util.isString(message.afterStatus))
          return "afterStatus: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfContractsStatusChanged.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfContractsStatusChanged)
        return object;
      let message = new $root.dnse.EvfContractsStatusChanged();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.preStatus != null)
        message.preStatus = String(object.preStatus);
      if (object.afterStatus != null)
        message.afterStatus = String(object.afterStatus);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfContractsStatusChanged.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfContractsStatusChanged.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        object.preStatus = "";
        object.afterStatus = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.preStatus != null && message.hasOwnProperty("preStatus"))
        object.preStatus = message.preStatus;
      if (message.afterStatus != null && message.hasOwnProperty("afterStatus"))
        object.afterStatus = message.afterStatus;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfContractsStatusChanged.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfContractsStatusChanged;
  }();
  dnse2.EvfAckOfDebtStatusChanged = function() {
    function EvfAckOfDebtStatusChanged(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    EvfAckOfDebtStatusChanged.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtStatusChanged.prototype.evfContractId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    EvfAckOfDebtStatusChanged.prototype.investorId = "";
    EvfAckOfDebtStatusChanged.prototype.accountNo = "";
    EvfAckOfDebtStatusChanged.prototype.preStatus = "";
    EvfAckOfDebtStatusChanged.prototype.afterStatus = "";
    EvfAckOfDebtStatusChanged.prototype.createdAt = null;
    EvfAckOfDebtStatusChanged.create = function create(properties) {
      return new EvfAckOfDebtStatusChanged(properties);
    };
    EvfAckOfDebtStatusChanged.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).int64(message.id);
      if (message.evfContractId != null && Object.hasOwnProperty.call(message, "evfContractId"))
        writer.uint32(16).int64(message.evfContractId);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(26).string(message.investorId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(34).string(message.accountNo);
      if (message.preStatus != null && Object.hasOwnProperty.call(message, "preStatus"))
        writer.uint32(42).string(message.preStatus);
      if (message.afterStatus != null && Object.hasOwnProperty.call(message, "afterStatus"))
        writer.uint32(50).string(message.afterStatus);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
      return writer;
    };
    EvfAckOfDebtStatusChanged.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    EvfAckOfDebtStatusChanged.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.EvfAckOfDebtStatusChanged();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.int64();
            break;
          case 2:
            message.evfContractId = reader.int64();
            break;
          case 3:
            message.investorId = reader.string();
            break;
          case 4:
            message.accountNo = reader.string();
            break;
          case 5:
            message.preStatus = reader.string();
            break;
          case 6:
            message.afterStatus = reader.string();
            break;
          case 7:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    EvfAckOfDebtStatusChanged.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    EvfAckOfDebtStatusChanged.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
          return "id: integer|Long expected";
      }
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId")) {
        if (!$util.isInteger(message.evfContractId) && !(message.evfContractId && $util.isInteger(message.evfContractId.low) && $util.isInteger(message.evfContractId.high)))
          return "evfContractId: integer|Long expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.preStatus != null && message.hasOwnProperty("preStatus")) {
        if (!$util.isString(message.preStatus))
          return "preStatus: string expected";
      }
      if (message.afterStatus != null && message.hasOwnProperty("afterStatus")) {
        if (!$util.isString(message.afterStatus))
          return "afterStatus: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    EvfAckOfDebtStatusChanged.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.EvfAckOfDebtStatusChanged)
        return object;
      let message = new $root.dnse.EvfAckOfDebtStatusChanged();
      if (object.id != null) {
        if ($util.Long)
          (message.id = $util.Long.fromValue(object.id)).unsigned = false;
        else if (typeof object.id === "string")
          message.id = parseInt(object.id, 10);
        else if (typeof object.id === "number")
          message.id = object.id;
        else if (typeof object.id === "object")
          message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
      }
      if (object.evfContractId != null) {
        if ($util.Long)
          (message.evfContractId = $util.Long.fromValue(object.evfContractId)).unsigned = false;
        else if (typeof object.evfContractId === "string")
          message.evfContractId = parseInt(object.evfContractId, 10);
        else if (typeof object.evfContractId === "number")
          message.evfContractId = object.evfContractId;
        else if (typeof object.evfContractId === "object")
          message.evfContractId = new $util.LongBits(object.evfContractId.low >>> 0, object.evfContractId.high >>> 0).toNumber();
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.preStatus != null)
        message.preStatus = String(object.preStatus);
      if (object.afterStatus != null)
        message.afterStatus = String(object.afterStatus);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.EvfAckOfDebtStatusChanged.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    EvfAckOfDebtStatusChanged.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.id = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.evfContractId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.evfContractId = options.longs === String ? "0" : 0;
        object.investorId = "";
        object.accountNo = "";
        object.preStatus = "";
        object.afterStatus = "";
        object.createdAt = null;
      }
      if (message.id != null && message.hasOwnProperty("id"))
        if (typeof message.id === "number")
          object.id = options.longs === String ? String(message.id) : message.id;
        else
          object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
      if (message.evfContractId != null && message.hasOwnProperty("evfContractId"))
        if (typeof message.evfContractId === "number")
          object.evfContractId = options.longs === String ? String(message.evfContractId) : message.evfContractId;
        else
          object.evfContractId = options.longs === String ? $util.Long.prototype.toString.call(message.evfContractId) : options.longs === Number ? new $util.LongBits(message.evfContractId.low >>> 0, message.evfContractId.high >>> 0).toNumber() : message.evfContractId;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.preStatus != null && message.hasOwnProperty("preStatus"))
        object.preStatus = message.preStatus;
      if (message.afterStatus != null && message.hasOwnProperty("afterStatus"))
        object.afterStatus = message.afterStatus;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    EvfAckOfDebtStatusChanged.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return EvfAckOfDebtStatusChanged;
  }();
  dnse2.conditional_order = function() {
    const conditional_order = {};
    conditional_order.v1 = function() {
      const v1 = {};
      v1.OrderStatus = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ORDER_STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "ORDER_STATUS_NEW"] = 1;
        values[valuesById[2] = "ORDER_STATUS_ACTIVATED"] = 2;
        values[valuesById[3] = "ORDER_STATUS_REJECTED"] = 3;
        values[valuesById[4] = "ORDER_STATUS_CANCELLED"] = 4;
        values[valuesById[5] = "ORDER_STATUS_EXPIRED"] = 5;
        values[valuesById[6] = "ORDER_STATUS_FAILED"] = 6;
        values[valuesById[7] = "ORDER_STATUS_FILLED"] = 7;
        values[valuesById[8] = "ORDER_STATUS_PARTIALLY_FILLED"] = 8;
        values[valuesById[9] = "ORDER_STATUS_CANCELLED_AFTER_TRIGGER"] = 9;
        values[valuesById[10] = "ORDER_STATUS_CANCELLED_BY_RIGHTS_EVENT"] = 10;
        return values;
      }();
      v1.Side = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SIDE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "SIDE_BUY"] = 1;
        values[valuesById[2] = "SIDE_SELL"] = 2;
        return values;
      }();
      v1.OrderType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ORDER_TYPE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "ORDER_TYPE_LIMIT"] = 1;
        values[valuesById[2] = "ORDER_TYPE_MP"] = 2;
        values[valuesById[3] = "ORDER_TYPE_MTL"] = 3;
        return values;
      }();
      v1.TargetOrder = function() {
        function TargetOrder(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        TargetOrder.prototype.side = 0;
        TargetOrder.prototype.price = 0;
        TargetOrder.prototype.quantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        TargetOrder.prototype.orderType = 0;
        TargetOrder.prototype.loanPackageId = 0;
        TargetOrder.create = function create(properties) {
          return new TargetOrder(properties);
        };
        TargetOrder.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(8).int32(message.side);
          if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(17).double(message.price);
          if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(24).int64(message.quantity);
          if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
            writer.uint32(32).int32(message.orderType);
          if (message.loanPackageId != null && Object.hasOwnProperty.call(message, "loanPackageId"))
            writer.uint32(40).int32(message.loanPackageId);
          return writer;
        };
        TargetOrder.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        TargetOrder.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.conditional_order.v1.TargetOrder();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.side = reader.int32();
                break;
              case 2:
                message.price = reader.double();
                break;
              case 3:
                message.quantity = reader.int64();
                break;
              case 4:
                message.orderType = reader.int32();
                break;
              case 5:
                message.loanPackageId = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        TargetOrder.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        TargetOrder.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.side != null && message.hasOwnProperty("side"))
            switch (message.side) {
              default:
                return "side: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.price != null && message.hasOwnProperty("price")) {
            if (typeof message.price !== "number")
              return "price: number expected";
          }
          if (message.quantity != null && message.hasOwnProperty("quantity")) {
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
              return "quantity: integer|Long expected";
          }
          if (message.orderType != null && message.hasOwnProperty("orderType"))
            switch (message.orderType) {
              default:
                return "orderType: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId")) {
            if (!$util.isInteger(message.loanPackageId))
              return "loanPackageId: integer expected";
          }
          return null;
        };
        TargetOrder.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.conditional_order.v1.TargetOrder)
            return object;
          let message = new $root.dnse.conditional_order.v1.TargetOrder();
          switch (object.side) {
            case "SIDE_UNSPECIFIED":
            case 0:
              message.side = 0;
              break;
            case "SIDE_BUY":
            case 1:
              message.side = 1;
              break;
            case "SIDE_SELL":
            case 2:
              message.side = 2;
              break;
          }
          if (object.price != null)
            message.price = Number(object.price);
          if (object.quantity != null) {
            if ($util.Long)
              (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
              message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
              message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
              message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
          }
          switch (object.orderType) {
            case "ORDER_TYPE_UNSPECIFIED":
            case 0:
              message.orderType = 0;
              break;
            case "ORDER_TYPE_LIMIT":
            case 1:
              message.orderType = 1;
              break;
            case "ORDER_TYPE_MP":
            case 2:
              message.orderType = 2;
              break;
            case "ORDER_TYPE_MTL":
            case 3:
              message.orderType = 3;
              break;
          }
          if (object.loanPackageId != null)
            message.loanPackageId = object.loanPackageId | 0;
          return message;
        };
        TargetOrder.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.side = options.enums === String ? "SIDE_UNSPECIFIED" : 0;
            object.price = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.quantity = options.longs === String ? "0" : 0;
            object.orderType = options.enums === String ? "ORDER_TYPE_UNSPECIFIED" : 0;
            object.loanPackageId = 0;
          }
          if (message.side != null && message.hasOwnProperty("side"))
            object.side = options.enums === String ? $root.dnse.conditional_order.v1.Side[message.side] : message.side;
          if (message.price != null && message.hasOwnProperty("price"))
            object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
          if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
              object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
              object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
          if (message.orderType != null && message.hasOwnProperty("orderType"))
            object.orderType = options.enums === String ? $root.dnse.conditional_order.v1.OrderType[message.orderType] : message.orderType;
          if (message.loanPackageId != null && message.hasOwnProperty("loanPackageId"))
            object.loanPackageId = message.loanPackageId;
          return object;
        };
        TargetOrder.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return TargetOrder;
      }();
      v1.TifKind = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TIF_KIND_UNSPECIFIED"] = 0;
        values[valuesById[1] = "TIF_KIND_DAY"] = 1;
        values[valuesById[2] = "TIF_KIND_GTC"] = 2;
        values[valuesById[3] = "TIF_KIND_GTD"] = 3;
        return values;
      }();
      v1.TimeInForce = function() {
        function TimeInForce(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        TimeInForce.prototype.kind = 0;
        TimeInForce.prototype.expireTime = null;
        TimeInForce.create = function create(properties) {
          return new TimeInForce(properties);
        };
        TimeInForce.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
            writer.uint32(8).int32(message.kind);
          if (message.expireTime != null && Object.hasOwnProperty.call(message, "expireTime"))
            $root.google.protobuf.Timestamp.encode(message.expireTime, writer.uint32(18).fork()).ldelim();
          return writer;
        };
        TimeInForce.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        TimeInForce.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.conditional_order.v1.TimeInForce();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.kind = reader.int32();
                break;
              case 2:
                message.expireTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        TimeInForce.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        TimeInForce.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.kind != null && message.hasOwnProperty("kind"))
            switch (message.kind) {
              default:
                return "kind: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.expireTime != null && message.hasOwnProperty("expireTime")) {
            let error = $root.google.protobuf.Timestamp.verify(message.expireTime);
            if (error)
              return "expireTime." + error;
          }
          return null;
        };
        TimeInForce.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.conditional_order.v1.TimeInForce)
            return object;
          let message = new $root.dnse.conditional_order.v1.TimeInForce();
          switch (object.kind) {
            case "TIF_KIND_UNSPECIFIED":
            case 0:
              message.kind = 0;
              break;
            case "TIF_KIND_DAY":
            case 1:
              message.kind = 1;
              break;
            case "TIF_KIND_GTC":
            case 2:
              message.kind = 2;
              break;
            case "TIF_KIND_GTD":
            case 3:
              message.kind = 3;
              break;
          }
          if (object.expireTime != null) {
            if (typeof object.expireTime !== "object")
              throw TypeError(".dnse.conditional_order.v1.TimeInForce.expireTime: object expected");
            message.expireTime = $root.google.protobuf.Timestamp.fromObject(object.expireTime);
          }
          return message;
        };
        TimeInForce.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.kind = options.enums === String ? "TIF_KIND_UNSPECIFIED" : 0;
            object.expireTime = null;
          }
          if (message.kind != null && message.hasOwnProperty("kind"))
            object.kind = options.enums === String ? $root.dnse.conditional_order.v1.TifKind[message.kind] : message.kind;
          if (message.expireTime != null && message.hasOwnProperty("expireTime"))
            object.expireTime = $root.google.protobuf.Timestamp.toObject(message.expireTime, options);
          return object;
        };
        TimeInForce.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return TimeInForce;
      }();
      v1.Category = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CATEGORY_UNSPECIFIED"] = 0;
        values[valuesById[1] = "CATEGORY_STOP"] = 1;
        values[valuesById[2] = "CATEGORY_TRAILING_STOP"] = 2;
        values[valuesById[3] = "CATEGORY_TRADING_EVENT"] = 3;
        return values;
      }();
      v1.MarketId = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MARKET_ID_UNSPECIFIED"] = 0;
        values[valuesById[1] = "MARKET_ID_UNDERLYING"] = 1;
        values[valuesById[2] = "MARKET_ID_DERIVATIVES"] = 2;
        return values;
      }();
      v1.Props = function() {
        function Props(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Props.prototype.stopPrice = 0;
        Props.prototype.trailingPercent = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Props.prototype.trailingAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Props.prototype.marketId = 0;
        Props.prototype.type = "";
        Props.create = function create(properties) {
          return new Props(properties);
        };
        Props.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.stopPrice != null && Object.hasOwnProperty.call(message, "stopPrice"))
            writer.uint32(9).double(message.stopPrice);
          if (message.trailingPercent != null && Object.hasOwnProperty.call(message, "trailingPercent"))
            writer.uint32(16).int64(message.trailingPercent);
          if (message.trailingAmount != null && Object.hasOwnProperty.call(message, "trailingAmount"))
            writer.uint32(24).int64(message.trailingAmount);
          if (message.marketId != null && Object.hasOwnProperty.call(message, "marketId"))
            writer.uint32(32).int32(message.marketId);
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(42).string(message.type);
          return writer;
        };
        Props.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Props.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.conditional_order.v1.Props();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.stopPrice = reader.double();
                break;
              case 2:
                message.trailingPercent = reader.int64();
                break;
              case 3:
                message.trailingAmount = reader.int64();
                break;
              case 4:
                message.marketId = reader.int32();
                break;
              case 5:
                message.type = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Props.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Props.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.stopPrice != null && message.hasOwnProperty("stopPrice")) {
            if (typeof message.stopPrice !== "number")
              return "stopPrice: number expected";
          }
          if (message.trailingPercent != null && message.hasOwnProperty("trailingPercent")) {
            if (!$util.isInteger(message.trailingPercent) && !(message.trailingPercent && $util.isInteger(message.trailingPercent.low) && $util.isInteger(message.trailingPercent.high)))
              return "trailingPercent: integer|Long expected";
          }
          if (message.trailingAmount != null && message.hasOwnProperty("trailingAmount")) {
            if (!$util.isInteger(message.trailingAmount) && !(message.trailingAmount && $util.isInteger(message.trailingAmount.low) && $util.isInteger(message.trailingAmount.high)))
              return "trailingAmount: integer|Long expected";
          }
          if (message.marketId != null && message.hasOwnProperty("marketId"))
            switch (message.marketId) {
              default:
                return "marketId: enum value expected";
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.type != null && message.hasOwnProperty("type")) {
            if (!$util.isString(message.type))
              return "type: string expected";
          }
          return null;
        };
        Props.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.conditional_order.v1.Props)
            return object;
          let message = new $root.dnse.conditional_order.v1.Props();
          if (object.stopPrice != null)
            message.stopPrice = Number(object.stopPrice);
          if (object.trailingPercent != null) {
            if ($util.Long)
              (message.trailingPercent = $util.Long.fromValue(object.trailingPercent)).unsigned = false;
            else if (typeof object.trailingPercent === "string")
              message.trailingPercent = parseInt(object.trailingPercent, 10);
            else if (typeof object.trailingPercent === "number")
              message.trailingPercent = object.trailingPercent;
            else if (typeof object.trailingPercent === "object")
              message.trailingPercent = new $util.LongBits(object.trailingPercent.low >>> 0, object.trailingPercent.high >>> 0).toNumber();
          }
          if (object.trailingAmount != null) {
            if ($util.Long)
              (message.trailingAmount = $util.Long.fromValue(object.trailingAmount)).unsigned = false;
            else if (typeof object.trailingAmount === "string")
              message.trailingAmount = parseInt(object.trailingAmount, 10);
            else if (typeof object.trailingAmount === "number")
              message.trailingAmount = object.trailingAmount;
            else if (typeof object.trailingAmount === "object")
              message.trailingAmount = new $util.LongBits(object.trailingAmount.low >>> 0, object.trailingAmount.high >>> 0).toNumber();
          }
          switch (object.marketId) {
            case "MARKET_ID_UNSPECIFIED":
            case 0:
              message.marketId = 0;
              break;
            case "MARKET_ID_UNDERLYING":
            case 1:
              message.marketId = 1;
              break;
            case "MARKET_ID_DERIVATIVES":
            case 2:
              message.marketId = 2;
              break;
          }
          if (object.type != null)
            message.type = String(object.type);
          return message;
        };
        Props.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.stopPrice = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.trailingPercent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.trailingPercent = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.trailingAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.trailingAmount = options.longs === String ? "0" : 0;
            object.marketId = options.enums === String ? "MARKET_ID_UNSPECIFIED" : 0;
            object.type = "";
          }
          if (message.stopPrice != null && message.hasOwnProperty("stopPrice"))
            object.stopPrice = options.json && !isFinite(message.stopPrice) ? String(message.stopPrice) : message.stopPrice;
          if (message.trailingPercent != null && message.hasOwnProperty("trailingPercent"))
            if (typeof message.trailingPercent === "number")
              object.trailingPercent = options.longs === String ? String(message.trailingPercent) : message.trailingPercent;
            else
              object.trailingPercent = options.longs === String ? $util.Long.prototype.toString.call(message.trailingPercent) : options.longs === Number ? new $util.LongBits(message.trailingPercent.low >>> 0, message.trailingPercent.high >>> 0).toNumber() : message.trailingPercent;
          if (message.trailingAmount != null && message.hasOwnProperty("trailingAmount"))
            if (typeof message.trailingAmount === "number")
              object.trailingAmount = options.longs === String ? String(message.trailingAmount) : message.trailingAmount;
            else
              object.trailingAmount = options.longs === String ? $util.Long.prototype.toString.call(message.trailingAmount) : options.longs === Number ? new $util.LongBits(message.trailingAmount.low >>> 0, message.trailingAmount.high >>> 0).toNumber() : message.trailingAmount;
          if (message.marketId != null && message.hasOwnProperty("marketId"))
            object.marketId = options.enums === String ? $root.dnse.conditional_order.v1.MarketId[message.marketId] : message.marketId;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
          return object;
        };
        Props.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return Props;
      }();
      v1.Metadata = function() {
        function Metadata(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Metadata.prototype.externalOrderId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Metadata.prototype.errorMessage = "";
        Metadata.prototype.status = "";
        Metadata.create = function create(properties) {
          return new Metadata(properties);
        };
        Metadata.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.externalOrderId != null && Object.hasOwnProperty.call(message, "externalOrderId"))
            writer.uint32(8).int64(message.externalOrderId);
          if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
            writer.uint32(18).string(message.errorMessage);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(26).string(message.status);
          return writer;
        };
        Metadata.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Metadata.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.conditional_order.v1.Metadata();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.externalOrderId = reader.int64();
                break;
              case 2:
                message.errorMessage = reader.string();
                break;
              case 3:
                message.status = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Metadata.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Metadata.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.externalOrderId != null && message.hasOwnProperty("externalOrderId")) {
            if (!$util.isInteger(message.externalOrderId) && !(message.externalOrderId && $util.isInteger(message.externalOrderId.low) && $util.isInteger(message.externalOrderId.high)))
              return "externalOrderId: integer|Long expected";
          }
          if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
            if (!$util.isString(message.errorMessage))
              return "errorMessage: string expected";
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isString(message.status))
              return "status: string expected";
          }
          return null;
        };
        Metadata.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.conditional_order.v1.Metadata)
            return object;
          let message = new $root.dnse.conditional_order.v1.Metadata();
          if (object.externalOrderId != null) {
            if ($util.Long)
              (message.externalOrderId = $util.Long.fromValue(object.externalOrderId)).unsigned = false;
            else if (typeof object.externalOrderId === "string")
              message.externalOrderId = parseInt(object.externalOrderId, 10);
            else if (typeof object.externalOrderId === "number")
              message.externalOrderId = object.externalOrderId;
            else if (typeof object.externalOrderId === "object")
              message.externalOrderId = new $util.LongBits(object.externalOrderId.low >>> 0, object.externalOrderId.high >>> 0).toNumber();
          }
          if (object.errorMessage != null)
            message.errorMessage = String(object.errorMessage);
          if (object.status != null)
            message.status = String(object.status);
          return message;
        };
        Metadata.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if ($util.Long) {
              let long = new $util.Long(0, 0, false);
              object.externalOrderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.externalOrderId = options.longs === String ? "0" : 0;
            object.errorMessage = "";
            object.status = "";
          }
          if (message.externalOrderId != null && message.hasOwnProperty("externalOrderId"))
            if (typeof message.externalOrderId === "number")
              object.externalOrderId = options.longs === String ? String(message.externalOrderId) : message.externalOrderId;
            else
              object.externalOrderId = options.longs === String ? $util.Long.prototype.toString.call(message.externalOrderId) : options.longs === Number ? new $util.LongBits(message.externalOrderId.low >>> 0, message.externalOrderId.high >>> 0).toNumber() : message.externalOrderId;
          if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
            object.errorMessage = message.errorMessage;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          return object;
        };
        Metadata.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return Metadata;
      }();
      v1.Order = function() {
        function Order(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Order.prototype.id = "";
        Order.prototype.investorId = "";
        Order.prototype.accountNo = "";
        Order.prototype.symbol = "";
        Order.prototype.category = 0;
        Order.prototype.props = null;
        Order.prototype.targetOrder = null;
        Order.prototype.condition = "";
        Order.prototype.timeInForce = null;
        Order.prototype.status = 0;
        Order.prototype.metadata = null;
        Order.prototype.createdAt = null;
        Order.prototype.updatedAt = null;
        Order.prototype.createdBy = "";
        Order.prototype.updatedBy = "";
        Order.create = function create(properties) {
          return new Order(properties);
        };
        Order.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
          if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
            writer.uint32(18).string(message.investorId);
          if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(26).string(message.accountNo);
          if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(34).string(message.symbol);
          if (message.category != null && Object.hasOwnProperty.call(message, "category"))
            writer.uint32(40).int32(message.category);
          if (message.props != null && Object.hasOwnProperty.call(message, "props"))
            $root.dnse.conditional_order.v1.Props.encode(message.props, writer.uint32(50).fork()).ldelim();
          if (message.targetOrder != null && Object.hasOwnProperty.call(message, "targetOrder"))
            $root.dnse.conditional_order.v1.TargetOrder.encode(message.targetOrder, writer.uint32(58).fork()).ldelim();
          if (message.condition != null && Object.hasOwnProperty.call(message, "condition"))
            writer.uint32(66).string(message.condition);
          if (message.timeInForce != null && Object.hasOwnProperty.call(message, "timeInForce"))
            $root.dnse.conditional_order.v1.TimeInForce.encode(message.timeInForce, writer.uint32(74).fork()).ldelim();
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(80).int32(message.status);
          if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
            $root.dnse.conditional_order.v1.Metadata.encode(message.metadata, writer.uint32(90).fork()).ldelim();
          if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(98).fork()).ldelim();
          if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
            $root.google.protobuf.Timestamp.encode(message.updatedAt, writer.uint32(106).fork()).ldelim();
          if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
            writer.uint32(114).string(message.createdBy);
          if (message.updatedBy != null && Object.hasOwnProperty.call(message, "updatedBy"))
            writer.uint32(122).string(message.updatedBy);
          return writer;
        };
        Order.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Order.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.conditional_order.v1.Order();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.string();
                break;
              case 2:
                message.investorId = reader.string();
                break;
              case 3:
                message.accountNo = reader.string();
                break;
              case 4:
                message.symbol = reader.string();
                break;
              case 5:
                message.category = reader.int32();
                break;
              case 6:
                message.props = $root.dnse.conditional_order.v1.Props.decode(reader, reader.uint32());
                break;
              case 7:
                message.targetOrder = $root.dnse.conditional_order.v1.TargetOrder.decode(reader, reader.uint32());
                break;
              case 8:
                message.condition = reader.string();
                break;
              case 9:
                message.timeInForce = $root.dnse.conditional_order.v1.TimeInForce.decode(reader, reader.uint32());
                break;
              case 10:
                message.status = reader.int32();
                break;
              case 11:
                message.metadata = $root.dnse.conditional_order.v1.Metadata.decode(reader, reader.uint32());
                break;
              case 12:
                message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 13:
                message.updatedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
              case 14:
                message.createdBy = reader.string();
                break;
              case 15:
                message.updatedBy = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Order.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Order.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.id != null && message.hasOwnProperty("id")) {
            if (!$util.isString(message.id))
              return "id: string expected";
          }
          if (message.investorId != null && message.hasOwnProperty("investorId")) {
            if (!$util.isString(message.investorId))
              return "investorId: string expected";
          }
          if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
            if (!$util.isString(message.accountNo))
              return "accountNo: string expected";
          }
          if (message.symbol != null && message.hasOwnProperty("symbol")) {
            if (!$util.isString(message.symbol))
              return "symbol: string expected";
          }
          if (message.category != null && message.hasOwnProperty("category"))
            switch (message.category) {
              default:
                return "category: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.props != null && message.hasOwnProperty("props")) {
            let error = $root.dnse.conditional_order.v1.Props.verify(message.props);
            if (error)
              return "props." + error;
          }
          if (message.targetOrder != null && message.hasOwnProperty("targetOrder")) {
            let error = $root.dnse.conditional_order.v1.TargetOrder.verify(message.targetOrder);
            if (error)
              return "targetOrder." + error;
          }
          if (message.condition != null && message.hasOwnProperty("condition")) {
            if (!$util.isString(message.condition))
              return "condition: string expected";
          }
          if (message.timeInForce != null && message.hasOwnProperty("timeInForce")) {
            let error = $root.dnse.conditional_order.v1.TimeInForce.verify(message.timeInForce);
            if (error)
              return "timeInForce." + error;
          }
          if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
              default:
                return "status: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
              case 9:
              case 10:
                break;
            }
          if (message.metadata != null && message.hasOwnProperty("metadata")) {
            let error = $root.dnse.conditional_order.v1.Metadata.verify(message.metadata);
            if (error)
              return "metadata." + error;
          }
          if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
            let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
            if (error)
              return "createdAt." + error;
          }
          if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
            let error = $root.google.protobuf.Timestamp.verify(message.updatedAt);
            if (error)
              return "updatedAt." + error;
          }
          if (message.createdBy != null && message.hasOwnProperty("createdBy")) {
            if (!$util.isString(message.createdBy))
              return "createdBy: string expected";
          }
          if (message.updatedBy != null && message.hasOwnProperty("updatedBy")) {
            if (!$util.isString(message.updatedBy))
              return "updatedBy: string expected";
          }
          return null;
        };
        Order.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.conditional_order.v1.Order)
            return object;
          let message = new $root.dnse.conditional_order.v1.Order();
          if (object.id != null)
            message.id = String(object.id);
          if (object.investorId != null)
            message.investorId = String(object.investorId);
          if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
          if (object.symbol != null)
            message.symbol = String(object.symbol);
          switch (object.category) {
            case "CATEGORY_UNSPECIFIED":
            case 0:
              message.category = 0;
              break;
            case "CATEGORY_STOP":
            case 1:
              message.category = 1;
              break;
            case "CATEGORY_TRAILING_STOP":
            case 2:
              message.category = 2;
              break;
            case "CATEGORY_TRADING_EVENT":
            case 3:
              message.category = 3;
              break;
          }
          if (object.props != null) {
            if (typeof object.props !== "object")
              throw TypeError(".dnse.conditional_order.v1.Order.props: object expected");
            message.props = $root.dnse.conditional_order.v1.Props.fromObject(object.props);
          }
          if (object.targetOrder != null) {
            if (typeof object.targetOrder !== "object")
              throw TypeError(".dnse.conditional_order.v1.Order.targetOrder: object expected");
            message.targetOrder = $root.dnse.conditional_order.v1.TargetOrder.fromObject(object.targetOrder);
          }
          if (object.condition != null)
            message.condition = String(object.condition);
          if (object.timeInForce != null) {
            if (typeof object.timeInForce !== "object")
              throw TypeError(".dnse.conditional_order.v1.Order.timeInForce: object expected");
            message.timeInForce = $root.dnse.conditional_order.v1.TimeInForce.fromObject(object.timeInForce);
          }
          switch (object.status) {
            case "ORDER_STATUS_UNSPECIFIED":
            case 0:
              message.status = 0;
              break;
            case "ORDER_STATUS_NEW":
            case 1:
              message.status = 1;
              break;
            case "ORDER_STATUS_ACTIVATED":
            case 2:
              message.status = 2;
              break;
            case "ORDER_STATUS_REJECTED":
            case 3:
              message.status = 3;
              break;
            case "ORDER_STATUS_CANCELLED":
            case 4:
              message.status = 4;
              break;
            case "ORDER_STATUS_EXPIRED":
            case 5:
              message.status = 5;
              break;
            case "ORDER_STATUS_FAILED":
            case 6:
              message.status = 6;
              break;
            case "ORDER_STATUS_FILLED":
            case 7:
              message.status = 7;
              break;
            case "ORDER_STATUS_PARTIALLY_FILLED":
            case 8:
              message.status = 8;
              break;
            case "ORDER_STATUS_CANCELLED_AFTER_TRIGGER":
            case 9:
              message.status = 9;
              break;
            case "ORDER_STATUS_CANCELLED_BY_RIGHTS_EVENT":
            case 10:
              message.status = 10;
              break;
          }
          if (object.metadata != null) {
            if (typeof object.metadata !== "object")
              throw TypeError(".dnse.conditional_order.v1.Order.metadata: object expected");
            message.metadata = $root.dnse.conditional_order.v1.Metadata.fromObject(object.metadata);
          }
          if (object.createdAt != null) {
            if (typeof object.createdAt !== "object")
              throw TypeError(".dnse.conditional_order.v1.Order.createdAt: object expected");
            message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
          }
          if (object.updatedAt != null) {
            if (typeof object.updatedAt !== "object")
              throw TypeError(".dnse.conditional_order.v1.Order.updatedAt: object expected");
            message.updatedAt = $root.google.protobuf.Timestamp.fromObject(object.updatedAt);
          }
          if (object.createdBy != null)
            message.createdBy = String(object.createdBy);
          if (object.updatedBy != null)
            message.updatedBy = String(object.updatedBy);
          return message;
        };
        Order.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.id = "";
            object.investorId = "";
            object.accountNo = "";
            object.symbol = "";
            object.category = options.enums === String ? "CATEGORY_UNSPECIFIED" : 0;
            object.props = null;
            object.targetOrder = null;
            object.condition = "";
            object.timeInForce = null;
            object.status = options.enums === String ? "ORDER_STATUS_UNSPECIFIED" : 0;
            object.metadata = null;
            object.createdAt = null;
            object.updatedAt = null;
            object.createdBy = "";
            object.updatedBy = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
          if (message.investorId != null && message.hasOwnProperty("investorId"))
            object.investorId = message.investorId;
          if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
          if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
          if (message.category != null && message.hasOwnProperty("category"))
            object.category = options.enums === String ? $root.dnse.conditional_order.v1.Category[message.category] : message.category;
          if (message.props != null && message.hasOwnProperty("props"))
            object.props = $root.dnse.conditional_order.v1.Props.toObject(message.props, options);
          if (message.targetOrder != null && message.hasOwnProperty("targetOrder"))
            object.targetOrder = $root.dnse.conditional_order.v1.TargetOrder.toObject(message.targetOrder, options);
          if (message.condition != null && message.hasOwnProperty("condition"))
            object.condition = message.condition;
          if (message.timeInForce != null && message.hasOwnProperty("timeInForce"))
            object.timeInForce = $root.dnse.conditional_order.v1.TimeInForce.toObject(message.timeInForce, options);
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.dnse.conditional_order.v1.OrderStatus[message.status] : message.status;
          if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = $root.dnse.conditional_order.v1.Metadata.toObject(message.metadata, options);
          if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
          if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
            object.updatedAt = $root.google.protobuf.Timestamp.toObject(message.updatedAt, options);
          if (message.createdBy != null && message.hasOwnProperty("createdBy"))
            object.createdBy = message.createdBy;
          if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
            object.updatedBy = message.updatedBy;
          return object;
        };
        Order.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return Order;
      }();
      v1.WorkerStatusReport = function() {
        function WorkerStatusReport(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        WorkerStatusReport.prototype.identifier = "";
        WorkerStatusReport.prototype.running = false;
        WorkerStatusReport.create = function create(properties) {
          return new WorkerStatusReport(properties);
        };
        WorkerStatusReport.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.identifier != null && Object.hasOwnProperty.call(message, "identifier"))
            writer.uint32(10).string(message.identifier);
          if (message.running != null && Object.hasOwnProperty.call(message, "running"))
            writer.uint32(16).bool(message.running);
          return writer;
        };
        WorkerStatusReport.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        WorkerStatusReport.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.conditional_order.v1.WorkerStatusReport();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.identifier = reader.string();
                break;
              case 2:
                message.running = reader.bool();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        WorkerStatusReport.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        WorkerStatusReport.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.identifier != null && message.hasOwnProperty("identifier")) {
            if (!$util.isString(message.identifier))
              return "identifier: string expected";
          }
          if (message.running != null && message.hasOwnProperty("running")) {
            if (typeof message.running !== "boolean")
              return "running: boolean expected";
          }
          return null;
        };
        WorkerStatusReport.fromObject = function fromObject(object) {
          if (object instanceof $root.dnse.conditional_order.v1.WorkerStatusReport)
            return object;
          let message = new $root.dnse.conditional_order.v1.WorkerStatusReport();
          if (object.identifier != null)
            message.identifier = String(object.identifier);
          if (object.running != null)
            message.running = Boolean(object.running);
          return message;
        };
        WorkerStatusReport.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.identifier = "";
            object.running = false;
          }
          if (message.identifier != null && message.hasOwnProperty("identifier"))
            object.identifier = message.identifier;
          if (message.running != null && message.hasOwnProperty("running"))
            object.running = message.running;
          return object;
        };
        WorkerStatusReport.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return WorkerStatusReport;
      }();
      return v1;
    }();
    return conditional_order;
  }();
  dnse2.WiPackType = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "WI_PACK_UNKOWN"] = 0;
    values[valuesById[1] = "WI_PACK_500K"] = 1;
    values[valuesById[2] = "WI_PACK_2000K"] = 2;
    return values;
  }();
  dnse2.WiPackNotification = function() {
    function WiPackNotification(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    WiPackNotification.prototype.packType = 0;
    WiPackNotification.prototype.investorId = "";
    WiPackNotification.prototype.createdAt = null;
    WiPackNotification.create = function create(properties) {
      return new WiPackNotification(properties);
    };
    WiPackNotification.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.packType != null && Object.hasOwnProperty.call(message, "packType"))
        writer.uint32(8).int32(message.packType);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    WiPackNotification.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    WiPackNotification.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.WiPackNotification();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.packType = reader.int32();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    WiPackNotification.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    WiPackNotification.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.packType != null && message.hasOwnProperty("packType"))
        switch (message.packType) {
          default:
            return "packType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
        if (error)
          return "createdAt." + error;
      }
      return null;
    };
    WiPackNotification.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.WiPackNotification)
        return object;
      let message = new $root.dnse.WiPackNotification();
      switch (object.packType) {
        case "WI_PACK_UNKOWN":
        case 0:
          message.packType = 0;
          break;
        case "WI_PACK_500K":
        case 1:
          message.packType = 1;
          break;
        case "WI_PACK_2000K":
        case 2:
          message.packType = 2;
          break;
      }
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdAt != null) {
        if (typeof object.createdAt !== "object")
          throw TypeError(".dnse.WiPackNotification.createdAt: object expected");
        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
      }
      return message;
    };
    WiPackNotification.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.packType = options.enums === String ? "WI_PACK_UNKOWN" : 0;
        object.investorId = "";
        object.createdAt = null;
      }
      if (message.packType != null && message.hasOwnProperty("packType"))
        object.packType = options.enums === String ? $root.dnse.WiPackType[message.packType] : message.packType;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdAt != null && message.hasOwnProperty("createdAt"))
        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
      return object;
    };
    WiPackNotification.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return WiPackNotification;
  }();
  dnse2.SavingsProduct = function() {
    function SavingsProduct(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsProduct.prototype.id = 0;
    SavingsProduct.prototype.groupName = "";
    SavingsProduct.prototype.code = "";
    SavingsProduct.prototype.name = "";
    SavingsProduct.prototype.periodInDay = 0;
    SavingsProduct.prototype.nominalAnnualInterestRate = 0;
    SavingsProduct.prototype.description = null;
    SavingsProduct.prototype.image = null;
    SavingsProduct.prototype.status = 0;
    SavingsProduct.prototype.createdDate = null;
    SavingsProduct.prototype.updatedDate = null;
    SavingsProduct.prototype.creator = "";
    SavingsProduct.prototype.updater = "";
    SavingsProduct.prototype.previousPeriodProductId = 0;
    SavingsProduct.prototype.minAvailableInvestmentAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsProduct.prototype.periodDesc = "";
    SavingsProduct.prototype.statusDesc = "";
    let $oneOfFields;
    Object.defineProperty(SavingsProduct.prototype, "_description", {
      get: $util.oneOfGetter($oneOfFields = ["description"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    Object.defineProperty(SavingsProduct.prototype, "_image", {
      get: $util.oneOfGetter($oneOfFields = ["image"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    SavingsProduct.create = function create(properties) {
      return new SavingsProduct(properties);
    };
    SavingsProduct.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).uint32(message.id);
      if (message.groupName != null && Object.hasOwnProperty.call(message, "groupName"))
        writer.uint32(18).string(message.groupName);
      if (message.code != null && Object.hasOwnProperty.call(message, "code"))
        writer.uint32(26).string(message.code);
      if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        writer.uint32(34).string(message.name);
      if (message.periodInDay != null && Object.hasOwnProperty.call(message, "periodInDay"))
        writer.uint32(40).uint32(message.periodInDay);
      if (message.nominalAnnualInterestRate != null && Object.hasOwnProperty.call(message, "nominalAnnualInterestRate"))
        writer.uint32(49).double(message.nominalAnnualInterestRate);
      if (message.description != null && Object.hasOwnProperty.call(message, "description"))
        writer.uint32(58).string(message.description);
      if (message.image != null && Object.hasOwnProperty.call(message, "image"))
        writer.uint32(66).string(message.image);
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(72).int32(message.status);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(82).fork()).ldelim();
      if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
        $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(90).fork()).ldelim();
      if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
        writer.uint32(98).string(message.creator);
      if (message.updater != null && Object.hasOwnProperty.call(message, "updater"))
        writer.uint32(106).string(message.updater);
      if (message.previousPeriodProductId != null && Object.hasOwnProperty.call(message, "previousPeriodProductId"))
        writer.uint32(112).uint32(message.previousPeriodProductId);
      if (message.minAvailableInvestmentAmount != null && Object.hasOwnProperty.call(message, "minAvailableInvestmentAmount"))
        writer.uint32(120).uint64(message.minAvailableInvestmentAmount);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(130).string(message.periodDesc);
      if (message.statusDesc != null && Object.hasOwnProperty.call(message, "statusDesc"))
        writer.uint32(138).string(message.statusDesc);
      return writer;
    };
    SavingsProduct.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsProduct.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsProduct();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.uint32();
            break;
          case 2:
            message.groupName = reader.string();
            break;
          case 3:
            message.code = reader.string();
            break;
          case 4:
            message.name = reader.string();
            break;
          case 5:
            message.periodInDay = reader.uint32();
            break;
          case 6:
            message.nominalAnnualInterestRate = reader.double();
            break;
          case 7:
            message.description = reader.string();
            break;
          case 8:
            message.image = reader.string();
            break;
          case 9:
            message.status = reader.int32();
            break;
          case 10:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 11:
            message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.creator = reader.string();
            break;
          case 13:
            message.updater = reader.string();
            break;
          case 14:
            message.previousPeriodProductId = reader.uint32();
            break;
          case 15:
            message.minAvailableInvestmentAmount = reader.uint64();
            break;
          case 16:
            message.periodDesc = reader.string();
            break;
          case 17:
            message.statusDesc = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsProduct.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsProduct.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.groupName != null && message.hasOwnProperty("groupName")) {
        if (!$util.isString(message.groupName))
          return "groupName: string expected";
      }
      if (message.code != null && message.hasOwnProperty("code")) {
        if (!$util.isString(message.code))
          return "code: string expected";
      }
      if (message.name != null && message.hasOwnProperty("name")) {
        if (!$util.isString(message.name))
          return "name: string expected";
      }
      if (message.periodInDay != null && message.hasOwnProperty("periodInDay")) {
        if (!$util.isInteger(message.periodInDay))
          return "periodInDay: integer expected";
      }
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate")) {
        if (typeof message.nominalAnnualInterestRate !== "number")
          return "nominalAnnualInterestRate: number expected";
      }
      if (message.description != null && message.hasOwnProperty("description")) {
        if (!$util.isString(message.description))
          return "description: string expected";
      }
      if (message.image != null && message.hasOwnProperty("image")) {
        if (!$util.isString(message.image))
          return "image: string expected";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
        if (error)
          return "updatedDate." + error;
      }
      if (message.creator != null && message.hasOwnProperty("creator")) {
        if (!$util.isString(message.creator))
          return "creator: string expected";
      }
      if (message.updater != null && message.hasOwnProperty("updater")) {
        if (!$util.isString(message.updater))
          return "updater: string expected";
      }
      if (message.previousPeriodProductId != null && message.hasOwnProperty("previousPeriodProductId")) {
        if (!$util.isInteger(message.previousPeriodProductId))
          return "previousPeriodProductId: integer expected";
      }
      if (message.minAvailableInvestmentAmount != null && message.hasOwnProperty("minAvailableInvestmentAmount")) {
        if (!$util.isInteger(message.minAvailableInvestmentAmount) && !(message.minAvailableInvestmentAmount && $util.isInteger(message.minAvailableInvestmentAmount.low) && $util.isInteger(message.minAvailableInvestmentAmount.high)))
          return "minAvailableInvestmentAmount: integer|Long expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.statusDesc != null && message.hasOwnProperty("statusDesc")) {
        if (!$util.isString(message.statusDesc))
          return "statusDesc: string expected";
      }
      return null;
    };
    SavingsProduct.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsProduct)
        return object;
      let message = new $root.dnse.SavingsProduct();
      if (object.id != null)
        message.id = object.id >>> 0;
      if (object.groupName != null)
        message.groupName = String(object.groupName);
      if (object.code != null)
        message.code = String(object.code);
      if (object.name != null)
        message.name = String(object.name);
      if (object.periodInDay != null)
        message.periodInDay = object.periodInDay >>> 0;
      if (object.nominalAnnualInterestRate != null)
        message.nominalAnnualInterestRate = Number(object.nominalAnnualInterestRate);
      if (object.description != null)
        message.description = String(object.description);
      if (object.image != null)
        message.image = String(object.image);
      switch (object.status) {
        case "UNKNOWN":
        case 0:
          message.status = 0;
          break;
        case "INACTIVE":
        case 1:
          message.status = 1;
          break;
        case "PENDING":
        case 2:
          message.status = 2;
          break;
        case "ACTIVE":
        case 3:
          message.status = 3;
          break;
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsProduct.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.updatedDate != null) {
        if (typeof object.updatedDate !== "object")
          throw TypeError(".dnse.SavingsProduct.updatedDate: object expected");
        message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
      }
      if (object.creator != null)
        message.creator = String(object.creator);
      if (object.updater != null)
        message.updater = String(object.updater);
      if (object.previousPeriodProductId != null)
        message.previousPeriodProductId = object.previousPeriodProductId >>> 0;
      if (object.minAvailableInvestmentAmount != null) {
        if ($util.Long)
          (message.minAvailableInvestmentAmount = $util.Long.fromValue(object.minAvailableInvestmentAmount)).unsigned = true;
        else if (typeof object.minAvailableInvestmentAmount === "string")
          message.minAvailableInvestmentAmount = parseInt(object.minAvailableInvestmentAmount, 10);
        else if (typeof object.minAvailableInvestmentAmount === "number")
          message.minAvailableInvestmentAmount = object.minAvailableInvestmentAmount;
        else if (typeof object.minAvailableInvestmentAmount === "object")
          message.minAvailableInvestmentAmount = new $util.LongBits(object.minAvailableInvestmentAmount.low >>> 0, object.minAvailableInvestmentAmount.high >>> 0).toNumber(true);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.statusDesc != null)
        message.statusDesc = String(object.statusDesc);
      return message;
    };
    SavingsProduct.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.groupName = "";
        object.code = "";
        object.name = "";
        object.periodInDay = 0;
        object.nominalAnnualInterestRate = 0;
        object.status = options.enums === String ? "UNKNOWN" : 0;
        object.createdDate = null;
        object.updatedDate = null;
        object.creator = "";
        object.updater = "";
        object.previousPeriodProductId = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.minAvailableInvestmentAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.minAvailableInvestmentAmount = options.longs === String ? "0" : 0;
        object.periodDesc = "";
        object.statusDesc = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.groupName != null && message.hasOwnProperty("groupName"))
        object.groupName = message.groupName;
      if (message.code != null && message.hasOwnProperty("code"))
        object.code = message.code;
      if (message.name != null && message.hasOwnProperty("name"))
        object.name = message.name;
      if (message.periodInDay != null && message.hasOwnProperty("periodInDay"))
        object.periodInDay = message.periodInDay;
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate"))
        object.nominalAnnualInterestRate = options.json && !isFinite(message.nominalAnnualInterestRate) ? String(message.nominalAnnualInterestRate) : message.nominalAnnualInterestRate;
      if (message.description != null && message.hasOwnProperty("description")) {
        object.description = message.description;
        if (options.oneofs)
          object._description = "description";
      }
      if (message.image != null && message.hasOwnProperty("image")) {
        object.image = message.image;
        if (options.oneofs)
          object._image = "image";
      }
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.SavingsProduct.Status[message.status] : message.status;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
        object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
      if (message.creator != null && message.hasOwnProperty("creator"))
        object.creator = message.creator;
      if (message.updater != null && message.hasOwnProperty("updater"))
        object.updater = message.updater;
      if (message.previousPeriodProductId != null && message.hasOwnProperty("previousPeriodProductId"))
        object.previousPeriodProductId = message.previousPeriodProductId;
      if (message.minAvailableInvestmentAmount != null && message.hasOwnProperty("minAvailableInvestmentAmount"))
        if (typeof message.minAvailableInvestmentAmount === "number")
          object.minAvailableInvestmentAmount = options.longs === String ? String(message.minAvailableInvestmentAmount) : message.minAvailableInvestmentAmount;
        else
          object.minAvailableInvestmentAmount = options.longs === String ? $util.Long.prototype.toString.call(message.minAvailableInvestmentAmount) : options.longs === Number ? new $util.LongBits(message.minAvailableInvestmentAmount.low >>> 0, message.minAvailableInvestmentAmount.high >>> 0).toNumber(true) : message.minAvailableInvestmentAmount;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.statusDesc != null && message.hasOwnProperty("statusDesc"))
        object.statusDesc = message.statusDesc;
      return object;
    };
    SavingsProduct.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    SavingsProduct.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "INACTIVE"] = 1;
      values[valuesById[2] = "PENDING"] = 2;
      values[valuesById[3] = "ACTIVE"] = 3;
      return values;
    }();
    return SavingsProduct;
  }();
  dnse2.UnderlyingDepositDetail = function() {
    function UnderlyingDepositDetail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    UnderlyingDepositDetail.prototype.accountNo = "";
    UnderlyingDepositDetail.prototype.accountNoDesc = "";
    UnderlyingDepositDetail.prototype.custodyCode = "";
    UnderlyingDepositDetail.create = function create(properties) {
      return new UnderlyingDepositDetail(properties);
    };
    UnderlyingDepositDetail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(10).string(message.accountNo);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(18).string(message.accountNoDesc);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      return writer;
    };
    UnderlyingDepositDetail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    UnderlyingDepositDetail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.UnderlyingDepositDetail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNo = reader.string();
            break;
          case 2:
            message.accountNoDesc = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    UnderlyingDepositDetail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    UnderlyingDepositDetail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      return null;
    };
    UnderlyingDepositDetail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.UnderlyingDepositDetail)
        return object;
      let message = new $root.dnse.UnderlyingDepositDetail();
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      return message;
    };
    UnderlyingDepositDetail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNo = "";
        object.accountNoDesc = "";
        object.custodyCode = "";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      return object;
    };
    UnderlyingDepositDetail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return UnderlyingDepositDetail;
  }();
  dnse2.GiftDepositDetail = function() {
    function GiftDepositDetail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GiftDepositDetail.prototype.fromAccountNo = "";
    GiftDepositDetail.prototype.toAccountNo = "";
    GiftDepositDetail.prototype.custodyCode = "";
    GiftDepositDetail.prototype.flexTransactionRef = "";
    GiftDepositDetail.prototype.giftLineId = 0;
    GiftDepositDetail.create = function create(properties) {
      return new GiftDepositDetail(properties);
    };
    GiftDepositDetail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.fromAccountNo != null && Object.hasOwnProperty.call(message, "fromAccountNo"))
        writer.uint32(10).string(message.fromAccountNo);
      if (message.toAccountNo != null && Object.hasOwnProperty.call(message, "toAccountNo"))
        writer.uint32(18).string(message.toAccountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.flexTransactionRef != null && Object.hasOwnProperty.call(message, "flexTransactionRef"))
        writer.uint32(34).string(message.flexTransactionRef);
      if (message.giftLineId != null && Object.hasOwnProperty.call(message, "giftLineId"))
        writer.uint32(40).uint32(message.giftLineId);
      return writer;
    };
    GiftDepositDetail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GiftDepositDetail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GiftDepositDetail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.fromAccountNo = reader.string();
            break;
          case 2:
            message.toAccountNo = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.flexTransactionRef = reader.string();
            break;
          case 5:
            message.giftLineId = reader.uint32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GiftDepositDetail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GiftDepositDetail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.fromAccountNo != null && message.hasOwnProperty("fromAccountNo")) {
        if (!$util.isString(message.fromAccountNo))
          return "fromAccountNo: string expected";
      }
      if (message.toAccountNo != null && message.hasOwnProperty("toAccountNo")) {
        if (!$util.isString(message.toAccountNo))
          return "toAccountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.flexTransactionRef != null && message.hasOwnProperty("flexTransactionRef")) {
        if (!$util.isString(message.flexTransactionRef))
          return "flexTransactionRef: string expected";
      }
      if (message.giftLineId != null && message.hasOwnProperty("giftLineId")) {
        if (!$util.isInteger(message.giftLineId))
          return "giftLineId: integer expected";
      }
      return null;
    };
    GiftDepositDetail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GiftDepositDetail)
        return object;
      let message = new $root.dnse.GiftDepositDetail();
      if (object.fromAccountNo != null)
        message.fromAccountNo = String(object.fromAccountNo);
      if (object.toAccountNo != null)
        message.toAccountNo = String(object.toAccountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.flexTransactionRef != null)
        message.flexTransactionRef = String(object.flexTransactionRef);
      if (object.giftLineId != null)
        message.giftLineId = object.giftLineId >>> 0;
      return message;
    };
    GiftDepositDetail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.fromAccountNo = "";
        object.toAccountNo = "";
        object.custodyCode = "";
        object.flexTransactionRef = "";
        object.giftLineId = 0;
      }
      if (message.fromAccountNo != null && message.hasOwnProperty("fromAccountNo"))
        object.fromAccountNo = message.fromAccountNo;
      if (message.toAccountNo != null && message.hasOwnProperty("toAccountNo"))
        object.toAccountNo = message.toAccountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.flexTransactionRef != null && message.hasOwnProperty("flexTransactionRef"))
        object.flexTransactionRef = message.flexTransactionRef;
      if (message.giftLineId != null && message.hasOwnProperty("giftLineId"))
        object.giftLineId = message.giftLineId;
      return object;
    };
    GiftDepositDetail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GiftDepositDetail;
  }();
  dnse2.BankDepositDetail = function() {
    function BankDepositDetail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BankDepositDetail.prototype.bankName = "";
    BankDepositDetail.prototype.bankCode = "";
    BankDepositDetail.prototype.bankBranchCode = "";
    BankDepositDetail.prototype.bankBranchName = "";
    BankDepositDetail.prototype.accountNo = "";
    BankDepositDetail.prototype.accountName = "";
    BankDepositDetail.create = function create(properties) {
      return new BankDepositDetail(properties);
    };
    BankDepositDetail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
        writer.uint32(10).string(message.bankName);
      if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
        writer.uint32(18).string(message.bankCode);
      if (message.bankBranchCode != null && Object.hasOwnProperty.call(message, "bankBranchCode"))
        writer.uint32(26).string(message.bankBranchCode);
      if (message.bankBranchName != null && Object.hasOwnProperty.call(message, "bankBranchName"))
        writer.uint32(34).string(message.bankBranchName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(42).string(message.accountNo);
      if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
        writer.uint32(50).string(message.accountName);
      return writer;
    };
    BankDepositDetail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BankDepositDetail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BankDepositDetail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.bankName = reader.string();
            break;
          case 2:
            message.bankCode = reader.string();
            break;
          case 3:
            message.bankBranchCode = reader.string();
            break;
          case 4:
            message.bankBranchName = reader.string();
            break;
          case 5:
            message.accountNo = reader.string();
            break;
          case 6:
            message.accountName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BankDepositDetail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BankDepositDetail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.bankName != null && message.hasOwnProperty("bankName")) {
        if (!$util.isString(message.bankName))
          return "bankName: string expected";
      }
      if (message.bankCode != null && message.hasOwnProperty("bankCode")) {
        if (!$util.isString(message.bankCode))
          return "bankCode: string expected";
      }
      if (message.bankBranchCode != null && message.hasOwnProperty("bankBranchCode")) {
        if (!$util.isString(message.bankBranchCode))
          return "bankBranchCode: string expected";
      }
      if (message.bankBranchName != null && message.hasOwnProperty("bankBranchName")) {
        if (!$util.isString(message.bankBranchName))
          return "bankBranchName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.accountName != null && message.hasOwnProperty("accountName")) {
        if (!$util.isString(message.accountName))
          return "accountName: string expected";
      }
      return null;
    };
    BankDepositDetail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BankDepositDetail)
        return object;
      let message = new $root.dnse.BankDepositDetail();
      if (object.bankName != null)
        message.bankName = String(object.bankName);
      if (object.bankCode != null)
        message.bankCode = String(object.bankCode);
      if (object.bankBranchCode != null)
        message.bankBranchCode = String(object.bankBranchCode);
      if (object.bankBranchName != null)
        message.bankBranchName = String(object.bankBranchName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.accountName != null)
        message.accountName = String(object.accountName);
      return message;
    };
    BankDepositDetail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.bankName = "";
        object.bankCode = "";
        object.bankBranchCode = "";
        object.bankBranchName = "";
        object.accountNo = "";
        object.accountName = "";
      }
      if (message.bankName != null && message.hasOwnProperty("bankName"))
        object.bankName = message.bankName;
      if (message.bankCode != null && message.hasOwnProperty("bankCode"))
        object.bankCode = message.bankCode;
      if (message.bankBranchCode != null && message.hasOwnProperty("bankBranchCode"))
        object.bankBranchCode = message.bankBranchCode;
      if (message.bankBranchName != null && message.hasOwnProperty("bankBranchName"))
        object.bankBranchName = message.bankBranchName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.accountName != null && message.hasOwnProperty("accountName"))
        object.accountName = message.accountName;
      return object;
    };
    BankDepositDetail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BankDepositDetail;
  }();
  dnse2.DepositDetail = function() {
    function DepositDetail(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    DepositDetail.prototype.underlyingDeposit = null;
    DepositDetail.prototype.bankDeposit = null;
    DepositDetail.prototype.giftDeposit = null;
    let $oneOfFields;
    Object.defineProperty(DepositDetail.prototype, "kind", {
      get: $util.oneOfGetter($oneOfFields = ["underlyingDeposit", "bankDeposit", "giftDeposit"]),
      set: $util.oneOfSetter($oneOfFields)
    });
    DepositDetail.create = function create(properties) {
      return new DepositDetail(properties);
    };
    DepositDetail.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.underlyingDeposit != null && Object.hasOwnProperty.call(message, "underlyingDeposit"))
        $root.dnse.UnderlyingDepositDetail.encode(message.underlyingDeposit, writer.uint32(10).fork()).ldelim();
      if (message.bankDeposit != null && Object.hasOwnProperty.call(message, "bankDeposit"))
        $root.dnse.BankDepositDetail.encode(message.bankDeposit, writer.uint32(18).fork()).ldelim();
      if (message.giftDeposit != null && Object.hasOwnProperty.call(message, "giftDeposit"))
        $root.dnse.GiftDepositDetail.encode(message.giftDeposit, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    DepositDetail.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    DepositDetail.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.DepositDetail();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.underlyingDeposit = $root.dnse.UnderlyingDepositDetail.decode(reader, reader.uint32());
            break;
          case 2:
            message.bankDeposit = $root.dnse.BankDepositDetail.decode(reader, reader.uint32());
            break;
          case 3:
            message.giftDeposit = $root.dnse.GiftDepositDetail.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    DepositDetail.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    DepositDetail.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      let properties = {};
      if (message.underlyingDeposit != null && message.hasOwnProperty("underlyingDeposit")) {
        properties.kind = 1;
        {
          let error = $root.dnse.UnderlyingDepositDetail.verify(message.underlyingDeposit);
          if (error)
            return "underlyingDeposit." + error;
        }
      }
      if (message.bankDeposit != null && message.hasOwnProperty("bankDeposit")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.BankDepositDetail.verify(message.bankDeposit);
          if (error)
            return "bankDeposit." + error;
        }
      }
      if (message.giftDeposit != null && message.hasOwnProperty("giftDeposit")) {
        if (properties.kind === 1)
          return "kind: multiple values";
        properties.kind = 1;
        {
          let error = $root.dnse.GiftDepositDetail.verify(message.giftDeposit);
          if (error)
            return "giftDeposit." + error;
        }
      }
      return null;
    };
    DepositDetail.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.DepositDetail)
        return object;
      let message = new $root.dnse.DepositDetail();
      if (object.underlyingDeposit != null) {
        if (typeof object.underlyingDeposit !== "object")
          throw TypeError(".dnse.DepositDetail.underlyingDeposit: object expected");
        message.underlyingDeposit = $root.dnse.UnderlyingDepositDetail.fromObject(object.underlyingDeposit);
      }
      if (object.bankDeposit != null) {
        if (typeof object.bankDeposit !== "object")
          throw TypeError(".dnse.DepositDetail.bankDeposit: object expected");
        message.bankDeposit = $root.dnse.BankDepositDetail.fromObject(object.bankDeposit);
      }
      if (object.giftDeposit != null) {
        if (typeof object.giftDeposit !== "object")
          throw TypeError(".dnse.DepositDetail.giftDeposit: object expected");
        message.giftDeposit = $root.dnse.GiftDepositDetail.fromObject(object.giftDeposit);
      }
      return message;
    };
    DepositDetail.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (message.underlyingDeposit != null && message.hasOwnProperty("underlyingDeposit")) {
        object.underlyingDeposit = $root.dnse.UnderlyingDepositDetail.toObject(message.underlyingDeposit, options);
        if (options.oneofs)
          object.kind = "underlyingDeposit";
      }
      if (message.bankDeposit != null && message.hasOwnProperty("bankDeposit")) {
        object.bankDeposit = $root.dnse.BankDepositDetail.toObject(message.bankDeposit, options);
        if (options.oneofs)
          object.kind = "bankDeposit";
      }
      if (message.giftDeposit != null && message.hasOwnProperty("giftDeposit")) {
        object.giftDeposit = $root.dnse.GiftDepositDetail.toObject(message.giftDeposit, options);
        if (options.oneofs)
          object.kind = "giftDeposit";
      }
      return object;
    };
    DepositDetail.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return DepositDetail;
  }();
  dnse2.DepositSource = function() {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN"] = 0;
    values[valuesById[1] = "UNDERLYING_ACCOUNT"] = 1;
    values[valuesById[2] = "GIFT"] = 2;
    return values;
  }();
  dnse2.Bloom = function() {
    function Bloom(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    Bloom.prototype.preBloom = false;
    Bloom.prototype.minInvestmentDay = 0;
    Bloom.prototype.preBloomAnnualInterestRate = 0;
    Bloom.create = function create(properties) {
      return new Bloom(properties);
    };
    Bloom.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.preBloom != null && Object.hasOwnProperty.call(message, "preBloom"))
        writer.uint32(8).bool(message.preBloom);
      if (message.minInvestmentDay != null && Object.hasOwnProperty.call(message, "minInvestmentDay"))
        writer.uint32(16).uint32(message.minInvestmentDay);
      if (message.preBloomAnnualInterestRate != null && Object.hasOwnProperty.call(message, "preBloomAnnualInterestRate"))
        writer.uint32(25).double(message.preBloomAnnualInterestRate);
      return writer;
    };
    Bloom.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    Bloom.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.Bloom();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.preBloom = reader.bool();
            break;
          case 2:
            message.minInvestmentDay = reader.uint32();
            break;
          case 3:
            message.preBloomAnnualInterestRate = reader.double();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    Bloom.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    Bloom.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.preBloom != null && message.hasOwnProperty("preBloom")) {
        if (typeof message.preBloom !== "boolean")
          return "preBloom: boolean expected";
      }
      if (message.minInvestmentDay != null && message.hasOwnProperty("minInvestmentDay")) {
        if (!$util.isInteger(message.minInvestmentDay))
          return "minInvestmentDay: integer expected";
      }
      if (message.preBloomAnnualInterestRate != null && message.hasOwnProperty("preBloomAnnualInterestRate")) {
        if (typeof message.preBloomAnnualInterestRate !== "number")
          return "preBloomAnnualInterestRate: number expected";
      }
      return null;
    };
    Bloom.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.Bloom)
        return object;
      let message = new $root.dnse.Bloom();
      if (object.preBloom != null)
        message.preBloom = Boolean(object.preBloom);
      if (object.minInvestmentDay != null)
        message.minInvestmentDay = object.minInvestmentDay >>> 0;
      if (object.preBloomAnnualInterestRate != null)
        message.preBloomAnnualInterestRate = Number(object.preBloomAnnualInterestRate);
      return message;
    };
    Bloom.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.preBloom = false;
        object.minInvestmentDay = 0;
        object.preBloomAnnualInterestRate = 0;
      }
      if (message.preBloom != null && message.hasOwnProperty("preBloom"))
        object.preBloom = message.preBloom;
      if (message.minInvestmentDay != null && message.hasOwnProperty("minInvestmentDay"))
        object.minInvestmentDay = message.minInvestmentDay;
      if (message.preBloomAnnualInterestRate != null && message.hasOwnProperty("preBloomAnnualInterestRate"))
        object.preBloomAnnualInterestRate = options.json && !isFinite(message.preBloomAnnualInterestRate) ? String(message.preBloomAnnualInterestRate) : message.preBloomAnnualInterestRate;
      return object;
    };
    Bloom.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Bloom;
  }();
  dnse2.SavingsAccount = function() {
    function SavingsAccount(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccount.prototype.id = 0;
    SavingsAccount.prototype.investorId = "";
    SavingsAccount.prototype.depositSource = 0;
    SavingsAccount.prototype.depositDetail = null;
    SavingsAccount.prototype.product = null;
    SavingsAccount.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccount.prototype.investmentDate = null;
    SavingsAccount.prototype.maturityDate = null;
    SavingsAccount.prototype.maturityInterest = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccount.prototype.settledInterest = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccount.prototype.settledDate = null;
    SavingsAccount.prototype.taxRate = 0;
    SavingsAccount.prototype.taxAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccount.prototype.productForCalculatedInterest = null;
    SavingsAccount.prototype.status = 0;
    SavingsAccount.prototype.autoRollover = false;
    SavingsAccount.prototype.createdDate = null;
    SavingsAccount.prototype.updatedDate = null;
    SavingsAccount.prototype.creator = "";
    SavingsAccount.prototype.updater = "";
    SavingsAccount.prototype.rolloverFromAccount = null;
    SavingsAccount.prototype.bloom = null;
    SavingsAccount.prototype.accumulatedInterest = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccount.prototype.statusDesc = "";
    SavingsAccount.create = function create(properties) {
      return new SavingsAccount(properties);
    };
    SavingsAccount.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        writer.uint32(8).uint32(message.id);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(18).string(message.investorId);
      if (message.depositSource != null && Object.hasOwnProperty.call(message, "depositSource"))
        writer.uint32(24).int32(message.depositSource);
      if (message.depositDetail != null && Object.hasOwnProperty.call(message, "depositDetail"))
        $root.dnse.DepositDetail.encode(message.depositDetail, writer.uint32(34).fork()).ldelim();
      if (message.product != null && Object.hasOwnProperty.call(message, "product"))
        $root.dnse.SavingsProduct.encode(message.product, writer.uint32(42).fork()).ldelim();
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(48).uint64(message.amount);
      if (message.investmentDate != null && Object.hasOwnProperty.call(message, "investmentDate"))
        $root.google.protobuf.Timestamp.encode(message.investmentDate, writer.uint32(58).fork()).ldelim();
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        $root.google.protobuf.Timestamp.encode(message.maturityDate, writer.uint32(66).fork()).ldelim();
      if (message.maturityInterest != null && Object.hasOwnProperty.call(message, "maturityInterest"))
        writer.uint32(72).uint64(message.maturityInterest);
      if (message.settledInterest != null && Object.hasOwnProperty.call(message, "settledInterest"))
        writer.uint32(80).uint64(message.settledInterest);
      if (message.settledDate != null && Object.hasOwnProperty.call(message, "settledDate"))
        $root.google.protobuf.Timestamp.encode(message.settledDate, writer.uint32(90).fork()).ldelim();
      if (message.taxRate != null && Object.hasOwnProperty.call(message, "taxRate"))
        writer.uint32(97).double(message.taxRate);
      if (message.taxAmount != null && Object.hasOwnProperty.call(message, "taxAmount"))
        writer.uint32(104).uint64(message.taxAmount);
      if (message.productForCalculatedInterest != null && Object.hasOwnProperty.call(message, "productForCalculatedInterest"))
        $root.dnse.SavingsProduct.encode(message.productForCalculatedInterest, writer.uint32(114).fork()).ldelim();
      if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        writer.uint32(120).int32(message.status);
      if (message.autoRollover != null && Object.hasOwnProperty.call(message, "autoRollover"))
        writer.uint32(128).bool(message.autoRollover);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(138).fork()).ldelim();
      if (message.updatedDate != null && Object.hasOwnProperty.call(message, "updatedDate"))
        $root.google.protobuf.Timestamp.encode(message.updatedDate, writer.uint32(146).fork()).ldelim();
      if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
        writer.uint32(154).string(message.creator);
      if (message.updater != null && Object.hasOwnProperty.call(message, "updater"))
        writer.uint32(162).string(message.updater);
      if (message.rolloverFromAccount != null && Object.hasOwnProperty.call(message, "rolloverFromAccount"))
        $root.dnse.SavingsAccount.encode(message.rolloverFromAccount, writer.uint32(170).fork()).ldelim();
      if (message.bloom != null && Object.hasOwnProperty.call(message, "bloom"))
        $root.dnse.Bloom.encode(message.bloom, writer.uint32(178).fork()).ldelim();
      if (message.accumulatedInterest != null && Object.hasOwnProperty.call(message, "accumulatedInterest"))
        writer.uint32(184).uint64(message.accumulatedInterest);
      if (message.statusDesc != null && Object.hasOwnProperty.call(message, "statusDesc"))
        writer.uint32(194).string(message.statusDesc);
      return writer;
    };
    SavingsAccount.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccount.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccount();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.id = reader.uint32();
            break;
          case 2:
            message.investorId = reader.string();
            break;
          case 3:
            message.depositSource = reader.int32();
            break;
          case 4:
            message.depositDetail = $root.dnse.DepositDetail.decode(reader, reader.uint32());
            break;
          case 5:
            message.product = $root.dnse.SavingsProduct.decode(reader, reader.uint32());
            break;
          case 6:
            message.amount = reader.uint64();
            break;
          case 7:
            message.investmentDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.maturityDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.maturityInterest = reader.uint64();
            break;
          case 10:
            message.settledInterest = reader.uint64();
            break;
          case 11:
            message.settledDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 12:
            message.taxRate = reader.double();
            break;
          case 13:
            message.taxAmount = reader.uint64();
            break;
          case 14:
            message.productForCalculatedInterest = $root.dnse.SavingsProduct.decode(reader, reader.uint32());
            break;
          case 15:
            message.status = reader.int32();
            break;
          case 16:
            message.autoRollover = reader.bool();
            break;
          case 17:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 18:
            message.updatedDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 19:
            message.creator = reader.string();
            break;
          case 20:
            message.updater = reader.string();
            break;
          case 21:
            message.rolloverFromAccount = $root.dnse.SavingsAccount.decode(reader, reader.uint32());
            break;
          case 22:
            message.bloom = $root.dnse.Bloom.decode(reader, reader.uint32());
            break;
          case 23:
            message.accumulatedInterest = reader.uint64();
            break;
          case 24:
            message.statusDesc = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccount.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccount.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.id != null && message.hasOwnProperty("id")) {
        if (!$util.isInteger(message.id))
          return "id: integer expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.depositSource != null && message.hasOwnProperty("depositSource"))
        switch (message.depositSource) {
          default:
            return "depositSource: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.depositDetail != null && message.hasOwnProperty("depositDetail")) {
        let error = $root.dnse.DepositDetail.verify(message.depositDetail);
        if (error)
          return "depositDetail." + error;
      }
      if (message.product != null && message.hasOwnProperty("product")) {
        let error = $root.dnse.SavingsProduct.verify(message.product);
        if (error)
          return "product." + error;
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.investmentDate != null && message.hasOwnProperty("investmentDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.investmentDate);
        if (error)
          return "investmentDate." + error;
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.maturityDate);
        if (error)
          return "maturityDate." + error;
      }
      if (message.maturityInterest != null && message.hasOwnProperty("maturityInterest")) {
        if (!$util.isInteger(message.maturityInterest) && !(message.maturityInterest && $util.isInteger(message.maturityInterest.low) && $util.isInteger(message.maturityInterest.high)))
          return "maturityInterest: integer|Long expected";
      }
      if (message.settledInterest != null && message.hasOwnProperty("settledInterest")) {
        if (!$util.isInteger(message.settledInterest) && !(message.settledInterest && $util.isInteger(message.settledInterest.low) && $util.isInteger(message.settledInterest.high)))
          return "settledInterest: integer|Long expected";
      }
      if (message.settledDate != null && message.hasOwnProperty("settledDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.settledDate);
        if (error)
          return "settledDate." + error;
      }
      if (message.taxRate != null && message.hasOwnProperty("taxRate")) {
        if (typeof message.taxRate !== "number")
          return "taxRate: number expected";
      }
      if (message.taxAmount != null && message.hasOwnProperty("taxAmount")) {
        if (!$util.isInteger(message.taxAmount) && !(message.taxAmount && $util.isInteger(message.taxAmount.low) && $util.isInteger(message.taxAmount.high)))
          return "taxAmount: integer|Long expected";
      }
      if (message.productForCalculatedInterest != null && message.hasOwnProperty("productForCalculatedInterest")) {
        let error = $root.dnse.SavingsProduct.verify(message.productForCalculatedInterest);
        if (error)
          return "productForCalculatedInterest." + error;
      }
      if (message.status != null && message.hasOwnProperty("status"))
        switch (message.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
            break;
        }
      if (message.autoRollover != null && message.hasOwnProperty("autoRollover")) {
        if (typeof message.autoRollover !== "boolean")
          return "autoRollover: boolean expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.updatedDate);
        if (error)
          return "updatedDate." + error;
      }
      if (message.creator != null && message.hasOwnProperty("creator")) {
        if (!$util.isString(message.creator))
          return "creator: string expected";
      }
      if (message.updater != null && message.hasOwnProperty("updater")) {
        if (!$util.isString(message.updater))
          return "updater: string expected";
      }
      if (message.rolloverFromAccount != null && message.hasOwnProperty("rolloverFromAccount")) {
        let error = $root.dnse.SavingsAccount.verify(message.rolloverFromAccount);
        if (error)
          return "rolloverFromAccount." + error;
      }
      if (message.bloom != null && message.hasOwnProperty("bloom")) {
        let error = $root.dnse.Bloom.verify(message.bloom);
        if (error)
          return "bloom." + error;
      }
      if (message.accumulatedInterest != null && message.hasOwnProperty("accumulatedInterest")) {
        if (!$util.isInteger(message.accumulatedInterest) && !(message.accumulatedInterest && $util.isInteger(message.accumulatedInterest.low) && $util.isInteger(message.accumulatedInterest.high)))
          return "accumulatedInterest: integer|Long expected";
      }
      if (message.statusDesc != null && message.hasOwnProperty("statusDesc")) {
        if (!$util.isString(message.statusDesc))
          return "statusDesc: string expected";
      }
      return null;
    };
    SavingsAccount.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccount)
        return object;
      let message = new $root.dnse.SavingsAccount();
      if (object.id != null)
        message.id = object.id >>> 0;
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      switch (object.depositSource) {
        case "UNKNOWN":
        case 0:
          message.depositSource = 0;
          break;
        case "UNDERLYING_ACCOUNT":
        case 1:
          message.depositSource = 1;
          break;
        case "GIFT":
        case 2:
          message.depositSource = 2;
          break;
      }
      if (object.depositDetail != null) {
        if (typeof object.depositDetail !== "object")
          throw TypeError(".dnse.SavingsAccount.depositDetail: object expected");
        message.depositDetail = $root.dnse.DepositDetail.fromObject(object.depositDetail);
      }
      if (object.product != null) {
        if (typeof object.product !== "object")
          throw TypeError(".dnse.SavingsAccount.product: object expected");
        message.product = $root.dnse.SavingsProduct.fromObject(object.product);
      }
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.investmentDate != null) {
        if (typeof object.investmentDate !== "object")
          throw TypeError(".dnse.SavingsAccount.investmentDate: object expected");
        message.investmentDate = $root.google.protobuf.Timestamp.fromObject(object.investmentDate);
      }
      if (object.maturityDate != null) {
        if (typeof object.maturityDate !== "object")
          throw TypeError(".dnse.SavingsAccount.maturityDate: object expected");
        message.maturityDate = $root.google.protobuf.Timestamp.fromObject(object.maturityDate);
      }
      if (object.maturityInterest != null) {
        if ($util.Long)
          (message.maturityInterest = $util.Long.fromValue(object.maturityInterest)).unsigned = true;
        else if (typeof object.maturityInterest === "string")
          message.maturityInterest = parseInt(object.maturityInterest, 10);
        else if (typeof object.maturityInterest === "number")
          message.maturityInterest = object.maturityInterest;
        else if (typeof object.maturityInterest === "object")
          message.maturityInterest = new $util.LongBits(object.maturityInterest.low >>> 0, object.maturityInterest.high >>> 0).toNumber(true);
      }
      if (object.settledInterest != null) {
        if ($util.Long)
          (message.settledInterest = $util.Long.fromValue(object.settledInterest)).unsigned = true;
        else if (typeof object.settledInterest === "string")
          message.settledInterest = parseInt(object.settledInterest, 10);
        else if (typeof object.settledInterest === "number")
          message.settledInterest = object.settledInterest;
        else if (typeof object.settledInterest === "object")
          message.settledInterest = new $util.LongBits(object.settledInterest.low >>> 0, object.settledInterest.high >>> 0).toNumber(true);
      }
      if (object.settledDate != null) {
        if (typeof object.settledDate !== "object")
          throw TypeError(".dnse.SavingsAccount.settledDate: object expected");
        message.settledDate = $root.google.protobuf.Timestamp.fromObject(object.settledDate);
      }
      if (object.taxRate != null)
        message.taxRate = Number(object.taxRate);
      if (object.taxAmount != null) {
        if ($util.Long)
          (message.taxAmount = $util.Long.fromValue(object.taxAmount)).unsigned = true;
        else if (typeof object.taxAmount === "string")
          message.taxAmount = parseInt(object.taxAmount, 10);
        else if (typeof object.taxAmount === "number")
          message.taxAmount = object.taxAmount;
        else if (typeof object.taxAmount === "object")
          message.taxAmount = new $util.LongBits(object.taxAmount.low >>> 0, object.taxAmount.high >>> 0).toNumber(true);
      }
      if (object.productForCalculatedInterest != null) {
        if (typeof object.productForCalculatedInterest !== "object")
          throw TypeError(".dnse.SavingsAccount.productForCalculatedInterest: object expected");
        message.productForCalculatedInterest = $root.dnse.SavingsProduct.fromObject(object.productForCalculatedInterest);
      }
      switch (object.status) {
        case "UNKNOWN":
        case 0:
          message.status = 0;
          break;
        case "INACTIVE":
        case 1:
          message.status = 1;
          break;
        case "ACTIVE":
        case 2:
          message.status = 2;
          break;
        case "MATURED":
        case 3:
          message.status = 3;
          break;
        case "SETTLED":
        case 4:
          message.status = 4;
          break;
        case "ROLLOVER":
        case 5:
          message.status = 5;
          break;
        case "CLOSED":
        case 6:
          message.status = 6;
          break;
        case "CREATED":
        case 7:
          message.status = 7;
          break;
        case "SENT":
        case 8:
          message.status = 8;
          break;
        case "REJECTED":
        case 9:
          message.status = 9;
          break;
      }
      if (object.autoRollover != null)
        message.autoRollover = Boolean(object.autoRollover);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccount.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.updatedDate != null) {
        if (typeof object.updatedDate !== "object")
          throw TypeError(".dnse.SavingsAccount.updatedDate: object expected");
        message.updatedDate = $root.google.protobuf.Timestamp.fromObject(object.updatedDate);
      }
      if (object.creator != null)
        message.creator = String(object.creator);
      if (object.updater != null)
        message.updater = String(object.updater);
      if (object.rolloverFromAccount != null) {
        if (typeof object.rolloverFromAccount !== "object")
          throw TypeError(".dnse.SavingsAccount.rolloverFromAccount: object expected");
        message.rolloverFromAccount = $root.dnse.SavingsAccount.fromObject(object.rolloverFromAccount);
      }
      if (object.bloom != null) {
        if (typeof object.bloom !== "object")
          throw TypeError(".dnse.SavingsAccount.bloom: object expected");
        message.bloom = $root.dnse.Bloom.fromObject(object.bloom);
      }
      if (object.accumulatedInterest != null) {
        if ($util.Long)
          (message.accumulatedInterest = $util.Long.fromValue(object.accumulatedInterest)).unsigned = true;
        else if (typeof object.accumulatedInterest === "string")
          message.accumulatedInterest = parseInt(object.accumulatedInterest, 10);
        else if (typeof object.accumulatedInterest === "number")
          message.accumulatedInterest = object.accumulatedInterest;
        else if (typeof object.accumulatedInterest === "object")
          message.accumulatedInterest = new $util.LongBits(object.accumulatedInterest.low >>> 0, object.accumulatedInterest.high >>> 0).toNumber(true);
      }
      if (object.statusDesc != null)
        message.statusDesc = String(object.statusDesc);
      return message;
    };
    SavingsAccount.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.investorId = "";
        object.depositSource = options.enums === String ? "UNKNOWN" : 0;
        object.depositDetail = null;
        object.product = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.investmentDate = null;
        object.maturityDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.maturityInterest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.maturityInterest = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.settledInterest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.settledInterest = options.longs === String ? "0" : 0;
        object.settledDate = null;
        object.taxRate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.taxAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.taxAmount = options.longs === String ? "0" : 0;
        object.productForCalculatedInterest = null;
        object.status = options.enums === String ? "UNKNOWN" : 0;
        object.autoRollover = false;
        object.createdDate = null;
        object.updatedDate = null;
        object.creator = "";
        object.updater = "";
        object.rolloverFromAccount = null;
        object.bloom = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.accumulatedInterest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.accumulatedInterest = options.longs === String ? "0" : 0;
        object.statusDesc = "";
      }
      if (message.id != null && message.hasOwnProperty("id"))
        object.id = message.id;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.depositSource != null && message.hasOwnProperty("depositSource"))
        object.depositSource = options.enums === String ? $root.dnse.DepositSource[message.depositSource] : message.depositSource;
      if (message.depositDetail != null && message.hasOwnProperty("depositDetail"))
        object.depositDetail = $root.dnse.DepositDetail.toObject(message.depositDetail, options);
      if (message.product != null && message.hasOwnProperty("product"))
        object.product = $root.dnse.SavingsProduct.toObject(message.product, options);
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.investmentDate != null && message.hasOwnProperty("investmentDate"))
        object.investmentDate = $root.google.protobuf.Timestamp.toObject(message.investmentDate, options);
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = $root.google.protobuf.Timestamp.toObject(message.maturityDate, options);
      if (message.maturityInterest != null && message.hasOwnProperty("maturityInterest"))
        if (typeof message.maturityInterest === "number")
          object.maturityInterest = options.longs === String ? String(message.maturityInterest) : message.maturityInterest;
        else
          object.maturityInterest = options.longs === String ? $util.Long.prototype.toString.call(message.maturityInterest) : options.longs === Number ? new $util.LongBits(message.maturityInterest.low >>> 0, message.maturityInterest.high >>> 0).toNumber(true) : message.maturityInterest;
      if (message.settledInterest != null && message.hasOwnProperty("settledInterest"))
        if (typeof message.settledInterest === "number")
          object.settledInterest = options.longs === String ? String(message.settledInterest) : message.settledInterest;
        else
          object.settledInterest = options.longs === String ? $util.Long.prototype.toString.call(message.settledInterest) : options.longs === Number ? new $util.LongBits(message.settledInterest.low >>> 0, message.settledInterest.high >>> 0).toNumber(true) : message.settledInterest;
      if (message.settledDate != null && message.hasOwnProperty("settledDate"))
        object.settledDate = $root.google.protobuf.Timestamp.toObject(message.settledDate, options);
      if (message.taxRate != null && message.hasOwnProperty("taxRate"))
        object.taxRate = options.json && !isFinite(message.taxRate) ? String(message.taxRate) : message.taxRate;
      if (message.taxAmount != null && message.hasOwnProperty("taxAmount"))
        if (typeof message.taxAmount === "number")
          object.taxAmount = options.longs === String ? String(message.taxAmount) : message.taxAmount;
        else
          object.taxAmount = options.longs === String ? $util.Long.prototype.toString.call(message.taxAmount) : options.longs === Number ? new $util.LongBits(message.taxAmount.low >>> 0, message.taxAmount.high >>> 0).toNumber(true) : message.taxAmount;
      if (message.productForCalculatedInterest != null && message.hasOwnProperty("productForCalculatedInterest"))
        object.productForCalculatedInterest = $root.dnse.SavingsProduct.toObject(message.productForCalculatedInterest, options);
      if (message.status != null && message.hasOwnProperty("status"))
        object.status = options.enums === String ? $root.dnse.SavingsAccount.Status[message.status] : message.status;
      if (message.autoRollover != null && message.hasOwnProperty("autoRollover"))
        object.autoRollover = message.autoRollover;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.updatedDate != null && message.hasOwnProperty("updatedDate"))
        object.updatedDate = $root.google.protobuf.Timestamp.toObject(message.updatedDate, options);
      if (message.creator != null && message.hasOwnProperty("creator"))
        object.creator = message.creator;
      if (message.updater != null && message.hasOwnProperty("updater"))
        object.updater = message.updater;
      if (message.rolloverFromAccount != null && message.hasOwnProperty("rolloverFromAccount"))
        object.rolloverFromAccount = $root.dnse.SavingsAccount.toObject(message.rolloverFromAccount, options);
      if (message.bloom != null && message.hasOwnProperty("bloom"))
        object.bloom = $root.dnse.Bloom.toObject(message.bloom, options);
      if (message.accumulatedInterest != null && message.hasOwnProperty("accumulatedInterest"))
        if (typeof message.accumulatedInterest === "number")
          object.accumulatedInterest = options.longs === String ? String(message.accumulatedInterest) : message.accumulatedInterest;
        else
          object.accumulatedInterest = options.longs === String ? $util.Long.prototype.toString.call(message.accumulatedInterest) : options.longs === Number ? new $util.LongBits(message.accumulatedInterest.low >>> 0, message.accumulatedInterest.high >>> 0).toNumber(true) : message.accumulatedInterest;
      if (message.statusDesc != null && message.hasOwnProperty("statusDesc"))
        object.statusDesc = message.statusDesc;
      return object;
    };
    SavingsAccount.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    SavingsAccount.Status = function() {
      const valuesById = {}, values = Object.create(valuesById);
      values[valuesById[0] = "UNKNOWN"] = 0;
      values[valuesById[1] = "INACTIVE"] = 1;
      values[valuesById[2] = "ACTIVE"] = 2;
      values[valuesById[3] = "MATURED"] = 3;
      values[valuesById[4] = "SETTLED"] = 4;
      values[valuesById[5] = "ROLLOVER"] = 5;
      values[valuesById[6] = "CLOSED"] = 6;
      values[valuesById[7] = "CREATED"] = 7;
      values[valuesById[8] = "SENT"] = 8;
      values[valuesById[9] = "REJECTED"] = 9;
      return values;
    }();
    return SavingsAccount;
  }();
  dnse2.SavingsAccountCreated = function() {
    function SavingsAccountCreated(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountCreated.prototype.accountNoDesc = "";
    SavingsAccountCreated.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountCreated.prototype.nominalAnnualInterestRate = 0;
    SavingsAccountCreated.prototype.productName = "";
    SavingsAccountCreated.prototype.investorId = "";
    SavingsAccountCreated.prototype.createdDate = null;
    SavingsAccountCreated.prototype.periodDesc = "";
    SavingsAccountCreated.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountCreated.create = function create(properties) {
      return new SavingsAccountCreated(properties);
    };
    SavingsAccountCreated.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.nominalAnnualInterestRate != null && Object.hasOwnProperty.call(message, "nominalAnnualInterestRate"))
        writer.uint32(25).double(message.nominalAnnualInterestRate);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(34).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(58).string(message.periodDesc);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(64).uint64(message.savingsAccountId);
      return writer;
    };
    SavingsAccountCreated.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountCreated.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountCreated();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.nominalAnnualInterestRate = reader.double();
            break;
          case 4:
            message.productName = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.periodDesc = reader.string();
            break;
          case 8:
            message.savingsAccountId = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountCreated.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountCreated.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate")) {
        if (typeof message.nominalAnnualInterestRate !== "number")
          return "nominalAnnualInterestRate: number expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      return null;
    };
    SavingsAccountCreated.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountCreated)
        return object;
      let message = new $root.dnse.SavingsAccountCreated();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.nominalAnnualInterestRate != null)
        message.nominalAnnualInterestRate = Number(object.nominalAnnualInterestRate);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountCreated.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      return message;
    };
    SavingsAccountCreated.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.nominalAnnualInterestRate = 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        object.periodDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate"))
        object.nominalAnnualInterestRate = options.json && !isFinite(message.nominalAnnualInterestRate) ? String(message.nominalAnnualInterestRate) : message.nominalAnnualInterestRate;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      return object;
    };
    SavingsAccountCreated.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountCreated;
  }();
  dnse2.SavingsAccountDeposit = function() {
    function SavingsAccountDeposit(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountDeposit.prototype.accountNoDesc = "";
    SavingsAccountDeposit.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountDeposit.prototype.balance = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountDeposit.prototype.productName = "";
    SavingsAccountDeposit.prototype.investorId = "";
    SavingsAccountDeposit.prototype.createdDate = null;
    SavingsAccountDeposit.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountDeposit.create = function create(properties) {
      return new SavingsAccountDeposit(properties);
    };
    SavingsAccountDeposit.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
        writer.uint32(24).uint64(message.balance);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(34).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(56).uint64(message.savingsAccountId);
      return writer;
    };
    SavingsAccountDeposit.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountDeposit.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountDeposit();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.balance = reader.uint64();
            break;
          case 4:
            message.productName = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.savingsAccountId = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountDeposit.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountDeposit.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.balance != null && message.hasOwnProperty("balance")) {
        if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
          return "balance: integer|Long expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      return null;
    };
    SavingsAccountDeposit.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountDeposit)
        return object;
      let message = new $root.dnse.SavingsAccountDeposit();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.balance != null) {
        if ($util.Long)
          (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
        else if (typeof object.balance === "string")
          message.balance = parseInt(object.balance, 10);
        else if (typeof object.balance === "number")
          message.balance = object.balance;
        else if (typeof object.balance === "object")
          message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
      }
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountDeposit.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      return message;
    };
    SavingsAccountDeposit.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.balance = options.longs === String ? "0" : 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.balance != null && message.hasOwnProperty("balance"))
        if (typeof message.balance === "number")
          object.balance = options.longs === String ? String(message.balance) : message.balance;
        else
          object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      return object;
    };
    SavingsAccountDeposit.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountDeposit;
  }();
  dnse2.SavingsAccountWithdrawal = function() {
    function SavingsAccountWithdrawal(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountWithdrawal.prototype.accountNoDesc = "";
    SavingsAccountWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountWithdrawal.prototype.balance = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountWithdrawal.prototype.productName = "";
    SavingsAccountWithdrawal.prototype.investorId = "";
    SavingsAccountWithdrawal.prototype.createdDate = null;
    SavingsAccountWithdrawal.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountWithdrawal.create = function create(properties) {
      return new SavingsAccountWithdrawal(properties);
    };
    SavingsAccountWithdrawal.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
        writer.uint32(24).uint64(message.balance);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(34).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(56).uint64(message.savingsAccountId);
      return writer;
    };
    SavingsAccountWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountWithdrawal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountWithdrawal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.balance = reader.uint64();
            break;
          case 4:
            message.productName = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.savingsAccountId = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountWithdrawal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountWithdrawal.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.balance != null && message.hasOwnProperty("balance")) {
        if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
          return "balance: integer|Long expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      return null;
    };
    SavingsAccountWithdrawal.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountWithdrawal)
        return object;
      let message = new $root.dnse.SavingsAccountWithdrawal();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.balance != null) {
        if ($util.Long)
          (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
        else if (typeof object.balance === "string")
          message.balance = parseInt(object.balance, 10);
        else if (typeof object.balance === "number")
          message.balance = object.balance;
        else if (typeof object.balance === "object")
          message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
      }
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountWithdrawal.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      return message;
    };
    SavingsAccountWithdrawal.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.balance = options.longs === String ? "0" : 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.balance != null && message.hasOwnProperty("balance"))
        if (typeof message.balance === "number")
          object.balance = options.longs === String ? String(message.balance) : message.balance;
        else
          object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      return object;
    };
    SavingsAccountWithdrawal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountWithdrawal;
  }();
  dnse2.SavingsAccountSettlement = function() {
    function SavingsAccountSettlement(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountSettlement.prototype.accountNoDesc = "";
    SavingsAccountSettlement.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountSettlement.prototype.interest = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountSettlement.prototype.taxAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountSettlement.prototype.productName = "";
    SavingsAccountSettlement.prototype.investorId = "";
    SavingsAccountSettlement.prototype.createdDate = null;
    SavingsAccountSettlement.prototype.periodDesc = "";
    SavingsAccountSettlement.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountSettlement.prototype.receivedAmount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountSettlement.create = function create(properties) {
      return new SavingsAccountSettlement(properties);
    };
    SavingsAccountSettlement.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.interest != null && Object.hasOwnProperty.call(message, "interest"))
        writer.uint32(24).uint64(message.interest);
      if (message.taxAmount != null && Object.hasOwnProperty.call(message, "taxAmount"))
        writer.uint32(32).uint64(message.taxAmount);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(42).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(50).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(58).fork()).ldelim();
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(66).string(message.periodDesc);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(72).uint64(message.savingsAccountId);
      if (message.receivedAmount != null && Object.hasOwnProperty.call(message, "receivedAmount"))
        writer.uint32(80).uint64(message.receivedAmount);
      return writer;
    };
    SavingsAccountSettlement.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountSettlement.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountSettlement();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.interest = reader.uint64();
            break;
          case 4:
            message.taxAmount = reader.uint64();
            break;
          case 5:
            message.productName = reader.string();
            break;
          case 6:
            message.investorId = reader.string();
            break;
          case 7:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 8:
            message.periodDesc = reader.string();
            break;
          case 9:
            message.savingsAccountId = reader.uint64();
            break;
          case 10:
            message.receivedAmount = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountSettlement.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountSettlement.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interest != null && message.hasOwnProperty("interest")) {
        if (!$util.isInteger(message.interest) && !(message.interest && $util.isInteger(message.interest.low) && $util.isInteger(message.interest.high)))
          return "interest: integer|Long expected";
      }
      if (message.taxAmount != null && message.hasOwnProperty("taxAmount")) {
        if (!$util.isInteger(message.taxAmount) && !(message.taxAmount && $util.isInteger(message.taxAmount.low) && $util.isInteger(message.taxAmount.high)))
          return "taxAmount: integer|Long expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.receivedAmount != null && message.hasOwnProperty("receivedAmount")) {
        if (!$util.isInteger(message.receivedAmount) && !(message.receivedAmount && $util.isInteger(message.receivedAmount.low) && $util.isInteger(message.receivedAmount.high)))
          return "receivedAmount: integer|Long expected";
      }
      return null;
    };
    SavingsAccountSettlement.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountSettlement)
        return object;
      let message = new $root.dnse.SavingsAccountSettlement();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.interest != null) {
        if ($util.Long)
          (message.interest = $util.Long.fromValue(object.interest)).unsigned = true;
        else if (typeof object.interest === "string")
          message.interest = parseInt(object.interest, 10);
        else if (typeof object.interest === "number")
          message.interest = object.interest;
        else if (typeof object.interest === "object")
          message.interest = new $util.LongBits(object.interest.low >>> 0, object.interest.high >>> 0).toNumber(true);
      }
      if (object.taxAmount != null) {
        if ($util.Long)
          (message.taxAmount = $util.Long.fromValue(object.taxAmount)).unsigned = true;
        else if (typeof object.taxAmount === "string")
          message.taxAmount = parseInt(object.taxAmount, 10);
        else if (typeof object.taxAmount === "number")
          message.taxAmount = object.taxAmount;
        else if (typeof object.taxAmount === "object")
          message.taxAmount = new $util.LongBits(object.taxAmount.low >>> 0, object.taxAmount.high >>> 0).toNumber(true);
      }
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountSettlement.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.receivedAmount != null) {
        if ($util.Long)
          (message.receivedAmount = $util.Long.fromValue(object.receivedAmount)).unsigned = true;
        else if (typeof object.receivedAmount === "string")
          message.receivedAmount = parseInt(object.receivedAmount, 10);
        else if (typeof object.receivedAmount === "number")
          message.receivedAmount = object.receivedAmount;
        else if (typeof object.receivedAmount === "object")
          message.receivedAmount = new $util.LongBits(object.receivedAmount.low >>> 0, object.receivedAmount.high >>> 0).toNumber(true);
      }
      return message;
    };
    SavingsAccountSettlement.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.interest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.interest = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.taxAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.taxAmount = options.longs === String ? "0" : 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        object.periodDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.receivedAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.receivedAmount = options.longs === String ? "0" : 0;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.interest != null && message.hasOwnProperty("interest"))
        if (typeof message.interest === "number")
          object.interest = options.longs === String ? String(message.interest) : message.interest;
        else
          object.interest = options.longs === String ? $util.Long.prototype.toString.call(message.interest) : options.longs === Number ? new $util.LongBits(message.interest.low >>> 0, message.interest.high >>> 0).toNumber(true) : message.interest;
      if (message.taxAmount != null && message.hasOwnProperty("taxAmount"))
        if (typeof message.taxAmount === "number")
          object.taxAmount = options.longs === String ? String(message.taxAmount) : message.taxAmount;
        else
          object.taxAmount = options.longs === String ? $util.Long.prototype.toString.call(message.taxAmount) : options.longs === Number ? new $util.LongBits(message.taxAmount.low >>> 0, message.taxAmount.high >>> 0).toNumber(true) : message.taxAmount;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.receivedAmount != null && message.hasOwnProperty("receivedAmount"))
        if (typeof message.receivedAmount === "number")
          object.receivedAmount = options.longs === String ? String(message.receivedAmount) : message.receivedAmount;
        else
          object.receivedAmount = options.longs === String ? $util.Long.prototype.toString.call(message.receivedAmount) : options.longs === Number ? new $util.LongBits(message.receivedAmount.low >>> 0, message.receivedAmount.high >>> 0).toNumber(true) : message.receivedAmount;
      return object;
    };
    SavingsAccountSettlement.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountSettlement;
  }();
  dnse2.SavingsAccountMaturityAlert = function() {
    function SavingsAccountMaturityAlert(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountMaturityAlert.prototype.investorId = "";
    SavingsAccountMaturityAlert.prototype.accountNoDesc = "";
    SavingsAccountMaturityAlert.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountMaturityAlert.prototype.nominalAnnualInterestRate = 0;
    SavingsAccountMaturityAlert.prototype.productName = "";
    SavingsAccountMaturityAlert.prototype.periodDesc = "";
    SavingsAccountMaturityAlert.prototype.maturityDate = "";
    SavingsAccountMaturityAlert.prototype.createdDate = null;
    SavingsAccountMaturityAlert.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountMaturityAlert.create = function create(properties) {
      return new SavingsAccountMaturityAlert(properties);
    };
    SavingsAccountMaturityAlert.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(18).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(24).uint64(message.amount);
      if (message.nominalAnnualInterestRate != null && Object.hasOwnProperty.call(message, "nominalAnnualInterestRate"))
        writer.uint32(33).double(message.nominalAnnualInterestRate);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(42).string(message.productName);
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(50).string(message.periodDesc);
      if (message.maturityDate != null && Object.hasOwnProperty.call(message, "maturityDate"))
        writer.uint32(58).string(message.maturityDate);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(66).fork()).ldelim();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(72).uint64(message.savingsAccountId);
      return writer;
    };
    SavingsAccountMaturityAlert.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountMaturityAlert.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountMaturityAlert();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.accountNoDesc = reader.string();
            break;
          case 3:
            message.amount = reader.uint64();
            break;
          case 4:
            message.nominalAnnualInterestRate = reader.double();
            break;
          case 5:
            message.productName = reader.string();
            break;
          case 6:
            message.periodDesc = reader.string();
            break;
          case 7:
            message.maturityDate = reader.string();
            break;
          case 8:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 9:
            message.savingsAccountId = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountMaturityAlert.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountMaturityAlert.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate")) {
        if (typeof message.nominalAnnualInterestRate !== "number")
          return "nominalAnnualInterestRate: number expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate")) {
        if (!$util.isString(message.maturityDate))
          return "maturityDate: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      return null;
    };
    SavingsAccountMaturityAlert.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountMaturityAlert)
        return object;
      let message = new $root.dnse.SavingsAccountMaturityAlert();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.nominalAnnualInterestRate != null)
        message.nominalAnnualInterestRate = Number(object.nominalAnnualInterestRate);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.maturityDate != null)
        message.maturityDate = String(object.maturityDate);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountMaturityAlert.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      return message;
    };
    SavingsAccountMaturityAlert.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.nominalAnnualInterestRate = 0;
        object.productName = "";
        object.periodDesc = "";
        object.maturityDate = "";
        object.createdDate = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate"))
        object.nominalAnnualInterestRate = options.json && !isFinite(message.nominalAnnualInterestRate) ? String(message.nominalAnnualInterestRate) : message.nominalAnnualInterestRate;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.maturityDate != null && message.hasOwnProperty("maturityDate"))
        object.maturityDate = message.maturityDate;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      return object;
    };
    SavingsAccountMaturityAlert.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountMaturityAlert;
  }();
  dnse2.SavingsAccountRollover = function() {
    function SavingsAccountRollover(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    SavingsAccountRollover.prototype.accountNoDesc = "";
    SavingsAccountRollover.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountRollover.prototype.nominalAnnualInterestRate = 0;
    SavingsAccountRollover.prototype.productName = "";
    SavingsAccountRollover.prototype.investorId = "";
    SavingsAccountRollover.prototype.createdDate = null;
    SavingsAccountRollover.prototype.periodDesc = "";
    SavingsAccountRollover.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    SavingsAccountRollover.prototype.rolloverPolicyDesc = "";
    SavingsAccountRollover.create = function create(properties) {
      return new SavingsAccountRollover(properties);
    };
    SavingsAccountRollover.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(10).string(message.accountNoDesc);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(16).uint64(message.amount);
      if (message.nominalAnnualInterestRate != null && Object.hasOwnProperty.call(message, "nominalAnnualInterestRate"))
        writer.uint32(25).double(message.nominalAnnualInterestRate);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(34).string(message.productName);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(42).string(message.investorId);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(50).fork()).ldelim();
      if (message.periodDesc != null && Object.hasOwnProperty.call(message, "periodDesc"))
        writer.uint32(58).string(message.periodDesc);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(64).uint64(message.savingsAccountId);
      if (message.rolloverPolicyDesc != null && Object.hasOwnProperty.call(message, "rolloverPolicyDesc"))
        writer.uint32(74).string(message.rolloverPolicyDesc);
      return writer;
    };
    SavingsAccountRollover.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    SavingsAccountRollover.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.SavingsAccountRollover();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.accountNoDesc = reader.string();
            break;
          case 2:
            message.amount = reader.uint64();
            break;
          case 3:
            message.nominalAnnualInterestRate = reader.double();
            break;
          case 4:
            message.productName = reader.string();
            break;
          case 5:
            message.investorId = reader.string();
            break;
          case 6:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 7:
            message.periodDesc = reader.string();
            break;
          case 8:
            message.savingsAccountId = reader.uint64();
            break;
          case 9:
            message.rolloverPolicyDesc = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    SavingsAccountRollover.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    SavingsAccountRollover.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate")) {
        if (typeof message.nominalAnnualInterestRate !== "number")
          return "nominalAnnualInterestRate: number expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc")) {
        if (!$util.isString(message.periodDesc))
          return "periodDesc: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.rolloverPolicyDesc != null && message.hasOwnProperty("rolloverPolicyDesc")) {
        if (!$util.isString(message.rolloverPolicyDesc))
          return "rolloverPolicyDesc: string expected";
      }
      return null;
    };
    SavingsAccountRollover.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.SavingsAccountRollover)
        return object;
      let message = new $root.dnse.SavingsAccountRollover();
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.nominalAnnualInterestRate != null)
        message.nominalAnnualInterestRate = Number(object.nominalAnnualInterestRate);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.SavingsAccountRollover.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.periodDesc != null)
        message.periodDesc = String(object.periodDesc);
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.rolloverPolicyDesc != null)
        message.rolloverPolicyDesc = String(object.rolloverPolicyDesc);
      return message;
    };
    SavingsAccountRollover.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.accountNoDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.nominalAnnualInterestRate = 0;
        object.productName = "";
        object.investorId = "";
        object.createdDate = null;
        object.periodDesc = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        object.rolloverPolicyDesc = "";
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.nominalAnnualInterestRate != null && message.hasOwnProperty("nominalAnnualInterestRate"))
        object.nominalAnnualInterestRate = options.json && !isFinite(message.nominalAnnualInterestRate) ? String(message.nominalAnnualInterestRate) : message.nominalAnnualInterestRate;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.periodDesc != null && message.hasOwnProperty("periodDesc"))
        object.periodDesc = message.periodDesc;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.rolloverPolicyDesc != null && message.hasOwnProperty("rolloverPolicyDesc"))
        object.rolloverPolicyDesc = message.rolloverPolicyDesc;
      return object;
    };
    SavingsAccountRollover.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return SavingsAccountRollover;
  }();
  dnse2.BPMSettlement = function() {
    function BPMSettlement(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BPMSettlement.prototype.savingsAccountId = "";
    BPMSettlement.prototype.productName = "";
    BPMSettlement.prototype.accountNo = "";
    BPMSettlement.prototype.investorId = "";
    BPMSettlement.prototype.custodyCode = "";
    BPMSettlement.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMSettlement.prototype.interest = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMSettlement.prototype.tax = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMSettlement.prototype.createdDate = null;
    BPMSettlement.prototype.accountNoDesc = "";
    BPMSettlement.prototype.partialWithdrawalSavingsAccountId = "";
    BPMSettlement.create = function create(properties) {
      return new BPMSettlement(properties);
    };
    BPMSettlement.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(10).string(message.savingsAccountId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(18).string(message.productName);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(26).string(message.accountNo);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(42).string(message.custodyCode);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(48).uint64(message.amount);
      if (message.interest != null && Object.hasOwnProperty.call(message, "interest"))
        writer.uint32(56).uint64(message.interest);
      if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
        writer.uint32(64).uint64(message.tax);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, "createdDate"))
        $root.google.protobuf.Timestamp.encode(message.createdDate, writer.uint32(74).fork()).ldelim();
      if (message.accountNoDesc != null && Object.hasOwnProperty.call(message, "accountNoDesc"))
        writer.uint32(82).string(message.accountNoDesc);
      if (message.partialWithdrawalSavingsAccountId != null && Object.hasOwnProperty.call(message, "partialWithdrawalSavingsAccountId"))
        writer.uint32(90).string(message.partialWithdrawalSavingsAccountId);
      return writer;
    };
    BPMSettlement.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BPMSettlement.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BPMSettlement();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.savingsAccountId = reader.string();
            break;
          case 2:
            message.productName = reader.string();
            break;
          case 3:
            message.accountNo = reader.string();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.custodyCode = reader.string();
            break;
          case 6:
            message.amount = reader.uint64();
            break;
          case 7:
            message.interest = reader.uint64();
            break;
          case 8:
            message.tax = reader.uint64();
            break;
          case 9:
            message.createdDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          case 10:
            message.accountNoDesc = reader.string();
            break;
          case 11:
            message.partialWithdrawalSavingsAccountId = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BPMSettlement.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BPMSettlement.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isString(message.savingsAccountId))
          return "savingsAccountId: string expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.interest != null && message.hasOwnProperty("interest")) {
        if (!$util.isInteger(message.interest) && !(message.interest && $util.isInteger(message.interest.low) && $util.isInteger(message.interest.high)))
          return "interest: integer|Long expected";
      }
      if (message.tax != null && message.hasOwnProperty("tax")) {
        if (!$util.isInteger(message.tax) && !(message.tax && $util.isInteger(message.tax.low) && $util.isInteger(message.tax.high)))
          return "tax: integer|Long expected";
      }
      if (message.createdDate != null && message.hasOwnProperty("createdDate")) {
        let error = $root.google.protobuf.Timestamp.verify(message.createdDate);
        if (error)
          return "createdDate." + error;
      }
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc")) {
        if (!$util.isString(message.accountNoDesc))
          return "accountNoDesc: string expected";
      }
      if (message.partialWithdrawalSavingsAccountId != null && message.hasOwnProperty("partialWithdrawalSavingsAccountId")) {
        if (!$util.isString(message.partialWithdrawalSavingsAccountId))
          return "partialWithdrawalSavingsAccountId: string expected";
      }
      return null;
    };
    BPMSettlement.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BPMSettlement)
        return object;
      let message = new $root.dnse.BPMSettlement();
      if (object.savingsAccountId != null)
        message.savingsAccountId = String(object.savingsAccountId);
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.interest != null) {
        if ($util.Long)
          (message.interest = $util.Long.fromValue(object.interest)).unsigned = true;
        else if (typeof object.interest === "string")
          message.interest = parseInt(object.interest, 10);
        else if (typeof object.interest === "number")
          message.interest = object.interest;
        else if (typeof object.interest === "object")
          message.interest = new $util.LongBits(object.interest.low >>> 0, object.interest.high >>> 0).toNumber(true);
      }
      if (object.tax != null) {
        if ($util.Long)
          (message.tax = $util.Long.fromValue(object.tax)).unsigned = true;
        else if (typeof object.tax === "string")
          message.tax = parseInt(object.tax, 10);
        else if (typeof object.tax === "number")
          message.tax = object.tax;
        else if (typeof object.tax === "object")
          message.tax = new $util.LongBits(object.tax.low >>> 0, object.tax.high >>> 0).toNumber(true);
      }
      if (object.createdDate != null) {
        if (typeof object.createdDate !== "object")
          throw TypeError(".dnse.BPMSettlement.createdDate: object expected");
        message.createdDate = $root.google.protobuf.Timestamp.fromObject(object.createdDate);
      }
      if (object.accountNoDesc != null)
        message.accountNoDesc = String(object.accountNoDesc);
      if (object.partialWithdrawalSavingsAccountId != null)
        message.partialWithdrawalSavingsAccountId = String(object.partialWithdrawalSavingsAccountId);
      return message;
    };
    BPMSettlement.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.savingsAccountId = "";
        object.productName = "";
        object.accountNo = "";
        object.investorId = "";
        object.custodyCode = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.interest = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.interest = options.longs === String ? "0" : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.tax = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.tax = options.longs === String ? "0" : 0;
        object.createdDate = null;
        object.accountNoDesc = "";
        object.partialWithdrawalSavingsAccountId = "";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        object.savingsAccountId = message.savingsAccountId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.interest != null && message.hasOwnProperty("interest"))
        if (typeof message.interest === "number")
          object.interest = options.longs === String ? String(message.interest) : message.interest;
        else
          object.interest = options.longs === String ? $util.Long.prototype.toString.call(message.interest) : options.longs === Number ? new $util.LongBits(message.interest.low >>> 0, message.interest.high >>> 0).toNumber(true) : message.interest;
      if (message.tax != null && message.hasOwnProperty("tax"))
        if (typeof message.tax === "number")
          object.tax = options.longs === String ? String(message.tax) : message.tax;
        else
          object.tax = options.longs === String ? $util.Long.prototype.toString.call(message.tax) : options.longs === Number ? new $util.LongBits(message.tax.low >>> 0, message.tax.high >>> 0).toNumber(true) : message.tax;
      if (message.createdDate != null && message.hasOwnProperty("createdDate"))
        object.createdDate = $root.google.protobuf.Timestamp.toObject(message.createdDate, options);
      if (message.accountNoDesc != null && message.hasOwnProperty("accountNoDesc"))
        object.accountNoDesc = message.accountNoDesc;
      if (message.partialWithdrawalSavingsAccountId != null && message.hasOwnProperty("partialWithdrawalSavingsAccountId"))
        object.partialWithdrawalSavingsAccountId = message.partialWithdrawalSavingsAccountId;
      return object;
    };
    BPMSettlement.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BPMSettlement;
  }();
  dnse2.BPMApproveOpen = function() {
    function BPMApproveOpen(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BPMApproveOpen.prototype.requestId = "";
    BPMApproveOpen.prototype.accountNo = "";
    BPMApproveOpen.prototype.custodyCode = "";
    BPMApproveOpen.prototype.investorId = "";
    BPMApproveOpen.prototype.productId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMApproveOpen.prototype.productName = "";
    BPMApproveOpen.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMApproveOpen.prototype.fullName = "";
    BPMApproveOpen.create = function create(properties) {
      return new BPMApproveOpen(properties);
    };
    BPMApproveOpen.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
        writer.uint32(10).string(message.requestId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.productId != null && Object.hasOwnProperty.call(message, "productId"))
        writer.uint32(40).uint64(message.productId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(50).string(message.productName);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(56).uint64(message.amount);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(66).string(message.fullName);
      return writer;
    };
    BPMApproveOpen.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BPMApproveOpen.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BPMApproveOpen();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.requestId = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.productId = reader.uint64();
            break;
          case 6:
            message.productName = reader.string();
            break;
          case 7:
            message.amount = reader.uint64();
            break;
          case 8:
            message.fullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BPMApproveOpen.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BPMApproveOpen.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.requestId != null && message.hasOwnProperty("requestId")) {
        if (!$util.isString(message.requestId))
          return "requestId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productId != null && message.hasOwnProperty("productId")) {
        if (!$util.isInteger(message.productId) && !(message.productId && $util.isInteger(message.productId.low) && $util.isInteger(message.productId.high)))
          return "productId: integer|Long expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      return null;
    };
    BPMApproveOpen.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BPMApproveOpen)
        return object;
      let message = new $root.dnse.BPMApproveOpen();
      if (object.requestId != null)
        message.requestId = String(object.requestId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productId != null) {
        if ($util.Long)
          (message.productId = $util.Long.fromValue(object.productId)).unsigned = true;
        else if (typeof object.productId === "string")
          message.productId = parseInt(object.productId, 10);
        else if (typeof object.productId === "number")
          message.productId = object.productId;
        else if (typeof object.productId === "object")
          message.productId = new $util.LongBits(object.productId.low >>> 0, object.productId.high >>> 0).toNumber(true);
      }
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      return message;
    };
    BPMApproveOpen.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.requestId = "";
        object.accountNo = "";
        object.custodyCode = "";
        object.investorId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.productId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.productId = options.longs === String ? "0" : 0;
        object.productName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.fullName = "";
      }
      if (message.requestId != null && message.hasOwnProperty("requestId"))
        object.requestId = message.requestId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productId != null && message.hasOwnProperty("productId"))
        if (typeof message.productId === "number")
          object.productId = options.longs === String ? String(message.productId) : message.productId;
        else
          object.productId = options.longs === String ? $util.Long.prototype.toString.call(message.productId) : options.longs === Number ? new $util.LongBits(message.productId.low >>> 0, message.productId.high >>> 0).toNumber(true) : message.productId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      return object;
    };
    BPMApproveOpen.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BPMApproveOpen;
  }();
  dnse2.BPMApproveSettle = function() {
    function BPMApproveSettle(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    BPMApproveSettle.prototype.requestId = "";
    BPMApproveSettle.prototype.accountNo = "";
    BPMApproveSettle.prototype.custodyCode = "";
    BPMApproveSettle.prototype.investorId = "";
    BPMApproveSettle.prototype.productId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMApproveSettle.prototype.productName = "";
    BPMApproveSettle.prototype.savingsAccountId = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMApproveSettle.prototype.investmentDate = "";
    BPMApproveSettle.prototype.amount = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    BPMApproveSettle.prototype.fullName = "";
    BPMApproveSettle.create = function create(properties) {
      return new BPMApproveSettle(properties);
    };
    BPMApproveSettle.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
        writer.uint32(10).string(message.requestId);
      if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
        writer.uint32(18).string(message.accountNo);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(26).string(message.custodyCode);
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(34).string(message.investorId);
      if (message.productId != null && Object.hasOwnProperty.call(message, "productId"))
        writer.uint32(40).uint64(message.productId);
      if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
        writer.uint32(50).string(message.productName);
      if (message.savingsAccountId != null && Object.hasOwnProperty.call(message, "savingsAccountId"))
        writer.uint32(56).uint64(message.savingsAccountId);
      if (message.investmentDate != null && Object.hasOwnProperty.call(message, "investmentDate"))
        writer.uint32(66).string(message.investmentDate);
      if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
        writer.uint32(72).uint64(message.amount);
      if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
        writer.uint32(82).string(message.fullName);
      return writer;
    };
    BPMApproveSettle.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    BPMApproveSettle.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.BPMApproveSettle();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.requestId = reader.string();
            break;
          case 2:
            message.accountNo = reader.string();
            break;
          case 3:
            message.custodyCode = reader.string();
            break;
          case 4:
            message.investorId = reader.string();
            break;
          case 5:
            message.productId = reader.uint64();
            break;
          case 6:
            message.productName = reader.string();
            break;
          case 7:
            message.savingsAccountId = reader.uint64();
            break;
          case 8:
            message.investmentDate = reader.string();
            break;
          case 9:
            message.amount = reader.uint64();
            break;
          case 10:
            message.fullName = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    BPMApproveSettle.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    BPMApproveSettle.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.requestId != null && message.hasOwnProperty("requestId")) {
        if (!$util.isString(message.requestId))
          return "requestId: string expected";
      }
      if (message.accountNo != null && message.hasOwnProperty("accountNo")) {
        if (!$util.isString(message.accountNo))
          return "accountNo: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.productId != null && message.hasOwnProperty("productId")) {
        if (!$util.isInteger(message.productId) && !(message.productId && $util.isInteger(message.productId.low) && $util.isInteger(message.productId.high)))
          return "productId: integer|Long expected";
      }
      if (message.productName != null && message.hasOwnProperty("productName")) {
        if (!$util.isString(message.productName))
          return "productName: string expected";
      }
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId")) {
        if (!$util.isInteger(message.savingsAccountId) && !(message.savingsAccountId && $util.isInteger(message.savingsAccountId.low) && $util.isInteger(message.savingsAccountId.high)))
          return "savingsAccountId: integer|Long expected";
      }
      if (message.investmentDate != null && message.hasOwnProperty("investmentDate")) {
        if (!$util.isString(message.investmentDate))
          return "investmentDate: string expected";
      }
      if (message.amount != null && message.hasOwnProperty("amount")) {
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
          return "amount: integer|Long expected";
      }
      if (message.fullName != null && message.hasOwnProperty("fullName")) {
        if (!$util.isString(message.fullName))
          return "fullName: string expected";
      }
      return null;
    };
    BPMApproveSettle.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.BPMApproveSettle)
        return object;
      let message = new $root.dnse.BPMApproveSettle();
      if (object.requestId != null)
        message.requestId = String(object.requestId);
      if (object.accountNo != null)
        message.accountNo = String(object.accountNo);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.productId != null) {
        if ($util.Long)
          (message.productId = $util.Long.fromValue(object.productId)).unsigned = true;
        else if (typeof object.productId === "string")
          message.productId = parseInt(object.productId, 10);
        else if (typeof object.productId === "number")
          message.productId = object.productId;
        else if (typeof object.productId === "object")
          message.productId = new $util.LongBits(object.productId.low >>> 0, object.productId.high >>> 0).toNumber(true);
      }
      if (object.productName != null)
        message.productName = String(object.productName);
      if (object.savingsAccountId != null) {
        if ($util.Long)
          (message.savingsAccountId = $util.Long.fromValue(object.savingsAccountId)).unsigned = true;
        else if (typeof object.savingsAccountId === "string")
          message.savingsAccountId = parseInt(object.savingsAccountId, 10);
        else if (typeof object.savingsAccountId === "number")
          message.savingsAccountId = object.savingsAccountId;
        else if (typeof object.savingsAccountId === "object")
          message.savingsAccountId = new $util.LongBits(object.savingsAccountId.low >>> 0, object.savingsAccountId.high >>> 0).toNumber(true);
      }
      if (object.investmentDate != null)
        message.investmentDate = String(object.investmentDate);
      if (object.amount != null) {
        if ($util.Long)
          (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
        else if (typeof object.amount === "string")
          message.amount = parseInt(object.amount, 10);
        else if (typeof object.amount === "number")
          message.amount = object.amount;
        else if (typeof object.amount === "object")
          message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
      }
      if (object.fullName != null)
        message.fullName = String(object.fullName);
      return message;
    };
    BPMApproveSettle.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.requestId = "";
        object.accountNo = "";
        object.custodyCode = "";
        object.investorId = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.productId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.productId = options.longs === String ? "0" : 0;
        object.productName = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.savingsAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.savingsAccountId = options.longs === String ? "0" : 0;
        object.investmentDate = "";
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else
          object.amount = options.longs === String ? "0" : 0;
        object.fullName = "";
      }
      if (message.requestId != null && message.hasOwnProperty("requestId"))
        object.requestId = message.requestId;
      if (message.accountNo != null && message.hasOwnProperty("accountNo"))
        object.accountNo = message.accountNo;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.productId != null && message.hasOwnProperty("productId"))
        if (typeof message.productId === "number")
          object.productId = options.longs === String ? String(message.productId) : message.productId;
        else
          object.productId = options.longs === String ? $util.Long.prototype.toString.call(message.productId) : options.longs === Number ? new $util.LongBits(message.productId.low >>> 0, message.productId.high >>> 0).toNumber(true) : message.productId;
      if (message.productName != null && message.hasOwnProperty("productName"))
        object.productName = message.productName;
      if (message.savingsAccountId != null && message.hasOwnProperty("savingsAccountId"))
        if (typeof message.savingsAccountId === "number")
          object.savingsAccountId = options.longs === String ? String(message.savingsAccountId) : message.savingsAccountId;
        else
          object.savingsAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.savingsAccountId) : options.longs === Number ? new $util.LongBits(message.savingsAccountId.low >>> 0, message.savingsAccountId.high >>> 0).toNumber(true) : message.savingsAccountId;
      if (message.investmentDate != null && message.hasOwnProperty("investmentDate"))
        object.investmentDate = message.investmentDate;
      if (message.amount != null && message.hasOwnProperty("amount"))
        if (typeof message.amount === "number")
          object.amount = options.longs === String ? String(message.amount) : message.amount;
        else
          object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
      if (message.fullName != null && message.hasOwnProperty("fullName"))
        object.fullName = message.fullName;
      return object;
    };
    BPMApproveSettle.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return BPMApproveSettle;
  }();
  dnse2.GoldenEggContractSigned = function() {
    function GoldenEggContractSigned(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggContractSigned.prototype.investorId = "";
    GoldenEggContractSigned.prototype.custodyCode = "";
    GoldenEggContractSigned.prototype.contractSignedAt = null;
    GoldenEggContractSigned.create = function create(properties) {
      return new GoldenEggContractSigned(properties);
    };
    GoldenEggContractSigned.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.investorId != null && Object.hasOwnProperty.call(message, "investorId"))
        writer.uint32(10).string(message.investorId);
      if (message.custodyCode != null && Object.hasOwnProperty.call(message, "custodyCode"))
        writer.uint32(18).string(message.custodyCode);
      if (message.contractSignedAt != null && Object.hasOwnProperty.call(message, "contractSignedAt"))
        $root.google.protobuf.Timestamp.encode(message.contractSignedAt, writer.uint32(26).fork()).ldelim();
      return writer;
    };
    GoldenEggContractSigned.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggContractSigned.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggContractSigned();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.investorId = reader.string();
            break;
          case 2:
            message.custodyCode = reader.string();
            break;
          case 3:
            message.contractSignedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggContractSigned.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggContractSigned.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.investorId != null && message.hasOwnProperty("investorId")) {
        if (!$util.isString(message.investorId))
          return "investorId: string expected";
      }
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode")) {
        if (!$util.isString(message.custodyCode))
          return "custodyCode: string expected";
      }
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.contractSignedAt);
        if (error)
          return "contractSignedAt." + error;
      }
      return null;
    };
    GoldenEggContractSigned.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggContractSigned)
        return object;
      let message = new $root.dnse.GoldenEggContractSigned();
      if (object.investorId != null)
        message.investorId = String(object.investorId);
      if (object.custodyCode != null)
        message.custodyCode = String(object.custodyCode);
      if (object.contractSignedAt != null) {
        if (typeof object.contractSignedAt !== "object")
          throw TypeError(".dnse.GoldenEggContractSigned.contractSignedAt: object expected");
        message.contractSignedAt = $root.google.protobuf.Timestamp.fromObject(object.contractSignedAt);
      }
      return message;
    };
    GoldenEggContractSigned.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.investorId = "";
        object.custodyCode = "";
        object.contractSignedAt = null;
      }
      if (message.investorId != null && message.hasOwnProperty("investorId"))
        object.investorId = message.investorId;
      if (message.custodyCode != null && message.hasOwnProperty("custodyCode"))
        object.custodyCode = message.custodyCode;
      if (message.contractSignedAt != null && message.hasOwnProperty("contractSignedAt"))
        object.contractSignedAt = $root.google.protobuf.Timestamp.toObject(message.contractSignedAt, options);
      return object;
    };
    GoldenEggContractSigned.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggContractSigned;
  }();
  dnse2.GoldenEggNewDay = function() {
    function GoldenEggNewDay(properties) {
      if (properties) {
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null)
            this[keys[i]] = properties[keys[i]];
      }
    }
    GoldenEggNewDay.prototype.day = null;
    GoldenEggNewDay.prototype.emittedAt = null;
    GoldenEggNewDay.create = function create(properties) {
      return new GoldenEggNewDay(properties);
    };
    GoldenEggNewDay.encode = function encode(message, writer) {
      if (!writer)
        writer = $Writer.create();
      if (message.day != null && Object.hasOwnProperty.call(message, "day"))
        $root.google.type.Date.encode(message.day, writer.uint32(10).fork()).ldelim();
      if (message.emittedAt != null && Object.hasOwnProperty.call(message, "emittedAt"))
        $root.google.protobuf.Timestamp.encode(message.emittedAt, writer.uint32(18).fork()).ldelim();
      return writer;
    };
    GoldenEggNewDay.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };
    GoldenEggNewDay.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader))
        reader = $Reader.create(reader);
      let end = length === void 0 ? reader.len : reader.pos + length, message = new $root.dnse.GoldenEggNewDay();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.day = $root.google.type.Date.decode(reader, reader.uint32());
            break;
          case 2:
            message.emittedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };
    GoldenEggNewDay.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader))
        reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };
    GoldenEggNewDay.verify = function verify(message) {
      if (typeof message !== "object" || message === null)
        return "object expected";
      if (message.day != null && message.hasOwnProperty("day")) {
        let error = $root.google.type.Date.verify(message.day);
        if (error)
          return "day." + error;
      }
      if (message.emittedAt != null && message.hasOwnProperty("emittedAt")) {
        let error = $root.google.protobuf.Timestamp.verify(message.emittedAt);
        if (error)
          return "emittedAt." + error;
      }
      return null;
    };
    GoldenEggNewDay.fromObject = function fromObject(object) {
      if (object instanceof $root.dnse.GoldenEggNewDay)
        return object;
      let message = new $root.dnse.GoldenEggNewDay();
      if (object.day != null) {
        if (typeof object.day !== "object")
          throw TypeError(".dnse.GoldenEggNewDay.day: object expected");
        message.day = $root.google.type.Date.fromObject(object.day);
      }
      if (object.emittedAt != null) {
        if (typeof object.emittedAt !== "object")
          throw TypeError(".dnse.GoldenEggNewDay.emittedAt: object expected");
        message.emittedAt = $root.google.protobuf.Timestamp.fromObject(object.emittedAt);
      }
      return message;
    };
    GoldenEggNewDay.toObject = function toObject(message, options) {
      if (!options)
        options = {};
      let object = {};
      if (options.defaults) {
        object.day = null;
        object.emittedAt = null;
      }
      if (message.day != null && message.hasOwnProperty("day"))
        object.day = $root.google.type.Date.toObject(message.day, options);
      if (message.emittedAt != null && message.hasOwnProperty("emittedAt"))
        object.emittedAt = $root.google.protobuf.Timestamp.toObject(message.emittedAt, options);
      return object;
    };
    GoldenEggNewDay.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return GoldenEggNewDay;
  }();
  return dnse2;
})();

export { dnse, enbox, models, notification, otp, price };
//# sourceMappingURL=index.mjs.map
